/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  bigint: { input: any; output: any; }
  float8: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  smallint: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "aggregator" */
export type Aggregator = {
  __typename?: 'aggregator';
  address: Scalars['String']['output'];
  admin: Scalars['String']['output'];
  alpha_pct_per_thousand: Scalars['smallint']['output'];
  creation_timestamp: Scalars['timestamptz']['output'];
  decimals: Scalars['smallint']['output'];
  /** An object relationship */
  factory?: Maybe<Aggregator_Factory>;
  factory_id?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  general_contracts: Array<Aggregator_General_Contract>;
  /** An aggregate relationship */
  general_contracts_aggregate: Aggregator_General_Contract_Aggregate;
  /** An object relationship */
  governance: Governance;
  governance_id: Scalars['bigint']['output'];
  /** An array relationship */
  governance_satellite_oracle_aggregators: Array<Governance_Satellite_Oracle_Aggregator>;
  /** An aggregate relationship */
  governance_satellite_oracle_aggregators_aggregate: Governance_Satellite_Oracle_Aggregator_Aggregate;
  heart_beat_seconds: Scalars['bigint']['output'];
  /** An array relationship */
  history_data: Array<Aggregator_History_Data>;
  /** An aggregate relationship */
  history_data_aggregate: Aggregator_History_Data_Aggregate;
  id: Scalars['bigint']['output'];
  /** An array relationship */
  lambdas: Array<Aggregator_Lambda>;
  /** An aggregate relationship */
  lambdas_aggregate: Aggregator_Lambda_Aggregate;
  last_completed_data: Scalars['float8']['output'];
  last_completed_data_epoch: Scalars['bigint']['output'];
  last_completed_data_last_updated_at: Scalars['timestamptz']['output'];
  last_completed_data_pct_oracle_resp: Scalars['smallint']['output'];
  last_completed_data_round: Scalars['bigint']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  name: Scalars['String']['output'];
  network: Scalars['String']['output'];
  /** An array relationship */
  oracles: Array<Aggregator_Oracle>;
  /** An aggregate relationship */
  oracles_aggregate: Aggregator_Oracle_Aggregate;
  pct_oracle_threshold: Scalars['smallint']['output'];
  reward_amount_mvrk: Scalars['float8']['output'];
  reward_amount_smvn: Scalars['float8']['output'];
  update_data_paused: Scalars['Boolean']['output'];
  /** An array relationship */
  whitelist_contracts: Array<Aggregator_Whitelist_Contract>;
  /** An aggregate relationship */
  whitelist_contracts_aggregate: Aggregator_Whitelist_Contract_Aggregate;
  withdraw_reward_mvrk_paused: Scalars['Boolean']['output'];
  withdraw_reward_smvn_paused: Scalars['Boolean']['output'];
};


/** columns and relationships of "aggregator" */
export type AggregatorGeneral_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_General_Contract_Order_By>>;
  where?: InputMaybe<Aggregator_General_Contract_Bool_Exp>;
};


/** columns and relationships of "aggregator" */
export type AggregatorGeneral_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_General_Contract_Order_By>>;
  where?: InputMaybe<Aggregator_General_Contract_Bool_Exp>;
};


/** columns and relationships of "aggregator" */
export type AggregatorGovernance_Satellite_Oracle_AggregatorsArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Oracle_Aggregator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Oracle_Aggregator_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Bool_Exp>;
};


/** columns and relationships of "aggregator" */
export type AggregatorGovernance_Satellite_Oracle_Aggregators_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Oracle_Aggregator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Oracle_Aggregator_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Bool_Exp>;
};


/** columns and relationships of "aggregator" */
export type AggregatorHistory_DataArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_History_Data_Order_By>>;
  where?: InputMaybe<Aggregator_History_Data_Bool_Exp>;
};


/** columns and relationships of "aggregator" */
export type AggregatorHistory_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_History_Data_Order_By>>;
  where?: InputMaybe<Aggregator_History_Data_Bool_Exp>;
};


/** columns and relationships of "aggregator" */
export type AggregatorLambdasArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Lambda_Order_By>>;
  where?: InputMaybe<Aggregator_Lambda_Bool_Exp>;
};


/** columns and relationships of "aggregator" */
export type AggregatorLambdas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Lambda_Order_By>>;
  where?: InputMaybe<Aggregator_Lambda_Bool_Exp>;
};


/** columns and relationships of "aggregator" */
export type AggregatorMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "aggregator" */
export type AggregatorOraclesArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Oracle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Oracle_Order_By>>;
  where?: InputMaybe<Aggregator_Oracle_Bool_Exp>;
};


/** columns and relationships of "aggregator" */
export type AggregatorOracles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Oracle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Oracle_Order_By>>;
  where?: InputMaybe<Aggregator_Oracle_Bool_Exp>;
};


/** columns and relationships of "aggregator" */
export type AggregatorWhitelist_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Aggregator_Whitelist_Contract_Bool_Exp>;
};


/** columns and relationships of "aggregator" */
export type AggregatorWhitelist_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Aggregator_Whitelist_Contract_Bool_Exp>;
};

/** aggregated selection of "aggregator" */
export type Aggregator_Aggregate = {
  __typename?: 'aggregator_aggregate';
  aggregate?: Maybe<Aggregator_Aggregate_Fields>;
  nodes: Array<Aggregator>;
};

export type Aggregator_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Aggregator_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Aggregator_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Aggregator_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Aggregator_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Aggregator_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Aggregator_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Aggregator_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Aggregator_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Aggregator_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Aggregator_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Aggregator_Aggregate_Bool_Exp_Var_Samp>;
};

export type Aggregator_Aggregate_Bool_Exp_Avg = {
  arguments: Aggregator_Select_Column_Aggregator_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_Aggregate_Bool_Exp_Bool_And = {
  arguments: Aggregator_Select_Column_Aggregator_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Aggregator_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Aggregator_Select_Column_Aggregator_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Aggregator_Aggregate_Bool_Exp_Corr = {
  arguments: Aggregator_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Aggregator_Select_Column_Aggregator_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Aggregator_Select_Column_Aggregator_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Aggregator_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Aggregator_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Aggregator_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Aggregator_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Aggregator_Select_Column_Aggregator_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Aggregator_Select_Column_Aggregator_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Aggregator_Aggregate_Bool_Exp_Max = {
  arguments: Aggregator_Select_Column_Aggregator_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_Aggregate_Bool_Exp_Min = {
  arguments: Aggregator_Select_Column_Aggregator_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Aggregator_Select_Column_Aggregator_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_Aggregate_Bool_Exp_Sum = {
  arguments: Aggregator_Select_Column_Aggregator_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Aggregator_Select_Column_Aggregator_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "aggregator" */
export type Aggregator_Aggregate_Fields = {
  __typename?: 'aggregator_aggregate_fields';
  avg?: Maybe<Aggregator_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Aggregator_Max_Fields>;
  min?: Maybe<Aggregator_Min_Fields>;
  stddev?: Maybe<Aggregator_Stddev_Fields>;
  stddev_pop?: Maybe<Aggregator_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Aggregator_Stddev_Samp_Fields>;
  sum?: Maybe<Aggregator_Sum_Fields>;
  var_pop?: Maybe<Aggregator_Var_Pop_Fields>;
  var_samp?: Maybe<Aggregator_Var_Samp_Fields>;
  variance?: Maybe<Aggregator_Variance_Fields>;
};


/** aggregate fields of "aggregator" */
export type Aggregator_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Aggregator_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "aggregator" */
export type Aggregator_Aggregate_Order_By = {
  avg?: InputMaybe<Aggregator_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Aggregator_Max_Order_By>;
  min?: InputMaybe<Aggregator_Min_Order_By>;
  stddev?: InputMaybe<Aggregator_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Aggregator_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Aggregator_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Aggregator_Sum_Order_By>;
  var_pop?: InputMaybe<Aggregator_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Aggregator_Var_Samp_Order_By>;
  variance?: InputMaybe<Aggregator_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Aggregator_Avg_Fields = {
  __typename?: 'aggregator_avg_fields';
  alpha_pct_per_thousand?: Maybe<Scalars['Float']['output']>;
  decimals?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  heart_beat_seconds?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_completed_data?: Maybe<Scalars['Float']['output']>;
  last_completed_data_epoch?: Maybe<Scalars['Float']['output']>;
  last_completed_data_pct_oracle_resp?: Maybe<Scalars['Float']['output']>;
  last_completed_data_round?: Maybe<Scalars['Float']['output']>;
  pct_oracle_threshold?: Maybe<Scalars['Float']['output']>;
  reward_amount_mvrk?: Maybe<Scalars['Float']['output']>;
  reward_amount_smvn?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "aggregator" */
export type Aggregator_Avg_Order_By = {
  alpha_pct_per_thousand?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  heart_beat_seconds?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_completed_data?: InputMaybe<Order_By>;
  last_completed_data_epoch?: InputMaybe<Order_By>;
  last_completed_data_pct_oracle_resp?: InputMaybe<Order_By>;
  last_completed_data_round?: InputMaybe<Order_By>;
  pct_oracle_threshold?: InputMaybe<Order_By>;
  reward_amount_mvrk?: InputMaybe<Order_By>;
  reward_amount_smvn?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "aggregator". All fields are combined with a logical 'AND'. */
export type Aggregator_Bool_Exp = {
  _and?: InputMaybe<Array<Aggregator_Bool_Exp>>;
  _not?: InputMaybe<Aggregator_Bool_Exp>;
  _or?: InputMaybe<Array<Aggregator_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  admin?: InputMaybe<String_Comparison_Exp>;
  alpha_pct_per_thousand?: InputMaybe<Smallint_Comparison_Exp>;
  creation_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  decimals?: InputMaybe<Smallint_Comparison_Exp>;
  factory?: InputMaybe<Aggregator_Factory_Bool_Exp>;
  factory_id?: InputMaybe<Bigint_Comparison_Exp>;
  general_contracts?: InputMaybe<Aggregator_General_Contract_Bool_Exp>;
  general_contracts_aggregate?: InputMaybe<Aggregator_General_Contract_Aggregate_Bool_Exp>;
  governance?: InputMaybe<Governance_Bool_Exp>;
  governance_id?: InputMaybe<Bigint_Comparison_Exp>;
  governance_satellite_oracle_aggregators?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Bool_Exp>;
  governance_satellite_oracle_aggregators_aggregate?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Aggregate_Bool_Exp>;
  heart_beat_seconds?: InputMaybe<Bigint_Comparison_Exp>;
  history_data?: InputMaybe<Aggregator_History_Data_Bool_Exp>;
  history_data_aggregate?: InputMaybe<Aggregator_History_Data_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambdas?: InputMaybe<Aggregator_Lambda_Bool_Exp>;
  lambdas_aggregate?: InputMaybe<Aggregator_Lambda_Aggregate_Bool_Exp>;
  last_completed_data?: InputMaybe<Float8_Comparison_Exp>;
  last_completed_data_epoch?: InputMaybe<Bigint_Comparison_Exp>;
  last_completed_data_last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_completed_data_pct_oracle_resp?: InputMaybe<Smallint_Comparison_Exp>;
  last_completed_data_round?: InputMaybe<Bigint_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
  oracles?: InputMaybe<Aggregator_Oracle_Bool_Exp>;
  oracles_aggregate?: InputMaybe<Aggregator_Oracle_Aggregate_Bool_Exp>;
  pct_oracle_threshold?: InputMaybe<Smallint_Comparison_Exp>;
  reward_amount_mvrk?: InputMaybe<Float8_Comparison_Exp>;
  reward_amount_smvn?: InputMaybe<Float8_Comparison_Exp>;
  update_data_paused?: InputMaybe<Boolean_Comparison_Exp>;
  whitelist_contracts?: InputMaybe<Aggregator_Whitelist_Contract_Bool_Exp>;
  whitelist_contracts_aggregate?: InputMaybe<Aggregator_Whitelist_Contract_Aggregate_Bool_Exp>;
  withdraw_reward_mvrk_paused?: InputMaybe<Boolean_Comparison_Exp>;
  withdraw_reward_smvn_paused?: InputMaybe<Boolean_Comparison_Exp>;
};

/** columns and relationships of "aggregator_factory" */
export type Aggregator_Factory = {
  __typename?: 'aggregator_factory';
  address: Scalars['String']['output'];
  admin: Scalars['String']['output'];
  /** An array relationship */
  aggregator_lambdas: Array<Aggregator_Factory_Aggregator_Lambda>;
  /** An aggregate relationship */
  aggregator_lambdas_aggregate: Aggregator_Factory_Aggregator_Lambda_Aggregate;
  aggregator_name_max_length: Scalars['smallint']['output'];
  /** An array relationship */
  aggregators: Array<Aggregator>;
  /** An aggregate relationship */
  aggregators_aggregate: Aggregator_Aggregate;
  create_aggregator_paused: Scalars['Boolean']['output'];
  distribute_reward_mvrk_paused: Scalars['Boolean']['output'];
  distribute_reward_smvn_paused: Scalars['Boolean']['output'];
  /** An array relationship */
  general_contracts: Array<Aggregator_Factory_General_Contract>;
  /** An aggregate relationship */
  general_contracts_aggregate: Aggregator_Factory_General_Contract_Aggregate;
  /** An object relationship */
  governance: Governance;
  governance_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An array relationship */
  lambdas: Array<Aggregator_Factory_Lambda>;
  /** An aggregate relationship */
  lambdas_aggregate: Aggregator_Factory_Lambda_Aggregate;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  network: Scalars['String']['output'];
  track_aggregator_paused: Scalars['Boolean']['output'];
  untrack_aggregator_paused: Scalars['Boolean']['output'];
  /** An array relationship */
  whitelist_contracts: Array<Aggregator_Factory_Whitelist_Contract>;
  /** An aggregate relationship */
  whitelist_contracts_aggregate: Aggregator_Factory_Whitelist_Contract_Aggregate;
};


/** columns and relationships of "aggregator_factory" */
export type Aggregator_FactoryAggregator_LambdasArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_Aggregator_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_Aggregator_Lambda_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_Aggregator_Lambda_Bool_Exp>;
};


/** columns and relationships of "aggregator_factory" */
export type Aggregator_FactoryAggregator_Lambdas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_Aggregator_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_Aggregator_Lambda_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_Aggregator_Lambda_Bool_Exp>;
};


/** columns and relationships of "aggregator_factory" */
export type Aggregator_FactoryAggregatorsArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Order_By>>;
  where?: InputMaybe<Aggregator_Bool_Exp>;
};


/** columns and relationships of "aggregator_factory" */
export type Aggregator_FactoryAggregators_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Order_By>>;
  where?: InputMaybe<Aggregator_Bool_Exp>;
};


/** columns and relationships of "aggregator_factory" */
export type Aggregator_FactoryGeneral_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_General_Contract_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_General_Contract_Bool_Exp>;
};


/** columns and relationships of "aggregator_factory" */
export type Aggregator_FactoryGeneral_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_General_Contract_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_General_Contract_Bool_Exp>;
};


/** columns and relationships of "aggregator_factory" */
export type Aggregator_FactoryLambdasArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_Lambda_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_Lambda_Bool_Exp>;
};


/** columns and relationships of "aggregator_factory" */
export type Aggregator_FactoryLambdas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_Lambda_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_Lambda_Bool_Exp>;
};


/** columns and relationships of "aggregator_factory" */
export type Aggregator_FactoryMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "aggregator_factory" */
export type Aggregator_FactoryWhitelist_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_Whitelist_Contract_Bool_Exp>;
};


/** columns and relationships of "aggregator_factory" */
export type Aggregator_FactoryWhitelist_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_Whitelist_Contract_Bool_Exp>;
};

/** aggregated selection of "aggregator_factory" */
export type Aggregator_Factory_Aggregate = {
  __typename?: 'aggregator_factory_aggregate';
  aggregate?: Maybe<Aggregator_Factory_Aggregate_Fields>;
  nodes: Array<Aggregator_Factory>;
};

export type Aggregator_Factory_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Aggregator_Factory_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Aggregator_Factory_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Aggregator_Factory_Aggregate_Bool_Exp_Count>;
};

export type Aggregator_Factory_Aggregate_Bool_Exp_Bool_And = {
  arguments: Aggregator_Factory_Select_Column_Aggregator_Factory_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Factory_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Aggregator_Factory_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Aggregator_Factory_Select_Column_Aggregator_Factory_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Factory_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Aggregator_Factory_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Aggregator_Factory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Factory_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "aggregator_factory" */
export type Aggregator_Factory_Aggregate_Fields = {
  __typename?: 'aggregator_factory_aggregate_fields';
  avg?: Maybe<Aggregator_Factory_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Aggregator_Factory_Max_Fields>;
  min?: Maybe<Aggregator_Factory_Min_Fields>;
  stddev?: Maybe<Aggregator_Factory_Stddev_Fields>;
  stddev_pop?: Maybe<Aggregator_Factory_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Aggregator_Factory_Stddev_Samp_Fields>;
  sum?: Maybe<Aggregator_Factory_Sum_Fields>;
  var_pop?: Maybe<Aggregator_Factory_Var_Pop_Fields>;
  var_samp?: Maybe<Aggregator_Factory_Var_Samp_Fields>;
  variance?: Maybe<Aggregator_Factory_Variance_Fields>;
};


/** aggregate fields of "aggregator_factory" */
export type Aggregator_Factory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Aggregator_Factory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "aggregator_factory" */
export type Aggregator_Factory_Aggregate_Order_By = {
  avg?: InputMaybe<Aggregator_Factory_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Aggregator_Factory_Max_Order_By>;
  min?: InputMaybe<Aggregator_Factory_Min_Order_By>;
  stddev?: InputMaybe<Aggregator_Factory_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Aggregator_Factory_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Aggregator_Factory_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Aggregator_Factory_Sum_Order_By>;
  var_pop?: InputMaybe<Aggregator_Factory_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Aggregator_Factory_Var_Samp_Order_By>;
  variance?: InputMaybe<Aggregator_Factory_Variance_Order_By>;
};

/** columns and relationships of "aggregator_factory_aggregator_lambda" */
export type Aggregator_Factory_Aggregator_Lambda = {
  __typename?: 'aggregator_factory_aggregator_lambda';
  /** An object relationship */
  contract: Aggregator_Factory;
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lambda_bytes: Scalars['String']['output'];
  lambda_name: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "aggregator_factory_aggregator_lambda" */
export type Aggregator_Factory_Aggregator_Lambda_Aggregate = {
  __typename?: 'aggregator_factory_aggregator_lambda_aggregate';
  aggregate?: Maybe<Aggregator_Factory_Aggregator_Lambda_Aggregate_Fields>;
  nodes: Array<Aggregator_Factory_Aggregator_Lambda>;
};

export type Aggregator_Factory_Aggregator_Lambda_Aggregate_Bool_Exp = {
  count?: InputMaybe<Aggregator_Factory_Aggregator_Lambda_Aggregate_Bool_Exp_Count>;
};

export type Aggregator_Factory_Aggregator_Lambda_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Aggregator_Factory_Aggregator_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Factory_Aggregator_Lambda_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "aggregator_factory_aggregator_lambda" */
export type Aggregator_Factory_Aggregator_Lambda_Aggregate_Fields = {
  __typename?: 'aggregator_factory_aggregator_lambda_aggregate_fields';
  avg?: Maybe<Aggregator_Factory_Aggregator_Lambda_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Aggregator_Factory_Aggregator_Lambda_Max_Fields>;
  min?: Maybe<Aggregator_Factory_Aggregator_Lambda_Min_Fields>;
  stddev?: Maybe<Aggregator_Factory_Aggregator_Lambda_Stddev_Fields>;
  stddev_pop?: Maybe<Aggregator_Factory_Aggregator_Lambda_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Aggregator_Factory_Aggregator_Lambda_Stddev_Samp_Fields>;
  sum?: Maybe<Aggregator_Factory_Aggregator_Lambda_Sum_Fields>;
  var_pop?: Maybe<Aggregator_Factory_Aggregator_Lambda_Var_Pop_Fields>;
  var_samp?: Maybe<Aggregator_Factory_Aggregator_Lambda_Var_Samp_Fields>;
  variance?: Maybe<Aggregator_Factory_Aggregator_Lambda_Variance_Fields>;
};


/** aggregate fields of "aggregator_factory_aggregator_lambda" */
export type Aggregator_Factory_Aggregator_Lambda_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Aggregator_Factory_Aggregator_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "aggregator_factory_aggregator_lambda" */
export type Aggregator_Factory_Aggregator_Lambda_Aggregate_Order_By = {
  avg?: InputMaybe<Aggregator_Factory_Aggregator_Lambda_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Aggregator_Factory_Aggregator_Lambda_Max_Order_By>;
  min?: InputMaybe<Aggregator_Factory_Aggregator_Lambda_Min_Order_By>;
  stddev?: InputMaybe<Aggregator_Factory_Aggregator_Lambda_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Aggregator_Factory_Aggregator_Lambda_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Aggregator_Factory_Aggregator_Lambda_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Aggregator_Factory_Aggregator_Lambda_Sum_Order_By>;
  var_pop?: InputMaybe<Aggregator_Factory_Aggregator_Lambda_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Aggregator_Factory_Aggregator_Lambda_Var_Samp_Order_By>;
  variance?: InputMaybe<Aggregator_Factory_Aggregator_Lambda_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Aggregator_Factory_Aggregator_Lambda_Avg_Fields = {
  __typename?: 'aggregator_factory_aggregator_lambda_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "aggregator_factory_aggregator_lambda" */
export type Aggregator_Factory_Aggregator_Lambda_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "aggregator_factory_aggregator_lambda". All fields are combined with a logical 'AND'. */
export type Aggregator_Factory_Aggregator_Lambda_Bool_Exp = {
  _and?: InputMaybe<Array<Aggregator_Factory_Aggregator_Lambda_Bool_Exp>>;
  _not?: InputMaybe<Aggregator_Factory_Aggregator_Lambda_Bool_Exp>;
  _or?: InputMaybe<Array<Aggregator_Factory_Aggregator_Lambda_Bool_Exp>>;
  contract?: InputMaybe<Aggregator_Factory_Bool_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambda_bytes?: InputMaybe<String_Comparison_Exp>;
  lambda_name?: InputMaybe<String_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Aggregator_Factory_Aggregator_Lambda_Max_Fields = {
  __typename?: 'aggregator_factory_aggregator_lambda_max_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "aggregator_factory_aggregator_lambda" */
export type Aggregator_Factory_Aggregator_Lambda_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Aggregator_Factory_Aggregator_Lambda_Min_Fields = {
  __typename?: 'aggregator_factory_aggregator_lambda_min_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "aggregator_factory_aggregator_lambda" */
export type Aggregator_Factory_Aggregator_Lambda_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "aggregator_factory_aggregator_lambda". */
export type Aggregator_Factory_Aggregator_Lambda_Order_By = {
  contract?: InputMaybe<Aggregator_Factory_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "aggregator_factory_aggregator_lambda" */
export enum Aggregator_Factory_Aggregator_Lambda_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaBytes = 'lambda_bytes',
  /** column name */
  LambdaName = 'lambda_name',
  /** column name */
  LastUpdatedAt = 'last_updated_at'
}

/** aggregate stddev on columns */
export type Aggregator_Factory_Aggregator_Lambda_Stddev_Fields = {
  __typename?: 'aggregator_factory_aggregator_lambda_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "aggregator_factory_aggregator_lambda" */
export type Aggregator_Factory_Aggregator_Lambda_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Aggregator_Factory_Aggregator_Lambda_Stddev_Pop_Fields = {
  __typename?: 'aggregator_factory_aggregator_lambda_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "aggregator_factory_aggregator_lambda" */
export type Aggregator_Factory_Aggregator_Lambda_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Aggregator_Factory_Aggregator_Lambda_Stddev_Samp_Fields = {
  __typename?: 'aggregator_factory_aggregator_lambda_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "aggregator_factory_aggregator_lambda" */
export type Aggregator_Factory_Aggregator_Lambda_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "aggregator_factory_aggregator_lambda" */
export type Aggregator_Factory_Aggregator_Lambda_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Aggregator_Factory_Aggregator_Lambda_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Aggregator_Factory_Aggregator_Lambda_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lambda_bytes?: InputMaybe<Scalars['String']['input']>;
  lambda_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Aggregator_Factory_Aggregator_Lambda_Sum_Fields = {
  __typename?: 'aggregator_factory_aggregator_lambda_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "aggregator_factory_aggregator_lambda" */
export type Aggregator_Factory_Aggregator_Lambda_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Aggregator_Factory_Aggregator_Lambda_Var_Pop_Fields = {
  __typename?: 'aggregator_factory_aggregator_lambda_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "aggregator_factory_aggregator_lambda" */
export type Aggregator_Factory_Aggregator_Lambda_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Aggregator_Factory_Aggregator_Lambda_Var_Samp_Fields = {
  __typename?: 'aggregator_factory_aggregator_lambda_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "aggregator_factory_aggregator_lambda" */
export type Aggregator_Factory_Aggregator_Lambda_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Aggregator_Factory_Aggregator_Lambda_Variance_Fields = {
  __typename?: 'aggregator_factory_aggregator_lambda_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "aggregator_factory_aggregator_lambda" */
export type Aggregator_Factory_Aggregator_Lambda_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Aggregator_Factory_Avg_Fields = {
  __typename?: 'aggregator_factory_avg_fields';
  aggregator_name_max_length?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "aggregator_factory" */
export type Aggregator_Factory_Avg_Order_By = {
  aggregator_name_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "aggregator_factory". All fields are combined with a logical 'AND'. */
export type Aggregator_Factory_Bool_Exp = {
  _and?: InputMaybe<Array<Aggregator_Factory_Bool_Exp>>;
  _not?: InputMaybe<Aggregator_Factory_Bool_Exp>;
  _or?: InputMaybe<Array<Aggregator_Factory_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  admin?: InputMaybe<String_Comparison_Exp>;
  aggregator_lambdas?: InputMaybe<Aggregator_Factory_Aggregator_Lambda_Bool_Exp>;
  aggregator_lambdas_aggregate?: InputMaybe<Aggregator_Factory_Aggregator_Lambda_Aggregate_Bool_Exp>;
  aggregator_name_max_length?: InputMaybe<Smallint_Comparison_Exp>;
  aggregators?: InputMaybe<Aggregator_Bool_Exp>;
  aggregators_aggregate?: InputMaybe<Aggregator_Aggregate_Bool_Exp>;
  create_aggregator_paused?: InputMaybe<Boolean_Comparison_Exp>;
  distribute_reward_mvrk_paused?: InputMaybe<Boolean_Comparison_Exp>;
  distribute_reward_smvn_paused?: InputMaybe<Boolean_Comparison_Exp>;
  general_contracts?: InputMaybe<Aggregator_Factory_General_Contract_Bool_Exp>;
  general_contracts_aggregate?: InputMaybe<Aggregator_Factory_General_Contract_Aggregate_Bool_Exp>;
  governance?: InputMaybe<Governance_Bool_Exp>;
  governance_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambdas?: InputMaybe<Aggregator_Factory_Lambda_Bool_Exp>;
  lambdas_aggregate?: InputMaybe<Aggregator_Factory_Lambda_Aggregate_Bool_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
  track_aggregator_paused?: InputMaybe<Boolean_Comparison_Exp>;
  untrack_aggregator_paused?: InputMaybe<Boolean_Comparison_Exp>;
  whitelist_contracts?: InputMaybe<Aggregator_Factory_Whitelist_Contract_Bool_Exp>;
  whitelist_contracts_aggregate?: InputMaybe<Aggregator_Factory_Whitelist_Contract_Aggregate_Bool_Exp>;
};

/** columns and relationships of "aggregator_factory_general_contract" */
export type Aggregator_Factory_General_Contract = {
  __typename?: 'aggregator_factory_general_contract';
  /** An object relationship */
  contract: Aggregator_Factory;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  contract_name: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "aggregator_factory_general_contract" */
export type Aggregator_Factory_General_Contract_Aggregate = {
  __typename?: 'aggregator_factory_general_contract_aggregate';
  aggregate?: Maybe<Aggregator_Factory_General_Contract_Aggregate_Fields>;
  nodes: Array<Aggregator_Factory_General_Contract>;
};

export type Aggregator_Factory_General_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Aggregator_Factory_General_Contract_Aggregate_Bool_Exp_Count>;
};

export type Aggregator_Factory_General_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Aggregator_Factory_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Factory_General_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "aggregator_factory_general_contract" */
export type Aggregator_Factory_General_Contract_Aggregate_Fields = {
  __typename?: 'aggregator_factory_general_contract_aggregate_fields';
  avg?: Maybe<Aggregator_Factory_General_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Aggregator_Factory_General_Contract_Max_Fields>;
  min?: Maybe<Aggregator_Factory_General_Contract_Min_Fields>;
  stddev?: Maybe<Aggregator_Factory_General_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Aggregator_Factory_General_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Aggregator_Factory_General_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Aggregator_Factory_General_Contract_Sum_Fields>;
  var_pop?: Maybe<Aggregator_Factory_General_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Aggregator_Factory_General_Contract_Var_Samp_Fields>;
  variance?: Maybe<Aggregator_Factory_General_Contract_Variance_Fields>;
};


/** aggregate fields of "aggregator_factory_general_contract" */
export type Aggregator_Factory_General_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Aggregator_Factory_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "aggregator_factory_general_contract" */
export type Aggregator_Factory_General_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Aggregator_Factory_General_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Aggregator_Factory_General_Contract_Max_Order_By>;
  min?: InputMaybe<Aggregator_Factory_General_Contract_Min_Order_By>;
  stddev?: InputMaybe<Aggregator_Factory_General_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Aggregator_Factory_General_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Aggregator_Factory_General_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Aggregator_Factory_General_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Aggregator_Factory_General_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Aggregator_Factory_General_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Aggregator_Factory_General_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Aggregator_Factory_General_Contract_Avg_Fields = {
  __typename?: 'aggregator_factory_general_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "aggregator_factory_general_contract" */
export type Aggregator_Factory_General_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "aggregator_factory_general_contract". All fields are combined with a logical 'AND'. */
export type Aggregator_Factory_General_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Aggregator_Factory_General_Contract_Bool_Exp>>;
  _not?: InputMaybe<Aggregator_Factory_General_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Aggregator_Factory_General_Contract_Bool_Exp>>;
  contract?: InputMaybe<Aggregator_Factory_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  contract_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Aggregator_Factory_General_Contract_Max_Fields = {
  __typename?: 'aggregator_factory_general_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "aggregator_factory_general_contract" */
export type Aggregator_Factory_General_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Aggregator_Factory_General_Contract_Min_Fields = {
  __typename?: 'aggregator_factory_general_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "aggregator_factory_general_contract" */
export type Aggregator_Factory_General_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "aggregator_factory_general_contract". */
export type Aggregator_Factory_General_Contract_Order_By = {
  contract?: InputMaybe<Aggregator_Factory_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "aggregator_factory_general_contract" */
export enum Aggregator_Factory_General_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  ContractName = 'contract_name',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Aggregator_Factory_General_Contract_Stddev_Fields = {
  __typename?: 'aggregator_factory_general_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "aggregator_factory_general_contract" */
export type Aggregator_Factory_General_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Aggregator_Factory_General_Contract_Stddev_Pop_Fields = {
  __typename?: 'aggregator_factory_general_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "aggregator_factory_general_contract" */
export type Aggregator_Factory_General_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Aggregator_Factory_General_Contract_Stddev_Samp_Fields = {
  __typename?: 'aggregator_factory_general_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "aggregator_factory_general_contract" */
export type Aggregator_Factory_General_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "aggregator_factory_general_contract" */
export type Aggregator_Factory_General_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Aggregator_Factory_General_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Aggregator_Factory_General_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  contract_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Aggregator_Factory_General_Contract_Sum_Fields = {
  __typename?: 'aggregator_factory_general_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "aggregator_factory_general_contract" */
export type Aggregator_Factory_General_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Aggregator_Factory_General_Contract_Var_Pop_Fields = {
  __typename?: 'aggregator_factory_general_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "aggregator_factory_general_contract" */
export type Aggregator_Factory_General_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Aggregator_Factory_General_Contract_Var_Samp_Fields = {
  __typename?: 'aggregator_factory_general_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "aggregator_factory_general_contract" */
export type Aggregator_Factory_General_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Aggregator_Factory_General_Contract_Variance_Fields = {
  __typename?: 'aggregator_factory_general_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "aggregator_factory_general_contract" */
export type Aggregator_Factory_General_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "aggregator_factory_lambda" */
export type Aggregator_Factory_Lambda = {
  __typename?: 'aggregator_factory_lambda';
  /** An object relationship */
  contract: Aggregator_Factory;
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lambda_bytes: Scalars['String']['output'];
  lambda_name: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "aggregator_factory_lambda" */
export type Aggregator_Factory_Lambda_Aggregate = {
  __typename?: 'aggregator_factory_lambda_aggregate';
  aggregate?: Maybe<Aggregator_Factory_Lambda_Aggregate_Fields>;
  nodes: Array<Aggregator_Factory_Lambda>;
};

export type Aggregator_Factory_Lambda_Aggregate_Bool_Exp = {
  count?: InputMaybe<Aggregator_Factory_Lambda_Aggregate_Bool_Exp_Count>;
};

export type Aggregator_Factory_Lambda_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Aggregator_Factory_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Factory_Lambda_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "aggregator_factory_lambda" */
export type Aggregator_Factory_Lambda_Aggregate_Fields = {
  __typename?: 'aggregator_factory_lambda_aggregate_fields';
  avg?: Maybe<Aggregator_Factory_Lambda_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Aggregator_Factory_Lambda_Max_Fields>;
  min?: Maybe<Aggregator_Factory_Lambda_Min_Fields>;
  stddev?: Maybe<Aggregator_Factory_Lambda_Stddev_Fields>;
  stddev_pop?: Maybe<Aggregator_Factory_Lambda_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Aggregator_Factory_Lambda_Stddev_Samp_Fields>;
  sum?: Maybe<Aggregator_Factory_Lambda_Sum_Fields>;
  var_pop?: Maybe<Aggregator_Factory_Lambda_Var_Pop_Fields>;
  var_samp?: Maybe<Aggregator_Factory_Lambda_Var_Samp_Fields>;
  variance?: Maybe<Aggregator_Factory_Lambda_Variance_Fields>;
};


/** aggregate fields of "aggregator_factory_lambda" */
export type Aggregator_Factory_Lambda_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Aggregator_Factory_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "aggregator_factory_lambda" */
export type Aggregator_Factory_Lambda_Aggregate_Order_By = {
  avg?: InputMaybe<Aggregator_Factory_Lambda_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Aggregator_Factory_Lambda_Max_Order_By>;
  min?: InputMaybe<Aggregator_Factory_Lambda_Min_Order_By>;
  stddev?: InputMaybe<Aggregator_Factory_Lambda_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Aggregator_Factory_Lambda_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Aggregator_Factory_Lambda_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Aggregator_Factory_Lambda_Sum_Order_By>;
  var_pop?: InputMaybe<Aggregator_Factory_Lambda_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Aggregator_Factory_Lambda_Var_Samp_Order_By>;
  variance?: InputMaybe<Aggregator_Factory_Lambda_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Aggregator_Factory_Lambda_Avg_Fields = {
  __typename?: 'aggregator_factory_lambda_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "aggregator_factory_lambda" */
export type Aggregator_Factory_Lambda_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "aggregator_factory_lambda". All fields are combined with a logical 'AND'. */
export type Aggregator_Factory_Lambda_Bool_Exp = {
  _and?: InputMaybe<Array<Aggregator_Factory_Lambda_Bool_Exp>>;
  _not?: InputMaybe<Aggregator_Factory_Lambda_Bool_Exp>;
  _or?: InputMaybe<Array<Aggregator_Factory_Lambda_Bool_Exp>>;
  contract?: InputMaybe<Aggregator_Factory_Bool_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambda_bytes?: InputMaybe<String_Comparison_Exp>;
  lambda_name?: InputMaybe<String_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Aggregator_Factory_Lambda_Max_Fields = {
  __typename?: 'aggregator_factory_lambda_max_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "aggregator_factory_lambda" */
export type Aggregator_Factory_Lambda_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Aggregator_Factory_Lambda_Min_Fields = {
  __typename?: 'aggregator_factory_lambda_min_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "aggregator_factory_lambda" */
export type Aggregator_Factory_Lambda_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "aggregator_factory_lambda". */
export type Aggregator_Factory_Lambda_Order_By = {
  contract?: InputMaybe<Aggregator_Factory_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "aggregator_factory_lambda" */
export enum Aggregator_Factory_Lambda_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaBytes = 'lambda_bytes',
  /** column name */
  LambdaName = 'lambda_name',
  /** column name */
  LastUpdatedAt = 'last_updated_at'
}

/** aggregate stddev on columns */
export type Aggregator_Factory_Lambda_Stddev_Fields = {
  __typename?: 'aggregator_factory_lambda_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "aggregator_factory_lambda" */
export type Aggregator_Factory_Lambda_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Aggregator_Factory_Lambda_Stddev_Pop_Fields = {
  __typename?: 'aggregator_factory_lambda_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "aggregator_factory_lambda" */
export type Aggregator_Factory_Lambda_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Aggregator_Factory_Lambda_Stddev_Samp_Fields = {
  __typename?: 'aggregator_factory_lambda_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "aggregator_factory_lambda" */
export type Aggregator_Factory_Lambda_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "aggregator_factory_lambda" */
export type Aggregator_Factory_Lambda_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Aggregator_Factory_Lambda_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Aggregator_Factory_Lambda_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lambda_bytes?: InputMaybe<Scalars['String']['input']>;
  lambda_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Aggregator_Factory_Lambda_Sum_Fields = {
  __typename?: 'aggregator_factory_lambda_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "aggregator_factory_lambda" */
export type Aggregator_Factory_Lambda_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Aggregator_Factory_Lambda_Var_Pop_Fields = {
  __typename?: 'aggregator_factory_lambda_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "aggregator_factory_lambda" */
export type Aggregator_Factory_Lambda_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Aggregator_Factory_Lambda_Var_Samp_Fields = {
  __typename?: 'aggregator_factory_lambda_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "aggregator_factory_lambda" */
export type Aggregator_Factory_Lambda_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Aggregator_Factory_Lambda_Variance_Fields = {
  __typename?: 'aggregator_factory_lambda_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "aggregator_factory_lambda" */
export type Aggregator_Factory_Lambda_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Aggregator_Factory_Max_Fields = {
  __typename?: 'aggregator_factory_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  aggregator_name_max_length?: Maybe<Scalars['smallint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  network?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "aggregator_factory" */
export type Aggregator_Factory_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  aggregator_name_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Aggregator_Factory_Min_Fields = {
  __typename?: 'aggregator_factory_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  aggregator_name_max_length?: Maybe<Scalars['smallint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  network?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "aggregator_factory" */
export type Aggregator_Factory_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  aggregator_name_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "aggregator_factory". */
export type Aggregator_Factory_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  aggregator_lambdas_aggregate?: InputMaybe<Aggregator_Factory_Aggregator_Lambda_Aggregate_Order_By>;
  aggregator_name_max_length?: InputMaybe<Order_By>;
  aggregators_aggregate?: InputMaybe<Aggregator_Aggregate_Order_By>;
  create_aggregator_paused?: InputMaybe<Order_By>;
  distribute_reward_mvrk_paused?: InputMaybe<Order_By>;
  distribute_reward_smvn_paused?: InputMaybe<Order_By>;
  general_contracts_aggregate?: InputMaybe<Aggregator_Factory_General_Contract_Aggregate_Order_By>;
  governance?: InputMaybe<Governance_Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambdas_aggregate?: InputMaybe<Aggregator_Factory_Lambda_Aggregate_Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  track_aggregator_paused?: InputMaybe<Order_By>;
  untrack_aggregator_paused?: InputMaybe<Order_By>;
  whitelist_contracts_aggregate?: InputMaybe<Aggregator_Factory_Whitelist_Contract_Aggregate_Order_By>;
};

/** select columns of table "aggregator_factory" */
export enum Aggregator_Factory_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Admin = 'admin',
  /** column name */
  AggregatorNameMaxLength = 'aggregator_name_max_length',
  /** column name */
  CreateAggregatorPaused = 'create_aggregator_paused',
  /** column name */
  DistributeRewardMvrkPaused = 'distribute_reward_mvrk_paused',
  /** column name */
  DistributeRewardSmvnPaused = 'distribute_reward_smvn_paused',
  /** column name */
  GovernanceId = 'governance_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Network = 'network',
  /** column name */
  TrackAggregatorPaused = 'track_aggregator_paused',
  /** column name */
  UntrackAggregatorPaused = 'untrack_aggregator_paused'
}

/** select "aggregator_factory_aggregate_bool_exp_bool_and_arguments_columns" columns of table "aggregator_factory" */
export enum Aggregator_Factory_Select_Column_Aggregator_Factory_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CreateAggregatorPaused = 'create_aggregator_paused',
  /** column name */
  DistributeRewardMvrkPaused = 'distribute_reward_mvrk_paused',
  /** column name */
  DistributeRewardSmvnPaused = 'distribute_reward_smvn_paused',
  /** column name */
  TrackAggregatorPaused = 'track_aggregator_paused',
  /** column name */
  UntrackAggregatorPaused = 'untrack_aggregator_paused'
}

/** select "aggregator_factory_aggregate_bool_exp_bool_or_arguments_columns" columns of table "aggregator_factory" */
export enum Aggregator_Factory_Select_Column_Aggregator_Factory_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CreateAggregatorPaused = 'create_aggregator_paused',
  /** column name */
  DistributeRewardMvrkPaused = 'distribute_reward_mvrk_paused',
  /** column name */
  DistributeRewardSmvnPaused = 'distribute_reward_smvn_paused',
  /** column name */
  TrackAggregatorPaused = 'track_aggregator_paused',
  /** column name */
  UntrackAggregatorPaused = 'untrack_aggregator_paused'
}

/** aggregate stddev on columns */
export type Aggregator_Factory_Stddev_Fields = {
  __typename?: 'aggregator_factory_stddev_fields';
  aggregator_name_max_length?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "aggregator_factory" */
export type Aggregator_Factory_Stddev_Order_By = {
  aggregator_name_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Aggregator_Factory_Stddev_Pop_Fields = {
  __typename?: 'aggregator_factory_stddev_pop_fields';
  aggregator_name_max_length?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "aggregator_factory" */
export type Aggregator_Factory_Stddev_Pop_Order_By = {
  aggregator_name_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Aggregator_Factory_Stddev_Samp_Fields = {
  __typename?: 'aggregator_factory_stddev_samp_fields';
  aggregator_name_max_length?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "aggregator_factory" */
export type Aggregator_Factory_Stddev_Samp_Order_By = {
  aggregator_name_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "aggregator_factory" */
export type Aggregator_Factory_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Aggregator_Factory_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Aggregator_Factory_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['String']['input']>;
  aggregator_name_max_length?: InputMaybe<Scalars['smallint']['input']>;
  create_aggregator_paused?: InputMaybe<Scalars['Boolean']['input']>;
  distribute_reward_mvrk_paused?: InputMaybe<Scalars['Boolean']['input']>;
  distribute_reward_smvn_paused?: InputMaybe<Scalars['Boolean']['input']>;
  governance_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  track_aggregator_paused?: InputMaybe<Scalars['Boolean']['input']>;
  untrack_aggregator_paused?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Aggregator_Factory_Sum_Fields = {
  __typename?: 'aggregator_factory_sum_fields';
  aggregator_name_max_length?: Maybe<Scalars['smallint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "aggregator_factory" */
export type Aggregator_Factory_Sum_Order_By = {
  aggregator_name_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Aggregator_Factory_Var_Pop_Fields = {
  __typename?: 'aggregator_factory_var_pop_fields';
  aggregator_name_max_length?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "aggregator_factory" */
export type Aggregator_Factory_Var_Pop_Order_By = {
  aggregator_name_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Aggregator_Factory_Var_Samp_Fields = {
  __typename?: 'aggregator_factory_var_samp_fields';
  aggregator_name_max_length?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "aggregator_factory" */
export type Aggregator_Factory_Var_Samp_Order_By = {
  aggregator_name_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Aggregator_Factory_Variance_Fields = {
  __typename?: 'aggregator_factory_variance_fields';
  aggregator_name_max_length?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "aggregator_factory" */
export type Aggregator_Factory_Variance_Order_By = {
  aggregator_name_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "aggregator_factory_whitelist_contract" */
export type Aggregator_Factory_Whitelist_Contract = {
  __typename?: 'aggregator_factory_whitelist_contract';
  /** An object relationship */
  contract: Aggregator_Factory;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "aggregator_factory_whitelist_contract" */
export type Aggregator_Factory_Whitelist_Contract_Aggregate = {
  __typename?: 'aggregator_factory_whitelist_contract_aggregate';
  aggregate?: Maybe<Aggregator_Factory_Whitelist_Contract_Aggregate_Fields>;
  nodes: Array<Aggregator_Factory_Whitelist_Contract>;
};

export type Aggregator_Factory_Whitelist_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Aggregator_Factory_Whitelist_Contract_Aggregate_Bool_Exp_Count>;
};

export type Aggregator_Factory_Whitelist_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Aggregator_Factory_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Factory_Whitelist_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "aggregator_factory_whitelist_contract" */
export type Aggregator_Factory_Whitelist_Contract_Aggregate_Fields = {
  __typename?: 'aggregator_factory_whitelist_contract_aggregate_fields';
  avg?: Maybe<Aggregator_Factory_Whitelist_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Aggregator_Factory_Whitelist_Contract_Max_Fields>;
  min?: Maybe<Aggregator_Factory_Whitelist_Contract_Min_Fields>;
  stddev?: Maybe<Aggregator_Factory_Whitelist_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Aggregator_Factory_Whitelist_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Aggregator_Factory_Whitelist_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Aggregator_Factory_Whitelist_Contract_Sum_Fields>;
  var_pop?: Maybe<Aggregator_Factory_Whitelist_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Aggregator_Factory_Whitelist_Contract_Var_Samp_Fields>;
  variance?: Maybe<Aggregator_Factory_Whitelist_Contract_Variance_Fields>;
};


/** aggregate fields of "aggregator_factory_whitelist_contract" */
export type Aggregator_Factory_Whitelist_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Aggregator_Factory_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "aggregator_factory_whitelist_contract" */
export type Aggregator_Factory_Whitelist_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Aggregator_Factory_Whitelist_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Aggregator_Factory_Whitelist_Contract_Max_Order_By>;
  min?: InputMaybe<Aggregator_Factory_Whitelist_Contract_Min_Order_By>;
  stddev?: InputMaybe<Aggregator_Factory_Whitelist_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Aggregator_Factory_Whitelist_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Aggregator_Factory_Whitelist_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Aggregator_Factory_Whitelist_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Aggregator_Factory_Whitelist_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Aggregator_Factory_Whitelist_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Aggregator_Factory_Whitelist_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Aggregator_Factory_Whitelist_Contract_Avg_Fields = {
  __typename?: 'aggregator_factory_whitelist_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "aggregator_factory_whitelist_contract" */
export type Aggregator_Factory_Whitelist_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "aggregator_factory_whitelist_contract". All fields are combined with a logical 'AND'. */
export type Aggregator_Factory_Whitelist_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Aggregator_Factory_Whitelist_Contract_Bool_Exp>>;
  _not?: InputMaybe<Aggregator_Factory_Whitelist_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Aggregator_Factory_Whitelist_Contract_Bool_Exp>>;
  contract?: InputMaybe<Aggregator_Factory_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Aggregator_Factory_Whitelist_Contract_Max_Fields = {
  __typename?: 'aggregator_factory_whitelist_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "aggregator_factory_whitelist_contract" */
export type Aggregator_Factory_Whitelist_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Aggregator_Factory_Whitelist_Contract_Min_Fields = {
  __typename?: 'aggregator_factory_whitelist_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "aggregator_factory_whitelist_contract" */
export type Aggregator_Factory_Whitelist_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "aggregator_factory_whitelist_contract". */
export type Aggregator_Factory_Whitelist_Contract_Order_By = {
  contract?: InputMaybe<Aggregator_Factory_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "aggregator_factory_whitelist_contract" */
export enum Aggregator_Factory_Whitelist_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Aggregator_Factory_Whitelist_Contract_Stddev_Fields = {
  __typename?: 'aggregator_factory_whitelist_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "aggregator_factory_whitelist_contract" */
export type Aggregator_Factory_Whitelist_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Aggregator_Factory_Whitelist_Contract_Stddev_Pop_Fields = {
  __typename?: 'aggregator_factory_whitelist_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "aggregator_factory_whitelist_contract" */
export type Aggregator_Factory_Whitelist_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Aggregator_Factory_Whitelist_Contract_Stddev_Samp_Fields = {
  __typename?: 'aggregator_factory_whitelist_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "aggregator_factory_whitelist_contract" */
export type Aggregator_Factory_Whitelist_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "aggregator_factory_whitelist_contract" */
export type Aggregator_Factory_Whitelist_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Aggregator_Factory_Whitelist_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Aggregator_Factory_Whitelist_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Aggregator_Factory_Whitelist_Contract_Sum_Fields = {
  __typename?: 'aggregator_factory_whitelist_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "aggregator_factory_whitelist_contract" */
export type Aggregator_Factory_Whitelist_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Aggregator_Factory_Whitelist_Contract_Var_Pop_Fields = {
  __typename?: 'aggregator_factory_whitelist_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "aggregator_factory_whitelist_contract" */
export type Aggregator_Factory_Whitelist_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Aggregator_Factory_Whitelist_Contract_Var_Samp_Fields = {
  __typename?: 'aggregator_factory_whitelist_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "aggregator_factory_whitelist_contract" */
export type Aggregator_Factory_Whitelist_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Aggregator_Factory_Whitelist_Contract_Variance_Fields = {
  __typename?: 'aggregator_factory_whitelist_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "aggregator_factory_whitelist_contract" */
export type Aggregator_Factory_Whitelist_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "aggregator_general_contract" */
export type Aggregator_General_Contract = {
  __typename?: 'aggregator_general_contract';
  /** An object relationship */
  contract: Aggregator;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  contract_name: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "aggregator_general_contract" */
export type Aggregator_General_Contract_Aggregate = {
  __typename?: 'aggregator_general_contract_aggregate';
  aggregate?: Maybe<Aggregator_General_Contract_Aggregate_Fields>;
  nodes: Array<Aggregator_General_Contract>;
};

export type Aggregator_General_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Aggregator_General_Contract_Aggregate_Bool_Exp_Count>;
};

export type Aggregator_General_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Aggregator_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_General_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "aggregator_general_contract" */
export type Aggregator_General_Contract_Aggregate_Fields = {
  __typename?: 'aggregator_general_contract_aggregate_fields';
  avg?: Maybe<Aggregator_General_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Aggregator_General_Contract_Max_Fields>;
  min?: Maybe<Aggregator_General_Contract_Min_Fields>;
  stddev?: Maybe<Aggregator_General_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Aggregator_General_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Aggregator_General_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Aggregator_General_Contract_Sum_Fields>;
  var_pop?: Maybe<Aggregator_General_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Aggregator_General_Contract_Var_Samp_Fields>;
  variance?: Maybe<Aggregator_General_Contract_Variance_Fields>;
};


/** aggregate fields of "aggregator_general_contract" */
export type Aggregator_General_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Aggregator_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "aggregator_general_contract" */
export type Aggregator_General_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Aggregator_General_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Aggregator_General_Contract_Max_Order_By>;
  min?: InputMaybe<Aggregator_General_Contract_Min_Order_By>;
  stddev?: InputMaybe<Aggregator_General_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Aggregator_General_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Aggregator_General_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Aggregator_General_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Aggregator_General_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Aggregator_General_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Aggregator_General_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Aggregator_General_Contract_Avg_Fields = {
  __typename?: 'aggregator_general_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "aggregator_general_contract" */
export type Aggregator_General_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "aggregator_general_contract". All fields are combined with a logical 'AND'. */
export type Aggregator_General_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Aggregator_General_Contract_Bool_Exp>>;
  _not?: InputMaybe<Aggregator_General_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Aggregator_General_Contract_Bool_Exp>>;
  contract?: InputMaybe<Aggregator_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  contract_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Aggregator_General_Contract_Max_Fields = {
  __typename?: 'aggregator_general_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "aggregator_general_contract" */
export type Aggregator_General_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Aggregator_General_Contract_Min_Fields = {
  __typename?: 'aggregator_general_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "aggregator_general_contract" */
export type Aggregator_General_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "aggregator_general_contract". */
export type Aggregator_General_Contract_Order_By = {
  contract?: InputMaybe<Aggregator_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "aggregator_general_contract" */
export enum Aggregator_General_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  ContractName = 'contract_name',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Aggregator_General_Contract_Stddev_Fields = {
  __typename?: 'aggregator_general_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "aggregator_general_contract" */
export type Aggregator_General_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Aggregator_General_Contract_Stddev_Pop_Fields = {
  __typename?: 'aggregator_general_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "aggregator_general_contract" */
export type Aggregator_General_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Aggregator_General_Contract_Stddev_Samp_Fields = {
  __typename?: 'aggregator_general_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "aggregator_general_contract" */
export type Aggregator_General_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "aggregator_general_contract" */
export type Aggregator_General_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Aggregator_General_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Aggregator_General_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  contract_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Aggregator_General_Contract_Sum_Fields = {
  __typename?: 'aggregator_general_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "aggregator_general_contract" */
export type Aggregator_General_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Aggregator_General_Contract_Var_Pop_Fields = {
  __typename?: 'aggregator_general_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "aggregator_general_contract" */
export type Aggregator_General_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Aggregator_General_Contract_Var_Samp_Fields = {
  __typename?: 'aggregator_general_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "aggregator_general_contract" */
export type Aggregator_General_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Aggregator_General_Contract_Variance_Fields = {
  __typename?: 'aggregator_general_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "aggregator_general_contract" */
export type Aggregator_General_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "aggregator_history_data" */
export type Aggregator_History_Data = {
  __typename?: 'aggregator_history_data';
  /** An object relationship */
  aggregator: Aggregator;
  aggregator_id: Scalars['bigint']['output'];
  data: Scalars['float8']['output'];
  epoch: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  pct_oracle_resp: Scalars['smallint']['output'];
  round: Scalars['bigint']['output'];
  timestamp: Scalars['timestamptz']['output'];
};

/** aggregated selection of "aggregator_history_data" */
export type Aggregator_History_Data_Aggregate = {
  __typename?: 'aggregator_history_data_aggregate';
  aggregate?: Maybe<Aggregator_History_Data_Aggregate_Fields>;
  nodes: Array<Aggregator_History_Data>;
};

export type Aggregator_History_Data_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Aggregator_History_Data_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Aggregator_History_Data_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Aggregator_History_Data_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Aggregator_History_Data_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Aggregator_History_Data_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Aggregator_History_Data_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Aggregator_History_Data_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Aggregator_History_Data_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Aggregator_History_Data_Aggregate_Bool_Exp_Var_Samp>;
};

export type Aggregator_History_Data_Aggregate_Bool_Exp_Avg = {
  arguments: Aggregator_History_Data_Select_Column_Aggregator_History_Data_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_History_Data_Aggregate_Bool_Exp_Corr = {
  arguments: Aggregator_History_Data_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_History_Data_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Aggregator_History_Data_Select_Column_Aggregator_History_Data_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Aggregator_History_Data_Select_Column_Aggregator_History_Data_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Aggregator_History_Data_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Aggregator_History_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_History_Data_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Aggregator_History_Data_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Aggregator_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Aggregator_History_Data_Select_Column_Aggregator_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Aggregator_History_Data_Select_Column_Aggregator_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Aggregator_History_Data_Aggregate_Bool_Exp_Max = {
  arguments: Aggregator_History_Data_Select_Column_Aggregator_History_Data_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_History_Data_Aggregate_Bool_Exp_Min = {
  arguments: Aggregator_History_Data_Select_Column_Aggregator_History_Data_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_History_Data_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Aggregator_History_Data_Select_Column_Aggregator_History_Data_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_History_Data_Aggregate_Bool_Exp_Sum = {
  arguments: Aggregator_History_Data_Select_Column_Aggregator_History_Data_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_History_Data_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Aggregator_History_Data_Select_Column_Aggregator_History_Data_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "aggregator_history_data" */
export type Aggregator_History_Data_Aggregate_Fields = {
  __typename?: 'aggregator_history_data_aggregate_fields';
  avg?: Maybe<Aggregator_History_Data_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Aggregator_History_Data_Max_Fields>;
  min?: Maybe<Aggregator_History_Data_Min_Fields>;
  stddev?: Maybe<Aggregator_History_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Aggregator_History_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Aggregator_History_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Aggregator_History_Data_Sum_Fields>;
  var_pop?: Maybe<Aggregator_History_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Aggregator_History_Data_Var_Samp_Fields>;
  variance?: Maybe<Aggregator_History_Data_Variance_Fields>;
};


/** aggregate fields of "aggregator_history_data" */
export type Aggregator_History_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Aggregator_History_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "aggregator_history_data" */
export type Aggregator_History_Data_Aggregate_Order_By = {
  avg?: InputMaybe<Aggregator_History_Data_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Aggregator_History_Data_Max_Order_By>;
  min?: InputMaybe<Aggregator_History_Data_Min_Order_By>;
  stddev?: InputMaybe<Aggregator_History_Data_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Aggregator_History_Data_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Aggregator_History_Data_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Aggregator_History_Data_Sum_Order_By>;
  var_pop?: InputMaybe<Aggregator_History_Data_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Aggregator_History_Data_Var_Samp_Order_By>;
  variance?: InputMaybe<Aggregator_History_Data_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Aggregator_History_Data_Avg_Fields = {
  __typename?: 'aggregator_history_data_avg_fields';
  aggregator_id?: Maybe<Scalars['Float']['output']>;
  data?: Maybe<Scalars['Float']['output']>;
  epoch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  pct_oracle_resp?: Maybe<Scalars['Float']['output']>;
  round?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "aggregator_history_data" */
export type Aggregator_History_Data_Avg_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  epoch?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pct_oracle_resp?: InputMaybe<Order_By>;
  round?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "aggregator_history_data". All fields are combined with a logical 'AND'. */
export type Aggregator_History_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Aggregator_History_Data_Bool_Exp>>;
  _not?: InputMaybe<Aggregator_History_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Aggregator_History_Data_Bool_Exp>>;
  aggregator?: InputMaybe<Aggregator_Bool_Exp>;
  aggregator_id?: InputMaybe<Bigint_Comparison_Exp>;
  data?: InputMaybe<Float8_Comparison_Exp>;
  epoch?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  pct_oracle_resp?: InputMaybe<Smallint_Comparison_Exp>;
  round?: InputMaybe<Bigint_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Aggregator_History_Data_Max_Fields = {
  __typename?: 'aggregator_history_data_max_fields';
  aggregator_id?: Maybe<Scalars['bigint']['output']>;
  data?: Maybe<Scalars['float8']['output']>;
  epoch?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  pct_oracle_resp?: Maybe<Scalars['smallint']['output']>;
  round?: Maybe<Scalars['bigint']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "aggregator_history_data" */
export type Aggregator_History_Data_Max_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  epoch?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pct_oracle_resp?: InputMaybe<Order_By>;
  round?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Aggregator_History_Data_Min_Fields = {
  __typename?: 'aggregator_history_data_min_fields';
  aggregator_id?: Maybe<Scalars['bigint']['output']>;
  data?: Maybe<Scalars['float8']['output']>;
  epoch?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  pct_oracle_resp?: Maybe<Scalars['smallint']['output']>;
  round?: Maybe<Scalars['bigint']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "aggregator_history_data" */
export type Aggregator_History_Data_Min_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  epoch?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pct_oracle_resp?: InputMaybe<Order_By>;
  round?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "aggregator_history_data". */
export type Aggregator_History_Data_Order_By = {
  aggregator?: InputMaybe<Aggregator_Order_By>;
  aggregator_id?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  epoch?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pct_oracle_resp?: InputMaybe<Order_By>;
  round?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
};

/** select columns of table "aggregator_history_data" */
export enum Aggregator_History_Data_Select_Column {
  /** column name */
  AggregatorId = 'aggregator_id',
  /** column name */
  Data = 'data',
  /** column name */
  Epoch = 'epoch',
  /** column name */
  Id = 'id',
  /** column name */
  PctOracleResp = 'pct_oracle_resp',
  /** column name */
  Round = 'round',
  /** column name */
  Timestamp = 'timestamp'
}

/** select "aggregator_history_data_aggregate_bool_exp_avg_arguments_columns" columns of table "aggregator_history_data" */
export enum Aggregator_History_Data_Select_Column_Aggregator_History_Data_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Data = 'data'
}

/** select "aggregator_history_data_aggregate_bool_exp_corr_arguments_columns" columns of table "aggregator_history_data" */
export enum Aggregator_History_Data_Select_Column_Aggregator_History_Data_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Data = 'data'
}

/** select "aggregator_history_data_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "aggregator_history_data" */
export enum Aggregator_History_Data_Select_Column_Aggregator_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Data = 'data'
}

/** select "aggregator_history_data_aggregate_bool_exp_max_arguments_columns" columns of table "aggregator_history_data" */
export enum Aggregator_History_Data_Select_Column_Aggregator_History_Data_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Data = 'data'
}

/** select "aggregator_history_data_aggregate_bool_exp_min_arguments_columns" columns of table "aggregator_history_data" */
export enum Aggregator_History_Data_Select_Column_Aggregator_History_Data_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Data = 'data'
}

/** select "aggregator_history_data_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "aggregator_history_data" */
export enum Aggregator_History_Data_Select_Column_Aggregator_History_Data_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Data = 'data'
}

/** select "aggregator_history_data_aggregate_bool_exp_sum_arguments_columns" columns of table "aggregator_history_data" */
export enum Aggregator_History_Data_Select_Column_Aggregator_History_Data_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Data = 'data'
}

/** select "aggregator_history_data_aggregate_bool_exp_var_samp_arguments_columns" columns of table "aggregator_history_data" */
export enum Aggregator_History_Data_Select_Column_Aggregator_History_Data_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Data = 'data'
}

/** aggregate stddev on columns */
export type Aggregator_History_Data_Stddev_Fields = {
  __typename?: 'aggregator_history_data_stddev_fields';
  aggregator_id?: Maybe<Scalars['Float']['output']>;
  data?: Maybe<Scalars['Float']['output']>;
  epoch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  pct_oracle_resp?: Maybe<Scalars['Float']['output']>;
  round?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "aggregator_history_data" */
export type Aggregator_History_Data_Stddev_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  epoch?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pct_oracle_resp?: InputMaybe<Order_By>;
  round?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Aggregator_History_Data_Stddev_Pop_Fields = {
  __typename?: 'aggregator_history_data_stddev_pop_fields';
  aggregator_id?: Maybe<Scalars['Float']['output']>;
  data?: Maybe<Scalars['Float']['output']>;
  epoch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  pct_oracle_resp?: Maybe<Scalars['Float']['output']>;
  round?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "aggregator_history_data" */
export type Aggregator_History_Data_Stddev_Pop_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  epoch?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pct_oracle_resp?: InputMaybe<Order_By>;
  round?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Aggregator_History_Data_Stddev_Samp_Fields = {
  __typename?: 'aggregator_history_data_stddev_samp_fields';
  aggregator_id?: Maybe<Scalars['Float']['output']>;
  data?: Maybe<Scalars['Float']['output']>;
  epoch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  pct_oracle_resp?: Maybe<Scalars['Float']['output']>;
  round?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "aggregator_history_data" */
export type Aggregator_History_Data_Stddev_Samp_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  epoch?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pct_oracle_resp?: InputMaybe<Order_By>;
  round?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "aggregator_history_data" */
export type Aggregator_History_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Aggregator_History_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Aggregator_History_Data_Stream_Cursor_Value_Input = {
  aggregator_id?: InputMaybe<Scalars['bigint']['input']>;
  data?: InputMaybe<Scalars['float8']['input']>;
  epoch?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  pct_oracle_resp?: InputMaybe<Scalars['smallint']['input']>;
  round?: InputMaybe<Scalars['bigint']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Aggregator_History_Data_Sum_Fields = {
  __typename?: 'aggregator_history_data_sum_fields';
  aggregator_id?: Maybe<Scalars['bigint']['output']>;
  data?: Maybe<Scalars['float8']['output']>;
  epoch?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  pct_oracle_resp?: Maybe<Scalars['smallint']['output']>;
  round?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "aggregator_history_data" */
export type Aggregator_History_Data_Sum_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  epoch?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pct_oracle_resp?: InputMaybe<Order_By>;
  round?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Aggregator_History_Data_Var_Pop_Fields = {
  __typename?: 'aggregator_history_data_var_pop_fields';
  aggregator_id?: Maybe<Scalars['Float']['output']>;
  data?: Maybe<Scalars['Float']['output']>;
  epoch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  pct_oracle_resp?: Maybe<Scalars['Float']['output']>;
  round?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "aggregator_history_data" */
export type Aggregator_History_Data_Var_Pop_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  epoch?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pct_oracle_resp?: InputMaybe<Order_By>;
  round?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Aggregator_History_Data_Var_Samp_Fields = {
  __typename?: 'aggregator_history_data_var_samp_fields';
  aggregator_id?: Maybe<Scalars['Float']['output']>;
  data?: Maybe<Scalars['Float']['output']>;
  epoch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  pct_oracle_resp?: Maybe<Scalars['Float']['output']>;
  round?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "aggregator_history_data" */
export type Aggregator_History_Data_Var_Samp_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  epoch?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pct_oracle_resp?: InputMaybe<Order_By>;
  round?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Aggregator_History_Data_Variance_Fields = {
  __typename?: 'aggregator_history_data_variance_fields';
  aggregator_id?: Maybe<Scalars['Float']['output']>;
  data?: Maybe<Scalars['Float']['output']>;
  epoch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  pct_oracle_resp?: Maybe<Scalars['Float']['output']>;
  round?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "aggregator_history_data" */
export type Aggregator_History_Data_Variance_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  epoch?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pct_oracle_resp?: InputMaybe<Order_By>;
  round?: InputMaybe<Order_By>;
};

/** columns and relationships of "aggregator_lambda" */
export type Aggregator_Lambda = {
  __typename?: 'aggregator_lambda';
  /** An object relationship */
  contract: Aggregator;
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lambda_bytes: Scalars['String']['output'];
  lambda_name: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "aggregator_lambda" */
export type Aggregator_Lambda_Aggregate = {
  __typename?: 'aggregator_lambda_aggregate';
  aggregate?: Maybe<Aggregator_Lambda_Aggregate_Fields>;
  nodes: Array<Aggregator_Lambda>;
};

export type Aggregator_Lambda_Aggregate_Bool_Exp = {
  count?: InputMaybe<Aggregator_Lambda_Aggregate_Bool_Exp_Count>;
};

export type Aggregator_Lambda_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Aggregator_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Lambda_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "aggregator_lambda" */
export type Aggregator_Lambda_Aggregate_Fields = {
  __typename?: 'aggregator_lambda_aggregate_fields';
  avg?: Maybe<Aggregator_Lambda_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Aggregator_Lambda_Max_Fields>;
  min?: Maybe<Aggregator_Lambda_Min_Fields>;
  stddev?: Maybe<Aggregator_Lambda_Stddev_Fields>;
  stddev_pop?: Maybe<Aggregator_Lambda_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Aggregator_Lambda_Stddev_Samp_Fields>;
  sum?: Maybe<Aggregator_Lambda_Sum_Fields>;
  var_pop?: Maybe<Aggregator_Lambda_Var_Pop_Fields>;
  var_samp?: Maybe<Aggregator_Lambda_Var_Samp_Fields>;
  variance?: Maybe<Aggregator_Lambda_Variance_Fields>;
};


/** aggregate fields of "aggregator_lambda" */
export type Aggregator_Lambda_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Aggregator_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "aggregator_lambda" */
export type Aggregator_Lambda_Aggregate_Order_By = {
  avg?: InputMaybe<Aggregator_Lambda_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Aggregator_Lambda_Max_Order_By>;
  min?: InputMaybe<Aggregator_Lambda_Min_Order_By>;
  stddev?: InputMaybe<Aggregator_Lambda_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Aggregator_Lambda_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Aggregator_Lambda_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Aggregator_Lambda_Sum_Order_By>;
  var_pop?: InputMaybe<Aggregator_Lambda_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Aggregator_Lambda_Var_Samp_Order_By>;
  variance?: InputMaybe<Aggregator_Lambda_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Aggregator_Lambda_Avg_Fields = {
  __typename?: 'aggregator_lambda_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "aggregator_lambda" */
export type Aggregator_Lambda_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "aggregator_lambda". All fields are combined with a logical 'AND'. */
export type Aggregator_Lambda_Bool_Exp = {
  _and?: InputMaybe<Array<Aggregator_Lambda_Bool_Exp>>;
  _not?: InputMaybe<Aggregator_Lambda_Bool_Exp>;
  _or?: InputMaybe<Array<Aggregator_Lambda_Bool_Exp>>;
  contract?: InputMaybe<Aggregator_Bool_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambda_bytes?: InputMaybe<String_Comparison_Exp>;
  lambda_name?: InputMaybe<String_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Aggregator_Lambda_Max_Fields = {
  __typename?: 'aggregator_lambda_max_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "aggregator_lambda" */
export type Aggregator_Lambda_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Aggregator_Lambda_Min_Fields = {
  __typename?: 'aggregator_lambda_min_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "aggregator_lambda" */
export type Aggregator_Lambda_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "aggregator_lambda". */
export type Aggregator_Lambda_Order_By = {
  contract?: InputMaybe<Aggregator_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "aggregator_lambda" */
export enum Aggregator_Lambda_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaBytes = 'lambda_bytes',
  /** column name */
  LambdaName = 'lambda_name',
  /** column name */
  LastUpdatedAt = 'last_updated_at'
}

/** aggregate stddev on columns */
export type Aggregator_Lambda_Stddev_Fields = {
  __typename?: 'aggregator_lambda_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "aggregator_lambda" */
export type Aggregator_Lambda_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Aggregator_Lambda_Stddev_Pop_Fields = {
  __typename?: 'aggregator_lambda_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "aggregator_lambda" */
export type Aggregator_Lambda_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Aggregator_Lambda_Stddev_Samp_Fields = {
  __typename?: 'aggregator_lambda_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "aggregator_lambda" */
export type Aggregator_Lambda_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "aggregator_lambda" */
export type Aggregator_Lambda_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Aggregator_Lambda_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Aggregator_Lambda_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lambda_bytes?: InputMaybe<Scalars['String']['input']>;
  lambda_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Aggregator_Lambda_Sum_Fields = {
  __typename?: 'aggregator_lambda_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "aggregator_lambda" */
export type Aggregator_Lambda_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Aggregator_Lambda_Var_Pop_Fields = {
  __typename?: 'aggregator_lambda_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "aggregator_lambda" */
export type Aggregator_Lambda_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Aggregator_Lambda_Var_Samp_Fields = {
  __typename?: 'aggregator_lambda_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "aggregator_lambda" */
export type Aggregator_Lambda_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Aggregator_Lambda_Variance_Fields = {
  __typename?: 'aggregator_lambda_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "aggregator_lambda" */
export type Aggregator_Lambda_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Aggregator_Max_Fields = {
  __typename?: 'aggregator_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  alpha_pct_per_thousand?: Maybe<Scalars['smallint']['output']>;
  creation_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  decimals?: Maybe<Scalars['smallint']['output']>;
  factory_id?: Maybe<Scalars['bigint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  heart_beat_seconds?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_completed_data?: Maybe<Scalars['float8']['output']>;
  last_completed_data_epoch?: Maybe<Scalars['bigint']['output']>;
  last_completed_data_last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_completed_data_pct_oracle_resp?: Maybe<Scalars['smallint']['output']>;
  last_completed_data_round?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  pct_oracle_threshold?: Maybe<Scalars['smallint']['output']>;
  reward_amount_mvrk?: Maybe<Scalars['float8']['output']>;
  reward_amount_smvn?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "aggregator" */
export type Aggregator_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  alpha_pct_per_thousand?: InputMaybe<Order_By>;
  creation_timestamp?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  heart_beat_seconds?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_completed_data?: InputMaybe<Order_By>;
  last_completed_data_epoch?: InputMaybe<Order_By>;
  last_completed_data_last_updated_at?: InputMaybe<Order_By>;
  last_completed_data_pct_oracle_resp?: InputMaybe<Order_By>;
  last_completed_data_round?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  pct_oracle_threshold?: InputMaybe<Order_By>;
  reward_amount_mvrk?: InputMaybe<Order_By>;
  reward_amount_smvn?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Aggregator_Min_Fields = {
  __typename?: 'aggregator_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  alpha_pct_per_thousand?: Maybe<Scalars['smallint']['output']>;
  creation_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  decimals?: Maybe<Scalars['smallint']['output']>;
  factory_id?: Maybe<Scalars['bigint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  heart_beat_seconds?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_completed_data?: Maybe<Scalars['float8']['output']>;
  last_completed_data_epoch?: Maybe<Scalars['bigint']['output']>;
  last_completed_data_last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_completed_data_pct_oracle_resp?: Maybe<Scalars['smallint']['output']>;
  last_completed_data_round?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  pct_oracle_threshold?: Maybe<Scalars['smallint']['output']>;
  reward_amount_mvrk?: Maybe<Scalars['float8']['output']>;
  reward_amount_smvn?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "aggregator" */
export type Aggregator_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  alpha_pct_per_thousand?: InputMaybe<Order_By>;
  creation_timestamp?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  heart_beat_seconds?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_completed_data?: InputMaybe<Order_By>;
  last_completed_data_epoch?: InputMaybe<Order_By>;
  last_completed_data_last_updated_at?: InputMaybe<Order_By>;
  last_completed_data_pct_oracle_resp?: InputMaybe<Order_By>;
  last_completed_data_round?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  pct_oracle_threshold?: InputMaybe<Order_By>;
  reward_amount_mvrk?: InputMaybe<Order_By>;
  reward_amount_smvn?: InputMaybe<Order_By>;
};

/** columns and relationships of "aggregator_oracle" */
export type Aggregator_Oracle = {
  __typename?: 'aggregator_oracle';
  /** An object relationship */
  aggregator: Aggregator;
  aggregator_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  init_epoch: Scalars['bigint']['output'];
  init_round: Scalars['bigint']['output'];
  /** An array relationship */
  observations: Array<Aggregator_Oracle_Observation>;
  /** An aggregate relationship */
  observations_aggregate: Aggregator_Oracle_Observation_Aggregate;
  peer_id: Scalars['String']['output'];
  public_key: Scalars['String']['output'];
  /** An array relationship */
  rewards: Array<Aggregator_Oracle_Reward>;
  /** An aggregate relationship */
  rewards_aggregate: Aggregator_Oracle_Reward_Aggregate;
  /** An object relationship */
  user: Maven_User;
  user_id: Scalars['bigint']['output'];
};


/** columns and relationships of "aggregator_oracle" */
export type Aggregator_OracleObservationsArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Oracle_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Oracle_Observation_Order_By>>;
  where?: InputMaybe<Aggregator_Oracle_Observation_Bool_Exp>;
};


/** columns and relationships of "aggregator_oracle" */
export type Aggregator_OracleObservations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Oracle_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Oracle_Observation_Order_By>>;
  where?: InputMaybe<Aggregator_Oracle_Observation_Bool_Exp>;
};


/** columns and relationships of "aggregator_oracle" */
export type Aggregator_OracleRewardsArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Oracle_Reward_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Oracle_Reward_Order_By>>;
  where?: InputMaybe<Aggregator_Oracle_Reward_Bool_Exp>;
};


/** columns and relationships of "aggregator_oracle" */
export type Aggregator_OracleRewards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Oracle_Reward_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Oracle_Reward_Order_By>>;
  where?: InputMaybe<Aggregator_Oracle_Reward_Bool_Exp>;
};

/** aggregated selection of "aggregator_oracle" */
export type Aggregator_Oracle_Aggregate = {
  __typename?: 'aggregator_oracle_aggregate';
  aggregate?: Maybe<Aggregator_Oracle_Aggregate_Fields>;
  nodes: Array<Aggregator_Oracle>;
};

export type Aggregator_Oracle_Aggregate_Bool_Exp = {
  count?: InputMaybe<Aggregator_Oracle_Aggregate_Bool_Exp_Count>;
};

export type Aggregator_Oracle_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Aggregator_Oracle_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Oracle_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "aggregator_oracle" */
export type Aggregator_Oracle_Aggregate_Fields = {
  __typename?: 'aggregator_oracle_aggregate_fields';
  avg?: Maybe<Aggregator_Oracle_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Aggregator_Oracle_Max_Fields>;
  min?: Maybe<Aggregator_Oracle_Min_Fields>;
  stddev?: Maybe<Aggregator_Oracle_Stddev_Fields>;
  stddev_pop?: Maybe<Aggregator_Oracle_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Aggregator_Oracle_Stddev_Samp_Fields>;
  sum?: Maybe<Aggregator_Oracle_Sum_Fields>;
  var_pop?: Maybe<Aggregator_Oracle_Var_Pop_Fields>;
  var_samp?: Maybe<Aggregator_Oracle_Var_Samp_Fields>;
  variance?: Maybe<Aggregator_Oracle_Variance_Fields>;
};


/** aggregate fields of "aggregator_oracle" */
export type Aggregator_Oracle_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Aggregator_Oracle_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "aggregator_oracle" */
export type Aggregator_Oracle_Aggregate_Order_By = {
  avg?: InputMaybe<Aggregator_Oracle_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Aggregator_Oracle_Max_Order_By>;
  min?: InputMaybe<Aggregator_Oracle_Min_Order_By>;
  stddev?: InputMaybe<Aggregator_Oracle_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Aggregator_Oracle_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Aggregator_Oracle_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Aggregator_Oracle_Sum_Order_By>;
  var_pop?: InputMaybe<Aggregator_Oracle_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Aggregator_Oracle_Var_Samp_Order_By>;
  variance?: InputMaybe<Aggregator_Oracle_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Aggregator_Oracle_Avg_Fields = {
  __typename?: 'aggregator_oracle_avg_fields';
  aggregator_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  init_epoch?: Maybe<Scalars['Float']['output']>;
  init_round?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "aggregator_oracle" */
export type Aggregator_Oracle_Avg_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  init_epoch?: InputMaybe<Order_By>;
  init_round?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "aggregator_oracle". All fields are combined with a logical 'AND'. */
export type Aggregator_Oracle_Bool_Exp = {
  _and?: InputMaybe<Array<Aggregator_Oracle_Bool_Exp>>;
  _not?: InputMaybe<Aggregator_Oracle_Bool_Exp>;
  _or?: InputMaybe<Array<Aggregator_Oracle_Bool_Exp>>;
  aggregator?: InputMaybe<Aggregator_Bool_Exp>;
  aggregator_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  init_epoch?: InputMaybe<Bigint_Comparison_Exp>;
  init_round?: InputMaybe<Bigint_Comparison_Exp>;
  observations?: InputMaybe<Aggregator_Oracle_Observation_Bool_Exp>;
  observations_aggregate?: InputMaybe<Aggregator_Oracle_Observation_Aggregate_Bool_Exp>;
  peer_id?: InputMaybe<String_Comparison_Exp>;
  public_key?: InputMaybe<String_Comparison_Exp>;
  rewards?: InputMaybe<Aggregator_Oracle_Reward_Bool_Exp>;
  rewards_aggregate?: InputMaybe<Aggregator_Oracle_Reward_Aggregate_Bool_Exp>;
  user?: InputMaybe<Maven_User_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Aggregator_Oracle_Max_Fields = {
  __typename?: 'aggregator_oracle_max_fields';
  aggregator_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  init_epoch?: Maybe<Scalars['bigint']['output']>;
  init_round?: Maybe<Scalars['bigint']['output']>;
  peer_id?: Maybe<Scalars['String']['output']>;
  public_key?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "aggregator_oracle" */
export type Aggregator_Oracle_Max_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  init_epoch?: InputMaybe<Order_By>;
  init_round?: InputMaybe<Order_By>;
  peer_id?: InputMaybe<Order_By>;
  public_key?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Aggregator_Oracle_Min_Fields = {
  __typename?: 'aggregator_oracle_min_fields';
  aggregator_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  init_epoch?: Maybe<Scalars['bigint']['output']>;
  init_round?: Maybe<Scalars['bigint']['output']>;
  peer_id?: Maybe<Scalars['String']['output']>;
  public_key?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "aggregator_oracle" */
export type Aggregator_Oracle_Min_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  init_epoch?: InputMaybe<Order_By>;
  init_round?: InputMaybe<Order_By>;
  peer_id?: InputMaybe<Order_By>;
  public_key?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "aggregator_oracle_observation" */
export type Aggregator_Oracle_Observation = {
  __typename?: 'aggregator_oracle_observation';
  data: Scalars['float8']['output'];
  epoch: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  oracle: Aggregator_Oracle;
  oracle_id: Scalars['bigint']['output'];
  round: Scalars['bigint']['output'];
  timestamp: Scalars['timestamptz']['output'];
};

/** aggregated selection of "aggregator_oracle_observation" */
export type Aggregator_Oracle_Observation_Aggregate = {
  __typename?: 'aggregator_oracle_observation_aggregate';
  aggregate?: Maybe<Aggregator_Oracle_Observation_Aggregate_Fields>;
  nodes: Array<Aggregator_Oracle_Observation>;
};

export type Aggregator_Oracle_Observation_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Var_Samp>;
};

export type Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Avg = {
  arguments: Aggregator_Oracle_Observation_Select_Column_Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Oracle_Observation_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Corr = {
  arguments: Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Oracle_Observation_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Aggregator_Oracle_Observation_Select_Column_Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Aggregator_Oracle_Observation_Select_Column_Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Aggregator_Oracle_Observation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Oracle_Observation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Oracle_Observation_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Aggregator_Oracle_Observation_Select_Column_Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Aggregator_Oracle_Observation_Select_Column_Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Max = {
  arguments: Aggregator_Oracle_Observation_Select_Column_Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Oracle_Observation_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Min = {
  arguments: Aggregator_Oracle_Observation_Select_Column_Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Oracle_Observation_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Aggregator_Oracle_Observation_Select_Column_Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Oracle_Observation_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Sum = {
  arguments: Aggregator_Oracle_Observation_Select_Column_Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Oracle_Observation_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Aggregator_Oracle_Observation_Select_Column_Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Oracle_Observation_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "aggregator_oracle_observation" */
export type Aggregator_Oracle_Observation_Aggregate_Fields = {
  __typename?: 'aggregator_oracle_observation_aggregate_fields';
  avg?: Maybe<Aggregator_Oracle_Observation_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Aggregator_Oracle_Observation_Max_Fields>;
  min?: Maybe<Aggregator_Oracle_Observation_Min_Fields>;
  stddev?: Maybe<Aggregator_Oracle_Observation_Stddev_Fields>;
  stddev_pop?: Maybe<Aggregator_Oracle_Observation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Aggregator_Oracle_Observation_Stddev_Samp_Fields>;
  sum?: Maybe<Aggregator_Oracle_Observation_Sum_Fields>;
  var_pop?: Maybe<Aggregator_Oracle_Observation_Var_Pop_Fields>;
  var_samp?: Maybe<Aggregator_Oracle_Observation_Var_Samp_Fields>;
  variance?: Maybe<Aggregator_Oracle_Observation_Variance_Fields>;
};


/** aggregate fields of "aggregator_oracle_observation" */
export type Aggregator_Oracle_Observation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Aggregator_Oracle_Observation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "aggregator_oracle_observation" */
export type Aggregator_Oracle_Observation_Aggregate_Order_By = {
  avg?: InputMaybe<Aggregator_Oracle_Observation_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Aggregator_Oracle_Observation_Max_Order_By>;
  min?: InputMaybe<Aggregator_Oracle_Observation_Min_Order_By>;
  stddev?: InputMaybe<Aggregator_Oracle_Observation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Aggregator_Oracle_Observation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Aggregator_Oracle_Observation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Aggregator_Oracle_Observation_Sum_Order_By>;
  var_pop?: InputMaybe<Aggregator_Oracle_Observation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Aggregator_Oracle_Observation_Var_Samp_Order_By>;
  variance?: InputMaybe<Aggregator_Oracle_Observation_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Aggregator_Oracle_Observation_Avg_Fields = {
  __typename?: 'aggregator_oracle_observation_avg_fields';
  data?: Maybe<Scalars['Float']['output']>;
  epoch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  round?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "aggregator_oracle_observation" */
export type Aggregator_Oracle_Observation_Avg_Order_By = {
  data?: InputMaybe<Order_By>;
  epoch?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  round?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "aggregator_oracle_observation". All fields are combined with a logical 'AND'. */
export type Aggregator_Oracle_Observation_Bool_Exp = {
  _and?: InputMaybe<Array<Aggregator_Oracle_Observation_Bool_Exp>>;
  _not?: InputMaybe<Aggregator_Oracle_Observation_Bool_Exp>;
  _or?: InputMaybe<Array<Aggregator_Oracle_Observation_Bool_Exp>>;
  data?: InputMaybe<Float8_Comparison_Exp>;
  epoch?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  oracle?: InputMaybe<Aggregator_Oracle_Bool_Exp>;
  oracle_id?: InputMaybe<Bigint_Comparison_Exp>;
  round?: InputMaybe<Bigint_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Aggregator_Oracle_Observation_Max_Fields = {
  __typename?: 'aggregator_oracle_observation_max_fields';
  data?: Maybe<Scalars['float8']['output']>;
  epoch?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  oracle_id?: Maybe<Scalars['bigint']['output']>;
  round?: Maybe<Scalars['bigint']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "aggregator_oracle_observation" */
export type Aggregator_Oracle_Observation_Max_Order_By = {
  data?: InputMaybe<Order_By>;
  epoch?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  round?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Aggregator_Oracle_Observation_Min_Fields = {
  __typename?: 'aggregator_oracle_observation_min_fields';
  data?: Maybe<Scalars['float8']['output']>;
  epoch?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  oracle_id?: Maybe<Scalars['bigint']['output']>;
  round?: Maybe<Scalars['bigint']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "aggregator_oracle_observation" */
export type Aggregator_Oracle_Observation_Min_Order_By = {
  data?: InputMaybe<Order_By>;
  epoch?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  round?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "aggregator_oracle_observation". */
export type Aggregator_Oracle_Observation_Order_By = {
  data?: InputMaybe<Order_By>;
  epoch?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oracle?: InputMaybe<Aggregator_Oracle_Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  round?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
};

/** select columns of table "aggregator_oracle_observation" */
export enum Aggregator_Oracle_Observation_Select_Column {
  /** column name */
  Data = 'data',
  /** column name */
  Epoch = 'epoch',
  /** column name */
  Id = 'id',
  /** column name */
  OracleId = 'oracle_id',
  /** column name */
  Round = 'round',
  /** column name */
  Timestamp = 'timestamp'
}

/** select "aggregator_oracle_observation_aggregate_bool_exp_avg_arguments_columns" columns of table "aggregator_oracle_observation" */
export enum Aggregator_Oracle_Observation_Select_Column_Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Data = 'data'
}

/** select "aggregator_oracle_observation_aggregate_bool_exp_corr_arguments_columns" columns of table "aggregator_oracle_observation" */
export enum Aggregator_Oracle_Observation_Select_Column_Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Data = 'data'
}

/** select "aggregator_oracle_observation_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "aggregator_oracle_observation" */
export enum Aggregator_Oracle_Observation_Select_Column_Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Data = 'data'
}

/** select "aggregator_oracle_observation_aggregate_bool_exp_max_arguments_columns" columns of table "aggregator_oracle_observation" */
export enum Aggregator_Oracle_Observation_Select_Column_Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Data = 'data'
}

/** select "aggregator_oracle_observation_aggregate_bool_exp_min_arguments_columns" columns of table "aggregator_oracle_observation" */
export enum Aggregator_Oracle_Observation_Select_Column_Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Data = 'data'
}

/** select "aggregator_oracle_observation_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "aggregator_oracle_observation" */
export enum Aggregator_Oracle_Observation_Select_Column_Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Data = 'data'
}

/** select "aggregator_oracle_observation_aggregate_bool_exp_sum_arguments_columns" columns of table "aggregator_oracle_observation" */
export enum Aggregator_Oracle_Observation_Select_Column_Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Data = 'data'
}

/** select "aggregator_oracle_observation_aggregate_bool_exp_var_samp_arguments_columns" columns of table "aggregator_oracle_observation" */
export enum Aggregator_Oracle_Observation_Select_Column_Aggregator_Oracle_Observation_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Data = 'data'
}

/** aggregate stddev on columns */
export type Aggregator_Oracle_Observation_Stddev_Fields = {
  __typename?: 'aggregator_oracle_observation_stddev_fields';
  data?: Maybe<Scalars['Float']['output']>;
  epoch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  round?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "aggregator_oracle_observation" */
export type Aggregator_Oracle_Observation_Stddev_Order_By = {
  data?: InputMaybe<Order_By>;
  epoch?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  round?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Aggregator_Oracle_Observation_Stddev_Pop_Fields = {
  __typename?: 'aggregator_oracle_observation_stddev_pop_fields';
  data?: Maybe<Scalars['Float']['output']>;
  epoch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  round?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "aggregator_oracle_observation" */
export type Aggregator_Oracle_Observation_Stddev_Pop_Order_By = {
  data?: InputMaybe<Order_By>;
  epoch?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  round?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Aggregator_Oracle_Observation_Stddev_Samp_Fields = {
  __typename?: 'aggregator_oracle_observation_stddev_samp_fields';
  data?: Maybe<Scalars['Float']['output']>;
  epoch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  round?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "aggregator_oracle_observation" */
export type Aggregator_Oracle_Observation_Stddev_Samp_Order_By = {
  data?: InputMaybe<Order_By>;
  epoch?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  round?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "aggregator_oracle_observation" */
export type Aggregator_Oracle_Observation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Aggregator_Oracle_Observation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Aggregator_Oracle_Observation_Stream_Cursor_Value_Input = {
  data?: InputMaybe<Scalars['float8']['input']>;
  epoch?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  oracle_id?: InputMaybe<Scalars['bigint']['input']>;
  round?: InputMaybe<Scalars['bigint']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Aggregator_Oracle_Observation_Sum_Fields = {
  __typename?: 'aggregator_oracle_observation_sum_fields';
  data?: Maybe<Scalars['float8']['output']>;
  epoch?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  oracle_id?: Maybe<Scalars['bigint']['output']>;
  round?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "aggregator_oracle_observation" */
export type Aggregator_Oracle_Observation_Sum_Order_By = {
  data?: InputMaybe<Order_By>;
  epoch?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  round?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Aggregator_Oracle_Observation_Var_Pop_Fields = {
  __typename?: 'aggregator_oracle_observation_var_pop_fields';
  data?: Maybe<Scalars['Float']['output']>;
  epoch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  round?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "aggregator_oracle_observation" */
export type Aggregator_Oracle_Observation_Var_Pop_Order_By = {
  data?: InputMaybe<Order_By>;
  epoch?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  round?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Aggregator_Oracle_Observation_Var_Samp_Fields = {
  __typename?: 'aggregator_oracle_observation_var_samp_fields';
  data?: Maybe<Scalars['Float']['output']>;
  epoch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  round?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "aggregator_oracle_observation" */
export type Aggregator_Oracle_Observation_Var_Samp_Order_By = {
  data?: InputMaybe<Order_By>;
  epoch?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  round?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Aggregator_Oracle_Observation_Variance_Fields = {
  __typename?: 'aggregator_oracle_observation_variance_fields';
  data?: Maybe<Scalars['Float']['output']>;
  epoch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  round?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "aggregator_oracle_observation" */
export type Aggregator_Oracle_Observation_Variance_Order_By = {
  data?: InputMaybe<Order_By>;
  epoch?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  round?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "aggregator_oracle". */
export type Aggregator_Oracle_Order_By = {
  aggregator?: InputMaybe<Aggregator_Order_By>;
  aggregator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  init_epoch?: InputMaybe<Order_By>;
  init_round?: InputMaybe<Order_By>;
  observations_aggregate?: InputMaybe<Aggregator_Oracle_Observation_Aggregate_Order_By>;
  peer_id?: InputMaybe<Order_By>;
  public_key?: InputMaybe<Order_By>;
  rewards_aggregate?: InputMaybe<Aggregator_Oracle_Reward_Aggregate_Order_By>;
  user?: InputMaybe<Maven_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "aggregator_oracle_reward" */
export type Aggregator_Oracle_Reward = {
  __typename?: 'aggregator_oracle_reward';
  id: Scalars['bigint']['output'];
  /** An object relationship */
  oracle: Aggregator_Oracle;
  oracle_id: Scalars['bigint']['output'];
  reward: Scalars['float8']['output'];
  /** MVRK: 0\nSMVN: 1 */
  type: Scalars['smallint']['output'];
};

/** aggregated selection of "aggregator_oracle_reward" */
export type Aggregator_Oracle_Reward_Aggregate = {
  __typename?: 'aggregator_oracle_reward_aggregate';
  aggregate?: Maybe<Aggregator_Oracle_Reward_Aggregate_Fields>;
  nodes: Array<Aggregator_Oracle_Reward>;
};

export type Aggregator_Oracle_Reward_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Var_Samp>;
};

export type Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Avg = {
  arguments: Aggregator_Oracle_Reward_Select_Column_Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Oracle_Reward_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Corr = {
  arguments: Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Oracle_Reward_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Aggregator_Oracle_Reward_Select_Column_Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Aggregator_Oracle_Reward_Select_Column_Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Aggregator_Oracle_Reward_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Oracle_Reward_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Oracle_Reward_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Aggregator_Oracle_Reward_Select_Column_Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Aggregator_Oracle_Reward_Select_Column_Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Max = {
  arguments: Aggregator_Oracle_Reward_Select_Column_Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Oracle_Reward_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Min = {
  arguments: Aggregator_Oracle_Reward_Select_Column_Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Oracle_Reward_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Aggregator_Oracle_Reward_Select_Column_Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Oracle_Reward_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Sum = {
  arguments: Aggregator_Oracle_Reward_Select_Column_Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Oracle_Reward_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Aggregator_Oracle_Reward_Select_Column_Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Oracle_Reward_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "aggregator_oracle_reward" */
export type Aggregator_Oracle_Reward_Aggregate_Fields = {
  __typename?: 'aggregator_oracle_reward_aggregate_fields';
  avg?: Maybe<Aggregator_Oracle_Reward_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Aggregator_Oracle_Reward_Max_Fields>;
  min?: Maybe<Aggregator_Oracle_Reward_Min_Fields>;
  stddev?: Maybe<Aggregator_Oracle_Reward_Stddev_Fields>;
  stddev_pop?: Maybe<Aggregator_Oracle_Reward_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Aggregator_Oracle_Reward_Stddev_Samp_Fields>;
  sum?: Maybe<Aggregator_Oracle_Reward_Sum_Fields>;
  var_pop?: Maybe<Aggregator_Oracle_Reward_Var_Pop_Fields>;
  var_samp?: Maybe<Aggregator_Oracle_Reward_Var_Samp_Fields>;
  variance?: Maybe<Aggregator_Oracle_Reward_Variance_Fields>;
};


/** aggregate fields of "aggregator_oracle_reward" */
export type Aggregator_Oracle_Reward_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Aggregator_Oracle_Reward_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "aggregator_oracle_reward" */
export type Aggregator_Oracle_Reward_Aggregate_Order_By = {
  avg?: InputMaybe<Aggregator_Oracle_Reward_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Aggregator_Oracle_Reward_Max_Order_By>;
  min?: InputMaybe<Aggregator_Oracle_Reward_Min_Order_By>;
  stddev?: InputMaybe<Aggregator_Oracle_Reward_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Aggregator_Oracle_Reward_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Aggregator_Oracle_Reward_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Aggregator_Oracle_Reward_Sum_Order_By>;
  var_pop?: InputMaybe<Aggregator_Oracle_Reward_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Aggregator_Oracle_Reward_Var_Samp_Order_By>;
  variance?: InputMaybe<Aggregator_Oracle_Reward_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Aggregator_Oracle_Reward_Avg_Fields = {
  __typename?: 'aggregator_oracle_reward_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  reward?: Maybe<Scalars['Float']['output']>;
  /** MVRK: 0\nSMVN: 1 */
  type?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "aggregator_oracle_reward" */
export type Aggregator_Oracle_Reward_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  reward?: InputMaybe<Order_By>;
  /** MVRK: 0\nSMVN: 1 */
  type?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "aggregator_oracle_reward". All fields are combined with a logical 'AND'. */
export type Aggregator_Oracle_Reward_Bool_Exp = {
  _and?: InputMaybe<Array<Aggregator_Oracle_Reward_Bool_Exp>>;
  _not?: InputMaybe<Aggregator_Oracle_Reward_Bool_Exp>;
  _or?: InputMaybe<Array<Aggregator_Oracle_Reward_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  oracle?: InputMaybe<Aggregator_Oracle_Bool_Exp>;
  oracle_id?: InputMaybe<Bigint_Comparison_Exp>;
  reward?: InputMaybe<Float8_Comparison_Exp>;
  type?: InputMaybe<Smallint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Aggregator_Oracle_Reward_Max_Fields = {
  __typename?: 'aggregator_oracle_reward_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  oracle_id?: Maybe<Scalars['bigint']['output']>;
  reward?: Maybe<Scalars['float8']['output']>;
  /** MVRK: 0\nSMVN: 1 */
  type?: Maybe<Scalars['smallint']['output']>;
};

/** order by max() on columns of table "aggregator_oracle_reward" */
export type Aggregator_Oracle_Reward_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  reward?: InputMaybe<Order_By>;
  /** MVRK: 0\nSMVN: 1 */
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Aggregator_Oracle_Reward_Min_Fields = {
  __typename?: 'aggregator_oracle_reward_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  oracle_id?: Maybe<Scalars['bigint']['output']>;
  reward?: Maybe<Scalars['float8']['output']>;
  /** MVRK: 0\nSMVN: 1 */
  type?: Maybe<Scalars['smallint']['output']>;
};

/** order by min() on columns of table "aggregator_oracle_reward" */
export type Aggregator_Oracle_Reward_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  reward?: InputMaybe<Order_By>;
  /** MVRK: 0\nSMVN: 1 */
  type?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "aggregator_oracle_reward". */
export type Aggregator_Oracle_Reward_Order_By = {
  id?: InputMaybe<Order_By>;
  oracle?: InputMaybe<Aggregator_Oracle_Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  reward?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "aggregator_oracle_reward" */
export enum Aggregator_Oracle_Reward_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  OracleId = 'oracle_id',
  /** column name */
  Reward = 'reward',
  /** column name */
  Type = 'type'
}

/** select "aggregator_oracle_reward_aggregate_bool_exp_avg_arguments_columns" columns of table "aggregator_oracle_reward" */
export enum Aggregator_Oracle_Reward_Select_Column_Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Reward = 'reward'
}

/** select "aggregator_oracle_reward_aggregate_bool_exp_corr_arguments_columns" columns of table "aggregator_oracle_reward" */
export enum Aggregator_Oracle_Reward_Select_Column_Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Reward = 'reward'
}

/** select "aggregator_oracle_reward_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "aggregator_oracle_reward" */
export enum Aggregator_Oracle_Reward_Select_Column_Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Reward = 'reward'
}

/** select "aggregator_oracle_reward_aggregate_bool_exp_max_arguments_columns" columns of table "aggregator_oracle_reward" */
export enum Aggregator_Oracle_Reward_Select_Column_Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Reward = 'reward'
}

/** select "aggregator_oracle_reward_aggregate_bool_exp_min_arguments_columns" columns of table "aggregator_oracle_reward" */
export enum Aggregator_Oracle_Reward_Select_Column_Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Reward = 'reward'
}

/** select "aggregator_oracle_reward_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "aggregator_oracle_reward" */
export enum Aggregator_Oracle_Reward_Select_Column_Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Reward = 'reward'
}

/** select "aggregator_oracle_reward_aggregate_bool_exp_sum_arguments_columns" columns of table "aggregator_oracle_reward" */
export enum Aggregator_Oracle_Reward_Select_Column_Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Reward = 'reward'
}

/** select "aggregator_oracle_reward_aggregate_bool_exp_var_samp_arguments_columns" columns of table "aggregator_oracle_reward" */
export enum Aggregator_Oracle_Reward_Select_Column_Aggregator_Oracle_Reward_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Reward = 'reward'
}

/** aggregate stddev on columns */
export type Aggregator_Oracle_Reward_Stddev_Fields = {
  __typename?: 'aggregator_oracle_reward_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  reward?: Maybe<Scalars['Float']['output']>;
  /** MVRK: 0\nSMVN: 1 */
  type?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "aggregator_oracle_reward" */
export type Aggregator_Oracle_Reward_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  reward?: InputMaybe<Order_By>;
  /** MVRK: 0\nSMVN: 1 */
  type?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Aggregator_Oracle_Reward_Stddev_Pop_Fields = {
  __typename?: 'aggregator_oracle_reward_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  reward?: Maybe<Scalars['Float']['output']>;
  /** MVRK: 0\nSMVN: 1 */
  type?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "aggregator_oracle_reward" */
export type Aggregator_Oracle_Reward_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  reward?: InputMaybe<Order_By>;
  /** MVRK: 0\nSMVN: 1 */
  type?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Aggregator_Oracle_Reward_Stddev_Samp_Fields = {
  __typename?: 'aggregator_oracle_reward_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  reward?: Maybe<Scalars['Float']['output']>;
  /** MVRK: 0\nSMVN: 1 */
  type?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "aggregator_oracle_reward" */
export type Aggregator_Oracle_Reward_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  reward?: InputMaybe<Order_By>;
  /** MVRK: 0\nSMVN: 1 */
  type?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "aggregator_oracle_reward" */
export type Aggregator_Oracle_Reward_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Aggregator_Oracle_Reward_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Aggregator_Oracle_Reward_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  oracle_id?: InputMaybe<Scalars['bigint']['input']>;
  reward?: InputMaybe<Scalars['float8']['input']>;
  /** MVRK: 0\nSMVN: 1 */
  type?: InputMaybe<Scalars['smallint']['input']>;
};

/** aggregate sum on columns */
export type Aggregator_Oracle_Reward_Sum_Fields = {
  __typename?: 'aggregator_oracle_reward_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  oracle_id?: Maybe<Scalars['bigint']['output']>;
  reward?: Maybe<Scalars['float8']['output']>;
  /** MVRK: 0\nSMVN: 1 */
  type?: Maybe<Scalars['smallint']['output']>;
};

/** order by sum() on columns of table "aggregator_oracle_reward" */
export type Aggregator_Oracle_Reward_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  reward?: InputMaybe<Order_By>;
  /** MVRK: 0\nSMVN: 1 */
  type?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Aggregator_Oracle_Reward_Var_Pop_Fields = {
  __typename?: 'aggregator_oracle_reward_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  reward?: Maybe<Scalars['Float']['output']>;
  /** MVRK: 0\nSMVN: 1 */
  type?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "aggregator_oracle_reward" */
export type Aggregator_Oracle_Reward_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  reward?: InputMaybe<Order_By>;
  /** MVRK: 0\nSMVN: 1 */
  type?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Aggregator_Oracle_Reward_Var_Samp_Fields = {
  __typename?: 'aggregator_oracle_reward_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  reward?: Maybe<Scalars['Float']['output']>;
  /** MVRK: 0\nSMVN: 1 */
  type?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "aggregator_oracle_reward" */
export type Aggregator_Oracle_Reward_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  reward?: InputMaybe<Order_By>;
  /** MVRK: 0\nSMVN: 1 */
  type?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Aggregator_Oracle_Reward_Variance_Fields = {
  __typename?: 'aggregator_oracle_reward_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  reward?: Maybe<Scalars['Float']['output']>;
  /** MVRK: 0\nSMVN: 1 */
  type?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "aggregator_oracle_reward" */
export type Aggregator_Oracle_Reward_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  reward?: InputMaybe<Order_By>;
  /** MVRK: 0\nSMVN: 1 */
  type?: InputMaybe<Order_By>;
};

/** select columns of table "aggregator_oracle" */
export enum Aggregator_Oracle_Select_Column {
  /** column name */
  AggregatorId = 'aggregator_id',
  /** column name */
  Id = 'id',
  /** column name */
  InitEpoch = 'init_epoch',
  /** column name */
  InitRound = 'init_round',
  /** column name */
  PeerId = 'peer_id',
  /** column name */
  PublicKey = 'public_key',
  /** column name */
  UserId = 'user_id'
}

/** aggregate stddev on columns */
export type Aggregator_Oracle_Stddev_Fields = {
  __typename?: 'aggregator_oracle_stddev_fields';
  aggregator_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  init_epoch?: Maybe<Scalars['Float']['output']>;
  init_round?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "aggregator_oracle" */
export type Aggregator_Oracle_Stddev_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  init_epoch?: InputMaybe<Order_By>;
  init_round?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Aggregator_Oracle_Stddev_Pop_Fields = {
  __typename?: 'aggregator_oracle_stddev_pop_fields';
  aggregator_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  init_epoch?: Maybe<Scalars['Float']['output']>;
  init_round?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "aggregator_oracle" */
export type Aggregator_Oracle_Stddev_Pop_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  init_epoch?: InputMaybe<Order_By>;
  init_round?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Aggregator_Oracle_Stddev_Samp_Fields = {
  __typename?: 'aggregator_oracle_stddev_samp_fields';
  aggregator_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  init_epoch?: Maybe<Scalars['Float']['output']>;
  init_round?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "aggregator_oracle" */
export type Aggregator_Oracle_Stddev_Samp_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  init_epoch?: InputMaybe<Order_By>;
  init_round?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "aggregator_oracle" */
export type Aggregator_Oracle_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Aggregator_Oracle_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Aggregator_Oracle_Stream_Cursor_Value_Input = {
  aggregator_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  init_epoch?: InputMaybe<Scalars['bigint']['input']>;
  init_round?: InputMaybe<Scalars['bigint']['input']>;
  peer_id?: InputMaybe<Scalars['String']['input']>;
  public_key?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Aggregator_Oracle_Sum_Fields = {
  __typename?: 'aggregator_oracle_sum_fields';
  aggregator_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  init_epoch?: Maybe<Scalars['bigint']['output']>;
  init_round?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "aggregator_oracle" */
export type Aggregator_Oracle_Sum_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  init_epoch?: InputMaybe<Order_By>;
  init_round?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Aggregator_Oracle_Var_Pop_Fields = {
  __typename?: 'aggregator_oracle_var_pop_fields';
  aggregator_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  init_epoch?: Maybe<Scalars['Float']['output']>;
  init_round?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "aggregator_oracle" */
export type Aggregator_Oracle_Var_Pop_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  init_epoch?: InputMaybe<Order_By>;
  init_round?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Aggregator_Oracle_Var_Samp_Fields = {
  __typename?: 'aggregator_oracle_var_samp_fields';
  aggregator_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  init_epoch?: Maybe<Scalars['Float']['output']>;
  init_round?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "aggregator_oracle" */
export type Aggregator_Oracle_Var_Samp_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  init_epoch?: InputMaybe<Order_By>;
  init_round?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Aggregator_Oracle_Variance_Fields = {
  __typename?: 'aggregator_oracle_variance_fields';
  aggregator_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  init_epoch?: Maybe<Scalars['Float']['output']>;
  init_round?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "aggregator_oracle" */
export type Aggregator_Oracle_Variance_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  init_epoch?: InputMaybe<Order_By>;
  init_round?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "aggregator". */
export type Aggregator_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  alpha_pct_per_thousand?: InputMaybe<Order_By>;
  creation_timestamp?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  factory?: InputMaybe<Aggregator_Factory_Order_By>;
  factory_id?: InputMaybe<Order_By>;
  general_contracts_aggregate?: InputMaybe<Aggregator_General_Contract_Aggregate_Order_By>;
  governance?: InputMaybe<Governance_Order_By>;
  governance_id?: InputMaybe<Order_By>;
  governance_satellite_oracle_aggregators_aggregate?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Aggregate_Order_By>;
  heart_beat_seconds?: InputMaybe<Order_By>;
  history_data_aggregate?: InputMaybe<Aggregator_History_Data_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  lambdas_aggregate?: InputMaybe<Aggregator_Lambda_Aggregate_Order_By>;
  last_completed_data?: InputMaybe<Order_By>;
  last_completed_data_epoch?: InputMaybe<Order_By>;
  last_completed_data_last_updated_at?: InputMaybe<Order_By>;
  last_completed_data_pct_oracle_resp?: InputMaybe<Order_By>;
  last_completed_data_round?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  oracles_aggregate?: InputMaybe<Aggregator_Oracle_Aggregate_Order_By>;
  pct_oracle_threshold?: InputMaybe<Order_By>;
  reward_amount_mvrk?: InputMaybe<Order_By>;
  reward_amount_smvn?: InputMaybe<Order_By>;
  update_data_paused?: InputMaybe<Order_By>;
  whitelist_contracts_aggregate?: InputMaybe<Aggregator_Whitelist_Contract_Aggregate_Order_By>;
  withdraw_reward_mvrk_paused?: InputMaybe<Order_By>;
  withdraw_reward_smvn_paused?: InputMaybe<Order_By>;
};

/** select columns of table "aggregator" */
export enum Aggregator_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Admin = 'admin',
  /** column name */
  AlphaPctPerThousand = 'alpha_pct_per_thousand',
  /** column name */
  CreationTimestamp = 'creation_timestamp',
  /** column name */
  Decimals = 'decimals',
  /** column name */
  FactoryId = 'factory_id',
  /** column name */
  GovernanceId = 'governance_id',
  /** column name */
  HeartBeatSeconds = 'heart_beat_seconds',
  /** column name */
  Id = 'id',
  /** column name */
  LastCompletedData = 'last_completed_data',
  /** column name */
  LastCompletedDataEpoch = 'last_completed_data_epoch',
  /** column name */
  LastCompletedDataLastUpdatedAt = 'last_completed_data_last_updated_at',
  /** column name */
  LastCompletedDataPctOracleResp = 'last_completed_data_pct_oracle_resp',
  /** column name */
  LastCompletedDataRound = 'last_completed_data_round',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Network = 'network',
  /** column name */
  PctOracleThreshold = 'pct_oracle_threshold',
  /** column name */
  RewardAmountMvrk = 'reward_amount_mvrk',
  /** column name */
  RewardAmountSmvn = 'reward_amount_smvn',
  /** column name */
  UpdateDataPaused = 'update_data_paused',
  /** column name */
  WithdrawRewardMvrkPaused = 'withdraw_reward_mvrk_paused',
  /** column name */
  WithdrawRewardSmvnPaused = 'withdraw_reward_smvn_paused'
}

/** select "aggregator_aggregate_bool_exp_avg_arguments_columns" columns of table "aggregator" */
export enum Aggregator_Select_Column_Aggregator_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  LastCompletedData = 'last_completed_data',
  /** column name */
  RewardAmountMvrk = 'reward_amount_mvrk',
  /** column name */
  RewardAmountSmvn = 'reward_amount_smvn'
}

/** select "aggregator_aggregate_bool_exp_bool_and_arguments_columns" columns of table "aggregator" */
export enum Aggregator_Select_Column_Aggregator_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  UpdateDataPaused = 'update_data_paused',
  /** column name */
  WithdrawRewardMvrkPaused = 'withdraw_reward_mvrk_paused',
  /** column name */
  WithdrawRewardSmvnPaused = 'withdraw_reward_smvn_paused'
}

/** select "aggregator_aggregate_bool_exp_bool_or_arguments_columns" columns of table "aggregator" */
export enum Aggregator_Select_Column_Aggregator_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  UpdateDataPaused = 'update_data_paused',
  /** column name */
  WithdrawRewardMvrkPaused = 'withdraw_reward_mvrk_paused',
  /** column name */
  WithdrawRewardSmvnPaused = 'withdraw_reward_smvn_paused'
}

/** select "aggregator_aggregate_bool_exp_corr_arguments_columns" columns of table "aggregator" */
export enum Aggregator_Select_Column_Aggregator_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  LastCompletedData = 'last_completed_data',
  /** column name */
  RewardAmountMvrk = 'reward_amount_mvrk',
  /** column name */
  RewardAmountSmvn = 'reward_amount_smvn'
}

/** select "aggregator_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "aggregator" */
export enum Aggregator_Select_Column_Aggregator_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  LastCompletedData = 'last_completed_data',
  /** column name */
  RewardAmountMvrk = 'reward_amount_mvrk',
  /** column name */
  RewardAmountSmvn = 'reward_amount_smvn'
}

/** select "aggregator_aggregate_bool_exp_max_arguments_columns" columns of table "aggregator" */
export enum Aggregator_Select_Column_Aggregator_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  LastCompletedData = 'last_completed_data',
  /** column name */
  RewardAmountMvrk = 'reward_amount_mvrk',
  /** column name */
  RewardAmountSmvn = 'reward_amount_smvn'
}

/** select "aggregator_aggregate_bool_exp_min_arguments_columns" columns of table "aggregator" */
export enum Aggregator_Select_Column_Aggregator_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  LastCompletedData = 'last_completed_data',
  /** column name */
  RewardAmountMvrk = 'reward_amount_mvrk',
  /** column name */
  RewardAmountSmvn = 'reward_amount_smvn'
}

/** select "aggregator_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "aggregator" */
export enum Aggregator_Select_Column_Aggregator_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  LastCompletedData = 'last_completed_data',
  /** column name */
  RewardAmountMvrk = 'reward_amount_mvrk',
  /** column name */
  RewardAmountSmvn = 'reward_amount_smvn'
}

/** select "aggregator_aggregate_bool_exp_sum_arguments_columns" columns of table "aggregator" */
export enum Aggregator_Select_Column_Aggregator_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  LastCompletedData = 'last_completed_data',
  /** column name */
  RewardAmountMvrk = 'reward_amount_mvrk',
  /** column name */
  RewardAmountSmvn = 'reward_amount_smvn'
}

/** select "aggregator_aggregate_bool_exp_var_samp_arguments_columns" columns of table "aggregator" */
export enum Aggregator_Select_Column_Aggregator_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  LastCompletedData = 'last_completed_data',
  /** column name */
  RewardAmountMvrk = 'reward_amount_mvrk',
  /** column name */
  RewardAmountSmvn = 'reward_amount_smvn'
}

/** aggregate stddev on columns */
export type Aggregator_Stddev_Fields = {
  __typename?: 'aggregator_stddev_fields';
  alpha_pct_per_thousand?: Maybe<Scalars['Float']['output']>;
  decimals?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  heart_beat_seconds?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_completed_data?: Maybe<Scalars['Float']['output']>;
  last_completed_data_epoch?: Maybe<Scalars['Float']['output']>;
  last_completed_data_pct_oracle_resp?: Maybe<Scalars['Float']['output']>;
  last_completed_data_round?: Maybe<Scalars['Float']['output']>;
  pct_oracle_threshold?: Maybe<Scalars['Float']['output']>;
  reward_amount_mvrk?: Maybe<Scalars['Float']['output']>;
  reward_amount_smvn?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "aggregator" */
export type Aggregator_Stddev_Order_By = {
  alpha_pct_per_thousand?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  heart_beat_seconds?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_completed_data?: InputMaybe<Order_By>;
  last_completed_data_epoch?: InputMaybe<Order_By>;
  last_completed_data_pct_oracle_resp?: InputMaybe<Order_By>;
  last_completed_data_round?: InputMaybe<Order_By>;
  pct_oracle_threshold?: InputMaybe<Order_By>;
  reward_amount_mvrk?: InputMaybe<Order_By>;
  reward_amount_smvn?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Aggregator_Stddev_Pop_Fields = {
  __typename?: 'aggregator_stddev_pop_fields';
  alpha_pct_per_thousand?: Maybe<Scalars['Float']['output']>;
  decimals?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  heart_beat_seconds?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_completed_data?: Maybe<Scalars['Float']['output']>;
  last_completed_data_epoch?: Maybe<Scalars['Float']['output']>;
  last_completed_data_pct_oracle_resp?: Maybe<Scalars['Float']['output']>;
  last_completed_data_round?: Maybe<Scalars['Float']['output']>;
  pct_oracle_threshold?: Maybe<Scalars['Float']['output']>;
  reward_amount_mvrk?: Maybe<Scalars['Float']['output']>;
  reward_amount_smvn?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "aggregator" */
export type Aggregator_Stddev_Pop_Order_By = {
  alpha_pct_per_thousand?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  heart_beat_seconds?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_completed_data?: InputMaybe<Order_By>;
  last_completed_data_epoch?: InputMaybe<Order_By>;
  last_completed_data_pct_oracle_resp?: InputMaybe<Order_By>;
  last_completed_data_round?: InputMaybe<Order_By>;
  pct_oracle_threshold?: InputMaybe<Order_By>;
  reward_amount_mvrk?: InputMaybe<Order_By>;
  reward_amount_smvn?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Aggregator_Stddev_Samp_Fields = {
  __typename?: 'aggregator_stddev_samp_fields';
  alpha_pct_per_thousand?: Maybe<Scalars['Float']['output']>;
  decimals?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  heart_beat_seconds?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_completed_data?: Maybe<Scalars['Float']['output']>;
  last_completed_data_epoch?: Maybe<Scalars['Float']['output']>;
  last_completed_data_pct_oracle_resp?: Maybe<Scalars['Float']['output']>;
  last_completed_data_round?: Maybe<Scalars['Float']['output']>;
  pct_oracle_threshold?: Maybe<Scalars['Float']['output']>;
  reward_amount_mvrk?: Maybe<Scalars['Float']['output']>;
  reward_amount_smvn?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "aggregator" */
export type Aggregator_Stddev_Samp_Order_By = {
  alpha_pct_per_thousand?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  heart_beat_seconds?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_completed_data?: InputMaybe<Order_By>;
  last_completed_data_epoch?: InputMaybe<Order_By>;
  last_completed_data_pct_oracle_resp?: InputMaybe<Order_By>;
  last_completed_data_round?: InputMaybe<Order_By>;
  pct_oracle_threshold?: InputMaybe<Order_By>;
  reward_amount_mvrk?: InputMaybe<Order_By>;
  reward_amount_smvn?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "aggregator" */
export type Aggregator_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Aggregator_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Aggregator_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['String']['input']>;
  alpha_pct_per_thousand?: InputMaybe<Scalars['smallint']['input']>;
  creation_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  decimals?: InputMaybe<Scalars['smallint']['input']>;
  factory_id?: InputMaybe<Scalars['bigint']['input']>;
  governance_id?: InputMaybe<Scalars['bigint']['input']>;
  heart_beat_seconds?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_completed_data?: InputMaybe<Scalars['float8']['input']>;
  last_completed_data_epoch?: InputMaybe<Scalars['bigint']['input']>;
  last_completed_data_last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_completed_data_pct_oracle_resp?: InputMaybe<Scalars['smallint']['input']>;
  last_completed_data_round?: InputMaybe<Scalars['bigint']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  pct_oracle_threshold?: InputMaybe<Scalars['smallint']['input']>;
  reward_amount_mvrk?: InputMaybe<Scalars['float8']['input']>;
  reward_amount_smvn?: InputMaybe<Scalars['float8']['input']>;
  update_data_paused?: InputMaybe<Scalars['Boolean']['input']>;
  withdraw_reward_mvrk_paused?: InputMaybe<Scalars['Boolean']['input']>;
  withdraw_reward_smvn_paused?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Aggregator_Sum_Fields = {
  __typename?: 'aggregator_sum_fields';
  alpha_pct_per_thousand?: Maybe<Scalars['smallint']['output']>;
  decimals?: Maybe<Scalars['smallint']['output']>;
  factory_id?: Maybe<Scalars['bigint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  heart_beat_seconds?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_completed_data?: Maybe<Scalars['float8']['output']>;
  last_completed_data_epoch?: Maybe<Scalars['bigint']['output']>;
  last_completed_data_pct_oracle_resp?: Maybe<Scalars['smallint']['output']>;
  last_completed_data_round?: Maybe<Scalars['bigint']['output']>;
  pct_oracle_threshold?: Maybe<Scalars['smallint']['output']>;
  reward_amount_mvrk?: Maybe<Scalars['float8']['output']>;
  reward_amount_smvn?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "aggregator" */
export type Aggregator_Sum_Order_By = {
  alpha_pct_per_thousand?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  heart_beat_seconds?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_completed_data?: InputMaybe<Order_By>;
  last_completed_data_epoch?: InputMaybe<Order_By>;
  last_completed_data_pct_oracle_resp?: InputMaybe<Order_By>;
  last_completed_data_round?: InputMaybe<Order_By>;
  pct_oracle_threshold?: InputMaybe<Order_By>;
  reward_amount_mvrk?: InputMaybe<Order_By>;
  reward_amount_smvn?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Aggregator_Var_Pop_Fields = {
  __typename?: 'aggregator_var_pop_fields';
  alpha_pct_per_thousand?: Maybe<Scalars['Float']['output']>;
  decimals?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  heart_beat_seconds?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_completed_data?: Maybe<Scalars['Float']['output']>;
  last_completed_data_epoch?: Maybe<Scalars['Float']['output']>;
  last_completed_data_pct_oracle_resp?: Maybe<Scalars['Float']['output']>;
  last_completed_data_round?: Maybe<Scalars['Float']['output']>;
  pct_oracle_threshold?: Maybe<Scalars['Float']['output']>;
  reward_amount_mvrk?: Maybe<Scalars['Float']['output']>;
  reward_amount_smvn?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "aggregator" */
export type Aggregator_Var_Pop_Order_By = {
  alpha_pct_per_thousand?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  heart_beat_seconds?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_completed_data?: InputMaybe<Order_By>;
  last_completed_data_epoch?: InputMaybe<Order_By>;
  last_completed_data_pct_oracle_resp?: InputMaybe<Order_By>;
  last_completed_data_round?: InputMaybe<Order_By>;
  pct_oracle_threshold?: InputMaybe<Order_By>;
  reward_amount_mvrk?: InputMaybe<Order_By>;
  reward_amount_smvn?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Aggregator_Var_Samp_Fields = {
  __typename?: 'aggregator_var_samp_fields';
  alpha_pct_per_thousand?: Maybe<Scalars['Float']['output']>;
  decimals?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  heart_beat_seconds?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_completed_data?: Maybe<Scalars['Float']['output']>;
  last_completed_data_epoch?: Maybe<Scalars['Float']['output']>;
  last_completed_data_pct_oracle_resp?: Maybe<Scalars['Float']['output']>;
  last_completed_data_round?: Maybe<Scalars['Float']['output']>;
  pct_oracle_threshold?: Maybe<Scalars['Float']['output']>;
  reward_amount_mvrk?: Maybe<Scalars['Float']['output']>;
  reward_amount_smvn?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "aggregator" */
export type Aggregator_Var_Samp_Order_By = {
  alpha_pct_per_thousand?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  heart_beat_seconds?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_completed_data?: InputMaybe<Order_By>;
  last_completed_data_epoch?: InputMaybe<Order_By>;
  last_completed_data_pct_oracle_resp?: InputMaybe<Order_By>;
  last_completed_data_round?: InputMaybe<Order_By>;
  pct_oracle_threshold?: InputMaybe<Order_By>;
  reward_amount_mvrk?: InputMaybe<Order_By>;
  reward_amount_smvn?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Aggregator_Variance_Fields = {
  __typename?: 'aggregator_variance_fields';
  alpha_pct_per_thousand?: Maybe<Scalars['Float']['output']>;
  decimals?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  heart_beat_seconds?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_completed_data?: Maybe<Scalars['Float']['output']>;
  last_completed_data_epoch?: Maybe<Scalars['Float']['output']>;
  last_completed_data_pct_oracle_resp?: Maybe<Scalars['Float']['output']>;
  last_completed_data_round?: Maybe<Scalars['Float']['output']>;
  pct_oracle_threshold?: Maybe<Scalars['Float']['output']>;
  reward_amount_mvrk?: Maybe<Scalars['Float']['output']>;
  reward_amount_smvn?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "aggregator" */
export type Aggregator_Variance_Order_By = {
  alpha_pct_per_thousand?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  heart_beat_seconds?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_completed_data?: InputMaybe<Order_By>;
  last_completed_data_epoch?: InputMaybe<Order_By>;
  last_completed_data_pct_oracle_resp?: InputMaybe<Order_By>;
  last_completed_data_round?: InputMaybe<Order_By>;
  pct_oracle_threshold?: InputMaybe<Order_By>;
  reward_amount_mvrk?: InputMaybe<Order_By>;
  reward_amount_smvn?: InputMaybe<Order_By>;
};

/** columns and relationships of "aggregator_whitelist_contract" */
export type Aggregator_Whitelist_Contract = {
  __typename?: 'aggregator_whitelist_contract';
  /** An object relationship */
  contract: Aggregator;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "aggregator_whitelist_contract" */
export type Aggregator_Whitelist_Contract_Aggregate = {
  __typename?: 'aggregator_whitelist_contract_aggregate';
  aggregate?: Maybe<Aggregator_Whitelist_Contract_Aggregate_Fields>;
  nodes: Array<Aggregator_Whitelist_Contract>;
};

export type Aggregator_Whitelist_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Aggregator_Whitelist_Contract_Aggregate_Bool_Exp_Count>;
};

export type Aggregator_Whitelist_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Aggregator_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Aggregator_Whitelist_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "aggregator_whitelist_contract" */
export type Aggregator_Whitelist_Contract_Aggregate_Fields = {
  __typename?: 'aggregator_whitelist_contract_aggregate_fields';
  avg?: Maybe<Aggregator_Whitelist_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Aggregator_Whitelist_Contract_Max_Fields>;
  min?: Maybe<Aggregator_Whitelist_Contract_Min_Fields>;
  stddev?: Maybe<Aggregator_Whitelist_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Aggregator_Whitelist_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Aggregator_Whitelist_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Aggregator_Whitelist_Contract_Sum_Fields>;
  var_pop?: Maybe<Aggregator_Whitelist_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Aggregator_Whitelist_Contract_Var_Samp_Fields>;
  variance?: Maybe<Aggregator_Whitelist_Contract_Variance_Fields>;
};


/** aggregate fields of "aggregator_whitelist_contract" */
export type Aggregator_Whitelist_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Aggregator_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "aggregator_whitelist_contract" */
export type Aggregator_Whitelist_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Aggregator_Whitelist_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Aggregator_Whitelist_Contract_Max_Order_By>;
  min?: InputMaybe<Aggregator_Whitelist_Contract_Min_Order_By>;
  stddev?: InputMaybe<Aggregator_Whitelist_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Aggregator_Whitelist_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Aggregator_Whitelist_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Aggregator_Whitelist_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Aggregator_Whitelist_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Aggregator_Whitelist_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Aggregator_Whitelist_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Aggregator_Whitelist_Contract_Avg_Fields = {
  __typename?: 'aggregator_whitelist_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "aggregator_whitelist_contract" */
export type Aggregator_Whitelist_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "aggregator_whitelist_contract". All fields are combined with a logical 'AND'. */
export type Aggregator_Whitelist_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Aggregator_Whitelist_Contract_Bool_Exp>>;
  _not?: InputMaybe<Aggregator_Whitelist_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Aggregator_Whitelist_Contract_Bool_Exp>>;
  contract?: InputMaybe<Aggregator_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Aggregator_Whitelist_Contract_Max_Fields = {
  __typename?: 'aggregator_whitelist_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "aggregator_whitelist_contract" */
export type Aggregator_Whitelist_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Aggregator_Whitelist_Contract_Min_Fields = {
  __typename?: 'aggregator_whitelist_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "aggregator_whitelist_contract" */
export type Aggregator_Whitelist_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "aggregator_whitelist_contract". */
export type Aggregator_Whitelist_Contract_Order_By = {
  contract?: InputMaybe<Aggregator_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "aggregator_whitelist_contract" */
export enum Aggregator_Whitelist_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Aggregator_Whitelist_Contract_Stddev_Fields = {
  __typename?: 'aggregator_whitelist_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "aggregator_whitelist_contract" */
export type Aggregator_Whitelist_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Aggregator_Whitelist_Contract_Stddev_Pop_Fields = {
  __typename?: 'aggregator_whitelist_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "aggregator_whitelist_contract" */
export type Aggregator_Whitelist_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Aggregator_Whitelist_Contract_Stddev_Samp_Fields = {
  __typename?: 'aggregator_whitelist_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "aggregator_whitelist_contract" */
export type Aggregator_Whitelist_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "aggregator_whitelist_contract" */
export type Aggregator_Whitelist_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Aggregator_Whitelist_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Aggregator_Whitelist_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Aggregator_Whitelist_Contract_Sum_Fields = {
  __typename?: 'aggregator_whitelist_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "aggregator_whitelist_contract" */
export type Aggregator_Whitelist_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Aggregator_Whitelist_Contract_Var_Pop_Fields = {
  __typename?: 'aggregator_whitelist_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "aggregator_whitelist_contract" */
export type Aggregator_Whitelist_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Aggregator_Whitelist_Contract_Var_Samp_Fields = {
  __typename?: 'aggregator_whitelist_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "aggregator_whitelist_contract" */
export type Aggregator_Whitelist_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Aggregator_Whitelist_Contract_Variance_Fields = {
  __typename?: 'aggregator_whitelist_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "aggregator_whitelist_contract" */
export type Aggregator_Whitelist_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** columns and relationships of "break_glass" */
export type Break_Glass = {
  __typename?: 'break_glass';
  action_counter: Scalars['bigint']['output'];
  action_expiry_days: Scalars['smallint']['output'];
  /** An array relationship */
  actions: Array<Break_Glass_Action>;
  /** An aggregate relationship */
  actions_aggregate: Break_Glass_Action_Aggregate;
  address: Scalars['String']['output'];
  admin: Scalars['String']['output'];
  council_member_image_max_length: Scalars['smallint']['output'];
  council_member_name_max_length: Scalars['smallint']['output'];
  council_member_website_max_length: Scalars['smallint']['output'];
  /** An array relationship */
  council_members: Array<Break_Glass_Council_Member>;
  /** An aggregate relationship */
  council_members_aggregate: Break_Glass_Council_Member_Aggregate;
  council_size: Scalars['smallint']['output'];
  /** An array relationship */
  general_contracts: Array<Break_Glass_General_Contract>;
  /** An aggregate relationship */
  general_contracts_aggregate: Break_Glass_General_Contract_Aggregate;
  glass_broken: Scalars['Boolean']['output'];
  /** An object relationship */
  governance: Governance;
  governance_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An array relationship */
  lambdas: Array<Break_Glass_Lambda>;
  /** An aggregate relationship */
  lambdas_aggregate: Break_Glass_Lambda_Aggregate;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  network: Scalars['String']['output'];
  threshold: Scalars['smallint']['output'];
  /** An array relationship */
  whitelist_contracts: Array<Break_Glass_Whitelist_Contract>;
  /** An aggregate relationship */
  whitelist_contracts_aggregate: Break_Glass_Whitelist_Contract_Aggregate;
};


/** columns and relationships of "break_glass" */
export type Break_GlassActionsArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Bool_Exp>;
};


/** columns and relationships of "break_glass" */
export type Break_GlassActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Bool_Exp>;
};


/** columns and relationships of "break_glass" */
export type Break_GlassCouncil_MembersArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Council_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Council_Member_Order_By>>;
  where?: InputMaybe<Break_Glass_Council_Member_Bool_Exp>;
};


/** columns and relationships of "break_glass" */
export type Break_GlassCouncil_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Council_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Council_Member_Order_By>>;
  where?: InputMaybe<Break_Glass_Council_Member_Bool_Exp>;
};


/** columns and relationships of "break_glass" */
export type Break_GlassGeneral_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_General_Contract_Order_By>>;
  where?: InputMaybe<Break_Glass_General_Contract_Bool_Exp>;
};


/** columns and relationships of "break_glass" */
export type Break_GlassGeneral_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_General_Contract_Order_By>>;
  where?: InputMaybe<Break_Glass_General_Contract_Bool_Exp>;
};


/** columns and relationships of "break_glass" */
export type Break_GlassLambdasArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Lambda_Order_By>>;
  where?: InputMaybe<Break_Glass_Lambda_Bool_Exp>;
};


/** columns and relationships of "break_glass" */
export type Break_GlassLambdas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Lambda_Order_By>>;
  where?: InputMaybe<Break_Glass_Lambda_Bool_Exp>;
};


/** columns and relationships of "break_glass" */
export type Break_GlassMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "break_glass" */
export type Break_GlassWhitelist_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Break_Glass_Whitelist_Contract_Bool_Exp>;
};


/** columns and relationships of "break_glass" */
export type Break_GlassWhitelist_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Break_Glass_Whitelist_Contract_Bool_Exp>;
};

/** columns and relationships of "break_glass_action" */
export type Break_Glass_Action = {
  __typename?: 'break_glass_action';
  action_type: Scalars['String']['output'];
  /** An object relationship */
  break_glass: Break_Glass;
  break_glass_id: Scalars['bigint']['output'];
  council_size_snapshot: Scalars['smallint']['output'];
  executed: Scalars['Boolean']['output'];
  execution_datetime?: Maybe<Scalars['timestamptz']['output']>;
  execution_level?: Maybe<Scalars['bigint']['output']>;
  expiration_datetime: Scalars['timestamptz']['output'];
  flushed_datetime?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bigint']['output'];
  /** An object relationship */
  initiator: Maven_User;
  initiator_id: Scalars['bigint']['output'];
  internal_id: Scalars['bigint']['output'];
  /** An array relationship */
  parameters: Array<Break_Glass_Action_Parameter>;
  /** An aggregate relationship */
  parameters_aggregate: Break_Glass_Action_Parameter_Aggregate;
  registered_threshold: Scalars['smallint']['output'];
  /** An array relationship */
  signers: Array<Break_Glass_Action_Signer>;
  /** An aggregate relationship */
  signers_aggregate: Break_Glass_Action_Signer_Aggregate;
  signers_count: Scalars['smallint']['output'];
  start_datetime: Scalars['timestamptz']['output'];
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status: Scalars['smallint']['output'];
  /** An array relationship */
  temp_member_parameters: Array<Break_Glass_Action_Temp_Parameter>;
  /** An aggregate relationship */
  temp_member_parameters_aggregate: Break_Glass_Action_Temp_Parameter_Aggregate;
};


/** columns and relationships of "break_glass_action" */
export type Break_Glass_ActionParametersArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Parameter_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Parameter_Bool_Exp>;
};


/** columns and relationships of "break_glass_action" */
export type Break_Glass_ActionParameters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Parameter_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Parameter_Bool_Exp>;
};


/** columns and relationships of "break_glass_action" */
export type Break_Glass_ActionSignersArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Signer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Signer_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Signer_Bool_Exp>;
};


/** columns and relationships of "break_glass_action" */
export type Break_Glass_ActionSigners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Signer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Signer_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Signer_Bool_Exp>;
};


/** columns and relationships of "break_glass_action" */
export type Break_Glass_ActionTemp_Member_ParametersArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Temp_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Temp_Parameter_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Temp_Parameter_Bool_Exp>;
};


/** columns and relationships of "break_glass_action" */
export type Break_Glass_ActionTemp_Member_Parameters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Temp_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Temp_Parameter_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Temp_Parameter_Bool_Exp>;
};

/** aggregated selection of "break_glass_action" */
export type Break_Glass_Action_Aggregate = {
  __typename?: 'break_glass_action_aggregate';
  aggregate?: Maybe<Break_Glass_Action_Aggregate_Fields>;
  nodes: Array<Break_Glass_Action>;
};

export type Break_Glass_Action_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Break_Glass_Action_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Break_Glass_Action_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Break_Glass_Action_Aggregate_Bool_Exp_Count>;
};

export type Break_Glass_Action_Aggregate_Bool_Exp_Bool_And = {
  arguments: Break_Glass_Action_Select_Column_Break_Glass_Action_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Break_Glass_Action_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Break_Glass_Action_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Break_Glass_Action_Select_Column_Break_Glass_Action_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Break_Glass_Action_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Break_Glass_Action_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Break_Glass_Action_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Break_Glass_Action_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "break_glass_action" */
export type Break_Glass_Action_Aggregate_Fields = {
  __typename?: 'break_glass_action_aggregate_fields';
  avg?: Maybe<Break_Glass_Action_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Break_Glass_Action_Max_Fields>;
  min?: Maybe<Break_Glass_Action_Min_Fields>;
  stddev?: Maybe<Break_Glass_Action_Stddev_Fields>;
  stddev_pop?: Maybe<Break_Glass_Action_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Break_Glass_Action_Stddev_Samp_Fields>;
  sum?: Maybe<Break_Glass_Action_Sum_Fields>;
  var_pop?: Maybe<Break_Glass_Action_Var_Pop_Fields>;
  var_samp?: Maybe<Break_Glass_Action_Var_Samp_Fields>;
  variance?: Maybe<Break_Glass_Action_Variance_Fields>;
};


/** aggregate fields of "break_glass_action" */
export type Break_Glass_Action_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Break_Glass_Action_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "break_glass_action" */
export type Break_Glass_Action_Aggregate_Order_By = {
  avg?: InputMaybe<Break_Glass_Action_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Break_Glass_Action_Max_Order_By>;
  min?: InputMaybe<Break_Glass_Action_Min_Order_By>;
  stddev?: InputMaybe<Break_Glass_Action_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Break_Glass_Action_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Break_Glass_Action_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Break_Glass_Action_Sum_Order_By>;
  var_pop?: InputMaybe<Break_Glass_Action_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Break_Glass_Action_Var_Samp_Order_By>;
  variance?: InputMaybe<Break_Glass_Action_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Break_Glass_Action_Avg_Fields = {
  __typename?: 'break_glass_action_avg_fields';
  break_glass_id?: Maybe<Scalars['Float']['output']>;
  council_size_snapshot?: Maybe<Scalars['Float']['output']>;
  execution_level?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initiator_id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  registered_threshold?: Maybe<Scalars['Float']['output']>;
  signers_count?: Maybe<Scalars['Float']['output']>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "break_glass_action" */
export type Break_Glass_Action_Avg_Order_By = {
  break_glass_id?: InputMaybe<Order_By>;
  council_size_snapshot?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  registered_threshold?: InputMaybe<Order_By>;
  signers_count?: InputMaybe<Order_By>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "break_glass_action". All fields are combined with a logical 'AND'. */
export type Break_Glass_Action_Bool_Exp = {
  _and?: InputMaybe<Array<Break_Glass_Action_Bool_Exp>>;
  _not?: InputMaybe<Break_Glass_Action_Bool_Exp>;
  _or?: InputMaybe<Array<Break_Glass_Action_Bool_Exp>>;
  action_type?: InputMaybe<String_Comparison_Exp>;
  break_glass?: InputMaybe<Break_Glass_Bool_Exp>;
  break_glass_id?: InputMaybe<Bigint_Comparison_Exp>;
  council_size_snapshot?: InputMaybe<Smallint_Comparison_Exp>;
  executed?: InputMaybe<Boolean_Comparison_Exp>;
  execution_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  execution_level?: InputMaybe<Bigint_Comparison_Exp>;
  expiration_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  flushed_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  initiator?: InputMaybe<Maven_User_Bool_Exp>;
  initiator_id?: InputMaybe<Bigint_Comparison_Exp>;
  internal_id?: InputMaybe<Bigint_Comparison_Exp>;
  parameters?: InputMaybe<Break_Glass_Action_Parameter_Bool_Exp>;
  parameters_aggregate?: InputMaybe<Break_Glass_Action_Parameter_Aggregate_Bool_Exp>;
  registered_threshold?: InputMaybe<Smallint_Comparison_Exp>;
  signers?: InputMaybe<Break_Glass_Action_Signer_Bool_Exp>;
  signers_aggregate?: InputMaybe<Break_Glass_Action_Signer_Aggregate_Bool_Exp>;
  signers_count?: InputMaybe<Smallint_Comparison_Exp>;
  start_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<Smallint_Comparison_Exp>;
  temp_member_parameters?: InputMaybe<Break_Glass_Action_Temp_Parameter_Bool_Exp>;
  temp_member_parameters_aggregate?: InputMaybe<Break_Glass_Action_Temp_Parameter_Aggregate_Bool_Exp>;
};

/** aggregate max on columns */
export type Break_Glass_Action_Max_Fields = {
  __typename?: 'break_glass_action_max_fields';
  action_type?: Maybe<Scalars['String']['output']>;
  break_glass_id?: Maybe<Scalars['bigint']['output']>;
  council_size_snapshot?: Maybe<Scalars['smallint']['output']>;
  execution_datetime?: Maybe<Scalars['timestamptz']['output']>;
  execution_level?: Maybe<Scalars['bigint']['output']>;
  expiration_datetime?: Maybe<Scalars['timestamptz']['output']>;
  flushed_datetime?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  initiator_id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['bigint']['output']>;
  registered_threshold?: Maybe<Scalars['smallint']['output']>;
  signers_count?: Maybe<Scalars['smallint']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: Maybe<Scalars['smallint']['output']>;
};

/** order by max() on columns of table "break_glass_action" */
export type Break_Glass_Action_Max_Order_By = {
  action_type?: InputMaybe<Order_By>;
  break_glass_id?: InputMaybe<Order_By>;
  council_size_snapshot?: InputMaybe<Order_By>;
  execution_datetime?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  expiration_datetime?: InputMaybe<Order_By>;
  flushed_datetime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  registered_threshold?: InputMaybe<Order_By>;
  signers_count?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Break_Glass_Action_Min_Fields = {
  __typename?: 'break_glass_action_min_fields';
  action_type?: Maybe<Scalars['String']['output']>;
  break_glass_id?: Maybe<Scalars['bigint']['output']>;
  council_size_snapshot?: Maybe<Scalars['smallint']['output']>;
  execution_datetime?: Maybe<Scalars['timestamptz']['output']>;
  execution_level?: Maybe<Scalars['bigint']['output']>;
  expiration_datetime?: Maybe<Scalars['timestamptz']['output']>;
  flushed_datetime?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  initiator_id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['bigint']['output']>;
  registered_threshold?: Maybe<Scalars['smallint']['output']>;
  signers_count?: Maybe<Scalars['smallint']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: Maybe<Scalars['smallint']['output']>;
};

/** order by min() on columns of table "break_glass_action" */
export type Break_Glass_Action_Min_Order_By = {
  action_type?: InputMaybe<Order_By>;
  break_glass_id?: InputMaybe<Order_By>;
  council_size_snapshot?: InputMaybe<Order_By>;
  execution_datetime?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  expiration_datetime?: InputMaybe<Order_By>;
  flushed_datetime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  registered_threshold?: InputMaybe<Order_By>;
  signers_count?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "break_glass_action". */
export type Break_Glass_Action_Order_By = {
  action_type?: InputMaybe<Order_By>;
  break_glass?: InputMaybe<Break_Glass_Order_By>;
  break_glass_id?: InputMaybe<Order_By>;
  council_size_snapshot?: InputMaybe<Order_By>;
  executed?: InputMaybe<Order_By>;
  execution_datetime?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  expiration_datetime?: InputMaybe<Order_By>;
  flushed_datetime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator?: InputMaybe<Maven_User_Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  parameters_aggregate?: InputMaybe<Break_Glass_Action_Parameter_Aggregate_Order_By>;
  registered_threshold?: InputMaybe<Order_By>;
  signers_aggregate?: InputMaybe<Break_Glass_Action_Signer_Aggregate_Order_By>;
  signers_count?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  temp_member_parameters_aggregate?: InputMaybe<Break_Glass_Action_Temp_Parameter_Aggregate_Order_By>;
};

/** columns and relationships of "break_glass_action_parameter" */
export type Break_Glass_Action_Parameter = {
  __typename?: 'break_glass_action_parameter';
  /** An object relationship */
  break_glass_action: Break_Glass_Action;
  break_glass_action_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "break_glass_action_parameter" */
export type Break_Glass_Action_Parameter_Aggregate = {
  __typename?: 'break_glass_action_parameter_aggregate';
  aggregate?: Maybe<Break_Glass_Action_Parameter_Aggregate_Fields>;
  nodes: Array<Break_Glass_Action_Parameter>;
};

export type Break_Glass_Action_Parameter_Aggregate_Bool_Exp = {
  count?: InputMaybe<Break_Glass_Action_Parameter_Aggregate_Bool_Exp_Count>;
};

export type Break_Glass_Action_Parameter_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Break_Glass_Action_Parameter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Break_Glass_Action_Parameter_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "break_glass_action_parameter" */
export type Break_Glass_Action_Parameter_Aggregate_Fields = {
  __typename?: 'break_glass_action_parameter_aggregate_fields';
  avg?: Maybe<Break_Glass_Action_Parameter_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Break_Glass_Action_Parameter_Max_Fields>;
  min?: Maybe<Break_Glass_Action_Parameter_Min_Fields>;
  stddev?: Maybe<Break_Glass_Action_Parameter_Stddev_Fields>;
  stddev_pop?: Maybe<Break_Glass_Action_Parameter_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Break_Glass_Action_Parameter_Stddev_Samp_Fields>;
  sum?: Maybe<Break_Glass_Action_Parameter_Sum_Fields>;
  var_pop?: Maybe<Break_Glass_Action_Parameter_Var_Pop_Fields>;
  var_samp?: Maybe<Break_Glass_Action_Parameter_Var_Samp_Fields>;
  variance?: Maybe<Break_Glass_Action_Parameter_Variance_Fields>;
};


/** aggregate fields of "break_glass_action_parameter" */
export type Break_Glass_Action_Parameter_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Break_Glass_Action_Parameter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "break_glass_action_parameter" */
export type Break_Glass_Action_Parameter_Aggregate_Order_By = {
  avg?: InputMaybe<Break_Glass_Action_Parameter_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Break_Glass_Action_Parameter_Max_Order_By>;
  min?: InputMaybe<Break_Glass_Action_Parameter_Min_Order_By>;
  stddev?: InputMaybe<Break_Glass_Action_Parameter_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Break_Glass_Action_Parameter_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Break_Glass_Action_Parameter_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Break_Glass_Action_Parameter_Sum_Order_By>;
  var_pop?: InputMaybe<Break_Glass_Action_Parameter_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Break_Glass_Action_Parameter_Var_Samp_Order_By>;
  variance?: InputMaybe<Break_Glass_Action_Parameter_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Break_Glass_Action_Parameter_Avg_Fields = {
  __typename?: 'break_glass_action_parameter_avg_fields';
  break_glass_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "break_glass_action_parameter" */
export type Break_Glass_Action_Parameter_Avg_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "break_glass_action_parameter". All fields are combined with a logical 'AND'. */
export type Break_Glass_Action_Parameter_Bool_Exp = {
  _and?: InputMaybe<Array<Break_Glass_Action_Parameter_Bool_Exp>>;
  _not?: InputMaybe<Break_Glass_Action_Parameter_Bool_Exp>;
  _or?: InputMaybe<Array<Break_Glass_Action_Parameter_Bool_Exp>>;
  break_glass_action?: InputMaybe<Break_Glass_Action_Bool_Exp>;
  break_glass_action_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Break_Glass_Action_Parameter_Max_Fields = {
  __typename?: 'break_glass_action_parameter_max_fields';
  break_glass_action_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "break_glass_action_parameter" */
export type Break_Glass_Action_Parameter_Max_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Break_Glass_Action_Parameter_Min_Fields = {
  __typename?: 'break_glass_action_parameter_min_fields';
  break_glass_action_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "break_glass_action_parameter" */
export type Break_Glass_Action_Parameter_Min_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "break_glass_action_parameter". */
export type Break_Glass_Action_Parameter_Order_By = {
  break_glass_action?: InputMaybe<Break_Glass_Action_Order_By>;
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "break_glass_action_parameter" */
export enum Break_Glass_Action_Parameter_Select_Column {
  /** column name */
  BreakGlassActionId = 'break_glass_action_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Value = 'value'
}

/** aggregate stddev on columns */
export type Break_Glass_Action_Parameter_Stddev_Fields = {
  __typename?: 'break_glass_action_parameter_stddev_fields';
  break_glass_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "break_glass_action_parameter" */
export type Break_Glass_Action_Parameter_Stddev_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Break_Glass_Action_Parameter_Stddev_Pop_Fields = {
  __typename?: 'break_glass_action_parameter_stddev_pop_fields';
  break_glass_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "break_glass_action_parameter" */
export type Break_Glass_Action_Parameter_Stddev_Pop_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Break_Glass_Action_Parameter_Stddev_Samp_Fields = {
  __typename?: 'break_glass_action_parameter_stddev_samp_fields';
  break_glass_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "break_glass_action_parameter" */
export type Break_Glass_Action_Parameter_Stddev_Samp_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "break_glass_action_parameter" */
export type Break_Glass_Action_Parameter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Break_Glass_Action_Parameter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Break_Glass_Action_Parameter_Stream_Cursor_Value_Input = {
  break_glass_action_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Break_Glass_Action_Parameter_Sum_Fields = {
  __typename?: 'break_glass_action_parameter_sum_fields';
  break_glass_action_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "break_glass_action_parameter" */
export type Break_Glass_Action_Parameter_Sum_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Break_Glass_Action_Parameter_Var_Pop_Fields = {
  __typename?: 'break_glass_action_parameter_var_pop_fields';
  break_glass_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "break_glass_action_parameter" */
export type Break_Glass_Action_Parameter_Var_Pop_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Break_Glass_Action_Parameter_Var_Samp_Fields = {
  __typename?: 'break_glass_action_parameter_var_samp_fields';
  break_glass_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "break_glass_action_parameter" */
export type Break_Glass_Action_Parameter_Var_Samp_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Break_Glass_Action_Parameter_Variance_Fields = {
  __typename?: 'break_glass_action_parameter_variance_fields';
  break_glass_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "break_glass_action_parameter" */
export type Break_Glass_Action_Parameter_Variance_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "break_glass_action" */
export enum Break_Glass_Action_Select_Column {
  /** column name */
  ActionType = 'action_type',
  /** column name */
  BreakGlassId = 'break_glass_id',
  /** column name */
  CouncilSizeSnapshot = 'council_size_snapshot',
  /** column name */
  Executed = 'executed',
  /** column name */
  ExecutionDatetime = 'execution_datetime',
  /** column name */
  ExecutionLevel = 'execution_level',
  /** column name */
  ExpirationDatetime = 'expiration_datetime',
  /** column name */
  FlushedDatetime = 'flushed_datetime',
  /** column name */
  Id = 'id',
  /** column name */
  InitiatorId = 'initiator_id',
  /** column name */
  InternalId = 'internal_id',
  /** column name */
  RegisteredThreshold = 'registered_threshold',
  /** column name */
  SignersCount = 'signers_count',
  /** column name */
  StartDatetime = 'start_datetime',
  /** column name */
  Status = 'status'
}

/** select "break_glass_action_aggregate_bool_exp_bool_and_arguments_columns" columns of table "break_glass_action" */
export enum Break_Glass_Action_Select_Column_Break_Glass_Action_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Executed = 'executed'
}

/** select "break_glass_action_aggregate_bool_exp_bool_or_arguments_columns" columns of table "break_glass_action" */
export enum Break_Glass_Action_Select_Column_Break_Glass_Action_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Executed = 'executed'
}

/** columns and relationships of "break_glass_action_signer" */
export type Break_Glass_Action_Signer = {
  __typename?: 'break_glass_action_signer';
  /** An object relationship */
  break_glass_action: Break_Glass_Action;
  break_glass_action_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  signer: Maven_User;
  signer_id: Scalars['bigint']['output'];
};

/** aggregated selection of "break_glass_action_signer" */
export type Break_Glass_Action_Signer_Aggregate = {
  __typename?: 'break_glass_action_signer_aggregate';
  aggregate?: Maybe<Break_Glass_Action_Signer_Aggregate_Fields>;
  nodes: Array<Break_Glass_Action_Signer>;
};

export type Break_Glass_Action_Signer_Aggregate_Bool_Exp = {
  count?: InputMaybe<Break_Glass_Action_Signer_Aggregate_Bool_Exp_Count>;
};

export type Break_Glass_Action_Signer_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Break_Glass_Action_Signer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Break_Glass_Action_Signer_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "break_glass_action_signer" */
export type Break_Glass_Action_Signer_Aggregate_Fields = {
  __typename?: 'break_glass_action_signer_aggregate_fields';
  avg?: Maybe<Break_Glass_Action_Signer_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Break_Glass_Action_Signer_Max_Fields>;
  min?: Maybe<Break_Glass_Action_Signer_Min_Fields>;
  stddev?: Maybe<Break_Glass_Action_Signer_Stddev_Fields>;
  stddev_pop?: Maybe<Break_Glass_Action_Signer_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Break_Glass_Action_Signer_Stddev_Samp_Fields>;
  sum?: Maybe<Break_Glass_Action_Signer_Sum_Fields>;
  var_pop?: Maybe<Break_Glass_Action_Signer_Var_Pop_Fields>;
  var_samp?: Maybe<Break_Glass_Action_Signer_Var_Samp_Fields>;
  variance?: Maybe<Break_Glass_Action_Signer_Variance_Fields>;
};


/** aggregate fields of "break_glass_action_signer" */
export type Break_Glass_Action_Signer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Break_Glass_Action_Signer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "break_glass_action_signer" */
export type Break_Glass_Action_Signer_Aggregate_Order_By = {
  avg?: InputMaybe<Break_Glass_Action_Signer_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Break_Glass_Action_Signer_Max_Order_By>;
  min?: InputMaybe<Break_Glass_Action_Signer_Min_Order_By>;
  stddev?: InputMaybe<Break_Glass_Action_Signer_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Break_Glass_Action_Signer_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Break_Glass_Action_Signer_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Break_Glass_Action_Signer_Sum_Order_By>;
  var_pop?: InputMaybe<Break_Glass_Action_Signer_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Break_Glass_Action_Signer_Var_Samp_Order_By>;
  variance?: InputMaybe<Break_Glass_Action_Signer_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Break_Glass_Action_Signer_Avg_Fields = {
  __typename?: 'break_glass_action_signer_avg_fields';
  break_glass_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  signer_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "break_glass_action_signer" */
export type Break_Glass_Action_Signer_Avg_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signer_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "break_glass_action_signer". All fields are combined with a logical 'AND'. */
export type Break_Glass_Action_Signer_Bool_Exp = {
  _and?: InputMaybe<Array<Break_Glass_Action_Signer_Bool_Exp>>;
  _not?: InputMaybe<Break_Glass_Action_Signer_Bool_Exp>;
  _or?: InputMaybe<Array<Break_Glass_Action_Signer_Bool_Exp>>;
  break_glass_action?: InputMaybe<Break_Glass_Action_Bool_Exp>;
  break_glass_action_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  signer?: InputMaybe<Maven_User_Bool_Exp>;
  signer_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Break_Glass_Action_Signer_Max_Fields = {
  __typename?: 'break_glass_action_signer_max_fields';
  break_glass_action_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  signer_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "break_glass_action_signer" */
export type Break_Glass_Action_Signer_Max_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signer_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Break_Glass_Action_Signer_Min_Fields = {
  __typename?: 'break_glass_action_signer_min_fields';
  break_glass_action_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  signer_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "break_glass_action_signer" */
export type Break_Glass_Action_Signer_Min_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signer_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "break_glass_action_signer". */
export type Break_Glass_Action_Signer_Order_By = {
  break_glass_action?: InputMaybe<Break_Glass_Action_Order_By>;
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signer?: InputMaybe<Maven_User_Order_By>;
  signer_id?: InputMaybe<Order_By>;
};

/** select columns of table "break_glass_action_signer" */
export enum Break_Glass_Action_Signer_Select_Column {
  /** column name */
  BreakGlassActionId = 'break_glass_action_id',
  /** column name */
  Id = 'id',
  /** column name */
  SignerId = 'signer_id'
}

/** aggregate stddev on columns */
export type Break_Glass_Action_Signer_Stddev_Fields = {
  __typename?: 'break_glass_action_signer_stddev_fields';
  break_glass_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  signer_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "break_glass_action_signer" */
export type Break_Glass_Action_Signer_Stddev_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signer_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Break_Glass_Action_Signer_Stddev_Pop_Fields = {
  __typename?: 'break_glass_action_signer_stddev_pop_fields';
  break_glass_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  signer_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "break_glass_action_signer" */
export type Break_Glass_Action_Signer_Stddev_Pop_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signer_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Break_Glass_Action_Signer_Stddev_Samp_Fields = {
  __typename?: 'break_glass_action_signer_stddev_samp_fields';
  break_glass_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  signer_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "break_glass_action_signer" */
export type Break_Glass_Action_Signer_Stddev_Samp_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signer_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "break_glass_action_signer" */
export type Break_Glass_Action_Signer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Break_Glass_Action_Signer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Break_Glass_Action_Signer_Stream_Cursor_Value_Input = {
  break_glass_action_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  signer_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Break_Glass_Action_Signer_Sum_Fields = {
  __typename?: 'break_glass_action_signer_sum_fields';
  break_glass_action_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  signer_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "break_glass_action_signer" */
export type Break_Glass_Action_Signer_Sum_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signer_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Break_Glass_Action_Signer_Var_Pop_Fields = {
  __typename?: 'break_glass_action_signer_var_pop_fields';
  break_glass_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  signer_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "break_glass_action_signer" */
export type Break_Glass_Action_Signer_Var_Pop_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signer_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Break_Glass_Action_Signer_Var_Samp_Fields = {
  __typename?: 'break_glass_action_signer_var_samp_fields';
  break_glass_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  signer_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "break_glass_action_signer" */
export type Break_Glass_Action_Signer_Var_Samp_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signer_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Break_Glass_Action_Signer_Variance_Fields = {
  __typename?: 'break_glass_action_signer_variance_fields';
  break_glass_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  signer_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "break_glass_action_signer" */
export type Break_Glass_Action_Signer_Variance_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signer_id?: InputMaybe<Order_By>;
};

/** aggregate stddev on columns */
export type Break_Glass_Action_Stddev_Fields = {
  __typename?: 'break_glass_action_stddev_fields';
  break_glass_id?: Maybe<Scalars['Float']['output']>;
  council_size_snapshot?: Maybe<Scalars['Float']['output']>;
  execution_level?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initiator_id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  registered_threshold?: Maybe<Scalars['Float']['output']>;
  signers_count?: Maybe<Scalars['Float']['output']>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "break_glass_action" */
export type Break_Glass_Action_Stddev_Order_By = {
  break_glass_id?: InputMaybe<Order_By>;
  council_size_snapshot?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  registered_threshold?: InputMaybe<Order_By>;
  signers_count?: InputMaybe<Order_By>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Break_Glass_Action_Stddev_Pop_Fields = {
  __typename?: 'break_glass_action_stddev_pop_fields';
  break_glass_id?: Maybe<Scalars['Float']['output']>;
  council_size_snapshot?: Maybe<Scalars['Float']['output']>;
  execution_level?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initiator_id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  registered_threshold?: Maybe<Scalars['Float']['output']>;
  signers_count?: Maybe<Scalars['Float']['output']>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "break_glass_action" */
export type Break_Glass_Action_Stddev_Pop_Order_By = {
  break_glass_id?: InputMaybe<Order_By>;
  council_size_snapshot?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  registered_threshold?: InputMaybe<Order_By>;
  signers_count?: InputMaybe<Order_By>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Break_Glass_Action_Stddev_Samp_Fields = {
  __typename?: 'break_glass_action_stddev_samp_fields';
  break_glass_id?: Maybe<Scalars['Float']['output']>;
  council_size_snapshot?: Maybe<Scalars['Float']['output']>;
  execution_level?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initiator_id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  registered_threshold?: Maybe<Scalars['Float']['output']>;
  signers_count?: Maybe<Scalars['Float']['output']>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "break_glass_action" */
export type Break_Glass_Action_Stddev_Samp_Order_By = {
  break_glass_id?: InputMaybe<Order_By>;
  council_size_snapshot?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  registered_threshold?: InputMaybe<Order_By>;
  signers_count?: InputMaybe<Order_By>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "break_glass_action" */
export type Break_Glass_Action_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Break_Glass_Action_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Break_Glass_Action_Stream_Cursor_Value_Input = {
  action_type?: InputMaybe<Scalars['String']['input']>;
  break_glass_id?: InputMaybe<Scalars['bigint']['input']>;
  council_size_snapshot?: InputMaybe<Scalars['smallint']['input']>;
  executed?: InputMaybe<Scalars['Boolean']['input']>;
  execution_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  execution_level?: InputMaybe<Scalars['bigint']['input']>;
  expiration_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  flushed_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  initiator_id?: InputMaybe<Scalars['bigint']['input']>;
  internal_id?: InputMaybe<Scalars['bigint']['input']>;
  registered_threshold?: InputMaybe<Scalars['smallint']['input']>;
  signers_count?: InputMaybe<Scalars['smallint']['input']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: InputMaybe<Scalars['smallint']['input']>;
};

/** aggregate sum on columns */
export type Break_Glass_Action_Sum_Fields = {
  __typename?: 'break_glass_action_sum_fields';
  break_glass_id?: Maybe<Scalars['bigint']['output']>;
  council_size_snapshot?: Maybe<Scalars['smallint']['output']>;
  execution_level?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  initiator_id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['bigint']['output']>;
  registered_threshold?: Maybe<Scalars['smallint']['output']>;
  signers_count?: Maybe<Scalars['smallint']['output']>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: Maybe<Scalars['smallint']['output']>;
};

/** order by sum() on columns of table "break_glass_action" */
export type Break_Glass_Action_Sum_Order_By = {
  break_glass_id?: InputMaybe<Order_By>;
  council_size_snapshot?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  registered_threshold?: InputMaybe<Order_By>;
  signers_count?: InputMaybe<Order_By>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: InputMaybe<Order_By>;
};

/** columns and relationships of "break_glass_action_temp_parameter" */
export type Break_Glass_Action_Temp_Parameter = {
  __typename?: 'break_glass_action_temp_parameter';
  /** An object relationship */
  break_glass_action: Break_Glass_Action;
  break_glass_action_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  old_council_member_address: Scalars['String']['output'];
};

/** aggregated selection of "break_glass_action_temp_parameter" */
export type Break_Glass_Action_Temp_Parameter_Aggregate = {
  __typename?: 'break_glass_action_temp_parameter_aggregate';
  aggregate?: Maybe<Break_Glass_Action_Temp_Parameter_Aggregate_Fields>;
  nodes: Array<Break_Glass_Action_Temp_Parameter>;
};

export type Break_Glass_Action_Temp_Parameter_Aggregate_Bool_Exp = {
  count?: InputMaybe<Break_Glass_Action_Temp_Parameter_Aggregate_Bool_Exp_Count>;
};

export type Break_Glass_Action_Temp_Parameter_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Break_Glass_Action_Temp_Parameter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Break_Glass_Action_Temp_Parameter_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "break_glass_action_temp_parameter" */
export type Break_Glass_Action_Temp_Parameter_Aggregate_Fields = {
  __typename?: 'break_glass_action_temp_parameter_aggregate_fields';
  avg?: Maybe<Break_Glass_Action_Temp_Parameter_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Break_Glass_Action_Temp_Parameter_Max_Fields>;
  min?: Maybe<Break_Glass_Action_Temp_Parameter_Min_Fields>;
  stddev?: Maybe<Break_Glass_Action_Temp_Parameter_Stddev_Fields>;
  stddev_pop?: Maybe<Break_Glass_Action_Temp_Parameter_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Break_Glass_Action_Temp_Parameter_Stddev_Samp_Fields>;
  sum?: Maybe<Break_Glass_Action_Temp_Parameter_Sum_Fields>;
  var_pop?: Maybe<Break_Glass_Action_Temp_Parameter_Var_Pop_Fields>;
  var_samp?: Maybe<Break_Glass_Action_Temp_Parameter_Var_Samp_Fields>;
  variance?: Maybe<Break_Glass_Action_Temp_Parameter_Variance_Fields>;
};


/** aggregate fields of "break_glass_action_temp_parameter" */
export type Break_Glass_Action_Temp_Parameter_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Break_Glass_Action_Temp_Parameter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "break_glass_action_temp_parameter" */
export type Break_Glass_Action_Temp_Parameter_Aggregate_Order_By = {
  avg?: InputMaybe<Break_Glass_Action_Temp_Parameter_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Break_Glass_Action_Temp_Parameter_Max_Order_By>;
  min?: InputMaybe<Break_Glass_Action_Temp_Parameter_Min_Order_By>;
  stddev?: InputMaybe<Break_Glass_Action_Temp_Parameter_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Break_Glass_Action_Temp_Parameter_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Break_Glass_Action_Temp_Parameter_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Break_Glass_Action_Temp_Parameter_Sum_Order_By>;
  var_pop?: InputMaybe<Break_Glass_Action_Temp_Parameter_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Break_Glass_Action_Temp_Parameter_Var_Samp_Order_By>;
  variance?: InputMaybe<Break_Glass_Action_Temp_Parameter_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Break_Glass_Action_Temp_Parameter_Avg_Fields = {
  __typename?: 'break_glass_action_temp_parameter_avg_fields';
  break_glass_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "break_glass_action_temp_parameter" */
export type Break_Glass_Action_Temp_Parameter_Avg_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "break_glass_action_temp_parameter". All fields are combined with a logical 'AND'. */
export type Break_Glass_Action_Temp_Parameter_Bool_Exp = {
  _and?: InputMaybe<Array<Break_Glass_Action_Temp_Parameter_Bool_Exp>>;
  _not?: InputMaybe<Break_Glass_Action_Temp_Parameter_Bool_Exp>;
  _or?: InputMaybe<Array<Break_Glass_Action_Temp_Parameter_Bool_Exp>>;
  break_glass_action?: InputMaybe<Break_Glass_Action_Bool_Exp>;
  break_glass_action_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  old_council_member_address?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Break_Glass_Action_Temp_Parameter_Max_Fields = {
  __typename?: 'break_glass_action_temp_parameter_max_fields';
  break_glass_action_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  old_council_member_address?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "break_glass_action_temp_parameter" */
export type Break_Glass_Action_Temp_Parameter_Max_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_council_member_address?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Break_Glass_Action_Temp_Parameter_Min_Fields = {
  __typename?: 'break_glass_action_temp_parameter_min_fields';
  break_glass_action_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  old_council_member_address?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "break_glass_action_temp_parameter" */
export type Break_Glass_Action_Temp_Parameter_Min_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_council_member_address?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "break_glass_action_temp_parameter". */
export type Break_Glass_Action_Temp_Parameter_Order_By = {
  break_glass_action?: InputMaybe<Break_Glass_Action_Order_By>;
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_council_member_address?: InputMaybe<Order_By>;
};

/** select columns of table "break_glass_action_temp_parameter" */
export enum Break_Glass_Action_Temp_Parameter_Select_Column {
  /** column name */
  BreakGlassActionId = 'break_glass_action_id',
  /** column name */
  Id = 'id',
  /** column name */
  OldCouncilMemberAddress = 'old_council_member_address'
}

/** aggregate stddev on columns */
export type Break_Glass_Action_Temp_Parameter_Stddev_Fields = {
  __typename?: 'break_glass_action_temp_parameter_stddev_fields';
  break_glass_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "break_glass_action_temp_parameter" */
export type Break_Glass_Action_Temp_Parameter_Stddev_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Break_Glass_Action_Temp_Parameter_Stddev_Pop_Fields = {
  __typename?: 'break_glass_action_temp_parameter_stddev_pop_fields';
  break_glass_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "break_glass_action_temp_parameter" */
export type Break_Glass_Action_Temp_Parameter_Stddev_Pop_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Break_Glass_Action_Temp_Parameter_Stddev_Samp_Fields = {
  __typename?: 'break_glass_action_temp_parameter_stddev_samp_fields';
  break_glass_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "break_glass_action_temp_parameter" */
export type Break_Glass_Action_Temp_Parameter_Stddev_Samp_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "break_glass_action_temp_parameter" */
export type Break_Glass_Action_Temp_Parameter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Break_Glass_Action_Temp_Parameter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Break_Glass_Action_Temp_Parameter_Stream_Cursor_Value_Input = {
  break_glass_action_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  old_council_member_address?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Break_Glass_Action_Temp_Parameter_Sum_Fields = {
  __typename?: 'break_glass_action_temp_parameter_sum_fields';
  break_glass_action_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "break_glass_action_temp_parameter" */
export type Break_Glass_Action_Temp_Parameter_Sum_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Break_Glass_Action_Temp_Parameter_Var_Pop_Fields = {
  __typename?: 'break_glass_action_temp_parameter_var_pop_fields';
  break_glass_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "break_glass_action_temp_parameter" */
export type Break_Glass_Action_Temp_Parameter_Var_Pop_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Break_Glass_Action_Temp_Parameter_Var_Samp_Fields = {
  __typename?: 'break_glass_action_temp_parameter_var_samp_fields';
  break_glass_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "break_glass_action_temp_parameter" */
export type Break_Glass_Action_Temp_Parameter_Var_Samp_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Break_Glass_Action_Temp_Parameter_Variance_Fields = {
  __typename?: 'break_glass_action_temp_parameter_variance_fields';
  break_glass_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "break_glass_action_temp_parameter" */
export type Break_Glass_Action_Temp_Parameter_Variance_Order_By = {
  break_glass_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Break_Glass_Action_Var_Pop_Fields = {
  __typename?: 'break_glass_action_var_pop_fields';
  break_glass_id?: Maybe<Scalars['Float']['output']>;
  council_size_snapshot?: Maybe<Scalars['Float']['output']>;
  execution_level?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initiator_id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  registered_threshold?: Maybe<Scalars['Float']['output']>;
  signers_count?: Maybe<Scalars['Float']['output']>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "break_glass_action" */
export type Break_Glass_Action_Var_Pop_Order_By = {
  break_glass_id?: InputMaybe<Order_By>;
  council_size_snapshot?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  registered_threshold?: InputMaybe<Order_By>;
  signers_count?: InputMaybe<Order_By>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Break_Glass_Action_Var_Samp_Fields = {
  __typename?: 'break_glass_action_var_samp_fields';
  break_glass_id?: Maybe<Scalars['Float']['output']>;
  council_size_snapshot?: Maybe<Scalars['Float']['output']>;
  execution_level?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initiator_id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  registered_threshold?: Maybe<Scalars['Float']['output']>;
  signers_count?: Maybe<Scalars['Float']['output']>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "break_glass_action" */
export type Break_Glass_Action_Var_Samp_Order_By = {
  break_glass_id?: InputMaybe<Order_By>;
  council_size_snapshot?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  registered_threshold?: InputMaybe<Order_By>;
  signers_count?: InputMaybe<Order_By>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Break_Glass_Action_Variance_Fields = {
  __typename?: 'break_glass_action_variance_fields';
  break_glass_id?: Maybe<Scalars['Float']['output']>;
  council_size_snapshot?: Maybe<Scalars['Float']['output']>;
  execution_level?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initiator_id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  registered_threshold?: Maybe<Scalars['Float']['output']>;
  signers_count?: Maybe<Scalars['Float']['output']>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "break_glass_action" */
export type Break_Glass_Action_Variance_Order_By = {
  break_glass_id?: InputMaybe<Order_By>;
  council_size_snapshot?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  registered_threshold?: InputMaybe<Order_By>;
  signers_count?: InputMaybe<Order_By>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: InputMaybe<Order_By>;
};

/** aggregated selection of "break_glass" */
export type Break_Glass_Aggregate = {
  __typename?: 'break_glass_aggregate';
  aggregate?: Maybe<Break_Glass_Aggregate_Fields>;
  nodes: Array<Break_Glass>;
};

export type Break_Glass_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Break_Glass_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Break_Glass_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Break_Glass_Aggregate_Bool_Exp_Count>;
};

export type Break_Glass_Aggregate_Bool_Exp_Bool_And = {
  arguments: Break_Glass_Select_Column_Break_Glass_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Break_Glass_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Break_Glass_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Break_Glass_Select_Column_Break_Glass_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Break_Glass_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Break_Glass_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Break_Glass_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Break_Glass_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "break_glass" */
export type Break_Glass_Aggregate_Fields = {
  __typename?: 'break_glass_aggregate_fields';
  avg?: Maybe<Break_Glass_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Break_Glass_Max_Fields>;
  min?: Maybe<Break_Glass_Min_Fields>;
  stddev?: Maybe<Break_Glass_Stddev_Fields>;
  stddev_pop?: Maybe<Break_Glass_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Break_Glass_Stddev_Samp_Fields>;
  sum?: Maybe<Break_Glass_Sum_Fields>;
  var_pop?: Maybe<Break_Glass_Var_Pop_Fields>;
  var_samp?: Maybe<Break_Glass_Var_Samp_Fields>;
  variance?: Maybe<Break_Glass_Variance_Fields>;
};


/** aggregate fields of "break_glass" */
export type Break_Glass_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Break_Glass_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "break_glass" */
export type Break_Glass_Aggregate_Order_By = {
  avg?: InputMaybe<Break_Glass_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Break_Glass_Max_Order_By>;
  min?: InputMaybe<Break_Glass_Min_Order_By>;
  stddev?: InputMaybe<Break_Glass_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Break_Glass_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Break_Glass_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Break_Glass_Sum_Order_By>;
  var_pop?: InputMaybe<Break_Glass_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Break_Glass_Var_Samp_Order_By>;
  variance?: InputMaybe<Break_Glass_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Break_Glass_Avg_Fields = {
  __typename?: 'break_glass_avg_fields';
  action_counter?: Maybe<Scalars['Float']['output']>;
  action_expiry_days?: Maybe<Scalars['Float']['output']>;
  council_member_image_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_name_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_website_max_length?: Maybe<Scalars['Float']['output']>;
  council_size?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "break_glass" */
export type Break_Glass_Avg_Order_By = {
  action_counter?: InputMaybe<Order_By>;
  action_expiry_days?: InputMaybe<Order_By>;
  council_member_image_max_length?: InputMaybe<Order_By>;
  council_member_name_max_length?: InputMaybe<Order_By>;
  council_member_website_max_length?: InputMaybe<Order_By>;
  council_size?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "break_glass". All fields are combined with a logical 'AND'. */
export type Break_Glass_Bool_Exp = {
  _and?: InputMaybe<Array<Break_Glass_Bool_Exp>>;
  _not?: InputMaybe<Break_Glass_Bool_Exp>;
  _or?: InputMaybe<Array<Break_Glass_Bool_Exp>>;
  action_counter?: InputMaybe<Bigint_Comparison_Exp>;
  action_expiry_days?: InputMaybe<Smallint_Comparison_Exp>;
  actions?: InputMaybe<Break_Glass_Action_Bool_Exp>;
  actions_aggregate?: InputMaybe<Break_Glass_Action_Aggregate_Bool_Exp>;
  address?: InputMaybe<String_Comparison_Exp>;
  admin?: InputMaybe<String_Comparison_Exp>;
  council_member_image_max_length?: InputMaybe<Smallint_Comparison_Exp>;
  council_member_name_max_length?: InputMaybe<Smallint_Comparison_Exp>;
  council_member_website_max_length?: InputMaybe<Smallint_Comparison_Exp>;
  council_members?: InputMaybe<Break_Glass_Council_Member_Bool_Exp>;
  council_members_aggregate?: InputMaybe<Break_Glass_Council_Member_Aggregate_Bool_Exp>;
  council_size?: InputMaybe<Smallint_Comparison_Exp>;
  general_contracts?: InputMaybe<Break_Glass_General_Contract_Bool_Exp>;
  general_contracts_aggregate?: InputMaybe<Break_Glass_General_Contract_Aggregate_Bool_Exp>;
  glass_broken?: InputMaybe<Boolean_Comparison_Exp>;
  governance?: InputMaybe<Governance_Bool_Exp>;
  governance_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambdas?: InputMaybe<Break_Glass_Lambda_Bool_Exp>;
  lambdas_aggregate?: InputMaybe<Break_Glass_Lambda_Aggregate_Bool_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
  threshold?: InputMaybe<Smallint_Comparison_Exp>;
  whitelist_contracts?: InputMaybe<Break_Glass_Whitelist_Contract_Bool_Exp>;
  whitelist_contracts_aggregate?: InputMaybe<Break_Glass_Whitelist_Contract_Aggregate_Bool_Exp>;
};

/** columns and relationships of "break_glass_council_member" */
export type Break_Glass_Council_Member = {
  __typename?: 'break_glass_council_member';
  /** An object relationship */
  break_glass: Break_Glass;
  break_glass_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  user: Maven_User;
  user_id: Scalars['bigint']['output'];
  website: Scalars['String']['output'];
};

/** aggregated selection of "break_glass_council_member" */
export type Break_Glass_Council_Member_Aggregate = {
  __typename?: 'break_glass_council_member_aggregate';
  aggregate?: Maybe<Break_Glass_Council_Member_Aggregate_Fields>;
  nodes: Array<Break_Glass_Council_Member>;
};

export type Break_Glass_Council_Member_Aggregate_Bool_Exp = {
  count?: InputMaybe<Break_Glass_Council_Member_Aggregate_Bool_Exp_Count>;
};

export type Break_Glass_Council_Member_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Break_Glass_Council_Member_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Break_Glass_Council_Member_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "break_glass_council_member" */
export type Break_Glass_Council_Member_Aggregate_Fields = {
  __typename?: 'break_glass_council_member_aggregate_fields';
  avg?: Maybe<Break_Glass_Council_Member_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Break_Glass_Council_Member_Max_Fields>;
  min?: Maybe<Break_Glass_Council_Member_Min_Fields>;
  stddev?: Maybe<Break_Glass_Council_Member_Stddev_Fields>;
  stddev_pop?: Maybe<Break_Glass_Council_Member_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Break_Glass_Council_Member_Stddev_Samp_Fields>;
  sum?: Maybe<Break_Glass_Council_Member_Sum_Fields>;
  var_pop?: Maybe<Break_Glass_Council_Member_Var_Pop_Fields>;
  var_samp?: Maybe<Break_Glass_Council_Member_Var_Samp_Fields>;
  variance?: Maybe<Break_Glass_Council_Member_Variance_Fields>;
};


/** aggregate fields of "break_glass_council_member" */
export type Break_Glass_Council_Member_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Break_Glass_Council_Member_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "break_glass_council_member" */
export type Break_Glass_Council_Member_Aggregate_Order_By = {
  avg?: InputMaybe<Break_Glass_Council_Member_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Break_Glass_Council_Member_Max_Order_By>;
  min?: InputMaybe<Break_Glass_Council_Member_Min_Order_By>;
  stddev?: InputMaybe<Break_Glass_Council_Member_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Break_Glass_Council_Member_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Break_Glass_Council_Member_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Break_Glass_Council_Member_Sum_Order_By>;
  var_pop?: InputMaybe<Break_Glass_Council_Member_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Break_Glass_Council_Member_Var_Samp_Order_By>;
  variance?: InputMaybe<Break_Glass_Council_Member_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Break_Glass_Council_Member_Avg_Fields = {
  __typename?: 'break_glass_council_member_avg_fields';
  break_glass_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "break_glass_council_member" */
export type Break_Glass_Council_Member_Avg_Order_By = {
  break_glass_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "break_glass_council_member". All fields are combined with a logical 'AND'. */
export type Break_Glass_Council_Member_Bool_Exp = {
  _and?: InputMaybe<Array<Break_Glass_Council_Member_Bool_Exp>>;
  _not?: InputMaybe<Break_Glass_Council_Member_Bool_Exp>;
  _or?: InputMaybe<Array<Break_Glass_Council_Member_Bool_Exp>>;
  break_glass?: InputMaybe<Break_Glass_Bool_Exp>;
  break_glass_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  image?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Maven_User_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
  website?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Break_Glass_Council_Member_Max_Fields = {
  __typename?: 'break_glass_council_member_max_fields';
  break_glass_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "break_glass_council_member" */
export type Break_Glass_Council_Member_Max_Order_By = {
  break_glass_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Break_Glass_Council_Member_Min_Fields = {
  __typename?: 'break_glass_council_member_min_fields';
  break_glass_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "break_glass_council_member" */
export type Break_Glass_Council_Member_Min_Order_By = {
  break_glass_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "break_glass_council_member". */
export type Break_Glass_Council_Member_Order_By = {
  break_glass?: InputMaybe<Break_Glass_Order_By>;
  break_glass_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  user?: InputMaybe<Maven_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** select columns of table "break_glass_council_member" */
export enum Break_Glass_Council_Member_Select_Column {
  /** column name */
  BreakGlassId = 'break_glass_id',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Name = 'name',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Website = 'website'
}

/** aggregate stddev on columns */
export type Break_Glass_Council_Member_Stddev_Fields = {
  __typename?: 'break_glass_council_member_stddev_fields';
  break_glass_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "break_glass_council_member" */
export type Break_Glass_Council_Member_Stddev_Order_By = {
  break_glass_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Break_Glass_Council_Member_Stddev_Pop_Fields = {
  __typename?: 'break_glass_council_member_stddev_pop_fields';
  break_glass_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "break_glass_council_member" */
export type Break_Glass_Council_Member_Stddev_Pop_Order_By = {
  break_glass_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Break_Glass_Council_Member_Stddev_Samp_Fields = {
  __typename?: 'break_glass_council_member_stddev_samp_fields';
  break_glass_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "break_glass_council_member" */
export type Break_Glass_Council_Member_Stddev_Samp_Order_By = {
  break_glass_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "break_glass_council_member" */
export type Break_Glass_Council_Member_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Break_Glass_Council_Member_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Break_Glass_Council_Member_Stream_Cursor_Value_Input = {
  break_glass_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Break_Glass_Council_Member_Sum_Fields = {
  __typename?: 'break_glass_council_member_sum_fields';
  break_glass_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "break_glass_council_member" */
export type Break_Glass_Council_Member_Sum_Order_By = {
  break_glass_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Break_Glass_Council_Member_Var_Pop_Fields = {
  __typename?: 'break_glass_council_member_var_pop_fields';
  break_glass_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "break_glass_council_member" */
export type Break_Glass_Council_Member_Var_Pop_Order_By = {
  break_glass_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Break_Glass_Council_Member_Var_Samp_Fields = {
  __typename?: 'break_glass_council_member_var_samp_fields';
  break_glass_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "break_glass_council_member" */
export type Break_Glass_Council_Member_Var_Samp_Order_By = {
  break_glass_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Break_Glass_Council_Member_Variance_Fields = {
  __typename?: 'break_glass_council_member_variance_fields';
  break_glass_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "break_glass_council_member" */
export type Break_Glass_Council_Member_Variance_Order_By = {
  break_glass_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "break_glass_general_contract" */
export type Break_Glass_General_Contract = {
  __typename?: 'break_glass_general_contract';
  /** An object relationship */
  contract: Break_Glass;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  contract_name: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "break_glass_general_contract" */
export type Break_Glass_General_Contract_Aggregate = {
  __typename?: 'break_glass_general_contract_aggregate';
  aggregate?: Maybe<Break_Glass_General_Contract_Aggregate_Fields>;
  nodes: Array<Break_Glass_General_Contract>;
};

export type Break_Glass_General_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Break_Glass_General_Contract_Aggregate_Bool_Exp_Count>;
};

export type Break_Glass_General_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Break_Glass_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Break_Glass_General_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "break_glass_general_contract" */
export type Break_Glass_General_Contract_Aggregate_Fields = {
  __typename?: 'break_glass_general_contract_aggregate_fields';
  avg?: Maybe<Break_Glass_General_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Break_Glass_General_Contract_Max_Fields>;
  min?: Maybe<Break_Glass_General_Contract_Min_Fields>;
  stddev?: Maybe<Break_Glass_General_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Break_Glass_General_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Break_Glass_General_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Break_Glass_General_Contract_Sum_Fields>;
  var_pop?: Maybe<Break_Glass_General_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Break_Glass_General_Contract_Var_Samp_Fields>;
  variance?: Maybe<Break_Glass_General_Contract_Variance_Fields>;
};


/** aggregate fields of "break_glass_general_contract" */
export type Break_Glass_General_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Break_Glass_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "break_glass_general_contract" */
export type Break_Glass_General_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Break_Glass_General_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Break_Glass_General_Contract_Max_Order_By>;
  min?: InputMaybe<Break_Glass_General_Contract_Min_Order_By>;
  stddev?: InputMaybe<Break_Glass_General_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Break_Glass_General_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Break_Glass_General_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Break_Glass_General_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Break_Glass_General_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Break_Glass_General_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Break_Glass_General_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Break_Glass_General_Contract_Avg_Fields = {
  __typename?: 'break_glass_general_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "break_glass_general_contract" */
export type Break_Glass_General_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "break_glass_general_contract". All fields are combined with a logical 'AND'. */
export type Break_Glass_General_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Break_Glass_General_Contract_Bool_Exp>>;
  _not?: InputMaybe<Break_Glass_General_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Break_Glass_General_Contract_Bool_Exp>>;
  contract?: InputMaybe<Break_Glass_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  contract_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Break_Glass_General_Contract_Max_Fields = {
  __typename?: 'break_glass_general_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "break_glass_general_contract" */
export type Break_Glass_General_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Break_Glass_General_Contract_Min_Fields = {
  __typename?: 'break_glass_general_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "break_glass_general_contract" */
export type Break_Glass_General_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "break_glass_general_contract". */
export type Break_Glass_General_Contract_Order_By = {
  contract?: InputMaybe<Break_Glass_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "break_glass_general_contract" */
export enum Break_Glass_General_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  ContractName = 'contract_name',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Break_Glass_General_Contract_Stddev_Fields = {
  __typename?: 'break_glass_general_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "break_glass_general_contract" */
export type Break_Glass_General_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Break_Glass_General_Contract_Stddev_Pop_Fields = {
  __typename?: 'break_glass_general_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "break_glass_general_contract" */
export type Break_Glass_General_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Break_Glass_General_Contract_Stddev_Samp_Fields = {
  __typename?: 'break_glass_general_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "break_glass_general_contract" */
export type Break_Glass_General_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "break_glass_general_contract" */
export type Break_Glass_General_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Break_Glass_General_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Break_Glass_General_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  contract_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Break_Glass_General_Contract_Sum_Fields = {
  __typename?: 'break_glass_general_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "break_glass_general_contract" */
export type Break_Glass_General_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Break_Glass_General_Contract_Var_Pop_Fields = {
  __typename?: 'break_glass_general_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "break_glass_general_contract" */
export type Break_Glass_General_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Break_Glass_General_Contract_Var_Samp_Fields = {
  __typename?: 'break_glass_general_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "break_glass_general_contract" */
export type Break_Glass_General_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Break_Glass_General_Contract_Variance_Fields = {
  __typename?: 'break_glass_general_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "break_glass_general_contract" */
export type Break_Glass_General_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "break_glass_lambda" */
export type Break_Glass_Lambda = {
  __typename?: 'break_glass_lambda';
  /** An object relationship */
  contract: Break_Glass;
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lambda_bytes: Scalars['String']['output'];
  lambda_name: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "break_glass_lambda" */
export type Break_Glass_Lambda_Aggregate = {
  __typename?: 'break_glass_lambda_aggregate';
  aggregate?: Maybe<Break_Glass_Lambda_Aggregate_Fields>;
  nodes: Array<Break_Glass_Lambda>;
};

export type Break_Glass_Lambda_Aggregate_Bool_Exp = {
  count?: InputMaybe<Break_Glass_Lambda_Aggregate_Bool_Exp_Count>;
};

export type Break_Glass_Lambda_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Break_Glass_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Break_Glass_Lambda_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "break_glass_lambda" */
export type Break_Glass_Lambda_Aggregate_Fields = {
  __typename?: 'break_glass_lambda_aggregate_fields';
  avg?: Maybe<Break_Glass_Lambda_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Break_Glass_Lambda_Max_Fields>;
  min?: Maybe<Break_Glass_Lambda_Min_Fields>;
  stddev?: Maybe<Break_Glass_Lambda_Stddev_Fields>;
  stddev_pop?: Maybe<Break_Glass_Lambda_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Break_Glass_Lambda_Stddev_Samp_Fields>;
  sum?: Maybe<Break_Glass_Lambda_Sum_Fields>;
  var_pop?: Maybe<Break_Glass_Lambda_Var_Pop_Fields>;
  var_samp?: Maybe<Break_Glass_Lambda_Var_Samp_Fields>;
  variance?: Maybe<Break_Glass_Lambda_Variance_Fields>;
};


/** aggregate fields of "break_glass_lambda" */
export type Break_Glass_Lambda_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Break_Glass_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "break_glass_lambda" */
export type Break_Glass_Lambda_Aggregate_Order_By = {
  avg?: InputMaybe<Break_Glass_Lambda_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Break_Glass_Lambda_Max_Order_By>;
  min?: InputMaybe<Break_Glass_Lambda_Min_Order_By>;
  stddev?: InputMaybe<Break_Glass_Lambda_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Break_Glass_Lambda_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Break_Glass_Lambda_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Break_Glass_Lambda_Sum_Order_By>;
  var_pop?: InputMaybe<Break_Glass_Lambda_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Break_Glass_Lambda_Var_Samp_Order_By>;
  variance?: InputMaybe<Break_Glass_Lambda_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Break_Glass_Lambda_Avg_Fields = {
  __typename?: 'break_glass_lambda_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "break_glass_lambda" */
export type Break_Glass_Lambda_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "break_glass_lambda". All fields are combined with a logical 'AND'. */
export type Break_Glass_Lambda_Bool_Exp = {
  _and?: InputMaybe<Array<Break_Glass_Lambda_Bool_Exp>>;
  _not?: InputMaybe<Break_Glass_Lambda_Bool_Exp>;
  _or?: InputMaybe<Array<Break_Glass_Lambda_Bool_Exp>>;
  contract?: InputMaybe<Break_Glass_Bool_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambda_bytes?: InputMaybe<String_Comparison_Exp>;
  lambda_name?: InputMaybe<String_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Break_Glass_Lambda_Max_Fields = {
  __typename?: 'break_glass_lambda_max_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "break_glass_lambda" */
export type Break_Glass_Lambda_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Break_Glass_Lambda_Min_Fields = {
  __typename?: 'break_glass_lambda_min_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "break_glass_lambda" */
export type Break_Glass_Lambda_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "break_glass_lambda". */
export type Break_Glass_Lambda_Order_By = {
  contract?: InputMaybe<Break_Glass_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "break_glass_lambda" */
export enum Break_Glass_Lambda_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaBytes = 'lambda_bytes',
  /** column name */
  LambdaName = 'lambda_name',
  /** column name */
  LastUpdatedAt = 'last_updated_at'
}

/** aggregate stddev on columns */
export type Break_Glass_Lambda_Stddev_Fields = {
  __typename?: 'break_glass_lambda_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "break_glass_lambda" */
export type Break_Glass_Lambda_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Break_Glass_Lambda_Stddev_Pop_Fields = {
  __typename?: 'break_glass_lambda_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "break_glass_lambda" */
export type Break_Glass_Lambda_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Break_Glass_Lambda_Stddev_Samp_Fields = {
  __typename?: 'break_glass_lambda_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "break_glass_lambda" */
export type Break_Glass_Lambda_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "break_glass_lambda" */
export type Break_Glass_Lambda_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Break_Glass_Lambda_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Break_Glass_Lambda_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lambda_bytes?: InputMaybe<Scalars['String']['input']>;
  lambda_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Break_Glass_Lambda_Sum_Fields = {
  __typename?: 'break_glass_lambda_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "break_glass_lambda" */
export type Break_Glass_Lambda_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Break_Glass_Lambda_Var_Pop_Fields = {
  __typename?: 'break_glass_lambda_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "break_glass_lambda" */
export type Break_Glass_Lambda_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Break_Glass_Lambda_Var_Samp_Fields = {
  __typename?: 'break_glass_lambda_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "break_glass_lambda" */
export type Break_Glass_Lambda_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Break_Glass_Lambda_Variance_Fields = {
  __typename?: 'break_glass_lambda_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "break_glass_lambda" */
export type Break_Glass_Lambda_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Break_Glass_Max_Fields = {
  __typename?: 'break_glass_max_fields';
  action_counter?: Maybe<Scalars['bigint']['output']>;
  action_expiry_days?: Maybe<Scalars['smallint']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  council_member_image_max_length?: Maybe<Scalars['smallint']['output']>;
  council_member_name_max_length?: Maybe<Scalars['smallint']['output']>;
  council_member_website_max_length?: Maybe<Scalars['smallint']['output']>;
  council_size?: Maybe<Scalars['smallint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  threshold?: Maybe<Scalars['smallint']['output']>;
};

/** order by max() on columns of table "break_glass" */
export type Break_Glass_Max_Order_By = {
  action_counter?: InputMaybe<Order_By>;
  action_expiry_days?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  council_member_image_max_length?: InputMaybe<Order_By>;
  council_member_name_max_length?: InputMaybe<Order_By>;
  council_member_website_max_length?: InputMaybe<Order_By>;
  council_size?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Break_Glass_Min_Fields = {
  __typename?: 'break_glass_min_fields';
  action_counter?: Maybe<Scalars['bigint']['output']>;
  action_expiry_days?: Maybe<Scalars['smallint']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  council_member_image_max_length?: Maybe<Scalars['smallint']['output']>;
  council_member_name_max_length?: Maybe<Scalars['smallint']['output']>;
  council_member_website_max_length?: Maybe<Scalars['smallint']['output']>;
  council_size?: Maybe<Scalars['smallint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  threshold?: Maybe<Scalars['smallint']['output']>;
};

/** order by min() on columns of table "break_glass" */
export type Break_Glass_Min_Order_By = {
  action_counter?: InputMaybe<Order_By>;
  action_expiry_days?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  council_member_image_max_length?: InputMaybe<Order_By>;
  council_member_name_max_length?: InputMaybe<Order_By>;
  council_member_website_max_length?: InputMaybe<Order_By>;
  council_size?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "break_glass". */
export type Break_Glass_Order_By = {
  action_counter?: InputMaybe<Order_By>;
  action_expiry_days?: InputMaybe<Order_By>;
  actions_aggregate?: InputMaybe<Break_Glass_Action_Aggregate_Order_By>;
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  council_member_image_max_length?: InputMaybe<Order_By>;
  council_member_name_max_length?: InputMaybe<Order_By>;
  council_member_website_max_length?: InputMaybe<Order_By>;
  council_members_aggregate?: InputMaybe<Break_Glass_Council_Member_Aggregate_Order_By>;
  council_size?: InputMaybe<Order_By>;
  general_contracts_aggregate?: InputMaybe<Break_Glass_General_Contract_Aggregate_Order_By>;
  glass_broken?: InputMaybe<Order_By>;
  governance?: InputMaybe<Governance_Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambdas_aggregate?: InputMaybe<Break_Glass_Lambda_Aggregate_Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
  whitelist_contracts_aggregate?: InputMaybe<Break_Glass_Whitelist_Contract_Aggregate_Order_By>;
};

/** select columns of table "break_glass" */
export enum Break_Glass_Select_Column {
  /** column name */
  ActionCounter = 'action_counter',
  /** column name */
  ActionExpiryDays = 'action_expiry_days',
  /** column name */
  Address = 'address',
  /** column name */
  Admin = 'admin',
  /** column name */
  CouncilMemberImageMaxLength = 'council_member_image_max_length',
  /** column name */
  CouncilMemberNameMaxLength = 'council_member_name_max_length',
  /** column name */
  CouncilMemberWebsiteMaxLength = 'council_member_website_max_length',
  /** column name */
  CouncilSize = 'council_size',
  /** column name */
  GlassBroken = 'glass_broken',
  /** column name */
  GovernanceId = 'governance_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Network = 'network',
  /** column name */
  Threshold = 'threshold'
}

/** select "break_glass_aggregate_bool_exp_bool_and_arguments_columns" columns of table "break_glass" */
export enum Break_Glass_Select_Column_Break_Glass_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  GlassBroken = 'glass_broken'
}

/** select "break_glass_aggregate_bool_exp_bool_or_arguments_columns" columns of table "break_glass" */
export enum Break_Glass_Select_Column_Break_Glass_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  GlassBroken = 'glass_broken'
}

/** aggregate stddev on columns */
export type Break_Glass_Stddev_Fields = {
  __typename?: 'break_glass_stddev_fields';
  action_counter?: Maybe<Scalars['Float']['output']>;
  action_expiry_days?: Maybe<Scalars['Float']['output']>;
  council_member_image_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_name_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_website_max_length?: Maybe<Scalars['Float']['output']>;
  council_size?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "break_glass" */
export type Break_Glass_Stddev_Order_By = {
  action_counter?: InputMaybe<Order_By>;
  action_expiry_days?: InputMaybe<Order_By>;
  council_member_image_max_length?: InputMaybe<Order_By>;
  council_member_name_max_length?: InputMaybe<Order_By>;
  council_member_website_max_length?: InputMaybe<Order_By>;
  council_size?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Break_Glass_Stddev_Pop_Fields = {
  __typename?: 'break_glass_stddev_pop_fields';
  action_counter?: Maybe<Scalars['Float']['output']>;
  action_expiry_days?: Maybe<Scalars['Float']['output']>;
  council_member_image_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_name_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_website_max_length?: Maybe<Scalars['Float']['output']>;
  council_size?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "break_glass" */
export type Break_Glass_Stddev_Pop_Order_By = {
  action_counter?: InputMaybe<Order_By>;
  action_expiry_days?: InputMaybe<Order_By>;
  council_member_image_max_length?: InputMaybe<Order_By>;
  council_member_name_max_length?: InputMaybe<Order_By>;
  council_member_website_max_length?: InputMaybe<Order_By>;
  council_size?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Break_Glass_Stddev_Samp_Fields = {
  __typename?: 'break_glass_stddev_samp_fields';
  action_counter?: Maybe<Scalars['Float']['output']>;
  action_expiry_days?: Maybe<Scalars['Float']['output']>;
  council_member_image_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_name_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_website_max_length?: Maybe<Scalars['Float']['output']>;
  council_size?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "break_glass" */
export type Break_Glass_Stddev_Samp_Order_By = {
  action_counter?: InputMaybe<Order_By>;
  action_expiry_days?: InputMaybe<Order_By>;
  council_member_image_max_length?: InputMaybe<Order_By>;
  council_member_name_max_length?: InputMaybe<Order_By>;
  council_member_website_max_length?: InputMaybe<Order_By>;
  council_size?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "break_glass" */
export type Break_Glass_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Break_Glass_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Break_Glass_Stream_Cursor_Value_Input = {
  action_counter?: InputMaybe<Scalars['bigint']['input']>;
  action_expiry_days?: InputMaybe<Scalars['smallint']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['String']['input']>;
  council_member_image_max_length?: InputMaybe<Scalars['smallint']['input']>;
  council_member_name_max_length?: InputMaybe<Scalars['smallint']['input']>;
  council_member_website_max_length?: InputMaybe<Scalars['smallint']['input']>;
  council_size?: InputMaybe<Scalars['smallint']['input']>;
  glass_broken?: InputMaybe<Scalars['Boolean']['input']>;
  governance_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  threshold?: InputMaybe<Scalars['smallint']['input']>;
};

/** aggregate sum on columns */
export type Break_Glass_Sum_Fields = {
  __typename?: 'break_glass_sum_fields';
  action_counter?: Maybe<Scalars['bigint']['output']>;
  action_expiry_days?: Maybe<Scalars['smallint']['output']>;
  council_member_image_max_length?: Maybe<Scalars['smallint']['output']>;
  council_member_name_max_length?: Maybe<Scalars['smallint']['output']>;
  council_member_website_max_length?: Maybe<Scalars['smallint']['output']>;
  council_size?: Maybe<Scalars['smallint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  threshold?: Maybe<Scalars['smallint']['output']>;
};

/** order by sum() on columns of table "break_glass" */
export type Break_Glass_Sum_Order_By = {
  action_counter?: InputMaybe<Order_By>;
  action_expiry_days?: InputMaybe<Order_By>;
  council_member_image_max_length?: InputMaybe<Order_By>;
  council_member_name_max_length?: InputMaybe<Order_By>;
  council_member_website_max_length?: InputMaybe<Order_By>;
  council_size?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Break_Glass_Var_Pop_Fields = {
  __typename?: 'break_glass_var_pop_fields';
  action_counter?: Maybe<Scalars['Float']['output']>;
  action_expiry_days?: Maybe<Scalars['Float']['output']>;
  council_member_image_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_name_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_website_max_length?: Maybe<Scalars['Float']['output']>;
  council_size?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "break_glass" */
export type Break_Glass_Var_Pop_Order_By = {
  action_counter?: InputMaybe<Order_By>;
  action_expiry_days?: InputMaybe<Order_By>;
  council_member_image_max_length?: InputMaybe<Order_By>;
  council_member_name_max_length?: InputMaybe<Order_By>;
  council_member_website_max_length?: InputMaybe<Order_By>;
  council_size?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Break_Glass_Var_Samp_Fields = {
  __typename?: 'break_glass_var_samp_fields';
  action_counter?: Maybe<Scalars['Float']['output']>;
  action_expiry_days?: Maybe<Scalars['Float']['output']>;
  council_member_image_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_name_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_website_max_length?: Maybe<Scalars['Float']['output']>;
  council_size?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "break_glass" */
export type Break_Glass_Var_Samp_Order_By = {
  action_counter?: InputMaybe<Order_By>;
  action_expiry_days?: InputMaybe<Order_By>;
  council_member_image_max_length?: InputMaybe<Order_By>;
  council_member_name_max_length?: InputMaybe<Order_By>;
  council_member_website_max_length?: InputMaybe<Order_By>;
  council_size?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Break_Glass_Variance_Fields = {
  __typename?: 'break_glass_variance_fields';
  action_counter?: Maybe<Scalars['Float']['output']>;
  action_expiry_days?: Maybe<Scalars['Float']['output']>;
  council_member_image_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_name_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_website_max_length?: Maybe<Scalars['Float']['output']>;
  council_size?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "break_glass" */
export type Break_Glass_Variance_Order_By = {
  action_counter?: InputMaybe<Order_By>;
  action_expiry_days?: InputMaybe<Order_By>;
  council_member_image_max_length?: InputMaybe<Order_By>;
  council_member_name_max_length?: InputMaybe<Order_By>;
  council_member_website_max_length?: InputMaybe<Order_By>;
  council_size?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** columns and relationships of "break_glass_whitelist_contract" */
export type Break_Glass_Whitelist_Contract = {
  __typename?: 'break_glass_whitelist_contract';
  /** An object relationship */
  contract: Break_Glass;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "break_glass_whitelist_contract" */
export type Break_Glass_Whitelist_Contract_Aggregate = {
  __typename?: 'break_glass_whitelist_contract_aggregate';
  aggregate?: Maybe<Break_Glass_Whitelist_Contract_Aggregate_Fields>;
  nodes: Array<Break_Glass_Whitelist_Contract>;
};

export type Break_Glass_Whitelist_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Break_Glass_Whitelist_Contract_Aggregate_Bool_Exp_Count>;
};

export type Break_Glass_Whitelist_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Break_Glass_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Break_Glass_Whitelist_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "break_glass_whitelist_contract" */
export type Break_Glass_Whitelist_Contract_Aggregate_Fields = {
  __typename?: 'break_glass_whitelist_contract_aggregate_fields';
  avg?: Maybe<Break_Glass_Whitelist_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Break_Glass_Whitelist_Contract_Max_Fields>;
  min?: Maybe<Break_Glass_Whitelist_Contract_Min_Fields>;
  stddev?: Maybe<Break_Glass_Whitelist_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Break_Glass_Whitelist_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Break_Glass_Whitelist_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Break_Glass_Whitelist_Contract_Sum_Fields>;
  var_pop?: Maybe<Break_Glass_Whitelist_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Break_Glass_Whitelist_Contract_Var_Samp_Fields>;
  variance?: Maybe<Break_Glass_Whitelist_Contract_Variance_Fields>;
};


/** aggregate fields of "break_glass_whitelist_contract" */
export type Break_Glass_Whitelist_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Break_Glass_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "break_glass_whitelist_contract" */
export type Break_Glass_Whitelist_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Break_Glass_Whitelist_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Break_Glass_Whitelist_Contract_Max_Order_By>;
  min?: InputMaybe<Break_Glass_Whitelist_Contract_Min_Order_By>;
  stddev?: InputMaybe<Break_Glass_Whitelist_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Break_Glass_Whitelist_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Break_Glass_Whitelist_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Break_Glass_Whitelist_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Break_Glass_Whitelist_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Break_Glass_Whitelist_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Break_Glass_Whitelist_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Break_Glass_Whitelist_Contract_Avg_Fields = {
  __typename?: 'break_glass_whitelist_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "break_glass_whitelist_contract" */
export type Break_Glass_Whitelist_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "break_glass_whitelist_contract". All fields are combined with a logical 'AND'. */
export type Break_Glass_Whitelist_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Break_Glass_Whitelist_Contract_Bool_Exp>>;
  _not?: InputMaybe<Break_Glass_Whitelist_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Break_Glass_Whitelist_Contract_Bool_Exp>>;
  contract?: InputMaybe<Break_Glass_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Break_Glass_Whitelist_Contract_Max_Fields = {
  __typename?: 'break_glass_whitelist_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "break_glass_whitelist_contract" */
export type Break_Glass_Whitelist_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Break_Glass_Whitelist_Contract_Min_Fields = {
  __typename?: 'break_glass_whitelist_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "break_glass_whitelist_contract" */
export type Break_Glass_Whitelist_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "break_glass_whitelist_contract". */
export type Break_Glass_Whitelist_Contract_Order_By = {
  contract?: InputMaybe<Break_Glass_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "break_glass_whitelist_contract" */
export enum Break_Glass_Whitelist_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Break_Glass_Whitelist_Contract_Stddev_Fields = {
  __typename?: 'break_glass_whitelist_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "break_glass_whitelist_contract" */
export type Break_Glass_Whitelist_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Break_Glass_Whitelist_Contract_Stddev_Pop_Fields = {
  __typename?: 'break_glass_whitelist_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "break_glass_whitelist_contract" */
export type Break_Glass_Whitelist_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Break_Glass_Whitelist_Contract_Stddev_Samp_Fields = {
  __typename?: 'break_glass_whitelist_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "break_glass_whitelist_contract" */
export type Break_Glass_Whitelist_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "break_glass_whitelist_contract" */
export type Break_Glass_Whitelist_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Break_Glass_Whitelist_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Break_Glass_Whitelist_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Break_Glass_Whitelist_Contract_Sum_Fields = {
  __typename?: 'break_glass_whitelist_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "break_glass_whitelist_contract" */
export type Break_Glass_Whitelist_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Break_Glass_Whitelist_Contract_Var_Pop_Fields = {
  __typename?: 'break_glass_whitelist_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "break_glass_whitelist_contract" */
export type Break_Glass_Whitelist_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Break_Glass_Whitelist_Contract_Var_Samp_Fields = {
  __typename?: 'break_glass_whitelist_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "break_glass_whitelist_contract" */
export type Break_Glass_Whitelist_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Break_Glass_Whitelist_Contract_Variance_Fields = {
  __typename?: 'break_glass_whitelist_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "break_glass_whitelist_contract" */
export type Break_Glass_Whitelist_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "council" */
export type Council = {
  __typename?: 'council';
  action_counter: Scalars['bigint']['output'];
  action_expiry_days: Scalars['bigint']['output'];
  /** An array relationship */
  actions: Array<Council_Action>;
  /** An aggregate relationship */
  actions_aggregate: Council_Action_Aggregate;
  address: Scalars['String']['output'];
  admin: Scalars['String']['output'];
  council_member_image_max_length: Scalars['smallint']['output'];
  council_member_name_max_length: Scalars['smallint']['output'];
  council_member_website_max_length: Scalars['smallint']['output'];
  council_size: Scalars['smallint']['output'];
  /** An array relationship */
  general_contracts: Array<Council_General_Contract>;
  /** An aggregate relationship */
  general_contracts_aggregate: Council_General_Contract_Aggregate;
  /** An object relationship */
  governance: Governance;
  governance_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An array relationship */
  lambdas: Array<Council_Lambda>;
  /** An aggregate relationship */
  lambdas_aggregate: Council_Lambda_Aggregate;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  members: Array<Council_Council_Member>;
  /** An aggregate relationship */
  members_aggregate: Council_Council_Member_Aggregate;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  network: Scalars['String']['output'];
  request_purpose_max_length: Scalars['smallint']['output'];
  request_token_name_max_length: Scalars['smallint']['output'];
  threshold: Scalars['bigint']['output'];
  /** An array relationship */
  whitelist_contracts: Array<Council_Whitelist_Contract>;
  /** An aggregate relationship */
  whitelist_contracts_aggregate: Council_Whitelist_Contract_Aggregate;
};


/** columns and relationships of "council" */
export type CouncilActionsArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Order_By>>;
  where?: InputMaybe<Council_Action_Bool_Exp>;
};


/** columns and relationships of "council" */
export type CouncilActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Order_By>>;
  where?: InputMaybe<Council_Action_Bool_Exp>;
};


/** columns and relationships of "council" */
export type CouncilGeneral_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Council_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_General_Contract_Order_By>>;
  where?: InputMaybe<Council_General_Contract_Bool_Exp>;
};


/** columns and relationships of "council" */
export type CouncilGeneral_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_General_Contract_Order_By>>;
  where?: InputMaybe<Council_General_Contract_Bool_Exp>;
};


/** columns and relationships of "council" */
export type CouncilLambdasArgs = {
  distinct_on?: InputMaybe<Array<Council_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Lambda_Order_By>>;
  where?: InputMaybe<Council_Lambda_Bool_Exp>;
};


/** columns and relationships of "council" */
export type CouncilLambdas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Lambda_Order_By>>;
  where?: InputMaybe<Council_Lambda_Bool_Exp>;
};


/** columns and relationships of "council" */
export type CouncilMembersArgs = {
  distinct_on?: InputMaybe<Array<Council_Council_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Council_Member_Order_By>>;
  where?: InputMaybe<Council_Council_Member_Bool_Exp>;
};


/** columns and relationships of "council" */
export type CouncilMembers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Council_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Council_Member_Order_By>>;
  where?: InputMaybe<Council_Council_Member_Bool_Exp>;
};


/** columns and relationships of "council" */
export type CouncilMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "council" */
export type CouncilWhitelist_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Council_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Council_Whitelist_Contract_Bool_Exp>;
};


/** columns and relationships of "council" */
export type CouncilWhitelist_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Council_Whitelist_Contract_Bool_Exp>;
};

/** columns and relationships of "council_action" */
export type Council_Action = {
  __typename?: 'council_action';
  action_type: Scalars['String']['output'];
  /** An object relationship */
  council: Council;
  council_id: Scalars['bigint']['output'];
  council_size_snapshot: Scalars['smallint']['output'];
  executed: Scalars['Boolean']['output'];
  execution_datetime?: Maybe<Scalars['timestamptz']['output']>;
  execution_level?: Maybe<Scalars['bigint']['output']>;
  expiration_datetime: Scalars['timestamptz']['output'];
  flushed_datetime?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bigint']['output'];
  /** An object relationship */
  initiator: Maven_User;
  initiator_id: Scalars['bigint']['output'];
  internal_id: Scalars['bigint']['output'];
  /** An array relationship */
  parameters: Array<Council_Action_Parameter>;
  /** An aggregate relationship */
  parameters_aggregate: Council_Action_Parameter_Aggregate;
  registered_threshold: Scalars['smallint']['output'];
  /** An array relationship */
  signers: Array<Council_Action_Signer>;
  /** An aggregate relationship */
  signers_aggregate: Council_Action_Signer_Aggregate;
  signers_count: Scalars['smallint']['output'];
  start_datetime: Scalars['timestamptz']['output'];
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status: Scalars['smallint']['output'];
  /** An array relationship */
  temp_member_parameters: Array<Council_Action_Temp_Parameter>;
  /** An aggregate relationship */
  temp_member_parameters_aggregate: Council_Action_Temp_Parameter_Aggregate;
};


/** columns and relationships of "council_action" */
export type Council_ActionParametersArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Parameter_Order_By>>;
  where?: InputMaybe<Council_Action_Parameter_Bool_Exp>;
};


/** columns and relationships of "council_action" */
export type Council_ActionParameters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Parameter_Order_By>>;
  where?: InputMaybe<Council_Action_Parameter_Bool_Exp>;
};


/** columns and relationships of "council_action" */
export type Council_ActionSignersArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Signer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Signer_Order_By>>;
  where?: InputMaybe<Council_Action_Signer_Bool_Exp>;
};


/** columns and relationships of "council_action" */
export type Council_ActionSigners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Signer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Signer_Order_By>>;
  where?: InputMaybe<Council_Action_Signer_Bool_Exp>;
};


/** columns and relationships of "council_action" */
export type Council_ActionTemp_Member_ParametersArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Temp_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Temp_Parameter_Order_By>>;
  where?: InputMaybe<Council_Action_Temp_Parameter_Bool_Exp>;
};


/** columns and relationships of "council_action" */
export type Council_ActionTemp_Member_Parameters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Temp_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Temp_Parameter_Order_By>>;
  where?: InputMaybe<Council_Action_Temp_Parameter_Bool_Exp>;
};

/** aggregated selection of "council_action" */
export type Council_Action_Aggregate = {
  __typename?: 'council_action_aggregate';
  aggregate?: Maybe<Council_Action_Aggregate_Fields>;
  nodes: Array<Council_Action>;
};

export type Council_Action_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Council_Action_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Council_Action_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Council_Action_Aggregate_Bool_Exp_Count>;
};

export type Council_Action_Aggregate_Bool_Exp_Bool_And = {
  arguments: Council_Action_Select_Column_Council_Action_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Council_Action_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Council_Action_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Council_Action_Select_Column_Council_Action_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Council_Action_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Council_Action_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Council_Action_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Council_Action_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "council_action" */
export type Council_Action_Aggregate_Fields = {
  __typename?: 'council_action_aggregate_fields';
  avg?: Maybe<Council_Action_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Council_Action_Max_Fields>;
  min?: Maybe<Council_Action_Min_Fields>;
  stddev?: Maybe<Council_Action_Stddev_Fields>;
  stddev_pop?: Maybe<Council_Action_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Council_Action_Stddev_Samp_Fields>;
  sum?: Maybe<Council_Action_Sum_Fields>;
  var_pop?: Maybe<Council_Action_Var_Pop_Fields>;
  var_samp?: Maybe<Council_Action_Var_Samp_Fields>;
  variance?: Maybe<Council_Action_Variance_Fields>;
};


/** aggregate fields of "council_action" */
export type Council_Action_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Council_Action_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "council_action" */
export type Council_Action_Aggregate_Order_By = {
  avg?: InputMaybe<Council_Action_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Council_Action_Max_Order_By>;
  min?: InputMaybe<Council_Action_Min_Order_By>;
  stddev?: InputMaybe<Council_Action_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Council_Action_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Council_Action_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Council_Action_Sum_Order_By>;
  var_pop?: InputMaybe<Council_Action_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Council_Action_Var_Samp_Order_By>;
  variance?: InputMaybe<Council_Action_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Council_Action_Avg_Fields = {
  __typename?: 'council_action_avg_fields';
  council_id?: Maybe<Scalars['Float']['output']>;
  council_size_snapshot?: Maybe<Scalars['Float']['output']>;
  execution_level?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initiator_id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  registered_threshold?: Maybe<Scalars['Float']['output']>;
  signers_count?: Maybe<Scalars['Float']['output']>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "council_action" */
export type Council_Action_Avg_Order_By = {
  council_id?: InputMaybe<Order_By>;
  council_size_snapshot?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  registered_threshold?: InputMaybe<Order_By>;
  signers_count?: InputMaybe<Order_By>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "council_action". All fields are combined with a logical 'AND'. */
export type Council_Action_Bool_Exp = {
  _and?: InputMaybe<Array<Council_Action_Bool_Exp>>;
  _not?: InputMaybe<Council_Action_Bool_Exp>;
  _or?: InputMaybe<Array<Council_Action_Bool_Exp>>;
  action_type?: InputMaybe<String_Comparison_Exp>;
  council?: InputMaybe<Council_Bool_Exp>;
  council_id?: InputMaybe<Bigint_Comparison_Exp>;
  council_size_snapshot?: InputMaybe<Smallint_Comparison_Exp>;
  executed?: InputMaybe<Boolean_Comparison_Exp>;
  execution_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  execution_level?: InputMaybe<Bigint_Comparison_Exp>;
  expiration_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  flushed_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  initiator?: InputMaybe<Maven_User_Bool_Exp>;
  initiator_id?: InputMaybe<Bigint_Comparison_Exp>;
  internal_id?: InputMaybe<Bigint_Comparison_Exp>;
  parameters?: InputMaybe<Council_Action_Parameter_Bool_Exp>;
  parameters_aggregate?: InputMaybe<Council_Action_Parameter_Aggregate_Bool_Exp>;
  registered_threshold?: InputMaybe<Smallint_Comparison_Exp>;
  signers?: InputMaybe<Council_Action_Signer_Bool_Exp>;
  signers_aggregate?: InputMaybe<Council_Action_Signer_Aggregate_Bool_Exp>;
  signers_count?: InputMaybe<Smallint_Comparison_Exp>;
  start_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<Smallint_Comparison_Exp>;
  temp_member_parameters?: InputMaybe<Council_Action_Temp_Parameter_Bool_Exp>;
  temp_member_parameters_aggregate?: InputMaybe<Council_Action_Temp_Parameter_Aggregate_Bool_Exp>;
};

/** aggregate max on columns */
export type Council_Action_Max_Fields = {
  __typename?: 'council_action_max_fields';
  action_type?: Maybe<Scalars['String']['output']>;
  council_id?: Maybe<Scalars['bigint']['output']>;
  council_size_snapshot?: Maybe<Scalars['smallint']['output']>;
  execution_datetime?: Maybe<Scalars['timestamptz']['output']>;
  execution_level?: Maybe<Scalars['bigint']['output']>;
  expiration_datetime?: Maybe<Scalars['timestamptz']['output']>;
  flushed_datetime?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  initiator_id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['bigint']['output']>;
  registered_threshold?: Maybe<Scalars['smallint']['output']>;
  signers_count?: Maybe<Scalars['smallint']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: Maybe<Scalars['smallint']['output']>;
};

/** order by max() on columns of table "council_action" */
export type Council_Action_Max_Order_By = {
  action_type?: InputMaybe<Order_By>;
  council_id?: InputMaybe<Order_By>;
  council_size_snapshot?: InputMaybe<Order_By>;
  execution_datetime?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  expiration_datetime?: InputMaybe<Order_By>;
  flushed_datetime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  registered_threshold?: InputMaybe<Order_By>;
  signers_count?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Council_Action_Min_Fields = {
  __typename?: 'council_action_min_fields';
  action_type?: Maybe<Scalars['String']['output']>;
  council_id?: Maybe<Scalars['bigint']['output']>;
  council_size_snapshot?: Maybe<Scalars['smallint']['output']>;
  execution_datetime?: Maybe<Scalars['timestamptz']['output']>;
  execution_level?: Maybe<Scalars['bigint']['output']>;
  expiration_datetime?: Maybe<Scalars['timestamptz']['output']>;
  flushed_datetime?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  initiator_id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['bigint']['output']>;
  registered_threshold?: Maybe<Scalars['smallint']['output']>;
  signers_count?: Maybe<Scalars['smallint']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: Maybe<Scalars['smallint']['output']>;
};

/** order by min() on columns of table "council_action" */
export type Council_Action_Min_Order_By = {
  action_type?: InputMaybe<Order_By>;
  council_id?: InputMaybe<Order_By>;
  council_size_snapshot?: InputMaybe<Order_By>;
  execution_datetime?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  expiration_datetime?: InputMaybe<Order_By>;
  flushed_datetime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  registered_threshold?: InputMaybe<Order_By>;
  signers_count?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "council_action". */
export type Council_Action_Order_By = {
  action_type?: InputMaybe<Order_By>;
  council?: InputMaybe<Council_Order_By>;
  council_id?: InputMaybe<Order_By>;
  council_size_snapshot?: InputMaybe<Order_By>;
  executed?: InputMaybe<Order_By>;
  execution_datetime?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  expiration_datetime?: InputMaybe<Order_By>;
  flushed_datetime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator?: InputMaybe<Maven_User_Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  parameters_aggregate?: InputMaybe<Council_Action_Parameter_Aggregate_Order_By>;
  registered_threshold?: InputMaybe<Order_By>;
  signers_aggregate?: InputMaybe<Council_Action_Signer_Aggregate_Order_By>;
  signers_count?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  temp_member_parameters_aggregate?: InputMaybe<Council_Action_Temp_Parameter_Aggregate_Order_By>;
};

/** columns and relationships of "council_action_parameter" */
export type Council_Action_Parameter = {
  __typename?: 'council_action_parameter';
  /** An object relationship */
  council_action: Council_Action;
  council_action_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "council_action_parameter" */
export type Council_Action_Parameter_Aggregate = {
  __typename?: 'council_action_parameter_aggregate';
  aggregate?: Maybe<Council_Action_Parameter_Aggregate_Fields>;
  nodes: Array<Council_Action_Parameter>;
};

export type Council_Action_Parameter_Aggregate_Bool_Exp = {
  count?: InputMaybe<Council_Action_Parameter_Aggregate_Bool_Exp_Count>;
};

export type Council_Action_Parameter_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Council_Action_Parameter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Council_Action_Parameter_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "council_action_parameter" */
export type Council_Action_Parameter_Aggregate_Fields = {
  __typename?: 'council_action_parameter_aggregate_fields';
  avg?: Maybe<Council_Action_Parameter_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Council_Action_Parameter_Max_Fields>;
  min?: Maybe<Council_Action_Parameter_Min_Fields>;
  stddev?: Maybe<Council_Action_Parameter_Stddev_Fields>;
  stddev_pop?: Maybe<Council_Action_Parameter_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Council_Action_Parameter_Stddev_Samp_Fields>;
  sum?: Maybe<Council_Action_Parameter_Sum_Fields>;
  var_pop?: Maybe<Council_Action_Parameter_Var_Pop_Fields>;
  var_samp?: Maybe<Council_Action_Parameter_Var_Samp_Fields>;
  variance?: Maybe<Council_Action_Parameter_Variance_Fields>;
};


/** aggregate fields of "council_action_parameter" */
export type Council_Action_Parameter_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Council_Action_Parameter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "council_action_parameter" */
export type Council_Action_Parameter_Aggregate_Order_By = {
  avg?: InputMaybe<Council_Action_Parameter_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Council_Action_Parameter_Max_Order_By>;
  min?: InputMaybe<Council_Action_Parameter_Min_Order_By>;
  stddev?: InputMaybe<Council_Action_Parameter_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Council_Action_Parameter_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Council_Action_Parameter_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Council_Action_Parameter_Sum_Order_By>;
  var_pop?: InputMaybe<Council_Action_Parameter_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Council_Action_Parameter_Var_Samp_Order_By>;
  variance?: InputMaybe<Council_Action_Parameter_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Council_Action_Parameter_Avg_Fields = {
  __typename?: 'council_action_parameter_avg_fields';
  council_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "council_action_parameter" */
export type Council_Action_Parameter_Avg_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "council_action_parameter". All fields are combined with a logical 'AND'. */
export type Council_Action_Parameter_Bool_Exp = {
  _and?: InputMaybe<Array<Council_Action_Parameter_Bool_Exp>>;
  _not?: InputMaybe<Council_Action_Parameter_Bool_Exp>;
  _or?: InputMaybe<Array<Council_Action_Parameter_Bool_Exp>>;
  council_action?: InputMaybe<Council_Action_Bool_Exp>;
  council_action_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Council_Action_Parameter_Max_Fields = {
  __typename?: 'council_action_parameter_max_fields';
  council_action_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "council_action_parameter" */
export type Council_Action_Parameter_Max_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Council_Action_Parameter_Min_Fields = {
  __typename?: 'council_action_parameter_min_fields';
  council_action_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "council_action_parameter" */
export type Council_Action_Parameter_Min_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "council_action_parameter". */
export type Council_Action_Parameter_Order_By = {
  council_action?: InputMaybe<Council_Action_Order_By>;
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "council_action_parameter" */
export enum Council_Action_Parameter_Select_Column {
  /** column name */
  CouncilActionId = 'council_action_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Value = 'value'
}

/** aggregate stddev on columns */
export type Council_Action_Parameter_Stddev_Fields = {
  __typename?: 'council_action_parameter_stddev_fields';
  council_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "council_action_parameter" */
export type Council_Action_Parameter_Stddev_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Council_Action_Parameter_Stddev_Pop_Fields = {
  __typename?: 'council_action_parameter_stddev_pop_fields';
  council_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "council_action_parameter" */
export type Council_Action_Parameter_Stddev_Pop_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Council_Action_Parameter_Stddev_Samp_Fields = {
  __typename?: 'council_action_parameter_stddev_samp_fields';
  council_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "council_action_parameter" */
export type Council_Action_Parameter_Stddev_Samp_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "council_action_parameter" */
export type Council_Action_Parameter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Council_Action_Parameter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Council_Action_Parameter_Stream_Cursor_Value_Input = {
  council_action_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Council_Action_Parameter_Sum_Fields = {
  __typename?: 'council_action_parameter_sum_fields';
  council_action_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "council_action_parameter" */
export type Council_Action_Parameter_Sum_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Council_Action_Parameter_Var_Pop_Fields = {
  __typename?: 'council_action_parameter_var_pop_fields';
  council_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "council_action_parameter" */
export type Council_Action_Parameter_Var_Pop_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Council_Action_Parameter_Var_Samp_Fields = {
  __typename?: 'council_action_parameter_var_samp_fields';
  council_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "council_action_parameter" */
export type Council_Action_Parameter_Var_Samp_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Council_Action_Parameter_Variance_Fields = {
  __typename?: 'council_action_parameter_variance_fields';
  council_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "council_action_parameter" */
export type Council_Action_Parameter_Variance_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "council_action" */
export enum Council_Action_Select_Column {
  /** column name */
  ActionType = 'action_type',
  /** column name */
  CouncilId = 'council_id',
  /** column name */
  CouncilSizeSnapshot = 'council_size_snapshot',
  /** column name */
  Executed = 'executed',
  /** column name */
  ExecutionDatetime = 'execution_datetime',
  /** column name */
  ExecutionLevel = 'execution_level',
  /** column name */
  ExpirationDatetime = 'expiration_datetime',
  /** column name */
  FlushedDatetime = 'flushed_datetime',
  /** column name */
  Id = 'id',
  /** column name */
  InitiatorId = 'initiator_id',
  /** column name */
  InternalId = 'internal_id',
  /** column name */
  RegisteredThreshold = 'registered_threshold',
  /** column name */
  SignersCount = 'signers_count',
  /** column name */
  StartDatetime = 'start_datetime',
  /** column name */
  Status = 'status'
}

/** select "council_action_aggregate_bool_exp_bool_and_arguments_columns" columns of table "council_action" */
export enum Council_Action_Select_Column_Council_Action_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Executed = 'executed'
}

/** select "council_action_aggregate_bool_exp_bool_or_arguments_columns" columns of table "council_action" */
export enum Council_Action_Select_Column_Council_Action_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Executed = 'executed'
}

/** columns and relationships of "council_action_signer" */
export type Council_Action_Signer = {
  __typename?: 'council_action_signer';
  /** An object relationship */
  council_action: Council_Action;
  council_action_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  signer: Maven_User;
  signer_id: Scalars['bigint']['output'];
};

/** aggregated selection of "council_action_signer" */
export type Council_Action_Signer_Aggregate = {
  __typename?: 'council_action_signer_aggregate';
  aggregate?: Maybe<Council_Action_Signer_Aggregate_Fields>;
  nodes: Array<Council_Action_Signer>;
};

export type Council_Action_Signer_Aggregate_Bool_Exp = {
  count?: InputMaybe<Council_Action_Signer_Aggregate_Bool_Exp_Count>;
};

export type Council_Action_Signer_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Council_Action_Signer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Council_Action_Signer_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "council_action_signer" */
export type Council_Action_Signer_Aggregate_Fields = {
  __typename?: 'council_action_signer_aggregate_fields';
  avg?: Maybe<Council_Action_Signer_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Council_Action_Signer_Max_Fields>;
  min?: Maybe<Council_Action_Signer_Min_Fields>;
  stddev?: Maybe<Council_Action_Signer_Stddev_Fields>;
  stddev_pop?: Maybe<Council_Action_Signer_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Council_Action_Signer_Stddev_Samp_Fields>;
  sum?: Maybe<Council_Action_Signer_Sum_Fields>;
  var_pop?: Maybe<Council_Action_Signer_Var_Pop_Fields>;
  var_samp?: Maybe<Council_Action_Signer_Var_Samp_Fields>;
  variance?: Maybe<Council_Action_Signer_Variance_Fields>;
};


/** aggregate fields of "council_action_signer" */
export type Council_Action_Signer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Council_Action_Signer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "council_action_signer" */
export type Council_Action_Signer_Aggregate_Order_By = {
  avg?: InputMaybe<Council_Action_Signer_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Council_Action_Signer_Max_Order_By>;
  min?: InputMaybe<Council_Action_Signer_Min_Order_By>;
  stddev?: InputMaybe<Council_Action_Signer_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Council_Action_Signer_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Council_Action_Signer_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Council_Action_Signer_Sum_Order_By>;
  var_pop?: InputMaybe<Council_Action_Signer_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Council_Action_Signer_Var_Samp_Order_By>;
  variance?: InputMaybe<Council_Action_Signer_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Council_Action_Signer_Avg_Fields = {
  __typename?: 'council_action_signer_avg_fields';
  council_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  signer_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "council_action_signer" */
export type Council_Action_Signer_Avg_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signer_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "council_action_signer". All fields are combined with a logical 'AND'. */
export type Council_Action_Signer_Bool_Exp = {
  _and?: InputMaybe<Array<Council_Action_Signer_Bool_Exp>>;
  _not?: InputMaybe<Council_Action_Signer_Bool_Exp>;
  _or?: InputMaybe<Array<Council_Action_Signer_Bool_Exp>>;
  council_action?: InputMaybe<Council_Action_Bool_Exp>;
  council_action_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  signer?: InputMaybe<Maven_User_Bool_Exp>;
  signer_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Council_Action_Signer_Max_Fields = {
  __typename?: 'council_action_signer_max_fields';
  council_action_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  signer_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "council_action_signer" */
export type Council_Action_Signer_Max_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signer_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Council_Action_Signer_Min_Fields = {
  __typename?: 'council_action_signer_min_fields';
  council_action_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  signer_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "council_action_signer" */
export type Council_Action_Signer_Min_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signer_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "council_action_signer". */
export type Council_Action_Signer_Order_By = {
  council_action?: InputMaybe<Council_Action_Order_By>;
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signer?: InputMaybe<Maven_User_Order_By>;
  signer_id?: InputMaybe<Order_By>;
};

/** select columns of table "council_action_signer" */
export enum Council_Action_Signer_Select_Column {
  /** column name */
  CouncilActionId = 'council_action_id',
  /** column name */
  Id = 'id',
  /** column name */
  SignerId = 'signer_id'
}

/** aggregate stddev on columns */
export type Council_Action_Signer_Stddev_Fields = {
  __typename?: 'council_action_signer_stddev_fields';
  council_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  signer_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "council_action_signer" */
export type Council_Action_Signer_Stddev_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signer_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Council_Action_Signer_Stddev_Pop_Fields = {
  __typename?: 'council_action_signer_stddev_pop_fields';
  council_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  signer_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "council_action_signer" */
export type Council_Action_Signer_Stddev_Pop_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signer_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Council_Action_Signer_Stddev_Samp_Fields = {
  __typename?: 'council_action_signer_stddev_samp_fields';
  council_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  signer_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "council_action_signer" */
export type Council_Action_Signer_Stddev_Samp_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signer_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "council_action_signer" */
export type Council_Action_Signer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Council_Action_Signer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Council_Action_Signer_Stream_Cursor_Value_Input = {
  council_action_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  signer_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Council_Action_Signer_Sum_Fields = {
  __typename?: 'council_action_signer_sum_fields';
  council_action_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  signer_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "council_action_signer" */
export type Council_Action_Signer_Sum_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signer_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Council_Action_Signer_Var_Pop_Fields = {
  __typename?: 'council_action_signer_var_pop_fields';
  council_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  signer_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "council_action_signer" */
export type Council_Action_Signer_Var_Pop_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signer_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Council_Action_Signer_Var_Samp_Fields = {
  __typename?: 'council_action_signer_var_samp_fields';
  council_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  signer_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "council_action_signer" */
export type Council_Action_Signer_Var_Samp_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signer_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Council_Action_Signer_Variance_Fields = {
  __typename?: 'council_action_signer_variance_fields';
  council_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  signer_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "council_action_signer" */
export type Council_Action_Signer_Variance_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signer_id?: InputMaybe<Order_By>;
};

/** aggregate stddev on columns */
export type Council_Action_Stddev_Fields = {
  __typename?: 'council_action_stddev_fields';
  council_id?: Maybe<Scalars['Float']['output']>;
  council_size_snapshot?: Maybe<Scalars['Float']['output']>;
  execution_level?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initiator_id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  registered_threshold?: Maybe<Scalars['Float']['output']>;
  signers_count?: Maybe<Scalars['Float']['output']>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "council_action" */
export type Council_Action_Stddev_Order_By = {
  council_id?: InputMaybe<Order_By>;
  council_size_snapshot?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  registered_threshold?: InputMaybe<Order_By>;
  signers_count?: InputMaybe<Order_By>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Council_Action_Stddev_Pop_Fields = {
  __typename?: 'council_action_stddev_pop_fields';
  council_id?: Maybe<Scalars['Float']['output']>;
  council_size_snapshot?: Maybe<Scalars['Float']['output']>;
  execution_level?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initiator_id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  registered_threshold?: Maybe<Scalars['Float']['output']>;
  signers_count?: Maybe<Scalars['Float']['output']>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "council_action" */
export type Council_Action_Stddev_Pop_Order_By = {
  council_id?: InputMaybe<Order_By>;
  council_size_snapshot?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  registered_threshold?: InputMaybe<Order_By>;
  signers_count?: InputMaybe<Order_By>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Council_Action_Stddev_Samp_Fields = {
  __typename?: 'council_action_stddev_samp_fields';
  council_id?: Maybe<Scalars['Float']['output']>;
  council_size_snapshot?: Maybe<Scalars['Float']['output']>;
  execution_level?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initiator_id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  registered_threshold?: Maybe<Scalars['Float']['output']>;
  signers_count?: Maybe<Scalars['Float']['output']>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "council_action" */
export type Council_Action_Stddev_Samp_Order_By = {
  council_id?: InputMaybe<Order_By>;
  council_size_snapshot?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  registered_threshold?: InputMaybe<Order_By>;
  signers_count?: InputMaybe<Order_By>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "council_action" */
export type Council_Action_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Council_Action_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Council_Action_Stream_Cursor_Value_Input = {
  action_type?: InputMaybe<Scalars['String']['input']>;
  council_id?: InputMaybe<Scalars['bigint']['input']>;
  council_size_snapshot?: InputMaybe<Scalars['smallint']['input']>;
  executed?: InputMaybe<Scalars['Boolean']['input']>;
  execution_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  execution_level?: InputMaybe<Scalars['bigint']['input']>;
  expiration_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  flushed_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  initiator_id?: InputMaybe<Scalars['bigint']['input']>;
  internal_id?: InputMaybe<Scalars['bigint']['input']>;
  registered_threshold?: InputMaybe<Scalars['smallint']['input']>;
  signers_count?: InputMaybe<Scalars['smallint']['input']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: InputMaybe<Scalars['smallint']['input']>;
};

/** aggregate sum on columns */
export type Council_Action_Sum_Fields = {
  __typename?: 'council_action_sum_fields';
  council_id?: Maybe<Scalars['bigint']['output']>;
  council_size_snapshot?: Maybe<Scalars['smallint']['output']>;
  execution_level?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  initiator_id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['bigint']['output']>;
  registered_threshold?: Maybe<Scalars['smallint']['output']>;
  signers_count?: Maybe<Scalars['smallint']['output']>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: Maybe<Scalars['smallint']['output']>;
};

/** order by sum() on columns of table "council_action" */
export type Council_Action_Sum_Order_By = {
  council_id?: InputMaybe<Order_By>;
  council_size_snapshot?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  registered_threshold?: InputMaybe<Order_By>;
  signers_count?: InputMaybe<Order_By>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: InputMaybe<Order_By>;
};

/** columns and relationships of "council_action_temp_parameter" */
export type Council_Action_Temp_Parameter = {
  __typename?: 'council_action_temp_parameter';
  /** An object relationship */
  council_action: Council_Action;
  council_action_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  old_council_member_address: Scalars['String']['output'];
};

/** aggregated selection of "council_action_temp_parameter" */
export type Council_Action_Temp_Parameter_Aggregate = {
  __typename?: 'council_action_temp_parameter_aggregate';
  aggregate?: Maybe<Council_Action_Temp_Parameter_Aggregate_Fields>;
  nodes: Array<Council_Action_Temp_Parameter>;
};

export type Council_Action_Temp_Parameter_Aggregate_Bool_Exp = {
  count?: InputMaybe<Council_Action_Temp_Parameter_Aggregate_Bool_Exp_Count>;
};

export type Council_Action_Temp_Parameter_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Council_Action_Temp_Parameter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Council_Action_Temp_Parameter_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "council_action_temp_parameter" */
export type Council_Action_Temp_Parameter_Aggregate_Fields = {
  __typename?: 'council_action_temp_parameter_aggregate_fields';
  avg?: Maybe<Council_Action_Temp_Parameter_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Council_Action_Temp_Parameter_Max_Fields>;
  min?: Maybe<Council_Action_Temp_Parameter_Min_Fields>;
  stddev?: Maybe<Council_Action_Temp_Parameter_Stddev_Fields>;
  stddev_pop?: Maybe<Council_Action_Temp_Parameter_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Council_Action_Temp_Parameter_Stddev_Samp_Fields>;
  sum?: Maybe<Council_Action_Temp_Parameter_Sum_Fields>;
  var_pop?: Maybe<Council_Action_Temp_Parameter_Var_Pop_Fields>;
  var_samp?: Maybe<Council_Action_Temp_Parameter_Var_Samp_Fields>;
  variance?: Maybe<Council_Action_Temp_Parameter_Variance_Fields>;
};


/** aggregate fields of "council_action_temp_parameter" */
export type Council_Action_Temp_Parameter_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Council_Action_Temp_Parameter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "council_action_temp_parameter" */
export type Council_Action_Temp_Parameter_Aggregate_Order_By = {
  avg?: InputMaybe<Council_Action_Temp_Parameter_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Council_Action_Temp_Parameter_Max_Order_By>;
  min?: InputMaybe<Council_Action_Temp_Parameter_Min_Order_By>;
  stddev?: InputMaybe<Council_Action_Temp_Parameter_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Council_Action_Temp_Parameter_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Council_Action_Temp_Parameter_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Council_Action_Temp_Parameter_Sum_Order_By>;
  var_pop?: InputMaybe<Council_Action_Temp_Parameter_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Council_Action_Temp_Parameter_Var_Samp_Order_By>;
  variance?: InputMaybe<Council_Action_Temp_Parameter_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Council_Action_Temp_Parameter_Avg_Fields = {
  __typename?: 'council_action_temp_parameter_avg_fields';
  council_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "council_action_temp_parameter" */
export type Council_Action_Temp_Parameter_Avg_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "council_action_temp_parameter". All fields are combined with a logical 'AND'. */
export type Council_Action_Temp_Parameter_Bool_Exp = {
  _and?: InputMaybe<Array<Council_Action_Temp_Parameter_Bool_Exp>>;
  _not?: InputMaybe<Council_Action_Temp_Parameter_Bool_Exp>;
  _or?: InputMaybe<Array<Council_Action_Temp_Parameter_Bool_Exp>>;
  council_action?: InputMaybe<Council_Action_Bool_Exp>;
  council_action_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  old_council_member_address?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Council_Action_Temp_Parameter_Max_Fields = {
  __typename?: 'council_action_temp_parameter_max_fields';
  council_action_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  old_council_member_address?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "council_action_temp_parameter" */
export type Council_Action_Temp_Parameter_Max_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_council_member_address?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Council_Action_Temp_Parameter_Min_Fields = {
  __typename?: 'council_action_temp_parameter_min_fields';
  council_action_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  old_council_member_address?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "council_action_temp_parameter" */
export type Council_Action_Temp_Parameter_Min_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_council_member_address?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "council_action_temp_parameter". */
export type Council_Action_Temp_Parameter_Order_By = {
  council_action?: InputMaybe<Council_Action_Order_By>;
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_council_member_address?: InputMaybe<Order_By>;
};

/** select columns of table "council_action_temp_parameter" */
export enum Council_Action_Temp_Parameter_Select_Column {
  /** column name */
  CouncilActionId = 'council_action_id',
  /** column name */
  Id = 'id',
  /** column name */
  OldCouncilMemberAddress = 'old_council_member_address'
}

/** aggregate stddev on columns */
export type Council_Action_Temp_Parameter_Stddev_Fields = {
  __typename?: 'council_action_temp_parameter_stddev_fields';
  council_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "council_action_temp_parameter" */
export type Council_Action_Temp_Parameter_Stddev_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Council_Action_Temp_Parameter_Stddev_Pop_Fields = {
  __typename?: 'council_action_temp_parameter_stddev_pop_fields';
  council_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "council_action_temp_parameter" */
export type Council_Action_Temp_Parameter_Stddev_Pop_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Council_Action_Temp_Parameter_Stddev_Samp_Fields = {
  __typename?: 'council_action_temp_parameter_stddev_samp_fields';
  council_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "council_action_temp_parameter" */
export type Council_Action_Temp_Parameter_Stddev_Samp_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "council_action_temp_parameter" */
export type Council_Action_Temp_Parameter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Council_Action_Temp_Parameter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Council_Action_Temp_Parameter_Stream_Cursor_Value_Input = {
  council_action_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  old_council_member_address?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Council_Action_Temp_Parameter_Sum_Fields = {
  __typename?: 'council_action_temp_parameter_sum_fields';
  council_action_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "council_action_temp_parameter" */
export type Council_Action_Temp_Parameter_Sum_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Council_Action_Temp_Parameter_Var_Pop_Fields = {
  __typename?: 'council_action_temp_parameter_var_pop_fields';
  council_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "council_action_temp_parameter" */
export type Council_Action_Temp_Parameter_Var_Pop_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Council_Action_Temp_Parameter_Var_Samp_Fields = {
  __typename?: 'council_action_temp_parameter_var_samp_fields';
  council_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "council_action_temp_parameter" */
export type Council_Action_Temp_Parameter_Var_Samp_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Council_Action_Temp_Parameter_Variance_Fields = {
  __typename?: 'council_action_temp_parameter_variance_fields';
  council_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "council_action_temp_parameter" */
export type Council_Action_Temp_Parameter_Variance_Order_By = {
  council_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Council_Action_Var_Pop_Fields = {
  __typename?: 'council_action_var_pop_fields';
  council_id?: Maybe<Scalars['Float']['output']>;
  council_size_snapshot?: Maybe<Scalars['Float']['output']>;
  execution_level?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initiator_id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  registered_threshold?: Maybe<Scalars['Float']['output']>;
  signers_count?: Maybe<Scalars['Float']['output']>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "council_action" */
export type Council_Action_Var_Pop_Order_By = {
  council_id?: InputMaybe<Order_By>;
  council_size_snapshot?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  registered_threshold?: InputMaybe<Order_By>;
  signers_count?: InputMaybe<Order_By>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Council_Action_Var_Samp_Fields = {
  __typename?: 'council_action_var_samp_fields';
  council_id?: Maybe<Scalars['Float']['output']>;
  council_size_snapshot?: Maybe<Scalars['Float']['output']>;
  execution_level?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initiator_id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  registered_threshold?: Maybe<Scalars['Float']['output']>;
  signers_count?: Maybe<Scalars['Float']['output']>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "council_action" */
export type Council_Action_Var_Samp_Order_By = {
  council_id?: InputMaybe<Order_By>;
  council_size_snapshot?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  registered_threshold?: InputMaybe<Order_By>;
  signers_count?: InputMaybe<Order_By>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Council_Action_Variance_Fields = {
  __typename?: 'council_action_variance_fields';
  council_id?: Maybe<Scalars['Float']['output']>;
  council_size_snapshot?: Maybe<Scalars['Float']['output']>;
  execution_level?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initiator_id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  registered_threshold?: Maybe<Scalars['Float']['output']>;
  signers_count?: Maybe<Scalars['Float']['output']>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "council_action" */
export type Council_Action_Variance_Order_By = {
  council_id?: InputMaybe<Order_By>;
  council_size_snapshot?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  registered_threshold?: InputMaybe<Order_By>;
  signers_count?: InputMaybe<Order_By>;
  /** PENDING: 0\nFLUSHED: 1\nEXECUTED: 2 */
  status?: InputMaybe<Order_By>;
};

/** aggregated selection of "council" */
export type Council_Aggregate = {
  __typename?: 'council_aggregate';
  aggregate?: Maybe<Council_Aggregate_Fields>;
  nodes: Array<Council>;
};

export type Council_Aggregate_Bool_Exp = {
  count?: InputMaybe<Council_Aggregate_Bool_Exp_Count>;
};

export type Council_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Council_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Council_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "council" */
export type Council_Aggregate_Fields = {
  __typename?: 'council_aggregate_fields';
  avg?: Maybe<Council_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Council_Max_Fields>;
  min?: Maybe<Council_Min_Fields>;
  stddev?: Maybe<Council_Stddev_Fields>;
  stddev_pop?: Maybe<Council_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Council_Stddev_Samp_Fields>;
  sum?: Maybe<Council_Sum_Fields>;
  var_pop?: Maybe<Council_Var_Pop_Fields>;
  var_samp?: Maybe<Council_Var_Samp_Fields>;
  variance?: Maybe<Council_Variance_Fields>;
};


/** aggregate fields of "council" */
export type Council_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Council_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "council" */
export type Council_Aggregate_Order_By = {
  avg?: InputMaybe<Council_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Council_Max_Order_By>;
  min?: InputMaybe<Council_Min_Order_By>;
  stddev?: InputMaybe<Council_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Council_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Council_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Council_Sum_Order_By>;
  var_pop?: InputMaybe<Council_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Council_Var_Samp_Order_By>;
  variance?: InputMaybe<Council_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Council_Avg_Fields = {
  __typename?: 'council_avg_fields';
  action_counter?: Maybe<Scalars['Float']['output']>;
  action_expiry_days?: Maybe<Scalars['Float']['output']>;
  council_member_image_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_name_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_website_max_length?: Maybe<Scalars['Float']['output']>;
  council_size?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  request_purpose_max_length?: Maybe<Scalars['Float']['output']>;
  request_token_name_max_length?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "council" */
export type Council_Avg_Order_By = {
  action_counter?: InputMaybe<Order_By>;
  action_expiry_days?: InputMaybe<Order_By>;
  council_member_image_max_length?: InputMaybe<Order_By>;
  council_member_name_max_length?: InputMaybe<Order_By>;
  council_member_website_max_length?: InputMaybe<Order_By>;
  council_size?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_purpose_max_length?: InputMaybe<Order_By>;
  request_token_name_max_length?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "council". All fields are combined with a logical 'AND'. */
export type Council_Bool_Exp = {
  _and?: InputMaybe<Array<Council_Bool_Exp>>;
  _not?: InputMaybe<Council_Bool_Exp>;
  _or?: InputMaybe<Array<Council_Bool_Exp>>;
  action_counter?: InputMaybe<Bigint_Comparison_Exp>;
  action_expiry_days?: InputMaybe<Bigint_Comparison_Exp>;
  actions?: InputMaybe<Council_Action_Bool_Exp>;
  actions_aggregate?: InputMaybe<Council_Action_Aggregate_Bool_Exp>;
  address?: InputMaybe<String_Comparison_Exp>;
  admin?: InputMaybe<String_Comparison_Exp>;
  council_member_image_max_length?: InputMaybe<Smallint_Comparison_Exp>;
  council_member_name_max_length?: InputMaybe<Smallint_Comparison_Exp>;
  council_member_website_max_length?: InputMaybe<Smallint_Comparison_Exp>;
  council_size?: InputMaybe<Smallint_Comparison_Exp>;
  general_contracts?: InputMaybe<Council_General_Contract_Bool_Exp>;
  general_contracts_aggregate?: InputMaybe<Council_General_Contract_Aggregate_Bool_Exp>;
  governance?: InputMaybe<Governance_Bool_Exp>;
  governance_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambdas?: InputMaybe<Council_Lambda_Bool_Exp>;
  lambdas_aggregate?: InputMaybe<Council_Lambda_Aggregate_Bool_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  members?: InputMaybe<Council_Council_Member_Bool_Exp>;
  members_aggregate?: InputMaybe<Council_Council_Member_Aggregate_Bool_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
  request_purpose_max_length?: InputMaybe<Smallint_Comparison_Exp>;
  request_token_name_max_length?: InputMaybe<Smallint_Comparison_Exp>;
  threshold?: InputMaybe<Bigint_Comparison_Exp>;
  whitelist_contracts?: InputMaybe<Council_Whitelist_Contract_Bool_Exp>;
  whitelist_contracts_aggregate?: InputMaybe<Council_Whitelist_Contract_Aggregate_Bool_Exp>;
};

/** columns and relationships of "council_council_member" */
export type Council_Council_Member = {
  __typename?: 'council_council_member';
  /** An object relationship */
  council: Council;
  council_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  user: Maven_User;
  user_id: Scalars['bigint']['output'];
  website: Scalars['String']['output'];
};

/** aggregated selection of "council_council_member" */
export type Council_Council_Member_Aggregate = {
  __typename?: 'council_council_member_aggregate';
  aggregate?: Maybe<Council_Council_Member_Aggregate_Fields>;
  nodes: Array<Council_Council_Member>;
};

export type Council_Council_Member_Aggregate_Bool_Exp = {
  count?: InputMaybe<Council_Council_Member_Aggregate_Bool_Exp_Count>;
};

export type Council_Council_Member_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Council_Council_Member_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Council_Council_Member_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "council_council_member" */
export type Council_Council_Member_Aggregate_Fields = {
  __typename?: 'council_council_member_aggregate_fields';
  avg?: Maybe<Council_Council_Member_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Council_Council_Member_Max_Fields>;
  min?: Maybe<Council_Council_Member_Min_Fields>;
  stddev?: Maybe<Council_Council_Member_Stddev_Fields>;
  stddev_pop?: Maybe<Council_Council_Member_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Council_Council_Member_Stddev_Samp_Fields>;
  sum?: Maybe<Council_Council_Member_Sum_Fields>;
  var_pop?: Maybe<Council_Council_Member_Var_Pop_Fields>;
  var_samp?: Maybe<Council_Council_Member_Var_Samp_Fields>;
  variance?: Maybe<Council_Council_Member_Variance_Fields>;
};


/** aggregate fields of "council_council_member" */
export type Council_Council_Member_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Council_Council_Member_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "council_council_member" */
export type Council_Council_Member_Aggregate_Order_By = {
  avg?: InputMaybe<Council_Council_Member_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Council_Council_Member_Max_Order_By>;
  min?: InputMaybe<Council_Council_Member_Min_Order_By>;
  stddev?: InputMaybe<Council_Council_Member_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Council_Council_Member_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Council_Council_Member_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Council_Council_Member_Sum_Order_By>;
  var_pop?: InputMaybe<Council_Council_Member_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Council_Council_Member_Var_Samp_Order_By>;
  variance?: InputMaybe<Council_Council_Member_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Council_Council_Member_Avg_Fields = {
  __typename?: 'council_council_member_avg_fields';
  council_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "council_council_member" */
export type Council_Council_Member_Avg_Order_By = {
  council_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "council_council_member". All fields are combined with a logical 'AND'. */
export type Council_Council_Member_Bool_Exp = {
  _and?: InputMaybe<Array<Council_Council_Member_Bool_Exp>>;
  _not?: InputMaybe<Council_Council_Member_Bool_Exp>;
  _or?: InputMaybe<Array<Council_Council_Member_Bool_Exp>>;
  council?: InputMaybe<Council_Bool_Exp>;
  council_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  image?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Maven_User_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
  website?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Council_Council_Member_Max_Fields = {
  __typename?: 'council_council_member_max_fields';
  council_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "council_council_member" */
export type Council_Council_Member_Max_Order_By = {
  council_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Council_Council_Member_Min_Fields = {
  __typename?: 'council_council_member_min_fields';
  council_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "council_council_member" */
export type Council_Council_Member_Min_Order_By = {
  council_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "council_council_member". */
export type Council_Council_Member_Order_By = {
  council?: InputMaybe<Council_Order_By>;
  council_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  user?: InputMaybe<Maven_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** select columns of table "council_council_member" */
export enum Council_Council_Member_Select_Column {
  /** column name */
  CouncilId = 'council_id',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Name = 'name',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Website = 'website'
}

/** aggregate stddev on columns */
export type Council_Council_Member_Stddev_Fields = {
  __typename?: 'council_council_member_stddev_fields';
  council_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "council_council_member" */
export type Council_Council_Member_Stddev_Order_By = {
  council_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Council_Council_Member_Stddev_Pop_Fields = {
  __typename?: 'council_council_member_stddev_pop_fields';
  council_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "council_council_member" */
export type Council_Council_Member_Stddev_Pop_Order_By = {
  council_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Council_Council_Member_Stddev_Samp_Fields = {
  __typename?: 'council_council_member_stddev_samp_fields';
  council_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "council_council_member" */
export type Council_Council_Member_Stddev_Samp_Order_By = {
  council_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "council_council_member" */
export type Council_Council_Member_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Council_Council_Member_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Council_Council_Member_Stream_Cursor_Value_Input = {
  council_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Council_Council_Member_Sum_Fields = {
  __typename?: 'council_council_member_sum_fields';
  council_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "council_council_member" */
export type Council_Council_Member_Sum_Order_By = {
  council_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Council_Council_Member_Var_Pop_Fields = {
  __typename?: 'council_council_member_var_pop_fields';
  council_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "council_council_member" */
export type Council_Council_Member_Var_Pop_Order_By = {
  council_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Council_Council_Member_Var_Samp_Fields = {
  __typename?: 'council_council_member_var_samp_fields';
  council_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "council_council_member" */
export type Council_Council_Member_Var_Samp_Order_By = {
  council_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Council_Council_Member_Variance_Fields = {
  __typename?: 'council_council_member_variance_fields';
  council_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "council_council_member" */
export type Council_Council_Member_Variance_Order_By = {
  council_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "council_general_contract" */
export type Council_General_Contract = {
  __typename?: 'council_general_contract';
  /** An object relationship */
  contract: Council;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  contract_name: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "council_general_contract" */
export type Council_General_Contract_Aggregate = {
  __typename?: 'council_general_contract_aggregate';
  aggregate?: Maybe<Council_General_Contract_Aggregate_Fields>;
  nodes: Array<Council_General_Contract>;
};

export type Council_General_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Council_General_Contract_Aggregate_Bool_Exp_Count>;
};

export type Council_General_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Council_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Council_General_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "council_general_contract" */
export type Council_General_Contract_Aggregate_Fields = {
  __typename?: 'council_general_contract_aggregate_fields';
  avg?: Maybe<Council_General_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Council_General_Contract_Max_Fields>;
  min?: Maybe<Council_General_Contract_Min_Fields>;
  stddev?: Maybe<Council_General_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Council_General_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Council_General_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Council_General_Contract_Sum_Fields>;
  var_pop?: Maybe<Council_General_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Council_General_Contract_Var_Samp_Fields>;
  variance?: Maybe<Council_General_Contract_Variance_Fields>;
};


/** aggregate fields of "council_general_contract" */
export type Council_General_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Council_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "council_general_contract" */
export type Council_General_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Council_General_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Council_General_Contract_Max_Order_By>;
  min?: InputMaybe<Council_General_Contract_Min_Order_By>;
  stddev?: InputMaybe<Council_General_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Council_General_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Council_General_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Council_General_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Council_General_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Council_General_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Council_General_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Council_General_Contract_Avg_Fields = {
  __typename?: 'council_general_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "council_general_contract" */
export type Council_General_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "council_general_contract". All fields are combined with a logical 'AND'. */
export type Council_General_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Council_General_Contract_Bool_Exp>>;
  _not?: InputMaybe<Council_General_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Council_General_Contract_Bool_Exp>>;
  contract?: InputMaybe<Council_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  contract_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Council_General_Contract_Max_Fields = {
  __typename?: 'council_general_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "council_general_contract" */
export type Council_General_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Council_General_Contract_Min_Fields = {
  __typename?: 'council_general_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "council_general_contract" */
export type Council_General_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "council_general_contract". */
export type Council_General_Contract_Order_By = {
  contract?: InputMaybe<Council_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "council_general_contract" */
export enum Council_General_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  ContractName = 'contract_name',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Council_General_Contract_Stddev_Fields = {
  __typename?: 'council_general_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "council_general_contract" */
export type Council_General_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Council_General_Contract_Stddev_Pop_Fields = {
  __typename?: 'council_general_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "council_general_contract" */
export type Council_General_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Council_General_Contract_Stddev_Samp_Fields = {
  __typename?: 'council_general_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "council_general_contract" */
export type Council_General_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "council_general_contract" */
export type Council_General_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Council_General_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Council_General_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  contract_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Council_General_Contract_Sum_Fields = {
  __typename?: 'council_general_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "council_general_contract" */
export type Council_General_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Council_General_Contract_Var_Pop_Fields = {
  __typename?: 'council_general_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "council_general_contract" */
export type Council_General_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Council_General_Contract_Var_Samp_Fields = {
  __typename?: 'council_general_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "council_general_contract" */
export type Council_General_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Council_General_Contract_Variance_Fields = {
  __typename?: 'council_general_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "council_general_contract" */
export type Council_General_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "council_lambda" */
export type Council_Lambda = {
  __typename?: 'council_lambda';
  /** An object relationship */
  contract: Council;
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lambda_bytes: Scalars['String']['output'];
  lambda_name: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "council_lambda" */
export type Council_Lambda_Aggregate = {
  __typename?: 'council_lambda_aggregate';
  aggregate?: Maybe<Council_Lambda_Aggregate_Fields>;
  nodes: Array<Council_Lambda>;
};

export type Council_Lambda_Aggregate_Bool_Exp = {
  count?: InputMaybe<Council_Lambda_Aggregate_Bool_Exp_Count>;
};

export type Council_Lambda_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Council_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Council_Lambda_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "council_lambda" */
export type Council_Lambda_Aggregate_Fields = {
  __typename?: 'council_lambda_aggregate_fields';
  avg?: Maybe<Council_Lambda_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Council_Lambda_Max_Fields>;
  min?: Maybe<Council_Lambda_Min_Fields>;
  stddev?: Maybe<Council_Lambda_Stddev_Fields>;
  stddev_pop?: Maybe<Council_Lambda_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Council_Lambda_Stddev_Samp_Fields>;
  sum?: Maybe<Council_Lambda_Sum_Fields>;
  var_pop?: Maybe<Council_Lambda_Var_Pop_Fields>;
  var_samp?: Maybe<Council_Lambda_Var_Samp_Fields>;
  variance?: Maybe<Council_Lambda_Variance_Fields>;
};


/** aggregate fields of "council_lambda" */
export type Council_Lambda_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Council_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "council_lambda" */
export type Council_Lambda_Aggregate_Order_By = {
  avg?: InputMaybe<Council_Lambda_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Council_Lambda_Max_Order_By>;
  min?: InputMaybe<Council_Lambda_Min_Order_By>;
  stddev?: InputMaybe<Council_Lambda_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Council_Lambda_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Council_Lambda_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Council_Lambda_Sum_Order_By>;
  var_pop?: InputMaybe<Council_Lambda_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Council_Lambda_Var_Samp_Order_By>;
  variance?: InputMaybe<Council_Lambda_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Council_Lambda_Avg_Fields = {
  __typename?: 'council_lambda_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "council_lambda" */
export type Council_Lambda_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "council_lambda". All fields are combined with a logical 'AND'. */
export type Council_Lambda_Bool_Exp = {
  _and?: InputMaybe<Array<Council_Lambda_Bool_Exp>>;
  _not?: InputMaybe<Council_Lambda_Bool_Exp>;
  _or?: InputMaybe<Array<Council_Lambda_Bool_Exp>>;
  contract?: InputMaybe<Council_Bool_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambda_bytes?: InputMaybe<String_Comparison_Exp>;
  lambda_name?: InputMaybe<String_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Council_Lambda_Max_Fields = {
  __typename?: 'council_lambda_max_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "council_lambda" */
export type Council_Lambda_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Council_Lambda_Min_Fields = {
  __typename?: 'council_lambda_min_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "council_lambda" */
export type Council_Lambda_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "council_lambda". */
export type Council_Lambda_Order_By = {
  contract?: InputMaybe<Council_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "council_lambda" */
export enum Council_Lambda_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaBytes = 'lambda_bytes',
  /** column name */
  LambdaName = 'lambda_name',
  /** column name */
  LastUpdatedAt = 'last_updated_at'
}

/** aggregate stddev on columns */
export type Council_Lambda_Stddev_Fields = {
  __typename?: 'council_lambda_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "council_lambda" */
export type Council_Lambda_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Council_Lambda_Stddev_Pop_Fields = {
  __typename?: 'council_lambda_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "council_lambda" */
export type Council_Lambda_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Council_Lambda_Stddev_Samp_Fields = {
  __typename?: 'council_lambda_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "council_lambda" */
export type Council_Lambda_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "council_lambda" */
export type Council_Lambda_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Council_Lambda_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Council_Lambda_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lambda_bytes?: InputMaybe<Scalars['String']['input']>;
  lambda_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Council_Lambda_Sum_Fields = {
  __typename?: 'council_lambda_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "council_lambda" */
export type Council_Lambda_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Council_Lambda_Var_Pop_Fields = {
  __typename?: 'council_lambda_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "council_lambda" */
export type Council_Lambda_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Council_Lambda_Var_Samp_Fields = {
  __typename?: 'council_lambda_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "council_lambda" */
export type Council_Lambda_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Council_Lambda_Variance_Fields = {
  __typename?: 'council_lambda_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "council_lambda" */
export type Council_Lambda_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Council_Max_Fields = {
  __typename?: 'council_max_fields';
  action_counter?: Maybe<Scalars['bigint']['output']>;
  action_expiry_days?: Maybe<Scalars['bigint']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  council_member_image_max_length?: Maybe<Scalars['smallint']['output']>;
  council_member_name_max_length?: Maybe<Scalars['smallint']['output']>;
  council_member_website_max_length?: Maybe<Scalars['smallint']['output']>;
  council_size?: Maybe<Scalars['smallint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  request_purpose_max_length?: Maybe<Scalars['smallint']['output']>;
  request_token_name_max_length?: Maybe<Scalars['smallint']['output']>;
  threshold?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "council" */
export type Council_Max_Order_By = {
  action_counter?: InputMaybe<Order_By>;
  action_expiry_days?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  council_member_image_max_length?: InputMaybe<Order_By>;
  council_member_name_max_length?: InputMaybe<Order_By>;
  council_member_website_max_length?: InputMaybe<Order_By>;
  council_size?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  request_purpose_max_length?: InputMaybe<Order_By>;
  request_token_name_max_length?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Council_Min_Fields = {
  __typename?: 'council_min_fields';
  action_counter?: Maybe<Scalars['bigint']['output']>;
  action_expiry_days?: Maybe<Scalars['bigint']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  council_member_image_max_length?: Maybe<Scalars['smallint']['output']>;
  council_member_name_max_length?: Maybe<Scalars['smallint']['output']>;
  council_member_website_max_length?: Maybe<Scalars['smallint']['output']>;
  council_size?: Maybe<Scalars['smallint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  request_purpose_max_length?: Maybe<Scalars['smallint']['output']>;
  request_token_name_max_length?: Maybe<Scalars['smallint']['output']>;
  threshold?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "council" */
export type Council_Min_Order_By = {
  action_counter?: InputMaybe<Order_By>;
  action_expiry_days?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  council_member_image_max_length?: InputMaybe<Order_By>;
  council_member_name_max_length?: InputMaybe<Order_By>;
  council_member_website_max_length?: InputMaybe<Order_By>;
  council_size?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  request_purpose_max_length?: InputMaybe<Order_By>;
  request_token_name_max_length?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "council". */
export type Council_Order_By = {
  action_counter?: InputMaybe<Order_By>;
  action_expiry_days?: InputMaybe<Order_By>;
  actions_aggregate?: InputMaybe<Council_Action_Aggregate_Order_By>;
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  council_member_image_max_length?: InputMaybe<Order_By>;
  council_member_name_max_length?: InputMaybe<Order_By>;
  council_member_website_max_length?: InputMaybe<Order_By>;
  council_size?: InputMaybe<Order_By>;
  general_contracts_aggregate?: InputMaybe<Council_General_Contract_Aggregate_Order_By>;
  governance?: InputMaybe<Governance_Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambdas_aggregate?: InputMaybe<Council_Lambda_Aggregate_Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  members_aggregate?: InputMaybe<Council_Council_Member_Aggregate_Order_By>;
  metadata?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  request_purpose_max_length?: InputMaybe<Order_By>;
  request_token_name_max_length?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
  whitelist_contracts_aggregate?: InputMaybe<Council_Whitelist_Contract_Aggregate_Order_By>;
};

/** select columns of table "council" */
export enum Council_Select_Column {
  /** column name */
  ActionCounter = 'action_counter',
  /** column name */
  ActionExpiryDays = 'action_expiry_days',
  /** column name */
  Address = 'address',
  /** column name */
  Admin = 'admin',
  /** column name */
  CouncilMemberImageMaxLength = 'council_member_image_max_length',
  /** column name */
  CouncilMemberNameMaxLength = 'council_member_name_max_length',
  /** column name */
  CouncilMemberWebsiteMaxLength = 'council_member_website_max_length',
  /** column name */
  CouncilSize = 'council_size',
  /** column name */
  GovernanceId = 'governance_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Network = 'network',
  /** column name */
  RequestPurposeMaxLength = 'request_purpose_max_length',
  /** column name */
  RequestTokenNameMaxLength = 'request_token_name_max_length',
  /** column name */
  Threshold = 'threshold'
}

/** aggregate stddev on columns */
export type Council_Stddev_Fields = {
  __typename?: 'council_stddev_fields';
  action_counter?: Maybe<Scalars['Float']['output']>;
  action_expiry_days?: Maybe<Scalars['Float']['output']>;
  council_member_image_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_name_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_website_max_length?: Maybe<Scalars['Float']['output']>;
  council_size?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  request_purpose_max_length?: Maybe<Scalars['Float']['output']>;
  request_token_name_max_length?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "council" */
export type Council_Stddev_Order_By = {
  action_counter?: InputMaybe<Order_By>;
  action_expiry_days?: InputMaybe<Order_By>;
  council_member_image_max_length?: InputMaybe<Order_By>;
  council_member_name_max_length?: InputMaybe<Order_By>;
  council_member_website_max_length?: InputMaybe<Order_By>;
  council_size?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_purpose_max_length?: InputMaybe<Order_By>;
  request_token_name_max_length?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Council_Stddev_Pop_Fields = {
  __typename?: 'council_stddev_pop_fields';
  action_counter?: Maybe<Scalars['Float']['output']>;
  action_expiry_days?: Maybe<Scalars['Float']['output']>;
  council_member_image_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_name_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_website_max_length?: Maybe<Scalars['Float']['output']>;
  council_size?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  request_purpose_max_length?: Maybe<Scalars['Float']['output']>;
  request_token_name_max_length?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "council" */
export type Council_Stddev_Pop_Order_By = {
  action_counter?: InputMaybe<Order_By>;
  action_expiry_days?: InputMaybe<Order_By>;
  council_member_image_max_length?: InputMaybe<Order_By>;
  council_member_name_max_length?: InputMaybe<Order_By>;
  council_member_website_max_length?: InputMaybe<Order_By>;
  council_size?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_purpose_max_length?: InputMaybe<Order_By>;
  request_token_name_max_length?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Council_Stddev_Samp_Fields = {
  __typename?: 'council_stddev_samp_fields';
  action_counter?: Maybe<Scalars['Float']['output']>;
  action_expiry_days?: Maybe<Scalars['Float']['output']>;
  council_member_image_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_name_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_website_max_length?: Maybe<Scalars['Float']['output']>;
  council_size?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  request_purpose_max_length?: Maybe<Scalars['Float']['output']>;
  request_token_name_max_length?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "council" */
export type Council_Stddev_Samp_Order_By = {
  action_counter?: InputMaybe<Order_By>;
  action_expiry_days?: InputMaybe<Order_By>;
  council_member_image_max_length?: InputMaybe<Order_By>;
  council_member_name_max_length?: InputMaybe<Order_By>;
  council_member_website_max_length?: InputMaybe<Order_By>;
  council_size?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_purpose_max_length?: InputMaybe<Order_By>;
  request_token_name_max_length?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "council" */
export type Council_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Council_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Council_Stream_Cursor_Value_Input = {
  action_counter?: InputMaybe<Scalars['bigint']['input']>;
  action_expiry_days?: InputMaybe<Scalars['bigint']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['String']['input']>;
  council_member_image_max_length?: InputMaybe<Scalars['smallint']['input']>;
  council_member_name_max_length?: InputMaybe<Scalars['smallint']['input']>;
  council_member_website_max_length?: InputMaybe<Scalars['smallint']['input']>;
  council_size?: InputMaybe<Scalars['smallint']['input']>;
  governance_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  request_purpose_max_length?: InputMaybe<Scalars['smallint']['input']>;
  request_token_name_max_length?: InputMaybe<Scalars['smallint']['input']>;
  threshold?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Council_Sum_Fields = {
  __typename?: 'council_sum_fields';
  action_counter?: Maybe<Scalars['bigint']['output']>;
  action_expiry_days?: Maybe<Scalars['bigint']['output']>;
  council_member_image_max_length?: Maybe<Scalars['smallint']['output']>;
  council_member_name_max_length?: Maybe<Scalars['smallint']['output']>;
  council_member_website_max_length?: Maybe<Scalars['smallint']['output']>;
  council_size?: Maybe<Scalars['smallint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  request_purpose_max_length?: Maybe<Scalars['smallint']['output']>;
  request_token_name_max_length?: Maybe<Scalars['smallint']['output']>;
  threshold?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "council" */
export type Council_Sum_Order_By = {
  action_counter?: InputMaybe<Order_By>;
  action_expiry_days?: InputMaybe<Order_By>;
  council_member_image_max_length?: InputMaybe<Order_By>;
  council_member_name_max_length?: InputMaybe<Order_By>;
  council_member_website_max_length?: InputMaybe<Order_By>;
  council_size?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_purpose_max_length?: InputMaybe<Order_By>;
  request_token_name_max_length?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Council_Var_Pop_Fields = {
  __typename?: 'council_var_pop_fields';
  action_counter?: Maybe<Scalars['Float']['output']>;
  action_expiry_days?: Maybe<Scalars['Float']['output']>;
  council_member_image_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_name_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_website_max_length?: Maybe<Scalars['Float']['output']>;
  council_size?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  request_purpose_max_length?: Maybe<Scalars['Float']['output']>;
  request_token_name_max_length?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "council" */
export type Council_Var_Pop_Order_By = {
  action_counter?: InputMaybe<Order_By>;
  action_expiry_days?: InputMaybe<Order_By>;
  council_member_image_max_length?: InputMaybe<Order_By>;
  council_member_name_max_length?: InputMaybe<Order_By>;
  council_member_website_max_length?: InputMaybe<Order_By>;
  council_size?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_purpose_max_length?: InputMaybe<Order_By>;
  request_token_name_max_length?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Council_Var_Samp_Fields = {
  __typename?: 'council_var_samp_fields';
  action_counter?: Maybe<Scalars['Float']['output']>;
  action_expiry_days?: Maybe<Scalars['Float']['output']>;
  council_member_image_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_name_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_website_max_length?: Maybe<Scalars['Float']['output']>;
  council_size?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  request_purpose_max_length?: Maybe<Scalars['Float']['output']>;
  request_token_name_max_length?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "council" */
export type Council_Var_Samp_Order_By = {
  action_counter?: InputMaybe<Order_By>;
  action_expiry_days?: InputMaybe<Order_By>;
  council_member_image_max_length?: InputMaybe<Order_By>;
  council_member_name_max_length?: InputMaybe<Order_By>;
  council_member_website_max_length?: InputMaybe<Order_By>;
  council_size?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_purpose_max_length?: InputMaybe<Order_By>;
  request_token_name_max_length?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Council_Variance_Fields = {
  __typename?: 'council_variance_fields';
  action_counter?: Maybe<Scalars['Float']['output']>;
  action_expiry_days?: Maybe<Scalars['Float']['output']>;
  council_member_image_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_name_max_length?: Maybe<Scalars['Float']['output']>;
  council_member_website_max_length?: Maybe<Scalars['Float']['output']>;
  council_size?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  request_purpose_max_length?: Maybe<Scalars['Float']['output']>;
  request_token_name_max_length?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "council" */
export type Council_Variance_Order_By = {
  action_counter?: InputMaybe<Order_By>;
  action_expiry_days?: InputMaybe<Order_By>;
  council_member_image_max_length?: InputMaybe<Order_By>;
  council_member_name_max_length?: InputMaybe<Order_By>;
  council_member_website_max_length?: InputMaybe<Order_By>;
  council_size?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_purpose_max_length?: InputMaybe<Order_By>;
  request_token_name_max_length?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
};

/** columns and relationships of "council_whitelist_contract" */
export type Council_Whitelist_Contract = {
  __typename?: 'council_whitelist_contract';
  /** An object relationship */
  contract: Council;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "council_whitelist_contract" */
export type Council_Whitelist_Contract_Aggregate = {
  __typename?: 'council_whitelist_contract_aggregate';
  aggregate?: Maybe<Council_Whitelist_Contract_Aggregate_Fields>;
  nodes: Array<Council_Whitelist_Contract>;
};

export type Council_Whitelist_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Council_Whitelist_Contract_Aggregate_Bool_Exp_Count>;
};

export type Council_Whitelist_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Council_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Council_Whitelist_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "council_whitelist_contract" */
export type Council_Whitelist_Contract_Aggregate_Fields = {
  __typename?: 'council_whitelist_contract_aggregate_fields';
  avg?: Maybe<Council_Whitelist_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Council_Whitelist_Contract_Max_Fields>;
  min?: Maybe<Council_Whitelist_Contract_Min_Fields>;
  stddev?: Maybe<Council_Whitelist_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Council_Whitelist_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Council_Whitelist_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Council_Whitelist_Contract_Sum_Fields>;
  var_pop?: Maybe<Council_Whitelist_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Council_Whitelist_Contract_Var_Samp_Fields>;
  variance?: Maybe<Council_Whitelist_Contract_Variance_Fields>;
};


/** aggregate fields of "council_whitelist_contract" */
export type Council_Whitelist_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Council_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "council_whitelist_contract" */
export type Council_Whitelist_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Council_Whitelist_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Council_Whitelist_Contract_Max_Order_By>;
  min?: InputMaybe<Council_Whitelist_Contract_Min_Order_By>;
  stddev?: InputMaybe<Council_Whitelist_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Council_Whitelist_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Council_Whitelist_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Council_Whitelist_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Council_Whitelist_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Council_Whitelist_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Council_Whitelist_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Council_Whitelist_Contract_Avg_Fields = {
  __typename?: 'council_whitelist_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "council_whitelist_contract" */
export type Council_Whitelist_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "council_whitelist_contract". All fields are combined with a logical 'AND'. */
export type Council_Whitelist_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Council_Whitelist_Contract_Bool_Exp>>;
  _not?: InputMaybe<Council_Whitelist_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Council_Whitelist_Contract_Bool_Exp>>;
  contract?: InputMaybe<Council_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Council_Whitelist_Contract_Max_Fields = {
  __typename?: 'council_whitelist_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "council_whitelist_contract" */
export type Council_Whitelist_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Council_Whitelist_Contract_Min_Fields = {
  __typename?: 'council_whitelist_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "council_whitelist_contract" */
export type Council_Whitelist_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "council_whitelist_contract". */
export type Council_Whitelist_Contract_Order_By = {
  contract?: InputMaybe<Council_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "council_whitelist_contract" */
export enum Council_Whitelist_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Council_Whitelist_Contract_Stddev_Fields = {
  __typename?: 'council_whitelist_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "council_whitelist_contract" */
export type Council_Whitelist_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Council_Whitelist_Contract_Stddev_Pop_Fields = {
  __typename?: 'council_whitelist_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "council_whitelist_contract" */
export type Council_Whitelist_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Council_Whitelist_Contract_Stddev_Samp_Fields = {
  __typename?: 'council_whitelist_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "council_whitelist_contract" */
export type Council_Whitelist_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "council_whitelist_contract" */
export type Council_Whitelist_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Council_Whitelist_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Council_Whitelist_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Council_Whitelist_Contract_Sum_Fields = {
  __typename?: 'council_whitelist_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "council_whitelist_contract" */
export type Council_Whitelist_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Council_Whitelist_Contract_Var_Pop_Fields = {
  __typename?: 'council_whitelist_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "council_whitelist_contract" */
export type Council_Whitelist_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Council_Whitelist_Contract_Var_Samp_Fields = {
  __typename?: 'council_whitelist_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "council_whitelist_contract" */
export type Council_Whitelist_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Council_Whitelist_Contract_Variance_Fields = {
  __typename?: 'council_whitelist_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "council_whitelist_contract" */
export type Council_Whitelist_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "delegation" */
export type Delegation = {
  __typename?: 'delegation';
  address: Scalars['String']['output'];
  admin: Scalars['String']['output'];
  delegate_to_satellite_paused: Scalars['Boolean']['output'];
  delegation_ratio: Scalars['smallint']['output'];
  /** An array relationship */
  delegations: Array<Delegation_Record>;
  /** An aggregate relationship */
  delegations_aggregate: Delegation_Record_Aggregate;
  distribute_reward_paused: Scalars['Boolean']['output'];
  /** An array relationship */
  general_contracts: Array<Delegation_General_Contract>;
  /** An aggregate relationship */
  general_contracts_aggregate: Delegation_General_Contract_Aggregate;
  /** An object relationship */
  governance: Governance;
  governance_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An array relationship */
  lambdas: Array<Delegation_Lambda>;
  /** An aggregate relationship */
  lambdas_aggregate: Delegation_Lambda_Aggregate;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  max_satellites: Scalars['smallint']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  minimum_smvn_balance: Scalars['float8']['output'];
  network: Scalars['String']['output'];
  register_as_satellite_paused: Scalars['Boolean']['output'];
  satellite_description_max_length: Scalars['smallint']['output'];
  satellite_image_max_length: Scalars['smallint']['output'];
  satellite_name_max_length: Scalars['smallint']['output'];
  /** An array relationship */
  satellite_rewardss: Array<Satellite_Rewards>;
  /** An aggregate relationship */
  satellite_rewardss_aggregate: Satellite_Rewards_Aggregate;
  satellite_website_max_length: Scalars['smallint']['output'];
  /** An array relationship */
  satellites: Array<Satellite>;
  /** An aggregate relationship */
  satellites_aggregate: Satellite_Aggregate;
  take_satellites_snapshot_paused: Scalars['Boolean']['output'];
  undelegate_from_satellite_paused: Scalars['Boolean']['output'];
  unregister_as_satellite_paused: Scalars['Boolean']['output'];
  update_satellite_record_paused: Scalars['Boolean']['output'];
  /** An array relationship */
  whitelist_contracts: Array<Delegation_Whitelist_Contract>;
  /** An aggregate relationship */
  whitelist_contracts_aggregate: Delegation_Whitelist_Contract_Aggregate;
};


/** columns and relationships of "delegation" */
export type DelegationDelegationsArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Record_Order_By>>;
  where?: InputMaybe<Delegation_Record_Bool_Exp>;
};


/** columns and relationships of "delegation" */
export type DelegationDelegations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Record_Order_By>>;
  where?: InputMaybe<Delegation_Record_Bool_Exp>;
};


/** columns and relationships of "delegation" */
export type DelegationGeneral_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Delegation_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_General_Contract_Order_By>>;
  where?: InputMaybe<Delegation_General_Contract_Bool_Exp>;
};


/** columns and relationships of "delegation" */
export type DelegationGeneral_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delegation_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_General_Contract_Order_By>>;
  where?: InputMaybe<Delegation_General_Contract_Bool_Exp>;
};


/** columns and relationships of "delegation" */
export type DelegationLambdasArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Lambda_Order_By>>;
  where?: InputMaybe<Delegation_Lambda_Bool_Exp>;
};


/** columns and relationships of "delegation" */
export type DelegationLambdas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Lambda_Order_By>>;
  where?: InputMaybe<Delegation_Lambda_Bool_Exp>;
};


/** columns and relationships of "delegation" */
export type DelegationMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "delegation" */
export type DelegationSatellite_RewardssArgs = {
  distinct_on?: InputMaybe<Array<Satellite_Rewards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Satellite_Rewards_Order_By>>;
  where?: InputMaybe<Satellite_Rewards_Bool_Exp>;
};


/** columns and relationships of "delegation" */
export type DelegationSatellite_Rewardss_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Satellite_Rewards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Satellite_Rewards_Order_By>>;
  where?: InputMaybe<Satellite_Rewards_Bool_Exp>;
};


/** columns and relationships of "delegation" */
export type DelegationSatellitesArgs = {
  distinct_on?: InputMaybe<Array<Satellite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Satellite_Order_By>>;
  where?: InputMaybe<Satellite_Bool_Exp>;
};


/** columns and relationships of "delegation" */
export type DelegationSatellites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Satellite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Satellite_Order_By>>;
  where?: InputMaybe<Satellite_Bool_Exp>;
};


/** columns and relationships of "delegation" */
export type DelegationWhitelist_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Delegation_Whitelist_Contract_Bool_Exp>;
};


/** columns and relationships of "delegation" */
export type DelegationWhitelist_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Delegation_Whitelist_Contract_Bool_Exp>;
};

/** aggregated selection of "delegation" */
export type Delegation_Aggregate = {
  __typename?: 'delegation_aggregate';
  aggregate?: Maybe<Delegation_Aggregate_Fields>;
  nodes: Array<Delegation>;
};

export type Delegation_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Delegation_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Delegation_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Delegation_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Delegation_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Delegation_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Delegation_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Delegation_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Delegation_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Delegation_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Delegation_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Delegation_Aggregate_Bool_Exp_Var_Samp>;
};

export type Delegation_Aggregate_Bool_Exp_Avg = {
  arguments: Delegation_Select_Column_Delegation_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Delegation_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Delegation_Aggregate_Bool_Exp_Bool_And = {
  arguments: Delegation_Select_Column_Delegation_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Delegation_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Delegation_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Delegation_Select_Column_Delegation_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Delegation_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Delegation_Aggregate_Bool_Exp_Corr = {
  arguments: Delegation_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Delegation_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Delegation_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Delegation_Select_Column_Delegation_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Delegation_Select_Column_Delegation_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Delegation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Delegation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Delegation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Delegation_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Delegation_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Delegation_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Delegation_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Delegation_Select_Column_Delegation_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Delegation_Select_Column_Delegation_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Delegation_Aggregate_Bool_Exp_Max = {
  arguments: Delegation_Select_Column_Delegation_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Delegation_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Delegation_Aggregate_Bool_Exp_Min = {
  arguments: Delegation_Select_Column_Delegation_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Delegation_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Delegation_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Delegation_Select_Column_Delegation_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Delegation_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Delegation_Aggregate_Bool_Exp_Sum = {
  arguments: Delegation_Select_Column_Delegation_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Delegation_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Delegation_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Delegation_Select_Column_Delegation_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Delegation_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "delegation" */
export type Delegation_Aggregate_Fields = {
  __typename?: 'delegation_aggregate_fields';
  avg?: Maybe<Delegation_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Delegation_Max_Fields>;
  min?: Maybe<Delegation_Min_Fields>;
  stddev?: Maybe<Delegation_Stddev_Fields>;
  stddev_pop?: Maybe<Delegation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Delegation_Stddev_Samp_Fields>;
  sum?: Maybe<Delegation_Sum_Fields>;
  var_pop?: Maybe<Delegation_Var_Pop_Fields>;
  var_samp?: Maybe<Delegation_Var_Samp_Fields>;
  variance?: Maybe<Delegation_Variance_Fields>;
};


/** aggregate fields of "delegation" */
export type Delegation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Delegation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "delegation" */
export type Delegation_Aggregate_Order_By = {
  avg?: InputMaybe<Delegation_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Delegation_Max_Order_By>;
  min?: InputMaybe<Delegation_Min_Order_By>;
  stddev?: InputMaybe<Delegation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Delegation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Delegation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Delegation_Sum_Order_By>;
  var_pop?: InputMaybe<Delegation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Delegation_Var_Samp_Order_By>;
  variance?: InputMaybe<Delegation_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Delegation_Avg_Fields = {
  __typename?: 'delegation_avg_fields';
  delegation_ratio?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_satellites?: Maybe<Scalars['Float']['output']>;
  minimum_smvn_balance?: Maybe<Scalars['Float']['output']>;
  satellite_description_max_length?: Maybe<Scalars['Float']['output']>;
  satellite_image_max_length?: Maybe<Scalars['Float']['output']>;
  satellite_name_max_length?: Maybe<Scalars['Float']['output']>;
  satellite_website_max_length?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "delegation" */
export type Delegation_Avg_Order_By = {
  delegation_ratio?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_satellites?: InputMaybe<Order_By>;
  minimum_smvn_balance?: InputMaybe<Order_By>;
  satellite_description_max_length?: InputMaybe<Order_By>;
  satellite_image_max_length?: InputMaybe<Order_By>;
  satellite_name_max_length?: InputMaybe<Order_By>;
  satellite_website_max_length?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "delegation". All fields are combined with a logical 'AND'. */
export type Delegation_Bool_Exp = {
  _and?: InputMaybe<Array<Delegation_Bool_Exp>>;
  _not?: InputMaybe<Delegation_Bool_Exp>;
  _or?: InputMaybe<Array<Delegation_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  admin?: InputMaybe<String_Comparison_Exp>;
  delegate_to_satellite_paused?: InputMaybe<Boolean_Comparison_Exp>;
  delegation_ratio?: InputMaybe<Smallint_Comparison_Exp>;
  delegations?: InputMaybe<Delegation_Record_Bool_Exp>;
  delegations_aggregate?: InputMaybe<Delegation_Record_Aggregate_Bool_Exp>;
  distribute_reward_paused?: InputMaybe<Boolean_Comparison_Exp>;
  general_contracts?: InputMaybe<Delegation_General_Contract_Bool_Exp>;
  general_contracts_aggregate?: InputMaybe<Delegation_General_Contract_Aggregate_Bool_Exp>;
  governance?: InputMaybe<Governance_Bool_Exp>;
  governance_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambdas?: InputMaybe<Delegation_Lambda_Bool_Exp>;
  lambdas_aggregate?: InputMaybe<Delegation_Lambda_Aggregate_Bool_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  max_satellites?: InputMaybe<Smallint_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  minimum_smvn_balance?: InputMaybe<Float8_Comparison_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
  register_as_satellite_paused?: InputMaybe<Boolean_Comparison_Exp>;
  satellite_description_max_length?: InputMaybe<Smallint_Comparison_Exp>;
  satellite_image_max_length?: InputMaybe<Smallint_Comparison_Exp>;
  satellite_name_max_length?: InputMaybe<Smallint_Comparison_Exp>;
  satellite_rewardss?: InputMaybe<Satellite_Rewards_Bool_Exp>;
  satellite_rewardss_aggregate?: InputMaybe<Satellite_Rewards_Aggregate_Bool_Exp>;
  satellite_website_max_length?: InputMaybe<Smallint_Comparison_Exp>;
  satellites?: InputMaybe<Satellite_Bool_Exp>;
  satellites_aggregate?: InputMaybe<Satellite_Aggregate_Bool_Exp>;
  take_satellites_snapshot_paused?: InputMaybe<Boolean_Comparison_Exp>;
  undelegate_from_satellite_paused?: InputMaybe<Boolean_Comparison_Exp>;
  unregister_as_satellite_paused?: InputMaybe<Boolean_Comparison_Exp>;
  update_satellite_record_paused?: InputMaybe<Boolean_Comparison_Exp>;
  whitelist_contracts?: InputMaybe<Delegation_Whitelist_Contract_Bool_Exp>;
  whitelist_contracts_aggregate?: InputMaybe<Delegation_Whitelist_Contract_Aggregate_Bool_Exp>;
};

/** columns and relationships of "delegation_general_contract" */
export type Delegation_General_Contract = {
  __typename?: 'delegation_general_contract';
  /** An object relationship */
  contract: Delegation;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  contract_name: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "delegation_general_contract" */
export type Delegation_General_Contract_Aggregate = {
  __typename?: 'delegation_general_contract_aggregate';
  aggregate?: Maybe<Delegation_General_Contract_Aggregate_Fields>;
  nodes: Array<Delegation_General_Contract>;
};

export type Delegation_General_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Delegation_General_Contract_Aggregate_Bool_Exp_Count>;
};

export type Delegation_General_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Delegation_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Delegation_General_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "delegation_general_contract" */
export type Delegation_General_Contract_Aggregate_Fields = {
  __typename?: 'delegation_general_contract_aggregate_fields';
  avg?: Maybe<Delegation_General_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Delegation_General_Contract_Max_Fields>;
  min?: Maybe<Delegation_General_Contract_Min_Fields>;
  stddev?: Maybe<Delegation_General_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Delegation_General_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Delegation_General_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Delegation_General_Contract_Sum_Fields>;
  var_pop?: Maybe<Delegation_General_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Delegation_General_Contract_Var_Samp_Fields>;
  variance?: Maybe<Delegation_General_Contract_Variance_Fields>;
};


/** aggregate fields of "delegation_general_contract" */
export type Delegation_General_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Delegation_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "delegation_general_contract" */
export type Delegation_General_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Delegation_General_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Delegation_General_Contract_Max_Order_By>;
  min?: InputMaybe<Delegation_General_Contract_Min_Order_By>;
  stddev?: InputMaybe<Delegation_General_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Delegation_General_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Delegation_General_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Delegation_General_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Delegation_General_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Delegation_General_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Delegation_General_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Delegation_General_Contract_Avg_Fields = {
  __typename?: 'delegation_general_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "delegation_general_contract" */
export type Delegation_General_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "delegation_general_contract". All fields are combined with a logical 'AND'. */
export type Delegation_General_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Delegation_General_Contract_Bool_Exp>>;
  _not?: InputMaybe<Delegation_General_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Delegation_General_Contract_Bool_Exp>>;
  contract?: InputMaybe<Delegation_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  contract_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Delegation_General_Contract_Max_Fields = {
  __typename?: 'delegation_general_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "delegation_general_contract" */
export type Delegation_General_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Delegation_General_Contract_Min_Fields = {
  __typename?: 'delegation_general_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "delegation_general_contract" */
export type Delegation_General_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "delegation_general_contract". */
export type Delegation_General_Contract_Order_By = {
  contract?: InputMaybe<Delegation_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "delegation_general_contract" */
export enum Delegation_General_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  ContractName = 'contract_name',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Delegation_General_Contract_Stddev_Fields = {
  __typename?: 'delegation_general_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "delegation_general_contract" */
export type Delegation_General_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Delegation_General_Contract_Stddev_Pop_Fields = {
  __typename?: 'delegation_general_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "delegation_general_contract" */
export type Delegation_General_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Delegation_General_Contract_Stddev_Samp_Fields = {
  __typename?: 'delegation_general_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "delegation_general_contract" */
export type Delegation_General_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "delegation_general_contract" */
export type Delegation_General_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Delegation_General_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Delegation_General_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  contract_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Delegation_General_Contract_Sum_Fields = {
  __typename?: 'delegation_general_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "delegation_general_contract" */
export type Delegation_General_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Delegation_General_Contract_Var_Pop_Fields = {
  __typename?: 'delegation_general_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "delegation_general_contract" */
export type Delegation_General_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Delegation_General_Contract_Var_Samp_Fields = {
  __typename?: 'delegation_general_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "delegation_general_contract" */
export type Delegation_General_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Delegation_General_Contract_Variance_Fields = {
  __typename?: 'delegation_general_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "delegation_general_contract" */
export type Delegation_General_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "delegation_lambda" */
export type Delegation_Lambda = {
  __typename?: 'delegation_lambda';
  /** An object relationship */
  contract: Delegation;
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lambda_bytes: Scalars['String']['output'];
  lambda_name: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "delegation_lambda" */
export type Delegation_Lambda_Aggregate = {
  __typename?: 'delegation_lambda_aggregate';
  aggregate?: Maybe<Delegation_Lambda_Aggregate_Fields>;
  nodes: Array<Delegation_Lambda>;
};

export type Delegation_Lambda_Aggregate_Bool_Exp = {
  count?: InputMaybe<Delegation_Lambda_Aggregate_Bool_Exp_Count>;
};

export type Delegation_Lambda_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Delegation_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Delegation_Lambda_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "delegation_lambda" */
export type Delegation_Lambda_Aggregate_Fields = {
  __typename?: 'delegation_lambda_aggregate_fields';
  avg?: Maybe<Delegation_Lambda_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Delegation_Lambda_Max_Fields>;
  min?: Maybe<Delegation_Lambda_Min_Fields>;
  stddev?: Maybe<Delegation_Lambda_Stddev_Fields>;
  stddev_pop?: Maybe<Delegation_Lambda_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Delegation_Lambda_Stddev_Samp_Fields>;
  sum?: Maybe<Delegation_Lambda_Sum_Fields>;
  var_pop?: Maybe<Delegation_Lambda_Var_Pop_Fields>;
  var_samp?: Maybe<Delegation_Lambda_Var_Samp_Fields>;
  variance?: Maybe<Delegation_Lambda_Variance_Fields>;
};


/** aggregate fields of "delegation_lambda" */
export type Delegation_Lambda_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Delegation_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "delegation_lambda" */
export type Delegation_Lambda_Aggregate_Order_By = {
  avg?: InputMaybe<Delegation_Lambda_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Delegation_Lambda_Max_Order_By>;
  min?: InputMaybe<Delegation_Lambda_Min_Order_By>;
  stddev?: InputMaybe<Delegation_Lambda_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Delegation_Lambda_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Delegation_Lambda_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Delegation_Lambda_Sum_Order_By>;
  var_pop?: InputMaybe<Delegation_Lambda_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Delegation_Lambda_Var_Samp_Order_By>;
  variance?: InputMaybe<Delegation_Lambda_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Delegation_Lambda_Avg_Fields = {
  __typename?: 'delegation_lambda_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "delegation_lambda" */
export type Delegation_Lambda_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "delegation_lambda". All fields are combined with a logical 'AND'. */
export type Delegation_Lambda_Bool_Exp = {
  _and?: InputMaybe<Array<Delegation_Lambda_Bool_Exp>>;
  _not?: InputMaybe<Delegation_Lambda_Bool_Exp>;
  _or?: InputMaybe<Array<Delegation_Lambda_Bool_Exp>>;
  contract?: InputMaybe<Delegation_Bool_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambda_bytes?: InputMaybe<String_Comparison_Exp>;
  lambda_name?: InputMaybe<String_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Delegation_Lambda_Max_Fields = {
  __typename?: 'delegation_lambda_max_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "delegation_lambda" */
export type Delegation_Lambda_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Delegation_Lambda_Min_Fields = {
  __typename?: 'delegation_lambda_min_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "delegation_lambda" */
export type Delegation_Lambda_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "delegation_lambda". */
export type Delegation_Lambda_Order_By = {
  contract?: InputMaybe<Delegation_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "delegation_lambda" */
export enum Delegation_Lambda_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaBytes = 'lambda_bytes',
  /** column name */
  LambdaName = 'lambda_name',
  /** column name */
  LastUpdatedAt = 'last_updated_at'
}

/** aggregate stddev on columns */
export type Delegation_Lambda_Stddev_Fields = {
  __typename?: 'delegation_lambda_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "delegation_lambda" */
export type Delegation_Lambda_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Delegation_Lambda_Stddev_Pop_Fields = {
  __typename?: 'delegation_lambda_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "delegation_lambda" */
export type Delegation_Lambda_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Delegation_Lambda_Stddev_Samp_Fields = {
  __typename?: 'delegation_lambda_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "delegation_lambda" */
export type Delegation_Lambda_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "delegation_lambda" */
export type Delegation_Lambda_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Delegation_Lambda_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Delegation_Lambda_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lambda_bytes?: InputMaybe<Scalars['String']['input']>;
  lambda_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Delegation_Lambda_Sum_Fields = {
  __typename?: 'delegation_lambda_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "delegation_lambda" */
export type Delegation_Lambda_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Delegation_Lambda_Var_Pop_Fields = {
  __typename?: 'delegation_lambda_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "delegation_lambda" */
export type Delegation_Lambda_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Delegation_Lambda_Var_Samp_Fields = {
  __typename?: 'delegation_lambda_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "delegation_lambda" */
export type Delegation_Lambda_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Delegation_Lambda_Variance_Fields = {
  __typename?: 'delegation_lambda_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "delegation_lambda" */
export type Delegation_Lambda_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Delegation_Max_Fields = {
  __typename?: 'delegation_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  delegation_ratio?: Maybe<Scalars['smallint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  max_satellites?: Maybe<Scalars['smallint']['output']>;
  minimum_smvn_balance?: Maybe<Scalars['float8']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  satellite_description_max_length?: Maybe<Scalars['smallint']['output']>;
  satellite_image_max_length?: Maybe<Scalars['smallint']['output']>;
  satellite_name_max_length?: Maybe<Scalars['smallint']['output']>;
  satellite_website_max_length?: Maybe<Scalars['smallint']['output']>;
};

/** order by max() on columns of table "delegation" */
export type Delegation_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  delegation_ratio?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  max_satellites?: InputMaybe<Order_By>;
  minimum_smvn_balance?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  satellite_description_max_length?: InputMaybe<Order_By>;
  satellite_image_max_length?: InputMaybe<Order_By>;
  satellite_name_max_length?: InputMaybe<Order_By>;
  satellite_website_max_length?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Delegation_Min_Fields = {
  __typename?: 'delegation_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  delegation_ratio?: Maybe<Scalars['smallint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  max_satellites?: Maybe<Scalars['smallint']['output']>;
  minimum_smvn_balance?: Maybe<Scalars['float8']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  satellite_description_max_length?: Maybe<Scalars['smallint']['output']>;
  satellite_image_max_length?: Maybe<Scalars['smallint']['output']>;
  satellite_name_max_length?: Maybe<Scalars['smallint']['output']>;
  satellite_website_max_length?: Maybe<Scalars['smallint']['output']>;
};

/** order by min() on columns of table "delegation" */
export type Delegation_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  delegation_ratio?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  max_satellites?: InputMaybe<Order_By>;
  minimum_smvn_balance?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  satellite_description_max_length?: InputMaybe<Order_By>;
  satellite_image_max_length?: InputMaybe<Order_By>;
  satellite_name_max_length?: InputMaybe<Order_By>;
  satellite_website_max_length?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "delegation". */
export type Delegation_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  delegate_to_satellite_paused?: InputMaybe<Order_By>;
  delegation_ratio?: InputMaybe<Order_By>;
  delegations_aggregate?: InputMaybe<Delegation_Record_Aggregate_Order_By>;
  distribute_reward_paused?: InputMaybe<Order_By>;
  general_contracts_aggregate?: InputMaybe<Delegation_General_Contract_Aggregate_Order_By>;
  governance?: InputMaybe<Governance_Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambdas_aggregate?: InputMaybe<Delegation_Lambda_Aggregate_Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  max_satellites?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  minimum_smvn_balance?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  register_as_satellite_paused?: InputMaybe<Order_By>;
  satellite_description_max_length?: InputMaybe<Order_By>;
  satellite_image_max_length?: InputMaybe<Order_By>;
  satellite_name_max_length?: InputMaybe<Order_By>;
  satellite_rewardss_aggregate?: InputMaybe<Satellite_Rewards_Aggregate_Order_By>;
  satellite_website_max_length?: InputMaybe<Order_By>;
  satellites_aggregate?: InputMaybe<Satellite_Aggregate_Order_By>;
  take_satellites_snapshot_paused?: InputMaybe<Order_By>;
  undelegate_from_satellite_paused?: InputMaybe<Order_By>;
  unregister_as_satellite_paused?: InputMaybe<Order_By>;
  update_satellite_record_paused?: InputMaybe<Order_By>;
  whitelist_contracts_aggregate?: InputMaybe<Delegation_Whitelist_Contract_Aggregate_Order_By>;
};

/** columns and relationships of "delegation_record" */
export type Delegation_Record = {
  __typename?: 'delegation_record';
  /** An object relationship */
  delegation: Delegation;
  delegation_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  satellite: Satellite;
  satellite_id: Scalars['bigint']['output'];
  satellite_registration_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Maven_User;
  user_id: Scalars['bigint']['output'];
};

/** aggregated selection of "delegation_record" */
export type Delegation_Record_Aggregate = {
  __typename?: 'delegation_record_aggregate';
  aggregate?: Maybe<Delegation_Record_Aggregate_Fields>;
  nodes: Array<Delegation_Record>;
};

export type Delegation_Record_Aggregate_Bool_Exp = {
  count?: InputMaybe<Delegation_Record_Aggregate_Bool_Exp_Count>;
};

export type Delegation_Record_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Delegation_Record_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Delegation_Record_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "delegation_record" */
export type Delegation_Record_Aggregate_Fields = {
  __typename?: 'delegation_record_aggregate_fields';
  avg?: Maybe<Delegation_Record_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Delegation_Record_Max_Fields>;
  min?: Maybe<Delegation_Record_Min_Fields>;
  stddev?: Maybe<Delegation_Record_Stddev_Fields>;
  stddev_pop?: Maybe<Delegation_Record_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Delegation_Record_Stddev_Samp_Fields>;
  sum?: Maybe<Delegation_Record_Sum_Fields>;
  var_pop?: Maybe<Delegation_Record_Var_Pop_Fields>;
  var_samp?: Maybe<Delegation_Record_Var_Samp_Fields>;
  variance?: Maybe<Delegation_Record_Variance_Fields>;
};


/** aggregate fields of "delegation_record" */
export type Delegation_Record_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Delegation_Record_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "delegation_record" */
export type Delegation_Record_Aggregate_Order_By = {
  avg?: InputMaybe<Delegation_Record_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Delegation_Record_Max_Order_By>;
  min?: InputMaybe<Delegation_Record_Min_Order_By>;
  stddev?: InputMaybe<Delegation_Record_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Delegation_Record_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Delegation_Record_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Delegation_Record_Sum_Order_By>;
  var_pop?: InputMaybe<Delegation_Record_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Delegation_Record_Var_Samp_Order_By>;
  variance?: InputMaybe<Delegation_Record_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Delegation_Record_Avg_Fields = {
  __typename?: 'delegation_record_avg_fields';
  delegation_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "delegation_record" */
export type Delegation_Record_Avg_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "delegation_record". All fields are combined with a logical 'AND'. */
export type Delegation_Record_Bool_Exp = {
  _and?: InputMaybe<Array<Delegation_Record_Bool_Exp>>;
  _not?: InputMaybe<Delegation_Record_Bool_Exp>;
  _or?: InputMaybe<Array<Delegation_Record_Bool_Exp>>;
  delegation?: InputMaybe<Delegation_Bool_Exp>;
  delegation_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  satellite?: InputMaybe<Satellite_Bool_Exp>;
  satellite_id?: InputMaybe<Bigint_Comparison_Exp>;
  satellite_registration_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Maven_User_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Delegation_Record_Max_Fields = {
  __typename?: 'delegation_record_max_fields';
  delegation_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  satellite_id?: Maybe<Scalars['bigint']['output']>;
  satellite_registration_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "delegation_record" */
export type Delegation_Record_Max_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_id?: InputMaybe<Order_By>;
  satellite_registration_timestamp?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Delegation_Record_Min_Fields = {
  __typename?: 'delegation_record_min_fields';
  delegation_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  satellite_id?: Maybe<Scalars['bigint']['output']>;
  satellite_registration_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "delegation_record" */
export type Delegation_Record_Min_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_id?: InputMaybe<Order_By>;
  satellite_registration_timestamp?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "delegation_record". */
export type Delegation_Record_Order_By = {
  delegation?: InputMaybe<Delegation_Order_By>;
  delegation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite?: InputMaybe<Satellite_Order_By>;
  satellite_id?: InputMaybe<Order_By>;
  satellite_registration_timestamp?: InputMaybe<Order_By>;
  user?: InputMaybe<Maven_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "delegation_record" */
export enum Delegation_Record_Select_Column {
  /** column name */
  DelegationId = 'delegation_id',
  /** column name */
  Id = 'id',
  /** column name */
  SatelliteId = 'satellite_id',
  /** column name */
  SatelliteRegistrationTimestamp = 'satellite_registration_timestamp',
  /** column name */
  UserId = 'user_id'
}

/** aggregate stddev on columns */
export type Delegation_Record_Stddev_Fields = {
  __typename?: 'delegation_record_stddev_fields';
  delegation_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "delegation_record" */
export type Delegation_Record_Stddev_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Delegation_Record_Stddev_Pop_Fields = {
  __typename?: 'delegation_record_stddev_pop_fields';
  delegation_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "delegation_record" */
export type Delegation_Record_Stddev_Pop_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Delegation_Record_Stddev_Samp_Fields = {
  __typename?: 'delegation_record_stddev_samp_fields';
  delegation_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "delegation_record" */
export type Delegation_Record_Stddev_Samp_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "delegation_record" */
export type Delegation_Record_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Delegation_Record_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Delegation_Record_Stream_Cursor_Value_Input = {
  delegation_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  satellite_id?: InputMaybe<Scalars['bigint']['input']>;
  satellite_registration_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Delegation_Record_Sum_Fields = {
  __typename?: 'delegation_record_sum_fields';
  delegation_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  satellite_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "delegation_record" */
export type Delegation_Record_Sum_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Delegation_Record_Var_Pop_Fields = {
  __typename?: 'delegation_record_var_pop_fields';
  delegation_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "delegation_record" */
export type Delegation_Record_Var_Pop_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Delegation_Record_Var_Samp_Fields = {
  __typename?: 'delegation_record_var_samp_fields';
  delegation_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "delegation_record" */
export type Delegation_Record_Var_Samp_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Delegation_Record_Variance_Fields = {
  __typename?: 'delegation_record_variance_fields';
  delegation_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "delegation_record" */
export type Delegation_Record_Variance_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "delegation" */
export enum Delegation_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Admin = 'admin',
  /** column name */
  DelegateToSatellitePaused = 'delegate_to_satellite_paused',
  /** column name */
  DelegationRatio = 'delegation_ratio',
  /** column name */
  DistributeRewardPaused = 'distribute_reward_paused',
  /** column name */
  GovernanceId = 'governance_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  MaxSatellites = 'max_satellites',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MinimumSmvnBalance = 'minimum_smvn_balance',
  /** column name */
  Network = 'network',
  /** column name */
  RegisterAsSatellitePaused = 'register_as_satellite_paused',
  /** column name */
  SatelliteDescriptionMaxLength = 'satellite_description_max_length',
  /** column name */
  SatelliteImageMaxLength = 'satellite_image_max_length',
  /** column name */
  SatelliteNameMaxLength = 'satellite_name_max_length',
  /** column name */
  SatelliteWebsiteMaxLength = 'satellite_website_max_length',
  /** column name */
  TakeSatellitesSnapshotPaused = 'take_satellites_snapshot_paused',
  /** column name */
  UndelegateFromSatellitePaused = 'undelegate_from_satellite_paused',
  /** column name */
  UnregisterAsSatellitePaused = 'unregister_as_satellite_paused',
  /** column name */
  UpdateSatelliteRecordPaused = 'update_satellite_record_paused'
}

/** select "delegation_aggregate_bool_exp_avg_arguments_columns" columns of table "delegation" */
export enum Delegation_Select_Column_Delegation_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  MinimumSmvnBalance = 'minimum_smvn_balance'
}

/** select "delegation_aggregate_bool_exp_bool_and_arguments_columns" columns of table "delegation" */
export enum Delegation_Select_Column_Delegation_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DelegateToSatellitePaused = 'delegate_to_satellite_paused',
  /** column name */
  DistributeRewardPaused = 'distribute_reward_paused',
  /** column name */
  RegisterAsSatellitePaused = 'register_as_satellite_paused',
  /** column name */
  TakeSatellitesSnapshotPaused = 'take_satellites_snapshot_paused',
  /** column name */
  UndelegateFromSatellitePaused = 'undelegate_from_satellite_paused',
  /** column name */
  UnregisterAsSatellitePaused = 'unregister_as_satellite_paused',
  /** column name */
  UpdateSatelliteRecordPaused = 'update_satellite_record_paused'
}

/** select "delegation_aggregate_bool_exp_bool_or_arguments_columns" columns of table "delegation" */
export enum Delegation_Select_Column_Delegation_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DelegateToSatellitePaused = 'delegate_to_satellite_paused',
  /** column name */
  DistributeRewardPaused = 'distribute_reward_paused',
  /** column name */
  RegisterAsSatellitePaused = 'register_as_satellite_paused',
  /** column name */
  TakeSatellitesSnapshotPaused = 'take_satellites_snapshot_paused',
  /** column name */
  UndelegateFromSatellitePaused = 'undelegate_from_satellite_paused',
  /** column name */
  UnregisterAsSatellitePaused = 'unregister_as_satellite_paused',
  /** column name */
  UpdateSatelliteRecordPaused = 'update_satellite_record_paused'
}

/** select "delegation_aggregate_bool_exp_corr_arguments_columns" columns of table "delegation" */
export enum Delegation_Select_Column_Delegation_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  MinimumSmvnBalance = 'minimum_smvn_balance'
}

/** select "delegation_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "delegation" */
export enum Delegation_Select_Column_Delegation_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  MinimumSmvnBalance = 'minimum_smvn_balance'
}

/** select "delegation_aggregate_bool_exp_max_arguments_columns" columns of table "delegation" */
export enum Delegation_Select_Column_Delegation_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  MinimumSmvnBalance = 'minimum_smvn_balance'
}

/** select "delegation_aggregate_bool_exp_min_arguments_columns" columns of table "delegation" */
export enum Delegation_Select_Column_Delegation_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  MinimumSmvnBalance = 'minimum_smvn_balance'
}

/** select "delegation_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "delegation" */
export enum Delegation_Select_Column_Delegation_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  MinimumSmvnBalance = 'minimum_smvn_balance'
}

/** select "delegation_aggregate_bool_exp_sum_arguments_columns" columns of table "delegation" */
export enum Delegation_Select_Column_Delegation_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  MinimumSmvnBalance = 'minimum_smvn_balance'
}

/** select "delegation_aggregate_bool_exp_var_samp_arguments_columns" columns of table "delegation" */
export enum Delegation_Select_Column_Delegation_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  MinimumSmvnBalance = 'minimum_smvn_balance'
}

/** aggregate stddev on columns */
export type Delegation_Stddev_Fields = {
  __typename?: 'delegation_stddev_fields';
  delegation_ratio?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_satellites?: Maybe<Scalars['Float']['output']>;
  minimum_smvn_balance?: Maybe<Scalars['Float']['output']>;
  satellite_description_max_length?: Maybe<Scalars['Float']['output']>;
  satellite_image_max_length?: Maybe<Scalars['Float']['output']>;
  satellite_name_max_length?: Maybe<Scalars['Float']['output']>;
  satellite_website_max_length?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "delegation" */
export type Delegation_Stddev_Order_By = {
  delegation_ratio?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_satellites?: InputMaybe<Order_By>;
  minimum_smvn_balance?: InputMaybe<Order_By>;
  satellite_description_max_length?: InputMaybe<Order_By>;
  satellite_image_max_length?: InputMaybe<Order_By>;
  satellite_name_max_length?: InputMaybe<Order_By>;
  satellite_website_max_length?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Delegation_Stddev_Pop_Fields = {
  __typename?: 'delegation_stddev_pop_fields';
  delegation_ratio?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_satellites?: Maybe<Scalars['Float']['output']>;
  minimum_smvn_balance?: Maybe<Scalars['Float']['output']>;
  satellite_description_max_length?: Maybe<Scalars['Float']['output']>;
  satellite_image_max_length?: Maybe<Scalars['Float']['output']>;
  satellite_name_max_length?: Maybe<Scalars['Float']['output']>;
  satellite_website_max_length?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "delegation" */
export type Delegation_Stddev_Pop_Order_By = {
  delegation_ratio?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_satellites?: InputMaybe<Order_By>;
  minimum_smvn_balance?: InputMaybe<Order_By>;
  satellite_description_max_length?: InputMaybe<Order_By>;
  satellite_image_max_length?: InputMaybe<Order_By>;
  satellite_name_max_length?: InputMaybe<Order_By>;
  satellite_website_max_length?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Delegation_Stddev_Samp_Fields = {
  __typename?: 'delegation_stddev_samp_fields';
  delegation_ratio?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_satellites?: Maybe<Scalars['Float']['output']>;
  minimum_smvn_balance?: Maybe<Scalars['Float']['output']>;
  satellite_description_max_length?: Maybe<Scalars['Float']['output']>;
  satellite_image_max_length?: Maybe<Scalars['Float']['output']>;
  satellite_name_max_length?: Maybe<Scalars['Float']['output']>;
  satellite_website_max_length?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "delegation" */
export type Delegation_Stddev_Samp_Order_By = {
  delegation_ratio?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_satellites?: InputMaybe<Order_By>;
  minimum_smvn_balance?: InputMaybe<Order_By>;
  satellite_description_max_length?: InputMaybe<Order_By>;
  satellite_image_max_length?: InputMaybe<Order_By>;
  satellite_name_max_length?: InputMaybe<Order_By>;
  satellite_website_max_length?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "delegation" */
export type Delegation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Delegation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Delegation_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['String']['input']>;
  delegate_to_satellite_paused?: InputMaybe<Scalars['Boolean']['input']>;
  delegation_ratio?: InputMaybe<Scalars['smallint']['input']>;
  distribute_reward_paused?: InputMaybe<Scalars['Boolean']['input']>;
  governance_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  max_satellites?: InputMaybe<Scalars['smallint']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  minimum_smvn_balance?: InputMaybe<Scalars['float8']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  register_as_satellite_paused?: InputMaybe<Scalars['Boolean']['input']>;
  satellite_description_max_length?: InputMaybe<Scalars['smallint']['input']>;
  satellite_image_max_length?: InputMaybe<Scalars['smallint']['input']>;
  satellite_name_max_length?: InputMaybe<Scalars['smallint']['input']>;
  satellite_website_max_length?: InputMaybe<Scalars['smallint']['input']>;
  take_satellites_snapshot_paused?: InputMaybe<Scalars['Boolean']['input']>;
  undelegate_from_satellite_paused?: InputMaybe<Scalars['Boolean']['input']>;
  unregister_as_satellite_paused?: InputMaybe<Scalars['Boolean']['input']>;
  update_satellite_record_paused?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Delegation_Sum_Fields = {
  __typename?: 'delegation_sum_fields';
  delegation_ratio?: Maybe<Scalars['smallint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  max_satellites?: Maybe<Scalars['smallint']['output']>;
  minimum_smvn_balance?: Maybe<Scalars['float8']['output']>;
  satellite_description_max_length?: Maybe<Scalars['smallint']['output']>;
  satellite_image_max_length?: Maybe<Scalars['smallint']['output']>;
  satellite_name_max_length?: Maybe<Scalars['smallint']['output']>;
  satellite_website_max_length?: Maybe<Scalars['smallint']['output']>;
};

/** order by sum() on columns of table "delegation" */
export type Delegation_Sum_Order_By = {
  delegation_ratio?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_satellites?: InputMaybe<Order_By>;
  minimum_smvn_balance?: InputMaybe<Order_By>;
  satellite_description_max_length?: InputMaybe<Order_By>;
  satellite_image_max_length?: InputMaybe<Order_By>;
  satellite_name_max_length?: InputMaybe<Order_By>;
  satellite_website_max_length?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Delegation_Var_Pop_Fields = {
  __typename?: 'delegation_var_pop_fields';
  delegation_ratio?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_satellites?: Maybe<Scalars['Float']['output']>;
  minimum_smvn_balance?: Maybe<Scalars['Float']['output']>;
  satellite_description_max_length?: Maybe<Scalars['Float']['output']>;
  satellite_image_max_length?: Maybe<Scalars['Float']['output']>;
  satellite_name_max_length?: Maybe<Scalars['Float']['output']>;
  satellite_website_max_length?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "delegation" */
export type Delegation_Var_Pop_Order_By = {
  delegation_ratio?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_satellites?: InputMaybe<Order_By>;
  minimum_smvn_balance?: InputMaybe<Order_By>;
  satellite_description_max_length?: InputMaybe<Order_By>;
  satellite_image_max_length?: InputMaybe<Order_By>;
  satellite_name_max_length?: InputMaybe<Order_By>;
  satellite_website_max_length?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Delegation_Var_Samp_Fields = {
  __typename?: 'delegation_var_samp_fields';
  delegation_ratio?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_satellites?: Maybe<Scalars['Float']['output']>;
  minimum_smvn_balance?: Maybe<Scalars['Float']['output']>;
  satellite_description_max_length?: Maybe<Scalars['Float']['output']>;
  satellite_image_max_length?: Maybe<Scalars['Float']['output']>;
  satellite_name_max_length?: Maybe<Scalars['Float']['output']>;
  satellite_website_max_length?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "delegation" */
export type Delegation_Var_Samp_Order_By = {
  delegation_ratio?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_satellites?: InputMaybe<Order_By>;
  minimum_smvn_balance?: InputMaybe<Order_By>;
  satellite_description_max_length?: InputMaybe<Order_By>;
  satellite_image_max_length?: InputMaybe<Order_By>;
  satellite_name_max_length?: InputMaybe<Order_By>;
  satellite_website_max_length?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Delegation_Variance_Fields = {
  __typename?: 'delegation_variance_fields';
  delegation_ratio?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_satellites?: Maybe<Scalars['Float']['output']>;
  minimum_smvn_balance?: Maybe<Scalars['Float']['output']>;
  satellite_description_max_length?: Maybe<Scalars['Float']['output']>;
  satellite_image_max_length?: Maybe<Scalars['Float']['output']>;
  satellite_name_max_length?: Maybe<Scalars['Float']['output']>;
  satellite_website_max_length?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "delegation" */
export type Delegation_Variance_Order_By = {
  delegation_ratio?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_satellites?: InputMaybe<Order_By>;
  minimum_smvn_balance?: InputMaybe<Order_By>;
  satellite_description_max_length?: InputMaybe<Order_By>;
  satellite_image_max_length?: InputMaybe<Order_By>;
  satellite_name_max_length?: InputMaybe<Order_By>;
  satellite_website_max_length?: InputMaybe<Order_By>;
};

/** columns and relationships of "delegation_whitelist_contract" */
export type Delegation_Whitelist_Contract = {
  __typename?: 'delegation_whitelist_contract';
  /** An object relationship */
  contract: Delegation;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "delegation_whitelist_contract" */
export type Delegation_Whitelist_Contract_Aggregate = {
  __typename?: 'delegation_whitelist_contract_aggregate';
  aggregate?: Maybe<Delegation_Whitelist_Contract_Aggregate_Fields>;
  nodes: Array<Delegation_Whitelist_Contract>;
};

export type Delegation_Whitelist_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Delegation_Whitelist_Contract_Aggregate_Bool_Exp_Count>;
};

export type Delegation_Whitelist_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Delegation_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Delegation_Whitelist_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "delegation_whitelist_contract" */
export type Delegation_Whitelist_Contract_Aggregate_Fields = {
  __typename?: 'delegation_whitelist_contract_aggregate_fields';
  avg?: Maybe<Delegation_Whitelist_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Delegation_Whitelist_Contract_Max_Fields>;
  min?: Maybe<Delegation_Whitelist_Contract_Min_Fields>;
  stddev?: Maybe<Delegation_Whitelist_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Delegation_Whitelist_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Delegation_Whitelist_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Delegation_Whitelist_Contract_Sum_Fields>;
  var_pop?: Maybe<Delegation_Whitelist_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Delegation_Whitelist_Contract_Var_Samp_Fields>;
  variance?: Maybe<Delegation_Whitelist_Contract_Variance_Fields>;
};


/** aggregate fields of "delegation_whitelist_contract" */
export type Delegation_Whitelist_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Delegation_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "delegation_whitelist_contract" */
export type Delegation_Whitelist_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Delegation_Whitelist_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Delegation_Whitelist_Contract_Max_Order_By>;
  min?: InputMaybe<Delegation_Whitelist_Contract_Min_Order_By>;
  stddev?: InputMaybe<Delegation_Whitelist_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Delegation_Whitelist_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Delegation_Whitelist_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Delegation_Whitelist_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Delegation_Whitelist_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Delegation_Whitelist_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Delegation_Whitelist_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Delegation_Whitelist_Contract_Avg_Fields = {
  __typename?: 'delegation_whitelist_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "delegation_whitelist_contract" */
export type Delegation_Whitelist_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "delegation_whitelist_contract". All fields are combined with a logical 'AND'. */
export type Delegation_Whitelist_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Delegation_Whitelist_Contract_Bool_Exp>>;
  _not?: InputMaybe<Delegation_Whitelist_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Delegation_Whitelist_Contract_Bool_Exp>>;
  contract?: InputMaybe<Delegation_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Delegation_Whitelist_Contract_Max_Fields = {
  __typename?: 'delegation_whitelist_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "delegation_whitelist_contract" */
export type Delegation_Whitelist_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Delegation_Whitelist_Contract_Min_Fields = {
  __typename?: 'delegation_whitelist_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "delegation_whitelist_contract" */
export type Delegation_Whitelist_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "delegation_whitelist_contract". */
export type Delegation_Whitelist_Contract_Order_By = {
  contract?: InputMaybe<Delegation_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "delegation_whitelist_contract" */
export enum Delegation_Whitelist_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Delegation_Whitelist_Contract_Stddev_Fields = {
  __typename?: 'delegation_whitelist_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "delegation_whitelist_contract" */
export type Delegation_Whitelist_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Delegation_Whitelist_Contract_Stddev_Pop_Fields = {
  __typename?: 'delegation_whitelist_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "delegation_whitelist_contract" */
export type Delegation_Whitelist_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Delegation_Whitelist_Contract_Stddev_Samp_Fields = {
  __typename?: 'delegation_whitelist_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "delegation_whitelist_contract" */
export type Delegation_Whitelist_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "delegation_whitelist_contract" */
export type Delegation_Whitelist_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Delegation_Whitelist_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Delegation_Whitelist_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Delegation_Whitelist_Contract_Sum_Fields = {
  __typename?: 'delegation_whitelist_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "delegation_whitelist_contract" */
export type Delegation_Whitelist_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Delegation_Whitelist_Contract_Var_Pop_Fields = {
  __typename?: 'delegation_whitelist_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "delegation_whitelist_contract" */
export type Delegation_Whitelist_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Delegation_Whitelist_Contract_Var_Samp_Fields = {
  __typename?: 'delegation_whitelist_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "delegation_whitelist_contract" */
export type Delegation_Whitelist_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Delegation_Whitelist_Contract_Variance_Fields = {
  __typename?: 'delegation_whitelist_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "delegation_whitelist_contract" */
export type Delegation_Whitelist_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "dipdup_contract" */
export type Dipdup_Contract = {
  __typename?: 'dipdup_contract';
  address?: Maybe<Scalars['String']['output']>;
  code_hash?: Maybe<Scalars['bigint']['output']>;
  created_at: Scalars['timestamptz']['output'];
  kind: Scalars['String']['output'];
  name: Scalars['String']['output'];
  typename?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "dipdup_contract" */
export type Dipdup_Contract_Aggregate = {
  __typename?: 'dipdup_contract_aggregate';
  aggregate?: Maybe<Dipdup_Contract_Aggregate_Fields>;
  nodes: Array<Dipdup_Contract>;
};

/** aggregate fields of "dipdup_contract" */
export type Dipdup_Contract_Aggregate_Fields = {
  __typename?: 'dipdup_contract_aggregate_fields';
  avg?: Maybe<Dipdup_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Dipdup_Contract_Max_Fields>;
  min?: Maybe<Dipdup_Contract_Min_Fields>;
  stddev?: Maybe<Dipdup_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Dipdup_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Dipdup_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Dipdup_Contract_Sum_Fields>;
  var_pop?: Maybe<Dipdup_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Dipdup_Contract_Var_Samp_Fields>;
  variance?: Maybe<Dipdup_Contract_Variance_Fields>;
};


/** aggregate fields of "dipdup_contract" */
export type Dipdup_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dipdup_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Dipdup_Contract_Avg_Fields = {
  __typename?: 'dipdup_contract_avg_fields';
  code_hash?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "dipdup_contract". All fields are combined with a logical 'AND'. */
export type Dipdup_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Dipdup_Contract_Bool_Exp>>;
  _not?: InputMaybe<Dipdup_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Dipdup_Contract_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  code_hash?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  typename?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Dipdup_Contract_Max_Fields = {
  __typename?: 'dipdup_contract_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  code_hash?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  typename?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** columns and relationships of "dipdup_contract_metadata" */
export type Dipdup_Contract_Metadata = {
  __typename?: 'dipdup_contract_metadata';
  contract: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  network: Scalars['String']['output'];
  update_id: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "dipdup_contract_metadata" */
export type Dipdup_Contract_MetadataMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "dipdup_contract_metadata" */
export type Dipdup_Contract_Metadata_Aggregate = {
  __typename?: 'dipdup_contract_metadata_aggregate';
  aggregate?: Maybe<Dipdup_Contract_Metadata_Aggregate_Fields>;
  nodes: Array<Dipdup_Contract_Metadata>;
};

/** aggregate fields of "dipdup_contract_metadata" */
export type Dipdup_Contract_Metadata_Aggregate_Fields = {
  __typename?: 'dipdup_contract_metadata_aggregate_fields';
  avg?: Maybe<Dipdup_Contract_Metadata_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Dipdup_Contract_Metadata_Max_Fields>;
  min?: Maybe<Dipdup_Contract_Metadata_Min_Fields>;
  stddev?: Maybe<Dipdup_Contract_Metadata_Stddev_Fields>;
  stddev_pop?: Maybe<Dipdup_Contract_Metadata_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Dipdup_Contract_Metadata_Stddev_Samp_Fields>;
  sum?: Maybe<Dipdup_Contract_Metadata_Sum_Fields>;
  var_pop?: Maybe<Dipdup_Contract_Metadata_Var_Pop_Fields>;
  var_samp?: Maybe<Dipdup_Contract_Metadata_Var_Samp_Fields>;
  variance?: Maybe<Dipdup_Contract_Metadata_Variance_Fields>;
};


/** aggregate fields of "dipdup_contract_metadata" */
export type Dipdup_Contract_Metadata_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dipdup_Contract_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Dipdup_Contract_Metadata_Avg_Fields = {
  __typename?: 'dipdup_contract_metadata_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  update_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "dipdup_contract_metadata". All fields are combined with a logical 'AND'. */
export type Dipdup_Contract_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Dipdup_Contract_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Dipdup_Contract_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Dipdup_Contract_Metadata_Bool_Exp>>;
  contract?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
  update_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Dipdup_Contract_Metadata_Max_Fields = {
  __typename?: 'dipdup_contract_metadata_max_fields';
  contract?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  update_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Dipdup_Contract_Metadata_Min_Fields = {
  __typename?: 'dipdup_contract_metadata_min_fields';
  contract?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  update_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "dipdup_contract_metadata". */
export type Dipdup_Contract_Metadata_Order_By = {
  contract?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  update_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "dipdup_contract_metadata" */
export enum Dipdup_Contract_Metadata_Select_Column {
  /** column name */
  Contract = 'contract',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Network = 'network',
  /** column name */
  UpdateId = 'update_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Dipdup_Contract_Metadata_Stddev_Fields = {
  __typename?: 'dipdup_contract_metadata_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  update_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Dipdup_Contract_Metadata_Stddev_Pop_Fields = {
  __typename?: 'dipdup_contract_metadata_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  update_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Dipdup_Contract_Metadata_Stddev_Samp_Fields = {
  __typename?: 'dipdup_contract_metadata_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  update_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "dipdup_contract_metadata" */
export type Dipdup_Contract_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dipdup_Contract_Metadata_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dipdup_Contract_Metadata_Stream_Cursor_Value_Input = {
  contract?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  update_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Dipdup_Contract_Metadata_Sum_Fields = {
  __typename?: 'dipdup_contract_metadata_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  update_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Dipdup_Contract_Metadata_Var_Pop_Fields = {
  __typename?: 'dipdup_contract_metadata_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  update_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Dipdup_Contract_Metadata_Var_Samp_Fields = {
  __typename?: 'dipdup_contract_metadata_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  update_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Dipdup_Contract_Metadata_Variance_Fields = {
  __typename?: 'dipdup_contract_metadata_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  update_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Dipdup_Contract_Min_Fields = {
  __typename?: 'dipdup_contract_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  code_hash?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  typename?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "dipdup_contract". */
export type Dipdup_Contract_Order_By = {
  address?: InputMaybe<Order_By>;
  code_hash?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  typename?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "dipdup_contract" */
export enum Dipdup_Contract_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  CodeHash = 'code_hash',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Kind = 'kind',
  /** column name */
  Name = 'name',
  /** column name */
  Typename = 'typename',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Dipdup_Contract_Stddev_Fields = {
  __typename?: 'dipdup_contract_stddev_fields';
  code_hash?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Dipdup_Contract_Stddev_Pop_Fields = {
  __typename?: 'dipdup_contract_stddev_pop_fields';
  code_hash?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Dipdup_Contract_Stddev_Samp_Fields = {
  __typename?: 'dipdup_contract_stddev_samp_fields';
  code_hash?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "dipdup_contract" */
export type Dipdup_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dipdup_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dipdup_Contract_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  code_hash?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  typename?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Dipdup_Contract_Sum_Fields = {
  __typename?: 'dipdup_contract_sum_fields';
  code_hash?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Dipdup_Contract_Var_Pop_Fields = {
  __typename?: 'dipdup_contract_var_pop_fields';
  code_hash?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Dipdup_Contract_Var_Samp_Fields = {
  __typename?: 'dipdup_contract_var_samp_fields';
  code_hash?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Dipdup_Contract_Variance_Fields = {
  __typename?: 'dipdup_contract_variance_fields';
  code_hash?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "dipdup_exception" */
export type Dipdup_Exception = {
  __typename?: 'dipdup_exception';
  id: Scalars['bigint']['output'];
  timestamp: Scalars['timestamptz']['output'];
  trace: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "dipdup_exception" */
export type Dipdup_Exception_Aggregate = {
  __typename?: 'dipdup_exception_aggregate';
  aggregate?: Maybe<Dipdup_Exception_Aggregate_Fields>;
  nodes: Array<Dipdup_Exception>;
};

/** aggregate fields of "dipdup_exception" */
export type Dipdup_Exception_Aggregate_Fields = {
  __typename?: 'dipdup_exception_aggregate_fields';
  avg?: Maybe<Dipdup_Exception_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Dipdup_Exception_Max_Fields>;
  min?: Maybe<Dipdup_Exception_Min_Fields>;
  stddev?: Maybe<Dipdup_Exception_Stddev_Fields>;
  stddev_pop?: Maybe<Dipdup_Exception_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Dipdup_Exception_Stddev_Samp_Fields>;
  sum?: Maybe<Dipdup_Exception_Sum_Fields>;
  var_pop?: Maybe<Dipdup_Exception_Var_Pop_Fields>;
  var_samp?: Maybe<Dipdup_Exception_Var_Samp_Fields>;
  variance?: Maybe<Dipdup_Exception_Variance_Fields>;
};


/** aggregate fields of "dipdup_exception" */
export type Dipdup_Exception_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dipdup_Exception_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Dipdup_Exception_Avg_Fields = {
  __typename?: 'dipdup_exception_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "dipdup_exception". All fields are combined with a logical 'AND'. */
export type Dipdup_Exception_Bool_Exp = {
  _and?: InputMaybe<Array<Dipdup_Exception_Bool_Exp>>;
  _not?: InputMaybe<Dipdup_Exception_Bool_Exp>;
  _or?: InputMaybe<Array<Dipdup_Exception_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  trace?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Dipdup_Exception_Max_Fields = {
  __typename?: 'dipdup_exception_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  trace?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Dipdup_Exception_Min_Fields = {
  __typename?: 'dipdup_exception_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  trace?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "dipdup_exception". */
export type Dipdup_Exception_Order_By = {
  id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  trace?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "dipdup_exception" */
export enum Dipdup_Exception_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Trace = 'trace',
  /** column name */
  Type = 'type',
  /** column name */
  Value = 'value'
}

/** aggregate stddev on columns */
export type Dipdup_Exception_Stddev_Fields = {
  __typename?: 'dipdup_exception_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Dipdup_Exception_Stddev_Pop_Fields = {
  __typename?: 'dipdup_exception_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Dipdup_Exception_Stddev_Samp_Fields = {
  __typename?: 'dipdup_exception_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "dipdup_exception" */
export type Dipdup_Exception_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dipdup_Exception_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dipdup_Exception_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  trace?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Dipdup_Exception_Sum_Fields = {
  __typename?: 'dipdup_exception_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Dipdup_Exception_Var_Pop_Fields = {
  __typename?: 'dipdup_exception_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Dipdup_Exception_Var_Samp_Fields = {
  __typename?: 'dipdup_exception_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Dipdup_Exception_Variance_Fields = {
  __typename?: 'dipdup_exception_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "dipdup_head" */
export type Dipdup_Head = {
  __typename?: 'dipdup_head';
  created_at: Scalars['timestamptz']['output'];
  hash?: Maybe<Scalars['String']['output']>;
  level: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  timestamp: Scalars['timestamptz']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "dipdup_head" */
export type Dipdup_Head_Aggregate = {
  __typename?: 'dipdup_head_aggregate';
  aggregate?: Maybe<Dipdup_Head_Aggregate_Fields>;
  nodes: Array<Dipdup_Head>;
};

/** aggregate fields of "dipdup_head" */
export type Dipdup_Head_Aggregate_Fields = {
  __typename?: 'dipdup_head_aggregate_fields';
  avg?: Maybe<Dipdup_Head_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Dipdup_Head_Max_Fields>;
  min?: Maybe<Dipdup_Head_Min_Fields>;
  stddev?: Maybe<Dipdup_Head_Stddev_Fields>;
  stddev_pop?: Maybe<Dipdup_Head_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Dipdup_Head_Stddev_Samp_Fields>;
  sum?: Maybe<Dipdup_Head_Sum_Fields>;
  var_pop?: Maybe<Dipdup_Head_Var_Pop_Fields>;
  var_samp?: Maybe<Dipdup_Head_Var_Samp_Fields>;
  variance?: Maybe<Dipdup_Head_Variance_Fields>;
};


/** aggregate fields of "dipdup_head" */
export type Dipdup_Head_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dipdup_Head_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Dipdup_Head_Avg_Fields = {
  __typename?: 'dipdup_head_avg_fields';
  level?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "dipdup_head". All fields are combined with a logical 'AND'. */
export type Dipdup_Head_Bool_Exp = {
  _and?: InputMaybe<Array<Dipdup_Head_Bool_Exp>>;
  _not?: InputMaybe<Dipdup_Head_Bool_Exp>;
  _or?: InputMaybe<Array<Dipdup_Head_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hash?: InputMaybe<String_Comparison_Exp>;
  level?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Dipdup_Head_Max_Fields = {
  __typename?: 'dipdup_head_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Dipdup_Head_Min_Fields = {
  __typename?: 'dipdup_head_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "dipdup_head". */
export type Dipdup_Head_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hash?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "dipdup_head" */
export enum Dipdup_Head_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Hash = 'hash',
  /** column name */
  Level = 'level',
  /** column name */
  Name = 'name',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Dipdup_Head_Stddev_Fields = {
  __typename?: 'dipdup_head_stddev_fields';
  level?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Dipdup_Head_Stddev_Pop_Fields = {
  __typename?: 'dipdup_head_stddev_pop_fields';
  level?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Dipdup_Head_Stddev_Samp_Fields = {
  __typename?: 'dipdup_head_stddev_samp_fields';
  level?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "dipdup_head" */
export type Dipdup_Head_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dipdup_Head_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dipdup_Head_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Dipdup_Head_Sum_Fields = {
  __typename?: 'dipdup_head_sum_fields';
  level?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Dipdup_Head_Var_Pop_Fields = {
  __typename?: 'dipdup_head_var_pop_fields';
  level?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Dipdup_Head_Var_Samp_Fields = {
  __typename?: 'dipdup_head_var_samp_fields';
  level?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Dipdup_Head_Variance_Fields = {
  __typename?: 'dipdup_head_variance_fields';
  level?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "dipdup_index" */
export type Dipdup_Index = {
  __typename?: 'dipdup_index';
  config_hash?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  level: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  template?: Maybe<Scalars['String']['output']>;
  template_values?: Maybe<Scalars['jsonb']['output']>;
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "dipdup_index" */
export type Dipdup_IndexTemplate_ValuesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "dipdup_index" */
export type Dipdup_Index_Aggregate = {
  __typename?: 'dipdup_index_aggregate';
  aggregate?: Maybe<Dipdup_Index_Aggregate_Fields>;
  nodes: Array<Dipdup_Index>;
};

/** aggregate fields of "dipdup_index" */
export type Dipdup_Index_Aggregate_Fields = {
  __typename?: 'dipdup_index_aggregate_fields';
  avg?: Maybe<Dipdup_Index_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Dipdup_Index_Max_Fields>;
  min?: Maybe<Dipdup_Index_Min_Fields>;
  stddev?: Maybe<Dipdup_Index_Stddev_Fields>;
  stddev_pop?: Maybe<Dipdup_Index_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Dipdup_Index_Stddev_Samp_Fields>;
  sum?: Maybe<Dipdup_Index_Sum_Fields>;
  var_pop?: Maybe<Dipdup_Index_Var_Pop_Fields>;
  var_samp?: Maybe<Dipdup_Index_Var_Samp_Fields>;
  variance?: Maybe<Dipdup_Index_Variance_Fields>;
};


/** aggregate fields of "dipdup_index" */
export type Dipdup_Index_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dipdup_Index_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Dipdup_Index_Avg_Fields = {
  __typename?: 'dipdup_index_avg_fields';
  level?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "dipdup_index". All fields are combined with a logical 'AND'. */
export type Dipdup_Index_Bool_Exp = {
  _and?: InputMaybe<Array<Dipdup_Index_Bool_Exp>>;
  _not?: InputMaybe<Dipdup_Index_Bool_Exp>;
  _or?: InputMaybe<Array<Dipdup_Index_Bool_Exp>>;
  config_hash?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  level?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  template?: InputMaybe<String_Comparison_Exp>;
  template_values?: InputMaybe<Jsonb_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Dipdup_Index_Max_Fields = {
  __typename?: 'dipdup_index_max_fields';
  config_hash?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  template?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Dipdup_Index_Min_Fields = {
  __typename?: 'dipdup_index_min_fields';
  config_hash?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  template?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "dipdup_index". */
export type Dipdup_Index_Order_By = {
  config_hash?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  template?: InputMaybe<Order_By>;
  template_values?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "dipdup_index" */
export enum Dipdup_Index_Select_Column {
  /** column name */
  ConfigHash = 'config_hash',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Level = 'level',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  Template = 'template',
  /** column name */
  TemplateValues = 'template_values',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Dipdup_Index_Stddev_Fields = {
  __typename?: 'dipdup_index_stddev_fields';
  level?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Dipdup_Index_Stddev_Pop_Fields = {
  __typename?: 'dipdup_index_stddev_pop_fields';
  level?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Dipdup_Index_Stddev_Samp_Fields = {
  __typename?: 'dipdup_index_stddev_samp_fields';
  level?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "dipdup_index" */
export type Dipdup_Index_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dipdup_Index_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dipdup_Index_Stream_Cursor_Value_Input = {
  config_hash?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
  template_values?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Dipdup_Index_Sum_Fields = {
  __typename?: 'dipdup_index_sum_fields';
  level?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Dipdup_Index_Var_Pop_Fields = {
  __typename?: 'dipdup_index_var_pop_fields';
  level?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Dipdup_Index_Var_Samp_Fields = {
  __typename?: 'dipdup_index_var_samp_fields';
  level?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Dipdup_Index_Variance_Fields = {
  __typename?: 'dipdup_index_variance_fields';
  level?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "dipdup_meta" */
export type Dipdup_Meta = {
  __typename?: 'dipdup_meta';
  created_at: Scalars['timestamptz']['output'];
  key: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  value?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "dipdup_meta" */
export type Dipdup_MetaValueArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "dipdup_meta" */
export type Dipdup_Meta_Aggregate = {
  __typename?: 'dipdup_meta_aggregate';
  aggregate?: Maybe<Dipdup_Meta_Aggregate_Fields>;
  nodes: Array<Dipdup_Meta>;
};

/** aggregate fields of "dipdup_meta" */
export type Dipdup_Meta_Aggregate_Fields = {
  __typename?: 'dipdup_meta_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Dipdup_Meta_Max_Fields>;
  min?: Maybe<Dipdup_Meta_Min_Fields>;
};


/** aggregate fields of "dipdup_meta" */
export type Dipdup_Meta_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dipdup_Meta_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "dipdup_meta". All fields are combined with a logical 'AND'. */
export type Dipdup_Meta_Bool_Exp = {
  _and?: InputMaybe<Array<Dipdup_Meta_Bool_Exp>>;
  _not?: InputMaybe<Dipdup_Meta_Bool_Exp>;
  _or?: InputMaybe<Array<Dipdup_Meta_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** aggregate max on columns */
export type Dipdup_Meta_Max_Fields = {
  __typename?: 'dipdup_meta_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Dipdup_Meta_Min_Fields = {
  __typename?: 'dipdup_meta_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "dipdup_meta". */
export type Dipdup_Meta_Order_By = {
  created_at?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "dipdup_meta" */
export enum Dipdup_Meta_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Key = 'key',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "dipdup_meta" */
export type Dipdup_Meta_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dipdup_Meta_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dipdup_Meta_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Model update created within versioned transactions */
export type Dipdup_Model_Update = {
  __typename?: 'dipdup_model_update';
  action: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  data?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['Int']['output'];
  index: Scalars['String']['output'];
  level: Scalars['Int']['output'];
  model_name: Scalars['String']['output'];
  model_pk: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** Model update created within versioned transactions */
export type Dipdup_Model_UpdateDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "dipdup_model_update" */
export type Dipdup_Model_Update_Aggregate = {
  __typename?: 'dipdup_model_update_aggregate';
  aggregate?: Maybe<Dipdup_Model_Update_Aggregate_Fields>;
  nodes: Array<Dipdup_Model_Update>;
};

/** aggregate fields of "dipdup_model_update" */
export type Dipdup_Model_Update_Aggregate_Fields = {
  __typename?: 'dipdup_model_update_aggregate_fields';
  avg?: Maybe<Dipdup_Model_Update_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Dipdup_Model_Update_Max_Fields>;
  min?: Maybe<Dipdup_Model_Update_Min_Fields>;
  stddev?: Maybe<Dipdup_Model_Update_Stddev_Fields>;
  stddev_pop?: Maybe<Dipdup_Model_Update_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Dipdup_Model_Update_Stddev_Samp_Fields>;
  sum?: Maybe<Dipdup_Model_Update_Sum_Fields>;
  var_pop?: Maybe<Dipdup_Model_Update_Var_Pop_Fields>;
  var_samp?: Maybe<Dipdup_Model_Update_Var_Samp_Fields>;
  variance?: Maybe<Dipdup_Model_Update_Variance_Fields>;
};


/** aggregate fields of "dipdup_model_update" */
export type Dipdup_Model_Update_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dipdup_Model_Update_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Dipdup_Model_Update_Avg_Fields = {
  __typename?: 'dipdup_model_update_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "dipdup_model_update". All fields are combined with a logical 'AND'. */
export type Dipdup_Model_Update_Bool_Exp = {
  _and?: InputMaybe<Array<Dipdup_Model_Update_Bool_Exp>>;
  _not?: InputMaybe<Dipdup_Model_Update_Bool_Exp>;
  _or?: InputMaybe<Array<Dipdup_Model_Update_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  index?: InputMaybe<String_Comparison_Exp>;
  level?: InputMaybe<Int_Comparison_Exp>;
  model_name?: InputMaybe<String_Comparison_Exp>;
  model_pk?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Dipdup_Model_Update_Max_Fields = {
  __typename?: 'dipdup_model_update_max_fields';
  action?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  index?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  model_name?: Maybe<Scalars['String']['output']>;
  model_pk?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Dipdup_Model_Update_Min_Fields = {
  __typename?: 'dipdup_model_update_min_fields';
  action?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  index?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  model_name?: Maybe<Scalars['String']['output']>;
  model_pk?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "dipdup_model_update". */
export type Dipdup_Model_Update_Order_By = {
  action?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  model_name?: InputMaybe<Order_By>;
  model_pk?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "dipdup_model_update" */
export enum Dipdup_Model_Update_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  Level = 'level',
  /** column name */
  ModelName = 'model_name',
  /** column name */
  ModelPk = 'model_pk',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Dipdup_Model_Update_Stddev_Fields = {
  __typename?: 'dipdup_model_update_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Dipdup_Model_Update_Stddev_Pop_Fields = {
  __typename?: 'dipdup_model_update_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Dipdup_Model_Update_Stddev_Samp_Fields = {
  __typename?: 'dipdup_model_update_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "dipdup_model_update" */
export type Dipdup_Model_Update_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dipdup_Model_Update_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dipdup_Model_Update_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  index?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  model_name?: InputMaybe<Scalars['String']['input']>;
  model_pk?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Dipdup_Model_Update_Sum_Fields = {
  __typename?: 'dipdup_model_update_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Dipdup_Model_Update_Var_Pop_Fields = {
  __typename?: 'dipdup_model_update_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Dipdup_Model_Update_Var_Samp_Fields = {
  __typename?: 'dipdup_model_update_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Dipdup_Model_Update_Variance_Fields = {
  __typename?: 'dipdup_model_update_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "dipdup_schema" */
export type Dipdup_Schema = {
  __typename?: 'dipdup_schema';
  created_at: Scalars['timestamptz']['output'];
  hash?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  reindex?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "dipdup_schema" */
export type Dipdup_Schema_Aggregate = {
  __typename?: 'dipdup_schema_aggregate';
  aggregate?: Maybe<Dipdup_Schema_Aggregate_Fields>;
  nodes: Array<Dipdup_Schema>;
};

/** aggregate fields of "dipdup_schema" */
export type Dipdup_Schema_Aggregate_Fields = {
  __typename?: 'dipdup_schema_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Dipdup_Schema_Max_Fields>;
  min?: Maybe<Dipdup_Schema_Min_Fields>;
};


/** aggregate fields of "dipdup_schema" */
export type Dipdup_Schema_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dipdup_Schema_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "dipdup_schema". All fields are combined with a logical 'AND'. */
export type Dipdup_Schema_Bool_Exp = {
  _and?: InputMaybe<Array<Dipdup_Schema_Bool_Exp>>;
  _not?: InputMaybe<Dipdup_Schema_Bool_Exp>;
  _or?: InputMaybe<Array<Dipdup_Schema_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hash?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  reindex?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Dipdup_Schema_Max_Fields = {
  __typename?: 'dipdup_schema_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reindex?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Dipdup_Schema_Min_Fields = {
  __typename?: 'dipdup_schema_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reindex?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "dipdup_schema". */
export type Dipdup_Schema_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hash?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  reindex?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "dipdup_schema" */
export enum Dipdup_Schema_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Hash = 'hash',
  /** column name */
  Name = 'name',
  /** column name */
  Reindex = 'reindex',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "dipdup_schema" */
export type Dipdup_Schema_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dipdup_Schema_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dipdup_Schema_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reindex?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "dipdup_status" */
export type Dipdup_Status = {
  __typename?: 'dipdup_status';
  level?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['numeric']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "dipdup_status" */
export type Dipdup_Status_Aggregate = {
  __typename?: 'dipdup_status_aggregate';
  aggregate?: Maybe<Dipdup_Status_Aggregate_Fields>;
  nodes: Array<Dipdup_Status>;
};

/** aggregate fields of "dipdup_status" */
export type Dipdup_Status_Aggregate_Fields = {
  __typename?: 'dipdup_status_aggregate_fields';
  avg?: Maybe<Dipdup_Status_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Dipdup_Status_Max_Fields>;
  min?: Maybe<Dipdup_Status_Min_Fields>;
  stddev?: Maybe<Dipdup_Status_Stddev_Fields>;
  stddev_pop?: Maybe<Dipdup_Status_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Dipdup_Status_Stddev_Samp_Fields>;
  sum?: Maybe<Dipdup_Status_Sum_Fields>;
  var_pop?: Maybe<Dipdup_Status_Var_Pop_Fields>;
  var_samp?: Maybe<Dipdup_Status_Var_Samp_Fields>;
  variance?: Maybe<Dipdup_Status_Variance_Fields>;
};


/** aggregate fields of "dipdup_status" */
export type Dipdup_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dipdup_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Dipdup_Status_Avg_Fields = {
  __typename?: 'dipdup_status_avg_fields';
  level?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "dipdup_status". All fields are combined with a logical 'AND'. */
export type Dipdup_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Dipdup_Status_Bool_Exp>>;
  _not?: InputMaybe<Dipdup_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Dipdup_Status_Bool_Exp>>;
  level?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<Numeric_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Dipdup_Status_Max_Fields = {
  __typename?: 'dipdup_status_max_fields';
  level?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['numeric']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Dipdup_Status_Min_Fields = {
  __typename?: 'dipdup_status_min_fields';
  level?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['numeric']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "dipdup_status". */
export type Dipdup_Status_Order_By = {
  level?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "dipdup_status" */
export enum Dipdup_Status_Select_Column {
  /** column name */
  Level = 'level',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Dipdup_Status_Stddev_Fields = {
  __typename?: 'dipdup_status_stddev_fields';
  level?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Dipdup_Status_Stddev_Pop_Fields = {
  __typename?: 'dipdup_status_stddev_pop_fields';
  level?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Dipdup_Status_Stddev_Samp_Fields = {
  __typename?: 'dipdup_status_stddev_samp_fields';
  level?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "dipdup_status" */
export type Dipdup_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dipdup_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dipdup_Status_Stream_Cursor_Value_Input = {
  level?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['numeric']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Dipdup_Status_Sum_Fields = {
  __typename?: 'dipdup_status_sum_fields';
  level?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate var_pop on columns */
export type Dipdup_Status_Var_Pop_Fields = {
  __typename?: 'dipdup_status_var_pop_fields';
  level?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Dipdup_Status_Var_Samp_Fields = {
  __typename?: 'dipdup_status_var_samp_fields';
  level?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Dipdup_Status_Variance_Fields = {
  __typename?: 'dipdup_status_variance_fields';
  level?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "dipdup_token_metadata" */
export type Dipdup_Token_Metadata = {
  __typename?: 'dipdup_token_metadata';
  contract: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  network: Scalars['String']['output'];
  token_id: Scalars['String']['output'];
  update_id: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "dipdup_token_metadata" */
export type Dipdup_Token_MetadataMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "dipdup_token_metadata" */
export type Dipdup_Token_Metadata_Aggregate = {
  __typename?: 'dipdup_token_metadata_aggregate';
  aggregate?: Maybe<Dipdup_Token_Metadata_Aggregate_Fields>;
  nodes: Array<Dipdup_Token_Metadata>;
};

/** aggregate fields of "dipdup_token_metadata" */
export type Dipdup_Token_Metadata_Aggregate_Fields = {
  __typename?: 'dipdup_token_metadata_aggregate_fields';
  avg?: Maybe<Dipdup_Token_Metadata_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Dipdup_Token_Metadata_Max_Fields>;
  min?: Maybe<Dipdup_Token_Metadata_Min_Fields>;
  stddev?: Maybe<Dipdup_Token_Metadata_Stddev_Fields>;
  stddev_pop?: Maybe<Dipdup_Token_Metadata_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Dipdup_Token_Metadata_Stddev_Samp_Fields>;
  sum?: Maybe<Dipdup_Token_Metadata_Sum_Fields>;
  var_pop?: Maybe<Dipdup_Token_Metadata_Var_Pop_Fields>;
  var_samp?: Maybe<Dipdup_Token_Metadata_Var_Samp_Fields>;
  variance?: Maybe<Dipdup_Token_Metadata_Variance_Fields>;
};


/** aggregate fields of "dipdup_token_metadata" */
export type Dipdup_Token_Metadata_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dipdup_Token_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Dipdup_Token_Metadata_Avg_Fields = {
  __typename?: 'dipdup_token_metadata_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  update_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "dipdup_token_metadata". All fields are combined with a logical 'AND'. */
export type Dipdup_Token_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Dipdup_Token_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Dipdup_Token_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Dipdup_Token_Metadata_Bool_Exp>>;
  contract?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
  token_id?: InputMaybe<String_Comparison_Exp>;
  update_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Dipdup_Token_Metadata_Max_Fields = {
  __typename?: 'dipdup_token_metadata_max_fields';
  contract?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  token_id?: Maybe<Scalars['String']['output']>;
  update_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Dipdup_Token_Metadata_Min_Fields = {
  __typename?: 'dipdup_token_metadata_min_fields';
  contract?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  token_id?: Maybe<Scalars['String']['output']>;
  update_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "dipdup_token_metadata". */
export type Dipdup_Token_Metadata_Order_By = {
  contract?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  update_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "dipdup_token_metadata" */
export enum Dipdup_Token_Metadata_Select_Column {
  /** column name */
  Contract = 'contract',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Network = 'network',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  UpdateId = 'update_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Dipdup_Token_Metadata_Stddev_Fields = {
  __typename?: 'dipdup_token_metadata_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  update_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Dipdup_Token_Metadata_Stddev_Pop_Fields = {
  __typename?: 'dipdup_token_metadata_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  update_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Dipdup_Token_Metadata_Stddev_Samp_Fields = {
  __typename?: 'dipdup_token_metadata_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  update_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "dipdup_token_metadata" */
export type Dipdup_Token_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dipdup_Token_Metadata_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dipdup_Token_Metadata_Stream_Cursor_Value_Input = {
  contract?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  token_id?: InputMaybe<Scalars['String']['input']>;
  update_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Dipdup_Token_Metadata_Sum_Fields = {
  __typename?: 'dipdup_token_metadata_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  update_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Dipdup_Token_Metadata_Var_Pop_Fields = {
  __typename?: 'dipdup_token_metadata_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  update_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Dipdup_Token_Metadata_Var_Samp_Fields = {
  __typename?: 'dipdup_token_metadata_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  update_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Dipdup_Token_Metadata_Variance_Fields = {
  __typename?: 'dipdup_token_metadata_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  update_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "doorman" */
export type Doorman = {
  __typename?: 'doorman';
  accumulated_fees_per_share: Scalars['float8']['output'];
  address: Scalars['String']['output'];
  admin: Scalars['String']['output'];
  compound_paused: Scalars['Boolean']['output'];
  exit_paused: Scalars['Boolean']['output'];
  farm_claim_paused: Scalars['Boolean']['output'];
  /** An array relationship */
  general_contracts: Array<Doorman_General_Contract>;
  /** An aggregate relationship */
  general_contracts_aggregate: Doorman_General_Contract_Aggregate;
  /** An object relationship */
  governance: Governance;
  governance_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An array relationship */
  lambdas: Array<Doorman_Lambda>;
  /** An aggregate relationship */
  lambdas_aggregate: Doorman_Lambda_Aggregate;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  min_mvn_amount: Scalars['float8']['output'];
  network: Scalars['String']['output'];
  on_vault_deposit_stake_paused: Scalars['Boolean']['output'];
  on_vault_liquidate_stake_paused: Scalars['Boolean']['output'];
  on_vault_withdraw_stake_paused: Scalars['Boolean']['output'];
  /** An array relationship */
  stake_accounts: Array<Doorman_Stake_Account>;
  /** An aggregate relationship */
  stake_accounts_aggregate: Doorman_Stake_Account_Aggregate;
  stake_mvn_paused: Scalars['Boolean']['output'];
  /** An array relationship */
  stakes_history_data: Array<Stake_History_Data>;
  /** An aggregate relationship */
  stakes_history_data_aggregate: Stake_History_Data_Aggregate;
  /** An array relationship */
  stakes_mvn_history_data: Array<Smvn_History_Data>;
  /** An aggregate relationship */
  stakes_mvn_history_data_aggregate: Smvn_History_Data_Aggregate;
  unclaimed_rewards: Scalars['float8']['output'];
  unstake_mvn_paused: Scalars['Boolean']['output'];
  /** An array relationship */
  whitelist_contracts: Array<Doorman_Whitelist_Contract>;
  /** An aggregate relationship */
  whitelist_contracts_aggregate: Doorman_Whitelist_Contract_Aggregate;
};


/** columns and relationships of "doorman" */
export type DoormanGeneral_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Doorman_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_General_Contract_Order_By>>;
  where?: InputMaybe<Doorman_General_Contract_Bool_Exp>;
};


/** columns and relationships of "doorman" */
export type DoormanGeneral_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Doorman_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_General_Contract_Order_By>>;
  where?: InputMaybe<Doorman_General_Contract_Bool_Exp>;
};


/** columns and relationships of "doorman" */
export type DoormanLambdasArgs = {
  distinct_on?: InputMaybe<Array<Doorman_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_Lambda_Order_By>>;
  where?: InputMaybe<Doorman_Lambda_Bool_Exp>;
};


/** columns and relationships of "doorman" */
export type DoormanLambdas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Doorman_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_Lambda_Order_By>>;
  where?: InputMaybe<Doorman_Lambda_Bool_Exp>;
};


/** columns and relationships of "doorman" */
export type DoormanMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "doorman" */
export type DoormanStake_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Doorman_Stake_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_Stake_Account_Order_By>>;
  where?: InputMaybe<Doorman_Stake_Account_Bool_Exp>;
};


/** columns and relationships of "doorman" */
export type DoormanStake_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Doorman_Stake_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_Stake_Account_Order_By>>;
  where?: InputMaybe<Doorman_Stake_Account_Bool_Exp>;
};


/** columns and relationships of "doorman" */
export type DoormanStakes_History_DataArgs = {
  distinct_on?: InputMaybe<Array<Stake_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stake_History_Data_Order_By>>;
  where?: InputMaybe<Stake_History_Data_Bool_Exp>;
};


/** columns and relationships of "doorman" */
export type DoormanStakes_History_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stake_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stake_History_Data_Order_By>>;
  where?: InputMaybe<Stake_History_Data_Bool_Exp>;
};


/** columns and relationships of "doorman" */
export type DoormanStakes_Mvn_History_DataArgs = {
  distinct_on?: InputMaybe<Array<Smvn_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smvn_History_Data_Order_By>>;
  where?: InputMaybe<Smvn_History_Data_Bool_Exp>;
};


/** columns and relationships of "doorman" */
export type DoormanStakes_Mvn_History_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Smvn_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smvn_History_Data_Order_By>>;
  where?: InputMaybe<Smvn_History_Data_Bool_Exp>;
};


/** columns and relationships of "doorman" */
export type DoormanWhitelist_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Doorman_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Doorman_Whitelist_Contract_Bool_Exp>;
};


/** columns and relationships of "doorman" */
export type DoormanWhitelist_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Doorman_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Doorman_Whitelist_Contract_Bool_Exp>;
};

/** aggregated selection of "doorman" */
export type Doorman_Aggregate = {
  __typename?: 'doorman_aggregate';
  aggregate?: Maybe<Doorman_Aggregate_Fields>;
  nodes: Array<Doorman>;
};

export type Doorman_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Doorman_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Doorman_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Doorman_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Doorman_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Doorman_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Doorman_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Doorman_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Doorman_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Doorman_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Doorman_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Doorman_Aggregate_Bool_Exp_Var_Samp>;
};

export type Doorman_Aggregate_Bool_Exp_Avg = {
  arguments: Doorman_Select_Column_Doorman_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Doorman_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Doorman_Aggregate_Bool_Exp_Bool_And = {
  arguments: Doorman_Select_Column_Doorman_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Doorman_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Doorman_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Doorman_Select_Column_Doorman_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Doorman_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Doorman_Aggregate_Bool_Exp_Corr = {
  arguments: Doorman_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Doorman_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Doorman_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Doorman_Select_Column_Doorman_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Doorman_Select_Column_Doorman_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Doorman_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Doorman_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Doorman_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Doorman_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Doorman_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Doorman_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Doorman_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Doorman_Select_Column_Doorman_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Doorman_Select_Column_Doorman_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Doorman_Aggregate_Bool_Exp_Max = {
  arguments: Doorman_Select_Column_Doorman_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Doorman_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Doorman_Aggregate_Bool_Exp_Min = {
  arguments: Doorman_Select_Column_Doorman_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Doorman_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Doorman_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Doorman_Select_Column_Doorman_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Doorman_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Doorman_Aggregate_Bool_Exp_Sum = {
  arguments: Doorman_Select_Column_Doorman_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Doorman_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Doorman_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Doorman_Select_Column_Doorman_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Doorman_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "doorman" */
export type Doorman_Aggregate_Fields = {
  __typename?: 'doorman_aggregate_fields';
  avg?: Maybe<Doorman_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Doorman_Max_Fields>;
  min?: Maybe<Doorman_Min_Fields>;
  stddev?: Maybe<Doorman_Stddev_Fields>;
  stddev_pop?: Maybe<Doorman_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Doorman_Stddev_Samp_Fields>;
  sum?: Maybe<Doorman_Sum_Fields>;
  var_pop?: Maybe<Doorman_Var_Pop_Fields>;
  var_samp?: Maybe<Doorman_Var_Samp_Fields>;
  variance?: Maybe<Doorman_Variance_Fields>;
};


/** aggregate fields of "doorman" */
export type Doorman_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Doorman_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "doorman" */
export type Doorman_Aggregate_Order_By = {
  avg?: InputMaybe<Doorman_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Doorman_Max_Order_By>;
  min?: InputMaybe<Doorman_Min_Order_By>;
  stddev?: InputMaybe<Doorman_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Doorman_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Doorman_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Doorman_Sum_Order_By>;
  var_pop?: InputMaybe<Doorman_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Doorman_Var_Samp_Order_By>;
  variance?: InputMaybe<Doorman_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Doorman_Avg_Fields = {
  __typename?: 'doorman_avg_fields';
  accumulated_fees_per_share?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  min_mvn_amount?: Maybe<Scalars['Float']['output']>;
  unclaimed_rewards?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "doorman" */
export type Doorman_Avg_Order_By = {
  accumulated_fees_per_share?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  min_mvn_amount?: InputMaybe<Order_By>;
  unclaimed_rewards?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "doorman". All fields are combined with a logical 'AND'. */
export type Doorman_Bool_Exp = {
  _and?: InputMaybe<Array<Doorman_Bool_Exp>>;
  _not?: InputMaybe<Doorman_Bool_Exp>;
  _or?: InputMaybe<Array<Doorman_Bool_Exp>>;
  accumulated_fees_per_share?: InputMaybe<Float8_Comparison_Exp>;
  address?: InputMaybe<String_Comparison_Exp>;
  admin?: InputMaybe<String_Comparison_Exp>;
  compound_paused?: InputMaybe<Boolean_Comparison_Exp>;
  exit_paused?: InputMaybe<Boolean_Comparison_Exp>;
  farm_claim_paused?: InputMaybe<Boolean_Comparison_Exp>;
  general_contracts?: InputMaybe<Doorman_General_Contract_Bool_Exp>;
  general_contracts_aggregate?: InputMaybe<Doorman_General_Contract_Aggregate_Bool_Exp>;
  governance?: InputMaybe<Governance_Bool_Exp>;
  governance_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambdas?: InputMaybe<Doorman_Lambda_Bool_Exp>;
  lambdas_aggregate?: InputMaybe<Doorman_Lambda_Aggregate_Bool_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  min_mvn_amount?: InputMaybe<Float8_Comparison_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
  on_vault_deposit_stake_paused?: InputMaybe<Boolean_Comparison_Exp>;
  on_vault_liquidate_stake_paused?: InputMaybe<Boolean_Comparison_Exp>;
  on_vault_withdraw_stake_paused?: InputMaybe<Boolean_Comparison_Exp>;
  stake_accounts?: InputMaybe<Doorman_Stake_Account_Bool_Exp>;
  stake_accounts_aggregate?: InputMaybe<Doorman_Stake_Account_Aggregate_Bool_Exp>;
  stake_mvn_paused?: InputMaybe<Boolean_Comparison_Exp>;
  stakes_history_data?: InputMaybe<Stake_History_Data_Bool_Exp>;
  stakes_history_data_aggregate?: InputMaybe<Stake_History_Data_Aggregate_Bool_Exp>;
  stakes_mvn_history_data?: InputMaybe<Smvn_History_Data_Bool_Exp>;
  stakes_mvn_history_data_aggregate?: InputMaybe<Smvn_History_Data_Aggregate_Bool_Exp>;
  unclaimed_rewards?: InputMaybe<Float8_Comparison_Exp>;
  unstake_mvn_paused?: InputMaybe<Boolean_Comparison_Exp>;
  whitelist_contracts?: InputMaybe<Doorman_Whitelist_Contract_Bool_Exp>;
  whitelist_contracts_aggregate?: InputMaybe<Doorman_Whitelist_Contract_Aggregate_Bool_Exp>;
};

/** columns and relationships of "doorman_general_contract" */
export type Doorman_General_Contract = {
  __typename?: 'doorman_general_contract';
  /** An object relationship */
  contract: Doorman;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  contract_name: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "doorman_general_contract" */
export type Doorman_General_Contract_Aggregate = {
  __typename?: 'doorman_general_contract_aggregate';
  aggregate?: Maybe<Doorman_General_Contract_Aggregate_Fields>;
  nodes: Array<Doorman_General_Contract>;
};

export type Doorman_General_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Doorman_General_Contract_Aggregate_Bool_Exp_Count>;
};

export type Doorman_General_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Doorman_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Doorman_General_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "doorman_general_contract" */
export type Doorman_General_Contract_Aggregate_Fields = {
  __typename?: 'doorman_general_contract_aggregate_fields';
  avg?: Maybe<Doorman_General_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Doorman_General_Contract_Max_Fields>;
  min?: Maybe<Doorman_General_Contract_Min_Fields>;
  stddev?: Maybe<Doorman_General_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Doorman_General_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Doorman_General_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Doorman_General_Contract_Sum_Fields>;
  var_pop?: Maybe<Doorman_General_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Doorman_General_Contract_Var_Samp_Fields>;
  variance?: Maybe<Doorman_General_Contract_Variance_Fields>;
};


/** aggregate fields of "doorman_general_contract" */
export type Doorman_General_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Doorman_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "doorman_general_contract" */
export type Doorman_General_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Doorman_General_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Doorman_General_Contract_Max_Order_By>;
  min?: InputMaybe<Doorman_General_Contract_Min_Order_By>;
  stddev?: InputMaybe<Doorman_General_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Doorman_General_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Doorman_General_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Doorman_General_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Doorman_General_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Doorman_General_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Doorman_General_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Doorman_General_Contract_Avg_Fields = {
  __typename?: 'doorman_general_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "doorman_general_contract" */
export type Doorman_General_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "doorman_general_contract". All fields are combined with a logical 'AND'. */
export type Doorman_General_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Doorman_General_Contract_Bool_Exp>>;
  _not?: InputMaybe<Doorman_General_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Doorman_General_Contract_Bool_Exp>>;
  contract?: InputMaybe<Doorman_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  contract_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Doorman_General_Contract_Max_Fields = {
  __typename?: 'doorman_general_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "doorman_general_contract" */
export type Doorman_General_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Doorman_General_Contract_Min_Fields = {
  __typename?: 'doorman_general_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "doorman_general_contract" */
export type Doorman_General_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "doorman_general_contract". */
export type Doorman_General_Contract_Order_By = {
  contract?: InputMaybe<Doorman_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "doorman_general_contract" */
export enum Doorman_General_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  ContractName = 'contract_name',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Doorman_General_Contract_Stddev_Fields = {
  __typename?: 'doorman_general_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "doorman_general_contract" */
export type Doorman_General_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Doorman_General_Contract_Stddev_Pop_Fields = {
  __typename?: 'doorman_general_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "doorman_general_contract" */
export type Doorman_General_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Doorman_General_Contract_Stddev_Samp_Fields = {
  __typename?: 'doorman_general_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "doorman_general_contract" */
export type Doorman_General_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "doorman_general_contract" */
export type Doorman_General_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Doorman_General_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Doorman_General_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  contract_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Doorman_General_Contract_Sum_Fields = {
  __typename?: 'doorman_general_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "doorman_general_contract" */
export type Doorman_General_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Doorman_General_Contract_Var_Pop_Fields = {
  __typename?: 'doorman_general_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "doorman_general_contract" */
export type Doorman_General_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Doorman_General_Contract_Var_Samp_Fields = {
  __typename?: 'doorman_general_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "doorman_general_contract" */
export type Doorman_General_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Doorman_General_Contract_Variance_Fields = {
  __typename?: 'doorman_general_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "doorman_general_contract" */
export type Doorman_General_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "doorman_lambda" */
export type Doorman_Lambda = {
  __typename?: 'doorman_lambda';
  /** An object relationship */
  contract: Doorman;
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lambda_bytes: Scalars['String']['output'];
  lambda_name: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "doorman_lambda" */
export type Doorman_Lambda_Aggregate = {
  __typename?: 'doorman_lambda_aggregate';
  aggregate?: Maybe<Doorman_Lambda_Aggregate_Fields>;
  nodes: Array<Doorman_Lambda>;
};

export type Doorman_Lambda_Aggregate_Bool_Exp = {
  count?: InputMaybe<Doorman_Lambda_Aggregate_Bool_Exp_Count>;
};

export type Doorman_Lambda_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Doorman_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Doorman_Lambda_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "doorman_lambda" */
export type Doorman_Lambda_Aggregate_Fields = {
  __typename?: 'doorman_lambda_aggregate_fields';
  avg?: Maybe<Doorman_Lambda_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Doorman_Lambda_Max_Fields>;
  min?: Maybe<Doorman_Lambda_Min_Fields>;
  stddev?: Maybe<Doorman_Lambda_Stddev_Fields>;
  stddev_pop?: Maybe<Doorman_Lambda_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Doorman_Lambda_Stddev_Samp_Fields>;
  sum?: Maybe<Doorman_Lambda_Sum_Fields>;
  var_pop?: Maybe<Doorman_Lambda_Var_Pop_Fields>;
  var_samp?: Maybe<Doorman_Lambda_Var_Samp_Fields>;
  variance?: Maybe<Doorman_Lambda_Variance_Fields>;
};


/** aggregate fields of "doorman_lambda" */
export type Doorman_Lambda_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Doorman_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "doorman_lambda" */
export type Doorman_Lambda_Aggregate_Order_By = {
  avg?: InputMaybe<Doorman_Lambda_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Doorman_Lambda_Max_Order_By>;
  min?: InputMaybe<Doorman_Lambda_Min_Order_By>;
  stddev?: InputMaybe<Doorman_Lambda_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Doorman_Lambda_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Doorman_Lambda_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Doorman_Lambda_Sum_Order_By>;
  var_pop?: InputMaybe<Doorman_Lambda_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Doorman_Lambda_Var_Samp_Order_By>;
  variance?: InputMaybe<Doorman_Lambda_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Doorman_Lambda_Avg_Fields = {
  __typename?: 'doorman_lambda_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "doorman_lambda" */
export type Doorman_Lambda_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "doorman_lambda". All fields are combined with a logical 'AND'. */
export type Doorman_Lambda_Bool_Exp = {
  _and?: InputMaybe<Array<Doorman_Lambda_Bool_Exp>>;
  _not?: InputMaybe<Doorman_Lambda_Bool_Exp>;
  _or?: InputMaybe<Array<Doorman_Lambda_Bool_Exp>>;
  contract?: InputMaybe<Doorman_Bool_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambda_bytes?: InputMaybe<String_Comparison_Exp>;
  lambda_name?: InputMaybe<String_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Doorman_Lambda_Max_Fields = {
  __typename?: 'doorman_lambda_max_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "doorman_lambda" */
export type Doorman_Lambda_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Doorman_Lambda_Min_Fields = {
  __typename?: 'doorman_lambda_min_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "doorman_lambda" */
export type Doorman_Lambda_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "doorman_lambda". */
export type Doorman_Lambda_Order_By = {
  contract?: InputMaybe<Doorman_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "doorman_lambda" */
export enum Doorman_Lambda_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaBytes = 'lambda_bytes',
  /** column name */
  LambdaName = 'lambda_name',
  /** column name */
  LastUpdatedAt = 'last_updated_at'
}

/** aggregate stddev on columns */
export type Doorman_Lambda_Stddev_Fields = {
  __typename?: 'doorman_lambda_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "doorman_lambda" */
export type Doorman_Lambda_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Doorman_Lambda_Stddev_Pop_Fields = {
  __typename?: 'doorman_lambda_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "doorman_lambda" */
export type Doorman_Lambda_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Doorman_Lambda_Stddev_Samp_Fields = {
  __typename?: 'doorman_lambda_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "doorman_lambda" */
export type Doorman_Lambda_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "doorman_lambda" */
export type Doorman_Lambda_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Doorman_Lambda_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Doorman_Lambda_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lambda_bytes?: InputMaybe<Scalars['String']['input']>;
  lambda_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Doorman_Lambda_Sum_Fields = {
  __typename?: 'doorman_lambda_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "doorman_lambda" */
export type Doorman_Lambda_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Doorman_Lambda_Var_Pop_Fields = {
  __typename?: 'doorman_lambda_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "doorman_lambda" */
export type Doorman_Lambda_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Doorman_Lambda_Var_Samp_Fields = {
  __typename?: 'doorman_lambda_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "doorman_lambda" */
export type Doorman_Lambda_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Doorman_Lambda_Variance_Fields = {
  __typename?: 'doorman_lambda_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "doorman_lambda" */
export type Doorman_Lambda_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Doorman_Max_Fields = {
  __typename?: 'doorman_max_fields';
  accumulated_fees_per_share?: Maybe<Scalars['float8']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  min_mvn_amount?: Maybe<Scalars['float8']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  unclaimed_rewards?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "doorman" */
export type Doorman_Max_Order_By = {
  accumulated_fees_per_share?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  min_mvn_amount?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  unclaimed_rewards?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Doorman_Min_Fields = {
  __typename?: 'doorman_min_fields';
  accumulated_fees_per_share?: Maybe<Scalars['float8']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  min_mvn_amount?: Maybe<Scalars['float8']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  unclaimed_rewards?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "doorman" */
export type Doorman_Min_Order_By = {
  accumulated_fees_per_share?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  min_mvn_amount?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  unclaimed_rewards?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "doorman". */
export type Doorman_Order_By = {
  accumulated_fees_per_share?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  compound_paused?: InputMaybe<Order_By>;
  exit_paused?: InputMaybe<Order_By>;
  farm_claim_paused?: InputMaybe<Order_By>;
  general_contracts_aggregate?: InputMaybe<Doorman_General_Contract_Aggregate_Order_By>;
  governance?: InputMaybe<Governance_Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambdas_aggregate?: InputMaybe<Doorman_Lambda_Aggregate_Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  min_mvn_amount?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  on_vault_deposit_stake_paused?: InputMaybe<Order_By>;
  on_vault_liquidate_stake_paused?: InputMaybe<Order_By>;
  on_vault_withdraw_stake_paused?: InputMaybe<Order_By>;
  stake_accounts_aggregate?: InputMaybe<Doorman_Stake_Account_Aggregate_Order_By>;
  stake_mvn_paused?: InputMaybe<Order_By>;
  stakes_history_data_aggregate?: InputMaybe<Stake_History_Data_Aggregate_Order_By>;
  stakes_mvn_history_data_aggregate?: InputMaybe<Smvn_History_Data_Aggregate_Order_By>;
  unclaimed_rewards?: InputMaybe<Order_By>;
  unstake_mvn_paused?: InputMaybe<Order_By>;
  whitelist_contracts_aggregate?: InputMaybe<Doorman_Whitelist_Contract_Aggregate_Order_By>;
};

/** select columns of table "doorman" */
export enum Doorman_Select_Column {
  /** column name */
  AccumulatedFeesPerShare = 'accumulated_fees_per_share',
  /** column name */
  Address = 'address',
  /** column name */
  Admin = 'admin',
  /** column name */
  CompoundPaused = 'compound_paused',
  /** column name */
  ExitPaused = 'exit_paused',
  /** column name */
  FarmClaimPaused = 'farm_claim_paused',
  /** column name */
  GovernanceId = 'governance_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MinMvnAmount = 'min_mvn_amount',
  /** column name */
  Network = 'network',
  /** column name */
  OnVaultDepositStakePaused = 'on_vault_deposit_stake_paused',
  /** column name */
  OnVaultLiquidateStakePaused = 'on_vault_liquidate_stake_paused',
  /** column name */
  OnVaultWithdrawStakePaused = 'on_vault_withdraw_stake_paused',
  /** column name */
  StakeMvnPaused = 'stake_mvn_paused',
  /** column name */
  UnclaimedRewards = 'unclaimed_rewards',
  /** column name */
  UnstakeMvnPaused = 'unstake_mvn_paused'
}

/** select "doorman_aggregate_bool_exp_avg_arguments_columns" columns of table "doorman" */
export enum Doorman_Select_Column_Doorman_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  AccumulatedFeesPerShare = 'accumulated_fees_per_share',
  /** column name */
  MinMvnAmount = 'min_mvn_amount',
  /** column name */
  UnclaimedRewards = 'unclaimed_rewards'
}

/** select "doorman_aggregate_bool_exp_bool_and_arguments_columns" columns of table "doorman" */
export enum Doorman_Select_Column_Doorman_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CompoundPaused = 'compound_paused',
  /** column name */
  ExitPaused = 'exit_paused',
  /** column name */
  FarmClaimPaused = 'farm_claim_paused',
  /** column name */
  OnVaultDepositStakePaused = 'on_vault_deposit_stake_paused',
  /** column name */
  OnVaultLiquidateStakePaused = 'on_vault_liquidate_stake_paused',
  /** column name */
  OnVaultWithdrawStakePaused = 'on_vault_withdraw_stake_paused',
  /** column name */
  StakeMvnPaused = 'stake_mvn_paused',
  /** column name */
  UnstakeMvnPaused = 'unstake_mvn_paused'
}

/** select "doorman_aggregate_bool_exp_bool_or_arguments_columns" columns of table "doorman" */
export enum Doorman_Select_Column_Doorman_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CompoundPaused = 'compound_paused',
  /** column name */
  ExitPaused = 'exit_paused',
  /** column name */
  FarmClaimPaused = 'farm_claim_paused',
  /** column name */
  OnVaultDepositStakePaused = 'on_vault_deposit_stake_paused',
  /** column name */
  OnVaultLiquidateStakePaused = 'on_vault_liquidate_stake_paused',
  /** column name */
  OnVaultWithdrawStakePaused = 'on_vault_withdraw_stake_paused',
  /** column name */
  StakeMvnPaused = 'stake_mvn_paused',
  /** column name */
  UnstakeMvnPaused = 'unstake_mvn_paused'
}

/** select "doorman_aggregate_bool_exp_corr_arguments_columns" columns of table "doorman" */
export enum Doorman_Select_Column_Doorman_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  AccumulatedFeesPerShare = 'accumulated_fees_per_share',
  /** column name */
  MinMvnAmount = 'min_mvn_amount',
  /** column name */
  UnclaimedRewards = 'unclaimed_rewards'
}

/** select "doorman_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "doorman" */
export enum Doorman_Select_Column_Doorman_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  AccumulatedFeesPerShare = 'accumulated_fees_per_share',
  /** column name */
  MinMvnAmount = 'min_mvn_amount',
  /** column name */
  UnclaimedRewards = 'unclaimed_rewards'
}

/** select "doorman_aggregate_bool_exp_max_arguments_columns" columns of table "doorman" */
export enum Doorman_Select_Column_Doorman_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  AccumulatedFeesPerShare = 'accumulated_fees_per_share',
  /** column name */
  MinMvnAmount = 'min_mvn_amount',
  /** column name */
  UnclaimedRewards = 'unclaimed_rewards'
}

/** select "doorman_aggregate_bool_exp_min_arguments_columns" columns of table "doorman" */
export enum Doorman_Select_Column_Doorman_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  AccumulatedFeesPerShare = 'accumulated_fees_per_share',
  /** column name */
  MinMvnAmount = 'min_mvn_amount',
  /** column name */
  UnclaimedRewards = 'unclaimed_rewards'
}

/** select "doorman_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "doorman" */
export enum Doorman_Select_Column_Doorman_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  AccumulatedFeesPerShare = 'accumulated_fees_per_share',
  /** column name */
  MinMvnAmount = 'min_mvn_amount',
  /** column name */
  UnclaimedRewards = 'unclaimed_rewards'
}

/** select "doorman_aggregate_bool_exp_sum_arguments_columns" columns of table "doorman" */
export enum Doorman_Select_Column_Doorman_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  AccumulatedFeesPerShare = 'accumulated_fees_per_share',
  /** column name */
  MinMvnAmount = 'min_mvn_amount',
  /** column name */
  UnclaimedRewards = 'unclaimed_rewards'
}

/** select "doorman_aggregate_bool_exp_var_samp_arguments_columns" columns of table "doorman" */
export enum Doorman_Select_Column_Doorman_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  AccumulatedFeesPerShare = 'accumulated_fees_per_share',
  /** column name */
  MinMvnAmount = 'min_mvn_amount',
  /** column name */
  UnclaimedRewards = 'unclaimed_rewards'
}

/** columns and relationships of "doorman_stake_account" */
export type Doorman_Stake_Account = {
  __typename?: 'doorman_stake_account';
  /** An object relationship */
  doorman: Doorman;
  doorman_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  participation_fees_per_share: Scalars['float8']['output'];
  smvn_balance: Scalars['float8']['output'];
  total_exit_fee_rewards_claimed: Scalars['float8']['output'];
  total_farm_rewards_claimed: Scalars['float8']['output'];
  total_satellite_rewards_claimed: Scalars['float8']['output'];
  /** An object relationship */
  user: Maven_User;
  user_id: Scalars['bigint']['output'];
};

/** aggregated selection of "doorman_stake_account" */
export type Doorman_Stake_Account_Aggregate = {
  __typename?: 'doorman_stake_account_aggregate';
  aggregate?: Maybe<Doorman_Stake_Account_Aggregate_Fields>;
  nodes: Array<Doorman_Stake_Account>;
};

export type Doorman_Stake_Account_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Doorman_Stake_Account_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Doorman_Stake_Account_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Doorman_Stake_Account_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Doorman_Stake_Account_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Doorman_Stake_Account_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Doorman_Stake_Account_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Doorman_Stake_Account_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Doorman_Stake_Account_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Doorman_Stake_Account_Aggregate_Bool_Exp_Var_Samp>;
};

export type Doorman_Stake_Account_Aggregate_Bool_Exp_Avg = {
  arguments: Doorman_Stake_Account_Select_Column_Doorman_Stake_Account_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Doorman_Stake_Account_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Doorman_Stake_Account_Aggregate_Bool_Exp_Corr = {
  arguments: Doorman_Stake_Account_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Doorman_Stake_Account_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Doorman_Stake_Account_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Doorman_Stake_Account_Select_Column_Doorman_Stake_Account_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Doorman_Stake_Account_Select_Column_Doorman_Stake_Account_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Doorman_Stake_Account_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Doorman_Stake_Account_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Doorman_Stake_Account_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Doorman_Stake_Account_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Doorman_Stake_Account_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Doorman_Stake_Account_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Doorman_Stake_Account_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Doorman_Stake_Account_Select_Column_Doorman_Stake_Account_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Doorman_Stake_Account_Select_Column_Doorman_Stake_Account_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Doorman_Stake_Account_Aggregate_Bool_Exp_Max = {
  arguments: Doorman_Stake_Account_Select_Column_Doorman_Stake_Account_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Doorman_Stake_Account_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Doorman_Stake_Account_Aggregate_Bool_Exp_Min = {
  arguments: Doorman_Stake_Account_Select_Column_Doorman_Stake_Account_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Doorman_Stake_Account_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Doorman_Stake_Account_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Doorman_Stake_Account_Select_Column_Doorman_Stake_Account_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Doorman_Stake_Account_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Doorman_Stake_Account_Aggregate_Bool_Exp_Sum = {
  arguments: Doorman_Stake_Account_Select_Column_Doorman_Stake_Account_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Doorman_Stake_Account_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Doorman_Stake_Account_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Doorman_Stake_Account_Select_Column_Doorman_Stake_Account_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Doorman_Stake_Account_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "doorman_stake_account" */
export type Doorman_Stake_Account_Aggregate_Fields = {
  __typename?: 'doorman_stake_account_aggregate_fields';
  avg?: Maybe<Doorman_Stake_Account_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Doorman_Stake_Account_Max_Fields>;
  min?: Maybe<Doorman_Stake_Account_Min_Fields>;
  stddev?: Maybe<Doorman_Stake_Account_Stddev_Fields>;
  stddev_pop?: Maybe<Doorman_Stake_Account_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Doorman_Stake_Account_Stddev_Samp_Fields>;
  sum?: Maybe<Doorman_Stake_Account_Sum_Fields>;
  var_pop?: Maybe<Doorman_Stake_Account_Var_Pop_Fields>;
  var_samp?: Maybe<Doorman_Stake_Account_Var_Samp_Fields>;
  variance?: Maybe<Doorman_Stake_Account_Variance_Fields>;
};


/** aggregate fields of "doorman_stake_account" */
export type Doorman_Stake_Account_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Doorman_Stake_Account_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "doorman_stake_account" */
export type Doorman_Stake_Account_Aggregate_Order_By = {
  avg?: InputMaybe<Doorman_Stake_Account_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Doorman_Stake_Account_Max_Order_By>;
  min?: InputMaybe<Doorman_Stake_Account_Min_Order_By>;
  stddev?: InputMaybe<Doorman_Stake_Account_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Doorman_Stake_Account_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Doorman_Stake_Account_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Doorman_Stake_Account_Sum_Order_By>;
  var_pop?: InputMaybe<Doorman_Stake_Account_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Doorman_Stake_Account_Var_Samp_Order_By>;
  variance?: InputMaybe<Doorman_Stake_Account_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Doorman_Stake_Account_Avg_Fields = {
  __typename?: 'doorman_stake_account_avg_fields';
  doorman_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  participation_fees_per_share?: Maybe<Scalars['Float']['output']>;
  smvn_balance?: Maybe<Scalars['Float']['output']>;
  total_exit_fee_rewards_claimed?: Maybe<Scalars['Float']['output']>;
  total_farm_rewards_claimed?: Maybe<Scalars['Float']['output']>;
  total_satellite_rewards_claimed?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "doorman_stake_account" */
export type Doorman_Stake_Account_Avg_Order_By = {
  doorman_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participation_fees_per_share?: InputMaybe<Order_By>;
  smvn_balance?: InputMaybe<Order_By>;
  total_exit_fee_rewards_claimed?: InputMaybe<Order_By>;
  total_farm_rewards_claimed?: InputMaybe<Order_By>;
  total_satellite_rewards_claimed?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "doorman_stake_account". All fields are combined with a logical 'AND'. */
export type Doorman_Stake_Account_Bool_Exp = {
  _and?: InputMaybe<Array<Doorman_Stake_Account_Bool_Exp>>;
  _not?: InputMaybe<Doorman_Stake_Account_Bool_Exp>;
  _or?: InputMaybe<Array<Doorman_Stake_Account_Bool_Exp>>;
  doorman?: InputMaybe<Doorman_Bool_Exp>;
  doorman_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  participation_fees_per_share?: InputMaybe<Float8_Comparison_Exp>;
  smvn_balance?: InputMaybe<Float8_Comparison_Exp>;
  total_exit_fee_rewards_claimed?: InputMaybe<Float8_Comparison_Exp>;
  total_farm_rewards_claimed?: InputMaybe<Float8_Comparison_Exp>;
  total_satellite_rewards_claimed?: InputMaybe<Float8_Comparison_Exp>;
  user?: InputMaybe<Maven_User_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Doorman_Stake_Account_Max_Fields = {
  __typename?: 'doorman_stake_account_max_fields';
  doorman_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  participation_fees_per_share?: Maybe<Scalars['float8']['output']>;
  smvn_balance?: Maybe<Scalars['float8']['output']>;
  total_exit_fee_rewards_claimed?: Maybe<Scalars['float8']['output']>;
  total_farm_rewards_claimed?: Maybe<Scalars['float8']['output']>;
  total_satellite_rewards_claimed?: Maybe<Scalars['float8']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "doorman_stake_account" */
export type Doorman_Stake_Account_Max_Order_By = {
  doorman_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participation_fees_per_share?: InputMaybe<Order_By>;
  smvn_balance?: InputMaybe<Order_By>;
  total_exit_fee_rewards_claimed?: InputMaybe<Order_By>;
  total_farm_rewards_claimed?: InputMaybe<Order_By>;
  total_satellite_rewards_claimed?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Doorman_Stake_Account_Min_Fields = {
  __typename?: 'doorman_stake_account_min_fields';
  doorman_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  participation_fees_per_share?: Maybe<Scalars['float8']['output']>;
  smvn_balance?: Maybe<Scalars['float8']['output']>;
  total_exit_fee_rewards_claimed?: Maybe<Scalars['float8']['output']>;
  total_farm_rewards_claimed?: Maybe<Scalars['float8']['output']>;
  total_satellite_rewards_claimed?: Maybe<Scalars['float8']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "doorman_stake_account" */
export type Doorman_Stake_Account_Min_Order_By = {
  doorman_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participation_fees_per_share?: InputMaybe<Order_By>;
  smvn_balance?: InputMaybe<Order_By>;
  total_exit_fee_rewards_claimed?: InputMaybe<Order_By>;
  total_farm_rewards_claimed?: InputMaybe<Order_By>;
  total_satellite_rewards_claimed?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "doorman_stake_account". */
export type Doorman_Stake_Account_Order_By = {
  doorman?: InputMaybe<Doorman_Order_By>;
  doorman_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participation_fees_per_share?: InputMaybe<Order_By>;
  smvn_balance?: InputMaybe<Order_By>;
  total_exit_fee_rewards_claimed?: InputMaybe<Order_By>;
  total_farm_rewards_claimed?: InputMaybe<Order_By>;
  total_satellite_rewards_claimed?: InputMaybe<Order_By>;
  user?: InputMaybe<Maven_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "doorman_stake_account" */
export enum Doorman_Stake_Account_Select_Column {
  /** column name */
  DoormanId = 'doorman_id',
  /** column name */
  Id = 'id',
  /** column name */
  ParticipationFeesPerShare = 'participation_fees_per_share',
  /** column name */
  SmvnBalance = 'smvn_balance',
  /** column name */
  TotalExitFeeRewardsClaimed = 'total_exit_fee_rewards_claimed',
  /** column name */
  TotalFarmRewardsClaimed = 'total_farm_rewards_claimed',
  /** column name */
  TotalSatelliteRewardsClaimed = 'total_satellite_rewards_claimed',
  /** column name */
  UserId = 'user_id'
}

/** select "doorman_stake_account_aggregate_bool_exp_avg_arguments_columns" columns of table "doorman_stake_account" */
export enum Doorman_Stake_Account_Select_Column_Doorman_Stake_Account_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  ParticipationFeesPerShare = 'participation_fees_per_share',
  /** column name */
  SmvnBalance = 'smvn_balance',
  /** column name */
  TotalExitFeeRewardsClaimed = 'total_exit_fee_rewards_claimed',
  /** column name */
  TotalFarmRewardsClaimed = 'total_farm_rewards_claimed',
  /** column name */
  TotalSatelliteRewardsClaimed = 'total_satellite_rewards_claimed'
}

/** select "doorman_stake_account_aggregate_bool_exp_corr_arguments_columns" columns of table "doorman_stake_account" */
export enum Doorman_Stake_Account_Select_Column_Doorman_Stake_Account_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  ParticipationFeesPerShare = 'participation_fees_per_share',
  /** column name */
  SmvnBalance = 'smvn_balance',
  /** column name */
  TotalExitFeeRewardsClaimed = 'total_exit_fee_rewards_claimed',
  /** column name */
  TotalFarmRewardsClaimed = 'total_farm_rewards_claimed',
  /** column name */
  TotalSatelliteRewardsClaimed = 'total_satellite_rewards_claimed'
}

/** select "doorman_stake_account_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "doorman_stake_account" */
export enum Doorman_Stake_Account_Select_Column_Doorman_Stake_Account_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  ParticipationFeesPerShare = 'participation_fees_per_share',
  /** column name */
  SmvnBalance = 'smvn_balance',
  /** column name */
  TotalExitFeeRewardsClaimed = 'total_exit_fee_rewards_claimed',
  /** column name */
  TotalFarmRewardsClaimed = 'total_farm_rewards_claimed',
  /** column name */
  TotalSatelliteRewardsClaimed = 'total_satellite_rewards_claimed'
}

/** select "doorman_stake_account_aggregate_bool_exp_max_arguments_columns" columns of table "doorman_stake_account" */
export enum Doorman_Stake_Account_Select_Column_Doorman_Stake_Account_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  ParticipationFeesPerShare = 'participation_fees_per_share',
  /** column name */
  SmvnBalance = 'smvn_balance',
  /** column name */
  TotalExitFeeRewardsClaimed = 'total_exit_fee_rewards_claimed',
  /** column name */
  TotalFarmRewardsClaimed = 'total_farm_rewards_claimed',
  /** column name */
  TotalSatelliteRewardsClaimed = 'total_satellite_rewards_claimed'
}

/** select "doorman_stake_account_aggregate_bool_exp_min_arguments_columns" columns of table "doorman_stake_account" */
export enum Doorman_Stake_Account_Select_Column_Doorman_Stake_Account_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  ParticipationFeesPerShare = 'participation_fees_per_share',
  /** column name */
  SmvnBalance = 'smvn_balance',
  /** column name */
  TotalExitFeeRewardsClaimed = 'total_exit_fee_rewards_claimed',
  /** column name */
  TotalFarmRewardsClaimed = 'total_farm_rewards_claimed',
  /** column name */
  TotalSatelliteRewardsClaimed = 'total_satellite_rewards_claimed'
}

/** select "doorman_stake_account_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "doorman_stake_account" */
export enum Doorman_Stake_Account_Select_Column_Doorman_Stake_Account_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  ParticipationFeesPerShare = 'participation_fees_per_share',
  /** column name */
  SmvnBalance = 'smvn_balance',
  /** column name */
  TotalExitFeeRewardsClaimed = 'total_exit_fee_rewards_claimed',
  /** column name */
  TotalFarmRewardsClaimed = 'total_farm_rewards_claimed',
  /** column name */
  TotalSatelliteRewardsClaimed = 'total_satellite_rewards_claimed'
}

/** select "doorman_stake_account_aggregate_bool_exp_sum_arguments_columns" columns of table "doorman_stake_account" */
export enum Doorman_Stake_Account_Select_Column_Doorman_Stake_Account_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  ParticipationFeesPerShare = 'participation_fees_per_share',
  /** column name */
  SmvnBalance = 'smvn_balance',
  /** column name */
  TotalExitFeeRewardsClaimed = 'total_exit_fee_rewards_claimed',
  /** column name */
  TotalFarmRewardsClaimed = 'total_farm_rewards_claimed',
  /** column name */
  TotalSatelliteRewardsClaimed = 'total_satellite_rewards_claimed'
}

/** select "doorman_stake_account_aggregate_bool_exp_var_samp_arguments_columns" columns of table "doorman_stake_account" */
export enum Doorman_Stake_Account_Select_Column_Doorman_Stake_Account_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  ParticipationFeesPerShare = 'participation_fees_per_share',
  /** column name */
  SmvnBalance = 'smvn_balance',
  /** column name */
  TotalExitFeeRewardsClaimed = 'total_exit_fee_rewards_claimed',
  /** column name */
  TotalFarmRewardsClaimed = 'total_farm_rewards_claimed',
  /** column name */
  TotalSatelliteRewardsClaimed = 'total_satellite_rewards_claimed'
}

/** aggregate stddev on columns */
export type Doorman_Stake_Account_Stddev_Fields = {
  __typename?: 'doorman_stake_account_stddev_fields';
  doorman_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  participation_fees_per_share?: Maybe<Scalars['Float']['output']>;
  smvn_balance?: Maybe<Scalars['Float']['output']>;
  total_exit_fee_rewards_claimed?: Maybe<Scalars['Float']['output']>;
  total_farm_rewards_claimed?: Maybe<Scalars['Float']['output']>;
  total_satellite_rewards_claimed?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "doorman_stake_account" */
export type Doorman_Stake_Account_Stddev_Order_By = {
  doorman_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participation_fees_per_share?: InputMaybe<Order_By>;
  smvn_balance?: InputMaybe<Order_By>;
  total_exit_fee_rewards_claimed?: InputMaybe<Order_By>;
  total_farm_rewards_claimed?: InputMaybe<Order_By>;
  total_satellite_rewards_claimed?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Doorman_Stake_Account_Stddev_Pop_Fields = {
  __typename?: 'doorman_stake_account_stddev_pop_fields';
  doorman_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  participation_fees_per_share?: Maybe<Scalars['Float']['output']>;
  smvn_balance?: Maybe<Scalars['Float']['output']>;
  total_exit_fee_rewards_claimed?: Maybe<Scalars['Float']['output']>;
  total_farm_rewards_claimed?: Maybe<Scalars['Float']['output']>;
  total_satellite_rewards_claimed?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "doorman_stake_account" */
export type Doorman_Stake_Account_Stddev_Pop_Order_By = {
  doorman_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participation_fees_per_share?: InputMaybe<Order_By>;
  smvn_balance?: InputMaybe<Order_By>;
  total_exit_fee_rewards_claimed?: InputMaybe<Order_By>;
  total_farm_rewards_claimed?: InputMaybe<Order_By>;
  total_satellite_rewards_claimed?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Doorman_Stake_Account_Stddev_Samp_Fields = {
  __typename?: 'doorman_stake_account_stddev_samp_fields';
  doorman_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  participation_fees_per_share?: Maybe<Scalars['Float']['output']>;
  smvn_balance?: Maybe<Scalars['Float']['output']>;
  total_exit_fee_rewards_claimed?: Maybe<Scalars['Float']['output']>;
  total_farm_rewards_claimed?: Maybe<Scalars['Float']['output']>;
  total_satellite_rewards_claimed?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "doorman_stake_account" */
export type Doorman_Stake_Account_Stddev_Samp_Order_By = {
  doorman_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participation_fees_per_share?: InputMaybe<Order_By>;
  smvn_balance?: InputMaybe<Order_By>;
  total_exit_fee_rewards_claimed?: InputMaybe<Order_By>;
  total_farm_rewards_claimed?: InputMaybe<Order_By>;
  total_satellite_rewards_claimed?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "doorman_stake_account" */
export type Doorman_Stake_Account_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Doorman_Stake_Account_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Doorman_Stake_Account_Stream_Cursor_Value_Input = {
  doorman_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  participation_fees_per_share?: InputMaybe<Scalars['float8']['input']>;
  smvn_balance?: InputMaybe<Scalars['float8']['input']>;
  total_exit_fee_rewards_claimed?: InputMaybe<Scalars['float8']['input']>;
  total_farm_rewards_claimed?: InputMaybe<Scalars['float8']['input']>;
  total_satellite_rewards_claimed?: InputMaybe<Scalars['float8']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Doorman_Stake_Account_Sum_Fields = {
  __typename?: 'doorman_stake_account_sum_fields';
  doorman_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  participation_fees_per_share?: Maybe<Scalars['float8']['output']>;
  smvn_balance?: Maybe<Scalars['float8']['output']>;
  total_exit_fee_rewards_claimed?: Maybe<Scalars['float8']['output']>;
  total_farm_rewards_claimed?: Maybe<Scalars['float8']['output']>;
  total_satellite_rewards_claimed?: Maybe<Scalars['float8']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "doorman_stake_account" */
export type Doorman_Stake_Account_Sum_Order_By = {
  doorman_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participation_fees_per_share?: InputMaybe<Order_By>;
  smvn_balance?: InputMaybe<Order_By>;
  total_exit_fee_rewards_claimed?: InputMaybe<Order_By>;
  total_farm_rewards_claimed?: InputMaybe<Order_By>;
  total_satellite_rewards_claimed?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Doorman_Stake_Account_Var_Pop_Fields = {
  __typename?: 'doorman_stake_account_var_pop_fields';
  doorman_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  participation_fees_per_share?: Maybe<Scalars['Float']['output']>;
  smvn_balance?: Maybe<Scalars['Float']['output']>;
  total_exit_fee_rewards_claimed?: Maybe<Scalars['Float']['output']>;
  total_farm_rewards_claimed?: Maybe<Scalars['Float']['output']>;
  total_satellite_rewards_claimed?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "doorman_stake_account" */
export type Doorman_Stake_Account_Var_Pop_Order_By = {
  doorman_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participation_fees_per_share?: InputMaybe<Order_By>;
  smvn_balance?: InputMaybe<Order_By>;
  total_exit_fee_rewards_claimed?: InputMaybe<Order_By>;
  total_farm_rewards_claimed?: InputMaybe<Order_By>;
  total_satellite_rewards_claimed?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Doorman_Stake_Account_Var_Samp_Fields = {
  __typename?: 'doorman_stake_account_var_samp_fields';
  doorman_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  participation_fees_per_share?: Maybe<Scalars['Float']['output']>;
  smvn_balance?: Maybe<Scalars['Float']['output']>;
  total_exit_fee_rewards_claimed?: Maybe<Scalars['Float']['output']>;
  total_farm_rewards_claimed?: Maybe<Scalars['Float']['output']>;
  total_satellite_rewards_claimed?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "doorman_stake_account" */
export type Doorman_Stake_Account_Var_Samp_Order_By = {
  doorman_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participation_fees_per_share?: InputMaybe<Order_By>;
  smvn_balance?: InputMaybe<Order_By>;
  total_exit_fee_rewards_claimed?: InputMaybe<Order_By>;
  total_farm_rewards_claimed?: InputMaybe<Order_By>;
  total_satellite_rewards_claimed?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Doorman_Stake_Account_Variance_Fields = {
  __typename?: 'doorman_stake_account_variance_fields';
  doorman_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  participation_fees_per_share?: Maybe<Scalars['Float']['output']>;
  smvn_balance?: Maybe<Scalars['Float']['output']>;
  total_exit_fee_rewards_claimed?: Maybe<Scalars['Float']['output']>;
  total_farm_rewards_claimed?: Maybe<Scalars['Float']['output']>;
  total_satellite_rewards_claimed?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "doorman_stake_account" */
export type Doorman_Stake_Account_Variance_Order_By = {
  doorman_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participation_fees_per_share?: InputMaybe<Order_By>;
  smvn_balance?: InputMaybe<Order_By>;
  total_exit_fee_rewards_claimed?: InputMaybe<Order_By>;
  total_farm_rewards_claimed?: InputMaybe<Order_By>;
  total_satellite_rewards_claimed?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev on columns */
export type Doorman_Stddev_Fields = {
  __typename?: 'doorman_stddev_fields';
  accumulated_fees_per_share?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  min_mvn_amount?: Maybe<Scalars['Float']['output']>;
  unclaimed_rewards?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "doorman" */
export type Doorman_Stddev_Order_By = {
  accumulated_fees_per_share?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  min_mvn_amount?: InputMaybe<Order_By>;
  unclaimed_rewards?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Doorman_Stddev_Pop_Fields = {
  __typename?: 'doorman_stddev_pop_fields';
  accumulated_fees_per_share?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  min_mvn_amount?: Maybe<Scalars['Float']['output']>;
  unclaimed_rewards?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "doorman" */
export type Doorman_Stddev_Pop_Order_By = {
  accumulated_fees_per_share?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  min_mvn_amount?: InputMaybe<Order_By>;
  unclaimed_rewards?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Doorman_Stddev_Samp_Fields = {
  __typename?: 'doorman_stddev_samp_fields';
  accumulated_fees_per_share?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  min_mvn_amount?: Maybe<Scalars['Float']['output']>;
  unclaimed_rewards?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "doorman" */
export type Doorman_Stddev_Samp_Order_By = {
  accumulated_fees_per_share?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  min_mvn_amount?: InputMaybe<Order_By>;
  unclaimed_rewards?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "doorman" */
export type Doorman_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Doorman_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Doorman_Stream_Cursor_Value_Input = {
  accumulated_fees_per_share?: InputMaybe<Scalars['float8']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['String']['input']>;
  compound_paused?: InputMaybe<Scalars['Boolean']['input']>;
  exit_paused?: InputMaybe<Scalars['Boolean']['input']>;
  farm_claim_paused?: InputMaybe<Scalars['Boolean']['input']>;
  governance_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  min_mvn_amount?: InputMaybe<Scalars['float8']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  on_vault_deposit_stake_paused?: InputMaybe<Scalars['Boolean']['input']>;
  on_vault_liquidate_stake_paused?: InputMaybe<Scalars['Boolean']['input']>;
  on_vault_withdraw_stake_paused?: InputMaybe<Scalars['Boolean']['input']>;
  stake_mvn_paused?: InputMaybe<Scalars['Boolean']['input']>;
  unclaimed_rewards?: InputMaybe<Scalars['float8']['input']>;
  unstake_mvn_paused?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Doorman_Sum_Fields = {
  __typename?: 'doorman_sum_fields';
  accumulated_fees_per_share?: Maybe<Scalars['float8']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  min_mvn_amount?: Maybe<Scalars['float8']['output']>;
  unclaimed_rewards?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "doorman" */
export type Doorman_Sum_Order_By = {
  accumulated_fees_per_share?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  min_mvn_amount?: InputMaybe<Order_By>;
  unclaimed_rewards?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Doorman_Var_Pop_Fields = {
  __typename?: 'doorman_var_pop_fields';
  accumulated_fees_per_share?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  min_mvn_amount?: Maybe<Scalars['Float']['output']>;
  unclaimed_rewards?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "doorman" */
export type Doorman_Var_Pop_Order_By = {
  accumulated_fees_per_share?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  min_mvn_amount?: InputMaybe<Order_By>;
  unclaimed_rewards?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Doorman_Var_Samp_Fields = {
  __typename?: 'doorman_var_samp_fields';
  accumulated_fees_per_share?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  min_mvn_amount?: Maybe<Scalars['Float']['output']>;
  unclaimed_rewards?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "doorman" */
export type Doorman_Var_Samp_Order_By = {
  accumulated_fees_per_share?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  min_mvn_amount?: InputMaybe<Order_By>;
  unclaimed_rewards?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Doorman_Variance_Fields = {
  __typename?: 'doorman_variance_fields';
  accumulated_fees_per_share?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  min_mvn_amount?: Maybe<Scalars['Float']['output']>;
  unclaimed_rewards?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "doorman" */
export type Doorman_Variance_Order_By = {
  accumulated_fees_per_share?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  min_mvn_amount?: InputMaybe<Order_By>;
  unclaimed_rewards?: InputMaybe<Order_By>;
};

/** columns and relationships of "doorman_whitelist_contract" */
export type Doorman_Whitelist_Contract = {
  __typename?: 'doorman_whitelist_contract';
  /** An object relationship */
  contract: Doorman;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "doorman_whitelist_contract" */
export type Doorman_Whitelist_Contract_Aggregate = {
  __typename?: 'doorman_whitelist_contract_aggregate';
  aggregate?: Maybe<Doorman_Whitelist_Contract_Aggregate_Fields>;
  nodes: Array<Doorman_Whitelist_Contract>;
};

export type Doorman_Whitelist_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Doorman_Whitelist_Contract_Aggregate_Bool_Exp_Count>;
};

export type Doorman_Whitelist_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Doorman_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Doorman_Whitelist_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "doorman_whitelist_contract" */
export type Doorman_Whitelist_Contract_Aggregate_Fields = {
  __typename?: 'doorman_whitelist_contract_aggregate_fields';
  avg?: Maybe<Doorman_Whitelist_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Doorman_Whitelist_Contract_Max_Fields>;
  min?: Maybe<Doorman_Whitelist_Contract_Min_Fields>;
  stddev?: Maybe<Doorman_Whitelist_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Doorman_Whitelist_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Doorman_Whitelist_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Doorman_Whitelist_Contract_Sum_Fields>;
  var_pop?: Maybe<Doorman_Whitelist_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Doorman_Whitelist_Contract_Var_Samp_Fields>;
  variance?: Maybe<Doorman_Whitelist_Contract_Variance_Fields>;
};


/** aggregate fields of "doorman_whitelist_contract" */
export type Doorman_Whitelist_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Doorman_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "doorman_whitelist_contract" */
export type Doorman_Whitelist_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Doorman_Whitelist_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Doorman_Whitelist_Contract_Max_Order_By>;
  min?: InputMaybe<Doorman_Whitelist_Contract_Min_Order_By>;
  stddev?: InputMaybe<Doorman_Whitelist_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Doorman_Whitelist_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Doorman_Whitelist_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Doorman_Whitelist_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Doorman_Whitelist_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Doorman_Whitelist_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Doorman_Whitelist_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Doorman_Whitelist_Contract_Avg_Fields = {
  __typename?: 'doorman_whitelist_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "doorman_whitelist_contract" */
export type Doorman_Whitelist_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "doorman_whitelist_contract". All fields are combined with a logical 'AND'. */
export type Doorman_Whitelist_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Doorman_Whitelist_Contract_Bool_Exp>>;
  _not?: InputMaybe<Doorman_Whitelist_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Doorman_Whitelist_Contract_Bool_Exp>>;
  contract?: InputMaybe<Doorman_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Doorman_Whitelist_Contract_Max_Fields = {
  __typename?: 'doorman_whitelist_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "doorman_whitelist_contract" */
export type Doorman_Whitelist_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Doorman_Whitelist_Contract_Min_Fields = {
  __typename?: 'doorman_whitelist_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "doorman_whitelist_contract" */
export type Doorman_Whitelist_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "doorman_whitelist_contract". */
export type Doorman_Whitelist_Contract_Order_By = {
  contract?: InputMaybe<Doorman_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "doorman_whitelist_contract" */
export enum Doorman_Whitelist_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Doorman_Whitelist_Contract_Stddev_Fields = {
  __typename?: 'doorman_whitelist_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "doorman_whitelist_contract" */
export type Doorman_Whitelist_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Doorman_Whitelist_Contract_Stddev_Pop_Fields = {
  __typename?: 'doorman_whitelist_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "doorman_whitelist_contract" */
export type Doorman_Whitelist_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Doorman_Whitelist_Contract_Stddev_Samp_Fields = {
  __typename?: 'doorman_whitelist_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "doorman_whitelist_contract" */
export type Doorman_Whitelist_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "doorman_whitelist_contract" */
export type Doorman_Whitelist_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Doorman_Whitelist_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Doorman_Whitelist_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Doorman_Whitelist_Contract_Sum_Fields = {
  __typename?: 'doorman_whitelist_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "doorman_whitelist_contract" */
export type Doorman_Whitelist_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Doorman_Whitelist_Contract_Var_Pop_Fields = {
  __typename?: 'doorman_whitelist_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "doorman_whitelist_contract" */
export type Doorman_Whitelist_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Doorman_Whitelist_Contract_Var_Samp_Fields = {
  __typename?: 'doorman_whitelist_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "doorman_whitelist_contract" */
export type Doorman_Whitelist_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Doorman_Whitelist_Contract_Variance_Fields = {
  __typename?: 'doorman_whitelist_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "doorman_whitelist_contract" */
export type Doorman_Whitelist_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "emergency_governance" */
export type Emergency_Governance = {
  __typename?: 'emergency_governance';
  address: Scalars['String']['output'];
  admin: Scalars['String']['output'];
  current_emergency_record_id: Scalars['bigint']['output'];
  decimals: Scalars['smallint']['output'];
  duration_in_minutes: Scalars['bigint']['output'];
  /** An array relationship */
  emergency_governance_records: Array<Emergency_Governance_Record>;
  /** An aggregate relationship */
  emergency_governance_records_aggregate: Emergency_Governance_Record_Aggregate;
  /** An array relationship */
  general_contracts: Array<Emergency_Governance_General_Contract>;
  /** An aggregate relationship */
  general_contracts_aggregate: Emergency_Governance_General_Contract_Aggregate;
  /** An object relationship */
  governance: Governance;
  governance_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An array relationship */
  lambdas: Array<Emergency_Governance_Lambda>;
  /** An aggregate relationship */
  lambdas_aggregate: Emergency_Governance_Lambda_Aggregate;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  min_smvn_required_to_trigger: Scalars['float8']['output'];
  min_smvn_required_to_vote: Scalars['float8']['output'];
  network: Scalars['String']['output'];
  next_emergency_record_id: Scalars['bigint']['output'];
  proposal_desc_max_length: Scalars['smallint']['output'];
  proposal_title_max_length: Scalars['smallint']['output'];
  required_fee_mumav: Scalars['bigint']['output'];
  smvn_percentage_required: Scalars['smallint']['output'];
  /** An array relationship */
  whitelist_contracts: Array<Emergency_Governance_Whitelist_Contract>;
  /** An aggregate relationship */
  whitelist_contracts_aggregate: Emergency_Governance_Whitelist_Contract_Aggregate;
};


/** columns and relationships of "emergency_governance" */
export type Emergency_GovernanceEmergency_Governance_RecordsArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Record_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Record_Bool_Exp>;
};


/** columns and relationships of "emergency_governance" */
export type Emergency_GovernanceEmergency_Governance_Records_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Record_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Record_Bool_Exp>;
};


/** columns and relationships of "emergency_governance" */
export type Emergency_GovernanceGeneral_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_General_Contract_Order_By>>;
  where?: InputMaybe<Emergency_Governance_General_Contract_Bool_Exp>;
};


/** columns and relationships of "emergency_governance" */
export type Emergency_GovernanceGeneral_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_General_Contract_Order_By>>;
  where?: InputMaybe<Emergency_Governance_General_Contract_Bool_Exp>;
};


/** columns and relationships of "emergency_governance" */
export type Emergency_GovernanceLambdasArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Lambda_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Lambda_Bool_Exp>;
};


/** columns and relationships of "emergency_governance" */
export type Emergency_GovernanceLambdas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Lambda_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Lambda_Bool_Exp>;
};


/** columns and relationships of "emergency_governance" */
export type Emergency_GovernanceMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "emergency_governance" */
export type Emergency_GovernanceWhitelist_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Whitelist_Contract_Bool_Exp>;
};


/** columns and relationships of "emergency_governance" */
export type Emergency_GovernanceWhitelist_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Whitelist_Contract_Bool_Exp>;
};

/** aggregated selection of "emergency_governance" */
export type Emergency_Governance_Aggregate = {
  __typename?: 'emergency_governance_aggregate';
  aggregate?: Maybe<Emergency_Governance_Aggregate_Fields>;
  nodes: Array<Emergency_Governance>;
};

export type Emergency_Governance_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Emergency_Governance_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Emergency_Governance_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Emergency_Governance_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Emergency_Governance_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Emergency_Governance_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Emergency_Governance_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Emergency_Governance_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Emergency_Governance_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Emergency_Governance_Aggregate_Bool_Exp_Var_Samp>;
};

export type Emergency_Governance_Aggregate_Bool_Exp_Avg = {
  arguments: Emergency_Governance_Select_Column_Emergency_Governance_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Emergency_Governance_Aggregate_Bool_Exp_Corr = {
  arguments: Emergency_Governance_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Emergency_Governance_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Emergency_Governance_Select_Column_Emergency_Governance_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Emergency_Governance_Select_Column_Emergency_Governance_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Emergency_Governance_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Emergency_Governance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Emergency_Governance_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Emergency_Governance_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Emergency_Governance_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Emergency_Governance_Select_Column_Emergency_Governance_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Emergency_Governance_Select_Column_Emergency_Governance_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Emergency_Governance_Aggregate_Bool_Exp_Max = {
  arguments: Emergency_Governance_Select_Column_Emergency_Governance_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Emergency_Governance_Aggregate_Bool_Exp_Min = {
  arguments: Emergency_Governance_Select_Column_Emergency_Governance_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Emergency_Governance_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Emergency_Governance_Select_Column_Emergency_Governance_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Emergency_Governance_Aggregate_Bool_Exp_Sum = {
  arguments: Emergency_Governance_Select_Column_Emergency_Governance_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Emergency_Governance_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Emergency_Governance_Select_Column_Emergency_Governance_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "emergency_governance" */
export type Emergency_Governance_Aggregate_Fields = {
  __typename?: 'emergency_governance_aggregate_fields';
  avg?: Maybe<Emergency_Governance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Emergency_Governance_Max_Fields>;
  min?: Maybe<Emergency_Governance_Min_Fields>;
  stddev?: Maybe<Emergency_Governance_Stddev_Fields>;
  stddev_pop?: Maybe<Emergency_Governance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Emergency_Governance_Stddev_Samp_Fields>;
  sum?: Maybe<Emergency_Governance_Sum_Fields>;
  var_pop?: Maybe<Emergency_Governance_Var_Pop_Fields>;
  var_samp?: Maybe<Emergency_Governance_Var_Samp_Fields>;
  variance?: Maybe<Emergency_Governance_Variance_Fields>;
};


/** aggregate fields of "emergency_governance" */
export type Emergency_Governance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Emergency_Governance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "emergency_governance" */
export type Emergency_Governance_Aggregate_Order_By = {
  avg?: InputMaybe<Emergency_Governance_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Emergency_Governance_Max_Order_By>;
  min?: InputMaybe<Emergency_Governance_Min_Order_By>;
  stddev?: InputMaybe<Emergency_Governance_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Emergency_Governance_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Emergency_Governance_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Emergency_Governance_Sum_Order_By>;
  var_pop?: InputMaybe<Emergency_Governance_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Emergency_Governance_Var_Samp_Order_By>;
  variance?: InputMaybe<Emergency_Governance_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Emergency_Governance_Avg_Fields = {
  __typename?: 'emergency_governance_avg_fields';
  current_emergency_record_id?: Maybe<Scalars['Float']['output']>;
  decimals?: Maybe<Scalars['Float']['output']>;
  duration_in_minutes?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  min_smvn_required_to_trigger?: Maybe<Scalars['Float']['output']>;
  min_smvn_required_to_vote?: Maybe<Scalars['Float']['output']>;
  next_emergency_record_id?: Maybe<Scalars['Float']['output']>;
  proposal_desc_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_title_max_length?: Maybe<Scalars['Float']['output']>;
  required_fee_mumav?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_required?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "emergency_governance" */
export type Emergency_Governance_Avg_Order_By = {
  current_emergency_record_id?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  duration_in_minutes?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  min_smvn_required_to_trigger?: InputMaybe<Order_By>;
  min_smvn_required_to_vote?: InputMaybe<Order_By>;
  next_emergency_record_id?: InputMaybe<Order_By>;
  proposal_desc_max_length?: InputMaybe<Order_By>;
  proposal_title_max_length?: InputMaybe<Order_By>;
  required_fee_mumav?: InputMaybe<Order_By>;
  smvn_percentage_required?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "emergency_governance". All fields are combined with a logical 'AND'. */
export type Emergency_Governance_Bool_Exp = {
  _and?: InputMaybe<Array<Emergency_Governance_Bool_Exp>>;
  _not?: InputMaybe<Emergency_Governance_Bool_Exp>;
  _or?: InputMaybe<Array<Emergency_Governance_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  admin?: InputMaybe<String_Comparison_Exp>;
  current_emergency_record_id?: InputMaybe<Bigint_Comparison_Exp>;
  decimals?: InputMaybe<Smallint_Comparison_Exp>;
  duration_in_minutes?: InputMaybe<Bigint_Comparison_Exp>;
  emergency_governance_records?: InputMaybe<Emergency_Governance_Record_Bool_Exp>;
  emergency_governance_records_aggregate?: InputMaybe<Emergency_Governance_Record_Aggregate_Bool_Exp>;
  general_contracts?: InputMaybe<Emergency_Governance_General_Contract_Bool_Exp>;
  general_contracts_aggregate?: InputMaybe<Emergency_Governance_General_Contract_Aggregate_Bool_Exp>;
  governance?: InputMaybe<Governance_Bool_Exp>;
  governance_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambdas?: InputMaybe<Emergency_Governance_Lambda_Bool_Exp>;
  lambdas_aggregate?: InputMaybe<Emergency_Governance_Lambda_Aggregate_Bool_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  min_smvn_required_to_trigger?: InputMaybe<Float8_Comparison_Exp>;
  min_smvn_required_to_vote?: InputMaybe<Float8_Comparison_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
  next_emergency_record_id?: InputMaybe<Bigint_Comparison_Exp>;
  proposal_desc_max_length?: InputMaybe<Smallint_Comparison_Exp>;
  proposal_title_max_length?: InputMaybe<Smallint_Comparison_Exp>;
  required_fee_mumav?: InputMaybe<Bigint_Comparison_Exp>;
  smvn_percentage_required?: InputMaybe<Smallint_Comparison_Exp>;
  whitelist_contracts?: InputMaybe<Emergency_Governance_Whitelist_Contract_Bool_Exp>;
  whitelist_contracts_aggregate?: InputMaybe<Emergency_Governance_Whitelist_Contract_Aggregate_Bool_Exp>;
};

/** columns and relationships of "emergency_governance_general_contract" */
export type Emergency_Governance_General_Contract = {
  __typename?: 'emergency_governance_general_contract';
  /** An object relationship */
  contract: Emergency_Governance;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  contract_name: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "emergency_governance_general_contract" */
export type Emergency_Governance_General_Contract_Aggregate = {
  __typename?: 'emergency_governance_general_contract_aggregate';
  aggregate?: Maybe<Emergency_Governance_General_Contract_Aggregate_Fields>;
  nodes: Array<Emergency_Governance_General_Contract>;
};

export type Emergency_Governance_General_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Emergency_Governance_General_Contract_Aggregate_Bool_Exp_Count>;
};

export type Emergency_Governance_General_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Emergency_Governance_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_General_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "emergency_governance_general_contract" */
export type Emergency_Governance_General_Contract_Aggregate_Fields = {
  __typename?: 'emergency_governance_general_contract_aggregate_fields';
  avg?: Maybe<Emergency_Governance_General_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Emergency_Governance_General_Contract_Max_Fields>;
  min?: Maybe<Emergency_Governance_General_Contract_Min_Fields>;
  stddev?: Maybe<Emergency_Governance_General_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Emergency_Governance_General_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Emergency_Governance_General_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Emergency_Governance_General_Contract_Sum_Fields>;
  var_pop?: Maybe<Emergency_Governance_General_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Emergency_Governance_General_Contract_Var_Samp_Fields>;
  variance?: Maybe<Emergency_Governance_General_Contract_Variance_Fields>;
};


/** aggregate fields of "emergency_governance_general_contract" */
export type Emergency_Governance_General_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Emergency_Governance_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "emergency_governance_general_contract" */
export type Emergency_Governance_General_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Emergency_Governance_General_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Emergency_Governance_General_Contract_Max_Order_By>;
  min?: InputMaybe<Emergency_Governance_General_Contract_Min_Order_By>;
  stddev?: InputMaybe<Emergency_Governance_General_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Emergency_Governance_General_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Emergency_Governance_General_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Emergency_Governance_General_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Emergency_Governance_General_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Emergency_Governance_General_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Emergency_Governance_General_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Emergency_Governance_General_Contract_Avg_Fields = {
  __typename?: 'emergency_governance_general_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "emergency_governance_general_contract" */
export type Emergency_Governance_General_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "emergency_governance_general_contract". All fields are combined with a logical 'AND'. */
export type Emergency_Governance_General_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Emergency_Governance_General_Contract_Bool_Exp>>;
  _not?: InputMaybe<Emergency_Governance_General_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Emergency_Governance_General_Contract_Bool_Exp>>;
  contract?: InputMaybe<Emergency_Governance_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  contract_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Emergency_Governance_General_Contract_Max_Fields = {
  __typename?: 'emergency_governance_general_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "emergency_governance_general_contract" */
export type Emergency_Governance_General_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Emergency_Governance_General_Contract_Min_Fields = {
  __typename?: 'emergency_governance_general_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "emergency_governance_general_contract" */
export type Emergency_Governance_General_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "emergency_governance_general_contract". */
export type Emergency_Governance_General_Contract_Order_By = {
  contract?: InputMaybe<Emergency_Governance_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "emergency_governance_general_contract" */
export enum Emergency_Governance_General_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  ContractName = 'contract_name',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Emergency_Governance_General_Contract_Stddev_Fields = {
  __typename?: 'emergency_governance_general_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "emergency_governance_general_contract" */
export type Emergency_Governance_General_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Emergency_Governance_General_Contract_Stddev_Pop_Fields = {
  __typename?: 'emergency_governance_general_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "emergency_governance_general_contract" */
export type Emergency_Governance_General_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Emergency_Governance_General_Contract_Stddev_Samp_Fields = {
  __typename?: 'emergency_governance_general_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "emergency_governance_general_contract" */
export type Emergency_Governance_General_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "emergency_governance_general_contract" */
export type Emergency_Governance_General_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Emergency_Governance_General_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Emergency_Governance_General_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  contract_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Emergency_Governance_General_Contract_Sum_Fields = {
  __typename?: 'emergency_governance_general_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "emergency_governance_general_contract" */
export type Emergency_Governance_General_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Emergency_Governance_General_Contract_Var_Pop_Fields = {
  __typename?: 'emergency_governance_general_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "emergency_governance_general_contract" */
export type Emergency_Governance_General_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Emergency_Governance_General_Contract_Var_Samp_Fields = {
  __typename?: 'emergency_governance_general_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "emergency_governance_general_contract" */
export type Emergency_Governance_General_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Emergency_Governance_General_Contract_Variance_Fields = {
  __typename?: 'emergency_governance_general_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "emergency_governance_general_contract" */
export type Emergency_Governance_General_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "emergency_governance_lambda" */
export type Emergency_Governance_Lambda = {
  __typename?: 'emergency_governance_lambda';
  /** An object relationship */
  contract: Emergency_Governance;
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lambda_bytes: Scalars['String']['output'];
  lambda_name: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "emergency_governance_lambda" */
export type Emergency_Governance_Lambda_Aggregate = {
  __typename?: 'emergency_governance_lambda_aggregate';
  aggregate?: Maybe<Emergency_Governance_Lambda_Aggregate_Fields>;
  nodes: Array<Emergency_Governance_Lambda>;
};

export type Emergency_Governance_Lambda_Aggregate_Bool_Exp = {
  count?: InputMaybe<Emergency_Governance_Lambda_Aggregate_Bool_Exp_Count>;
};

export type Emergency_Governance_Lambda_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Emergency_Governance_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Lambda_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "emergency_governance_lambda" */
export type Emergency_Governance_Lambda_Aggregate_Fields = {
  __typename?: 'emergency_governance_lambda_aggregate_fields';
  avg?: Maybe<Emergency_Governance_Lambda_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Emergency_Governance_Lambda_Max_Fields>;
  min?: Maybe<Emergency_Governance_Lambda_Min_Fields>;
  stddev?: Maybe<Emergency_Governance_Lambda_Stddev_Fields>;
  stddev_pop?: Maybe<Emergency_Governance_Lambda_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Emergency_Governance_Lambda_Stddev_Samp_Fields>;
  sum?: Maybe<Emergency_Governance_Lambda_Sum_Fields>;
  var_pop?: Maybe<Emergency_Governance_Lambda_Var_Pop_Fields>;
  var_samp?: Maybe<Emergency_Governance_Lambda_Var_Samp_Fields>;
  variance?: Maybe<Emergency_Governance_Lambda_Variance_Fields>;
};


/** aggregate fields of "emergency_governance_lambda" */
export type Emergency_Governance_Lambda_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Emergency_Governance_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "emergency_governance_lambda" */
export type Emergency_Governance_Lambda_Aggregate_Order_By = {
  avg?: InputMaybe<Emergency_Governance_Lambda_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Emergency_Governance_Lambda_Max_Order_By>;
  min?: InputMaybe<Emergency_Governance_Lambda_Min_Order_By>;
  stddev?: InputMaybe<Emergency_Governance_Lambda_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Emergency_Governance_Lambda_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Emergency_Governance_Lambda_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Emergency_Governance_Lambda_Sum_Order_By>;
  var_pop?: InputMaybe<Emergency_Governance_Lambda_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Emergency_Governance_Lambda_Var_Samp_Order_By>;
  variance?: InputMaybe<Emergency_Governance_Lambda_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Emergency_Governance_Lambda_Avg_Fields = {
  __typename?: 'emergency_governance_lambda_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "emergency_governance_lambda" */
export type Emergency_Governance_Lambda_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "emergency_governance_lambda". All fields are combined with a logical 'AND'. */
export type Emergency_Governance_Lambda_Bool_Exp = {
  _and?: InputMaybe<Array<Emergency_Governance_Lambda_Bool_Exp>>;
  _not?: InputMaybe<Emergency_Governance_Lambda_Bool_Exp>;
  _or?: InputMaybe<Array<Emergency_Governance_Lambda_Bool_Exp>>;
  contract?: InputMaybe<Emergency_Governance_Bool_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambda_bytes?: InputMaybe<String_Comparison_Exp>;
  lambda_name?: InputMaybe<String_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Emergency_Governance_Lambda_Max_Fields = {
  __typename?: 'emergency_governance_lambda_max_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "emergency_governance_lambda" */
export type Emergency_Governance_Lambda_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Emergency_Governance_Lambda_Min_Fields = {
  __typename?: 'emergency_governance_lambda_min_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "emergency_governance_lambda" */
export type Emergency_Governance_Lambda_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "emergency_governance_lambda". */
export type Emergency_Governance_Lambda_Order_By = {
  contract?: InputMaybe<Emergency_Governance_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "emergency_governance_lambda" */
export enum Emergency_Governance_Lambda_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaBytes = 'lambda_bytes',
  /** column name */
  LambdaName = 'lambda_name',
  /** column name */
  LastUpdatedAt = 'last_updated_at'
}

/** aggregate stddev on columns */
export type Emergency_Governance_Lambda_Stddev_Fields = {
  __typename?: 'emergency_governance_lambda_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "emergency_governance_lambda" */
export type Emergency_Governance_Lambda_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Emergency_Governance_Lambda_Stddev_Pop_Fields = {
  __typename?: 'emergency_governance_lambda_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "emergency_governance_lambda" */
export type Emergency_Governance_Lambda_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Emergency_Governance_Lambda_Stddev_Samp_Fields = {
  __typename?: 'emergency_governance_lambda_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "emergency_governance_lambda" */
export type Emergency_Governance_Lambda_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "emergency_governance_lambda" */
export type Emergency_Governance_Lambda_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Emergency_Governance_Lambda_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Emergency_Governance_Lambda_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lambda_bytes?: InputMaybe<Scalars['String']['input']>;
  lambda_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Emergency_Governance_Lambda_Sum_Fields = {
  __typename?: 'emergency_governance_lambda_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "emergency_governance_lambda" */
export type Emergency_Governance_Lambda_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Emergency_Governance_Lambda_Var_Pop_Fields = {
  __typename?: 'emergency_governance_lambda_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "emergency_governance_lambda" */
export type Emergency_Governance_Lambda_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Emergency_Governance_Lambda_Var_Samp_Fields = {
  __typename?: 'emergency_governance_lambda_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "emergency_governance_lambda" */
export type Emergency_Governance_Lambda_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Emergency_Governance_Lambda_Variance_Fields = {
  __typename?: 'emergency_governance_lambda_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "emergency_governance_lambda" */
export type Emergency_Governance_Lambda_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Emergency_Governance_Max_Fields = {
  __typename?: 'emergency_governance_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  current_emergency_record_id?: Maybe<Scalars['bigint']['output']>;
  decimals?: Maybe<Scalars['smallint']['output']>;
  duration_in_minutes?: Maybe<Scalars['bigint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  min_smvn_required_to_trigger?: Maybe<Scalars['float8']['output']>;
  min_smvn_required_to_vote?: Maybe<Scalars['float8']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  next_emergency_record_id?: Maybe<Scalars['bigint']['output']>;
  proposal_desc_max_length?: Maybe<Scalars['smallint']['output']>;
  proposal_title_max_length?: Maybe<Scalars['smallint']['output']>;
  required_fee_mumav?: Maybe<Scalars['bigint']['output']>;
  smvn_percentage_required?: Maybe<Scalars['smallint']['output']>;
};

/** order by max() on columns of table "emergency_governance" */
export type Emergency_Governance_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  current_emergency_record_id?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  duration_in_minutes?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  min_smvn_required_to_trigger?: InputMaybe<Order_By>;
  min_smvn_required_to_vote?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  next_emergency_record_id?: InputMaybe<Order_By>;
  proposal_desc_max_length?: InputMaybe<Order_By>;
  proposal_title_max_length?: InputMaybe<Order_By>;
  required_fee_mumav?: InputMaybe<Order_By>;
  smvn_percentage_required?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Emergency_Governance_Min_Fields = {
  __typename?: 'emergency_governance_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  current_emergency_record_id?: Maybe<Scalars['bigint']['output']>;
  decimals?: Maybe<Scalars['smallint']['output']>;
  duration_in_minutes?: Maybe<Scalars['bigint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  min_smvn_required_to_trigger?: Maybe<Scalars['float8']['output']>;
  min_smvn_required_to_vote?: Maybe<Scalars['float8']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  next_emergency_record_id?: Maybe<Scalars['bigint']['output']>;
  proposal_desc_max_length?: Maybe<Scalars['smallint']['output']>;
  proposal_title_max_length?: Maybe<Scalars['smallint']['output']>;
  required_fee_mumav?: Maybe<Scalars['bigint']['output']>;
  smvn_percentage_required?: Maybe<Scalars['smallint']['output']>;
};

/** order by min() on columns of table "emergency_governance" */
export type Emergency_Governance_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  current_emergency_record_id?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  duration_in_minutes?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  min_smvn_required_to_trigger?: InputMaybe<Order_By>;
  min_smvn_required_to_vote?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  next_emergency_record_id?: InputMaybe<Order_By>;
  proposal_desc_max_length?: InputMaybe<Order_By>;
  proposal_title_max_length?: InputMaybe<Order_By>;
  required_fee_mumav?: InputMaybe<Order_By>;
  smvn_percentage_required?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "emergency_governance". */
export type Emergency_Governance_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  current_emergency_record_id?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  duration_in_minutes?: InputMaybe<Order_By>;
  emergency_governance_records_aggregate?: InputMaybe<Emergency_Governance_Record_Aggregate_Order_By>;
  general_contracts_aggregate?: InputMaybe<Emergency_Governance_General_Contract_Aggregate_Order_By>;
  governance?: InputMaybe<Governance_Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambdas_aggregate?: InputMaybe<Emergency_Governance_Lambda_Aggregate_Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  min_smvn_required_to_trigger?: InputMaybe<Order_By>;
  min_smvn_required_to_vote?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  next_emergency_record_id?: InputMaybe<Order_By>;
  proposal_desc_max_length?: InputMaybe<Order_By>;
  proposal_title_max_length?: InputMaybe<Order_By>;
  required_fee_mumav?: InputMaybe<Order_By>;
  smvn_percentage_required?: InputMaybe<Order_By>;
  whitelist_contracts_aggregate?: InputMaybe<Emergency_Governance_Whitelist_Contract_Aggregate_Order_By>;
};

/** columns and relationships of "emergency_governance_record" */
export type Emergency_Governance_Record = {
  __typename?: 'emergency_governance_record';
  description: Scalars['String']['output'];
  /** An object relationship */
  emergency_governance: Emergency_Governance;
  emergency_governance_id: Scalars['bigint']['output'];
  executed: Scalars['Boolean']['output'];
  execution_datetime?: Maybe<Scalars['timestamptz']['output']>;
  execution_level?: Maybe<Scalars['bigint']['output']>;
  expiration_timestamp: Scalars['timestamptz']['output'];
  id: Scalars['bigint']['output'];
  internal_id: Scalars['bigint']['output'];
  /** An object relationship */
  proposer: Maven_User;
  proposer_id: Scalars['bigint']['output'];
  smvn_percentage_required: Scalars['float8']['output'];
  smvn_required_for_trigger: Scalars['float8']['output'];
  start_level: Scalars['bigint']['output'];
  start_timestamp: Scalars['timestamptz']['output'];
  title: Scalars['String']['output'];
  total_smvn_votes: Scalars['float8']['output'];
  /** An array relationship */
  voters: Array<Emergency_Governance_Vote>;
  /** An aggregate relationship */
  voters_aggregate: Emergency_Governance_Vote_Aggregate;
};


/** columns and relationships of "emergency_governance_record" */
export type Emergency_Governance_RecordVotersArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Vote_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Vote_Bool_Exp>;
};


/** columns and relationships of "emergency_governance_record" */
export type Emergency_Governance_RecordVoters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Vote_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Vote_Bool_Exp>;
};

/** aggregated selection of "emergency_governance_record" */
export type Emergency_Governance_Record_Aggregate = {
  __typename?: 'emergency_governance_record_aggregate';
  aggregate?: Maybe<Emergency_Governance_Record_Aggregate_Fields>;
  nodes: Array<Emergency_Governance_Record>;
};

export type Emergency_Governance_Record_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Emergency_Governance_Record_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Emergency_Governance_Record_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Emergency_Governance_Record_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Emergency_Governance_Record_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Emergency_Governance_Record_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Emergency_Governance_Record_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Emergency_Governance_Record_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Emergency_Governance_Record_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Emergency_Governance_Record_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Emergency_Governance_Record_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Emergency_Governance_Record_Aggregate_Bool_Exp_Var_Samp>;
};

export type Emergency_Governance_Record_Aggregate_Bool_Exp_Avg = {
  arguments: Emergency_Governance_Record_Select_Column_Emergency_Governance_Record_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Record_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Emergency_Governance_Record_Aggregate_Bool_Exp_Bool_And = {
  arguments: Emergency_Governance_Record_Select_Column_Emergency_Governance_Record_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Record_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Emergency_Governance_Record_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Emergency_Governance_Record_Select_Column_Emergency_Governance_Record_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Record_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Emergency_Governance_Record_Aggregate_Bool_Exp_Corr = {
  arguments: Emergency_Governance_Record_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Record_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Emergency_Governance_Record_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Emergency_Governance_Record_Select_Column_Emergency_Governance_Record_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Emergency_Governance_Record_Select_Column_Emergency_Governance_Record_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Emergency_Governance_Record_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Emergency_Governance_Record_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Record_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Emergency_Governance_Record_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Emergency_Governance_Record_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Record_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Emergency_Governance_Record_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Emergency_Governance_Record_Select_Column_Emergency_Governance_Record_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Emergency_Governance_Record_Select_Column_Emergency_Governance_Record_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Emergency_Governance_Record_Aggregate_Bool_Exp_Max = {
  arguments: Emergency_Governance_Record_Select_Column_Emergency_Governance_Record_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Record_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Emergency_Governance_Record_Aggregate_Bool_Exp_Min = {
  arguments: Emergency_Governance_Record_Select_Column_Emergency_Governance_Record_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Record_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Emergency_Governance_Record_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Emergency_Governance_Record_Select_Column_Emergency_Governance_Record_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Record_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Emergency_Governance_Record_Aggregate_Bool_Exp_Sum = {
  arguments: Emergency_Governance_Record_Select_Column_Emergency_Governance_Record_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Record_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Emergency_Governance_Record_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Emergency_Governance_Record_Select_Column_Emergency_Governance_Record_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Record_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "emergency_governance_record" */
export type Emergency_Governance_Record_Aggregate_Fields = {
  __typename?: 'emergency_governance_record_aggregate_fields';
  avg?: Maybe<Emergency_Governance_Record_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Emergency_Governance_Record_Max_Fields>;
  min?: Maybe<Emergency_Governance_Record_Min_Fields>;
  stddev?: Maybe<Emergency_Governance_Record_Stddev_Fields>;
  stddev_pop?: Maybe<Emergency_Governance_Record_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Emergency_Governance_Record_Stddev_Samp_Fields>;
  sum?: Maybe<Emergency_Governance_Record_Sum_Fields>;
  var_pop?: Maybe<Emergency_Governance_Record_Var_Pop_Fields>;
  var_samp?: Maybe<Emergency_Governance_Record_Var_Samp_Fields>;
  variance?: Maybe<Emergency_Governance_Record_Variance_Fields>;
};


/** aggregate fields of "emergency_governance_record" */
export type Emergency_Governance_Record_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Emergency_Governance_Record_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "emergency_governance_record" */
export type Emergency_Governance_Record_Aggregate_Order_By = {
  avg?: InputMaybe<Emergency_Governance_Record_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Emergency_Governance_Record_Max_Order_By>;
  min?: InputMaybe<Emergency_Governance_Record_Min_Order_By>;
  stddev?: InputMaybe<Emergency_Governance_Record_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Emergency_Governance_Record_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Emergency_Governance_Record_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Emergency_Governance_Record_Sum_Order_By>;
  var_pop?: InputMaybe<Emergency_Governance_Record_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Emergency_Governance_Record_Var_Samp_Order_By>;
  variance?: InputMaybe<Emergency_Governance_Record_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Emergency_Governance_Record_Avg_Fields = {
  __typename?: 'emergency_governance_record_avg_fields';
  emergency_governance_id?: Maybe<Scalars['Float']['output']>;
  execution_level?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  proposer_id?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_required?: Maybe<Scalars['Float']['output']>;
  smvn_required_for_trigger?: Maybe<Scalars['Float']['output']>;
  start_level?: Maybe<Scalars['Float']['output']>;
  total_smvn_votes?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "emergency_governance_record" */
export type Emergency_Governance_Record_Avg_Order_By = {
  emergency_governance_id?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  proposer_id?: InputMaybe<Order_By>;
  smvn_percentage_required?: InputMaybe<Order_By>;
  smvn_required_for_trigger?: InputMaybe<Order_By>;
  start_level?: InputMaybe<Order_By>;
  total_smvn_votes?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "emergency_governance_record". All fields are combined with a logical 'AND'. */
export type Emergency_Governance_Record_Bool_Exp = {
  _and?: InputMaybe<Array<Emergency_Governance_Record_Bool_Exp>>;
  _not?: InputMaybe<Emergency_Governance_Record_Bool_Exp>;
  _or?: InputMaybe<Array<Emergency_Governance_Record_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  emergency_governance?: InputMaybe<Emergency_Governance_Bool_Exp>;
  emergency_governance_id?: InputMaybe<Bigint_Comparison_Exp>;
  executed?: InputMaybe<Boolean_Comparison_Exp>;
  execution_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  execution_level?: InputMaybe<Bigint_Comparison_Exp>;
  expiration_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  internal_id?: InputMaybe<Bigint_Comparison_Exp>;
  proposer?: InputMaybe<Maven_User_Bool_Exp>;
  proposer_id?: InputMaybe<Bigint_Comparison_Exp>;
  smvn_percentage_required?: InputMaybe<Float8_Comparison_Exp>;
  smvn_required_for_trigger?: InputMaybe<Float8_Comparison_Exp>;
  start_level?: InputMaybe<Bigint_Comparison_Exp>;
  start_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  total_smvn_votes?: InputMaybe<Float8_Comparison_Exp>;
  voters?: InputMaybe<Emergency_Governance_Vote_Bool_Exp>;
  voters_aggregate?: InputMaybe<Emergency_Governance_Vote_Aggregate_Bool_Exp>;
};

/** aggregate max on columns */
export type Emergency_Governance_Record_Max_Fields = {
  __typename?: 'emergency_governance_record_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  emergency_governance_id?: Maybe<Scalars['bigint']['output']>;
  execution_datetime?: Maybe<Scalars['timestamptz']['output']>;
  execution_level?: Maybe<Scalars['bigint']['output']>;
  expiration_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['bigint']['output']>;
  proposer_id?: Maybe<Scalars['bigint']['output']>;
  smvn_percentage_required?: Maybe<Scalars['float8']['output']>;
  smvn_required_for_trigger?: Maybe<Scalars['float8']['output']>;
  start_level?: Maybe<Scalars['bigint']['output']>;
  start_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total_smvn_votes?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "emergency_governance_record" */
export type Emergency_Governance_Record_Max_Order_By = {
  description?: InputMaybe<Order_By>;
  emergency_governance_id?: InputMaybe<Order_By>;
  execution_datetime?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  expiration_timestamp?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  proposer_id?: InputMaybe<Order_By>;
  smvn_percentage_required?: InputMaybe<Order_By>;
  smvn_required_for_trigger?: InputMaybe<Order_By>;
  start_level?: InputMaybe<Order_By>;
  start_timestamp?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  total_smvn_votes?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Emergency_Governance_Record_Min_Fields = {
  __typename?: 'emergency_governance_record_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  emergency_governance_id?: Maybe<Scalars['bigint']['output']>;
  execution_datetime?: Maybe<Scalars['timestamptz']['output']>;
  execution_level?: Maybe<Scalars['bigint']['output']>;
  expiration_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['bigint']['output']>;
  proposer_id?: Maybe<Scalars['bigint']['output']>;
  smvn_percentage_required?: Maybe<Scalars['float8']['output']>;
  smvn_required_for_trigger?: Maybe<Scalars['float8']['output']>;
  start_level?: Maybe<Scalars['bigint']['output']>;
  start_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total_smvn_votes?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "emergency_governance_record" */
export type Emergency_Governance_Record_Min_Order_By = {
  description?: InputMaybe<Order_By>;
  emergency_governance_id?: InputMaybe<Order_By>;
  execution_datetime?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  expiration_timestamp?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  proposer_id?: InputMaybe<Order_By>;
  smvn_percentage_required?: InputMaybe<Order_By>;
  smvn_required_for_trigger?: InputMaybe<Order_By>;
  start_level?: InputMaybe<Order_By>;
  start_timestamp?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  total_smvn_votes?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "emergency_governance_record". */
export type Emergency_Governance_Record_Order_By = {
  description?: InputMaybe<Order_By>;
  emergency_governance?: InputMaybe<Emergency_Governance_Order_By>;
  emergency_governance_id?: InputMaybe<Order_By>;
  executed?: InputMaybe<Order_By>;
  execution_datetime?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  expiration_timestamp?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  proposer?: InputMaybe<Maven_User_Order_By>;
  proposer_id?: InputMaybe<Order_By>;
  smvn_percentage_required?: InputMaybe<Order_By>;
  smvn_required_for_trigger?: InputMaybe<Order_By>;
  start_level?: InputMaybe<Order_By>;
  start_timestamp?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  total_smvn_votes?: InputMaybe<Order_By>;
  voters_aggregate?: InputMaybe<Emergency_Governance_Vote_Aggregate_Order_By>;
};

/** select columns of table "emergency_governance_record" */
export enum Emergency_Governance_Record_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  EmergencyGovernanceId = 'emergency_governance_id',
  /** column name */
  Executed = 'executed',
  /** column name */
  ExecutionDatetime = 'execution_datetime',
  /** column name */
  ExecutionLevel = 'execution_level',
  /** column name */
  ExpirationTimestamp = 'expiration_timestamp',
  /** column name */
  Id = 'id',
  /** column name */
  InternalId = 'internal_id',
  /** column name */
  ProposerId = 'proposer_id',
  /** column name */
  SmvnPercentageRequired = 'smvn_percentage_required',
  /** column name */
  SmvnRequiredForTrigger = 'smvn_required_for_trigger',
  /** column name */
  StartLevel = 'start_level',
  /** column name */
  StartTimestamp = 'start_timestamp',
  /** column name */
  Title = 'title',
  /** column name */
  TotalSmvnVotes = 'total_smvn_votes'
}

/** select "emergency_governance_record_aggregate_bool_exp_avg_arguments_columns" columns of table "emergency_governance_record" */
export enum Emergency_Governance_Record_Select_Column_Emergency_Governance_Record_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  SmvnPercentageRequired = 'smvn_percentage_required',
  /** column name */
  SmvnRequiredForTrigger = 'smvn_required_for_trigger',
  /** column name */
  TotalSmvnVotes = 'total_smvn_votes'
}

/** select "emergency_governance_record_aggregate_bool_exp_bool_and_arguments_columns" columns of table "emergency_governance_record" */
export enum Emergency_Governance_Record_Select_Column_Emergency_Governance_Record_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Executed = 'executed'
}

/** select "emergency_governance_record_aggregate_bool_exp_bool_or_arguments_columns" columns of table "emergency_governance_record" */
export enum Emergency_Governance_Record_Select_Column_Emergency_Governance_Record_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Executed = 'executed'
}

/** select "emergency_governance_record_aggregate_bool_exp_corr_arguments_columns" columns of table "emergency_governance_record" */
export enum Emergency_Governance_Record_Select_Column_Emergency_Governance_Record_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  SmvnPercentageRequired = 'smvn_percentage_required',
  /** column name */
  SmvnRequiredForTrigger = 'smvn_required_for_trigger',
  /** column name */
  TotalSmvnVotes = 'total_smvn_votes'
}

/** select "emergency_governance_record_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "emergency_governance_record" */
export enum Emergency_Governance_Record_Select_Column_Emergency_Governance_Record_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  SmvnPercentageRequired = 'smvn_percentage_required',
  /** column name */
  SmvnRequiredForTrigger = 'smvn_required_for_trigger',
  /** column name */
  TotalSmvnVotes = 'total_smvn_votes'
}

/** select "emergency_governance_record_aggregate_bool_exp_max_arguments_columns" columns of table "emergency_governance_record" */
export enum Emergency_Governance_Record_Select_Column_Emergency_Governance_Record_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  SmvnPercentageRequired = 'smvn_percentage_required',
  /** column name */
  SmvnRequiredForTrigger = 'smvn_required_for_trigger',
  /** column name */
  TotalSmvnVotes = 'total_smvn_votes'
}

/** select "emergency_governance_record_aggregate_bool_exp_min_arguments_columns" columns of table "emergency_governance_record" */
export enum Emergency_Governance_Record_Select_Column_Emergency_Governance_Record_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  SmvnPercentageRequired = 'smvn_percentage_required',
  /** column name */
  SmvnRequiredForTrigger = 'smvn_required_for_trigger',
  /** column name */
  TotalSmvnVotes = 'total_smvn_votes'
}

/** select "emergency_governance_record_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "emergency_governance_record" */
export enum Emergency_Governance_Record_Select_Column_Emergency_Governance_Record_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  SmvnPercentageRequired = 'smvn_percentage_required',
  /** column name */
  SmvnRequiredForTrigger = 'smvn_required_for_trigger',
  /** column name */
  TotalSmvnVotes = 'total_smvn_votes'
}

/** select "emergency_governance_record_aggregate_bool_exp_sum_arguments_columns" columns of table "emergency_governance_record" */
export enum Emergency_Governance_Record_Select_Column_Emergency_Governance_Record_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  SmvnPercentageRequired = 'smvn_percentage_required',
  /** column name */
  SmvnRequiredForTrigger = 'smvn_required_for_trigger',
  /** column name */
  TotalSmvnVotes = 'total_smvn_votes'
}

/** select "emergency_governance_record_aggregate_bool_exp_var_samp_arguments_columns" columns of table "emergency_governance_record" */
export enum Emergency_Governance_Record_Select_Column_Emergency_Governance_Record_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  SmvnPercentageRequired = 'smvn_percentage_required',
  /** column name */
  SmvnRequiredForTrigger = 'smvn_required_for_trigger',
  /** column name */
  TotalSmvnVotes = 'total_smvn_votes'
}

/** aggregate stddev on columns */
export type Emergency_Governance_Record_Stddev_Fields = {
  __typename?: 'emergency_governance_record_stddev_fields';
  emergency_governance_id?: Maybe<Scalars['Float']['output']>;
  execution_level?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  proposer_id?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_required?: Maybe<Scalars['Float']['output']>;
  smvn_required_for_trigger?: Maybe<Scalars['Float']['output']>;
  start_level?: Maybe<Scalars['Float']['output']>;
  total_smvn_votes?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "emergency_governance_record" */
export type Emergency_Governance_Record_Stddev_Order_By = {
  emergency_governance_id?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  proposer_id?: InputMaybe<Order_By>;
  smvn_percentage_required?: InputMaybe<Order_By>;
  smvn_required_for_trigger?: InputMaybe<Order_By>;
  start_level?: InputMaybe<Order_By>;
  total_smvn_votes?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Emergency_Governance_Record_Stddev_Pop_Fields = {
  __typename?: 'emergency_governance_record_stddev_pop_fields';
  emergency_governance_id?: Maybe<Scalars['Float']['output']>;
  execution_level?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  proposer_id?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_required?: Maybe<Scalars['Float']['output']>;
  smvn_required_for_trigger?: Maybe<Scalars['Float']['output']>;
  start_level?: Maybe<Scalars['Float']['output']>;
  total_smvn_votes?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "emergency_governance_record" */
export type Emergency_Governance_Record_Stddev_Pop_Order_By = {
  emergency_governance_id?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  proposer_id?: InputMaybe<Order_By>;
  smvn_percentage_required?: InputMaybe<Order_By>;
  smvn_required_for_trigger?: InputMaybe<Order_By>;
  start_level?: InputMaybe<Order_By>;
  total_smvn_votes?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Emergency_Governance_Record_Stddev_Samp_Fields = {
  __typename?: 'emergency_governance_record_stddev_samp_fields';
  emergency_governance_id?: Maybe<Scalars['Float']['output']>;
  execution_level?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  proposer_id?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_required?: Maybe<Scalars['Float']['output']>;
  smvn_required_for_trigger?: Maybe<Scalars['Float']['output']>;
  start_level?: Maybe<Scalars['Float']['output']>;
  total_smvn_votes?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "emergency_governance_record" */
export type Emergency_Governance_Record_Stddev_Samp_Order_By = {
  emergency_governance_id?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  proposer_id?: InputMaybe<Order_By>;
  smvn_percentage_required?: InputMaybe<Order_By>;
  smvn_required_for_trigger?: InputMaybe<Order_By>;
  start_level?: InputMaybe<Order_By>;
  total_smvn_votes?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "emergency_governance_record" */
export type Emergency_Governance_Record_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Emergency_Governance_Record_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Emergency_Governance_Record_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  emergency_governance_id?: InputMaybe<Scalars['bigint']['input']>;
  executed?: InputMaybe<Scalars['Boolean']['input']>;
  execution_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  execution_level?: InputMaybe<Scalars['bigint']['input']>;
  expiration_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  internal_id?: InputMaybe<Scalars['bigint']['input']>;
  proposer_id?: InputMaybe<Scalars['bigint']['input']>;
  smvn_percentage_required?: InputMaybe<Scalars['float8']['input']>;
  smvn_required_for_trigger?: InputMaybe<Scalars['float8']['input']>;
  start_level?: InputMaybe<Scalars['bigint']['input']>;
  start_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  total_smvn_votes?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type Emergency_Governance_Record_Sum_Fields = {
  __typename?: 'emergency_governance_record_sum_fields';
  emergency_governance_id?: Maybe<Scalars['bigint']['output']>;
  execution_level?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['bigint']['output']>;
  proposer_id?: Maybe<Scalars['bigint']['output']>;
  smvn_percentage_required?: Maybe<Scalars['float8']['output']>;
  smvn_required_for_trigger?: Maybe<Scalars['float8']['output']>;
  start_level?: Maybe<Scalars['bigint']['output']>;
  total_smvn_votes?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "emergency_governance_record" */
export type Emergency_Governance_Record_Sum_Order_By = {
  emergency_governance_id?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  proposer_id?: InputMaybe<Order_By>;
  smvn_percentage_required?: InputMaybe<Order_By>;
  smvn_required_for_trigger?: InputMaybe<Order_By>;
  start_level?: InputMaybe<Order_By>;
  total_smvn_votes?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Emergency_Governance_Record_Var_Pop_Fields = {
  __typename?: 'emergency_governance_record_var_pop_fields';
  emergency_governance_id?: Maybe<Scalars['Float']['output']>;
  execution_level?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  proposer_id?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_required?: Maybe<Scalars['Float']['output']>;
  smvn_required_for_trigger?: Maybe<Scalars['Float']['output']>;
  start_level?: Maybe<Scalars['Float']['output']>;
  total_smvn_votes?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "emergency_governance_record" */
export type Emergency_Governance_Record_Var_Pop_Order_By = {
  emergency_governance_id?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  proposer_id?: InputMaybe<Order_By>;
  smvn_percentage_required?: InputMaybe<Order_By>;
  smvn_required_for_trigger?: InputMaybe<Order_By>;
  start_level?: InputMaybe<Order_By>;
  total_smvn_votes?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Emergency_Governance_Record_Var_Samp_Fields = {
  __typename?: 'emergency_governance_record_var_samp_fields';
  emergency_governance_id?: Maybe<Scalars['Float']['output']>;
  execution_level?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  proposer_id?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_required?: Maybe<Scalars['Float']['output']>;
  smvn_required_for_trigger?: Maybe<Scalars['Float']['output']>;
  start_level?: Maybe<Scalars['Float']['output']>;
  total_smvn_votes?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "emergency_governance_record" */
export type Emergency_Governance_Record_Var_Samp_Order_By = {
  emergency_governance_id?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  proposer_id?: InputMaybe<Order_By>;
  smvn_percentage_required?: InputMaybe<Order_By>;
  smvn_required_for_trigger?: InputMaybe<Order_By>;
  start_level?: InputMaybe<Order_By>;
  total_smvn_votes?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Emergency_Governance_Record_Variance_Fields = {
  __typename?: 'emergency_governance_record_variance_fields';
  emergency_governance_id?: Maybe<Scalars['Float']['output']>;
  execution_level?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  proposer_id?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_required?: Maybe<Scalars['Float']['output']>;
  smvn_required_for_trigger?: Maybe<Scalars['Float']['output']>;
  start_level?: Maybe<Scalars['Float']['output']>;
  total_smvn_votes?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "emergency_governance_record" */
export type Emergency_Governance_Record_Variance_Order_By = {
  emergency_governance_id?: InputMaybe<Order_By>;
  execution_level?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  proposer_id?: InputMaybe<Order_By>;
  smvn_percentage_required?: InputMaybe<Order_By>;
  smvn_required_for_trigger?: InputMaybe<Order_By>;
  start_level?: InputMaybe<Order_By>;
  total_smvn_votes?: InputMaybe<Order_By>;
};

/** select columns of table "emergency_governance" */
export enum Emergency_Governance_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Admin = 'admin',
  /** column name */
  CurrentEmergencyRecordId = 'current_emergency_record_id',
  /** column name */
  Decimals = 'decimals',
  /** column name */
  DurationInMinutes = 'duration_in_minutes',
  /** column name */
  GovernanceId = 'governance_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MinSmvnRequiredToTrigger = 'min_smvn_required_to_trigger',
  /** column name */
  MinSmvnRequiredToVote = 'min_smvn_required_to_vote',
  /** column name */
  Network = 'network',
  /** column name */
  NextEmergencyRecordId = 'next_emergency_record_id',
  /** column name */
  ProposalDescMaxLength = 'proposal_desc_max_length',
  /** column name */
  ProposalTitleMaxLength = 'proposal_title_max_length',
  /** column name */
  RequiredFeeMumav = 'required_fee_mumav',
  /** column name */
  SmvnPercentageRequired = 'smvn_percentage_required'
}

/** select "emergency_governance_aggregate_bool_exp_avg_arguments_columns" columns of table "emergency_governance" */
export enum Emergency_Governance_Select_Column_Emergency_Governance_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  MinSmvnRequiredToTrigger = 'min_smvn_required_to_trigger',
  /** column name */
  MinSmvnRequiredToVote = 'min_smvn_required_to_vote'
}

/** select "emergency_governance_aggregate_bool_exp_corr_arguments_columns" columns of table "emergency_governance" */
export enum Emergency_Governance_Select_Column_Emergency_Governance_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  MinSmvnRequiredToTrigger = 'min_smvn_required_to_trigger',
  /** column name */
  MinSmvnRequiredToVote = 'min_smvn_required_to_vote'
}

/** select "emergency_governance_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "emergency_governance" */
export enum Emergency_Governance_Select_Column_Emergency_Governance_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  MinSmvnRequiredToTrigger = 'min_smvn_required_to_trigger',
  /** column name */
  MinSmvnRequiredToVote = 'min_smvn_required_to_vote'
}

/** select "emergency_governance_aggregate_bool_exp_max_arguments_columns" columns of table "emergency_governance" */
export enum Emergency_Governance_Select_Column_Emergency_Governance_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  MinSmvnRequiredToTrigger = 'min_smvn_required_to_trigger',
  /** column name */
  MinSmvnRequiredToVote = 'min_smvn_required_to_vote'
}

/** select "emergency_governance_aggregate_bool_exp_min_arguments_columns" columns of table "emergency_governance" */
export enum Emergency_Governance_Select_Column_Emergency_Governance_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  MinSmvnRequiredToTrigger = 'min_smvn_required_to_trigger',
  /** column name */
  MinSmvnRequiredToVote = 'min_smvn_required_to_vote'
}

/** select "emergency_governance_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "emergency_governance" */
export enum Emergency_Governance_Select_Column_Emergency_Governance_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  MinSmvnRequiredToTrigger = 'min_smvn_required_to_trigger',
  /** column name */
  MinSmvnRequiredToVote = 'min_smvn_required_to_vote'
}

/** select "emergency_governance_aggregate_bool_exp_sum_arguments_columns" columns of table "emergency_governance" */
export enum Emergency_Governance_Select_Column_Emergency_Governance_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  MinSmvnRequiredToTrigger = 'min_smvn_required_to_trigger',
  /** column name */
  MinSmvnRequiredToVote = 'min_smvn_required_to_vote'
}

/** select "emergency_governance_aggregate_bool_exp_var_samp_arguments_columns" columns of table "emergency_governance" */
export enum Emergency_Governance_Select_Column_Emergency_Governance_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  MinSmvnRequiredToTrigger = 'min_smvn_required_to_trigger',
  /** column name */
  MinSmvnRequiredToVote = 'min_smvn_required_to_vote'
}

/** aggregate stddev on columns */
export type Emergency_Governance_Stddev_Fields = {
  __typename?: 'emergency_governance_stddev_fields';
  current_emergency_record_id?: Maybe<Scalars['Float']['output']>;
  decimals?: Maybe<Scalars['Float']['output']>;
  duration_in_minutes?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  min_smvn_required_to_trigger?: Maybe<Scalars['Float']['output']>;
  min_smvn_required_to_vote?: Maybe<Scalars['Float']['output']>;
  next_emergency_record_id?: Maybe<Scalars['Float']['output']>;
  proposal_desc_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_title_max_length?: Maybe<Scalars['Float']['output']>;
  required_fee_mumav?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_required?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "emergency_governance" */
export type Emergency_Governance_Stddev_Order_By = {
  current_emergency_record_id?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  duration_in_minutes?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  min_smvn_required_to_trigger?: InputMaybe<Order_By>;
  min_smvn_required_to_vote?: InputMaybe<Order_By>;
  next_emergency_record_id?: InputMaybe<Order_By>;
  proposal_desc_max_length?: InputMaybe<Order_By>;
  proposal_title_max_length?: InputMaybe<Order_By>;
  required_fee_mumav?: InputMaybe<Order_By>;
  smvn_percentage_required?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Emergency_Governance_Stddev_Pop_Fields = {
  __typename?: 'emergency_governance_stddev_pop_fields';
  current_emergency_record_id?: Maybe<Scalars['Float']['output']>;
  decimals?: Maybe<Scalars['Float']['output']>;
  duration_in_minutes?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  min_smvn_required_to_trigger?: Maybe<Scalars['Float']['output']>;
  min_smvn_required_to_vote?: Maybe<Scalars['Float']['output']>;
  next_emergency_record_id?: Maybe<Scalars['Float']['output']>;
  proposal_desc_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_title_max_length?: Maybe<Scalars['Float']['output']>;
  required_fee_mumav?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_required?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "emergency_governance" */
export type Emergency_Governance_Stddev_Pop_Order_By = {
  current_emergency_record_id?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  duration_in_minutes?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  min_smvn_required_to_trigger?: InputMaybe<Order_By>;
  min_smvn_required_to_vote?: InputMaybe<Order_By>;
  next_emergency_record_id?: InputMaybe<Order_By>;
  proposal_desc_max_length?: InputMaybe<Order_By>;
  proposal_title_max_length?: InputMaybe<Order_By>;
  required_fee_mumav?: InputMaybe<Order_By>;
  smvn_percentage_required?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Emergency_Governance_Stddev_Samp_Fields = {
  __typename?: 'emergency_governance_stddev_samp_fields';
  current_emergency_record_id?: Maybe<Scalars['Float']['output']>;
  decimals?: Maybe<Scalars['Float']['output']>;
  duration_in_minutes?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  min_smvn_required_to_trigger?: Maybe<Scalars['Float']['output']>;
  min_smvn_required_to_vote?: Maybe<Scalars['Float']['output']>;
  next_emergency_record_id?: Maybe<Scalars['Float']['output']>;
  proposal_desc_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_title_max_length?: Maybe<Scalars['Float']['output']>;
  required_fee_mumav?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_required?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "emergency_governance" */
export type Emergency_Governance_Stddev_Samp_Order_By = {
  current_emergency_record_id?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  duration_in_minutes?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  min_smvn_required_to_trigger?: InputMaybe<Order_By>;
  min_smvn_required_to_vote?: InputMaybe<Order_By>;
  next_emergency_record_id?: InputMaybe<Order_By>;
  proposal_desc_max_length?: InputMaybe<Order_By>;
  proposal_title_max_length?: InputMaybe<Order_By>;
  required_fee_mumav?: InputMaybe<Order_By>;
  smvn_percentage_required?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "emergency_governance" */
export type Emergency_Governance_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Emergency_Governance_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Emergency_Governance_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['String']['input']>;
  current_emergency_record_id?: InputMaybe<Scalars['bigint']['input']>;
  decimals?: InputMaybe<Scalars['smallint']['input']>;
  duration_in_minutes?: InputMaybe<Scalars['bigint']['input']>;
  governance_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  min_smvn_required_to_trigger?: InputMaybe<Scalars['float8']['input']>;
  min_smvn_required_to_vote?: InputMaybe<Scalars['float8']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  next_emergency_record_id?: InputMaybe<Scalars['bigint']['input']>;
  proposal_desc_max_length?: InputMaybe<Scalars['smallint']['input']>;
  proposal_title_max_length?: InputMaybe<Scalars['smallint']['input']>;
  required_fee_mumav?: InputMaybe<Scalars['bigint']['input']>;
  smvn_percentage_required?: InputMaybe<Scalars['smallint']['input']>;
};

/** aggregate sum on columns */
export type Emergency_Governance_Sum_Fields = {
  __typename?: 'emergency_governance_sum_fields';
  current_emergency_record_id?: Maybe<Scalars['bigint']['output']>;
  decimals?: Maybe<Scalars['smallint']['output']>;
  duration_in_minutes?: Maybe<Scalars['bigint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  min_smvn_required_to_trigger?: Maybe<Scalars['float8']['output']>;
  min_smvn_required_to_vote?: Maybe<Scalars['float8']['output']>;
  next_emergency_record_id?: Maybe<Scalars['bigint']['output']>;
  proposal_desc_max_length?: Maybe<Scalars['smallint']['output']>;
  proposal_title_max_length?: Maybe<Scalars['smallint']['output']>;
  required_fee_mumav?: Maybe<Scalars['bigint']['output']>;
  smvn_percentage_required?: Maybe<Scalars['smallint']['output']>;
};

/** order by sum() on columns of table "emergency_governance" */
export type Emergency_Governance_Sum_Order_By = {
  current_emergency_record_id?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  duration_in_minutes?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  min_smvn_required_to_trigger?: InputMaybe<Order_By>;
  min_smvn_required_to_vote?: InputMaybe<Order_By>;
  next_emergency_record_id?: InputMaybe<Order_By>;
  proposal_desc_max_length?: InputMaybe<Order_By>;
  proposal_title_max_length?: InputMaybe<Order_By>;
  required_fee_mumav?: InputMaybe<Order_By>;
  smvn_percentage_required?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Emergency_Governance_Var_Pop_Fields = {
  __typename?: 'emergency_governance_var_pop_fields';
  current_emergency_record_id?: Maybe<Scalars['Float']['output']>;
  decimals?: Maybe<Scalars['Float']['output']>;
  duration_in_minutes?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  min_smvn_required_to_trigger?: Maybe<Scalars['Float']['output']>;
  min_smvn_required_to_vote?: Maybe<Scalars['Float']['output']>;
  next_emergency_record_id?: Maybe<Scalars['Float']['output']>;
  proposal_desc_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_title_max_length?: Maybe<Scalars['Float']['output']>;
  required_fee_mumav?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_required?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "emergency_governance" */
export type Emergency_Governance_Var_Pop_Order_By = {
  current_emergency_record_id?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  duration_in_minutes?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  min_smvn_required_to_trigger?: InputMaybe<Order_By>;
  min_smvn_required_to_vote?: InputMaybe<Order_By>;
  next_emergency_record_id?: InputMaybe<Order_By>;
  proposal_desc_max_length?: InputMaybe<Order_By>;
  proposal_title_max_length?: InputMaybe<Order_By>;
  required_fee_mumav?: InputMaybe<Order_By>;
  smvn_percentage_required?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Emergency_Governance_Var_Samp_Fields = {
  __typename?: 'emergency_governance_var_samp_fields';
  current_emergency_record_id?: Maybe<Scalars['Float']['output']>;
  decimals?: Maybe<Scalars['Float']['output']>;
  duration_in_minutes?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  min_smvn_required_to_trigger?: Maybe<Scalars['Float']['output']>;
  min_smvn_required_to_vote?: Maybe<Scalars['Float']['output']>;
  next_emergency_record_id?: Maybe<Scalars['Float']['output']>;
  proposal_desc_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_title_max_length?: Maybe<Scalars['Float']['output']>;
  required_fee_mumav?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_required?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "emergency_governance" */
export type Emergency_Governance_Var_Samp_Order_By = {
  current_emergency_record_id?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  duration_in_minutes?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  min_smvn_required_to_trigger?: InputMaybe<Order_By>;
  min_smvn_required_to_vote?: InputMaybe<Order_By>;
  next_emergency_record_id?: InputMaybe<Order_By>;
  proposal_desc_max_length?: InputMaybe<Order_By>;
  proposal_title_max_length?: InputMaybe<Order_By>;
  required_fee_mumav?: InputMaybe<Order_By>;
  smvn_percentage_required?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Emergency_Governance_Variance_Fields = {
  __typename?: 'emergency_governance_variance_fields';
  current_emergency_record_id?: Maybe<Scalars['Float']['output']>;
  decimals?: Maybe<Scalars['Float']['output']>;
  duration_in_minutes?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  min_smvn_required_to_trigger?: Maybe<Scalars['Float']['output']>;
  min_smvn_required_to_vote?: Maybe<Scalars['Float']['output']>;
  next_emergency_record_id?: Maybe<Scalars['Float']['output']>;
  proposal_desc_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_title_max_length?: Maybe<Scalars['Float']['output']>;
  required_fee_mumav?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_required?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "emergency_governance" */
export type Emergency_Governance_Variance_Order_By = {
  current_emergency_record_id?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  duration_in_minutes?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  min_smvn_required_to_trigger?: InputMaybe<Order_By>;
  min_smvn_required_to_vote?: InputMaybe<Order_By>;
  next_emergency_record_id?: InputMaybe<Order_By>;
  proposal_desc_max_length?: InputMaybe<Order_By>;
  proposal_title_max_length?: InputMaybe<Order_By>;
  required_fee_mumav?: InputMaybe<Order_By>;
  smvn_percentage_required?: InputMaybe<Order_By>;
};

/** columns and relationships of "emergency_governance_vote" */
export type Emergency_Governance_Vote = {
  __typename?: 'emergency_governance_vote';
  /** An object relationship */
  emergency_governance_record: Emergency_Governance_Record;
  emergency_governance_record_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  smvn_amount: Scalars['float8']['output'];
  timestamp: Scalars['timestamptz']['output'];
  /** An object relationship */
  voter: Maven_User;
  voter_id: Scalars['bigint']['output'];
};

/** aggregated selection of "emergency_governance_vote" */
export type Emergency_Governance_Vote_Aggregate = {
  __typename?: 'emergency_governance_vote_aggregate';
  aggregate?: Maybe<Emergency_Governance_Vote_Aggregate_Fields>;
  nodes: Array<Emergency_Governance_Vote>;
};

export type Emergency_Governance_Vote_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Emergency_Governance_Vote_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Emergency_Governance_Vote_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Emergency_Governance_Vote_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Emergency_Governance_Vote_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Emergency_Governance_Vote_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Emergency_Governance_Vote_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Emergency_Governance_Vote_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Emergency_Governance_Vote_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Emergency_Governance_Vote_Aggregate_Bool_Exp_Var_Samp>;
};

export type Emergency_Governance_Vote_Aggregate_Bool_Exp_Avg = {
  arguments: Emergency_Governance_Vote_Select_Column_Emergency_Governance_Vote_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Vote_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Emergency_Governance_Vote_Aggregate_Bool_Exp_Corr = {
  arguments: Emergency_Governance_Vote_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Vote_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Emergency_Governance_Vote_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Emergency_Governance_Vote_Select_Column_Emergency_Governance_Vote_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Emergency_Governance_Vote_Select_Column_Emergency_Governance_Vote_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Emergency_Governance_Vote_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Emergency_Governance_Vote_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Vote_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Emergency_Governance_Vote_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Emergency_Governance_Vote_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Vote_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Emergency_Governance_Vote_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Emergency_Governance_Vote_Select_Column_Emergency_Governance_Vote_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Emergency_Governance_Vote_Select_Column_Emergency_Governance_Vote_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Emergency_Governance_Vote_Aggregate_Bool_Exp_Max = {
  arguments: Emergency_Governance_Vote_Select_Column_Emergency_Governance_Vote_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Vote_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Emergency_Governance_Vote_Aggregate_Bool_Exp_Min = {
  arguments: Emergency_Governance_Vote_Select_Column_Emergency_Governance_Vote_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Vote_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Emergency_Governance_Vote_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Emergency_Governance_Vote_Select_Column_Emergency_Governance_Vote_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Vote_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Emergency_Governance_Vote_Aggregate_Bool_Exp_Sum = {
  arguments: Emergency_Governance_Vote_Select_Column_Emergency_Governance_Vote_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Vote_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Emergency_Governance_Vote_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Emergency_Governance_Vote_Select_Column_Emergency_Governance_Vote_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Vote_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "emergency_governance_vote" */
export type Emergency_Governance_Vote_Aggregate_Fields = {
  __typename?: 'emergency_governance_vote_aggregate_fields';
  avg?: Maybe<Emergency_Governance_Vote_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Emergency_Governance_Vote_Max_Fields>;
  min?: Maybe<Emergency_Governance_Vote_Min_Fields>;
  stddev?: Maybe<Emergency_Governance_Vote_Stddev_Fields>;
  stddev_pop?: Maybe<Emergency_Governance_Vote_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Emergency_Governance_Vote_Stddev_Samp_Fields>;
  sum?: Maybe<Emergency_Governance_Vote_Sum_Fields>;
  var_pop?: Maybe<Emergency_Governance_Vote_Var_Pop_Fields>;
  var_samp?: Maybe<Emergency_Governance_Vote_Var_Samp_Fields>;
  variance?: Maybe<Emergency_Governance_Vote_Variance_Fields>;
};


/** aggregate fields of "emergency_governance_vote" */
export type Emergency_Governance_Vote_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Emergency_Governance_Vote_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "emergency_governance_vote" */
export type Emergency_Governance_Vote_Aggregate_Order_By = {
  avg?: InputMaybe<Emergency_Governance_Vote_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Emergency_Governance_Vote_Max_Order_By>;
  min?: InputMaybe<Emergency_Governance_Vote_Min_Order_By>;
  stddev?: InputMaybe<Emergency_Governance_Vote_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Emergency_Governance_Vote_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Emergency_Governance_Vote_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Emergency_Governance_Vote_Sum_Order_By>;
  var_pop?: InputMaybe<Emergency_Governance_Vote_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Emergency_Governance_Vote_Var_Samp_Order_By>;
  variance?: InputMaybe<Emergency_Governance_Vote_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Emergency_Governance_Vote_Avg_Fields = {
  __typename?: 'emergency_governance_vote_avg_fields';
  emergency_governance_record_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  smvn_amount?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "emergency_governance_vote" */
export type Emergency_Governance_Vote_Avg_Order_By = {
  emergency_governance_record_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  smvn_amount?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "emergency_governance_vote". All fields are combined with a logical 'AND'. */
export type Emergency_Governance_Vote_Bool_Exp = {
  _and?: InputMaybe<Array<Emergency_Governance_Vote_Bool_Exp>>;
  _not?: InputMaybe<Emergency_Governance_Vote_Bool_Exp>;
  _or?: InputMaybe<Array<Emergency_Governance_Vote_Bool_Exp>>;
  emergency_governance_record?: InputMaybe<Emergency_Governance_Record_Bool_Exp>;
  emergency_governance_record_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  smvn_amount?: InputMaybe<Float8_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  voter?: InputMaybe<Maven_User_Bool_Exp>;
  voter_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Emergency_Governance_Vote_Max_Fields = {
  __typename?: 'emergency_governance_vote_max_fields';
  emergency_governance_record_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  smvn_amount?: Maybe<Scalars['float8']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  voter_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "emergency_governance_vote" */
export type Emergency_Governance_Vote_Max_Order_By = {
  emergency_governance_record_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  smvn_amount?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Emergency_Governance_Vote_Min_Fields = {
  __typename?: 'emergency_governance_vote_min_fields';
  emergency_governance_record_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  smvn_amount?: Maybe<Scalars['float8']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  voter_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "emergency_governance_vote" */
export type Emergency_Governance_Vote_Min_Order_By = {
  emergency_governance_record_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  smvn_amount?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "emergency_governance_vote". */
export type Emergency_Governance_Vote_Order_By = {
  emergency_governance_record?: InputMaybe<Emergency_Governance_Record_Order_By>;
  emergency_governance_record_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  smvn_amount?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  voter?: InputMaybe<Maven_User_Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** select columns of table "emergency_governance_vote" */
export enum Emergency_Governance_Vote_Select_Column {
  /** column name */
  EmergencyGovernanceRecordId = 'emergency_governance_record_id',
  /** column name */
  Id = 'id',
  /** column name */
  SmvnAmount = 'smvn_amount',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  VoterId = 'voter_id'
}

/** select "emergency_governance_vote_aggregate_bool_exp_avg_arguments_columns" columns of table "emergency_governance_vote" */
export enum Emergency_Governance_Vote_Select_Column_Emergency_Governance_Vote_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  SmvnAmount = 'smvn_amount'
}

/** select "emergency_governance_vote_aggregate_bool_exp_corr_arguments_columns" columns of table "emergency_governance_vote" */
export enum Emergency_Governance_Vote_Select_Column_Emergency_Governance_Vote_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  SmvnAmount = 'smvn_amount'
}

/** select "emergency_governance_vote_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "emergency_governance_vote" */
export enum Emergency_Governance_Vote_Select_Column_Emergency_Governance_Vote_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  SmvnAmount = 'smvn_amount'
}

/** select "emergency_governance_vote_aggregate_bool_exp_max_arguments_columns" columns of table "emergency_governance_vote" */
export enum Emergency_Governance_Vote_Select_Column_Emergency_Governance_Vote_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  SmvnAmount = 'smvn_amount'
}

/** select "emergency_governance_vote_aggregate_bool_exp_min_arguments_columns" columns of table "emergency_governance_vote" */
export enum Emergency_Governance_Vote_Select_Column_Emergency_Governance_Vote_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  SmvnAmount = 'smvn_amount'
}

/** select "emergency_governance_vote_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "emergency_governance_vote" */
export enum Emergency_Governance_Vote_Select_Column_Emergency_Governance_Vote_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  SmvnAmount = 'smvn_amount'
}

/** select "emergency_governance_vote_aggregate_bool_exp_sum_arguments_columns" columns of table "emergency_governance_vote" */
export enum Emergency_Governance_Vote_Select_Column_Emergency_Governance_Vote_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  SmvnAmount = 'smvn_amount'
}

/** select "emergency_governance_vote_aggregate_bool_exp_var_samp_arguments_columns" columns of table "emergency_governance_vote" */
export enum Emergency_Governance_Vote_Select_Column_Emergency_Governance_Vote_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  SmvnAmount = 'smvn_amount'
}

/** aggregate stddev on columns */
export type Emergency_Governance_Vote_Stddev_Fields = {
  __typename?: 'emergency_governance_vote_stddev_fields';
  emergency_governance_record_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  smvn_amount?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "emergency_governance_vote" */
export type Emergency_Governance_Vote_Stddev_Order_By = {
  emergency_governance_record_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  smvn_amount?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Emergency_Governance_Vote_Stddev_Pop_Fields = {
  __typename?: 'emergency_governance_vote_stddev_pop_fields';
  emergency_governance_record_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  smvn_amount?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "emergency_governance_vote" */
export type Emergency_Governance_Vote_Stddev_Pop_Order_By = {
  emergency_governance_record_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  smvn_amount?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Emergency_Governance_Vote_Stddev_Samp_Fields = {
  __typename?: 'emergency_governance_vote_stddev_samp_fields';
  emergency_governance_record_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  smvn_amount?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "emergency_governance_vote" */
export type Emergency_Governance_Vote_Stddev_Samp_Order_By = {
  emergency_governance_record_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  smvn_amount?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "emergency_governance_vote" */
export type Emergency_Governance_Vote_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Emergency_Governance_Vote_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Emergency_Governance_Vote_Stream_Cursor_Value_Input = {
  emergency_governance_record_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  smvn_amount?: InputMaybe<Scalars['float8']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  voter_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Emergency_Governance_Vote_Sum_Fields = {
  __typename?: 'emergency_governance_vote_sum_fields';
  emergency_governance_record_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  smvn_amount?: Maybe<Scalars['float8']['output']>;
  voter_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "emergency_governance_vote" */
export type Emergency_Governance_Vote_Sum_Order_By = {
  emergency_governance_record_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  smvn_amount?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Emergency_Governance_Vote_Var_Pop_Fields = {
  __typename?: 'emergency_governance_vote_var_pop_fields';
  emergency_governance_record_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  smvn_amount?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "emergency_governance_vote" */
export type Emergency_Governance_Vote_Var_Pop_Order_By = {
  emergency_governance_record_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  smvn_amount?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Emergency_Governance_Vote_Var_Samp_Fields = {
  __typename?: 'emergency_governance_vote_var_samp_fields';
  emergency_governance_record_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  smvn_amount?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "emergency_governance_vote" */
export type Emergency_Governance_Vote_Var_Samp_Order_By = {
  emergency_governance_record_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  smvn_amount?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Emergency_Governance_Vote_Variance_Fields = {
  __typename?: 'emergency_governance_vote_variance_fields';
  emergency_governance_record_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  smvn_amount?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "emergency_governance_vote" */
export type Emergency_Governance_Vote_Variance_Order_By = {
  emergency_governance_record_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  smvn_amount?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "emergency_governance_whitelist_contract" */
export type Emergency_Governance_Whitelist_Contract = {
  __typename?: 'emergency_governance_whitelist_contract';
  /** An object relationship */
  contract: Emergency_Governance;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "emergency_governance_whitelist_contract" */
export type Emergency_Governance_Whitelist_Contract_Aggregate = {
  __typename?: 'emergency_governance_whitelist_contract_aggregate';
  aggregate?: Maybe<Emergency_Governance_Whitelist_Contract_Aggregate_Fields>;
  nodes: Array<Emergency_Governance_Whitelist_Contract>;
};

export type Emergency_Governance_Whitelist_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Emergency_Governance_Whitelist_Contract_Aggregate_Bool_Exp_Count>;
};

export type Emergency_Governance_Whitelist_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Emergency_Governance_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Emergency_Governance_Whitelist_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "emergency_governance_whitelist_contract" */
export type Emergency_Governance_Whitelist_Contract_Aggregate_Fields = {
  __typename?: 'emergency_governance_whitelist_contract_aggregate_fields';
  avg?: Maybe<Emergency_Governance_Whitelist_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Emergency_Governance_Whitelist_Contract_Max_Fields>;
  min?: Maybe<Emergency_Governance_Whitelist_Contract_Min_Fields>;
  stddev?: Maybe<Emergency_Governance_Whitelist_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Emergency_Governance_Whitelist_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Emergency_Governance_Whitelist_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Emergency_Governance_Whitelist_Contract_Sum_Fields>;
  var_pop?: Maybe<Emergency_Governance_Whitelist_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Emergency_Governance_Whitelist_Contract_Var_Samp_Fields>;
  variance?: Maybe<Emergency_Governance_Whitelist_Contract_Variance_Fields>;
};


/** aggregate fields of "emergency_governance_whitelist_contract" */
export type Emergency_Governance_Whitelist_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Emergency_Governance_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "emergency_governance_whitelist_contract" */
export type Emergency_Governance_Whitelist_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Emergency_Governance_Whitelist_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Emergency_Governance_Whitelist_Contract_Max_Order_By>;
  min?: InputMaybe<Emergency_Governance_Whitelist_Contract_Min_Order_By>;
  stddev?: InputMaybe<Emergency_Governance_Whitelist_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Emergency_Governance_Whitelist_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Emergency_Governance_Whitelist_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Emergency_Governance_Whitelist_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Emergency_Governance_Whitelist_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Emergency_Governance_Whitelist_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Emergency_Governance_Whitelist_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Emergency_Governance_Whitelist_Contract_Avg_Fields = {
  __typename?: 'emergency_governance_whitelist_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "emergency_governance_whitelist_contract" */
export type Emergency_Governance_Whitelist_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "emergency_governance_whitelist_contract". All fields are combined with a logical 'AND'. */
export type Emergency_Governance_Whitelist_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Emergency_Governance_Whitelist_Contract_Bool_Exp>>;
  _not?: InputMaybe<Emergency_Governance_Whitelist_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Emergency_Governance_Whitelist_Contract_Bool_Exp>>;
  contract?: InputMaybe<Emergency_Governance_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Emergency_Governance_Whitelist_Contract_Max_Fields = {
  __typename?: 'emergency_governance_whitelist_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "emergency_governance_whitelist_contract" */
export type Emergency_Governance_Whitelist_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Emergency_Governance_Whitelist_Contract_Min_Fields = {
  __typename?: 'emergency_governance_whitelist_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "emergency_governance_whitelist_contract" */
export type Emergency_Governance_Whitelist_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "emergency_governance_whitelist_contract". */
export type Emergency_Governance_Whitelist_Contract_Order_By = {
  contract?: InputMaybe<Emergency_Governance_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "emergency_governance_whitelist_contract" */
export enum Emergency_Governance_Whitelist_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Emergency_Governance_Whitelist_Contract_Stddev_Fields = {
  __typename?: 'emergency_governance_whitelist_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "emergency_governance_whitelist_contract" */
export type Emergency_Governance_Whitelist_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Emergency_Governance_Whitelist_Contract_Stddev_Pop_Fields = {
  __typename?: 'emergency_governance_whitelist_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "emergency_governance_whitelist_contract" */
export type Emergency_Governance_Whitelist_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Emergency_Governance_Whitelist_Contract_Stddev_Samp_Fields = {
  __typename?: 'emergency_governance_whitelist_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "emergency_governance_whitelist_contract" */
export type Emergency_Governance_Whitelist_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "emergency_governance_whitelist_contract" */
export type Emergency_Governance_Whitelist_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Emergency_Governance_Whitelist_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Emergency_Governance_Whitelist_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Emergency_Governance_Whitelist_Contract_Sum_Fields = {
  __typename?: 'emergency_governance_whitelist_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "emergency_governance_whitelist_contract" */
export type Emergency_Governance_Whitelist_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Emergency_Governance_Whitelist_Contract_Var_Pop_Fields = {
  __typename?: 'emergency_governance_whitelist_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "emergency_governance_whitelist_contract" */
export type Emergency_Governance_Whitelist_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Emergency_Governance_Whitelist_Contract_Var_Samp_Fields = {
  __typename?: 'emergency_governance_whitelist_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "emergency_governance_whitelist_contract" */
export type Emergency_Governance_Whitelist_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Emergency_Governance_Whitelist_Contract_Variance_Fields = {
  __typename?: 'emergency_governance_whitelist_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "emergency_governance_whitelist_contract" */
export type Emergency_Governance_Whitelist_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "farm" */
export type Farm = {
  __typename?: 'farm';
  accumulated_rewards_per_share: Scalars['float8']['output'];
  address: Scalars['String']['output'];
  admin: Scalars['String']['output'];
  claim_paused: Scalars['Boolean']['output'];
  creation_timestamp: Scalars['timestamptz']['output'];
  current_reward_per_block: Scalars['float8']['output'];
  deposit_paused: Scalars['Boolean']['output'];
  end_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  factory?: Maybe<Farm_Factory>;
  factory_id?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  farm_accounts: Array<Farm_Account>;
  /** An aggregate relationship */
  farm_accounts_aggregate: Farm_Account_Aggregate;
  force_rewards_from_transfer: Scalars['Boolean']['output'];
  /** An array relationship */
  general_contracts: Array<Farm_General_Contract>;
  /** An aggregate relationship */
  general_contracts_aggregate: Farm_General_Contract_Aggregate;
  /** An object relationship */
  governance: Governance;
  governance_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  infinite: Scalars['Boolean']['output'];
  init: Scalars['Boolean']['output'];
  init_block: Scalars['bigint']['output'];
  is_m_farm: Scalars['Boolean']['output'];
  /** An array relationship */
  lambdas: Array<Farm_Lambda>;
  /** An aggregate relationship */
  lambdas_aggregate: Farm_Lambda_Aggregate;
  last_block_update: Scalars['bigint']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  loan_token_name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  lp_token: Token;
  lp_token_balance: Scalars['bigint']['output'];
  lp_token_id: Scalars['bigint']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  min_block_time_snapshot: Scalars['smallint']['output'];
  name: Scalars['String']['output'];
  network: Scalars['String']['output'];
  open: Scalars['Boolean']['output'];
  paid_rewards: Scalars['float8']['output'];
  start_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  token0?: Maybe<Token>;
  token0_id?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  token1?: Maybe<Token>;
  token1_id?: Maybe<Scalars['bigint']['output']>;
  total_blocks: Scalars['bigint']['output'];
  total_rewards: Scalars['float8']['output'];
  unpaid_rewards: Scalars['float8']['output'];
  /** An array relationship */
  whitelist_contracts: Array<Farm_Whitelist_Contract>;
  /** An aggregate relationship */
  whitelist_contracts_aggregate: Farm_Whitelist_Contract_Aggregate;
  withdraw_paused: Scalars['Boolean']['output'];
};


/** columns and relationships of "farm" */
export type FarmFarm_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Farm_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Account_Order_By>>;
  where?: InputMaybe<Farm_Account_Bool_Exp>;
};


/** columns and relationships of "farm" */
export type FarmFarm_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Account_Order_By>>;
  where?: InputMaybe<Farm_Account_Bool_Exp>;
};


/** columns and relationships of "farm" */
export type FarmGeneral_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Farm_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_General_Contract_Order_By>>;
  where?: InputMaybe<Farm_General_Contract_Bool_Exp>;
};


/** columns and relationships of "farm" */
export type FarmGeneral_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_General_Contract_Order_By>>;
  where?: InputMaybe<Farm_General_Contract_Bool_Exp>;
};


/** columns and relationships of "farm" */
export type FarmLambdasArgs = {
  distinct_on?: InputMaybe<Array<Farm_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Lambda_Order_By>>;
  where?: InputMaybe<Farm_Lambda_Bool_Exp>;
};


/** columns and relationships of "farm" */
export type FarmLambdas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Lambda_Order_By>>;
  where?: InputMaybe<Farm_Lambda_Bool_Exp>;
};


/** columns and relationships of "farm" */
export type FarmMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "farm" */
export type FarmWhitelist_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Farm_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Farm_Whitelist_Contract_Bool_Exp>;
};


/** columns and relationships of "farm" */
export type FarmWhitelist_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Farm_Whitelist_Contract_Bool_Exp>;
};

/** columns and relationships of "farm_account" */
export type Farm_Account = {
  __typename?: 'farm_account';
  claimed_rewards: Scalars['float8']['output'];
  deposited_amount: Scalars['bigint']['output'];
  /** An object relationship */
  farm: Farm;
  farm_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  participation_rewards_per_share: Scalars['float8']['output'];
  token_reward_index?: Maybe<Scalars['float8']['output']>;
  unclaimed_rewards: Scalars['float8']['output'];
  /** An object relationship */
  user: Maven_User;
  user_id: Scalars['bigint']['output'];
};

/** aggregated selection of "farm_account" */
export type Farm_Account_Aggregate = {
  __typename?: 'farm_account_aggregate';
  aggregate?: Maybe<Farm_Account_Aggregate_Fields>;
  nodes: Array<Farm_Account>;
};

export type Farm_Account_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Farm_Account_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Farm_Account_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Farm_Account_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Farm_Account_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Farm_Account_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Farm_Account_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Farm_Account_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Farm_Account_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Farm_Account_Aggregate_Bool_Exp_Var_Samp>;
};

export type Farm_Account_Aggregate_Bool_Exp_Avg = {
  arguments: Farm_Account_Select_Column_Farm_Account_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Account_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farm_Account_Aggregate_Bool_Exp_Corr = {
  arguments: Farm_Account_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Account_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farm_Account_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Farm_Account_Select_Column_Farm_Account_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Farm_Account_Select_Column_Farm_Account_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Farm_Account_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Farm_Account_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Account_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Farm_Account_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Farm_Account_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Account_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farm_Account_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Farm_Account_Select_Column_Farm_Account_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Farm_Account_Select_Column_Farm_Account_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Farm_Account_Aggregate_Bool_Exp_Max = {
  arguments: Farm_Account_Select_Column_Farm_Account_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Account_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farm_Account_Aggregate_Bool_Exp_Min = {
  arguments: Farm_Account_Select_Column_Farm_Account_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Account_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farm_Account_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Farm_Account_Select_Column_Farm_Account_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Account_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farm_Account_Aggregate_Bool_Exp_Sum = {
  arguments: Farm_Account_Select_Column_Farm_Account_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Account_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farm_Account_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Farm_Account_Select_Column_Farm_Account_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Account_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "farm_account" */
export type Farm_Account_Aggregate_Fields = {
  __typename?: 'farm_account_aggregate_fields';
  avg?: Maybe<Farm_Account_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Farm_Account_Max_Fields>;
  min?: Maybe<Farm_Account_Min_Fields>;
  stddev?: Maybe<Farm_Account_Stddev_Fields>;
  stddev_pop?: Maybe<Farm_Account_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Farm_Account_Stddev_Samp_Fields>;
  sum?: Maybe<Farm_Account_Sum_Fields>;
  var_pop?: Maybe<Farm_Account_Var_Pop_Fields>;
  var_samp?: Maybe<Farm_Account_Var_Samp_Fields>;
  variance?: Maybe<Farm_Account_Variance_Fields>;
};


/** aggregate fields of "farm_account" */
export type Farm_Account_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Farm_Account_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "farm_account" */
export type Farm_Account_Aggregate_Order_By = {
  avg?: InputMaybe<Farm_Account_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Farm_Account_Max_Order_By>;
  min?: InputMaybe<Farm_Account_Min_Order_By>;
  stddev?: InputMaybe<Farm_Account_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Farm_Account_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Farm_Account_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Farm_Account_Sum_Order_By>;
  var_pop?: InputMaybe<Farm_Account_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Farm_Account_Var_Samp_Order_By>;
  variance?: InputMaybe<Farm_Account_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Farm_Account_Avg_Fields = {
  __typename?: 'farm_account_avg_fields';
  claimed_rewards?: Maybe<Scalars['Float']['output']>;
  deposited_amount?: Maybe<Scalars['Float']['output']>;
  farm_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  participation_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  token_reward_index?: Maybe<Scalars['Float']['output']>;
  unclaimed_rewards?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "farm_account" */
export type Farm_Account_Avg_Order_By = {
  claimed_rewards?: InputMaybe<Order_By>;
  deposited_amount?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participation_rewards_per_share?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  unclaimed_rewards?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "farm_account". All fields are combined with a logical 'AND'. */
export type Farm_Account_Bool_Exp = {
  _and?: InputMaybe<Array<Farm_Account_Bool_Exp>>;
  _not?: InputMaybe<Farm_Account_Bool_Exp>;
  _or?: InputMaybe<Array<Farm_Account_Bool_Exp>>;
  claimed_rewards?: InputMaybe<Float8_Comparison_Exp>;
  deposited_amount?: InputMaybe<Bigint_Comparison_Exp>;
  farm?: InputMaybe<Farm_Bool_Exp>;
  farm_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  participation_rewards_per_share?: InputMaybe<Float8_Comparison_Exp>;
  token_reward_index?: InputMaybe<Float8_Comparison_Exp>;
  unclaimed_rewards?: InputMaybe<Float8_Comparison_Exp>;
  user?: InputMaybe<Maven_User_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Farm_Account_Max_Fields = {
  __typename?: 'farm_account_max_fields';
  claimed_rewards?: Maybe<Scalars['float8']['output']>;
  deposited_amount?: Maybe<Scalars['bigint']['output']>;
  farm_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  participation_rewards_per_share?: Maybe<Scalars['float8']['output']>;
  token_reward_index?: Maybe<Scalars['float8']['output']>;
  unclaimed_rewards?: Maybe<Scalars['float8']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "farm_account" */
export type Farm_Account_Max_Order_By = {
  claimed_rewards?: InputMaybe<Order_By>;
  deposited_amount?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participation_rewards_per_share?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  unclaimed_rewards?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Farm_Account_Min_Fields = {
  __typename?: 'farm_account_min_fields';
  claimed_rewards?: Maybe<Scalars['float8']['output']>;
  deposited_amount?: Maybe<Scalars['bigint']['output']>;
  farm_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  participation_rewards_per_share?: Maybe<Scalars['float8']['output']>;
  token_reward_index?: Maybe<Scalars['float8']['output']>;
  unclaimed_rewards?: Maybe<Scalars['float8']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "farm_account" */
export type Farm_Account_Min_Order_By = {
  claimed_rewards?: InputMaybe<Order_By>;
  deposited_amount?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participation_rewards_per_share?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  unclaimed_rewards?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "farm_account". */
export type Farm_Account_Order_By = {
  claimed_rewards?: InputMaybe<Order_By>;
  deposited_amount?: InputMaybe<Order_By>;
  farm?: InputMaybe<Farm_Order_By>;
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participation_rewards_per_share?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  unclaimed_rewards?: InputMaybe<Order_By>;
  user?: InputMaybe<Maven_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "farm_account" */
export enum Farm_Account_Select_Column {
  /** column name */
  ClaimedRewards = 'claimed_rewards',
  /** column name */
  DepositedAmount = 'deposited_amount',
  /** column name */
  FarmId = 'farm_id',
  /** column name */
  Id = 'id',
  /** column name */
  ParticipationRewardsPerShare = 'participation_rewards_per_share',
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  UnclaimedRewards = 'unclaimed_rewards',
  /** column name */
  UserId = 'user_id'
}

/** select "farm_account_aggregate_bool_exp_avg_arguments_columns" columns of table "farm_account" */
export enum Farm_Account_Select_Column_Farm_Account_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  ClaimedRewards = 'claimed_rewards',
  /** column name */
  ParticipationRewardsPerShare = 'participation_rewards_per_share',
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  UnclaimedRewards = 'unclaimed_rewards'
}

/** select "farm_account_aggregate_bool_exp_corr_arguments_columns" columns of table "farm_account" */
export enum Farm_Account_Select_Column_Farm_Account_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  ClaimedRewards = 'claimed_rewards',
  /** column name */
  ParticipationRewardsPerShare = 'participation_rewards_per_share',
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  UnclaimedRewards = 'unclaimed_rewards'
}

/** select "farm_account_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "farm_account" */
export enum Farm_Account_Select_Column_Farm_Account_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  ClaimedRewards = 'claimed_rewards',
  /** column name */
  ParticipationRewardsPerShare = 'participation_rewards_per_share',
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  UnclaimedRewards = 'unclaimed_rewards'
}

/** select "farm_account_aggregate_bool_exp_max_arguments_columns" columns of table "farm_account" */
export enum Farm_Account_Select_Column_Farm_Account_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  ClaimedRewards = 'claimed_rewards',
  /** column name */
  ParticipationRewardsPerShare = 'participation_rewards_per_share',
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  UnclaimedRewards = 'unclaimed_rewards'
}

/** select "farm_account_aggregate_bool_exp_min_arguments_columns" columns of table "farm_account" */
export enum Farm_Account_Select_Column_Farm_Account_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  ClaimedRewards = 'claimed_rewards',
  /** column name */
  ParticipationRewardsPerShare = 'participation_rewards_per_share',
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  UnclaimedRewards = 'unclaimed_rewards'
}

/** select "farm_account_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "farm_account" */
export enum Farm_Account_Select_Column_Farm_Account_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  ClaimedRewards = 'claimed_rewards',
  /** column name */
  ParticipationRewardsPerShare = 'participation_rewards_per_share',
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  UnclaimedRewards = 'unclaimed_rewards'
}

/** select "farm_account_aggregate_bool_exp_sum_arguments_columns" columns of table "farm_account" */
export enum Farm_Account_Select_Column_Farm_Account_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  ClaimedRewards = 'claimed_rewards',
  /** column name */
  ParticipationRewardsPerShare = 'participation_rewards_per_share',
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  UnclaimedRewards = 'unclaimed_rewards'
}

/** select "farm_account_aggregate_bool_exp_var_samp_arguments_columns" columns of table "farm_account" */
export enum Farm_Account_Select_Column_Farm_Account_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  ClaimedRewards = 'claimed_rewards',
  /** column name */
  ParticipationRewardsPerShare = 'participation_rewards_per_share',
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  UnclaimedRewards = 'unclaimed_rewards'
}

/** aggregate stddev on columns */
export type Farm_Account_Stddev_Fields = {
  __typename?: 'farm_account_stddev_fields';
  claimed_rewards?: Maybe<Scalars['Float']['output']>;
  deposited_amount?: Maybe<Scalars['Float']['output']>;
  farm_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  participation_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  token_reward_index?: Maybe<Scalars['Float']['output']>;
  unclaimed_rewards?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "farm_account" */
export type Farm_Account_Stddev_Order_By = {
  claimed_rewards?: InputMaybe<Order_By>;
  deposited_amount?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participation_rewards_per_share?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  unclaimed_rewards?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Farm_Account_Stddev_Pop_Fields = {
  __typename?: 'farm_account_stddev_pop_fields';
  claimed_rewards?: Maybe<Scalars['Float']['output']>;
  deposited_amount?: Maybe<Scalars['Float']['output']>;
  farm_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  participation_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  token_reward_index?: Maybe<Scalars['Float']['output']>;
  unclaimed_rewards?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "farm_account" */
export type Farm_Account_Stddev_Pop_Order_By = {
  claimed_rewards?: InputMaybe<Order_By>;
  deposited_amount?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participation_rewards_per_share?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  unclaimed_rewards?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Farm_Account_Stddev_Samp_Fields = {
  __typename?: 'farm_account_stddev_samp_fields';
  claimed_rewards?: Maybe<Scalars['Float']['output']>;
  deposited_amount?: Maybe<Scalars['Float']['output']>;
  farm_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  participation_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  token_reward_index?: Maybe<Scalars['Float']['output']>;
  unclaimed_rewards?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "farm_account" */
export type Farm_Account_Stddev_Samp_Order_By = {
  claimed_rewards?: InputMaybe<Order_By>;
  deposited_amount?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participation_rewards_per_share?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  unclaimed_rewards?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "farm_account" */
export type Farm_Account_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Farm_Account_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Farm_Account_Stream_Cursor_Value_Input = {
  claimed_rewards?: InputMaybe<Scalars['float8']['input']>;
  deposited_amount?: InputMaybe<Scalars['bigint']['input']>;
  farm_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  participation_rewards_per_share?: InputMaybe<Scalars['float8']['input']>;
  token_reward_index?: InputMaybe<Scalars['float8']['input']>;
  unclaimed_rewards?: InputMaybe<Scalars['float8']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Farm_Account_Sum_Fields = {
  __typename?: 'farm_account_sum_fields';
  claimed_rewards?: Maybe<Scalars['float8']['output']>;
  deposited_amount?: Maybe<Scalars['bigint']['output']>;
  farm_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  participation_rewards_per_share?: Maybe<Scalars['float8']['output']>;
  token_reward_index?: Maybe<Scalars['float8']['output']>;
  unclaimed_rewards?: Maybe<Scalars['float8']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "farm_account" */
export type Farm_Account_Sum_Order_By = {
  claimed_rewards?: InputMaybe<Order_By>;
  deposited_amount?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participation_rewards_per_share?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  unclaimed_rewards?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Farm_Account_Var_Pop_Fields = {
  __typename?: 'farm_account_var_pop_fields';
  claimed_rewards?: Maybe<Scalars['Float']['output']>;
  deposited_amount?: Maybe<Scalars['Float']['output']>;
  farm_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  participation_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  token_reward_index?: Maybe<Scalars['Float']['output']>;
  unclaimed_rewards?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "farm_account" */
export type Farm_Account_Var_Pop_Order_By = {
  claimed_rewards?: InputMaybe<Order_By>;
  deposited_amount?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participation_rewards_per_share?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  unclaimed_rewards?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Farm_Account_Var_Samp_Fields = {
  __typename?: 'farm_account_var_samp_fields';
  claimed_rewards?: Maybe<Scalars['Float']['output']>;
  deposited_amount?: Maybe<Scalars['Float']['output']>;
  farm_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  participation_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  token_reward_index?: Maybe<Scalars['Float']['output']>;
  unclaimed_rewards?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "farm_account" */
export type Farm_Account_Var_Samp_Order_By = {
  claimed_rewards?: InputMaybe<Order_By>;
  deposited_amount?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participation_rewards_per_share?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  unclaimed_rewards?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Farm_Account_Variance_Fields = {
  __typename?: 'farm_account_variance_fields';
  claimed_rewards?: Maybe<Scalars['Float']['output']>;
  deposited_amount?: Maybe<Scalars['Float']['output']>;
  farm_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  participation_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  token_reward_index?: Maybe<Scalars['Float']['output']>;
  unclaimed_rewards?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "farm_account" */
export type Farm_Account_Variance_Order_By = {
  claimed_rewards?: InputMaybe<Order_By>;
  deposited_amount?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participation_rewards_per_share?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  unclaimed_rewards?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregated selection of "farm" */
export type Farm_Aggregate = {
  __typename?: 'farm_aggregate';
  aggregate?: Maybe<Farm_Aggregate_Fields>;
  nodes: Array<Farm>;
};

export type Farm_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Farm_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Farm_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Farm_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Farm_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Farm_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Farm_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Farm_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Farm_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Farm_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Farm_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Farm_Aggregate_Bool_Exp_Var_Samp>;
};

export type Farm_Aggregate_Bool_Exp_Avg = {
  arguments: Farm_Select_Column_Farm_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farm_Aggregate_Bool_Exp_Bool_And = {
  arguments: Farm_Select_Column_Farm_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Farm_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Farm_Select_Column_Farm_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Farm_Aggregate_Bool_Exp_Corr = {
  arguments: Farm_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farm_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Farm_Select_Column_Farm_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Farm_Select_Column_Farm_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Farm_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Farm_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Farm_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Farm_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farm_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Farm_Select_Column_Farm_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Farm_Select_Column_Farm_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Farm_Aggregate_Bool_Exp_Max = {
  arguments: Farm_Select_Column_Farm_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farm_Aggregate_Bool_Exp_Min = {
  arguments: Farm_Select_Column_Farm_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farm_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Farm_Select_Column_Farm_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farm_Aggregate_Bool_Exp_Sum = {
  arguments: Farm_Select_Column_Farm_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Farm_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Farm_Select_Column_Farm_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "farm" */
export type Farm_Aggregate_Fields = {
  __typename?: 'farm_aggregate_fields';
  avg?: Maybe<Farm_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Farm_Max_Fields>;
  min?: Maybe<Farm_Min_Fields>;
  stddev?: Maybe<Farm_Stddev_Fields>;
  stddev_pop?: Maybe<Farm_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Farm_Stddev_Samp_Fields>;
  sum?: Maybe<Farm_Sum_Fields>;
  var_pop?: Maybe<Farm_Var_Pop_Fields>;
  var_samp?: Maybe<Farm_Var_Samp_Fields>;
  variance?: Maybe<Farm_Variance_Fields>;
};


/** aggregate fields of "farm" */
export type Farm_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Farm_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "farm" */
export type Farm_Aggregate_Order_By = {
  avg?: InputMaybe<Farm_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Farm_Max_Order_By>;
  min?: InputMaybe<Farm_Min_Order_By>;
  stddev?: InputMaybe<Farm_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Farm_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Farm_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Farm_Sum_Order_By>;
  var_pop?: InputMaybe<Farm_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Farm_Var_Samp_Order_By>;
  variance?: InputMaybe<Farm_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Farm_Avg_Fields = {
  __typename?: 'farm_avg_fields';
  accumulated_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  current_reward_per_block?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  init_block?: Maybe<Scalars['Float']['output']>;
  last_block_update?: Maybe<Scalars['Float']['output']>;
  lp_token_balance?: Maybe<Scalars['Float']['output']>;
  lp_token_id?: Maybe<Scalars['Float']['output']>;
  min_block_time_snapshot?: Maybe<Scalars['Float']['output']>;
  paid_rewards?: Maybe<Scalars['Float']['output']>;
  token0_id?: Maybe<Scalars['Float']['output']>;
  token1_id?: Maybe<Scalars['Float']['output']>;
  total_blocks?: Maybe<Scalars['Float']['output']>;
  total_rewards?: Maybe<Scalars['Float']['output']>;
  unpaid_rewards?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "farm" */
export type Farm_Avg_Order_By = {
  accumulated_rewards_per_share?: InputMaybe<Order_By>;
  current_reward_per_block?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  init_block?: InputMaybe<Order_By>;
  last_block_update?: InputMaybe<Order_By>;
  lp_token_balance?: InputMaybe<Order_By>;
  lp_token_id?: InputMaybe<Order_By>;
  min_block_time_snapshot?: InputMaybe<Order_By>;
  paid_rewards?: InputMaybe<Order_By>;
  token0_id?: InputMaybe<Order_By>;
  token1_id?: InputMaybe<Order_By>;
  total_blocks?: InputMaybe<Order_By>;
  total_rewards?: InputMaybe<Order_By>;
  unpaid_rewards?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "farm". All fields are combined with a logical 'AND'. */
export type Farm_Bool_Exp = {
  _and?: InputMaybe<Array<Farm_Bool_Exp>>;
  _not?: InputMaybe<Farm_Bool_Exp>;
  _or?: InputMaybe<Array<Farm_Bool_Exp>>;
  accumulated_rewards_per_share?: InputMaybe<Float8_Comparison_Exp>;
  address?: InputMaybe<String_Comparison_Exp>;
  admin?: InputMaybe<String_Comparison_Exp>;
  claim_paused?: InputMaybe<Boolean_Comparison_Exp>;
  creation_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  current_reward_per_block?: InputMaybe<Float8_Comparison_Exp>;
  deposit_paused?: InputMaybe<Boolean_Comparison_Exp>;
  end_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  factory?: InputMaybe<Farm_Factory_Bool_Exp>;
  factory_id?: InputMaybe<Bigint_Comparison_Exp>;
  farm_accounts?: InputMaybe<Farm_Account_Bool_Exp>;
  farm_accounts_aggregate?: InputMaybe<Farm_Account_Aggregate_Bool_Exp>;
  force_rewards_from_transfer?: InputMaybe<Boolean_Comparison_Exp>;
  general_contracts?: InputMaybe<Farm_General_Contract_Bool_Exp>;
  general_contracts_aggregate?: InputMaybe<Farm_General_Contract_Aggregate_Bool_Exp>;
  governance?: InputMaybe<Governance_Bool_Exp>;
  governance_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  infinite?: InputMaybe<Boolean_Comparison_Exp>;
  init?: InputMaybe<Boolean_Comparison_Exp>;
  init_block?: InputMaybe<Bigint_Comparison_Exp>;
  is_m_farm?: InputMaybe<Boolean_Comparison_Exp>;
  lambdas?: InputMaybe<Farm_Lambda_Bool_Exp>;
  lambdas_aggregate?: InputMaybe<Farm_Lambda_Aggregate_Bool_Exp>;
  last_block_update?: InputMaybe<Bigint_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  loan_token_name?: InputMaybe<String_Comparison_Exp>;
  lp_token?: InputMaybe<Token_Bool_Exp>;
  lp_token_balance?: InputMaybe<Bigint_Comparison_Exp>;
  lp_token_id?: InputMaybe<Bigint_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  min_block_time_snapshot?: InputMaybe<Smallint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
  open?: InputMaybe<Boolean_Comparison_Exp>;
  paid_rewards?: InputMaybe<Float8_Comparison_Exp>;
  start_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  token0?: InputMaybe<Token_Bool_Exp>;
  token0_id?: InputMaybe<Bigint_Comparison_Exp>;
  token1?: InputMaybe<Token_Bool_Exp>;
  token1_id?: InputMaybe<Bigint_Comparison_Exp>;
  total_blocks?: InputMaybe<Bigint_Comparison_Exp>;
  total_rewards?: InputMaybe<Float8_Comparison_Exp>;
  unpaid_rewards?: InputMaybe<Float8_Comparison_Exp>;
  whitelist_contracts?: InputMaybe<Farm_Whitelist_Contract_Bool_Exp>;
  whitelist_contracts_aggregate?: InputMaybe<Farm_Whitelist_Contract_Aggregate_Bool_Exp>;
  withdraw_paused?: InputMaybe<Boolean_Comparison_Exp>;
};

/** columns and relationships of "farm_factory" */
export type Farm_Factory = {
  __typename?: 'farm_factory';
  address: Scalars['String']['output'];
  admin: Scalars['String']['output'];
  create_farm_m_token_paused: Scalars['Boolean']['output'];
  create_farm_paused: Scalars['Boolean']['output'];
  /** An array relationship */
  farm_lambdas: Array<Farm_Factory_Farm_Lambda>;
  /** An aggregate relationship */
  farm_lambdas_aggregate: Farm_Factory_Farm_Lambda_Aggregate;
  farm_name_max_length: Scalars['smallint']['output'];
  /** An array relationship */
  farms: Array<Farm>;
  /** An aggregate relationship */
  farms_aggregate: Farm_Aggregate;
  /** An array relationship */
  general_contracts: Array<Farm_Factory_General_Contract>;
  /** An aggregate relationship */
  general_contracts_aggregate: Farm_Factory_General_Contract_Aggregate;
  /** An object relationship */
  governance: Governance;
  governance_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An array relationship */
  lambdas: Array<Farm_Factory_Lambda>;
  /** An aggregate relationship */
  lambdas_aggregate: Farm_Factory_Lambda_Aggregate;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  m_farm_lambdas: Array<Farm_Factory_M_Farm_Lambda>;
  /** An aggregate relationship */
  m_farm_lambdas_aggregate: Farm_Factory_M_Farm_Lambda_Aggregate;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  network: Scalars['String']['output'];
  track_farm_paused: Scalars['Boolean']['output'];
  untrack_farm_paused: Scalars['Boolean']['output'];
  /** An array relationship */
  whitelist_contracts: Array<Farm_Factory_Whitelist_Contract>;
  /** An aggregate relationship */
  whitelist_contracts_aggregate: Farm_Factory_Whitelist_Contract_Aggregate;
};


/** columns and relationships of "farm_factory" */
export type Farm_FactoryFarm_LambdasArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_Farm_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_Farm_Lambda_Order_By>>;
  where?: InputMaybe<Farm_Factory_Farm_Lambda_Bool_Exp>;
};


/** columns and relationships of "farm_factory" */
export type Farm_FactoryFarm_Lambdas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_Farm_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_Farm_Lambda_Order_By>>;
  where?: InputMaybe<Farm_Factory_Farm_Lambda_Bool_Exp>;
};


/** columns and relationships of "farm_factory" */
export type Farm_FactoryFarmsArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


/** columns and relationships of "farm_factory" */
export type Farm_FactoryFarms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


/** columns and relationships of "farm_factory" */
export type Farm_FactoryGeneral_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_General_Contract_Order_By>>;
  where?: InputMaybe<Farm_Factory_General_Contract_Bool_Exp>;
};


/** columns and relationships of "farm_factory" */
export type Farm_FactoryGeneral_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_General_Contract_Order_By>>;
  where?: InputMaybe<Farm_Factory_General_Contract_Bool_Exp>;
};


/** columns and relationships of "farm_factory" */
export type Farm_FactoryLambdasArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_Lambda_Order_By>>;
  where?: InputMaybe<Farm_Factory_Lambda_Bool_Exp>;
};


/** columns and relationships of "farm_factory" */
export type Farm_FactoryLambdas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_Lambda_Order_By>>;
  where?: InputMaybe<Farm_Factory_Lambda_Bool_Exp>;
};


/** columns and relationships of "farm_factory" */
export type Farm_FactoryM_Farm_LambdasArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_M_Farm_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_M_Farm_Lambda_Order_By>>;
  where?: InputMaybe<Farm_Factory_M_Farm_Lambda_Bool_Exp>;
};


/** columns and relationships of "farm_factory" */
export type Farm_FactoryM_Farm_Lambdas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_M_Farm_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_M_Farm_Lambda_Order_By>>;
  where?: InputMaybe<Farm_Factory_M_Farm_Lambda_Bool_Exp>;
};


/** columns and relationships of "farm_factory" */
export type Farm_FactoryMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "farm_factory" */
export type Farm_FactoryWhitelist_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Farm_Factory_Whitelist_Contract_Bool_Exp>;
};


/** columns and relationships of "farm_factory" */
export type Farm_FactoryWhitelist_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Farm_Factory_Whitelist_Contract_Bool_Exp>;
};

/** aggregated selection of "farm_factory" */
export type Farm_Factory_Aggregate = {
  __typename?: 'farm_factory_aggregate';
  aggregate?: Maybe<Farm_Factory_Aggregate_Fields>;
  nodes: Array<Farm_Factory>;
};

export type Farm_Factory_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Farm_Factory_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Farm_Factory_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Farm_Factory_Aggregate_Bool_Exp_Count>;
};

export type Farm_Factory_Aggregate_Bool_Exp_Bool_And = {
  arguments: Farm_Factory_Select_Column_Farm_Factory_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Factory_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Farm_Factory_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Farm_Factory_Select_Column_Farm_Factory_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Factory_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Farm_Factory_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Farm_Factory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Factory_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "farm_factory" */
export type Farm_Factory_Aggregate_Fields = {
  __typename?: 'farm_factory_aggregate_fields';
  avg?: Maybe<Farm_Factory_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Farm_Factory_Max_Fields>;
  min?: Maybe<Farm_Factory_Min_Fields>;
  stddev?: Maybe<Farm_Factory_Stddev_Fields>;
  stddev_pop?: Maybe<Farm_Factory_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Farm_Factory_Stddev_Samp_Fields>;
  sum?: Maybe<Farm_Factory_Sum_Fields>;
  var_pop?: Maybe<Farm_Factory_Var_Pop_Fields>;
  var_samp?: Maybe<Farm_Factory_Var_Samp_Fields>;
  variance?: Maybe<Farm_Factory_Variance_Fields>;
};


/** aggregate fields of "farm_factory" */
export type Farm_Factory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Farm_Factory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "farm_factory" */
export type Farm_Factory_Aggregate_Order_By = {
  avg?: InputMaybe<Farm_Factory_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Farm_Factory_Max_Order_By>;
  min?: InputMaybe<Farm_Factory_Min_Order_By>;
  stddev?: InputMaybe<Farm_Factory_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Farm_Factory_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Farm_Factory_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Farm_Factory_Sum_Order_By>;
  var_pop?: InputMaybe<Farm_Factory_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Farm_Factory_Var_Samp_Order_By>;
  variance?: InputMaybe<Farm_Factory_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Farm_Factory_Avg_Fields = {
  __typename?: 'farm_factory_avg_fields';
  farm_name_max_length?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "farm_factory" */
export type Farm_Factory_Avg_Order_By = {
  farm_name_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "farm_factory". All fields are combined with a logical 'AND'. */
export type Farm_Factory_Bool_Exp = {
  _and?: InputMaybe<Array<Farm_Factory_Bool_Exp>>;
  _not?: InputMaybe<Farm_Factory_Bool_Exp>;
  _or?: InputMaybe<Array<Farm_Factory_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  admin?: InputMaybe<String_Comparison_Exp>;
  create_farm_m_token_paused?: InputMaybe<Boolean_Comparison_Exp>;
  create_farm_paused?: InputMaybe<Boolean_Comparison_Exp>;
  farm_lambdas?: InputMaybe<Farm_Factory_Farm_Lambda_Bool_Exp>;
  farm_lambdas_aggregate?: InputMaybe<Farm_Factory_Farm_Lambda_Aggregate_Bool_Exp>;
  farm_name_max_length?: InputMaybe<Smallint_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  farms_aggregate?: InputMaybe<Farm_Aggregate_Bool_Exp>;
  general_contracts?: InputMaybe<Farm_Factory_General_Contract_Bool_Exp>;
  general_contracts_aggregate?: InputMaybe<Farm_Factory_General_Contract_Aggregate_Bool_Exp>;
  governance?: InputMaybe<Governance_Bool_Exp>;
  governance_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambdas?: InputMaybe<Farm_Factory_Lambda_Bool_Exp>;
  lambdas_aggregate?: InputMaybe<Farm_Factory_Lambda_Aggregate_Bool_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  m_farm_lambdas?: InputMaybe<Farm_Factory_M_Farm_Lambda_Bool_Exp>;
  m_farm_lambdas_aggregate?: InputMaybe<Farm_Factory_M_Farm_Lambda_Aggregate_Bool_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
  track_farm_paused?: InputMaybe<Boolean_Comparison_Exp>;
  untrack_farm_paused?: InputMaybe<Boolean_Comparison_Exp>;
  whitelist_contracts?: InputMaybe<Farm_Factory_Whitelist_Contract_Bool_Exp>;
  whitelist_contracts_aggregate?: InputMaybe<Farm_Factory_Whitelist_Contract_Aggregate_Bool_Exp>;
};

/** columns and relationships of "farm_factory_farm_lambda" */
export type Farm_Factory_Farm_Lambda = {
  __typename?: 'farm_factory_farm_lambda';
  /** An object relationship */
  contract: Farm_Factory;
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lambda_bytes: Scalars['String']['output'];
  lambda_name: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "farm_factory_farm_lambda" */
export type Farm_Factory_Farm_Lambda_Aggregate = {
  __typename?: 'farm_factory_farm_lambda_aggregate';
  aggregate?: Maybe<Farm_Factory_Farm_Lambda_Aggregate_Fields>;
  nodes: Array<Farm_Factory_Farm_Lambda>;
};

export type Farm_Factory_Farm_Lambda_Aggregate_Bool_Exp = {
  count?: InputMaybe<Farm_Factory_Farm_Lambda_Aggregate_Bool_Exp_Count>;
};

export type Farm_Factory_Farm_Lambda_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Farm_Factory_Farm_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Factory_Farm_Lambda_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "farm_factory_farm_lambda" */
export type Farm_Factory_Farm_Lambda_Aggregate_Fields = {
  __typename?: 'farm_factory_farm_lambda_aggregate_fields';
  avg?: Maybe<Farm_Factory_Farm_Lambda_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Farm_Factory_Farm_Lambda_Max_Fields>;
  min?: Maybe<Farm_Factory_Farm_Lambda_Min_Fields>;
  stddev?: Maybe<Farm_Factory_Farm_Lambda_Stddev_Fields>;
  stddev_pop?: Maybe<Farm_Factory_Farm_Lambda_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Farm_Factory_Farm_Lambda_Stddev_Samp_Fields>;
  sum?: Maybe<Farm_Factory_Farm_Lambda_Sum_Fields>;
  var_pop?: Maybe<Farm_Factory_Farm_Lambda_Var_Pop_Fields>;
  var_samp?: Maybe<Farm_Factory_Farm_Lambda_Var_Samp_Fields>;
  variance?: Maybe<Farm_Factory_Farm_Lambda_Variance_Fields>;
};


/** aggregate fields of "farm_factory_farm_lambda" */
export type Farm_Factory_Farm_Lambda_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Farm_Factory_Farm_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "farm_factory_farm_lambda" */
export type Farm_Factory_Farm_Lambda_Aggregate_Order_By = {
  avg?: InputMaybe<Farm_Factory_Farm_Lambda_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Farm_Factory_Farm_Lambda_Max_Order_By>;
  min?: InputMaybe<Farm_Factory_Farm_Lambda_Min_Order_By>;
  stddev?: InputMaybe<Farm_Factory_Farm_Lambda_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Farm_Factory_Farm_Lambda_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Farm_Factory_Farm_Lambda_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Farm_Factory_Farm_Lambda_Sum_Order_By>;
  var_pop?: InputMaybe<Farm_Factory_Farm_Lambda_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Farm_Factory_Farm_Lambda_Var_Samp_Order_By>;
  variance?: InputMaybe<Farm_Factory_Farm_Lambda_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Farm_Factory_Farm_Lambda_Avg_Fields = {
  __typename?: 'farm_factory_farm_lambda_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "farm_factory_farm_lambda" */
export type Farm_Factory_Farm_Lambda_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "farm_factory_farm_lambda". All fields are combined with a logical 'AND'. */
export type Farm_Factory_Farm_Lambda_Bool_Exp = {
  _and?: InputMaybe<Array<Farm_Factory_Farm_Lambda_Bool_Exp>>;
  _not?: InputMaybe<Farm_Factory_Farm_Lambda_Bool_Exp>;
  _or?: InputMaybe<Array<Farm_Factory_Farm_Lambda_Bool_Exp>>;
  contract?: InputMaybe<Farm_Factory_Bool_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambda_bytes?: InputMaybe<String_Comparison_Exp>;
  lambda_name?: InputMaybe<String_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Farm_Factory_Farm_Lambda_Max_Fields = {
  __typename?: 'farm_factory_farm_lambda_max_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "farm_factory_farm_lambda" */
export type Farm_Factory_Farm_Lambda_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Farm_Factory_Farm_Lambda_Min_Fields = {
  __typename?: 'farm_factory_farm_lambda_min_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "farm_factory_farm_lambda" */
export type Farm_Factory_Farm_Lambda_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "farm_factory_farm_lambda". */
export type Farm_Factory_Farm_Lambda_Order_By = {
  contract?: InputMaybe<Farm_Factory_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "farm_factory_farm_lambda" */
export enum Farm_Factory_Farm_Lambda_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaBytes = 'lambda_bytes',
  /** column name */
  LambdaName = 'lambda_name',
  /** column name */
  LastUpdatedAt = 'last_updated_at'
}

/** aggregate stddev on columns */
export type Farm_Factory_Farm_Lambda_Stddev_Fields = {
  __typename?: 'farm_factory_farm_lambda_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "farm_factory_farm_lambda" */
export type Farm_Factory_Farm_Lambda_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Farm_Factory_Farm_Lambda_Stddev_Pop_Fields = {
  __typename?: 'farm_factory_farm_lambda_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "farm_factory_farm_lambda" */
export type Farm_Factory_Farm_Lambda_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Farm_Factory_Farm_Lambda_Stddev_Samp_Fields = {
  __typename?: 'farm_factory_farm_lambda_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "farm_factory_farm_lambda" */
export type Farm_Factory_Farm_Lambda_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "farm_factory_farm_lambda" */
export type Farm_Factory_Farm_Lambda_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Farm_Factory_Farm_Lambda_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Farm_Factory_Farm_Lambda_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lambda_bytes?: InputMaybe<Scalars['String']['input']>;
  lambda_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Farm_Factory_Farm_Lambda_Sum_Fields = {
  __typename?: 'farm_factory_farm_lambda_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "farm_factory_farm_lambda" */
export type Farm_Factory_Farm_Lambda_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Farm_Factory_Farm_Lambda_Var_Pop_Fields = {
  __typename?: 'farm_factory_farm_lambda_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "farm_factory_farm_lambda" */
export type Farm_Factory_Farm_Lambda_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Farm_Factory_Farm_Lambda_Var_Samp_Fields = {
  __typename?: 'farm_factory_farm_lambda_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "farm_factory_farm_lambda" */
export type Farm_Factory_Farm_Lambda_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Farm_Factory_Farm_Lambda_Variance_Fields = {
  __typename?: 'farm_factory_farm_lambda_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "farm_factory_farm_lambda" */
export type Farm_Factory_Farm_Lambda_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "farm_factory_general_contract" */
export type Farm_Factory_General_Contract = {
  __typename?: 'farm_factory_general_contract';
  /** An object relationship */
  contract: Farm_Factory;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  contract_name: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "farm_factory_general_contract" */
export type Farm_Factory_General_Contract_Aggregate = {
  __typename?: 'farm_factory_general_contract_aggregate';
  aggregate?: Maybe<Farm_Factory_General_Contract_Aggregate_Fields>;
  nodes: Array<Farm_Factory_General_Contract>;
};

export type Farm_Factory_General_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Farm_Factory_General_Contract_Aggregate_Bool_Exp_Count>;
};

export type Farm_Factory_General_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Farm_Factory_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Factory_General_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "farm_factory_general_contract" */
export type Farm_Factory_General_Contract_Aggregate_Fields = {
  __typename?: 'farm_factory_general_contract_aggregate_fields';
  avg?: Maybe<Farm_Factory_General_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Farm_Factory_General_Contract_Max_Fields>;
  min?: Maybe<Farm_Factory_General_Contract_Min_Fields>;
  stddev?: Maybe<Farm_Factory_General_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Farm_Factory_General_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Farm_Factory_General_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Farm_Factory_General_Contract_Sum_Fields>;
  var_pop?: Maybe<Farm_Factory_General_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Farm_Factory_General_Contract_Var_Samp_Fields>;
  variance?: Maybe<Farm_Factory_General_Contract_Variance_Fields>;
};


/** aggregate fields of "farm_factory_general_contract" */
export type Farm_Factory_General_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Farm_Factory_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "farm_factory_general_contract" */
export type Farm_Factory_General_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Farm_Factory_General_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Farm_Factory_General_Contract_Max_Order_By>;
  min?: InputMaybe<Farm_Factory_General_Contract_Min_Order_By>;
  stddev?: InputMaybe<Farm_Factory_General_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Farm_Factory_General_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Farm_Factory_General_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Farm_Factory_General_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Farm_Factory_General_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Farm_Factory_General_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Farm_Factory_General_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Farm_Factory_General_Contract_Avg_Fields = {
  __typename?: 'farm_factory_general_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "farm_factory_general_contract" */
export type Farm_Factory_General_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "farm_factory_general_contract". All fields are combined with a logical 'AND'. */
export type Farm_Factory_General_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Farm_Factory_General_Contract_Bool_Exp>>;
  _not?: InputMaybe<Farm_Factory_General_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Farm_Factory_General_Contract_Bool_Exp>>;
  contract?: InputMaybe<Farm_Factory_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  contract_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Farm_Factory_General_Contract_Max_Fields = {
  __typename?: 'farm_factory_general_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "farm_factory_general_contract" */
export type Farm_Factory_General_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Farm_Factory_General_Contract_Min_Fields = {
  __typename?: 'farm_factory_general_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "farm_factory_general_contract" */
export type Farm_Factory_General_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "farm_factory_general_contract". */
export type Farm_Factory_General_Contract_Order_By = {
  contract?: InputMaybe<Farm_Factory_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "farm_factory_general_contract" */
export enum Farm_Factory_General_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  ContractName = 'contract_name',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Farm_Factory_General_Contract_Stddev_Fields = {
  __typename?: 'farm_factory_general_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "farm_factory_general_contract" */
export type Farm_Factory_General_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Farm_Factory_General_Contract_Stddev_Pop_Fields = {
  __typename?: 'farm_factory_general_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "farm_factory_general_contract" */
export type Farm_Factory_General_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Farm_Factory_General_Contract_Stddev_Samp_Fields = {
  __typename?: 'farm_factory_general_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "farm_factory_general_contract" */
export type Farm_Factory_General_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "farm_factory_general_contract" */
export type Farm_Factory_General_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Farm_Factory_General_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Farm_Factory_General_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  contract_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Farm_Factory_General_Contract_Sum_Fields = {
  __typename?: 'farm_factory_general_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "farm_factory_general_contract" */
export type Farm_Factory_General_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Farm_Factory_General_Contract_Var_Pop_Fields = {
  __typename?: 'farm_factory_general_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "farm_factory_general_contract" */
export type Farm_Factory_General_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Farm_Factory_General_Contract_Var_Samp_Fields = {
  __typename?: 'farm_factory_general_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "farm_factory_general_contract" */
export type Farm_Factory_General_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Farm_Factory_General_Contract_Variance_Fields = {
  __typename?: 'farm_factory_general_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "farm_factory_general_contract" */
export type Farm_Factory_General_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "farm_factory_lambda" */
export type Farm_Factory_Lambda = {
  __typename?: 'farm_factory_lambda';
  /** An object relationship */
  contract: Farm_Factory;
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lambda_bytes: Scalars['String']['output'];
  lambda_name: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "farm_factory_lambda" */
export type Farm_Factory_Lambda_Aggregate = {
  __typename?: 'farm_factory_lambda_aggregate';
  aggregate?: Maybe<Farm_Factory_Lambda_Aggregate_Fields>;
  nodes: Array<Farm_Factory_Lambda>;
};

export type Farm_Factory_Lambda_Aggregate_Bool_Exp = {
  count?: InputMaybe<Farm_Factory_Lambda_Aggregate_Bool_Exp_Count>;
};

export type Farm_Factory_Lambda_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Farm_Factory_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Factory_Lambda_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "farm_factory_lambda" */
export type Farm_Factory_Lambda_Aggregate_Fields = {
  __typename?: 'farm_factory_lambda_aggregate_fields';
  avg?: Maybe<Farm_Factory_Lambda_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Farm_Factory_Lambda_Max_Fields>;
  min?: Maybe<Farm_Factory_Lambda_Min_Fields>;
  stddev?: Maybe<Farm_Factory_Lambda_Stddev_Fields>;
  stddev_pop?: Maybe<Farm_Factory_Lambda_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Farm_Factory_Lambda_Stddev_Samp_Fields>;
  sum?: Maybe<Farm_Factory_Lambda_Sum_Fields>;
  var_pop?: Maybe<Farm_Factory_Lambda_Var_Pop_Fields>;
  var_samp?: Maybe<Farm_Factory_Lambda_Var_Samp_Fields>;
  variance?: Maybe<Farm_Factory_Lambda_Variance_Fields>;
};


/** aggregate fields of "farm_factory_lambda" */
export type Farm_Factory_Lambda_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Farm_Factory_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "farm_factory_lambda" */
export type Farm_Factory_Lambda_Aggregate_Order_By = {
  avg?: InputMaybe<Farm_Factory_Lambda_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Farm_Factory_Lambda_Max_Order_By>;
  min?: InputMaybe<Farm_Factory_Lambda_Min_Order_By>;
  stddev?: InputMaybe<Farm_Factory_Lambda_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Farm_Factory_Lambda_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Farm_Factory_Lambda_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Farm_Factory_Lambda_Sum_Order_By>;
  var_pop?: InputMaybe<Farm_Factory_Lambda_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Farm_Factory_Lambda_Var_Samp_Order_By>;
  variance?: InputMaybe<Farm_Factory_Lambda_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Farm_Factory_Lambda_Avg_Fields = {
  __typename?: 'farm_factory_lambda_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "farm_factory_lambda" */
export type Farm_Factory_Lambda_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "farm_factory_lambda". All fields are combined with a logical 'AND'. */
export type Farm_Factory_Lambda_Bool_Exp = {
  _and?: InputMaybe<Array<Farm_Factory_Lambda_Bool_Exp>>;
  _not?: InputMaybe<Farm_Factory_Lambda_Bool_Exp>;
  _or?: InputMaybe<Array<Farm_Factory_Lambda_Bool_Exp>>;
  contract?: InputMaybe<Farm_Factory_Bool_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambda_bytes?: InputMaybe<String_Comparison_Exp>;
  lambda_name?: InputMaybe<String_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Farm_Factory_Lambda_Max_Fields = {
  __typename?: 'farm_factory_lambda_max_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "farm_factory_lambda" */
export type Farm_Factory_Lambda_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Farm_Factory_Lambda_Min_Fields = {
  __typename?: 'farm_factory_lambda_min_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "farm_factory_lambda" */
export type Farm_Factory_Lambda_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "farm_factory_lambda". */
export type Farm_Factory_Lambda_Order_By = {
  contract?: InputMaybe<Farm_Factory_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "farm_factory_lambda" */
export enum Farm_Factory_Lambda_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaBytes = 'lambda_bytes',
  /** column name */
  LambdaName = 'lambda_name',
  /** column name */
  LastUpdatedAt = 'last_updated_at'
}

/** aggregate stddev on columns */
export type Farm_Factory_Lambda_Stddev_Fields = {
  __typename?: 'farm_factory_lambda_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "farm_factory_lambda" */
export type Farm_Factory_Lambda_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Farm_Factory_Lambda_Stddev_Pop_Fields = {
  __typename?: 'farm_factory_lambda_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "farm_factory_lambda" */
export type Farm_Factory_Lambda_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Farm_Factory_Lambda_Stddev_Samp_Fields = {
  __typename?: 'farm_factory_lambda_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "farm_factory_lambda" */
export type Farm_Factory_Lambda_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "farm_factory_lambda" */
export type Farm_Factory_Lambda_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Farm_Factory_Lambda_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Farm_Factory_Lambda_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lambda_bytes?: InputMaybe<Scalars['String']['input']>;
  lambda_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Farm_Factory_Lambda_Sum_Fields = {
  __typename?: 'farm_factory_lambda_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "farm_factory_lambda" */
export type Farm_Factory_Lambda_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Farm_Factory_Lambda_Var_Pop_Fields = {
  __typename?: 'farm_factory_lambda_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "farm_factory_lambda" */
export type Farm_Factory_Lambda_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Farm_Factory_Lambda_Var_Samp_Fields = {
  __typename?: 'farm_factory_lambda_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "farm_factory_lambda" */
export type Farm_Factory_Lambda_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Farm_Factory_Lambda_Variance_Fields = {
  __typename?: 'farm_factory_lambda_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "farm_factory_lambda" */
export type Farm_Factory_Lambda_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "farm_factory_m_farm_lambda" */
export type Farm_Factory_M_Farm_Lambda = {
  __typename?: 'farm_factory_m_farm_lambda';
  /** An object relationship */
  contract: Farm_Factory;
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lambda_bytes: Scalars['String']['output'];
  lambda_name: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "farm_factory_m_farm_lambda" */
export type Farm_Factory_M_Farm_Lambda_Aggregate = {
  __typename?: 'farm_factory_m_farm_lambda_aggregate';
  aggregate?: Maybe<Farm_Factory_M_Farm_Lambda_Aggregate_Fields>;
  nodes: Array<Farm_Factory_M_Farm_Lambda>;
};

export type Farm_Factory_M_Farm_Lambda_Aggregate_Bool_Exp = {
  count?: InputMaybe<Farm_Factory_M_Farm_Lambda_Aggregate_Bool_Exp_Count>;
};

export type Farm_Factory_M_Farm_Lambda_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Farm_Factory_M_Farm_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Factory_M_Farm_Lambda_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "farm_factory_m_farm_lambda" */
export type Farm_Factory_M_Farm_Lambda_Aggregate_Fields = {
  __typename?: 'farm_factory_m_farm_lambda_aggregate_fields';
  avg?: Maybe<Farm_Factory_M_Farm_Lambda_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Farm_Factory_M_Farm_Lambda_Max_Fields>;
  min?: Maybe<Farm_Factory_M_Farm_Lambda_Min_Fields>;
  stddev?: Maybe<Farm_Factory_M_Farm_Lambda_Stddev_Fields>;
  stddev_pop?: Maybe<Farm_Factory_M_Farm_Lambda_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Farm_Factory_M_Farm_Lambda_Stddev_Samp_Fields>;
  sum?: Maybe<Farm_Factory_M_Farm_Lambda_Sum_Fields>;
  var_pop?: Maybe<Farm_Factory_M_Farm_Lambda_Var_Pop_Fields>;
  var_samp?: Maybe<Farm_Factory_M_Farm_Lambda_Var_Samp_Fields>;
  variance?: Maybe<Farm_Factory_M_Farm_Lambda_Variance_Fields>;
};


/** aggregate fields of "farm_factory_m_farm_lambda" */
export type Farm_Factory_M_Farm_Lambda_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Farm_Factory_M_Farm_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "farm_factory_m_farm_lambda" */
export type Farm_Factory_M_Farm_Lambda_Aggregate_Order_By = {
  avg?: InputMaybe<Farm_Factory_M_Farm_Lambda_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Farm_Factory_M_Farm_Lambda_Max_Order_By>;
  min?: InputMaybe<Farm_Factory_M_Farm_Lambda_Min_Order_By>;
  stddev?: InputMaybe<Farm_Factory_M_Farm_Lambda_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Farm_Factory_M_Farm_Lambda_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Farm_Factory_M_Farm_Lambda_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Farm_Factory_M_Farm_Lambda_Sum_Order_By>;
  var_pop?: InputMaybe<Farm_Factory_M_Farm_Lambda_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Farm_Factory_M_Farm_Lambda_Var_Samp_Order_By>;
  variance?: InputMaybe<Farm_Factory_M_Farm_Lambda_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Farm_Factory_M_Farm_Lambda_Avg_Fields = {
  __typename?: 'farm_factory_m_farm_lambda_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "farm_factory_m_farm_lambda" */
export type Farm_Factory_M_Farm_Lambda_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "farm_factory_m_farm_lambda". All fields are combined with a logical 'AND'. */
export type Farm_Factory_M_Farm_Lambda_Bool_Exp = {
  _and?: InputMaybe<Array<Farm_Factory_M_Farm_Lambda_Bool_Exp>>;
  _not?: InputMaybe<Farm_Factory_M_Farm_Lambda_Bool_Exp>;
  _or?: InputMaybe<Array<Farm_Factory_M_Farm_Lambda_Bool_Exp>>;
  contract?: InputMaybe<Farm_Factory_Bool_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambda_bytes?: InputMaybe<String_Comparison_Exp>;
  lambda_name?: InputMaybe<String_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Farm_Factory_M_Farm_Lambda_Max_Fields = {
  __typename?: 'farm_factory_m_farm_lambda_max_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "farm_factory_m_farm_lambda" */
export type Farm_Factory_M_Farm_Lambda_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Farm_Factory_M_Farm_Lambda_Min_Fields = {
  __typename?: 'farm_factory_m_farm_lambda_min_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "farm_factory_m_farm_lambda" */
export type Farm_Factory_M_Farm_Lambda_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "farm_factory_m_farm_lambda". */
export type Farm_Factory_M_Farm_Lambda_Order_By = {
  contract?: InputMaybe<Farm_Factory_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "farm_factory_m_farm_lambda" */
export enum Farm_Factory_M_Farm_Lambda_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaBytes = 'lambda_bytes',
  /** column name */
  LambdaName = 'lambda_name',
  /** column name */
  LastUpdatedAt = 'last_updated_at'
}

/** aggregate stddev on columns */
export type Farm_Factory_M_Farm_Lambda_Stddev_Fields = {
  __typename?: 'farm_factory_m_farm_lambda_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "farm_factory_m_farm_lambda" */
export type Farm_Factory_M_Farm_Lambda_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Farm_Factory_M_Farm_Lambda_Stddev_Pop_Fields = {
  __typename?: 'farm_factory_m_farm_lambda_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "farm_factory_m_farm_lambda" */
export type Farm_Factory_M_Farm_Lambda_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Farm_Factory_M_Farm_Lambda_Stddev_Samp_Fields = {
  __typename?: 'farm_factory_m_farm_lambda_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "farm_factory_m_farm_lambda" */
export type Farm_Factory_M_Farm_Lambda_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "farm_factory_m_farm_lambda" */
export type Farm_Factory_M_Farm_Lambda_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Farm_Factory_M_Farm_Lambda_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Farm_Factory_M_Farm_Lambda_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lambda_bytes?: InputMaybe<Scalars['String']['input']>;
  lambda_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Farm_Factory_M_Farm_Lambda_Sum_Fields = {
  __typename?: 'farm_factory_m_farm_lambda_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "farm_factory_m_farm_lambda" */
export type Farm_Factory_M_Farm_Lambda_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Farm_Factory_M_Farm_Lambda_Var_Pop_Fields = {
  __typename?: 'farm_factory_m_farm_lambda_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "farm_factory_m_farm_lambda" */
export type Farm_Factory_M_Farm_Lambda_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Farm_Factory_M_Farm_Lambda_Var_Samp_Fields = {
  __typename?: 'farm_factory_m_farm_lambda_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "farm_factory_m_farm_lambda" */
export type Farm_Factory_M_Farm_Lambda_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Farm_Factory_M_Farm_Lambda_Variance_Fields = {
  __typename?: 'farm_factory_m_farm_lambda_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "farm_factory_m_farm_lambda" */
export type Farm_Factory_M_Farm_Lambda_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Farm_Factory_Max_Fields = {
  __typename?: 'farm_factory_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  farm_name_max_length?: Maybe<Scalars['smallint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  network?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "farm_factory" */
export type Farm_Factory_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  farm_name_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Farm_Factory_Min_Fields = {
  __typename?: 'farm_factory_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  farm_name_max_length?: Maybe<Scalars['smallint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  network?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "farm_factory" */
export type Farm_Factory_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  farm_name_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "farm_factory". */
export type Farm_Factory_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  create_farm_m_token_paused?: InputMaybe<Order_By>;
  create_farm_paused?: InputMaybe<Order_By>;
  farm_lambdas_aggregate?: InputMaybe<Farm_Factory_Farm_Lambda_Aggregate_Order_By>;
  farm_name_max_length?: InputMaybe<Order_By>;
  farms_aggregate?: InputMaybe<Farm_Aggregate_Order_By>;
  general_contracts_aggregate?: InputMaybe<Farm_Factory_General_Contract_Aggregate_Order_By>;
  governance?: InputMaybe<Governance_Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambdas_aggregate?: InputMaybe<Farm_Factory_Lambda_Aggregate_Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  m_farm_lambdas_aggregate?: InputMaybe<Farm_Factory_M_Farm_Lambda_Aggregate_Order_By>;
  metadata?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  track_farm_paused?: InputMaybe<Order_By>;
  untrack_farm_paused?: InputMaybe<Order_By>;
  whitelist_contracts_aggregate?: InputMaybe<Farm_Factory_Whitelist_Contract_Aggregate_Order_By>;
};

/** select columns of table "farm_factory" */
export enum Farm_Factory_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Admin = 'admin',
  /** column name */
  CreateFarmMTokenPaused = 'create_farm_m_token_paused',
  /** column name */
  CreateFarmPaused = 'create_farm_paused',
  /** column name */
  FarmNameMaxLength = 'farm_name_max_length',
  /** column name */
  GovernanceId = 'governance_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Network = 'network',
  /** column name */
  TrackFarmPaused = 'track_farm_paused',
  /** column name */
  UntrackFarmPaused = 'untrack_farm_paused'
}

/** select "farm_factory_aggregate_bool_exp_bool_and_arguments_columns" columns of table "farm_factory" */
export enum Farm_Factory_Select_Column_Farm_Factory_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CreateFarmMTokenPaused = 'create_farm_m_token_paused',
  /** column name */
  CreateFarmPaused = 'create_farm_paused',
  /** column name */
  TrackFarmPaused = 'track_farm_paused',
  /** column name */
  UntrackFarmPaused = 'untrack_farm_paused'
}

/** select "farm_factory_aggregate_bool_exp_bool_or_arguments_columns" columns of table "farm_factory" */
export enum Farm_Factory_Select_Column_Farm_Factory_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CreateFarmMTokenPaused = 'create_farm_m_token_paused',
  /** column name */
  CreateFarmPaused = 'create_farm_paused',
  /** column name */
  TrackFarmPaused = 'track_farm_paused',
  /** column name */
  UntrackFarmPaused = 'untrack_farm_paused'
}

/** aggregate stddev on columns */
export type Farm_Factory_Stddev_Fields = {
  __typename?: 'farm_factory_stddev_fields';
  farm_name_max_length?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "farm_factory" */
export type Farm_Factory_Stddev_Order_By = {
  farm_name_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Farm_Factory_Stddev_Pop_Fields = {
  __typename?: 'farm_factory_stddev_pop_fields';
  farm_name_max_length?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "farm_factory" */
export type Farm_Factory_Stddev_Pop_Order_By = {
  farm_name_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Farm_Factory_Stddev_Samp_Fields = {
  __typename?: 'farm_factory_stddev_samp_fields';
  farm_name_max_length?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "farm_factory" */
export type Farm_Factory_Stddev_Samp_Order_By = {
  farm_name_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "farm_factory" */
export type Farm_Factory_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Farm_Factory_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Farm_Factory_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['String']['input']>;
  create_farm_m_token_paused?: InputMaybe<Scalars['Boolean']['input']>;
  create_farm_paused?: InputMaybe<Scalars['Boolean']['input']>;
  farm_name_max_length?: InputMaybe<Scalars['smallint']['input']>;
  governance_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  track_farm_paused?: InputMaybe<Scalars['Boolean']['input']>;
  untrack_farm_paused?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Farm_Factory_Sum_Fields = {
  __typename?: 'farm_factory_sum_fields';
  farm_name_max_length?: Maybe<Scalars['smallint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "farm_factory" */
export type Farm_Factory_Sum_Order_By = {
  farm_name_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Farm_Factory_Var_Pop_Fields = {
  __typename?: 'farm_factory_var_pop_fields';
  farm_name_max_length?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "farm_factory" */
export type Farm_Factory_Var_Pop_Order_By = {
  farm_name_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Farm_Factory_Var_Samp_Fields = {
  __typename?: 'farm_factory_var_samp_fields';
  farm_name_max_length?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "farm_factory" */
export type Farm_Factory_Var_Samp_Order_By = {
  farm_name_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Farm_Factory_Variance_Fields = {
  __typename?: 'farm_factory_variance_fields';
  farm_name_max_length?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "farm_factory" */
export type Farm_Factory_Variance_Order_By = {
  farm_name_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "farm_factory_whitelist_contract" */
export type Farm_Factory_Whitelist_Contract = {
  __typename?: 'farm_factory_whitelist_contract';
  /** An object relationship */
  contract: Farm_Factory;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "farm_factory_whitelist_contract" */
export type Farm_Factory_Whitelist_Contract_Aggregate = {
  __typename?: 'farm_factory_whitelist_contract_aggregate';
  aggregate?: Maybe<Farm_Factory_Whitelist_Contract_Aggregate_Fields>;
  nodes: Array<Farm_Factory_Whitelist_Contract>;
};

export type Farm_Factory_Whitelist_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Farm_Factory_Whitelist_Contract_Aggregate_Bool_Exp_Count>;
};

export type Farm_Factory_Whitelist_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Farm_Factory_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Factory_Whitelist_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "farm_factory_whitelist_contract" */
export type Farm_Factory_Whitelist_Contract_Aggregate_Fields = {
  __typename?: 'farm_factory_whitelist_contract_aggregate_fields';
  avg?: Maybe<Farm_Factory_Whitelist_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Farm_Factory_Whitelist_Contract_Max_Fields>;
  min?: Maybe<Farm_Factory_Whitelist_Contract_Min_Fields>;
  stddev?: Maybe<Farm_Factory_Whitelist_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Farm_Factory_Whitelist_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Farm_Factory_Whitelist_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Farm_Factory_Whitelist_Contract_Sum_Fields>;
  var_pop?: Maybe<Farm_Factory_Whitelist_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Farm_Factory_Whitelist_Contract_Var_Samp_Fields>;
  variance?: Maybe<Farm_Factory_Whitelist_Contract_Variance_Fields>;
};


/** aggregate fields of "farm_factory_whitelist_contract" */
export type Farm_Factory_Whitelist_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Farm_Factory_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "farm_factory_whitelist_contract" */
export type Farm_Factory_Whitelist_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Farm_Factory_Whitelist_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Farm_Factory_Whitelist_Contract_Max_Order_By>;
  min?: InputMaybe<Farm_Factory_Whitelist_Contract_Min_Order_By>;
  stddev?: InputMaybe<Farm_Factory_Whitelist_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Farm_Factory_Whitelist_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Farm_Factory_Whitelist_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Farm_Factory_Whitelist_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Farm_Factory_Whitelist_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Farm_Factory_Whitelist_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Farm_Factory_Whitelist_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Farm_Factory_Whitelist_Contract_Avg_Fields = {
  __typename?: 'farm_factory_whitelist_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "farm_factory_whitelist_contract" */
export type Farm_Factory_Whitelist_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "farm_factory_whitelist_contract". All fields are combined with a logical 'AND'. */
export type Farm_Factory_Whitelist_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Farm_Factory_Whitelist_Contract_Bool_Exp>>;
  _not?: InputMaybe<Farm_Factory_Whitelist_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Farm_Factory_Whitelist_Contract_Bool_Exp>>;
  contract?: InputMaybe<Farm_Factory_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Farm_Factory_Whitelist_Contract_Max_Fields = {
  __typename?: 'farm_factory_whitelist_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "farm_factory_whitelist_contract" */
export type Farm_Factory_Whitelist_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Farm_Factory_Whitelist_Contract_Min_Fields = {
  __typename?: 'farm_factory_whitelist_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "farm_factory_whitelist_contract" */
export type Farm_Factory_Whitelist_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "farm_factory_whitelist_contract". */
export type Farm_Factory_Whitelist_Contract_Order_By = {
  contract?: InputMaybe<Farm_Factory_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "farm_factory_whitelist_contract" */
export enum Farm_Factory_Whitelist_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Farm_Factory_Whitelist_Contract_Stddev_Fields = {
  __typename?: 'farm_factory_whitelist_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "farm_factory_whitelist_contract" */
export type Farm_Factory_Whitelist_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Farm_Factory_Whitelist_Contract_Stddev_Pop_Fields = {
  __typename?: 'farm_factory_whitelist_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "farm_factory_whitelist_contract" */
export type Farm_Factory_Whitelist_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Farm_Factory_Whitelist_Contract_Stddev_Samp_Fields = {
  __typename?: 'farm_factory_whitelist_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "farm_factory_whitelist_contract" */
export type Farm_Factory_Whitelist_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "farm_factory_whitelist_contract" */
export type Farm_Factory_Whitelist_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Farm_Factory_Whitelist_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Farm_Factory_Whitelist_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Farm_Factory_Whitelist_Contract_Sum_Fields = {
  __typename?: 'farm_factory_whitelist_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "farm_factory_whitelist_contract" */
export type Farm_Factory_Whitelist_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Farm_Factory_Whitelist_Contract_Var_Pop_Fields = {
  __typename?: 'farm_factory_whitelist_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "farm_factory_whitelist_contract" */
export type Farm_Factory_Whitelist_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Farm_Factory_Whitelist_Contract_Var_Samp_Fields = {
  __typename?: 'farm_factory_whitelist_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "farm_factory_whitelist_contract" */
export type Farm_Factory_Whitelist_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Farm_Factory_Whitelist_Contract_Variance_Fields = {
  __typename?: 'farm_factory_whitelist_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "farm_factory_whitelist_contract" */
export type Farm_Factory_Whitelist_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "farm_general_contract" */
export type Farm_General_Contract = {
  __typename?: 'farm_general_contract';
  /** An object relationship */
  contract: Farm;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  contract_name: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "farm_general_contract" */
export type Farm_General_Contract_Aggregate = {
  __typename?: 'farm_general_contract_aggregate';
  aggregate?: Maybe<Farm_General_Contract_Aggregate_Fields>;
  nodes: Array<Farm_General_Contract>;
};

export type Farm_General_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Farm_General_Contract_Aggregate_Bool_Exp_Count>;
};

export type Farm_General_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Farm_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_General_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "farm_general_contract" */
export type Farm_General_Contract_Aggregate_Fields = {
  __typename?: 'farm_general_contract_aggregate_fields';
  avg?: Maybe<Farm_General_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Farm_General_Contract_Max_Fields>;
  min?: Maybe<Farm_General_Contract_Min_Fields>;
  stddev?: Maybe<Farm_General_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Farm_General_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Farm_General_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Farm_General_Contract_Sum_Fields>;
  var_pop?: Maybe<Farm_General_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Farm_General_Contract_Var_Samp_Fields>;
  variance?: Maybe<Farm_General_Contract_Variance_Fields>;
};


/** aggregate fields of "farm_general_contract" */
export type Farm_General_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Farm_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "farm_general_contract" */
export type Farm_General_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Farm_General_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Farm_General_Contract_Max_Order_By>;
  min?: InputMaybe<Farm_General_Contract_Min_Order_By>;
  stddev?: InputMaybe<Farm_General_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Farm_General_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Farm_General_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Farm_General_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Farm_General_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Farm_General_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Farm_General_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Farm_General_Contract_Avg_Fields = {
  __typename?: 'farm_general_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "farm_general_contract" */
export type Farm_General_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "farm_general_contract". All fields are combined with a logical 'AND'. */
export type Farm_General_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Farm_General_Contract_Bool_Exp>>;
  _not?: InputMaybe<Farm_General_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Farm_General_Contract_Bool_Exp>>;
  contract?: InputMaybe<Farm_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  contract_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Farm_General_Contract_Max_Fields = {
  __typename?: 'farm_general_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "farm_general_contract" */
export type Farm_General_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Farm_General_Contract_Min_Fields = {
  __typename?: 'farm_general_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "farm_general_contract" */
export type Farm_General_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "farm_general_contract". */
export type Farm_General_Contract_Order_By = {
  contract?: InputMaybe<Farm_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "farm_general_contract" */
export enum Farm_General_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  ContractName = 'contract_name',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Farm_General_Contract_Stddev_Fields = {
  __typename?: 'farm_general_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "farm_general_contract" */
export type Farm_General_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Farm_General_Contract_Stddev_Pop_Fields = {
  __typename?: 'farm_general_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "farm_general_contract" */
export type Farm_General_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Farm_General_Contract_Stddev_Samp_Fields = {
  __typename?: 'farm_general_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "farm_general_contract" */
export type Farm_General_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "farm_general_contract" */
export type Farm_General_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Farm_General_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Farm_General_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  contract_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Farm_General_Contract_Sum_Fields = {
  __typename?: 'farm_general_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "farm_general_contract" */
export type Farm_General_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Farm_General_Contract_Var_Pop_Fields = {
  __typename?: 'farm_general_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "farm_general_contract" */
export type Farm_General_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Farm_General_Contract_Var_Samp_Fields = {
  __typename?: 'farm_general_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "farm_general_contract" */
export type Farm_General_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Farm_General_Contract_Variance_Fields = {
  __typename?: 'farm_general_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "farm_general_contract" */
export type Farm_General_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "farm_lambda" */
export type Farm_Lambda = {
  __typename?: 'farm_lambda';
  /** An object relationship */
  contract: Farm;
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lambda_bytes: Scalars['String']['output'];
  lambda_name: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "farm_lambda" */
export type Farm_Lambda_Aggregate = {
  __typename?: 'farm_lambda_aggregate';
  aggregate?: Maybe<Farm_Lambda_Aggregate_Fields>;
  nodes: Array<Farm_Lambda>;
};

export type Farm_Lambda_Aggregate_Bool_Exp = {
  count?: InputMaybe<Farm_Lambda_Aggregate_Bool_Exp_Count>;
};

export type Farm_Lambda_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Farm_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Lambda_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "farm_lambda" */
export type Farm_Lambda_Aggregate_Fields = {
  __typename?: 'farm_lambda_aggregate_fields';
  avg?: Maybe<Farm_Lambda_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Farm_Lambda_Max_Fields>;
  min?: Maybe<Farm_Lambda_Min_Fields>;
  stddev?: Maybe<Farm_Lambda_Stddev_Fields>;
  stddev_pop?: Maybe<Farm_Lambda_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Farm_Lambda_Stddev_Samp_Fields>;
  sum?: Maybe<Farm_Lambda_Sum_Fields>;
  var_pop?: Maybe<Farm_Lambda_Var_Pop_Fields>;
  var_samp?: Maybe<Farm_Lambda_Var_Samp_Fields>;
  variance?: Maybe<Farm_Lambda_Variance_Fields>;
};


/** aggregate fields of "farm_lambda" */
export type Farm_Lambda_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Farm_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "farm_lambda" */
export type Farm_Lambda_Aggregate_Order_By = {
  avg?: InputMaybe<Farm_Lambda_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Farm_Lambda_Max_Order_By>;
  min?: InputMaybe<Farm_Lambda_Min_Order_By>;
  stddev?: InputMaybe<Farm_Lambda_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Farm_Lambda_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Farm_Lambda_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Farm_Lambda_Sum_Order_By>;
  var_pop?: InputMaybe<Farm_Lambda_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Farm_Lambda_Var_Samp_Order_By>;
  variance?: InputMaybe<Farm_Lambda_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Farm_Lambda_Avg_Fields = {
  __typename?: 'farm_lambda_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "farm_lambda" */
export type Farm_Lambda_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "farm_lambda". All fields are combined with a logical 'AND'. */
export type Farm_Lambda_Bool_Exp = {
  _and?: InputMaybe<Array<Farm_Lambda_Bool_Exp>>;
  _not?: InputMaybe<Farm_Lambda_Bool_Exp>;
  _or?: InputMaybe<Array<Farm_Lambda_Bool_Exp>>;
  contract?: InputMaybe<Farm_Bool_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambda_bytes?: InputMaybe<String_Comparison_Exp>;
  lambda_name?: InputMaybe<String_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Farm_Lambda_Max_Fields = {
  __typename?: 'farm_lambda_max_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "farm_lambda" */
export type Farm_Lambda_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Farm_Lambda_Min_Fields = {
  __typename?: 'farm_lambda_min_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "farm_lambda" */
export type Farm_Lambda_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "farm_lambda". */
export type Farm_Lambda_Order_By = {
  contract?: InputMaybe<Farm_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "farm_lambda" */
export enum Farm_Lambda_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaBytes = 'lambda_bytes',
  /** column name */
  LambdaName = 'lambda_name',
  /** column name */
  LastUpdatedAt = 'last_updated_at'
}

/** aggregate stddev on columns */
export type Farm_Lambda_Stddev_Fields = {
  __typename?: 'farm_lambda_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "farm_lambda" */
export type Farm_Lambda_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Farm_Lambda_Stddev_Pop_Fields = {
  __typename?: 'farm_lambda_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "farm_lambda" */
export type Farm_Lambda_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Farm_Lambda_Stddev_Samp_Fields = {
  __typename?: 'farm_lambda_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "farm_lambda" */
export type Farm_Lambda_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "farm_lambda" */
export type Farm_Lambda_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Farm_Lambda_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Farm_Lambda_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lambda_bytes?: InputMaybe<Scalars['String']['input']>;
  lambda_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Farm_Lambda_Sum_Fields = {
  __typename?: 'farm_lambda_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "farm_lambda" */
export type Farm_Lambda_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Farm_Lambda_Var_Pop_Fields = {
  __typename?: 'farm_lambda_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "farm_lambda" */
export type Farm_Lambda_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Farm_Lambda_Var_Samp_Fields = {
  __typename?: 'farm_lambda_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "farm_lambda" */
export type Farm_Lambda_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Farm_Lambda_Variance_Fields = {
  __typename?: 'farm_lambda_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "farm_lambda" */
export type Farm_Lambda_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Farm_Max_Fields = {
  __typename?: 'farm_max_fields';
  accumulated_rewards_per_share?: Maybe<Scalars['float8']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  creation_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  current_reward_per_block?: Maybe<Scalars['float8']['output']>;
  end_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  factory_id?: Maybe<Scalars['bigint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  init_block?: Maybe<Scalars['bigint']['output']>;
  last_block_update?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  loan_token_name?: Maybe<Scalars['String']['output']>;
  lp_token_balance?: Maybe<Scalars['bigint']['output']>;
  lp_token_id?: Maybe<Scalars['bigint']['output']>;
  min_block_time_snapshot?: Maybe<Scalars['smallint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  paid_rewards?: Maybe<Scalars['float8']['output']>;
  start_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  token0_id?: Maybe<Scalars['bigint']['output']>;
  token1_id?: Maybe<Scalars['bigint']['output']>;
  total_blocks?: Maybe<Scalars['bigint']['output']>;
  total_rewards?: Maybe<Scalars['float8']['output']>;
  unpaid_rewards?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "farm" */
export type Farm_Max_Order_By = {
  accumulated_rewards_per_share?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  creation_timestamp?: InputMaybe<Order_By>;
  current_reward_per_block?: InputMaybe<Order_By>;
  end_timestamp?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  init_block?: InputMaybe<Order_By>;
  last_block_update?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  loan_token_name?: InputMaybe<Order_By>;
  lp_token_balance?: InputMaybe<Order_By>;
  lp_token_id?: InputMaybe<Order_By>;
  min_block_time_snapshot?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  paid_rewards?: InputMaybe<Order_By>;
  start_timestamp?: InputMaybe<Order_By>;
  token0_id?: InputMaybe<Order_By>;
  token1_id?: InputMaybe<Order_By>;
  total_blocks?: InputMaybe<Order_By>;
  total_rewards?: InputMaybe<Order_By>;
  unpaid_rewards?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Farm_Min_Fields = {
  __typename?: 'farm_min_fields';
  accumulated_rewards_per_share?: Maybe<Scalars['float8']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  creation_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  current_reward_per_block?: Maybe<Scalars['float8']['output']>;
  end_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  factory_id?: Maybe<Scalars['bigint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  init_block?: Maybe<Scalars['bigint']['output']>;
  last_block_update?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  loan_token_name?: Maybe<Scalars['String']['output']>;
  lp_token_balance?: Maybe<Scalars['bigint']['output']>;
  lp_token_id?: Maybe<Scalars['bigint']['output']>;
  min_block_time_snapshot?: Maybe<Scalars['smallint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  paid_rewards?: Maybe<Scalars['float8']['output']>;
  start_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  token0_id?: Maybe<Scalars['bigint']['output']>;
  token1_id?: Maybe<Scalars['bigint']['output']>;
  total_blocks?: Maybe<Scalars['bigint']['output']>;
  total_rewards?: Maybe<Scalars['float8']['output']>;
  unpaid_rewards?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "farm" */
export type Farm_Min_Order_By = {
  accumulated_rewards_per_share?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  creation_timestamp?: InputMaybe<Order_By>;
  current_reward_per_block?: InputMaybe<Order_By>;
  end_timestamp?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  init_block?: InputMaybe<Order_By>;
  last_block_update?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  loan_token_name?: InputMaybe<Order_By>;
  lp_token_balance?: InputMaybe<Order_By>;
  lp_token_id?: InputMaybe<Order_By>;
  min_block_time_snapshot?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  paid_rewards?: InputMaybe<Order_By>;
  start_timestamp?: InputMaybe<Order_By>;
  token0_id?: InputMaybe<Order_By>;
  token1_id?: InputMaybe<Order_By>;
  total_blocks?: InputMaybe<Order_By>;
  total_rewards?: InputMaybe<Order_By>;
  unpaid_rewards?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "farm". */
export type Farm_Order_By = {
  accumulated_rewards_per_share?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  claim_paused?: InputMaybe<Order_By>;
  creation_timestamp?: InputMaybe<Order_By>;
  current_reward_per_block?: InputMaybe<Order_By>;
  deposit_paused?: InputMaybe<Order_By>;
  end_timestamp?: InputMaybe<Order_By>;
  factory?: InputMaybe<Farm_Factory_Order_By>;
  factory_id?: InputMaybe<Order_By>;
  farm_accounts_aggregate?: InputMaybe<Farm_Account_Aggregate_Order_By>;
  force_rewards_from_transfer?: InputMaybe<Order_By>;
  general_contracts_aggregate?: InputMaybe<Farm_General_Contract_Aggregate_Order_By>;
  governance?: InputMaybe<Governance_Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  infinite?: InputMaybe<Order_By>;
  init?: InputMaybe<Order_By>;
  init_block?: InputMaybe<Order_By>;
  is_m_farm?: InputMaybe<Order_By>;
  lambdas_aggregate?: InputMaybe<Farm_Lambda_Aggregate_Order_By>;
  last_block_update?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  loan_token_name?: InputMaybe<Order_By>;
  lp_token?: InputMaybe<Token_Order_By>;
  lp_token_balance?: InputMaybe<Order_By>;
  lp_token_id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  min_block_time_snapshot?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  open?: InputMaybe<Order_By>;
  paid_rewards?: InputMaybe<Order_By>;
  start_timestamp?: InputMaybe<Order_By>;
  token0?: InputMaybe<Token_Order_By>;
  token0_id?: InputMaybe<Order_By>;
  token1?: InputMaybe<Token_Order_By>;
  token1_id?: InputMaybe<Order_By>;
  total_blocks?: InputMaybe<Order_By>;
  total_rewards?: InputMaybe<Order_By>;
  unpaid_rewards?: InputMaybe<Order_By>;
  whitelist_contracts_aggregate?: InputMaybe<Farm_Whitelist_Contract_Aggregate_Order_By>;
  withdraw_paused?: InputMaybe<Order_By>;
};

/** select columns of table "farm" */
export enum Farm_Select_Column {
  /** column name */
  AccumulatedRewardsPerShare = 'accumulated_rewards_per_share',
  /** column name */
  Address = 'address',
  /** column name */
  Admin = 'admin',
  /** column name */
  ClaimPaused = 'claim_paused',
  /** column name */
  CreationTimestamp = 'creation_timestamp',
  /** column name */
  CurrentRewardPerBlock = 'current_reward_per_block',
  /** column name */
  DepositPaused = 'deposit_paused',
  /** column name */
  EndTimestamp = 'end_timestamp',
  /** column name */
  FactoryId = 'factory_id',
  /** column name */
  ForceRewardsFromTransfer = 'force_rewards_from_transfer',
  /** column name */
  GovernanceId = 'governance_id',
  /** column name */
  Id = 'id',
  /** column name */
  Infinite = 'infinite',
  /** column name */
  Init = 'init',
  /** column name */
  InitBlock = 'init_block',
  /** column name */
  IsMFarm = 'is_m_farm',
  /** column name */
  LastBlockUpdate = 'last_block_update',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  LoanTokenName = 'loan_token_name',
  /** column name */
  LpTokenBalance = 'lp_token_balance',
  /** column name */
  LpTokenId = 'lp_token_id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MinBlockTimeSnapshot = 'min_block_time_snapshot',
  /** column name */
  Name = 'name',
  /** column name */
  Network = 'network',
  /** column name */
  Open = 'open',
  /** column name */
  PaidRewards = 'paid_rewards',
  /** column name */
  StartTimestamp = 'start_timestamp',
  /** column name */
  Token0Id = 'token0_id',
  /** column name */
  Token1Id = 'token1_id',
  /** column name */
  TotalBlocks = 'total_blocks',
  /** column name */
  TotalRewards = 'total_rewards',
  /** column name */
  UnpaidRewards = 'unpaid_rewards',
  /** column name */
  WithdrawPaused = 'withdraw_paused'
}

/** select "farm_aggregate_bool_exp_avg_arguments_columns" columns of table "farm" */
export enum Farm_Select_Column_Farm_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  AccumulatedRewardsPerShare = 'accumulated_rewards_per_share',
  /** column name */
  CurrentRewardPerBlock = 'current_reward_per_block',
  /** column name */
  PaidRewards = 'paid_rewards',
  /** column name */
  TotalRewards = 'total_rewards',
  /** column name */
  UnpaidRewards = 'unpaid_rewards'
}

/** select "farm_aggregate_bool_exp_bool_and_arguments_columns" columns of table "farm" */
export enum Farm_Select_Column_Farm_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ClaimPaused = 'claim_paused',
  /** column name */
  DepositPaused = 'deposit_paused',
  /** column name */
  ForceRewardsFromTransfer = 'force_rewards_from_transfer',
  /** column name */
  Infinite = 'infinite',
  /** column name */
  Init = 'init',
  /** column name */
  IsMFarm = 'is_m_farm',
  /** column name */
  Open = 'open',
  /** column name */
  WithdrawPaused = 'withdraw_paused'
}

/** select "farm_aggregate_bool_exp_bool_or_arguments_columns" columns of table "farm" */
export enum Farm_Select_Column_Farm_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ClaimPaused = 'claim_paused',
  /** column name */
  DepositPaused = 'deposit_paused',
  /** column name */
  ForceRewardsFromTransfer = 'force_rewards_from_transfer',
  /** column name */
  Infinite = 'infinite',
  /** column name */
  Init = 'init',
  /** column name */
  IsMFarm = 'is_m_farm',
  /** column name */
  Open = 'open',
  /** column name */
  WithdrawPaused = 'withdraw_paused'
}

/** select "farm_aggregate_bool_exp_corr_arguments_columns" columns of table "farm" */
export enum Farm_Select_Column_Farm_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  AccumulatedRewardsPerShare = 'accumulated_rewards_per_share',
  /** column name */
  CurrentRewardPerBlock = 'current_reward_per_block',
  /** column name */
  PaidRewards = 'paid_rewards',
  /** column name */
  TotalRewards = 'total_rewards',
  /** column name */
  UnpaidRewards = 'unpaid_rewards'
}

/** select "farm_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "farm" */
export enum Farm_Select_Column_Farm_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  AccumulatedRewardsPerShare = 'accumulated_rewards_per_share',
  /** column name */
  CurrentRewardPerBlock = 'current_reward_per_block',
  /** column name */
  PaidRewards = 'paid_rewards',
  /** column name */
  TotalRewards = 'total_rewards',
  /** column name */
  UnpaidRewards = 'unpaid_rewards'
}

/** select "farm_aggregate_bool_exp_max_arguments_columns" columns of table "farm" */
export enum Farm_Select_Column_Farm_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  AccumulatedRewardsPerShare = 'accumulated_rewards_per_share',
  /** column name */
  CurrentRewardPerBlock = 'current_reward_per_block',
  /** column name */
  PaidRewards = 'paid_rewards',
  /** column name */
  TotalRewards = 'total_rewards',
  /** column name */
  UnpaidRewards = 'unpaid_rewards'
}

/** select "farm_aggregate_bool_exp_min_arguments_columns" columns of table "farm" */
export enum Farm_Select_Column_Farm_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  AccumulatedRewardsPerShare = 'accumulated_rewards_per_share',
  /** column name */
  CurrentRewardPerBlock = 'current_reward_per_block',
  /** column name */
  PaidRewards = 'paid_rewards',
  /** column name */
  TotalRewards = 'total_rewards',
  /** column name */
  UnpaidRewards = 'unpaid_rewards'
}

/** select "farm_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "farm" */
export enum Farm_Select_Column_Farm_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  AccumulatedRewardsPerShare = 'accumulated_rewards_per_share',
  /** column name */
  CurrentRewardPerBlock = 'current_reward_per_block',
  /** column name */
  PaidRewards = 'paid_rewards',
  /** column name */
  TotalRewards = 'total_rewards',
  /** column name */
  UnpaidRewards = 'unpaid_rewards'
}

/** select "farm_aggregate_bool_exp_sum_arguments_columns" columns of table "farm" */
export enum Farm_Select_Column_Farm_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  AccumulatedRewardsPerShare = 'accumulated_rewards_per_share',
  /** column name */
  CurrentRewardPerBlock = 'current_reward_per_block',
  /** column name */
  PaidRewards = 'paid_rewards',
  /** column name */
  TotalRewards = 'total_rewards',
  /** column name */
  UnpaidRewards = 'unpaid_rewards'
}

/** select "farm_aggregate_bool_exp_var_samp_arguments_columns" columns of table "farm" */
export enum Farm_Select_Column_Farm_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  AccumulatedRewardsPerShare = 'accumulated_rewards_per_share',
  /** column name */
  CurrentRewardPerBlock = 'current_reward_per_block',
  /** column name */
  PaidRewards = 'paid_rewards',
  /** column name */
  TotalRewards = 'total_rewards',
  /** column name */
  UnpaidRewards = 'unpaid_rewards'
}

/** aggregate stddev on columns */
export type Farm_Stddev_Fields = {
  __typename?: 'farm_stddev_fields';
  accumulated_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  current_reward_per_block?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  init_block?: Maybe<Scalars['Float']['output']>;
  last_block_update?: Maybe<Scalars['Float']['output']>;
  lp_token_balance?: Maybe<Scalars['Float']['output']>;
  lp_token_id?: Maybe<Scalars['Float']['output']>;
  min_block_time_snapshot?: Maybe<Scalars['Float']['output']>;
  paid_rewards?: Maybe<Scalars['Float']['output']>;
  token0_id?: Maybe<Scalars['Float']['output']>;
  token1_id?: Maybe<Scalars['Float']['output']>;
  total_blocks?: Maybe<Scalars['Float']['output']>;
  total_rewards?: Maybe<Scalars['Float']['output']>;
  unpaid_rewards?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "farm" */
export type Farm_Stddev_Order_By = {
  accumulated_rewards_per_share?: InputMaybe<Order_By>;
  current_reward_per_block?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  init_block?: InputMaybe<Order_By>;
  last_block_update?: InputMaybe<Order_By>;
  lp_token_balance?: InputMaybe<Order_By>;
  lp_token_id?: InputMaybe<Order_By>;
  min_block_time_snapshot?: InputMaybe<Order_By>;
  paid_rewards?: InputMaybe<Order_By>;
  token0_id?: InputMaybe<Order_By>;
  token1_id?: InputMaybe<Order_By>;
  total_blocks?: InputMaybe<Order_By>;
  total_rewards?: InputMaybe<Order_By>;
  unpaid_rewards?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Farm_Stddev_Pop_Fields = {
  __typename?: 'farm_stddev_pop_fields';
  accumulated_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  current_reward_per_block?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  init_block?: Maybe<Scalars['Float']['output']>;
  last_block_update?: Maybe<Scalars['Float']['output']>;
  lp_token_balance?: Maybe<Scalars['Float']['output']>;
  lp_token_id?: Maybe<Scalars['Float']['output']>;
  min_block_time_snapshot?: Maybe<Scalars['Float']['output']>;
  paid_rewards?: Maybe<Scalars['Float']['output']>;
  token0_id?: Maybe<Scalars['Float']['output']>;
  token1_id?: Maybe<Scalars['Float']['output']>;
  total_blocks?: Maybe<Scalars['Float']['output']>;
  total_rewards?: Maybe<Scalars['Float']['output']>;
  unpaid_rewards?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "farm" */
export type Farm_Stddev_Pop_Order_By = {
  accumulated_rewards_per_share?: InputMaybe<Order_By>;
  current_reward_per_block?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  init_block?: InputMaybe<Order_By>;
  last_block_update?: InputMaybe<Order_By>;
  lp_token_balance?: InputMaybe<Order_By>;
  lp_token_id?: InputMaybe<Order_By>;
  min_block_time_snapshot?: InputMaybe<Order_By>;
  paid_rewards?: InputMaybe<Order_By>;
  token0_id?: InputMaybe<Order_By>;
  token1_id?: InputMaybe<Order_By>;
  total_blocks?: InputMaybe<Order_By>;
  total_rewards?: InputMaybe<Order_By>;
  unpaid_rewards?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Farm_Stddev_Samp_Fields = {
  __typename?: 'farm_stddev_samp_fields';
  accumulated_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  current_reward_per_block?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  init_block?: Maybe<Scalars['Float']['output']>;
  last_block_update?: Maybe<Scalars['Float']['output']>;
  lp_token_balance?: Maybe<Scalars['Float']['output']>;
  lp_token_id?: Maybe<Scalars['Float']['output']>;
  min_block_time_snapshot?: Maybe<Scalars['Float']['output']>;
  paid_rewards?: Maybe<Scalars['Float']['output']>;
  token0_id?: Maybe<Scalars['Float']['output']>;
  token1_id?: Maybe<Scalars['Float']['output']>;
  total_blocks?: Maybe<Scalars['Float']['output']>;
  total_rewards?: Maybe<Scalars['Float']['output']>;
  unpaid_rewards?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "farm" */
export type Farm_Stddev_Samp_Order_By = {
  accumulated_rewards_per_share?: InputMaybe<Order_By>;
  current_reward_per_block?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  init_block?: InputMaybe<Order_By>;
  last_block_update?: InputMaybe<Order_By>;
  lp_token_balance?: InputMaybe<Order_By>;
  lp_token_id?: InputMaybe<Order_By>;
  min_block_time_snapshot?: InputMaybe<Order_By>;
  paid_rewards?: InputMaybe<Order_By>;
  token0_id?: InputMaybe<Order_By>;
  token1_id?: InputMaybe<Order_By>;
  total_blocks?: InputMaybe<Order_By>;
  total_rewards?: InputMaybe<Order_By>;
  unpaid_rewards?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "farm" */
export type Farm_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Farm_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Farm_Stream_Cursor_Value_Input = {
  accumulated_rewards_per_share?: InputMaybe<Scalars['float8']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['String']['input']>;
  claim_paused?: InputMaybe<Scalars['Boolean']['input']>;
  creation_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  current_reward_per_block?: InputMaybe<Scalars['float8']['input']>;
  deposit_paused?: InputMaybe<Scalars['Boolean']['input']>;
  end_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  factory_id?: InputMaybe<Scalars['bigint']['input']>;
  force_rewards_from_transfer?: InputMaybe<Scalars['Boolean']['input']>;
  governance_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  infinite?: InputMaybe<Scalars['Boolean']['input']>;
  init?: InputMaybe<Scalars['Boolean']['input']>;
  init_block?: InputMaybe<Scalars['bigint']['input']>;
  is_m_farm?: InputMaybe<Scalars['Boolean']['input']>;
  last_block_update?: InputMaybe<Scalars['bigint']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  loan_token_name?: InputMaybe<Scalars['String']['input']>;
  lp_token_balance?: InputMaybe<Scalars['bigint']['input']>;
  lp_token_id?: InputMaybe<Scalars['bigint']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  min_block_time_snapshot?: InputMaybe<Scalars['smallint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  paid_rewards?: InputMaybe<Scalars['float8']['input']>;
  start_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  token0_id?: InputMaybe<Scalars['bigint']['input']>;
  token1_id?: InputMaybe<Scalars['bigint']['input']>;
  total_blocks?: InputMaybe<Scalars['bigint']['input']>;
  total_rewards?: InputMaybe<Scalars['float8']['input']>;
  unpaid_rewards?: InputMaybe<Scalars['float8']['input']>;
  withdraw_paused?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Farm_Sum_Fields = {
  __typename?: 'farm_sum_fields';
  accumulated_rewards_per_share?: Maybe<Scalars['float8']['output']>;
  current_reward_per_block?: Maybe<Scalars['float8']['output']>;
  factory_id?: Maybe<Scalars['bigint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  init_block?: Maybe<Scalars['bigint']['output']>;
  last_block_update?: Maybe<Scalars['bigint']['output']>;
  lp_token_balance?: Maybe<Scalars['bigint']['output']>;
  lp_token_id?: Maybe<Scalars['bigint']['output']>;
  min_block_time_snapshot?: Maybe<Scalars['smallint']['output']>;
  paid_rewards?: Maybe<Scalars['float8']['output']>;
  token0_id?: Maybe<Scalars['bigint']['output']>;
  token1_id?: Maybe<Scalars['bigint']['output']>;
  total_blocks?: Maybe<Scalars['bigint']['output']>;
  total_rewards?: Maybe<Scalars['float8']['output']>;
  unpaid_rewards?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "farm" */
export type Farm_Sum_Order_By = {
  accumulated_rewards_per_share?: InputMaybe<Order_By>;
  current_reward_per_block?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  init_block?: InputMaybe<Order_By>;
  last_block_update?: InputMaybe<Order_By>;
  lp_token_balance?: InputMaybe<Order_By>;
  lp_token_id?: InputMaybe<Order_By>;
  min_block_time_snapshot?: InputMaybe<Order_By>;
  paid_rewards?: InputMaybe<Order_By>;
  token0_id?: InputMaybe<Order_By>;
  token1_id?: InputMaybe<Order_By>;
  total_blocks?: InputMaybe<Order_By>;
  total_rewards?: InputMaybe<Order_By>;
  unpaid_rewards?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Farm_Var_Pop_Fields = {
  __typename?: 'farm_var_pop_fields';
  accumulated_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  current_reward_per_block?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  init_block?: Maybe<Scalars['Float']['output']>;
  last_block_update?: Maybe<Scalars['Float']['output']>;
  lp_token_balance?: Maybe<Scalars['Float']['output']>;
  lp_token_id?: Maybe<Scalars['Float']['output']>;
  min_block_time_snapshot?: Maybe<Scalars['Float']['output']>;
  paid_rewards?: Maybe<Scalars['Float']['output']>;
  token0_id?: Maybe<Scalars['Float']['output']>;
  token1_id?: Maybe<Scalars['Float']['output']>;
  total_blocks?: Maybe<Scalars['Float']['output']>;
  total_rewards?: Maybe<Scalars['Float']['output']>;
  unpaid_rewards?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "farm" */
export type Farm_Var_Pop_Order_By = {
  accumulated_rewards_per_share?: InputMaybe<Order_By>;
  current_reward_per_block?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  init_block?: InputMaybe<Order_By>;
  last_block_update?: InputMaybe<Order_By>;
  lp_token_balance?: InputMaybe<Order_By>;
  lp_token_id?: InputMaybe<Order_By>;
  min_block_time_snapshot?: InputMaybe<Order_By>;
  paid_rewards?: InputMaybe<Order_By>;
  token0_id?: InputMaybe<Order_By>;
  token1_id?: InputMaybe<Order_By>;
  total_blocks?: InputMaybe<Order_By>;
  total_rewards?: InputMaybe<Order_By>;
  unpaid_rewards?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Farm_Var_Samp_Fields = {
  __typename?: 'farm_var_samp_fields';
  accumulated_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  current_reward_per_block?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  init_block?: Maybe<Scalars['Float']['output']>;
  last_block_update?: Maybe<Scalars['Float']['output']>;
  lp_token_balance?: Maybe<Scalars['Float']['output']>;
  lp_token_id?: Maybe<Scalars['Float']['output']>;
  min_block_time_snapshot?: Maybe<Scalars['Float']['output']>;
  paid_rewards?: Maybe<Scalars['Float']['output']>;
  token0_id?: Maybe<Scalars['Float']['output']>;
  token1_id?: Maybe<Scalars['Float']['output']>;
  total_blocks?: Maybe<Scalars['Float']['output']>;
  total_rewards?: Maybe<Scalars['Float']['output']>;
  unpaid_rewards?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "farm" */
export type Farm_Var_Samp_Order_By = {
  accumulated_rewards_per_share?: InputMaybe<Order_By>;
  current_reward_per_block?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  init_block?: InputMaybe<Order_By>;
  last_block_update?: InputMaybe<Order_By>;
  lp_token_balance?: InputMaybe<Order_By>;
  lp_token_id?: InputMaybe<Order_By>;
  min_block_time_snapshot?: InputMaybe<Order_By>;
  paid_rewards?: InputMaybe<Order_By>;
  token0_id?: InputMaybe<Order_By>;
  token1_id?: InputMaybe<Order_By>;
  total_blocks?: InputMaybe<Order_By>;
  total_rewards?: InputMaybe<Order_By>;
  unpaid_rewards?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Farm_Variance_Fields = {
  __typename?: 'farm_variance_fields';
  accumulated_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  current_reward_per_block?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  init_block?: Maybe<Scalars['Float']['output']>;
  last_block_update?: Maybe<Scalars['Float']['output']>;
  lp_token_balance?: Maybe<Scalars['Float']['output']>;
  lp_token_id?: Maybe<Scalars['Float']['output']>;
  min_block_time_snapshot?: Maybe<Scalars['Float']['output']>;
  paid_rewards?: Maybe<Scalars['Float']['output']>;
  token0_id?: Maybe<Scalars['Float']['output']>;
  token1_id?: Maybe<Scalars['Float']['output']>;
  total_blocks?: Maybe<Scalars['Float']['output']>;
  total_rewards?: Maybe<Scalars['Float']['output']>;
  unpaid_rewards?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "farm" */
export type Farm_Variance_Order_By = {
  accumulated_rewards_per_share?: InputMaybe<Order_By>;
  current_reward_per_block?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  init_block?: InputMaybe<Order_By>;
  last_block_update?: InputMaybe<Order_By>;
  lp_token_balance?: InputMaybe<Order_By>;
  lp_token_id?: InputMaybe<Order_By>;
  min_block_time_snapshot?: InputMaybe<Order_By>;
  paid_rewards?: InputMaybe<Order_By>;
  token0_id?: InputMaybe<Order_By>;
  token1_id?: InputMaybe<Order_By>;
  total_blocks?: InputMaybe<Order_By>;
  total_rewards?: InputMaybe<Order_By>;
  unpaid_rewards?: InputMaybe<Order_By>;
};

/** columns and relationships of "farm_whitelist_contract" */
export type Farm_Whitelist_Contract = {
  __typename?: 'farm_whitelist_contract';
  /** An object relationship */
  contract: Farm;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "farm_whitelist_contract" */
export type Farm_Whitelist_Contract_Aggregate = {
  __typename?: 'farm_whitelist_contract_aggregate';
  aggregate?: Maybe<Farm_Whitelist_Contract_Aggregate_Fields>;
  nodes: Array<Farm_Whitelist_Contract>;
};

export type Farm_Whitelist_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Farm_Whitelist_Contract_Aggregate_Bool_Exp_Count>;
};

export type Farm_Whitelist_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Farm_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Farm_Whitelist_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "farm_whitelist_contract" */
export type Farm_Whitelist_Contract_Aggregate_Fields = {
  __typename?: 'farm_whitelist_contract_aggregate_fields';
  avg?: Maybe<Farm_Whitelist_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Farm_Whitelist_Contract_Max_Fields>;
  min?: Maybe<Farm_Whitelist_Contract_Min_Fields>;
  stddev?: Maybe<Farm_Whitelist_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Farm_Whitelist_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Farm_Whitelist_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Farm_Whitelist_Contract_Sum_Fields>;
  var_pop?: Maybe<Farm_Whitelist_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Farm_Whitelist_Contract_Var_Samp_Fields>;
  variance?: Maybe<Farm_Whitelist_Contract_Variance_Fields>;
};


/** aggregate fields of "farm_whitelist_contract" */
export type Farm_Whitelist_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Farm_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "farm_whitelist_contract" */
export type Farm_Whitelist_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Farm_Whitelist_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Farm_Whitelist_Contract_Max_Order_By>;
  min?: InputMaybe<Farm_Whitelist_Contract_Min_Order_By>;
  stddev?: InputMaybe<Farm_Whitelist_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Farm_Whitelist_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Farm_Whitelist_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Farm_Whitelist_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Farm_Whitelist_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Farm_Whitelist_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Farm_Whitelist_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Farm_Whitelist_Contract_Avg_Fields = {
  __typename?: 'farm_whitelist_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "farm_whitelist_contract" */
export type Farm_Whitelist_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "farm_whitelist_contract". All fields are combined with a logical 'AND'. */
export type Farm_Whitelist_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Farm_Whitelist_Contract_Bool_Exp>>;
  _not?: InputMaybe<Farm_Whitelist_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Farm_Whitelist_Contract_Bool_Exp>>;
  contract?: InputMaybe<Farm_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Farm_Whitelist_Contract_Max_Fields = {
  __typename?: 'farm_whitelist_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "farm_whitelist_contract" */
export type Farm_Whitelist_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Farm_Whitelist_Contract_Min_Fields = {
  __typename?: 'farm_whitelist_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "farm_whitelist_contract" */
export type Farm_Whitelist_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "farm_whitelist_contract". */
export type Farm_Whitelist_Contract_Order_By = {
  contract?: InputMaybe<Farm_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "farm_whitelist_contract" */
export enum Farm_Whitelist_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Farm_Whitelist_Contract_Stddev_Fields = {
  __typename?: 'farm_whitelist_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "farm_whitelist_contract" */
export type Farm_Whitelist_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Farm_Whitelist_Contract_Stddev_Pop_Fields = {
  __typename?: 'farm_whitelist_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "farm_whitelist_contract" */
export type Farm_Whitelist_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Farm_Whitelist_Contract_Stddev_Samp_Fields = {
  __typename?: 'farm_whitelist_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "farm_whitelist_contract" */
export type Farm_Whitelist_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "farm_whitelist_contract" */
export type Farm_Whitelist_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Farm_Whitelist_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Farm_Whitelist_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Farm_Whitelist_Contract_Sum_Fields = {
  __typename?: 'farm_whitelist_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "farm_whitelist_contract" */
export type Farm_Whitelist_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Farm_Whitelist_Contract_Var_Pop_Fields = {
  __typename?: 'farm_whitelist_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "farm_whitelist_contract" */
export type Farm_Whitelist_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Farm_Whitelist_Contract_Var_Samp_Fields = {
  __typename?: 'farm_whitelist_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "farm_whitelist_contract" */
export type Farm_Whitelist_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Farm_Whitelist_Contract_Variance_Fields = {
  __typename?: 'farm_whitelist_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "farm_whitelist_contract" */
export type Farm_Whitelist_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** columns and relationships of "governance" */
export type Governance = {
  __typename?: 'governance';
  address: Scalars['String']['output'];
  admin: Scalars['String']['output'];
  /** An array relationship */
  aggregator_factories: Array<Aggregator_Factory>;
  /** An aggregate relationship */
  aggregator_factories_aggregate: Aggregator_Factory_Aggregate;
  /** An array relationship */
  aggregators: Array<Aggregator>;
  /** An aggregate relationship */
  aggregators_aggregate: Aggregator_Aggregate;
  blocks_per_proposal_round: Scalars['bigint']['output'];
  blocks_per_timelock_round: Scalars['bigint']['output'];
  blocks_per_voting_round: Scalars['bigint']['output'];
  /** An array relationship */
  break_glasses: Array<Break_Glass>;
  /** An aggregate relationship */
  break_glasses_aggregate: Break_Glass_Aggregate;
  /** An array relationship */
  councils: Array<Council>;
  /** An aggregate relationship */
  councils_aggregate: Council_Aggregate;
  current_blocks_per_proposal_round: Scalars['bigint']['output'];
  current_blocks_per_timelock_round: Scalars['bigint']['output'];
  current_blocks_per_voting_round: Scalars['bigint']['output'];
  current_cycle_end_level: Scalars['bigint']['output'];
  current_cycle_total_voters_reward: Scalars['float8']['output'];
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  current_round: Scalars['smallint']['output'];
  current_round_end_level: Scalars['bigint']['output'];
  current_round_start_level: Scalars['bigint']['output'];
  cycle_highest_voted_proposal_id: Scalars['bigint']['output'];
  cycle_id: Scalars['bigint']['output'];
  cycle_voters_reward: Scalars['float8']['output'];
  /** An array relationship */
  delegations: Array<Delegation>;
  /** An aggregate relationship */
  delegations_aggregate: Delegation_Aggregate;
  /** An array relationship */
  doormans: Array<Doorman>;
  /** An aggregate relationship */
  doormans_aggregate: Doorman_Aggregate;
  /** An array relationship */
  emergency_governances: Array<Emergency_Governance>;
  /** An aggregate relationship */
  emergency_governances_aggregate: Emergency_Governance_Aggregate;
  /** An array relationship */
  farm_factories: Array<Farm_Factory>;
  /** An aggregate relationship */
  farm_factories_aggregate: Farm_Factory_Aggregate;
  /** An array relationship */
  farms: Array<Farm>;
  /** An aggregate relationship */
  farms_aggregate: Farm_Aggregate;
  /** An array relationship */
  general_contracts: Array<Governance_General_Contract>;
  /** An aggregate relationship */
  general_contracts_aggregate: Governance_General_Contract_Aggregate;
  /** An array relationship */
  governance_financials: Array<Governance_Financial>;
  /** An aggregate relationship */
  governance_financials_aggregate: Governance_Financial_Aggregate;
  /** An array relationship */
  governance_proxies: Array<Governance_Proxy>;
  /** An aggregate relationship */
  governance_proxies_aggregate: Governance_Proxy_Aggregate;
  governance_proxy_address: Scalars['String']['output'];
  /** An array relationship */
  governance_satellites: Array<Governance_Satellite>;
  /** An aggregate relationship */
  governance_satellites_aggregate: Governance_Satellite_Aggregate;
  id: Scalars['bigint']['output'];
  /** An array relationship */
  lambdas: Array<Governance_Lambda>;
  /** An aggregate relationship */
  lambdas_aggregate: Governance_Lambda_Aggregate;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  lending_controllers: Array<Lending_Controller>;
  /** An aggregate relationship */
  lending_controllers_aggregate: Lending_Controller_Aggregate;
  /** An array relationship */
  m_tokens: Array<M_Token>;
  /** An aggregate relationship */
  m_tokens_aggregate: M_Token_Aggregate;
  max_proposal_per_satellite: Scalars['smallint']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  min_quorum_percentage: Scalars['smallint']['output'];
  min_yay_vote_percentage: Scalars['smallint']['output'];
  /** An array relationship */
  mvn_tokens: Array<Mvn_Token>;
  /** An aggregate relationship */
  mvn_tokens_aggregate: Mvn_Token_Aggregate;
  network: Scalars['String']['output'];
  next_proposal_id: Scalars['bigint']['output'];
  proposal_description_max_length: Scalars['bigint']['output'];
  proposal_invoice_max_length: Scalars['bigint']['output'];
  proposal_metadata_title_max_length: Scalars['bigint']['output'];
  proposal_round_vote_percentage: Scalars['smallint']['output'];
  proposal_source_code_max_length: Scalars['bigint']['output'];
  proposal_submission_fee_mumav: Scalars['bigint']['output'];
  proposal_title_max_length: Scalars['bigint']['output'];
  /** An array relationship */
  proposals: Array<Governance_Proposal>;
  /** An aggregate relationship */
  proposals_aggregate: Governance_Proposal_Aggregate;
  /** An array relationship */
  satellite_snapshots: Array<Governance_Satellite_Snapshot>;
  /** An aggregate relationship */
  satellite_snapshots_aggregate: Governance_Satellite_Snapshot_Aggregate;
  /** An array relationship */
  smvn_snapshots: Array<Governance_Smvn_Snapshot>;
  /** An aggregate relationship */
  smvn_snapshots_aggregate: Governance_Smvn_Snapshot_Aggregate;
  success_reward: Scalars['float8']['output'];
  timelock_proposal_id: Scalars['bigint']['output'];
  /** An array relationship */
  treasuries: Array<Treasury>;
  /** An aggregate relationship */
  treasuries_aggregate: Treasury_Aggregate;
  /** An array relationship */
  treasury_factories: Array<Treasury_Factory>;
  /** An aggregate relationship */
  treasury_factories_aggregate: Treasury_Factory_Aggregate;
  /** An array relationship */
  vault_factories: Array<Vault_Factory>;
  /** An aggregate relationship */
  vault_factories_aggregate: Vault_Factory_Aggregate;
  /** An array relationship */
  vestings: Array<Vesting>;
  /** An aggregate relationship */
  vestings_aggregate: Vesting_Aggregate;
  /** An array relationship */
  whitelist_contracts: Array<Governance_Whitelist_Contract>;
  /** An aggregate relationship */
  whitelist_contracts_aggregate: Governance_Whitelist_Contract_Aggregate;
  /** An array relationship */
  whitelist_developers: Array<Whitelist_Developer>;
  /** An aggregate relationship */
  whitelist_developers_aggregate: Whitelist_Developer_Aggregate;
};


/** columns and relationships of "governance" */
export type GovernanceAggregator_FactoriesArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceAggregator_Factories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceAggregatorsArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Order_By>>;
  where?: InputMaybe<Aggregator_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceAggregators_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Order_By>>;
  where?: InputMaybe<Aggregator_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceBreak_GlassesArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Order_By>>;
  where?: InputMaybe<Break_Glass_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceBreak_Glasses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Order_By>>;
  where?: InputMaybe<Break_Glass_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceCouncilsArgs = {
  distinct_on?: InputMaybe<Array<Council_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Order_By>>;
  where?: InputMaybe<Council_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceCouncils_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Order_By>>;
  where?: InputMaybe<Council_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceDelegationsArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Order_By>>;
  where?: InputMaybe<Delegation_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceDelegations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Order_By>>;
  where?: InputMaybe<Delegation_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceDoormansArgs = {
  distinct_on?: InputMaybe<Array<Doorman_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_Order_By>>;
  where?: InputMaybe<Doorman_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceDoormans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Doorman_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_Order_By>>;
  where?: InputMaybe<Doorman_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceEmergency_GovernancesArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceEmergency_Governances_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceFarm_FactoriesArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_Order_By>>;
  where?: InputMaybe<Farm_Factory_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceFarm_Factories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_Order_By>>;
  where?: InputMaybe<Farm_Factory_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceFarmsArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceFarms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceGeneral_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Governance_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_General_Contract_Order_By>>;
  where?: InputMaybe<Governance_General_Contract_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceGeneral_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_General_Contract_Order_By>>;
  where?: InputMaybe<Governance_General_Contract_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceGovernance_FinancialsArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Order_By>>;
  where?: InputMaybe<Governance_Financial_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceGovernance_Financials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Order_By>>;
  where?: InputMaybe<Governance_Financial_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceGovernance_ProxiesArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proxy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proxy_Order_By>>;
  where?: InputMaybe<Governance_Proxy_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceGovernance_Proxies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proxy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proxy_Order_By>>;
  where?: InputMaybe<Governance_Proxy_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceGovernance_SatellitesArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceGovernance_Satellites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceLambdasArgs = {
  distinct_on?: InputMaybe<Array<Governance_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Lambda_Order_By>>;
  where?: InputMaybe<Governance_Lambda_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceLambdas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Lambda_Order_By>>;
  where?: InputMaybe<Governance_Lambda_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceLending_ControllersArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Order_By>>;
  where?: InputMaybe<Lending_Controller_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceLending_Controllers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Order_By>>;
  where?: InputMaybe<Lending_Controller_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceM_TokensArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Order_By>>;
  where?: InputMaybe<M_Token_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceM_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Order_By>>;
  where?: InputMaybe<M_Token_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "governance" */
export type GovernanceMvn_TokensArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_Order_By>>;
  where?: InputMaybe<Mvn_Token_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceMvn_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_Order_By>>;
  where?: InputMaybe<Mvn_Token_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceProposalsArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceProposals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceSatellite_SnapshotsArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Snapshot_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Snapshot_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceSatellite_Snapshots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Snapshot_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Snapshot_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceSmvn_SnapshotsArgs = {
  distinct_on?: InputMaybe<Array<Governance_Smvn_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Smvn_Snapshot_Order_By>>;
  where?: InputMaybe<Governance_Smvn_Snapshot_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceSmvn_Snapshots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Smvn_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Smvn_Snapshot_Order_By>>;
  where?: InputMaybe<Governance_Smvn_Snapshot_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceTreasuriesArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Order_By>>;
  where?: InputMaybe<Treasury_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceTreasuries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Order_By>>;
  where?: InputMaybe<Treasury_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceTreasury_FactoriesArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceTreasury_Factories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceVault_FactoriesArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_Order_By>>;
  where?: InputMaybe<Vault_Factory_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceVault_Factories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_Order_By>>;
  where?: InputMaybe<Vault_Factory_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceVestingsArgs = {
  distinct_on?: InputMaybe<Array<Vesting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_Order_By>>;
  where?: InputMaybe<Vesting_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceVestings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vesting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_Order_By>>;
  where?: InputMaybe<Vesting_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceWhitelist_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Governance_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Governance_Whitelist_Contract_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceWhitelist_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Governance_Whitelist_Contract_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceWhitelist_DevelopersArgs = {
  distinct_on?: InputMaybe<Array<Whitelist_Developer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whitelist_Developer_Order_By>>;
  where?: InputMaybe<Whitelist_Developer_Bool_Exp>;
};


/** columns and relationships of "governance" */
export type GovernanceWhitelist_Developers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whitelist_Developer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whitelist_Developer_Order_By>>;
  where?: InputMaybe<Whitelist_Developer_Bool_Exp>;
};

/** aggregated selection of "governance" */
export type Governance_Aggregate = {
  __typename?: 'governance_aggregate';
  aggregate?: Maybe<Governance_Aggregate_Fields>;
  nodes: Array<Governance>;
};

/** aggregate fields of "governance" */
export type Governance_Aggregate_Fields = {
  __typename?: 'governance_aggregate_fields';
  avg?: Maybe<Governance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Max_Fields>;
  min?: Maybe<Governance_Min_Fields>;
  stddev?: Maybe<Governance_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Sum_Fields>;
  var_pop?: Maybe<Governance_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Var_Samp_Fields>;
  variance?: Maybe<Governance_Variance_Fields>;
};


/** aggregate fields of "governance" */
export type Governance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Governance_Avg_Fields = {
  __typename?: 'governance_avg_fields';
  blocks_per_proposal_round?: Maybe<Scalars['Float']['output']>;
  blocks_per_timelock_round?: Maybe<Scalars['Float']['output']>;
  blocks_per_voting_round?: Maybe<Scalars['Float']['output']>;
  current_blocks_per_proposal_round?: Maybe<Scalars['Float']['output']>;
  current_blocks_per_timelock_round?: Maybe<Scalars['Float']['output']>;
  current_blocks_per_voting_round?: Maybe<Scalars['Float']['output']>;
  current_cycle_end_level?: Maybe<Scalars['Float']['output']>;
  current_cycle_total_voters_reward?: Maybe<Scalars['Float']['output']>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  current_round?: Maybe<Scalars['Float']['output']>;
  current_round_end_level?: Maybe<Scalars['Float']['output']>;
  current_round_start_level?: Maybe<Scalars['Float']['output']>;
  cycle_highest_voted_proposal_id?: Maybe<Scalars['Float']['output']>;
  cycle_id?: Maybe<Scalars['Float']['output']>;
  cycle_voters_reward?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_proposal_per_satellite?: Maybe<Scalars['Float']['output']>;
  min_quorum_percentage?: Maybe<Scalars['Float']['output']>;
  min_yay_vote_percentage?: Maybe<Scalars['Float']['output']>;
  next_proposal_id?: Maybe<Scalars['Float']['output']>;
  proposal_description_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_invoice_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_metadata_title_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_round_vote_percentage?: Maybe<Scalars['Float']['output']>;
  proposal_source_code_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_submission_fee_mumav?: Maybe<Scalars['Float']['output']>;
  proposal_title_max_length?: Maybe<Scalars['Float']['output']>;
  success_reward?: Maybe<Scalars['Float']['output']>;
  timelock_proposal_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "governance". All fields are combined with a logical 'AND'. */
export type Governance_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Bool_Exp>>;
  _not?: InputMaybe<Governance_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  admin?: InputMaybe<String_Comparison_Exp>;
  aggregator_factories?: InputMaybe<Aggregator_Factory_Bool_Exp>;
  aggregator_factories_aggregate?: InputMaybe<Aggregator_Factory_Aggregate_Bool_Exp>;
  aggregators?: InputMaybe<Aggregator_Bool_Exp>;
  aggregators_aggregate?: InputMaybe<Aggregator_Aggregate_Bool_Exp>;
  blocks_per_proposal_round?: InputMaybe<Bigint_Comparison_Exp>;
  blocks_per_timelock_round?: InputMaybe<Bigint_Comparison_Exp>;
  blocks_per_voting_round?: InputMaybe<Bigint_Comparison_Exp>;
  break_glasses?: InputMaybe<Break_Glass_Bool_Exp>;
  break_glasses_aggregate?: InputMaybe<Break_Glass_Aggregate_Bool_Exp>;
  councils?: InputMaybe<Council_Bool_Exp>;
  councils_aggregate?: InputMaybe<Council_Aggregate_Bool_Exp>;
  current_blocks_per_proposal_round?: InputMaybe<Bigint_Comparison_Exp>;
  current_blocks_per_timelock_round?: InputMaybe<Bigint_Comparison_Exp>;
  current_blocks_per_voting_round?: InputMaybe<Bigint_Comparison_Exp>;
  current_cycle_end_level?: InputMaybe<Bigint_Comparison_Exp>;
  current_cycle_total_voters_reward?: InputMaybe<Float8_Comparison_Exp>;
  current_round?: InputMaybe<Smallint_Comparison_Exp>;
  current_round_end_level?: InputMaybe<Bigint_Comparison_Exp>;
  current_round_start_level?: InputMaybe<Bigint_Comparison_Exp>;
  cycle_highest_voted_proposal_id?: InputMaybe<Bigint_Comparison_Exp>;
  cycle_id?: InputMaybe<Bigint_Comparison_Exp>;
  cycle_voters_reward?: InputMaybe<Float8_Comparison_Exp>;
  delegations?: InputMaybe<Delegation_Bool_Exp>;
  delegations_aggregate?: InputMaybe<Delegation_Aggregate_Bool_Exp>;
  doormans?: InputMaybe<Doorman_Bool_Exp>;
  doormans_aggregate?: InputMaybe<Doorman_Aggregate_Bool_Exp>;
  emergency_governances?: InputMaybe<Emergency_Governance_Bool_Exp>;
  emergency_governances_aggregate?: InputMaybe<Emergency_Governance_Aggregate_Bool_Exp>;
  farm_factories?: InputMaybe<Farm_Factory_Bool_Exp>;
  farm_factories_aggregate?: InputMaybe<Farm_Factory_Aggregate_Bool_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  farms_aggregate?: InputMaybe<Farm_Aggregate_Bool_Exp>;
  general_contracts?: InputMaybe<Governance_General_Contract_Bool_Exp>;
  general_contracts_aggregate?: InputMaybe<Governance_General_Contract_Aggregate_Bool_Exp>;
  governance_financials?: InputMaybe<Governance_Financial_Bool_Exp>;
  governance_financials_aggregate?: InputMaybe<Governance_Financial_Aggregate_Bool_Exp>;
  governance_proxies?: InputMaybe<Governance_Proxy_Bool_Exp>;
  governance_proxies_aggregate?: InputMaybe<Governance_Proxy_Aggregate_Bool_Exp>;
  governance_proxy_address?: InputMaybe<String_Comparison_Exp>;
  governance_satellites?: InputMaybe<Governance_Satellite_Bool_Exp>;
  governance_satellites_aggregate?: InputMaybe<Governance_Satellite_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambdas?: InputMaybe<Governance_Lambda_Bool_Exp>;
  lambdas_aggregate?: InputMaybe<Governance_Lambda_Aggregate_Bool_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  lending_controllers?: InputMaybe<Lending_Controller_Bool_Exp>;
  lending_controllers_aggregate?: InputMaybe<Lending_Controller_Aggregate_Bool_Exp>;
  m_tokens?: InputMaybe<M_Token_Bool_Exp>;
  m_tokens_aggregate?: InputMaybe<M_Token_Aggregate_Bool_Exp>;
  max_proposal_per_satellite?: InputMaybe<Smallint_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  min_quorum_percentage?: InputMaybe<Smallint_Comparison_Exp>;
  min_yay_vote_percentage?: InputMaybe<Smallint_Comparison_Exp>;
  mvn_tokens?: InputMaybe<Mvn_Token_Bool_Exp>;
  mvn_tokens_aggregate?: InputMaybe<Mvn_Token_Aggregate_Bool_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
  next_proposal_id?: InputMaybe<Bigint_Comparison_Exp>;
  proposal_description_max_length?: InputMaybe<Bigint_Comparison_Exp>;
  proposal_invoice_max_length?: InputMaybe<Bigint_Comparison_Exp>;
  proposal_metadata_title_max_length?: InputMaybe<Bigint_Comparison_Exp>;
  proposal_round_vote_percentage?: InputMaybe<Smallint_Comparison_Exp>;
  proposal_source_code_max_length?: InputMaybe<Bigint_Comparison_Exp>;
  proposal_submission_fee_mumav?: InputMaybe<Bigint_Comparison_Exp>;
  proposal_title_max_length?: InputMaybe<Bigint_Comparison_Exp>;
  proposals?: InputMaybe<Governance_Proposal_Bool_Exp>;
  proposals_aggregate?: InputMaybe<Governance_Proposal_Aggregate_Bool_Exp>;
  satellite_snapshots?: InputMaybe<Governance_Satellite_Snapshot_Bool_Exp>;
  satellite_snapshots_aggregate?: InputMaybe<Governance_Satellite_Snapshot_Aggregate_Bool_Exp>;
  smvn_snapshots?: InputMaybe<Governance_Smvn_Snapshot_Bool_Exp>;
  smvn_snapshots_aggregate?: InputMaybe<Governance_Smvn_Snapshot_Aggregate_Bool_Exp>;
  success_reward?: InputMaybe<Float8_Comparison_Exp>;
  timelock_proposal_id?: InputMaybe<Bigint_Comparison_Exp>;
  treasuries?: InputMaybe<Treasury_Bool_Exp>;
  treasuries_aggregate?: InputMaybe<Treasury_Aggregate_Bool_Exp>;
  treasury_factories?: InputMaybe<Treasury_Factory_Bool_Exp>;
  treasury_factories_aggregate?: InputMaybe<Treasury_Factory_Aggregate_Bool_Exp>;
  vault_factories?: InputMaybe<Vault_Factory_Bool_Exp>;
  vault_factories_aggregate?: InputMaybe<Vault_Factory_Aggregate_Bool_Exp>;
  vestings?: InputMaybe<Vesting_Bool_Exp>;
  vestings_aggregate?: InputMaybe<Vesting_Aggregate_Bool_Exp>;
  whitelist_contracts?: InputMaybe<Governance_Whitelist_Contract_Bool_Exp>;
  whitelist_contracts_aggregate?: InputMaybe<Governance_Whitelist_Contract_Aggregate_Bool_Exp>;
  whitelist_developers?: InputMaybe<Whitelist_Developer_Bool_Exp>;
  whitelist_developers_aggregate?: InputMaybe<Whitelist_Developer_Aggregate_Bool_Exp>;
};

/** columns and relationships of "governance_financial" */
export type Governance_Financial = {
  __typename?: 'governance_financial';
  address: Scalars['String']['output'];
  admin: Scalars['String']['output'];
  approval_percentage: Scalars['smallint']['output'];
  fin_req_counter: Scalars['bigint']['output'];
  fin_req_duration_in_days: Scalars['smallint']['output'];
  /** An array relationship */
  general_contracts: Array<Governance_Financial_General_Contract>;
  /** An aggregate relationship */
  general_contracts_aggregate: Governance_Financial_General_Contract_Aggregate;
  /** An object relationship */
  governance: Governance;
  governance_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An array relationship */
  lambdas: Array<Governance_Financial_Lambda>;
  /** An aggregate relationship */
  lambdas_aggregate: Governance_Financial_Lambda_Aggregate;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  network: Scalars['String']['output'];
  /** An array relationship */
  requests: Array<Governance_Financial_Request>;
  /** An aggregate relationship */
  requests_aggregate: Governance_Financial_Request_Aggregate;
  /** An array relationship */
  whitelist_contracts: Array<Governance_Financial_Whitelist_Contract>;
  /** An aggregate relationship */
  whitelist_contracts_aggregate: Governance_Financial_Whitelist_Contract_Aggregate;
  /** An array relationship */
  whitelist_token_contracts: Array<Governance_Financial_Whitelist_Token_Contract>;
  /** An aggregate relationship */
  whitelist_token_contracts_aggregate: Governance_Financial_Whitelist_Token_Contract_Aggregate;
};


/** columns and relationships of "governance_financial" */
export type Governance_FinancialGeneral_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_General_Contract_Order_By>>;
  where?: InputMaybe<Governance_Financial_General_Contract_Bool_Exp>;
};


/** columns and relationships of "governance_financial" */
export type Governance_FinancialGeneral_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_General_Contract_Order_By>>;
  where?: InputMaybe<Governance_Financial_General_Contract_Bool_Exp>;
};


/** columns and relationships of "governance_financial" */
export type Governance_FinancialLambdasArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Lambda_Order_By>>;
  where?: InputMaybe<Governance_Financial_Lambda_Bool_Exp>;
};


/** columns and relationships of "governance_financial" */
export type Governance_FinancialLambdas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Lambda_Order_By>>;
  where?: InputMaybe<Governance_Financial_Lambda_Bool_Exp>;
};


/** columns and relationships of "governance_financial" */
export type Governance_FinancialMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "governance_financial" */
export type Governance_FinancialRequestsArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Request_Order_By>>;
  where?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
};


/** columns and relationships of "governance_financial" */
export type Governance_FinancialRequests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Request_Order_By>>;
  where?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
};


/** columns and relationships of "governance_financial" */
export type Governance_FinancialWhitelist_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Governance_Financial_Whitelist_Contract_Bool_Exp>;
};


/** columns and relationships of "governance_financial" */
export type Governance_FinancialWhitelist_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Governance_Financial_Whitelist_Contract_Bool_Exp>;
};


/** columns and relationships of "governance_financial" */
export type Governance_FinancialWhitelist_Token_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Whitelist_Token_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Whitelist_Token_Contract_Order_By>>;
  where?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Bool_Exp>;
};


/** columns and relationships of "governance_financial" */
export type Governance_FinancialWhitelist_Token_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Whitelist_Token_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Whitelist_Token_Contract_Order_By>>;
  where?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Bool_Exp>;
};

/** aggregated selection of "governance_financial" */
export type Governance_Financial_Aggregate = {
  __typename?: 'governance_financial_aggregate';
  aggregate?: Maybe<Governance_Financial_Aggregate_Fields>;
  nodes: Array<Governance_Financial>;
};

export type Governance_Financial_Aggregate_Bool_Exp = {
  count?: InputMaybe<Governance_Financial_Aggregate_Bool_Exp_Count>;
};

export type Governance_Financial_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_Financial_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Financial_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "governance_financial" */
export type Governance_Financial_Aggregate_Fields = {
  __typename?: 'governance_financial_aggregate_fields';
  avg?: Maybe<Governance_Financial_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Financial_Max_Fields>;
  min?: Maybe<Governance_Financial_Min_Fields>;
  stddev?: Maybe<Governance_Financial_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Financial_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Financial_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Financial_Sum_Fields>;
  var_pop?: Maybe<Governance_Financial_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Financial_Var_Samp_Fields>;
  variance?: Maybe<Governance_Financial_Variance_Fields>;
};


/** aggregate fields of "governance_financial" */
export type Governance_Financial_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Financial_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_financial" */
export type Governance_Financial_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_Financial_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_Financial_Max_Order_By>;
  min?: InputMaybe<Governance_Financial_Min_Order_By>;
  stddev?: InputMaybe<Governance_Financial_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_Financial_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_Financial_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_Financial_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_Financial_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_Financial_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_Financial_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Governance_Financial_Avg_Fields = {
  __typename?: 'governance_financial_avg_fields';
  approval_percentage?: Maybe<Scalars['Float']['output']>;
  fin_req_counter?: Maybe<Scalars['Float']['output']>;
  fin_req_duration_in_days?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_financial" */
export type Governance_Financial_Avg_Order_By = {
  approval_percentage?: InputMaybe<Order_By>;
  fin_req_counter?: InputMaybe<Order_By>;
  fin_req_duration_in_days?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_financial". All fields are combined with a logical 'AND'. */
export type Governance_Financial_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Financial_Bool_Exp>>;
  _not?: InputMaybe<Governance_Financial_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Financial_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  admin?: InputMaybe<String_Comparison_Exp>;
  approval_percentage?: InputMaybe<Smallint_Comparison_Exp>;
  fin_req_counter?: InputMaybe<Bigint_Comparison_Exp>;
  fin_req_duration_in_days?: InputMaybe<Smallint_Comparison_Exp>;
  general_contracts?: InputMaybe<Governance_Financial_General_Contract_Bool_Exp>;
  general_contracts_aggregate?: InputMaybe<Governance_Financial_General_Contract_Aggregate_Bool_Exp>;
  governance?: InputMaybe<Governance_Bool_Exp>;
  governance_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambdas?: InputMaybe<Governance_Financial_Lambda_Bool_Exp>;
  lambdas_aggregate?: InputMaybe<Governance_Financial_Lambda_Aggregate_Bool_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
  requests?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
  requests_aggregate?: InputMaybe<Governance_Financial_Request_Aggregate_Bool_Exp>;
  whitelist_contracts?: InputMaybe<Governance_Financial_Whitelist_Contract_Bool_Exp>;
  whitelist_contracts_aggregate?: InputMaybe<Governance_Financial_Whitelist_Contract_Aggregate_Bool_Exp>;
  whitelist_token_contracts?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Bool_Exp>;
  whitelist_token_contracts_aggregate?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Aggregate_Bool_Exp>;
};

/** columns and relationships of "governance_financial_general_contract" */
export type Governance_Financial_General_Contract = {
  __typename?: 'governance_financial_general_contract';
  /** An object relationship */
  contract: Governance_Financial;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  contract_name: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "governance_financial_general_contract" */
export type Governance_Financial_General_Contract_Aggregate = {
  __typename?: 'governance_financial_general_contract_aggregate';
  aggregate?: Maybe<Governance_Financial_General_Contract_Aggregate_Fields>;
  nodes: Array<Governance_Financial_General_Contract>;
};

export type Governance_Financial_General_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Governance_Financial_General_Contract_Aggregate_Bool_Exp_Count>;
};

export type Governance_Financial_General_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_Financial_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Financial_General_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "governance_financial_general_contract" */
export type Governance_Financial_General_Contract_Aggregate_Fields = {
  __typename?: 'governance_financial_general_contract_aggregate_fields';
  avg?: Maybe<Governance_Financial_General_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Financial_General_Contract_Max_Fields>;
  min?: Maybe<Governance_Financial_General_Contract_Min_Fields>;
  stddev?: Maybe<Governance_Financial_General_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Financial_General_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Financial_General_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Financial_General_Contract_Sum_Fields>;
  var_pop?: Maybe<Governance_Financial_General_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Financial_General_Contract_Var_Samp_Fields>;
  variance?: Maybe<Governance_Financial_General_Contract_Variance_Fields>;
};


/** aggregate fields of "governance_financial_general_contract" */
export type Governance_Financial_General_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Financial_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_financial_general_contract" */
export type Governance_Financial_General_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_Financial_General_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_Financial_General_Contract_Max_Order_By>;
  min?: InputMaybe<Governance_Financial_General_Contract_Min_Order_By>;
  stddev?: InputMaybe<Governance_Financial_General_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_Financial_General_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_Financial_General_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_Financial_General_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_Financial_General_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_Financial_General_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_Financial_General_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Governance_Financial_General_Contract_Avg_Fields = {
  __typename?: 'governance_financial_general_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_financial_general_contract" */
export type Governance_Financial_General_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_financial_general_contract". All fields are combined with a logical 'AND'. */
export type Governance_Financial_General_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Financial_General_Contract_Bool_Exp>>;
  _not?: InputMaybe<Governance_Financial_General_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Financial_General_Contract_Bool_Exp>>;
  contract?: InputMaybe<Governance_Financial_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  contract_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Governance_Financial_General_Contract_Max_Fields = {
  __typename?: 'governance_financial_general_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "governance_financial_general_contract" */
export type Governance_Financial_General_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_Financial_General_Contract_Min_Fields = {
  __typename?: 'governance_financial_general_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "governance_financial_general_contract" */
export type Governance_Financial_General_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_financial_general_contract". */
export type Governance_Financial_General_Contract_Order_By = {
  contract?: InputMaybe<Governance_Financial_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "governance_financial_general_contract" */
export enum Governance_Financial_General_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  ContractName = 'contract_name',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Governance_Financial_General_Contract_Stddev_Fields = {
  __typename?: 'governance_financial_general_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_financial_general_contract" */
export type Governance_Financial_General_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_Financial_General_Contract_Stddev_Pop_Fields = {
  __typename?: 'governance_financial_general_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_financial_general_contract" */
export type Governance_Financial_General_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_Financial_General_Contract_Stddev_Samp_Fields = {
  __typename?: 'governance_financial_general_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_financial_general_contract" */
export type Governance_Financial_General_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_financial_general_contract" */
export type Governance_Financial_General_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Financial_General_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Financial_General_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  contract_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Governance_Financial_General_Contract_Sum_Fields = {
  __typename?: 'governance_financial_general_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "governance_financial_general_contract" */
export type Governance_Financial_General_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_Financial_General_Contract_Var_Pop_Fields = {
  __typename?: 'governance_financial_general_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_financial_general_contract" */
export type Governance_Financial_General_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_Financial_General_Contract_Var_Samp_Fields = {
  __typename?: 'governance_financial_general_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_financial_general_contract" */
export type Governance_Financial_General_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_Financial_General_Contract_Variance_Fields = {
  __typename?: 'governance_financial_general_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_financial_general_contract" */
export type Governance_Financial_General_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "governance_financial_lambda" */
export type Governance_Financial_Lambda = {
  __typename?: 'governance_financial_lambda';
  /** An object relationship */
  contract: Governance_Financial;
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lambda_bytes: Scalars['String']['output'];
  lambda_name: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "governance_financial_lambda" */
export type Governance_Financial_Lambda_Aggregate = {
  __typename?: 'governance_financial_lambda_aggregate';
  aggregate?: Maybe<Governance_Financial_Lambda_Aggregate_Fields>;
  nodes: Array<Governance_Financial_Lambda>;
};

export type Governance_Financial_Lambda_Aggregate_Bool_Exp = {
  count?: InputMaybe<Governance_Financial_Lambda_Aggregate_Bool_Exp_Count>;
};

export type Governance_Financial_Lambda_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_Financial_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Financial_Lambda_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "governance_financial_lambda" */
export type Governance_Financial_Lambda_Aggregate_Fields = {
  __typename?: 'governance_financial_lambda_aggregate_fields';
  avg?: Maybe<Governance_Financial_Lambda_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Financial_Lambda_Max_Fields>;
  min?: Maybe<Governance_Financial_Lambda_Min_Fields>;
  stddev?: Maybe<Governance_Financial_Lambda_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Financial_Lambda_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Financial_Lambda_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Financial_Lambda_Sum_Fields>;
  var_pop?: Maybe<Governance_Financial_Lambda_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Financial_Lambda_Var_Samp_Fields>;
  variance?: Maybe<Governance_Financial_Lambda_Variance_Fields>;
};


/** aggregate fields of "governance_financial_lambda" */
export type Governance_Financial_Lambda_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Financial_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_financial_lambda" */
export type Governance_Financial_Lambda_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_Financial_Lambda_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_Financial_Lambda_Max_Order_By>;
  min?: InputMaybe<Governance_Financial_Lambda_Min_Order_By>;
  stddev?: InputMaybe<Governance_Financial_Lambda_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_Financial_Lambda_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_Financial_Lambda_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_Financial_Lambda_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_Financial_Lambda_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_Financial_Lambda_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_Financial_Lambda_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Governance_Financial_Lambda_Avg_Fields = {
  __typename?: 'governance_financial_lambda_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_financial_lambda" */
export type Governance_Financial_Lambda_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_financial_lambda". All fields are combined with a logical 'AND'. */
export type Governance_Financial_Lambda_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Financial_Lambda_Bool_Exp>>;
  _not?: InputMaybe<Governance_Financial_Lambda_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Financial_Lambda_Bool_Exp>>;
  contract?: InputMaybe<Governance_Financial_Bool_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambda_bytes?: InputMaybe<String_Comparison_Exp>;
  lambda_name?: InputMaybe<String_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Governance_Financial_Lambda_Max_Fields = {
  __typename?: 'governance_financial_lambda_max_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "governance_financial_lambda" */
export type Governance_Financial_Lambda_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_Financial_Lambda_Min_Fields = {
  __typename?: 'governance_financial_lambda_min_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "governance_financial_lambda" */
export type Governance_Financial_Lambda_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_financial_lambda". */
export type Governance_Financial_Lambda_Order_By = {
  contract?: InputMaybe<Governance_Financial_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "governance_financial_lambda" */
export enum Governance_Financial_Lambda_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaBytes = 'lambda_bytes',
  /** column name */
  LambdaName = 'lambda_name',
  /** column name */
  LastUpdatedAt = 'last_updated_at'
}

/** aggregate stddev on columns */
export type Governance_Financial_Lambda_Stddev_Fields = {
  __typename?: 'governance_financial_lambda_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_financial_lambda" */
export type Governance_Financial_Lambda_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_Financial_Lambda_Stddev_Pop_Fields = {
  __typename?: 'governance_financial_lambda_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_financial_lambda" */
export type Governance_Financial_Lambda_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_Financial_Lambda_Stddev_Samp_Fields = {
  __typename?: 'governance_financial_lambda_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_financial_lambda" */
export type Governance_Financial_Lambda_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_financial_lambda" */
export type Governance_Financial_Lambda_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Financial_Lambda_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Financial_Lambda_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lambda_bytes?: InputMaybe<Scalars['String']['input']>;
  lambda_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Governance_Financial_Lambda_Sum_Fields = {
  __typename?: 'governance_financial_lambda_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "governance_financial_lambda" */
export type Governance_Financial_Lambda_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_Financial_Lambda_Var_Pop_Fields = {
  __typename?: 'governance_financial_lambda_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_financial_lambda" */
export type Governance_Financial_Lambda_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_Financial_Lambda_Var_Samp_Fields = {
  __typename?: 'governance_financial_lambda_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_financial_lambda" */
export type Governance_Financial_Lambda_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_Financial_Lambda_Variance_Fields = {
  __typename?: 'governance_financial_lambda_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_financial_lambda" */
export type Governance_Financial_Lambda_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Governance_Financial_Max_Fields = {
  __typename?: 'governance_financial_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  approval_percentage?: Maybe<Scalars['smallint']['output']>;
  fin_req_counter?: Maybe<Scalars['bigint']['output']>;
  fin_req_duration_in_days?: Maybe<Scalars['smallint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  network?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "governance_financial" */
export type Governance_Financial_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  approval_percentage?: InputMaybe<Order_By>;
  fin_req_counter?: InputMaybe<Order_By>;
  fin_req_duration_in_days?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_Financial_Min_Fields = {
  __typename?: 'governance_financial_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  approval_percentage?: Maybe<Scalars['smallint']['output']>;
  fin_req_counter?: Maybe<Scalars['bigint']['output']>;
  fin_req_duration_in_days?: Maybe<Scalars['smallint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  network?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "governance_financial" */
export type Governance_Financial_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  approval_percentage?: InputMaybe<Order_By>;
  fin_req_counter?: InputMaybe<Order_By>;
  fin_req_duration_in_days?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_financial". */
export type Governance_Financial_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  approval_percentage?: InputMaybe<Order_By>;
  fin_req_counter?: InputMaybe<Order_By>;
  fin_req_duration_in_days?: InputMaybe<Order_By>;
  general_contracts_aggregate?: InputMaybe<Governance_Financial_General_Contract_Aggregate_Order_By>;
  governance?: InputMaybe<Governance_Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambdas_aggregate?: InputMaybe<Governance_Financial_Lambda_Aggregate_Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  requests_aggregate?: InputMaybe<Governance_Financial_Request_Aggregate_Order_By>;
  whitelist_contracts_aggregate?: InputMaybe<Governance_Financial_Whitelist_Contract_Aggregate_Order_By>;
  whitelist_token_contracts_aggregate?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Aggregate_Order_By>;
};

/** columns and relationships of "governance_financial_request" */
export type Governance_Financial_Request = {
  __typename?: 'governance_financial_request';
  dropped_datetime?: Maybe<Scalars['timestamptz']['output']>;
  executed: Scalars['Boolean']['output'];
  execution_datetime?: Maybe<Scalars['timestamptz']['output']>;
  expiration_datetime: Scalars['timestamptz']['output'];
  governance_cycle_id: Scalars['bigint']['output'];
  /** An object relationship */
  governance_financial: Governance_Financial;
  governance_financial_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  internal_id: Scalars['bigint']['output'];
  nay_vote_smvn_total: Scalars['float8']['output'];
  pass_vote_smvn_total: Scalars['float8']['output'];
  /** An object relationship */
  receiver: Maven_User;
  receiver_id: Scalars['bigint']['output'];
  request_purpose: Scalars['String']['output'];
  request_type: Scalars['String']['output'];
  requested_datetime: Scalars['timestamptz']['output'];
  /** An object relationship */
  requester: Maven_User;
  requester_id: Scalars['bigint']['output'];
  smvn_percentage_for_approval: Scalars['smallint']['output'];
  smvn_required_for_approval: Scalars['float8']['output'];
  snapshot_smvn_total_supply: Scalars['float8']['output'];
  /** ACTIVE: 0\nDROPPED: 1 */
  status: Scalars['smallint']['output'];
  /** An object relationship */
  token: Token;
  token_amount: Scalars['float8']['output'];
  token_id: Scalars['bigint']['output'];
  /** An object relationship */
  treasury: Treasury;
  treasury_id: Scalars['bigint']['output'];
  /** An array relationship */
  votes: Array<Governance_Financial_Request_Vote>;
  /** An aggregate relationship */
  votes_aggregate: Governance_Financial_Request_Vote_Aggregate;
  yay_vote_smvn_total: Scalars['float8']['output'];
};


/** columns and relationships of "governance_financial_request" */
export type Governance_Financial_RequestVotesArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Request_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Request_Vote_Order_By>>;
  where?: InputMaybe<Governance_Financial_Request_Vote_Bool_Exp>;
};


/** columns and relationships of "governance_financial_request" */
export type Governance_Financial_RequestVotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Request_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Request_Vote_Order_By>>;
  where?: InputMaybe<Governance_Financial_Request_Vote_Bool_Exp>;
};

/** aggregated selection of "governance_financial_request" */
export type Governance_Financial_Request_Aggregate = {
  __typename?: 'governance_financial_request_aggregate';
  aggregate?: Maybe<Governance_Financial_Request_Aggregate_Fields>;
  nodes: Array<Governance_Financial_Request>;
};

export type Governance_Financial_Request_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Governance_Financial_Request_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Governance_Financial_Request_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Governance_Financial_Request_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Governance_Financial_Request_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Governance_Financial_Request_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Governance_Financial_Request_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Governance_Financial_Request_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Governance_Financial_Request_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Governance_Financial_Request_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Governance_Financial_Request_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Governance_Financial_Request_Aggregate_Bool_Exp_Var_Samp>;
};

export type Governance_Financial_Request_Aggregate_Bool_Exp_Avg = {
  arguments: Governance_Financial_Request_Select_Column_Governance_Financial_Request_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Financial_Request_Aggregate_Bool_Exp_Bool_And = {
  arguments: Governance_Financial_Request_Select_Column_Governance_Financial_Request_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Governance_Financial_Request_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Governance_Financial_Request_Select_Column_Governance_Financial_Request_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Governance_Financial_Request_Aggregate_Bool_Exp_Corr = {
  arguments: Governance_Financial_Request_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Financial_Request_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Governance_Financial_Request_Select_Column_Governance_Financial_Request_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Governance_Financial_Request_Select_Column_Governance_Financial_Request_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Governance_Financial_Request_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_Financial_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Governance_Financial_Request_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Governance_Financial_Request_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Financial_Request_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Governance_Financial_Request_Select_Column_Governance_Financial_Request_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Governance_Financial_Request_Select_Column_Governance_Financial_Request_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Governance_Financial_Request_Aggregate_Bool_Exp_Max = {
  arguments: Governance_Financial_Request_Select_Column_Governance_Financial_Request_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Financial_Request_Aggregate_Bool_Exp_Min = {
  arguments: Governance_Financial_Request_Select_Column_Governance_Financial_Request_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Financial_Request_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Governance_Financial_Request_Select_Column_Governance_Financial_Request_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Financial_Request_Aggregate_Bool_Exp_Sum = {
  arguments: Governance_Financial_Request_Select_Column_Governance_Financial_Request_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Financial_Request_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Governance_Financial_Request_Select_Column_Governance_Financial_Request_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "governance_financial_request" */
export type Governance_Financial_Request_Aggregate_Fields = {
  __typename?: 'governance_financial_request_aggregate_fields';
  avg?: Maybe<Governance_Financial_Request_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Financial_Request_Max_Fields>;
  min?: Maybe<Governance_Financial_Request_Min_Fields>;
  stddev?: Maybe<Governance_Financial_Request_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Financial_Request_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Financial_Request_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Financial_Request_Sum_Fields>;
  var_pop?: Maybe<Governance_Financial_Request_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Financial_Request_Var_Samp_Fields>;
  variance?: Maybe<Governance_Financial_Request_Variance_Fields>;
};


/** aggregate fields of "governance_financial_request" */
export type Governance_Financial_Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Financial_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_financial_request" */
export type Governance_Financial_Request_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_Financial_Request_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_Financial_Request_Max_Order_By>;
  min?: InputMaybe<Governance_Financial_Request_Min_Order_By>;
  stddev?: InputMaybe<Governance_Financial_Request_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_Financial_Request_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_Financial_Request_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_Financial_Request_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_Financial_Request_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_Financial_Request_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_Financial_Request_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Governance_Financial_Request_Avg_Fields = {
  __typename?: 'governance_financial_request_avg_fields';
  governance_cycle_id?: Maybe<Scalars['Float']['output']>;
  governance_financial_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  receiver_id?: Maybe<Scalars['Float']['output']>;
  requester_id?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_for_approval?: Maybe<Scalars['Float']['output']>;
  smvn_required_for_approval?: Maybe<Scalars['Float']['output']>;
  snapshot_smvn_total_supply?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['Float']['output']>;
  token_amount?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  treasury_id?: Maybe<Scalars['Float']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_financial_request" */
export type Governance_Financial_Request_Avg_Order_By = {
  governance_cycle_id?: InputMaybe<Order_By>;
  governance_financial_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  requester_id?: InputMaybe<Order_By>;
  smvn_percentage_for_approval?: InputMaybe<Order_By>;
  smvn_required_for_approval?: InputMaybe<Order_By>;
  snapshot_smvn_total_supply?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  token_amount?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_financial_request". All fields are combined with a logical 'AND'. */
export type Governance_Financial_Request_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Financial_Request_Bool_Exp>>;
  _not?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Financial_Request_Bool_Exp>>;
  dropped_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  executed?: InputMaybe<Boolean_Comparison_Exp>;
  execution_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  expiration_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  governance_cycle_id?: InputMaybe<Bigint_Comparison_Exp>;
  governance_financial?: InputMaybe<Governance_Financial_Bool_Exp>;
  governance_financial_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  internal_id?: InputMaybe<Bigint_Comparison_Exp>;
  nay_vote_smvn_total?: InputMaybe<Float8_Comparison_Exp>;
  pass_vote_smvn_total?: InputMaybe<Float8_Comparison_Exp>;
  receiver?: InputMaybe<Maven_User_Bool_Exp>;
  receiver_id?: InputMaybe<Bigint_Comparison_Exp>;
  request_purpose?: InputMaybe<String_Comparison_Exp>;
  request_type?: InputMaybe<String_Comparison_Exp>;
  requested_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  requester?: InputMaybe<Maven_User_Bool_Exp>;
  requester_id?: InputMaybe<Bigint_Comparison_Exp>;
  smvn_percentage_for_approval?: InputMaybe<Smallint_Comparison_Exp>;
  smvn_required_for_approval?: InputMaybe<Float8_Comparison_Exp>;
  snapshot_smvn_total_supply?: InputMaybe<Float8_Comparison_Exp>;
  status?: InputMaybe<Smallint_Comparison_Exp>;
  token?: InputMaybe<Token_Bool_Exp>;
  token_amount?: InputMaybe<Float8_Comparison_Exp>;
  token_id?: InputMaybe<Bigint_Comparison_Exp>;
  treasury?: InputMaybe<Treasury_Bool_Exp>;
  treasury_id?: InputMaybe<Bigint_Comparison_Exp>;
  votes?: InputMaybe<Governance_Financial_Request_Vote_Bool_Exp>;
  votes_aggregate?: InputMaybe<Governance_Financial_Request_Vote_Aggregate_Bool_Exp>;
  yay_vote_smvn_total?: InputMaybe<Float8_Comparison_Exp>;
};

/** aggregate max on columns */
export type Governance_Financial_Request_Max_Fields = {
  __typename?: 'governance_financial_request_max_fields';
  dropped_datetime?: Maybe<Scalars['timestamptz']['output']>;
  execution_datetime?: Maybe<Scalars['timestamptz']['output']>;
  expiration_datetime?: Maybe<Scalars['timestamptz']['output']>;
  governance_cycle_id?: Maybe<Scalars['bigint']['output']>;
  governance_financial_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['bigint']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
  receiver_id?: Maybe<Scalars['bigint']['output']>;
  request_purpose?: Maybe<Scalars['String']['output']>;
  request_type?: Maybe<Scalars['String']['output']>;
  requested_datetime?: Maybe<Scalars['timestamptz']['output']>;
  requester_id?: Maybe<Scalars['bigint']['output']>;
  smvn_percentage_for_approval?: Maybe<Scalars['smallint']['output']>;
  smvn_required_for_approval?: Maybe<Scalars['float8']['output']>;
  snapshot_smvn_total_supply?: Maybe<Scalars['float8']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['smallint']['output']>;
  token_amount?: Maybe<Scalars['float8']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  treasury_id?: Maybe<Scalars['bigint']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "governance_financial_request" */
export type Governance_Financial_Request_Max_Order_By = {
  dropped_datetime?: InputMaybe<Order_By>;
  execution_datetime?: InputMaybe<Order_By>;
  expiration_datetime?: InputMaybe<Order_By>;
  governance_cycle_id?: InputMaybe<Order_By>;
  governance_financial_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  request_purpose?: InputMaybe<Order_By>;
  request_type?: InputMaybe<Order_By>;
  requested_datetime?: InputMaybe<Order_By>;
  requester_id?: InputMaybe<Order_By>;
  smvn_percentage_for_approval?: InputMaybe<Order_By>;
  smvn_required_for_approval?: InputMaybe<Order_By>;
  snapshot_smvn_total_supply?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  token_amount?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_Financial_Request_Min_Fields = {
  __typename?: 'governance_financial_request_min_fields';
  dropped_datetime?: Maybe<Scalars['timestamptz']['output']>;
  execution_datetime?: Maybe<Scalars['timestamptz']['output']>;
  expiration_datetime?: Maybe<Scalars['timestamptz']['output']>;
  governance_cycle_id?: Maybe<Scalars['bigint']['output']>;
  governance_financial_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['bigint']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
  receiver_id?: Maybe<Scalars['bigint']['output']>;
  request_purpose?: Maybe<Scalars['String']['output']>;
  request_type?: Maybe<Scalars['String']['output']>;
  requested_datetime?: Maybe<Scalars['timestamptz']['output']>;
  requester_id?: Maybe<Scalars['bigint']['output']>;
  smvn_percentage_for_approval?: Maybe<Scalars['smallint']['output']>;
  smvn_required_for_approval?: Maybe<Scalars['float8']['output']>;
  snapshot_smvn_total_supply?: Maybe<Scalars['float8']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['smallint']['output']>;
  token_amount?: Maybe<Scalars['float8']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  treasury_id?: Maybe<Scalars['bigint']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "governance_financial_request" */
export type Governance_Financial_Request_Min_Order_By = {
  dropped_datetime?: InputMaybe<Order_By>;
  execution_datetime?: InputMaybe<Order_By>;
  expiration_datetime?: InputMaybe<Order_By>;
  governance_cycle_id?: InputMaybe<Order_By>;
  governance_financial_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  request_purpose?: InputMaybe<Order_By>;
  request_type?: InputMaybe<Order_By>;
  requested_datetime?: InputMaybe<Order_By>;
  requester_id?: InputMaybe<Order_By>;
  smvn_percentage_for_approval?: InputMaybe<Order_By>;
  smvn_required_for_approval?: InputMaybe<Order_By>;
  snapshot_smvn_total_supply?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  token_amount?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_financial_request". */
export type Governance_Financial_Request_Order_By = {
  dropped_datetime?: InputMaybe<Order_By>;
  executed?: InputMaybe<Order_By>;
  execution_datetime?: InputMaybe<Order_By>;
  expiration_datetime?: InputMaybe<Order_By>;
  governance_cycle_id?: InputMaybe<Order_By>;
  governance_financial?: InputMaybe<Governance_Financial_Order_By>;
  governance_financial_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  receiver?: InputMaybe<Maven_User_Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  request_purpose?: InputMaybe<Order_By>;
  request_type?: InputMaybe<Order_By>;
  requested_datetime?: InputMaybe<Order_By>;
  requester?: InputMaybe<Maven_User_Order_By>;
  requester_id?: InputMaybe<Order_By>;
  smvn_percentage_for_approval?: InputMaybe<Order_By>;
  smvn_required_for_approval?: InputMaybe<Order_By>;
  snapshot_smvn_total_supply?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  token?: InputMaybe<Token_Order_By>;
  token_amount?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  treasury?: InputMaybe<Treasury_Order_By>;
  treasury_id?: InputMaybe<Order_By>;
  votes_aggregate?: InputMaybe<Governance_Financial_Request_Vote_Aggregate_Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** select columns of table "governance_financial_request" */
export enum Governance_Financial_Request_Select_Column {
  /** column name */
  DroppedDatetime = 'dropped_datetime',
  /** column name */
  Executed = 'executed',
  /** column name */
  ExecutionDatetime = 'execution_datetime',
  /** column name */
  ExpirationDatetime = 'expiration_datetime',
  /** column name */
  GovernanceCycleId = 'governance_cycle_id',
  /** column name */
  GovernanceFinancialId = 'governance_financial_id',
  /** column name */
  Id = 'id',
  /** column name */
  InternalId = 'internal_id',
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  ReceiverId = 'receiver_id',
  /** column name */
  RequestPurpose = 'request_purpose',
  /** column name */
  RequestType = 'request_type',
  /** column name */
  RequestedDatetime = 'requested_datetime',
  /** column name */
  RequesterId = 'requester_id',
  /** column name */
  SmvnPercentageForApproval = 'smvn_percentage_for_approval',
  /** column name */
  SmvnRequiredForApproval = 'smvn_required_for_approval',
  /** column name */
  SnapshotSmvnTotalSupply = 'snapshot_smvn_total_supply',
  /** column name */
  Status = 'status',
  /** column name */
  TokenAmount = 'token_amount',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  TreasuryId = 'treasury_id',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** select "governance_financial_request_aggregate_bool_exp_avg_arguments_columns" columns of table "governance_financial_request" */
export enum Governance_Financial_Request_Select_Column_Governance_Financial_Request_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  SmvnRequiredForApproval = 'smvn_required_for_approval',
  /** column name */
  SnapshotSmvnTotalSupply = 'snapshot_smvn_total_supply',
  /** column name */
  TokenAmount = 'token_amount',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** select "governance_financial_request_aggregate_bool_exp_bool_and_arguments_columns" columns of table "governance_financial_request" */
export enum Governance_Financial_Request_Select_Column_Governance_Financial_Request_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Executed = 'executed'
}

/** select "governance_financial_request_aggregate_bool_exp_bool_or_arguments_columns" columns of table "governance_financial_request" */
export enum Governance_Financial_Request_Select_Column_Governance_Financial_Request_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Executed = 'executed'
}

/** select "governance_financial_request_aggregate_bool_exp_corr_arguments_columns" columns of table "governance_financial_request" */
export enum Governance_Financial_Request_Select_Column_Governance_Financial_Request_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  SmvnRequiredForApproval = 'smvn_required_for_approval',
  /** column name */
  SnapshotSmvnTotalSupply = 'snapshot_smvn_total_supply',
  /** column name */
  TokenAmount = 'token_amount',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** select "governance_financial_request_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "governance_financial_request" */
export enum Governance_Financial_Request_Select_Column_Governance_Financial_Request_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  SmvnRequiredForApproval = 'smvn_required_for_approval',
  /** column name */
  SnapshotSmvnTotalSupply = 'snapshot_smvn_total_supply',
  /** column name */
  TokenAmount = 'token_amount',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** select "governance_financial_request_aggregate_bool_exp_max_arguments_columns" columns of table "governance_financial_request" */
export enum Governance_Financial_Request_Select_Column_Governance_Financial_Request_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  SmvnRequiredForApproval = 'smvn_required_for_approval',
  /** column name */
  SnapshotSmvnTotalSupply = 'snapshot_smvn_total_supply',
  /** column name */
  TokenAmount = 'token_amount',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** select "governance_financial_request_aggregate_bool_exp_min_arguments_columns" columns of table "governance_financial_request" */
export enum Governance_Financial_Request_Select_Column_Governance_Financial_Request_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  SmvnRequiredForApproval = 'smvn_required_for_approval',
  /** column name */
  SnapshotSmvnTotalSupply = 'snapshot_smvn_total_supply',
  /** column name */
  TokenAmount = 'token_amount',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** select "governance_financial_request_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "governance_financial_request" */
export enum Governance_Financial_Request_Select_Column_Governance_Financial_Request_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  SmvnRequiredForApproval = 'smvn_required_for_approval',
  /** column name */
  SnapshotSmvnTotalSupply = 'snapshot_smvn_total_supply',
  /** column name */
  TokenAmount = 'token_amount',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** select "governance_financial_request_aggregate_bool_exp_sum_arguments_columns" columns of table "governance_financial_request" */
export enum Governance_Financial_Request_Select_Column_Governance_Financial_Request_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  SmvnRequiredForApproval = 'smvn_required_for_approval',
  /** column name */
  SnapshotSmvnTotalSupply = 'snapshot_smvn_total_supply',
  /** column name */
  TokenAmount = 'token_amount',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** select "governance_financial_request_aggregate_bool_exp_var_samp_arguments_columns" columns of table "governance_financial_request" */
export enum Governance_Financial_Request_Select_Column_Governance_Financial_Request_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  SmvnRequiredForApproval = 'smvn_required_for_approval',
  /** column name */
  SnapshotSmvnTotalSupply = 'snapshot_smvn_total_supply',
  /** column name */
  TokenAmount = 'token_amount',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** aggregate stddev on columns */
export type Governance_Financial_Request_Stddev_Fields = {
  __typename?: 'governance_financial_request_stddev_fields';
  governance_cycle_id?: Maybe<Scalars['Float']['output']>;
  governance_financial_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  receiver_id?: Maybe<Scalars['Float']['output']>;
  requester_id?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_for_approval?: Maybe<Scalars['Float']['output']>;
  smvn_required_for_approval?: Maybe<Scalars['Float']['output']>;
  snapshot_smvn_total_supply?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['Float']['output']>;
  token_amount?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  treasury_id?: Maybe<Scalars['Float']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_financial_request" */
export type Governance_Financial_Request_Stddev_Order_By = {
  governance_cycle_id?: InputMaybe<Order_By>;
  governance_financial_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  requester_id?: InputMaybe<Order_By>;
  smvn_percentage_for_approval?: InputMaybe<Order_By>;
  smvn_required_for_approval?: InputMaybe<Order_By>;
  snapshot_smvn_total_supply?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  token_amount?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_Financial_Request_Stddev_Pop_Fields = {
  __typename?: 'governance_financial_request_stddev_pop_fields';
  governance_cycle_id?: Maybe<Scalars['Float']['output']>;
  governance_financial_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  receiver_id?: Maybe<Scalars['Float']['output']>;
  requester_id?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_for_approval?: Maybe<Scalars['Float']['output']>;
  smvn_required_for_approval?: Maybe<Scalars['Float']['output']>;
  snapshot_smvn_total_supply?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['Float']['output']>;
  token_amount?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  treasury_id?: Maybe<Scalars['Float']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_financial_request" */
export type Governance_Financial_Request_Stddev_Pop_Order_By = {
  governance_cycle_id?: InputMaybe<Order_By>;
  governance_financial_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  requester_id?: InputMaybe<Order_By>;
  smvn_percentage_for_approval?: InputMaybe<Order_By>;
  smvn_required_for_approval?: InputMaybe<Order_By>;
  snapshot_smvn_total_supply?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  token_amount?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_Financial_Request_Stddev_Samp_Fields = {
  __typename?: 'governance_financial_request_stddev_samp_fields';
  governance_cycle_id?: Maybe<Scalars['Float']['output']>;
  governance_financial_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  receiver_id?: Maybe<Scalars['Float']['output']>;
  requester_id?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_for_approval?: Maybe<Scalars['Float']['output']>;
  smvn_required_for_approval?: Maybe<Scalars['Float']['output']>;
  snapshot_smvn_total_supply?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['Float']['output']>;
  token_amount?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  treasury_id?: Maybe<Scalars['Float']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_financial_request" */
export type Governance_Financial_Request_Stddev_Samp_Order_By = {
  governance_cycle_id?: InputMaybe<Order_By>;
  governance_financial_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  requester_id?: InputMaybe<Order_By>;
  smvn_percentage_for_approval?: InputMaybe<Order_By>;
  smvn_required_for_approval?: InputMaybe<Order_By>;
  snapshot_smvn_total_supply?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  token_amount?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_financial_request" */
export type Governance_Financial_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Financial_Request_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Financial_Request_Stream_Cursor_Value_Input = {
  dropped_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  executed?: InputMaybe<Scalars['Boolean']['input']>;
  execution_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  expiration_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  governance_cycle_id?: InputMaybe<Scalars['bigint']['input']>;
  governance_financial_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  internal_id?: InputMaybe<Scalars['bigint']['input']>;
  nay_vote_smvn_total?: InputMaybe<Scalars['float8']['input']>;
  pass_vote_smvn_total?: InputMaybe<Scalars['float8']['input']>;
  receiver_id?: InputMaybe<Scalars['bigint']['input']>;
  request_purpose?: InputMaybe<Scalars['String']['input']>;
  request_type?: InputMaybe<Scalars['String']['input']>;
  requested_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  requester_id?: InputMaybe<Scalars['bigint']['input']>;
  smvn_percentage_for_approval?: InputMaybe<Scalars['smallint']['input']>;
  smvn_required_for_approval?: InputMaybe<Scalars['float8']['input']>;
  snapshot_smvn_total_supply?: InputMaybe<Scalars['float8']['input']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Scalars['smallint']['input']>;
  token_amount?: InputMaybe<Scalars['float8']['input']>;
  token_id?: InputMaybe<Scalars['bigint']['input']>;
  treasury_id?: InputMaybe<Scalars['bigint']['input']>;
  yay_vote_smvn_total?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type Governance_Financial_Request_Sum_Fields = {
  __typename?: 'governance_financial_request_sum_fields';
  governance_cycle_id?: Maybe<Scalars['bigint']['output']>;
  governance_financial_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['bigint']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
  receiver_id?: Maybe<Scalars['bigint']['output']>;
  requester_id?: Maybe<Scalars['bigint']['output']>;
  smvn_percentage_for_approval?: Maybe<Scalars['smallint']['output']>;
  smvn_required_for_approval?: Maybe<Scalars['float8']['output']>;
  snapshot_smvn_total_supply?: Maybe<Scalars['float8']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['smallint']['output']>;
  token_amount?: Maybe<Scalars['float8']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  treasury_id?: Maybe<Scalars['bigint']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "governance_financial_request" */
export type Governance_Financial_Request_Sum_Order_By = {
  governance_cycle_id?: InputMaybe<Order_By>;
  governance_financial_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  requester_id?: InputMaybe<Order_By>;
  smvn_percentage_for_approval?: InputMaybe<Order_By>;
  smvn_required_for_approval?: InputMaybe<Order_By>;
  snapshot_smvn_total_supply?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  token_amount?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_Financial_Request_Var_Pop_Fields = {
  __typename?: 'governance_financial_request_var_pop_fields';
  governance_cycle_id?: Maybe<Scalars['Float']['output']>;
  governance_financial_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  receiver_id?: Maybe<Scalars['Float']['output']>;
  requester_id?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_for_approval?: Maybe<Scalars['Float']['output']>;
  smvn_required_for_approval?: Maybe<Scalars['Float']['output']>;
  snapshot_smvn_total_supply?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['Float']['output']>;
  token_amount?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  treasury_id?: Maybe<Scalars['Float']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_financial_request" */
export type Governance_Financial_Request_Var_Pop_Order_By = {
  governance_cycle_id?: InputMaybe<Order_By>;
  governance_financial_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  requester_id?: InputMaybe<Order_By>;
  smvn_percentage_for_approval?: InputMaybe<Order_By>;
  smvn_required_for_approval?: InputMaybe<Order_By>;
  snapshot_smvn_total_supply?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  token_amount?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_Financial_Request_Var_Samp_Fields = {
  __typename?: 'governance_financial_request_var_samp_fields';
  governance_cycle_id?: Maybe<Scalars['Float']['output']>;
  governance_financial_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  receiver_id?: Maybe<Scalars['Float']['output']>;
  requester_id?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_for_approval?: Maybe<Scalars['Float']['output']>;
  smvn_required_for_approval?: Maybe<Scalars['Float']['output']>;
  snapshot_smvn_total_supply?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['Float']['output']>;
  token_amount?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  treasury_id?: Maybe<Scalars['Float']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_financial_request" */
export type Governance_Financial_Request_Var_Samp_Order_By = {
  governance_cycle_id?: InputMaybe<Order_By>;
  governance_financial_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  requester_id?: InputMaybe<Order_By>;
  smvn_percentage_for_approval?: InputMaybe<Order_By>;
  smvn_required_for_approval?: InputMaybe<Order_By>;
  snapshot_smvn_total_supply?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  token_amount?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_Financial_Request_Variance_Fields = {
  __typename?: 'governance_financial_request_variance_fields';
  governance_cycle_id?: Maybe<Scalars['Float']['output']>;
  governance_financial_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  receiver_id?: Maybe<Scalars['Float']['output']>;
  requester_id?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_for_approval?: Maybe<Scalars['Float']['output']>;
  smvn_required_for_approval?: Maybe<Scalars['Float']['output']>;
  snapshot_smvn_total_supply?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['Float']['output']>;
  token_amount?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  treasury_id?: Maybe<Scalars['Float']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_financial_request" */
export type Governance_Financial_Request_Variance_Order_By = {
  governance_cycle_id?: InputMaybe<Order_By>;
  governance_financial_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  requester_id?: InputMaybe<Order_By>;
  smvn_percentage_for_approval?: InputMaybe<Order_By>;
  smvn_required_for_approval?: InputMaybe<Order_By>;
  snapshot_smvn_total_supply?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  token_amount?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** columns and relationships of "governance_financial_request_vote" */
export type Governance_Financial_Request_Vote = {
  __typename?: 'governance_financial_request_vote';
  /** An object relationship */
  governance_financial_request: Governance_Financial_Request;
  governance_financial_request_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  satellite_snapshot: Governance_Satellite_Snapshot;
  satellite_snapshot_id: Scalars['bigint']['output'];
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote: Scalars['smallint']['output'];
  /** An object relationship */
  voter: Maven_User;
  voter_id: Scalars['bigint']['output'];
};

/** aggregated selection of "governance_financial_request_vote" */
export type Governance_Financial_Request_Vote_Aggregate = {
  __typename?: 'governance_financial_request_vote_aggregate';
  aggregate?: Maybe<Governance_Financial_Request_Vote_Aggregate_Fields>;
  nodes: Array<Governance_Financial_Request_Vote>;
};

export type Governance_Financial_Request_Vote_Aggregate_Bool_Exp = {
  count?: InputMaybe<Governance_Financial_Request_Vote_Aggregate_Bool_Exp_Count>;
};

export type Governance_Financial_Request_Vote_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_Financial_Request_Vote_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Financial_Request_Vote_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "governance_financial_request_vote" */
export type Governance_Financial_Request_Vote_Aggregate_Fields = {
  __typename?: 'governance_financial_request_vote_aggregate_fields';
  avg?: Maybe<Governance_Financial_Request_Vote_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Financial_Request_Vote_Max_Fields>;
  min?: Maybe<Governance_Financial_Request_Vote_Min_Fields>;
  stddev?: Maybe<Governance_Financial_Request_Vote_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Financial_Request_Vote_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Financial_Request_Vote_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Financial_Request_Vote_Sum_Fields>;
  var_pop?: Maybe<Governance_Financial_Request_Vote_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Financial_Request_Vote_Var_Samp_Fields>;
  variance?: Maybe<Governance_Financial_Request_Vote_Variance_Fields>;
};


/** aggregate fields of "governance_financial_request_vote" */
export type Governance_Financial_Request_Vote_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Financial_Request_Vote_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_financial_request_vote" */
export type Governance_Financial_Request_Vote_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_Financial_Request_Vote_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_Financial_Request_Vote_Max_Order_By>;
  min?: InputMaybe<Governance_Financial_Request_Vote_Min_Order_By>;
  stddev?: InputMaybe<Governance_Financial_Request_Vote_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_Financial_Request_Vote_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_Financial_Request_Vote_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_Financial_Request_Vote_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_Financial_Request_Vote_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_Financial_Request_Vote_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_Financial_Request_Vote_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Governance_Financial_Request_Vote_Avg_Fields = {
  __typename?: 'governance_financial_request_vote_avg_fields';
  governance_financial_request_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_financial_request_vote" */
export type Governance_Financial_Request_Vote_Avg_Order_By = {
  governance_financial_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_snapshot_id?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_financial_request_vote". All fields are combined with a logical 'AND'. */
export type Governance_Financial_Request_Vote_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Financial_Request_Vote_Bool_Exp>>;
  _not?: InputMaybe<Governance_Financial_Request_Vote_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Financial_Request_Vote_Bool_Exp>>;
  governance_financial_request?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
  governance_financial_request_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  satellite_snapshot?: InputMaybe<Governance_Satellite_Snapshot_Bool_Exp>;
  satellite_snapshot_id?: InputMaybe<Bigint_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  vote?: InputMaybe<Smallint_Comparison_Exp>;
  voter?: InputMaybe<Maven_User_Bool_Exp>;
  voter_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Governance_Financial_Request_Vote_Max_Fields = {
  __typename?: 'governance_financial_request_vote_max_fields';
  governance_financial_request_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  satellite_snapshot_id?: Maybe<Scalars['bigint']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['smallint']['output']>;
  voter_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "governance_financial_request_vote" */
export type Governance_Financial_Request_Vote_Max_Order_By = {
  governance_financial_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_snapshot_id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_Financial_Request_Vote_Min_Fields = {
  __typename?: 'governance_financial_request_vote_min_fields';
  governance_financial_request_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  satellite_snapshot_id?: Maybe<Scalars['bigint']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['smallint']['output']>;
  voter_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "governance_financial_request_vote" */
export type Governance_Financial_Request_Vote_Min_Order_By = {
  governance_financial_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_snapshot_id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_financial_request_vote". */
export type Governance_Financial_Request_Vote_Order_By = {
  governance_financial_request?: InputMaybe<Governance_Financial_Request_Order_By>;
  governance_financial_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_snapshot?: InputMaybe<Governance_Satellite_Snapshot_Order_By>;
  satellite_snapshot_id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  vote?: InputMaybe<Order_By>;
  voter?: InputMaybe<Maven_User_Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** select columns of table "governance_financial_request_vote" */
export enum Governance_Financial_Request_Vote_Select_Column {
  /** column name */
  GovernanceFinancialRequestId = 'governance_financial_request_id',
  /** column name */
  Id = 'id',
  /** column name */
  SatelliteSnapshotId = 'satellite_snapshot_id',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Vote = 'vote',
  /** column name */
  VoterId = 'voter_id'
}

/** aggregate stddev on columns */
export type Governance_Financial_Request_Vote_Stddev_Fields = {
  __typename?: 'governance_financial_request_vote_stddev_fields';
  governance_financial_request_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_financial_request_vote" */
export type Governance_Financial_Request_Vote_Stddev_Order_By = {
  governance_financial_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_snapshot_id?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_Financial_Request_Vote_Stddev_Pop_Fields = {
  __typename?: 'governance_financial_request_vote_stddev_pop_fields';
  governance_financial_request_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_financial_request_vote" */
export type Governance_Financial_Request_Vote_Stddev_Pop_Order_By = {
  governance_financial_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_snapshot_id?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_Financial_Request_Vote_Stddev_Samp_Fields = {
  __typename?: 'governance_financial_request_vote_stddev_samp_fields';
  governance_financial_request_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_financial_request_vote" */
export type Governance_Financial_Request_Vote_Stddev_Samp_Order_By = {
  governance_financial_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_snapshot_id?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_financial_request_vote" */
export type Governance_Financial_Request_Vote_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Financial_Request_Vote_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Financial_Request_Vote_Stream_Cursor_Value_Input = {
  governance_financial_request_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  satellite_snapshot_id?: InputMaybe<Scalars['bigint']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Scalars['smallint']['input']>;
  voter_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Governance_Financial_Request_Vote_Sum_Fields = {
  __typename?: 'governance_financial_request_vote_sum_fields';
  governance_financial_request_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  satellite_snapshot_id?: Maybe<Scalars['bigint']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['smallint']['output']>;
  voter_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "governance_financial_request_vote" */
export type Governance_Financial_Request_Vote_Sum_Order_By = {
  governance_financial_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_snapshot_id?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_Financial_Request_Vote_Var_Pop_Fields = {
  __typename?: 'governance_financial_request_vote_var_pop_fields';
  governance_financial_request_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_financial_request_vote" */
export type Governance_Financial_Request_Vote_Var_Pop_Order_By = {
  governance_financial_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_snapshot_id?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_Financial_Request_Vote_Var_Samp_Fields = {
  __typename?: 'governance_financial_request_vote_var_samp_fields';
  governance_financial_request_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_financial_request_vote" */
export type Governance_Financial_Request_Vote_Var_Samp_Order_By = {
  governance_financial_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_snapshot_id?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_Financial_Request_Vote_Variance_Fields = {
  __typename?: 'governance_financial_request_vote_variance_fields';
  governance_financial_request_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_financial_request_vote" */
export type Governance_Financial_Request_Vote_Variance_Order_By = {
  governance_financial_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_snapshot_id?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** select columns of table "governance_financial" */
export enum Governance_Financial_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Admin = 'admin',
  /** column name */
  ApprovalPercentage = 'approval_percentage',
  /** column name */
  FinReqCounter = 'fin_req_counter',
  /** column name */
  FinReqDurationInDays = 'fin_req_duration_in_days',
  /** column name */
  GovernanceId = 'governance_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Network = 'network'
}

/** aggregate stddev on columns */
export type Governance_Financial_Stddev_Fields = {
  __typename?: 'governance_financial_stddev_fields';
  approval_percentage?: Maybe<Scalars['Float']['output']>;
  fin_req_counter?: Maybe<Scalars['Float']['output']>;
  fin_req_duration_in_days?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_financial" */
export type Governance_Financial_Stddev_Order_By = {
  approval_percentage?: InputMaybe<Order_By>;
  fin_req_counter?: InputMaybe<Order_By>;
  fin_req_duration_in_days?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_Financial_Stddev_Pop_Fields = {
  __typename?: 'governance_financial_stddev_pop_fields';
  approval_percentage?: Maybe<Scalars['Float']['output']>;
  fin_req_counter?: Maybe<Scalars['Float']['output']>;
  fin_req_duration_in_days?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_financial" */
export type Governance_Financial_Stddev_Pop_Order_By = {
  approval_percentage?: InputMaybe<Order_By>;
  fin_req_counter?: InputMaybe<Order_By>;
  fin_req_duration_in_days?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_Financial_Stddev_Samp_Fields = {
  __typename?: 'governance_financial_stddev_samp_fields';
  approval_percentage?: Maybe<Scalars['Float']['output']>;
  fin_req_counter?: Maybe<Scalars['Float']['output']>;
  fin_req_duration_in_days?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_financial" */
export type Governance_Financial_Stddev_Samp_Order_By = {
  approval_percentage?: InputMaybe<Order_By>;
  fin_req_counter?: InputMaybe<Order_By>;
  fin_req_duration_in_days?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_financial" */
export type Governance_Financial_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Financial_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Financial_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['String']['input']>;
  approval_percentage?: InputMaybe<Scalars['smallint']['input']>;
  fin_req_counter?: InputMaybe<Scalars['bigint']['input']>;
  fin_req_duration_in_days?: InputMaybe<Scalars['smallint']['input']>;
  governance_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Governance_Financial_Sum_Fields = {
  __typename?: 'governance_financial_sum_fields';
  approval_percentage?: Maybe<Scalars['smallint']['output']>;
  fin_req_counter?: Maybe<Scalars['bigint']['output']>;
  fin_req_duration_in_days?: Maybe<Scalars['smallint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "governance_financial" */
export type Governance_Financial_Sum_Order_By = {
  approval_percentage?: InputMaybe<Order_By>;
  fin_req_counter?: InputMaybe<Order_By>;
  fin_req_duration_in_days?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_Financial_Var_Pop_Fields = {
  __typename?: 'governance_financial_var_pop_fields';
  approval_percentage?: Maybe<Scalars['Float']['output']>;
  fin_req_counter?: Maybe<Scalars['Float']['output']>;
  fin_req_duration_in_days?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_financial" */
export type Governance_Financial_Var_Pop_Order_By = {
  approval_percentage?: InputMaybe<Order_By>;
  fin_req_counter?: InputMaybe<Order_By>;
  fin_req_duration_in_days?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_Financial_Var_Samp_Fields = {
  __typename?: 'governance_financial_var_samp_fields';
  approval_percentage?: Maybe<Scalars['Float']['output']>;
  fin_req_counter?: Maybe<Scalars['Float']['output']>;
  fin_req_duration_in_days?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_financial" */
export type Governance_Financial_Var_Samp_Order_By = {
  approval_percentage?: InputMaybe<Order_By>;
  fin_req_counter?: InputMaybe<Order_By>;
  fin_req_duration_in_days?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_Financial_Variance_Fields = {
  __typename?: 'governance_financial_variance_fields';
  approval_percentage?: Maybe<Scalars['Float']['output']>;
  fin_req_counter?: Maybe<Scalars['Float']['output']>;
  fin_req_duration_in_days?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_financial" */
export type Governance_Financial_Variance_Order_By = {
  approval_percentage?: InputMaybe<Order_By>;
  fin_req_counter?: InputMaybe<Order_By>;
  fin_req_duration_in_days?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "governance_financial_whitelist_contract" */
export type Governance_Financial_Whitelist_Contract = {
  __typename?: 'governance_financial_whitelist_contract';
  /** An object relationship */
  contract: Governance_Financial;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "governance_financial_whitelist_contract" */
export type Governance_Financial_Whitelist_Contract_Aggregate = {
  __typename?: 'governance_financial_whitelist_contract_aggregate';
  aggregate?: Maybe<Governance_Financial_Whitelist_Contract_Aggregate_Fields>;
  nodes: Array<Governance_Financial_Whitelist_Contract>;
};

export type Governance_Financial_Whitelist_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Governance_Financial_Whitelist_Contract_Aggregate_Bool_Exp_Count>;
};

export type Governance_Financial_Whitelist_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_Financial_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Financial_Whitelist_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "governance_financial_whitelist_contract" */
export type Governance_Financial_Whitelist_Contract_Aggregate_Fields = {
  __typename?: 'governance_financial_whitelist_contract_aggregate_fields';
  avg?: Maybe<Governance_Financial_Whitelist_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Financial_Whitelist_Contract_Max_Fields>;
  min?: Maybe<Governance_Financial_Whitelist_Contract_Min_Fields>;
  stddev?: Maybe<Governance_Financial_Whitelist_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Financial_Whitelist_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Financial_Whitelist_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Financial_Whitelist_Contract_Sum_Fields>;
  var_pop?: Maybe<Governance_Financial_Whitelist_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Financial_Whitelist_Contract_Var_Samp_Fields>;
  variance?: Maybe<Governance_Financial_Whitelist_Contract_Variance_Fields>;
};


/** aggregate fields of "governance_financial_whitelist_contract" */
export type Governance_Financial_Whitelist_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Financial_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_financial_whitelist_contract" */
export type Governance_Financial_Whitelist_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_Financial_Whitelist_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_Financial_Whitelist_Contract_Max_Order_By>;
  min?: InputMaybe<Governance_Financial_Whitelist_Contract_Min_Order_By>;
  stddev?: InputMaybe<Governance_Financial_Whitelist_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_Financial_Whitelist_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_Financial_Whitelist_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_Financial_Whitelist_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_Financial_Whitelist_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_Financial_Whitelist_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_Financial_Whitelist_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Governance_Financial_Whitelist_Contract_Avg_Fields = {
  __typename?: 'governance_financial_whitelist_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_financial_whitelist_contract" */
export type Governance_Financial_Whitelist_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_financial_whitelist_contract". All fields are combined with a logical 'AND'. */
export type Governance_Financial_Whitelist_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Financial_Whitelist_Contract_Bool_Exp>>;
  _not?: InputMaybe<Governance_Financial_Whitelist_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Financial_Whitelist_Contract_Bool_Exp>>;
  contract?: InputMaybe<Governance_Financial_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Governance_Financial_Whitelist_Contract_Max_Fields = {
  __typename?: 'governance_financial_whitelist_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "governance_financial_whitelist_contract" */
export type Governance_Financial_Whitelist_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_Financial_Whitelist_Contract_Min_Fields = {
  __typename?: 'governance_financial_whitelist_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "governance_financial_whitelist_contract" */
export type Governance_Financial_Whitelist_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_financial_whitelist_contract". */
export type Governance_Financial_Whitelist_Contract_Order_By = {
  contract?: InputMaybe<Governance_Financial_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "governance_financial_whitelist_contract" */
export enum Governance_Financial_Whitelist_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Governance_Financial_Whitelist_Contract_Stddev_Fields = {
  __typename?: 'governance_financial_whitelist_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_financial_whitelist_contract" */
export type Governance_Financial_Whitelist_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_Financial_Whitelist_Contract_Stddev_Pop_Fields = {
  __typename?: 'governance_financial_whitelist_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_financial_whitelist_contract" */
export type Governance_Financial_Whitelist_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_Financial_Whitelist_Contract_Stddev_Samp_Fields = {
  __typename?: 'governance_financial_whitelist_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_financial_whitelist_contract" */
export type Governance_Financial_Whitelist_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_financial_whitelist_contract" */
export type Governance_Financial_Whitelist_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Financial_Whitelist_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Financial_Whitelist_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Governance_Financial_Whitelist_Contract_Sum_Fields = {
  __typename?: 'governance_financial_whitelist_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "governance_financial_whitelist_contract" */
export type Governance_Financial_Whitelist_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_Financial_Whitelist_Contract_Var_Pop_Fields = {
  __typename?: 'governance_financial_whitelist_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_financial_whitelist_contract" */
export type Governance_Financial_Whitelist_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_Financial_Whitelist_Contract_Var_Samp_Fields = {
  __typename?: 'governance_financial_whitelist_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_financial_whitelist_contract" */
export type Governance_Financial_Whitelist_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_Financial_Whitelist_Contract_Variance_Fields = {
  __typename?: 'governance_financial_whitelist_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_financial_whitelist_contract" */
export type Governance_Financial_Whitelist_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "governance_financial_whitelist_token_contract" */
export type Governance_Financial_Whitelist_Token_Contract = {
  __typename?: 'governance_financial_whitelist_token_contract';
  /** An object relationship */
  contract: Governance_Financial;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  token: Token;
  token_id: Scalars['bigint']['output'];
};

/** aggregated selection of "governance_financial_whitelist_token_contract" */
export type Governance_Financial_Whitelist_Token_Contract_Aggregate = {
  __typename?: 'governance_financial_whitelist_token_contract_aggregate';
  aggregate?: Maybe<Governance_Financial_Whitelist_Token_Contract_Aggregate_Fields>;
  nodes: Array<Governance_Financial_Whitelist_Token_Contract>;
};

export type Governance_Financial_Whitelist_Token_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Aggregate_Bool_Exp_Count>;
};

export type Governance_Financial_Whitelist_Token_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_Financial_Whitelist_Token_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "governance_financial_whitelist_token_contract" */
export type Governance_Financial_Whitelist_Token_Contract_Aggregate_Fields = {
  __typename?: 'governance_financial_whitelist_token_contract_aggregate_fields';
  avg?: Maybe<Governance_Financial_Whitelist_Token_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Financial_Whitelist_Token_Contract_Max_Fields>;
  min?: Maybe<Governance_Financial_Whitelist_Token_Contract_Min_Fields>;
  stddev?: Maybe<Governance_Financial_Whitelist_Token_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Financial_Whitelist_Token_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Financial_Whitelist_Token_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Financial_Whitelist_Token_Contract_Sum_Fields>;
  var_pop?: Maybe<Governance_Financial_Whitelist_Token_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Financial_Whitelist_Token_Contract_Var_Samp_Fields>;
  variance?: Maybe<Governance_Financial_Whitelist_Token_Contract_Variance_Fields>;
};


/** aggregate fields of "governance_financial_whitelist_token_contract" */
export type Governance_Financial_Whitelist_Token_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Financial_Whitelist_Token_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_financial_whitelist_token_contract" */
export type Governance_Financial_Whitelist_Token_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Max_Order_By>;
  min?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Min_Order_By>;
  stddev?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Governance_Financial_Whitelist_Token_Contract_Avg_Fields = {
  __typename?: 'governance_financial_whitelist_token_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_financial_whitelist_token_contract" */
export type Governance_Financial_Whitelist_Token_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_financial_whitelist_token_contract". All fields are combined with a logical 'AND'. */
export type Governance_Financial_Whitelist_Token_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Financial_Whitelist_Token_Contract_Bool_Exp>>;
  _not?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Financial_Whitelist_Token_Contract_Bool_Exp>>;
  contract?: InputMaybe<Governance_Financial_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  token?: InputMaybe<Token_Bool_Exp>;
  token_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Governance_Financial_Whitelist_Token_Contract_Max_Fields = {
  __typename?: 'governance_financial_whitelist_token_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "governance_financial_whitelist_token_contract" */
export type Governance_Financial_Whitelist_Token_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_Financial_Whitelist_Token_Contract_Min_Fields = {
  __typename?: 'governance_financial_whitelist_token_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "governance_financial_whitelist_token_contract" */
export type Governance_Financial_Whitelist_Token_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_financial_whitelist_token_contract". */
export type Governance_Financial_Whitelist_Token_Contract_Order_By = {
  contract?: InputMaybe<Governance_Financial_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token?: InputMaybe<Token_Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** select columns of table "governance_financial_whitelist_token_contract" */
export enum Governance_Financial_Whitelist_Token_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  TokenId = 'token_id'
}

/** aggregate stddev on columns */
export type Governance_Financial_Whitelist_Token_Contract_Stddev_Fields = {
  __typename?: 'governance_financial_whitelist_token_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_financial_whitelist_token_contract" */
export type Governance_Financial_Whitelist_Token_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_Financial_Whitelist_Token_Contract_Stddev_Pop_Fields = {
  __typename?: 'governance_financial_whitelist_token_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_financial_whitelist_token_contract" */
export type Governance_Financial_Whitelist_Token_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_Financial_Whitelist_Token_Contract_Stddev_Samp_Fields = {
  __typename?: 'governance_financial_whitelist_token_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_financial_whitelist_token_contract" */
export type Governance_Financial_Whitelist_Token_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_financial_whitelist_token_contract" */
export type Governance_Financial_Whitelist_Token_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Financial_Whitelist_Token_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Financial_Whitelist_Token_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  token_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Governance_Financial_Whitelist_Token_Contract_Sum_Fields = {
  __typename?: 'governance_financial_whitelist_token_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "governance_financial_whitelist_token_contract" */
export type Governance_Financial_Whitelist_Token_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_Financial_Whitelist_Token_Contract_Var_Pop_Fields = {
  __typename?: 'governance_financial_whitelist_token_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_financial_whitelist_token_contract" */
export type Governance_Financial_Whitelist_Token_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_Financial_Whitelist_Token_Contract_Var_Samp_Fields = {
  __typename?: 'governance_financial_whitelist_token_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_financial_whitelist_token_contract" */
export type Governance_Financial_Whitelist_Token_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_Financial_Whitelist_Token_Contract_Variance_Fields = {
  __typename?: 'governance_financial_whitelist_token_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_financial_whitelist_token_contract" */
export type Governance_Financial_Whitelist_Token_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "governance_general_contract" */
export type Governance_General_Contract = {
  __typename?: 'governance_general_contract';
  /** An object relationship */
  contract: Governance;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  contract_name: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "governance_general_contract" */
export type Governance_General_Contract_Aggregate = {
  __typename?: 'governance_general_contract_aggregate';
  aggregate?: Maybe<Governance_General_Contract_Aggregate_Fields>;
  nodes: Array<Governance_General_Contract>;
};

export type Governance_General_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Governance_General_Contract_Aggregate_Bool_Exp_Count>;
};

export type Governance_General_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_General_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "governance_general_contract" */
export type Governance_General_Contract_Aggregate_Fields = {
  __typename?: 'governance_general_contract_aggregate_fields';
  avg?: Maybe<Governance_General_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_General_Contract_Max_Fields>;
  min?: Maybe<Governance_General_Contract_Min_Fields>;
  stddev?: Maybe<Governance_General_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_General_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_General_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_General_Contract_Sum_Fields>;
  var_pop?: Maybe<Governance_General_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_General_Contract_Var_Samp_Fields>;
  variance?: Maybe<Governance_General_Contract_Variance_Fields>;
};


/** aggregate fields of "governance_general_contract" */
export type Governance_General_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_general_contract" */
export type Governance_General_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_General_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_General_Contract_Max_Order_By>;
  min?: InputMaybe<Governance_General_Contract_Min_Order_By>;
  stddev?: InputMaybe<Governance_General_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_General_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_General_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_General_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_General_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_General_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_General_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Governance_General_Contract_Avg_Fields = {
  __typename?: 'governance_general_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_general_contract" */
export type Governance_General_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_general_contract". All fields are combined with a logical 'AND'. */
export type Governance_General_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_General_Contract_Bool_Exp>>;
  _not?: InputMaybe<Governance_General_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_General_Contract_Bool_Exp>>;
  contract?: InputMaybe<Governance_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  contract_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Governance_General_Contract_Max_Fields = {
  __typename?: 'governance_general_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "governance_general_contract" */
export type Governance_General_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_General_Contract_Min_Fields = {
  __typename?: 'governance_general_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "governance_general_contract" */
export type Governance_General_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_general_contract". */
export type Governance_General_Contract_Order_By = {
  contract?: InputMaybe<Governance_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "governance_general_contract" */
export enum Governance_General_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  ContractName = 'contract_name',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Governance_General_Contract_Stddev_Fields = {
  __typename?: 'governance_general_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_general_contract" */
export type Governance_General_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_General_Contract_Stddev_Pop_Fields = {
  __typename?: 'governance_general_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_general_contract" */
export type Governance_General_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_General_Contract_Stddev_Samp_Fields = {
  __typename?: 'governance_general_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_general_contract" */
export type Governance_General_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_general_contract" */
export type Governance_General_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_General_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_General_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  contract_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Governance_General_Contract_Sum_Fields = {
  __typename?: 'governance_general_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "governance_general_contract" */
export type Governance_General_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_General_Contract_Var_Pop_Fields = {
  __typename?: 'governance_general_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_general_contract" */
export type Governance_General_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_General_Contract_Var_Samp_Fields = {
  __typename?: 'governance_general_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_general_contract" */
export type Governance_General_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_General_Contract_Variance_Fields = {
  __typename?: 'governance_general_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_general_contract" */
export type Governance_General_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "governance_lambda" */
export type Governance_Lambda = {
  __typename?: 'governance_lambda';
  /** An object relationship */
  contract: Governance;
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lambda_bytes: Scalars['String']['output'];
  lambda_name: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "governance_lambda" */
export type Governance_Lambda_Aggregate = {
  __typename?: 'governance_lambda_aggregate';
  aggregate?: Maybe<Governance_Lambda_Aggregate_Fields>;
  nodes: Array<Governance_Lambda>;
};

export type Governance_Lambda_Aggregate_Bool_Exp = {
  count?: InputMaybe<Governance_Lambda_Aggregate_Bool_Exp_Count>;
};

export type Governance_Lambda_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Lambda_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "governance_lambda" */
export type Governance_Lambda_Aggregate_Fields = {
  __typename?: 'governance_lambda_aggregate_fields';
  avg?: Maybe<Governance_Lambda_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Lambda_Max_Fields>;
  min?: Maybe<Governance_Lambda_Min_Fields>;
  stddev?: Maybe<Governance_Lambda_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Lambda_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Lambda_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Lambda_Sum_Fields>;
  var_pop?: Maybe<Governance_Lambda_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Lambda_Var_Samp_Fields>;
  variance?: Maybe<Governance_Lambda_Variance_Fields>;
};


/** aggregate fields of "governance_lambda" */
export type Governance_Lambda_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_lambda" */
export type Governance_Lambda_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_Lambda_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_Lambda_Max_Order_By>;
  min?: InputMaybe<Governance_Lambda_Min_Order_By>;
  stddev?: InputMaybe<Governance_Lambda_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_Lambda_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_Lambda_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_Lambda_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_Lambda_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_Lambda_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_Lambda_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Governance_Lambda_Avg_Fields = {
  __typename?: 'governance_lambda_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_lambda" */
export type Governance_Lambda_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_lambda". All fields are combined with a logical 'AND'. */
export type Governance_Lambda_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Lambda_Bool_Exp>>;
  _not?: InputMaybe<Governance_Lambda_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Lambda_Bool_Exp>>;
  contract?: InputMaybe<Governance_Bool_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambda_bytes?: InputMaybe<String_Comparison_Exp>;
  lambda_name?: InputMaybe<String_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Governance_Lambda_Max_Fields = {
  __typename?: 'governance_lambda_max_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "governance_lambda" */
export type Governance_Lambda_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_Lambda_Min_Fields = {
  __typename?: 'governance_lambda_min_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "governance_lambda" */
export type Governance_Lambda_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_lambda". */
export type Governance_Lambda_Order_By = {
  contract?: InputMaybe<Governance_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "governance_lambda" */
export enum Governance_Lambda_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaBytes = 'lambda_bytes',
  /** column name */
  LambdaName = 'lambda_name',
  /** column name */
  LastUpdatedAt = 'last_updated_at'
}

/** aggregate stddev on columns */
export type Governance_Lambda_Stddev_Fields = {
  __typename?: 'governance_lambda_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_lambda" */
export type Governance_Lambda_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_Lambda_Stddev_Pop_Fields = {
  __typename?: 'governance_lambda_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_lambda" */
export type Governance_Lambda_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_Lambda_Stddev_Samp_Fields = {
  __typename?: 'governance_lambda_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_lambda" */
export type Governance_Lambda_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_lambda" */
export type Governance_Lambda_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Lambda_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Lambda_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lambda_bytes?: InputMaybe<Scalars['String']['input']>;
  lambda_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Governance_Lambda_Sum_Fields = {
  __typename?: 'governance_lambda_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "governance_lambda" */
export type Governance_Lambda_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_Lambda_Var_Pop_Fields = {
  __typename?: 'governance_lambda_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_lambda" */
export type Governance_Lambda_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_Lambda_Var_Samp_Fields = {
  __typename?: 'governance_lambda_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_lambda" */
export type Governance_Lambda_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_Lambda_Variance_Fields = {
  __typename?: 'governance_lambda_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_lambda" */
export type Governance_Lambda_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Governance_Max_Fields = {
  __typename?: 'governance_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  blocks_per_proposal_round?: Maybe<Scalars['bigint']['output']>;
  blocks_per_timelock_round?: Maybe<Scalars['bigint']['output']>;
  blocks_per_voting_round?: Maybe<Scalars['bigint']['output']>;
  current_blocks_per_proposal_round?: Maybe<Scalars['bigint']['output']>;
  current_blocks_per_timelock_round?: Maybe<Scalars['bigint']['output']>;
  current_blocks_per_voting_round?: Maybe<Scalars['bigint']['output']>;
  current_cycle_end_level?: Maybe<Scalars['bigint']['output']>;
  current_cycle_total_voters_reward?: Maybe<Scalars['float8']['output']>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  current_round?: Maybe<Scalars['smallint']['output']>;
  current_round_end_level?: Maybe<Scalars['bigint']['output']>;
  current_round_start_level?: Maybe<Scalars['bigint']['output']>;
  cycle_highest_voted_proposal_id?: Maybe<Scalars['bigint']['output']>;
  cycle_id?: Maybe<Scalars['bigint']['output']>;
  cycle_voters_reward?: Maybe<Scalars['float8']['output']>;
  governance_proxy_address?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  max_proposal_per_satellite?: Maybe<Scalars['smallint']['output']>;
  min_quorum_percentage?: Maybe<Scalars['smallint']['output']>;
  min_yay_vote_percentage?: Maybe<Scalars['smallint']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  next_proposal_id?: Maybe<Scalars['bigint']['output']>;
  proposal_description_max_length?: Maybe<Scalars['bigint']['output']>;
  proposal_invoice_max_length?: Maybe<Scalars['bigint']['output']>;
  proposal_metadata_title_max_length?: Maybe<Scalars['bigint']['output']>;
  proposal_round_vote_percentage?: Maybe<Scalars['smallint']['output']>;
  proposal_source_code_max_length?: Maybe<Scalars['bigint']['output']>;
  proposal_submission_fee_mumav?: Maybe<Scalars['bigint']['output']>;
  proposal_title_max_length?: Maybe<Scalars['bigint']['output']>;
  success_reward?: Maybe<Scalars['float8']['output']>;
  timelock_proposal_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Governance_Min_Fields = {
  __typename?: 'governance_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  blocks_per_proposal_round?: Maybe<Scalars['bigint']['output']>;
  blocks_per_timelock_round?: Maybe<Scalars['bigint']['output']>;
  blocks_per_voting_round?: Maybe<Scalars['bigint']['output']>;
  current_blocks_per_proposal_round?: Maybe<Scalars['bigint']['output']>;
  current_blocks_per_timelock_round?: Maybe<Scalars['bigint']['output']>;
  current_blocks_per_voting_round?: Maybe<Scalars['bigint']['output']>;
  current_cycle_end_level?: Maybe<Scalars['bigint']['output']>;
  current_cycle_total_voters_reward?: Maybe<Scalars['float8']['output']>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  current_round?: Maybe<Scalars['smallint']['output']>;
  current_round_end_level?: Maybe<Scalars['bigint']['output']>;
  current_round_start_level?: Maybe<Scalars['bigint']['output']>;
  cycle_highest_voted_proposal_id?: Maybe<Scalars['bigint']['output']>;
  cycle_id?: Maybe<Scalars['bigint']['output']>;
  cycle_voters_reward?: Maybe<Scalars['float8']['output']>;
  governance_proxy_address?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  max_proposal_per_satellite?: Maybe<Scalars['smallint']['output']>;
  min_quorum_percentage?: Maybe<Scalars['smallint']['output']>;
  min_yay_vote_percentage?: Maybe<Scalars['smallint']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  next_proposal_id?: Maybe<Scalars['bigint']['output']>;
  proposal_description_max_length?: Maybe<Scalars['bigint']['output']>;
  proposal_invoice_max_length?: Maybe<Scalars['bigint']['output']>;
  proposal_metadata_title_max_length?: Maybe<Scalars['bigint']['output']>;
  proposal_round_vote_percentage?: Maybe<Scalars['smallint']['output']>;
  proposal_source_code_max_length?: Maybe<Scalars['bigint']['output']>;
  proposal_submission_fee_mumav?: Maybe<Scalars['bigint']['output']>;
  proposal_title_max_length?: Maybe<Scalars['bigint']['output']>;
  success_reward?: Maybe<Scalars['float8']['output']>;
  timelock_proposal_id?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "governance". */
export type Governance_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  aggregator_factories_aggregate?: InputMaybe<Aggregator_Factory_Aggregate_Order_By>;
  aggregators_aggregate?: InputMaybe<Aggregator_Aggregate_Order_By>;
  blocks_per_proposal_round?: InputMaybe<Order_By>;
  blocks_per_timelock_round?: InputMaybe<Order_By>;
  blocks_per_voting_round?: InputMaybe<Order_By>;
  break_glasses_aggregate?: InputMaybe<Break_Glass_Aggregate_Order_By>;
  councils_aggregate?: InputMaybe<Council_Aggregate_Order_By>;
  current_blocks_per_proposal_round?: InputMaybe<Order_By>;
  current_blocks_per_timelock_round?: InputMaybe<Order_By>;
  current_blocks_per_voting_round?: InputMaybe<Order_By>;
  current_cycle_end_level?: InputMaybe<Order_By>;
  current_cycle_total_voters_reward?: InputMaybe<Order_By>;
  current_round?: InputMaybe<Order_By>;
  current_round_end_level?: InputMaybe<Order_By>;
  current_round_start_level?: InputMaybe<Order_By>;
  cycle_highest_voted_proposal_id?: InputMaybe<Order_By>;
  cycle_id?: InputMaybe<Order_By>;
  cycle_voters_reward?: InputMaybe<Order_By>;
  delegations_aggregate?: InputMaybe<Delegation_Aggregate_Order_By>;
  doormans_aggregate?: InputMaybe<Doorman_Aggregate_Order_By>;
  emergency_governances_aggregate?: InputMaybe<Emergency_Governance_Aggregate_Order_By>;
  farm_factories_aggregate?: InputMaybe<Farm_Factory_Aggregate_Order_By>;
  farms_aggregate?: InputMaybe<Farm_Aggregate_Order_By>;
  general_contracts_aggregate?: InputMaybe<Governance_General_Contract_Aggregate_Order_By>;
  governance_financials_aggregate?: InputMaybe<Governance_Financial_Aggregate_Order_By>;
  governance_proxies_aggregate?: InputMaybe<Governance_Proxy_Aggregate_Order_By>;
  governance_proxy_address?: InputMaybe<Order_By>;
  governance_satellites_aggregate?: InputMaybe<Governance_Satellite_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  lambdas_aggregate?: InputMaybe<Governance_Lambda_Aggregate_Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  lending_controllers_aggregate?: InputMaybe<Lending_Controller_Aggregate_Order_By>;
  m_tokens_aggregate?: InputMaybe<M_Token_Aggregate_Order_By>;
  max_proposal_per_satellite?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  min_quorum_percentage?: InputMaybe<Order_By>;
  min_yay_vote_percentage?: InputMaybe<Order_By>;
  mvn_tokens_aggregate?: InputMaybe<Mvn_Token_Aggregate_Order_By>;
  network?: InputMaybe<Order_By>;
  next_proposal_id?: InputMaybe<Order_By>;
  proposal_description_max_length?: InputMaybe<Order_By>;
  proposal_invoice_max_length?: InputMaybe<Order_By>;
  proposal_metadata_title_max_length?: InputMaybe<Order_By>;
  proposal_round_vote_percentage?: InputMaybe<Order_By>;
  proposal_source_code_max_length?: InputMaybe<Order_By>;
  proposal_submission_fee_mumav?: InputMaybe<Order_By>;
  proposal_title_max_length?: InputMaybe<Order_By>;
  proposals_aggregate?: InputMaybe<Governance_Proposal_Aggregate_Order_By>;
  satellite_snapshots_aggregate?: InputMaybe<Governance_Satellite_Snapshot_Aggregate_Order_By>;
  smvn_snapshots_aggregate?: InputMaybe<Governance_Smvn_Snapshot_Aggregate_Order_By>;
  success_reward?: InputMaybe<Order_By>;
  timelock_proposal_id?: InputMaybe<Order_By>;
  treasuries_aggregate?: InputMaybe<Treasury_Aggregate_Order_By>;
  treasury_factories_aggregate?: InputMaybe<Treasury_Factory_Aggregate_Order_By>;
  vault_factories_aggregate?: InputMaybe<Vault_Factory_Aggregate_Order_By>;
  vestings_aggregate?: InputMaybe<Vesting_Aggregate_Order_By>;
  whitelist_contracts_aggregate?: InputMaybe<Governance_Whitelist_Contract_Aggregate_Order_By>;
  whitelist_developers_aggregate?: InputMaybe<Whitelist_Developer_Aggregate_Order_By>;
};

/** columns and relationships of "governance_proposal" */
export type Governance_Proposal = {
  __typename?: 'governance_proposal';
  current_cycle_end_level: Scalars['bigint']['output'];
  current_cycle_start_level: Scalars['bigint']['output'];
  current_round_proposal: Scalars['Boolean']['output'];
  cycle: Scalars['bigint']['output'];
  /** An array relationship */
  data: Array<Governance_Proposal_Data>;
  /** An aggregate relationship */
  data_aggregate: Governance_Proposal_Data_Aggregate;
  defeated_datetime?: Maybe<Scalars['timestamptz']['output']>;
  description: Scalars['String']['output'];
  dropped_datetime?: Maybe<Scalars['timestamptz']['output']>;
  executed: Scalars['Boolean']['output'];
  execution_counter: Scalars['smallint']['output'];
  execution_datetime?: Maybe<Scalars['timestamptz']['output']>;
  execution_ready: Scalars['Boolean']['output'];
  /** An object relationship */
  governance: Governance;
  governance_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  internal_id: Scalars['bigint']['output'];
  invoice: Scalars['String']['output'];
  locked: Scalars['Boolean']['output'];
  min_proposal_round_vote_pct: Scalars['bigint']['output'];
  min_proposal_round_vote_req: Scalars['bigint']['output'];
  min_quorum_percentage: Scalars['bigint']['output'];
  min_yay_vote_percentage: Scalars['float8']['output'];
  nay_vote_count: Scalars['bigint']['output'];
  nay_vote_smvn_total: Scalars['float8']['output'];
  pass_vote_count: Scalars['bigint']['output'];
  pass_vote_smvn_total: Scalars['float8']['output'];
  payment_processed: Scalars['Boolean']['output'];
  /** An array relationship */
  payments: Array<Governance_Proposal_Payment>;
  /** An aggregate relationship */
  payments_aggregate: Governance_Proposal_Payment_Aggregate;
  proposal_vote_count: Scalars['bigint']['output'];
  proposal_vote_smvn_total: Scalars['float8']['output'];
  /** An object relationship */
  proposer: Maven_User;
  proposer_id: Scalars['bigint']['output'];
  quorum_count: Scalars['bigint']['output'];
  quorum_smvn_total: Scalars['float8']['output'];
  reward_claim_ready: Scalars['Boolean']['output'];
  source_code: Scalars['String']['output'];
  start_datetime: Scalars['timestamptz']['output'];
  /** ACTIVE: 0\nDROPPED: 1 */
  status: Scalars['smallint']['output'];
  success_reward: Scalars['float8']['output'];
  title: Scalars['String']['output'];
  total_voters_reward: Scalars['float8']['output'];
  /** An array relationship */
  votes: Array<Governance_Proposal_Vote>;
  /** An aggregate relationship */
  votes_aggregate: Governance_Proposal_Vote_Aggregate;
  yay_vote_count: Scalars['bigint']['output'];
  yay_vote_smvn_total: Scalars['float8']['output'];
};


/** columns and relationships of "governance_proposal" */
export type Governance_ProposalDataArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Data_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Data_Bool_Exp>;
};


/** columns and relationships of "governance_proposal" */
export type Governance_ProposalData_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Data_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Data_Bool_Exp>;
};


/** columns and relationships of "governance_proposal" */
export type Governance_ProposalPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Payment_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Payment_Bool_Exp>;
};


/** columns and relationships of "governance_proposal" */
export type Governance_ProposalPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Payment_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Payment_Bool_Exp>;
};


/** columns and relationships of "governance_proposal" */
export type Governance_ProposalVotesArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Vote_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Vote_Bool_Exp>;
};


/** columns and relationships of "governance_proposal" */
export type Governance_ProposalVotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Vote_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Vote_Bool_Exp>;
};

/** aggregated selection of "governance_proposal" */
export type Governance_Proposal_Aggregate = {
  __typename?: 'governance_proposal_aggregate';
  aggregate?: Maybe<Governance_Proposal_Aggregate_Fields>;
  nodes: Array<Governance_Proposal>;
};

export type Governance_Proposal_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Governance_Proposal_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Governance_Proposal_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Governance_Proposal_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Governance_Proposal_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Governance_Proposal_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Governance_Proposal_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Governance_Proposal_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Governance_Proposal_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Governance_Proposal_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Governance_Proposal_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Governance_Proposal_Aggregate_Bool_Exp_Var_Samp>;
};

export type Governance_Proposal_Aggregate_Bool_Exp_Avg = {
  arguments: Governance_Proposal_Select_Column_Governance_Proposal_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Proposal_Aggregate_Bool_Exp_Bool_And = {
  arguments: Governance_Proposal_Select_Column_Governance_Proposal_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Governance_Proposal_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Governance_Proposal_Select_Column_Governance_Proposal_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Governance_Proposal_Aggregate_Bool_Exp_Corr = {
  arguments: Governance_Proposal_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Proposal_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Governance_Proposal_Select_Column_Governance_Proposal_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Governance_Proposal_Select_Column_Governance_Proposal_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Governance_Proposal_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_Proposal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Governance_Proposal_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Governance_Proposal_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Proposal_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Governance_Proposal_Select_Column_Governance_Proposal_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Governance_Proposal_Select_Column_Governance_Proposal_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Governance_Proposal_Aggregate_Bool_Exp_Max = {
  arguments: Governance_Proposal_Select_Column_Governance_Proposal_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Proposal_Aggregate_Bool_Exp_Min = {
  arguments: Governance_Proposal_Select_Column_Governance_Proposal_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Proposal_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Governance_Proposal_Select_Column_Governance_Proposal_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Proposal_Aggregate_Bool_Exp_Sum = {
  arguments: Governance_Proposal_Select_Column_Governance_Proposal_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Proposal_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Governance_Proposal_Select_Column_Governance_Proposal_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "governance_proposal" */
export type Governance_Proposal_Aggregate_Fields = {
  __typename?: 'governance_proposal_aggregate_fields';
  avg?: Maybe<Governance_Proposal_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Proposal_Max_Fields>;
  min?: Maybe<Governance_Proposal_Min_Fields>;
  stddev?: Maybe<Governance_Proposal_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Proposal_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Proposal_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Proposal_Sum_Fields>;
  var_pop?: Maybe<Governance_Proposal_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Proposal_Var_Samp_Fields>;
  variance?: Maybe<Governance_Proposal_Variance_Fields>;
};


/** aggregate fields of "governance_proposal" */
export type Governance_Proposal_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Proposal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_proposal" */
export type Governance_Proposal_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_Proposal_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_Proposal_Max_Order_By>;
  min?: InputMaybe<Governance_Proposal_Min_Order_By>;
  stddev?: InputMaybe<Governance_Proposal_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_Proposal_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_Proposal_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_Proposal_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_Proposal_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_Proposal_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_Proposal_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Governance_Proposal_Avg_Fields = {
  __typename?: 'governance_proposal_avg_fields';
  current_cycle_end_level?: Maybe<Scalars['Float']['output']>;
  current_cycle_start_level?: Maybe<Scalars['Float']['output']>;
  cycle?: Maybe<Scalars['Float']['output']>;
  execution_counter?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  min_proposal_round_vote_pct?: Maybe<Scalars['Float']['output']>;
  min_proposal_round_vote_req?: Maybe<Scalars['Float']['output']>;
  min_quorum_percentage?: Maybe<Scalars['Float']['output']>;
  min_yay_vote_percentage?: Maybe<Scalars['Float']['output']>;
  nay_vote_count?: Maybe<Scalars['Float']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  pass_vote_count?: Maybe<Scalars['Float']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  proposal_vote_count?: Maybe<Scalars['Float']['output']>;
  proposal_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  proposer_id?: Maybe<Scalars['Float']['output']>;
  quorum_count?: Maybe<Scalars['Float']['output']>;
  quorum_smvn_total?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['Float']['output']>;
  success_reward?: Maybe<Scalars['Float']['output']>;
  total_voters_reward?: Maybe<Scalars['Float']['output']>;
  yay_vote_count?: Maybe<Scalars['Float']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_proposal" */
export type Governance_Proposal_Avg_Order_By = {
  current_cycle_end_level?: InputMaybe<Order_By>;
  current_cycle_start_level?: InputMaybe<Order_By>;
  cycle?: InputMaybe<Order_By>;
  execution_counter?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  min_proposal_round_vote_pct?: InputMaybe<Order_By>;
  min_proposal_round_vote_req?: InputMaybe<Order_By>;
  min_quorum_percentage?: InputMaybe<Order_By>;
  min_yay_vote_percentage?: InputMaybe<Order_By>;
  nay_vote_count?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_count?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  proposal_vote_count?: InputMaybe<Order_By>;
  proposal_vote_smvn_total?: InputMaybe<Order_By>;
  proposer_id?: InputMaybe<Order_By>;
  quorum_count?: InputMaybe<Order_By>;
  quorum_smvn_total?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  success_reward?: InputMaybe<Order_By>;
  total_voters_reward?: InputMaybe<Order_By>;
  yay_vote_count?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_proposal". All fields are combined with a logical 'AND'. */
export type Governance_Proposal_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Proposal_Bool_Exp>>;
  _not?: InputMaybe<Governance_Proposal_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Proposal_Bool_Exp>>;
  current_cycle_end_level?: InputMaybe<Bigint_Comparison_Exp>;
  current_cycle_start_level?: InputMaybe<Bigint_Comparison_Exp>;
  current_round_proposal?: InputMaybe<Boolean_Comparison_Exp>;
  cycle?: InputMaybe<Bigint_Comparison_Exp>;
  data?: InputMaybe<Governance_Proposal_Data_Bool_Exp>;
  data_aggregate?: InputMaybe<Governance_Proposal_Data_Aggregate_Bool_Exp>;
  defeated_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dropped_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  executed?: InputMaybe<Boolean_Comparison_Exp>;
  execution_counter?: InputMaybe<Smallint_Comparison_Exp>;
  execution_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  execution_ready?: InputMaybe<Boolean_Comparison_Exp>;
  governance?: InputMaybe<Governance_Bool_Exp>;
  governance_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  internal_id?: InputMaybe<Bigint_Comparison_Exp>;
  invoice?: InputMaybe<String_Comparison_Exp>;
  locked?: InputMaybe<Boolean_Comparison_Exp>;
  min_proposal_round_vote_pct?: InputMaybe<Bigint_Comparison_Exp>;
  min_proposal_round_vote_req?: InputMaybe<Bigint_Comparison_Exp>;
  min_quorum_percentage?: InputMaybe<Bigint_Comparison_Exp>;
  min_yay_vote_percentage?: InputMaybe<Float8_Comparison_Exp>;
  nay_vote_count?: InputMaybe<Bigint_Comparison_Exp>;
  nay_vote_smvn_total?: InputMaybe<Float8_Comparison_Exp>;
  pass_vote_count?: InputMaybe<Bigint_Comparison_Exp>;
  pass_vote_smvn_total?: InputMaybe<Float8_Comparison_Exp>;
  payment_processed?: InputMaybe<Boolean_Comparison_Exp>;
  payments?: InputMaybe<Governance_Proposal_Payment_Bool_Exp>;
  payments_aggregate?: InputMaybe<Governance_Proposal_Payment_Aggregate_Bool_Exp>;
  proposal_vote_count?: InputMaybe<Bigint_Comparison_Exp>;
  proposal_vote_smvn_total?: InputMaybe<Float8_Comparison_Exp>;
  proposer?: InputMaybe<Maven_User_Bool_Exp>;
  proposer_id?: InputMaybe<Bigint_Comparison_Exp>;
  quorum_count?: InputMaybe<Bigint_Comparison_Exp>;
  quorum_smvn_total?: InputMaybe<Float8_Comparison_Exp>;
  reward_claim_ready?: InputMaybe<Boolean_Comparison_Exp>;
  source_code?: InputMaybe<String_Comparison_Exp>;
  start_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<Smallint_Comparison_Exp>;
  success_reward?: InputMaybe<Float8_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  total_voters_reward?: InputMaybe<Float8_Comparison_Exp>;
  votes?: InputMaybe<Governance_Proposal_Vote_Bool_Exp>;
  votes_aggregate?: InputMaybe<Governance_Proposal_Vote_Aggregate_Bool_Exp>;
  yay_vote_count?: InputMaybe<Bigint_Comparison_Exp>;
  yay_vote_smvn_total?: InputMaybe<Float8_Comparison_Exp>;
};

/** columns and relationships of "governance_proposal_data" */
export type Governance_Proposal_Data = {
  __typename?: 'governance_proposal_data';
  code_description?: Maybe<Scalars['String']['output']>;
  encoded_code?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  governance_proposal: Governance_Proposal;
  governance_proposal_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  internal_id: Scalars['smallint']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "governance_proposal_data" */
export type Governance_Proposal_Data_Aggregate = {
  __typename?: 'governance_proposal_data_aggregate';
  aggregate?: Maybe<Governance_Proposal_Data_Aggregate_Fields>;
  nodes: Array<Governance_Proposal_Data>;
};

export type Governance_Proposal_Data_Aggregate_Bool_Exp = {
  count?: InputMaybe<Governance_Proposal_Data_Aggregate_Bool_Exp_Count>;
};

export type Governance_Proposal_Data_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_Proposal_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Data_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "governance_proposal_data" */
export type Governance_Proposal_Data_Aggregate_Fields = {
  __typename?: 'governance_proposal_data_aggregate_fields';
  avg?: Maybe<Governance_Proposal_Data_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Proposal_Data_Max_Fields>;
  min?: Maybe<Governance_Proposal_Data_Min_Fields>;
  stddev?: Maybe<Governance_Proposal_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Proposal_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Proposal_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Proposal_Data_Sum_Fields>;
  var_pop?: Maybe<Governance_Proposal_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Proposal_Data_Var_Samp_Fields>;
  variance?: Maybe<Governance_Proposal_Data_Variance_Fields>;
};


/** aggregate fields of "governance_proposal_data" */
export type Governance_Proposal_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Proposal_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_proposal_data" */
export type Governance_Proposal_Data_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_Proposal_Data_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_Proposal_Data_Max_Order_By>;
  min?: InputMaybe<Governance_Proposal_Data_Min_Order_By>;
  stddev?: InputMaybe<Governance_Proposal_Data_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_Proposal_Data_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_Proposal_Data_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_Proposal_Data_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_Proposal_Data_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_Proposal_Data_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_Proposal_Data_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Governance_Proposal_Data_Avg_Fields = {
  __typename?: 'governance_proposal_data_avg_fields';
  governance_proposal_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_proposal_data" */
export type Governance_Proposal_Data_Avg_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_proposal_data". All fields are combined with a logical 'AND'. */
export type Governance_Proposal_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Proposal_Data_Bool_Exp>>;
  _not?: InputMaybe<Governance_Proposal_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Proposal_Data_Bool_Exp>>;
  code_description?: InputMaybe<String_Comparison_Exp>;
  encoded_code?: InputMaybe<String_Comparison_Exp>;
  governance_proposal?: InputMaybe<Governance_Proposal_Bool_Exp>;
  governance_proposal_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  internal_id?: InputMaybe<Smallint_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Governance_Proposal_Data_Max_Fields = {
  __typename?: 'governance_proposal_data_max_fields';
  code_description?: Maybe<Scalars['String']['output']>;
  encoded_code?: Maybe<Scalars['String']['output']>;
  governance_proposal_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['smallint']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "governance_proposal_data" */
export type Governance_Proposal_Data_Max_Order_By = {
  code_description?: InputMaybe<Order_By>;
  encoded_code?: InputMaybe<Order_By>;
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_Proposal_Data_Min_Fields = {
  __typename?: 'governance_proposal_data_min_fields';
  code_description?: Maybe<Scalars['String']['output']>;
  encoded_code?: Maybe<Scalars['String']['output']>;
  governance_proposal_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['smallint']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "governance_proposal_data" */
export type Governance_Proposal_Data_Min_Order_By = {
  code_description?: InputMaybe<Order_By>;
  encoded_code?: InputMaybe<Order_By>;
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_proposal_data". */
export type Governance_Proposal_Data_Order_By = {
  code_description?: InputMaybe<Order_By>;
  encoded_code?: InputMaybe<Order_By>;
  governance_proposal?: InputMaybe<Governance_Proposal_Order_By>;
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** select columns of table "governance_proposal_data" */
export enum Governance_Proposal_Data_Select_Column {
  /** column name */
  CodeDescription = 'code_description',
  /** column name */
  EncodedCode = 'encoded_code',
  /** column name */
  GovernanceProposalId = 'governance_proposal_id',
  /** column name */
  Id = 'id',
  /** column name */
  InternalId = 'internal_id',
  /** column name */
  Title = 'title'
}

/** aggregate stddev on columns */
export type Governance_Proposal_Data_Stddev_Fields = {
  __typename?: 'governance_proposal_data_stddev_fields';
  governance_proposal_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_proposal_data" */
export type Governance_Proposal_Data_Stddev_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_Proposal_Data_Stddev_Pop_Fields = {
  __typename?: 'governance_proposal_data_stddev_pop_fields';
  governance_proposal_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_proposal_data" */
export type Governance_Proposal_Data_Stddev_Pop_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_Proposal_Data_Stddev_Samp_Fields = {
  __typename?: 'governance_proposal_data_stddev_samp_fields';
  governance_proposal_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_proposal_data" */
export type Governance_Proposal_Data_Stddev_Samp_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_proposal_data" */
export type Governance_Proposal_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Proposal_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Proposal_Data_Stream_Cursor_Value_Input = {
  code_description?: InputMaybe<Scalars['String']['input']>;
  encoded_code?: InputMaybe<Scalars['String']['input']>;
  governance_proposal_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  internal_id?: InputMaybe<Scalars['smallint']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Governance_Proposal_Data_Sum_Fields = {
  __typename?: 'governance_proposal_data_sum_fields';
  governance_proposal_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['smallint']['output']>;
};

/** order by sum() on columns of table "governance_proposal_data" */
export type Governance_Proposal_Data_Sum_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_Proposal_Data_Var_Pop_Fields = {
  __typename?: 'governance_proposal_data_var_pop_fields';
  governance_proposal_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_proposal_data" */
export type Governance_Proposal_Data_Var_Pop_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_Proposal_Data_Var_Samp_Fields = {
  __typename?: 'governance_proposal_data_var_samp_fields';
  governance_proposal_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_proposal_data" */
export type Governance_Proposal_Data_Var_Samp_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_Proposal_Data_Variance_Fields = {
  __typename?: 'governance_proposal_data_variance_fields';
  governance_proposal_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_proposal_data" */
export type Governance_Proposal_Data_Variance_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Governance_Proposal_Max_Fields = {
  __typename?: 'governance_proposal_max_fields';
  current_cycle_end_level?: Maybe<Scalars['bigint']['output']>;
  current_cycle_start_level?: Maybe<Scalars['bigint']['output']>;
  cycle?: Maybe<Scalars['bigint']['output']>;
  defeated_datetime?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dropped_datetime?: Maybe<Scalars['timestamptz']['output']>;
  execution_counter?: Maybe<Scalars['smallint']['output']>;
  execution_datetime?: Maybe<Scalars['timestamptz']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['bigint']['output']>;
  invoice?: Maybe<Scalars['String']['output']>;
  min_proposal_round_vote_pct?: Maybe<Scalars['bigint']['output']>;
  min_proposal_round_vote_req?: Maybe<Scalars['bigint']['output']>;
  min_quorum_percentage?: Maybe<Scalars['bigint']['output']>;
  min_yay_vote_percentage?: Maybe<Scalars['float8']['output']>;
  nay_vote_count?: Maybe<Scalars['bigint']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
  pass_vote_count?: Maybe<Scalars['bigint']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
  proposal_vote_count?: Maybe<Scalars['bigint']['output']>;
  proposal_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
  proposer_id?: Maybe<Scalars['bigint']['output']>;
  quorum_count?: Maybe<Scalars['bigint']['output']>;
  quorum_smvn_total?: Maybe<Scalars['float8']['output']>;
  source_code?: Maybe<Scalars['String']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['smallint']['output']>;
  success_reward?: Maybe<Scalars['float8']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total_voters_reward?: Maybe<Scalars['float8']['output']>;
  yay_vote_count?: Maybe<Scalars['bigint']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "governance_proposal" */
export type Governance_Proposal_Max_Order_By = {
  current_cycle_end_level?: InputMaybe<Order_By>;
  current_cycle_start_level?: InputMaybe<Order_By>;
  cycle?: InputMaybe<Order_By>;
  defeated_datetime?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dropped_datetime?: InputMaybe<Order_By>;
  execution_counter?: InputMaybe<Order_By>;
  execution_datetime?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  invoice?: InputMaybe<Order_By>;
  min_proposal_round_vote_pct?: InputMaybe<Order_By>;
  min_proposal_round_vote_req?: InputMaybe<Order_By>;
  min_quorum_percentage?: InputMaybe<Order_By>;
  min_yay_vote_percentage?: InputMaybe<Order_By>;
  nay_vote_count?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_count?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  proposal_vote_count?: InputMaybe<Order_By>;
  proposal_vote_smvn_total?: InputMaybe<Order_By>;
  proposer_id?: InputMaybe<Order_By>;
  quorum_count?: InputMaybe<Order_By>;
  quorum_smvn_total?: InputMaybe<Order_By>;
  source_code?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  success_reward?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  total_voters_reward?: InputMaybe<Order_By>;
  yay_vote_count?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_Proposal_Min_Fields = {
  __typename?: 'governance_proposal_min_fields';
  current_cycle_end_level?: Maybe<Scalars['bigint']['output']>;
  current_cycle_start_level?: Maybe<Scalars['bigint']['output']>;
  cycle?: Maybe<Scalars['bigint']['output']>;
  defeated_datetime?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dropped_datetime?: Maybe<Scalars['timestamptz']['output']>;
  execution_counter?: Maybe<Scalars['smallint']['output']>;
  execution_datetime?: Maybe<Scalars['timestamptz']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['bigint']['output']>;
  invoice?: Maybe<Scalars['String']['output']>;
  min_proposal_round_vote_pct?: Maybe<Scalars['bigint']['output']>;
  min_proposal_round_vote_req?: Maybe<Scalars['bigint']['output']>;
  min_quorum_percentage?: Maybe<Scalars['bigint']['output']>;
  min_yay_vote_percentage?: Maybe<Scalars['float8']['output']>;
  nay_vote_count?: Maybe<Scalars['bigint']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
  pass_vote_count?: Maybe<Scalars['bigint']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
  proposal_vote_count?: Maybe<Scalars['bigint']['output']>;
  proposal_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
  proposer_id?: Maybe<Scalars['bigint']['output']>;
  quorum_count?: Maybe<Scalars['bigint']['output']>;
  quorum_smvn_total?: Maybe<Scalars['float8']['output']>;
  source_code?: Maybe<Scalars['String']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['smallint']['output']>;
  success_reward?: Maybe<Scalars['float8']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total_voters_reward?: Maybe<Scalars['float8']['output']>;
  yay_vote_count?: Maybe<Scalars['bigint']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "governance_proposal" */
export type Governance_Proposal_Min_Order_By = {
  current_cycle_end_level?: InputMaybe<Order_By>;
  current_cycle_start_level?: InputMaybe<Order_By>;
  cycle?: InputMaybe<Order_By>;
  defeated_datetime?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dropped_datetime?: InputMaybe<Order_By>;
  execution_counter?: InputMaybe<Order_By>;
  execution_datetime?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  invoice?: InputMaybe<Order_By>;
  min_proposal_round_vote_pct?: InputMaybe<Order_By>;
  min_proposal_round_vote_req?: InputMaybe<Order_By>;
  min_quorum_percentage?: InputMaybe<Order_By>;
  min_yay_vote_percentage?: InputMaybe<Order_By>;
  nay_vote_count?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_count?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  proposal_vote_count?: InputMaybe<Order_By>;
  proposal_vote_smvn_total?: InputMaybe<Order_By>;
  proposer_id?: InputMaybe<Order_By>;
  quorum_count?: InputMaybe<Order_By>;
  quorum_smvn_total?: InputMaybe<Order_By>;
  source_code?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  success_reward?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  total_voters_reward?: InputMaybe<Order_By>;
  yay_vote_count?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_proposal". */
export type Governance_Proposal_Order_By = {
  current_cycle_end_level?: InputMaybe<Order_By>;
  current_cycle_start_level?: InputMaybe<Order_By>;
  current_round_proposal?: InputMaybe<Order_By>;
  cycle?: InputMaybe<Order_By>;
  data_aggregate?: InputMaybe<Governance_Proposal_Data_Aggregate_Order_By>;
  defeated_datetime?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dropped_datetime?: InputMaybe<Order_By>;
  executed?: InputMaybe<Order_By>;
  execution_counter?: InputMaybe<Order_By>;
  execution_datetime?: InputMaybe<Order_By>;
  execution_ready?: InputMaybe<Order_By>;
  governance?: InputMaybe<Governance_Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  invoice?: InputMaybe<Order_By>;
  locked?: InputMaybe<Order_By>;
  min_proposal_round_vote_pct?: InputMaybe<Order_By>;
  min_proposal_round_vote_req?: InputMaybe<Order_By>;
  min_quorum_percentage?: InputMaybe<Order_By>;
  min_yay_vote_percentage?: InputMaybe<Order_By>;
  nay_vote_count?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_count?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  payment_processed?: InputMaybe<Order_By>;
  payments_aggregate?: InputMaybe<Governance_Proposal_Payment_Aggregate_Order_By>;
  proposal_vote_count?: InputMaybe<Order_By>;
  proposal_vote_smvn_total?: InputMaybe<Order_By>;
  proposer?: InputMaybe<Maven_User_Order_By>;
  proposer_id?: InputMaybe<Order_By>;
  quorum_count?: InputMaybe<Order_By>;
  quorum_smvn_total?: InputMaybe<Order_By>;
  reward_claim_ready?: InputMaybe<Order_By>;
  source_code?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  success_reward?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  total_voters_reward?: InputMaybe<Order_By>;
  votes_aggregate?: InputMaybe<Governance_Proposal_Vote_Aggregate_Order_By>;
  yay_vote_count?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** columns and relationships of "governance_proposal_payment" */
export type Governance_Proposal_Payment = {
  __typename?: 'governance_proposal_payment';
  /** An object relationship */
  governance_proposal: Governance_Proposal;
  governance_proposal_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  internal_id: Scalars['smallint']['output'];
  title?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  to_?: Maybe<Maven_User>;
  to__id?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  token?: Maybe<Token>;
  token_amount?: Maybe<Scalars['float8']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "governance_proposal_payment" */
export type Governance_Proposal_Payment_Aggregate = {
  __typename?: 'governance_proposal_payment_aggregate';
  aggregate?: Maybe<Governance_Proposal_Payment_Aggregate_Fields>;
  nodes: Array<Governance_Proposal_Payment>;
};

export type Governance_Proposal_Payment_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Governance_Proposal_Payment_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Governance_Proposal_Payment_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Governance_Proposal_Payment_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Governance_Proposal_Payment_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Governance_Proposal_Payment_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Governance_Proposal_Payment_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Governance_Proposal_Payment_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Governance_Proposal_Payment_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Governance_Proposal_Payment_Aggregate_Bool_Exp_Var_Samp>;
};

export type Governance_Proposal_Payment_Aggregate_Bool_Exp_Avg = {
  arguments: Governance_Proposal_Payment_Select_Column_Governance_Proposal_Payment_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Payment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Proposal_Payment_Aggregate_Bool_Exp_Corr = {
  arguments: Governance_Proposal_Payment_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Payment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Proposal_Payment_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Governance_Proposal_Payment_Select_Column_Governance_Proposal_Payment_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Governance_Proposal_Payment_Select_Column_Governance_Proposal_Payment_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Governance_Proposal_Payment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_Proposal_Payment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Payment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Governance_Proposal_Payment_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Governance_Proposal_Payment_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Payment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Proposal_Payment_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Governance_Proposal_Payment_Select_Column_Governance_Proposal_Payment_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Governance_Proposal_Payment_Select_Column_Governance_Proposal_Payment_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Governance_Proposal_Payment_Aggregate_Bool_Exp_Max = {
  arguments: Governance_Proposal_Payment_Select_Column_Governance_Proposal_Payment_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Payment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Proposal_Payment_Aggregate_Bool_Exp_Min = {
  arguments: Governance_Proposal_Payment_Select_Column_Governance_Proposal_Payment_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Payment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Proposal_Payment_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Governance_Proposal_Payment_Select_Column_Governance_Proposal_Payment_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Payment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Proposal_Payment_Aggregate_Bool_Exp_Sum = {
  arguments: Governance_Proposal_Payment_Select_Column_Governance_Proposal_Payment_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Payment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Proposal_Payment_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Governance_Proposal_Payment_Select_Column_Governance_Proposal_Payment_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Payment_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "governance_proposal_payment" */
export type Governance_Proposal_Payment_Aggregate_Fields = {
  __typename?: 'governance_proposal_payment_aggregate_fields';
  avg?: Maybe<Governance_Proposal_Payment_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Proposal_Payment_Max_Fields>;
  min?: Maybe<Governance_Proposal_Payment_Min_Fields>;
  stddev?: Maybe<Governance_Proposal_Payment_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Proposal_Payment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Proposal_Payment_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Proposal_Payment_Sum_Fields>;
  var_pop?: Maybe<Governance_Proposal_Payment_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Proposal_Payment_Var_Samp_Fields>;
  variance?: Maybe<Governance_Proposal_Payment_Variance_Fields>;
};


/** aggregate fields of "governance_proposal_payment" */
export type Governance_Proposal_Payment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Proposal_Payment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_proposal_payment" */
export type Governance_Proposal_Payment_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_Proposal_Payment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_Proposal_Payment_Max_Order_By>;
  min?: InputMaybe<Governance_Proposal_Payment_Min_Order_By>;
  stddev?: InputMaybe<Governance_Proposal_Payment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_Proposal_Payment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_Proposal_Payment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_Proposal_Payment_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_Proposal_Payment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_Proposal_Payment_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_Proposal_Payment_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Governance_Proposal_Payment_Avg_Fields = {
  __typename?: 'governance_proposal_payment_avg_fields';
  governance_proposal_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  to__id?: Maybe<Scalars['Float']['output']>;
  token_amount?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_proposal_payment" */
export type Governance_Proposal_Payment_Avg_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
  token_amount?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_proposal_payment". All fields are combined with a logical 'AND'. */
export type Governance_Proposal_Payment_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Proposal_Payment_Bool_Exp>>;
  _not?: InputMaybe<Governance_Proposal_Payment_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Proposal_Payment_Bool_Exp>>;
  governance_proposal?: InputMaybe<Governance_Proposal_Bool_Exp>;
  governance_proposal_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  internal_id?: InputMaybe<Smallint_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  to_?: InputMaybe<Maven_User_Bool_Exp>;
  to__id?: InputMaybe<Bigint_Comparison_Exp>;
  token?: InputMaybe<Token_Bool_Exp>;
  token_amount?: InputMaybe<Float8_Comparison_Exp>;
  token_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Governance_Proposal_Payment_Max_Fields = {
  __typename?: 'governance_proposal_payment_max_fields';
  governance_proposal_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['smallint']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  to__id?: Maybe<Scalars['bigint']['output']>;
  token_amount?: Maybe<Scalars['float8']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "governance_proposal_payment" */
export type Governance_Proposal_Payment_Max_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
  token_amount?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_Proposal_Payment_Min_Fields = {
  __typename?: 'governance_proposal_payment_min_fields';
  governance_proposal_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['smallint']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  to__id?: Maybe<Scalars['bigint']['output']>;
  token_amount?: Maybe<Scalars['float8']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "governance_proposal_payment" */
export type Governance_Proposal_Payment_Min_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
  token_amount?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_proposal_payment". */
export type Governance_Proposal_Payment_Order_By = {
  governance_proposal?: InputMaybe<Governance_Proposal_Order_By>;
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  to_?: InputMaybe<Maven_User_Order_By>;
  to__id?: InputMaybe<Order_By>;
  token?: InputMaybe<Token_Order_By>;
  token_amount?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** select columns of table "governance_proposal_payment" */
export enum Governance_Proposal_Payment_Select_Column {
  /** column name */
  GovernanceProposalId = 'governance_proposal_id',
  /** column name */
  Id = 'id',
  /** column name */
  InternalId = 'internal_id',
  /** column name */
  Title = 'title',
  /** column name */
  ToId = 'to__id',
  /** column name */
  TokenAmount = 'token_amount',
  /** column name */
  TokenId = 'token_id'
}

/** select "governance_proposal_payment_aggregate_bool_exp_avg_arguments_columns" columns of table "governance_proposal_payment" */
export enum Governance_Proposal_Payment_Select_Column_Governance_Proposal_Payment_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  TokenAmount = 'token_amount'
}

/** select "governance_proposal_payment_aggregate_bool_exp_corr_arguments_columns" columns of table "governance_proposal_payment" */
export enum Governance_Proposal_Payment_Select_Column_Governance_Proposal_Payment_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  TokenAmount = 'token_amount'
}

/** select "governance_proposal_payment_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "governance_proposal_payment" */
export enum Governance_Proposal_Payment_Select_Column_Governance_Proposal_Payment_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  TokenAmount = 'token_amount'
}

/** select "governance_proposal_payment_aggregate_bool_exp_max_arguments_columns" columns of table "governance_proposal_payment" */
export enum Governance_Proposal_Payment_Select_Column_Governance_Proposal_Payment_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  TokenAmount = 'token_amount'
}

/** select "governance_proposal_payment_aggregate_bool_exp_min_arguments_columns" columns of table "governance_proposal_payment" */
export enum Governance_Proposal_Payment_Select_Column_Governance_Proposal_Payment_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  TokenAmount = 'token_amount'
}

/** select "governance_proposal_payment_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "governance_proposal_payment" */
export enum Governance_Proposal_Payment_Select_Column_Governance_Proposal_Payment_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  TokenAmount = 'token_amount'
}

/** select "governance_proposal_payment_aggregate_bool_exp_sum_arguments_columns" columns of table "governance_proposal_payment" */
export enum Governance_Proposal_Payment_Select_Column_Governance_Proposal_Payment_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  TokenAmount = 'token_amount'
}

/** select "governance_proposal_payment_aggregate_bool_exp_var_samp_arguments_columns" columns of table "governance_proposal_payment" */
export enum Governance_Proposal_Payment_Select_Column_Governance_Proposal_Payment_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  TokenAmount = 'token_amount'
}

/** aggregate stddev on columns */
export type Governance_Proposal_Payment_Stddev_Fields = {
  __typename?: 'governance_proposal_payment_stddev_fields';
  governance_proposal_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  to__id?: Maybe<Scalars['Float']['output']>;
  token_amount?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_proposal_payment" */
export type Governance_Proposal_Payment_Stddev_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
  token_amount?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_Proposal_Payment_Stddev_Pop_Fields = {
  __typename?: 'governance_proposal_payment_stddev_pop_fields';
  governance_proposal_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  to__id?: Maybe<Scalars['Float']['output']>;
  token_amount?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_proposal_payment" */
export type Governance_Proposal_Payment_Stddev_Pop_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
  token_amount?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_Proposal_Payment_Stddev_Samp_Fields = {
  __typename?: 'governance_proposal_payment_stddev_samp_fields';
  governance_proposal_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  to__id?: Maybe<Scalars['Float']['output']>;
  token_amount?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_proposal_payment" */
export type Governance_Proposal_Payment_Stddev_Samp_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
  token_amount?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_proposal_payment" */
export type Governance_Proposal_Payment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Proposal_Payment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Proposal_Payment_Stream_Cursor_Value_Input = {
  governance_proposal_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  internal_id?: InputMaybe<Scalars['smallint']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  to__id?: InputMaybe<Scalars['bigint']['input']>;
  token_amount?: InputMaybe<Scalars['float8']['input']>;
  token_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Governance_Proposal_Payment_Sum_Fields = {
  __typename?: 'governance_proposal_payment_sum_fields';
  governance_proposal_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['smallint']['output']>;
  to__id?: Maybe<Scalars['bigint']['output']>;
  token_amount?: Maybe<Scalars['float8']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "governance_proposal_payment" */
export type Governance_Proposal_Payment_Sum_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
  token_amount?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_Proposal_Payment_Var_Pop_Fields = {
  __typename?: 'governance_proposal_payment_var_pop_fields';
  governance_proposal_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  to__id?: Maybe<Scalars['Float']['output']>;
  token_amount?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_proposal_payment" */
export type Governance_Proposal_Payment_Var_Pop_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
  token_amount?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_Proposal_Payment_Var_Samp_Fields = {
  __typename?: 'governance_proposal_payment_var_samp_fields';
  governance_proposal_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  to__id?: Maybe<Scalars['Float']['output']>;
  token_amount?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_proposal_payment" */
export type Governance_Proposal_Payment_Var_Samp_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
  token_amount?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_Proposal_Payment_Variance_Fields = {
  __typename?: 'governance_proposal_payment_variance_fields';
  governance_proposal_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  to__id?: Maybe<Scalars['Float']['output']>;
  token_amount?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_proposal_payment" */
export type Governance_Proposal_Payment_Variance_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
  token_amount?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** select columns of table "governance_proposal" */
export enum Governance_Proposal_Select_Column {
  /** column name */
  CurrentCycleEndLevel = 'current_cycle_end_level',
  /** column name */
  CurrentCycleStartLevel = 'current_cycle_start_level',
  /** column name */
  CurrentRoundProposal = 'current_round_proposal',
  /** column name */
  Cycle = 'cycle',
  /** column name */
  DefeatedDatetime = 'defeated_datetime',
  /** column name */
  Description = 'description',
  /** column name */
  DroppedDatetime = 'dropped_datetime',
  /** column name */
  Executed = 'executed',
  /** column name */
  ExecutionCounter = 'execution_counter',
  /** column name */
  ExecutionDatetime = 'execution_datetime',
  /** column name */
  ExecutionReady = 'execution_ready',
  /** column name */
  GovernanceId = 'governance_id',
  /** column name */
  Id = 'id',
  /** column name */
  InternalId = 'internal_id',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  Locked = 'locked',
  /** column name */
  MinProposalRoundVotePct = 'min_proposal_round_vote_pct',
  /** column name */
  MinProposalRoundVoteReq = 'min_proposal_round_vote_req',
  /** column name */
  MinQuorumPercentage = 'min_quorum_percentage',
  /** column name */
  MinYayVotePercentage = 'min_yay_vote_percentage',
  /** column name */
  NayVoteCount = 'nay_vote_count',
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteCount = 'pass_vote_count',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  PaymentProcessed = 'payment_processed',
  /** column name */
  ProposalVoteCount = 'proposal_vote_count',
  /** column name */
  ProposalVoteSmvnTotal = 'proposal_vote_smvn_total',
  /** column name */
  ProposerId = 'proposer_id',
  /** column name */
  QuorumCount = 'quorum_count',
  /** column name */
  QuorumSmvnTotal = 'quorum_smvn_total',
  /** column name */
  RewardClaimReady = 'reward_claim_ready',
  /** column name */
  SourceCode = 'source_code',
  /** column name */
  StartDatetime = 'start_datetime',
  /** column name */
  Status = 'status',
  /** column name */
  SuccessReward = 'success_reward',
  /** column name */
  Title = 'title',
  /** column name */
  TotalVotersReward = 'total_voters_reward',
  /** column name */
  YayVoteCount = 'yay_vote_count',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** select "governance_proposal_aggregate_bool_exp_avg_arguments_columns" columns of table "governance_proposal" */
export enum Governance_Proposal_Select_Column_Governance_Proposal_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  MinYayVotePercentage = 'min_yay_vote_percentage',
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  ProposalVoteSmvnTotal = 'proposal_vote_smvn_total',
  /** column name */
  QuorumSmvnTotal = 'quorum_smvn_total',
  /** column name */
  SuccessReward = 'success_reward',
  /** column name */
  TotalVotersReward = 'total_voters_reward',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** select "governance_proposal_aggregate_bool_exp_bool_and_arguments_columns" columns of table "governance_proposal" */
export enum Governance_Proposal_Select_Column_Governance_Proposal_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CurrentRoundProposal = 'current_round_proposal',
  /** column name */
  Executed = 'executed',
  /** column name */
  ExecutionReady = 'execution_ready',
  /** column name */
  Locked = 'locked',
  /** column name */
  PaymentProcessed = 'payment_processed',
  /** column name */
  RewardClaimReady = 'reward_claim_ready'
}

/** select "governance_proposal_aggregate_bool_exp_bool_or_arguments_columns" columns of table "governance_proposal" */
export enum Governance_Proposal_Select_Column_Governance_Proposal_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CurrentRoundProposal = 'current_round_proposal',
  /** column name */
  Executed = 'executed',
  /** column name */
  ExecutionReady = 'execution_ready',
  /** column name */
  Locked = 'locked',
  /** column name */
  PaymentProcessed = 'payment_processed',
  /** column name */
  RewardClaimReady = 'reward_claim_ready'
}

/** select "governance_proposal_aggregate_bool_exp_corr_arguments_columns" columns of table "governance_proposal" */
export enum Governance_Proposal_Select_Column_Governance_Proposal_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  MinYayVotePercentage = 'min_yay_vote_percentage',
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  ProposalVoteSmvnTotal = 'proposal_vote_smvn_total',
  /** column name */
  QuorumSmvnTotal = 'quorum_smvn_total',
  /** column name */
  SuccessReward = 'success_reward',
  /** column name */
  TotalVotersReward = 'total_voters_reward',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** select "governance_proposal_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "governance_proposal" */
export enum Governance_Proposal_Select_Column_Governance_Proposal_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  MinYayVotePercentage = 'min_yay_vote_percentage',
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  ProposalVoteSmvnTotal = 'proposal_vote_smvn_total',
  /** column name */
  QuorumSmvnTotal = 'quorum_smvn_total',
  /** column name */
  SuccessReward = 'success_reward',
  /** column name */
  TotalVotersReward = 'total_voters_reward',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** select "governance_proposal_aggregate_bool_exp_max_arguments_columns" columns of table "governance_proposal" */
export enum Governance_Proposal_Select_Column_Governance_Proposal_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  MinYayVotePercentage = 'min_yay_vote_percentage',
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  ProposalVoteSmvnTotal = 'proposal_vote_smvn_total',
  /** column name */
  QuorumSmvnTotal = 'quorum_smvn_total',
  /** column name */
  SuccessReward = 'success_reward',
  /** column name */
  TotalVotersReward = 'total_voters_reward',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** select "governance_proposal_aggregate_bool_exp_min_arguments_columns" columns of table "governance_proposal" */
export enum Governance_Proposal_Select_Column_Governance_Proposal_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  MinYayVotePercentage = 'min_yay_vote_percentage',
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  ProposalVoteSmvnTotal = 'proposal_vote_smvn_total',
  /** column name */
  QuorumSmvnTotal = 'quorum_smvn_total',
  /** column name */
  SuccessReward = 'success_reward',
  /** column name */
  TotalVotersReward = 'total_voters_reward',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** select "governance_proposal_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "governance_proposal" */
export enum Governance_Proposal_Select_Column_Governance_Proposal_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  MinYayVotePercentage = 'min_yay_vote_percentage',
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  ProposalVoteSmvnTotal = 'proposal_vote_smvn_total',
  /** column name */
  QuorumSmvnTotal = 'quorum_smvn_total',
  /** column name */
  SuccessReward = 'success_reward',
  /** column name */
  TotalVotersReward = 'total_voters_reward',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** select "governance_proposal_aggregate_bool_exp_sum_arguments_columns" columns of table "governance_proposal" */
export enum Governance_Proposal_Select_Column_Governance_Proposal_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  MinYayVotePercentage = 'min_yay_vote_percentage',
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  ProposalVoteSmvnTotal = 'proposal_vote_smvn_total',
  /** column name */
  QuorumSmvnTotal = 'quorum_smvn_total',
  /** column name */
  SuccessReward = 'success_reward',
  /** column name */
  TotalVotersReward = 'total_voters_reward',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** select "governance_proposal_aggregate_bool_exp_var_samp_arguments_columns" columns of table "governance_proposal" */
export enum Governance_Proposal_Select_Column_Governance_Proposal_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  MinYayVotePercentage = 'min_yay_vote_percentage',
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  ProposalVoteSmvnTotal = 'proposal_vote_smvn_total',
  /** column name */
  QuorumSmvnTotal = 'quorum_smvn_total',
  /** column name */
  SuccessReward = 'success_reward',
  /** column name */
  TotalVotersReward = 'total_voters_reward',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** aggregate stddev on columns */
export type Governance_Proposal_Stddev_Fields = {
  __typename?: 'governance_proposal_stddev_fields';
  current_cycle_end_level?: Maybe<Scalars['Float']['output']>;
  current_cycle_start_level?: Maybe<Scalars['Float']['output']>;
  cycle?: Maybe<Scalars['Float']['output']>;
  execution_counter?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  min_proposal_round_vote_pct?: Maybe<Scalars['Float']['output']>;
  min_proposal_round_vote_req?: Maybe<Scalars['Float']['output']>;
  min_quorum_percentage?: Maybe<Scalars['Float']['output']>;
  min_yay_vote_percentage?: Maybe<Scalars['Float']['output']>;
  nay_vote_count?: Maybe<Scalars['Float']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  pass_vote_count?: Maybe<Scalars['Float']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  proposal_vote_count?: Maybe<Scalars['Float']['output']>;
  proposal_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  proposer_id?: Maybe<Scalars['Float']['output']>;
  quorum_count?: Maybe<Scalars['Float']['output']>;
  quorum_smvn_total?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['Float']['output']>;
  success_reward?: Maybe<Scalars['Float']['output']>;
  total_voters_reward?: Maybe<Scalars['Float']['output']>;
  yay_vote_count?: Maybe<Scalars['Float']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_proposal" */
export type Governance_Proposal_Stddev_Order_By = {
  current_cycle_end_level?: InputMaybe<Order_By>;
  current_cycle_start_level?: InputMaybe<Order_By>;
  cycle?: InputMaybe<Order_By>;
  execution_counter?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  min_proposal_round_vote_pct?: InputMaybe<Order_By>;
  min_proposal_round_vote_req?: InputMaybe<Order_By>;
  min_quorum_percentage?: InputMaybe<Order_By>;
  min_yay_vote_percentage?: InputMaybe<Order_By>;
  nay_vote_count?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_count?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  proposal_vote_count?: InputMaybe<Order_By>;
  proposal_vote_smvn_total?: InputMaybe<Order_By>;
  proposer_id?: InputMaybe<Order_By>;
  quorum_count?: InputMaybe<Order_By>;
  quorum_smvn_total?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  success_reward?: InputMaybe<Order_By>;
  total_voters_reward?: InputMaybe<Order_By>;
  yay_vote_count?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_Proposal_Stddev_Pop_Fields = {
  __typename?: 'governance_proposal_stddev_pop_fields';
  current_cycle_end_level?: Maybe<Scalars['Float']['output']>;
  current_cycle_start_level?: Maybe<Scalars['Float']['output']>;
  cycle?: Maybe<Scalars['Float']['output']>;
  execution_counter?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  min_proposal_round_vote_pct?: Maybe<Scalars['Float']['output']>;
  min_proposal_round_vote_req?: Maybe<Scalars['Float']['output']>;
  min_quorum_percentage?: Maybe<Scalars['Float']['output']>;
  min_yay_vote_percentage?: Maybe<Scalars['Float']['output']>;
  nay_vote_count?: Maybe<Scalars['Float']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  pass_vote_count?: Maybe<Scalars['Float']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  proposal_vote_count?: Maybe<Scalars['Float']['output']>;
  proposal_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  proposer_id?: Maybe<Scalars['Float']['output']>;
  quorum_count?: Maybe<Scalars['Float']['output']>;
  quorum_smvn_total?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['Float']['output']>;
  success_reward?: Maybe<Scalars['Float']['output']>;
  total_voters_reward?: Maybe<Scalars['Float']['output']>;
  yay_vote_count?: Maybe<Scalars['Float']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_proposal" */
export type Governance_Proposal_Stddev_Pop_Order_By = {
  current_cycle_end_level?: InputMaybe<Order_By>;
  current_cycle_start_level?: InputMaybe<Order_By>;
  cycle?: InputMaybe<Order_By>;
  execution_counter?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  min_proposal_round_vote_pct?: InputMaybe<Order_By>;
  min_proposal_round_vote_req?: InputMaybe<Order_By>;
  min_quorum_percentage?: InputMaybe<Order_By>;
  min_yay_vote_percentage?: InputMaybe<Order_By>;
  nay_vote_count?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_count?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  proposal_vote_count?: InputMaybe<Order_By>;
  proposal_vote_smvn_total?: InputMaybe<Order_By>;
  proposer_id?: InputMaybe<Order_By>;
  quorum_count?: InputMaybe<Order_By>;
  quorum_smvn_total?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  success_reward?: InputMaybe<Order_By>;
  total_voters_reward?: InputMaybe<Order_By>;
  yay_vote_count?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_Proposal_Stddev_Samp_Fields = {
  __typename?: 'governance_proposal_stddev_samp_fields';
  current_cycle_end_level?: Maybe<Scalars['Float']['output']>;
  current_cycle_start_level?: Maybe<Scalars['Float']['output']>;
  cycle?: Maybe<Scalars['Float']['output']>;
  execution_counter?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  min_proposal_round_vote_pct?: Maybe<Scalars['Float']['output']>;
  min_proposal_round_vote_req?: Maybe<Scalars['Float']['output']>;
  min_quorum_percentage?: Maybe<Scalars['Float']['output']>;
  min_yay_vote_percentage?: Maybe<Scalars['Float']['output']>;
  nay_vote_count?: Maybe<Scalars['Float']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  pass_vote_count?: Maybe<Scalars['Float']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  proposal_vote_count?: Maybe<Scalars['Float']['output']>;
  proposal_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  proposer_id?: Maybe<Scalars['Float']['output']>;
  quorum_count?: Maybe<Scalars['Float']['output']>;
  quorum_smvn_total?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['Float']['output']>;
  success_reward?: Maybe<Scalars['Float']['output']>;
  total_voters_reward?: Maybe<Scalars['Float']['output']>;
  yay_vote_count?: Maybe<Scalars['Float']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_proposal" */
export type Governance_Proposal_Stddev_Samp_Order_By = {
  current_cycle_end_level?: InputMaybe<Order_By>;
  current_cycle_start_level?: InputMaybe<Order_By>;
  cycle?: InputMaybe<Order_By>;
  execution_counter?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  min_proposal_round_vote_pct?: InputMaybe<Order_By>;
  min_proposal_round_vote_req?: InputMaybe<Order_By>;
  min_quorum_percentage?: InputMaybe<Order_By>;
  min_yay_vote_percentage?: InputMaybe<Order_By>;
  nay_vote_count?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_count?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  proposal_vote_count?: InputMaybe<Order_By>;
  proposal_vote_smvn_total?: InputMaybe<Order_By>;
  proposer_id?: InputMaybe<Order_By>;
  quorum_count?: InputMaybe<Order_By>;
  quorum_smvn_total?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  success_reward?: InputMaybe<Order_By>;
  total_voters_reward?: InputMaybe<Order_By>;
  yay_vote_count?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_proposal" */
export type Governance_Proposal_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Proposal_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Proposal_Stream_Cursor_Value_Input = {
  current_cycle_end_level?: InputMaybe<Scalars['bigint']['input']>;
  current_cycle_start_level?: InputMaybe<Scalars['bigint']['input']>;
  current_round_proposal?: InputMaybe<Scalars['Boolean']['input']>;
  cycle?: InputMaybe<Scalars['bigint']['input']>;
  defeated_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dropped_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  executed?: InputMaybe<Scalars['Boolean']['input']>;
  execution_counter?: InputMaybe<Scalars['smallint']['input']>;
  execution_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  execution_ready?: InputMaybe<Scalars['Boolean']['input']>;
  governance_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  internal_id?: InputMaybe<Scalars['bigint']['input']>;
  invoice?: InputMaybe<Scalars['String']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  min_proposal_round_vote_pct?: InputMaybe<Scalars['bigint']['input']>;
  min_proposal_round_vote_req?: InputMaybe<Scalars['bigint']['input']>;
  min_quorum_percentage?: InputMaybe<Scalars['bigint']['input']>;
  min_yay_vote_percentage?: InputMaybe<Scalars['float8']['input']>;
  nay_vote_count?: InputMaybe<Scalars['bigint']['input']>;
  nay_vote_smvn_total?: InputMaybe<Scalars['float8']['input']>;
  pass_vote_count?: InputMaybe<Scalars['bigint']['input']>;
  pass_vote_smvn_total?: InputMaybe<Scalars['float8']['input']>;
  payment_processed?: InputMaybe<Scalars['Boolean']['input']>;
  proposal_vote_count?: InputMaybe<Scalars['bigint']['input']>;
  proposal_vote_smvn_total?: InputMaybe<Scalars['float8']['input']>;
  proposer_id?: InputMaybe<Scalars['bigint']['input']>;
  quorum_count?: InputMaybe<Scalars['bigint']['input']>;
  quorum_smvn_total?: InputMaybe<Scalars['float8']['input']>;
  reward_claim_ready?: InputMaybe<Scalars['Boolean']['input']>;
  source_code?: InputMaybe<Scalars['String']['input']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Scalars['smallint']['input']>;
  success_reward?: InputMaybe<Scalars['float8']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  total_voters_reward?: InputMaybe<Scalars['float8']['input']>;
  yay_vote_count?: InputMaybe<Scalars['bigint']['input']>;
  yay_vote_smvn_total?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type Governance_Proposal_Sum_Fields = {
  __typename?: 'governance_proposal_sum_fields';
  current_cycle_end_level?: Maybe<Scalars['bigint']['output']>;
  current_cycle_start_level?: Maybe<Scalars['bigint']['output']>;
  cycle?: Maybe<Scalars['bigint']['output']>;
  execution_counter?: Maybe<Scalars['smallint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['bigint']['output']>;
  min_proposal_round_vote_pct?: Maybe<Scalars['bigint']['output']>;
  min_proposal_round_vote_req?: Maybe<Scalars['bigint']['output']>;
  min_quorum_percentage?: Maybe<Scalars['bigint']['output']>;
  min_yay_vote_percentage?: Maybe<Scalars['float8']['output']>;
  nay_vote_count?: Maybe<Scalars['bigint']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
  pass_vote_count?: Maybe<Scalars['bigint']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
  proposal_vote_count?: Maybe<Scalars['bigint']['output']>;
  proposal_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
  proposer_id?: Maybe<Scalars['bigint']['output']>;
  quorum_count?: Maybe<Scalars['bigint']['output']>;
  quorum_smvn_total?: Maybe<Scalars['float8']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['smallint']['output']>;
  success_reward?: Maybe<Scalars['float8']['output']>;
  total_voters_reward?: Maybe<Scalars['float8']['output']>;
  yay_vote_count?: Maybe<Scalars['bigint']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "governance_proposal" */
export type Governance_Proposal_Sum_Order_By = {
  current_cycle_end_level?: InputMaybe<Order_By>;
  current_cycle_start_level?: InputMaybe<Order_By>;
  cycle?: InputMaybe<Order_By>;
  execution_counter?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  min_proposal_round_vote_pct?: InputMaybe<Order_By>;
  min_proposal_round_vote_req?: InputMaybe<Order_By>;
  min_quorum_percentage?: InputMaybe<Order_By>;
  min_yay_vote_percentage?: InputMaybe<Order_By>;
  nay_vote_count?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_count?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  proposal_vote_count?: InputMaybe<Order_By>;
  proposal_vote_smvn_total?: InputMaybe<Order_By>;
  proposer_id?: InputMaybe<Order_By>;
  quorum_count?: InputMaybe<Order_By>;
  quorum_smvn_total?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  success_reward?: InputMaybe<Order_By>;
  total_voters_reward?: InputMaybe<Order_By>;
  yay_vote_count?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_Proposal_Var_Pop_Fields = {
  __typename?: 'governance_proposal_var_pop_fields';
  current_cycle_end_level?: Maybe<Scalars['Float']['output']>;
  current_cycle_start_level?: Maybe<Scalars['Float']['output']>;
  cycle?: Maybe<Scalars['Float']['output']>;
  execution_counter?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  min_proposal_round_vote_pct?: Maybe<Scalars['Float']['output']>;
  min_proposal_round_vote_req?: Maybe<Scalars['Float']['output']>;
  min_quorum_percentage?: Maybe<Scalars['Float']['output']>;
  min_yay_vote_percentage?: Maybe<Scalars['Float']['output']>;
  nay_vote_count?: Maybe<Scalars['Float']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  pass_vote_count?: Maybe<Scalars['Float']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  proposal_vote_count?: Maybe<Scalars['Float']['output']>;
  proposal_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  proposer_id?: Maybe<Scalars['Float']['output']>;
  quorum_count?: Maybe<Scalars['Float']['output']>;
  quorum_smvn_total?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['Float']['output']>;
  success_reward?: Maybe<Scalars['Float']['output']>;
  total_voters_reward?: Maybe<Scalars['Float']['output']>;
  yay_vote_count?: Maybe<Scalars['Float']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_proposal" */
export type Governance_Proposal_Var_Pop_Order_By = {
  current_cycle_end_level?: InputMaybe<Order_By>;
  current_cycle_start_level?: InputMaybe<Order_By>;
  cycle?: InputMaybe<Order_By>;
  execution_counter?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  min_proposal_round_vote_pct?: InputMaybe<Order_By>;
  min_proposal_round_vote_req?: InputMaybe<Order_By>;
  min_quorum_percentage?: InputMaybe<Order_By>;
  min_yay_vote_percentage?: InputMaybe<Order_By>;
  nay_vote_count?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_count?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  proposal_vote_count?: InputMaybe<Order_By>;
  proposal_vote_smvn_total?: InputMaybe<Order_By>;
  proposer_id?: InputMaybe<Order_By>;
  quorum_count?: InputMaybe<Order_By>;
  quorum_smvn_total?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  success_reward?: InputMaybe<Order_By>;
  total_voters_reward?: InputMaybe<Order_By>;
  yay_vote_count?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_Proposal_Var_Samp_Fields = {
  __typename?: 'governance_proposal_var_samp_fields';
  current_cycle_end_level?: Maybe<Scalars['Float']['output']>;
  current_cycle_start_level?: Maybe<Scalars['Float']['output']>;
  cycle?: Maybe<Scalars['Float']['output']>;
  execution_counter?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  min_proposal_round_vote_pct?: Maybe<Scalars['Float']['output']>;
  min_proposal_round_vote_req?: Maybe<Scalars['Float']['output']>;
  min_quorum_percentage?: Maybe<Scalars['Float']['output']>;
  min_yay_vote_percentage?: Maybe<Scalars['Float']['output']>;
  nay_vote_count?: Maybe<Scalars['Float']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  pass_vote_count?: Maybe<Scalars['Float']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  proposal_vote_count?: Maybe<Scalars['Float']['output']>;
  proposal_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  proposer_id?: Maybe<Scalars['Float']['output']>;
  quorum_count?: Maybe<Scalars['Float']['output']>;
  quorum_smvn_total?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['Float']['output']>;
  success_reward?: Maybe<Scalars['Float']['output']>;
  total_voters_reward?: Maybe<Scalars['Float']['output']>;
  yay_vote_count?: Maybe<Scalars['Float']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_proposal" */
export type Governance_Proposal_Var_Samp_Order_By = {
  current_cycle_end_level?: InputMaybe<Order_By>;
  current_cycle_start_level?: InputMaybe<Order_By>;
  cycle?: InputMaybe<Order_By>;
  execution_counter?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  min_proposal_round_vote_pct?: InputMaybe<Order_By>;
  min_proposal_round_vote_req?: InputMaybe<Order_By>;
  min_quorum_percentage?: InputMaybe<Order_By>;
  min_yay_vote_percentage?: InputMaybe<Order_By>;
  nay_vote_count?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_count?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  proposal_vote_count?: InputMaybe<Order_By>;
  proposal_vote_smvn_total?: InputMaybe<Order_By>;
  proposer_id?: InputMaybe<Order_By>;
  quorum_count?: InputMaybe<Order_By>;
  quorum_smvn_total?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  success_reward?: InputMaybe<Order_By>;
  total_voters_reward?: InputMaybe<Order_By>;
  yay_vote_count?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_Proposal_Variance_Fields = {
  __typename?: 'governance_proposal_variance_fields';
  current_cycle_end_level?: Maybe<Scalars['Float']['output']>;
  current_cycle_start_level?: Maybe<Scalars['Float']['output']>;
  cycle?: Maybe<Scalars['Float']['output']>;
  execution_counter?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  min_proposal_round_vote_pct?: Maybe<Scalars['Float']['output']>;
  min_proposal_round_vote_req?: Maybe<Scalars['Float']['output']>;
  min_quorum_percentage?: Maybe<Scalars['Float']['output']>;
  min_yay_vote_percentage?: Maybe<Scalars['Float']['output']>;
  nay_vote_count?: Maybe<Scalars['Float']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  pass_vote_count?: Maybe<Scalars['Float']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  proposal_vote_count?: Maybe<Scalars['Float']['output']>;
  proposal_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  proposer_id?: Maybe<Scalars['Float']['output']>;
  quorum_count?: Maybe<Scalars['Float']['output']>;
  quorum_smvn_total?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['Float']['output']>;
  success_reward?: Maybe<Scalars['Float']['output']>;
  total_voters_reward?: Maybe<Scalars['Float']['output']>;
  yay_vote_count?: Maybe<Scalars['Float']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_proposal" */
export type Governance_Proposal_Variance_Order_By = {
  current_cycle_end_level?: InputMaybe<Order_By>;
  current_cycle_start_level?: InputMaybe<Order_By>;
  cycle?: InputMaybe<Order_By>;
  execution_counter?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  min_proposal_round_vote_pct?: InputMaybe<Order_By>;
  min_proposal_round_vote_req?: InputMaybe<Order_By>;
  min_quorum_percentage?: InputMaybe<Order_By>;
  min_yay_vote_percentage?: InputMaybe<Order_By>;
  nay_vote_count?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_count?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  proposal_vote_count?: InputMaybe<Order_By>;
  proposal_vote_smvn_total?: InputMaybe<Order_By>;
  proposer_id?: InputMaybe<Order_By>;
  quorum_count?: InputMaybe<Order_By>;
  quorum_smvn_total?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  success_reward?: InputMaybe<Order_By>;
  total_voters_reward?: InputMaybe<Order_By>;
  yay_vote_count?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** columns and relationships of "governance_proposal_vote" */
export type Governance_Proposal_Vote = {
  __typename?: 'governance_proposal_vote';
  current_round_vote: Scalars['Boolean']['output'];
  /** An object relationship */
  governance_proposal: Governance_Proposal;
  governance_proposal_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  round: Scalars['smallint']['output'];
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote: Scalars['smallint']['output'];
  /** An object relationship */
  voter: Maven_User;
  voter_id: Scalars['bigint']['output'];
  voting_power: Scalars['float8']['output'];
  voting_reward_claimed: Scalars['Boolean']['output'];
};

/** aggregated selection of "governance_proposal_vote" */
export type Governance_Proposal_Vote_Aggregate = {
  __typename?: 'governance_proposal_vote_aggregate';
  aggregate?: Maybe<Governance_Proposal_Vote_Aggregate_Fields>;
  nodes: Array<Governance_Proposal_Vote>;
};

export type Governance_Proposal_Vote_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Governance_Proposal_Vote_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Governance_Proposal_Vote_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Governance_Proposal_Vote_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Governance_Proposal_Vote_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Governance_Proposal_Vote_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Governance_Proposal_Vote_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Governance_Proposal_Vote_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Governance_Proposal_Vote_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Governance_Proposal_Vote_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Governance_Proposal_Vote_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Governance_Proposal_Vote_Aggregate_Bool_Exp_Var_Samp>;
};

export type Governance_Proposal_Vote_Aggregate_Bool_Exp_Avg = {
  arguments: Governance_Proposal_Vote_Select_Column_Governance_Proposal_Vote_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Vote_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Proposal_Vote_Aggregate_Bool_Exp_Bool_And = {
  arguments: Governance_Proposal_Vote_Select_Column_Governance_Proposal_Vote_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Vote_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Governance_Proposal_Vote_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Governance_Proposal_Vote_Select_Column_Governance_Proposal_Vote_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Vote_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Governance_Proposal_Vote_Aggregate_Bool_Exp_Corr = {
  arguments: Governance_Proposal_Vote_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Vote_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Proposal_Vote_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Governance_Proposal_Vote_Select_Column_Governance_Proposal_Vote_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Governance_Proposal_Vote_Select_Column_Governance_Proposal_Vote_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Governance_Proposal_Vote_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_Proposal_Vote_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Vote_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Governance_Proposal_Vote_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Governance_Proposal_Vote_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Vote_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Proposal_Vote_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Governance_Proposal_Vote_Select_Column_Governance_Proposal_Vote_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Governance_Proposal_Vote_Select_Column_Governance_Proposal_Vote_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Governance_Proposal_Vote_Aggregate_Bool_Exp_Max = {
  arguments: Governance_Proposal_Vote_Select_Column_Governance_Proposal_Vote_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Vote_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Proposal_Vote_Aggregate_Bool_Exp_Min = {
  arguments: Governance_Proposal_Vote_Select_Column_Governance_Proposal_Vote_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Vote_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Proposal_Vote_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Governance_Proposal_Vote_Select_Column_Governance_Proposal_Vote_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Vote_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Proposal_Vote_Aggregate_Bool_Exp_Sum = {
  arguments: Governance_Proposal_Vote_Select_Column_Governance_Proposal_Vote_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Vote_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Proposal_Vote_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Governance_Proposal_Vote_Select_Column_Governance_Proposal_Vote_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proposal_Vote_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "governance_proposal_vote" */
export type Governance_Proposal_Vote_Aggregate_Fields = {
  __typename?: 'governance_proposal_vote_aggregate_fields';
  avg?: Maybe<Governance_Proposal_Vote_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Proposal_Vote_Max_Fields>;
  min?: Maybe<Governance_Proposal_Vote_Min_Fields>;
  stddev?: Maybe<Governance_Proposal_Vote_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Proposal_Vote_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Proposal_Vote_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Proposal_Vote_Sum_Fields>;
  var_pop?: Maybe<Governance_Proposal_Vote_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Proposal_Vote_Var_Samp_Fields>;
  variance?: Maybe<Governance_Proposal_Vote_Variance_Fields>;
};


/** aggregate fields of "governance_proposal_vote" */
export type Governance_Proposal_Vote_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Proposal_Vote_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_proposal_vote" */
export type Governance_Proposal_Vote_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_Proposal_Vote_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_Proposal_Vote_Max_Order_By>;
  min?: InputMaybe<Governance_Proposal_Vote_Min_Order_By>;
  stddev?: InputMaybe<Governance_Proposal_Vote_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_Proposal_Vote_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_Proposal_Vote_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_Proposal_Vote_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_Proposal_Vote_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_Proposal_Vote_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_Proposal_Vote_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Governance_Proposal_Vote_Avg_Fields = {
  __typename?: 'governance_proposal_vote_avg_fields';
  governance_proposal_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  round?: Maybe<Scalars['Float']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
  voting_power?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_proposal_vote" */
export type Governance_Proposal_Vote_Avg_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  round?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
  voting_power?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_proposal_vote". All fields are combined with a logical 'AND'. */
export type Governance_Proposal_Vote_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Proposal_Vote_Bool_Exp>>;
  _not?: InputMaybe<Governance_Proposal_Vote_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Proposal_Vote_Bool_Exp>>;
  current_round_vote?: InputMaybe<Boolean_Comparison_Exp>;
  governance_proposal?: InputMaybe<Governance_Proposal_Bool_Exp>;
  governance_proposal_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  round?: InputMaybe<Smallint_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  vote?: InputMaybe<Smallint_Comparison_Exp>;
  voter?: InputMaybe<Maven_User_Bool_Exp>;
  voter_id?: InputMaybe<Bigint_Comparison_Exp>;
  voting_power?: InputMaybe<Float8_Comparison_Exp>;
  voting_reward_claimed?: InputMaybe<Boolean_Comparison_Exp>;
};

/** aggregate max on columns */
export type Governance_Proposal_Vote_Max_Fields = {
  __typename?: 'governance_proposal_vote_max_fields';
  governance_proposal_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  round?: Maybe<Scalars['smallint']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['smallint']['output']>;
  voter_id?: Maybe<Scalars['bigint']['output']>;
  voting_power?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "governance_proposal_vote" */
export type Governance_Proposal_Vote_Max_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  round?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
  voting_power?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_Proposal_Vote_Min_Fields = {
  __typename?: 'governance_proposal_vote_min_fields';
  governance_proposal_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  round?: Maybe<Scalars['smallint']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['smallint']['output']>;
  voter_id?: Maybe<Scalars['bigint']['output']>;
  voting_power?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "governance_proposal_vote" */
export type Governance_Proposal_Vote_Min_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  round?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
  voting_power?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_proposal_vote". */
export type Governance_Proposal_Vote_Order_By = {
  current_round_vote?: InputMaybe<Order_By>;
  governance_proposal?: InputMaybe<Governance_Proposal_Order_By>;
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  round?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  vote?: InputMaybe<Order_By>;
  voter?: InputMaybe<Maven_User_Order_By>;
  voter_id?: InputMaybe<Order_By>;
  voting_power?: InputMaybe<Order_By>;
  voting_reward_claimed?: InputMaybe<Order_By>;
};

/** select columns of table "governance_proposal_vote" */
export enum Governance_Proposal_Vote_Select_Column {
  /** column name */
  CurrentRoundVote = 'current_round_vote',
  /** column name */
  GovernanceProposalId = 'governance_proposal_id',
  /** column name */
  Id = 'id',
  /** column name */
  Round = 'round',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Vote = 'vote',
  /** column name */
  VoterId = 'voter_id',
  /** column name */
  VotingPower = 'voting_power',
  /** column name */
  VotingRewardClaimed = 'voting_reward_claimed'
}

/** select "governance_proposal_vote_aggregate_bool_exp_avg_arguments_columns" columns of table "governance_proposal_vote" */
export enum Governance_Proposal_Vote_Select_Column_Governance_Proposal_Vote_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  VotingPower = 'voting_power'
}

/** select "governance_proposal_vote_aggregate_bool_exp_bool_and_arguments_columns" columns of table "governance_proposal_vote" */
export enum Governance_Proposal_Vote_Select_Column_Governance_Proposal_Vote_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CurrentRoundVote = 'current_round_vote',
  /** column name */
  VotingRewardClaimed = 'voting_reward_claimed'
}

/** select "governance_proposal_vote_aggregate_bool_exp_bool_or_arguments_columns" columns of table "governance_proposal_vote" */
export enum Governance_Proposal_Vote_Select_Column_Governance_Proposal_Vote_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CurrentRoundVote = 'current_round_vote',
  /** column name */
  VotingRewardClaimed = 'voting_reward_claimed'
}

/** select "governance_proposal_vote_aggregate_bool_exp_corr_arguments_columns" columns of table "governance_proposal_vote" */
export enum Governance_Proposal_Vote_Select_Column_Governance_Proposal_Vote_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  VotingPower = 'voting_power'
}

/** select "governance_proposal_vote_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "governance_proposal_vote" */
export enum Governance_Proposal_Vote_Select_Column_Governance_Proposal_Vote_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  VotingPower = 'voting_power'
}

/** select "governance_proposal_vote_aggregate_bool_exp_max_arguments_columns" columns of table "governance_proposal_vote" */
export enum Governance_Proposal_Vote_Select_Column_Governance_Proposal_Vote_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  VotingPower = 'voting_power'
}

/** select "governance_proposal_vote_aggregate_bool_exp_min_arguments_columns" columns of table "governance_proposal_vote" */
export enum Governance_Proposal_Vote_Select_Column_Governance_Proposal_Vote_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  VotingPower = 'voting_power'
}

/** select "governance_proposal_vote_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "governance_proposal_vote" */
export enum Governance_Proposal_Vote_Select_Column_Governance_Proposal_Vote_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  VotingPower = 'voting_power'
}

/** select "governance_proposal_vote_aggregate_bool_exp_sum_arguments_columns" columns of table "governance_proposal_vote" */
export enum Governance_Proposal_Vote_Select_Column_Governance_Proposal_Vote_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  VotingPower = 'voting_power'
}

/** select "governance_proposal_vote_aggregate_bool_exp_var_samp_arguments_columns" columns of table "governance_proposal_vote" */
export enum Governance_Proposal_Vote_Select_Column_Governance_Proposal_Vote_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  VotingPower = 'voting_power'
}

/** aggregate stddev on columns */
export type Governance_Proposal_Vote_Stddev_Fields = {
  __typename?: 'governance_proposal_vote_stddev_fields';
  governance_proposal_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  round?: Maybe<Scalars['Float']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
  voting_power?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_proposal_vote" */
export type Governance_Proposal_Vote_Stddev_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  round?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
  voting_power?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_Proposal_Vote_Stddev_Pop_Fields = {
  __typename?: 'governance_proposal_vote_stddev_pop_fields';
  governance_proposal_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  round?: Maybe<Scalars['Float']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
  voting_power?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_proposal_vote" */
export type Governance_Proposal_Vote_Stddev_Pop_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  round?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
  voting_power?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_Proposal_Vote_Stddev_Samp_Fields = {
  __typename?: 'governance_proposal_vote_stddev_samp_fields';
  governance_proposal_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  round?: Maybe<Scalars['Float']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
  voting_power?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_proposal_vote" */
export type Governance_Proposal_Vote_Stddev_Samp_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  round?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
  voting_power?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_proposal_vote" */
export type Governance_Proposal_Vote_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Proposal_Vote_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Proposal_Vote_Stream_Cursor_Value_Input = {
  current_round_vote?: InputMaybe<Scalars['Boolean']['input']>;
  governance_proposal_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  round?: InputMaybe<Scalars['smallint']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Scalars['smallint']['input']>;
  voter_id?: InputMaybe<Scalars['bigint']['input']>;
  voting_power?: InputMaybe<Scalars['float8']['input']>;
  voting_reward_claimed?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Governance_Proposal_Vote_Sum_Fields = {
  __typename?: 'governance_proposal_vote_sum_fields';
  governance_proposal_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  round?: Maybe<Scalars['smallint']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['smallint']['output']>;
  voter_id?: Maybe<Scalars['bigint']['output']>;
  voting_power?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "governance_proposal_vote" */
export type Governance_Proposal_Vote_Sum_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  round?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
  voting_power?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_Proposal_Vote_Var_Pop_Fields = {
  __typename?: 'governance_proposal_vote_var_pop_fields';
  governance_proposal_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  round?: Maybe<Scalars['Float']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
  voting_power?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_proposal_vote" */
export type Governance_Proposal_Vote_Var_Pop_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  round?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
  voting_power?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_Proposal_Vote_Var_Samp_Fields = {
  __typename?: 'governance_proposal_vote_var_samp_fields';
  governance_proposal_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  round?: Maybe<Scalars['Float']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
  voting_power?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_proposal_vote" */
export type Governance_Proposal_Vote_Var_Samp_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  round?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
  voting_power?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_Proposal_Vote_Variance_Fields = {
  __typename?: 'governance_proposal_vote_variance_fields';
  governance_proposal_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  round?: Maybe<Scalars['Float']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
  voting_power?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_proposal_vote" */
export type Governance_Proposal_Vote_Variance_Order_By = {
  governance_proposal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  round?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
  voting_power?: InputMaybe<Order_By>;
};

/** columns and relationships of "governance_proxy" */
export type Governance_Proxy = {
  __typename?: 'governance_proxy';
  address: Scalars['String']['output'];
  admin: Scalars['String']['output'];
  /** An object relationship */
  governance: Governance;
  governance_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An array relationship */
  lambdas: Array<Governance_Proxy_Lambda>;
  /** An aggregate relationship */
  lambdas_aggregate: Governance_Proxy_Lambda_Aggregate;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  network: Scalars['String']['output'];
};


/** columns and relationships of "governance_proxy" */
export type Governance_ProxyLambdasArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proxy_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proxy_Lambda_Order_By>>;
  where?: InputMaybe<Governance_Proxy_Lambda_Bool_Exp>;
};


/** columns and relationships of "governance_proxy" */
export type Governance_ProxyLambdas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proxy_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proxy_Lambda_Order_By>>;
  where?: InputMaybe<Governance_Proxy_Lambda_Bool_Exp>;
};


/** columns and relationships of "governance_proxy" */
export type Governance_ProxyMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "governance_proxy" */
export type Governance_Proxy_Aggregate = {
  __typename?: 'governance_proxy_aggregate';
  aggregate?: Maybe<Governance_Proxy_Aggregate_Fields>;
  nodes: Array<Governance_Proxy>;
};

export type Governance_Proxy_Aggregate_Bool_Exp = {
  count?: InputMaybe<Governance_Proxy_Aggregate_Bool_Exp_Count>;
};

export type Governance_Proxy_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_Proxy_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proxy_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "governance_proxy" */
export type Governance_Proxy_Aggregate_Fields = {
  __typename?: 'governance_proxy_aggregate_fields';
  avg?: Maybe<Governance_Proxy_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Proxy_Max_Fields>;
  min?: Maybe<Governance_Proxy_Min_Fields>;
  stddev?: Maybe<Governance_Proxy_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Proxy_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Proxy_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Proxy_Sum_Fields>;
  var_pop?: Maybe<Governance_Proxy_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Proxy_Var_Samp_Fields>;
  variance?: Maybe<Governance_Proxy_Variance_Fields>;
};


/** aggregate fields of "governance_proxy" */
export type Governance_Proxy_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Proxy_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_proxy" */
export type Governance_Proxy_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_Proxy_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_Proxy_Max_Order_By>;
  min?: InputMaybe<Governance_Proxy_Min_Order_By>;
  stddev?: InputMaybe<Governance_Proxy_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_Proxy_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_Proxy_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_Proxy_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_Proxy_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_Proxy_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_Proxy_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Governance_Proxy_Avg_Fields = {
  __typename?: 'governance_proxy_avg_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_proxy" */
export type Governance_Proxy_Avg_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_proxy". All fields are combined with a logical 'AND'. */
export type Governance_Proxy_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Proxy_Bool_Exp>>;
  _not?: InputMaybe<Governance_Proxy_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Proxy_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  admin?: InputMaybe<String_Comparison_Exp>;
  governance?: InputMaybe<Governance_Bool_Exp>;
  governance_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambdas?: InputMaybe<Governance_Proxy_Lambda_Bool_Exp>;
  lambdas_aggregate?: InputMaybe<Governance_Proxy_Lambda_Aggregate_Bool_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "governance_proxy_lambda" */
export type Governance_Proxy_Lambda = {
  __typename?: 'governance_proxy_lambda';
  /** An object relationship */
  contract: Governance_Proxy;
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lambda_bytes: Scalars['String']['output'];
  lambda_name: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "governance_proxy_lambda" */
export type Governance_Proxy_Lambda_Aggregate = {
  __typename?: 'governance_proxy_lambda_aggregate';
  aggregate?: Maybe<Governance_Proxy_Lambda_Aggregate_Fields>;
  nodes: Array<Governance_Proxy_Lambda>;
};

export type Governance_Proxy_Lambda_Aggregate_Bool_Exp = {
  count?: InputMaybe<Governance_Proxy_Lambda_Aggregate_Bool_Exp_Count>;
};

export type Governance_Proxy_Lambda_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_Proxy_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Proxy_Lambda_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "governance_proxy_lambda" */
export type Governance_Proxy_Lambda_Aggregate_Fields = {
  __typename?: 'governance_proxy_lambda_aggregate_fields';
  avg?: Maybe<Governance_Proxy_Lambda_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Proxy_Lambda_Max_Fields>;
  min?: Maybe<Governance_Proxy_Lambda_Min_Fields>;
  stddev?: Maybe<Governance_Proxy_Lambda_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Proxy_Lambda_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Proxy_Lambda_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Proxy_Lambda_Sum_Fields>;
  var_pop?: Maybe<Governance_Proxy_Lambda_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Proxy_Lambda_Var_Samp_Fields>;
  variance?: Maybe<Governance_Proxy_Lambda_Variance_Fields>;
};


/** aggregate fields of "governance_proxy_lambda" */
export type Governance_Proxy_Lambda_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Proxy_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_proxy_lambda" */
export type Governance_Proxy_Lambda_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_Proxy_Lambda_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_Proxy_Lambda_Max_Order_By>;
  min?: InputMaybe<Governance_Proxy_Lambda_Min_Order_By>;
  stddev?: InputMaybe<Governance_Proxy_Lambda_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_Proxy_Lambda_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_Proxy_Lambda_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_Proxy_Lambda_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_Proxy_Lambda_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_Proxy_Lambda_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_Proxy_Lambda_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Governance_Proxy_Lambda_Avg_Fields = {
  __typename?: 'governance_proxy_lambda_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_proxy_lambda" */
export type Governance_Proxy_Lambda_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_proxy_lambda". All fields are combined with a logical 'AND'. */
export type Governance_Proxy_Lambda_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Proxy_Lambda_Bool_Exp>>;
  _not?: InputMaybe<Governance_Proxy_Lambda_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Proxy_Lambda_Bool_Exp>>;
  contract?: InputMaybe<Governance_Proxy_Bool_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambda_bytes?: InputMaybe<String_Comparison_Exp>;
  lambda_name?: InputMaybe<String_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Governance_Proxy_Lambda_Max_Fields = {
  __typename?: 'governance_proxy_lambda_max_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "governance_proxy_lambda" */
export type Governance_Proxy_Lambda_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_Proxy_Lambda_Min_Fields = {
  __typename?: 'governance_proxy_lambda_min_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "governance_proxy_lambda" */
export type Governance_Proxy_Lambda_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_proxy_lambda". */
export type Governance_Proxy_Lambda_Order_By = {
  contract?: InputMaybe<Governance_Proxy_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "governance_proxy_lambda" */
export enum Governance_Proxy_Lambda_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaBytes = 'lambda_bytes',
  /** column name */
  LambdaName = 'lambda_name',
  /** column name */
  LastUpdatedAt = 'last_updated_at'
}

/** aggregate stddev on columns */
export type Governance_Proxy_Lambda_Stddev_Fields = {
  __typename?: 'governance_proxy_lambda_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_proxy_lambda" */
export type Governance_Proxy_Lambda_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_Proxy_Lambda_Stddev_Pop_Fields = {
  __typename?: 'governance_proxy_lambda_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_proxy_lambda" */
export type Governance_Proxy_Lambda_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_Proxy_Lambda_Stddev_Samp_Fields = {
  __typename?: 'governance_proxy_lambda_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_proxy_lambda" */
export type Governance_Proxy_Lambda_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_proxy_lambda" */
export type Governance_Proxy_Lambda_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Proxy_Lambda_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Proxy_Lambda_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lambda_bytes?: InputMaybe<Scalars['String']['input']>;
  lambda_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Governance_Proxy_Lambda_Sum_Fields = {
  __typename?: 'governance_proxy_lambda_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "governance_proxy_lambda" */
export type Governance_Proxy_Lambda_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_Proxy_Lambda_Var_Pop_Fields = {
  __typename?: 'governance_proxy_lambda_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_proxy_lambda" */
export type Governance_Proxy_Lambda_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_Proxy_Lambda_Var_Samp_Fields = {
  __typename?: 'governance_proxy_lambda_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_proxy_lambda" */
export type Governance_Proxy_Lambda_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_Proxy_Lambda_Variance_Fields = {
  __typename?: 'governance_proxy_lambda_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_proxy_lambda" */
export type Governance_Proxy_Lambda_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Governance_Proxy_Max_Fields = {
  __typename?: 'governance_proxy_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  network?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "governance_proxy" */
export type Governance_Proxy_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_Proxy_Min_Fields = {
  __typename?: 'governance_proxy_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  network?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "governance_proxy" */
export type Governance_Proxy_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_proxy". */
export type Governance_Proxy_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  governance?: InputMaybe<Governance_Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambdas_aggregate?: InputMaybe<Governance_Proxy_Lambda_Aggregate_Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
};

/** select columns of table "governance_proxy" */
export enum Governance_Proxy_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Admin = 'admin',
  /** column name */
  GovernanceId = 'governance_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Network = 'network'
}

/** aggregate stddev on columns */
export type Governance_Proxy_Stddev_Fields = {
  __typename?: 'governance_proxy_stddev_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_proxy" */
export type Governance_Proxy_Stddev_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_Proxy_Stddev_Pop_Fields = {
  __typename?: 'governance_proxy_stddev_pop_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_proxy" */
export type Governance_Proxy_Stddev_Pop_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_Proxy_Stddev_Samp_Fields = {
  __typename?: 'governance_proxy_stddev_samp_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_proxy" */
export type Governance_Proxy_Stddev_Samp_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_proxy" */
export type Governance_Proxy_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Proxy_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Proxy_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['String']['input']>;
  governance_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Governance_Proxy_Sum_Fields = {
  __typename?: 'governance_proxy_sum_fields';
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "governance_proxy" */
export type Governance_Proxy_Sum_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_Proxy_Var_Pop_Fields = {
  __typename?: 'governance_proxy_var_pop_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_proxy" */
export type Governance_Proxy_Var_Pop_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_Proxy_Var_Samp_Fields = {
  __typename?: 'governance_proxy_var_samp_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_proxy" */
export type Governance_Proxy_Var_Samp_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_Proxy_Variance_Fields = {
  __typename?: 'governance_proxy_variance_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_proxy" */
export type Governance_Proxy_Variance_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "governance_satellite" */
export type Governance_Satellite = {
  __typename?: 'governance_satellite';
  /** An array relationship */
  actions: Array<Governance_Satellite_Action>;
  /** An aggregate relationship */
  actions_aggregate: Governance_Satellite_Action_Aggregate;
  address: Scalars['String']['output'];
  admin: Scalars['String']['output'];
  approval_percentage: Scalars['smallint']['output'];
  /** An array relationship */
  general_contracts: Array<Governance_Satellite_General_Contract>;
  /** An aggregate relationship */
  general_contracts_aggregate: Governance_Satellite_General_Contract_Aggregate;
  gov_purpose_max_length: Scalars['smallint']['output'];
  /** An object relationship */
  governance: Governance;
  governance_id: Scalars['bigint']['output'];
  governance_satellite_counter: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An array relationship */
  lambdas: Array<Governance_Satellite_Lambda>;
  /** An aggregate relationship */
  lambdas_aggregate: Governance_Satellite_Lambda_Aggregate;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  max_actions_per_satellite: Scalars['smallint']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  network: Scalars['String']['output'];
  /** An array relationship */
  oracles: Array<Governance_Satellite_Oracle>;
  /** An aggregate relationship */
  oracles_aggregate: Governance_Satellite_Oracle_Aggregate;
  sat_action_duration_in_days: Scalars['smallint']['output'];
  /** An array relationship */
  whitelist_contracts: Array<Governance_Satellite_Whitelist_Contract>;
  /** An aggregate relationship */
  whitelist_contracts_aggregate: Governance_Satellite_Whitelist_Contract_Aggregate;
};


/** columns and relationships of "governance_satellite" */
export type Governance_SatelliteActionsArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Action_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Action_Bool_Exp>;
};


/** columns and relationships of "governance_satellite" */
export type Governance_SatelliteActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Action_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Action_Bool_Exp>;
};


/** columns and relationships of "governance_satellite" */
export type Governance_SatelliteGeneral_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_General_Contract_Order_By>>;
  where?: InputMaybe<Governance_Satellite_General_Contract_Bool_Exp>;
};


/** columns and relationships of "governance_satellite" */
export type Governance_SatelliteGeneral_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_General_Contract_Order_By>>;
  where?: InputMaybe<Governance_Satellite_General_Contract_Bool_Exp>;
};


/** columns and relationships of "governance_satellite" */
export type Governance_SatelliteLambdasArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Lambda_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Lambda_Bool_Exp>;
};


/** columns and relationships of "governance_satellite" */
export type Governance_SatelliteLambdas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Lambda_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Lambda_Bool_Exp>;
};


/** columns and relationships of "governance_satellite" */
export type Governance_SatelliteMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "governance_satellite" */
export type Governance_SatelliteOraclesArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Oracle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Oracle_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Oracle_Bool_Exp>;
};


/** columns and relationships of "governance_satellite" */
export type Governance_SatelliteOracles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Oracle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Oracle_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Oracle_Bool_Exp>;
};


/** columns and relationships of "governance_satellite" */
export type Governance_SatelliteWhitelist_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Whitelist_Contract_Bool_Exp>;
};


/** columns and relationships of "governance_satellite" */
export type Governance_SatelliteWhitelist_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Whitelist_Contract_Bool_Exp>;
};

/** columns and relationships of "governance_satellite_action" */
export type Governance_Satellite_Action = {
  __typename?: 'governance_satellite_action';
  dropped_datetime?: Maybe<Scalars['timestamptz']['output']>;
  executed: Scalars['Boolean']['output'];
  execution_datetime?: Maybe<Scalars['timestamptz']['output']>;
  expiration_datetime?: Maybe<Scalars['timestamptz']['output']>;
  governance_cycle_id: Scalars['bigint']['output'];
  governance_purpose: Scalars['String']['output'];
  /** An object relationship */
  governance_satellite: Governance_Satellite;
  governance_satellite_id: Scalars['bigint']['output'];
  governance_type: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  initiator: Maven_User;
  initiator_id: Scalars['bigint']['output'];
  internal_id: Scalars['bigint']['output'];
  nay_vote_smvn_total: Scalars['float8']['output'];
  /** An array relationship */
  parameters: Array<Governance_Satellite_Action_Parameter>;
  /** An aggregate relationship */
  parameters_aggregate: Governance_Satellite_Action_Parameter_Aggregate;
  pass_vote_smvn_total: Scalars['float8']['output'];
  smvn_percentage_for_approval: Scalars['smallint']['output'];
  smvn_required_for_approval: Scalars['float8']['output'];
  snapshot_smvn_total_supply: Scalars['float8']['output'];
  start_datetime: Scalars['timestamptz']['output'];
  /** ACTIVE: 0\nDROPPED: 1 */
  status: Scalars['smallint']['output'];
  /** An array relationship */
  votes: Array<Governance_Satellite_Action_Vote>;
  /** An aggregate relationship */
  votes_aggregate: Governance_Satellite_Action_Vote_Aggregate;
  yay_vote_smvn_total: Scalars['float8']['output'];
};


/** columns and relationships of "governance_satellite_action" */
export type Governance_Satellite_ActionParametersArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Action_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Action_Parameter_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Action_Parameter_Bool_Exp>;
};


/** columns and relationships of "governance_satellite_action" */
export type Governance_Satellite_ActionParameters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Action_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Action_Parameter_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Action_Parameter_Bool_Exp>;
};


/** columns and relationships of "governance_satellite_action" */
export type Governance_Satellite_ActionVotesArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Action_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Action_Vote_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Action_Vote_Bool_Exp>;
};


/** columns and relationships of "governance_satellite_action" */
export type Governance_Satellite_ActionVotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Action_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Action_Vote_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Action_Vote_Bool_Exp>;
};

/** aggregated selection of "governance_satellite_action" */
export type Governance_Satellite_Action_Aggregate = {
  __typename?: 'governance_satellite_action_aggregate';
  aggregate?: Maybe<Governance_Satellite_Action_Aggregate_Fields>;
  nodes: Array<Governance_Satellite_Action>;
};

export type Governance_Satellite_Action_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Governance_Satellite_Action_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Governance_Satellite_Action_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Governance_Satellite_Action_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Governance_Satellite_Action_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Governance_Satellite_Action_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Governance_Satellite_Action_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Governance_Satellite_Action_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Governance_Satellite_Action_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Governance_Satellite_Action_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Governance_Satellite_Action_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Governance_Satellite_Action_Aggregate_Bool_Exp_Var_Samp>;
};

export type Governance_Satellite_Action_Aggregate_Bool_Exp_Avg = {
  arguments: Governance_Satellite_Action_Select_Column_Governance_Satellite_Action_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Action_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Satellite_Action_Aggregate_Bool_Exp_Bool_And = {
  arguments: Governance_Satellite_Action_Select_Column_Governance_Satellite_Action_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Action_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Governance_Satellite_Action_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Governance_Satellite_Action_Select_Column_Governance_Satellite_Action_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Action_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Governance_Satellite_Action_Aggregate_Bool_Exp_Corr = {
  arguments: Governance_Satellite_Action_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Action_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Satellite_Action_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Governance_Satellite_Action_Select_Column_Governance_Satellite_Action_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Governance_Satellite_Action_Select_Column_Governance_Satellite_Action_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Governance_Satellite_Action_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_Satellite_Action_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Action_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Governance_Satellite_Action_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Governance_Satellite_Action_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Action_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Satellite_Action_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Governance_Satellite_Action_Select_Column_Governance_Satellite_Action_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Governance_Satellite_Action_Select_Column_Governance_Satellite_Action_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Governance_Satellite_Action_Aggregate_Bool_Exp_Max = {
  arguments: Governance_Satellite_Action_Select_Column_Governance_Satellite_Action_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Action_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Satellite_Action_Aggregate_Bool_Exp_Min = {
  arguments: Governance_Satellite_Action_Select_Column_Governance_Satellite_Action_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Action_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Satellite_Action_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Governance_Satellite_Action_Select_Column_Governance_Satellite_Action_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Action_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Satellite_Action_Aggregate_Bool_Exp_Sum = {
  arguments: Governance_Satellite_Action_Select_Column_Governance_Satellite_Action_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Action_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Satellite_Action_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Governance_Satellite_Action_Select_Column_Governance_Satellite_Action_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Action_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "governance_satellite_action" */
export type Governance_Satellite_Action_Aggregate_Fields = {
  __typename?: 'governance_satellite_action_aggregate_fields';
  avg?: Maybe<Governance_Satellite_Action_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Satellite_Action_Max_Fields>;
  min?: Maybe<Governance_Satellite_Action_Min_Fields>;
  stddev?: Maybe<Governance_Satellite_Action_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Satellite_Action_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Satellite_Action_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Satellite_Action_Sum_Fields>;
  var_pop?: Maybe<Governance_Satellite_Action_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Satellite_Action_Var_Samp_Fields>;
  variance?: Maybe<Governance_Satellite_Action_Variance_Fields>;
};


/** aggregate fields of "governance_satellite_action" */
export type Governance_Satellite_Action_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Satellite_Action_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_satellite_action" */
export type Governance_Satellite_Action_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_Satellite_Action_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_Satellite_Action_Max_Order_By>;
  min?: InputMaybe<Governance_Satellite_Action_Min_Order_By>;
  stddev?: InputMaybe<Governance_Satellite_Action_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_Satellite_Action_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_Satellite_Action_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_Satellite_Action_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_Satellite_Action_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_Satellite_Action_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_Satellite_Action_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Governance_Satellite_Action_Avg_Fields = {
  __typename?: 'governance_satellite_action_avg_fields';
  governance_cycle_id?: Maybe<Scalars['Float']['output']>;
  governance_satellite_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initiator_id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_for_approval?: Maybe<Scalars['Float']['output']>;
  smvn_required_for_approval?: Maybe<Scalars['Float']['output']>;
  snapshot_smvn_total_supply?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['Float']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_satellite_action" */
export type Governance_Satellite_Action_Avg_Order_By = {
  governance_cycle_id?: InputMaybe<Order_By>;
  governance_satellite_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  smvn_percentage_for_approval?: InputMaybe<Order_By>;
  smvn_required_for_approval?: InputMaybe<Order_By>;
  snapshot_smvn_total_supply?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_satellite_action". All fields are combined with a logical 'AND'. */
export type Governance_Satellite_Action_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Satellite_Action_Bool_Exp>>;
  _not?: InputMaybe<Governance_Satellite_Action_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Satellite_Action_Bool_Exp>>;
  dropped_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  executed?: InputMaybe<Boolean_Comparison_Exp>;
  execution_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  expiration_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  governance_cycle_id?: InputMaybe<Bigint_Comparison_Exp>;
  governance_purpose?: InputMaybe<String_Comparison_Exp>;
  governance_satellite?: InputMaybe<Governance_Satellite_Bool_Exp>;
  governance_satellite_id?: InputMaybe<Bigint_Comparison_Exp>;
  governance_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  initiator?: InputMaybe<Maven_User_Bool_Exp>;
  initiator_id?: InputMaybe<Bigint_Comparison_Exp>;
  internal_id?: InputMaybe<Bigint_Comparison_Exp>;
  nay_vote_smvn_total?: InputMaybe<Float8_Comparison_Exp>;
  parameters?: InputMaybe<Governance_Satellite_Action_Parameter_Bool_Exp>;
  parameters_aggregate?: InputMaybe<Governance_Satellite_Action_Parameter_Aggregate_Bool_Exp>;
  pass_vote_smvn_total?: InputMaybe<Float8_Comparison_Exp>;
  smvn_percentage_for_approval?: InputMaybe<Smallint_Comparison_Exp>;
  smvn_required_for_approval?: InputMaybe<Float8_Comparison_Exp>;
  snapshot_smvn_total_supply?: InputMaybe<Float8_Comparison_Exp>;
  start_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<Smallint_Comparison_Exp>;
  votes?: InputMaybe<Governance_Satellite_Action_Vote_Bool_Exp>;
  votes_aggregate?: InputMaybe<Governance_Satellite_Action_Vote_Aggregate_Bool_Exp>;
  yay_vote_smvn_total?: InputMaybe<Float8_Comparison_Exp>;
};

/** aggregate max on columns */
export type Governance_Satellite_Action_Max_Fields = {
  __typename?: 'governance_satellite_action_max_fields';
  dropped_datetime?: Maybe<Scalars['timestamptz']['output']>;
  execution_datetime?: Maybe<Scalars['timestamptz']['output']>;
  expiration_datetime?: Maybe<Scalars['timestamptz']['output']>;
  governance_cycle_id?: Maybe<Scalars['bigint']['output']>;
  governance_purpose?: Maybe<Scalars['String']['output']>;
  governance_satellite_id?: Maybe<Scalars['bigint']['output']>;
  governance_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  initiator_id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['bigint']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
  smvn_percentage_for_approval?: Maybe<Scalars['smallint']['output']>;
  smvn_required_for_approval?: Maybe<Scalars['float8']['output']>;
  snapshot_smvn_total_supply?: Maybe<Scalars['float8']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['smallint']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "governance_satellite_action" */
export type Governance_Satellite_Action_Max_Order_By = {
  dropped_datetime?: InputMaybe<Order_By>;
  execution_datetime?: InputMaybe<Order_By>;
  expiration_datetime?: InputMaybe<Order_By>;
  governance_cycle_id?: InputMaybe<Order_By>;
  governance_purpose?: InputMaybe<Order_By>;
  governance_satellite_id?: InputMaybe<Order_By>;
  governance_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  smvn_percentage_for_approval?: InputMaybe<Order_By>;
  smvn_required_for_approval?: InputMaybe<Order_By>;
  snapshot_smvn_total_supply?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_Satellite_Action_Min_Fields = {
  __typename?: 'governance_satellite_action_min_fields';
  dropped_datetime?: Maybe<Scalars['timestamptz']['output']>;
  execution_datetime?: Maybe<Scalars['timestamptz']['output']>;
  expiration_datetime?: Maybe<Scalars['timestamptz']['output']>;
  governance_cycle_id?: Maybe<Scalars['bigint']['output']>;
  governance_purpose?: Maybe<Scalars['String']['output']>;
  governance_satellite_id?: Maybe<Scalars['bigint']['output']>;
  governance_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  initiator_id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['bigint']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
  smvn_percentage_for_approval?: Maybe<Scalars['smallint']['output']>;
  smvn_required_for_approval?: Maybe<Scalars['float8']['output']>;
  snapshot_smvn_total_supply?: Maybe<Scalars['float8']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['smallint']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "governance_satellite_action" */
export type Governance_Satellite_Action_Min_Order_By = {
  dropped_datetime?: InputMaybe<Order_By>;
  execution_datetime?: InputMaybe<Order_By>;
  expiration_datetime?: InputMaybe<Order_By>;
  governance_cycle_id?: InputMaybe<Order_By>;
  governance_purpose?: InputMaybe<Order_By>;
  governance_satellite_id?: InputMaybe<Order_By>;
  governance_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  smvn_percentage_for_approval?: InputMaybe<Order_By>;
  smvn_required_for_approval?: InputMaybe<Order_By>;
  snapshot_smvn_total_supply?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_satellite_action". */
export type Governance_Satellite_Action_Order_By = {
  dropped_datetime?: InputMaybe<Order_By>;
  executed?: InputMaybe<Order_By>;
  execution_datetime?: InputMaybe<Order_By>;
  expiration_datetime?: InputMaybe<Order_By>;
  governance_cycle_id?: InputMaybe<Order_By>;
  governance_purpose?: InputMaybe<Order_By>;
  governance_satellite?: InputMaybe<Governance_Satellite_Order_By>;
  governance_satellite_id?: InputMaybe<Order_By>;
  governance_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator?: InputMaybe<Maven_User_Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  parameters_aggregate?: InputMaybe<Governance_Satellite_Action_Parameter_Aggregate_Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  smvn_percentage_for_approval?: InputMaybe<Order_By>;
  smvn_required_for_approval?: InputMaybe<Order_By>;
  snapshot_smvn_total_supply?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  votes_aggregate?: InputMaybe<Governance_Satellite_Action_Vote_Aggregate_Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** columns and relationships of "governance_satellite_action_parameter" */
export type Governance_Satellite_Action_Parameter = {
  __typename?: 'governance_satellite_action_parameter';
  /** An object relationship */
  governance_satellite_action: Governance_Satellite_Action;
  governance_satellite_action_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "governance_satellite_action_parameter" */
export type Governance_Satellite_Action_Parameter_Aggregate = {
  __typename?: 'governance_satellite_action_parameter_aggregate';
  aggregate?: Maybe<Governance_Satellite_Action_Parameter_Aggregate_Fields>;
  nodes: Array<Governance_Satellite_Action_Parameter>;
};

export type Governance_Satellite_Action_Parameter_Aggregate_Bool_Exp = {
  count?: InputMaybe<Governance_Satellite_Action_Parameter_Aggregate_Bool_Exp_Count>;
};

export type Governance_Satellite_Action_Parameter_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_Satellite_Action_Parameter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Action_Parameter_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "governance_satellite_action_parameter" */
export type Governance_Satellite_Action_Parameter_Aggregate_Fields = {
  __typename?: 'governance_satellite_action_parameter_aggregate_fields';
  avg?: Maybe<Governance_Satellite_Action_Parameter_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Satellite_Action_Parameter_Max_Fields>;
  min?: Maybe<Governance_Satellite_Action_Parameter_Min_Fields>;
  stddev?: Maybe<Governance_Satellite_Action_Parameter_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Satellite_Action_Parameter_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Satellite_Action_Parameter_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Satellite_Action_Parameter_Sum_Fields>;
  var_pop?: Maybe<Governance_Satellite_Action_Parameter_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Satellite_Action_Parameter_Var_Samp_Fields>;
  variance?: Maybe<Governance_Satellite_Action_Parameter_Variance_Fields>;
};


/** aggregate fields of "governance_satellite_action_parameter" */
export type Governance_Satellite_Action_Parameter_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Satellite_Action_Parameter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_satellite_action_parameter" */
export type Governance_Satellite_Action_Parameter_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_Satellite_Action_Parameter_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_Satellite_Action_Parameter_Max_Order_By>;
  min?: InputMaybe<Governance_Satellite_Action_Parameter_Min_Order_By>;
  stddev?: InputMaybe<Governance_Satellite_Action_Parameter_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_Satellite_Action_Parameter_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_Satellite_Action_Parameter_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_Satellite_Action_Parameter_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_Satellite_Action_Parameter_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_Satellite_Action_Parameter_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_Satellite_Action_Parameter_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Governance_Satellite_Action_Parameter_Avg_Fields = {
  __typename?: 'governance_satellite_action_parameter_avg_fields';
  governance_satellite_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_satellite_action_parameter" */
export type Governance_Satellite_Action_Parameter_Avg_Order_By = {
  governance_satellite_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_satellite_action_parameter". All fields are combined with a logical 'AND'. */
export type Governance_Satellite_Action_Parameter_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Satellite_Action_Parameter_Bool_Exp>>;
  _not?: InputMaybe<Governance_Satellite_Action_Parameter_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Satellite_Action_Parameter_Bool_Exp>>;
  governance_satellite_action?: InputMaybe<Governance_Satellite_Action_Bool_Exp>;
  governance_satellite_action_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Governance_Satellite_Action_Parameter_Max_Fields = {
  __typename?: 'governance_satellite_action_parameter_max_fields';
  governance_satellite_action_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "governance_satellite_action_parameter" */
export type Governance_Satellite_Action_Parameter_Max_Order_By = {
  governance_satellite_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_Satellite_Action_Parameter_Min_Fields = {
  __typename?: 'governance_satellite_action_parameter_min_fields';
  governance_satellite_action_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "governance_satellite_action_parameter" */
export type Governance_Satellite_Action_Parameter_Min_Order_By = {
  governance_satellite_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_satellite_action_parameter". */
export type Governance_Satellite_Action_Parameter_Order_By = {
  governance_satellite_action?: InputMaybe<Governance_Satellite_Action_Order_By>;
  governance_satellite_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "governance_satellite_action_parameter" */
export enum Governance_Satellite_Action_Parameter_Select_Column {
  /** column name */
  GovernanceSatelliteActionId = 'governance_satellite_action_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Value = 'value'
}

/** aggregate stddev on columns */
export type Governance_Satellite_Action_Parameter_Stddev_Fields = {
  __typename?: 'governance_satellite_action_parameter_stddev_fields';
  governance_satellite_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_satellite_action_parameter" */
export type Governance_Satellite_Action_Parameter_Stddev_Order_By = {
  governance_satellite_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_Satellite_Action_Parameter_Stddev_Pop_Fields = {
  __typename?: 'governance_satellite_action_parameter_stddev_pop_fields';
  governance_satellite_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_satellite_action_parameter" */
export type Governance_Satellite_Action_Parameter_Stddev_Pop_Order_By = {
  governance_satellite_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_Satellite_Action_Parameter_Stddev_Samp_Fields = {
  __typename?: 'governance_satellite_action_parameter_stddev_samp_fields';
  governance_satellite_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_satellite_action_parameter" */
export type Governance_Satellite_Action_Parameter_Stddev_Samp_Order_By = {
  governance_satellite_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_satellite_action_parameter" */
export type Governance_Satellite_Action_Parameter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Satellite_Action_Parameter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Satellite_Action_Parameter_Stream_Cursor_Value_Input = {
  governance_satellite_action_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Governance_Satellite_Action_Parameter_Sum_Fields = {
  __typename?: 'governance_satellite_action_parameter_sum_fields';
  governance_satellite_action_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "governance_satellite_action_parameter" */
export type Governance_Satellite_Action_Parameter_Sum_Order_By = {
  governance_satellite_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_Satellite_Action_Parameter_Var_Pop_Fields = {
  __typename?: 'governance_satellite_action_parameter_var_pop_fields';
  governance_satellite_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_satellite_action_parameter" */
export type Governance_Satellite_Action_Parameter_Var_Pop_Order_By = {
  governance_satellite_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_Satellite_Action_Parameter_Var_Samp_Fields = {
  __typename?: 'governance_satellite_action_parameter_var_samp_fields';
  governance_satellite_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_satellite_action_parameter" */
export type Governance_Satellite_Action_Parameter_Var_Samp_Order_By = {
  governance_satellite_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_Satellite_Action_Parameter_Variance_Fields = {
  __typename?: 'governance_satellite_action_parameter_variance_fields';
  governance_satellite_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_satellite_action_parameter" */
export type Governance_Satellite_Action_Parameter_Variance_Order_By = {
  governance_satellite_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "governance_satellite_action" */
export enum Governance_Satellite_Action_Select_Column {
  /** column name */
  DroppedDatetime = 'dropped_datetime',
  /** column name */
  Executed = 'executed',
  /** column name */
  ExecutionDatetime = 'execution_datetime',
  /** column name */
  ExpirationDatetime = 'expiration_datetime',
  /** column name */
  GovernanceCycleId = 'governance_cycle_id',
  /** column name */
  GovernancePurpose = 'governance_purpose',
  /** column name */
  GovernanceSatelliteId = 'governance_satellite_id',
  /** column name */
  GovernanceType = 'governance_type',
  /** column name */
  Id = 'id',
  /** column name */
  InitiatorId = 'initiator_id',
  /** column name */
  InternalId = 'internal_id',
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  SmvnPercentageForApproval = 'smvn_percentage_for_approval',
  /** column name */
  SmvnRequiredForApproval = 'smvn_required_for_approval',
  /** column name */
  SnapshotSmvnTotalSupply = 'snapshot_smvn_total_supply',
  /** column name */
  StartDatetime = 'start_datetime',
  /** column name */
  Status = 'status',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** select "governance_satellite_action_aggregate_bool_exp_avg_arguments_columns" columns of table "governance_satellite_action" */
export enum Governance_Satellite_Action_Select_Column_Governance_Satellite_Action_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  SmvnRequiredForApproval = 'smvn_required_for_approval',
  /** column name */
  SnapshotSmvnTotalSupply = 'snapshot_smvn_total_supply',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** select "governance_satellite_action_aggregate_bool_exp_bool_and_arguments_columns" columns of table "governance_satellite_action" */
export enum Governance_Satellite_Action_Select_Column_Governance_Satellite_Action_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Executed = 'executed'
}

/** select "governance_satellite_action_aggregate_bool_exp_bool_or_arguments_columns" columns of table "governance_satellite_action" */
export enum Governance_Satellite_Action_Select_Column_Governance_Satellite_Action_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Executed = 'executed'
}

/** select "governance_satellite_action_aggregate_bool_exp_corr_arguments_columns" columns of table "governance_satellite_action" */
export enum Governance_Satellite_Action_Select_Column_Governance_Satellite_Action_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  SmvnRequiredForApproval = 'smvn_required_for_approval',
  /** column name */
  SnapshotSmvnTotalSupply = 'snapshot_smvn_total_supply',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** select "governance_satellite_action_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "governance_satellite_action" */
export enum Governance_Satellite_Action_Select_Column_Governance_Satellite_Action_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  SmvnRequiredForApproval = 'smvn_required_for_approval',
  /** column name */
  SnapshotSmvnTotalSupply = 'snapshot_smvn_total_supply',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** select "governance_satellite_action_aggregate_bool_exp_max_arguments_columns" columns of table "governance_satellite_action" */
export enum Governance_Satellite_Action_Select_Column_Governance_Satellite_Action_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  SmvnRequiredForApproval = 'smvn_required_for_approval',
  /** column name */
  SnapshotSmvnTotalSupply = 'snapshot_smvn_total_supply',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** select "governance_satellite_action_aggregate_bool_exp_min_arguments_columns" columns of table "governance_satellite_action" */
export enum Governance_Satellite_Action_Select_Column_Governance_Satellite_Action_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  SmvnRequiredForApproval = 'smvn_required_for_approval',
  /** column name */
  SnapshotSmvnTotalSupply = 'snapshot_smvn_total_supply',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** select "governance_satellite_action_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "governance_satellite_action" */
export enum Governance_Satellite_Action_Select_Column_Governance_Satellite_Action_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  SmvnRequiredForApproval = 'smvn_required_for_approval',
  /** column name */
  SnapshotSmvnTotalSupply = 'snapshot_smvn_total_supply',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** select "governance_satellite_action_aggregate_bool_exp_sum_arguments_columns" columns of table "governance_satellite_action" */
export enum Governance_Satellite_Action_Select_Column_Governance_Satellite_Action_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  SmvnRequiredForApproval = 'smvn_required_for_approval',
  /** column name */
  SnapshotSmvnTotalSupply = 'snapshot_smvn_total_supply',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** select "governance_satellite_action_aggregate_bool_exp_var_samp_arguments_columns" columns of table "governance_satellite_action" */
export enum Governance_Satellite_Action_Select_Column_Governance_Satellite_Action_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  NayVoteSmvnTotal = 'nay_vote_smvn_total',
  /** column name */
  PassVoteSmvnTotal = 'pass_vote_smvn_total',
  /** column name */
  SmvnRequiredForApproval = 'smvn_required_for_approval',
  /** column name */
  SnapshotSmvnTotalSupply = 'snapshot_smvn_total_supply',
  /** column name */
  YayVoteSmvnTotal = 'yay_vote_smvn_total'
}

/** aggregate stddev on columns */
export type Governance_Satellite_Action_Stddev_Fields = {
  __typename?: 'governance_satellite_action_stddev_fields';
  governance_cycle_id?: Maybe<Scalars['Float']['output']>;
  governance_satellite_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initiator_id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_for_approval?: Maybe<Scalars['Float']['output']>;
  smvn_required_for_approval?: Maybe<Scalars['Float']['output']>;
  snapshot_smvn_total_supply?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['Float']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_satellite_action" */
export type Governance_Satellite_Action_Stddev_Order_By = {
  governance_cycle_id?: InputMaybe<Order_By>;
  governance_satellite_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  smvn_percentage_for_approval?: InputMaybe<Order_By>;
  smvn_required_for_approval?: InputMaybe<Order_By>;
  snapshot_smvn_total_supply?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_Satellite_Action_Stddev_Pop_Fields = {
  __typename?: 'governance_satellite_action_stddev_pop_fields';
  governance_cycle_id?: Maybe<Scalars['Float']['output']>;
  governance_satellite_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initiator_id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_for_approval?: Maybe<Scalars['Float']['output']>;
  smvn_required_for_approval?: Maybe<Scalars['Float']['output']>;
  snapshot_smvn_total_supply?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['Float']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_satellite_action" */
export type Governance_Satellite_Action_Stddev_Pop_Order_By = {
  governance_cycle_id?: InputMaybe<Order_By>;
  governance_satellite_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  smvn_percentage_for_approval?: InputMaybe<Order_By>;
  smvn_required_for_approval?: InputMaybe<Order_By>;
  snapshot_smvn_total_supply?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_Satellite_Action_Stddev_Samp_Fields = {
  __typename?: 'governance_satellite_action_stddev_samp_fields';
  governance_cycle_id?: Maybe<Scalars['Float']['output']>;
  governance_satellite_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initiator_id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_for_approval?: Maybe<Scalars['Float']['output']>;
  smvn_required_for_approval?: Maybe<Scalars['Float']['output']>;
  snapshot_smvn_total_supply?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['Float']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_satellite_action" */
export type Governance_Satellite_Action_Stddev_Samp_Order_By = {
  governance_cycle_id?: InputMaybe<Order_By>;
  governance_satellite_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  smvn_percentage_for_approval?: InputMaybe<Order_By>;
  smvn_required_for_approval?: InputMaybe<Order_By>;
  snapshot_smvn_total_supply?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_satellite_action" */
export type Governance_Satellite_Action_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Satellite_Action_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Satellite_Action_Stream_Cursor_Value_Input = {
  dropped_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  executed?: InputMaybe<Scalars['Boolean']['input']>;
  execution_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  expiration_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  governance_cycle_id?: InputMaybe<Scalars['bigint']['input']>;
  governance_purpose?: InputMaybe<Scalars['String']['input']>;
  governance_satellite_id?: InputMaybe<Scalars['bigint']['input']>;
  governance_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  initiator_id?: InputMaybe<Scalars['bigint']['input']>;
  internal_id?: InputMaybe<Scalars['bigint']['input']>;
  nay_vote_smvn_total?: InputMaybe<Scalars['float8']['input']>;
  pass_vote_smvn_total?: InputMaybe<Scalars['float8']['input']>;
  smvn_percentage_for_approval?: InputMaybe<Scalars['smallint']['input']>;
  smvn_required_for_approval?: InputMaybe<Scalars['float8']['input']>;
  snapshot_smvn_total_supply?: InputMaybe<Scalars['float8']['input']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Scalars['smallint']['input']>;
  yay_vote_smvn_total?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type Governance_Satellite_Action_Sum_Fields = {
  __typename?: 'governance_satellite_action_sum_fields';
  governance_cycle_id?: Maybe<Scalars['bigint']['output']>;
  governance_satellite_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  initiator_id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['bigint']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
  smvn_percentage_for_approval?: Maybe<Scalars['smallint']['output']>;
  smvn_required_for_approval?: Maybe<Scalars['float8']['output']>;
  snapshot_smvn_total_supply?: Maybe<Scalars['float8']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['smallint']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "governance_satellite_action" */
export type Governance_Satellite_Action_Sum_Order_By = {
  governance_cycle_id?: InputMaybe<Order_By>;
  governance_satellite_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  smvn_percentage_for_approval?: InputMaybe<Order_By>;
  smvn_required_for_approval?: InputMaybe<Order_By>;
  snapshot_smvn_total_supply?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_Satellite_Action_Var_Pop_Fields = {
  __typename?: 'governance_satellite_action_var_pop_fields';
  governance_cycle_id?: Maybe<Scalars['Float']['output']>;
  governance_satellite_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initiator_id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_for_approval?: Maybe<Scalars['Float']['output']>;
  smvn_required_for_approval?: Maybe<Scalars['Float']['output']>;
  snapshot_smvn_total_supply?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['Float']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_satellite_action" */
export type Governance_Satellite_Action_Var_Pop_Order_By = {
  governance_cycle_id?: InputMaybe<Order_By>;
  governance_satellite_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  smvn_percentage_for_approval?: InputMaybe<Order_By>;
  smvn_required_for_approval?: InputMaybe<Order_By>;
  snapshot_smvn_total_supply?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_Satellite_Action_Var_Samp_Fields = {
  __typename?: 'governance_satellite_action_var_samp_fields';
  governance_cycle_id?: Maybe<Scalars['Float']['output']>;
  governance_satellite_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initiator_id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_for_approval?: Maybe<Scalars['Float']['output']>;
  smvn_required_for_approval?: Maybe<Scalars['Float']['output']>;
  snapshot_smvn_total_supply?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['Float']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_satellite_action" */
export type Governance_Satellite_Action_Var_Samp_Order_By = {
  governance_cycle_id?: InputMaybe<Order_By>;
  governance_satellite_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  smvn_percentage_for_approval?: InputMaybe<Order_By>;
  smvn_required_for_approval?: InputMaybe<Order_By>;
  snapshot_smvn_total_supply?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_Satellite_Action_Variance_Fields = {
  __typename?: 'governance_satellite_action_variance_fields';
  governance_cycle_id?: Maybe<Scalars['Float']['output']>;
  governance_satellite_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initiator_id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  nay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  pass_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
  smvn_percentage_for_approval?: Maybe<Scalars['Float']['output']>;
  smvn_required_for_approval?: Maybe<Scalars['Float']['output']>;
  snapshot_smvn_total_supply?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: Maybe<Scalars['Float']['output']>;
  yay_vote_smvn_total?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_satellite_action" */
export type Governance_Satellite_Action_Variance_Order_By = {
  governance_cycle_id?: InputMaybe<Order_By>;
  governance_satellite_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiator_id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  nay_vote_smvn_total?: InputMaybe<Order_By>;
  pass_vote_smvn_total?: InputMaybe<Order_By>;
  smvn_percentage_for_approval?: InputMaybe<Order_By>;
  smvn_required_for_approval?: InputMaybe<Order_By>;
  snapshot_smvn_total_supply?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nDROPPED: 1 */
  status?: InputMaybe<Order_By>;
  yay_vote_smvn_total?: InputMaybe<Order_By>;
};

/** columns and relationships of "governance_satellite_action_vote" */
export type Governance_Satellite_Action_Vote = {
  __typename?: 'governance_satellite_action_vote';
  /** An object relationship */
  governance_satellite_action: Governance_Satellite_Action;
  governance_satellite_action_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  satellite_snapshot: Governance_Satellite_Snapshot;
  satellite_snapshot_id: Scalars['bigint']['output'];
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote: Scalars['smallint']['output'];
  /** An object relationship */
  voter: Maven_User;
  voter_id: Scalars['bigint']['output'];
};

/** aggregated selection of "governance_satellite_action_vote" */
export type Governance_Satellite_Action_Vote_Aggregate = {
  __typename?: 'governance_satellite_action_vote_aggregate';
  aggregate?: Maybe<Governance_Satellite_Action_Vote_Aggregate_Fields>;
  nodes: Array<Governance_Satellite_Action_Vote>;
};

export type Governance_Satellite_Action_Vote_Aggregate_Bool_Exp = {
  count?: InputMaybe<Governance_Satellite_Action_Vote_Aggregate_Bool_Exp_Count>;
};

export type Governance_Satellite_Action_Vote_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_Satellite_Action_Vote_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Action_Vote_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "governance_satellite_action_vote" */
export type Governance_Satellite_Action_Vote_Aggregate_Fields = {
  __typename?: 'governance_satellite_action_vote_aggregate_fields';
  avg?: Maybe<Governance_Satellite_Action_Vote_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Satellite_Action_Vote_Max_Fields>;
  min?: Maybe<Governance_Satellite_Action_Vote_Min_Fields>;
  stddev?: Maybe<Governance_Satellite_Action_Vote_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Satellite_Action_Vote_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Satellite_Action_Vote_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Satellite_Action_Vote_Sum_Fields>;
  var_pop?: Maybe<Governance_Satellite_Action_Vote_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Satellite_Action_Vote_Var_Samp_Fields>;
  variance?: Maybe<Governance_Satellite_Action_Vote_Variance_Fields>;
};


/** aggregate fields of "governance_satellite_action_vote" */
export type Governance_Satellite_Action_Vote_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Satellite_Action_Vote_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_satellite_action_vote" */
export type Governance_Satellite_Action_Vote_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_Satellite_Action_Vote_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_Satellite_Action_Vote_Max_Order_By>;
  min?: InputMaybe<Governance_Satellite_Action_Vote_Min_Order_By>;
  stddev?: InputMaybe<Governance_Satellite_Action_Vote_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_Satellite_Action_Vote_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_Satellite_Action_Vote_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_Satellite_Action_Vote_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_Satellite_Action_Vote_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_Satellite_Action_Vote_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_Satellite_Action_Vote_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Governance_Satellite_Action_Vote_Avg_Fields = {
  __typename?: 'governance_satellite_action_vote_avg_fields';
  governance_satellite_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_satellite_action_vote" */
export type Governance_Satellite_Action_Vote_Avg_Order_By = {
  governance_satellite_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_snapshot_id?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_satellite_action_vote". All fields are combined with a logical 'AND'. */
export type Governance_Satellite_Action_Vote_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Satellite_Action_Vote_Bool_Exp>>;
  _not?: InputMaybe<Governance_Satellite_Action_Vote_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Satellite_Action_Vote_Bool_Exp>>;
  governance_satellite_action?: InputMaybe<Governance_Satellite_Action_Bool_Exp>;
  governance_satellite_action_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  satellite_snapshot?: InputMaybe<Governance_Satellite_Snapshot_Bool_Exp>;
  satellite_snapshot_id?: InputMaybe<Bigint_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  vote?: InputMaybe<Smallint_Comparison_Exp>;
  voter?: InputMaybe<Maven_User_Bool_Exp>;
  voter_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Governance_Satellite_Action_Vote_Max_Fields = {
  __typename?: 'governance_satellite_action_vote_max_fields';
  governance_satellite_action_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  satellite_snapshot_id?: Maybe<Scalars['bigint']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['smallint']['output']>;
  voter_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "governance_satellite_action_vote" */
export type Governance_Satellite_Action_Vote_Max_Order_By = {
  governance_satellite_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_snapshot_id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_Satellite_Action_Vote_Min_Fields = {
  __typename?: 'governance_satellite_action_vote_min_fields';
  governance_satellite_action_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  satellite_snapshot_id?: Maybe<Scalars['bigint']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['smallint']['output']>;
  voter_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "governance_satellite_action_vote" */
export type Governance_Satellite_Action_Vote_Min_Order_By = {
  governance_satellite_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_snapshot_id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_satellite_action_vote". */
export type Governance_Satellite_Action_Vote_Order_By = {
  governance_satellite_action?: InputMaybe<Governance_Satellite_Action_Order_By>;
  governance_satellite_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_snapshot?: InputMaybe<Governance_Satellite_Snapshot_Order_By>;
  satellite_snapshot_id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  vote?: InputMaybe<Order_By>;
  voter?: InputMaybe<Maven_User_Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** select columns of table "governance_satellite_action_vote" */
export enum Governance_Satellite_Action_Vote_Select_Column {
  /** column name */
  GovernanceSatelliteActionId = 'governance_satellite_action_id',
  /** column name */
  Id = 'id',
  /** column name */
  SatelliteSnapshotId = 'satellite_snapshot_id',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Vote = 'vote',
  /** column name */
  VoterId = 'voter_id'
}

/** aggregate stddev on columns */
export type Governance_Satellite_Action_Vote_Stddev_Fields = {
  __typename?: 'governance_satellite_action_vote_stddev_fields';
  governance_satellite_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_satellite_action_vote" */
export type Governance_Satellite_Action_Vote_Stddev_Order_By = {
  governance_satellite_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_snapshot_id?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_Satellite_Action_Vote_Stddev_Pop_Fields = {
  __typename?: 'governance_satellite_action_vote_stddev_pop_fields';
  governance_satellite_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_satellite_action_vote" */
export type Governance_Satellite_Action_Vote_Stddev_Pop_Order_By = {
  governance_satellite_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_snapshot_id?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_Satellite_Action_Vote_Stddev_Samp_Fields = {
  __typename?: 'governance_satellite_action_vote_stddev_samp_fields';
  governance_satellite_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_satellite_action_vote" */
export type Governance_Satellite_Action_Vote_Stddev_Samp_Order_By = {
  governance_satellite_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_snapshot_id?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_satellite_action_vote" */
export type Governance_Satellite_Action_Vote_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Satellite_Action_Vote_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Satellite_Action_Vote_Stream_Cursor_Value_Input = {
  governance_satellite_action_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  satellite_snapshot_id?: InputMaybe<Scalars['bigint']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Scalars['smallint']['input']>;
  voter_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Governance_Satellite_Action_Vote_Sum_Fields = {
  __typename?: 'governance_satellite_action_vote_sum_fields';
  governance_satellite_action_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  satellite_snapshot_id?: Maybe<Scalars['bigint']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['smallint']['output']>;
  voter_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "governance_satellite_action_vote" */
export type Governance_Satellite_Action_Vote_Sum_Order_By = {
  governance_satellite_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_snapshot_id?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_Satellite_Action_Vote_Var_Pop_Fields = {
  __typename?: 'governance_satellite_action_vote_var_pop_fields';
  governance_satellite_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_satellite_action_vote" */
export type Governance_Satellite_Action_Vote_Var_Pop_Order_By = {
  governance_satellite_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_snapshot_id?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_Satellite_Action_Vote_Var_Samp_Fields = {
  __typename?: 'governance_satellite_action_vote_var_samp_fields';
  governance_satellite_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_satellite_action_vote" */
export type Governance_Satellite_Action_Vote_Var_Samp_Order_By = {
  governance_satellite_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_snapshot_id?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_Satellite_Action_Vote_Variance_Fields = {
  __typename?: 'governance_satellite_action_vote_variance_fields';
  governance_satellite_action_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: Maybe<Scalars['Float']['output']>;
  voter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_satellite_action_vote" */
export type Governance_Satellite_Action_Vote_Variance_Order_By = {
  governance_satellite_action_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_snapshot_id?: InputMaybe<Order_By>;
  /** NAY: 0\nYAY: 1\nPASS: 2 */
  vote?: InputMaybe<Order_By>;
  voter_id?: InputMaybe<Order_By>;
};

/** aggregated selection of "governance_satellite" */
export type Governance_Satellite_Aggregate = {
  __typename?: 'governance_satellite_aggregate';
  aggregate?: Maybe<Governance_Satellite_Aggregate_Fields>;
  nodes: Array<Governance_Satellite>;
};

export type Governance_Satellite_Aggregate_Bool_Exp = {
  count?: InputMaybe<Governance_Satellite_Aggregate_Bool_Exp_Count>;
};

export type Governance_Satellite_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_Satellite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "governance_satellite" */
export type Governance_Satellite_Aggregate_Fields = {
  __typename?: 'governance_satellite_aggregate_fields';
  avg?: Maybe<Governance_Satellite_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Satellite_Max_Fields>;
  min?: Maybe<Governance_Satellite_Min_Fields>;
  stddev?: Maybe<Governance_Satellite_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Satellite_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Satellite_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Satellite_Sum_Fields>;
  var_pop?: Maybe<Governance_Satellite_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Satellite_Var_Samp_Fields>;
  variance?: Maybe<Governance_Satellite_Variance_Fields>;
};


/** aggregate fields of "governance_satellite" */
export type Governance_Satellite_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Satellite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_satellite" */
export type Governance_Satellite_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_Satellite_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_Satellite_Max_Order_By>;
  min?: InputMaybe<Governance_Satellite_Min_Order_By>;
  stddev?: InputMaybe<Governance_Satellite_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_Satellite_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_Satellite_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_Satellite_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_Satellite_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_Satellite_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_Satellite_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Governance_Satellite_Avg_Fields = {
  __typename?: 'governance_satellite_avg_fields';
  approval_percentage?: Maybe<Scalars['Float']['output']>;
  gov_purpose_max_length?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  governance_satellite_counter?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_actions_per_satellite?: Maybe<Scalars['Float']['output']>;
  sat_action_duration_in_days?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_satellite" */
export type Governance_Satellite_Avg_Order_By = {
  approval_percentage?: InputMaybe<Order_By>;
  gov_purpose_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  governance_satellite_counter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_actions_per_satellite?: InputMaybe<Order_By>;
  sat_action_duration_in_days?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_satellite". All fields are combined with a logical 'AND'. */
export type Governance_Satellite_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Satellite_Bool_Exp>>;
  _not?: InputMaybe<Governance_Satellite_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Satellite_Bool_Exp>>;
  actions?: InputMaybe<Governance_Satellite_Action_Bool_Exp>;
  actions_aggregate?: InputMaybe<Governance_Satellite_Action_Aggregate_Bool_Exp>;
  address?: InputMaybe<String_Comparison_Exp>;
  admin?: InputMaybe<String_Comparison_Exp>;
  approval_percentage?: InputMaybe<Smallint_Comparison_Exp>;
  general_contracts?: InputMaybe<Governance_Satellite_General_Contract_Bool_Exp>;
  general_contracts_aggregate?: InputMaybe<Governance_Satellite_General_Contract_Aggregate_Bool_Exp>;
  gov_purpose_max_length?: InputMaybe<Smallint_Comparison_Exp>;
  governance?: InputMaybe<Governance_Bool_Exp>;
  governance_id?: InputMaybe<Bigint_Comparison_Exp>;
  governance_satellite_counter?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambdas?: InputMaybe<Governance_Satellite_Lambda_Bool_Exp>;
  lambdas_aggregate?: InputMaybe<Governance_Satellite_Lambda_Aggregate_Bool_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  max_actions_per_satellite?: InputMaybe<Smallint_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
  oracles?: InputMaybe<Governance_Satellite_Oracle_Bool_Exp>;
  oracles_aggregate?: InputMaybe<Governance_Satellite_Oracle_Aggregate_Bool_Exp>;
  sat_action_duration_in_days?: InputMaybe<Smallint_Comparison_Exp>;
  whitelist_contracts?: InputMaybe<Governance_Satellite_Whitelist_Contract_Bool_Exp>;
  whitelist_contracts_aggregate?: InputMaybe<Governance_Satellite_Whitelist_Contract_Aggregate_Bool_Exp>;
};

/** columns and relationships of "governance_satellite_general_contract" */
export type Governance_Satellite_General_Contract = {
  __typename?: 'governance_satellite_general_contract';
  /** An object relationship */
  contract: Governance_Satellite;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  contract_name: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "governance_satellite_general_contract" */
export type Governance_Satellite_General_Contract_Aggregate = {
  __typename?: 'governance_satellite_general_contract_aggregate';
  aggregate?: Maybe<Governance_Satellite_General_Contract_Aggregate_Fields>;
  nodes: Array<Governance_Satellite_General_Contract>;
};

export type Governance_Satellite_General_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Governance_Satellite_General_Contract_Aggregate_Bool_Exp_Count>;
};

export type Governance_Satellite_General_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_Satellite_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_General_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "governance_satellite_general_contract" */
export type Governance_Satellite_General_Contract_Aggregate_Fields = {
  __typename?: 'governance_satellite_general_contract_aggregate_fields';
  avg?: Maybe<Governance_Satellite_General_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Satellite_General_Contract_Max_Fields>;
  min?: Maybe<Governance_Satellite_General_Contract_Min_Fields>;
  stddev?: Maybe<Governance_Satellite_General_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Satellite_General_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Satellite_General_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Satellite_General_Contract_Sum_Fields>;
  var_pop?: Maybe<Governance_Satellite_General_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Satellite_General_Contract_Var_Samp_Fields>;
  variance?: Maybe<Governance_Satellite_General_Contract_Variance_Fields>;
};


/** aggregate fields of "governance_satellite_general_contract" */
export type Governance_Satellite_General_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Satellite_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_satellite_general_contract" */
export type Governance_Satellite_General_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_Satellite_General_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_Satellite_General_Contract_Max_Order_By>;
  min?: InputMaybe<Governance_Satellite_General_Contract_Min_Order_By>;
  stddev?: InputMaybe<Governance_Satellite_General_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_Satellite_General_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_Satellite_General_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_Satellite_General_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_Satellite_General_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_Satellite_General_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_Satellite_General_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Governance_Satellite_General_Contract_Avg_Fields = {
  __typename?: 'governance_satellite_general_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_satellite_general_contract" */
export type Governance_Satellite_General_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_satellite_general_contract". All fields are combined with a logical 'AND'. */
export type Governance_Satellite_General_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Satellite_General_Contract_Bool_Exp>>;
  _not?: InputMaybe<Governance_Satellite_General_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Satellite_General_Contract_Bool_Exp>>;
  contract?: InputMaybe<Governance_Satellite_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  contract_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Governance_Satellite_General_Contract_Max_Fields = {
  __typename?: 'governance_satellite_general_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "governance_satellite_general_contract" */
export type Governance_Satellite_General_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_Satellite_General_Contract_Min_Fields = {
  __typename?: 'governance_satellite_general_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "governance_satellite_general_contract" */
export type Governance_Satellite_General_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_satellite_general_contract". */
export type Governance_Satellite_General_Contract_Order_By = {
  contract?: InputMaybe<Governance_Satellite_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "governance_satellite_general_contract" */
export enum Governance_Satellite_General_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  ContractName = 'contract_name',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Governance_Satellite_General_Contract_Stddev_Fields = {
  __typename?: 'governance_satellite_general_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_satellite_general_contract" */
export type Governance_Satellite_General_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_Satellite_General_Contract_Stddev_Pop_Fields = {
  __typename?: 'governance_satellite_general_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_satellite_general_contract" */
export type Governance_Satellite_General_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_Satellite_General_Contract_Stddev_Samp_Fields = {
  __typename?: 'governance_satellite_general_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_satellite_general_contract" */
export type Governance_Satellite_General_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_satellite_general_contract" */
export type Governance_Satellite_General_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Satellite_General_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Satellite_General_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  contract_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Governance_Satellite_General_Contract_Sum_Fields = {
  __typename?: 'governance_satellite_general_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "governance_satellite_general_contract" */
export type Governance_Satellite_General_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_Satellite_General_Contract_Var_Pop_Fields = {
  __typename?: 'governance_satellite_general_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_satellite_general_contract" */
export type Governance_Satellite_General_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_Satellite_General_Contract_Var_Samp_Fields = {
  __typename?: 'governance_satellite_general_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_satellite_general_contract" */
export type Governance_Satellite_General_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_Satellite_General_Contract_Variance_Fields = {
  __typename?: 'governance_satellite_general_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_satellite_general_contract" */
export type Governance_Satellite_General_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "governance_satellite_lambda" */
export type Governance_Satellite_Lambda = {
  __typename?: 'governance_satellite_lambda';
  /** An object relationship */
  contract: Governance_Satellite;
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lambda_bytes: Scalars['String']['output'];
  lambda_name: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "governance_satellite_lambda" */
export type Governance_Satellite_Lambda_Aggregate = {
  __typename?: 'governance_satellite_lambda_aggregate';
  aggregate?: Maybe<Governance_Satellite_Lambda_Aggregate_Fields>;
  nodes: Array<Governance_Satellite_Lambda>;
};

export type Governance_Satellite_Lambda_Aggregate_Bool_Exp = {
  count?: InputMaybe<Governance_Satellite_Lambda_Aggregate_Bool_Exp_Count>;
};

export type Governance_Satellite_Lambda_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_Satellite_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Lambda_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "governance_satellite_lambda" */
export type Governance_Satellite_Lambda_Aggregate_Fields = {
  __typename?: 'governance_satellite_lambda_aggregate_fields';
  avg?: Maybe<Governance_Satellite_Lambda_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Satellite_Lambda_Max_Fields>;
  min?: Maybe<Governance_Satellite_Lambda_Min_Fields>;
  stddev?: Maybe<Governance_Satellite_Lambda_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Satellite_Lambda_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Satellite_Lambda_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Satellite_Lambda_Sum_Fields>;
  var_pop?: Maybe<Governance_Satellite_Lambda_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Satellite_Lambda_Var_Samp_Fields>;
  variance?: Maybe<Governance_Satellite_Lambda_Variance_Fields>;
};


/** aggregate fields of "governance_satellite_lambda" */
export type Governance_Satellite_Lambda_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Satellite_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_satellite_lambda" */
export type Governance_Satellite_Lambda_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_Satellite_Lambda_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_Satellite_Lambda_Max_Order_By>;
  min?: InputMaybe<Governance_Satellite_Lambda_Min_Order_By>;
  stddev?: InputMaybe<Governance_Satellite_Lambda_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_Satellite_Lambda_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_Satellite_Lambda_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_Satellite_Lambda_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_Satellite_Lambda_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_Satellite_Lambda_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_Satellite_Lambda_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Governance_Satellite_Lambda_Avg_Fields = {
  __typename?: 'governance_satellite_lambda_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_satellite_lambda" */
export type Governance_Satellite_Lambda_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_satellite_lambda". All fields are combined with a logical 'AND'. */
export type Governance_Satellite_Lambda_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Satellite_Lambda_Bool_Exp>>;
  _not?: InputMaybe<Governance_Satellite_Lambda_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Satellite_Lambda_Bool_Exp>>;
  contract?: InputMaybe<Governance_Satellite_Bool_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambda_bytes?: InputMaybe<String_Comparison_Exp>;
  lambda_name?: InputMaybe<String_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Governance_Satellite_Lambda_Max_Fields = {
  __typename?: 'governance_satellite_lambda_max_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "governance_satellite_lambda" */
export type Governance_Satellite_Lambda_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_Satellite_Lambda_Min_Fields = {
  __typename?: 'governance_satellite_lambda_min_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "governance_satellite_lambda" */
export type Governance_Satellite_Lambda_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_satellite_lambda". */
export type Governance_Satellite_Lambda_Order_By = {
  contract?: InputMaybe<Governance_Satellite_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "governance_satellite_lambda" */
export enum Governance_Satellite_Lambda_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaBytes = 'lambda_bytes',
  /** column name */
  LambdaName = 'lambda_name',
  /** column name */
  LastUpdatedAt = 'last_updated_at'
}

/** aggregate stddev on columns */
export type Governance_Satellite_Lambda_Stddev_Fields = {
  __typename?: 'governance_satellite_lambda_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_satellite_lambda" */
export type Governance_Satellite_Lambda_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_Satellite_Lambda_Stddev_Pop_Fields = {
  __typename?: 'governance_satellite_lambda_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_satellite_lambda" */
export type Governance_Satellite_Lambda_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_Satellite_Lambda_Stddev_Samp_Fields = {
  __typename?: 'governance_satellite_lambda_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_satellite_lambda" */
export type Governance_Satellite_Lambda_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_satellite_lambda" */
export type Governance_Satellite_Lambda_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Satellite_Lambda_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Satellite_Lambda_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lambda_bytes?: InputMaybe<Scalars['String']['input']>;
  lambda_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Governance_Satellite_Lambda_Sum_Fields = {
  __typename?: 'governance_satellite_lambda_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "governance_satellite_lambda" */
export type Governance_Satellite_Lambda_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_Satellite_Lambda_Var_Pop_Fields = {
  __typename?: 'governance_satellite_lambda_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_satellite_lambda" */
export type Governance_Satellite_Lambda_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_Satellite_Lambda_Var_Samp_Fields = {
  __typename?: 'governance_satellite_lambda_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_satellite_lambda" */
export type Governance_Satellite_Lambda_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_Satellite_Lambda_Variance_Fields = {
  __typename?: 'governance_satellite_lambda_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_satellite_lambda" */
export type Governance_Satellite_Lambda_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Governance_Satellite_Max_Fields = {
  __typename?: 'governance_satellite_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  approval_percentage?: Maybe<Scalars['smallint']['output']>;
  gov_purpose_max_length?: Maybe<Scalars['smallint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  governance_satellite_counter?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  max_actions_per_satellite?: Maybe<Scalars['smallint']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  sat_action_duration_in_days?: Maybe<Scalars['smallint']['output']>;
};

/** order by max() on columns of table "governance_satellite" */
export type Governance_Satellite_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  approval_percentage?: InputMaybe<Order_By>;
  gov_purpose_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  governance_satellite_counter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  max_actions_per_satellite?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  sat_action_duration_in_days?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_Satellite_Min_Fields = {
  __typename?: 'governance_satellite_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  approval_percentage?: Maybe<Scalars['smallint']['output']>;
  gov_purpose_max_length?: Maybe<Scalars['smallint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  governance_satellite_counter?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  max_actions_per_satellite?: Maybe<Scalars['smallint']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  sat_action_duration_in_days?: Maybe<Scalars['smallint']['output']>;
};

/** order by min() on columns of table "governance_satellite" */
export type Governance_Satellite_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  approval_percentage?: InputMaybe<Order_By>;
  gov_purpose_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  governance_satellite_counter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  max_actions_per_satellite?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  sat_action_duration_in_days?: InputMaybe<Order_By>;
};

/** columns and relationships of "governance_satellite_oracle" */
export type Governance_Satellite_Oracle = {
  __typename?: 'governance_satellite_oracle';
  /** An array relationship */
  aggregators: Array<Governance_Satellite_Oracle_Aggregator>;
  /** An aggregate relationship */
  aggregators_aggregate: Governance_Satellite_Oracle_Aggregator_Aggregate;
  /** An object relationship */
  governance_satellite: Governance_Satellite;
  governance_satellite_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  oracle: Maven_User;
  oracle_id: Scalars['bigint']['output'];
};


/** columns and relationships of "governance_satellite_oracle" */
export type Governance_Satellite_OracleAggregatorsArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Oracle_Aggregator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Oracle_Aggregator_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Bool_Exp>;
};


/** columns and relationships of "governance_satellite_oracle" */
export type Governance_Satellite_OracleAggregators_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Oracle_Aggregator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Oracle_Aggregator_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Bool_Exp>;
};

/** aggregated selection of "governance_satellite_oracle" */
export type Governance_Satellite_Oracle_Aggregate = {
  __typename?: 'governance_satellite_oracle_aggregate';
  aggregate?: Maybe<Governance_Satellite_Oracle_Aggregate_Fields>;
  nodes: Array<Governance_Satellite_Oracle>;
};

export type Governance_Satellite_Oracle_Aggregate_Bool_Exp = {
  count?: InputMaybe<Governance_Satellite_Oracle_Aggregate_Bool_Exp_Count>;
};

export type Governance_Satellite_Oracle_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_Satellite_Oracle_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Oracle_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "governance_satellite_oracle" */
export type Governance_Satellite_Oracle_Aggregate_Fields = {
  __typename?: 'governance_satellite_oracle_aggregate_fields';
  avg?: Maybe<Governance_Satellite_Oracle_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Satellite_Oracle_Max_Fields>;
  min?: Maybe<Governance_Satellite_Oracle_Min_Fields>;
  stddev?: Maybe<Governance_Satellite_Oracle_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Satellite_Oracle_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Satellite_Oracle_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Satellite_Oracle_Sum_Fields>;
  var_pop?: Maybe<Governance_Satellite_Oracle_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Satellite_Oracle_Var_Samp_Fields>;
  variance?: Maybe<Governance_Satellite_Oracle_Variance_Fields>;
};


/** aggregate fields of "governance_satellite_oracle" */
export type Governance_Satellite_Oracle_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Satellite_Oracle_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_satellite_oracle" */
export type Governance_Satellite_Oracle_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_Satellite_Oracle_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_Satellite_Oracle_Max_Order_By>;
  min?: InputMaybe<Governance_Satellite_Oracle_Min_Order_By>;
  stddev?: InputMaybe<Governance_Satellite_Oracle_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_Satellite_Oracle_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_Satellite_Oracle_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_Satellite_Oracle_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_Satellite_Oracle_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_Satellite_Oracle_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_Satellite_Oracle_Variance_Order_By>;
};

/** columns and relationships of "governance_satellite_oracle_aggregator" */
export type Governance_Satellite_Oracle_Aggregator = {
  __typename?: 'governance_satellite_oracle_aggregator';
  /** An object relationship */
  aggregator: Aggregator;
  aggregator_id: Scalars['bigint']['output'];
  /** An object relationship */
  governance_satellite_oracle: Governance_Satellite_Oracle;
  governance_satellite_oracle_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  start_timestamp: Scalars['timestamptz']['output'];
};

/** aggregated selection of "governance_satellite_oracle_aggregator" */
export type Governance_Satellite_Oracle_Aggregator_Aggregate = {
  __typename?: 'governance_satellite_oracle_aggregator_aggregate';
  aggregate?: Maybe<Governance_Satellite_Oracle_Aggregator_Aggregate_Fields>;
  nodes: Array<Governance_Satellite_Oracle_Aggregator>;
};

export type Governance_Satellite_Oracle_Aggregator_Aggregate_Bool_Exp = {
  count?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Aggregate_Bool_Exp_Count>;
};

export type Governance_Satellite_Oracle_Aggregator_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_Satellite_Oracle_Aggregator_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "governance_satellite_oracle_aggregator" */
export type Governance_Satellite_Oracle_Aggregator_Aggregate_Fields = {
  __typename?: 'governance_satellite_oracle_aggregator_aggregate_fields';
  avg?: Maybe<Governance_Satellite_Oracle_Aggregator_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Satellite_Oracle_Aggregator_Max_Fields>;
  min?: Maybe<Governance_Satellite_Oracle_Aggregator_Min_Fields>;
  stddev?: Maybe<Governance_Satellite_Oracle_Aggregator_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Satellite_Oracle_Aggregator_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Satellite_Oracle_Aggregator_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Satellite_Oracle_Aggregator_Sum_Fields>;
  var_pop?: Maybe<Governance_Satellite_Oracle_Aggregator_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Satellite_Oracle_Aggregator_Var_Samp_Fields>;
  variance?: Maybe<Governance_Satellite_Oracle_Aggregator_Variance_Fields>;
};


/** aggregate fields of "governance_satellite_oracle_aggregator" */
export type Governance_Satellite_Oracle_Aggregator_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Satellite_Oracle_Aggregator_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_satellite_oracle_aggregator" */
export type Governance_Satellite_Oracle_Aggregator_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Max_Order_By>;
  min?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Min_Order_By>;
  stddev?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Governance_Satellite_Oracle_Aggregator_Avg_Fields = {
  __typename?: 'governance_satellite_oracle_aggregator_avg_fields';
  aggregator_id?: Maybe<Scalars['Float']['output']>;
  governance_satellite_oracle_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_satellite_oracle_aggregator" */
export type Governance_Satellite_Oracle_Aggregator_Avg_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  governance_satellite_oracle_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_satellite_oracle_aggregator". All fields are combined with a logical 'AND'. */
export type Governance_Satellite_Oracle_Aggregator_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Satellite_Oracle_Aggregator_Bool_Exp>>;
  _not?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Satellite_Oracle_Aggregator_Bool_Exp>>;
  aggregator?: InputMaybe<Aggregator_Bool_Exp>;
  aggregator_id?: InputMaybe<Bigint_Comparison_Exp>;
  governance_satellite_oracle?: InputMaybe<Governance_Satellite_Oracle_Bool_Exp>;
  governance_satellite_oracle_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  start_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Governance_Satellite_Oracle_Aggregator_Max_Fields = {
  __typename?: 'governance_satellite_oracle_aggregator_max_fields';
  aggregator_id?: Maybe<Scalars['bigint']['output']>;
  governance_satellite_oracle_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  start_timestamp?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "governance_satellite_oracle_aggregator" */
export type Governance_Satellite_Oracle_Aggregator_Max_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  governance_satellite_oracle_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  start_timestamp?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_Satellite_Oracle_Aggregator_Min_Fields = {
  __typename?: 'governance_satellite_oracle_aggregator_min_fields';
  aggregator_id?: Maybe<Scalars['bigint']['output']>;
  governance_satellite_oracle_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  start_timestamp?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "governance_satellite_oracle_aggregator" */
export type Governance_Satellite_Oracle_Aggregator_Min_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  governance_satellite_oracle_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  start_timestamp?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_satellite_oracle_aggregator". */
export type Governance_Satellite_Oracle_Aggregator_Order_By = {
  aggregator?: InputMaybe<Aggregator_Order_By>;
  aggregator_id?: InputMaybe<Order_By>;
  governance_satellite_oracle?: InputMaybe<Governance_Satellite_Oracle_Order_By>;
  governance_satellite_oracle_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  start_timestamp?: InputMaybe<Order_By>;
};

/** select columns of table "governance_satellite_oracle_aggregator" */
export enum Governance_Satellite_Oracle_Aggregator_Select_Column {
  /** column name */
  AggregatorId = 'aggregator_id',
  /** column name */
  GovernanceSatelliteOracleId = 'governance_satellite_oracle_id',
  /** column name */
  Id = 'id',
  /** column name */
  StartTimestamp = 'start_timestamp'
}

/** aggregate stddev on columns */
export type Governance_Satellite_Oracle_Aggregator_Stddev_Fields = {
  __typename?: 'governance_satellite_oracle_aggregator_stddev_fields';
  aggregator_id?: Maybe<Scalars['Float']['output']>;
  governance_satellite_oracle_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_satellite_oracle_aggregator" */
export type Governance_Satellite_Oracle_Aggregator_Stddev_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  governance_satellite_oracle_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_Satellite_Oracle_Aggregator_Stddev_Pop_Fields = {
  __typename?: 'governance_satellite_oracle_aggregator_stddev_pop_fields';
  aggregator_id?: Maybe<Scalars['Float']['output']>;
  governance_satellite_oracle_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_satellite_oracle_aggregator" */
export type Governance_Satellite_Oracle_Aggregator_Stddev_Pop_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  governance_satellite_oracle_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_Satellite_Oracle_Aggregator_Stddev_Samp_Fields = {
  __typename?: 'governance_satellite_oracle_aggregator_stddev_samp_fields';
  aggregator_id?: Maybe<Scalars['Float']['output']>;
  governance_satellite_oracle_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_satellite_oracle_aggregator" */
export type Governance_Satellite_Oracle_Aggregator_Stddev_Samp_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  governance_satellite_oracle_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_satellite_oracle_aggregator" */
export type Governance_Satellite_Oracle_Aggregator_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Satellite_Oracle_Aggregator_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Satellite_Oracle_Aggregator_Stream_Cursor_Value_Input = {
  aggregator_id?: InputMaybe<Scalars['bigint']['input']>;
  governance_satellite_oracle_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  start_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Governance_Satellite_Oracle_Aggregator_Sum_Fields = {
  __typename?: 'governance_satellite_oracle_aggregator_sum_fields';
  aggregator_id?: Maybe<Scalars['bigint']['output']>;
  governance_satellite_oracle_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "governance_satellite_oracle_aggregator" */
export type Governance_Satellite_Oracle_Aggregator_Sum_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  governance_satellite_oracle_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_Satellite_Oracle_Aggregator_Var_Pop_Fields = {
  __typename?: 'governance_satellite_oracle_aggregator_var_pop_fields';
  aggregator_id?: Maybe<Scalars['Float']['output']>;
  governance_satellite_oracle_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_satellite_oracle_aggregator" */
export type Governance_Satellite_Oracle_Aggregator_Var_Pop_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  governance_satellite_oracle_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_Satellite_Oracle_Aggregator_Var_Samp_Fields = {
  __typename?: 'governance_satellite_oracle_aggregator_var_samp_fields';
  aggregator_id?: Maybe<Scalars['Float']['output']>;
  governance_satellite_oracle_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_satellite_oracle_aggregator" */
export type Governance_Satellite_Oracle_Aggregator_Var_Samp_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  governance_satellite_oracle_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_Satellite_Oracle_Aggregator_Variance_Fields = {
  __typename?: 'governance_satellite_oracle_aggregator_variance_fields';
  aggregator_id?: Maybe<Scalars['Float']['output']>;
  governance_satellite_oracle_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_satellite_oracle_aggregator" */
export type Governance_Satellite_Oracle_Aggregator_Variance_Order_By = {
  aggregator_id?: InputMaybe<Order_By>;
  governance_satellite_oracle_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Governance_Satellite_Oracle_Avg_Fields = {
  __typename?: 'governance_satellite_oracle_avg_fields';
  governance_satellite_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_satellite_oracle" */
export type Governance_Satellite_Oracle_Avg_Order_By = {
  governance_satellite_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_satellite_oracle". All fields are combined with a logical 'AND'. */
export type Governance_Satellite_Oracle_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Satellite_Oracle_Bool_Exp>>;
  _not?: InputMaybe<Governance_Satellite_Oracle_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Satellite_Oracle_Bool_Exp>>;
  aggregators?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Bool_Exp>;
  aggregators_aggregate?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Aggregate_Bool_Exp>;
  governance_satellite?: InputMaybe<Governance_Satellite_Bool_Exp>;
  governance_satellite_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  oracle?: InputMaybe<Maven_User_Bool_Exp>;
  oracle_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Governance_Satellite_Oracle_Max_Fields = {
  __typename?: 'governance_satellite_oracle_max_fields';
  governance_satellite_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  oracle_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "governance_satellite_oracle" */
export type Governance_Satellite_Oracle_Max_Order_By = {
  governance_satellite_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_Satellite_Oracle_Min_Fields = {
  __typename?: 'governance_satellite_oracle_min_fields';
  governance_satellite_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  oracle_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "governance_satellite_oracle" */
export type Governance_Satellite_Oracle_Min_Order_By = {
  governance_satellite_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_satellite_oracle". */
export type Governance_Satellite_Oracle_Order_By = {
  aggregators_aggregate?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Aggregate_Order_By>;
  governance_satellite?: InputMaybe<Governance_Satellite_Order_By>;
  governance_satellite_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oracle?: InputMaybe<Maven_User_Order_By>;
  oracle_id?: InputMaybe<Order_By>;
};

/** select columns of table "governance_satellite_oracle" */
export enum Governance_Satellite_Oracle_Select_Column {
  /** column name */
  GovernanceSatelliteId = 'governance_satellite_id',
  /** column name */
  Id = 'id',
  /** column name */
  OracleId = 'oracle_id'
}

/** aggregate stddev on columns */
export type Governance_Satellite_Oracle_Stddev_Fields = {
  __typename?: 'governance_satellite_oracle_stddev_fields';
  governance_satellite_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_satellite_oracle" */
export type Governance_Satellite_Oracle_Stddev_Order_By = {
  governance_satellite_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_Satellite_Oracle_Stddev_Pop_Fields = {
  __typename?: 'governance_satellite_oracle_stddev_pop_fields';
  governance_satellite_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_satellite_oracle" */
export type Governance_Satellite_Oracle_Stddev_Pop_Order_By = {
  governance_satellite_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_Satellite_Oracle_Stddev_Samp_Fields = {
  __typename?: 'governance_satellite_oracle_stddev_samp_fields';
  governance_satellite_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_satellite_oracle" */
export type Governance_Satellite_Oracle_Stddev_Samp_Order_By = {
  governance_satellite_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_satellite_oracle" */
export type Governance_Satellite_Oracle_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Satellite_Oracle_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Satellite_Oracle_Stream_Cursor_Value_Input = {
  governance_satellite_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  oracle_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Governance_Satellite_Oracle_Sum_Fields = {
  __typename?: 'governance_satellite_oracle_sum_fields';
  governance_satellite_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  oracle_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "governance_satellite_oracle" */
export type Governance_Satellite_Oracle_Sum_Order_By = {
  governance_satellite_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_Satellite_Oracle_Var_Pop_Fields = {
  __typename?: 'governance_satellite_oracle_var_pop_fields';
  governance_satellite_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_satellite_oracle" */
export type Governance_Satellite_Oracle_Var_Pop_Order_By = {
  governance_satellite_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_Satellite_Oracle_Var_Samp_Fields = {
  __typename?: 'governance_satellite_oracle_var_samp_fields';
  governance_satellite_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_satellite_oracle" */
export type Governance_Satellite_Oracle_Var_Samp_Order_By = {
  governance_satellite_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_Satellite_Oracle_Variance_Fields = {
  __typename?: 'governance_satellite_oracle_variance_fields';
  governance_satellite_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_satellite_oracle" */
export type Governance_Satellite_Oracle_Variance_Order_By = {
  governance_satellite_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_satellite". */
export type Governance_Satellite_Order_By = {
  actions_aggregate?: InputMaybe<Governance_Satellite_Action_Aggregate_Order_By>;
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  approval_percentage?: InputMaybe<Order_By>;
  general_contracts_aggregate?: InputMaybe<Governance_Satellite_General_Contract_Aggregate_Order_By>;
  gov_purpose_max_length?: InputMaybe<Order_By>;
  governance?: InputMaybe<Governance_Order_By>;
  governance_id?: InputMaybe<Order_By>;
  governance_satellite_counter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambdas_aggregate?: InputMaybe<Governance_Satellite_Lambda_Aggregate_Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  max_actions_per_satellite?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  oracles_aggregate?: InputMaybe<Governance_Satellite_Oracle_Aggregate_Order_By>;
  sat_action_duration_in_days?: InputMaybe<Order_By>;
  whitelist_contracts_aggregate?: InputMaybe<Governance_Satellite_Whitelist_Contract_Aggregate_Order_By>;
};

/** select columns of table "governance_satellite" */
export enum Governance_Satellite_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Admin = 'admin',
  /** column name */
  ApprovalPercentage = 'approval_percentage',
  /** column name */
  GovPurposeMaxLength = 'gov_purpose_max_length',
  /** column name */
  GovernanceId = 'governance_id',
  /** column name */
  GovernanceSatelliteCounter = 'governance_satellite_counter',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  MaxActionsPerSatellite = 'max_actions_per_satellite',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Network = 'network',
  /** column name */
  SatActionDurationInDays = 'sat_action_duration_in_days'
}

/** columns and relationships of "governance_satellite_snapshot" */
export type Governance_Satellite_Snapshot = {
  __typename?: 'governance_satellite_snapshot';
  accumulated_rewards_per_share: Scalars['float8']['output'];
  cycle: Scalars['bigint']['output'];
  /** An object relationship */
  governance: Governance;
  /** An array relationship */
  governance_financial_requests_votes: Array<Governance_Financial_Request_Vote>;
  /** An aggregate relationship */
  governance_financial_requests_votes_aggregate: Governance_Financial_Request_Vote_Aggregate;
  governance_id: Scalars['bigint']['output'];
  /** An array relationship */
  governance_satellite_actions_votes: Array<Governance_Satellite_Action_Vote>;
  /** An aggregate relationship */
  governance_satellite_actions_votes_aggregate: Governance_Satellite_Action_Vote_Aggregate;
  id: Scalars['bigint']['output'];
  latest: Scalars['Boolean']['output'];
  next_snapshot_cycle_id?: Maybe<Scalars['bigint']['output']>;
  ready: Scalars['Boolean']['output'];
  total_delegated_amount: Scalars['float8']['output'];
  total_smvn_balance: Scalars['float8']['output'];
  total_voting_power: Scalars['float8']['output'];
  /** An object relationship */
  user: Maven_User;
  user_id: Scalars['bigint']['output'];
};


/** columns and relationships of "governance_satellite_snapshot" */
export type Governance_Satellite_SnapshotGovernance_Financial_Requests_VotesArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Request_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Request_Vote_Order_By>>;
  where?: InputMaybe<Governance_Financial_Request_Vote_Bool_Exp>;
};


/** columns and relationships of "governance_satellite_snapshot" */
export type Governance_Satellite_SnapshotGovernance_Financial_Requests_Votes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Request_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Request_Vote_Order_By>>;
  where?: InputMaybe<Governance_Financial_Request_Vote_Bool_Exp>;
};


/** columns and relationships of "governance_satellite_snapshot" */
export type Governance_Satellite_SnapshotGovernance_Satellite_Actions_VotesArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Action_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Action_Vote_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Action_Vote_Bool_Exp>;
};


/** columns and relationships of "governance_satellite_snapshot" */
export type Governance_Satellite_SnapshotGovernance_Satellite_Actions_Votes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Action_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Action_Vote_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Action_Vote_Bool_Exp>;
};

/** aggregated selection of "governance_satellite_snapshot" */
export type Governance_Satellite_Snapshot_Aggregate = {
  __typename?: 'governance_satellite_snapshot_aggregate';
  aggregate?: Maybe<Governance_Satellite_Snapshot_Aggregate_Fields>;
  nodes: Array<Governance_Satellite_Snapshot>;
};

export type Governance_Satellite_Snapshot_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Var_Samp>;
};

export type Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Avg = {
  arguments: Governance_Satellite_Snapshot_Select_Column_Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Snapshot_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Bool_And = {
  arguments: Governance_Satellite_Snapshot_Select_Column_Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Snapshot_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Governance_Satellite_Snapshot_Select_Column_Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Snapshot_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Corr = {
  arguments: Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Snapshot_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Governance_Satellite_Snapshot_Select_Column_Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Governance_Satellite_Snapshot_Select_Column_Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_Satellite_Snapshot_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Snapshot_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Snapshot_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Governance_Satellite_Snapshot_Select_Column_Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Governance_Satellite_Snapshot_Select_Column_Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Max = {
  arguments: Governance_Satellite_Snapshot_Select_Column_Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Snapshot_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Min = {
  arguments: Governance_Satellite_Snapshot_Select_Column_Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Snapshot_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Governance_Satellite_Snapshot_Select_Column_Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Snapshot_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Sum = {
  arguments: Governance_Satellite_Snapshot_Select_Column_Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Snapshot_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Governance_Satellite_Snapshot_Select_Column_Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Snapshot_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "governance_satellite_snapshot" */
export type Governance_Satellite_Snapshot_Aggregate_Fields = {
  __typename?: 'governance_satellite_snapshot_aggregate_fields';
  avg?: Maybe<Governance_Satellite_Snapshot_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Satellite_Snapshot_Max_Fields>;
  min?: Maybe<Governance_Satellite_Snapshot_Min_Fields>;
  stddev?: Maybe<Governance_Satellite_Snapshot_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Satellite_Snapshot_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Satellite_Snapshot_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Satellite_Snapshot_Sum_Fields>;
  var_pop?: Maybe<Governance_Satellite_Snapshot_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Satellite_Snapshot_Var_Samp_Fields>;
  variance?: Maybe<Governance_Satellite_Snapshot_Variance_Fields>;
};


/** aggregate fields of "governance_satellite_snapshot" */
export type Governance_Satellite_Snapshot_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Satellite_Snapshot_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_satellite_snapshot" */
export type Governance_Satellite_Snapshot_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_Satellite_Snapshot_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_Satellite_Snapshot_Max_Order_By>;
  min?: InputMaybe<Governance_Satellite_Snapshot_Min_Order_By>;
  stddev?: InputMaybe<Governance_Satellite_Snapshot_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_Satellite_Snapshot_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_Satellite_Snapshot_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_Satellite_Snapshot_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_Satellite_Snapshot_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_Satellite_Snapshot_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_Satellite_Snapshot_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Governance_Satellite_Snapshot_Avg_Fields = {
  __typename?: 'governance_satellite_snapshot_avg_fields';
  accumulated_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  cycle?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  next_snapshot_cycle_id?: Maybe<Scalars['Float']['output']>;
  total_delegated_amount?: Maybe<Scalars['Float']['output']>;
  total_smvn_balance?: Maybe<Scalars['Float']['output']>;
  total_voting_power?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_satellite_snapshot" */
export type Governance_Satellite_Snapshot_Avg_Order_By = {
  accumulated_rewards_per_share?: InputMaybe<Order_By>;
  cycle?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_snapshot_cycle_id?: InputMaybe<Order_By>;
  total_delegated_amount?: InputMaybe<Order_By>;
  total_smvn_balance?: InputMaybe<Order_By>;
  total_voting_power?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_satellite_snapshot". All fields are combined with a logical 'AND'. */
export type Governance_Satellite_Snapshot_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Satellite_Snapshot_Bool_Exp>>;
  _not?: InputMaybe<Governance_Satellite_Snapshot_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Satellite_Snapshot_Bool_Exp>>;
  accumulated_rewards_per_share?: InputMaybe<Float8_Comparison_Exp>;
  cycle?: InputMaybe<Bigint_Comparison_Exp>;
  governance?: InputMaybe<Governance_Bool_Exp>;
  governance_financial_requests_votes?: InputMaybe<Governance_Financial_Request_Vote_Bool_Exp>;
  governance_financial_requests_votes_aggregate?: InputMaybe<Governance_Financial_Request_Vote_Aggregate_Bool_Exp>;
  governance_id?: InputMaybe<Bigint_Comparison_Exp>;
  governance_satellite_actions_votes?: InputMaybe<Governance_Satellite_Action_Vote_Bool_Exp>;
  governance_satellite_actions_votes_aggregate?: InputMaybe<Governance_Satellite_Action_Vote_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  latest?: InputMaybe<Boolean_Comparison_Exp>;
  next_snapshot_cycle_id?: InputMaybe<Bigint_Comparison_Exp>;
  ready?: InputMaybe<Boolean_Comparison_Exp>;
  total_delegated_amount?: InputMaybe<Float8_Comparison_Exp>;
  total_smvn_balance?: InputMaybe<Float8_Comparison_Exp>;
  total_voting_power?: InputMaybe<Float8_Comparison_Exp>;
  user?: InputMaybe<Maven_User_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Governance_Satellite_Snapshot_Max_Fields = {
  __typename?: 'governance_satellite_snapshot_max_fields';
  accumulated_rewards_per_share?: Maybe<Scalars['float8']['output']>;
  cycle?: Maybe<Scalars['bigint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  next_snapshot_cycle_id?: Maybe<Scalars['bigint']['output']>;
  total_delegated_amount?: Maybe<Scalars['float8']['output']>;
  total_smvn_balance?: Maybe<Scalars['float8']['output']>;
  total_voting_power?: Maybe<Scalars['float8']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "governance_satellite_snapshot" */
export type Governance_Satellite_Snapshot_Max_Order_By = {
  accumulated_rewards_per_share?: InputMaybe<Order_By>;
  cycle?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_snapshot_cycle_id?: InputMaybe<Order_By>;
  total_delegated_amount?: InputMaybe<Order_By>;
  total_smvn_balance?: InputMaybe<Order_By>;
  total_voting_power?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_Satellite_Snapshot_Min_Fields = {
  __typename?: 'governance_satellite_snapshot_min_fields';
  accumulated_rewards_per_share?: Maybe<Scalars['float8']['output']>;
  cycle?: Maybe<Scalars['bigint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  next_snapshot_cycle_id?: Maybe<Scalars['bigint']['output']>;
  total_delegated_amount?: Maybe<Scalars['float8']['output']>;
  total_smvn_balance?: Maybe<Scalars['float8']['output']>;
  total_voting_power?: Maybe<Scalars['float8']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "governance_satellite_snapshot" */
export type Governance_Satellite_Snapshot_Min_Order_By = {
  accumulated_rewards_per_share?: InputMaybe<Order_By>;
  cycle?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_snapshot_cycle_id?: InputMaybe<Order_By>;
  total_delegated_amount?: InputMaybe<Order_By>;
  total_smvn_balance?: InputMaybe<Order_By>;
  total_voting_power?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_satellite_snapshot". */
export type Governance_Satellite_Snapshot_Order_By = {
  accumulated_rewards_per_share?: InputMaybe<Order_By>;
  cycle?: InputMaybe<Order_By>;
  governance?: InputMaybe<Governance_Order_By>;
  governance_financial_requests_votes_aggregate?: InputMaybe<Governance_Financial_Request_Vote_Aggregate_Order_By>;
  governance_id?: InputMaybe<Order_By>;
  governance_satellite_actions_votes_aggregate?: InputMaybe<Governance_Satellite_Action_Vote_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  latest?: InputMaybe<Order_By>;
  next_snapshot_cycle_id?: InputMaybe<Order_By>;
  ready?: InputMaybe<Order_By>;
  total_delegated_amount?: InputMaybe<Order_By>;
  total_smvn_balance?: InputMaybe<Order_By>;
  total_voting_power?: InputMaybe<Order_By>;
  user?: InputMaybe<Maven_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "governance_satellite_snapshot" */
export enum Governance_Satellite_Snapshot_Select_Column {
  /** column name */
  AccumulatedRewardsPerShare = 'accumulated_rewards_per_share',
  /** column name */
  Cycle = 'cycle',
  /** column name */
  GovernanceId = 'governance_id',
  /** column name */
  Id = 'id',
  /** column name */
  Latest = 'latest',
  /** column name */
  NextSnapshotCycleId = 'next_snapshot_cycle_id',
  /** column name */
  Ready = 'ready',
  /** column name */
  TotalDelegatedAmount = 'total_delegated_amount',
  /** column name */
  TotalSmvnBalance = 'total_smvn_balance',
  /** column name */
  TotalVotingPower = 'total_voting_power',
  /** column name */
  UserId = 'user_id'
}

/** select "governance_satellite_snapshot_aggregate_bool_exp_avg_arguments_columns" columns of table "governance_satellite_snapshot" */
export enum Governance_Satellite_Snapshot_Select_Column_Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  AccumulatedRewardsPerShare = 'accumulated_rewards_per_share',
  /** column name */
  TotalDelegatedAmount = 'total_delegated_amount',
  /** column name */
  TotalSmvnBalance = 'total_smvn_balance',
  /** column name */
  TotalVotingPower = 'total_voting_power'
}

/** select "governance_satellite_snapshot_aggregate_bool_exp_bool_and_arguments_columns" columns of table "governance_satellite_snapshot" */
export enum Governance_Satellite_Snapshot_Select_Column_Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Latest = 'latest',
  /** column name */
  Ready = 'ready'
}

/** select "governance_satellite_snapshot_aggregate_bool_exp_bool_or_arguments_columns" columns of table "governance_satellite_snapshot" */
export enum Governance_Satellite_Snapshot_Select_Column_Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Latest = 'latest',
  /** column name */
  Ready = 'ready'
}

/** select "governance_satellite_snapshot_aggregate_bool_exp_corr_arguments_columns" columns of table "governance_satellite_snapshot" */
export enum Governance_Satellite_Snapshot_Select_Column_Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  AccumulatedRewardsPerShare = 'accumulated_rewards_per_share',
  /** column name */
  TotalDelegatedAmount = 'total_delegated_amount',
  /** column name */
  TotalSmvnBalance = 'total_smvn_balance',
  /** column name */
  TotalVotingPower = 'total_voting_power'
}

/** select "governance_satellite_snapshot_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "governance_satellite_snapshot" */
export enum Governance_Satellite_Snapshot_Select_Column_Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  AccumulatedRewardsPerShare = 'accumulated_rewards_per_share',
  /** column name */
  TotalDelegatedAmount = 'total_delegated_amount',
  /** column name */
  TotalSmvnBalance = 'total_smvn_balance',
  /** column name */
  TotalVotingPower = 'total_voting_power'
}

/** select "governance_satellite_snapshot_aggregate_bool_exp_max_arguments_columns" columns of table "governance_satellite_snapshot" */
export enum Governance_Satellite_Snapshot_Select_Column_Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  AccumulatedRewardsPerShare = 'accumulated_rewards_per_share',
  /** column name */
  TotalDelegatedAmount = 'total_delegated_amount',
  /** column name */
  TotalSmvnBalance = 'total_smvn_balance',
  /** column name */
  TotalVotingPower = 'total_voting_power'
}

/** select "governance_satellite_snapshot_aggregate_bool_exp_min_arguments_columns" columns of table "governance_satellite_snapshot" */
export enum Governance_Satellite_Snapshot_Select_Column_Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  AccumulatedRewardsPerShare = 'accumulated_rewards_per_share',
  /** column name */
  TotalDelegatedAmount = 'total_delegated_amount',
  /** column name */
  TotalSmvnBalance = 'total_smvn_balance',
  /** column name */
  TotalVotingPower = 'total_voting_power'
}

/** select "governance_satellite_snapshot_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "governance_satellite_snapshot" */
export enum Governance_Satellite_Snapshot_Select_Column_Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  AccumulatedRewardsPerShare = 'accumulated_rewards_per_share',
  /** column name */
  TotalDelegatedAmount = 'total_delegated_amount',
  /** column name */
  TotalSmvnBalance = 'total_smvn_balance',
  /** column name */
  TotalVotingPower = 'total_voting_power'
}

/** select "governance_satellite_snapshot_aggregate_bool_exp_sum_arguments_columns" columns of table "governance_satellite_snapshot" */
export enum Governance_Satellite_Snapshot_Select_Column_Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  AccumulatedRewardsPerShare = 'accumulated_rewards_per_share',
  /** column name */
  TotalDelegatedAmount = 'total_delegated_amount',
  /** column name */
  TotalSmvnBalance = 'total_smvn_balance',
  /** column name */
  TotalVotingPower = 'total_voting_power'
}

/** select "governance_satellite_snapshot_aggregate_bool_exp_var_samp_arguments_columns" columns of table "governance_satellite_snapshot" */
export enum Governance_Satellite_Snapshot_Select_Column_Governance_Satellite_Snapshot_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  AccumulatedRewardsPerShare = 'accumulated_rewards_per_share',
  /** column name */
  TotalDelegatedAmount = 'total_delegated_amount',
  /** column name */
  TotalSmvnBalance = 'total_smvn_balance',
  /** column name */
  TotalVotingPower = 'total_voting_power'
}

/** aggregate stddev on columns */
export type Governance_Satellite_Snapshot_Stddev_Fields = {
  __typename?: 'governance_satellite_snapshot_stddev_fields';
  accumulated_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  cycle?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  next_snapshot_cycle_id?: Maybe<Scalars['Float']['output']>;
  total_delegated_amount?: Maybe<Scalars['Float']['output']>;
  total_smvn_balance?: Maybe<Scalars['Float']['output']>;
  total_voting_power?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_satellite_snapshot" */
export type Governance_Satellite_Snapshot_Stddev_Order_By = {
  accumulated_rewards_per_share?: InputMaybe<Order_By>;
  cycle?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_snapshot_cycle_id?: InputMaybe<Order_By>;
  total_delegated_amount?: InputMaybe<Order_By>;
  total_smvn_balance?: InputMaybe<Order_By>;
  total_voting_power?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_Satellite_Snapshot_Stddev_Pop_Fields = {
  __typename?: 'governance_satellite_snapshot_stddev_pop_fields';
  accumulated_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  cycle?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  next_snapshot_cycle_id?: Maybe<Scalars['Float']['output']>;
  total_delegated_amount?: Maybe<Scalars['Float']['output']>;
  total_smvn_balance?: Maybe<Scalars['Float']['output']>;
  total_voting_power?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_satellite_snapshot" */
export type Governance_Satellite_Snapshot_Stddev_Pop_Order_By = {
  accumulated_rewards_per_share?: InputMaybe<Order_By>;
  cycle?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_snapshot_cycle_id?: InputMaybe<Order_By>;
  total_delegated_amount?: InputMaybe<Order_By>;
  total_smvn_balance?: InputMaybe<Order_By>;
  total_voting_power?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_Satellite_Snapshot_Stddev_Samp_Fields = {
  __typename?: 'governance_satellite_snapshot_stddev_samp_fields';
  accumulated_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  cycle?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  next_snapshot_cycle_id?: Maybe<Scalars['Float']['output']>;
  total_delegated_amount?: Maybe<Scalars['Float']['output']>;
  total_smvn_balance?: Maybe<Scalars['Float']['output']>;
  total_voting_power?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_satellite_snapshot" */
export type Governance_Satellite_Snapshot_Stddev_Samp_Order_By = {
  accumulated_rewards_per_share?: InputMaybe<Order_By>;
  cycle?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_snapshot_cycle_id?: InputMaybe<Order_By>;
  total_delegated_amount?: InputMaybe<Order_By>;
  total_smvn_balance?: InputMaybe<Order_By>;
  total_voting_power?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_satellite_snapshot" */
export type Governance_Satellite_Snapshot_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Satellite_Snapshot_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Satellite_Snapshot_Stream_Cursor_Value_Input = {
  accumulated_rewards_per_share?: InputMaybe<Scalars['float8']['input']>;
  cycle?: InputMaybe<Scalars['bigint']['input']>;
  governance_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  latest?: InputMaybe<Scalars['Boolean']['input']>;
  next_snapshot_cycle_id?: InputMaybe<Scalars['bigint']['input']>;
  ready?: InputMaybe<Scalars['Boolean']['input']>;
  total_delegated_amount?: InputMaybe<Scalars['float8']['input']>;
  total_smvn_balance?: InputMaybe<Scalars['float8']['input']>;
  total_voting_power?: InputMaybe<Scalars['float8']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Governance_Satellite_Snapshot_Sum_Fields = {
  __typename?: 'governance_satellite_snapshot_sum_fields';
  accumulated_rewards_per_share?: Maybe<Scalars['float8']['output']>;
  cycle?: Maybe<Scalars['bigint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  next_snapshot_cycle_id?: Maybe<Scalars['bigint']['output']>;
  total_delegated_amount?: Maybe<Scalars['float8']['output']>;
  total_smvn_balance?: Maybe<Scalars['float8']['output']>;
  total_voting_power?: Maybe<Scalars['float8']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "governance_satellite_snapshot" */
export type Governance_Satellite_Snapshot_Sum_Order_By = {
  accumulated_rewards_per_share?: InputMaybe<Order_By>;
  cycle?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_snapshot_cycle_id?: InputMaybe<Order_By>;
  total_delegated_amount?: InputMaybe<Order_By>;
  total_smvn_balance?: InputMaybe<Order_By>;
  total_voting_power?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_Satellite_Snapshot_Var_Pop_Fields = {
  __typename?: 'governance_satellite_snapshot_var_pop_fields';
  accumulated_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  cycle?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  next_snapshot_cycle_id?: Maybe<Scalars['Float']['output']>;
  total_delegated_amount?: Maybe<Scalars['Float']['output']>;
  total_smvn_balance?: Maybe<Scalars['Float']['output']>;
  total_voting_power?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_satellite_snapshot" */
export type Governance_Satellite_Snapshot_Var_Pop_Order_By = {
  accumulated_rewards_per_share?: InputMaybe<Order_By>;
  cycle?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_snapshot_cycle_id?: InputMaybe<Order_By>;
  total_delegated_amount?: InputMaybe<Order_By>;
  total_smvn_balance?: InputMaybe<Order_By>;
  total_voting_power?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_Satellite_Snapshot_Var_Samp_Fields = {
  __typename?: 'governance_satellite_snapshot_var_samp_fields';
  accumulated_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  cycle?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  next_snapshot_cycle_id?: Maybe<Scalars['Float']['output']>;
  total_delegated_amount?: Maybe<Scalars['Float']['output']>;
  total_smvn_balance?: Maybe<Scalars['Float']['output']>;
  total_voting_power?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_satellite_snapshot" */
export type Governance_Satellite_Snapshot_Var_Samp_Order_By = {
  accumulated_rewards_per_share?: InputMaybe<Order_By>;
  cycle?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_snapshot_cycle_id?: InputMaybe<Order_By>;
  total_delegated_amount?: InputMaybe<Order_By>;
  total_smvn_balance?: InputMaybe<Order_By>;
  total_voting_power?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_Satellite_Snapshot_Variance_Fields = {
  __typename?: 'governance_satellite_snapshot_variance_fields';
  accumulated_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  cycle?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  next_snapshot_cycle_id?: Maybe<Scalars['Float']['output']>;
  total_delegated_amount?: Maybe<Scalars['Float']['output']>;
  total_smvn_balance?: Maybe<Scalars['Float']['output']>;
  total_voting_power?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_satellite_snapshot" */
export type Governance_Satellite_Snapshot_Variance_Order_By = {
  accumulated_rewards_per_share?: InputMaybe<Order_By>;
  cycle?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_snapshot_cycle_id?: InputMaybe<Order_By>;
  total_delegated_amount?: InputMaybe<Order_By>;
  total_smvn_balance?: InputMaybe<Order_By>;
  total_voting_power?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev on columns */
export type Governance_Satellite_Stddev_Fields = {
  __typename?: 'governance_satellite_stddev_fields';
  approval_percentage?: Maybe<Scalars['Float']['output']>;
  gov_purpose_max_length?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  governance_satellite_counter?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_actions_per_satellite?: Maybe<Scalars['Float']['output']>;
  sat_action_duration_in_days?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_satellite" */
export type Governance_Satellite_Stddev_Order_By = {
  approval_percentage?: InputMaybe<Order_By>;
  gov_purpose_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  governance_satellite_counter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_actions_per_satellite?: InputMaybe<Order_By>;
  sat_action_duration_in_days?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_Satellite_Stddev_Pop_Fields = {
  __typename?: 'governance_satellite_stddev_pop_fields';
  approval_percentage?: Maybe<Scalars['Float']['output']>;
  gov_purpose_max_length?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  governance_satellite_counter?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_actions_per_satellite?: Maybe<Scalars['Float']['output']>;
  sat_action_duration_in_days?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_satellite" */
export type Governance_Satellite_Stddev_Pop_Order_By = {
  approval_percentage?: InputMaybe<Order_By>;
  gov_purpose_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  governance_satellite_counter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_actions_per_satellite?: InputMaybe<Order_By>;
  sat_action_duration_in_days?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_Satellite_Stddev_Samp_Fields = {
  __typename?: 'governance_satellite_stddev_samp_fields';
  approval_percentage?: Maybe<Scalars['Float']['output']>;
  gov_purpose_max_length?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  governance_satellite_counter?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_actions_per_satellite?: Maybe<Scalars['Float']['output']>;
  sat_action_duration_in_days?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_satellite" */
export type Governance_Satellite_Stddev_Samp_Order_By = {
  approval_percentage?: InputMaybe<Order_By>;
  gov_purpose_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  governance_satellite_counter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_actions_per_satellite?: InputMaybe<Order_By>;
  sat_action_duration_in_days?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_satellite" */
export type Governance_Satellite_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Satellite_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Satellite_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['String']['input']>;
  approval_percentage?: InputMaybe<Scalars['smallint']['input']>;
  gov_purpose_max_length?: InputMaybe<Scalars['smallint']['input']>;
  governance_id?: InputMaybe<Scalars['bigint']['input']>;
  governance_satellite_counter?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  max_actions_per_satellite?: InputMaybe<Scalars['smallint']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  sat_action_duration_in_days?: InputMaybe<Scalars['smallint']['input']>;
};

/** aggregate sum on columns */
export type Governance_Satellite_Sum_Fields = {
  __typename?: 'governance_satellite_sum_fields';
  approval_percentage?: Maybe<Scalars['smallint']['output']>;
  gov_purpose_max_length?: Maybe<Scalars['smallint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  governance_satellite_counter?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  max_actions_per_satellite?: Maybe<Scalars['smallint']['output']>;
  sat_action_duration_in_days?: Maybe<Scalars['smallint']['output']>;
};

/** order by sum() on columns of table "governance_satellite" */
export type Governance_Satellite_Sum_Order_By = {
  approval_percentage?: InputMaybe<Order_By>;
  gov_purpose_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  governance_satellite_counter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_actions_per_satellite?: InputMaybe<Order_By>;
  sat_action_duration_in_days?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_Satellite_Var_Pop_Fields = {
  __typename?: 'governance_satellite_var_pop_fields';
  approval_percentage?: Maybe<Scalars['Float']['output']>;
  gov_purpose_max_length?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  governance_satellite_counter?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_actions_per_satellite?: Maybe<Scalars['Float']['output']>;
  sat_action_duration_in_days?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_satellite" */
export type Governance_Satellite_Var_Pop_Order_By = {
  approval_percentage?: InputMaybe<Order_By>;
  gov_purpose_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  governance_satellite_counter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_actions_per_satellite?: InputMaybe<Order_By>;
  sat_action_duration_in_days?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_Satellite_Var_Samp_Fields = {
  __typename?: 'governance_satellite_var_samp_fields';
  approval_percentage?: Maybe<Scalars['Float']['output']>;
  gov_purpose_max_length?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  governance_satellite_counter?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_actions_per_satellite?: Maybe<Scalars['Float']['output']>;
  sat_action_duration_in_days?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_satellite" */
export type Governance_Satellite_Var_Samp_Order_By = {
  approval_percentage?: InputMaybe<Order_By>;
  gov_purpose_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  governance_satellite_counter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_actions_per_satellite?: InputMaybe<Order_By>;
  sat_action_duration_in_days?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_Satellite_Variance_Fields = {
  __typename?: 'governance_satellite_variance_fields';
  approval_percentage?: Maybe<Scalars['Float']['output']>;
  gov_purpose_max_length?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  governance_satellite_counter?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_actions_per_satellite?: Maybe<Scalars['Float']['output']>;
  sat_action_duration_in_days?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_satellite" */
export type Governance_Satellite_Variance_Order_By = {
  approval_percentage?: InputMaybe<Order_By>;
  gov_purpose_max_length?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  governance_satellite_counter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_actions_per_satellite?: InputMaybe<Order_By>;
  sat_action_duration_in_days?: InputMaybe<Order_By>;
};

/** columns and relationships of "governance_satellite_whitelist_contract" */
export type Governance_Satellite_Whitelist_Contract = {
  __typename?: 'governance_satellite_whitelist_contract';
  /** An object relationship */
  contract: Governance_Satellite;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "governance_satellite_whitelist_contract" */
export type Governance_Satellite_Whitelist_Contract_Aggregate = {
  __typename?: 'governance_satellite_whitelist_contract_aggregate';
  aggregate?: Maybe<Governance_Satellite_Whitelist_Contract_Aggregate_Fields>;
  nodes: Array<Governance_Satellite_Whitelist_Contract>;
};

export type Governance_Satellite_Whitelist_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Governance_Satellite_Whitelist_Contract_Aggregate_Bool_Exp_Count>;
};

export type Governance_Satellite_Whitelist_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_Satellite_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Satellite_Whitelist_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "governance_satellite_whitelist_contract" */
export type Governance_Satellite_Whitelist_Contract_Aggregate_Fields = {
  __typename?: 'governance_satellite_whitelist_contract_aggregate_fields';
  avg?: Maybe<Governance_Satellite_Whitelist_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Satellite_Whitelist_Contract_Max_Fields>;
  min?: Maybe<Governance_Satellite_Whitelist_Contract_Min_Fields>;
  stddev?: Maybe<Governance_Satellite_Whitelist_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Satellite_Whitelist_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Satellite_Whitelist_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Satellite_Whitelist_Contract_Sum_Fields>;
  var_pop?: Maybe<Governance_Satellite_Whitelist_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Satellite_Whitelist_Contract_Var_Samp_Fields>;
  variance?: Maybe<Governance_Satellite_Whitelist_Contract_Variance_Fields>;
};


/** aggregate fields of "governance_satellite_whitelist_contract" */
export type Governance_Satellite_Whitelist_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Satellite_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_satellite_whitelist_contract" */
export type Governance_Satellite_Whitelist_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_Satellite_Whitelist_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_Satellite_Whitelist_Contract_Max_Order_By>;
  min?: InputMaybe<Governance_Satellite_Whitelist_Contract_Min_Order_By>;
  stddev?: InputMaybe<Governance_Satellite_Whitelist_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_Satellite_Whitelist_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_Satellite_Whitelist_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_Satellite_Whitelist_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_Satellite_Whitelist_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_Satellite_Whitelist_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_Satellite_Whitelist_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Governance_Satellite_Whitelist_Contract_Avg_Fields = {
  __typename?: 'governance_satellite_whitelist_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_satellite_whitelist_contract" */
export type Governance_Satellite_Whitelist_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_satellite_whitelist_contract". All fields are combined with a logical 'AND'. */
export type Governance_Satellite_Whitelist_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Satellite_Whitelist_Contract_Bool_Exp>>;
  _not?: InputMaybe<Governance_Satellite_Whitelist_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Satellite_Whitelist_Contract_Bool_Exp>>;
  contract?: InputMaybe<Governance_Satellite_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Governance_Satellite_Whitelist_Contract_Max_Fields = {
  __typename?: 'governance_satellite_whitelist_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "governance_satellite_whitelist_contract" */
export type Governance_Satellite_Whitelist_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_Satellite_Whitelist_Contract_Min_Fields = {
  __typename?: 'governance_satellite_whitelist_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "governance_satellite_whitelist_contract" */
export type Governance_Satellite_Whitelist_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_satellite_whitelist_contract". */
export type Governance_Satellite_Whitelist_Contract_Order_By = {
  contract?: InputMaybe<Governance_Satellite_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "governance_satellite_whitelist_contract" */
export enum Governance_Satellite_Whitelist_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Governance_Satellite_Whitelist_Contract_Stddev_Fields = {
  __typename?: 'governance_satellite_whitelist_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_satellite_whitelist_contract" */
export type Governance_Satellite_Whitelist_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_Satellite_Whitelist_Contract_Stddev_Pop_Fields = {
  __typename?: 'governance_satellite_whitelist_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_satellite_whitelist_contract" */
export type Governance_Satellite_Whitelist_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_Satellite_Whitelist_Contract_Stddev_Samp_Fields = {
  __typename?: 'governance_satellite_whitelist_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_satellite_whitelist_contract" */
export type Governance_Satellite_Whitelist_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_satellite_whitelist_contract" */
export type Governance_Satellite_Whitelist_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Satellite_Whitelist_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Satellite_Whitelist_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Governance_Satellite_Whitelist_Contract_Sum_Fields = {
  __typename?: 'governance_satellite_whitelist_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "governance_satellite_whitelist_contract" */
export type Governance_Satellite_Whitelist_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_Satellite_Whitelist_Contract_Var_Pop_Fields = {
  __typename?: 'governance_satellite_whitelist_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_satellite_whitelist_contract" */
export type Governance_Satellite_Whitelist_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_Satellite_Whitelist_Contract_Var_Samp_Fields = {
  __typename?: 'governance_satellite_whitelist_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_satellite_whitelist_contract" */
export type Governance_Satellite_Whitelist_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_Satellite_Whitelist_Contract_Variance_Fields = {
  __typename?: 'governance_satellite_whitelist_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_satellite_whitelist_contract" */
export type Governance_Satellite_Whitelist_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "governance" */
export enum Governance_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Admin = 'admin',
  /** column name */
  BlocksPerProposalRound = 'blocks_per_proposal_round',
  /** column name */
  BlocksPerTimelockRound = 'blocks_per_timelock_round',
  /** column name */
  BlocksPerVotingRound = 'blocks_per_voting_round',
  /** column name */
  CurrentBlocksPerProposalRound = 'current_blocks_per_proposal_round',
  /** column name */
  CurrentBlocksPerTimelockRound = 'current_blocks_per_timelock_round',
  /** column name */
  CurrentBlocksPerVotingRound = 'current_blocks_per_voting_round',
  /** column name */
  CurrentCycleEndLevel = 'current_cycle_end_level',
  /** column name */
  CurrentCycleTotalVotersReward = 'current_cycle_total_voters_reward',
  /** column name */
  CurrentRound = 'current_round',
  /** column name */
  CurrentRoundEndLevel = 'current_round_end_level',
  /** column name */
  CurrentRoundStartLevel = 'current_round_start_level',
  /** column name */
  CycleHighestVotedProposalId = 'cycle_highest_voted_proposal_id',
  /** column name */
  CycleId = 'cycle_id',
  /** column name */
  CycleVotersReward = 'cycle_voters_reward',
  /** column name */
  GovernanceProxyAddress = 'governance_proxy_address',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  MaxProposalPerSatellite = 'max_proposal_per_satellite',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MinQuorumPercentage = 'min_quorum_percentage',
  /** column name */
  MinYayVotePercentage = 'min_yay_vote_percentage',
  /** column name */
  Network = 'network',
  /** column name */
  NextProposalId = 'next_proposal_id',
  /** column name */
  ProposalDescriptionMaxLength = 'proposal_description_max_length',
  /** column name */
  ProposalInvoiceMaxLength = 'proposal_invoice_max_length',
  /** column name */
  ProposalMetadataTitleMaxLength = 'proposal_metadata_title_max_length',
  /** column name */
  ProposalRoundVotePercentage = 'proposal_round_vote_percentage',
  /** column name */
  ProposalSourceCodeMaxLength = 'proposal_source_code_max_length',
  /** column name */
  ProposalSubmissionFeeMumav = 'proposal_submission_fee_mumav',
  /** column name */
  ProposalTitleMaxLength = 'proposal_title_max_length',
  /** column name */
  SuccessReward = 'success_reward',
  /** column name */
  TimelockProposalId = 'timelock_proposal_id'
}

/** columns and relationships of "governance_smvn_snapshot" */
export type Governance_Smvn_Snapshot = {
  __typename?: 'governance_smvn_snapshot';
  cycle: Scalars['bigint']['output'];
  /** An object relationship */
  governance: Governance;
  governance_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  smvn_total_supply: Scalars['float8']['output'];
};

/** aggregated selection of "governance_smvn_snapshot" */
export type Governance_Smvn_Snapshot_Aggregate = {
  __typename?: 'governance_smvn_snapshot_aggregate';
  aggregate?: Maybe<Governance_Smvn_Snapshot_Aggregate_Fields>;
  nodes: Array<Governance_Smvn_Snapshot>;
};

export type Governance_Smvn_Snapshot_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Var_Samp>;
};

export type Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Avg = {
  arguments: Governance_Smvn_Snapshot_Select_Column_Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Smvn_Snapshot_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Corr = {
  arguments: Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Smvn_Snapshot_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Governance_Smvn_Snapshot_Select_Column_Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Governance_Smvn_Snapshot_Select_Column_Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_Smvn_Snapshot_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Smvn_Snapshot_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Smvn_Snapshot_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Governance_Smvn_Snapshot_Select_Column_Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Governance_Smvn_Snapshot_Select_Column_Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Max = {
  arguments: Governance_Smvn_Snapshot_Select_Column_Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Smvn_Snapshot_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Min = {
  arguments: Governance_Smvn_Snapshot_Select_Column_Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Smvn_Snapshot_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Governance_Smvn_Snapshot_Select_Column_Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Smvn_Snapshot_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Sum = {
  arguments: Governance_Smvn_Snapshot_Select_Column_Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Smvn_Snapshot_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Governance_Smvn_Snapshot_Select_Column_Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Smvn_Snapshot_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "governance_smvn_snapshot" */
export type Governance_Smvn_Snapshot_Aggregate_Fields = {
  __typename?: 'governance_smvn_snapshot_aggregate_fields';
  avg?: Maybe<Governance_Smvn_Snapshot_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Smvn_Snapshot_Max_Fields>;
  min?: Maybe<Governance_Smvn_Snapshot_Min_Fields>;
  stddev?: Maybe<Governance_Smvn_Snapshot_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Smvn_Snapshot_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Smvn_Snapshot_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Smvn_Snapshot_Sum_Fields>;
  var_pop?: Maybe<Governance_Smvn_Snapshot_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Smvn_Snapshot_Var_Samp_Fields>;
  variance?: Maybe<Governance_Smvn_Snapshot_Variance_Fields>;
};


/** aggregate fields of "governance_smvn_snapshot" */
export type Governance_Smvn_Snapshot_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Smvn_Snapshot_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_smvn_snapshot" */
export type Governance_Smvn_Snapshot_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_Smvn_Snapshot_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_Smvn_Snapshot_Max_Order_By>;
  min?: InputMaybe<Governance_Smvn_Snapshot_Min_Order_By>;
  stddev?: InputMaybe<Governance_Smvn_Snapshot_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_Smvn_Snapshot_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_Smvn_Snapshot_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_Smvn_Snapshot_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_Smvn_Snapshot_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_Smvn_Snapshot_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_Smvn_Snapshot_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Governance_Smvn_Snapshot_Avg_Fields = {
  __typename?: 'governance_smvn_snapshot_avg_fields';
  cycle?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  smvn_total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_smvn_snapshot" */
export type Governance_Smvn_Snapshot_Avg_Order_By = {
  cycle?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  smvn_total_supply?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_smvn_snapshot". All fields are combined with a logical 'AND'. */
export type Governance_Smvn_Snapshot_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Smvn_Snapshot_Bool_Exp>>;
  _not?: InputMaybe<Governance_Smvn_Snapshot_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Smvn_Snapshot_Bool_Exp>>;
  cycle?: InputMaybe<Bigint_Comparison_Exp>;
  governance?: InputMaybe<Governance_Bool_Exp>;
  governance_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  smvn_total_supply?: InputMaybe<Float8_Comparison_Exp>;
};

/** aggregate max on columns */
export type Governance_Smvn_Snapshot_Max_Fields = {
  __typename?: 'governance_smvn_snapshot_max_fields';
  cycle?: Maybe<Scalars['bigint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  smvn_total_supply?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "governance_smvn_snapshot" */
export type Governance_Smvn_Snapshot_Max_Order_By = {
  cycle?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  smvn_total_supply?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_Smvn_Snapshot_Min_Fields = {
  __typename?: 'governance_smvn_snapshot_min_fields';
  cycle?: Maybe<Scalars['bigint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  smvn_total_supply?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "governance_smvn_snapshot" */
export type Governance_Smvn_Snapshot_Min_Order_By = {
  cycle?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  smvn_total_supply?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_smvn_snapshot". */
export type Governance_Smvn_Snapshot_Order_By = {
  cycle?: InputMaybe<Order_By>;
  governance?: InputMaybe<Governance_Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  smvn_total_supply?: InputMaybe<Order_By>;
};

/** select columns of table "governance_smvn_snapshot" */
export enum Governance_Smvn_Snapshot_Select_Column {
  /** column name */
  Cycle = 'cycle',
  /** column name */
  GovernanceId = 'governance_id',
  /** column name */
  Id = 'id',
  /** column name */
  SmvnTotalSupply = 'smvn_total_supply'
}

/** select "governance_smvn_snapshot_aggregate_bool_exp_avg_arguments_columns" columns of table "governance_smvn_snapshot" */
export enum Governance_Smvn_Snapshot_Select_Column_Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  SmvnTotalSupply = 'smvn_total_supply'
}

/** select "governance_smvn_snapshot_aggregate_bool_exp_corr_arguments_columns" columns of table "governance_smvn_snapshot" */
export enum Governance_Smvn_Snapshot_Select_Column_Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  SmvnTotalSupply = 'smvn_total_supply'
}

/** select "governance_smvn_snapshot_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "governance_smvn_snapshot" */
export enum Governance_Smvn_Snapshot_Select_Column_Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  SmvnTotalSupply = 'smvn_total_supply'
}

/** select "governance_smvn_snapshot_aggregate_bool_exp_max_arguments_columns" columns of table "governance_smvn_snapshot" */
export enum Governance_Smvn_Snapshot_Select_Column_Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  SmvnTotalSupply = 'smvn_total_supply'
}

/** select "governance_smvn_snapshot_aggregate_bool_exp_min_arguments_columns" columns of table "governance_smvn_snapshot" */
export enum Governance_Smvn_Snapshot_Select_Column_Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  SmvnTotalSupply = 'smvn_total_supply'
}

/** select "governance_smvn_snapshot_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "governance_smvn_snapshot" */
export enum Governance_Smvn_Snapshot_Select_Column_Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  SmvnTotalSupply = 'smvn_total_supply'
}

/** select "governance_smvn_snapshot_aggregate_bool_exp_sum_arguments_columns" columns of table "governance_smvn_snapshot" */
export enum Governance_Smvn_Snapshot_Select_Column_Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  SmvnTotalSupply = 'smvn_total_supply'
}

/** select "governance_smvn_snapshot_aggregate_bool_exp_var_samp_arguments_columns" columns of table "governance_smvn_snapshot" */
export enum Governance_Smvn_Snapshot_Select_Column_Governance_Smvn_Snapshot_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  SmvnTotalSupply = 'smvn_total_supply'
}

/** aggregate stddev on columns */
export type Governance_Smvn_Snapshot_Stddev_Fields = {
  __typename?: 'governance_smvn_snapshot_stddev_fields';
  cycle?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  smvn_total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_smvn_snapshot" */
export type Governance_Smvn_Snapshot_Stddev_Order_By = {
  cycle?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  smvn_total_supply?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_Smvn_Snapshot_Stddev_Pop_Fields = {
  __typename?: 'governance_smvn_snapshot_stddev_pop_fields';
  cycle?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  smvn_total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_smvn_snapshot" */
export type Governance_Smvn_Snapshot_Stddev_Pop_Order_By = {
  cycle?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  smvn_total_supply?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_Smvn_Snapshot_Stddev_Samp_Fields = {
  __typename?: 'governance_smvn_snapshot_stddev_samp_fields';
  cycle?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  smvn_total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_smvn_snapshot" */
export type Governance_Smvn_Snapshot_Stddev_Samp_Order_By = {
  cycle?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  smvn_total_supply?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_smvn_snapshot" */
export type Governance_Smvn_Snapshot_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Smvn_Snapshot_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Smvn_Snapshot_Stream_Cursor_Value_Input = {
  cycle?: InputMaybe<Scalars['bigint']['input']>;
  governance_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  smvn_total_supply?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type Governance_Smvn_Snapshot_Sum_Fields = {
  __typename?: 'governance_smvn_snapshot_sum_fields';
  cycle?: Maybe<Scalars['bigint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  smvn_total_supply?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "governance_smvn_snapshot" */
export type Governance_Smvn_Snapshot_Sum_Order_By = {
  cycle?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  smvn_total_supply?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_Smvn_Snapshot_Var_Pop_Fields = {
  __typename?: 'governance_smvn_snapshot_var_pop_fields';
  cycle?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  smvn_total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_smvn_snapshot" */
export type Governance_Smvn_Snapshot_Var_Pop_Order_By = {
  cycle?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  smvn_total_supply?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_Smvn_Snapshot_Var_Samp_Fields = {
  __typename?: 'governance_smvn_snapshot_var_samp_fields';
  cycle?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  smvn_total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_smvn_snapshot" */
export type Governance_Smvn_Snapshot_Var_Samp_Order_By = {
  cycle?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  smvn_total_supply?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_Smvn_Snapshot_Variance_Fields = {
  __typename?: 'governance_smvn_snapshot_variance_fields';
  cycle?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  smvn_total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_smvn_snapshot" */
export type Governance_Smvn_Snapshot_Variance_Order_By = {
  cycle?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  smvn_total_supply?: InputMaybe<Order_By>;
};

/** aggregate stddev on columns */
export type Governance_Stddev_Fields = {
  __typename?: 'governance_stddev_fields';
  blocks_per_proposal_round?: Maybe<Scalars['Float']['output']>;
  blocks_per_timelock_round?: Maybe<Scalars['Float']['output']>;
  blocks_per_voting_round?: Maybe<Scalars['Float']['output']>;
  current_blocks_per_proposal_round?: Maybe<Scalars['Float']['output']>;
  current_blocks_per_timelock_round?: Maybe<Scalars['Float']['output']>;
  current_blocks_per_voting_round?: Maybe<Scalars['Float']['output']>;
  current_cycle_end_level?: Maybe<Scalars['Float']['output']>;
  current_cycle_total_voters_reward?: Maybe<Scalars['Float']['output']>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  current_round?: Maybe<Scalars['Float']['output']>;
  current_round_end_level?: Maybe<Scalars['Float']['output']>;
  current_round_start_level?: Maybe<Scalars['Float']['output']>;
  cycle_highest_voted_proposal_id?: Maybe<Scalars['Float']['output']>;
  cycle_id?: Maybe<Scalars['Float']['output']>;
  cycle_voters_reward?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_proposal_per_satellite?: Maybe<Scalars['Float']['output']>;
  min_quorum_percentage?: Maybe<Scalars['Float']['output']>;
  min_yay_vote_percentage?: Maybe<Scalars['Float']['output']>;
  next_proposal_id?: Maybe<Scalars['Float']['output']>;
  proposal_description_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_invoice_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_metadata_title_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_round_vote_percentage?: Maybe<Scalars['Float']['output']>;
  proposal_source_code_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_submission_fee_mumav?: Maybe<Scalars['Float']['output']>;
  proposal_title_max_length?: Maybe<Scalars['Float']['output']>;
  success_reward?: Maybe<Scalars['Float']['output']>;
  timelock_proposal_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Governance_Stddev_Pop_Fields = {
  __typename?: 'governance_stddev_pop_fields';
  blocks_per_proposal_round?: Maybe<Scalars['Float']['output']>;
  blocks_per_timelock_round?: Maybe<Scalars['Float']['output']>;
  blocks_per_voting_round?: Maybe<Scalars['Float']['output']>;
  current_blocks_per_proposal_round?: Maybe<Scalars['Float']['output']>;
  current_blocks_per_timelock_round?: Maybe<Scalars['Float']['output']>;
  current_blocks_per_voting_round?: Maybe<Scalars['Float']['output']>;
  current_cycle_end_level?: Maybe<Scalars['Float']['output']>;
  current_cycle_total_voters_reward?: Maybe<Scalars['Float']['output']>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  current_round?: Maybe<Scalars['Float']['output']>;
  current_round_end_level?: Maybe<Scalars['Float']['output']>;
  current_round_start_level?: Maybe<Scalars['Float']['output']>;
  cycle_highest_voted_proposal_id?: Maybe<Scalars['Float']['output']>;
  cycle_id?: Maybe<Scalars['Float']['output']>;
  cycle_voters_reward?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_proposal_per_satellite?: Maybe<Scalars['Float']['output']>;
  min_quorum_percentage?: Maybe<Scalars['Float']['output']>;
  min_yay_vote_percentage?: Maybe<Scalars['Float']['output']>;
  next_proposal_id?: Maybe<Scalars['Float']['output']>;
  proposal_description_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_invoice_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_metadata_title_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_round_vote_percentage?: Maybe<Scalars['Float']['output']>;
  proposal_source_code_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_submission_fee_mumav?: Maybe<Scalars['Float']['output']>;
  proposal_title_max_length?: Maybe<Scalars['Float']['output']>;
  success_reward?: Maybe<Scalars['Float']['output']>;
  timelock_proposal_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Governance_Stddev_Samp_Fields = {
  __typename?: 'governance_stddev_samp_fields';
  blocks_per_proposal_round?: Maybe<Scalars['Float']['output']>;
  blocks_per_timelock_round?: Maybe<Scalars['Float']['output']>;
  blocks_per_voting_round?: Maybe<Scalars['Float']['output']>;
  current_blocks_per_proposal_round?: Maybe<Scalars['Float']['output']>;
  current_blocks_per_timelock_round?: Maybe<Scalars['Float']['output']>;
  current_blocks_per_voting_round?: Maybe<Scalars['Float']['output']>;
  current_cycle_end_level?: Maybe<Scalars['Float']['output']>;
  current_cycle_total_voters_reward?: Maybe<Scalars['Float']['output']>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  current_round?: Maybe<Scalars['Float']['output']>;
  current_round_end_level?: Maybe<Scalars['Float']['output']>;
  current_round_start_level?: Maybe<Scalars['Float']['output']>;
  cycle_highest_voted_proposal_id?: Maybe<Scalars['Float']['output']>;
  cycle_id?: Maybe<Scalars['Float']['output']>;
  cycle_voters_reward?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_proposal_per_satellite?: Maybe<Scalars['Float']['output']>;
  min_quorum_percentage?: Maybe<Scalars['Float']['output']>;
  min_yay_vote_percentage?: Maybe<Scalars['Float']['output']>;
  next_proposal_id?: Maybe<Scalars['Float']['output']>;
  proposal_description_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_invoice_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_metadata_title_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_round_vote_percentage?: Maybe<Scalars['Float']['output']>;
  proposal_source_code_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_submission_fee_mumav?: Maybe<Scalars['Float']['output']>;
  proposal_title_max_length?: Maybe<Scalars['Float']['output']>;
  success_reward?: Maybe<Scalars['Float']['output']>;
  timelock_proposal_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "governance" */
export type Governance_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['String']['input']>;
  blocks_per_proposal_round?: InputMaybe<Scalars['bigint']['input']>;
  blocks_per_timelock_round?: InputMaybe<Scalars['bigint']['input']>;
  blocks_per_voting_round?: InputMaybe<Scalars['bigint']['input']>;
  current_blocks_per_proposal_round?: InputMaybe<Scalars['bigint']['input']>;
  current_blocks_per_timelock_round?: InputMaybe<Scalars['bigint']['input']>;
  current_blocks_per_voting_round?: InputMaybe<Scalars['bigint']['input']>;
  current_cycle_end_level?: InputMaybe<Scalars['bigint']['input']>;
  current_cycle_total_voters_reward?: InputMaybe<Scalars['float8']['input']>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  current_round?: InputMaybe<Scalars['smallint']['input']>;
  current_round_end_level?: InputMaybe<Scalars['bigint']['input']>;
  current_round_start_level?: InputMaybe<Scalars['bigint']['input']>;
  cycle_highest_voted_proposal_id?: InputMaybe<Scalars['bigint']['input']>;
  cycle_id?: InputMaybe<Scalars['bigint']['input']>;
  cycle_voters_reward?: InputMaybe<Scalars['float8']['input']>;
  governance_proxy_address?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  max_proposal_per_satellite?: InputMaybe<Scalars['smallint']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  min_quorum_percentage?: InputMaybe<Scalars['smallint']['input']>;
  min_yay_vote_percentage?: InputMaybe<Scalars['smallint']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  next_proposal_id?: InputMaybe<Scalars['bigint']['input']>;
  proposal_description_max_length?: InputMaybe<Scalars['bigint']['input']>;
  proposal_invoice_max_length?: InputMaybe<Scalars['bigint']['input']>;
  proposal_metadata_title_max_length?: InputMaybe<Scalars['bigint']['input']>;
  proposal_round_vote_percentage?: InputMaybe<Scalars['smallint']['input']>;
  proposal_source_code_max_length?: InputMaybe<Scalars['bigint']['input']>;
  proposal_submission_fee_mumav?: InputMaybe<Scalars['bigint']['input']>;
  proposal_title_max_length?: InputMaybe<Scalars['bigint']['input']>;
  success_reward?: InputMaybe<Scalars['float8']['input']>;
  timelock_proposal_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Governance_Sum_Fields = {
  __typename?: 'governance_sum_fields';
  blocks_per_proposal_round?: Maybe<Scalars['bigint']['output']>;
  blocks_per_timelock_round?: Maybe<Scalars['bigint']['output']>;
  blocks_per_voting_round?: Maybe<Scalars['bigint']['output']>;
  current_blocks_per_proposal_round?: Maybe<Scalars['bigint']['output']>;
  current_blocks_per_timelock_round?: Maybe<Scalars['bigint']['output']>;
  current_blocks_per_voting_round?: Maybe<Scalars['bigint']['output']>;
  current_cycle_end_level?: Maybe<Scalars['bigint']['output']>;
  current_cycle_total_voters_reward?: Maybe<Scalars['float8']['output']>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  current_round?: Maybe<Scalars['smallint']['output']>;
  current_round_end_level?: Maybe<Scalars['bigint']['output']>;
  current_round_start_level?: Maybe<Scalars['bigint']['output']>;
  cycle_highest_voted_proposal_id?: Maybe<Scalars['bigint']['output']>;
  cycle_id?: Maybe<Scalars['bigint']['output']>;
  cycle_voters_reward?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  max_proposal_per_satellite?: Maybe<Scalars['smallint']['output']>;
  min_quorum_percentage?: Maybe<Scalars['smallint']['output']>;
  min_yay_vote_percentage?: Maybe<Scalars['smallint']['output']>;
  next_proposal_id?: Maybe<Scalars['bigint']['output']>;
  proposal_description_max_length?: Maybe<Scalars['bigint']['output']>;
  proposal_invoice_max_length?: Maybe<Scalars['bigint']['output']>;
  proposal_metadata_title_max_length?: Maybe<Scalars['bigint']['output']>;
  proposal_round_vote_percentage?: Maybe<Scalars['smallint']['output']>;
  proposal_source_code_max_length?: Maybe<Scalars['bigint']['output']>;
  proposal_submission_fee_mumav?: Maybe<Scalars['bigint']['output']>;
  proposal_title_max_length?: Maybe<Scalars['bigint']['output']>;
  success_reward?: Maybe<Scalars['float8']['output']>;
  timelock_proposal_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Governance_Var_Pop_Fields = {
  __typename?: 'governance_var_pop_fields';
  blocks_per_proposal_round?: Maybe<Scalars['Float']['output']>;
  blocks_per_timelock_round?: Maybe<Scalars['Float']['output']>;
  blocks_per_voting_round?: Maybe<Scalars['Float']['output']>;
  current_blocks_per_proposal_round?: Maybe<Scalars['Float']['output']>;
  current_blocks_per_timelock_round?: Maybe<Scalars['Float']['output']>;
  current_blocks_per_voting_round?: Maybe<Scalars['Float']['output']>;
  current_cycle_end_level?: Maybe<Scalars['Float']['output']>;
  current_cycle_total_voters_reward?: Maybe<Scalars['Float']['output']>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  current_round?: Maybe<Scalars['Float']['output']>;
  current_round_end_level?: Maybe<Scalars['Float']['output']>;
  current_round_start_level?: Maybe<Scalars['Float']['output']>;
  cycle_highest_voted_proposal_id?: Maybe<Scalars['Float']['output']>;
  cycle_id?: Maybe<Scalars['Float']['output']>;
  cycle_voters_reward?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_proposal_per_satellite?: Maybe<Scalars['Float']['output']>;
  min_quorum_percentage?: Maybe<Scalars['Float']['output']>;
  min_yay_vote_percentage?: Maybe<Scalars['Float']['output']>;
  next_proposal_id?: Maybe<Scalars['Float']['output']>;
  proposal_description_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_invoice_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_metadata_title_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_round_vote_percentage?: Maybe<Scalars['Float']['output']>;
  proposal_source_code_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_submission_fee_mumav?: Maybe<Scalars['Float']['output']>;
  proposal_title_max_length?: Maybe<Scalars['Float']['output']>;
  success_reward?: Maybe<Scalars['Float']['output']>;
  timelock_proposal_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Governance_Var_Samp_Fields = {
  __typename?: 'governance_var_samp_fields';
  blocks_per_proposal_round?: Maybe<Scalars['Float']['output']>;
  blocks_per_timelock_round?: Maybe<Scalars['Float']['output']>;
  blocks_per_voting_round?: Maybe<Scalars['Float']['output']>;
  current_blocks_per_proposal_round?: Maybe<Scalars['Float']['output']>;
  current_blocks_per_timelock_round?: Maybe<Scalars['Float']['output']>;
  current_blocks_per_voting_round?: Maybe<Scalars['Float']['output']>;
  current_cycle_end_level?: Maybe<Scalars['Float']['output']>;
  current_cycle_total_voters_reward?: Maybe<Scalars['Float']['output']>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  current_round?: Maybe<Scalars['Float']['output']>;
  current_round_end_level?: Maybe<Scalars['Float']['output']>;
  current_round_start_level?: Maybe<Scalars['Float']['output']>;
  cycle_highest_voted_proposal_id?: Maybe<Scalars['Float']['output']>;
  cycle_id?: Maybe<Scalars['Float']['output']>;
  cycle_voters_reward?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_proposal_per_satellite?: Maybe<Scalars['Float']['output']>;
  min_quorum_percentage?: Maybe<Scalars['Float']['output']>;
  min_yay_vote_percentage?: Maybe<Scalars['Float']['output']>;
  next_proposal_id?: Maybe<Scalars['Float']['output']>;
  proposal_description_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_invoice_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_metadata_title_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_round_vote_percentage?: Maybe<Scalars['Float']['output']>;
  proposal_source_code_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_submission_fee_mumav?: Maybe<Scalars['Float']['output']>;
  proposal_title_max_length?: Maybe<Scalars['Float']['output']>;
  success_reward?: Maybe<Scalars['Float']['output']>;
  timelock_proposal_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Governance_Variance_Fields = {
  __typename?: 'governance_variance_fields';
  blocks_per_proposal_round?: Maybe<Scalars['Float']['output']>;
  blocks_per_timelock_round?: Maybe<Scalars['Float']['output']>;
  blocks_per_voting_round?: Maybe<Scalars['Float']['output']>;
  current_blocks_per_proposal_round?: Maybe<Scalars['Float']['output']>;
  current_blocks_per_timelock_round?: Maybe<Scalars['Float']['output']>;
  current_blocks_per_voting_round?: Maybe<Scalars['Float']['output']>;
  current_cycle_end_level?: Maybe<Scalars['Float']['output']>;
  current_cycle_total_voters_reward?: Maybe<Scalars['Float']['output']>;
  /** PROPOSAL: 0\nVOTING: 1\nTIMELOCK: 2 */
  current_round?: Maybe<Scalars['Float']['output']>;
  current_round_end_level?: Maybe<Scalars['Float']['output']>;
  current_round_start_level?: Maybe<Scalars['Float']['output']>;
  cycle_highest_voted_proposal_id?: Maybe<Scalars['Float']['output']>;
  cycle_id?: Maybe<Scalars['Float']['output']>;
  cycle_voters_reward?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  max_proposal_per_satellite?: Maybe<Scalars['Float']['output']>;
  min_quorum_percentage?: Maybe<Scalars['Float']['output']>;
  min_yay_vote_percentage?: Maybe<Scalars['Float']['output']>;
  next_proposal_id?: Maybe<Scalars['Float']['output']>;
  proposal_description_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_invoice_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_metadata_title_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_round_vote_percentage?: Maybe<Scalars['Float']['output']>;
  proposal_source_code_max_length?: Maybe<Scalars['Float']['output']>;
  proposal_submission_fee_mumav?: Maybe<Scalars['Float']['output']>;
  proposal_title_max_length?: Maybe<Scalars['Float']['output']>;
  success_reward?: Maybe<Scalars['Float']['output']>;
  timelock_proposal_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "governance_whitelist_contract" */
export type Governance_Whitelist_Contract = {
  __typename?: 'governance_whitelist_contract';
  /** An object relationship */
  contract: Governance;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "governance_whitelist_contract" */
export type Governance_Whitelist_Contract_Aggregate = {
  __typename?: 'governance_whitelist_contract_aggregate';
  aggregate?: Maybe<Governance_Whitelist_Contract_Aggregate_Fields>;
  nodes: Array<Governance_Whitelist_Contract>;
};

export type Governance_Whitelist_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Governance_Whitelist_Contract_Aggregate_Bool_Exp_Count>;
};

export type Governance_Whitelist_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Governance_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Governance_Whitelist_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "governance_whitelist_contract" */
export type Governance_Whitelist_Contract_Aggregate_Fields = {
  __typename?: 'governance_whitelist_contract_aggregate_fields';
  avg?: Maybe<Governance_Whitelist_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Governance_Whitelist_Contract_Max_Fields>;
  min?: Maybe<Governance_Whitelist_Contract_Min_Fields>;
  stddev?: Maybe<Governance_Whitelist_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Governance_Whitelist_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Governance_Whitelist_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Governance_Whitelist_Contract_Sum_Fields>;
  var_pop?: Maybe<Governance_Whitelist_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Governance_Whitelist_Contract_Var_Samp_Fields>;
  variance?: Maybe<Governance_Whitelist_Contract_Variance_Fields>;
};


/** aggregate fields of "governance_whitelist_contract" */
export type Governance_Whitelist_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Governance_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "governance_whitelist_contract" */
export type Governance_Whitelist_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Governance_Whitelist_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Governance_Whitelist_Contract_Max_Order_By>;
  min?: InputMaybe<Governance_Whitelist_Contract_Min_Order_By>;
  stddev?: InputMaybe<Governance_Whitelist_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Governance_Whitelist_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Governance_Whitelist_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Governance_Whitelist_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Governance_Whitelist_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Governance_Whitelist_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Governance_Whitelist_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Governance_Whitelist_Contract_Avg_Fields = {
  __typename?: 'governance_whitelist_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "governance_whitelist_contract" */
export type Governance_Whitelist_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "governance_whitelist_contract". All fields are combined with a logical 'AND'. */
export type Governance_Whitelist_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Governance_Whitelist_Contract_Bool_Exp>>;
  _not?: InputMaybe<Governance_Whitelist_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Governance_Whitelist_Contract_Bool_Exp>>;
  contract?: InputMaybe<Governance_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Governance_Whitelist_Contract_Max_Fields = {
  __typename?: 'governance_whitelist_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "governance_whitelist_contract" */
export type Governance_Whitelist_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Governance_Whitelist_Contract_Min_Fields = {
  __typename?: 'governance_whitelist_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "governance_whitelist_contract" */
export type Governance_Whitelist_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "governance_whitelist_contract". */
export type Governance_Whitelist_Contract_Order_By = {
  contract?: InputMaybe<Governance_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "governance_whitelist_contract" */
export enum Governance_Whitelist_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Governance_Whitelist_Contract_Stddev_Fields = {
  __typename?: 'governance_whitelist_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "governance_whitelist_contract" */
export type Governance_Whitelist_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Governance_Whitelist_Contract_Stddev_Pop_Fields = {
  __typename?: 'governance_whitelist_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "governance_whitelist_contract" */
export type Governance_Whitelist_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Governance_Whitelist_Contract_Stddev_Samp_Fields = {
  __typename?: 'governance_whitelist_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "governance_whitelist_contract" */
export type Governance_Whitelist_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "governance_whitelist_contract" */
export type Governance_Whitelist_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Governance_Whitelist_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Governance_Whitelist_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Governance_Whitelist_Contract_Sum_Fields = {
  __typename?: 'governance_whitelist_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "governance_whitelist_contract" */
export type Governance_Whitelist_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Governance_Whitelist_Contract_Var_Pop_Fields = {
  __typename?: 'governance_whitelist_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "governance_whitelist_contract" */
export type Governance_Whitelist_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Governance_Whitelist_Contract_Var_Samp_Fields = {
  __typename?: 'governance_whitelist_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "governance_whitelist_contract" */
export type Governance_Whitelist_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Governance_Whitelist_Contract_Variance_Fields = {
  __typename?: 'governance_whitelist_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "governance_whitelist_contract" */
export type Governance_Whitelist_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "gql_history_data_summary" */
export type Gql_History_Data_Summary = {
  __typename?: 'gql_history_data_summary';
  id?: Maybe<Scalars['bigint']['output']>;
  lending_controller_id?: Maybe<Scalars['bigint']['output']>;
  operation_date?: Maybe<Scalars['timestamptz']['output']>;
  operation_type?: Maybe<Scalars['smallint']['output']>;
  operations_count?: Maybe<Scalars['bigint']['output']>;
  token_address?: Maybe<Scalars['String']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  total_amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregated selection of "gql_history_data_summary" */
export type Gql_History_Data_Summary_Aggregate = {
  __typename?: 'gql_history_data_summary_aggregate';
  aggregate?: Maybe<Gql_History_Data_Summary_Aggregate_Fields>;
  nodes: Array<Gql_History_Data_Summary>;
};

/** aggregate fields of "gql_history_data_summary" */
export type Gql_History_Data_Summary_Aggregate_Fields = {
  __typename?: 'gql_history_data_summary_aggregate_fields';
  avg?: Maybe<Gql_History_Data_Summary_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Gql_History_Data_Summary_Max_Fields>;
  min?: Maybe<Gql_History_Data_Summary_Min_Fields>;
  stddev?: Maybe<Gql_History_Data_Summary_Stddev_Fields>;
  stddev_pop?: Maybe<Gql_History_Data_Summary_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Gql_History_Data_Summary_Stddev_Samp_Fields>;
  sum?: Maybe<Gql_History_Data_Summary_Sum_Fields>;
  var_pop?: Maybe<Gql_History_Data_Summary_Var_Pop_Fields>;
  var_samp?: Maybe<Gql_History_Data_Summary_Var_Samp_Fields>;
  variance?: Maybe<Gql_History_Data_Summary_Variance_Fields>;
};


/** aggregate fields of "gql_history_data_summary" */
export type Gql_History_Data_Summary_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gql_History_Data_Summary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Gql_History_Data_Summary_Avg_Fields = {
  __typename?: 'gql_history_data_summary_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  operation_type?: Maybe<Scalars['Float']['output']>;
  operations_count?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "gql_history_data_summary". All fields are combined with a logical 'AND'. */
export type Gql_History_Data_Summary_Bool_Exp = {
  _and?: InputMaybe<Array<Gql_History_Data_Summary_Bool_Exp>>;
  _not?: InputMaybe<Gql_History_Data_Summary_Bool_Exp>;
  _or?: InputMaybe<Array<Gql_History_Data_Summary_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lending_controller_id?: InputMaybe<Bigint_Comparison_Exp>;
  operation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  operation_type?: InputMaybe<Smallint_Comparison_Exp>;
  operations_count?: InputMaybe<Bigint_Comparison_Exp>;
  token_address?: InputMaybe<String_Comparison_Exp>;
  token_id?: InputMaybe<Bigint_Comparison_Exp>;
  total_amount?: InputMaybe<Float8_Comparison_Exp>;
};

/** aggregate max on columns */
export type Gql_History_Data_Summary_Max_Fields = {
  __typename?: 'gql_history_data_summary_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  lending_controller_id?: Maybe<Scalars['bigint']['output']>;
  operation_date?: Maybe<Scalars['timestamptz']['output']>;
  operation_type?: Maybe<Scalars['smallint']['output']>;
  operations_count?: Maybe<Scalars['bigint']['output']>;
  token_address?: Maybe<Scalars['String']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  total_amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate min on columns */
export type Gql_History_Data_Summary_Min_Fields = {
  __typename?: 'gql_history_data_summary_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  lending_controller_id?: Maybe<Scalars['bigint']['output']>;
  operation_date?: Maybe<Scalars['timestamptz']['output']>;
  operation_type?: Maybe<Scalars['smallint']['output']>;
  operations_count?: Maybe<Scalars['bigint']['output']>;
  token_address?: Maybe<Scalars['String']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  total_amount?: Maybe<Scalars['float8']['output']>;
};

/** Ordering options when selecting data from "gql_history_data_summary". */
export type Gql_History_Data_Summary_Order_By = {
  id?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  operation_date?: InputMaybe<Order_By>;
  operation_type?: InputMaybe<Order_By>;
  operations_count?: InputMaybe<Order_By>;
  token_address?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** select columns of table "gql_history_data_summary" */
export enum Gql_History_Data_Summary_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  LendingControllerId = 'lending_controller_id',
  /** column name */
  OperationDate = 'operation_date',
  /** column name */
  OperationType = 'operation_type',
  /** column name */
  OperationsCount = 'operations_count',
  /** column name */
  TokenAddress = 'token_address',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  TotalAmount = 'total_amount'
}

/** aggregate stddev on columns */
export type Gql_History_Data_Summary_Stddev_Fields = {
  __typename?: 'gql_history_data_summary_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  operation_type?: Maybe<Scalars['Float']['output']>;
  operations_count?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Gql_History_Data_Summary_Stddev_Pop_Fields = {
  __typename?: 'gql_history_data_summary_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  operation_type?: Maybe<Scalars['Float']['output']>;
  operations_count?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Gql_History_Data_Summary_Stddev_Samp_Fields = {
  __typename?: 'gql_history_data_summary_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  operation_type?: Maybe<Scalars['Float']['output']>;
  operations_count?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "gql_history_data_summary" */
export type Gql_History_Data_Summary_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gql_History_Data_Summary_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gql_History_Data_Summary_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  lending_controller_id?: InputMaybe<Scalars['bigint']['input']>;
  operation_date?: InputMaybe<Scalars['timestamptz']['input']>;
  operation_type?: InputMaybe<Scalars['smallint']['input']>;
  operations_count?: InputMaybe<Scalars['bigint']['input']>;
  token_address?: InputMaybe<Scalars['String']['input']>;
  token_id?: InputMaybe<Scalars['bigint']['input']>;
  total_amount?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type Gql_History_Data_Summary_Sum_Fields = {
  __typename?: 'gql_history_data_summary_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  lending_controller_id?: Maybe<Scalars['bigint']['output']>;
  operation_type?: Maybe<Scalars['smallint']['output']>;
  operations_count?: Maybe<Scalars['bigint']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  total_amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Gql_History_Data_Summary_Var_Pop_Fields = {
  __typename?: 'gql_history_data_summary_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  operation_type?: Maybe<Scalars['Float']['output']>;
  operations_count?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Gql_History_Data_Summary_Var_Samp_Fields = {
  __typename?: 'gql_history_data_summary_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  operation_type?: Maybe<Scalars['Float']['output']>;
  operations_count?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Gql_History_Data_Summary_Variance_Fields = {
  __typename?: 'gql_history_data_summary_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  operation_type?: Maybe<Scalars['Float']['output']>;
  operations_count?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "gql_loan_token_market_stats" */
export type Gql_Loan_Token_Market_Stats = {
  __typename?: 'gql_loan_token_market_stats';
  borrowers_count?: Maybe<Scalars['bigint']['output']>;
  current_interest_rate?: Maybe<Scalars['float8']['output']>;
  depositors_count?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated?: Maybe<Scalars['timestamptz']['output']>;
  lending_controller_id?: Maybe<Scalars['bigint']['output']>;
  loan_token_name?: Maybe<Scalars['String']['output']>;
  m_token_address?: Maybe<Scalars['String']['output']>;
  m_token_id?: Maybe<Scalars['bigint']['output']>;
  paused?: Maybe<Scalars['Boolean']['output']>;
  reserve_ratio?: Maybe<Scalars['smallint']['output']>;
  rewards_earned_total?: Maybe<Scalars['float8']['output']>;
  token_address?: Maybe<Scalars['String']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  token_pool_total?: Maybe<Scalars['float8']['output']>;
  total_borrowed?: Maybe<Scalars['float8']['output']>;
  total_remaining?: Maybe<Scalars['float8']['output']>;
  utilisation_rate?: Maybe<Scalars['float8']['output']>;
};

/** aggregated selection of "gql_loan_token_market_stats" */
export type Gql_Loan_Token_Market_Stats_Aggregate = {
  __typename?: 'gql_loan_token_market_stats_aggregate';
  aggregate?: Maybe<Gql_Loan_Token_Market_Stats_Aggregate_Fields>;
  nodes: Array<Gql_Loan_Token_Market_Stats>;
};

/** aggregate fields of "gql_loan_token_market_stats" */
export type Gql_Loan_Token_Market_Stats_Aggregate_Fields = {
  __typename?: 'gql_loan_token_market_stats_aggregate_fields';
  avg?: Maybe<Gql_Loan_Token_Market_Stats_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Gql_Loan_Token_Market_Stats_Max_Fields>;
  min?: Maybe<Gql_Loan_Token_Market_Stats_Min_Fields>;
  stddev?: Maybe<Gql_Loan_Token_Market_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<Gql_Loan_Token_Market_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Gql_Loan_Token_Market_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<Gql_Loan_Token_Market_Stats_Sum_Fields>;
  var_pop?: Maybe<Gql_Loan_Token_Market_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<Gql_Loan_Token_Market_Stats_Var_Samp_Fields>;
  variance?: Maybe<Gql_Loan_Token_Market_Stats_Variance_Fields>;
};


/** aggregate fields of "gql_loan_token_market_stats" */
export type Gql_Loan_Token_Market_Stats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gql_Loan_Token_Market_Stats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Gql_Loan_Token_Market_Stats_Avg_Fields = {
  __typename?: 'gql_loan_token_market_stats_avg_fields';
  borrowers_count?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  depositors_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  reserve_ratio?: Maybe<Scalars['Float']['output']>;
  rewards_earned_total?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  utilisation_rate?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "gql_loan_token_market_stats". All fields are combined with a logical 'AND'. */
export type Gql_Loan_Token_Market_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Gql_Loan_Token_Market_Stats_Bool_Exp>>;
  _not?: InputMaybe<Gql_Loan_Token_Market_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Gql_Loan_Token_Market_Stats_Bool_Exp>>;
  borrowers_count?: InputMaybe<Bigint_Comparison_Exp>;
  current_interest_rate?: InputMaybe<Float8_Comparison_Exp>;
  depositors_count?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  last_updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  lending_controller_id?: InputMaybe<Bigint_Comparison_Exp>;
  loan_token_name?: InputMaybe<String_Comparison_Exp>;
  m_token_address?: InputMaybe<String_Comparison_Exp>;
  m_token_id?: InputMaybe<Bigint_Comparison_Exp>;
  paused?: InputMaybe<Boolean_Comparison_Exp>;
  reserve_ratio?: InputMaybe<Smallint_Comparison_Exp>;
  rewards_earned_total?: InputMaybe<Float8_Comparison_Exp>;
  token_address?: InputMaybe<String_Comparison_Exp>;
  token_id?: InputMaybe<Bigint_Comparison_Exp>;
  token_pool_total?: InputMaybe<Float8_Comparison_Exp>;
  total_borrowed?: InputMaybe<Float8_Comparison_Exp>;
  total_remaining?: InputMaybe<Float8_Comparison_Exp>;
  utilisation_rate?: InputMaybe<Float8_Comparison_Exp>;
};

/** aggregate max on columns */
export type Gql_Loan_Token_Market_Stats_Max_Fields = {
  __typename?: 'gql_loan_token_market_stats_max_fields';
  borrowers_count?: Maybe<Scalars['bigint']['output']>;
  current_interest_rate?: Maybe<Scalars['float8']['output']>;
  depositors_count?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated?: Maybe<Scalars['timestamptz']['output']>;
  lending_controller_id?: Maybe<Scalars['bigint']['output']>;
  loan_token_name?: Maybe<Scalars['String']['output']>;
  m_token_address?: Maybe<Scalars['String']['output']>;
  m_token_id?: Maybe<Scalars['bigint']['output']>;
  reserve_ratio?: Maybe<Scalars['smallint']['output']>;
  rewards_earned_total?: Maybe<Scalars['float8']['output']>;
  token_address?: Maybe<Scalars['String']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  token_pool_total?: Maybe<Scalars['float8']['output']>;
  total_borrowed?: Maybe<Scalars['float8']['output']>;
  total_remaining?: Maybe<Scalars['float8']['output']>;
  utilisation_rate?: Maybe<Scalars['float8']['output']>;
};

/** aggregate min on columns */
export type Gql_Loan_Token_Market_Stats_Min_Fields = {
  __typename?: 'gql_loan_token_market_stats_min_fields';
  borrowers_count?: Maybe<Scalars['bigint']['output']>;
  current_interest_rate?: Maybe<Scalars['float8']['output']>;
  depositors_count?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated?: Maybe<Scalars['timestamptz']['output']>;
  lending_controller_id?: Maybe<Scalars['bigint']['output']>;
  loan_token_name?: Maybe<Scalars['String']['output']>;
  m_token_address?: Maybe<Scalars['String']['output']>;
  m_token_id?: Maybe<Scalars['bigint']['output']>;
  reserve_ratio?: Maybe<Scalars['smallint']['output']>;
  rewards_earned_total?: Maybe<Scalars['float8']['output']>;
  token_address?: Maybe<Scalars['String']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  token_pool_total?: Maybe<Scalars['float8']['output']>;
  total_borrowed?: Maybe<Scalars['float8']['output']>;
  total_remaining?: Maybe<Scalars['float8']['output']>;
  utilisation_rate?: Maybe<Scalars['float8']['output']>;
};

/** Ordering options when selecting data from "gql_loan_token_market_stats". */
export type Gql_Loan_Token_Market_Stats_Order_By = {
  borrowers_count?: InputMaybe<Order_By>;
  current_interest_rate?: InputMaybe<Order_By>;
  depositors_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  loan_token_name?: InputMaybe<Order_By>;
  m_token_address?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  paused?: InputMaybe<Order_By>;
  reserve_ratio?: InputMaybe<Order_By>;
  rewards_earned_total?: InputMaybe<Order_By>;
  token_address?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_pool_total?: InputMaybe<Order_By>;
  total_borrowed?: InputMaybe<Order_By>;
  total_remaining?: InputMaybe<Order_By>;
  utilisation_rate?: InputMaybe<Order_By>;
};

/** select columns of table "gql_loan_token_market_stats" */
export enum Gql_Loan_Token_Market_Stats_Select_Column {
  /** column name */
  BorrowersCount = 'borrowers_count',
  /** column name */
  CurrentInterestRate = 'current_interest_rate',
  /** column name */
  DepositorsCount = 'depositors_count',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdated = 'last_updated',
  /** column name */
  LendingControllerId = 'lending_controller_id',
  /** column name */
  LoanTokenName = 'loan_token_name',
  /** column name */
  MTokenAddress = 'm_token_address',
  /** column name */
  MTokenId = 'm_token_id',
  /** column name */
  Paused = 'paused',
  /** column name */
  ReserveRatio = 'reserve_ratio',
  /** column name */
  RewardsEarnedTotal = 'rewards_earned_total',
  /** column name */
  TokenAddress = 'token_address',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  TokenPoolTotal = 'token_pool_total',
  /** column name */
  TotalBorrowed = 'total_borrowed',
  /** column name */
  TotalRemaining = 'total_remaining',
  /** column name */
  UtilisationRate = 'utilisation_rate'
}

/** aggregate stddev on columns */
export type Gql_Loan_Token_Market_Stats_Stddev_Fields = {
  __typename?: 'gql_loan_token_market_stats_stddev_fields';
  borrowers_count?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  depositors_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  reserve_ratio?: Maybe<Scalars['Float']['output']>;
  rewards_earned_total?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  utilisation_rate?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Gql_Loan_Token_Market_Stats_Stddev_Pop_Fields = {
  __typename?: 'gql_loan_token_market_stats_stddev_pop_fields';
  borrowers_count?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  depositors_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  reserve_ratio?: Maybe<Scalars['Float']['output']>;
  rewards_earned_total?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  utilisation_rate?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Gql_Loan_Token_Market_Stats_Stddev_Samp_Fields = {
  __typename?: 'gql_loan_token_market_stats_stddev_samp_fields';
  borrowers_count?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  depositors_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  reserve_ratio?: Maybe<Scalars['Float']['output']>;
  rewards_earned_total?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  utilisation_rate?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "gql_loan_token_market_stats" */
export type Gql_Loan_Token_Market_Stats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gql_Loan_Token_Market_Stats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gql_Loan_Token_Market_Stats_Stream_Cursor_Value_Input = {
  borrowers_count?: InputMaybe<Scalars['bigint']['input']>;
  current_interest_rate?: InputMaybe<Scalars['float8']['input']>;
  depositors_count?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_updated?: InputMaybe<Scalars['timestamptz']['input']>;
  lending_controller_id?: InputMaybe<Scalars['bigint']['input']>;
  loan_token_name?: InputMaybe<Scalars['String']['input']>;
  m_token_address?: InputMaybe<Scalars['String']['input']>;
  m_token_id?: InputMaybe<Scalars['bigint']['input']>;
  paused?: InputMaybe<Scalars['Boolean']['input']>;
  reserve_ratio?: InputMaybe<Scalars['smallint']['input']>;
  rewards_earned_total?: InputMaybe<Scalars['float8']['input']>;
  token_address?: InputMaybe<Scalars['String']['input']>;
  token_id?: InputMaybe<Scalars['bigint']['input']>;
  token_pool_total?: InputMaybe<Scalars['float8']['input']>;
  total_borrowed?: InputMaybe<Scalars['float8']['input']>;
  total_remaining?: InputMaybe<Scalars['float8']['input']>;
  utilisation_rate?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type Gql_Loan_Token_Market_Stats_Sum_Fields = {
  __typename?: 'gql_loan_token_market_stats_sum_fields';
  borrowers_count?: Maybe<Scalars['bigint']['output']>;
  current_interest_rate?: Maybe<Scalars['float8']['output']>;
  depositors_count?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lending_controller_id?: Maybe<Scalars['bigint']['output']>;
  m_token_id?: Maybe<Scalars['bigint']['output']>;
  reserve_ratio?: Maybe<Scalars['smallint']['output']>;
  rewards_earned_total?: Maybe<Scalars['float8']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  token_pool_total?: Maybe<Scalars['float8']['output']>;
  total_borrowed?: Maybe<Scalars['float8']['output']>;
  total_remaining?: Maybe<Scalars['float8']['output']>;
  utilisation_rate?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Gql_Loan_Token_Market_Stats_Var_Pop_Fields = {
  __typename?: 'gql_loan_token_market_stats_var_pop_fields';
  borrowers_count?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  depositors_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  reserve_ratio?: Maybe<Scalars['Float']['output']>;
  rewards_earned_total?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  utilisation_rate?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Gql_Loan_Token_Market_Stats_Var_Samp_Fields = {
  __typename?: 'gql_loan_token_market_stats_var_samp_fields';
  borrowers_count?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  depositors_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  reserve_ratio?: Maybe<Scalars['Float']['output']>;
  rewards_earned_total?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  utilisation_rate?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Gql_Loan_Token_Market_Stats_Variance_Fields = {
  __typename?: 'gql_loan_token_market_stats_variance_fields';
  borrowers_count?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  depositors_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  reserve_ratio?: Maybe<Scalars['Float']['output']>;
  rewards_earned_total?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  utilisation_rate?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "gql_vault_with_balances" */
export type Gql_Vault_With_Balances = {
  __typename?: 'gql_vault_with_balances';
  allowance?: Maybe<Scalars['smallint']['output']>;
  baker_address?: Maybe<Scalars['String']['output']>;
  borrow_index?: Maybe<Scalars['float8']['output']>;
  collateral_json?: Maybe<Scalars['jsonb']['output']>;
  creation_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  current_interest_rate?: Maybe<Scalars['float8']['output']>;
  depositors_json?: Maybe<Scalars['jsonb']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['bigint']['output']>;
  is_open?: Maybe<Scalars['Boolean']['output']>;
  last_updated?: Maybe<Scalars['timestamptz']['output']>;
  last_updated_block_level?: Maybe<Scalars['bigint']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['bigint']['output']>;
  liquidation_end_level?: Maybe<Scalars['bigint']['output']>;
  loan_interest_total?: Maybe<Scalars['float8']['output']>;
  loan_outstanding_total?: Maybe<Scalars['float8']['output']>;
  loan_principal_total?: Maybe<Scalars['float8']['output']>;
  loan_token_address?: Maybe<Scalars['String']['output']>;
  loan_token_id?: Maybe<Scalars['bigint']['output']>;
  marked_for_liquidation_level?: Maybe<Scalars['bigint']['output']>;
  min_repayment_amount?: Maybe<Scalars['float8']['output']>;
  owner_address?: Maybe<Scalars['String']['output']>;
  owner_id?: Maybe<Scalars['bigint']['output']>;
  reserve_ratio?: Maybe<Scalars['smallint']['output']>;
  token_pool_total?: Maybe<Scalars['float8']['output']>;
  total_remaining?: Maybe<Scalars['float8']['output']>;
  vault_address?: Maybe<Scalars['String']['output']>;
  vault_id?: Maybe<Scalars['bigint']['output']>;
  vault_name?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "gql_vault_with_balances" */
export type Gql_Vault_With_BalancesCollateral_JsonArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "gql_vault_with_balances" */
export type Gql_Vault_With_BalancesDepositors_JsonArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "gql_vault_with_balances" */
export type Gql_Vault_With_Balances_Aggregate = {
  __typename?: 'gql_vault_with_balances_aggregate';
  aggregate?: Maybe<Gql_Vault_With_Balances_Aggregate_Fields>;
  nodes: Array<Gql_Vault_With_Balances>;
};

/** aggregate fields of "gql_vault_with_balances" */
export type Gql_Vault_With_Balances_Aggregate_Fields = {
  __typename?: 'gql_vault_with_balances_aggregate_fields';
  avg?: Maybe<Gql_Vault_With_Balances_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Gql_Vault_With_Balances_Max_Fields>;
  min?: Maybe<Gql_Vault_With_Balances_Min_Fields>;
  stddev?: Maybe<Gql_Vault_With_Balances_Stddev_Fields>;
  stddev_pop?: Maybe<Gql_Vault_With_Balances_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Gql_Vault_With_Balances_Stddev_Samp_Fields>;
  sum?: Maybe<Gql_Vault_With_Balances_Sum_Fields>;
  var_pop?: Maybe<Gql_Vault_With_Balances_Var_Pop_Fields>;
  var_samp?: Maybe<Gql_Vault_With_Balances_Var_Samp_Fields>;
  variance?: Maybe<Gql_Vault_With_Balances_Variance_Fields>;
};


/** aggregate fields of "gql_vault_with_balances" */
export type Gql_Vault_With_Balances_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gql_Vault_With_Balances_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Gql_Vault_With_Balances_Avg_Fields = {
  __typename?: 'gql_vault_with_balances_avg_fields';
  allowance?: Maybe<Scalars['Float']['output']>;
  borrow_index?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  last_updated_block_level?: Maybe<Scalars['Float']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['Float']['output']>;
  liquidation_end_level?: Maybe<Scalars['Float']['output']>;
  loan_interest_total?: Maybe<Scalars['Float']['output']>;
  loan_outstanding_total?: Maybe<Scalars['Float']['output']>;
  loan_principal_total?: Maybe<Scalars['Float']['output']>;
  loan_token_id?: Maybe<Scalars['Float']['output']>;
  marked_for_liquidation_level?: Maybe<Scalars['Float']['output']>;
  min_repayment_amount?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
  reserve_ratio?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "gql_vault_with_balances". All fields are combined with a logical 'AND'. */
export type Gql_Vault_With_Balances_Bool_Exp = {
  _and?: InputMaybe<Array<Gql_Vault_With_Balances_Bool_Exp>>;
  _not?: InputMaybe<Gql_Vault_With_Balances_Bool_Exp>;
  _or?: InputMaybe<Array<Gql_Vault_With_Balances_Bool_Exp>>;
  allowance?: InputMaybe<Smallint_Comparison_Exp>;
  baker_address?: InputMaybe<String_Comparison_Exp>;
  borrow_index?: InputMaybe<Float8_Comparison_Exp>;
  collateral_json?: InputMaybe<Jsonb_Comparison_Exp>;
  creation_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  current_interest_rate?: InputMaybe<Float8_Comparison_Exp>;
  depositors_json?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  internal_id?: InputMaybe<Bigint_Comparison_Exp>;
  is_open?: InputMaybe<Boolean_Comparison_Exp>;
  last_updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_updated_block_level?: InputMaybe<Bigint_Comparison_Exp>;
  lending_controller_vault_id?: InputMaybe<Bigint_Comparison_Exp>;
  liquidation_end_level?: InputMaybe<Bigint_Comparison_Exp>;
  loan_interest_total?: InputMaybe<Float8_Comparison_Exp>;
  loan_outstanding_total?: InputMaybe<Float8_Comparison_Exp>;
  loan_principal_total?: InputMaybe<Float8_Comparison_Exp>;
  loan_token_address?: InputMaybe<String_Comparison_Exp>;
  loan_token_id?: InputMaybe<Bigint_Comparison_Exp>;
  marked_for_liquidation_level?: InputMaybe<Bigint_Comparison_Exp>;
  min_repayment_amount?: InputMaybe<Float8_Comparison_Exp>;
  owner_address?: InputMaybe<String_Comparison_Exp>;
  owner_id?: InputMaybe<Bigint_Comparison_Exp>;
  reserve_ratio?: InputMaybe<Smallint_Comparison_Exp>;
  token_pool_total?: InputMaybe<Float8_Comparison_Exp>;
  total_remaining?: InputMaybe<Float8_Comparison_Exp>;
  vault_address?: InputMaybe<String_Comparison_Exp>;
  vault_id?: InputMaybe<Bigint_Comparison_Exp>;
  vault_name?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Gql_Vault_With_Balances_Max_Fields = {
  __typename?: 'gql_vault_with_balances_max_fields';
  allowance?: Maybe<Scalars['smallint']['output']>;
  baker_address?: Maybe<Scalars['String']['output']>;
  borrow_index?: Maybe<Scalars['float8']['output']>;
  creation_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  current_interest_rate?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['bigint']['output']>;
  last_updated?: Maybe<Scalars['timestamptz']['output']>;
  last_updated_block_level?: Maybe<Scalars['bigint']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['bigint']['output']>;
  liquidation_end_level?: Maybe<Scalars['bigint']['output']>;
  loan_interest_total?: Maybe<Scalars['float8']['output']>;
  loan_outstanding_total?: Maybe<Scalars['float8']['output']>;
  loan_principal_total?: Maybe<Scalars['float8']['output']>;
  loan_token_address?: Maybe<Scalars['String']['output']>;
  loan_token_id?: Maybe<Scalars['bigint']['output']>;
  marked_for_liquidation_level?: Maybe<Scalars['bigint']['output']>;
  min_repayment_amount?: Maybe<Scalars['float8']['output']>;
  owner_address?: Maybe<Scalars['String']['output']>;
  owner_id?: Maybe<Scalars['bigint']['output']>;
  reserve_ratio?: Maybe<Scalars['smallint']['output']>;
  token_pool_total?: Maybe<Scalars['float8']['output']>;
  total_remaining?: Maybe<Scalars['float8']['output']>;
  vault_address?: Maybe<Scalars['String']['output']>;
  vault_id?: Maybe<Scalars['bigint']['output']>;
  vault_name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Gql_Vault_With_Balances_Min_Fields = {
  __typename?: 'gql_vault_with_balances_min_fields';
  allowance?: Maybe<Scalars['smallint']['output']>;
  baker_address?: Maybe<Scalars['String']['output']>;
  borrow_index?: Maybe<Scalars['float8']['output']>;
  creation_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  current_interest_rate?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['bigint']['output']>;
  last_updated?: Maybe<Scalars['timestamptz']['output']>;
  last_updated_block_level?: Maybe<Scalars['bigint']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['bigint']['output']>;
  liquidation_end_level?: Maybe<Scalars['bigint']['output']>;
  loan_interest_total?: Maybe<Scalars['float8']['output']>;
  loan_outstanding_total?: Maybe<Scalars['float8']['output']>;
  loan_principal_total?: Maybe<Scalars['float8']['output']>;
  loan_token_address?: Maybe<Scalars['String']['output']>;
  loan_token_id?: Maybe<Scalars['bigint']['output']>;
  marked_for_liquidation_level?: Maybe<Scalars['bigint']['output']>;
  min_repayment_amount?: Maybe<Scalars['float8']['output']>;
  owner_address?: Maybe<Scalars['String']['output']>;
  owner_id?: Maybe<Scalars['bigint']['output']>;
  reserve_ratio?: Maybe<Scalars['smallint']['output']>;
  token_pool_total?: Maybe<Scalars['float8']['output']>;
  total_remaining?: Maybe<Scalars['float8']['output']>;
  vault_address?: Maybe<Scalars['String']['output']>;
  vault_id?: Maybe<Scalars['bigint']['output']>;
  vault_name?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "gql_vault_with_balances". */
export type Gql_Vault_With_Balances_Order_By = {
  allowance?: InputMaybe<Order_By>;
  baker_address?: InputMaybe<Order_By>;
  borrow_index?: InputMaybe<Order_By>;
  collateral_json?: InputMaybe<Order_By>;
  creation_timestamp?: InputMaybe<Order_By>;
  current_interest_rate?: InputMaybe<Order_By>;
  depositors_json?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  is_open?: InputMaybe<Order_By>;
  last_updated?: InputMaybe<Order_By>;
  last_updated_block_level?: InputMaybe<Order_By>;
  lending_controller_vault_id?: InputMaybe<Order_By>;
  liquidation_end_level?: InputMaybe<Order_By>;
  loan_interest_total?: InputMaybe<Order_By>;
  loan_outstanding_total?: InputMaybe<Order_By>;
  loan_principal_total?: InputMaybe<Order_By>;
  loan_token_address?: InputMaybe<Order_By>;
  loan_token_id?: InputMaybe<Order_By>;
  marked_for_liquidation_level?: InputMaybe<Order_By>;
  min_repayment_amount?: InputMaybe<Order_By>;
  owner_address?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  reserve_ratio?: InputMaybe<Order_By>;
  token_pool_total?: InputMaybe<Order_By>;
  total_remaining?: InputMaybe<Order_By>;
  vault_address?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
  vault_name?: InputMaybe<Order_By>;
};

/** select columns of table "gql_vault_with_balances" */
export enum Gql_Vault_With_Balances_Select_Column {
  /** column name */
  Allowance = 'allowance',
  /** column name */
  BakerAddress = 'baker_address',
  /** column name */
  BorrowIndex = 'borrow_index',
  /** column name */
  CollateralJson = 'collateral_json',
  /** column name */
  CreationTimestamp = 'creation_timestamp',
  /** column name */
  CurrentInterestRate = 'current_interest_rate',
  /** column name */
  DepositorsJson = 'depositors_json',
  /** column name */
  Id = 'id',
  /** column name */
  InternalId = 'internal_id',
  /** column name */
  IsOpen = 'is_open',
  /** column name */
  LastUpdated = 'last_updated',
  /** column name */
  LastUpdatedBlockLevel = 'last_updated_block_level',
  /** column name */
  LendingControllerVaultId = 'lending_controller_vault_id',
  /** column name */
  LiquidationEndLevel = 'liquidation_end_level',
  /** column name */
  LoanInterestTotal = 'loan_interest_total',
  /** column name */
  LoanOutstandingTotal = 'loan_outstanding_total',
  /** column name */
  LoanPrincipalTotal = 'loan_principal_total',
  /** column name */
  LoanTokenAddress = 'loan_token_address',
  /** column name */
  LoanTokenId = 'loan_token_id',
  /** column name */
  MarkedForLiquidationLevel = 'marked_for_liquidation_level',
  /** column name */
  MinRepaymentAmount = 'min_repayment_amount',
  /** column name */
  OwnerAddress = 'owner_address',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  ReserveRatio = 'reserve_ratio',
  /** column name */
  TokenPoolTotal = 'token_pool_total',
  /** column name */
  TotalRemaining = 'total_remaining',
  /** column name */
  VaultAddress = 'vault_address',
  /** column name */
  VaultId = 'vault_id',
  /** column name */
  VaultName = 'vault_name'
}

/** aggregate stddev on columns */
export type Gql_Vault_With_Balances_Stddev_Fields = {
  __typename?: 'gql_vault_with_balances_stddev_fields';
  allowance?: Maybe<Scalars['Float']['output']>;
  borrow_index?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  last_updated_block_level?: Maybe<Scalars['Float']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['Float']['output']>;
  liquidation_end_level?: Maybe<Scalars['Float']['output']>;
  loan_interest_total?: Maybe<Scalars['Float']['output']>;
  loan_outstanding_total?: Maybe<Scalars['Float']['output']>;
  loan_principal_total?: Maybe<Scalars['Float']['output']>;
  loan_token_id?: Maybe<Scalars['Float']['output']>;
  marked_for_liquidation_level?: Maybe<Scalars['Float']['output']>;
  min_repayment_amount?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
  reserve_ratio?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Gql_Vault_With_Balances_Stddev_Pop_Fields = {
  __typename?: 'gql_vault_with_balances_stddev_pop_fields';
  allowance?: Maybe<Scalars['Float']['output']>;
  borrow_index?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  last_updated_block_level?: Maybe<Scalars['Float']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['Float']['output']>;
  liquidation_end_level?: Maybe<Scalars['Float']['output']>;
  loan_interest_total?: Maybe<Scalars['Float']['output']>;
  loan_outstanding_total?: Maybe<Scalars['Float']['output']>;
  loan_principal_total?: Maybe<Scalars['Float']['output']>;
  loan_token_id?: Maybe<Scalars['Float']['output']>;
  marked_for_liquidation_level?: Maybe<Scalars['Float']['output']>;
  min_repayment_amount?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
  reserve_ratio?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Gql_Vault_With_Balances_Stddev_Samp_Fields = {
  __typename?: 'gql_vault_with_balances_stddev_samp_fields';
  allowance?: Maybe<Scalars['Float']['output']>;
  borrow_index?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  last_updated_block_level?: Maybe<Scalars['Float']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['Float']['output']>;
  liquidation_end_level?: Maybe<Scalars['Float']['output']>;
  loan_interest_total?: Maybe<Scalars['Float']['output']>;
  loan_outstanding_total?: Maybe<Scalars['Float']['output']>;
  loan_principal_total?: Maybe<Scalars['Float']['output']>;
  loan_token_id?: Maybe<Scalars['Float']['output']>;
  marked_for_liquidation_level?: Maybe<Scalars['Float']['output']>;
  min_repayment_amount?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
  reserve_ratio?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "gql_vault_with_balances" */
export type Gql_Vault_With_Balances_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gql_Vault_With_Balances_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gql_Vault_With_Balances_Stream_Cursor_Value_Input = {
  allowance?: InputMaybe<Scalars['smallint']['input']>;
  baker_address?: InputMaybe<Scalars['String']['input']>;
  borrow_index?: InputMaybe<Scalars['float8']['input']>;
  collateral_json?: InputMaybe<Scalars['jsonb']['input']>;
  creation_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  current_interest_rate?: InputMaybe<Scalars['float8']['input']>;
  depositors_json?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  internal_id?: InputMaybe<Scalars['bigint']['input']>;
  is_open?: InputMaybe<Scalars['Boolean']['input']>;
  last_updated?: InputMaybe<Scalars['timestamptz']['input']>;
  last_updated_block_level?: InputMaybe<Scalars['bigint']['input']>;
  lending_controller_vault_id?: InputMaybe<Scalars['bigint']['input']>;
  liquidation_end_level?: InputMaybe<Scalars['bigint']['input']>;
  loan_interest_total?: InputMaybe<Scalars['float8']['input']>;
  loan_outstanding_total?: InputMaybe<Scalars['float8']['input']>;
  loan_principal_total?: InputMaybe<Scalars['float8']['input']>;
  loan_token_address?: InputMaybe<Scalars['String']['input']>;
  loan_token_id?: InputMaybe<Scalars['bigint']['input']>;
  marked_for_liquidation_level?: InputMaybe<Scalars['bigint']['input']>;
  min_repayment_amount?: InputMaybe<Scalars['float8']['input']>;
  owner_address?: InputMaybe<Scalars['String']['input']>;
  owner_id?: InputMaybe<Scalars['bigint']['input']>;
  reserve_ratio?: InputMaybe<Scalars['smallint']['input']>;
  token_pool_total?: InputMaybe<Scalars['float8']['input']>;
  total_remaining?: InputMaybe<Scalars['float8']['input']>;
  vault_address?: InputMaybe<Scalars['String']['input']>;
  vault_id?: InputMaybe<Scalars['bigint']['input']>;
  vault_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Gql_Vault_With_Balances_Sum_Fields = {
  __typename?: 'gql_vault_with_balances_sum_fields';
  allowance?: Maybe<Scalars['smallint']['output']>;
  borrow_index?: Maybe<Scalars['float8']['output']>;
  current_interest_rate?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['bigint']['output']>;
  last_updated_block_level?: Maybe<Scalars['bigint']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['bigint']['output']>;
  liquidation_end_level?: Maybe<Scalars['bigint']['output']>;
  loan_interest_total?: Maybe<Scalars['float8']['output']>;
  loan_outstanding_total?: Maybe<Scalars['float8']['output']>;
  loan_principal_total?: Maybe<Scalars['float8']['output']>;
  loan_token_id?: Maybe<Scalars['bigint']['output']>;
  marked_for_liquidation_level?: Maybe<Scalars['bigint']['output']>;
  min_repayment_amount?: Maybe<Scalars['float8']['output']>;
  owner_id?: Maybe<Scalars['bigint']['output']>;
  reserve_ratio?: Maybe<Scalars['smallint']['output']>;
  token_pool_total?: Maybe<Scalars['float8']['output']>;
  total_remaining?: Maybe<Scalars['float8']['output']>;
  vault_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Gql_Vault_With_Balances_Var_Pop_Fields = {
  __typename?: 'gql_vault_with_balances_var_pop_fields';
  allowance?: Maybe<Scalars['Float']['output']>;
  borrow_index?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  last_updated_block_level?: Maybe<Scalars['Float']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['Float']['output']>;
  liquidation_end_level?: Maybe<Scalars['Float']['output']>;
  loan_interest_total?: Maybe<Scalars['Float']['output']>;
  loan_outstanding_total?: Maybe<Scalars['Float']['output']>;
  loan_principal_total?: Maybe<Scalars['Float']['output']>;
  loan_token_id?: Maybe<Scalars['Float']['output']>;
  marked_for_liquidation_level?: Maybe<Scalars['Float']['output']>;
  min_repayment_amount?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
  reserve_ratio?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Gql_Vault_With_Balances_Var_Samp_Fields = {
  __typename?: 'gql_vault_with_balances_var_samp_fields';
  allowance?: Maybe<Scalars['Float']['output']>;
  borrow_index?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  last_updated_block_level?: Maybe<Scalars['Float']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['Float']['output']>;
  liquidation_end_level?: Maybe<Scalars['Float']['output']>;
  loan_interest_total?: Maybe<Scalars['Float']['output']>;
  loan_outstanding_total?: Maybe<Scalars['Float']['output']>;
  loan_principal_total?: Maybe<Scalars['Float']['output']>;
  loan_token_id?: Maybe<Scalars['Float']['output']>;
  marked_for_liquidation_level?: Maybe<Scalars['Float']['output']>;
  min_repayment_amount?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
  reserve_ratio?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Gql_Vault_With_Balances_Variance_Fields = {
  __typename?: 'gql_vault_with_balances_variance_fields';
  allowance?: Maybe<Scalars['Float']['output']>;
  borrow_index?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  last_updated_block_level?: Maybe<Scalars['Float']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['Float']['output']>;
  liquidation_end_level?: Maybe<Scalars['Float']['output']>;
  loan_interest_total?: Maybe<Scalars['Float']['output']>;
  loan_outstanding_total?: Maybe<Scalars['Float']['output']>;
  loan_principal_total?: Maybe<Scalars['Float']['output']>;
  loan_token_id?: Maybe<Scalars['Float']['output']>;
  marked_for_liquidation_level?: Maybe<Scalars['Float']['output']>;
  min_repayment_amount?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
  reserve_ratio?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "lending_controller" */
export type Lending_Controller = {
  __typename?: 'lending_controller';
  add_liquidity_paused: Scalars['Boolean']['output'];
  address: Scalars['String']['output'];
  admin: Scalars['String']['output'];
  admin_liquidation_fee_pct: Scalars['smallint']['output'];
  borrow_paused: Scalars['Boolean']['output'];
  close_vault_paused: Scalars['Boolean']['output'];
  collateral_ratio: Scalars['smallint']['output'];
  /** An array relationship */
  collateral_tokens: Array<Lending_Controller_Collateral_Token>;
  /** An aggregate relationship */
  collateral_tokens_aggregate: Lending_Controller_Collateral_Token_Aggregate;
  decimals: Scalars['smallint']['output'];
  /** An object relationship */
  governance: Governance;
  governance_id: Scalars['bigint']['output'];
  /** An array relationship */
  history_data: Array<Lending_Controller_History_Data>;
  /** An aggregate relationship */
  history_data_aggregate: Lending_Controller_History_Data_Aggregate;
  id: Scalars['bigint']['output'];
  interest_rate_decimals: Scalars['smallint']['output'];
  interest_treasury_share: Scalars['smallint']['output'];
  /** An array relationship */
  lambdas: Array<Lending_Controller_Lambda>;
  /** An aggregate relationship */
  lambdas_aggregate: Lending_Controller_Lambda_Aggregate;
  last_completed_data_max_delay: Scalars['bigint']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  liquidate_vault_paused: Scalars['Boolean']['output'];
  liquidation_delay_in_minutes: Scalars['bigint']['output'];
  liquidation_fee_pct: Scalars['smallint']['output'];
  liquidation_max_duration: Scalars['bigint']['output'];
  liquidation_ratio: Scalars['smallint']['output'];
  /** An array relationship */
  loan_tokens: Array<Lending_Controller_Loan_Token>;
  /** An aggregate relationship */
  loan_tokens_aggregate: Lending_Controller_Loan_Token_Aggregate;
  mark_for_liquidation_paused: Scalars['Boolean']['output'];
  max_decimals_for_calculation: Scalars['smallint']['output'];
  max_vault_liquidation_pct: Scalars['smallint']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  minimum_loan_fee_pct: Scalars['smallint']['output'];
  minimum_loan_treasury_share: Scalars['smallint']['output'];
  network: Scalars['String']['output'];
  register_deposit_paused: Scalars['Boolean']['output'];
  register_vault_creation_paused: Scalars['Boolean']['output'];
  register_withdrawal_paused: Scalars['Boolean']['output'];
  remove_liquidity_paused: Scalars['Boolean']['output'];
  repay_paused: Scalars['Boolean']['output'];
  set_collateral_token_paused: Scalars['Boolean']['output'];
  set_loan_token_paused: Scalars['Boolean']['output'];
  vault_deposit_paused: Scalars['Boolean']['output'];
  vault_deposit_staked_token_paused: Scalars['Boolean']['output'];
  vault_on_liquidate_paused: Scalars['Boolean']['output'];
  vault_withdraw_paused: Scalars['Boolean']['output'];
  vault_withdraw_staked_token_paused: Scalars['Boolean']['output'];
  /** An array relationship */
  vaults: Array<Lending_Controller_Vault>;
  /** An aggregate relationship */
  vaults_aggregate: Lending_Controller_Vault_Aggregate;
};


/** columns and relationships of "lending_controller" */
export type Lending_ControllerCollateral_TokensArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Collateral_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Collateral_Token_Order_By>>;
  where?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
};


/** columns and relationships of "lending_controller" */
export type Lending_ControllerCollateral_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Collateral_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Collateral_Token_Order_By>>;
  where?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
};


/** columns and relationships of "lending_controller" */
export type Lending_ControllerHistory_DataArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_History_Data_Order_By>>;
  where?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
};


/** columns and relationships of "lending_controller" */
export type Lending_ControllerHistory_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_History_Data_Order_By>>;
  where?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
};


/** columns and relationships of "lending_controller" */
export type Lending_ControllerLambdasArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Lambda_Order_By>>;
  where?: InputMaybe<Lending_Controller_Lambda_Bool_Exp>;
};


/** columns and relationships of "lending_controller" */
export type Lending_ControllerLambdas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Lambda_Order_By>>;
  where?: InputMaybe<Lending_Controller_Lambda_Bool_Exp>;
};


/** columns and relationships of "lending_controller" */
export type Lending_ControllerLoan_TokensArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Loan_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Loan_Token_Order_By>>;
  where?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
};


/** columns and relationships of "lending_controller" */
export type Lending_ControllerLoan_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Loan_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Loan_Token_Order_By>>;
  where?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
};


/** columns and relationships of "lending_controller" */
export type Lending_ControllerMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "lending_controller" */
export type Lending_ControllerVaultsArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Vault_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Vault_Order_By>>;
  where?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
};


/** columns and relationships of "lending_controller" */
export type Lending_ControllerVaults_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Vault_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Vault_Order_By>>;
  where?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
};

/** aggregated selection of "lending_controller" */
export type Lending_Controller_Aggregate = {
  __typename?: 'lending_controller_aggregate';
  aggregate?: Maybe<Lending_Controller_Aggregate_Fields>;
  nodes: Array<Lending_Controller>;
};

export type Lending_Controller_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Lending_Controller_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Lending_Controller_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Lending_Controller_Aggregate_Bool_Exp_Count>;
};

export type Lending_Controller_Aggregate_Bool_Exp_Bool_And = {
  arguments: Lending_Controller_Select_Column_Lending_Controller_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lending_Controller_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Lending_Controller_Select_Column_Lending_Controller_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lending_Controller_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Lending_Controller_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "lending_controller" */
export type Lending_Controller_Aggregate_Fields = {
  __typename?: 'lending_controller_aggregate_fields';
  avg?: Maybe<Lending_Controller_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Lending_Controller_Max_Fields>;
  min?: Maybe<Lending_Controller_Min_Fields>;
  stddev?: Maybe<Lending_Controller_Stddev_Fields>;
  stddev_pop?: Maybe<Lending_Controller_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lending_Controller_Stddev_Samp_Fields>;
  sum?: Maybe<Lending_Controller_Sum_Fields>;
  var_pop?: Maybe<Lending_Controller_Var_Pop_Fields>;
  var_samp?: Maybe<Lending_Controller_Var_Samp_Fields>;
  variance?: Maybe<Lending_Controller_Variance_Fields>;
};


/** aggregate fields of "lending_controller" */
export type Lending_Controller_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lending_Controller_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "lending_controller" */
export type Lending_Controller_Aggregate_Order_By = {
  avg?: InputMaybe<Lending_Controller_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lending_Controller_Max_Order_By>;
  min?: InputMaybe<Lending_Controller_Min_Order_By>;
  stddev?: InputMaybe<Lending_Controller_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Lending_Controller_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Lending_Controller_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Lending_Controller_Sum_Order_By>;
  var_pop?: InputMaybe<Lending_Controller_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Lending_Controller_Var_Samp_Order_By>;
  variance?: InputMaybe<Lending_Controller_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Lending_Controller_Avg_Fields = {
  __typename?: 'lending_controller_avg_fields';
  admin_liquidation_fee_pct?: Maybe<Scalars['Float']['output']>;
  collateral_ratio?: Maybe<Scalars['Float']['output']>;
  decimals?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  interest_rate_decimals?: Maybe<Scalars['Float']['output']>;
  interest_treasury_share?: Maybe<Scalars['Float']['output']>;
  last_completed_data_max_delay?: Maybe<Scalars['Float']['output']>;
  liquidation_delay_in_minutes?: Maybe<Scalars['Float']['output']>;
  liquidation_fee_pct?: Maybe<Scalars['Float']['output']>;
  liquidation_max_duration?: Maybe<Scalars['Float']['output']>;
  liquidation_ratio?: Maybe<Scalars['Float']['output']>;
  max_decimals_for_calculation?: Maybe<Scalars['Float']['output']>;
  max_vault_liquidation_pct?: Maybe<Scalars['Float']['output']>;
  minimum_loan_fee_pct?: Maybe<Scalars['Float']['output']>;
  minimum_loan_treasury_share?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "lending_controller" */
export type Lending_Controller_Avg_Order_By = {
  admin_liquidation_fee_pct?: InputMaybe<Order_By>;
  collateral_ratio?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interest_rate_decimals?: InputMaybe<Order_By>;
  interest_treasury_share?: InputMaybe<Order_By>;
  last_completed_data_max_delay?: InputMaybe<Order_By>;
  liquidation_delay_in_minutes?: InputMaybe<Order_By>;
  liquidation_fee_pct?: InputMaybe<Order_By>;
  liquidation_max_duration?: InputMaybe<Order_By>;
  liquidation_ratio?: InputMaybe<Order_By>;
  max_decimals_for_calculation?: InputMaybe<Order_By>;
  max_vault_liquidation_pct?: InputMaybe<Order_By>;
  minimum_loan_fee_pct?: InputMaybe<Order_By>;
  minimum_loan_treasury_share?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "lending_controller". All fields are combined with a logical 'AND'. */
export type Lending_Controller_Bool_Exp = {
  _and?: InputMaybe<Array<Lending_Controller_Bool_Exp>>;
  _not?: InputMaybe<Lending_Controller_Bool_Exp>;
  _or?: InputMaybe<Array<Lending_Controller_Bool_Exp>>;
  add_liquidity_paused?: InputMaybe<Boolean_Comparison_Exp>;
  address?: InputMaybe<String_Comparison_Exp>;
  admin?: InputMaybe<String_Comparison_Exp>;
  admin_liquidation_fee_pct?: InputMaybe<Smallint_Comparison_Exp>;
  borrow_paused?: InputMaybe<Boolean_Comparison_Exp>;
  close_vault_paused?: InputMaybe<Boolean_Comparison_Exp>;
  collateral_ratio?: InputMaybe<Smallint_Comparison_Exp>;
  collateral_tokens?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
  collateral_tokens_aggregate?: InputMaybe<Lending_Controller_Collateral_Token_Aggregate_Bool_Exp>;
  decimals?: InputMaybe<Smallint_Comparison_Exp>;
  governance?: InputMaybe<Governance_Bool_Exp>;
  governance_id?: InputMaybe<Bigint_Comparison_Exp>;
  history_data?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
  history_data_aggregate?: InputMaybe<Lending_Controller_History_Data_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  interest_rate_decimals?: InputMaybe<Smallint_Comparison_Exp>;
  interest_treasury_share?: InputMaybe<Smallint_Comparison_Exp>;
  lambdas?: InputMaybe<Lending_Controller_Lambda_Bool_Exp>;
  lambdas_aggregate?: InputMaybe<Lending_Controller_Lambda_Aggregate_Bool_Exp>;
  last_completed_data_max_delay?: InputMaybe<Bigint_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  liquidate_vault_paused?: InputMaybe<Boolean_Comparison_Exp>;
  liquidation_delay_in_minutes?: InputMaybe<Bigint_Comparison_Exp>;
  liquidation_fee_pct?: InputMaybe<Smallint_Comparison_Exp>;
  liquidation_max_duration?: InputMaybe<Bigint_Comparison_Exp>;
  liquidation_ratio?: InputMaybe<Smallint_Comparison_Exp>;
  loan_tokens?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
  loan_tokens_aggregate?: InputMaybe<Lending_Controller_Loan_Token_Aggregate_Bool_Exp>;
  mark_for_liquidation_paused?: InputMaybe<Boolean_Comparison_Exp>;
  max_decimals_for_calculation?: InputMaybe<Smallint_Comparison_Exp>;
  max_vault_liquidation_pct?: InputMaybe<Smallint_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  minimum_loan_fee_pct?: InputMaybe<Smallint_Comparison_Exp>;
  minimum_loan_treasury_share?: InputMaybe<Smallint_Comparison_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
  register_deposit_paused?: InputMaybe<Boolean_Comparison_Exp>;
  register_vault_creation_paused?: InputMaybe<Boolean_Comparison_Exp>;
  register_withdrawal_paused?: InputMaybe<Boolean_Comparison_Exp>;
  remove_liquidity_paused?: InputMaybe<Boolean_Comparison_Exp>;
  repay_paused?: InputMaybe<Boolean_Comparison_Exp>;
  set_collateral_token_paused?: InputMaybe<Boolean_Comparison_Exp>;
  set_loan_token_paused?: InputMaybe<Boolean_Comparison_Exp>;
  vault_deposit_paused?: InputMaybe<Boolean_Comparison_Exp>;
  vault_deposit_staked_token_paused?: InputMaybe<Boolean_Comparison_Exp>;
  vault_on_liquidate_paused?: InputMaybe<Boolean_Comparison_Exp>;
  vault_withdraw_paused?: InputMaybe<Boolean_Comparison_Exp>;
  vault_withdraw_staked_token_paused?: InputMaybe<Boolean_Comparison_Exp>;
  vaults?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
  vaults_aggregate?: InputMaybe<Lending_Controller_Vault_Aggregate_Bool_Exp>;
};

/** columns and relationships of "lending_controller_collateral_token" */
export type Lending_Controller_Collateral_Token = {
  __typename?: 'lending_controller_collateral_token';
  /** An array relationship */
  balances: Array<Lending_Controller_Vault_Collateral_Balance>;
  /** An aggregate relationship */
  balances_aggregate: Lending_Controller_Vault_Collateral_Balance_Aggregate;
  /** An array relationship */
  history_data: Array<Lending_Controller_History_Data>;
  /** An aggregate relationship */
  history_data_aggregate: Lending_Controller_History_Data_Aggregate;
  id: Scalars['bigint']['output'];
  is_scaled_token: Scalars['Boolean']['output'];
  is_staked_token: Scalars['Boolean']['output'];
  /** An object relationship */
  lending_controller: Lending_Controller;
  lending_controller_id: Scalars['bigint']['output'];
  max_deposit_amount?: Maybe<Scalars['float8']['output']>;
  /** An object relationship */
  oracle: Maven_User;
  oracle_id: Scalars['bigint']['output'];
  paused: Scalars['Boolean']['output'];
  protected: Scalars['Boolean']['output'];
  staking_contract_address?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  token: Token;
  token_id: Scalars['bigint']['output'];
  token_name: Scalars['String']['output'];
  total_deposited: Scalars['float8']['output'];
};


/** columns and relationships of "lending_controller_collateral_token" */
export type Lending_Controller_Collateral_TokenBalancesArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Vault_Collateral_Balance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Vault_Collateral_Balance_Order_By>>;
  where?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Bool_Exp>;
};


/** columns and relationships of "lending_controller_collateral_token" */
export type Lending_Controller_Collateral_TokenBalances_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Vault_Collateral_Balance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Vault_Collateral_Balance_Order_By>>;
  where?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Bool_Exp>;
};


/** columns and relationships of "lending_controller_collateral_token" */
export type Lending_Controller_Collateral_TokenHistory_DataArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_History_Data_Order_By>>;
  where?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
};


/** columns and relationships of "lending_controller_collateral_token" */
export type Lending_Controller_Collateral_TokenHistory_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_History_Data_Order_By>>;
  where?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
};

/** aggregated selection of "lending_controller_collateral_token" */
export type Lending_Controller_Collateral_Token_Aggregate = {
  __typename?: 'lending_controller_collateral_token_aggregate';
  aggregate?: Maybe<Lending_Controller_Collateral_Token_Aggregate_Fields>;
  nodes: Array<Lending_Controller_Collateral_Token>;
};

export type Lending_Controller_Collateral_Token_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Var_Samp>;
};

export type Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Avg = {
  arguments: Lending_Controller_Collateral_Token_Select_Column_Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Bool_And = {
  arguments: Lending_Controller_Collateral_Token_Select_Column_Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Lending_Controller_Collateral_Token_Select_Column_Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Corr = {
  arguments: Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Lending_Controller_Collateral_Token_Select_Column_Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Lending_Controller_Collateral_Token_Select_Column_Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Lending_Controller_Collateral_Token_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Lending_Controller_Collateral_Token_Select_Column_Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Lending_Controller_Collateral_Token_Select_Column_Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Max = {
  arguments: Lending_Controller_Collateral_Token_Select_Column_Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Min = {
  arguments: Lending_Controller_Collateral_Token_Select_Column_Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Lending_Controller_Collateral_Token_Select_Column_Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Sum = {
  arguments: Lending_Controller_Collateral_Token_Select_Column_Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Lending_Controller_Collateral_Token_Select_Column_Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "lending_controller_collateral_token" */
export type Lending_Controller_Collateral_Token_Aggregate_Fields = {
  __typename?: 'lending_controller_collateral_token_aggregate_fields';
  avg?: Maybe<Lending_Controller_Collateral_Token_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Lending_Controller_Collateral_Token_Max_Fields>;
  min?: Maybe<Lending_Controller_Collateral_Token_Min_Fields>;
  stddev?: Maybe<Lending_Controller_Collateral_Token_Stddev_Fields>;
  stddev_pop?: Maybe<Lending_Controller_Collateral_Token_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lending_Controller_Collateral_Token_Stddev_Samp_Fields>;
  sum?: Maybe<Lending_Controller_Collateral_Token_Sum_Fields>;
  var_pop?: Maybe<Lending_Controller_Collateral_Token_Var_Pop_Fields>;
  var_samp?: Maybe<Lending_Controller_Collateral_Token_Var_Samp_Fields>;
  variance?: Maybe<Lending_Controller_Collateral_Token_Variance_Fields>;
};


/** aggregate fields of "lending_controller_collateral_token" */
export type Lending_Controller_Collateral_Token_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lending_Controller_Collateral_Token_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "lending_controller_collateral_token" */
export type Lending_Controller_Collateral_Token_Aggregate_Order_By = {
  avg?: InputMaybe<Lending_Controller_Collateral_Token_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lending_Controller_Collateral_Token_Max_Order_By>;
  min?: InputMaybe<Lending_Controller_Collateral_Token_Min_Order_By>;
  stddev?: InputMaybe<Lending_Controller_Collateral_Token_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Lending_Controller_Collateral_Token_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Lending_Controller_Collateral_Token_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Lending_Controller_Collateral_Token_Sum_Order_By>;
  var_pop?: InputMaybe<Lending_Controller_Collateral_Token_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Lending_Controller_Collateral_Token_Var_Samp_Order_By>;
  variance?: InputMaybe<Lending_Controller_Collateral_Token_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Lending_Controller_Collateral_Token_Avg_Fields = {
  __typename?: 'lending_controller_collateral_token_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  max_deposit_amount?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  total_deposited?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "lending_controller_collateral_token" */
export type Lending_Controller_Collateral_Token_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  max_deposit_amount?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  total_deposited?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "lending_controller_collateral_token". All fields are combined with a logical 'AND'. */
export type Lending_Controller_Collateral_Token_Bool_Exp = {
  _and?: InputMaybe<Array<Lending_Controller_Collateral_Token_Bool_Exp>>;
  _not?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
  _or?: InputMaybe<Array<Lending_Controller_Collateral_Token_Bool_Exp>>;
  balances?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Bool_Exp>;
  balances_aggregate?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp>;
  history_data?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
  history_data_aggregate?: InputMaybe<Lending_Controller_History_Data_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_scaled_token?: InputMaybe<Boolean_Comparison_Exp>;
  is_staked_token?: InputMaybe<Boolean_Comparison_Exp>;
  lending_controller?: InputMaybe<Lending_Controller_Bool_Exp>;
  lending_controller_id?: InputMaybe<Bigint_Comparison_Exp>;
  max_deposit_amount?: InputMaybe<Float8_Comparison_Exp>;
  oracle?: InputMaybe<Maven_User_Bool_Exp>;
  oracle_id?: InputMaybe<Bigint_Comparison_Exp>;
  paused?: InputMaybe<Boolean_Comparison_Exp>;
  protected?: InputMaybe<Boolean_Comparison_Exp>;
  staking_contract_address?: InputMaybe<String_Comparison_Exp>;
  token?: InputMaybe<Token_Bool_Exp>;
  token_id?: InputMaybe<Bigint_Comparison_Exp>;
  token_name?: InputMaybe<String_Comparison_Exp>;
  total_deposited?: InputMaybe<Float8_Comparison_Exp>;
};

/** aggregate max on columns */
export type Lending_Controller_Collateral_Token_Max_Fields = {
  __typename?: 'lending_controller_collateral_token_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  lending_controller_id?: Maybe<Scalars['bigint']['output']>;
  max_deposit_amount?: Maybe<Scalars['float8']['output']>;
  oracle_id?: Maybe<Scalars['bigint']['output']>;
  staking_contract_address?: Maybe<Scalars['String']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  token_name?: Maybe<Scalars['String']['output']>;
  total_deposited?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "lending_controller_collateral_token" */
export type Lending_Controller_Collateral_Token_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  max_deposit_amount?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  staking_contract_address?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_name?: InputMaybe<Order_By>;
  total_deposited?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Lending_Controller_Collateral_Token_Min_Fields = {
  __typename?: 'lending_controller_collateral_token_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  lending_controller_id?: Maybe<Scalars['bigint']['output']>;
  max_deposit_amount?: Maybe<Scalars['float8']['output']>;
  oracle_id?: Maybe<Scalars['bigint']['output']>;
  staking_contract_address?: Maybe<Scalars['String']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  token_name?: Maybe<Scalars['String']['output']>;
  total_deposited?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "lending_controller_collateral_token" */
export type Lending_Controller_Collateral_Token_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  max_deposit_amount?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  staking_contract_address?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_name?: InputMaybe<Order_By>;
  total_deposited?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "lending_controller_collateral_token". */
export type Lending_Controller_Collateral_Token_Order_By = {
  balances_aggregate?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Aggregate_Order_By>;
  history_data_aggregate?: InputMaybe<Lending_Controller_History_Data_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_scaled_token?: InputMaybe<Order_By>;
  is_staked_token?: InputMaybe<Order_By>;
  lending_controller?: InputMaybe<Lending_Controller_Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  max_deposit_amount?: InputMaybe<Order_By>;
  oracle?: InputMaybe<Maven_User_Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  paused?: InputMaybe<Order_By>;
  protected?: InputMaybe<Order_By>;
  staking_contract_address?: InputMaybe<Order_By>;
  token?: InputMaybe<Token_Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_name?: InputMaybe<Order_By>;
  total_deposited?: InputMaybe<Order_By>;
};

/** select columns of table "lending_controller_collateral_token" */
export enum Lending_Controller_Collateral_Token_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsScaledToken = 'is_scaled_token',
  /** column name */
  IsStakedToken = 'is_staked_token',
  /** column name */
  LendingControllerId = 'lending_controller_id',
  /** column name */
  MaxDepositAmount = 'max_deposit_amount',
  /** column name */
  OracleId = 'oracle_id',
  /** column name */
  Paused = 'paused',
  /** column name */
  Protected = 'protected',
  /** column name */
  StakingContractAddress = 'staking_contract_address',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  TokenName = 'token_name',
  /** column name */
  TotalDeposited = 'total_deposited'
}

/** select "lending_controller_collateral_token_aggregate_bool_exp_avg_arguments_columns" columns of table "lending_controller_collateral_token" */
export enum Lending_Controller_Collateral_Token_Select_Column_Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  MaxDepositAmount = 'max_deposit_amount',
  /** column name */
  TotalDeposited = 'total_deposited'
}

/** select "lending_controller_collateral_token_aggregate_bool_exp_bool_and_arguments_columns" columns of table "lending_controller_collateral_token" */
export enum Lending_Controller_Collateral_Token_Select_Column_Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsScaledToken = 'is_scaled_token',
  /** column name */
  IsStakedToken = 'is_staked_token',
  /** column name */
  Paused = 'paused',
  /** column name */
  Protected = 'protected'
}

/** select "lending_controller_collateral_token_aggregate_bool_exp_bool_or_arguments_columns" columns of table "lending_controller_collateral_token" */
export enum Lending_Controller_Collateral_Token_Select_Column_Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsScaledToken = 'is_scaled_token',
  /** column name */
  IsStakedToken = 'is_staked_token',
  /** column name */
  Paused = 'paused',
  /** column name */
  Protected = 'protected'
}

/** select "lending_controller_collateral_token_aggregate_bool_exp_corr_arguments_columns" columns of table "lending_controller_collateral_token" */
export enum Lending_Controller_Collateral_Token_Select_Column_Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  MaxDepositAmount = 'max_deposit_amount',
  /** column name */
  TotalDeposited = 'total_deposited'
}

/** select "lending_controller_collateral_token_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "lending_controller_collateral_token" */
export enum Lending_Controller_Collateral_Token_Select_Column_Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  MaxDepositAmount = 'max_deposit_amount',
  /** column name */
  TotalDeposited = 'total_deposited'
}

/** select "lending_controller_collateral_token_aggregate_bool_exp_max_arguments_columns" columns of table "lending_controller_collateral_token" */
export enum Lending_Controller_Collateral_Token_Select_Column_Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  MaxDepositAmount = 'max_deposit_amount',
  /** column name */
  TotalDeposited = 'total_deposited'
}

/** select "lending_controller_collateral_token_aggregate_bool_exp_min_arguments_columns" columns of table "lending_controller_collateral_token" */
export enum Lending_Controller_Collateral_Token_Select_Column_Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  MaxDepositAmount = 'max_deposit_amount',
  /** column name */
  TotalDeposited = 'total_deposited'
}

/** select "lending_controller_collateral_token_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "lending_controller_collateral_token" */
export enum Lending_Controller_Collateral_Token_Select_Column_Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  MaxDepositAmount = 'max_deposit_amount',
  /** column name */
  TotalDeposited = 'total_deposited'
}

/** select "lending_controller_collateral_token_aggregate_bool_exp_sum_arguments_columns" columns of table "lending_controller_collateral_token" */
export enum Lending_Controller_Collateral_Token_Select_Column_Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  MaxDepositAmount = 'max_deposit_amount',
  /** column name */
  TotalDeposited = 'total_deposited'
}

/** select "lending_controller_collateral_token_aggregate_bool_exp_var_samp_arguments_columns" columns of table "lending_controller_collateral_token" */
export enum Lending_Controller_Collateral_Token_Select_Column_Lending_Controller_Collateral_Token_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  MaxDepositAmount = 'max_deposit_amount',
  /** column name */
  TotalDeposited = 'total_deposited'
}

/** aggregate stddev on columns */
export type Lending_Controller_Collateral_Token_Stddev_Fields = {
  __typename?: 'lending_controller_collateral_token_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  max_deposit_amount?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  total_deposited?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "lending_controller_collateral_token" */
export type Lending_Controller_Collateral_Token_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  max_deposit_amount?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  total_deposited?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Lending_Controller_Collateral_Token_Stddev_Pop_Fields = {
  __typename?: 'lending_controller_collateral_token_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  max_deposit_amount?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  total_deposited?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "lending_controller_collateral_token" */
export type Lending_Controller_Collateral_Token_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  max_deposit_amount?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  total_deposited?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Lending_Controller_Collateral_Token_Stddev_Samp_Fields = {
  __typename?: 'lending_controller_collateral_token_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  max_deposit_amount?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  total_deposited?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "lending_controller_collateral_token" */
export type Lending_Controller_Collateral_Token_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  max_deposit_amount?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  total_deposited?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "lending_controller_collateral_token" */
export type Lending_Controller_Collateral_Token_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lending_Controller_Collateral_Token_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lending_Controller_Collateral_Token_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_scaled_token?: InputMaybe<Scalars['Boolean']['input']>;
  is_staked_token?: InputMaybe<Scalars['Boolean']['input']>;
  lending_controller_id?: InputMaybe<Scalars['bigint']['input']>;
  max_deposit_amount?: InputMaybe<Scalars['float8']['input']>;
  oracle_id?: InputMaybe<Scalars['bigint']['input']>;
  paused?: InputMaybe<Scalars['Boolean']['input']>;
  protected?: InputMaybe<Scalars['Boolean']['input']>;
  staking_contract_address?: InputMaybe<Scalars['String']['input']>;
  token_id?: InputMaybe<Scalars['bigint']['input']>;
  token_name?: InputMaybe<Scalars['String']['input']>;
  total_deposited?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type Lending_Controller_Collateral_Token_Sum_Fields = {
  __typename?: 'lending_controller_collateral_token_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  lending_controller_id?: Maybe<Scalars['bigint']['output']>;
  max_deposit_amount?: Maybe<Scalars['float8']['output']>;
  oracle_id?: Maybe<Scalars['bigint']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  total_deposited?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "lending_controller_collateral_token" */
export type Lending_Controller_Collateral_Token_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  max_deposit_amount?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  total_deposited?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Lending_Controller_Collateral_Token_Var_Pop_Fields = {
  __typename?: 'lending_controller_collateral_token_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  max_deposit_amount?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  total_deposited?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "lending_controller_collateral_token" */
export type Lending_Controller_Collateral_Token_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  max_deposit_amount?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  total_deposited?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Lending_Controller_Collateral_Token_Var_Samp_Fields = {
  __typename?: 'lending_controller_collateral_token_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  max_deposit_amount?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  total_deposited?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "lending_controller_collateral_token" */
export type Lending_Controller_Collateral_Token_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  max_deposit_amount?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  total_deposited?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Lending_Controller_Collateral_Token_Variance_Fields = {
  __typename?: 'lending_controller_collateral_token_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  max_deposit_amount?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  total_deposited?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "lending_controller_collateral_token" */
export type Lending_Controller_Collateral_Token_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  max_deposit_amount?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  total_deposited?: InputMaybe<Order_By>;
};

/** columns and relationships of "lending_controller_history_data" */
export type Lending_Controller_History_Data = {
  __typename?: 'lending_controller_history_data';
  amount: Scalars['float8']['output'];
  /** An object relationship */
  collateral_token?: Maybe<Lending_Controller_Collateral_Token>;
  collateral_token_id?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  /** An object relationship */
  lending_controller: Lending_Controller;
  lending_controller_id: Scalars['bigint']['output'];
  level: Scalars['bigint']['output'];
  /** An object relationship */
  loan_token?: Maybe<Lending_Controller_Loan_Token>;
  loan_token_id?: Maybe<Scalars['bigint']['output']>;
  operation_hash: Scalars['String']['output'];
  /** An object relationship */
  sender: Maven_User;
  sender_id: Scalars['bigint']['output'];
  timestamp: Scalars['timestamptz']['output'];
  /** ADD_LIQUIDITY: 0\nREMOVE_LIQUIDITY: 1\nBORROW: 2\nREPAY: 3\nDEPOSIT: 4\nWITHDRAW: 5\nDEPOSIT_STAKED_TOKEN: 6\nWITHDRAW_STAKED_TOKEN: 7\nVAULT_CREATION: 8\nMARK_FOR_LIQUIDATION: 9\nLIQUIDATE_VAULT: 10\nCLOSE_VAULT: 11 */
  type: Scalars['smallint']['output'];
  /** An object relationship */
  vault?: Maybe<Lending_Controller_Vault>;
  vault_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "lending_controller_history_data" */
export type Lending_Controller_History_Data_Aggregate = {
  __typename?: 'lending_controller_history_data_aggregate';
  aggregate?: Maybe<Lending_Controller_History_Data_Aggregate_Fields>;
  nodes: Array<Lending_Controller_History_Data>;
};

export type Lending_Controller_History_Data_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Lending_Controller_History_Data_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Lending_Controller_History_Data_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Lending_Controller_History_Data_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Lending_Controller_History_Data_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Lending_Controller_History_Data_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Lending_Controller_History_Data_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Lending_Controller_History_Data_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Lending_Controller_History_Data_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Lending_Controller_History_Data_Aggregate_Bool_Exp_Var_Samp>;
};

export type Lending_Controller_History_Data_Aggregate_Bool_Exp_Avg = {
  arguments: Lending_Controller_History_Data_Select_Column_Lending_Controller_History_Data_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_History_Data_Aggregate_Bool_Exp_Corr = {
  arguments: Lending_Controller_History_Data_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_History_Data_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Lending_Controller_History_Data_Select_Column_Lending_Controller_History_Data_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Lending_Controller_History_Data_Select_Column_Lending_Controller_History_Data_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Lending_Controller_History_Data_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Lending_Controller_History_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Lending_Controller_History_Data_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Lending_Controller_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Lending_Controller_History_Data_Select_Column_Lending_Controller_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Lending_Controller_History_Data_Select_Column_Lending_Controller_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Lending_Controller_History_Data_Aggregate_Bool_Exp_Max = {
  arguments: Lending_Controller_History_Data_Select_Column_Lending_Controller_History_Data_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_History_Data_Aggregate_Bool_Exp_Min = {
  arguments: Lending_Controller_History_Data_Select_Column_Lending_Controller_History_Data_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_History_Data_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Lending_Controller_History_Data_Select_Column_Lending_Controller_History_Data_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_History_Data_Aggregate_Bool_Exp_Sum = {
  arguments: Lending_Controller_History_Data_Select_Column_Lending_Controller_History_Data_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_History_Data_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Lending_Controller_History_Data_Select_Column_Lending_Controller_History_Data_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "lending_controller_history_data" */
export type Lending_Controller_History_Data_Aggregate_Fields = {
  __typename?: 'lending_controller_history_data_aggregate_fields';
  avg?: Maybe<Lending_Controller_History_Data_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Lending_Controller_History_Data_Max_Fields>;
  min?: Maybe<Lending_Controller_History_Data_Min_Fields>;
  stddev?: Maybe<Lending_Controller_History_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Lending_Controller_History_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lending_Controller_History_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Lending_Controller_History_Data_Sum_Fields>;
  var_pop?: Maybe<Lending_Controller_History_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Lending_Controller_History_Data_Var_Samp_Fields>;
  variance?: Maybe<Lending_Controller_History_Data_Variance_Fields>;
};


/** aggregate fields of "lending_controller_history_data" */
export type Lending_Controller_History_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lending_Controller_History_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "lending_controller_history_data" */
export type Lending_Controller_History_Data_Aggregate_Order_By = {
  avg?: InputMaybe<Lending_Controller_History_Data_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lending_Controller_History_Data_Max_Order_By>;
  min?: InputMaybe<Lending_Controller_History_Data_Min_Order_By>;
  stddev?: InputMaybe<Lending_Controller_History_Data_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Lending_Controller_History_Data_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Lending_Controller_History_Data_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Lending_Controller_History_Data_Sum_Order_By>;
  var_pop?: InputMaybe<Lending_Controller_History_Data_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Lending_Controller_History_Data_Var_Samp_Order_By>;
  variance?: InputMaybe<Lending_Controller_History_Data_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Lending_Controller_History_Data_Avg_Fields = {
  __typename?: 'lending_controller_history_data_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  collateral_token_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  loan_token_id?: Maybe<Scalars['Float']['output']>;
  sender_id?: Maybe<Scalars['Float']['output']>;
  /** ADD_LIQUIDITY: 0\nREMOVE_LIQUIDITY: 1\nBORROW: 2\nREPAY: 3\nDEPOSIT: 4\nWITHDRAW: 5\nDEPOSIT_STAKED_TOKEN: 6\nWITHDRAW_STAKED_TOKEN: 7\nVAULT_CREATION: 8\nMARK_FOR_LIQUIDATION: 9\nLIQUIDATE_VAULT: 10\nCLOSE_VAULT: 11 */
  type?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "lending_controller_history_data" */
export type Lending_Controller_History_Data_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  collateral_token_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  loan_token_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
  /** ADD_LIQUIDITY: 0\nREMOVE_LIQUIDITY: 1\nBORROW: 2\nREPAY: 3\nDEPOSIT: 4\nWITHDRAW: 5\nDEPOSIT_STAKED_TOKEN: 6\nWITHDRAW_STAKED_TOKEN: 7\nVAULT_CREATION: 8\nMARK_FOR_LIQUIDATION: 9\nLIQUIDATE_VAULT: 10\nCLOSE_VAULT: 11 */
  type?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "lending_controller_history_data". All fields are combined with a logical 'AND'. */
export type Lending_Controller_History_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Lending_Controller_History_Data_Bool_Exp>>;
  _not?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Lending_Controller_History_Data_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  collateral_token?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
  collateral_token_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lending_controller?: InputMaybe<Lending_Controller_Bool_Exp>;
  lending_controller_id?: InputMaybe<Bigint_Comparison_Exp>;
  level?: InputMaybe<Bigint_Comparison_Exp>;
  loan_token?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
  loan_token_id?: InputMaybe<Bigint_Comparison_Exp>;
  operation_hash?: InputMaybe<String_Comparison_Exp>;
  sender?: InputMaybe<Maven_User_Bool_Exp>;
  sender_id?: InputMaybe<Bigint_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  type?: InputMaybe<Smallint_Comparison_Exp>;
  vault?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
  vault_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Lending_Controller_History_Data_Max_Fields = {
  __typename?: 'lending_controller_history_data_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  collateral_token_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lending_controller_id?: Maybe<Scalars['bigint']['output']>;
  level?: Maybe<Scalars['bigint']['output']>;
  loan_token_id?: Maybe<Scalars['bigint']['output']>;
  operation_hash?: Maybe<Scalars['String']['output']>;
  sender_id?: Maybe<Scalars['bigint']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  /** ADD_LIQUIDITY: 0\nREMOVE_LIQUIDITY: 1\nBORROW: 2\nREPAY: 3\nDEPOSIT: 4\nWITHDRAW: 5\nDEPOSIT_STAKED_TOKEN: 6\nWITHDRAW_STAKED_TOKEN: 7\nVAULT_CREATION: 8\nMARK_FOR_LIQUIDATION: 9\nLIQUIDATE_VAULT: 10\nCLOSE_VAULT: 11 */
  type?: Maybe<Scalars['smallint']['output']>;
  vault_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "lending_controller_history_data" */
export type Lending_Controller_History_Data_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  collateral_token_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  loan_token_id?: InputMaybe<Order_By>;
  operation_hash?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  /** ADD_LIQUIDITY: 0\nREMOVE_LIQUIDITY: 1\nBORROW: 2\nREPAY: 3\nDEPOSIT: 4\nWITHDRAW: 5\nDEPOSIT_STAKED_TOKEN: 6\nWITHDRAW_STAKED_TOKEN: 7\nVAULT_CREATION: 8\nMARK_FOR_LIQUIDATION: 9\nLIQUIDATE_VAULT: 10\nCLOSE_VAULT: 11 */
  type?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Lending_Controller_History_Data_Min_Fields = {
  __typename?: 'lending_controller_history_data_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  collateral_token_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lending_controller_id?: Maybe<Scalars['bigint']['output']>;
  level?: Maybe<Scalars['bigint']['output']>;
  loan_token_id?: Maybe<Scalars['bigint']['output']>;
  operation_hash?: Maybe<Scalars['String']['output']>;
  sender_id?: Maybe<Scalars['bigint']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  /** ADD_LIQUIDITY: 0\nREMOVE_LIQUIDITY: 1\nBORROW: 2\nREPAY: 3\nDEPOSIT: 4\nWITHDRAW: 5\nDEPOSIT_STAKED_TOKEN: 6\nWITHDRAW_STAKED_TOKEN: 7\nVAULT_CREATION: 8\nMARK_FOR_LIQUIDATION: 9\nLIQUIDATE_VAULT: 10\nCLOSE_VAULT: 11 */
  type?: Maybe<Scalars['smallint']['output']>;
  vault_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "lending_controller_history_data" */
export type Lending_Controller_History_Data_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  collateral_token_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  loan_token_id?: InputMaybe<Order_By>;
  operation_hash?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  /** ADD_LIQUIDITY: 0\nREMOVE_LIQUIDITY: 1\nBORROW: 2\nREPAY: 3\nDEPOSIT: 4\nWITHDRAW: 5\nDEPOSIT_STAKED_TOKEN: 6\nWITHDRAW_STAKED_TOKEN: 7\nVAULT_CREATION: 8\nMARK_FOR_LIQUIDATION: 9\nLIQUIDATE_VAULT: 10\nCLOSE_VAULT: 11 */
  type?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "lending_controller_history_data". */
export type Lending_Controller_History_Data_Order_By = {
  amount?: InputMaybe<Order_By>;
  collateral_token?: InputMaybe<Lending_Controller_Collateral_Token_Order_By>;
  collateral_token_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lending_controller?: InputMaybe<Lending_Controller_Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  loan_token?: InputMaybe<Lending_Controller_Loan_Token_Order_By>;
  loan_token_id?: InputMaybe<Order_By>;
  operation_hash?: InputMaybe<Order_By>;
  sender?: InputMaybe<Maven_User_Order_By>;
  sender_id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  vault?: InputMaybe<Lending_Controller_Vault_Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** select columns of table "lending_controller_history_data" */
export enum Lending_Controller_History_Data_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CollateralTokenId = 'collateral_token_id',
  /** column name */
  Id = 'id',
  /** column name */
  LendingControllerId = 'lending_controller_id',
  /** column name */
  Level = 'level',
  /** column name */
  LoanTokenId = 'loan_token_id',
  /** column name */
  OperationHash = 'operation_hash',
  /** column name */
  SenderId = 'sender_id',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Type = 'type',
  /** column name */
  VaultId = 'vault_id'
}

/** select "lending_controller_history_data_aggregate_bool_exp_avg_arguments_columns" columns of table "lending_controller_history_data" */
export enum Lending_Controller_History_Data_Select_Column_Lending_Controller_History_Data_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Amount = 'amount'
}

/** select "lending_controller_history_data_aggregate_bool_exp_corr_arguments_columns" columns of table "lending_controller_history_data" */
export enum Lending_Controller_History_Data_Select_Column_Lending_Controller_History_Data_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Amount = 'amount'
}

/** select "lending_controller_history_data_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "lending_controller_history_data" */
export enum Lending_Controller_History_Data_Select_Column_Lending_Controller_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Amount = 'amount'
}

/** select "lending_controller_history_data_aggregate_bool_exp_max_arguments_columns" columns of table "lending_controller_history_data" */
export enum Lending_Controller_History_Data_Select_Column_Lending_Controller_History_Data_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Amount = 'amount'
}

/** select "lending_controller_history_data_aggregate_bool_exp_min_arguments_columns" columns of table "lending_controller_history_data" */
export enum Lending_Controller_History_Data_Select_Column_Lending_Controller_History_Data_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Amount = 'amount'
}

/** select "lending_controller_history_data_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "lending_controller_history_data" */
export enum Lending_Controller_History_Data_Select_Column_Lending_Controller_History_Data_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Amount = 'amount'
}

/** select "lending_controller_history_data_aggregate_bool_exp_sum_arguments_columns" columns of table "lending_controller_history_data" */
export enum Lending_Controller_History_Data_Select_Column_Lending_Controller_History_Data_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Amount = 'amount'
}

/** select "lending_controller_history_data_aggregate_bool_exp_var_samp_arguments_columns" columns of table "lending_controller_history_data" */
export enum Lending_Controller_History_Data_Select_Column_Lending_Controller_History_Data_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Amount = 'amount'
}

/** aggregate stddev on columns */
export type Lending_Controller_History_Data_Stddev_Fields = {
  __typename?: 'lending_controller_history_data_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  collateral_token_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  loan_token_id?: Maybe<Scalars['Float']['output']>;
  sender_id?: Maybe<Scalars['Float']['output']>;
  /** ADD_LIQUIDITY: 0\nREMOVE_LIQUIDITY: 1\nBORROW: 2\nREPAY: 3\nDEPOSIT: 4\nWITHDRAW: 5\nDEPOSIT_STAKED_TOKEN: 6\nWITHDRAW_STAKED_TOKEN: 7\nVAULT_CREATION: 8\nMARK_FOR_LIQUIDATION: 9\nLIQUIDATE_VAULT: 10\nCLOSE_VAULT: 11 */
  type?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "lending_controller_history_data" */
export type Lending_Controller_History_Data_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  collateral_token_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  loan_token_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
  /** ADD_LIQUIDITY: 0\nREMOVE_LIQUIDITY: 1\nBORROW: 2\nREPAY: 3\nDEPOSIT: 4\nWITHDRAW: 5\nDEPOSIT_STAKED_TOKEN: 6\nWITHDRAW_STAKED_TOKEN: 7\nVAULT_CREATION: 8\nMARK_FOR_LIQUIDATION: 9\nLIQUIDATE_VAULT: 10\nCLOSE_VAULT: 11 */
  type?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Lending_Controller_History_Data_Stddev_Pop_Fields = {
  __typename?: 'lending_controller_history_data_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  collateral_token_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  loan_token_id?: Maybe<Scalars['Float']['output']>;
  sender_id?: Maybe<Scalars['Float']['output']>;
  /** ADD_LIQUIDITY: 0\nREMOVE_LIQUIDITY: 1\nBORROW: 2\nREPAY: 3\nDEPOSIT: 4\nWITHDRAW: 5\nDEPOSIT_STAKED_TOKEN: 6\nWITHDRAW_STAKED_TOKEN: 7\nVAULT_CREATION: 8\nMARK_FOR_LIQUIDATION: 9\nLIQUIDATE_VAULT: 10\nCLOSE_VAULT: 11 */
  type?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "lending_controller_history_data" */
export type Lending_Controller_History_Data_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  collateral_token_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  loan_token_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
  /** ADD_LIQUIDITY: 0\nREMOVE_LIQUIDITY: 1\nBORROW: 2\nREPAY: 3\nDEPOSIT: 4\nWITHDRAW: 5\nDEPOSIT_STAKED_TOKEN: 6\nWITHDRAW_STAKED_TOKEN: 7\nVAULT_CREATION: 8\nMARK_FOR_LIQUIDATION: 9\nLIQUIDATE_VAULT: 10\nCLOSE_VAULT: 11 */
  type?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Lending_Controller_History_Data_Stddev_Samp_Fields = {
  __typename?: 'lending_controller_history_data_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  collateral_token_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  loan_token_id?: Maybe<Scalars['Float']['output']>;
  sender_id?: Maybe<Scalars['Float']['output']>;
  /** ADD_LIQUIDITY: 0\nREMOVE_LIQUIDITY: 1\nBORROW: 2\nREPAY: 3\nDEPOSIT: 4\nWITHDRAW: 5\nDEPOSIT_STAKED_TOKEN: 6\nWITHDRAW_STAKED_TOKEN: 7\nVAULT_CREATION: 8\nMARK_FOR_LIQUIDATION: 9\nLIQUIDATE_VAULT: 10\nCLOSE_VAULT: 11 */
  type?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "lending_controller_history_data" */
export type Lending_Controller_History_Data_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  collateral_token_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  loan_token_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
  /** ADD_LIQUIDITY: 0\nREMOVE_LIQUIDITY: 1\nBORROW: 2\nREPAY: 3\nDEPOSIT: 4\nWITHDRAW: 5\nDEPOSIT_STAKED_TOKEN: 6\nWITHDRAW_STAKED_TOKEN: 7\nVAULT_CREATION: 8\nMARK_FOR_LIQUIDATION: 9\nLIQUIDATE_VAULT: 10\nCLOSE_VAULT: 11 */
  type?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "lending_controller_history_data" */
export type Lending_Controller_History_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lending_Controller_History_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lending_Controller_History_Data_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  collateral_token_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lending_controller_id?: InputMaybe<Scalars['bigint']['input']>;
  level?: InputMaybe<Scalars['bigint']['input']>;
  loan_token_id?: InputMaybe<Scalars['bigint']['input']>;
  operation_hash?: InputMaybe<Scalars['String']['input']>;
  sender_id?: InputMaybe<Scalars['bigint']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  /** ADD_LIQUIDITY: 0\nREMOVE_LIQUIDITY: 1\nBORROW: 2\nREPAY: 3\nDEPOSIT: 4\nWITHDRAW: 5\nDEPOSIT_STAKED_TOKEN: 6\nWITHDRAW_STAKED_TOKEN: 7\nVAULT_CREATION: 8\nMARK_FOR_LIQUIDATION: 9\nLIQUIDATE_VAULT: 10\nCLOSE_VAULT: 11 */
  type?: InputMaybe<Scalars['smallint']['input']>;
  vault_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Lending_Controller_History_Data_Sum_Fields = {
  __typename?: 'lending_controller_history_data_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  collateral_token_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lending_controller_id?: Maybe<Scalars['bigint']['output']>;
  level?: Maybe<Scalars['bigint']['output']>;
  loan_token_id?: Maybe<Scalars['bigint']['output']>;
  sender_id?: Maybe<Scalars['bigint']['output']>;
  /** ADD_LIQUIDITY: 0\nREMOVE_LIQUIDITY: 1\nBORROW: 2\nREPAY: 3\nDEPOSIT: 4\nWITHDRAW: 5\nDEPOSIT_STAKED_TOKEN: 6\nWITHDRAW_STAKED_TOKEN: 7\nVAULT_CREATION: 8\nMARK_FOR_LIQUIDATION: 9\nLIQUIDATE_VAULT: 10\nCLOSE_VAULT: 11 */
  type?: Maybe<Scalars['smallint']['output']>;
  vault_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "lending_controller_history_data" */
export type Lending_Controller_History_Data_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  collateral_token_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  loan_token_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
  /** ADD_LIQUIDITY: 0\nREMOVE_LIQUIDITY: 1\nBORROW: 2\nREPAY: 3\nDEPOSIT: 4\nWITHDRAW: 5\nDEPOSIT_STAKED_TOKEN: 6\nWITHDRAW_STAKED_TOKEN: 7\nVAULT_CREATION: 8\nMARK_FOR_LIQUIDATION: 9\nLIQUIDATE_VAULT: 10\nCLOSE_VAULT: 11 */
  type?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Lending_Controller_History_Data_Var_Pop_Fields = {
  __typename?: 'lending_controller_history_data_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  collateral_token_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  loan_token_id?: Maybe<Scalars['Float']['output']>;
  sender_id?: Maybe<Scalars['Float']['output']>;
  /** ADD_LIQUIDITY: 0\nREMOVE_LIQUIDITY: 1\nBORROW: 2\nREPAY: 3\nDEPOSIT: 4\nWITHDRAW: 5\nDEPOSIT_STAKED_TOKEN: 6\nWITHDRAW_STAKED_TOKEN: 7\nVAULT_CREATION: 8\nMARK_FOR_LIQUIDATION: 9\nLIQUIDATE_VAULT: 10\nCLOSE_VAULT: 11 */
  type?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "lending_controller_history_data" */
export type Lending_Controller_History_Data_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  collateral_token_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  loan_token_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
  /** ADD_LIQUIDITY: 0\nREMOVE_LIQUIDITY: 1\nBORROW: 2\nREPAY: 3\nDEPOSIT: 4\nWITHDRAW: 5\nDEPOSIT_STAKED_TOKEN: 6\nWITHDRAW_STAKED_TOKEN: 7\nVAULT_CREATION: 8\nMARK_FOR_LIQUIDATION: 9\nLIQUIDATE_VAULT: 10\nCLOSE_VAULT: 11 */
  type?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Lending_Controller_History_Data_Var_Samp_Fields = {
  __typename?: 'lending_controller_history_data_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  collateral_token_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  loan_token_id?: Maybe<Scalars['Float']['output']>;
  sender_id?: Maybe<Scalars['Float']['output']>;
  /** ADD_LIQUIDITY: 0\nREMOVE_LIQUIDITY: 1\nBORROW: 2\nREPAY: 3\nDEPOSIT: 4\nWITHDRAW: 5\nDEPOSIT_STAKED_TOKEN: 6\nWITHDRAW_STAKED_TOKEN: 7\nVAULT_CREATION: 8\nMARK_FOR_LIQUIDATION: 9\nLIQUIDATE_VAULT: 10\nCLOSE_VAULT: 11 */
  type?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "lending_controller_history_data" */
export type Lending_Controller_History_Data_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  collateral_token_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  loan_token_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
  /** ADD_LIQUIDITY: 0\nREMOVE_LIQUIDITY: 1\nBORROW: 2\nREPAY: 3\nDEPOSIT: 4\nWITHDRAW: 5\nDEPOSIT_STAKED_TOKEN: 6\nWITHDRAW_STAKED_TOKEN: 7\nVAULT_CREATION: 8\nMARK_FOR_LIQUIDATION: 9\nLIQUIDATE_VAULT: 10\nCLOSE_VAULT: 11 */
  type?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Lending_Controller_History_Data_Variance_Fields = {
  __typename?: 'lending_controller_history_data_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  collateral_token_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  loan_token_id?: Maybe<Scalars['Float']['output']>;
  sender_id?: Maybe<Scalars['Float']['output']>;
  /** ADD_LIQUIDITY: 0\nREMOVE_LIQUIDITY: 1\nBORROW: 2\nREPAY: 3\nDEPOSIT: 4\nWITHDRAW: 5\nDEPOSIT_STAKED_TOKEN: 6\nWITHDRAW_STAKED_TOKEN: 7\nVAULT_CREATION: 8\nMARK_FOR_LIQUIDATION: 9\nLIQUIDATE_VAULT: 10\nCLOSE_VAULT: 11 */
  type?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "lending_controller_history_data" */
export type Lending_Controller_History_Data_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  collateral_token_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  loan_token_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
  /** ADD_LIQUIDITY: 0\nREMOVE_LIQUIDITY: 1\nBORROW: 2\nREPAY: 3\nDEPOSIT: 4\nWITHDRAW: 5\nDEPOSIT_STAKED_TOKEN: 6\nWITHDRAW_STAKED_TOKEN: 7\nVAULT_CREATION: 8\nMARK_FOR_LIQUIDATION: 9\nLIQUIDATE_VAULT: 10\nCLOSE_VAULT: 11 */
  type?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "lending_controller_lambda" */
export type Lending_Controller_Lambda = {
  __typename?: 'lending_controller_lambda';
  /** An object relationship */
  contract: Lending_Controller;
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lambda_bytes: Scalars['String']['output'];
  lambda_name: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "lending_controller_lambda" */
export type Lending_Controller_Lambda_Aggregate = {
  __typename?: 'lending_controller_lambda_aggregate';
  aggregate?: Maybe<Lending_Controller_Lambda_Aggregate_Fields>;
  nodes: Array<Lending_Controller_Lambda>;
};

export type Lending_Controller_Lambda_Aggregate_Bool_Exp = {
  count?: InputMaybe<Lending_Controller_Lambda_Aggregate_Bool_Exp_Count>;
};

export type Lending_Controller_Lambda_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Lending_Controller_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Lambda_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "lending_controller_lambda" */
export type Lending_Controller_Lambda_Aggregate_Fields = {
  __typename?: 'lending_controller_lambda_aggregate_fields';
  avg?: Maybe<Lending_Controller_Lambda_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Lending_Controller_Lambda_Max_Fields>;
  min?: Maybe<Lending_Controller_Lambda_Min_Fields>;
  stddev?: Maybe<Lending_Controller_Lambda_Stddev_Fields>;
  stddev_pop?: Maybe<Lending_Controller_Lambda_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lending_Controller_Lambda_Stddev_Samp_Fields>;
  sum?: Maybe<Lending_Controller_Lambda_Sum_Fields>;
  var_pop?: Maybe<Lending_Controller_Lambda_Var_Pop_Fields>;
  var_samp?: Maybe<Lending_Controller_Lambda_Var_Samp_Fields>;
  variance?: Maybe<Lending_Controller_Lambda_Variance_Fields>;
};


/** aggregate fields of "lending_controller_lambda" */
export type Lending_Controller_Lambda_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lending_Controller_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "lending_controller_lambda" */
export type Lending_Controller_Lambda_Aggregate_Order_By = {
  avg?: InputMaybe<Lending_Controller_Lambda_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lending_Controller_Lambda_Max_Order_By>;
  min?: InputMaybe<Lending_Controller_Lambda_Min_Order_By>;
  stddev?: InputMaybe<Lending_Controller_Lambda_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Lending_Controller_Lambda_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Lending_Controller_Lambda_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Lending_Controller_Lambda_Sum_Order_By>;
  var_pop?: InputMaybe<Lending_Controller_Lambda_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Lending_Controller_Lambda_Var_Samp_Order_By>;
  variance?: InputMaybe<Lending_Controller_Lambda_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Lending_Controller_Lambda_Avg_Fields = {
  __typename?: 'lending_controller_lambda_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "lending_controller_lambda" */
export type Lending_Controller_Lambda_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "lending_controller_lambda". All fields are combined with a logical 'AND'. */
export type Lending_Controller_Lambda_Bool_Exp = {
  _and?: InputMaybe<Array<Lending_Controller_Lambda_Bool_Exp>>;
  _not?: InputMaybe<Lending_Controller_Lambda_Bool_Exp>;
  _or?: InputMaybe<Array<Lending_Controller_Lambda_Bool_Exp>>;
  contract?: InputMaybe<Lending_Controller_Bool_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambda_bytes?: InputMaybe<String_Comparison_Exp>;
  lambda_name?: InputMaybe<String_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Lending_Controller_Lambda_Max_Fields = {
  __typename?: 'lending_controller_lambda_max_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "lending_controller_lambda" */
export type Lending_Controller_Lambda_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Lending_Controller_Lambda_Min_Fields = {
  __typename?: 'lending_controller_lambda_min_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "lending_controller_lambda" */
export type Lending_Controller_Lambda_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "lending_controller_lambda". */
export type Lending_Controller_Lambda_Order_By = {
  contract?: InputMaybe<Lending_Controller_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "lending_controller_lambda" */
export enum Lending_Controller_Lambda_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaBytes = 'lambda_bytes',
  /** column name */
  LambdaName = 'lambda_name',
  /** column name */
  LastUpdatedAt = 'last_updated_at'
}

/** aggregate stddev on columns */
export type Lending_Controller_Lambda_Stddev_Fields = {
  __typename?: 'lending_controller_lambda_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "lending_controller_lambda" */
export type Lending_Controller_Lambda_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Lending_Controller_Lambda_Stddev_Pop_Fields = {
  __typename?: 'lending_controller_lambda_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "lending_controller_lambda" */
export type Lending_Controller_Lambda_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Lending_Controller_Lambda_Stddev_Samp_Fields = {
  __typename?: 'lending_controller_lambda_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "lending_controller_lambda" */
export type Lending_Controller_Lambda_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "lending_controller_lambda" */
export type Lending_Controller_Lambda_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lending_Controller_Lambda_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lending_Controller_Lambda_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lambda_bytes?: InputMaybe<Scalars['String']['input']>;
  lambda_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Lending_Controller_Lambda_Sum_Fields = {
  __typename?: 'lending_controller_lambda_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "lending_controller_lambda" */
export type Lending_Controller_Lambda_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Lending_Controller_Lambda_Var_Pop_Fields = {
  __typename?: 'lending_controller_lambda_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "lending_controller_lambda" */
export type Lending_Controller_Lambda_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Lending_Controller_Lambda_Var_Samp_Fields = {
  __typename?: 'lending_controller_lambda_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "lending_controller_lambda" */
export type Lending_Controller_Lambda_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Lending_Controller_Lambda_Variance_Fields = {
  __typename?: 'lending_controller_lambda_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "lending_controller_lambda" */
export type Lending_Controller_Lambda_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "lending_controller_loan_token" */
export type Lending_Controller_Loan_Token = {
  __typename?: 'lending_controller_loan_token';
  base_interest_rate: Scalars['float8']['output'];
  borrow_index: Scalars['float8']['output'];
  current_interest_rate: Scalars['float8']['output'];
  /** An array relationship */
  history_data: Array<Lending_Controller_History_Data>;
  /** An aggregate relationship */
  history_data_aggregate: Lending_Controller_History_Data_Aggregate;
  id: Scalars['bigint']['output'];
  interest_rate_above_optimal_utilisation: Scalars['float8']['output'];
  interest_rate_below_optimal_utilisation: Scalars['float8']['output'];
  last_updated_block_level: Scalars['bigint']['output'];
  /** An object relationship */
  lending_controller: Lending_Controller;
  lending_controller_id: Scalars['bigint']['output'];
  loan_token_name: Scalars['String']['output'];
  /** An object relationship */
  m_token: M_Token;
  m_token_id: Scalars['bigint']['output'];
  max_interest_rate: Scalars['float8']['output'];
  min_repayment_amount: Scalars['float8']['output'];
  optimal_utilisation_rate: Scalars['float8']['output'];
  /** An object relationship */
  oracle: Maven_User;
  oracle_id: Scalars['bigint']['output'];
  paused: Scalars['Boolean']['output'];
  raw_m_tokens_total_supply: Scalars['float8']['output'];
  reserve_ratio: Scalars['smallint']['output'];
  /** An object relationship */
  token: Token;
  token_id: Scalars['bigint']['output'];
  token_pool_total: Scalars['float8']['output'];
  token_reward_index: Scalars['float8']['output'];
  total_borrowed: Scalars['float8']['output'];
  total_remaining: Scalars['float8']['output'];
  utilisation_rate: Scalars['float8']['output'];
  /** An array relationship */
  vaults: Array<Lending_Controller_Vault>;
  /** An aggregate relationship */
  vaults_aggregate: Lending_Controller_Vault_Aggregate;
};


/** columns and relationships of "lending_controller_loan_token" */
export type Lending_Controller_Loan_TokenHistory_DataArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_History_Data_Order_By>>;
  where?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
};


/** columns and relationships of "lending_controller_loan_token" */
export type Lending_Controller_Loan_TokenHistory_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_History_Data_Order_By>>;
  where?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
};


/** columns and relationships of "lending_controller_loan_token" */
export type Lending_Controller_Loan_TokenVaultsArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Vault_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Vault_Order_By>>;
  where?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
};


/** columns and relationships of "lending_controller_loan_token" */
export type Lending_Controller_Loan_TokenVaults_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Vault_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Vault_Order_By>>;
  where?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
};

/** aggregated selection of "lending_controller_loan_token" */
export type Lending_Controller_Loan_Token_Aggregate = {
  __typename?: 'lending_controller_loan_token_aggregate';
  aggregate?: Maybe<Lending_Controller_Loan_Token_Aggregate_Fields>;
  nodes: Array<Lending_Controller_Loan_Token>;
};

export type Lending_Controller_Loan_Token_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Var_Samp>;
};

export type Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Avg = {
  arguments: Lending_Controller_Loan_Token_Select_Column_Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Bool_And = {
  arguments: Lending_Controller_Loan_Token_Select_Column_Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Lending_Controller_Loan_Token_Select_Column_Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Corr = {
  arguments: Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Lending_Controller_Loan_Token_Select_Column_Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Lending_Controller_Loan_Token_Select_Column_Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Lending_Controller_Loan_Token_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Lending_Controller_Loan_Token_Select_Column_Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Lending_Controller_Loan_Token_Select_Column_Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Max = {
  arguments: Lending_Controller_Loan_Token_Select_Column_Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Min = {
  arguments: Lending_Controller_Loan_Token_Select_Column_Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Lending_Controller_Loan_Token_Select_Column_Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Sum = {
  arguments: Lending_Controller_Loan_Token_Select_Column_Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Lending_Controller_Loan_Token_Select_Column_Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "lending_controller_loan_token" */
export type Lending_Controller_Loan_Token_Aggregate_Fields = {
  __typename?: 'lending_controller_loan_token_aggregate_fields';
  avg?: Maybe<Lending_Controller_Loan_Token_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Lending_Controller_Loan_Token_Max_Fields>;
  min?: Maybe<Lending_Controller_Loan_Token_Min_Fields>;
  stddev?: Maybe<Lending_Controller_Loan_Token_Stddev_Fields>;
  stddev_pop?: Maybe<Lending_Controller_Loan_Token_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lending_Controller_Loan_Token_Stddev_Samp_Fields>;
  sum?: Maybe<Lending_Controller_Loan_Token_Sum_Fields>;
  var_pop?: Maybe<Lending_Controller_Loan_Token_Var_Pop_Fields>;
  var_samp?: Maybe<Lending_Controller_Loan_Token_Var_Samp_Fields>;
  variance?: Maybe<Lending_Controller_Loan_Token_Variance_Fields>;
};


/** aggregate fields of "lending_controller_loan_token" */
export type Lending_Controller_Loan_Token_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lending_Controller_Loan_Token_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "lending_controller_loan_token" */
export type Lending_Controller_Loan_Token_Aggregate_Order_By = {
  avg?: InputMaybe<Lending_Controller_Loan_Token_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lending_Controller_Loan_Token_Max_Order_By>;
  min?: InputMaybe<Lending_Controller_Loan_Token_Min_Order_By>;
  stddev?: InputMaybe<Lending_Controller_Loan_Token_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Lending_Controller_Loan_Token_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Lending_Controller_Loan_Token_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Lending_Controller_Loan_Token_Sum_Order_By>;
  var_pop?: InputMaybe<Lending_Controller_Loan_Token_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Lending_Controller_Loan_Token_Var_Samp_Order_By>;
  variance?: InputMaybe<Lending_Controller_Loan_Token_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Lending_Controller_Loan_Token_Avg_Fields = {
  __typename?: 'lending_controller_loan_token_avg_fields';
  base_interest_rate?: Maybe<Scalars['Float']['output']>;
  borrow_index?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  interest_rate_above_optimal_utilisation?: Maybe<Scalars['Float']['output']>;
  interest_rate_below_optimal_utilisation?: Maybe<Scalars['Float']['output']>;
  last_updated_block_level?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  max_interest_rate?: Maybe<Scalars['Float']['output']>;
  min_repayment_amount?: Maybe<Scalars['Float']['output']>;
  optimal_utilisation_rate?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  raw_m_tokens_total_supply?: Maybe<Scalars['Float']['output']>;
  reserve_ratio?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  token_reward_index?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  utilisation_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "lending_controller_loan_token" */
export type Lending_Controller_Loan_Token_Avg_Order_By = {
  base_interest_rate?: InputMaybe<Order_By>;
  borrow_index?: InputMaybe<Order_By>;
  current_interest_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interest_rate_above_optimal_utilisation?: InputMaybe<Order_By>;
  interest_rate_below_optimal_utilisation?: InputMaybe<Order_By>;
  last_updated_block_level?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  max_interest_rate?: InputMaybe<Order_By>;
  min_repayment_amount?: InputMaybe<Order_By>;
  optimal_utilisation_rate?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  raw_m_tokens_total_supply?: InputMaybe<Order_By>;
  reserve_ratio?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_pool_total?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  total_borrowed?: InputMaybe<Order_By>;
  total_remaining?: InputMaybe<Order_By>;
  utilisation_rate?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "lending_controller_loan_token". All fields are combined with a logical 'AND'. */
export type Lending_Controller_Loan_Token_Bool_Exp = {
  _and?: InputMaybe<Array<Lending_Controller_Loan_Token_Bool_Exp>>;
  _not?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
  _or?: InputMaybe<Array<Lending_Controller_Loan_Token_Bool_Exp>>;
  base_interest_rate?: InputMaybe<Float8_Comparison_Exp>;
  borrow_index?: InputMaybe<Float8_Comparison_Exp>;
  current_interest_rate?: InputMaybe<Float8_Comparison_Exp>;
  history_data?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
  history_data_aggregate?: InputMaybe<Lending_Controller_History_Data_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  interest_rate_above_optimal_utilisation?: InputMaybe<Float8_Comparison_Exp>;
  interest_rate_below_optimal_utilisation?: InputMaybe<Float8_Comparison_Exp>;
  last_updated_block_level?: InputMaybe<Bigint_Comparison_Exp>;
  lending_controller?: InputMaybe<Lending_Controller_Bool_Exp>;
  lending_controller_id?: InputMaybe<Bigint_Comparison_Exp>;
  loan_token_name?: InputMaybe<String_Comparison_Exp>;
  m_token?: InputMaybe<M_Token_Bool_Exp>;
  m_token_id?: InputMaybe<Bigint_Comparison_Exp>;
  max_interest_rate?: InputMaybe<Float8_Comparison_Exp>;
  min_repayment_amount?: InputMaybe<Float8_Comparison_Exp>;
  optimal_utilisation_rate?: InputMaybe<Float8_Comparison_Exp>;
  oracle?: InputMaybe<Maven_User_Bool_Exp>;
  oracle_id?: InputMaybe<Bigint_Comparison_Exp>;
  paused?: InputMaybe<Boolean_Comparison_Exp>;
  raw_m_tokens_total_supply?: InputMaybe<Float8_Comparison_Exp>;
  reserve_ratio?: InputMaybe<Smallint_Comparison_Exp>;
  token?: InputMaybe<Token_Bool_Exp>;
  token_id?: InputMaybe<Bigint_Comparison_Exp>;
  token_pool_total?: InputMaybe<Float8_Comparison_Exp>;
  token_reward_index?: InputMaybe<Float8_Comparison_Exp>;
  total_borrowed?: InputMaybe<Float8_Comparison_Exp>;
  total_remaining?: InputMaybe<Float8_Comparison_Exp>;
  utilisation_rate?: InputMaybe<Float8_Comparison_Exp>;
  vaults?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
  vaults_aggregate?: InputMaybe<Lending_Controller_Vault_Aggregate_Bool_Exp>;
};

/** aggregate max on columns */
export type Lending_Controller_Loan_Token_Max_Fields = {
  __typename?: 'lending_controller_loan_token_max_fields';
  base_interest_rate?: Maybe<Scalars['float8']['output']>;
  borrow_index?: Maybe<Scalars['float8']['output']>;
  current_interest_rate?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  interest_rate_above_optimal_utilisation?: Maybe<Scalars['float8']['output']>;
  interest_rate_below_optimal_utilisation?: Maybe<Scalars['float8']['output']>;
  last_updated_block_level?: Maybe<Scalars['bigint']['output']>;
  lending_controller_id?: Maybe<Scalars['bigint']['output']>;
  loan_token_name?: Maybe<Scalars['String']['output']>;
  m_token_id?: Maybe<Scalars['bigint']['output']>;
  max_interest_rate?: Maybe<Scalars['float8']['output']>;
  min_repayment_amount?: Maybe<Scalars['float8']['output']>;
  optimal_utilisation_rate?: Maybe<Scalars['float8']['output']>;
  oracle_id?: Maybe<Scalars['bigint']['output']>;
  raw_m_tokens_total_supply?: Maybe<Scalars['float8']['output']>;
  reserve_ratio?: Maybe<Scalars['smallint']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  token_pool_total?: Maybe<Scalars['float8']['output']>;
  token_reward_index?: Maybe<Scalars['float8']['output']>;
  total_borrowed?: Maybe<Scalars['float8']['output']>;
  total_remaining?: Maybe<Scalars['float8']['output']>;
  utilisation_rate?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "lending_controller_loan_token" */
export type Lending_Controller_Loan_Token_Max_Order_By = {
  base_interest_rate?: InputMaybe<Order_By>;
  borrow_index?: InputMaybe<Order_By>;
  current_interest_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interest_rate_above_optimal_utilisation?: InputMaybe<Order_By>;
  interest_rate_below_optimal_utilisation?: InputMaybe<Order_By>;
  last_updated_block_level?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  loan_token_name?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  max_interest_rate?: InputMaybe<Order_By>;
  min_repayment_amount?: InputMaybe<Order_By>;
  optimal_utilisation_rate?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  raw_m_tokens_total_supply?: InputMaybe<Order_By>;
  reserve_ratio?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_pool_total?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  total_borrowed?: InputMaybe<Order_By>;
  total_remaining?: InputMaybe<Order_By>;
  utilisation_rate?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Lending_Controller_Loan_Token_Min_Fields = {
  __typename?: 'lending_controller_loan_token_min_fields';
  base_interest_rate?: Maybe<Scalars['float8']['output']>;
  borrow_index?: Maybe<Scalars['float8']['output']>;
  current_interest_rate?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  interest_rate_above_optimal_utilisation?: Maybe<Scalars['float8']['output']>;
  interest_rate_below_optimal_utilisation?: Maybe<Scalars['float8']['output']>;
  last_updated_block_level?: Maybe<Scalars['bigint']['output']>;
  lending_controller_id?: Maybe<Scalars['bigint']['output']>;
  loan_token_name?: Maybe<Scalars['String']['output']>;
  m_token_id?: Maybe<Scalars['bigint']['output']>;
  max_interest_rate?: Maybe<Scalars['float8']['output']>;
  min_repayment_amount?: Maybe<Scalars['float8']['output']>;
  optimal_utilisation_rate?: Maybe<Scalars['float8']['output']>;
  oracle_id?: Maybe<Scalars['bigint']['output']>;
  raw_m_tokens_total_supply?: Maybe<Scalars['float8']['output']>;
  reserve_ratio?: Maybe<Scalars['smallint']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  token_pool_total?: Maybe<Scalars['float8']['output']>;
  token_reward_index?: Maybe<Scalars['float8']['output']>;
  total_borrowed?: Maybe<Scalars['float8']['output']>;
  total_remaining?: Maybe<Scalars['float8']['output']>;
  utilisation_rate?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "lending_controller_loan_token" */
export type Lending_Controller_Loan_Token_Min_Order_By = {
  base_interest_rate?: InputMaybe<Order_By>;
  borrow_index?: InputMaybe<Order_By>;
  current_interest_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interest_rate_above_optimal_utilisation?: InputMaybe<Order_By>;
  interest_rate_below_optimal_utilisation?: InputMaybe<Order_By>;
  last_updated_block_level?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  loan_token_name?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  max_interest_rate?: InputMaybe<Order_By>;
  min_repayment_amount?: InputMaybe<Order_By>;
  optimal_utilisation_rate?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  raw_m_tokens_total_supply?: InputMaybe<Order_By>;
  reserve_ratio?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_pool_total?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  total_borrowed?: InputMaybe<Order_By>;
  total_remaining?: InputMaybe<Order_By>;
  utilisation_rate?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "lending_controller_loan_token". */
export type Lending_Controller_Loan_Token_Order_By = {
  base_interest_rate?: InputMaybe<Order_By>;
  borrow_index?: InputMaybe<Order_By>;
  current_interest_rate?: InputMaybe<Order_By>;
  history_data_aggregate?: InputMaybe<Lending_Controller_History_Data_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  interest_rate_above_optimal_utilisation?: InputMaybe<Order_By>;
  interest_rate_below_optimal_utilisation?: InputMaybe<Order_By>;
  last_updated_block_level?: InputMaybe<Order_By>;
  lending_controller?: InputMaybe<Lending_Controller_Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  loan_token_name?: InputMaybe<Order_By>;
  m_token?: InputMaybe<M_Token_Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  max_interest_rate?: InputMaybe<Order_By>;
  min_repayment_amount?: InputMaybe<Order_By>;
  optimal_utilisation_rate?: InputMaybe<Order_By>;
  oracle?: InputMaybe<Maven_User_Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  paused?: InputMaybe<Order_By>;
  raw_m_tokens_total_supply?: InputMaybe<Order_By>;
  reserve_ratio?: InputMaybe<Order_By>;
  token?: InputMaybe<Token_Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_pool_total?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  total_borrowed?: InputMaybe<Order_By>;
  total_remaining?: InputMaybe<Order_By>;
  utilisation_rate?: InputMaybe<Order_By>;
  vaults_aggregate?: InputMaybe<Lending_Controller_Vault_Aggregate_Order_By>;
};

/** select columns of table "lending_controller_loan_token" */
export enum Lending_Controller_Loan_Token_Select_Column {
  /** column name */
  BaseInterestRate = 'base_interest_rate',
  /** column name */
  BorrowIndex = 'borrow_index',
  /** column name */
  CurrentInterestRate = 'current_interest_rate',
  /** column name */
  Id = 'id',
  /** column name */
  InterestRateAboveOptimalUtilisation = 'interest_rate_above_optimal_utilisation',
  /** column name */
  InterestRateBelowOptimalUtilisation = 'interest_rate_below_optimal_utilisation',
  /** column name */
  LastUpdatedBlockLevel = 'last_updated_block_level',
  /** column name */
  LendingControllerId = 'lending_controller_id',
  /** column name */
  LoanTokenName = 'loan_token_name',
  /** column name */
  MTokenId = 'm_token_id',
  /** column name */
  MaxInterestRate = 'max_interest_rate',
  /** column name */
  MinRepaymentAmount = 'min_repayment_amount',
  /** column name */
  OptimalUtilisationRate = 'optimal_utilisation_rate',
  /** column name */
  OracleId = 'oracle_id',
  /** column name */
  Paused = 'paused',
  /** column name */
  RawMTokensTotalSupply = 'raw_m_tokens_total_supply',
  /** column name */
  ReserveRatio = 'reserve_ratio',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  TokenPoolTotal = 'token_pool_total',
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  TotalBorrowed = 'total_borrowed',
  /** column name */
  TotalRemaining = 'total_remaining',
  /** column name */
  UtilisationRate = 'utilisation_rate'
}

/** select "lending_controller_loan_token_aggregate_bool_exp_avg_arguments_columns" columns of table "lending_controller_loan_token" */
export enum Lending_Controller_Loan_Token_Select_Column_Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  BaseInterestRate = 'base_interest_rate',
  /** column name */
  BorrowIndex = 'borrow_index',
  /** column name */
  CurrentInterestRate = 'current_interest_rate',
  /** column name */
  InterestRateAboveOptimalUtilisation = 'interest_rate_above_optimal_utilisation',
  /** column name */
  InterestRateBelowOptimalUtilisation = 'interest_rate_below_optimal_utilisation',
  /** column name */
  MaxInterestRate = 'max_interest_rate',
  /** column name */
  MinRepaymentAmount = 'min_repayment_amount',
  /** column name */
  OptimalUtilisationRate = 'optimal_utilisation_rate',
  /** column name */
  RawMTokensTotalSupply = 'raw_m_tokens_total_supply',
  /** column name */
  TokenPoolTotal = 'token_pool_total',
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  TotalBorrowed = 'total_borrowed',
  /** column name */
  TotalRemaining = 'total_remaining',
  /** column name */
  UtilisationRate = 'utilisation_rate'
}

/** select "lending_controller_loan_token_aggregate_bool_exp_bool_and_arguments_columns" columns of table "lending_controller_loan_token" */
export enum Lending_Controller_Loan_Token_Select_Column_Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Paused = 'paused'
}

/** select "lending_controller_loan_token_aggregate_bool_exp_bool_or_arguments_columns" columns of table "lending_controller_loan_token" */
export enum Lending_Controller_Loan_Token_Select_Column_Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Paused = 'paused'
}

/** select "lending_controller_loan_token_aggregate_bool_exp_corr_arguments_columns" columns of table "lending_controller_loan_token" */
export enum Lending_Controller_Loan_Token_Select_Column_Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  BaseInterestRate = 'base_interest_rate',
  /** column name */
  BorrowIndex = 'borrow_index',
  /** column name */
  CurrentInterestRate = 'current_interest_rate',
  /** column name */
  InterestRateAboveOptimalUtilisation = 'interest_rate_above_optimal_utilisation',
  /** column name */
  InterestRateBelowOptimalUtilisation = 'interest_rate_below_optimal_utilisation',
  /** column name */
  MaxInterestRate = 'max_interest_rate',
  /** column name */
  MinRepaymentAmount = 'min_repayment_amount',
  /** column name */
  OptimalUtilisationRate = 'optimal_utilisation_rate',
  /** column name */
  RawMTokensTotalSupply = 'raw_m_tokens_total_supply',
  /** column name */
  TokenPoolTotal = 'token_pool_total',
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  TotalBorrowed = 'total_borrowed',
  /** column name */
  TotalRemaining = 'total_remaining',
  /** column name */
  UtilisationRate = 'utilisation_rate'
}

/** select "lending_controller_loan_token_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "lending_controller_loan_token" */
export enum Lending_Controller_Loan_Token_Select_Column_Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  BaseInterestRate = 'base_interest_rate',
  /** column name */
  BorrowIndex = 'borrow_index',
  /** column name */
  CurrentInterestRate = 'current_interest_rate',
  /** column name */
  InterestRateAboveOptimalUtilisation = 'interest_rate_above_optimal_utilisation',
  /** column name */
  InterestRateBelowOptimalUtilisation = 'interest_rate_below_optimal_utilisation',
  /** column name */
  MaxInterestRate = 'max_interest_rate',
  /** column name */
  MinRepaymentAmount = 'min_repayment_amount',
  /** column name */
  OptimalUtilisationRate = 'optimal_utilisation_rate',
  /** column name */
  RawMTokensTotalSupply = 'raw_m_tokens_total_supply',
  /** column name */
  TokenPoolTotal = 'token_pool_total',
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  TotalBorrowed = 'total_borrowed',
  /** column name */
  TotalRemaining = 'total_remaining',
  /** column name */
  UtilisationRate = 'utilisation_rate'
}

/** select "lending_controller_loan_token_aggregate_bool_exp_max_arguments_columns" columns of table "lending_controller_loan_token" */
export enum Lending_Controller_Loan_Token_Select_Column_Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  BaseInterestRate = 'base_interest_rate',
  /** column name */
  BorrowIndex = 'borrow_index',
  /** column name */
  CurrentInterestRate = 'current_interest_rate',
  /** column name */
  InterestRateAboveOptimalUtilisation = 'interest_rate_above_optimal_utilisation',
  /** column name */
  InterestRateBelowOptimalUtilisation = 'interest_rate_below_optimal_utilisation',
  /** column name */
  MaxInterestRate = 'max_interest_rate',
  /** column name */
  MinRepaymentAmount = 'min_repayment_amount',
  /** column name */
  OptimalUtilisationRate = 'optimal_utilisation_rate',
  /** column name */
  RawMTokensTotalSupply = 'raw_m_tokens_total_supply',
  /** column name */
  TokenPoolTotal = 'token_pool_total',
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  TotalBorrowed = 'total_borrowed',
  /** column name */
  TotalRemaining = 'total_remaining',
  /** column name */
  UtilisationRate = 'utilisation_rate'
}

/** select "lending_controller_loan_token_aggregate_bool_exp_min_arguments_columns" columns of table "lending_controller_loan_token" */
export enum Lending_Controller_Loan_Token_Select_Column_Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  BaseInterestRate = 'base_interest_rate',
  /** column name */
  BorrowIndex = 'borrow_index',
  /** column name */
  CurrentInterestRate = 'current_interest_rate',
  /** column name */
  InterestRateAboveOptimalUtilisation = 'interest_rate_above_optimal_utilisation',
  /** column name */
  InterestRateBelowOptimalUtilisation = 'interest_rate_below_optimal_utilisation',
  /** column name */
  MaxInterestRate = 'max_interest_rate',
  /** column name */
  MinRepaymentAmount = 'min_repayment_amount',
  /** column name */
  OptimalUtilisationRate = 'optimal_utilisation_rate',
  /** column name */
  RawMTokensTotalSupply = 'raw_m_tokens_total_supply',
  /** column name */
  TokenPoolTotal = 'token_pool_total',
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  TotalBorrowed = 'total_borrowed',
  /** column name */
  TotalRemaining = 'total_remaining',
  /** column name */
  UtilisationRate = 'utilisation_rate'
}

/** select "lending_controller_loan_token_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "lending_controller_loan_token" */
export enum Lending_Controller_Loan_Token_Select_Column_Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  BaseInterestRate = 'base_interest_rate',
  /** column name */
  BorrowIndex = 'borrow_index',
  /** column name */
  CurrentInterestRate = 'current_interest_rate',
  /** column name */
  InterestRateAboveOptimalUtilisation = 'interest_rate_above_optimal_utilisation',
  /** column name */
  InterestRateBelowOptimalUtilisation = 'interest_rate_below_optimal_utilisation',
  /** column name */
  MaxInterestRate = 'max_interest_rate',
  /** column name */
  MinRepaymentAmount = 'min_repayment_amount',
  /** column name */
  OptimalUtilisationRate = 'optimal_utilisation_rate',
  /** column name */
  RawMTokensTotalSupply = 'raw_m_tokens_total_supply',
  /** column name */
  TokenPoolTotal = 'token_pool_total',
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  TotalBorrowed = 'total_borrowed',
  /** column name */
  TotalRemaining = 'total_remaining',
  /** column name */
  UtilisationRate = 'utilisation_rate'
}

/** select "lending_controller_loan_token_aggregate_bool_exp_sum_arguments_columns" columns of table "lending_controller_loan_token" */
export enum Lending_Controller_Loan_Token_Select_Column_Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  BaseInterestRate = 'base_interest_rate',
  /** column name */
  BorrowIndex = 'borrow_index',
  /** column name */
  CurrentInterestRate = 'current_interest_rate',
  /** column name */
  InterestRateAboveOptimalUtilisation = 'interest_rate_above_optimal_utilisation',
  /** column name */
  InterestRateBelowOptimalUtilisation = 'interest_rate_below_optimal_utilisation',
  /** column name */
  MaxInterestRate = 'max_interest_rate',
  /** column name */
  MinRepaymentAmount = 'min_repayment_amount',
  /** column name */
  OptimalUtilisationRate = 'optimal_utilisation_rate',
  /** column name */
  RawMTokensTotalSupply = 'raw_m_tokens_total_supply',
  /** column name */
  TokenPoolTotal = 'token_pool_total',
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  TotalBorrowed = 'total_borrowed',
  /** column name */
  TotalRemaining = 'total_remaining',
  /** column name */
  UtilisationRate = 'utilisation_rate'
}

/** select "lending_controller_loan_token_aggregate_bool_exp_var_samp_arguments_columns" columns of table "lending_controller_loan_token" */
export enum Lending_Controller_Loan_Token_Select_Column_Lending_Controller_Loan_Token_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  BaseInterestRate = 'base_interest_rate',
  /** column name */
  BorrowIndex = 'borrow_index',
  /** column name */
  CurrentInterestRate = 'current_interest_rate',
  /** column name */
  InterestRateAboveOptimalUtilisation = 'interest_rate_above_optimal_utilisation',
  /** column name */
  InterestRateBelowOptimalUtilisation = 'interest_rate_below_optimal_utilisation',
  /** column name */
  MaxInterestRate = 'max_interest_rate',
  /** column name */
  MinRepaymentAmount = 'min_repayment_amount',
  /** column name */
  OptimalUtilisationRate = 'optimal_utilisation_rate',
  /** column name */
  RawMTokensTotalSupply = 'raw_m_tokens_total_supply',
  /** column name */
  TokenPoolTotal = 'token_pool_total',
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  TotalBorrowed = 'total_borrowed',
  /** column name */
  TotalRemaining = 'total_remaining',
  /** column name */
  UtilisationRate = 'utilisation_rate'
}

/** aggregate stddev on columns */
export type Lending_Controller_Loan_Token_Stddev_Fields = {
  __typename?: 'lending_controller_loan_token_stddev_fields';
  base_interest_rate?: Maybe<Scalars['Float']['output']>;
  borrow_index?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  interest_rate_above_optimal_utilisation?: Maybe<Scalars['Float']['output']>;
  interest_rate_below_optimal_utilisation?: Maybe<Scalars['Float']['output']>;
  last_updated_block_level?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  max_interest_rate?: Maybe<Scalars['Float']['output']>;
  min_repayment_amount?: Maybe<Scalars['Float']['output']>;
  optimal_utilisation_rate?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  raw_m_tokens_total_supply?: Maybe<Scalars['Float']['output']>;
  reserve_ratio?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  token_reward_index?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  utilisation_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "lending_controller_loan_token" */
export type Lending_Controller_Loan_Token_Stddev_Order_By = {
  base_interest_rate?: InputMaybe<Order_By>;
  borrow_index?: InputMaybe<Order_By>;
  current_interest_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interest_rate_above_optimal_utilisation?: InputMaybe<Order_By>;
  interest_rate_below_optimal_utilisation?: InputMaybe<Order_By>;
  last_updated_block_level?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  max_interest_rate?: InputMaybe<Order_By>;
  min_repayment_amount?: InputMaybe<Order_By>;
  optimal_utilisation_rate?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  raw_m_tokens_total_supply?: InputMaybe<Order_By>;
  reserve_ratio?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_pool_total?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  total_borrowed?: InputMaybe<Order_By>;
  total_remaining?: InputMaybe<Order_By>;
  utilisation_rate?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Lending_Controller_Loan_Token_Stddev_Pop_Fields = {
  __typename?: 'lending_controller_loan_token_stddev_pop_fields';
  base_interest_rate?: Maybe<Scalars['Float']['output']>;
  borrow_index?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  interest_rate_above_optimal_utilisation?: Maybe<Scalars['Float']['output']>;
  interest_rate_below_optimal_utilisation?: Maybe<Scalars['Float']['output']>;
  last_updated_block_level?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  max_interest_rate?: Maybe<Scalars['Float']['output']>;
  min_repayment_amount?: Maybe<Scalars['Float']['output']>;
  optimal_utilisation_rate?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  raw_m_tokens_total_supply?: Maybe<Scalars['Float']['output']>;
  reserve_ratio?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  token_reward_index?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  utilisation_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "lending_controller_loan_token" */
export type Lending_Controller_Loan_Token_Stddev_Pop_Order_By = {
  base_interest_rate?: InputMaybe<Order_By>;
  borrow_index?: InputMaybe<Order_By>;
  current_interest_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interest_rate_above_optimal_utilisation?: InputMaybe<Order_By>;
  interest_rate_below_optimal_utilisation?: InputMaybe<Order_By>;
  last_updated_block_level?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  max_interest_rate?: InputMaybe<Order_By>;
  min_repayment_amount?: InputMaybe<Order_By>;
  optimal_utilisation_rate?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  raw_m_tokens_total_supply?: InputMaybe<Order_By>;
  reserve_ratio?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_pool_total?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  total_borrowed?: InputMaybe<Order_By>;
  total_remaining?: InputMaybe<Order_By>;
  utilisation_rate?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Lending_Controller_Loan_Token_Stddev_Samp_Fields = {
  __typename?: 'lending_controller_loan_token_stddev_samp_fields';
  base_interest_rate?: Maybe<Scalars['Float']['output']>;
  borrow_index?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  interest_rate_above_optimal_utilisation?: Maybe<Scalars['Float']['output']>;
  interest_rate_below_optimal_utilisation?: Maybe<Scalars['Float']['output']>;
  last_updated_block_level?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  max_interest_rate?: Maybe<Scalars['Float']['output']>;
  min_repayment_amount?: Maybe<Scalars['Float']['output']>;
  optimal_utilisation_rate?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  raw_m_tokens_total_supply?: Maybe<Scalars['Float']['output']>;
  reserve_ratio?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  token_reward_index?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  utilisation_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "lending_controller_loan_token" */
export type Lending_Controller_Loan_Token_Stddev_Samp_Order_By = {
  base_interest_rate?: InputMaybe<Order_By>;
  borrow_index?: InputMaybe<Order_By>;
  current_interest_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interest_rate_above_optimal_utilisation?: InputMaybe<Order_By>;
  interest_rate_below_optimal_utilisation?: InputMaybe<Order_By>;
  last_updated_block_level?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  max_interest_rate?: InputMaybe<Order_By>;
  min_repayment_amount?: InputMaybe<Order_By>;
  optimal_utilisation_rate?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  raw_m_tokens_total_supply?: InputMaybe<Order_By>;
  reserve_ratio?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_pool_total?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  total_borrowed?: InputMaybe<Order_By>;
  total_remaining?: InputMaybe<Order_By>;
  utilisation_rate?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "lending_controller_loan_token" */
export type Lending_Controller_Loan_Token_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lending_Controller_Loan_Token_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lending_Controller_Loan_Token_Stream_Cursor_Value_Input = {
  base_interest_rate?: InputMaybe<Scalars['float8']['input']>;
  borrow_index?: InputMaybe<Scalars['float8']['input']>;
  current_interest_rate?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  interest_rate_above_optimal_utilisation?: InputMaybe<Scalars['float8']['input']>;
  interest_rate_below_optimal_utilisation?: InputMaybe<Scalars['float8']['input']>;
  last_updated_block_level?: InputMaybe<Scalars['bigint']['input']>;
  lending_controller_id?: InputMaybe<Scalars['bigint']['input']>;
  loan_token_name?: InputMaybe<Scalars['String']['input']>;
  m_token_id?: InputMaybe<Scalars['bigint']['input']>;
  max_interest_rate?: InputMaybe<Scalars['float8']['input']>;
  min_repayment_amount?: InputMaybe<Scalars['float8']['input']>;
  optimal_utilisation_rate?: InputMaybe<Scalars['float8']['input']>;
  oracle_id?: InputMaybe<Scalars['bigint']['input']>;
  paused?: InputMaybe<Scalars['Boolean']['input']>;
  raw_m_tokens_total_supply?: InputMaybe<Scalars['float8']['input']>;
  reserve_ratio?: InputMaybe<Scalars['smallint']['input']>;
  token_id?: InputMaybe<Scalars['bigint']['input']>;
  token_pool_total?: InputMaybe<Scalars['float8']['input']>;
  token_reward_index?: InputMaybe<Scalars['float8']['input']>;
  total_borrowed?: InputMaybe<Scalars['float8']['input']>;
  total_remaining?: InputMaybe<Scalars['float8']['input']>;
  utilisation_rate?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type Lending_Controller_Loan_Token_Sum_Fields = {
  __typename?: 'lending_controller_loan_token_sum_fields';
  base_interest_rate?: Maybe<Scalars['float8']['output']>;
  borrow_index?: Maybe<Scalars['float8']['output']>;
  current_interest_rate?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  interest_rate_above_optimal_utilisation?: Maybe<Scalars['float8']['output']>;
  interest_rate_below_optimal_utilisation?: Maybe<Scalars['float8']['output']>;
  last_updated_block_level?: Maybe<Scalars['bigint']['output']>;
  lending_controller_id?: Maybe<Scalars['bigint']['output']>;
  m_token_id?: Maybe<Scalars['bigint']['output']>;
  max_interest_rate?: Maybe<Scalars['float8']['output']>;
  min_repayment_amount?: Maybe<Scalars['float8']['output']>;
  optimal_utilisation_rate?: Maybe<Scalars['float8']['output']>;
  oracle_id?: Maybe<Scalars['bigint']['output']>;
  raw_m_tokens_total_supply?: Maybe<Scalars['float8']['output']>;
  reserve_ratio?: Maybe<Scalars['smallint']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  token_pool_total?: Maybe<Scalars['float8']['output']>;
  token_reward_index?: Maybe<Scalars['float8']['output']>;
  total_borrowed?: Maybe<Scalars['float8']['output']>;
  total_remaining?: Maybe<Scalars['float8']['output']>;
  utilisation_rate?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "lending_controller_loan_token" */
export type Lending_Controller_Loan_Token_Sum_Order_By = {
  base_interest_rate?: InputMaybe<Order_By>;
  borrow_index?: InputMaybe<Order_By>;
  current_interest_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interest_rate_above_optimal_utilisation?: InputMaybe<Order_By>;
  interest_rate_below_optimal_utilisation?: InputMaybe<Order_By>;
  last_updated_block_level?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  max_interest_rate?: InputMaybe<Order_By>;
  min_repayment_amount?: InputMaybe<Order_By>;
  optimal_utilisation_rate?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  raw_m_tokens_total_supply?: InputMaybe<Order_By>;
  reserve_ratio?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_pool_total?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  total_borrowed?: InputMaybe<Order_By>;
  total_remaining?: InputMaybe<Order_By>;
  utilisation_rate?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Lending_Controller_Loan_Token_Var_Pop_Fields = {
  __typename?: 'lending_controller_loan_token_var_pop_fields';
  base_interest_rate?: Maybe<Scalars['Float']['output']>;
  borrow_index?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  interest_rate_above_optimal_utilisation?: Maybe<Scalars['Float']['output']>;
  interest_rate_below_optimal_utilisation?: Maybe<Scalars['Float']['output']>;
  last_updated_block_level?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  max_interest_rate?: Maybe<Scalars['Float']['output']>;
  min_repayment_amount?: Maybe<Scalars['Float']['output']>;
  optimal_utilisation_rate?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  raw_m_tokens_total_supply?: Maybe<Scalars['Float']['output']>;
  reserve_ratio?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  token_reward_index?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  utilisation_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "lending_controller_loan_token" */
export type Lending_Controller_Loan_Token_Var_Pop_Order_By = {
  base_interest_rate?: InputMaybe<Order_By>;
  borrow_index?: InputMaybe<Order_By>;
  current_interest_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interest_rate_above_optimal_utilisation?: InputMaybe<Order_By>;
  interest_rate_below_optimal_utilisation?: InputMaybe<Order_By>;
  last_updated_block_level?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  max_interest_rate?: InputMaybe<Order_By>;
  min_repayment_amount?: InputMaybe<Order_By>;
  optimal_utilisation_rate?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  raw_m_tokens_total_supply?: InputMaybe<Order_By>;
  reserve_ratio?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_pool_total?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  total_borrowed?: InputMaybe<Order_By>;
  total_remaining?: InputMaybe<Order_By>;
  utilisation_rate?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Lending_Controller_Loan_Token_Var_Samp_Fields = {
  __typename?: 'lending_controller_loan_token_var_samp_fields';
  base_interest_rate?: Maybe<Scalars['Float']['output']>;
  borrow_index?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  interest_rate_above_optimal_utilisation?: Maybe<Scalars['Float']['output']>;
  interest_rate_below_optimal_utilisation?: Maybe<Scalars['Float']['output']>;
  last_updated_block_level?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  max_interest_rate?: Maybe<Scalars['Float']['output']>;
  min_repayment_amount?: Maybe<Scalars['Float']['output']>;
  optimal_utilisation_rate?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  raw_m_tokens_total_supply?: Maybe<Scalars['Float']['output']>;
  reserve_ratio?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  token_reward_index?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  utilisation_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "lending_controller_loan_token" */
export type Lending_Controller_Loan_Token_Var_Samp_Order_By = {
  base_interest_rate?: InputMaybe<Order_By>;
  borrow_index?: InputMaybe<Order_By>;
  current_interest_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interest_rate_above_optimal_utilisation?: InputMaybe<Order_By>;
  interest_rate_below_optimal_utilisation?: InputMaybe<Order_By>;
  last_updated_block_level?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  max_interest_rate?: InputMaybe<Order_By>;
  min_repayment_amount?: InputMaybe<Order_By>;
  optimal_utilisation_rate?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  raw_m_tokens_total_supply?: InputMaybe<Order_By>;
  reserve_ratio?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_pool_total?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  total_borrowed?: InputMaybe<Order_By>;
  total_remaining?: InputMaybe<Order_By>;
  utilisation_rate?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Lending_Controller_Loan_Token_Variance_Fields = {
  __typename?: 'lending_controller_loan_token_variance_fields';
  base_interest_rate?: Maybe<Scalars['Float']['output']>;
  borrow_index?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  interest_rate_above_optimal_utilisation?: Maybe<Scalars['Float']['output']>;
  interest_rate_below_optimal_utilisation?: Maybe<Scalars['Float']['output']>;
  last_updated_block_level?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  max_interest_rate?: Maybe<Scalars['Float']['output']>;
  min_repayment_amount?: Maybe<Scalars['Float']['output']>;
  optimal_utilisation_rate?: Maybe<Scalars['Float']['output']>;
  oracle_id?: Maybe<Scalars['Float']['output']>;
  raw_m_tokens_total_supply?: Maybe<Scalars['Float']['output']>;
  reserve_ratio?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  token_reward_index?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  utilisation_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "lending_controller_loan_token" */
export type Lending_Controller_Loan_Token_Variance_Order_By = {
  base_interest_rate?: InputMaybe<Order_By>;
  borrow_index?: InputMaybe<Order_By>;
  current_interest_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interest_rate_above_optimal_utilisation?: InputMaybe<Order_By>;
  interest_rate_below_optimal_utilisation?: InputMaybe<Order_By>;
  last_updated_block_level?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  max_interest_rate?: InputMaybe<Order_By>;
  min_repayment_amount?: InputMaybe<Order_By>;
  optimal_utilisation_rate?: InputMaybe<Order_By>;
  oracle_id?: InputMaybe<Order_By>;
  raw_m_tokens_total_supply?: InputMaybe<Order_By>;
  reserve_ratio?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_pool_total?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  total_borrowed?: InputMaybe<Order_By>;
  total_remaining?: InputMaybe<Order_By>;
  utilisation_rate?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Lending_Controller_Max_Fields = {
  __typename?: 'lending_controller_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  admin_liquidation_fee_pct?: Maybe<Scalars['smallint']['output']>;
  collateral_ratio?: Maybe<Scalars['smallint']['output']>;
  decimals?: Maybe<Scalars['smallint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  interest_rate_decimals?: Maybe<Scalars['smallint']['output']>;
  interest_treasury_share?: Maybe<Scalars['smallint']['output']>;
  last_completed_data_max_delay?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  liquidation_delay_in_minutes?: Maybe<Scalars['bigint']['output']>;
  liquidation_fee_pct?: Maybe<Scalars['smallint']['output']>;
  liquidation_max_duration?: Maybe<Scalars['bigint']['output']>;
  liquidation_ratio?: Maybe<Scalars['smallint']['output']>;
  max_decimals_for_calculation?: Maybe<Scalars['smallint']['output']>;
  max_vault_liquidation_pct?: Maybe<Scalars['smallint']['output']>;
  minimum_loan_fee_pct?: Maybe<Scalars['smallint']['output']>;
  minimum_loan_treasury_share?: Maybe<Scalars['smallint']['output']>;
  network?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "lending_controller" */
export type Lending_Controller_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  admin_liquidation_fee_pct?: InputMaybe<Order_By>;
  collateral_ratio?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interest_rate_decimals?: InputMaybe<Order_By>;
  interest_treasury_share?: InputMaybe<Order_By>;
  last_completed_data_max_delay?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  liquidation_delay_in_minutes?: InputMaybe<Order_By>;
  liquidation_fee_pct?: InputMaybe<Order_By>;
  liquidation_max_duration?: InputMaybe<Order_By>;
  liquidation_ratio?: InputMaybe<Order_By>;
  max_decimals_for_calculation?: InputMaybe<Order_By>;
  max_vault_liquidation_pct?: InputMaybe<Order_By>;
  minimum_loan_fee_pct?: InputMaybe<Order_By>;
  minimum_loan_treasury_share?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Lending_Controller_Min_Fields = {
  __typename?: 'lending_controller_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  admin_liquidation_fee_pct?: Maybe<Scalars['smallint']['output']>;
  collateral_ratio?: Maybe<Scalars['smallint']['output']>;
  decimals?: Maybe<Scalars['smallint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  interest_rate_decimals?: Maybe<Scalars['smallint']['output']>;
  interest_treasury_share?: Maybe<Scalars['smallint']['output']>;
  last_completed_data_max_delay?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  liquidation_delay_in_minutes?: Maybe<Scalars['bigint']['output']>;
  liquidation_fee_pct?: Maybe<Scalars['smallint']['output']>;
  liquidation_max_duration?: Maybe<Scalars['bigint']['output']>;
  liquidation_ratio?: Maybe<Scalars['smallint']['output']>;
  max_decimals_for_calculation?: Maybe<Scalars['smallint']['output']>;
  max_vault_liquidation_pct?: Maybe<Scalars['smallint']['output']>;
  minimum_loan_fee_pct?: Maybe<Scalars['smallint']['output']>;
  minimum_loan_treasury_share?: Maybe<Scalars['smallint']['output']>;
  network?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "lending_controller" */
export type Lending_Controller_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  admin_liquidation_fee_pct?: InputMaybe<Order_By>;
  collateral_ratio?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interest_rate_decimals?: InputMaybe<Order_By>;
  interest_treasury_share?: InputMaybe<Order_By>;
  last_completed_data_max_delay?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  liquidation_delay_in_minutes?: InputMaybe<Order_By>;
  liquidation_fee_pct?: InputMaybe<Order_By>;
  liquidation_max_duration?: InputMaybe<Order_By>;
  liquidation_ratio?: InputMaybe<Order_By>;
  max_decimals_for_calculation?: InputMaybe<Order_By>;
  max_vault_liquidation_pct?: InputMaybe<Order_By>;
  minimum_loan_fee_pct?: InputMaybe<Order_By>;
  minimum_loan_treasury_share?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "lending_controller". */
export type Lending_Controller_Order_By = {
  add_liquidity_paused?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  admin_liquidation_fee_pct?: InputMaybe<Order_By>;
  borrow_paused?: InputMaybe<Order_By>;
  close_vault_paused?: InputMaybe<Order_By>;
  collateral_ratio?: InputMaybe<Order_By>;
  collateral_tokens_aggregate?: InputMaybe<Lending_Controller_Collateral_Token_Aggregate_Order_By>;
  decimals?: InputMaybe<Order_By>;
  governance?: InputMaybe<Governance_Order_By>;
  governance_id?: InputMaybe<Order_By>;
  history_data_aggregate?: InputMaybe<Lending_Controller_History_Data_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  interest_rate_decimals?: InputMaybe<Order_By>;
  interest_treasury_share?: InputMaybe<Order_By>;
  lambdas_aggregate?: InputMaybe<Lending_Controller_Lambda_Aggregate_Order_By>;
  last_completed_data_max_delay?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  liquidate_vault_paused?: InputMaybe<Order_By>;
  liquidation_delay_in_minutes?: InputMaybe<Order_By>;
  liquidation_fee_pct?: InputMaybe<Order_By>;
  liquidation_max_duration?: InputMaybe<Order_By>;
  liquidation_ratio?: InputMaybe<Order_By>;
  loan_tokens_aggregate?: InputMaybe<Lending_Controller_Loan_Token_Aggregate_Order_By>;
  mark_for_liquidation_paused?: InputMaybe<Order_By>;
  max_decimals_for_calculation?: InputMaybe<Order_By>;
  max_vault_liquidation_pct?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  minimum_loan_fee_pct?: InputMaybe<Order_By>;
  minimum_loan_treasury_share?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  register_deposit_paused?: InputMaybe<Order_By>;
  register_vault_creation_paused?: InputMaybe<Order_By>;
  register_withdrawal_paused?: InputMaybe<Order_By>;
  remove_liquidity_paused?: InputMaybe<Order_By>;
  repay_paused?: InputMaybe<Order_By>;
  set_collateral_token_paused?: InputMaybe<Order_By>;
  set_loan_token_paused?: InputMaybe<Order_By>;
  vault_deposit_paused?: InputMaybe<Order_By>;
  vault_deposit_staked_token_paused?: InputMaybe<Order_By>;
  vault_on_liquidate_paused?: InputMaybe<Order_By>;
  vault_withdraw_paused?: InputMaybe<Order_By>;
  vault_withdraw_staked_token_paused?: InputMaybe<Order_By>;
  vaults_aggregate?: InputMaybe<Lending_Controller_Vault_Aggregate_Order_By>;
};

/** select columns of table "lending_controller" */
export enum Lending_Controller_Select_Column {
  /** column name */
  AddLiquidityPaused = 'add_liquidity_paused',
  /** column name */
  Address = 'address',
  /** column name */
  Admin = 'admin',
  /** column name */
  AdminLiquidationFeePct = 'admin_liquidation_fee_pct',
  /** column name */
  BorrowPaused = 'borrow_paused',
  /** column name */
  CloseVaultPaused = 'close_vault_paused',
  /** column name */
  CollateralRatio = 'collateral_ratio',
  /** column name */
  Decimals = 'decimals',
  /** column name */
  GovernanceId = 'governance_id',
  /** column name */
  Id = 'id',
  /** column name */
  InterestRateDecimals = 'interest_rate_decimals',
  /** column name */
  InterestTreasuryShare = 'interest_treasury_share',
  /** column name */
  LastCompletedDataMaxDelay = 'last_completed_data_max_delay',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  LiquidateVaultPaused = 'liquidate_vault_paused',
  /** column name */
  LiquidationDelayInMinutes = 'liquidation_delay_in_minutes',
  /** column name */
  LiquidationFeePct = 'liquidation_fee_pct',
  /** column name */
  LiquidationMaxDuration = 'liquidation_max_duration',
  /** column name */
  LiquidationRatio = 'liquidation_ratio',
  /** column name */
  MarkForLiquidationPaused = 'mark_for_liquidation_paused',
  /** column name */
  MaxDecimalsForCalculation = 'max_decimals_for_calculation',
  /** column name */
  MaxVaultLiquidationPct = 'max_vault_liquidation_pct',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MinimumLoanFeePct = 'minimum_loan_fee_pct',
  /** column name */
  MinimumLoanTreasuryShare = 'minimum_loan_treasury_share',
  /** column name */
  Network = 'network',
  /** column name */
  RegisterDepositPaused = 'register_deposit_paused',
  /** column name */
  RegisterVaultCreationPaused = 'register_vault_creation_paused',
  /** column name */
  RegisterWithdrawalPaused = 'register_withdrawal_paused',
  /** column name */
  RemoveLiquidityPaused = 'remove_liquidity_paused',
  /** column name */
  RepayPaused = 'repay_paused',
  /** column name */
  SetCollateralTokenPaused = 'set_collateral_token_paused',
  /** column name */
  SetLoanTokenPaused = 'set_loan_token_paused',
  /** column name */
  VaultDepositPaused = 'vault_deposit_paused',
  /** column name */
  VaultDepositStakedTokenPaused = 'vault_deposit_staked_token_paused',
  /** column name */
  VaultOnLiquidatePaused = 'vault_on_liquidate_paused',
  /** column name */
  VaultWithdrawPaused = 'vault_withdraw_paused',
  /** column name */
  VaultWithdrawStakedTokenPaused = 'vault_withdraw_staked_token_paused'
}

/** select "lending_controller_aggregate_bool_exp_bool_and_arguments_columns" columns of table "lending_controller" */
export enum Lending_Controller_Select_Column_Lending_Controller_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AddLiquidityPaused = 'add_liquidity_paused',
  /** column name */
  BorrowPaused = 'borrow_paused',
  /** column name */
  CloseVaultPaused = 'close_vault_paused',
  /** column name */
  LiquidateVaultPaused = 'liquidate_vault_paused',
  /** column name */
  MarkForLiquidationPaused = 'mark_for_liquidation_paused',
  /** column name */
  RegisterDepositPaused = 'register_deposit_paused',
  /** column name */
  RegisterVaultCreationPaused = 'register_vault_creation_paused',
  /** column name */
  RegisterWithdrawalPaused = 'register_withdrawal_paused',
  /** column name */
  RemoveLiquidityPaused = 'remove_liquidity_paused',
  /** column name */
  RepayPaused = 'repay_paused',
  /** column name */
  SetCollateralTokenPaused = 'set_collateral_token_paused',
  /** column name */
  SetLoanTokenPaused = 'set_loan_token_paused',
  /** column name */
  VaultDepositPaused = 'vault_deposit_paused',
  /** column name */
  VaultDepositStakedTokenPaused = 'vault_deposit_staked_token_paused',
  /** column name */
  VaultOnLiquidatePaused = 'vault_on_liquidate_paused',
  /** column name */
  VaultWithdrawPaused = 'vault_withdraw_paused',
  /** column name */
  VaultWithdrawStakedTokenPaused = 'vault_withdraw_staked_token_paused'
}

/** select "lending_controller_aggregate_bool_exp_bool_or_arguments_columns" columns of table "lending_controller" */
export enum Lending_Controller_Select_Column_Lending_Controller_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AddLiquidityPaused = 'add_liquidity_paused',
  /** column name */
  BorrowPaused = 'borrow_paused',
  /** column name */
  CloseVaultPaused = 'close_vault_paused',
  /** column name */
  LiquidateVaultPaused = 'liquidate_vault_paused',
  /** column name */
  MarkForLiquidationPaused = 'mark_for_liquidation_paused',
  /** column name */
  RegisterDepositPaused = 'register_deposit_paused',
  /** column name */
  RegisterVaultCreationPaused = 'register_vault_creation_paused',
  /** column name */
  RegisterWithdrawalPaused = 'register_withdrawal_paused',
  /** column name */
  RemoveLiquidityPaused = 'remove_liquidity_paused',
  /** column name */
  RepayPaused = 'repay_paused',
  /** column name */
  SetCollateralTokenPaused = 'set_collateral_token_paused',
  /** column name */
  SetLoanTokenPaused = 'set_loan_token_paused',
  /** column name */
  VaultDepositPaused = 'vault_deposit_paused',
  /** column name */
  VaultDepositStakedTokenPaused = 'vault_deposit_staked_token_paused',
  /** column name */
  VaultOnLiquidatePaused = 'vault_on_liquidate_paused',
  /** column name */
  VaultWithdrawPaused = 'vault_withdraw_paused',
  /** column name */
  VaultWithdrawStakedTokenPaused = 'vault_withdraw_staked_token_paused'
}

/** aggregate stddev on columns */
export type Lending_Controller_Stddev_Fields = {
  __typename?: 'lending_controller_stddev_fields';
  admin_liquidation_fee_pct?: Maybe<Scalars['Float']['output']>;
  collateral_ratio?: Maybe<Scalars['Float']['output']>;
  decimals?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  interest_rate_decimals?: Maybe<Scalars['Float']['output']>;
  interest_treasury_share?: Maybe<Scalars['Float']['output']>;
  last_completed_data_max_delay?: Maybe<Scalars['Float']['output']>;
  liquidation_delay_in_minutes?: Maybe<Scalars['Float']['output']>;
  liquidation_fee_pct?: Maybe<Scalars['Float']['output']>;
  liquidation_max_duration?: Maybe<Scalars['Float']['output']>;
  liquidation_ratio?: Maybe<Scalars['Float']['output']>;
  max_decimals_for_calculation?: Maybe<Scalars['Float']['output']>;
  max_vault_liquidation_pct?: Maybe<Scalars['Float']['output']>;
  minimum_loan_fee_pct?: Maybe<Scalars['Float']['output']>;
  minimum_loan_treasury_share?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "lending_controller" */
export type Lending_Controller_Stddev_Order_By = {
  admin_liquidation_fee_pct?: InputMaybe<Order_By>;
  collateral_ratio?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interest_rate_decimals?: InputMaybe<Order_By>;
  interest_treasury_share?: InputMaybe<Order_By>;
  last_completed_data_max_delay?: InputMaybe<Order_By>;
  liquidation_delay_in_minutes?: InputMaybe<Order_By>;
  liquidation_fee_pct?: InputMaybe<Order_By>;
  liquidation_max_duration?: InputMaybe<Order_By>;
  liquidation_ratio?: InputMaybe<Order_By>;
  max_decimals_for_calculation?: InputMaybe<Order_By>;
  max_vault_liquidation_pct?: InputMaybe<Order_By>;
  minimum_loan_fee_pct?: InputMaybe<Order_By>;
  minimum_loan_treasury_share?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Lending_Controller_Stddev_Pop_Fields = {
  __typename?: 'lending_controller_stddev_pop_fields';
  admin_liquidation_fee_pct?: Maybe<Scalars['Float']['output']>;
  collateral_ratio?: Maybe<Scalars['Float']['output']>;
  decimals?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  interest_rate_decimals?: Maybe<Scalars['Float']['output']>;
  interest_treasury_share?: Maybe<Scalars['Float']['output']>;
  last_completed_data_max_delay?: Maybe<Scalars['Float']['output']>;
  liquidation_delay_in_minutes?: Maybe<Scalars['Float']['output']>;
  liquidation_fee_pct?: Maybe<Scalars['Float']['output']>;
  liquidation_max_duration?: Maybe<Scalars['Float']['output']>;
  liquidation_ratio?: Maybe<Scalars['Float']['output']>;
  max_decimals_for_calculation?: Maybe<Scalars['Float']['output']>;
  max_vault_liquidation_pct?: Maybe<Scalars['Float']['output']>;
  minimum_loan_fee_pct?: Maybe<Scalars['Float']['output']>;
  minimum_loan_treasury_share?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "lending_controller" */
export type Lending_Controller_Stddev_Pop_Order_By = {
  admin_liquidation_fee_pct?: InputMaybe<Order_By>;
  collateral_ratio?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interest_rate_decimals?: InputMaybe<Order_By>;
  interest_treasury_share?: InputMaybe<Order_By>;
  last_completed_data_max_delay?: InputMaybe<Order_By>;
  liquidation_delay_in_minutes?: InputMaybe<Order_By>;
  liquidation_fee_pct?: InputMaybe<Order_By>;
  liquidation_max_duration?: InputMaybe<Order_By>;
  liquidation_ratio?: InputMaybe<Order_By>;
  max_decimals_for_calculation?: InputMaybe<Order_By>;
  max_vault_liquidation_pct?: InputMaybe<Order_By>;
  minimum_loan_fee_pct?: InputMaybe<Order_By>;
  minimum_loan_treasury_share?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Lending_Controller_Stddev_Samp_Fields = {
  __typename?: 'lending_controller_stddev_samp_fields';
  admin_liquidation_fee_pct?: Maybe<Scalars['Float']['output']>;
  collateral_ratio?: Maybe<Scalars['Float']['output']>;
  decimals?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  interest_rate_decimals?: Maybe<Scalars['Float']['output']>;
  interest_treasury_share?: Maybe<Scalars['Float']['output']>;
  last_completed_data_max_delay?: Maybe<Scalars['Float']['output']>;
  liquidation_delay_in_minutes?: Maybe<Scalars['Float']['output']>;
  liquidation_fee_pct?: Maybe<Scalars['Float']['output']>;
  liquidation_max_duration?: Maybe<Scalars['Float']['output']>;
  liquidation_ratio?: Maybe<Scalars['Float']['output']>;
  max_decimals_for_calculation?: Maybe<Scalars['Float']['output']>;
  max_vault_liquidation_pct?: Maybe<Scalars['Float']['output']>;
  minimum_loan_fee_pct?: Maybe<Scalars['Float']['output']>;
  minimum_loan_treasury_share?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "lending_controller" */
export type Lending_Controller_Stddev_Samp_Order_By = {
  admin_liquidation_fee_pct?: InputMaybe<Order_By>;
  collateral_ratio?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interest_rate_decimals?: InputMaybe<Order_By>;
  interest_treasury_share?: InputMaybe<Order_By>;
  last_completed_data_max_delay?: InputMaybe<Order_By>;
  liquidation_delay_in_minutes?: InputMaybe<Order_By>;
  liquidation_fee_pct?: InputMaybe<Order_By>;
  liquidation_max_duration?: InputMaybe<Order_By>;
  liquidation_ratio?: InputMaybe<Order_By>;
  max_decimals_for_calculation?: InputMaybe<Order_By>;
  max_vault_liquidation_pct?: InputMaybe<Order_By>;
  minimum_loan_fee_pct?: InputMaybe<Order_By>;
  minimum_loan_treasury_share?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "lending_controller" */
export type Lending_Controller_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lending_Controller_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lending_Controller_Stream_Cursor_Value_Input = {
  add_liquidity_paused?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['String']['input']>;
  admin_liquidation_fee_pct?: InputMaybe<Scalars['smallint']['input']>;
  borrow_paused?: InputMaybe<Scalars['Boolean']['input']>;
  close_vault_paused?: InputMaybe<Scalars['Boolean']['input']>;
  collateral_ratio?: InputMaybe<Scalars['smallint']['input']>;
  decimals?: InputMaybe<Scalars['smallint']['input']>;
  governance_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  interest_rate_decimals?: InputMaybe<Scalars['smallint']['input']>;
  interest_treasury_share?: InputMaybe<Scalars['smallint']['input']>;
  last_completed_data_max_delay?: InputMaybe<Scalars['bigint']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  liquidate_vault_paused?: InputMaybe<Scalars['Boolean']['input']>;
  liquidation_delay_in_minutes?: InputMaybe<Scalars['bigint']['input']>;
  liquidation_fee_pct?: InputMaybe<Scalars['smallint']['input']>;
  liquidation_max_duration?: InputMaybe<Scalars['bigint']['input']>;
  liquidation_ratio?: InputMaybe<Scalars['smallint']['input']>;
  mark_for_liquidation_paused?: InputMaybe<Scalars['Boolean']['input']>;
  max_decimals_for_calculation?: InputMaybe<Scalars['smallint']['input']>;
  max_vault_liquidation_pct?: InputMaybe<Scalars['smallint']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  minimum_loan_fee_pct?: InputMaybe<Scalars['smallint']['input']>;
  minimum_loan_treasury_share?: InputMaybe<Scalars['smallint']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  register_deposit_paused?: InputMaybe<Scalars['Boolean']['input']>;
  register_vault_creation_paused?: InputMaybe<Scalars['Boolean']['input']>;
  register_withdrawal_paused?: InputMaybe<Scalars['Boolean']['input']>;
  remove_liquidity_paused?: InputMaybe<Scalars['Boolean']['input']>;
  repay_paused?: InputMaybe<Scalars['Boolean']['input']>;
  set_collateral_token_paused?: InputMaybe<Scalars['Boolean']['input']>;
  set_loan_token_paused?: InputMaybe<Scalars['Boolean']['input']>;
  vault_deposit_paused?: InputMaybe<Scalars['Boolean']['input']>;
  vault_deposit_staked_token_paused?: InputMaybe<Scalars['Boolean']['input']>;
  vault_on_liquidate_paused?: InputMaybe<Scalars['Boolean']['input']>;
  vault_withdraw_paused?: InputMaybe<Scalars['Boolean']['input']>;
  vault_withdraw_staked_token_paused?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Lending_Controller_Sum_Fields = {
  __typename?: 'lending_controller_sum_fields';
  admin_liquidation_fee_pct?: Maybe<Scalars['smallint']['output']>;
  collateral_ratio?: Maybe<Scalars['smallint']['output']>;
  decimals?: Maybe<Scalars['smallint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  interest_rate_decimals?: Maybe<Scalars['smallint']['output']>;
  interest_treasury_share?: Maybe<Scalars['smallint']['output']>;
  last_completed_data_max_delay?: Maybe<Scalars['bigint']['output']>;
  liquidation_delay_in_minutes?: Maybe<Scalars['bigint']['output']>;
  liquidation_fee_pct?: Maybe<Scalars['smallint']['output']>;
  liquidation_max_duration?: Maybe<Scalars['bigint']['output']>;
  liquidation_ratio?: Maybe<Scalars['smallint']['output']>;
  max_decimals_for_calculation?: Maybe<Scalars['smallint']['output']>;
  max_vault_liquidation_pct?: Maybe<Scalars['smallint']['output']>;
  minimum_loan_fee_pct?: Maybe<Scalars['smallint']['output']>;
  minimum_loan_treasury_share?: Maybe<Scalars['smallint']['output']>;
};

/** order by sum() on columns of table "lending_controller" */
export type Lending_Controller_Sum_Order_By = {
  admin_liquidation_fee_pct?: InputMaybe<Order_By>;
  collateral_ratio?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interest_rate_decimals?: InputMaybe<Order_By>;
  interest_treasury_share?: InputMaybe<Order_By>;
  last_completed_data_max_delay?: InputMaybe<Order_By>;
  liquidation_delay_in_minutes?: InputMaybe<Order_By>;
  liquidation_fee_pct?: InputMaybe<Order_By>;
  liquidation_max_duration?: InputMaybe<Order_By>;
  liquidation_ratio?: InputMaybe<Order_By>;
  max_decimals_for_calculation?: InputMaybe<Order_By>;
  max_vault_liquidation_pct?: InputMaybe<Order_By>;
  minimum_loan_fee_pct?: InputMaybe<Order_By>;
  minimum_loan_treasury_share?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Lending_Controller_Var_Pop_Fields = {
  __typename?: 'lending_controller_var_pop_fields';
  admin_liquidation_fee_pct?: Maybe<Scalars['Float']['output']>;
  collateral_ratio?: Maybe<Scalars['Float']['output']>;
  decimals?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  interest_rate_decimals?: Maybe<Scalars['Float']['output']>;
  interest_treasury_share?: Maybe<Scalars['Float']['output']>;
  last_completed_data_max_delay?: Maybe<Scalars['Float']['output']>;
  liquidation_delay_in_minutes?: Maybe<Scalars['Float']['output']>;
  liquidation_fee_pct?: Maybe<Scalars['Float']['output']>;
  liquidation_max_duration?: Maybe<Scalars['Float']['output']>;
  liquidation_ratio?: Maybe<Scalars['Float']['output']>;
  max_decimals_for_calculation?: Maybe<Scalars['Float']['output']>;
  max_vault_liquidation_pct?: Maybe<Scalars['Float']['output']>;
  minimum_loan_fee_pct?: Maybe<Scalars['Float']['output']>;
  minimum_loan_treasury_share?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "lending_controller" */
export type Lending_Controller_Var_Pop_Order_By = {
  admin_liquidation_fee_pct?: InputMaybe<Order_By>;
  collateral_ratio?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interest_rate_decimals?: InputMaybe<Order_By>;
  interest_treasury_share?: InputMaybe<Order_By>;
  last_completed_data_max_delay?: InputMaybe<Order_By>;
  liquidation_delay_in_minutes?: InputMaybe<Order_By>;
  liquidation_fee_pct?: InputMaybe<Order_By>;
  liquidation_max_duration?: InputMaybe<Order_By>;
  liquidation_ratio?: InputMaybe<Order_By>;
  max_decimals_for_calculation?: InputMaybe<Order_By>;
  max_vault_liquidation_pct?: InputMaybe<Order_By>;
  minimum_loan_fee_pct?: InputMaybe<Order_By>;
  minimum_loan_treasury_share?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Lending_Controller_Var_Samp_Fields = {
  __typename?: 'lending_controller_var_samp_fields';
  admin_liquidation_fee_pct?: Maybe<Scalars['Float']['output']>;
  collateral_ratio?: Maybe<Scalars['Float']['output']>;
  decimals?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  interest_rate_decimals?: Maybe<Scalars['Float']['output']>;
  interest_treasury_share?: Maybe<Scalars['Float']['output']>;
  last_completed_data_max_delay?: Maybe<Scalars['Float']['output']>;
  liquidation_delay_in_minutes?: Maybe<Scalars['Float']['output']>;
  liquidation_fee_pct?: Maybe<Scalars['Float']['output']>;
  liquidation_max_duration?: Maybe<Scalars['Float']['output']>;
  liquidation_ratio?: Maybe<Scalars['Float']['output']>;
  max_decimals_for_calculation?: Maybe<Scalars['Float']['output']>;
  max_vault_liquidation_pct?: Maybe<Scalars['Float']['output']>;
  minimum_loan_fee_pct?: Maybe<Scalars['Float']['output']>;
  minimum_loan_treasury_share?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "lending_controller" */
export type Lending_Controller_Var_Samp_Order_By = {
  admin_liquidation_fee_pct?: InputMaybe<Order_By>;
  collateral_ratio?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interest_rate_decimals?: InputMaybe<Order_By>;
  interest_treasury_share?: InputMaybe<Order_By>;
  last_completed_data_max_delay?: InputMaybe<Order_By>;
  liquidation_delay_in_minutes?: InputMaybe<Order_By>;
  liquidation_fee_pct?: InputMaybe<Order_By>;
  liquidation_max_duration?: InputMaybe<Order_By>;
  liquidation_ratio?: InputMaybe<Order_By>;
  max_decimals_for_calculation?: InputMaybe<Order_By>;
  max_vault_liquidation_pct?: InputMaybe<Order_By>;
  minimum_loan_fee_pct?: InputMaybe<Order_By>;
  minimum_loan_treasury_share?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Lending_Controller_Variance_Fields = {
  __typename?: 'lending_controller_variance_fields';
  admin_liquidation_fee_pct?: Maybe<Scalars['Float']['output']>;
  collateral_ratio?: Maybe<Scalars['Float']['output']>;
  decimals?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  interest_rate_decimals?: Maybe<Scalars['Float']['output']>;
  interest_treasury_share?: Maybe<Scalars['Float']['output']>;
  last_completed_data_max_delay?: Maybe<Scalars['Float']['output']>;
  liquidation_delay_in_minutes?: Maybe<Scalars['Float']['output']>;
  liquidation_fee_pct?: Maybe<Scalars['Float']['output']>;
  liquidation_max_duration?: Maybe<Scalars['Float']['output']>;
  liquidation_ratio?: Maybe<Scalars['Float']['output']>;
  max_decimals_for_calculation?: Maybe<Scalars['Float']['output']>;
  max_vault_liquidation_pct?: Maybe<Scalars['Float']['output']>;
  minimum_loan_fee_pct?: Maybe<Scalars['Float']['output']>;
  minimum_loan_treasury_share?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "lending_controller" */
export type Lending_Controller_Variance_Order_By = {
  admin_liquidation_fee_pct?: InputMaybe<Order_By>;
  collateral_ratio?: InputMaybe<Order_By>;
  decimals?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interest_rate_decimals?: InputMaybe<Order_By>;
  interest_treasury_share?: InputMaybe<Order_By>;
  last_completed_data_max_delay?: InputMaybe<Order_By>;
  liquidation_delay_in_minutes?: InputMaybe<Order_By>;
  liquidation_fee_pct?: InputMaybe<Order_By>;
  liquidation_max_duration?: InputMaybe<Order_By>;
  liquidation_ratio?: InputMaybe<Order_By>;
  max_decimals_for_calculation?: InputMaybe<Order_By>;
  max_vault_liquidation_pct?: InputMaybe<Order_By>;
  minimum_loan_fee_pct?: InputMaybe<Order_By>;
  minimum_loan_treasury_share?: InputMaybe<Order_By>;
};

/** columns and relationships of "lending_controller_vault" */
export type Lending_Controller_Vault = {
  __typename?: 'lending_controller_vault';
  borrow_index: Scalars['float8']['output'];
  /** An array relationship */
  collateral_balances: Array<Lending_Controller_Vault_Collateral_Balance>;
  /** An aggregate relationship */
  collateral_balances_aggregate: Lending_Controller_Vault_Collateral_Balance_Aggregate;
  /** An array relationship */
  history_data: Array<Lending_Controller_History_Data>;
  /** An aggregate relationship */
  history_data_aggregate: Lending_Controller_History_Data_Aggregate;
  id: Scalars['bigint']['output'];
  internal_id: Scalars['bigint']['output'];
  last_updated_block_level: Scalars['bigint']['output'];
  last_updated_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  lending_controller: Lending_Controller;
  lending_controller_id: Scalars['bigint']['output'];
  liquidation_end_level: Scalars['bigint']['output'];
  loan_decimals: Scalars['smallint']['output'];
  loan_interest_total: Scalars['float8']['output'];
  loan_outstanding_total: Scalars['float8']['output'];
  loan_principal_total: Scalars['float8']['output'];
  /** An object relationship */
  loan_token: Lending_Controller_Loan_Token;
  loan_token_id: Scalars['bigint']['output'];
  marked_for_liquidation_level: Scalars['bigint']['output'];
  open: Scalars['Boolean']['output'];
  /** An object relationship */
  owner: Maven_User;
  owner_id: Scalars['bigint']['output'];
  /** An object relationship */
  vault?: Maybe<Vault>;
  vault_id?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "lending_controller_vault" */
export type Lending_Controller_VaultCollateral_BalancesArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Vault_Collateral_Balance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Vault_Collateral_Balance_Order_By>>;
  where?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Bool_Exp>;
};


/** columns and relationships of "lending_controller_vault" */
export type Lending_Controller_VaultCollateral_Balances_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Vault_Collateral_Balance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Vault_Collateral_Balance_Order_By>>;
  where?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Bool_Exp>;
};


/** columns and relationships of "lending_controller_vault" */
export type Lending_Controller_VaultHistory_DataArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_History_Data_Order_By>>;
  where?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
};


/** columns and relationships of "lending_controller_vault" */
export type Lending_Controller_VaultHistory_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_History_Data_Order_By>>;
  where?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
};

/** aggregated selection of "lending_controller_vault" */
export type Lending_Controller_Vault_Aggregate = {
  __typename?: 'lending_controller_vault_aggregate';
  aggregate?: Maybe<Lending_Controller_Vault_Aggregate_Fields>;
  nodes: Array<Lending_Controller_Vault>;
};

export type Lending_Controller_Vault_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Lending_Controller_Vault_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Lending_Controller_Vault_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Lending_Controller_Vault_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Lending_Controller_Vault_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Lending_Controller_Vault_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Lending_Controller_Vault_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Lending_Controller_Vault_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Lending_Controller_Vault_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Lending_Controller_Vault_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Lending_Controller_Vault_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Lending_Controller_Vault_Aggregate_Bool_Exp_Var_Samp>;
};

export type Lending_Controller_Vault_Aggregate_Bool_Exp_Avg = {
  arguments: Lending_Controller_Vault_Select_Column_Lending_Controller_Vault_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Vault_Aggregate_Bool_Exp_Bool_And = {
  arguments: Lending_Controller_Vault_Select_Column_Lending_Controller_Vault_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lending_Controller_Vault_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Lending_Controller_Vault_Select_Column_Lending_Controller_Vault_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lending_Controller_Vault_Aggregate_Bool_Exp_Corr = {
  arguments: Lending_Controller_Vault_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Vault_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Lending_Controller_Vault_Select_Column_Lending_Controller_Vault_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Lending_Controller_Vault_Select_Column_Lending_Controller_Vault_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Lending_Controller_Vault_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Lending_Controller_Vault_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Lending_Controller_Vault_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Lending_Controller_Vault_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Vault_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Lending_Controller_Vault_Select_Column_Lending_Controller_Vault_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Lending_Controller_Vault_Select_Column_Lending_Controller_Vault_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Lending_Controller_Vault_Aggregate_Bool_Exp_Max = {
  arguments: Lending_Controller_Vault_Select_Column_Lending_Controller_Vault_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Vault_Aggregate_Bool_Exp_Min = {
  arguments: Lending_Controller_Vault_Select_Column_Lending_Controller_Vault_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Vault_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Lending_Controller_Vault_Select_Column_Lending_Controller_Vault_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Vault_Aggregate_Bool_Exp_Sum = {
  arguments: Lending_Controller_Vault_Select_Column_Lending_Controller_Vault_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Vault_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Lending_Controller_Vault_Select_Column_Lending_Controller_Vault_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "lending_controller_vault" */
export type Lending_Controller_Vault_Aggregate_Fields = {
  __typename?: 'lending_controller_vault_aggregate_fields';
  avg?: Maybe<Lending_Controller_Vault_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Lending_Controller_Vault_Max_Fields>;
  min?: Maybe<Lending_Controller_Vault_Min_Fields>;
  stddev?: Maybe<Lending_Controller_Vault_Stddev_Fields>;
  stddev_pop?: Maybe<Lending_Controller_Vault_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lending_Controller_Vault_Stddev_Samp_Fields>;
  sum?: Maybe<Lending_Controller_Vault_Sum_Fields>;
  var_pop?: Maybe<Lending_Controller_Vault_Var_Pop_Fields>;
  var_samp?: Maybe<Lending_Controller_Vault_Var_Samp_Fields>;
  variance?: Maybe<Lending_Controller_Vault_Variance_Fields>;
};


/** aggregate fields of "lending_controller_vault" */
export type Lending_Controller_Vault_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lending_Controller_Vault_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "lending_controller_vault" */
export type Lending_Controller_Vault_Aggregate_Order_By = {
  avg?: InputMaybe<Lending_Controller_Vault_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lending_Controller_Vault_Max_Order_By>;
  min?: InputMaybe<Lending_Controller_Vault_Min_Order_By>;
  stddev?: InputMaybe<Lending_Controller_Vault_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Lending_Controller_Vault_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Lending_Controller_Vault_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Lending_Controller_Vault_Sum_Order_By>;
  var_pop?: InputMaybe<Lending_Controller_Vault_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Lending_Controller_Vault_Var_Samp_Order_By>;
  variance?: InputMaybe<Lending_Controller_Vault_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Lending_Controller_Vault_Avg_Fields = {
  __typename?: 'lending_controller_vault_avg_fields';
  borrow_index?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  last_updated_block_level?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  liquidation_end_level?: Maybe<Scalars['Float']['output']>;
  loan_decimals?: Maybe<Scalars['Float']['output']>;
  loan_interest_total?: Maybe<Scalars['Float']['output']>;
  loan_outstanding_total?: Maybe<Scalars['Float']['output']>;
  loan_principal_total?: Maybe<Scalars['Float']['output']>;
  loan_token_id?: Maybe<Scalars['Float']['output']>;
  marked_for_liquidation_level?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "lending_controller_vault" */
export type Lending_Controller_Vault_Avg_Order_By = {
  borrow_index?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  last_updated_block_level?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  liquidation_end_level?: InputMaybe<Order_By>;
  loan_decimals?: InputMaybe<Order_By>;
  loan_interest_total?: InputMaybe<Order_By>;
  loan_outstanding_total?: InputMaybe<Order_By>;
  loan_principal_total?: InputMaybe<Order_By>;
  loan_token_id?: InputMaybe<Order_By>;
  marked_for_liquidation_level?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "lending_controller_vault". All fields are combined with a logical 'AND'. */
export type Lending_Controller_Vault_Bool_Exp = {
  _and?: InputMaybe<Array<Lending_Controller_Vault_Bool_Exp>>;
  _not?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
  _or?: InputMaybe<Array<Lending_Controller_Vault_Bool_Exp>>;
  borrow_index?: InputMaybe<Float8_Comparison_Exp>;
  collateral_balances?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Bool_Exp>;
  collateral_balances_aggregate?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp>;
  history_data?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
  history_data_aggregate?: InputMaybe<Lending_Controller_History_Data_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  internal_id?: InputMaybe<Bigint_Comparison_Exp>;
  last_updated_block_level?: InputMaybe<Bigint_Comparison_Exp>;
  last_updated_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  lending_controller?: InputMaybe<Lending_Controller_Bool_Exp>;
  lending_controller_id?: InputMaybe<Bigint_Comparison_Exp>;
  liquidation_end_level?: InputMaybe<Bigint_Comparison_Exp>;
  loan_decimals?: InputMaybe<Smallint_Comparison_Exp>;
  loan_interest_total?: InputMaybe<Float8_Comparison_Exp>;
  loan_outstanding_total?: InputMaybe<Float8_Comparison_Exp>;
  loan_principal_total?: InputMaybe<Float8_Comparison_Exp>;
  loan_token?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
  loan_token_id?: InputMaybe<Bigint_Comparison_Exp>;
  marked_for_liquidation_level?: InputMaybe<Bigint_Comparison_Exp>;
  open?: InputMaybe<Boolean_Comparison_Exp>;
  owner?: InputMaybe<Maven_User_Bool_Exp>;
  owner_id?: InputMaybe<Bigint_Comparison_Exp>;
  vault?: InputMaybe<Vault_Bool_Exp>;
  vault_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** columns and relationships of "lending_controller_vault_collateral_balance" */
export type Lending_Controller_Vault_Collateral_Balance = {
  __typename?: 'lending_controller_vault_collateral_balance';
  balance: Scalars['float8']['output'];
  /** An object relationship */
  collateral_token: Lending_Controller_Collateral_Token;
  collateral_token_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  lending_controller_vault: Lending_Controller_Vault;
  lending_controller_vault_id: Scalars['bigint']['output'];
};

/** aggregated selection of "lending_controller_vault_collateral_balance" */
export type Lending_Controller_Vault_Collateral_Balance_Aggregate = {
  __typename?: 'lending_controller_vault_collateral_balance_aggregate';
  aggregate?: Maybe<Lending_Controller_Vault_Collateral_Balance_Aggregate_Fields>;
  nodes: Array<Lending_Controller_Vault_Collateral_Balance>;
};

export type Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Var_Samp>;
};

export type Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Avg = {
  arguments: Lending_Controller_Vault_Collateral_Balance_Select_Column_Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Corr = {
  arguments: Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Lending_Controller_Vault_Collateral_Balance_Select_Column_Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Lending_Controller_Vault_Collateral_Balance_Select_Column_Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Lending_Controller_Vault_Collateral_Balance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Lending_Controller_Vault_Collateral_Balance_Select_Column_Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Lending_Controller_Vault_Collateral_Balance_Select_Column_Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Max = {
  arguments: Lending_Controller_Vault_Collateral_Balance_Select_Column_Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Min = {
  arguments: Lending_Controller_Vault_Collateral_Balance_Select_Column_Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Lending_Controller_Vault_Collateral_Balance_Select_Column_Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Sum = {
  arguments: Lending_Controller_Vault_Collateral_Balance_Select_Column_Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Lending_Controller_Vault_Collateral_Balance_Select_Column_Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "lending_controller_vault_collateral_balance" */
export type Lending_Controller_Vault_Collateral_Balance_Aggregate_Fields = {
  __typename?: 'lending_controller_vault_collateral_balance_aggregate_fields';
  avg?: Maybe<Lending_Controller_Vault_Collateral_Balance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Lending_Controller_Vault_Collateral_Balance_Max_Fields>;
  min?: Maybe<Lending_Controller_Vault_Collateral_Balance_Min_Fields>;
  stddev?: Maybe<Lending_Controller_Vault_Collateral_Balance_Stddev_Fields>;
  stddev_pop?: Maybe<Lending_Controller_Vault_Collateral_Balance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lending_Controller_Vault_Collateral_Balance_Stddev_Samp_Fields>;
  sum?: Maybe<Lending_Controller_Vault_Collateral_Balance_Sum_Fields>;
  var_pop?: Maybe<Lending_Controller_Vault_Collateral_Balance_Var_Pop_Fields>;
  var_samp?: Maybe<Lending_Controller_Vault_Collateral_Balance_Var_Samp_Fields>;
  variance?: Maybe<Lending_Controller_Vault_Collateral_Balance_Variance_Fields>;
};


/** aggregate fields of "lending_controller_vault_collateral_balance" */
export type Lending_Controller_Vault_Collateral_Balance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lending_Controller_Vault_Collateral_Balance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "lending_controller_vault_collateral_balance" */
export type Lending_Controller_Vault_Collateral_Balance_Aggregate_Order_By = {
  avg?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Max_Order_By>;
  min?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Min_Order_By>;
  stddev?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Sum_Order_By>;
  var_pop?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Var_Samp_Order_By>;
  variance?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Lending_Controller_Vault_Collateral_Balance_Avg_Fields = {
  __typename?: 'lending_controller_vault_collateral_balance_avg_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  collateral_token_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "lending_controller_vault_collateral_balance" */
export type Lending_Controller_Vault_Collateral_Balance_Avg_Order_By = {
  balance?: InputMaybe<Order_By>;
  collateral_token_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lending_controller_vault_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "lending_controller_vault_collateral_balance". All fields are combined with a logical 'AND'. */
export type Lending_Controller_Vault_Collateral_Balance_Bool_Exp = {
  _and?: InputMaybe<Array<Lending_Controller_Vault_Collateral_Balance_Bool_Exp>>;
  _not?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Bool_Exp>;
  _or?: InputMaybe<Array<Lending_Controller_Vault_Collateral_Balance_Bool_Exp>>;
  balance?: InputMaybe<Float8_Comparison_Exp>;
  collateral_token?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
  collateral_token_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lending_controller_vault?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
  lending_controller_vault_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Lending_Controller_Vault_Collateral_Balance_Max_Fields = {
  __typename?: 'lending_controller_vault_collateral_balance_max_fields';
  balance?: Maybe<Scalars['float8']['output']>;
  collateral_token_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "lending_controller_vault_collateral_balance" */
export type Lending_Controller_Vault_Collateral_Balance_Max_Order_By = {
  balance?: InputMaybe<Order_By>;
  collateral_token_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lending_controller_vault_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Lending_Controller_Vault_Collateral_Balance_Min_Fields = {
  __typename?: 'lending_controller_vault_collateral_balance_min_fields';
  balance?: Maybe<Scalars['float8']['output']>;
  collateral_token_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "lending_controller_vault_collateral_balance" */
export type Lending_Controller_Vault_Collateral_Balance_Min_Order_By = {
  balance?: InputMaybe<Order_By>;
  collateral_token_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lending_controller_vault_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "lending_controller_vault_collateral_balance". */
export type Lending_Controller_Vault_Collateral_Balance_Order_By = {
  balance?: InputMaybe<Order_By>;
  collateral_token?: InputMaybe<Lending_Controller_Collateral_Token_Order_By>;
  collateral_token_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lending_controller_vault?: InputMaybe<Lending_Controller_Vault_Order_By>;
  lending_controller_vault_id?: InputMaybe<Order_By>;
};

/** select columns of table "lending_controller_vault_collateral_balance" */
export enum Lending_Controller_Vault_Collateral_Balance_Select_Column {
  /** column name */
  Balance = 'balance',
  /** column name */
  CollateralTokenId = 'collateral_token_id',
  /** column name */
  Id = 'id',
  /** column name */
  LendingControllerVaultId = 'lending_controller_vault_id'
}

/** select "lending_controller_vault_collateral_balance_aggregate_bool_exp_avg_arguments_columns" columns of table "lending_controller_vault_collateral_balance" */
export enum Lending_Controller_Vault_Collateral_Balance_Select_Column_Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Balance = 'balance'
}

/** select "lending_controller_vault_collateral_balance_aggregate_bool_exp_corr_arguments_columns" columns of table "lending_controller_vault_collateral_balance" */
export enum Lending_Controller_Vault_Collateral_Balance_Select_Column_Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Balance = 'balance'
}

/** select "lending_controller_vault_collateral_balance_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "lending_controller_vault_collateral_balance" */
export enum Lending_Controller_Vault_Collateral_Balance_Select_Column_Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Balance = 'balance'
}

/** select "lending_controller_vault_collateral_balance_aggregate_bool_exp_max_arguments_columns" columns of table "lending_controller_vault_collateral_balance" */
export enum Lending_Controller_Vault_Collateral_Balance_Select_Column_Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Balance = 'balance'
}

/** select "lending_controller_vault_collateral_balance_aggregate_bool_exp_min_arguments_columns" columns of table "lending_controller_vault_collateral_balance" */
export enum Lending_Controller_Vault_Collateral_Balance_Select_Column_Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Balance = 'balance'
}

/** select "lending_controller_vault_collateral_balance_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "lending_controller_vault_collateral_balance" */
export enum Lending_Controller_Vault_Collateral_Balance_Select_Column_Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Balance = 'balance'
}

/** select "lending_controller_vault_collateral_balance_aggregate_bool_exp_sum_arguments_columns" columns of table "lending_controller_vault_collateral_balance" */
export enum Lending_Controller_Vault_Collateral_Balance_Select_Column_Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Balance = 'balance'
}

/** select "lending_controller_vault_collateral_balance_aggregate_bool_exp_var_samp_arguments_columns" columns of table "lending_controller_vault_collateral_balance" */
export enum Lending_Controller_Vault_Collateral_Balance_Select_Column_Lending_Controller_Vault_Collateral_Balance_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Balance = 'balance'
}

/** aggregate stddev on columns */
export type Lending_Controller_Vault_Collateral_Balance_Stddev_Fields = {
  __typename?: 'lending_controller_vault_collateral_balance_stddev_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  collateral_token_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "lending_controller_vault_collateral_balance" */
export type Lending_Controller_Vault_Collateral_Balance_Stddev_Order_By = {
  balance?: InputMaybe<Order_By>;
  collateral_token_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lending_controller_vault_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Lending_Controller_Vault_Collateral_Balance_Stddev_Pop_Fields = {
  __typename?: 'lending_controller_vault_collateral_balance_stddev_pop_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  collateral_token_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "lending_controller_vault_collateral_balance" */
export type Lending_Controller_Vault_Collateral_Balance_Stddev_Pop_Order_By = {
  balance?: InputMaybe<Order_By>;
  collateral_token_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lending_controller_vault_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Lending_Controller_Vault_Collateral_Balance_Stddev_Samp_Fields = {
  __typename?: 'lending_controller_vault_collateral_balance_stddev_samp_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  collateral_token_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "lending_controller_vault_collateral_balance" */
export type Lending_Controller_Vault_Collateral_Balance_Stddev_Samp_Order_By = {
  balance?: InputMaybe<Order_By>;
  collateral_token_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lending_controller_vault_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "lending_controller_vault_collateral_balance" */
export type Lending_Controller_Vault_Collateral_Balance_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lending_Controller_Vault_Collateral_Balance_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lending_Controller_Vault_Collateral_Balance_Stream_Cursor_Value_Input = {
  balance?: InputMaybe<Scalars['float8']['input']>;
  collateral_token_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lending_controller_vault_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Lending_Controller_Vault_Collateral_Balance_Sum_Fields = {
  __typename?: 'lending_controller_vault_collateral_balance_sum_fields';
  balance?: Maybe<Scalars['float8']['output']>;
  collateral_token_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "lending_controller_vault_collateral_balance" */
export type Lending_Controller_Vault_Collateral_Balance_Sum_Order_By = {
  balance?: InputMaybe<Order_By>;
  collateral_token_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lending_controller_vault_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Lending_Controller_Vault_Collateral_Balance_Var_Pop_Fields = {
  __typename?: 'lending_controller_vault_collateral_balance_var_pop_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  collateral_token_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "lending_controller_vault_collateral_balance" */
export type Lending_Controller_Vault_Collateral_Balance_Var_Pop_Order_By = {
  balance?: InputMaybe<Order_By>;
  collateral_token_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lending_controller_vault_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Lending_Controller_Vault_Collateral_Balance_Var_Samp_Fields = {
  __typename?: 'lending_controller_vault_collateral_balance_var_samp_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  collateral_token_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "lending_controller_vault_collateral_balance" */
export type Lending_Controller_Vault_Collateral_Balance_Var_Samp_Order_By = {
  balance?: InputMaybe<Order_By>;
  collateral_token_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lending_controller_vault_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Lending_Controller_Vault_Collateral_Balance_Variance_Fields = {
  __typename?: 'lending_controller_vault_collateral_balance_variance_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  collateral_token_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "lending_controller_vault_collateral_balance" */
export type Lending_Controller_Vault_Collateral_Balance_Variance_Order_By = {
  balance?: InputMaybe<Order_By>;
  collateral_token_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lending_controller_vault_id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Lending_Controller_Vault_Max_Fields = {
  __typename?: 'lending_controller_vault_max_fields';
  borrow_index?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['bigint']['output']>;
  last_updated_block_level?: Maybe<Scalars['bigint']['output']>;
  last_updated_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  lending_controller_id?: Maybe<Scalars['bigint']['output']>;
  liquidation_end_level?: Maybe<Scalars['bigint']['output']>;
  loan_decimals?: Maybe<Scalars['smallint']['output']>;
  loan_interest_total?: Maybe<Scalars['float8']['output']>;
  loan_outstanding_total?: Maybe<Scalars['float8']['output']>;
  loan_principal_total?: Maybe<Scalars['float8']['output']>;
  loan_token_id?: Maybe<Scalars['bigint']['output']>;
  marked_for_liquidation_level?: Maybe<Scalars['bigint']['output']>;
  owner_id?: Maybe<Scalars['bigint']['output']>;
  vault_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "lending_controller_vault" */
export type Lending_Controller_Vault_Max_Order_By = {
  borrow_index?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  last_updated_block_level?: InputMaybe<Order_By>;
  last_updated_timestamp?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  liquidation_end_level?: InputMaybe<Order_By>;
  loan_decimals?: InputMaybe<Order_By>;
  loan_interest_total?: InputMaybe<Order_By>;
  loan_outstanding_total?: InputMaybe<Order_By>;
  loan_principal_total?: InputMaybe<Order_By>;
  loan_token_id?: InputMaybe<Order_By>;
  marked_for_liquidation_level?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Lending_Controller_Vault_Min_Fields = {
  __typename?: 'lending_controller_vault_min_fields';
  borrow_index?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['bigint']['output']>;
  last_updated_block_level?: Maybe<Scalars['bigint']['output']>;
  last_updated_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  lending_controller_id?: Maybe<Scalars['bigint']['output']>;
  liquidation_end_level?: Maybe<Scalars['bigint']['output']>;
  loan_decimals?: Maybe<Scalars['smallint']['output']>;
  loan_interest_total?: Maybe<Scalars['float8']['output']>;
  loan_outstanding_total?: Maybe<Scalars['float8']['output']>;
  loan_principal_total?: Maybe<Scalars['float8']['output']>;
  loan_token_id?: Maybe<Scalars['bigint']['output']>;
  marked_for_liquidation_level?: Maybe<Scalars['bigint']['output']>;
  owner_id?: Maybe<Scalars['bigint']['output']>;
  vault_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "lending_controller_vault" */
export type Lending_Controller_Vault_Min_Order_By = {
  borrow_index?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  last_updated_block_level?: InputMaybe<Order_By>;
  last_updated_timestamp?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  liquidation_end_level?: InputMaybe<Order_By>;
  loan_decimals?: InputMaybe<Order_By>;
  loan_interest_total?: InputMaybe<Order_By>;
  loan_outstanding_total?: InputMaybe<Order_By>;
  loan_principal_total?: InputMaybe<Order_By>;
  loan_token_id?: InputMaybe<Order_By>;
  marked_for_liquidation_level?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "lending_controller_vault". */
export type Lending_Controller_Vault_Order_By = {
  borrow_index?: InputMaybe<Order_By>;
  collateral_balances_aggregate?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Aggregate_Order_By>;
  history_data_aggregate?: InputMaybe<Lending_Controller_History_Data_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  last_updated_block_level?: InputMaybe<Order_By>;
  last_updated_timestamp?: InputMaybe<Order_By>;
  lending_controller?: InputMaybe<Lending_Controller_Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  liquidation_end_level?: InputMaybe<Order_By>;
  loan_decimals?: InputMaybe<Order_By>;
  loan_interest_total?: InputMaybe<Order_By>;
  loan_outstanding_total?: InputMaybe<Order_By>;
  loan_principal_total?: InputMaybe<Order_By>;
  loan_token?: InputMaybe<Lending_Controller_Loan_Token_Order_By>;
  loan_token_id?: InputMaybe<Order_By>;
  marked_for_liquidation_level?: InputMaybe<Order_By>;
  open?: InputMaybe<Order_By>;
  owner?: InputMaybe<Maven_User_Order_By>;
  owner_id?: InputMaybe<Order_By>;
  vault?: InputMaybe<Vault_Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** select columns of table "lending_controller_vault" */
export enum Lending_Controller_Vault_Select_Column {
  /** column name */
  BorrowIndex = 'borrow_index',
  /** column name */
  Id = 'id',
  /** column name */
  InternalId = 'internal_id',
  /** column name */
  LastUpdatedBlockLevel = 'last_updated_block_level',
  /** column name */
  LastUpdatedTimestamp = 'last_updated_timestamp',
  /** column name */
  LendingControllerId = 'lending_controller_id',
  /** column name */
  LiquidationEndLevel = 'liquidation_end_level',
  /** column name */
  LoanDecimals = 'loan_decimals',
  /** column name */
  LoanInterestTotal = 'loan_interest_total',
  /** column name */
  LoanOutstandingTotal = 'loan_outstanding_total',
  /** column name */
  LoanPrincipalTotal = 'loan_principal_total',
  /** column name */
  LoanTokenId = 'loan_token_id',
  /** column name */
  MarkedForLiquidationLevel = 'marked_for_liquidation_level',
  /** column name */
  Open = 'open',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  VaultId = 'vault_id'
}

/** select "lending_controller_vault_aggregate_bool_exp_avg_arguments_columns" columns of table "lending_controller_vault" */
export enum Lending_Controller_Vault_Select_Column_Lending_Controller_Vault_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  BorrowIndex = 'borrow_index',
  /** column name */
  LoanInterestTotal = 'loan_interest_total',
  /** column name */
  LoanOutstandingTotal = 'loan_outstanding_total',
  /** column name */
  LoanPrincipalTotal = 'loan_principal_total'
}

/** select "lending_controller_vault_aggregate_bool_exp_bool_and_arguments_columns" columns of table "lending_controller_vault" */
export enum Lending_Controller_Vault_Select_Column_Lending_Controller_Vault_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Open = 'open'
}

/** select "lending_controller_vault_aggregate_bool_exp_bool_or_arguments_columns" columns of table "lending_controller_vault" */
export enum Lending_Controller_Vault_Select_Column_Lending_Controller_Vault_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Open = 'open'
}

/** select "lending_controller_vault_aggregate_bool_exp_corr_arguments_columns" columns of table "lending_controller_vault" */
export enum Lending_Controller_Vault_Select_Column_Lending_Controller_Vault_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  BorrowIndex = 'borrow_index',
  /** column name */
  LoanInterestTotal = 'loan_interest_total',
  /** column name */
  LoanOutstandingTotal = 'loan_outstanding_total',
  /** column name */
  LoanPrincipalTotal = 'loan_principal_total'
}

/** select "lending_controller_vault_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "lending_controller_vault" */
export enum Lending_Controller_Vault_Select_Column_Lending_Controller_Vault_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  BorrowIndex = 'borrow_index',
  /** column name */
  LoanInterestTotal = 'loan_interest_total',
  /** column name */
  LoanOutstandingTotal = 'loan_outstanding_total',
  /** column name */
  LoanPrincipalTotal = 'loan_principal_total'
}

/** select "lending_controller_vault_aggregate_bool_exp_max_arguments_columns" columns of table "lending_controller_vault" */
export enum Lending_Controller_Vault_Select_Column_Lending_Controller_Vault_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  BorrowIndex = 'borrow_index',
  /** column name */
  LoanInterestTotal = 'loan_interest_total',
  /** column name */
  LoanOutstandingTotal = 'loan_outstanding_total',
  /** column name */
  LoanPrincipalTotal = 'loan_principal_total'
}

/** select "lending_controller_vault_aggregate_bool_exp_min_arguments_columns" columns of table "lending_controller_vault" */
export enum Lending_Controller_Vault_Select_Column_Lending_Controller_Vault_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  BorrowIndex = 'borrow_index',
  /** column name */
  LoanInterestTotal = 'loan_interest_total',
  /** column name */
  LoanOutstandingTotal = 'loan_outstanding_total',
  /** column name */
  LoanPrincipalTotal = 'loan_principal_total'
}

/** select "lending_controller_vault_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "lending_controller_vault" */
export enum Lending_Controller_Vault_Select_Column_Lending_Controller_Vault_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  BorrowIndex = 'borrow_index',
  /** column name */
  LoanInterestTotal = 'loan_interest_total',
  /** column name */
  LoanOutstandingTotal = 'loan_outstanding_total',
  /** column name */
  LoanPrincipalTotal = 'loan_principal_total'
}

/** select "lending_controller_vault_aggregate_bool_exp_sum_arguments_columns" columns of table "lending_controller_vault" */
export enum Lending_Controller_Vault_Select_Column_Lending_Controller_Vault_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  BorrowIndex = 'borrow_index',
  /** column name */
  LoanInterestTotal = 'loan_interest_total',
  /** column name */
  LoanOutstandingTotal = 'loan_outstanding_total',
  /** column name */
  LoanPrincipalTotal = 'loan_principal_total'
}

/** select "lending_controller_vault_aggregate_bool_exp_var_samp_arguments_columns" columns of table "lending_controller_vault" */
export enum Lending_Controller_Vault_Select_Column_Lending_Controller_Vault_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  BorrowIndex = 'borrow_index',
  /** column name */
  LoanInterestTotal = 'loan_interest_total',
  /** column name */
  LoanOutstandingTotal = 'loan_outstanding_total',
  /** column name */
  LoanPrincipalTotal = 'loan_principal_total'
}

/** aggregate stddev on columns */
export type Lending_Controller_Vault_Stddev_Fields = {
  __typename?: 'lending_controller_vault_stddev_fields';
  borrow_index?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  last_updated_block_level?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  liquidation_end_level?: Maybe<Scalars['Float']['output']>;
  loan_decimals?: Maybe<Scalars['Float']['output']>;
  loan_interest_total?: Maybe<Scalars['Float']['output']>;
  loan_outstanding_total?: Maybe<Scalars['Float']['output']>;
  loan_principal_total?: Maybe<Scalars['Float']['output']>;
  loan_token_id?: Maybe<Scalars['Float']['output']>;
  marked_for_liquidation_level?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "lending_controller_vault" */
export type Lending_Controller_Vault_Stddev_Order_By = {
  borrow_index?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  last_updated_block_level?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  liquidation_end_level?: InputMaybe<Order_By>;
  loan_decimals?: InputMaybe<Order_By>;
  loan_interest_total?: InputMaybe<Order_By>;
  loan_outstanding_total?: InputMaybe<Order_By>;
  loan_principal_total?: InputMaybe<Order_By>;
  loan_token_id?: InputMaybe<Order_By>;
  marked_for_liquidation_level?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Lending_Controller_Vault_Stddev_Pop_Fields = {
  __typename?: 'lending_controller_vault_stddev_pop_fields';
  borrow_index?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  last_updated_block_level?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  liquidation_end_level?: Maybe<Scalars['Float']['output']>;
  loan_decimals?: Maybe<Scalars['Float']['output']>;
  loan_interest_total?: Maybe<Scalars['Float']['output']>;
  loan_outstanding_total?: Maybe<Scalars['Float']['output']>;
  loan_principal_total?: Maybe<Scalars['Float']['output']>;
  loan_token_id?: Maybe<Scalars['Float']['output']>;
  marked_for_liquidation_level?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "lending_controller_vault" */
export type Lending_Controller_Vault_Stddev_Pop_Order_By = {
  borrow_index?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  last_updated_block_level?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  liquidation_end_level?: InputMaybe<Order_By>;
  loan_decimals?: InputMaybe<Order_By>;
  loan_interest_total?: InputMaybe<Order_By>;
  loan_outstanding_total?: InputMaybe<Order_By>;
  loan_principal_total?: InputMaybe<Order_By>;
  loan_token_id?: InputMaybe<Order_By>;
  marked_for_liquidation_level?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Lending_Controller_Vault_Stddev_Samp_Fields = {
  __typename?: 'lending_controller_vault_stddev_samp_fields';
  borrow_index?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  last_updated_block_level?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  liquidation_end_level?: Maybe<Scalars['Float']['output']>;
  loan_decimals?: Maybe<Scalars['Float']['output']>;
  loan_interest_total?: Maybe<Scalars['Float']['output']>;
  loan_outstanding_total?: Maybe<Scalars['Float']['output']>;
  loan_principal_total?: Maybe<Scalars['Float']['output']>;
  loan_token_id?: Maybe<Scalars['Float']['output']>;
  marked_for_liquidation_level?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "lending_controller_vault" */
export type Lending_Controller_Vault_Stddev_Samp_Order_By = {
  borrow_index?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  last_updated_block_level?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  liquidation_end_level?: InputMaybe<Order_By>;
  loan_decimals?: InputMaybe<Order_By>;
  loan_interest_total?: InputMaybe<Order_By>;
  loan_outstanding_total?: InputMaybe<Order_By>;
  loan_principal_total?: InputMaybe<Order_By>;
  loan_token_id?: InputMaybe<Order_By>;
  marked_for_liquidation_level?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "lending_controller_vault" */
export type Lending_Controller_Vault_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lending_Controller_Vault_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lending_Controller_Vault_Stream_Cursor_Value_Input = {
  borrow_index?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  internal_id?: InputMaybe<Scalars['bigint']['input']>;
  last_updated_block_level?: InputMaybe<Scalars['bigint']['input']>;
  last_updated_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  lending_controller_id?: InputMaybe<Scalars['bigint']['input']>;
  liquidation_end_level?: InputMaybe<Scalars['bigint']['input']>;
  loan_decimals?: InputMaybe<Scalars['smallint']['input']>;
  loan_interest_total?: InputMaybe<Scalars['float8']['input']>;
  loan_outstanding_total?: InputMaybe<Scalars['float8']['input']>;
  loan_principal_total?: InputMaybe<Scalars['float8']['input']>;
  loan_token_id?: InputMaybe<Scalars['bigint']['input']>;
  marked_for_liquidation_level?: InputMaybe<Scalars['bigint']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  owner_id?: InputMaybe<Scalars['bigint']['input']>;
  vault_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Lending_Controller_Vault_Sum_Fields = {
  __typename?: 'lending_controller_vault_sum_fields';
  borrow_index?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  internal_id?: Maybe<Scalars['bigint']['output']>;
  last_updated_block_level?: Maybe<Scalars['bigint']['output']>;
  lending_controller_id?: Maybe<Scalars['bigint']['output']>;
  liquidation_end_level?: Maybe<Scalars['bigint']['output']>;
  loan_decimals?: Maybe<Scalars['smallint']['output']>;
  loan_interest_total?: Maybe<Scalars['float8']['output']>;
  loan_outstanding_total?: Maybe<Scalars['float8']['output']>;
  loan_principal_total?: Maybe<Scalars['float8']['output']>;
  loan_token_id?: Maybe<Scalars['bigint']['output']>;
  marked_for_liquidation_level?: Maybe<Scalars['bigint']['output']>;
  owner_id?: Maybe<Scalars['bigint']['output']>;
  vault_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "lending_controller_vault" */
export type Lending_Controller_Vault_Sum_Order_By = {
  borrow_index?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  last_updated_block_level?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  liquidation_end_level?: InputMaybe<Order_By>;
  loan_decimals?: InputMaybe<Order_By>;
  loan_interest_total?: InputMaybe<Order_By>;
  loan_outstanding_total?: InputMaybe<Order_By>;
  loan_principal_total?: InputMaybe<Order_By>;
  loan_token_id?: InputMaybe<Order_By>;
  marked_for_liquidation_level?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Lending_Controller_Vault_Var_Pop_Fields = {
  __typename?: 'lending_controller_vault_var_pop_fields';
  borrow_index?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  last_updated_block_level?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  liquidation_end_level?: Maybe<Scalars['Float']['output']>;
  loan_decimals?: Maybe<Scalars['Float']['output']>;
  loan_interest_total?: Maybe<Scalars['Float']['output']>;
  loan_outstanding_total?: Maybe<Scalars['Float']['output']>;
  loan_principal_total?: Maybe<Scalars['Float']['output']>;
  loan_token_id?: Maybe<Scalars['Float']['output']>;
  marked_for_liquidation_level?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "lending_controller_vault" */
export type Lending_Controller_Vault_Var_Pop_Order_By = {
  borrow_index?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  last_updated_block_level?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  liquidation_end_level?: InputMaybe<Order_By>;
  loan_decimals?: InputMaybe<Order_By>;
  loan_interest_total?: InputMaybe<Order_By>;
  loan_outstanding_total?: InputMaybe<Order_By>;
  loan_principal_total?: InputMaybe<Order_By>;
  loan_token_id?: InputMaybe<Order_By>;
  marked_for_liquidation_level?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Lending_Controller_Vault_Var_Samp_Fields = {
  __typename?: 'lending_controller_vault_var_samp_fields';
  borrow_index?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  last_updated_block_level?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  liquidation_end_level?: Maybe<Scalars['Float']['output']>;
  loan_decimals?: Maybe<Scalars['Float']['output']>;
  loan_interest_total?: Maybe<Scalars['Float']['output']>;
  loan_outstanding_total?: Maybe<Scalars['Float']['output']>;
  loan_principal_total?: Maybe<Scalars['Float']['output']>;
  loan_token_id?: Maybe<Scalars['Float']['output']>;
  marked_for_liquidation_level?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "lending_controller_vault" */
export type Lending_Controller_Vault_Var_Samp_Order_By = {
  borrow_index?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  last_updated_block_level?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  liquidation_end_level?: InputMaybe<Order_By>;
  loan_decimals?: InputMaybe<Order_By>;
  loan_interest_total?: InputMaybe<Order_By>;
  loan_outstanding_total?: InputMaybe<Order_By>;
  loan_principal_total?: InputMaybe<Order_By>;
  loan_token_id?: InputMaybe<Order_By>;
  marked_for_liquidation_level?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Lending_Controller_Vault_Variance_Fields = {
  __typename?: 'lending_controller_vault_variance_fields';
  borrow_index?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  last_updated_block_level?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  liquidation_end_level?: Maybe<Scalars['Float']['output']>;
  loan_decimals?: Maybe<Scalars['Float']['output']>;
  loan_interest_total?: Maybe<Scalars['Float']['output']>;
  loan_outstanding_total?: Maybe<Scalars['Float']['output']>;
  loan_principal_total?: Maybe<Scalars['Float']['output']>;
  loan_token_id?: Maybe<Scalars['Float']['output']>;
  marked_for_liquidation_level?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "lending_controller_vault" */
export type Lending_Controller_Vault_Variance_Order_By = {
  borrow_index?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  last_updated_block_level?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  liquidation_end_level?: InputMaybe<Order_By>;
  loan_decimals?: InputMaybe<Order_By>;
  loan_interest_total?: InputMaybe<Order_By>;
  loan_outstanding_total?: InputMaybe<Order_By>;
  loan_principal_total?: InputMaybe<Order_By>;
  loan_token_id?: InputMaybe<Order_By>;
  marked_for_liquidation_level?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "loan_token_view" */
export type Loan_Token_View = {
  __typename?: 'loan_token_view';
  borrowers_count?: Maybe<Scalars['bigint']['output']>;
  current_interest_rate?: Maybe<Scalars['float8']['output']>;
  depositors_count?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated?: Maybe<Scalars['timestamptz']['output']>;
  lending_controller_id?: Maybe<Scalars['bigint']['output']>;
  loan_token_name?: Maybe<Scalars['String']['output']>;
  m_token_address?: Maybe<Scalars['String']['output']>;
  m_token_id?: Maybe<Scalars['bigint']['output']>;
  paused?: Maybe<Scalars['Boolean']['output']>;
  rewards_earned_total?: Maybe<Scalars['float8']['output']>;
  token_address?: Maybe<Scalars['String']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  token_pool_total?: Maybe<Scalars['float8']['output']>;
  total_borrowed?: Maybe<Scalars['float8']['output']>;
  total_remaining?: Maybe<Scalars['float8']['output']>;
  utilisation_rate?: Maybe<Scalars['float8']['output']>;
};

/** aggregated selection of "loan_token_view" */
export type Loan_Token_View_Aggregate = {
  __typename?: 'loan_token_view_aggregate';
  aggregate?: Maybe<Loan_Token_View_Aggregate_Fields>;
  nodes: Array<Loan_Token_View>;
};

/** aggregate fields of "loan_token_view" */
export type Loan_Token_View_Aggregate_Fields = {
  __typename?: 'loan_token_view_aggregate_fields';
  avg?: Maybe<Loan_Token_View_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Loan_Token_View_Max_Fields>;
  min?: Maybe<Loan_Token_View_Min_Fields>;
  stddev?: Maybe<Loan_Token_View_Stddev_Fields>;
  stddev_pop?: Maybe<Loan_Token_View_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Loan_Token_View_Stddev_Samp_Fields>;
  sum?: Maybe<Loan_Token_View_Sum_Fields>;
  var_pop?: Maybe<Loan_Token_View_Var_Pop_Fields>;
  var_samp?: Maybe<Loan_Token_View_Var_Samp_Fields>;
  variance?: Maybe<Loan_Token_View_Variance_Fields>;
};


/** aggregate fields of "loan_token_view" */
export type Loan_Token_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Loan_Token_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Loan_Token_View_Avg_Fields = {
  __typename?: 'loan_token_view_avg_fields';
  borrowers_count?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  depositors_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  rewards_earned_total?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  utilisation_rate?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "loan_token_view". All fields are combined with a logical 'AND'. */
export type Loan_Token_View_Bool_Exp = {
  _and?: InputMaybe<Array<Loan_Token_View_Bool_Exp>>;
  _not?: InputMaybe<Loan_Token_View_Bool_Exp>;
  _or?: InputMaybe<Array<Loan_Token_View_Bool_Exp>>;
  borrowers_count?: InputMaybe<Bigint_Comparison_Exp>;
  current_interest_rate?: InputMaybe<Float8_Comparison_Exp>;
  depositors_count?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  last_updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  lending_controller_id?: InputMaybe<Bigint_Comparison_Exp>;
  loan_token_name?: InputMaybe<String_Comparison_Exp>;
  m_token_address?: InputMaybe<String_Comparison_Exp>;
  m_token_id?: InputMaybe<Bigint_Comparison_Exp>;
  paused?: InputMaybe<Boolean_Comparison_Exp>;
  rewards_earned_total?: InputMaybe<Float8_Comparison_Exp>;
  token_address?: InputMaybe<String_Comparison_Exp>;
  token_id?: InputMaybe<Bigint_Comparison_Exp>;
  token_pool_total?: InputMaybe<Float8_Comparison_Exp>;
  total_borrowed?: InputMaybe<Float8_Comparison_Exp>;
  total_remaining?: InputMaybe<Float8_Comparison_Exp>;
  utilisation_rate?: InputMaybe<Float8_Comparison_Exp>;
};

/** aggregate max on columns */
export type Loan_Token_View_Max_Fields = {
  __typename?: 'loan_token_view_max_fields';
  borrowers_count?: Maybe<Scalars['bigint']['output']>;
  current_interest_rate?: Maybe<Scalars['float8']['output']>;
  depositors_count?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated?: Maybe<Scalars['timestamptz']['output']>;
  lending_controller_id?: Maybe<Scalars['bigint']['output']>;
  loan_token_name?: Maybe<Scalars['String']['output']>;
  m_token_address?: Maybe<Scalars['String']['output']>;
  m_token_id?: Maybe<Scalars['bigint']['output']>;
  rewards_earned_total?: Maybe<Scalars['float8']['output']>;
  token_address?: Maybe<Scalars['String']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  token_pool_total?: Maybe<Scalars['float8']['output']>;
  total_borrowed?: Maybe<Scalars['float8']['output']>;
  total_remaining?: Maybe<Scalars['float8']['output']>;
  utilisation_rate?: Maybe<Scalars['float8']['output']>;
};

/** aggregate min on columns */
export type Loan_Token_View_Min_Fields = {
  __typename?: 'loan_token_view_min_fields';
  borrowers_count?: Maybe<Scalars['bigint']['output']>;
  current_interest_rate?: Maybe<Scalars['float8']['output']>;
  depositors_count?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated?: Maybe<Scalars['timestamptz']['output']>;
  lending_controller_id?: Maybe<Scalars['bigint']['output']>;
  loan_token_name?: Maybe<Scalars['String']['output']>;
  m_token_address?: Maybe<Scalars['String']['output']>;
  m_token_id?: Maybe<Scalars['bigint']['output']>;
  rewards_earned_total?: Maybe<Scalars['float8']['output']>;
  token_address?: Maybe<Scalars['String']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  token_pool_total?: Maybe<Scalars['float8']['output']>;
  total_borrowed?: Maybe<Scalars['float8']['output']>;
  total_remaining?: Maybe<Scalars['float8']['output']>;
  utilisation_rate?: Maybe<Scalars['float8']['output']>;
};

/** Ordering options when selecting data from "loan_token_view". */
export type Loan_Token_View_Order_By = {
  borrowers_count?: InputMaybe<Order_By>;
  current_interest_rate?: InputMaybe<Order_By>;
  depositors_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated?: InputMaybe<Order_By>;
  lending_controller_id?: InputMaybe<Order_By>;
  loan_token_name?: InputMaybe<Order_By>;
  m_token_address?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  paused?: InputMaybe<Order_By>;
  rewards_earned_total?: InputMaybe<Order_By>;
  token_address?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_pool_total?: InputMaybe<Order_By>;
  total_borrowed?: InputMaybe<Order_By>;
  total_remaining?: InputMaybe<Order_By>;
  utilisation_rate?: InputMaybe<Order_By>;
};

/** select columns of table "loan_token_view" */
export enum Loan_Token_View_Select_Column {
  /** column name */
  BorrowersCount = 'borrowers_count',
  /** column name */
  CurrentInterestRate = 'current_interest_rate',
  /** column name */
  DepositorsCount = 'depositors_count',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdated = 'last_updated',
  /** column name */
  LendingControllerId = 'lending_controller_id',
  /** column name */
  LoanTokenName = 'loan_token_name',
  /** column name */
  MTokenAddress = 'm_token_address',
  /** column name */
  MTokenId = 'm_token_id',
  /** column name */
  Paused = 'paused',
  /** column name */
  RewardsEarnedTotal = 'rewards_earned_total',
  /** column name */
  TokenAddress = 'token_address',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  TokenPoolTotal = 'token_pool_total',
  /** column name */
  TotalBorrowed = 'total_borrowed',
  /** column name */
  TotalRemaining = 'total_remaining',
  /** column name */
  UtilisationRate = 'utilisation_rate'
}

/** aggregate stddev on columns */
export type Loan_Token_View_Stddev_Fields = {
  __typename?: 'loan_token_view_stddev_fields';
  borrowers_count?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  depositors_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  rewards_earned_total?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  utilisation_rate?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Loan_Token_View_Stddev_Pop_Fields = {
  __typename?: 'loan_token_view_stddev_pop_fields';
  borrowers_count?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  depositors_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  rewards_earned_total?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  utilisation_rate?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Loan_Token_View_Stddev_Samp_Fields = {
  __typename?: 'loan_token_view_stddev_samp_fields';
  borrowers_count?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  depositors_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  rewards_earned_total?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  utilisation_rate?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "loan_token_view" */
export type Loan_Token_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Loan_Token_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Loan_Token_View_Stream_Cursor_Value_Input = {
  borrowers_count?: InputMaybe<Scalars['bigint']['input']>;
  current_interest_rate?: InputMaybe<Scalars['float8']['input']>;
  depositors_count?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_updated?: InputMaybe<Scalars['timestamptz']['input']>;
  lending_controller_id?: InputMaybe<Scalars['bigint']['input']>;
  loan_token_name?: InputMaybe<Scalars['String']['input']>;
  m_token_address?: InputMaybe<Scalars['String']['input']>;
  m_token_id?: InputMaybe<Scalars['bigint']['input']>;
  paused?: InputMaybe<Scalars['Boolean']['input']>;
  rewards_earned_total?: InputMaybe<Scalars['float8']['input']>;
  token_address?: InputMaybe<Scalars['String']['input']>;
  token_id?: InputMaybe<Scalars['bigint']['input']>;
  token_pool_total?: InputMaybe<Scalars['float8']['input']>;
  total_borrowed?: InputMaybe<Scalars['float8']['input']>;
  total_remaining?: InputMaybe<Scalars['float8']['input']>;
  utilisation_rate?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type Loan_Token_View_Sum_Fields = {
  __typename?: 'loan_token_view_sum_fields';
  borrowers_count?: Maybe<Scalars['bigint']['output']>;
  current_interest_rate?: Maybe<Scalars['float8']['output']>;
  depositors_count?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lending_controller_id?: Maybe<Scalars['bigint']['output']>;
  m_token_id?: Maybe<Scalars['bigint']['output']>;
  rewards_earned_total?: Maybe<Scalars['float8']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  token_pool_total?: Maybe<Scalars['float8']['output']>;
  total_borrowed?: Maybe<Scalars['float8']['output']>;
  total_remaining?: Maybe<Scalars['float8']['output']>;
  utilisation_rate?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Loan_Token_View_Var_Pop_Fields = {
  __typename?: 'loan_token_view_var_pop_fields';
  borrowers_count?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  depositors_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  rewards_earned_total?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  utilisation_rate?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Loan_Token_View_Var_Samp_Fields = {
  __typename?: 'loan_token_view_var_samp_fields';
  borrowers_count?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  depositors_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  rewards_earned_total?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  utilisation_rate?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Loan_Token_View_Variance_Fields = {
  __typename?: 'loan_token_view_variance_fields';
  borrowers_count?: Maybe<Scalars['Float']['output']>;
  current_interest_rate?: Maybe<Scalars['Float']['output']>;
  depositors_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  rewards_earned_total?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  total_remaining?: Maybe<Scalars['Float']['output']>;
  utilisation_rate?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "m_token" */
export type M_Token = {
  __typename?: 'm_token';
  /** An array relationship */
  accounts: Array<M_Token_Account>;
  /** An aggregate relationship */
  accounts_aggregate: M_Token_Account_Aggregate;
  address: Scalars['String']['output'];
  admin: Scalars['String']['output'];
  /** An array relationship */
  general_contracts: Array<M_Token_General_Contract>;
  /** An aggregate relationship */
  general_contracts_aggregate: M_Token_General_Contract_Aggregate;
  /** An object relationship */
  governance: Governance;
  governance_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  is_scaled_token: Scalars['Boolean']['output'];
  /** An array relationship */
  lambdas: Array<M_Token_Lambda>;
  /** An aggregate relationship */
  lambdas_aggregate: M_Token_Lambda_Aggregate;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  lending_controller_loan_tokens: Array<Lending_Controller_Loan_Token>;
  /** An aggregate relationship */
  lending_controller_loan_tokens_aggregate: Lending_Controller_Loan_Token_Aggregate;
  loan_token_name: Scalars['String']['output'];
  metadata: Scalars['jsonb']['output'];
  network: Scalars['String']['output'];
  /** An array relationship */
  operators: Array<M_Token_Operator>;
  /** An aggregate relationship */
  operators_aggregate: M_Token_Operator_Aggregate;
  /** An object relationship */
  token: Token;
  token_id: Scalars['bigint']['output'];
  token_reward_index: Scalars['float8']['output'];
  total_supply: Scalars['float8']['output'];
  /** An array relationship */
  whitelist_contracts: Array<M_Token_Whitelist_Contract>;
  /** An aggregate relationship */
  whitelist_contracts_aggregate: M_Token_Whitelist_Contract_Aggregate;
};


/** columns and relationships of "m_token" */
export type M_TokenAccountsArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Account_Order_By>>;
  where?: InputMaybe<M_Token_Account_Bool_Exp>;
};


/** columns and relationships of "m_token" */
export type M_TokenAccounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Account_Order_By>>;
  where?: InputMaybe<M_Token_Account_Bool_Exp>;
};


/** columns and relationships of "m_token" */
export type M_TokenGeneral_ContractsArgs = {
  distinct_on?: InputMaybe<Array<M_Token_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_General_Contract_Order_By>>;
  where?: InputMaybe<M_Token_General_Contract_Bool_Exp>;
};


/** columns and relationships of "m_token" */
export type M_TokenGeneral_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<M_Token_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_General_Contract_Order_By>>;
  where?: InputMaybe<M_Token_General_Contract_Bool_Exp>;
};


/** columns and relationships of "m_token" */
export type M_TokenLambdasArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Lambda_Order_By>>;
  where?: InputMaybe<M_Token_Lambda_Bool_Exp>;
};


/** columns and relationships of "m_token" */
export type M_TokenLambdas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Lambda_Order_By>>;
  where?: InputMaybe<M_Token_Lambda_Bool_Exp>;
};


/** columns and relationships of "m_token" */
export type M_TokenLending_Controller_Loan_TokensArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Loan_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Loan_Token_Order_By>>;
  where?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
};


/** columns and relationships of "m_token" */
export type M_TokenLending_Controller_Loan_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Loan_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Loan_Token_Order_By>>;
  where?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
};


/** columns and relationships of "m_token" */
export type M_TokenMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "m_token" */
export type M_TokenOperatorsArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Operator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Operator_Order_By>>;
  where?: InputMaybe<M_Token_Operator_Bool_Exp>;
};


/** columns and relationships of "m_token" */
export type M_TokenOperators_AggregateArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Operator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Operator_Order_By>>;
  where?: InputMaybe<M_Token_Operator_Bool_Exp>;
};


/** columns and relationships of "m_token" */
export type M_TokenWhitelist_ContractsArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<M_Token_Whitelist_Contract_Bool_Exp>;
};


/** columns and relationships of "m_token" */
export type M_TokenWhitelist_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<M_Token_Whitelist_Contract_Bool_Exp>;
};

/** columns and relationships of "m_token_account" */
export type M_Token_Account = {
  __typename?: 'm_token_account';
  balance: Scalars['float8']['output'];
  /** An array relationship */
  history_data: Array<M_Token_Account_History_Data>;
  /** An aggregate relationship */
  history_data_aggregate: M_Token_Account_History_Data_Aggregate;
  id: Scalars['bigint']['output'];
  /** An object relationship */
  m_token: M_Token;
  m_token_id: Scalars['bigint']['output'];
  reward_index: Scalars['float8']['output'];
  rewards_earned: Scalars['float8']['output'];
  /** An object relationship */
  user: Maven_User;
  user_id: Scalars['bigint']['output'];
};


/** columns and relationships of "m_token_account" */
export type M_Token_AccountHistory_DataArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Account_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Account_History_Data_Order_By>>;
  where?: InputMaybe<M_Token_Account_History_Data_Bool_Exp>;
};


/** columns and relationships of "m_token_account" */
export type M_Token_AccountHistory_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Account_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Account_History_Data_Order_By>>;
  where?: InputMaybe<M_Token_Account_History_Data_Bool_Exp>;
};

/** aggregated selection of "m_token_account" */
export type M_Token_Account_Aggregate = {
  __typename?: 'm_token_account_aggregate';
  aggregate?: Maybe<M_Token_Account_Aggregate_Fields>;
  nodes: Array<M_Token_Account>;
};

export type M_Token_Account_Aggregate_Bool_Exp = {
  avg?: InputMaybe<M_Token_Account_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<M_Token_Account_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<M_Token_Account_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<M_Token_Account_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<M_Token_Account_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<M_Token_Account_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<M_Token_Account_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<M_Token_Account_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<M_Token_Account_Aggregate_Bool_Exp_Var_Samp>;
};

export type M_Token_Account_Aggregate_Bool_Exp_Avg = {
  arguments: M_Token_Account_Select_Column_M_Token_Account_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Account_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type M_Token_Account_Aggregate_Bool_Exp_Corr = {
  arguments: M_Token_Account_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Account_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type M_Token_Account_Aggregate_Bool_Exp_Corr_Arguments = {
  X: M_Token_Account_Select_Column_M_Token_Account_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: M_Token_Account_Select_Column_M_Token_Account_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type M_Token_Account_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<M_Token_Account_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Account_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type M_Token_Account_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: M_Token_Account_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Account_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type M_Token_Account_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: M_Token_Account_Select_Column_M_Token_Account_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: M_Token_Account_Select_Column_M_Token_Account_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type M_Token_Account_Aggregate_Bool_Exp_Max = {
  arguments: M_Token_Account_Select_Column_M_Token_Account_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Account_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type M_Token_Account_Aggregate_Bool_Exp_Min = {
  arguments: M_Token_Account_Select_Column_M_Token_Account_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Account_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type M_Token_Account_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: M_Token_Account_Select_Column_M_Token_Account_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Account_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type M_Token_Account_Aggregate_Bool_Exp_Sum = {
  arguments: M_Token_Account_Select_Column_M_Token_Account_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Account_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type M_Token_Account_Aggregate_Bool_Exp_Var_Samp = {
  arguments: M_Token_Account_Select_Column_M_Token_Account_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Account_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "m_token_account" */
export type M_Token_Account_Aggregate_Fields = {
  __typename?: 'm_token_account_aggregate_fields';
  avg?: Maybe<M_Token_Account_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<M_Token_Account_Max_Fields>;
  min?: Maybe<M_Token_Account_Min_Fields>;
  stddev?: Maybe<M_Token_Account_Stddev_Fields>;
  stddev_pop?: Maybe<M_Token_Account_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<M_Token_Account_Stddev_Samp_Fields>;
  sum?: Maybe<M_Token_Account_Sum_Fields>;
  var_pop?: Maybe<M_Token_Account_Var_Pop_Fields>;
  var_samp?: Maybe<M_Token_Account_Var_Samp_Fields>;
  variance?: Maybe<M_Token_Account_Variance_Fields>;
};


/** aggregate fields of "m_token_account" */
export type M_Token_Account_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<M_Token_Account_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "m_token_account" */
export type M_Token_Account_Aggregate_Order_By = {
  avg?: InputMaybe<M_Token_Account_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<M_Token_Account_Max_Order_By>;
  min?: InputMaybe<M_Token_Account_Min_Order_By>;
  stddev?: InputMaybe<M_Token_Account_Stddev_Order_By>;
  stddev_pop?: InputMaybe<M_Token_Account_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<M_Token_Account_Stddev_Samp_Order_By>;
  sum?: InputMaybe<M_Token_Account_Sum_Order_By>;
  var_pop?: InputMaybe<M_Token_Account_Var_Pop_Order_By>;
  var_samp?: InputMaybe<M_Token_Account_Var_Samp_Order_By>;
  variance?: InputMaybe<M_Token_Account_Variance_Order_By>;
};

/** aggregate avg on columns */
export type M_Token_Account_Avg_Fields = {
  __typename?: 'm_token_account_avg_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  reward_index?: Maybe<Scalars['Float']['output']>;
  rewards_earned?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "m_token_account" */
export type M_Token_Account_Avg_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  reward_index?: InputMaybe<Order_By>;
  rewards_earned?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "m_token_account". All fields are combined with a logical 'AND'. */
export type M_Token_Account_Bool_Exp = {
  _and?: InputMaybe<Array<M_Token_Account_Bool_Exp>>;
  _not?: InputMaybe<M_Token_Account_Bool_Exp>;
  _or?: InputMaybe<Array<M_Token_Account_Bool_Exp>>;
  balance?: InputMaybe<Float8_Comparison_Exp>;
  history_data?: InputMaybe<M_Token_Account_History_Data_Bool_Exp>;
  history_data_aggregate?: InputMaybe<M_Token_Account_History_Data_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  m_token?: InputMaybe<M_Token_Bool_Exp>;
  m_token_id?: InputMaybe<Bigint_Comparison_Exp>;
  reward_index?: InputMaybe<Float8_Comparison_Exp>;
  rewards_earned?: InputMaybe<Float8_Comparison_Exp>;
  user?: InputMaybe<Maven_User_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** columns and relationships of "m_token_account_history_data" */
export type M_Token_Account_History_Data = {
  __typename?: 'm_token_account_history_data';
  balance: Scalars['float8']['output'];
  id: Scalars['bigint']['output'];
  level: Scalars['bigint']['output'];
  /** An object relationship */
  m_token_account: M_Token_Account;
  m_token_account_id: Scalars['bigint']['output'];
  operation_hash: Scalars['String']['output'];
  reward_index: Scalars['float8']['output'];
  rewards_earned: Scalars['float8']['output'];
  timestamp: Scalars['timestamptz']['output'];
  /** TRANSFER: 0\nMINT_OR_BURN: 1 */
  type: Scalars['smallint']['output'];
};

/** aggregated selection of "m_token_account_history_data" */
export type M_Token_Account_History_Data_Aggregate = {
  __typename?: 'm_token_account_history_data_aggregate';
  aggregate?: Maybe<M_Token_Account_History_Data_Aggregate_Fields>;
  nodes: Array<M_Token_Account_History_Data>;
};

export type M_Token_Account_History_Data_Aggregate_Bool_Exp = {
  avg?: InputMaybe<M_Token_Account_History_Data_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<M_Token_Account_History_Data_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<M_Token_Account_History_Data_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<M_Token_Account_History_Data_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<M_Token_Account_History_Data_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<M_Token_Account_History_Data_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<M_Token_Account_History_Data_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<M_Token_Account_History_Data_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<M_Token_Account_History_Data_Aggregate_Bool_Exp_Var_Samp>;
};

export type M_Token_Account_History_Data_Aggregate_Bool_Exp_Avg = {
  arguments: M_Token_Account_History_Data_Select_Column_M_Token_Account_History_Data_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Account_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type M_Token_Account_History_Data_Aggregate_Bool_Exp_Corr = {
  arguments: M_Token_Account_History_Data_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Account_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type M_Token_Account_History_Data_Aggregate_Bool_Exp_Corr_Arguments = {
  X: M_Token_Account_History_Data_Select_Column_M_Token_Account_History_Data_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: M_Token_Account_History_Data_Select_Column_M_Token_Account_History_Data_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type M_Token_Account_History_Data_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<M_Token_Account_History_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Account_History_Data_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type M_Token_Account_History_Data_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: M_Token_Account_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Account_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type M_Token_Account_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: M_Token_Account_History_Data_Select_Column_M_Token_Account_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: M_Token_Account_History_Data_Select_Column_M_Token_Account_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type M_Token_Account_History_Data_Aggregate_Bool_Exp_Max = {
  arguments: M_Token_Account_History_Data_Select_Column_M_Token_Account_History_Data_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Account_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type M_Token_Account_History_Data_Aggregate_Bool_Exp_Min = {
  arguments: M_Token_Account_History_Data_Select_Column_M_Token_Account_History_Data_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Account_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type M_Token_Account_History_Data_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: M_Token_Account_History_Data_Select_Column_M_Token_Account_History_Data_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Account_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type M_Token_Account_History_Data_Aggregate_Bool_Exp_Sum = {
  arguments: M_Token_Account_History_Data_Select_Column_M_Token_Account_History_Data_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Account_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type M_Token_Account_History_Data_Aggregate_Bool_Exp_Var_Samp = {
  arguments: M_Token_Account_History_Data_Select_Column_M_Token_Account_History_Data_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Account_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "m_token_account_history_data" */
export type M_Token_Account_History_Data_Aggregate_Fields = {
  __typename?: 'm_token_account_history_data_aggregate_fields';
  avg?: Maybe<M_Token_Account_History_Data_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<M_Token_Account_History_Data_Max_Fields>;
  min?: Maybe<M_Token_Account_History_Data_Min_Fields>;
  stddev?: Maybe<M_Token_Account_History_Data_Stddev_Fields>;
  stddev_pop?: Maybe<M_Token_Account_History_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<M_Token_Account_History_Data_Stddev_Samp_Fields>;
  sum?: Maybe<M_Token_Account_History_Data_Sum_Fields>;
  var_pop?: Maybe<M_Token_Account_History_Data_Var_Pop_Fields>;
  var_samp?: Maybe<M_Token_Account_History_Data_Var_Samp_Fields>;
  variance?: Maybe<M_Token_Account_History_Data_Variance_Fields>;
};


/** aggregate fields of "m_token_account_history_data" */
export type M_Token_Account_History_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<M_Token_Account_History_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "m_token_account_history_data" */
export type M_Token_Account_History_Data_Aggregate_Order_By = {
  avg?: InputMaybe<M_Token_Account_History_Data_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<M_Token_Account_History_Data_Max_Order_By>;
  min?: InputMaybe<M_Token_Account_History_Data_Min_Order_By>;
  stddev?: InputMaybe<M_Token_Account_History_Data_Stddev_Order_By>;
  stddev_pop?: InputMaybe<M_Token_Account_History_Data_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<M_Token_Account_History_Data_Stddev_Samp_Order_By>;
  sum?: InputMaybe<M_Token_Account_History_Data_Sum_Order_By>;
  var_pop?: InputMaybe<M_Token_Account_History_Data_Var_Pop_Order_By>;
  var_samp?: InputMaybe<M_Token_Account_History_Data_Var_Samp_Order_By>;
  variance?: InputMaybe<M_Token_Account_History_Data_Variance_Order_By>;
};

/** aggregate avg on columns */
export type M_Token_Account_History_Data_Avg_Fields = {
  __typename?: 'm_token_account_history_data_avg_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  m_token_account_id?: Maybe<Scalars['Float']['output']>;
  reward_index?: Maybe<Scalars['Float']['output']>;
  rewards_earned?: Maybe<Scalars['Float']['output']>;
  /** TRANSFER: 0\nMINT_OR_BURN: 1 */
  type?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "m_token_account_history_data" */
export type M_Token_Account_History_Data_Avg_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  m_token_account_id?: InputMaybe<Order_By>;
  reward_index?: InputMaybe<Order_By>;
  rewards_earned?: InputMaybe<Order_By>;
  /** TRANSFER: 0\nMINT_OR_BURN: 1 */
  type?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "m_token_account_history_data". All fields are combined with a logical 'AND'. */
export type M_Token_Account_History_Data_Bool_Exp = {
  _and?: InputMaybe<Array<M_Token_Account_History_Data_Bool_Exp>>;
  _not?: InputMaybe<M_Token_Account_History_Data_Bool_Exp>;
  _or?: InputMaybe<Array<M_Token_Account_History_Data_Bool_Exp>>;
  balance?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  level?: InputMaybe<Bigint_Comparison_Exp>;
  m_token_account?: InputMaybe<M_Token_Account_Bool_Exp>;
  m_token_account_id?: InputMaybe<Bigint_Comparison_Exp>;
  operation_hash?: InputMaybe<String_Comparison_Exp>;
  reward_index?: InputMaybe<Float8_Comparison_Exp>;
  rewards_earned?: InputMaybe<Float8_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  type?: InputMaybe<Smallint_Comparison_Exp>;
};

/** aggregate max on columns */
export type M_Token_Account_History_Data_Max_Fields = {
  __typename?: 'm_token_account_history_data_max_fields';
  balance?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  level?: Maybe<Scalars['bigint']['output']>;
  m_token_account_id?: Maybe<Scalars['bigint']['output']>;
  operation_hash?: Maybe<Scalars['String']['output']>;
  reward_index?: Maybe<Scalars['float8']['output']>;
  rewards_earned?: Maybe<Scalars['float8']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  /** TRANSFER: 0\nMINT_OR_BURN: 1 */
  type?: Maybe<Scalars['smallint']['output']>;
};

/** order by max() on columns of table "m_token_account_history_data" */
export type M_Token_Account_History_Data_Max_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  m_token_account_id?: InputMaybe<Order_By>;
  operation_hash?: InputMaybe<Order_By>;
  reward_index?: InputMaybe<Order_By>;
  rewards_earned?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  /** TRANSFER: 0\nMINT_OR_BURN: 1 */
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type M_Token_Account_History_Data_Min_Fields = {
  __typename?: 'm_token_account_history_data_min_fields';
  balance?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  level?: Maybe<Scalars['bigint']['output']>;
  m_token_account_id?: Maybe<Scalars['bigint']['output']>;
  operation_hash?: Maybe<Scalars['String']['output']>;
  reward_index?: Maybe<Scalars['float8']['output']>;
  rewards_earned?: Maybe<Scalars['float8']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  /** TRANSFER: 0\nMINT_OR_BURN: 1 */
  type?: Maybe<Scalars['smallint']['output']>;
};

/** order by min() on columns of table "m_token_account_history_data" */
export type M_Token_Account_History_Data_Min_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  m_token_account_id?: InputMaybe<Order_By>;
  operation_hash?: InputMaybe<Order_By>;
  reward_index?: InputMaybe<Order_By>;
  rewards_earned?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  /** TRANSFER: 0\nMINT_OR_BURN: 1 */
  type?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "m_token_account_history_data". */
export type M_Token_Account_History_Data_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  m_token_account?: InputMaybe<M_Token_Account_Order_By>;
  m_token_account_id?: InputMaybe<Order_By>;
  operation_hash?: InputMaybe<Order_By>;
  reward_index?: InputMaybe<Order_By>;
  rewards_earned?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "m_token_account_history_data" */
export enum M_Token_Account_History_Data_Select_Column {
  /** column name */
  Balance = 'balance',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  MTokenAccountId = 'm_token_account_id',
  /** column name */
  OperationHash = 'operation_hash',
  /** column name */
  RewardIndex = 'reward_index',
  /** column name */
  RewardsEarned = 'rewards_earned',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Type = 'type'
}

/** select "m_token_account_history_data_aggregate_bool_exp_avg_arguments_columns" columns of table "m_token_account_history_data" */
export enum M_Token_Account_History_Data_Select_Column_M_Token_Account_History_Data_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Balance = 'balance',
  /** column name */
  RewardIndex = 'reward_index',
  /** column name */
  RewardsEarned = 'rewards_earned'
}

/** select "m_token_account_history_data_aggregate_bool_exp_corr_arguments_columns" columns of table "m_token_account_history_data" */
export enum M_Token_Account_History_Data_Select_Column_M_Token_Account_History_Data_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Balance = 'balance',
  /** column name */
  RewardIndex = 'reward_index',
  /** column name */
  RewardsEarned = 'rewards_earned'
}

/** select "m_token_account_history_data_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "m_token_account_history_data" */
export enum M_Token_Account_History_Data_Select_Column_M_Token_Account_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Balance = 'balance',
  /** column name */
  RewardIndex = 'reward_index',
  /** column name */
  RewardsEarned = 'rewards_earned'
}

/** select "m_token_account_history_data_aggregate_bool_exp_max_arguments_columns" columns of table "m_token_account_history_data" */
export enum M_Token_Account_History_Data_Select_Column_M_Token_Account_History_Data_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Balance = 'balance',
  /** column name */
  RewardIndex = 'reward_index',
  /** column name */
  RewardsEarned = 'rewards_earned'
}

/** select "m_token_account_history_data_aggregate_bool_exp_min_arguments_columns" columns of table "m_token_account_history_data" */
export enum M_Token_Account_History_Data_Select_Column_M_Token_Account_History_Data_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Balance = 'balance',
  /** column name */
  RewardIndex = 'reward_index',
  /** column name */
  RewardsEarned = 'rewards_earned'
}

/** select "m_token_account_history_data_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "m_token_account_history_data" */
export enum M_Token_Account_History_Data_Select_Column_M_Token_Account_History_Data_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Balance = 'balance',
  /** column name */
  RewardIndex = 'reward_index',
  /** column name */
  RewardsEarned = 'rewards_earned'
}

/** select "m_token_account_history_data_aggregate_bool_exp_sum_arguments_columns" columns of table "m_token_account_history_data" */
export enum M_Token_Account_History_Data_Select_Column_M_Token_Account_History_Data_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Balance = 'balance',
  /** column name */
  RewardIndex = 'reward_index',
  /** column name */
  RewardsEarned = 'rewards_earned'
}

/** select "m_token_account_history_data_aggregate_bool_exp_var_samp_arguments_columns" columns of table "m_token_account_history_data" */
export enum M_Token_Account_History_Data_Select_Column_M_Token_Account_History_Data_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Balance = 'balance',
  /** column name */
  RewardIndex = 'reward_index',
  /** column name */
  RewardsEarned = 'rewards_earned'
}

/** aggregate stddev on columns */
export type M_Token_Account_History_Data_Stddev_Fields = {
  __typename?: 'm_token_account_history_data_stddev_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  m_token_account_id?: Maybe<Scalars['Float']['output']>;
  reward_index?: Maybe<Scalars['Float']['output']>;
  rewards_earned?: Maybe<Scalars['Float']['output']>;
  /** TRANSFER: 0\nMINT_OR_BURN: 1 */
  type?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "m_token_account_history_data" */
export type M_Token_Account_History_Data_Stddev_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  m_token_account_id?: InputMaybe<Order_By>;
  reward_index?: InputMaybe<Order_By>;
  rewards_earned?: InputMaybe<Order_By>;
  /** TRANSFER: 0\nMINT_OR_BURN: 1 */
  type?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type M_Token_Account_History_Data_Stddev_Pop_Fields = {
  __typename?: 'm_token_account_history_data_stddev_pop_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  m_token_account_id?: Maybe<Scalars['Float']['output']>;
  reward_index?: Maybe<Scalars['Float']['output']>;
  rewards_earned?: Maybe<Scalars['Float']['output']>;
  /** TRANSFER: 0\nMINT_OR_BURN: 1 */
  type?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "m_token_account_history_data" */
export type M_Token_Account_History_Data_Stddev_Pop_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  m_token_account_id?: InputMaybe<Order_By>;
  reward_index?: InputMaybe<Order_By>;
  rewards_earned?: InputMaybe<Order_By>;
  /** TRANSFER: 0\nMINT_OR_BURN: 1 */
  type?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type M_Token_Account_History_Data_Stddev_Samp_Fields = {
  __typename?: 'm_token_account_history_data_stddev_samp_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  m_token_account_id?: Maybe<Scalars['Float']['output']>;
  reward_index?: Maybe<Scalars['Float']['output']>;
  rewards_earned?: Maybe<Scalars['Float']['output']>;
  /** TRANSFER: 0\nMINT_OR_BURN: 1 */
  type?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "m_token_account_history_data" */
export type M_Token_Account_History_Data_Stddev_Samp_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  m_token_account_id?: InputMaybe<Order_By>;
  reward_index?: InputMaybe<Order_By>;
  rewards_earned?: InputMaybe<Order_By>;
  /** TRANSFER: 0\nMINT_OR_BURN: 1 */
  type?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "m_token_account_history_data" */
export type M_Token_Account_History_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: M_Token_Account_History_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type M_Token_Account_History_Data_Stream_Cursor_Value_Input = {
  balance?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  level?: InputMaybe<Scalars['bigint']['input']>;
  m_token_account_id?: InputMaybe<Scalars['bigint']['input']>;
  operation_hash?: InputMaybe<Scalars['String']['input']>;
  reward_index?: InputMaybe<Scalars['float8']['input']>;
  rewards_earned?: InputMaybe<Scalars['float8']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  /** TRANSFER: 0\nMINT_OR_BURN: 1 */
  type?: InputMaybe<Scalars['smallint']['input']>;
};

/** aggregate sum on columns */
export type M_Token_Account_History_Data_Sum_Fields = {
  __typename?: 'm_token_account_history_data_sum_fields';
  balance?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  level?: Maybe<Scalars['bigint']['output']>;
  m_token_account_id?: Maybe<Scalars['bigint']['output']>;
  reward_index?: Maybe<Scalars['float8']['output']>;
  rewards_earned?: Maybe<Scalars['float8']['output']>;
  /** TRANSFER: 0\nMINT_OR_BURN: 1 */
  type?: Maybe<Scalars['smallint']['output']>;
};

/** order by sum() on columns of table "m_token_account_history_data" */
export type M_Token_Account_History_Data_Sum_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  m_token_account_id?: InputMaybe<Order_By>;
  reward_index?: InputMaybe<Order_By>;
  rewards_earned?: InputMaybe<Order_By>;
  /** TRANSFER: 0\nMINT_OR_BURN: 1 */
  type?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type M_Token_Account_History_Data_Var_Pop_Fields = {
  __typename?: 'm_token_account_history_data_var_pop_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  m_token_account_id?: Maybe<Scalars['Float']['output']>;
  reward_index?: Maybe<Scalars['Float']['output']>;
  rewards_earned?: Maybe<Scalars['Float']['output']>;
  /** TRANSFER: 0\nMINT_OR_BURN: 1 */
  type?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "m_token_account_history_data" */
export type M_Token_Account_History_Data_Var_Pop_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  m_token_account_id?: InputMaybe<Order_By>;
  reward_index?: InputMaybe<Order_By>;
  rewards_earned?: InputMaybe<Order_By>;
  /** TRANSFER: 0\nMINT_OR_BURN: 1 */
  type?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type M_Token_Account_History_Data_Var_Samp_Fields = {
  __typename?: 'm_token_account_history_data_var_samp_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  m_token_account_id?: Maybe<Scalars['Float']['output']>;
  reward_index?: Maybe<Scalars['Float']['output']>;
  rewards_earned?: Maybe<Scalars['Float']['output']>;
  /** TRANSFER: 0\nMINT_OR_BURN: 1 */
  type?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "m_token_account_history_data" */
export type M_Token_Account_History_Data_Var_Samp_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  m_token_account_id?: InputMaybe<Order_By>;
  reward_index?: InputMaybe<Order_By>;
  rewards_earned?: InputMaybe<Order_By>;
  /** TRANSFER: 0\nMINT_OR_BURN: 1 */
  type?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type M_Token_Account_History_Data_Variance_Fields = {
  __typename?: 'm_token_account_history_data_variance_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  m_token_account_id?: Maybe<Scalars['Float']['output']>;
  reward_index?: Maybe<Scalars['Float']['output']>;
  rewards_earned?: Maybe<Scalars['Float']['output']>;
  /** TRANSFER: 0\nMINT_OR_BURN: 1 */
  type?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "m_token_account_history_data" */
export type M_Token_Account_History_Data_Variance_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  m_token_account_id?: InputMaybe<Order_By>;
  reward_index?: InputMaybe<Order_By>;
  rewards_earned?: InputMaybe<Order_By>;
  /** TRANSFER: 0\nMINT_OR_BURN: 1 */
  type?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type M_Token_Account_Max_Fields = {
  __typename?: 'm_token_account_max_fields';
  balance?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  m_token_id?: Maybe<Scalars['bigint']['output']>;
  reward_index?: Maybe<Scalars['float8']['output']>;
  rewards_earned?: Maybe<Scalars['float8']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "m_token_account" */
export type M_Token_Account_Max_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  reward_index?: InputMaybe<Order_By>;
  rewards_earned?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type M_Token_Account_Min_Fields = {
  __typename?: 'm_token_account_min_fields';
  balance?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  m_token_id?: Maybe<Scalars['bigint']['output']>;
  reward_index?: Maybe<Scalars['float8']['output']>;
  rewards_earned?: Maybe<Scalars['float8']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "m_token_account" */
export type M_Token_Account_Min_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  reward_index?: InputMaybe<Order_By>;
  rewards_earned?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "m_token_account". */
export type M_Token_Account_Order_By = {
  balance?: InputMaybe<Order_By>;
  history_data_aggregate?: InputMaybe<M_Token_Account_History_Data_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  m_token?: InputMaybe<M_Token_Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  reward_index?: InputMaybe<Order_By>;
  rewards_earned?: InputMaybe<Order_By>;
  user?: InputMaybe<Maven_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "m_token_account" */
export enum M_Token_Account_Select_Column {
  /** column name */
  Balance = 'balance',
  /** column name */
  Id = 'id',
  /** column name */
  MTokenId = 'm_token_id',
  /** column name */
  RewardIndex = 'reward_index',
  /** column name */
  RewardsEarned = 'rewards_earned',
  /** column name */
  UserId = 'user_id'
}

/** select "m_token_account_aggregate_bool_exp_avg_arguments_columns" columns of table "m_token_account" */
export enum M_Token_Account_Select_Column_M_Token_Account_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Balance = 'balance',
  /** column name */
  RewardIndex = 'reward_index',
  /** column name */
  RewardsEarned = 'rewards_earned'
}

/** select "m_token_account_aggregate_bool_exp_corr_arguments_columns" columns of table "m_token_account" */
export enum M_Token_Account_Select_Column_M_Token_Account_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Balance = 'balance',
  /** column name */
  RewardIndex = 'reward_index',
  /** column name */
  RewardsEarned = 'rewards_earned'
}

/** select "m_token_account_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "m_token_account" */
export enum M_Token_Account_Select_Column_M_Token_Account_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Balance = 'balance',
  /** column name */
  RewardIndex = 'reward_index',
  /** column name */
  RewardsEarned = 'rewards_earned'
}

/** select "m_token_account_aggregate_bool_exp_max_arguments_columns" columns of table "m_token_account" */
export enum M_Token_Account_Select_Column_M_Token_Account_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Balance = 'balance',
  /** column name */
  RewardIndex = 'reward_index',
  /** column name */
  RewardsEarned = 'rewards_earned'
}

/** select "m_token_account_aggregate_bool_exp_min_arguments_columns" columns of table "m_token_account" */
export enum M_Token_Account_Select_Column_M_Token_Account_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Balance = 'balance',
  /** column name */
  RewardIndex = 'reward_index',
  /** column name */
  RewardsEarned = 'rewards_earned'
}

/** select "m_token_account_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "m_token_account" */
export enum M_Token_Account_Select_Column_M_Token_Account_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Balance = 'balance',
  /** column name */
  RewardIndex = 'reward_index',
  /** column name */
  RewardsEarned = 'rewards_earned'
}

/** select "m_token_account_aggregate_bool_exp_sum_arguments_columns" columns of table "m_token_account" */
export enum M_Token_Account_Select_Column_M_Token_Account_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Balance = 'balance',
  /** column name */
  RewardIndex = 'reward_index',
  /** column name */
  RewardsEarned = 'rewards_earned'
}

/** select "m_token_account_aggregate_bool_exp_var_samp_arguments_columns" columns of table "m_token_account" */
export enum M_Token_Account_Select_Column_M_Token_Account_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Balance = 'balance',
  /** column name */
  RewardIndex = 'reward_index',
  /** column name */
  RewardsEarned = 'rewards_earned'
}

/** aggregate stddev on columns */
export type M_Token_Account_Stddev_Fields = {
  __typename?: 'm_token_account_stddev_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  reward_index?: Maybe<Scalars['Float']['output']>;
  rewards_earned?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "m_token_account" */
export type M_Token_Account_Stddev_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  reward_index?: InputMaybe<Order_By>;
  rewards_earned?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type M_Token_Account_Stddev_Pop_Fields = {
  __typename?: 'm_token_account_stddev_pop_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  reward_index?: Maybe<Scalars['Float']['output']>;
  rewards_earned?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "m_token_account" */
export type M_Token_Account_Stddev_Pop_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  reward_index?: InputMaybe<Order_By>;
  rewards_earned?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type M_Token_Account_Stddev_Samp_Fields = {
  __typename?: 'm_token_account_stddev_samp_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  reward_index?: Maybe<Scalars['Float']['output']>;
  rewards_earned?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "m_token_account" */
export type M_Token_Account_Stddev_Samp_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  reward_index?: InputMaybe<Order_By>;
  rewards_earned?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "m_token_account" */
export type M_Token_Account_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: M_Token_Account_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type M_Token_Account_Stream_Cursor_Value_Input = {
  balance?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  m_token_id?: InputMaybe<Scalars['bigint']['input']>;
  reward_index?: InputMaybe<Scalars['float8']['input']>;
  rewards_earned?: InputMaybe<Scalars['float8']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type M_Token_Account_Sum_Fields = {
  __typename?: 'm_token_account_sum_fields';
  balance?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  m_token_id?: Maybe<Scalars['bigint']['output']>;
  reward_index?: Maybe<Scalars['float8']['output']>;
  rewards_earned?: Maybe<Scalars['float8']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "m_token_account" */
export type M_Token_Account_Sum_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  reward_index?: InputMaybe<Order_By>;
  rewards_earned?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type M_Token_Account_Var_Pop_Fields = {
  __typename?: 'm_token_account_var_pop_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  reward_index?: Maybe<Scalars['Float']['output']>;
  rewards_earned?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "m_token_account" */
export type M_Token_Account_Var_Pop_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  reward_index?: InputMaybe<Order_By>;
  rewards_earned?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type M_Token_Account_Var_Samp_Fields = {
  __typename?: 'm_token_account_var_samp_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  reward_index?: Maybe<Scalars['Float']['output']>;
  rewards_earned?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "m_token_account" */
export type M_Token_Account_Var_Samp_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  reward_index?: InputMaybe<Order_By>;
  rewards_earned?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type M_Token_Account_Variance_Fields = {
  __typename?: 'm_token_account_variance_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  reward_index?: Maybe<Scalars['Float']['output']>;
  rewards_earned?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "m_token_account" */
export type M_Token_Account_Variance_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  reward_index?: InputMaybe<Order_By>;
  rewards_earned?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregated selection of "m_token" */
export type M_Token_Aggregate = {
  __typename?: 'm_token_aggregate';
  aggregate?: Maybe<M_Token_Aggregate_Fields>;
  nodes: Array<M_Token>;
};

export type M_Token_Aggregate_Bool_Exp = {
  avg?: InputMaybe<M_Token_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<M_Token_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<M_Token_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<M_Token_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<M_Token_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<M_Token_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<M_Token_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<M_Token_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<M_Token_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<M_Token_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<M_Token_Aggregate_Bool_Exp_Var_Samp>;
};

export type M_Token_Aggregate_Bool_Exp_Avg = {
  arguments: M_Token_Select_Column_M_Token_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type M_Token_Aggregate_Bool_Exp_Bool_And = {
  arguments: M_Token_Select_Column_M_Token_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type M_Token_Aggregate_Bool_Exp_Bool_Or = {
  arguments: M_Token_Select_Column_M_Token_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type M_Token_Aggregate_Bool_Exp_Corr = {
  arguments: M_Token_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type M_Token_Aggregate_Bool_Exp_Corr_Arguments = {
  X: M_Token_Select_Column_M_Token_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: M_Token_Select_Column_M_Token_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type M_Token_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<M_Token_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type M_Token_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: M_Token_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type M_Token_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: M_Token_Select_Column_M_Token_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: M_Token_Select_Column_M_Token_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type M_Token_Aggregate_Bool_Exp_Max = {
  arguments: M_Token_Select_Column_M_Token_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type M_Token_Aggregate_Bool_Exp_Min = {
  arguments: M_Token_Select_Column_M_Token_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type M_Token_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: M_Token_Select_Column_M_Token_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type M_Token_Aggregate_Bool_Exp_Sum = {
  arguments: M_Token_Select_Column_M_Token_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type M_Token_Aggregate_Bool_Exp_Var_Samp = {
  arguments: M_Token_Select_Column_M_Token_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "m_token" */
export type M_Token_Aggregate_Fields = {
  __typename?: 'm_token_aggregate_fields';
  avg?: Maybe<M_Token_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<M_Token_Max_Fields>;
  min?: Maybe<M_Token_Min_Fields>;
  stddev?: Maybe<M_Token_Stddev_Fields>;
  stddev_pop?: Maybe<M_Token_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<M_Token_Stddev_Samp_Fields>;
  sum?: Maybe<M_Token_Sum_Fields>;
  var_pop?: Maybe<M_Token_Var_Pop_Fields>;
  var_samp?: Maybe<M_Token_Var_Samp_Fields>;
  variance?: Maybe<M_Token_Variance_Fields>;
};


/** aggregate fields of "m_token" */
export type M_Token_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<M_Token_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "m_token" */
export type M_Token_Aggregate_Order_By = {
  avg?: InputMaybe<M_Token_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<M_Token_Max_Order_By>;
  min?: InputMaybe<M_Token_Min_Order_By>;
  stddev?: InputMaybe<M_Token_Stddev_Order_By>;
  stddev_pop?: InputMaybe<M_Token_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<M_Token_Stddev_Samp_Order_By>;
  sum?: InputMaybe<M_Token_Sum_Order_By>;
  var_pop?: InputMaybe<M_Token_Var_Pop_Order_By>;
  var_samp?: InputMaybe<M_Token_Var_Samp_Order_By>;
  variance?: InputMaybe<M_Token_Variance_Order_By>;
};

/** aggregate avg on columns */
export type M_Token_Avg_Fields = {
  __typename?: 'm_token_avg_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_reward_index?: Maybe<Scalars['Float']['output']>;
  total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "m_token" */
export type M_Token_Avg_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  total_supply?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "m_token". All fields are combined with a logical 'AND'. */
export type M_Token_Bool_Exp = {
  _and?: InputMaybe<Array<M_Token_Bool_Exp>>;
  _not?: InputMaybe<M_Token_Bool_Exp>;
  _or?: InputMaybe<Array<M_Token_Bool_Exp>>;
  accounts?: InputMaybe<M_Token_Account_Bool_Exp>;
  accounts_aggregate?: InputMaybe<M_Token_Account_Aggregate_Bool_Exp>;
  address?: InputMaybe<String_Comparison_Exp>;
  admin?: InputMaybe<String_Comparison_Exp>;
  general_contracts?: InputMaybe<M_Token_General_Contract_Bool_Exp>;
  general_contracts_aggregate?: InputMaybe<M_Token_General_Contract_Aggregate_Bool_Exp>;
  governance?: InputMaybe<Governance_Bool_Exp>;
  governance_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_scaled_token?: InputMaybe<Boolean_Comparison_Exp>;
  lambdas?: InputMaybe<M_Token_Lambda_Bool_Exp>;
  lambdas_aggregate?: InputMaybe<M_Token_Lambda_Aggregate_Bool_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  lending_controller_loan_tokens?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
  lending_controller_loan_tokens_aggregate?: InputMaybe<Lending_Controller_Loan_Token_Aggregate_Bool_Exp>;
  loan_token_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
  operators?: InputMaybe<M_Token_Operator_Bool_Exp>;
  operators_aggregate?: InputMaybe<M_Token_Operator_Aggregate_Bool_Exp>;
  token?: InputMaybe<Token_Bool_Exp>;
  token_id?: InputMaybe<Bigint_Comparison_Exp>;
  token_reward_index?: InputMaybe<Float8_Comparison_Exp>;
  total_supply?: InputMaybe<Float8_Comparison_Exp>;
  whitelist_contracts?: InputMaybe<M_Token_Whitelist_Contract_Bool_Exp>;
  whitelist_contracts_aggregate?: InputMaybe<M_Token_Whitelist_Contract_Aggregate_Bool_Exp>;
};

/** columns and relationships of "m_token_general_contract" */
export type M_Token_General_Contract = {
  __typename?: 'm_token_general_contract';
  /** An object relationship */
  contract: M_Token;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  contract_name: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "m_token_general_contract" */
export type M_Token_General_Contract_Aggregate = {
  __typename?: 'm_token_general_contract_aggregate';
  aggregate?: Maybe<M_Token_General_Contract_Aggregate_Fields>;
  nodes: Array<M_Token_General_Contract>;
};

export type M_Token_General_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<M_Token_General_Contract_Aggregate_Bool_Exp_Count>;
};

export type M_Token_General_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<M_Token_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_General_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "m_token_general_contract" */
export type M_Token_General_Contract_Aggregate_Fields = {
  __typename?: 'm_token_general_contract_aggregate_fields';
  avg?: Maybe<M_Token_General_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<M_Token_General_Contract_Max_Fields>;
  min?: Maybe<M_Token_General_Contract_Min_Fields>;
  stddev?: Maybe<M_Token_General_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<M_Token_General_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<M_Token_General_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<M_Token_General_Contract_Sum_Fields>;
  var_pop?: Maybe<M_Token_General_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<M_Token_General_Contract_Var_Samp_Fields>;
  variance?: Maybe<M_Token_General_Contract_Variance_Fields>;
};


/** aggregate fields of "m_token_general_contract" */
export type M_Token_General_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<M_Token_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "m_token_general_contract" */
export type M_Token_General_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<M_Token_General_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<M_Token_General_Contract_Max_Order_By>;
  min?: InputMaybe<M_Token_General_Contract_Min_Order_By>;
  stddev?: InputMaybe<M_Token_General_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<M_Token_General_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<M_Token_General_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<M_Token_General_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<M_Token_General_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<M_Token_General_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<M_Token_General_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type M_Token_General_Contract_Avg_Fields = {
  __typename?: 'm_token_general_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "m_token_general_contract" */
export type M_Token_General_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "m_token_general_contract". All fields are combined with a logical 'AND'. */
export type M_Token_General_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<M_Token_General_Contract_Bool_Exp>>;
  _not?: InputMaybe<M_Token_General_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<M_Token_General_Contract_Bool_Exp>>;
  contract?: InputMaybe<M_Token_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  contract_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type M_Token_General_Contract_Max_Fields = {
  __typename?: 'm_token_general_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "m_token_general_contract" */
export type M_Token_General_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type M_Token_General_Contract_Min_Fields = {
  __typename?: 'm_token_general_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "m_token_general_contract" */
export type M_Token_General_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "m_token_general_contract". */
export type M_Token_General_Contract_Order_By = {
  contract?: InputMaybe<M_Token_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "m_token_general_contract" */
export enum M_Token_General_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  ContractName = 'contract_name',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type M_Token_General_Contract_Stddev_Fields = {
  __typename?: 'm_token_general_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "m_token_general_contract" */
export type M_Token_General_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type M_Token_General_Contract_Stddev_Pop_Fields = {
  __typename?: 'm_token_general_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "m_token_general_contract" */
export type M_Token_General_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type M_Token_General_Contract_Stddev_Samp_Fields = {
  __typename?: 'm_token_general_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "m_token_general_contract" */
export type M_Token_General_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "m_token_general_contract" */
export type M_Token_General_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: M_Token_General_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type M_Token_General_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  contract_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type M_Token_General_Contract_Sum_Fields = {
  __typename?: 'm_token_general_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "m_token_general_contract" */
export type M_Token_General_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type M_Token_General_Contract_Var_Pop_Fields = {
  __typename?: 'm_token_general_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "m_token_general_contract" */
export type M_Token_General_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type M_Token_General_Contract_Var_Samp_Fields = {
  __typename?: 'm_token_general_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "m_token_general_contract" */
export type M_Token_General_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type M_Token_General_Contract_Variance_Fields = {
  __typename?: 'm_token_general_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "m_token_general_contract" */
export type M_Token_General_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "m_token_lambda" */
export type M_Token_Lambda = {
  __typename?: 'm_token_lambda';
  /** An object relationship */
  contract: M_Token;
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lambda_bytes: Scalars['String']['output'];
  lambda_name: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "m_token_lambda" */
export type M_Token_Lambda_Aggregate = {
  __typename?: 'm_token_lambda_aggregate';
  aggregate?: Maybe<M_Token_Lambda_Aggregate_Fields>;
  nodes: Array<M_Token_Lambda>;
};

export type M_Token_Lambda_Aggregate_Bool_Exp = {
  count?: InputMaybe<M_Token_Lambda_Aggregate_Bool_Exp_Count>;
};

export type M_Token_Lambda_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<M_Token_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Lambda_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "m_token_lambda" */
export type M_Token_Lambda_Aggregate_Fields = {
  __typename?: 'm_token_lambda_aggregate_fields';
  avg?: Maybe<M_Token_Lambda_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<M_Token_Lambda_Max_Fields>;
  min?: Maybe<M_Token_Lambda_Min_Fields>;
  stddev?: Maybe<M_Token_Lambda_Stddev_Fields>;
  stddev_pop?: Maybe<M_Token_Lambda_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<M_Token_Lambda_Stddev_Samp_Fields>;
  sum?: Maybe<M_Token_Lambda_Sum_Fields>;
  var_pop?: Maybe<M_Token_Lambda_Var_Pop_Fields>;
  var_samp?: Maybe<M_Token_Lambda_Var_Samp_Fields>;
  variance?: Maybe<M_Token_Lambda_Variance_Fields>;
};


/** aggregate fields of "m_token_lambda" */
export type M_Token_Lambda_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<M_Token_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "m_token_lambda" */
export type M_Token_Lambda_Aggregate_Order_By = {
  avg?: InputMaybe<M_Token_Lambda_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<M_Token_Lambda_Max_Order_By>;
  min?: InputMaybe<M_Token_Lambda_Min_Order_By>;
  stddev?: InputMaybe<M_Token_Lambda_Stddev_Order_By>;
  stddev_pop?: InputMaybe<M_Token_Lambda_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<M_Token_Lambda_Stddev_Samp_Order_By>;
  sum?: InputMaybe<M_Token_Lambda_Sum_Order_By>;
  var_pop?: InputMaybe<M_Token_Lambda_Var_Pop_Order_By>;
  var_samp?: InputMaybe<M_Token_Lambda_Var_Samp_Order_By>;
  variance?: InputMaybe<M_Token_Lambda_Variance_Order_By>;
};

/** aggregate avg on columns */
export type M_Token_Lambda_Avg_Fields = {
  __typename?: 'm_token_lambda_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "m_token_lambda" */
export type M_Token_Lambda_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "m_token_lambda". All fields are combined with a logical 'AND'. */
export type M_Token_Lambda_Bool_Exp = {
  _and?: InputMaybe<Array<M_Token_Lambda_Bool_Exp>>;
  _not?: InputMaybe<M_Token_Lambda_Bool_Exp>;
  _or?: InputMaybe<Array<M_Token_Lambda_Bool_Exp>>;
  contract?: InputMaybe<M_Token_Bool_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambda_bytes?: InputMaybe<String_Comparison_Exp>;
  lambda_name?: InputMaybe<String_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type M_Token_Lambda_Max_Fields = {
  __typename?: 'm_token_lambda_max_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "m_token_lambda" */
export type M_Token_Lambda_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type M_Token_Lambda_Min_Fields = {
  __typename?: 'm_token_lambda_min_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "m_token_lambda" */
export type M_Token_Lambda_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "m_token_lambda". */
export type M_Token_Lambda_Order_By = {
  contract?: InputMaybe<M_Token_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "m_token_lambda" */
export enum M_Token_Lambda_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaBytes = 'lambda_bytes',
  /** column name */
  LambdaName = 'lambda_name',
  /** column name */
  LastUpdatedAt = 'last_updated_at'
}

/** aggregate stddev on columns */
export type M_Token_Lambda_Stddev_Fields = {
  __typename?: 'm_token_lambda_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "m_token_lambda" */
export type M_Token_Lambda_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type M_Token_Lambda_Stddev_Pop_Fields = {
  __typename?: 'm_token_lambda_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "m_token_lambda" */
export type M_Token_Lambda_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type M_Token_Lambda_Stddev_Samp_Fields = {
  __typename?: 'm_token_lambda_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "m_token_lambda" */
export type M_Token_Lambda_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "m_token_lambda" */
export type M_Token_Lambda_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: M_Token_Lambda_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type M_Token_Lambda_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lambda_bytes?: InputMaybe<Scalars['String']['input']>;
  lambda_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type M_Token_Lambda_Sum_Fields = {
  __typename?: 'm_token_lambda_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "m_token_lambda" */
export type M_Token_Lambda_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type M_Token_Lambda_Var_Pop_Fields = {
  __typename?: 'm_token_lambda_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "m_token_lambda" */
export type M_Token_Lambda_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type M_Token_Lambda_Var_Samp_Fields = {
  __typename?: 'm_token_lambda_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "m_token_lambda" */
export type M_Token_Lambda_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type M_Token_Lambda_Variance_Fields = {
  __typename?: 'm_token_lambda_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "m_token_lambda" */
export type M_Token_Lambda_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type M_Token_Max_Fields = {
  __typename?: 'm_token_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  loan_token_name?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  token_reward_index?: Maybe<Scalars['float8']['output']>;
  total_supply?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "m_token" */
export type M_Token_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  loan_token_name?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  total_supply?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type M_Token_Min_Fields = {
  __typename?: 'm_token_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  loan_token_name?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  token_reward_index?: Maybe<Scalars['float8']['output']>;
  total_supply?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "m_token" */
export type M_Token_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  loan_token_name?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  total_supply?: InputMaybe<Order_By>;
};

/** columns and relationships of "m_token_operator" */
export type M_Token_Operator = {
  __typename?: 'm_token_operator';
  id: Scalars['bigint']['output'];
  /** An object relationship */
  m_token: M_Token;
  m_token_id: Scalars['bigint']['output'];
  /** An object relationship */
  operator: Maven_User;
  operator_id: Scalars['bigint']['output'];
  /** An object relationship */
  owner: Maven_User;
  owner_id: Scalars['bigint']['output'];
};

/** aggregated selection of "m_token_operator" */
export type M_Token_Operator_Aggregate = {
  __typename?: 'm_token_operator_aggregate';
  aggregate?: Maybe<M_Token_Operator_Aggregate_Fields>;
  nodes: Array<M_Token_Operator>;
};

export type M_Token_Operator_Aggregate_Bool_Exp = {
  count?: InputMaybe<M_Token_Operator_Aggregate_Bool_Exp_Count>;
};

export type M_Token_Operator_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<M_Token_Operator_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Operator_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "m_token_operator" */
export type M_Token_Operator_Aggregate_Fields = {
  __typename?: 'm_token_operator_aggregate_fields';
  avg?: Maybe<M_Token_Operator_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<M_Token_Operator_Max_Fields>;
  min?: Maybe<M_Token_Operator_Min_Fields>;
  stddev?: Maybe<M_Token_Operator_Stddev_Fields>;
  stddev_pop?: Maybe<M_Token_Operator_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<M_Token_Operator_Stddev_Samp_Fields>;
  sum?: Maybe<M_Token_Operator_Sum_Fields>;
  var_pop?: Maybe<M_Token_Operator_Var_Pop_Fields>;
  var_samp?: Maybe<M_Token_Operator_Var_Samp_Fields>;
  variance?: Maybe<M_Token_Operator_Variance_Fields>;
};


/** aggregate fields of "m_token_operator" */
export type M_Token_Operator_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<M_Token_Operator_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "m_token_operator" */
export type M_Token_Operator_Aggregate_Order_By = {
  avg?: InputMaybe<M_Token_Operator_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<M_Token_Operator_Max_Order_By>;
  min?: InputMaybe<M_Token_Operator_Min_Order_By>;
  stddev?: InputMaybe<M_Token_Operator_Stddev_Order_By>;
  stddev_pop?: InputMaybe<M_Token_Operator_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<M_Token_Operator_Stddev_Samp_Order_By>;
  sum?: InputMaybe<M_Token_Operator_Sum_Order_By>;
  var_pop?: InputMaybe<M_Token_Operator_Var_Pop_Order_By>;
  var_samp?: InputMaybe<M_Token_Operator_Var_Samp_Order_By>;
  variance?: InputMaybe<M_Token_Operator_Variance_Order_By>;
};

/** aggregate avg on columns */
export type M_Token_Operator_Avg_Fields = {
  __typename?: 'm_token_operator_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  operator_id?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "m_token_operator" */
export type M_Token_Operator_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  operator_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "m_token_operator". All fields are combined with a logical 'AND'. */
export type M_Token_Operator_Bool_Exp = {
  _and?: InputMaybe<Array<M_Token_Operator_Bool_Exp>>;
  _not?: InputMaybe<M_Token_Operator_Bool_Exp>;
  _or?: InputMaybe<Array<M_Token_Operator_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  m_token?: InputMaybe<M_Token_Bool_Exp>;
  m_token_id?: InputMaybe<Bigint_Comparison_Exp>;
  operator?: InputMaybe<Maven_User_Bool_Exp>;
  operator_id?: InputMaybe<Bigint_Comparison_Exp>;
  owner?: InputMaybe<Maven_User_Bool_Exp>;
  owner_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type M_Token_Operator_Max_Fields = {
  __typename?: 'm_token_operator_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  m_token_id?: Maybe<Scalars['bigint']['output']>;
  operator_id?: Maybe<Scalars['bigint']['output']>;
  owner_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "m_token_operator" */
export type M_Token_Operator_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  operator_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type M_Token_Operator_Min_Fields = {
  __typename?: 'm_token_operator_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  m_token_id?: Maybe<Scalars['bigint']['output']>;
  operator_id?: Maybe<Scalars['bigint']['output']>;
  owner_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "m_token_operator" */
export type M_Token_Operator_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  operator_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "m_token_operator". */
export type M_Token_Operator_Order_By = {
  id?: InputMaybe<Order_By>;
  m_token?: InputMaybe<M_Token_Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  operator?: InputMaybe<Maven_User_Order_By>;
  operator_id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Maven_User_Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** select columns of table "m_token_operator" */
export enum M_Token_Operator_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MTokenId = 'm_token_id',
  /** column name */
  OperatorId = 'operator_id',
  /** column name */
  OwnerId = 'owner_id'
}

/** aggregate stddev on columns */
export type M_Token_Operator_Stddev_Fields = {
  __typename?: 'm_token_operator_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  operator_id?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "m_token_operator" */
export type M_Token_Operator_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  operator_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type M_Token_Operator_Stddev_Pop_Fields = {
  __typename?: 'm_token_operator_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  operator_id?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "m_token_operator" */
export type M_Token_Operator_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  operator_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type M_Token_Operator_Stddev_Samp_Fields = {
  __typename?: 'm_token_operator_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  operator_id?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "m_token_operator" */
export type M_Token_Operator_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  operator_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "m_token_operator" */
export type M_Token_Operator_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: M_Token_Operator_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type M_Token_Operator_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  m_token_id?: InputMaybe<Scalars['bigint']['input']>;
  operator_id?: InputMaybe<Scalars['bigint']['input']>;
  owner_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type M_Token_Operator_Sum_Fields = {
  __typename?: 'm_token_operator_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  m_token_id?: Maybe<Scalars['bigint']['output']>;
  operator_id?: Maybe<Scalars['bigint']['output']>;
  owner_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "m_token_operator" */
export type M_Token_Operator_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  operator_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type M_Token_Operator_Var_Pop_Fields = {
  __typename?: 'm_token_operator_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  operator_id?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "m_token_operator" */
export type M_Token_Operator_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  operator_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type M_Token_Operator_Var_Samp_Fields = {
  __typename?: 'm_token_operator_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  operator_id?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "m_token_operator" */
export type M_Token_Operator_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  operator_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type M_Token_Operator_Variance_Fields = {
  __typename?: 'm_token_operator_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  m_token_id?: Maybe<Scalars['Float']['output']>;
  operator_id?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "m_token_operator" */
export type M_Token_Operator_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  m_token_id?: InputMaybe<Order_By>;
  operator_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "m_token". */
export type M_Token_Order_By = {
  accounts_aggregate?: InputMaybe<M_Token_Account_Aggregate_Order_By>;
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  general_contracts_aggregate?: InputMaybe<M_Token_General_Contract_Aggregate_Order_By>;
  governance?: InputMaybe<Governance_Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_scaled_token?: InputMaybe<Order_By>;
  lambdas_aggregate?: InputMaybe<M_Token_Lambda_Aggregate_Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  lending_controller_loan_tokens_aggregate?: InputMaybe<Lending_Controller_Loan_Token_Aggregate_Order_By>;
  loan_token_name?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  operators_aggregate?: InputMaybe<M_Token_Operator_Aggregate_Order_By>;
  token?: InputMaybe<Token_Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  total_supply?: InputMaybe<Order_By>;
  whitelist_contracts_aggregate?: InputMaybe<M_Token_Whitelist_Contract_Aggregate_Order_By>;
};

/** select columns of table "m_token" */
export enum M_Token_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Admin = 'admin',
  /** column name */
  GovernanceId = 'governance_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsScaledToken = 'is_scaled_token',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  LoanTokenName = 'loan_token_name',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Network = 'network',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  TotalSupply = 'total_supply'
}

/** select "m_token_aggregate_bool_exp_avg_arguments_columns" columns of table "m_token" */
export enum M_Token_Select_Column_M_Token_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  TotalSupply = 'total_supply'
}

/** select "m_token_aggregate_bool_exp_bool_and_arguments_columns" columns of table "m_token" */
export enum M_Token_Select_Column_M_Token_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsScaledToken = 'is_scaled_token'
}

/** select "m_token_aggregate_bool_exp_bool_or_arguments_columns" columns of table "m_token" */
export enum M_Token_Select_Column_M_Token_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsScaledToken = 'is_scaled_token'
}

/** select "m_token_aggregate_bool_exp_corr_arguments_columns" columns of table "m_token" */
export enum M_Token_Select_Column_M_Token_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  TotalSupply = 'total_supply'
}

/** select "m_token_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "m_token" */
export enum M_Token_Select_Column_M_Token_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  TotalSupply = 'total_supply'
}

/** select "m_token_aggregate_bool_exp_max_arguments_columns" columns of table "m_token" */
export enum M_Token_Select_Column_M_Token_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  TotalSupply = 'total_supply'
}

/** select "m_token_aggregate_bool_exp_min_arguments_columns" columns of table "m_token" */
export enum M_Token_Select_Column_M_Token_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  TotalSupply = 'total_supply'
}

/** select "m_token_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "m_token" */
export enum M_Token_Select_Column_M_Token_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  TotalSupply = 'total_supply'
}

/** select "m_token_aggregate_bool_exp_sum_arguments_columns" columns of table "m_token" */
export enum M_Token_Select_Column_M_Token_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  TotalSupply = 'total_supply'
}

/** select "m_token_aggregate_bool_exp_var_samp_arguments_columns" columns of table "m_token" */
export enum M_Token_Select_Column_M_Token_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  TokenRewardIndex = 'token_reward_index',
  /** column name */
  TotalSupply = 'total_supply'
}

/** aggregate stddev on columns */
export type M_Token_Stddev_Fields = {
  __typename?: 'm_token_stddev_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_reward_index?: Maybe<Scalars['Float']['output']>;
  total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "m_token" */
export type M_Token_Stddev_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  total_supply?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type M_Token_Stddev_Pop_Fields = {
  __typename?: 'm_token_stddev_pop_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_reward_index?: Maybe<Scalars['Float']['output']>;
  total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "m_token" */
export type M_Token_Stddev_Pop_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  total_supply?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type M_Token_Stddev_Samp_Fields = {
  __typename?: 'm_token_stddev_samp_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_reward_index?: Maybe<Scalars['Float']['output']>;
  total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "m_token" */
export type M_Token_Stddev_Samp_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  total_supply?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "m_token" */
export type M_Token_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: M_Token_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type M_Token_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['String']['input']>;
  governance_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_scaled_token?: InputMaybe<Scalars['Boolean']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  loan_token_name?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  token_id?: InputMaybe<Scalars['bigint']['input']>;
  token_reward_index?: InputMaybe<Scalars['float8']['input']>;
  total_supply?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type M_Token_Sum_Fields = {
  __typename?: 'm_token_sum_fields';
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  token_reward_index?: Maybe<Scalars['float8']['output']>;
  total_supply?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "m_token" */
export type M_Token_Sum_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  total_supply?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type M_Token_Var_Pop_Fields = {
  __typename?: 'm_token_var_pop_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_reward_index?: Maybe<Scalars['Float']['output']>;
  total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "m_token" */
export type M_Token_Var_Pop_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  total_supply?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type M_Token_Var_Samp_Fields = {
  __typename?: 'm_token_var_samp_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_reward_index?: Maybe<Scalars['Float']['output']>;
  total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "m_token" */
export type M_Token_Var_Samp_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  total_supply?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type M_Token_Variance_Fields = {
  __typename?: 'm_token_variance_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  token_reward_index?: Maybe<Scalars['Float']['output']>;
  total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "m_token" */
export type M_Token_Variance_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_reward_index?: InputMaybe<Order_By>;
  total_supply?: InputMaybe<Order_By>;
};

/** columns and relationships of "m_token_whitelist_contract" */
export type M_Token_Whitelist_Contract = {
  __typename?: 'm_token_whitelist_contract';
  /** An object relationship */
  contract: M_Token;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "m_token_whitelist_contract" */
export type M_Token_Whitelist_Contract_Aggregate = {
  __typename?: 'm_token_whitelist_contract_aggregate';
  aggregate?: Maybe<M_Token_Whitelist_Contract_Aggregate_Fields>;
  nodes: Array<M_Token_Whitelist_Contract>;
};

export type M_Token_Whitelist_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<M_Token_Whitelist_Contract_Aggregate_Bool_Exp_Count>;
};

export type M_Token_Whitelist_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<M_Token_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<M_Token_Whitelist_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "m_token_whitelist_contract" */
export type M_Token_Whitelist_Contract_Aggregate_Fields = {
  __typename?: 'm_token_whitelist_contract_aggregate_fields';
  avg?: Maybe<M_Token_Whitelist_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<M_Token_Whitelist_Contract_Max_Fields>;
  min?: Maybe<M_Token_Whitelist_Contract_Min_Fields>;
  stddev?: Maybe<M_Token_Whitelist_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<M_Token_Whitelist_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<M_Token_Whitelist_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<M_Token_Whitelist_Contract_Sum_Fields>;
  var_pop?: Maybe<M_Token_Whitelist_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<M_Token_Whitelist_Contract_Var_Samp_Fields>;
  variance?: Maybe<M_Token_Whitelist_Contract_Variance_Fields>;
};


/** aggregate fields of "m_token_whitelist_contract" */
export type M_Token_Whitelist_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<M_Token_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "m_token_whitelist_contract" */
export type M_Token_Whitelist_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<M_Token_Whitelist_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<M_Token_Whitelist_Contract_Max_Order_By>;
  min?: InputMaybe<M_Token_Whitelist_Contract_Min_Order_By>;
  stddev?: InputMaybe<M_Token_Whitelist_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<M_Token_Whitelist_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<M_Token_Whitelist_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<M_Token_Whitelist_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<M_Token_Whitelist_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<M_Token_Whitelist_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<M_Token_Whitelist_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type M_Token_Whitelist_Contract_Avg_Fields = {
  __typename?: 'm_token_whitelist_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "m_token_whitelist_contract" */
export type M_Token_Whitelist_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "m_token_whitelist_contract". All fields are combined with a logical 'AND'. */
export type M_Token_Whitelist_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<M_Token_Whitelist_Contract_Bool_Exp>>;
  _not?: InputMaybe<M_Token_Whitelist_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<M_Token_Whitelist_Contract_Bool_Exp>>;
  contract?: InputMaybe<M_Token_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type M_Token_Whitelist_Contract_Max_Fields = {
  __typename?: 'm_token_whitelist_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "m_token_whitelist_contract" */
export type M_Token_Whitelist_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type M_Token_Whitelist_Contract_Min_Fields = {
  __typename?: 'm_token_whitelist_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "m_token_whitelist_contract" */
export type M_Token_Whitelist_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "m_token_whitelist_contract". */
export type M_Token_Whitelist_Contract_Order_By = {
  contract?: InputMaybe<M_Token_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "m_token_whitelist_contract" */
export enum M_Token_Whitelist_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type M_Token_Whitelist_Contract_Stddev_Fields = {
  __typename?: 'm_token_whitelist_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "m_token_whitelist_contract" */
export type M_Token_Whitelist_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type M_Token_Whitelist_Contract_Stddev_Pop_Fields = {
  __typename?: 'm_token_whitelist_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "m_token_whitelist_contract" */
export type M_Token_Whitelist_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type M_Token_Whitelist_Contract_Stddev_Samp_Fields = {
  __typename?: 'm_token_whitelist_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "m_token_whitelist_contract" */
export type M_Token_Whitelist_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "m_token_whitelist_contract" */
export type M_Token_Whitelist_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: M_Token_Whitelist_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type M_Token_Whitelist_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type M_Token_Whitelist_Contract_Sum_Fields = {
  __typename?: 'm_token_whitelist_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "m_token_whitelist_contract" */
export type M_Token_Whitelist_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type M_Token_Whitelist_Contract_Var_Pop_Fields = {
  __typename?: 'm_token_whitelist_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "m_token_whitelist_contract" */
export type M_Token_Whitelist_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type M_Token_Whitelist_Contract_Var_Samp_Fields = {
  __typename?: 'm_token_whitelist_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "m_token_whitelist_contract" */
export type M_Token_Whitelist_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type M_Token_Whitelist_Contract_Variance_Fields = {
  __typename?: 'm_token_whitelist_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "m_token_whitelist_contract" */
export type M_Token_Whitelist_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "maven_user" */
export type Maven_User = {
  __typename?: 'maven_user';
  address: Scalars['String']['output'];
  /** An array relationship */
  aggregator_oracles: Array<Aggregator_Oracle>;
  /** An aggregate relationship */
  aggregator_oracles_aggregate: Aggregator_Oracle_Aggregate;
  /** An array relationship */
  break_glass_action_signers: Array<Break_Glass_Action_Signer>;
  /** An aggregate relationship */
  break_glass_action_signers_aggregate: Break_Glass_Action_Signer_Aggregate;
  /** An array relationship */
  break_glass_actions_initiator: Array<Break_Glass_Action>;
  /** An aggregate relationship */
  break_glass_actions_initiator_aggregate: Break_Glass_Action_Aggregate;
  /** An array relationship */
  break_glass_council_members: Array<Break_Glass_Council_Member>;
  /** An aggregate relationship */
  break_glass_council_members_aggregate: Break_Glass_Council_Member_Aggregate;
  /** An array relationship */
  council_actions_initiator: Array<Council_Action>;
  /** An aggregate relationship */
  council_actions_initiator_aggregate: Council_Action_Aggregate;
  /** An array relationship */
  council_actions_signer: Array<Council_Action_Signer>;
  /** An aggregate relationship */
  council_actions_signer_aggregate: Council_Action_Signer_Aggregate;
  /** An array relationship */
  council_council_members: Array<Council_Council_Member>;
  /** An aggregate relationship */
  council_council_members_aggregate: Council_Council_Member_Aggregate;
  /** An array relationship */
  delegated_treasuries: Array<Treasury>;
  /** An aggregate relationship */
  delegated_treasuries_aggregate: Treasury_Aggregate;
  /** An array relationship */
  delegated_vaults: Array<Vault>;
  /** An aggregate relationship */
  delegated_vaults_aggregate: Vault_Aggregate;
  /** An array relationship */
  delegations: Array<Delegation_Record>;
  /** An aggregate relationship */
  delegations_aggregate: Delegation_Record_Aggregate;
  /** An array relationship */
  doorman_stake_accounts: Array<Doorman_Stake_Account>;
  /** An aggregate relationship */
  doorman_stake_accounts_aggregate: Doorman_Stake_Account_Aggregate;
  /** An array relationship */
  emergency_governance_proposer: Array<Emergency_Governance_Record>;
  /** An aggregate relationship */
  emergency_governance_proposer_aggregate: Emergency_Governance_Record_Aggregate;
  /** An array relationship */
  emergency_governance_votes: Array<Emergency_Governance_Vote>;
  /** An aggregate relationship */
  emergency_governance_votes_aggregate: Emergency_Governance_Vote_Aggregate;
  /** An array relationship */
  farm_accounts: Array<Farm_Account>;
  /** An aggregate relationship */
  farm_accounts_aggregate: Farm_Account_Aggregate;
  /** An array relationship */
  governance_financial_requests_receiver: Array<Governance_Financial_Request>;
  /** An aggregate relationship */
  governance_financial_requests_receiver_aggregate: Governance_Financial_Request_Aggregate;
  /** An array relationship */
  governance_financial_requests_requester: Array<Governance_Financial_Request>;
  /** An aggregate relationship */
  governance_financial_requests_requester_aggregate: Governance_Financial_Request_Aggregate;
  /** An array relationship */
  governance_financial_requests_votes: Array<Governance_Financial_Request_Vote>;
  /** An aggregate relationship */
  governance_financial_requests_votes_aggregate: Governance_Financial_Request_Vote_Aggregate;
  /** An array relationship */
  governance_proposals_payments: Array<Governance_Proposal_Payment>;
  /** An aggregate relationship */
  governance_proposals_payments_aggregate: Governance_Proposal_Payment_Aggregate;
  /** An array relationship */
  governance_proposals_proposer: Array<Governance_Proposal>;
  /** An aggregate relationship */
  governance_proposals_proposer_aggregate: Governance_Proposal_Aggregate;
  /** An array relationship */
  governance_proposals_votes: Array<Governance_Proposal_Vote>;
  /** An aggregate relationship */
  governance_proposals_votes_aggregate: Governance_Proposal_Vote_Aggregate;
  /** An array relationship */
  governance_satellite_action_initiators: Array<Governance_Satellite_Action>;
  /** An aggregate relationship */
  governance_satellite_action_initiators_aggregate: Governance_Satellite_Action_Aggregate;
  /** An array relationship */
  governance_satellite_actions_votes: Array<Governance_Satellite_Action_Vote>;
  /** An aggregate relationship */
  governance_satellite_actions_votes_aggregate: Governance_Satellite_Action_Vote_Aggregate;
  /** An array relationship */
  governance_satellite_oracles: Array<Governance_Satellite_Oracle>;
  /** An aggregate relationship */
  governance_satellite_oracles_aggregate: Governance_Satellite_Oracle_Aggregate;
  /** An array relationship */
  governance_satellite_snapshots: Array<Governance_Satellite_Snapshot>;
  /** An aggregate relationship */
  governance_satellite_snapshots_aggregate: Governance_Satellite_Snapshot_Aggregate;
  id: Scalars['bigint']['output'];
  /** An array relationship */
  lending_controller_collateral_token_oracles: Array<Lending_Controller_Collateral_Token>;
  /** An aggregate relationship */
  lending_controller_collateral_token_oracles_aggregate: Lending_Controller_Collateral_Token_Aggregate;
  /** An array relationship */
  lending_controller_history_data_sender: Array<Lending_Controller_History_Data>;
  /** An aggregate relationship */
  lending_controller_history_data_sender_aggregate: Lending_Controller_History_Data_Aggregate;
  /** An array relationship */
  lending_controller_loan_token_oracles: Array<Lending_Controller_Loan_Token>;
  /** An aggregate relationship */
  lending_controller_loan_token_oracles_aggregate: Lending_Controller_Loan_Token_Aggregate;
  /** An array relationship */
  lending_controller_vaults: Array<Lending_Controller_Vault>;
  /** An aggregate relationship */
  lending_controller_vaults_aggregate: Lending_Controller_Vault_Aggregate;
  /** An array relationship */
  m_token_accounts: Array<M_Token_Account>;
  /** An aggregate relationship */
  m_token_accounts_aggregate: M_Token_Account_Aggregate;
  /** An array relationship */
  m_token_user_operators: Array<M_Token_Operator>;
  /** An aggregate relationship */
  m_token_user_operators_aggregate: M_Token_Operator_Aggregate;
  /** An array relationship */
  m_token_user_owners: Array<M_Token_Operator>;
  /** An aggregate relationship */
  m_token_user_owners_aggregate: M_Token_Operator_Aggregate;
  /** An array relationship */
  mint_history_data: Array<Mvn_Mint_Or_Burn_History_Data>;
  /** An aggregate relationship */
  mint_history_data_aggregate: Mvn_Mint_Or_Burn_History_Data_Aggregate;
  mvn_balance: Scalars['float8']['output'];
  /** An array relationship */
  mvn_token_user_operators: Array<Mvn_Token_Operator>;
  /** An aggregate relationship */
  mvn_token_user_operators_aggregate: Mvn_Token_Operator_Aggregate;
  /** An array relationship */
  mvn_token_user_owners: Array<Mvn_Token_Operator>;
  /** An aggregate relationship */
  mvn_token_user_owners_aggregate: Mvn_Token_Operator_Aggregate;
  /** An array relationship */
  mvn_transfer_receiver: Array<Mvn_Transfer_History_Data>;
  /** An aggregate relationship */
  mvn_transfer_receiver_aggregate: Mvn_Transfer_History_Data_Aggregate;
  /** An array relationship */
  mvn_transfer_sender: Array<Mvn_Transfer_History_Data>;
  /** An aggregate relationship */
  mvn_transfer_sender_aggregate: Mvn_Transfer_History_Data_Aggregate;
  network: Scalars['String']['output'];
  /** An array relationship */
  satellite_rewardss: Array<Satellite_Rewards>;
  /** An aggregate relationship */
  satellite_rewardss_aggregate: Satellite_Rewards_Aggregate;
  /** An array relationship */
  satellites: Array<Satellite>;
  /** An aggregate relationship */
  satellites_aggregate: Satellite_Aggregate;
  smvn_balance: Scalars['float8']['output'];
  /** An array relationship */
  stakes_history_data: Array<Stake_History_Data>;
  /** An aggregate relationship */
  stakes_history_data_aggregate: Stake_History_Data_Aggregate;
  /** An array relationship */
  treasury_transfer_receiver: Array<Treasury_Transfer_History_Data>;
  /** An aggregate relationship */
  treasury_transfer_receiver_aggregate: Treasury_Transfer_History_Data_Aggregate;
  /** An array relationship */
  vault_depositors: Array<Vault_Depositor>;
  /** An aggregate relationship */
  vault_depositors_aggregate: Vault_Depositor_Aggregate;
  /** An array relationship */
  vesting_vestees: Array<Vesting_Vestee>;
  /** An aggregate relationship */
  vesting_vestees_aggregate: Vesting_Vestee_Aggregate;
  /** An array relationship */
  whitelist_developers: Array<Whitelist_Developer>;
  /** An aggregate relationship */
  whitelist_developers_aggregate: Whitelist_Developer_Aggregate;
};


/** columns and relationships of "maven_user" */
export type Maven_UserAggregator_OraclesArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Oracle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Oracle_Order_By>>;
  where?: InputMaybe<Aggregator_Oracle_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserAggregator_Oracles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Oracle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Oracle_Order_By>>;
  where?: InputMaybe<Aggregator_Oracle_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserBreak_Glass_Action_SignersArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Signer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Signer_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Signer_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserBreak_Glass_Action_Signers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Signer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Signer_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Signer_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserBreak_Glass_Actions_InitiatorArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserBreak_Glass_Actions_Initiator_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserBreak_Glass_Council_MembersArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Council_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Council_Member_Order_By>>;
  where?: InputMaybe<Break_Glass_Council_Member_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserBreak_Glass_Council_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Council_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Council_Member_Order_By>>;
  where?: InputMaybe<Break_Glass_Council_Member_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserCouncil_Actions_InitiatorArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Order_By>>;
  where?: InputMaybe<Council_Action_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserCouncil_Actions_Initiator_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Order_By>>;
  where?: InputMaybe<Council_Action_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserCouncil_Actions_SignerArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Signer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Signer_Order_By>>;
  where?: InputMaybe<Council_Action_Signer_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserCouncil_Actions_Signer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Signer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Signer_Order_By>>;
  where?: InputMaybe<Council_Action_Signer_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserCouncil_Council_MembersArgs = {
  distinct_on?: InputMaybe<Array<Council_Council_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Council_Member_Order_By>>;
  where?: InputMaybe<Council_Council_Member_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserCouncil_Council_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Council_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Council_Member_Order_By>>;
  where?: InputMaybe<Council_Council_Member_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserDelegated_TreasuriesArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Order_By>>;
  where?: InputMaybe<Treasury_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserDelegated_Treasuries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Order_By>>;
  where?: InputMaybe<Treasury_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserDelegated_VaultsArgs = {
  distinct_on?: InputMaybe<Array<Vault_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Order_By>>;
  where?: InputMaybe<Vault_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserDelegated_Vaults_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Order_By>>;
  where?: InputMaybe<Vault_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserDelegationsArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Record_Order_By>>;
  where?: InputMaybe<Delegation_Record_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserDelegations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Record_Order_By>>;
  where?: InputMaybe<Delegation_Record_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserDoorman_Stake_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Doorman_Stake_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_Stake_Account_Order_By>>;
  where?: InputMaybe<Doorman_Stake_Account_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserDoorman_Stake_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Doorman_Stake_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_Stake_Account_Order_By>>;
  where?: InputMaybe<Doorman_Stake_Account_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserEmergency_Governance_ProposerArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Record_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Record_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserEmergency_Governance_Proposer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Record_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Record_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserEmergency_Governance_VotesArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Vote_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Vote_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserEmergency_Governance_Votes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Vote_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Vote_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserFarm_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Farm_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Account_Order_By>>;
  where?: InputMaybe<Farm_Account_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserFarm_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Account_Order_By>>;
  where?: InputMaybe<Farm_Account_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserGovernance_Financial_Requests_ReceiverArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Request_Order_By>>;
  where?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserGovernance_Financial_Requests_Receiver_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Request_Order_By>>;
  where?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserGovernance_Financial_Requests_RequesterArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Request_Order_By>>;
  where?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserGovernance_Financial_Requests_Requester_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Request_Order_By>>;
  where?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserGovernance_Financial_Requests_VotesArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Request_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Request_Vote_Order_By>>;
  where?: InputMaybe<Governance_Financial_Request_Vote_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserGovernance_Financial_Requests_Votes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Request_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Request_Vote_Order_By>>;
  where?: InputMaybe<Governance_Financial_Request_Vote_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserGovernance_Proposals_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Payment_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Payment_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserGovernance_Proposals_Payments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Payment_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Payment_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserGovernance_Proposals_ProposerArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserGovernance_Proposals_Proposer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserGovernance_Proposals_VotesArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Vote_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Vote_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserGovernance_Proposals_Votes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Vote_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Vote_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserGovernance_Satellite_Action_InitiatorsArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Action_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Action_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserGovernance_Satellite_Action_Initiators_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Action_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Action_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserGovernance_Satellite_Actions_VotesArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Action_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Action_Vote_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Action_Vote_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserGovernance_Satellite_Actions_Votes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Action_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Action_Vote_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Action_Vote_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserGovernance_Satellite_OraclesArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Oracle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Oracle_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Oracle_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserGovernance_Satellite_Oracles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Oracle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Oracle_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Oracle_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserGovernance_Satellite_SnapshotsArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Snapshot_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Snapshot_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserGovernance_Satellite_Snapshots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Snapshot_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Snapshot_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserLending_Controller_Collateral_Token_OraclesArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Collateral_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Collateral_Token_Order_By>>;
  where?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserLending_Controller_Collateral_Token_Oracles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Collateral_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Collateral_Token_Order_By>>;
  where?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserLending_Controller_History_Data_SenderArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_History_Data_Order_By>>;
  where?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserLending_Controller_History_Data_Sender_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_History_Data_Order_By>>;
  where?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserLending_Controller_Loan_Token_OraclesArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Loan_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Loan_Token_Order_By>>;
  where?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserLending_Controller_Loan_Token_Oracles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Loan_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Loan_Token_Order_By>>;
  where?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserLending_Controller_VaultsArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Vault_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Vault_Order_By>>;
  where?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserLending_Controller_Vaults_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Vault_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Vault_Order_By>>;
  where?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserM_Token_AccountsArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Account_Order_By>>;
  where?: InputMaybe<M_Token_Account_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserM_Token_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Account_Order_By>>;
  where?: InputMaybe<M_Token_Account_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserM_Token_User_OperatorsArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Operator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Operator_Order_By>>;
  where?: InputMaybe<M_Token_Operator_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserM_Token_User_Operators_AggregateArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Operator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Operator_Order_By>>;
  where?: InputMaybe<M_Token_Operator_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserM_Token_User_OwnersArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Operator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Operator_Order_By>>;
  where?: InputMaybe<M_Token_Operator_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserM_Token_User_Owners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Operator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Operator_Order_By>>;
  where?: InputMaybe<M_Token_Operator_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserMint_History_DataArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Mint_Or_Burn_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Mint_Or_Burn_History_Data_Order_By>>;
  where?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserMint_History_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Mint_Or_Burn_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Mint_Or_Burn_History_Data_Order_By>>;
  where?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserMvn_Token_User_OperatorsArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_Operator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_Operator_Order_By>>;
  where?: InputMaybe<Mvn_Token_Operator_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserMvn_Token_User_Operators_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_Operator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_Operator_Order_By>>;
  where?: InputMaybe<Mvn_Token_Operator_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserMvn_Token_User_OwnersArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_Operator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_Operator_Order_By>>;
  where?: InputMaybe<Mvn_Token_Operator_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserMvn_Token_User_Owners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_Operator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_Operator_Order_By>>;
  where?: InputMaybe<Mvn_Token_Operator_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserMvn_Transfer_ReceiverArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Transfer_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Transfer_History_Data_Order_By>>;
  where?: InputMaybe<Mvn_Transfer_History_Data_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserMvn_Transfer_Receiver_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Transfer_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Transfer_History_Data_Order_By>>;
  where?: InputMaybe<Mvn_Transfer_History_Data_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserMvn_Transfer_SenderArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Transfer_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Transfer_History_Data_Order_By>>;
  where?: InputMaybe<Mvn_Transfer_History_Data_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserMvn_Transfer_Sender_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Transfer_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Transfer_History_Data_Order_By>>;
  where?: InputMaybe<Mvn_Transfer_History_Data_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserSatellite_RewardssArgs = {
  distinct_on?: InputMaybe<Array<Satellite_Rewards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Satellite_Rewards_Order_By>>;
  where?: InputMaybe<Satellite_Rewards_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserSatellite_Rewardss_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Satellite_Rewards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Satellite_Rewards_Order_By>>;
  where?: InputMaybe<Satellite_Rewards_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserSatellitesArgs = {
  distinct_on?: InputMaybe<Array<Satellite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Satellite_Order_By>>;
  where?: InputMaybe<Satellite_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserSatellites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Satellite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Satellite_Order_By>>;
  where?: InputMaybe<Satellite_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserStakes_History_DataArgs = {
  distinct_on?: InputMaybe<Array<Stake_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stake_History_Data_Order_By>>;
  where?: InputMaybe<Stake_History_Data_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserStakes_History_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stake_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stake_History_Data_Order_By>>;
  where?: InputMaybe<Stake_History_Data_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserTreasury_Transfer_ReceiverArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Transfer_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Transfer_History_Data_Order_By>>;
  where?: InputMaybe<Treasury_Transfer_History_Data_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserTreasury_Transfer_Receiver_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Transfer_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Transfer_History_Data_Order_By>>;
  where?: InputMaybe<Treasury_Transfer_History_Data_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserVault_DepositorsArgs = {
  distinct_on?: InputMaybe<Array<Vault_Depositor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Depositor_Order_By>>;
  where?: InputMaybe<Vault_Depositor_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserVault_Depositors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Depositor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Depositor_Order_By>>;
  where?: InputMaybe<Vault_Depositor_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserVesting_VesteesArgs = {
  distinct_on?: InputMaybe<Array<Vesting_Vestee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_Vestee_Order_By>>;
  where?: InputMaybe<Vesting_Vestee_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserVesting_Vestees_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vesting_Vestee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_Vestee_Order_By>>;
  where?: InputMaybe<Vesting_Vestee_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserWhitelist_DevelopersArgs = {
  distinct_on?: InputMaybe<Array<Whitelist_Developer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whitelist_Developer_Order_By>>;
  where?: InputMaybe<Whitelist_Developer_Bool_Exp>;
};


/** columns and relationships of "maven_user" */
export type Maven_UserWhitelist_Developers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whitelist_Developer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whitelist_Developer_Order_By>>;
  where?: InputMaybe<Whitelist_Developer_Bool_Exp>;
};

/** aggregated selection of "maven_user" */
export type Maven_User_Aggregate = {
  __typename?: 'maven_user_aggregate';
  aggregate?: Maybe<Maven_User_Aggregate_Fields>;
  nodes: Array<Maven_User>;
};

/** aggregate fields of "maven_user" */
export type Maven_User_Aggregate_Fields = {
  __typename?: 'maven_user_aggregate_fields';
  avg?: Maybe<Maven_User_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Maven_User_Max_Fields>;
  min?: Maybe<Maven_User_Min_Fields>;
  stddev?: Maybe<Maven_User_Stddev_Fields>;
  stddev_pop?: Maybe<Maven_User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Maven_User_Stddev_Samp_Fields>;
  sum?: Maybe<Maven_User_Sum_Fields>;
  var_pop?: Maybe<Maven_User_Var_Pop_Fields>;
  var_samp?: Maybe<Maven_User_Var_Samp_Fields>;
  variance?: Maybe<Maven_User_Variance_Fields>;
};


/** aggregate fields of "maven_user" */
export type Maven_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Maven_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Maven_User_Avg_Fields = {
  __typename?: 'maven_user_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  mvn_balance?: Maybe<Scalars['Float']['output']>;
  smvn_balance?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "maven_user". All fields are combined with a logical 'AND'. */
export type Maven_User_Bool_Exp = {
  _and?: InputMaybe<Array<Maven_User_Bool_Exp>>;
  _not?: InputMaybe<Maven_User_Bool_Exp>;
  _or?: InputMaybe<Array<Maven_User_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  aggregator_oracles?: InputMaybe<Aggregator_Oracle_Bool_Exp>;
  aggregator_oracles_aggregate?: InputMaybe<Aggregator_Oracle_Aggregate_Bool_Exp>;
  break_glass_action_signers?: InputMaybe<Break_Glass_Action_Signer_Bool_Exp>;
  break_glass_action_signers_aggregate?: InputMaybe<Break_Glass_Action_Signer_Aggregate_Bool_Exp>;
  break_glass_actions_initiator?: InputMaybe<Break_Glass_Action_Bool_Exp>;
  break_glass_actions_initiator_aggregate?: InputMaybe<Break_Glass_Action_Aggregate_Bool_Exp>;
  break_glass_council_members?: InputMaybe<Break_Glass_Council_Member_Bool_Exp>;
  break_glass_council_members_aggregate?: InputMaybe<Break_Glass_Council_Member_Aggregate_Bool_Exp>;
  council_actions_initiator?: InputMaybe<Council_Action_Bool_Exp>;
  council_actions_initiator_aggregate?: InputMaybe<Council_Action_Aggregate_Bool_Exp>;
  council_actions_signer?: InputMaybe<Council_Action_Signer_Bool_Exp>;
  council_actions_signer_aggregate?: InputMaybe<Council_Action_Signer_Aggregate_Bool_Exp>;
  council_council_members?: InputMaybe<Council_Council_Member_Bool_Exp>;
  council_council_members_aggregate?: InputMaybe<Council_Council_Member_Aggregate_Bool_Exp>;
  delegated_treasuries?: InputMaybe<Treasury_Bool_Exp>;
  delegated_treasuries_aggregate?: InputMaybe<Treasury_Aggregate_Bool_Exp>;
  delegated_vaults?: InputMaybe<Vault_Bool_Exp>;
  delegated_vaults_aggregate?: InputMaybe<Vault_Aggregate_Bool_Exp>;
  delegations?: InputMaybe<Delegation_Record_Bool_Exp>;
  delegations_aggregate?: InputMaybe<Delegation_Record_Aggregate_Bool_Exp>;
  doorman_stake_accounts?: InputMaybe<Doorman_Stake_Account_Bool_Exp>;
  doorman_stake_accounts_aggregate?: InputMaybe<Doorman_Stake_Account_Aggregate_Bool_Exp>;
  emergency_governance_proposer?: InputMaybe<Emergency_Governance_Record_Bool_Exp>;
  emergency_governance_proposer_aggregate?: InputMaybe<Emergency_Governance_Record_Aggregate_Bool_Exp>;
  emergency_governance_votes?: InputMaybe<Emergency_Governance_Vote_Bool_Exp>;
  emergency_governance_votes_aggregate?: InputMaybe<Emergency_Governance_Vote_Aggregate_Bool_Exp>;
  farm_accounts?: InputMaybe<Farm_Account_Bool_Exp>;
  farm_accounts_aggregate?: InputMaybe<Farm_Account_Aggregate_Bool_Exp>;
  governance_financial_requests_receiver?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
  governance_financial_requests_receiver_aggregate?: InputMaybe<Governance_Financial_Request_Aggregate_Bool_Exp>;
  governance_financial_requests_requester?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
  governance_financial_requests_requester_aggregate?: InputMaybe<Governance_Financial_Request_Aggregate_Bool_Exp>;
  governance_financial_requests_votes?: InputMaybe<Governance_Financial_Request_Vote_Bool_Exp>;
  governance_financial_requests_votes_aggregate?: InputMaybe<Governance_Financial_Request_Vote_Aggregate_Bool_Exp>;
  governance_proposals_payments?: InputMaybe<Governance_Proposal_Payment_Bool_Exp>;
  governance_proposals_payments_aggregate?: InputMaybe<Governance_Proposal_Payment_Aggregate_Bool_Exp>;
  governance_proposals_proposer?: InputMaybe<Governance_Proposal_Bool_Exp>;
  governance_proposals_proposer_aggregate?: InputMaybe<Governance_Proposal_Aggregate_Bool_Exp>;
  governance_proposals_votes?: InputMaybe<Governance_Proposal_Vote_Bool_Exp>;
  governance_proposals_votes_aggregate?: InputMaybe<Governance_Proposal_Vote_Aggregate_Bool_Exp>;
  governance_satellite_action_initiators?: InputMaybe<Governance_Satellite_Action_Bool_Exp>;
  governance_satellite_action_initiators_aggregate?: InputMaybe<Governance_Satellite_Action_Aggregate_Bool_Exp>;
  governance_satellite_actions_votes?: InputMaybe<Governance_Satellite_Action_Vote_Bool_Exp>;
  governance_satellite_actions_votes_aggregate?: InputMaybe<Governance_Satellite_Action_Vote_Aggregate_Bool_Exp>;
  governance_satellite_oracles?: InputMaybe<Governance_Satellite_Oracle_Bool_Exp>;
  governance_satellite_oracles_aggregate?: InputMaybe<Governance_Satellite_Oracle_Aggregate_Bool_Exp>;
  governance_satellite_snapshots?: InputMaybe<Governance_Satellite_Snapshot_Bool_Exp>;
  governance_satellite_snapshots_aggregate?: InputMaybe<Governance_Satellite_Snapshot_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lending_controller_collateral_token_oracles?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
  lending_controller_collateral_token_oracles_aggregate?: InputMaybe<Lending_Controller_Collateral_Token_Aggregate_Bool_Exp>;
  lending_controller_history_data_sender?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
  lending_controller_history_data_sender_aggregate?: InputMaybe<Lending_Controller_History_Data_Aggregate_Bool_Exp>;
  lending_controller_loan_token_oracles?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
  lending_controller_loan_token_oracles_aggregate?: InputMaybe<Lending_Controller_Loan_Token_Aggregate_Bool_Exp>;
  lending_controller_vaults?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
  lending_controller_vaults_aggregate?: InputMaybe<Lending_Controller_Vault_Aggregate_Bool_Exp>;
  m_token_accounts?: InputMaybe<M_Token_Account_Bool_Exp>;
  m_token_accounts_aggregate?: InputMaybe<M_Token_Account_Aggregate_Bool_Exp>;
  m_token_user_operators?: InputMaybe<M_Token_Operator_Bool_Exp>;
  m_token_user_operators_aggregate?: InputMaybe<M_Token_Operator_Aggregate_Bool_Exp>;
  m_token_user_owners?: InputMaybe<M_Token_Operator_Bool_Exp>;
  m_token_user_owners_aggregate?: InputMaybe<M_Token_Operator_Aggregate_Bool_Exp>;
  mint_history_data?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Bool_Exp>;
  mint_history_data_aggregate?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp>;
  mvn_balance?: InputMaybe<Float8_Comparison_Exp>;
  mvn_token_user_operators?: InputMaybe<Mvn_Token_Operator_Bool_Exp>;
  mvn_token_user_operators_aggregate?: InputMaybe<Mvn_Token_Operator_Aggregate_Bool_Exp>;
  mvn_token_user_owners?: InputMaybe<Mvn_Token_Operator_Bool_Exp>;
  mvn_token_user_owners_aggregate?: InputMaybe<Mvn_Token_Operator_Aggregate_Bool_Exp>;
  mvn_transfer_receiver?: InputMaybe<Mvn_Transfer_History_Data_Bool_Exp>;
  mvn_transfer_receiver_aggregate?: InputMaybe<Mvn_Transfer_History_Data_Aggregate_Bool_Exp>;
  mvn_transfer_sender?: InputMaybe<Mvn_Transfer_History_Data_Bool_Exp>;
  mvn_transfer_sender_aggregate?: InputMaybe<Mvn_Transfer_History_Data_Aggregate_Bool_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
  satellite_rewardss?: InputMaybe<Satellite_Rewards_Bool_Exp>;
  satellite_rewardss_aggregate?: InputMaybe<Satellite_Rewards_Aggregate_Bool_Exp>;
  satellites?: InputMaybe<Satellite_Bool_Exp>;
  satellites_aggregate?: InputMaybe<Satellite_Aggregate_Bool_Exp>;
  smvn_balance?: InputMaybe<Float8_Comparison_Exp>;
  stakes_history_data?: InputMaybe<Stake_History_Data_Bool_Exp>;
  stakes_history_data_aggregate?: InputMaybe<Stake_History_Data_Aggregate_Bool_Exp>;
  treasury_transfer_receiver?: InputMaybe<Treasury_Transfer_History_Data_Bool_Exp>;
  treasury_transfer_receiver_aggregate?: InputMaybe<Treasury_Transfer_History_Data_Aggregate_Bool_Exp>;
  vault_depositors?: InputMaybe<Vault_Depositor_Bool_Exp>;
  vault_depositors_aggregate?: InputMaybe<Vault_Depositor_Aggregate_Bool_Exp>;
  vesting_vestees?: InputMaybe<Vesting_Vestee_Bool_Exp>;
  vesting_vestees_aggregate?: InputMaybe<Vesting_Vestee_Aggregate_Bool_Exp>;
  whitelist_developers?: InputMaybe<Whitelist_Developer_Bool_Exp>;
  whitelist_developers_aggregate?: InputMaybe<Whitelist_Developer_Aggregate_Bool_Exp>;
};

/** aggregate max on columns */
export type Maven_User_Max_Fields = {
  __typename?: 'maven_user_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  mvn_balance?: Maybe<Scalars['float8']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  smvn_balance?: Maybe<Scalars['float8']['output']>;
};

/** aggregate min on columns */
export type Maven_User_Min_Fields = {
  __typename?: 'maven_user_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  mvn_balance?: Maybe<Scalars['float8']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  smvn_balance?: Maybe<Scalars['float8']['output']>;
};

/** Ordering options when selecting data from "maven_user". */
export type Maven_User_Order_By = {
  address?: InputMaybe<Order_By>;
  aggregator_oracles_aggregate?: InputMaybe<Aggregator_Oracle_Aggregate_Order_By>;
  break_glass_action_signers_aggregate?: InputMaybe<Break_Glass_Action_Signer_Aggregate_Order_By>;
  break_glass_actions_initiator_aggregate?: InputMaybe<Break_Glass_Action_Aggregate_Order_By>;
  break_glass_council_members_aggregate?: InputMaybe<Break_Glass_Council_Member_Aggregate_Order_By>;
  council_actions_initiator_aggregate?: InputMaybe<Council_Action_Aggregate_Order_By>;
  council_actions_signer_aggregate?: InputMaybe<Council_Action_Signer_Aggregate_Order_By>;
  council_council_members_aggregate?: InputMaybe<Council_Council_Member_Aggregate_Order_By>;
  delegated_treasuries_aggregate?: InputMaybe<Treasury_Aggregate_Order_By>;
  delegated_vaults_aggregate?: InputMaybe<Vault_Aggregate_Order_By>;
  delegations_aggregate?: InputMaybe<Delegation_Record_Aggregate_Order_By>;
  doorman_stake_accounts_aggregate?: InputMaybe<Doorman_Stake_Account_Aggregate_Order_By>;
  emergency_governance_proposer_aggregate?: InputMaybe<Emergency_Governance_Record_Aggregate_Order_By>;
  emergency_governance_votes_aggregate?: InputMaybe<Emergency_Governance_Vote_Aggregate_Order_By>;
  farm_accounts_aggregate?: InputMaybe<Farm_Account_Aggregate_Order_By>;
  governance_financial_requests_receiver_aggregate?: InputMaybe<Governance_Financial_Request_Aggregate_Order_By>;
  governance_financial_requests_requester_aggregate?: InputMaybe<Governance_Financial_Request_Aggregate_Order_By>;
  governance_financial_requests_votes_aggregate?: InputMaybe<Governance_Financial_Request_Vote_Aggregate_Order_By>;
  governance_proposals_payments_aggregate?: InputMaybe<Governance_Proposal_Payment_Aggregate_Order_By>;
  governance_proposals_proposer_aggregate?: InputMaybe<Governance_Proposal_Aggregate_Order_By>;
  governance_proposals_votes_aggregate?: InputMaybe<Governance_Proposal_Vote_Aggregate_Order_By>;
  governance_satellite_action_initiators_aggregate?: InputMaybe<Governance_Satellite_Action_Aggregate_Order_By>;
  governance_satellite_actions_votes_aggregate?: InputMaybe<Governance_Satellite_Action_Vote_Aggregate_Order_By>;
  governance_satellite_oracles_aggregate?: InputMaybe<Governance_Satellite_Oracle_Aggregate_Order_By>;
  governance_satellite_snapshots_aggregate?: InputMaybe<Governance_Satellite_Snapshot_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  lending_controller_collateral_token_oracles_aggregate?: InputMaybe<Lending_Controller_Collateral_Token_Aggregate_Order_By>;
  lending_controller_history_data_sender_aggregate?: InputMaybe<Lending_Controller_History_Data_Aggregate_Order_By>;
  lending_controller_loan_token_oracles_aggregate?: InputMaybe<Lending_Controller_Loan_Token_Aggregate_Order_By>;
  lending_controller_vaults_aggregate?: InputMaybe<Lending_Controller_Vault_Aggregate_Order_By>;
  m_token_accounts_aggregate?: InputMaybe<M_Token_Account_Aggregate_Order_By>;
  m_token_user_operators_aggregate?: InputMaybe<M_Token_Operator_Aggregate_Order_By>;
  m_token_user_owners_aggregate?: InputMaybe<M_Token_Operator_Aggregate_Order_By>;
  mint_history_data_aggregate?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Aggregate_Order_By>;
  mvn_balance?: InputMaybe<Order_By>;
  mvn_token_user_operators_aggregate?: InputMaybe<Mvn_Token_Operator_Aggregate_Order_By>;
  mvn_token_user_owners_aggregate?: InputMaybe<Mvn_Token_Operator_Aggregate_Order_By>;
  mvn_transfer_receiver_aggregate?: InputMaybe<Mvn_Transfer_History_Data_Aggregate_Order_By>;
  mvn_transfer_sender_aggregate?: InputMaybe<Mvn_Transfer_History_Data_Aggregate_Order_By>;
  network?: InputMaybe<Order_By>;
  satellite_rewardss_aggregate?: InputMaybe<Satellite_Rewards_Aggregate_Order_By>;
  satellites_aggregate?: InputMaybe<Satellite_Aggregate_Order_By>;
  smvn_balance?: InputMaybe<Order_By>;
  stakes_history_data_aggregate?: InputMaybe<Stake_History_Data_Aggregate_Order_By>;
  treasury_transfer_receiver_aggregate?: InputMaybe<Treasury_Transfer_History_Data_Aggregate_Order_By>;
  vault_depositors_aggregate?: InputMaybe<Vault_Depositor_Aggregate_Order_By>;
  vesting_vestees_aggregate?: InputMaybe<Vesting_Vestee_Aggregate_Order_By>;
  whitelist_developers_aggregate?: InputMaybe<Whitelist_Developer_Aggregate_Order_By>;
};

/** select columns of table "maven_user" */
export enum Maven_User_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Id = 'id',
  /** column name */
  MvnBalance = 'mvn_balance',
  /** column name */
  Network = 'network',
  /** column name */
  SmvnBalance = 'smvn_balance'
}

/** aggregate stddev on columns */
export type Maven_User_Stddev_Fields = {
  __typename?: 'maven_user_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  mvn_balance?: Maybe<Scalars['Float']['output']>;
  smvn_balance?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Maven_User_Stddev_Pop_Fields = {
  __typename?: 'maven_user_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  mvn_balance?: Maybe<Scalars['Float']['output']>;
  smvn_balance?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Maven_User_Stddev_Samp_Fields = {
  __typename?: 'maven_user_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  mvn_balance?: Maybe<Scalars['Float']['output']>;
  smvn_balance?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "maven_user" */
export type Maven_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Maven_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Maven_User_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  mvn_balance?: InputMaybe<Scalars['float8']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  smvn_balance?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type Maven_User_Sum_Fields = {
  __typename?: 'maven_user_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  mvn_balance?: Maybe<Scalars['float8']['output']>;
  smvn_balance?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Maven_User_Var_Pop_Fields = {
  __typename?: 'maven_user_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  mvn_balance?: Maybe<Scalars['Float']['output']>;
  smvn_balance?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Maven_User_Var_Samp_Fields = {
  __typename?: 'maven_user_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  mvn_balance?: Maybe<Scalars['Float']['output']>;
  smvn_balance?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Maven_User_Variance_Fields = {
  __typename?: 'maven_user_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  mvn_balance?: Maybe<Scalars['Float']['output']>;
  smvn_balance?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "mvn_mint_or_burn_history_data" */
export type Mvn_Mint_Or_Burn_History_Data = {
  __typename?: 'mvn_mint_or_burn_history_data';
  amount: Scalars['float8']['output'];
  id: Scalars['bigint']['output'];
  level: Scalars['bigint']['output'];
  /** An object relationship */
  mvn_token: Mvn_Token;
  mvn_token_id: Scalars['bigint']['output'];
  mvn_total_supply: Scalars['float8']['output'];
  timestamp: Scalars['timestamptz']['output'];
  /** MINT: 0\nBURN: 1 */
  type: Scalars['smallint']['output'];
  /** An object relationship */
  user: Maven_User;
  user_id: Scalars['bigint']['output'];
};

/** aggregated selection of "mvn_mint_or_burn_history_data" */
export type Mvn_Mint_Or_Burn_History_Data_Aggregate = {
  __typename?: 'mvn_mint_or_burn_history_data_aggregate';
  aggregate?: Maybe<Mvn_Mint_Or_Burn_History_Data_Aggregate_Fields>;
  nodes: Array<Mvn_Mint_Or_Burn_History_Data>;
};

export type Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Var_Samp>;
};

export type Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Avg = {
  arguments: Mvn_Mint_Or_Burn_History_Data_Select_Column_Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Corr = {
  arguments: Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Mvn_Mint_Or_Burn_History_Data_Select_Column_Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Mvn_Mint_Or_Burn_History_Data_Select_Column_Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Mvn_Mint_Or_Burn_History_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Mvn_Mint_Or_Burn_History_Data_Select_Column_Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Mvn_Mint_Or_Burn_History_Data_Select_Column_Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Max = {
  arguments: Mvn_Mint_Or_Burn_History_Data_Select_Column_Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Min = {
  arguments: Mvn_Mint_Or_Burn_History_Data_Select_Column_Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Mvn_Mint_Or_Burn_History_Data_Select_Column_Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Sum = {
  arguments: Mvn_Mint_Or_Burn_History_Data_Select_Column_Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Mvn_Mint_Or_Burn_History_Data_Select_Column_Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "mvn_mint_or_burn_history_data" */
export type Mvn_Mint_Or_Burn_History_Data_Aggregate_Fields = {
  __typename?: 'mvn_mint_or_burn_history_data_aggregate_fields';
  avg?: Maybe<Mvn_Mint_Or_Burn_History_Data_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mvn_Mint_Or_Burn_History_Data_Max_Fields>;
  min?: Maybe<Mvn_Mint_Or_Burn_History_Data_Min_Fields>;
  stddev?: Maybe<Mvn_Mint_Or_Burn_History_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Mvn_Mint_Or_Burn_History_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mvn_Mint_Or_Burn_History_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Mvn_Mint_Or_Burn_History_Data_Sum_Fields>;
  var_pop?: Maybe<Mvn_Mint_Or_Burn_History_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Mvn_Mint_Or_Burn_History_Data_Var_Samp_Fields>;
  variance?: Maybe<Mvn_Mint_Or_Burn_History_Data_Variance_Fields>;
};


/** aggregate fields of "mvn_mint_or_burn_history_data" */
export type Mvn_Mint_Or_Burn_History_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mvn_Mint_Or_Burn_History_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "mvn_mint_or_burn_history_data" */
export type Mvn_Mint_Or_Burn_History_Data_Aggregate_Order_By = {
  avg?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Max_Order_By>;
  min?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Min_Order_By>;
  stddev?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Sum_Order_By>;
  var_pop?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Var_Samp_Order_By>;
  variance?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Mvn_Mint_Or_Burn_History_Data_Avg_Fields = {
  __typename?: 'mvn_mint_or_burn_history_data_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  mvn_token_id?: Maybe<Scalars['Float']['output']>;
  mvn_total_supply?: Maybe<Scalars['Float']['output']>;
  /** MINT: 0\nBURN: 1 */
  type?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "mvn_mint_or_burn_history_data" */
export type Mvn_Mint_Or_Burn_History_Data_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  mvn_total_supply?: InputMaybe<Order_By>;
  /** MINT: 0\nBURN: 1 */
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mvn_mint_or_burn_history_data". All fields are combined with a logical 'AND'. */
export type Mvn_Mint_Or_Burn_History_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Mvn_Mint_Or_Burn_History_Data_Bool_Exp>>;
  _not?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Mvn_Mint_Or_Burn_History_Data_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  level?: InputMaybe<Bigint_Comparison_Exp>;
  mvn_token?: InputMaybe<Mvn_Token_Bool_Exp>;
  mvn_token_id?: InputMaybe<Bigint_Comparison_Exp>;
  mvn_total_supply?: InputMaybe<Float8_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  type?: InputMaybe<Smallint_Comparison_Exp>;
  user?: InputMaybe<Maven_User_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mvn_Mint_Or_Burn_History_Data_Max_Fields = {
  __typename?: 'mvn_mint_or_burn_history_data_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  level?: Maybe<Scalars['bigint']['output']>;
  mvn_token_id?: Maybe<Scalars['bigint']['output']>;
  mvn_total_supply?: Maybe<Scalars['float8']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  /** MINT: 0\nBURN: 1 */
  type?: Maybe<Scalars['smallint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "mvn_mint_or_burn_history_data" */
export type Mvn_Mint_Or_Burn_History_Data_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  mvn_total_supply?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  /** MINT: 0\nBURN: 1 */
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mvn_Mint_Or_Burn_History_Data_Min_Fields = {
  __typename?: 'mvn_mint_or_burn_history_data_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  level?: Maybe<Scalars['bigint']['output']>;
  mvn_token_id?: Maybe<Scalars['bigint']['output']>;
  mvn_total_supply?: Maybe<Scalars['float8']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  /** MINT: 0\nBURN: 1 */
  type?: Maybe<Scalars['smallint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "mvn_mint_or_burn_history_data" */
export type Mvn_Mint_Or_Burn_History_Data_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  mvn_total_supply?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  /** MINT: 0\nBURN: 1 */
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "mvn_mint_or_burn_history_data". */
export type Mvn_Mint_Or_Burn_History_Data_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  mvn_token?: InputMaybe<Mvn_Token_Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  mvn_total_supply?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Maven_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "mvn_mint_or_burn_history_data" */
export enum Mvn_Mint_Or_Burn_History_Data_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  MvnTokenId = 'mvn_token_id',
  /** column name */
  MvnTotalSupply = 'mvn_total_supply',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

/** select "mvn_mint_or_burn_history_data_aggregate_bool_exp_avg_arguments_columns" columns of table "mvn_mint_or_burn_history_data" */
export enum Mvn_Mint_Or_Burn_History_Data_Select_Column_Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Amount = 'amount',
  /** column name */
  MvnTotalSupply = 'mvn_total_supply'
}

/** select "mvn_mint_or_burn_history_data_aggregate_bool_exp_corr_arguments_columns" columns of table "mvn_mint_or_burn_history_data" */
export enum Mvn_Mint_Or_Burn_History_Data_Select_Column_Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Amount = 'amount',
  /** column name */
  MvnTotalSupply = 'mvn_total_supply'
}

/** select "mvn_mint_or_burn_history_data_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "mvn_mint_or_burn_history_data" */
export enum Mvn_Mint_Or_Burn_History_Data_Select_Column_Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Amount = 'amount',
  /** column name */
  MvnTotalSupply = 'mvn_total_supply'
}

/** select "mvn_mint_or_burn_history_data_aggregate_bool_exp_max_arguments_columns" columns of table "mvn_mint_or_burn_history_data" */
export enum Mvn_Mint_Or_Burn_History_Data_Select_Column_Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Amount = 'amount',
  /** column name */
  MvnTotalSupply = 'mvn_total_supply'
}

/** select "mvn_mint_or_burn_history_data_aggregate_bool_exp_min_arguments_columns" columns of table "mvn_mint_or_burn_history_data" */
export enum Mvn_Mint_Or_Burn_History_Data_Select_Column_Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Amount = 'amount',
  /** column name */
  MvnTotalSupply = 'mvn_total_supply'
}

/** select "mvn_mint_or_burn_history_data_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "mvn_mint_or_burn_history_data" */
export enum Mvn_Mint_Or_Burn_History_Data_Select_Column_Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Amount = 'amount',
  /** column name */
  MvnTotalSupply = 'mvn_total_supply'
}

/** select "mvn_mint_or_burn_history_data_aggregate_bool_exp_sum_arguments_columns" columns of table "mvn_mint_or_burn_history_data" */
export enum Mvn_Mint_Or_Burn_History_Data_Select_Column_Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Amount = 'amount',
  /** column name */
  MvnTotalSupply = 'mvn_total_supply'
}

/** select "mvn_mint_or_burn_history_data_aggregate_bool_exp_var_samp_arguments_columns" columns of table "mvn_mint_or_burn_history_data" */
export enum Mvn_Mint_Or_Burn_History_Data_Select_Column_Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Amount = 'amount',
  /** column name */
  MvnTotalSupply = 'mvn_total_supply'
}

/** aggregate stddev on columns */
export type Mvn_Mint_Or_Burn_History_Data_Stddev_Fields = {
  __typename?: 'mvn_mint_or_burn_history_data_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  mvn_token_id?: Maybe<Scalars['Float']['output']>;
  mvn_total_supply?: Maybe<Scalars['Float']['output']>;
  /** MINT: 0\nBURN: 1 */
  type?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "mvn_mint_or_burn_history_data" */
export type Mvn_Mint_Or_Burn_History_Data_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  mvn_total_supply?: InputMaybe<Order_By>;
  /** MINT: 0\nBURN: 1 */
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mvn_Mint_Or_Burn_History_Data_Stddev_Pop_Fields = {
  __typename?: 'mvn_mint_or_burn_history_data_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  mvn_token_id?: Maybe<Scalars['Float']['output']>;
  mvn_total_supply?: Maybe<Scalars['Float']['output']>;
  /** MINT: 0\nBURN: 1 */
  type?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "mvn_mint_or_burn_history_data" */
export type Mvn_Mint_Or_Burn_History_Data_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  mvn_total_supply?: InputMaybe<Order_By>;
  /** MINT: 0\nBURN: 1 */
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mvn_Mint_Or_Burn_History_Data_Stddev_Samp_Fields = {
  __typename?: 'mvn_mint_or_burn_history_data_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  mvn_token_id?: Maybe<Scalars['Float']['output']>;
  mvn_total_supply?: Maybe<Scalars['Float']['output']>;
  /** MINT: 0\nBURN: 1 */
  type?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "mvn_mint_or_burn_history_data" */
export type Mvn_Mint_Or_Burn_History_Data_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  mvn_total_supply?: InputMaybe<Order_By>;
  /** MINT: 0\nBURN: 1 */
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mvn_mint_or_burn_history_data" */
export type Mvn_Mint_Or_Burn_History_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mvn_Mint_Or_Burn_History_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mvn_Mint_Or_Burn_History_Data_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  level?: InputMaybe<Scalars['bigint']['input']>;
  mvn_token_id?: InputMaybe<Scalars['bigint']['input']>;
  mvn_total_supply?: InputMaybe<Scalars['float8']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  /** MINT: 0\nBURN: 1 */
  type?: InputMaybe<Scalars['smallint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Mvn_Mint_Or_Burn_History_Data_Sum_Fields = {
  __typename?: 'mvn_mint_or_burn_history_data_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  level?: Maybe<Scalars['bigint']['output']>;
  mvn_token_id?: Maybe<Scalars['bigint']['output']>;
  mvn_total_supply?: Maybe<Scalars['float8']['output']>;
  /** MINT: 0\nBURN: 1 */
  type?: Maybe<Scalars['smallint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "mvn_mint_or_burn_history_data" */
export type Mvn_Mint_Or_Burn_History_Data_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  mvn_total_supply?: InputMaybe<Order_By>;
  /** MINT: 0\nBURN: 1 */
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Mvn_Mint_Or_Burn_History_Data_Var_Pop_Fields = {
  __typename?: 'mvn_mint_or_burn_history_data_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  mvn_token_id?: Maybe<Scalars['Float']['output']>;
  mvn_total_supply?: Maybe<Scalars['Float']['output']>;
  /** MINT: 0\nBURN: 1 */
  type?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "mvn_mint_or_burn_history_data" */
export type Mvn_Mint_Or_Burn_History_Data_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  mvn_total_supply?: InputMaybe<Order_By>;
  /** MINT: 0\nBURN: 1 */
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mvn_Mint_Or_Burn_History_Data_Var_Samp_Fields = {
  __typename?: 'mvn_mint_or_burn_history_data_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  mvn_token_id?: Maybe<Scalars['Float']['output']>;
  mvn_total_supply?: Maybe<Scalars['Float']['output']>;
  /** MINT: 0\nBURN: 1 */
  type?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "mvn_mint_or_burn_history_data" */
export type Mvn_Mint_Or_Burn_History_Data_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  mvn_total_supply?: InputMaybe<Order_By>;
  /** MINT: 0\nBURN: 1 */
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mvn_Mint_Or_Burn_History_Data_Variance_Fields = {
  __typename?: 'mvn_mint_or_burn_history_data_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  mvn_token_id?: Maybe<Scalars['Float']['output']>;
  mvn_total_supply?: Maybe<Scalars['Float']['output']>;
  /** MINT: 0\nBURN: 1 */
  type?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "mvn_mint_or_burn_history_data" */
export type Mvn_Mint_Or_Burn_History_Data_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  mvn_total_supply?: InputMaybe<Order_By>;
  /** MINT: 0\nBURN: 1 */
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "mvn_token" */
export type Mvn_Token = {
  __typename?: 'mvn_token';
  address: Scalars['String']['output'];
  admin: Scalars['String']['output'];
  /** An array relationship */
  general_contracts: Array<Mvn_Token_General_Contract>;
  /** An aggregate relationship */
  general_contracts_aggregate: Mvn_Token_General_Contract_Aggregate;
  /** An object relationship */
  governance: Governance;
  governance_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  inflation_rate: Scalars['smallint']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  maximum_supply: Scalars['float8']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  mint_history_data: Array<Mvn_Mint_Or_Burn_History_Data>;
  /** An aggregate relationship */
  mint_history_data_aggregate: Mvn_Mint_Or_Burn_History_Data_Aggregate;
  network: Scalars['String']['output'];
  next_inflation_timestamp: Scalars['timestamptz']['output'];
  /** An array relationship */
  operators: Array<Mvn_Token_Operator>;
  /** An aggregate relationship */
  operators_aggregate: Mvn_Token_Operator_Aggregate;
  /** An object relationship */
  token: Token;
  token_id: Scalars['bigint']['output'];
  total_supply: Scalars['float8']['output'];
  /** An array relationship */
  transfer_history_data: Array<Mvn_Transfer_History_Data>;
  /** An aggregate relationship */
  transfer_history_data_aggregate: Mvn_Transfer_History_Data_Aggregate;
  /** An array relationship */
  whitelist_contracts: Array<Mvn_Token_Whitelist_Contract>;
  /** An aggregate relationship */
  whitelist_contracts_aggregate: Mvn_Token_Whitelist_Contract_Aggregate;
};


/** columns and relationships of "mvn_token" */
export type Mvn_TokenGeneral_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_General_Contract_Order_By>>;
  where?: InputMaybe<Mvn_Token_General_Contract_Bool_Exp>;
};


/** columns and relationships of "mvn_token" */
export type Mvn_TokenGeneral_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_General_Contract_Order_By>>;
  where?: InputMaybe<Mvn_Token_General_Contract_Bool_Exp>;
};


/** columns and relationships of "mvn_token" */
export type Mvn_TokenMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "mvn_token" */
export type Mvn_TokenMint_History_DataArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Mint_Or_Burn_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Mint_Or_Burn_History_Data_Order_By>>;
  where?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Bool_Exp>;
};


/** columns and relationships of "mvn_token" */
export type Mvn_TokenMint_History_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Mint_Or_Burn_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Mint_Or_Burn_History_Data_Order_By>>;
  where?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Bool_Exp>;
};


/** columns and relationships of "mvn_token" */
export type Mvn_TokenOperatorsArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_Operator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_Operator_Order_By>>;
  where?: InputMaybe<Mvn_Token_Operator_Bool_Exp>;
};


/** columns and relationships of "mvn_token" */
export type Mvn_TokenOperators_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_Operator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_Operator_Order_By>>;
  where?: InputMaybe<Mvn_Token_Operator_Bool_Exp>;
};


/** columns and relationships of "mvn_token" */
export type Mvn_TokenTransfer_History_DataArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Transfer_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Transfer_History_Data_Order_By>>;
  where?: InputMaybe<Mvn_Transfer_History_Data_Bool_Exp>;
};


/** columns and relationships of "mvn_token" */
export type Mvn_TokenTransfer_History_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Transfer_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Transfer_History_Data_Order_By>>;
  where?: InputMaybe<Mvn_Transfer_History_Data_Bool_Exp>;
};


/** columns and relationships of "mvn_token" */
export type Mvn_TokenWhitelist_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Mvn_Token_Whitelist_Contract_Bool_Exp>;
};


/** columns and relationships of "mvn_token" */
export type Mvn_TokenWhitelist_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Mvn_Token_Whitelist_Contract_Bool_Exp>;
};

/** aggregated selection of "mvn_token" */
export type Mvn_Token_Aggregate = {
  __typename?: 'mvn_token_aggregate';
  aggregate?: Maybe<Mvn_Token_Aggregate_Fields>;
  nodes: Array<Mvn_Token>;
};

export type Mvn_Token_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Mvn_Token_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Mvn_Token_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Mvn_Token_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Mvn_Token_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Mvn_Token_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Mvn_Token_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Mvn_Token_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Mvn_Token_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Mvn_Token_Aggregate_Bool_Exp_Var_Samp>;
};

export type Mvn_Token_Aggregate_Bool_Exp_Avg = {
  arguments: Mvn_Token_Select_Column_Mvn_Token_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mvn_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Mvn_Token_Aggregate_Bool_Exp_Corr = {
  arguments: Mvn_Token_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mvn_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Mvn_Token_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Mvn_Token_Select_Column_Mvn_Token_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Mvn_Token_Select_Column_Mvn_Token_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Mvn_Token_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Mvn_Token_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mvn_Token_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Mvn_Token_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Mvn_Token_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mvn_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Mvn_Token_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Mvn_Token_Select_Column_Mvn_Token_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Mvn_Token_Select_Column_Mvn_Token_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Mvn_Token_Aggregate_Bool_Exp_Max = {
  arguments: Mvn_Token_Select_Column_Mvn_Token_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mvn_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Mvn_Token_Aggregate_Bool_Exp_Min = {
  arguments: Mvn_Token_Select_Column_Mvn_Token_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mvn_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Mvn_Token_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Mvn_Token_Select_Column_Mvn_Token_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mvn_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Mvn_Token_Aggregate_Bool_Exp_Sum = {
  arguments: Mvn_Token_Select_Column_Mvn_Token_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mvn_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Mvn_Token_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Mvn_Token_Select_Column_Mvn_Token_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mvn_Token_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "mvn_token" */
export type Mvn_Token_Aggregate_Fields = {
  __typename?: 'mvn_token_aggregate_fields';
  avg?: Maybe<Mvn_Token_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mvn_Token_Max_Fields>;
  min?: Maybe<Mvn_Token_Min_Fields>;
  stddev?: Maybe<Mvn_Token_Stddev_Fields>;
  stddev_pop?: Maybe<Mvn_Token_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mvn_Token_Stddev_Samp_Fields>;
  sum?: Maybe<Mvn_Token_Sum_Fields>;
  var_pop?: Maybe<Mvn_Token_Var_Pop_Fields>;
  var_samp?: Maybe<Mvn_Token_Var_Samp_Fields>;
  variance?: Maybe<Mvn_Token_Variance_Fields>;
};


/** aggregate fields of "mvn_token" */
export type Mvn_Token_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mvn_Token_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "mvn_token" */
export type Mvn_Token_Aggregate_Order_By = {
  avg?: InputMaybe<Mvn_Token_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mvn_Token_Max_Order_By>;
  min?: InputMaybe<Mvn_Token_Min_Order_By>;
  stddev?: InputMaybe<Mvn_Token_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mvn_Token_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mvn_Token_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mvn_Token_Sum_Order_By>;
  var_pop?: InputMaybe<Mvn_Token_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mvn_Token_Var_Samp_Order_By>;
  variance?: InputMaybe<Mvn_Token_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Mvn_Token_Avg_Fields = {
  __typename?: 'mvn_token_avg_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  inflation_rate?: Maybe<Scalars['Float']['output']>;
  maximum_supply?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "mvn_token" */
export type Mvn_Token_Avg_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inflation_rate?: InputMaybe<Order_By>;
  maximum_supply?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  total_supply?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mvn_token". All fields are combined with a logical 'AND'. */
export type Mvn_Token_Bool_Exp = {
  _and?: InputMaybe<Array<Mvn_Token_Bool_Exp>>;
  _not?: InputMaybe<Mvn_Token_Bool_Exp>;
  _or?: InputMaybe<Array<Mvn_Token_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  admin?: InputMaybe<String_Comparison_Exp>;
  general_contracts?: InputMaybe<Mvn_Token_General_Contract_Bool_Exp>;
  general_contracts_aggregate?: InputMaybe<Mvn_Token_General_Contract_Aggregate_Bool_Exp>;
  governance?: InputMaybe<Governance_Bool_Exp>;
  governance_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  inflation_rate?: InputMaybe<Smallint_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  maximum_supply?: InputMaybe<Float8_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mint_history_data?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Bool_Exp>;
  mint_history_data_aggregate?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Aggregate_Bool_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
  next_inflation_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  operators?: InputMaybe<Mvn_Token_Operator_Bool_Exp>;
  operators_aggregate?: InputMaybe<Mvn_Token_Operator_Aggregate_Bool_Exp>;
  token?: InputMaybe<Token_Bool_Exp>;
  token_id?: InputMaybe<Bigint_Comparison_Exp>;
  total_supply?: InputMaybe<Float8_Comparison_Exp>;
  transfer_history_data?: InputMaybe<Mvn_Transfer_History_Data_Bool_Exp>;
  transfer_history_data_aggregate?: InputMaybe<Mvn_Transfer_History_Data_Aggregate_Bool_Exp>;
  whitelist_contracts?: InputMaybe<Mvn_Token_Whitelist_Contract_Bool_Exp>;
  whitelist_contracts_aggregate?: InputMaybe<Mvn_Token_Whitelist_Contract_Aggregate_Bool_Exp>;
};

/** columns and relationships of "mvn_token_general_contract" */
export type Mvn_Token_General_Contract = {
  __typename?: 'mvn_token_general_contract';
  /** An object relationship */
  contract: Mvn_Token;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  contract_name: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "mvn_token_general_contract" */
export type Mvn_Token_General_Contract_Aggregate = {
  __typename?: 'mvn_token_general_contract_aggregate';
  aggregate?: Maybe<Mvn_Token_General_Contract_Aggregate_Fields>;
  nodes: Array<Mvn_Token_General_Contract>;
};

export type Mvn_Token_General_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Mvn_Token_General_Contract_Aggregate_Bool_Exp_Count>;
};

export type Mvn_Token_General_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Mvn_Token_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mvn_Token_General_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "mvn_token_general_contract" */
export type Mvn_Token_General_Contract_Aggregate_Fields = {
  __typename?: 'mvn_token_general_contract_aggregate_fields';
  avg?: Maybe<Mvn_Token_General_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mvn_Token_General_Contract_Max_Fields>;
  min?: Maybe<Mvn_Token_General_Contract_Min_Fields>;
  stddev?: Maybe<Mvn_Token_General_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Mvn_Token_General_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mvn_Token_General_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Mvn_Token_General_Contract_Sum_Fields>;
  var_pop?: Maybe<Mvn_Token_General_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Mvn_Token_General_Contract_Var_Samp_Fields>;
  variance?: Maybe<Mvn_Token_General_Contract_Variance_Fields>;
};


/** aggregate fields of "mvn_token_general_contract" */
export type Mvn_Token_General_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mvn_Token_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "mvn_token_general_contract" */
export type Mvn_Token_General_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Mvn_Token_General_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mvn_Token_General_Contract_Max_Order_By>;
  min?: InputMaybe<Mvn_Token_General_Contract_Min_Order_By>;
  stddev?: InputMaybe<Mvn_Token_General_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mvn_Token_General_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mvn_Token_General_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mvn_Token_General_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Mvn_Token_General_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mvn_Token_General_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Mvn_Token_General_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Mvn_Token_General_Contract_Avg_Fields = {
  __typename?: 'mvn_token_general_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "mvn_token_general_contract" */
export type Mvn_Token_General_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mvn_token_general_contract". All fields are combined with a logical 'AND'. */
export type Mvn_Token_General_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Mvn_Token_General_Contract_Bool_Exp>>;
  _not?: InputMaybe<Mvn_Token_General_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Mvn_Token_General_Contract_Bool_Exp>>;
  contract?: InputMaybe<Mvn_Token_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  contract_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mvn_Token_General_Contract_Max_Fields = {
  __typename?: 'mvn_token_general_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "mvn_token_general_contract" */
export type Mvn_Token_General_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mvn_Token_General_Contract_Min_Fields = {
  __typename?: 'mvn_token_general_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "mvn_token_general_contract" */
export type Mvn_Token_General_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "mvn_token_general_contract". */
export type Mvn_Token_General_Contract_Order_By = {
  contract?: InputMaybe<Mvn_Token_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "mvn_token_general_contract" */
export enum Mvn_Token_General_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  ContractName = 'contract_name',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Mvn_Token_General_Contract_Stddev_Fields = {
  __typename?: 'mvn_token_general_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "mvn_token_general_contract" */
export type Mvn_Token_General_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mvn_Token_General_Contract_Stddev_Pop_Fields = {
  __typename?: 'mvn_token_general_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "mvn_token_general_contract" */
export type Mvn_Token_General_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mvn_Token_General_Contract_Stddev_Samp_Fields = {
  __typename?: 'mvn_token_general_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "mvn_token_general_contract" */
export type Mvn_Token_General_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mvn_token_general_contract" */
export type Mvn_Token_General_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mvn_Token_General_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mvn_Token_General_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  contract_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Mvn_Token_General_Contract_Sum_Fields = {
  __typename?: 'mvn_token_general_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "mvn_token_general_contract" */
export type Mvn_Token_General_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Mvn_Token_General_Contract_Var_Pop_Fields = {
  __typename?: 'mvn_token_general_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "mvn_token_general_contract" */
export type Mvn_Token_General_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mvn_Token_General_Contract_Var_Samp_Fields = {
  __typename?: 'mvn_token_general_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "mvn_token_general_contract" */
export type Mvn_Token_General_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mvn_Token_General_Contract_Variance_Fields = {
  __typename?: 'mvn_token_general_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "mvn_token_general_contract" */
export type Mvn_Token_General_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Mvn_Token_Max_Fields = {
  __typename?: 'mvn_token_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  inflation_rate?: Maybe<Scalars['smallint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  maximum_supply?: Maybe<Scalars['float8']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  next_inflation_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  total_supply?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "mvn_token" */
export type Mvn_Token_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inflation_rate?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  maximum_supply?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  next_inflation_timestamp?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  total_supply?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mvn_Token_Min_Fields = {
  __typename?: 'mvn_token_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  inflation_rate?: Maybe<Scalars['smallint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  maximum_supply?: Maybe<Scalars['float8']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  next_inflation_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  total_supply?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "mvn_token" */
export type Mvn_Token_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inflation_rate?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  maximum_supply?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  next_inflation_timestamp?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  total_supply?: InputMaybe<Order_By>;
};

/** columns and relationships of "mvn_token_operator" */
export type Mvn_Token_Operator = {
  __typename?: 'mvn_token_operator';
  id: Scalars['bigint']['output'];
  /** An object relationship */
  mvn_token: Mvn_Token;
  mvn_token_id: Scalars['bigint']['output'];
  /** An object relationship */
  operator: Maven_User;
  operator_id: Scalars['bigint']['output'];
  /** An object relationship */
  owner: Maven_User;
  owner_id: Scalars['bigint']['output'];
};

/** aggregated selection of "mvn_token_operator" */
export type Mvn_Token_Operator_Aggregate = {
  __typename?: 'mvn_token_operator_aggregate';
  aggregate?: Maybe<Mvn_Token_Operator_Aggregate_Fields>;
  nodes: Array<Mvn_Token_Operator>;
};

export type Mvn_Token_Operator_Aggregate_Bool_Exp = {
  count?: InputMaybe<Mvn_Token_Operator_Aggregate_Bool_Exp_Count>;
};

export type Mvn_Token_Operator_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Mvn_Token_Operator_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mvn_Token_Operator_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "mvn_token_operator" */
export type Mvn_Token_Operator_Aggregate_Fields = {
  __typename?: 'mvn_token_operator_aggregate_fields';
  avg?: Maybe<Mvn_Token_Operator_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mvn_Token_Operator_Max_Fields>;
  min?: Maybe<Mvn_Token_Operator_Min_Fields>;
  stddev?: Maybe<Mvn_Token_Operator_Stddev_Fields>;
  stddev_pop?: Maybe<Mvn_Token_Operator_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mvn_Token_Operator_Stddev_Samp_Fields>;
  sum?: Maybe<Mvn_Token_Operator_Sum_Fields>;
  var_pop?: Maybe<Mvn_Token_Operator_Var_Pop_Fields>;
  var_samp?: Maybe<Mvn_Token_Operator_Var_Samp_Fields>;
  variance?: Maybe<Mvn_Token_Operator_Variance_Fields>;
};


/** aggregate fields of "mvn_token_operator" */
export type Mvn_Token_Operator_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mvn_Token_Operator_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "mvn_token_operator" */
export type Mvn_Token_Operator_Aggregate_Order_By = {
  avg?: InputMaybe<Mvn_Token_Operator_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mvn_Token_Operator_Max_Order_By>;
  min?: InputMaybe<Mvn_Token_Operator_Min_Order_By>;
  stddev?: InputMaybe<Mvn_Token_Operator_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mvn_Token_Operator_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mvn_Token_Operator_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mvn_Token_Operator_Sum_Order_By>;
  var_pop?: InputMaybe<Mvn_Token_Operator_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mvn_Token_Operator_Var_Samp_Order_By>;
  variance?: InputMaybe<Mvn_Token_Operator_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Mvn_Token_Operator_Avg_Fields = {
  __typename?: 'mvn_token_operator_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  mvn_token_id?: Maybe<Scalars['Float']['output']>;
  operator_id?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "mvn_token_operator" */
export type Mvn_Token_Operator_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  operator_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mvn_token_operator". All fields are combined with a logical 'AND'. */
export type Mvn_Token_Operator_Bool_Exp = {
  _and?: InputMaybe<Array<Mvn_Token_Operator_Bool_Exp>>;
  _not?: InputMaybe<Mvn_Token_Operator_Bool_Exp>;
  _or?: InputMaybe<Array<Mvn_Token_Operator_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  mvn_token?: InputMaybe<Mvn_Token_Bool_Exp>;
  mvn_token_id?: InputMaybe<Bigint_Comparison_Exp>;
  operator?: InputMaybe<Maven_User_Bool_Exp>;
  operator_id?: InputMaybe<Bigint_Comparison_Exp>;
  owner?: InputMaybe<Maven_User_Bool_Exp>;
  owner_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mvn_Token_Operator_Max_Fields = {
  __typename?: 'mvn_token_operator_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  mvn_token_id?: Maybe<Scalars['bigint']['output']>;
  operator_id?: Maybe<Scalars['bigint']['output']>;
  owner_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "mvn_token_operator" */
export type Mvn_Token_Operator_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  operator_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mvn_Token_Operator_Min_Fields = {
  __typename?: 'mvn_token_operator_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  mvn_token_id?: Maybe<Scalars['bigint']['output']>;
  operator_id?: Maybe<Scalars['bigint']['output']>;
  owner_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "mvn_token_operator" */
export type Mvn_Token_Operator_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  operator_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "mvn_token_operator". */
export type Mvn_Token_Operator_Order_By = {
  id?: InputMaybe<Order_By>;
  mvn_token?: InputMaybe<Mvn_Token_Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  operator?: InputMaybe<Maven_User_Order_By>;
  operator_id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Maven_User_Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** select columns of table "mvn_token_operator" */
export enum Mvn_Token_Operator_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MvnTokenId = 'mvn_token_id',
  /** column name */
  OperatorId = 'operator_id',
  /** column name */
  OwnerId = 'owner_id'
}

/** aggregate stddev on columns */
export type Mvn_Token_Operator_Stddev_Fields = {
  __typename?: 'mvn_token_operator_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  mvn_token_id?: Maybe<Scalars['Float']['output']>;
  operator_id?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "mvn_token_operator" */
export type Mvn_Token_Operator_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  operator_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mvn_Token_Operator_Stddev_Pop_Fields = {
  __typename?: 'mvn_token_operator_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  mvn_token_id?: Maybe<Scalars['Float']['output']>;
  operator_id?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "mvn_token_operator" */
export type Mvn_Token_Operator_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  operator_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mvn_Token_Operator_Stddev_Samp_Fields = {
  __typename?: 'mvn_token_operator_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  mvn_token_id?: Maybe<Scalars['Float']['output']>;
  operator_id?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "mvn_token_operator" */
export type Mvn_Token_Operator_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  operator_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mvn_token_operator" */
export type Mvn_Token_Operator_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mvn_Token_Operator_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mvn_Token_Operator_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  mvn_token_id?: InputMaybe<Scalars['bigint']['input']>;
  operator_id?: InputMaybe<Scalars['bigint']['input']>;
  owner_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Mvn_Token_Operator_Sum_Fields = {
  __typename?: 'mvn_token_operator_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  mvn_token_id?: Maybe<Scalars['bigint']['output']>;
  operator_id?: Maybe<Scalars['bigint']['output']>;
  owner_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "mvn_token_operator" */
export type Mvn_Token_Operator_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  operator_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Mvn_Token_Operator_Var_Pop_Fields = {
  __typename?: 'mvn_token_operator_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  mvn_token_id?: Maybe<Scalars['Float']['output']>;
  operator_id?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "mvn_token_operator" */
export type Mvn_Token_Operator_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  operator_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mvn_Token_Operator_Var_Samp_Fields = {
  __typename?: 'mvn_token_operator_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  mvn_token_id?: Maybe<Scalars['Float']['output']>;
  operator_id?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "mvn_token_operator" */
export type Mvn_Token_Operator_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  operator_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mvn_Token_Operator_Variance_Fields = {
  __typename?: 'mvn_token_operator_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  mvn_token_id?: Maybe<Scalars['Float']['output']>;
  operator_id?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "mvn_token_operator" */
export type Mvn_Token_Operator_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  operator_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "mvn_token". */
export type Mvn_Token_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  general_contracts_aggregate?: InputMaybe<Mvn_Token_General_Contract_Aggregate_Order_By>;
  governance?: InputMaybe<Governance_Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inflation_rate?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  maximum_supply?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  mint_history_data_aggregate?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Aggregate_Order_By>;
  network?: InputMaybe<Order_By>;
  next_inflation_timestamp?: InputMaybe<Order_By>;
  operators_aggregate?: InputMaybe<Mvn_Token_Operator_Aggregate_Order_By>;
  token?: InputMaybe<Token_Order_By>;
  token_id?: InputMaybe<Order_By>;
  total_supply?: InputMaybe<Order_By>;
  transfer_history_data_aggregate?: InputMaybe<Mvn_Transfer_History_Data_Aggregate_Order_By>;
  whitelist_contracts_aggregate?: InputMaybe<Mvn_Token_Whitelist_Contract_Aggregate_Order_By>;
};

/** select columns of table "mvn_token" */
export enum Mvn_Token_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Admin = 'admin',
  /** column name */
  GovernanceId = 'governance_id',
  /** column name */
  Id = 'id',
  /** column name */
  InflationRate = 'inflation_rate',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  MaximumSupply = 'maximum_supply',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Network = 'network',
  /** column name */
  NextInflationTimestamp = 'next_inflation_timestamp',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  TotalSupply = 'total_supply'
}

/** select "mvn_token_aggregate_bool_exp_avg_arguments_columns" columns of table "mvn_token" */
export enum Mvn_Token_Select_Column_Mvn_Token_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  MaximumSupply = 'maximum_supply',
  /** column name */
  TotalSupply = 'total_supply'
}

/** select "mvn_token_aggregate_bool_exp_corr_arguments_columns" columns of table "mvn_token" */
export enum Mvn_Token_Select_Column_Mvn_Token_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  MaximumSupply = 'maximum_supply',
  /** column name */
  TotalSupply = 'total_supply'
}

/** select "mvn_token_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "mvn_token" */
export enum Mvn_Token_Select_Column_Mvn_Token_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  MaximumSupply = 'maximum_supply',
  /** column name */
  TotalSupply = 'total_supply'
}

/** select "mvn_token_aggregate_bool_exp_max_arguments_columns" columns of table "mvn_token" */
export enum Mvn_Token_Select_Column_Mvn_Token_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  MaximumSupply = 'maximum_supply',
  /** column name */
  TotalSupply = 'total_supply'
}

/** select "mvn_token_aggregate_bool_exp_min_arguments_columns" columns of table "mvn_token" */
export enum Mvn_Token_Select_Column_Mvn_Token_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  MaximumSupply = 'maximum_supply',
  /** column name */
  TotalSupply = 'total_supply'
}

/** select "mvn_token_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "mvn_token" */
export enum Mvn_Token_Select_Column_Mvn_Token_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  MaximumSupply = 'maximum_supply',
  /** column name */
  TotalSupply = 'total_supply'
}

/** select "mvn_token_aggregate_bool_exp_sum_arguments_columns" columns of table "mvn_token" */
export enum Mvn_Token_Select_Column_Mvn_Token_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  MaximumSupply = 'maximum_supply',
  /** column name */
  TotalSupply = 'total_supply'
}

/** select "mvn_token_aggregate_bool_exp_var_samp_arguments_columns" columns of table "mvn_token" */
export enum Mvn_Token_Select_Column_Mvn_Token_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  MaximumSupply = 'maximum_supply',
  /** column name */
  TotalSupply = 'total_supply'
}

/** aggregate stddev on columns */
export type Mvn_Token_Stddev_Fields = {
  __typename?: 'mvn_token_stddev_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  inflation_rate?: Maybe<Scalars['Float']['output']>;
  maximum_supply?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "mvn_token" */
export type Mvn_Token_Stddev_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inflation_rate?: InputMaybe<Order_By>;
  maximum_supply?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  total_supply?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mvn_Token_Stddev_Pop_Fields = {
  __typename?: 'mvn_token_stddev_pop_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  inflation_rate?: Maybe<Scalars['Float']['output']>;
  maximum_supply?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "mvn_token" */
export type Mvn_Token_Stddev_Pop_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inflation_rate?: InputMaybe<Order_By>;
  maximum_supply?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  total_supply?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mvn_Token_Stddev_Samp_Fields = {
  __typename?: 'mvn_token_stddev_samp_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  inflation_rate?: Maybe<Scalars['Float']['output']>;
  maximum_supply?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "mvn_token" */
export type Mvn_Token_Stddev_Samp_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inflation_rate?: InputMaybe<Order_By>;
  maximum_supply?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  total_supply?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mvn_token" */
export type Mvn_Token_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mvn_Token_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mvn_Token_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['String']['input']>;
  governance_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  inflation_rate?: InputMaybe<Scalars['smallint']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  maximum_supply?: InputMaybe<Scalars['float8']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  next_inflation_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  token_id?: InputMaybe<Scalars['bigint']['input']>;
  total_supply?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type Mvn_Token_Sum_Fields = {
  __typename?: 'mvn_token_sum_fields';
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  inflation_rate?: Maybe<Scalars['smallint']['output']>;
  maximum_supply?: Maybe<Scalars['float8']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  total_supply?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "mvn_token" */
export type Mvn_Token_Sum_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inflation_rate?: InputMaybe<Order_By>;
  maximum_supply?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  total_supply?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Mvn_Token_Var_Pop_Fields = {
  __typename?: 'mvn_token_var_pop_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  inflation_rate?: Maybe<Scalars['Float']['output']>;
  maximum_supply?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "mvn_token" */
export type Mvn_Token_Var_Pop_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inflation_rate?: InputMaybe<Order_By>;
  maximum_supply?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  total_supply?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mvn_Token_Var_Samp_Fields = {
  __typename?: 'mvn_token_var_samp_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  inflation_rate?: Maybe<Scalars['Float']['output']>;
  maximum_supply?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "mvn_token" */
export type Mvn_Token_Var_Samp_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inflation_rate?: InputMaybe<Order_By>;
  maximum_supply?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  total_supply?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mvn_Token_Variance_Fields = {
  __typename?: 'mvn_token_variance_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  inflation_rate?: Maybe<Scalars['Float']['output']>;
  maximum_supply?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "mvn_token" */
export type Mvn_Token_Variance_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inflation_rate?: InputMaybe<Order_By>;
  maximum_supply?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  total_supply?: InputMaybe<Order_By>;
};

/** columns and relationships of "mvn_token_whitelist_contract" */
export type Mvn_Token_Whitelist_Contract = {
  __typename?: 'mvn_token_whitelist_contract';
  /** An object relationship */
  contract: Mvn_Token;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "mvn_token_whitelist_contract" */
export type Mvn_Token_Whitelist_Contract_Aggregate = {
  __typename?: 'mvn_token_whitelist_contract_aggregate';
  aggregate?: Maybe<Mvn_Token_Whitelist_Contract_Aggregate_Fields>;
  nodes: Array<Mvn_Token_Whitelist_Contract>;
};

export type Mvn_Token_Whitelist_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Mvn_Token_Whitelist_Contract_Aggregate_Bool_Exp_Count>;
};

export type Mvn_Token_Whitelist_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Mvn_Token_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mvn_Token_Whitelist_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "mvn_token_whitelist_contract" */
export type Mvn_Token_Whitelist_Contract_Aggregate_Fields = {
  __typename?: 'mvn_token_whitelist_contract_aggregate_fields';
  avg?: Maybe<Mvn_Token_Whitelist_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mvn_Token_Whitelist_Contract_Max_Fields>;
  min?: Maybe<Mvn_Token_Whitelist_Contract_Min_Fields>;
  stddev?: Maybe<Mvn_Token_Whitelist_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Mvn_Token_Whitelist_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mvn_Token_Whitelist_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Mvn_Token_Whitelist_Contract_Sum_Fields>;
  var_pop?: Maybe<Mvn_Token_Whitelist_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Mvn_Token_Whitelist_Contract_Var_Samp_Fields>;
  variance?: Maybe<Mvn_Token_Whitelist_Contract_Variance_Fields>;
};


/** aggregate fields of "mvn_token_whitelist_contract" */
export type Mvn_Token_Whitelist_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mvn_Token_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "mvn_token_whitelist_contract" */
export type Mvn_Token_Whitelist_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Mvn_Token_Whitelist_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mvn_Token_Whitelist_Contract_Max_Order_By>;
  min?: InputMaybe<Mvn_Token_Whitelist_Contract_Min_Order_By>;
  stddev?: InputMaybe<Mvn_Token_Whitelist_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mvn_Token_Whitelist_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mvn_Token_Whitelist_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mvn_Token_Whitelist_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Mvn_Token_Whitelist_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mvn_Token_Whitelist_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Mvn_Token_Whitelist_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Mvn_Token_Whitelist_Contract_Avg_Fields = {
  __typename?: 'mvn_token_whitelist_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "mvn_token_whitelist_contract" */
export type Mvn_Token_Whitelist_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mvn_token_whitelist_contract". All fields are combined with a logical 'AND'. */
export type Mvn_Token_Whitelist_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Mvn_Token_Whitelist_Contract_Bool_Exp>>;
  _not?: InputMaybe<Mvn_Token_Whitelist_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Mvn_Token_Whitelist_Contract_Bool_Exp>>;
  contract?: InputMaybe<Mvn_Token_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mvn_Token_Whitelist_Contract_Max_Fields = {
  __typename?: 'mvn_token_whitelist_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "mvn_token_whitelist_contract" */
export type Mvn_Token_Whitelist_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mvn_Token_Whitelist_Contract_Min_Fields = {
  __typename?: 'mvn_token_whitelist_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "mvn_token_whitelist_contract" */
export type Mvn_Token_Whitelist_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "mvn_token_whitelist_contract". */
export type Mvn_Token_Whitelist_Contract_Order_By = {
  contract?: InputMaybe<Mvn_Token_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "mvn_token_whitelist_contract" */
export enum Mvn_Token_Whitelist_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Mvn_Token_Whitelist_Contract_Stddev_Fields = {
  __typename?: 'mvn_token_whitelist_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "mvn_token_whitelist_contract" */
export type Mvn_Token_Whitelist_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mvn_Token_Whitelist_Contract_Stddev_Pop_Fields = {
  __typename?: 'mvn_token_whitelist_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "mvn_token_whitelist_contract" */
export type Mvn_Token_Whitelist_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mvn_Token_Whitelist_Contract_Stddev_Samp_Fields = {
  __typename?: 'mvn_token_whitelist_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "mvn_token_whitelist_contract" */
export type Mvn_Token_Whitelist_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mvn_token_whitelist_contract" */
export type Mvn_Token_Whitelist_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mvn_Token_Whitelist_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mvn_Token_Whitelist_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Mvn_Token_Whitelist_Contract_Sum_Fields = {
  __typename?: 'mvn_token_whitelist_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "mvn_token_whitelist_contract" */
export type Mvn_Token_Whitelist_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Mvn_Token_Whitelist_Contract_Var_Pop_Fields = {
  __typename?: 'mvn_token_whitelist_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "mvn_token_whitelist_contract" */
export type Mvn_Token_Whitelist_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mvn_Token_Whitelist_Contract_Var_Samp_Fields = {
  __typename?: 'mvn_token_whitelist_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "mvn_token_whitelist_contract" */
export type Mvn_Token_Whitelist_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mvn_Token_Whitelist_Contract_Variance_Fields = {
  __typename?: 'mvn_token_whitelist_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "mvn_token_whitelist_contract" */
export type Mvn_Token_Whitelist_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "mvn_transfer_history_data" */
export type Mvn_Transfer_History_Data = {
  __typename?: 'mvn_transfer_history_data';
  amount: Scalars['bigint']['output'];
  /** An object relationship */
  from_: Maven_User;
  from__id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  mvn_token: Mvn_Token;
  mvn_token_id: Scalars['bigint']['output'];
  timestamp: Scalars['timestamptz']['output'];
  /** An object relationship */
  to_: Maven_User;
  to__id: Scalars['bigint']['output'];
};

/** aggregated selection of "mvn_transfer_history_data" */
export type Mvn_Transfer_History_Data_Aggregate = {
  __typename?: 'mvn_transfer_history_data_aggregate';
  aggregate?: Maybe<Mvn_Transfer_History_Data_Aggregate_Fields>;
  nodes: Array<Mvn_Transfer_History_Data>;
};

export type Mvn_Transfer_History_Data_Aggregate_Bool_Exp = {
  count?: InputMaybe<Mvn_Transfer_History_Data_Aggregate_Bool_Exp_Count>;
};

export type Mvn_Transfer_History_Data_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Mvn_Transfer_History_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mvn_Transfer_History_Data_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "mvn_transfer_history_data" */
export type Mvn_Transfer_History_Data_Aggregate_Fields = {
  __typename?: 'mvn_transfer_history_data_aggregate_fields';
  avg?: Maybe<Mvn_Transfer_History_Data_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mvn_Transfer_History_Data_Max_Fields>;
  min?: Maybe<Mvn_Transfer_History_Data_Min_Fields>;
  stddev?: Maybe<Mvn_Transfer_History_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Mvn_Transfer_History_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mvn_Transfer_History_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Mvn_Transfer_History_Data_Sum_Fields>;
  var_pop?: Maybe<Mvn_Transfer_History_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Mvn_Transfer_History_Data_Var_Samp_Fields>;
  variance?: Maybe<Mvn_Transfer_History_Data_Variance_Fields>;
};


/** aggregate fields of "mvn_transfer_history_data" */
export type Mvn_Transfer_History_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mvn_Transfer_History_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "mvn_transfer_history_data" */
export type Mvn_Transfer_History_Data_Aggregate_Order_By = {
  avg?: InputMaybe<Mvn_Transfer_History_Data_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mvn_Transfer_History_Data_Max_Order_By>;
  min?: InputMaybe<Mvn_Transfer_History_Data_Min_Order_By>;
  stddev?: InputMaybe<Mvn_Transfer_History_Data_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mvn_Transfer_History_Data_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mvn_Transfer_History_Data_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mvn_Transfer_History_Data_Sum_Order_By>;
  var_pop?: InputMaybe<Mvn_Transfer_History_Data_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mvn_Transfer_History_Data_Var_Samp_Order_By>;
  variance?: InputMaybe<Mvn_Transfer_History_Data_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Mvn_Transfer_History_Data_Avg_Fields = {
  __typename?: 'mvn_transfer_history_data_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  from__id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mvn_token_id?: Maybe<Scalars['Float']['output']>;
  to__id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "mvn_transfer_history_data" */
export type Mvn_Transfer_History_Data_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  from__id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mvn_transfer_history_data". All fields are combined with a logical 'AND'. */
export type Mvn_Transfer_History_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Mvn_Transfer_History_Data_Bool_Exp>>;
  _not?: InputMaybe<Mvn_Transfer_History_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Mvn_Transfer_History_Data_Bool_Exp>>;
  amount?: InputMaybe<Bigint_Comparison_Exp>;
  from_?: InputMaybe<Maven_User_Bool_Exp>;
  from__id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  mvn_token?: InputMaybe<Mvn_Token_Bool_Exp>;
  mvn_token_id?: InputMaybe<Bigint_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  to_?: InputMaybe<Maven_User_Bool_Exp>;
  to__id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mvn_Transfer_History_Data_Max_Fields = {
  __typename?: 'mvn_transfer_history_data_max_fields';
  amount?: Maybe<Scalars['bigint']['output']>;
  from__id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  mvn_token_id?: Maybe<Scalars['bigint']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  to__id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "mvn_transfer_history_data" */
export type Mvn_Transfer_History_Data_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  from__id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mvn_Transfer_History_Data_Min_Fields = {
  __typename?: 'mvn_transfer_history_data_min_fields';
  amount?: Maybe<Scalars['bigint']['output']>;
  from__id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  mvn_token_id?: Maybe<Scalars['bigint']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  to__id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "mvn_transfer_history_data" */
export type Mvn_Transfer_History_Data_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  from__id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "mvn_transfer_history_data". */
export type Mvn_Transfer_History_Data_Order_By = {
  amount?: InputMaybe<Order_By>;
  from_?: InputMaybe<Maven_User_Order_By>;
  from__id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mvn_token?: InputMaybe<Mvn_Token_Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  to_?: InputMaybe<Maven_User_Order_By>;
  to__id?: InputMaybe<Order_By>;
};

/** select columns of table "mvn_transfer_history_data" */
export enum Mvn_Transfer_History_Data_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  FromId = 'from__id',
  /** column name */
  Id = 'id',
  /** column name */
  MvnTokenId = 'mvn_token_id',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  ToId = 'to__id'
}

/** aggregate stddev on columns */
export type Mvn_Transfer_History_Data_Stddev_Fields = {
  __typename?: 'mvn_transfer_history_data_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  from__id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mvn_token_id?: Maybe<Scalars['Float']['output']>;
  to__id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "mvn_transfer_history_data" */
export type Mvn_Transfer_History_Data_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  from__id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mvn_Transfer_History_Data_Stddev_Pop_Fields = {
  __typename?: 'mvn_transfer_history_data_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  from__id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mvn_token_id?: Maybe<Scalars['Float']['output']>;
  to__id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "mvn_transfer_history_data" */
export type Mvn_Transfer_History_Data_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  from__id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mvn_Transfer_History_Data_Stddev_Samp_Fields = {
  __typename?: 'mvn_transfer_history_data_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  from__id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mvn_token_id?: Maybe<Scalars['Float']['output']>;
  to__id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "mvn_transfer_history_data" */
export type Mvn_Transfer_History_Data_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  from__id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mvn_transfer_history_data" */
export type Mvn_Transfer_History_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mvn_Transfer_History_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mvn_Transfer_History_Data_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['bigint']['input']>;
  from__id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  mvn_token_id?: InputMaybe<Scalars['bigint']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  to__id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Mvn_Transfer_History_Data_Sum_Fields = {
  __typename?: 'mvn_transfer_history_data_sum_fields';
  amount?: Maybe<Scalars['bigint']['output']>;
  from__id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  mvn_token_id?: Maybe<Scalars['bigint']['output']>;
  to__id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "mvn_transfer_history_data" */
export type Mvn_Transfer_History_Data_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  from__id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Mvn_Transfer_History_Data_Var_Pop_Fields = {
  __typename?: 'mvn_transfer_history_data_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  from__id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mvn_token_id?: Maybe<Scalars['Float']['output']>;
  to__id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "mvn_transfer_history_data" */
export type Mvn_Transfer_History_Data_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  from__id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mvn_Transfer_History_Data_Var_Samp_Fields = {
  __typename?: 'mvn_transfer_history_data_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  from__id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mvn_token_id?: Maybe<Scalars['Float']['output']>;
  to__id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "mvn_transfer_history_data" */
export type Mvn_Transfer_History_Data_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  from__id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mvn_Transfer_History_Data_Variance_Fields = {
  __typename?: 'mvn_transfer_history_data_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  from__id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mvn_token_id?: Maybe<Scalars['Float']['output']>;
  to__id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "mvn_transfer_history_data" */
export type Mvn_Transfer_History_Data_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  from__id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mvn_token_id?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "aggregator" */
  aggregator: Array<Aggregator>;
  /** fetch aggregated fields from the table: "aggregator" */
  aggregator_aggregate: Aggregator_Aggregate;
  /** fetch data from the table: "aggregator" using primary key columns */
  aggregator_by_pk?: Maybe<Aggregator>;
  /** fetch data from the table: "aggregator_factory" */
  aggregator_factory: Array<Aggregator_Factory>;
  /** fetch aggregated fields from the table: "aggregator_factory" */
  aggregator_factory_aggregate: Aggregator_Factory_Aggregate;
  /** fetch data from the table: "aggregator_factory_aggregator_lambda" */
  aggregator_factory_aggregator_lambda: Array<Aggregator_Factory_Aggregator_Lambda>;
  /** fetch aggregated fields from the table: "aggregator_factory_aggregator_lambda" */
  aggregator_factory_aggregator_lambda_aggregate: Aggregator_Factory_Aggregator_Lambda_Aggregate;
  /** fetch data from the table: "aggregator_factory_aggregator_lambda" using primary key columns */
  aggregator_factory_aggregator_lambda_by_pk?: Maybe<Aggregator_Factory_Aggregator_Lambda>;
  /** fetch data from the table: "aggregator_factory" using primary key columns */
  aggregator_factory_by_pk?: Maybe<Aggregator_Factory>;
  /** fetch data from the table: "aggregator_factory_general_contract" */
  aggregator_factory_general_contract: Array<Aggregator_Factory_General_Contract>;
  /** fetch aggregated fields from the table: "aggregator_factory_general_contract" */
  aggregator_factory_general_contract_aggregate: Aggregator_Factory_General_Contract_Aggregate;
  /** fetch data from the table: "aggregator_factory_general_contract" using primary key columns */
  aggregator_factory_general_contract_by_pk?: Maybe<Aggregator_Factory_General_Contract>;
  /** fetch data from the table: "aggregator_factory_lambda" */
  aggregator_factory_lambda: Array<Aggregator_Factory_Lambda>;
  /** fetch aggregated fields from the table: "aggregator_factory_lambda" */
  aggregator_factory_lambda_aggregate: Aggregator_Factory_Lambda_Aggregate;
  /** fetch data from the table: "aggregator_factory_lambda" using primary key columns */
  aggregator_factory_lambda_by_pk?: Maybe<Aggregator_Factory_Lambda>;
  /** fetch data from the table: "aggregator_factory_whitelist_contract" */
  aggregator_factory_whitelist_contract: Array<Aggregator_Factory_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "aggregator_factory_whitelist_contract" */
  aggregator_factory_whitelist_contract_aggregate: Aggregator_Factory_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "aggregator_factory_whitelist_contract" using primary key columns */
  aggregator_factory_whitelist_contract_by_pk?: Maybe<Aggregator_Factory_Whitelist_Contract>;
  /** fetch data from the table: "aggregator_general_contract" */
  aggregator_general_contract: Array<Aggregator_General_Contract>;
  /** fetch aggregated fields from the table: "aggregator_general_contract" */
  aggregator_general_contract_aggregate: Aggregator_General_Contract_Aggregate;
  /** fetch data from the table: "aggregator_general_contract" using primary key columns */
  aggregator_general_contract_by_pk?: Maybe<Aggregator_General_Contract>;
  /** fetch data from the table: "aggregator_history_data" */
  aggregator_history_data: Array<Aggregator_History_Data>;
  /** fetch aggregated fields from the table: "aggregator_history_data" */
  aggregator_history_data_aggregate: Aggregator_History_Data_Aggregate;
  /** fetch data from the table: "aggregator_history_data" using primary key columns */
  aggregator_history_data_by_pk?: Maybe<Aggregator_History_Data>;
  /** fetch data from the table: "aggregator_lambda" */
  aggregator_lambda: Array<Aggregator_Lambda>;
  /** fetch aggregated fields from the table: "aggregator_lambda" */
  aggregator_lambda_aggregate: Aggregator_Lambda_Aggregate;
  /** fetch data from the table: "aggregator_lambda" using primary key columns */
  aggregator_lambda_by_pk?: Maybe<Aggregator_Lambda>;
  /** fetch data from the table: "aggregator_oracle" */
  aggregator_oracle: Array<Aggregator_Oracle>;
  /** fetch aggregated fields from the table: "aggregator_oracle" */
  aggregator_oracle_aggregate: Aggregator_Oracle_Aggregate;
  /** fetch data from the table: "aggregator_oracle" using primary key columns */
  aggregator_oracle_by_pk?: Maybe<Aggregator_Oracle>;
  /** fetch data from the table: "aggregator_oracle_observation" */
  aggregator_oracle_observation: Array<Aggregator_Oracle_Observation>;
  /** fetch aggregated fields from the table: "aggregator_oracle_observation" */
  aggregator_oracle_observation_aggregate: Aggregator_Oracle_Observation_Aggregate;
  /** fetch data from the table: "aggregator_oracle_observation" using primary key columns */
  aggregator_oracle_observation_by_pk?: Maybe<Aggregator_Oracle_Observation>;
  /** fetch data from the table: "aggregator_oracle_reward" */
  aggregator_oracle_reward: Array<Aggregator_Oracle_Reward>;
  /** fetch aggregated fields from the table: "aggregator_oracle_reward" */
  aggregator_oracle_reward_aggregate: Aggregator_Oracle_Reward_Aggregate;
  /** fetch data from the table: "aggregator_oracle_reward" using primary key columns */
  aggregator_oracle_reward_by_pk?: Maybe<Aggregator_Oracle_Reward>;
  /** fetch data from the table: "aggregator_whitelist_contract" */
  aggregator_whitelist_contract: Array<Aggregator_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "aggregator_whitelist_contract" */
  aggregator_whitelist_contract_aggregate: Aggregator_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "aggregator_whitelist_contract" using primary key columns */
  aggregator_whitelist_contract_by_pk?: Maybe<Aggregator_Whitelist_Contract>;
  /** fetch data from the table: "break_glass" */
  break_glass: Array<Break_Glass>;
  /** fetch data from the table: "break_glass_action" */
  break_glass_action: Array<Break_Glass_Action>;
  /** fetch aggregated fields from the table: "break_glass_action" */
  break_glass_action_aggregate: Break_Glass_Action_Aggregate;
  /** fetch data from the table: "break_glass_action" using primary key columns */
  break_glass_action_by_pk?: Maybe<Break_Glass_Action>;
  /** fetch data from the table: "break_glass_action_parameter" */
  break_glass_action_parameter: Array<Break_Glass_Action_Parameter>;
  /** fetch aggregated fields from the table: "break_glass_action_parameter" */
  break_glass_action_parameter_aggregate: Break_Glass_Action_Parameter_Aggregate;
  /** fetch data from the table: "break_glass_action_parameter" using primary key columns */
  break_glass_action_parameter_by_pk?: Maybe<Break_Glass_Action_Parameter>;
  /** fetch data from the table: "break_glass_action_signer" */
  break_glass_action_signer: Array<Break_Glass_Action_Signer>;
  /** fetch aggregated fields from the table: "break_glass_action_signer" */
  break_glass_action_signer_aggregate: Break_Glass_Action_Signer_Aggregate;
  /** fetch data from the table: "break_glass_action_signer" using primary key columns */
  break_glass_action_signer_by_pk?: Maybe<Break_Glass_Action_Signer>;
  /** fetch data from the table: "break_glass_action_temp_parameter" */
  break_glass_action_temp_parameter: Array<Break_Glass_Action_Temp_Parameter>;
  /** fetch aggregated fields from the table: "break_glass_action_temp_parameter" */
  break_glass_action_temp_parameter_aggregate: Break_Glass_Action_Temp_Parameter_Aggregate;
  /** fetch data from the table: "break_glass_action_temp_parameter" using primary key columns */
  break_glass_action_temp_parameter_by_pk?: Maybe<Break_Glass_Action_Temp_Parameter>;
  /** fetch aggregated fields from the table: "break_glass" */
  break_glass_aggregate: Break_Glass_Aggregate;
  /** fetch data from the table: "break_glass" using primary key columns */
  break_glass_by_pk?: Maybe<Break_Glass>;
  /** fetch data from the table: "break_glass_council_member" */
  break_glass_council_member: Array<Break_Glass_Council_Member>;
  /** fetch aggregated fields from the table: "break_glass_council_member" */
  break_glass_council_member_aggregate: Break_Glass_Council_Member_Aggregate;
  /** fetch data from the table: "break_glass_council_member" using primary key columns */
  break_glass_council_member_by_pk?: Maybe<Break_Glass_Council_Member>;
  /** fetch data from the table: "break_glass_general_contract" */
  break_glass_general_contract: Array<Break_Glass_General_Contract>;
  /** fetch aggregated fields from the table: "break_glass_general_contract" */
  break_glass_general_contract_aggregate: Break_Glass_General_Contract_Aggregate;
  /** fetch data from the table: "break_glass_general_contract" using primary key columns */
  break_glass_general_contract_by_pk?: Maybe<Break_Glass_General_Contract>;
  /** fetch data from the table: "break_glass_lambda" */
  break_glass_lambda: Array<Break_Glass_Lambda>;
  /** fetch aggregated fields from the table: "break_glass_lambda" */
  break_glass_lambda_aggregate: Break_Glass_Lambda_Aggregate;
  /** fetch data from the table: "break_glass_lambda" using primary key columns */
  break_glass_lambda_by_pk?: Maybe<Break_Glass_Lambda>;
  /** fetch data from the table: "break_glass_whitelist_contract" */
  break_glass_whitelist_contract: Array<Break_Glass_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "break_glass_whitelist_contract" */
  break_glass_whitelist_contract_aggregate: Break_Glass_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "break_glass_whitelist_contract" using primary key columns */
  break_glass_whitelist_contract_by_pk?: Maybe<Break_Glass_Whitelist_Contract>;
  /** fetch data from the table: "council" */
  council: Array<Council>;
  /** fetch data from the table: "council_action" */
  council_action: Array<Council_Action>;
  /** fetch aggregated fields from the table: "council_action" */
  council_action_aggregate: Council_Action_Aggregate;
  /** fetch data from the table: "council_action" using primary key columns */
  council_action_by_pk?: Maybe<Council_Action>;
  /** fetch data from the table: "council_action_parameter" */
  council_action_parameter: Array<Council_Action_Parameter>;
  /** fetch aggregated fields from the table: "council_action_parameter" */
  council_action_parameter_aggregate: Council_Action_Parameter_Aggregate;
  /** fetch data from the table: "council_action_parameter" using primary key columns */
  council_action_parameter_by_pk?: Maybe<Council_Action_Parameter>;
  /** fetch data from the table: "council_action_signer" */
  council_action_signer: Array<Council_Action_Signer>;
  /** fetch aggregated fields from the table: "council_action_signer" */
  council_action_signer_aggregate: Council_Action_Signer_Aggregate;
  /** fetch data from the table: "council_action_signer" using primary key columns */
  council_action_signer_by_pk?: Maybe<Council_Action_Signer>;
  /** fetch data from the table: "council_action_temp_parameter" */
  council_action_temp_parameter: Array<Council_Action_Temp_Parameter>;
  /** fetch aggregated fields from the table: "council_action_temp_parameter" */
  council_action_temp_parameter_aggregate: Council_Action_Temp_Parameter_Aggregate;
  /** fetch data from the table: "council_action_temp_parameter" using primary key columns */
  council_action_temp_parameter_by_pk?: Maybe<Council_Action_Temp_Parameter>;
  /** fetch aggregated fields from the table: "council" */
  council_aggregate: Council_Aggregate;
  /** fetch data from the table: "council" using primary key columns */
  council_by_pk?: Maybe<Council>;
  /** fetch data from the table: "council_council_member" */
  council_council_member: Array<Council_Council_Member>;
  /** fetch aggregated fields from the table: "council_council_member" */
  council_council_member_aggregate: Council_Council_Member_Aggregate;
  /** fetch data from the table: "council_council_member" using primary key columns */
  council_council_member_by_pk?: Maybe<Council_Council_Member>;
  /** fetch data from the table: "council_general_contract" */
  council_general_contract: Array<Council_General_Contract>;
  /** fetch aggregated fields from the table: "council_general_contract" */
  council_general_contract_aggregate: Council_General_Contract_Aggregate;
  /** fetch data from the table: "council_general_contract" using primary key columns */
  council_general_contract_by_pk?: Maybe<Council_General_Contract>;
  /** fetch data from the table: "council_lambda" */
  council_lambda: Array<Council_Lambda>;
  /** fetch aggregated fields from the table: "council_lambda" */
  council_lambda_aggregate: Council_Lambda_Aggregate;
  /** fetch data from the table: "council_lambda" using primary key columns */
  council_lambda_by_pk?: Maybe<Council_Lambda>;
  /** fetch data from the table: "council_whitelist_contract" */
  council_whitelist_contract: Array<Council_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "council_whitelist_contract" */
  council_whitelist_contract_aggregate: Council_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "council_whitelist_contract" using primary key columns */
  council_whitelist_contract_by_pk?: Maybe<Council_Whitelist_Contract>;
  /** fetch data from the table: "delegation" */
  delegation: Array<Delegation>;
  /** fetch aggregated fields from the table: "delegation" */
  delegation_aggregate: Delegation_Aggregate;
  /** fetch data from the table: "delegation" using primary key columns */
  delegation_by_pk?: Maybe<Delegation>;
  /** fetch data from the table: "delegation_general_contract" */
  delegation_general_contract: Array<Delegation_General_Contract>;
  /** fetch aggregated fields from the table: "delegation_general_contract" */
  delegation_general_contract_aggregate: Delegation_General_Contract_Aggregate;
  /** fetch data from the table: "delegation_general_contract" using primary key columns */
  delegation_general_contract_by_pk?: Maybe<Delegation_General_Contract>;
  /** fetch data from the table: "delegation_lambda" */
  delegation_lambda: Array<Delegation_Lambda>;
  /** fetch aggregated fields from the table: "delegation_lambda" */
  delegation_lambda_aggregate: Delegation_Lambda_Aggregate;
  /** fetch data from the table: "delegation_lambda" using primary key columns */
  delegation_lambda_by_pk?: Maybe<Delegation_Lambda>;
  /** fetch data from the table: "delegation_record" */
  delegation_record: Array<Delegation_Record>;
  /** fetch aggregated fields from the table: "delegation_record" */
  delegation_record_aggregate: Delegation_Record_Aggregate;
  /** fetch data from the table: "delegation_record" using primary key columns */
  delegation_record_by_pk?: Maybe<Delegation_Record>;
  /** fetch data from the table: "delegation_whitelist_contract" */
  delegation_whitelist_contract: Array<Delegation_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "delegation_whitelist_contract" */
  delegation_whitelist_contract_aggregate: Delegation_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "delegation_whitelist_contract" using primary key columns */
  delegation_whitelist_contract_by_pk?: Maybe<Delegation_Whitelist_Contract>;
  /** fetch data from the table: "dipdup_contract" */
  dipdup_contract: Array<Dipdup_Contract>;
  /** fetch aggregated fields from the table: "dipdup_contract" */
  dipdup_contract_aggregate: Dipdup_Contract_Aggregate;
  /** fetch data from the table: "dipdup_contract" using primary key columns */
  dipdup_contract_by_pk?: Maybe<Dipdup_Contract>;
  /** fetch data from the table: "dipdup_contract_metadata" */
  dipdup_contract_metadata: Array<Dipdup_Contract_Metadata>;
  /** fetch aggregated fields from the table: "dipdup_contract_metadata" */
  dipdup_contract_metadata_aggregate: Dipdup_Contract_Metadata_Aggregate;
  /** fetch data from the table: "dipdup_contract_metadata" using primary key columns */
  dipdup_contract_metadata_by_pk?: Maybe<Dipdup_Contract_Metadata>;
  /** fetch data from the table: "dipdup_exception" */
  dipdup_exception: Array<Dipdup_Exception>;
  /** fetch aggregated fields from the table: "dipdup_exception" */
  dipdup_exception_aggregate: Dipdup_Exception_Aggregate;
  /** fetch data from the table: "dipdup_exception" using primary key columns */
  dipdup_exception_by_pk?: Maybe<Dipdup_Exception>;
  /** fetch data from the table: "dipdup_head" */
  dipdup_head: Array<Dipdup_Head>;
  /** fetch aggregated fields from the table: "dipdup_head" */
  dipdup_head_aggregate: Dipdup_Head_Aggregate;
  /** fetch data from the table: "dipdup_head" using primary key columns */
  dipdup_head_by_pk?: Maybe<Dipdup_Head>;
  /** fetch data from the table: "dipdup_index" */
  dipdup_index: Array<Dipdup_Index>;
  /** fetch aggregated fields from the table: "dipdup_index" */
  dipdup_index_aggregate: Dipdup_Index_Aggregate;
  /** fetch data from the table: "dipdup_index" using primary key columns */
  dipdup_index_by_pk?: Maybe<Dipdup_Index>;
  /** fetch data from the table: "dipdup_meta" */
  dipdup_meta: Array<Dipdup_Meta>;
  /** fetch aggregated fields from the table: "dipdup_meta" */
  dipdup_meta_aggregate: Dipdup_Meta_Aggregate;
  /** fetch data from the table: "dipdup_meta" using primary key columns */
  dipdup_meta_by_pk?: Maybe<Dipdup_Meta>;
  /** fetch data from the table: "dipdup_model_update" */
  dipdup_model_update: Array<Dipdup_Model_Update>;
  /** fetch aggregated fields from the table: "dipdup_model_update" */
  dipdup_model_update_aggregate: Dipdup_Model_Update_Aggregate;
  /** fetch data from the table: "dipdup_model_update" using primary key columns */
  dipdup_model_update_by_pk?: Maybe<Dipdup_Model_Update>;
  /** fetch data from the table: "dipdup_schema" */
  dipdup_schema: Array<Dipdup_Schema>;
  /** fetch aggregated fields from the table: "dipdup_schema" */
  dipdup_schema_aggregate: Dipdup_Schema_Aggregate;
  /** fetch data from the table: "dipdup_schema" using primary key columns */
  dipdup_schema_by_pk?: Maybe<Dipdup_Schema>;
  /** fetch data from the table: "dipdup_status" */
  dipdup_status: Array<Dipdup_Status>;
  /** fetch aggregated fields from the table: "dipdup_status" */
  dipdup_status_aggregate: Dipdup_Status_Aggregate;
  /** fetch data from the table: "dipdup_token_metadata" */
  dipdup_token_metadata: Array<Dipdup_Token_Metadata>;
  /** fetch aggregated fields from the table: "dipdup_token_metadata" */
  dipdup_token_metadata_aggregate: Dipdup_Token_Metadata_Aggregate;
  /** fetch data from the table: "dipdup_token_metadata" using primary key columns */
  dipdup_token_metadata_by_pk?: Maybe<Dipdup_Token_Metadata>;
  /** fetch data from the table: "doorman" */
  doorman: Array<Doorman>;
  /** fetch aggregated fields from the table: "doorman" */
  doorman_aggregate: Doorman_Aggregate;
  /** fetch data from the table: "doorman" using primary key columns */
  doorman_by_pk?: Maybe<Doorman>;
  /** fetch data from the table: "doorman_general_contract" */
  doorman_general_contract: Array<Doorman_General_Contract>;
  /** fetch aggregated fields from the table: "doorman_general_contract" */
  doorman_general_contract_aggregate: Doorman_General_Contract_Aggregate;
  /** fetch data from the table: "doorman_general_contract" using primary key columns */
  doorman_general_contract_by_pk?: Maybe<Doorman_General_Contract>;
  /** fetch data from the table: "doorman_lambda" */
  doorman_lambda: Array<Doorman_Lambda>;
  /** fetch aggregated fields from the table: "doorman_lambda" */
  doorman_lambda_aggregate: Doorman_Lambda_Aggregate;
  /** fetch data from the table: "doorman_lambda" using primary key columns */
  doorman_lambda_by_pk?: Maybe<Doorman_Lambda>;
  /** fetch data from the table: "doorman_stake_account" */
  doorman_stake_account: Array<Doorman_Stake_Account>;
  /** fetch aggregated fields from the table: "doorman_stake_account" */
  doorman_stake_account_aggregate: Doorman_Stake_Account_Aggregate;
  /** fetch data from the table: "doorman_stake_account" using primary key columns */
  doorman_stake_account_by_pk?: Maybe<Doorman_Stake_Account>;
  /** fetch data from the table: "doorman_whitelist_contract" */
  doorman_whitelist_contract: Array<Doorman_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "doorman_whitelist_contract" */
  doorman_whitelist_contract_aggregate: Doorman_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "doorman_whitelist_contract" using primary key columns */
  doorman_whitelist_contract_by_pk?: Maybe<Doorman_Whitelist_Contract>;
  /** fetch data from the table: "emergency_governance" */
  emergency_governance: Array<Emergency_Governance>;
  /** fetch aggregated fields from the table: "emergency_governance" */
  emergency_governance_aggregate: Emergency_Governance_Aggregate;
  /** fetch data from the table: "emergency_governance" using primary key columns */
  emergency_governance_by_pk?: Maybe<Emergency_Governance>;
  /** fetch data from the table: "emergency_governance_general_contract" */
  emergency_governance_general_contract: Array<Emergency_Governance_General_Contract>;
  /** fetch aggregated fields from the table: "emergency_governance_general_contract" */
  emergency_governance_general_contract_aggregate: Emergency_Governance_General_Contract_Aggregate;
  /** fetch data from the table: "emergency_governance_general_contract" using primary key columns */
  emergency_governance_general_contract_by_pk?: Maybe<Emergency_Governance_General_Contract>;
  /** fetch data from the table: "emergency_governance_lambda" */
  emergency_governance_lambda: Array<Emergency_Governance_Lambda>;
  /** fetch aggregated fields from the table: "emergency_governance_lambda" */
  emergency_governance_lambda_aggregate: Emergency_Governance_Lambda_Aggregate;
  /** fetch data from the table: "emergency_governance_lambda" using primary key columns */
  emergency_governance_lambda_by_pk?: Maybe<Emergency_Governance_Lambda>;
  /** fetch data from the table: "emergency_governance_record" */
  emergency_governance_record: Array<Emergency_Governance_Record>;
  /** fetch aggregated fields from the table: "emergency_governance_record" */
  emergency_governance_record_aggregate: Emergency_Governance_Record_Aggregate;
  /** fetch data from the table: "emergency_governance_record" using primary key columns */
  emergency_governance_record_by_pk?: Maybe<Emergency_Governance_Record>;
  /** fetch data from the table: "emergency_governance_vote" */
  emergency_governance_vote: Array<Emergency_Governance_Vote>;
  /** fetch aggregated fields from the table: "emergency_governance_vote" */
  emergency_governance_vote_aggregate: Emergency_Governance_Vote_Aggregate;
  /** fetch data from the table: "emergency_governance_vote" using primary key columns */
  emergency_governance_vote_by_pk?: Maybe<Emergency_Governance_Vote>;
  /** fetch data from the table: "emergency_governance_whitelist_contract" */
  emergency_governance_whitelist_contract: Array<Emergency_Governance_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "emergency_governance_whitelist_contract" */
  emergency_governance_whitelist_contract_aggregate: Emergency_Governance_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "emergency_governance_whitelist_contract" using primary key columns */
  emergency_governance_whitelist_contract_by_pk?: Maybe<Emergency_Governance_Whitelist_Contract>;
  /** fetch data from the table: "farm" */
  farm: Array<Farm>;
  /** fetch data from the table: "farm_account" */
  farm_account: Array<Farm_Account>;
  /** fetch aggregated fields from the table: "farm_account" */
  farm_account_aggregate: Farm_Account_Aggregate;
  /** fetch data from the table: "farm_account" using primary key columns */
  farm_account_by_pk?: Maybe<Farm_Account>;
  /** fetch aggregated fields from the table: "farm" */
  farm_aggregate: Farm_Aggregate;
  /** fetch data from the table: "farm" using primary key columns */
  farm_by_pk?: Maybe<Farm>;
  /** fetch data from the table: "farm_factory" */
  farm_factory: Array<Farm_Factory>;
  /** fetch aggregated fields from the table: "farm_factory" */
  farm_factory_aggregate: Farm_Factory_Aggregate;
  /** fetch data from the table: "farm_factory" using primary key columns */
  farm_factory_by_pk?: Maybe<Farm_Factory>;
  /** fetch data from the table: "farm_factory_farm_lambda" */
  farm_factory_farm_lambda: Array<Farm_Factory_Farm_Lambda>;
  /** fetch aggregated fields from the table: "farm_factory_farm_lambda" */
  farm_factory_farm_lambda_aggregate: Farm_Factory_Farm_Lambda_Aggregate;
  /** fetch data from the table: "farm_factory_farm_lambda" using primary key columns */
  farm_factory_farm_lambda_by_pk?: Maybe<Farm_Factory_Farm_Lambda>;
  /** fetch data from the table: "farm_factory_general_contract" */
  farm_factory_general_contract: Array<Farm_Factory_General_Contract>;
  /** fetch aggregated fields from the table: "farm_factory_general_contract" */
  farm_factory_general_contract_aggregate: Farm_Factory_General_Contract_Aggregate;
  /** fetch data from the table: "farm_factory_general_contract" using primary key columns */
  farm_factory_general_contract_by_pk?: Maybe<Farm_Factory_General_Contract>;
  /** fetch data from the table: "farm_factory_lambda" */
  farm_factory_lambda: Array<Farm_Factory_Lambda>;
  /** fetch aggregated fields from the table: "farm_factory_lambda" */
  farm_factory_lambda_aggregate: Farm_Factory_Lambda_Aggregate;
  /** fetch data from the table: "farm_factory_lambda" using primary key columns */
  farm_factory_lambda_by_pk?: Maybe<Farm_Factory_Lambda>;
  /** fetch data from the table: "farm_factory_m_farm_lambda" */
  farm_factory_m_farm_lambda: Array<Farm_Factory_M_Farm_Lambda>;
  /** fetch aggregated fields from the table: "farm_factory_m_farm_lambda" */
  farm_factory_m_farm_lambda_aggregate: Farm_Factory_M_Farm_Lambda_Aggregate;
  /** fetch data from the table: "farm_factory_m_farm_lambda" using primary key columns */
  farm_factory_m_farm_lambda_by_pk?: Maybe<Farm_Factory_M_Farm_Lambda>;
  /** fetch data from the table: "farm_factory_whitelist_contract" */
  farm_factory_whitelist_contract: Array<Farm_Factory_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "farm_factory_whitelist_contract" */
  farm_factory_whitelist_contract_aggregate: Farm_Factory_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "farm_factory_whitelist_contract" using primary key columns */
  farm_factory_whitelist_contract_by_pk?: Maybe<Farm_Factory_Whitelist_Contract>;
  /** fetch data from the table: "farm_general_contract" */
  farm_general_contract: Array<Farm_General_Contract>;
  /** fetch aggregated fields from the table: "farm_general_contract" */
  farm_general_contract_aggregate: Farm_General_Contract_Aggregate;
  /** fetch data from the table: "farm_general_contract" using primary key columns */
  farm_general_contract_by_pk?: Maybe<Farm_General_Contract>;
  /** fetch data from the table: "farm_lambda" */
  farm_lambda: Array<Farm_Lambda>;
  /** fetch aggregated fields from the table: "farm_lambda" */
  farm_lambda_aggregate: Farm_Lambda_Aggregate;
  /** fetch data from the table: "farm_lambda" using primary key columns */
  farm_lambda_by_pk?: Maybe<Farm_Lambda>;
  /** fetch data from the table: "farm_whitelist_contract" */
  farm_whitelist_contract: Array<Farm_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "farm_whitelist_contract" */
  farm_whitelist_contract_aggregate: Farm_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "farm_whitelist_contract" using primary key columns */
  farm_whitelist_contract_by_pk?: Maybe<Farm_Whitelist_Contract>;
  /** fetch data from the table: "governance" */
  governance: Array<Governance>;
  /** fetch aggregated fields from the table: "governance" */
  governance_aggregate: Governance_Aggregate;
  /** fetch data from the table: "governance" using primary key columns */
  governance_by_pk?: Maybe<Governance>;
  /** fetch data from the table: "governance_financial" */
  governance_financial: Array<Governance_Financial>;
  /** fetch aggregated fields from the table: "governance_financial" */
  governance_financial_aggregate: Governance_Financial_Aggregate;
  /** fetch data from the table: "governance_financial" using primary key columns */
  governance_financial_by_pk?: Maybe<Governance_Financial>;
  /** fetch data from the table: "governance_financial_general_contract" */
  governance_financial_general_contract: Array<Governance_Financial_General_Contract>;
  /** fetch aggregated fields from the table: "governance_financial_general_contract" */
  governance_financial_general_contract_aggregate: Governance_Financial_General_Contract_Aggregate;
  /** fetch data from the table: "governance_financial_general_contract" using primary key columns */
  governance_financial_general_contract_by_pk?: Maybe<Governance_Financial_General_Contract>;
  /** fetch data from the table: "governance_financial_lambda" */
  governance_financial_lambda: Array<Governance_Financial_Lambda>;
  /** fetch aggregated fields from the table: "governance_financial_lambda" */
  governance_financial_lambda_aggregate: Governance_Financial_Lambda_Aggregate;
  /** fetch data from the table: "governance_financial_lambda" using primary key columns */
  governance_financial_lambda_by_pk?: Maybe<Governance_Financial_Lambda>;
  /** fetch data from the table: "governance_financial_request" */
  governance_financial_request: Array<Governance_Financial_Request>;
  /** fetch aggregated fields from the table: "governance_financial_request" */
  governance_financial_request_aggregate: Governance_Financial_Request_Aggregate;
  /** fetch data from the table: "governance_financial_request" using primary key columns */
  governance_financial_request_by_pk?: Maybe<Governance_Financial_Request>;
  /** fetch data from the table: "governance_financial_request_vote" */
  governance_financial_request_vote: Array<Governance_Financial_Request_Vote>;
  /** fetch aggregated fields from the table: "governance_financial_request_vote" */
  governance_financial_request_vote_aggregate: Governance_Financial_Request_Vote_Aggregate;
  /** fetch data from the table: "governance_financial_request_vote" using primary key columns */
  governance_financial_request_vote_by_pk?: Maybe<Governance_Financial_Request_Vote>;
  /** fetch data from the table: "governance_financial_whitelist_contract" */
  governance_financial_whitelist_contract: Array<Governance_Financial_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "governance_financial_whitelist_contract" */
  governance_financial_whitelist_contract_aggregate: Governance_Financial_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "governance_financial_whitelist_contract" using primary key columns */
  governance_financial_whitelist_contract_by_pk?: Maybe<Governance_Financial_Whitelist_Contract>;
  /** fetch data from the table: "governance_financial_whitelist_token_contract" */
  governance_financial_whitelist_token_contract: Array<Governance_Financial_Whitelist_Token_Contract>;
  /** fetch aggregated fields from the table: "governance_financial_whitelist_token_contract" */
  governance_financial_whitelist_token_contract_aggregate: Governance_Financial_Whitelist_Token_Contract_Aggregate;
  /** fetch data from the table: "governance_financial_whitelist_token_contract" using primary key columns */
  governance_financial_whitelist_token_contract_by_pk?: Maybe<Governance_Financial_Whitelist_Token_Contract>;
  /** fetch data from the table: "governance_general_contract" */
  governance_general_contract: Array<Governance_General_Contract>;
  /** fetch aggregated fields from the table: "governance_general_contract" */
  governance_general_contract_aggregate: Governance_General_Contract_Aggregate;
  /** fetch data from the table: "governance_general_contract" using primary key columns */
  governance_general_contract_by_pk?: Maybe<Governance_General_Contract>;
  /** fetch data from the table: "governance_lambda" */
  governance_lambda: Array<Governance_Lambda>;
  /** fetch aggregated fields from the table: "governance_lambda" */
  governance_lambda_aggregate: Governance_Lambda_Aggregate;
  /** fetch data from the table: "governance_lambda" using primary key columns */
  governance_lambda_by_pk?: Maybe<Governance_Lambda>;
  /** fetch data from the table: "governance_proposal" */
  governance_proposal: Array<Governance_Proposal>;
  /** fetch aggregated fields from the table: "governance_proposal" */
  governance_proposal_aggregate: Governance_Proposal_Aggregate;
  /** fetch data from the table: "governance_proposal" using primary key columns */
  governance_proposal_by_pk?: Maybe<Governance_Proposal>;
  /** fetch data from the table: "governance_proposal_data" */
  governance_proposal_data: Array<Governance_Proposal_Data>;
  /** fetch aggregated fields from the table: "governance_proposal_data" */
  governance_proposal_data_aggregate: Governance_Proposal_Data_Aggregate;
  /** fetch data from the table: "governance_proposal_data" using primary key columns */
  governance_proposal_data_by_pk?: Maybe<Governance_Proposal_Data>;
  /** fetch data from the table: "governance_proposal_payment" */
  governance_proposal_payment: Array<Governance_Proposal_Payment>;
  /** fetch aggregated fields from the table: "governance_proposal_payment" */
  governance_proposal_payment_aggregate: Governance_Proposal_Payment_Aggregate;
  /** fetch data from the table: "governance_proposal_payment" using primary key columns */
  governance_proposal_payment_by_pk?: Maybe<Governance_Proposal_Payment>;
  /** fetch data from the table: "governance_proposal_vote" */
  governance_proposal_vote: Array<Governance_Proposal_Vote>;
  /** fetch aggregated fields from the table: "governance_proposal_vote" */
  governance_proposal_vote_aggregate: Governance_Proposal_Vote_Aggregate;
  /** fetch data from the table: "governance_proposal_vote" using primary key columns */
  governance_proposal_vote_by_pk?: Maybe<Governance_Proposal_Vote>;
  /** fetch data from the table: "governance_proxy" */
  governance_proxy: Array<Governance_Proxy>;
  /** fetch aggregated fields from the table: "governance_proxy" */
  governance_proxy_aggregate: Governance_Proxy_Aggregate;
  /** fetch data from the table: "governance_proxy" using primary key columns */
  governance_proxy_by_pk?: Maybe<Governance_Proxy>;
  /** fetch data from the table: "governance_proxy_lambda" */
  governance_proxy_lambda: Array<Governance_Proxy_Lambda>;
  /** fetch aggregated fields from the table: "governance_proxy_lambda" */
  governance_proxy_lambda_aggregate: Governance_Proxy_Lambda_Aggregate;
  /** fetch data from the table: "governance_proxy_lambda" using primary key columns */
  governance_proxy_lambda_by_pk?: Maybe<Governance_Proxy_Lambda>;
  /** fetch data from the table: "governance_satellite" */
  governance_satellite: Array<Governance_Satellite>;
  /** fetch data from the table: "governance_satellite_action" */
  governance_satellite_action: Array<Governance_Satellite_Action>;
  /** fetch aggregated fields from the table: "governance_satellite_action" */
  governance_satellite_action_aggregate: Governance_Satellite_Action_Aggregate;
  /** fetch data from the table: "governance_satellite_action" using primary key columns */
  governance_satellite_action_by_pk?: Maybe<Governance_Satellite_Action>;
  /** fetch data from the table: "governance_satellite_action_parameter" */
  governance_satellite_action_parameter: Array<Governance_Satellite_Action_Parameter>;
  /** fetch aggregated fields from the table: "governance_satellite_action_parameter" */
  governance_satellite_action_parameter_aggregate: Governance_Satellite_Action_Parameter_Aggregate;
  /** fetch data from the table: "governance_satellite_action_parameter" using primary key columns */
  governance_satellite_action_parameter_by_pk?: Maybe<Governance_Satellite_Action_Parameter>;
  /** fetch data from the table: "governance_satellite_action_vote" */
  governance_satellite_action_vote: Array<Governance_Satellite_Action_Vote>;
  /** fetch aggregated fields from the table: "governance_satellite_action_vote" */
  governance_satellite_action_vote_aggregate: Governance_Satellite_Action_Vote_Aggregate;
  /** fetch data from the table: "governance_satellite_action_vote" using primary key columns */
  governance_satellite_action_vote_by_pk?: Maybe<Governance_Satellite_Action_Vote>;
  /** fetch aggregated fields from the table: "governance_satellite" */
  governance_satellite_aggregate: Governance_Satellite_Aggregate;
  /** fetch data from the table: "governance_satellite" using primary key columns */
  governance_satellite_by_pk?: Maybe<Governance_Satellite>;
  /** fetch data from the table: "governance_satellite_general_contract" */
  governance_satellite_general_contract: Array<Governance_Satellite_General_Contract>;
  /** fetch aggregated fields from the table: "governance_satellite_general_contract" */
  governance_satellite_general_contract_aggregate: Governance_Satellite_General_Contract_Aggregate;
  /** fetch data from the table: "governance_satellite_general_contract" using primary key columns */
  governance_satellite_general_contract_by_pk?: Maybe<Governance_Satellite_General_Contract>;
  /** fetch data from the table: "governance_satellite_lambda" */
  governance_satellite_lambda: Array<Governance_Satellite_Lambda>;
  /** fetch aggregated fields from the table: "governance_satellite_lambda" */
  governance_satellite_lambda_aggregate: Governance_Satellite_Lambda_Aggregate;
  /** fetch data from the table: "governance_satellite_lambda" using primary key columns */
  governance_satellite_lambda_by_pk?: Maybe<Governance_Satellite_Lambda>;
  /** fetch data from the table: "governance_satellite_oracle" */
  governance_satellite_oracle: Array<Governance_Satellite_Oracle>;
  /** fetch aggregated fields from the table: "governance_satellite_oracle" */
  governance_satellite_oracle_aggregate: Governance_Satellite_Oracle_Aggregate;
  /** fetch data from the table: "governance_satellite_oracle_aggregator" */
  governance_satellite_oracle_aggregator: Array<Governance_Satellite_Oracle_Aggregator>;
  /** fetch aggregated fields from the table: "governance_satellite_oracle_aggregator" */
  governance_satellite_oracle_aggregator_aggregate: Governance_Satellite_Oracle_Aggregator_Aggregate;
  /** fetch data from the table: "governance_satellite_oracle_aggregator" using primary key columns */
  governance_satellite_oracle_aggregator_by_pk?: Maybe<Governance_Satellite_Oracle_Aggregator>;
  /** fetch data from the table: "governance_satellite_oracle" using primary key columns */
  governance_satellite_oracle_by_pk?: Maybe<Governance_Satellite_Oracle>;
  /** fetch data from the table: "governance_satellite_snapshot" */
  governance_satellite_snapshot: Array<Governance_Satellite_Snapshot>;
  /** fetch aggregated fields from the table: "governance_satellite_snapshot" */
  governance_satellite_snapshot_aggregate: Governance_Satellite_Snapshot_Aggregate;
  /** fetch data from the table: "governance_satellite_snapshot" using primary key columns */
  governance_satellite_snapshot_by_pk?: Maybe<Governance_Satellite_Snapshot>;
  /** fetch data from the table: "governance_satellite_whitelist_contract" */
  governance_satellite_whitelist_contract: Array<Governance_Satellite_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "governance_satellite_whitelist_contract" */
  governance_satellite_whitelist_contract_aggregate: Governance_Satellite_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "governance_satellite_whitelist_contract" using primary key columns */
  governance_satellite_whitelist_contract_by_pk?: Maybe<Governance_Satellite_Whitelist_Contract>;
  /** fetch data from the table: "governance_smvn_snapshot" */
  governance_smvn_snapshot: Array<Governance_Smvn_Snapshot>;
  /** fetch aggregated fields from the table: "governance_smvn_snapshot" */
  governance_smvn_snapshot_aggregate: Governance_Smvn_Snapshot_Aggregate;
  /** fetch data from the table: "governance_smvn_snapshot" using primary key columns */
  governance_smvn_snapshot_by_pk?: Maybe<Governance_Smvn_Snapshot>;
  /** fetch data from the table: "governance_whitelist_contract" */
  governance_whitelist_contract: Array<Governance_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "governance_whitelist_contract" */
  governance_whitelist_contract_aggregate: Governance_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "governance_whitelist_contract" using primary key columns */
  governance_whitelist_contract_by_pk?: Maybe<Governance_Whitelist_Contract>;
  /** fetch data from the table: "gql_history_data_summary" */
  gql_history_data_summary: Array<Gql_History_Data_Summary>;
  /** fetch aggregated fields from the table: "gql_history_data_summary" */
  gql_history_data_summary_aggregate: Gql_History_Data_Summary_Aggregate;
  /** fetch data from the table: "gql_loan_token_market_stats" */
  gql_loan_token_market_stats: Array<Gql_Loan_Token_Market_Stats>;
  /** fetch aggregated fields from the table: "gql_loan_token_market_stats" */
  gql_loan_token_market_stats_aggregate: Gql_Loan_Token_Market_Stats_Aggregate;
  /** fetch data from the table: "gql_vault_with_balances" */
  gql_vault_with_balances: Array<Gql_Vault_With_Balances>;
  /** fetch aggregated fields from the table: "gql_vault_with_balances" */
  gql_vault_with_balances_aggregate: Gql_Vault_With_Balances_Aggregate;
  /** fetch data from the table: "lending_controller" */
  lending_controller: Array<Lending_Controller>;
  /** fetch aggregated fields from the table: "lending_controller" */
  lending_controller_aggregate: Lending_Controller_Aggregate;
  /** fetch data from the table: "lending_controller" using primary key columns */
  lending_controller_by_pk?: Maybe<Lending_Controller>;
  /** fetch data from the table: "lending_controller_collateral_token" */
  lending_controller_collateral_token: Array<Lending_Controller_Collateral_Token>;
  /** fetch aggregated fields from the table: "lending_controller_collateral_token" */
  lending_controller_collateral_token_aggregate: Lending_Controller_Collateral_Token_Aggregate;
  /** fetch data from the table: "lending_controller_collateral_token" using primary key columns */
  lending_controller_collateral_token_by_pk?: Maybe<Lending_Controller_Collateral_Token>;
  /** fetch data from the table: "lending_controller_history_data" */
  lending_controller_history_data: Array<Lending_Controller_History_Data>;
  /** fetch aggregated fields from the table: "lending_controller_history_data" */
  lending_controller_history_data_aggregate: Lending_Controller_History_Data_Aggregate;
  /** fetch data from the table: "lending_controller_history_data" using primary key columns */
  lending_controller_history_data_by_pk?: Maybe<Lending_Controller_History_Data>;
  /** fetch data from the table: "lending_controller_lambda" */
  lending_controller_lambda: Array<Lending_Controller_Lambda>;
  /** fetch aggregated fields from the table: "lending_controller_lambda" */
  lending_controller_lambda_aggregate: Lending_Controller_Lambda_Aggregate;
  /** fetch data from the table: "lending_controller_lambda" using primary key columns */
  lending_controller_lambda_by_pk?: Maybe<Lending_Controller_Lambda>;
  /** fetch data from the table: "lending_controller_loan_token" */
  lending_controller_loan_token: Array<Lending_Controller_Loan_Token>;
  /** fetch aggregated fields from the table: "lending_controller_loan_token" */
  lending_controller_loan_token_aggregate: Lending_Controller_Loan_Token_Aggregate;
  /** fetch data from the table: "lending_controller_loan_token" using primary key columns */
  lending_controller_loan_token_by_pk?: Maybe<Lending_Controller_Loan_Token>;
  /** fetch data from the table: "lending_controller_vault" */
  lending_controller_vault: Array<Lending_Controller_Vault>;
  /** fetch aggregated fields from the table: "lending_controller_vault" */
  lending_controller_vault_aggregate: Lending_Controller_Vault_Aggregate;
  /** fetch data from the table: "lending_controller_vault" using primary key columns */
  lending_controller_vault_by_pk?: Maybe<Lending_Controller_Vault>;
  /** fetch data from the table: "lending_controller_vault_collateral_balance" */
  lending_controller_vault_collateral_balance: Array<Lending_Controller_Vault_Collateral_Balance>;
  /** fetch aggregated fields from the table: "lending_controller_vault_collateral_balance" */
  lending_controller_vault_collateral_balance_aggregate: Lending_Controller_Vault_Collateral_Balance_Aggregate;
  /** fetch data from the table: "lending_controller_vault_collateral_balance" using primary key columns */
  lending_controller_vault_collateral_balance_by_pk?: Maybe<Lending_Controller_Vault_Collateral_Balance>;
  /** fetch data from the table: "loan_token_view" */
  loan_token_view: Array<Loan_Token_View>;
  /** fetch aggregated fields from the table: "loan_token_view" */
  loan_token_view_aggregate: Loan_Token_View_Aggregate;
  /** fetch data from the table: "m_token" */
  m_token: Array<M_Token>;
  /** fetch data from the table: "m_token_account" */
  m_token_account: Array<M_Token_Account>;
  /** fetch aggregated fields from the table: "m_token_account" */
  m_token_account_aggregate: M_Token_Account_Aggregate;
  /** fetch data from the table: "m_token_account" using primary key columns */
  m_token_account_by_pk?: Maybe<M_Token_Account>;
  /** fetch data from the table: "m_token_account_history_data" */
  m_token_account_history_data: Array<M_Token_Account_History_Data>;
  /** fetch aggregated fields from the table: "m_token_account_history_data" */
  m_token_account_history_data_aggregate: M_Token_Account_History_Data_Aggregate;
  /** fetch data from the table: "m_token_account_history_data" using primary key columns */
  m_token_account_history_data_by_pk?: Maybe<M_Token_Account_History_Data>;
  /** fetch aggregated fields from the table: "m_token" */
  m_token_aggregate: M_Token_Aggregate;
  /** fetch data from the table: "m_token" using primary key columns */
  m_token_by_pk?: Maybe<M_Token>;
  /** fetch data from the table: "m_token_general_contract" */
  m_token_general_contract: Array<M_Token_General_Contract>;
  /** fetch aggregated fields from the table: "m_token_general_contract" */
  m_token_general_contract_aggregate: M_Token_General_Contract_Aggregate;
  /** fetch data from the table: "m_token_general_contract" using primary key columns */
  m_token_general_contract_by_pk?: Maybe<M_Token_General_Contract>;
  /** fetch data from the table: "m_token_lambda" */
  m_token_lambda: Array<M_Token_Lambda>;
  /** fetch aggregated fields from the table: "m_token_lambda" */
  m_token_lambda_aggregate: M_Token_Lambda_Aggregate;
  /** fetch data from the table: "m_token_lambda" using primary key columns */
  m_token_lambda_by_pk?: Maybe<M_Token_Lambda>;
  /** fetch data from the table: "m_token_operator" */
  m_token_operator: Array<M_Token_Operator>;
  /** fetch aggregated fields from the table: "m_token_operator" */
  m_token_operator_aggregate: M_Token_Operator_Aggregate;
  /** fetch data from the table: "m_token_operator" using primary key columns */
  m_token_operator_by_pk?: Maybe<M_Token_Operator>;
  /** fetch data from the table: "m_token_whitelist_contract" */
  m_token_whitelist_contract: Array<M_Token_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "m_token_whitelist_contract" */
  m_token_whitelist_contract_aggregate: M_Token_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "m_token_whitelist_contract" using primary key columns */
  m_token_whitelist_contract_by_pk?: Maybe<M_Token_Whitelist_Contract>;
  /** fetch data from the table: "maven_user" */
  maven_user: Array<Maven_User>;
  /** fetch aggregated fields from the table: "maven_user" */
  maven_user_aggregate: Maven_User_Aggregate;
  /** fetch data from the table: "maven_user" using primary key columns */
  maven_user_by_pk?: Maybe<Maven_User>;
  /** fetch data from the table: "mvn_mint_or_burn_history_data" */
  mvn_mint_or_burn_history_data: Array<Mvn_Mint_Or_Burn_History_Data>;
  /** fetch aggregated fields from the table: "mvn_mint_or_burn_history_data" */
  mvn_mint_or_burn_history_data_aggregate: Mvn_Mint_Or_Burn_History_Data_Aggregate;
  /** fetch data from the table: "mvn_mint_or_burn_history_data" using primary key columns */
  mvn_mint_or_burn_history_data_by_pk?: Maybe<Mvn_Mint_Or_Burn_History_Data>;
  /** fetch data from the table: "mvn_token" */
  mvn_token: Array<Mvn_Token>;
  /** fetch aggregated fields from the table: "mvn_token" */
  mvn_token_aggregate: Mvn_Token_Aggregate;
  /** fetch data from the table: "mvn_token" using primary key columns */
  mvn_token_by_pk?: Maybe<Mvn_Token>;
  /** fetch data from the table: "mvn_token_general_contract" */
  mvn_token_general_contract: Array<Mvn_Token_General_Contract>;
  /** fetch aggregated fields from the table: "mvn_token_general_contract" */
  mvn_token_general_contract_aggregate: Mvn_Token_General_Contract_Aggregate;
  /** fetch data from the table: "mvn_token_general_contract" using primary key columns */
  mvn_token_general_contract_by_pk?: Maybe<Mvn_Token_General_Contract>;
  /** fetch data from the table: "mvn_token_operator" */
  mvn_token_operator: Array<Mvn_Token_Operator>;
  /** fetch aggregated fields from the table: "mvn_token_operator" */
  mvn_token_operator_aggregate: Mvn_Token_Operator_Aggregate;
  /** fetch data from the table: "mvn_token_operator" using primary key columns */
  mvn_token_operator_by_pk?: Maybe<Mvn_Token_Operator>;
  /** fetch data from the table: "mvn_token_whitelist_contract" */
  mvn_token_whitelist_contract: Array<Mvn_Token_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "mvn_token_whitelist_contract" */
  mvn_token_whitelist_contract_aggregate: Mvn_Token_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "mvn_token_whitelist_contract" using primary key columns */
  mvn_token_whitelist_contract_by_pk?: Maybe<Mvn_Token_Whitelist_Contract>;
  /** fetch data from the table: "mvn_transfer_history_data" */
  mvn_transfer_history_data: Array<Mvn_Transfer_History_Data>;
  /** fetch aggregated fields from the table: "mvn_transfer_history_data" */
  mvn_transfer_history_data_aggregate: Mvn_Transfer_History_Data_Aggregate;
  /** fetch data from the table: "mvn_transfer_history_data" using primary key columns */
  mvn_transfer_history_data_by_pk?: Maybe<Mvn_Transfer_History_Data>;
  /** fetch data from the table: "satellite" */
  satellite: Array<Satellite>;
  /** fetch aggregated fields from the table: "satellite" */
  satellite_aggregate: Satellite_Aggregate;
  /** fetch data from the table: "satellite" using primary key columns */
  satellite_by_pk?: Maybe<Satellite>;
  /** fetch data from the table: "satellite_rewards" */
  satellite_rewards: Array<Satellite_Rewards>;
  /** fetch aggregated fields from the table: "satellite_rewards" */
  satellite_rewards_aggregate: Satellite_Rewards_Aggregate;
  /** fetch data from the table: "satellite_rewards" using primary key columns */
  satellite_rewards_by_pk?: Maybe<Satellite_Rewards>;
  /** fetch data from the table: "smvn_history_data" */
  smvn_history_data: Array<Smvn_History_Data>;
  /** fetch aggregated fields from the table: "smvn_history_data" */
  smvn_history_data_aggregate: Smvn_History_Data_Aggregate;
  /** fetch data from the table: "smvn_history_data" using primary key columns */
  smvn_history_data_by_pk?: Maybe<Smvn_History_Data>;
  /** fetch data from the table: "stake_history_data" */
  stake_history_data: Array<Stake_History_Data>;
  /** fetch aggregated fields from the table: "stake_history_data" */
  stake_history_data_aggregate: Stake_History_Data_Aggregate;
  /** fetch data from the table: "stake_history_data" using primary key columns */
  stake_history_data_by_pk?: Maybe<Stake_History_Data>;
  /** fetch data from the table: "token" */
  token: Array<Token>;
  /** fetch aggregated fields from the table: "token" */
  token_aggregate: Token_Aggregate;
  /** fetch data from the table: "token" using primary key columns */
  token_by_pk?: Maybe<Token>;
  /** fetch data from the table: "treasury" */
  treasury: Array<Treasury>;
  /** fetch aggregated fields from the table: "treasury" */
  treasury_aggregate: Treasury_Aggregate;
  /** fetch data from the table: "treasury_balance" */
  treasury_balance: Array<Treasury_Balance>;
  /** fetch aggregated fields from the table: "treasury_balance" */
  treasury_balance_aggregate: Treasury_Balance_Aggregate;
  /** fetch data from the table: "treasury_balance" using primary key columns */
  treasury_balance_by_pk?: Maybe<Treasury_Balance>;
  /** fetch data from the table: "treasury" using primary key columns */
  treasury_by_pk?: Maybe<Treasury>;
  /** fetch data from the table: "treasury_factory" */
  treasury_factory: Array<Treasury_Factory>;
  /** fetch aggregated fields from the table: "treasury_factory" */
  treasury_factory_aggregate: Treasury_Factory_Aggregate;
  /** fetch data from the table: "treasury_factory" using primary key columns */
  treasury_factory_by_pk?: Maybe<Treasury_Factory>;
  /** fetch data from the table: "treasury_factory_general_contract" */
  treasury_factory_general_contract: Array<Treasury_Factory_General_Contract>;
  /** fetch aggregated fields from the table: "treasury_factory_general_contract" */
  treasury_factory_general_contract_aggregate: Treasury_Factory_General_Contract_Aggregate;
  /** fetch data from the table: "treasury_factory_general_contract" using primary key columns */
  treasury_factory_general_contract_by_pk?: Maybe<Treasury_Factory_General_Contract>;
  /** fetch data from the table: "treasury_factory_lambda" */
  treasury_factory_lambda: Array<Treasury_Factory_Lambda>;
  /** fetch aggregated fields from the table: "treasury_factory_lambda" */
  treasury_factory_lambda_aggregate: Treasury_Factory_Lambda_Aggregate;
  /** fetch data from the table: "treasury_factory_lambda" using primary key columns */
  treasury_factory_lambda_by_pk?: Maybe<Treasury_Factory_Lambda>;
  /** fetch data from the table: "treasury_factory_treasury_lambda" */
  treasury_factory_treasury_lambda: Array<Treasury_Factory_Treasury_Lambda>;
  /** fetch aggregated fields from the table: "treasury_factory_treasury_lambda" */
  treasury_factory_treasury_lambda_aggregate: Treasury_Factory_Treasury_Lambda_Aggregate;
  /** fetch data from the table: "treasury_factory_treasury_lambda" using primary key columns */
  treasury_factory_treasury_lambda_by_pk?: Maybe<Treasury_Factory_Treasury_Lambda>;
  /** fetch data from the table: "treasury_factory_whitelist_contract" */
  treasury_factory_whitelist_contract: Array<Treasury_Factory_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "treasury_factory_whitelist_contract" */
  treasury_factory_whitelist_contract_aggregate: Treasury_Factory_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "treasury_factory_whitelist_contract" using primary key columns */
  treasury_factory_whitelist_contract_by_pk?: Maybe<Treasury_Factory_Whitelist_Contract>;
  /** fetch data from the table: "treasury_factory_whitelist_token_contract" */
  treasury_factory_whitelist_token_contract: Array<Treasury_Factory_Whitelist_Token_Contract>;
  /** fetch aggregated fields from the table: "treasury_factory_whitelist_token_contract" */
  treasury_factory_whitelist_token_contract_aggregate: Treasury_Factory_Whitelist_Token_Contract_Aggregate;
  /** fetch data from the table: "treasury_factory_whitelist_token_contract" using primary key columns */
  treasury_factory_whitelist_token_contract_by_pk?: Maybe<Treasury_Factory_Whitelist_Token_Contract>;
  /** fetch data from the table: "treasury_general_contract" */
  treasury_general_contract: Array<Treasury_General_Contract>;
  /** fetch aggregated fields from the table: "treasury_general_contract" */
  treasury_general_contract_aggregate: Treasury_General_Contract_Aggregate;
  /** fetch data from the table: "treasury_general_contract" using primary key columns */
  treasury_general_contract_by_pk?: Maybe<Treasury_General_Contract>;
  /** fetch data from the table: "treasury_lambda" */
  treasury_lambda: Array<Treasury_Lambda>;
  /** fetch aggregated fields from the table: "treasury_lambda" */
  treasury_lambda_aggregate: Treasury_Lambda_Aggregate;
  /** fetch data from the table: "treasury_lambda" using primary key columns */
  treasury_lambda_by_pk?: Maybe<Treasury_Lambda>;
  /** fetch data from the table: "treasury_transfer_history_data" */
  treasury_transfer_history_data: Array<Treasury_Transfer_History_Data>;
  /** fetch aggregated fields from the table: "treasury_transfer_history_data" */
  treasury_transfer_history_data_aggregate: Treasury_Transfer_History_Data_Aggregate;
  /** fetch data from the table: "treasury_transfer_history_data" using primary key columns */
  treasury_transfer_history_data_by_pk?: Maybe<Treasury_Transfer_History_Data>;
  /** fetch data from the table: "treasury_whitelist_contract" */
  treasury_whitelist_contract: Array<Treasury_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "treasury_whitelist_contract" */
  treasury_whitelist_contract_aggregate: Treasury_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "treasury_whitelist_contract" using primary key columns */
  treasury_whitelist_contract_by_pk?: Maybe<Treasury_Whitelist_Contract>;
  /** fetch data from the table: "treasury_whitelist_token_contract" */
  treasury_whitelist_token_contract: Array<Treasury_Whitelist_Token_Contract>;
  /** fetch aggregated fields from the table: "treasury_whitelist_token_contract" */
  treasury_whitelist_token_contract_aggregate: Treasury_Whitelist_Token_Contract_Aggregate;
  /** fetch data from the table: "treasury_whitelist_token_contract" using primary key columns */
  treasury_whitelist_token_contract_by_pk?: Maybe<Treasury_Whitelist_Token_Contract>;
  /** fetch data from the table: "tvl_stats" */
  tvl_stats: Array<Tvl_Stats>;
  /** fetch aggregated fields from the table: "tvl_stats" */
  tvl_stats_aggregate: Tvl_Stats_Aggregate;
  /** fetch data from the table: "user_dashboard" */
  user_dashboard: Array<User_Dashboard>;
  /** fetch aggregated fields from the table: "user_dashboard" */
  user_dashboard_aggregate: User_Dashboard_Aggregate;
  /** fetch data from the table: "vault" */
  vault: Array<Vault>;
  /** fetch aggregated fields from the table: "vault" */
  vault_aggregate: Vault_Aggregate;
  /** fetch data from the table: "vault" using primary key columns */
  vault_by_pk?: Maybe<Vault>;
  /** fetch data from the table: "vault_collateral_view" */
  vault_collateral_view: Array<Vault_Collateral_View>;
  /** fetch aggregated fields from the table: "vault_collateral_view" */
  vault_collateral_view_aggregate: Vault_Collateral_View_Aggregate;
  /** fetch data from the table: "vault_depositor" */
  vault_depositor: Array<Vault_Depositor>;
  /** fetch aggregated fields from the table: "vault_depositor" */
  vault_depositor_aggregate: Vault_Depositor_Aggregate;
  /** fetch data from the table: "vault_depositor" using primary key columns */
  vault_depositor_by_pk?: Maybe<Vault_Depositor>;
  /** fetch data from the table: "vault_factory" */
  vault_factory: Array<Vault_Factory>;
  /** fetch aggregated fields from the table: "vault_factory" */
  vault_factory_aggregate: Vault_Factory_Aggregate;
  /** fetch data from the table: "vault_factory" using primary key columns */
  vault_factory_by_pk?: Maybe<Vault_Factory>;
  /** fetch data from the table: "vault_factory_general_contract" */
  vault_factory_general_contract: Array<Vault_Factory_General_Contract>;
  /** fetch aggregated fields from the table: "vault_factory_general_contract" */
  vault_factory_general_contract_aggregate: Vault_Factory_General_Contract_Aggregate;
  /** fetch data from the table: "vault_factory_general_contract" using primary key columns */
  vault_factory_general_contract_by_pk?: Maybe<Vault_Factory_General_Contract>;
  /** fetch data from the table: "vault_factory_lambda" */
  vault_factory_lambda: Array<Vault_Factory_Lambda>;
  /** fetch aggregated fields from the table: "vault_factory_lambda" */
  vault_factory_lambda_aggregate: Vault_Factory_Lambda_Aggregate;
  /** fetch data from the table: "vault_factory_lambda" using primary key columns */
  vault_factory_lambda_by_pk?: Maybe<Vault_Factory_Lambda>;
  /** fetch data from the table: "vault_factory_vault_lambda" */
  vault_factory_vault_lambda: Array<Vault_Factory_Vault_Lambda>;
  /** fetch aggregated fields from the table: "vault_factory_vault_lambda" */
  vault_factory_vault_lambda_aggregate: Vault_Factory_Vault_Lambda_Aggregate;
  /** fetch data from the table: "vault_factory_vault_lambda" using primary key columns */
  vault_factory_vault_lambda_by_pk?: Maybe<Vault_Factory_Vault_Lambda>;
  /** fetch data from the table: "vault_factory_whitelist_contract" */
  vault_factory_whitelist_contract: Array<Vault_Factory_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "vault_factory_whitelist_contract" */
  vault_factory_whitelist_contract_aggregate: Vault_Factory_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "vault_factory_whitelist_contract" using primary key columns */
  vault_factory_whitelist_contract_by_pk?: Maybe<Vault_Factory_Whitelist_Contract>;
  /** fetch data from the table: "vault_lambda" */
  vault_lambda: Array<Vault_Lambda>;
  /** fetch aggregated fields from the table: "vault_lambda" */
  vault_lambda_aggregate: Vault_Lambda_Aggregate;
  /** fetch data from the table: "vault_lambda" using primary key columns */
  vault_lambda_by_pk?: Maybe<Vault_Lambda>;
  /** fetch data from the table: "vesting" */
  vesting: Array<Vesting>;
  /** fetch aggregated fields from the table: "vesting" */
  vesting_aggregate: Vesting_Aggregate;
  /** fetch data from the table: "vesting" using primary key columns */
  vesting_by_pk?: Maybe<Vesting>;
  /** fetch data from the table: "vesting_general_contract" */
  vesting_general_contract: Array<Vesting_General_Contract>;
  /** fetch aggregated fields from the table: "vesting_general_contract" */
  vesting_general_contract_aggregate: Vesting_General_Contract_Aggregate;
  /** fetch data from the table: "vesting_general_contract" using primary key columns */
  vesting_general_contract_by_pk?: Maybe<Vesting_General_Contract>;
  /** fetch data from the table: "vesting_lambda" */
  vesting_lambda: Array<Vesting_Lambda>;
  /** fetch aggregated fields from the table: "vesting_lambda" */
  vesting_lambda_aggregate: Vesting_Lambda_Aggregate;
  /** fetch data from the table: "vesting_lambda" using primary key columns */
  vesting_lambda_by_pk?: Maybe<Vesting_Lambda>;
  /** fetch data from the table: "vesting_vestee" */
  vesting_vestee: Array<Vesting_Vestee>;
  /** fetch aggregated fields from the table: "vesting_vestee" */
  vesting_vestee_aggregate: Vesting_Vestee_Aggregate;
  /** fetch data from the table: "vesting_vestee" using primary key columns */
  vesting_vestee_by_pk?: Maybe<Vesting_Vestee>;
  /** fetch data from the table: "vesting_whitelist_contract" */
  vesting_whitelist_contract: Array<Vesting_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "vesting_whitelist_contract" */
  vesting_whitelist_contract_aggregate: Vesting_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "vesting_whitelist_contract" using primary key columns */
  vesting_whitelist_contract_by_pk?: Maybe<Vesting_Whitelist_Contract>;
  /** fetch data from the table: "whitelist_developer" */
  whitelist_developer: Array<Whitelist_Developer>;
  /** fetch aggregated fields from the table: "whitelist_developer" */
  whitelist_developer_aggregate: Whitelist_Developer_Aggregate;
  /** fetch data from the table: "whitelist_developer" using primary key columns */
  whitelist_developer_by_pk?: Maybe<Whitelist_Developer>;
};


export type Query_RootAggregatorArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Order_By>>;
  where?: InputMaybe<Aggregator_Bool_Exp>;
};


export type Query_RootAggregator_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Order_By>>;
  where?: InputMaybe<Aggregator_Bool_Exp>;
};


export type Query_RootAggregator_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootAggregator_FactoryArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_Bool_Exp>;
};


export type Query_RootAggregator_Factory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_Bool_Exp>;
};


export type Query_RootAggregator_Factory_Aggregator_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_Aggregator_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_Aggregator_Lambda_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_Aggregator_Lambda_Bool_Exp>;
};


export type Query_RootAggregator_Factory_Aggregator_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_Aggregator_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_Aggregator_Lambda_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_Aggregator_Lambda_Bool_Exp>;
};


export type Query_RootAggregator_Factory_Aggregator_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootAggregator_Factory_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootAggregator_Factory_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_General_Contract_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_General_Contract_Bool_Exp>;
};


export type Query_RootAggregator_Factory_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_General_Contract_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_General_Contract_Bool_Exp>;
};


export type Query_RootAggregator_Factory_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootAggregator_Factory_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_Lambda_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_Lambda_Bool_Exp>;
};


export type Query_RootAggregator_Factory_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_Lambda_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_Lambda_Bool_Exp>;
};


export type Query_RootAggregator_Factory_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootAggregator_Factory_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootAggregator_Factory_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootAggregator_Factory_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootAggregator_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_General_Contract_Order_By>>;
  where?: InputMaybe<Aggregator_General_Contract_Bool_Exp>;
};


export type Query_RootAggregator_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_General_Contract_Order_By>>;
  where?: InputMaybe<Aggregator_General_Contract_Bool_Exp>;
};


export type Query_RootAggregator_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootAggregator_History_DataArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_History_Data_Order_By>>;
  where?: InputMaybe<Aggregator_History_Data_Bool_Exp>;
};


export type Query_RootAggregator_History_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_History_Data_Order_By>>;
  where?: InputMaybe<Aggregator_History_Data_Bool_Exp>;
};


export type Query_RootAggregator_History_Data_By_PkArgs = {
  id: Scalars['bigint']['input'];
  timestamp: Scalars['timestamptz']['input'];
};


export type Query_RootAggregator_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Lambda_Order_By>>;
  where?: InputMaybe<Aggregator_Lambda_Bool_Exp>;
};


export type Query_RootAggregator_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Lambda_Order_By>>;
  where?: InputMaybe<Aggregator_Lambda_Bool_Exp>;
};


export type Query_RootAggregator_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootAggregator_OracleArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Oracle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Oracle_Order_By>>;
  where?: InputMaybe<Aggregator_Oracle_Bool_Exp>;
};


export type Query_RootAggregator_Oracle_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Oracle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Oracle_Order_By>>;
  where?: InputMaybe<Aggregator_Oracle_Bool_Exp>;
};


export type Query_RootAggregator_Oracle_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootAggregator_Oracle_ObservationArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Oracle_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Oracle_Observation_Order_By>>;
  where?: InputMaybe<Aggregator_Oracle_Observation_Bool_Exp>;
};


export type Query_RootAggregator_Oracle_Observation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Oracle_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Oracle_Observation_Order_By>>;
  where?: InputMaybe<Aggregator_Oracle_Observation_Bool_Exp>;
};


export type Query_RootAggregator_Oracle_Observation_By_PkArgs = {
  id: Scalars['bigint']['input'];
  timestamp: Scalars['timestamptz']['input'];
};


export type Query_RootAggregator_Oracle_RewardArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Oracle_Reward_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Oracle_Reward_Order_By>>;
  where?: InputMaybe<Aggregator_Oracle_Reward_Bool_Exp>;
};


export type Query_RootAggregator_Oracle_Reward_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Oracle_Reward_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Oracle_Reward_Order_By>>;
  where?: InputMaybe<Aggregator_Oracle_Reward_Bool_Exp>;
};


export type Query_RootAggregator_Oracle_Reward_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootAggregator_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Aggregator_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootAggregator_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Aggregator_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootAggregator_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootBreak_GlassArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Order_By>>;
  where?: InputMaybe<Break_Glass_Bool_Exp>;
};


export type Query_RootBreak_Glass_ActionArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Bool_Exp>;
};


export type Query_RootBreak_Glass_Action_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Bool_Exp>;
};


export type Query_RootBreak_Glass_Action_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootBreak_Glass_Action_ParameterArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Parameter_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Parameter_Bool_Exp>;
};


export type Query_RootBreak_Glass_Action_Parameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Parameter_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Parameter_Bool_Exp>;
};


export type Query_RootBreak_Glass_Action_Parameter_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootBreak_Glass_Action_SignerArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Signer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Signer_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Signer_Bool_Exp>;
};


export type Query_RootBreak_Glass_Action_Signer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Signer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Signer_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Signer_Bool_Exp>;
};


export type Query_RootBreak_Glass_Action_Signer_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootBreak_Glass_Action_Temp_ParameterArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Temp_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Temp_Parameter_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Temp_Parameter_Bool_Exp>;
};


export type Query_RootBreak_Glass_Action_Temp_Parameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Temp_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Temp_Parameter_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Temp_Parameter_Bool_Exp>;
};


export type Query_RootBreak_Glass_Action_Temp_Parameter_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootBreak_Glass_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Order_By>>;
  where?: InputMaybe<Break_Glass_Bool_Exp>;
};


export type Query_RootBreak_Glass_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootBreak_Glass_Council_MemberArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Council_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Council_Member_Order_By>>;
  where?: InputMaybe<Break_Glass_Council_Member_Bool_Exp>;
};


export type Query_RootBreak_Glass_Council_Member_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Council_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Council_Member_Order_By>>;
  where?: InputMaybe<Break_Glass_Council_Member_Bool_Exp>;
};


export type Query_RootBreak_Glass_Council_Member_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootBreak_Glass_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_General_Contract_Order_By>>;
  where?: InputMaybe<Break_Glass_General_Contract_Bool_Exp>;
};


export type Query_RootBreak_Glass_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_General_Contract_Order_By>>;
  where?: InputMaybe<Break_Glass_General_Contract_Bool_Exp>;
};


export type Query_RootBreak_Glass_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootBreak_Glass_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Lambda_Order_By>>;
  where?: InputMaybe<Break_Glass_Lambda_Bool_Exp>;
};


export type Query_RootBreak_Glass_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Lambda_Order_By>>;
  where?: InputMaybe<Break_Glass_Lambda_Bool_Exp>;
};


export type Query_RootBreak_Glass_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootBreak_Glass_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Break_Glass_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootBreak_Glass_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Break_Glass_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootBreak_Glass_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootCouncilArgs = {
  distinct_on?: InputMaybe<Array<Council_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Order_By>>;
  where?: InputMaybe<Council_Bool_Exp>;
};


export type Query_RootCouncil_ActionArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Order_By>>;
  where?: InputMaybe<Council_Action_Bool_Exp>;
};


export type Query_RootCouncil_Action_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Order_By>>;
  where?: InputMaybe<Council_Action_Bool_Exp>;
};


export type Query_RootCouncil_Action_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootCouncil_Action_ParameterArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Parameter_Order_By>>;
  where?: InputMaybe<Council_Action_Parameter_Bool_Exp>;
};


export type Query_RootCouncil_Action_Parameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Parameter_Order_By>>;
  where?: InputMaybe<Council_Action_Parameter_Bool_Exp>;
};


export type Query_RootCouncil_Action_Parameter_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootCouncil_Action_SignerArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Signer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Signer_Order_By>>;
  where?: InputMaybe<Council_Action_Signer_Bool_Exp>;
};


export type Query_RootCouncil_Action_Signer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Signer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Signer_Order_By>>;
  where?: InputMaybe<Council_Action_Signer_Bool_Exp>;
};


export type Query_RootCouncil_Action_Signer_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootCouncil_Action_Temp_ParameterArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Temp_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Temp_Parameter_Order_By>>;
  where?: InputMaybe<Council_Action_Temp_Parameter_Bool_Exp>;
};


export type Query_RootCouncil_Action_Temp_Parameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Temp_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Temp_Parameter_Order_By>>;
  where?: InputMaybe<Council_Action_Temp_Parameter_Bool_Exp>;
};


export type Query_RootCouncil_Action_Temp_Parameter_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootCouncil_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Order_By>>;
  where?: InputMaybe<Council_Bool_Exp>;
};


export type Query_RootCouncil_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootCouncil_Council_MemberArgs = {
  distinct_on?: InputMaybe<Array<Council_Council_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Council_Member_Order_By>>;
  where?: InputMaybe<Council_Council_Member_Bool_Exp>;
};


export type Query_RootCouncil_Council_Member_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Council_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Council_Member_Order_By>>;
  where?: InputMaybe<Council_Council_Member_Bool_Exp>;
};


export type Query_RootCouncil_Council_Member_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootCouncil_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Council_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_General_Contract_Order_By>>;
  where?: InputMaybe<Council_General_Contract_Bool_Exp>;
};


export type Query_RootCouncil_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_General_Contract_Order_By>>;
  where?: InputMaybe<Council_General_Contract_Bool_Exp>;
};


export type Query_RootCouncil_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootCouncil_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Council_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Lambda_Order_By>>;
  where?: InputMaybe<Council_Lambda_Bool_Exp>;
};


export type Query_RootCouncil_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Lambda_Order_By>>;
  where?: InputMaybe<Council_Lambda_Bool_Exp>;
};


export type Query_RootCouncil_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootCouncil_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Council_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Council_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootCouncil_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Council_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootCouncil_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootDelegationArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Order_By>>;
  where?: InputMaybe<Delegation_Bool_Exp>;
};


export type Query_RootDelegation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Order_By>>;
  where?: InputMaybe<Delegation_Bool_Exp>;
};


export type Query_RootDelegation_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootDelegation_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Delegation_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_General_Contract_Order_By>>;
  where?: InputMaybe<Delegation_General_Contract_Bool_Exp>;
};


export type Query_RootDelegation_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delegation_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_General_Contract_Order_By>>;
  where?: InputMaybe<Delegation_General_Contract_Bool_Exp>;
};


export type Query_RootDelegation_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootDelegation_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Lambda_Order_By>>;
  where?: InputMaybe<Delegation_Lambda_Bool_Exp>;
};


export type Query_RootDelegation_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Lambda_Order_By>>;
  where?: InputMaybe<Delegation_Lambda_Bool_Exp>;
};


export type Query_RootDelegation_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootDelegation_RecordArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Record_Order_By>>;
  where?: InputMaybe<Delegation_Record_Bool_Exp>;
};


export type Query_RootDelegation_Record_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Record_Order_By>>;
  where?: InputMaybe<Delegation_Record_Bool_Exp>;
};


export type Query_RootDelegation_Record_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootDelegation_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Delegation_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootDelegation_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Delegation_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootDelegation_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootDipdup_ContractArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Contract_Order_By>>;
  where?: InputMaybe<Dipdup_Contract_Bool_Exp>;
};


export type Query_RootDipdup_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Contract_Order_By>>;
  where?: InputMaybe<Dipdup_Contract_Bool_Exp>;
};


export type Query_RootDipdup_Contract_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootDipdup_Contract_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Contract_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Contract_Metadata_Order_By>>;
  where?: InputMaybe<Dipdup_Contract_Metadata_Bool_Exp>;
};


export type Query_RootDipdup_Contract_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Contract_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Contract_Metadata_Order_By>>;
  where?: InputMaybe<Dipdup_Contract_Metadata_Bool_Exp>;
};


export type Query_RootDipdup_Contract_Metadata_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootDipdup_ExceptionArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Exception_Order_By>>;
  where?: InputMaybe<Dipdup_Exception_Bool_Exp>;
};


export type Query_RootDipdup_Exception_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Exception_Order_By>>;
  where?: InputMaybe<Dipdup_Exception_Bool_Exp>;
};


export type Query_RootDipdup_Exception_By_PkArgs = {
  id: Scalars['bigint']['input'];
  timestamp: Scalars['timestamptz']['input'];
};


export type Query_RootDipdup_HeadArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Head_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Head_Order_By>>;
  where?: InputMaybe<Dipdup_Head_Bool_Exp>;
};


export type Query_RootDipdup_Head_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Head_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Head_Order_By>>;
  where?: InputMaybe<Dipdup_Head_Bool_Exp>;
};


export type Query_RootDipdup_Head_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootDipdup_IndexArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Index_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Index_Order_By>>;
  where?: InputMaybe<Dipdup_Index_Bool_Exp>;
};


export type Query_RootDipdup_Index_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Index_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Index_Order_By>>;
  where?: InputMaybe<Dipdup_Index_Bool_Exp>;
};


export type Query_RootDipdup_Index_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootDipdup_MetaArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Meta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Meta_Order_By>>;
  where?: InputMaybe<Dipdup_Meta_Bool_Exp>;
};


export type Query_RootDipdup_Meta_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Meta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Meta_Order_By>>;
  where?: InputMaybe<Dipdup_Meta_Bool_Exp>;
};


export type Query_RootDipdup_Meta_By_PkArgs = {
  key: Scalars['String']['input'];
};


export type Query_RootDipdup_Model_UpdateArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Model_Update_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Model_Update_Order_By>>;
  where?: InputMaybe<Dipdup_Model_Update_Bool_Exp>;
};


export type Query_RootDipdup_Model_Update_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Model_Update_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Model_Update_Order_By>>;
  where?: InputMaybe<Dipdup_Model_Update_Bool_Exp>;
};


export type Query_RootDipdup_Model_Update_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootDipdup_SchemaArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Schema_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Schema_Order_By>>;
  where?: InputMaybe<Dipdup_Schema_Bool_Exp>;
};


export type Query_RootDipdup_Schema_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Schema_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Schema_Order_By>>;
  where?: InputMaybe<Dipdup_Schema_Bool_Exp>;
};


export type Query_RootDipdup_Schema_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootDipdup_StatusArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Status_Order_By>>;
  where?: InputMaybe<Dipdup_Status_Bool_Exp>;
};


export type Query_RootDipdup_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Status_Order_By>>;
  where?: InputMaybe<Dipdup_Status_Bool_Exp>;
};


export type Query_RootDipdup_Token_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Token_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Token_Metadata_Order_By>>;
  where?: InputMaybe<Dipdup_Token_Metadata_Bool_Exp>;
};


export type Query_RootDipdup_Token_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Token_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Token_Metadata_Order_By>>;
  where?: InputMaybe<Dipdup_Token_Metadata_Bool_Exp>;
};


export type Query_RootDipdup_Token_Metadata_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootDoormanArgs = {
  distinct_on?: InputMaybe<Array<Doorman_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_Order_By>>;
  where?: InputMaybe<Doorman_Bool_Exp>;
};


export type Query_RootDoorman_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Doorman_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_Order_By>>;
  where?: InputMaybe<Doorman_Bool_Exp>;
};


export type Query_RootDoorman_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootDoorman_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Doorman_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_General_Contract_Order_By>>;
  where?: InputMaybe<Doorman_General_Contract_Bool_Exp>;
};


export type Query_RootDoorman_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Doorman_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_General_Contract_Order_By>>;
  where?: InputMaybe<Doorman_General_Contract_Bool_Exp>;
};


export type Query_RootDoorman_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootDoorman_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Doorman_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_Lambda_Order_By>>;
  where?: InputMaybe<Doorman_Lambda_Bool_Exp>;
};


export type Query_RootDoorman_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Doorman_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_Lambda_Order_By>>;
  where?: InputMaybe<Doorman_Lambda_Bool_Exp>;
};


export type Query_RootDoorman_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootDoorman_Stake_AccountArgs = {
  distinct_on?: InputMaybe<Array<Doorman_Stake_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_Stake_Account_Order_By>>;
  where?: InputMaybe<Doorman_Stake_Account_Bool_Exp>;
};


export type Query_RootDoorman_Stake_Account_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Doorman_Stake_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_Stake_Account_Order_By>>;
  where?: InputMaybe<Doorman_Stake_Account_Bool_Exp>;
};


export type Query_RootDoorman_Stake_Account_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootDoorman_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Doorman_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Doorman_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootDoorman_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Doorman_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Doorman_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootDoorman_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootEmergency_GovernanceArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Bool_Exp>;
};


export type Query_RootEmergency_Governance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Bool_Exp>;
};


export type Query_RootEmergency_Governance_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootEmergency_Governance_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_General_Contract_Order_By>>;
  where?: InputMaybe<Emergency_Governance_General_Contract_Bool_Exp>;
};


export type Query_RootEmergency_Governance_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_General_Contract_Order_By>>;
  where?: InputMaybe<Emergency_Governance_General_Contract_Bool_Exp>;
};


export type Query_RootEmergency_Governance_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootEmergency_Governance_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Lambda_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Lambda_Bool_Exp>;
};


export type Query_RootEmergency_Governance_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Lambda_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Lambda_Bool_Exp>;
};


export type Query_RootEmergency_Governance_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootEmergency_Governance_RecordArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Record_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Record_Bool_Exp>;
};


export type Query_RootEmergency_Governance_Record_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Record_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Record_Bool_Exp>;
};


export type Query_RootEmergency_Governance_Record_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootEmergency_Governance_VoteArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Vote_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Vote_Bool_Exp>;
};


export type Query_RootEmergency_Governance_Vote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Vote_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Vote_Bool_Exp>;
};


export type Query_RootEmergency_Governance_Vote_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootEmergency_Governance_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootEmergency_Governance_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootEmergency_Governance_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootFarmArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


export type Query_RootFarm_AccountArgs = {
  distinct_on?: InputMaybe<Array<Farm_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Account_Order_By>>;
  where?: InputMaybe<Farm_Account_Bool_Exp>;
};


export type Query_RootFarm_Account_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Account_Order_By>>;
  where?: InputMaybe<Farm_Account_Bool_Exp>;
};


export type Query_RootFarm_Account_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootFarm_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


export type Query_RootFarm_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootFarm_FactoryArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_Order_By>>;
  where?: InputMaybe<Farm_Factory_Bool_Exp>;
};


export type Query_RootFarm_Factory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_Order_By>>;
  where?: InputMaybe<Farm_Factory_Bool_Exp>;
};


export type Query_RootFarm_Factory_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootFarm_Factory_Farm_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_Farm_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_Farm_Lambda_Order_By>>;
  where?: InputMaybe<Farm_Factory_Farm_Lambda_Bool_Exp>;
};


export type Query_RootFarm_Factory_Farm_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_Farm_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_Farm_Lambda_Order_By>>;
  where?: InputMaybe<Farm_Factory_Farm_Lambda_Bool_Exp>;
};


export type Query_RootFarm_Factory_Farm_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootFarm_Factory_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_General_Contract_Order_By>>;
  where?: InputMaybe<Farm_Factory_General_Contract_Bool_Exp>;
};


export type Query_RootFarm_Factory_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_General_Contract_Order_By>>;
  where?: InputMaybe<Farm_Factory_General_Contract_Bool_Exp>;
};


export type Query_RootFarm_Factory_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootFarm_Factory_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_Lambda_Order_By>>;
  where?: InputMaybe<Farm_Factory_Lambda_Bool_Exp>;
};


export type Query_RootFarm_Factory_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_Lambda_Order_By>>;
  where?: InputMaybe<Farm_Factory_Lambda_Bool_Exp>;
};


export type Query_RootFarm_Factory_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootFarm_Factory_M_Farm_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_M_Farm_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_M_Farm_Lambda_Order_By>>;
  where?: InputMaybe<Farm_Factory_M_Farm_Lambda_Bool_Exp>;
};


export type Query_RootFarm_Factory_M_Farm_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_M_Farm_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_M_Farm_Lambda_Order_By>>;
  where?: InputMaybe<Farm_Factory_M_Farm_Lambda_Bool_Exp>;
};


export type Query_RootFarm_Factory_M_Farm_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootFarm_Factory_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Farm_Factory_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootFarm_Factory_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Farm_Factory_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootFarm_Factory_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootFarm_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Farm_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_General_Contract_Order_By>>;
  where?: InputMaybe<Farm_General_Contract_Bool_Exp>;
};


export type Query_RootFarm_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_General_Contract_Order_By>>;
  where?: InputMaybe<Farm_General_Contract_Bool_Exp>;
};


export type Query_RootFarm_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootFarm_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Farm_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Lambda_Order_By>>;
  where?: InputMaybe<Farm_Lambda_Bool_Exp>;
};


export type Query_RootFarm_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Lambda_Order_By>>;
  where?: InputMaybe<Farm_Lambda_Bool_Exp>;
};


export type Query_RootFarm_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootFarm_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Farm_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Farm_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootFarm_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Farm_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootFarm_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernanceArgs = {
  distinct_on?: InputMaybe<Array<Governance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Order_By>>;
  where?: InputMaybe<Governance_Bool_Exp>;
};


export type Query_RootGovernance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Order_By>>;
  where?: InputMaybe<Governance_Bool_Exp>;
};


export type Query_RootGovernance_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_FinancialArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Order_By>>;
  where?: InputMaybe<Governance_Financial_Bool_Exp>;
};


export type Query_RootGovernance_Financial_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Order_By>>;
  where?: InputMaybe<Governance_Financial_Bool_Exp>;
};


export type Query_RootGovernance_Financial_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_Financial_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_General_Contract_Order_By>>;
  where?: InputMaybe<Governance_Financial_General_Contract_Bool_Exp>;
};


export type Query_RootGovernance_Financial_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_General_Contract_Order_By>>;
  where?: InputMaybe<Governance_Financial_General_Contract_Bool_Exp>;
};


export type Query_RootGovernance_Financial_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_Financial_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Lambda_Order_By>>;
  where?: InputMaybe<Governance_Financial_Lambda_Bool_Exp>;
};


export type Query_RootGovernance_Financial_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Lambda_Order_By>>;
  where?: InputMaybe<Governance_Financial_Lambda_Bool_Exp>;
};


export type Query_RootGovernance_Financial_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_Financial_RequestArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Request_Order_By>>;
  where?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
};


export type Query_RootGovernance_Financial_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Request_Order_By>>;
  where?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
};


export type Query_RootGovernance_Financial_Request_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_Financial_Request_VoteArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Request_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Request_Vote_Order_By>>;
  where?: InputMaybe<Governance_Financial_Request_Vote_Bool_Exp>;
};


export type Query_RootGovernance_Financial_Request_Vote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Request_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Request_Vote_Order_By>>;
  where?: InputMaybe<Governance_Financial_Request_Vote_Bool_Exp>;
};


export type Query_RootGovernance_Financial_Request_Vote_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_Financial_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Governance_Financial_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootGovernance_Financial_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Governance_Financial_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootGovernance_Financial_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_Financial_Whitelist_Token_ContractArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Whitelist_Token_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Whitelist_Token_Contract_Order_By>>;
  where?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Bool_Exp>;
};


export type Query_RootGovernance_Financial_Whitelist_Token_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Whitelist_Token_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Whitelist_Token_Contract_Order_By>>;
  where?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Bool_Exp>;
};


export type Query_RootGovernance_Financial_Whitelist_Token_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Governance_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_General_Contract_Order_By>>;
  where?: InputMaybe<Governance_General_Contract_Bool_Exp>;
};


export type Query_RootGovernance_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_General_Contract_Order_By>>;
  where?: InputMaybe<Governance_General_Contract_Bool_Exp>;
};


export type Query_RootGovernance_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Governance_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Lambda_Order_By>>;
  where?: InputMaybe<Governance_Lambda_Bool_Exp>;
};


export type Query_RootGovernance_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Lambda_Order_By>>;
  where?: InputMaybe<Governance_Lambda_Bool_Exp>;
};


export type Query_RootGovernance_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_ProposalArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Bool_Exp>;
};


export type Query_RootGovernance_Proposal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Bool_Exp>;
};


export type Query_RootGovernance_Proposal_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_Proposal_DataArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Data_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Data_Bool_Exp>;
};


export type Query_RootGovernance_Proposal_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Data_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Data_Bool_Exp>;
};


export type Query_RootGovernance_Proposal_Data_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_Proposal_PaymentArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Payment_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Payment_Bool_Exp>;
};


export type Query_RootGovernance_Proposal_Payment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Payment_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Payment_Bool_Exp>;
};


export type Query_RootGovernance_Proposal_Payment_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_Proposal_VoteArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Vote_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Vote_Bool_Exp>;
};


export type Query_RootGovernance_Proposal_Vote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Vote_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Vote_Bool_Exp>;
};


export type Query_RootGovernance_Proposal_Vote_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_ProxyArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proxy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proxy_Order_By>>;
  where?: InputMaybe<Governance_Proxy_Bool_Exp>;
};


export type Query_RootGovernance_Proxy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proxy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proxy_Order_By>>;
  where?: InputMaybe<Governance_Proxy_Bool_Exp>;
};


export type Query_RootGovernance_Proxy_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_Proxy_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proxy_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proxy_Lambda_Order_By>>;
  where?: InputMaybe<Governance_Proxy_Lambda_Bool_Exp>;
};


export type Query_RootGovernance_Proxy_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proxy_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proxy_Lambda_Order_By>>;
  where?: InputMaybe<Governance_Proxy_Lambda_Bool_Exp>;
};


export type Query_RootGovernance_Proxy_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_SatelliteArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Bool_Exp>;
};


export type Query_RootGovernance_Satellite_ActionArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Action_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Action_Bool_Exp>;
};


export type Query_RootGovernance_Satellite_Action_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Action_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Action_Bool_Exp>;
};


export type Query_RootGovernance_Satellite_Action_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_Satellite_Action_ParameterArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Action_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Action_Parameter_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Action_Parameter_Bool_Exp>;
};


export type Query_RootGovernance_Satellite_Action_Parameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Action_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Action_Parameter_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Action_Parameter_Bool_Exp>;
};


export type Query_RootGovernance_Satellite_Action_Parameter_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_Satellite_Action_VoteArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Action_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Action_Vote_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Action_Vote_Bool_Exp>;
};


export type Query_RootGovernance_Satellite_Action_Vote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Action_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Action_Vote_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Action_Vote_Bool_Exp>;
};


export type Query_RootGovernance_Satellite_Action_Vote_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_Satellite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Bool_Exp>;
};


export type Query_RootGovernance_Satellite_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_Satellite_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_General_Contract_Order_By>>;
  where?: InputMaybe<Governance_Satellite_General_Contract_Bool_Exp>;
};


export type Query_RootGovernance_Satellite_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_General_Contract_Order_By>>;
  where?: InputMaybe<Governance_Satellite_General_Contract_Bool_Exp>;
};


export type Query_RootGovernance_Satellite_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_Satellite_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Lambda_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Lambda_Bool_Exp>;
};


export type Query_RootGovernance_Satellite_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Lambda_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Lambda_Bool_Exp>;
};


export type Query_RootGovernance_Satellite_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_Satellite_OracleArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Oracle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Oracle_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Oracle_Bool_Exp>;
};


export type Query_RootGovernance_Satellite_Oracle_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Oracle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Oracle_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Oracle_Bool_Exp>;
};


export type Query_RootGovernance_Satellite_Oracle_AggregatorArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Oracle_Aggregator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Oracle_Aggregator_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Bool_Exp>;
};


export type Query_RootGovernance_Satellite_Oracle_Aggregator_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Oracle_Aggregator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Oracle_Aggregator_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Bool_Exp>;
};


export type Query_RootGovernance_Satellite_Oracle_Aggregator_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_Satellite_Oracle_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_Satellite_SnapshotArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Snapshot_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Snapshot_Bool_Exp>;
};


export type Query_RootGovernance_Satellite_Snapshot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Snapshot_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Snapshot_Bool_Exp>;
};


export type Query_RootGovernance_Satellite_Snapshot_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_Satellite_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootGovernance_Satellite_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootGovernance_Satellite_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_Smvn_SnapshotArgs = {
  distinct_on?: InputMaybe<Array<Governance_Smvn_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Smvn_Snapshot_Order_By>>;
  where?: InputMaybe<Governance_Smvn_Snapshot_Bool_Exp>;
};


export type Query_RootGovernance_Smvn_Snapshot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Smvn_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Smvn_Snapshot_Order_By>>;
  where?: InputMaybe<Governance_Smvn_Snapshot_Bool_Exp>;
};


export type Query_RootGovernance_Smvn_Snapshot_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGovernance_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Governance_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Governance_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootGovernance_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Governance_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootGovernance_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGql_History_Data_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Gql_History_Data_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gql_History_Data_Summary_Order_By>>;
  where?: InputMaybe<Gql_History_Data_Summary_Bool_Exp>;
};


export type Query_RootGql_History_Data_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gql_History_Data_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gql_History_Data_Summary_Order_By>>;
  where?: InputMaybe<Gql_History_Data_Summary_Bool_Exp>;
};


export type Query_RootGql_Loan_Token_Market_StatsArgs = {
  distinct_on?: InputMaybe<Array<Gql_Loan_Token_Market_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gql_Loan_Token_Market_Stats_Order_By>>;
  where?: InputMaybe<Gql_Loan_Token_Market_Stats_Bool_Exp>;
};


export type Query_RootGql_Loan_Token_Market_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gql_Loan_Token_Market_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gql_Loan_Token_Market_Stats_Order_By>>;
  where?: InputMaybe<Gql_Loan_Token_Market_Stats_Bool_Exp>;
};


export type Query_RootGql_Vault_With_BalancesArgs = {
  distinct_on?: InputMaybe<Array<Gql_Vault_With_Balances_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gql_Vault_With_Balances_Order_By>>;
  where?: InputMaybe<Gql_Vault_With_Balances_Bool_Exp>;
};


export type Query_RootGql_Vault_With_Balances_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gql_Vault_With_Balances_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gql_Vault_With_Balances_Order_By>>;
  where?: InputMaybe<Gql_Vault_With_Balances_Bool_Exp>;
};


export type Query_RootLending_ControllerArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Order_By>>;
  where?: InputMaybe<Lending_Controller_Bool_Exp>;
};


export type Query_RootLending_Controller_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Order_By>>;
  where?: InputMaybe<Lending_Controller_Bool_Exp>;
};


export type Query_RootLending_Controller_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootLending_Controller_Collateral_TokenArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Collateral_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Collateral_Token_Order_By>>;
  where?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
};


export type Query_RootLending_Controller_Collateral_Token_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Collateral_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Collateral_Token_Order_By>>;
  where?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
};


export type Query_RootLending_Controller_Collateral_Token_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootLending_Controller_History_DataArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_History_Data_Order_By>>;
  where?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
};


export type Query_RootLending_Controller_History_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_History_Data_Order_By>>;
  where?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
};


export type Query_RootLending_Controller_History_Data_By_PkArgs = {
  id: Scalars['bigint']['input'];
  timestamp: Scalars['timestamptz']['input'];
};


export type Query_RootLending_Controller_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Lambda_Order_By>>;
  where?: InputMaybe<Lending_Controller_Lambda_Bool_Exp>;
};


export type Query_RootLending_Controller_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Lambda_Order_By>>;
  where?: InputMaybe<Lending_Controller_Lambda_Bool_Exp>;
};


export type Query_RootLending_Controller_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootLending_Controller_Loan_TokenArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Loan_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Loan_Token_Order_By>>;
  where?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
};


export type Query_RootLending_Controller_Loan_Token_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Loan_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Loan_Token_Order_By>>;
  where?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
};


export type Query_RootLending_Controller_Loan_Token_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootLending_Controller_VaultArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Vault_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Vault_Order_By>>;
  where?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
};


export type Query_RootLending_Controller_Vault_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Vault_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Vault_Order_By>>;
  where?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
};


export type Query_RootLending_Controller_Vault_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootLending_Controller_Vault_Collateral_BalanceArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Vault_Collateral_Balance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Vault_Collateral_Balance_Order_By>>;
  where?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Bool_Exp>;
};


export type Query_RootLending_Controller_Vault_Collateral_Balance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Vault_Collateral_Balance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Vault_Collateral_Balance_Order_By>>;
  where?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Bool_Exp>;
};


export type Query_RootLending_Controller_Vault_Collateral_Balance_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootLoan_Token_ViewArgs = {
  distinct_on?: InputMaybe<Array<Loan_Token_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Loan_Token_View_Order_By>>;
  where?: InputMaybe<Loan_Token_View_Bool_Exp>;
};


export type Query_RootLoan_Token_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Loan_Token_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Loan_Token_View_Order_By>>;
  where?: InputMaybe<Loan_Token_View_Bool_Exp>;
};


export type Query_RootM_TokenArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Order_By>>;
  where?: InputMaybe<M_Token_Bool_Exp>;
};


export type Query_RootM_Token_AccountArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Account_Order_By>>;
  where?: InputMaybe<M_Token_Account_Bool_Exp>;
};


export type Query_RootM_Token_Account_AggregateArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Account_Order_By>>;
  where?: InputMaybe<M_Token_Account_Bool_Exp>;
};


export type Query_RootM_Token_Account_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootM_Token_Account_History_DataArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Account_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Account_History_Data_Order_By>>;
  where?: InputMaybe<M_Token_Account_History_Data_Bool_Exp>;
};


export type Query_RootM_Token_Account_History_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Account_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Account_History_Data_Order_By>>;
  where?: InputMaybe<M_Token_Account_History_Data_Bool_Exp>;
};


export type Query_RootM_Token_Account_History_Data_By_PkArgs = {
  id: Scalars['bigint']['input'];
  timestamp: Scalars['timestamptz']['input'];
};


export type Query_RootM_Token_AggregateArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Order_By>>;
  where?: InputMaybe<M_Token_Bool_Exp>;
};


export type Query_RootM_Token_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootM_Token_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<M_Token_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_General_Contract_Order_By>>;
  where?: InputMaybe<M_Token_General_Contract_Bool_Exp>;
};


export type Query_RootM_Token_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<M_Token_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_General_Contract_Order_By>>;
  where?: InputMaybe<M_Token_General_Contract_Bool_Exp>;
};


export type Query_RootM_Token_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootM_Token_LambdaArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Lambda_Order_By>>;
  where?: InputMaybe<M_Token_Lambda_Bool_Exp>;
};


export type Query_RootM_Token_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Lambda_Order_By>>;
  where?: InputMaybe<M_Token_Lambda_Bool_Exp>;
};


export type Query_RootM_Token_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootM_Token_OperatorArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Operator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Operator_Order_By>>;
  where?: InputMaybe<M_Token_Operator_Bool_Exp>;
};


export type Query_RootM_Token_Operator_AggregateArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Operator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Operator_Order_By>>;
  where?: InputMaybe<M_Token_Operator_Bool_Exp>;
};


export type Query_RootM_Token_Operator_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootM_Token_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<M_Token_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootM_Token_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<M_Token_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootM_Token_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootMaven_UserArgs = {
  distinct_on?: InputMaybe<Array<Maven_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Maven_User_Order_By>>;
  where?: InputMaybe<Maven_User_Bool_Exp>;
};


export type Query_RootMaven_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Maven_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Maven_User_Order_By>>;
  where?: InputMaybe<Maven_User_Bool_Exp>;
};


export type Query_RootMaven_User_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootMvn_Mint_Or_Burn_History_DataArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Mint_Or_Burn_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Mint_Or_Burn_History_Data_Order_By>>;
  where?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Bool_Exp>;
};


export type Query_RootMvn_Mint_Or_Burn_History_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Mint_Or_Burn_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Mint_Or_Burn_History_Data_Order_By>>;
  where?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Bool_Exp>;
};


export type Query_RootMvn_Mint_Or_Burn_History_Data_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootMvn_TokenArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_Order_By>>;
  where?: InputMaybe<Mvn_Token_Bool_Exp>;
};


export type Query_RootMvn_Token_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_Order_By>>;
  where?: InputMaybe<Mvn_Token_Bool_Exp>;
};


export type Query_RootMvn_Token_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootMvn_Token_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_General_Contract_Order_By>>;
  where?: InputMaybe<Mvn_Token_General_Contract_Bool_Exp>;
};


export type Query_RootMvn_Token_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_General_Contract_Order_By>>;
  where?: InputMaybe<Mvn_Token_General_Contract_Bool_Exp>;
};


export type Query_RootMvn_Token_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootMvn_Token_OperatorArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_Operator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_Operator_Order_By>>;
  where?: InputMaybe<Mvn_Token_Operator_Bool_Exp>;
};


export type Query_RootMvn_Token_Operator_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_Operator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_Operator_Order_By>>;
  where?: InputMaybe<Mvn_Token_Operator_Bool_Exp>;
};


export type Query_RootMvn_Token_Operator_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootMvn_Token_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Mvn_Token_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootMvn_Token_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Mvn_Token_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootMvn_Token_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootMvn_Transfer_History_DataArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Transfer_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Transfer_History_Data_Order_By>>;
  where?: InputMaybe<Mvn_Transfer_History_Data_Bool_Exp>;
};


export type Query_RootMvn_Transfer_History_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Transfer_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Transfer_History_Data_Order_By>>;
  where?: InputMaybe<Mvn_Transfer_History_Data_Bool_Exp>;
};


export type Query_RootMvn_Transfer_History_Data_By_PkArgs = {
  id: Scalars['bigint']['input'];
  timestamp: Scalars['timestamptz']['input'];
};


export type Query_RootSatelliteArgs = {
  distinct_on?: InputMaybe<Array<Satellite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Satellite_Order_By>>;
  where?: InputMaybe<Satellite_Bool_Exp>;
};


export type Query_RootSatellite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Satellite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Satellite_Order_By>>;
  where?: InputMaybe<Satellite_Bool_Exp>;
};


export type Query_RootSatellite_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootSatellite_RewardsArgs = {
  distinct_on?: InputMaybe<Array<Satellite_Rewards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Satellite_Rewards_Order_By>>;
  where?: InputMaybe<Satellite_Rewards_Bool_Exp>;
};


export type Query_RootSatellite_Rewards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Satellite_Rewards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Satellite_Rewards_Order_By>>;
  where?: InputMaybe<Satellite_Rewards_Bool_Exp>;
};


export type Query_RootSatellite_Rewards_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootSmvn_History_DataArgs = {
  distinct_on?: InputMaybe<Array<Smvn_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smvn_History_Data_Order_By>>;
  where?: InputMaybe<Smvn_History_Data_Bool_Exp>;
};


export type Query_RootSmvn_History_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Smvn_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smvn_History_Data_Order_By>>;
  where?: InputMaybe<Smvn_History_Data_Bool_Exp>;
};


export type Query_RootSmvn_History_Data_By_PkArgs = {
  id: Scalars['bigint']['input'];
  timestamp: Scalars['timestamptz']['input'];
};


export type Query_RootStake_History_DataArgs = {
  distinct_on?: InputMaybe<Array<Stake_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stake_History_Data_Order_By>>;
  where?: InputMaybe<Stake_History_Data_Bool_Exp>;
};


export type Query_RootStake_History_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stake_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stake_History_Data_Order_By>>;
  where?: InputMaybe<Stake_History_Data_Bool_Exp>;
};


export type Query_RootStake_History_Data_By_PkArgs = {
  id: Scalars['bigint']['input'];
  timestamp: Scalars['timestamptz']['input'];
};


export type Query_RootTokenArgs = {
  distinct_on?: InputMaybe<Array<Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Token_Order_By>>;
  where?: InputMaybe<Token_Bool_Exp>;
};


export type Query_RootToken_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Token_Order_By>>;
  where?: InputMaybe<Token_Bool_Exp>;
};


export type Query_RootToken_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTreasuryArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Order_By>>;
  where?: InputMaybe<Treasury_Bool_Exp>;
};


export type Query_RootTreasury_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Order_By>>;
  where?: InputMaybe<Treasury_Bool_Exp>;
};


export type Query_RootTreasury_BalanceArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Balance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Balance_Order_By>>;
  where?: InputMaybe<Treasury_Balance_Bool_Exp>;
};


export type Query_RootTreasury_Balance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Balance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Balance_Order_By>>;
  where?: InputMaybe<Treasury_Balance_Bool_Exp>;
};


export type Query_RootTreasury_Balance_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTreasury_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTreasury_FactoryArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Bool_Exp>;
};


export type Query_RootTreasury_Factory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Bool_Exp>;
};


export type Query_RootTreasury_Factory_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTreasury_Factory_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_General_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Factory_General_Contract_Bool_Exp>;
};


export type Query_RootTreasury_Factory_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_General_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Factory_General_Contract_Bool_Exp>;
};


export type Query_RootTreasury_Factory_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTreasury_Factory_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Lambda_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Lambda_Bool_Exp>;
};


export type Query_RootTreasury_Factory_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Lambda_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Lambda_Bool_Exp>;
};


export type Query_RootTreasury_Factory_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTreasury_Factory_Treasury_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Treasury_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Treasury_Lambda_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Treasury_Lambda_Bool_Exp>;
};


export type Query_RootTreasury_Factory_Treasury_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Treasury_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Treasury_Lambda_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Treasury_Lambda_Bool_Exp>;
};


export type Query_RootTreasury_Factory_Treasury_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTreasury_Factory_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootTreasury_Factory_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootTreasury_Factory_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTreasury_Factory_Whitelist_Token_ContractArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Whitelist_Token_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Whitelist_Token_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Bool_Exp>;
};


export type Query_RootTreasury_Factory_Whitelist_Token_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Whitelist_Token_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Whitelist_Token_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Bool_Exp>;
};


export type Query_RootTreasury_Factory_Whitelist_Token_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTreasury_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Treasury_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_General_Contract_Order_By>>;
  where?: InputMaybe<Treasury_General_Contract_Bool_Exp>;
};


export type Query_RootTreasury_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_General_Contract_Order_By>>;
  where?: InputMaybe<Treasury_General_Contract_Bool_Exp>;
};


export type Query_RootTreasury_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTreasury_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Lambda_Order_By>>;
  where?: InputMaybe<Treasury_Lambda_Bool_Exp>;
};


export type Query_RootTreasury_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Lambda_Order_By>>;
  where?: InputMaybe<Treasury_Lambda_Bool_Exp>;
};


export type Query_RootTreasury_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTreasury_Transfer_History_DataArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Transfer_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Transfer_History_Data_Order_By>>;
  where?: InputMaybe<Treasury_Transfer_History_Data_Bool_Exp>;
};


export type Query_RootTreasury_Transfer_History_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Transfer_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Transfer_History_Data_Order_By>>;
  where?: InputMaybe<Treasury_Transfer_History_Data_Bool_Exp>;
};


export type Query_RootTreasury_Transfer_History_Data_By_PkArgs = {
  id: Scalars['bigint']['input'];
  timestamp: Scalars['timestamptz']['input'];
};


export type Query_RootTreasury_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootTreasury_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootTreasury_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTreasury_Whitelist_Token_ContractArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Whitelist_Token_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Whitelist_Token_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Whitelist_Token_Contract_Bool_Exp>;
};


export type Query_RootTreasury_Whitelist_Token_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Whitelist_Token_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Whitelist_Token_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Whitelist_Token_Contract_Bool_Exp>;
};


export type Query_RootTreasury_Whitelist_Token_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTvl_StatsArgs = {
  distinct_on?: InputMaybe<Array<Tvl_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tvl_Stats_Order_By>>;
  where?: InputMaybe<Tvl_Stats_Bool_Exp>;
};


export type Query_RootTvl_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tvl_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tvl_Stats_Order_By>>;
  where?: InputMaybe<Tvl_Stats_Bool_Exp>;
};


export type Query_RootUser_DashboardArgs = {
  distinct_on?: InputMaybe<Array<User_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Dashboard_Order_By>>;
  where?: InputMaybe<User_Dashboard_Bool_Exp>;
};


export type Query_RootUser_Dashboard_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Dashboard_Order_By>>;
  where?: InputMaybe<User_Dashboard_Bool_Exp>;
};


export type Query_RootVaultArgs = {
  distinct_on?: InputMaybe<Array<Vault_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Order_By>>;
  where?: InputMaybe<Vault_Bool_Exp>;
};


export type Query_RootVault_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Order_By>>;
  where?: InputMaybe<Vault_Bool_Exp>;
};


export type Query_RootVault_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVault_Collateral_ViewArgs = {
  distinct_on?: InputMaybe<Array<Vault_Collateral_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Collateral_View_Order_By>>;
  where?: InputMaybe<Vault_Collateral_View_Bool_Exp>;
};


export type Query_RootVault_Collateral_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Collateral_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Collateral_View_Order_By>>;
  where?: InputMaybe<Vault_Collateral_View_Bool_Exp>;
};


export type Query_RootVault_DepositorArgs = {
  distinct_on?: InputMaybe<Array<Vault_Depositor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Depositor_Order_By>>;
  where?: InputMaybe<Vault_Depositor_Bool_Exp>;
};


export type Query_RootVault_Depositor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Depositor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Depositor_Order_By>>;
  where?: InputMaybe<Vault_Depositor_Bool_Exp>;
};


export type Query_RootVault_Depositor_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVault_FactoryArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_Order_By>>;
  where?: InputMaybe<Vault_Factory_Bool_Exp>;
};


export type Query_RootVault_Factory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_Order_By>>;
  where?: InputMaybe<Vault_Factory_Bool_Exp>;
};


export type Query_RootVault_Factory_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVault_Factory_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_General_Contract_Order_By>>;
  where?: InputMaybe<Vault_Factory_General_Contract_Bool_Exp>;
};


export type Query_RootVault_Factory_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_General_Contract_Order_By>>;
  where?: InputMaybe<Vault_Factory_General_Contract_Bool_Exp>;
};


export type Query_RootVault_Factory_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVault_Factory_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_Lambda_Order_By>>;
  where?: InputMaybe<Vault_Factory_Lambda_Bool_Exp>;
};


export type Query_RootVault_Factory_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_Lambda_Order_By>>;
  where?: InputMaybe<Vault_Factory_Lambda_Bool_Exp>;
};


export type Query_RootVault_Factory_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVault_Factory_Vault_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_Vault_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_Vault_Lambda_Order_By>>;
  where?: InputMaybe<Vault_Factory_Vault_Lambda_Bool_Exp>;
};


export type Query_RootVault_Factory_Vault_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_Vault_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_Vault_Lambda_Order_By>>;
  where?: InputMaybe<Vault_Factory_Vault_Lambda_Bool_Exp>;
};


export type Query_RootVault_Factory_Vault_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVault_Factory_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Vault_Factory_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootVault_Factory_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Vault_Factory_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootVault_Factory_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVault_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Vault_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Lambda_Order_By>>;
  where?: InputMaybe<Vault_Lambda_Bool_Exp>;
};


export type Query_RootVault_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Lambda_Order_By>>;
  where?: InputMaybe<Vault_Lambda_Bool_Exp>;
};


export type Query_RootVault_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVestingArgs = {
  distinct_on?: InputMaybe<Array<Vesting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_Order_By>>;
  where?: InputMaybe<Vesting_Bool_Exp>;
};


export type Query_RootVesting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vesting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_Order_By>>;
  where?: InputMaybe<Vesting_Bool_Exp>;
};


export type Query_RootVesting_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVesting_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Vesting_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_General_Contract_Order_By>>;
  where?: InputMaybe<Vesting_General_Contract_Bool_Exp>;
};


export type Query_RootVesting_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vesting_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_General_Contract_Order_By>>;
  where?: InputMaybe<Vesting_General_Contract_Bool_Exp>;
};


export type Query_RootVesting_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVesting_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Vesting_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_Lambda_Order_By>>;
  where?: InputMaybe<Vesting_Lambda_Bool_Exp>;
};


export type Query_RootVesting_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vesting_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_Lambda_Order_By>>;
  where?: InputMaybe<Vesting_Lambda_Bool_Exp>;
};


export type Query_RootVesting_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVesting_VesteeArgs = {
  distinct_on?: InputMaybe<Array<Vesting_Vestee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_Vestee_Order_By>>;
  where?: InputMaybe<Vesting_Vestee_Bool_Exp>;
};


export type Query_RootVesting_Vestee_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vesting_Vestee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_Vestee_Order_By>>;
  where?: InputMaybe<Vesting_Vestee_Bool_Exp>;
};


export type Query_RootVesting_Vestee_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVesting_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Vesting_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Vesting_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootVesting_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vesting_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Vesting_Whitelist_Contract_Bool_Exp>;
};


export type Query_RootVesting_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootWhitelist_DeveloperArgs = {
  distinct_on?: InputMaybe<Array<Whitelist_Developer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whitelist_Developer_Order_By>>;
  where?: InputMaybe<Whitelist_Developer_Bool_Exp>;
};


export type Query_RootWhitelist_Developer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whitelist_Developer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whitelist_Developer_Order_By>>;
  where?: InputMaybe<Whitelist_Developer_Bool_Exp>;
};


export type Query_RootWhitelist_Developer_By_PkArgs = {
  id: Scalars['bigint']['input'];
};

/** columns and relationships of "satellite" */
export type Satellite = {
  __typename?: 'satellite';
  currently_registered: Scalars['Boolean']['output'];
  /** An object relationship */
  delegation: Delegation;
  delegation_id: Scalars['bigint']['output'];
  /** An array relationship */
  delegations: Array<Delegation_Record>;
  /** An aggregate relationship */
  delegations_aggregate: Delegation_Record_Aggregate;
  description: Scalars['String']['output'];
  fee: Scalars['smallint']['output'];
  financial_request_counter: Scalars['bigint']['output'];
  governance_proposal_counter: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
  peer_id?: Maybe<Scalars['String']['output']>;
  public_key?: Maybe<Scalars['String']['output']>;
  registration_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  satellite_action_counter: Scalars['bigint']['output'];
  /** ACTIVE: 0\nSUSPENDED: 1\nBANNED: 2 */
  status: Scalars['smallint']['output'];
  total_delegated_amount: Scalars['float8']['output'];
  /** An object relationship */
  user: Maven_User;
  user_id: Scalars['bigint']['output'];
  website: Scalars['String']['output'];
};


/** columns and relationships of "satellite" */
export type SatelliteDelegationsArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Record_Order_By>>;
  where?: InputMaybe<Delegation_Record_Bool_Exp>;
};


/** columns and relationships of "satellite" */
export type SatelliteDelegations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Record_Order_By>>;
  where?: InputMaybe<Delegation_Record_Bool_Exp>;
};

/** aggregated selection of "satellite" */
export type Satellite_Aggregate = {
  __typename?: 'satellite_aggregate';
  aggregate?: Maybe<Satellite_Aggregate_Fields>;
  nodes: Array<Satellite>;
};

export type Satellite_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Satellite_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Satellite_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Satellite_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Satellite_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Satellite_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Satellite_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Satellite_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Satellite_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Satellite_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Satellite_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Satellite_Aggregate_Bool_Exp_Var_Samp>;
};

export type Satellite_Aggregate_Bool_Exp_Avg = {
  arguments: Satellite_Select_Column_Satellite_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Satellite_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Satellite_Aggregate_Bool_Exp_Bool_And = {
  arguments: Satellite_Select_Column_Satellite_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Satellite_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Satellite_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Satellite_Select_Column_Satellite_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Satellite_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Satellite_Aggregate_Bool_Exp_Corr = {
  arguments: Satellite_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Satellite_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Satellite_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Satellite_Select_Column_Satellite_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Satellite_Select_Column_Satellite_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Satellite_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Satellite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Satellite_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Satellite_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Satellite_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Satellite_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Satellite_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Satellite_Select_Column_Satellite_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Satellite_Select_Column_Satellite_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Satellite_Aggregate_Bool_Exp_Max = {
  arguments: Satellite_Select_Column_Satellite_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Satellite_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Satellite_Aggregate_Bool_Exp_Min = {
  arguments: Satellite_Select_Column_Satellite_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Satellite_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Satellite_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Satellite_Select_Column_Satellite_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Satellite_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Satellite_Aggregate_Bool_Exp_Sum = {
  arguments: Satellite_Select_Column_Satellite_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Satellite_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Satellite_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Satellite_Select_Column_Satellite_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Satellite_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "satellite" */
export type Satellite_Aggregate_Fields = {
  __typename?: 'satellite_aggregate_fields';
  avg?: Maybe<Satellite_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Satellite_Max_Fields>;
  min?: Maybe<Satellite_Min_Fields>;
  stddev?: Maybe<Satellite_Stddev_Fields>;
  stddev_pop?: Maybe<Satellite_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Satellite_Stddev_Samp_Fields>;
  sum?: Maybe<Satellite_Sum_Fields>;
  var_pop?: Maybe<Satellite_Var_Pop_Fields>;
  var_samp?: Maybe<Satellite_Var_Samp_Fields>;
  variance?: Maybe<Satellite_Variance_Fields>;
};


/** aggregate fields of "satellite" */
export type Satellite_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Satellite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "satellite" */
export type Satellite_Aggregate_Order_By = {
  avg?: InputMaybe<Satellite_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Satellite_Max_Order_By>;
  min?: InputMaybe<Satellite_Min_Order_By>;
  stddev?: InputMaybe<Satellite_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Satellite_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Satellite_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Satellite_Sum_Order_By>;
  var_pop?: InputMaybe<Satellite_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Satellite_Var_Samp_Order_By>;
  variance?: InputMaybe<Satellite_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Satellite_Avg_Fields = {
  __typename?: 'satellite_avg_fields';
  delegation_id?: Maybe<Scalars['Float']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  financial_request_counter?: Maybe<Scalars['Float']['output']>;
  governance_proposal_counter?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_action_counter?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nSUSPENDED: 1\nBANNED: 2 */
  status?: Maybe<Scalars['Float']['output']>;
  total_delegated_amount?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "satellite" */
export type Satellite_Avg_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  fee?: InputMaybe<Order_By>;
  financial_request_counter?: InputMaybe<Order_By>;
  governance_proposal_counter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_action_counter?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nSUSPENDED: 1\nBANNED: 2 */
  status?: InputMaybe<Order_By>;
  total_delegated_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "satellite". All fields are combined with a logical 'AND'. */
export type Satellite_Bool_Exp = {
  _and?: InputMaybe<Array<Satellite_Bool_Exp>>;
  _not?: InputMaybe<Satellite_Bool_Exp>;
  _or?: InputMaybe<Array<Satellite_Bool_Exp>>;
  currently_registered?: InputMaybe<Boolean_Comparison_Exp>;
  delegation?: InputMaybe<Delegation_Bool_Exp>;
  delegation_id?: InputMaybe<Bigint_Comparison_Exp>;
  delegations?: InputMaybe<Delegation_Record_Bool_Exp>;
  delegations_aggregate?: InputMaybe<Delegation_Record_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  fee?: InputMaybe<Smallint_Comparison_Exp>;
  financial_request_counter?: InputMaybe<Bigint_Comparison_Exp>;
  governance_proposal_counter?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  image?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  peer_id?: InputMaybe<String_Comparison_Exp>;
  public_key?: InputMaybe<String_Comparison_Exp>;
  registration_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  satellite_action_counter?: InputMaybe<Bigint_Comparison_Exp>;
  status?: InputMaybe<Smallint_Comparison_Exp>;
  total_delegated_amount?: InputMaybe<Float8_Comparison_Exp>;
  user?: InputMaybe<Maven_User_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
  website?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Satellite_Max_Fields = {
  __typename?: 'satellite_max_fields';
  delegation_id?: Maybe<Scalars['bigint']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['smallint']['output']>;
  financial_request_counter?: Maybe<Scalars['bigint']['output']>;
  governance_proposal_counter?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  peer_id?: Maybe<Scalars['String']['output']>;
  public_key?: Maybe<Scalars['String']['output']>;
  registration_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  satellite_action_counter?: Maybe<Scalars['bigint']['output']>;
  /** ACTIVE: 0\nSUSPENDED: 1\nBANNED: 2 */
  status?: Maybe<Scalars['smallint']['output']>;
  total_delegated_amount?: Maybe<Scalars['float8']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "satellite" */
export type Satellite_Max_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  fee?: InputMaybe<Order_By>;
  financial_request_counter?: InputMaybe<Order_By>;
  governance_proposal_counter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  peer_id?: InputMaybe<Order_By>;
  public_key?: InputMaybe<Order_By>;
  registration_timestamp?: InputMaybe<Order_By>;
  satellite_action_counter?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nSUSPENDED: 1\nBANNED: 2 */
  status?: InputMaybe<Order_By>;
  total_delegated_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Satellite_Min_Fields = {
  __typename?: 'satellite_min_fields';
  delegation_id?: Maybe<Scalars['bigint']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['smallint']['output']>;
  financial_request_counter?: Maybe<Scalars['bigint']['output']>;
  governance_proposal_counter?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  peer_id?: Maybe<Scalars['String']['output']>;
  public_key?: Maybe<Scalars['String']['output']>;
  registration_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  satellite_action_counter?: Maybe<Scalars['bigint']['output']>;
  /** ACTIVE: 0\nSUSPENDED: 1\nBANNED: 2 */
  status?: Maybe<Scalars['smallint']['output']>;
  total_delegated_amount?: Maybe<Scalars['float8']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "satellite" */
export type Satellite_Min_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  fee?: InputMaybe<Order_By>;
  financial_request_counter?: InputMaybe<Order_By>;
  governance_proposal_counter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  peer_id?: InputMaybe<Order_By>;
  public_key?: InputMaybe<Order_By>;
  registration_timestamp?: InputMaybe<Order_By>;
  satellite_action_counter?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nSUSPENDED: 1\nBANNED: 2 */
  status?: InputMaybe<Order_By>;
  total_delegated_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "satellite". */
export type Satellite_Order_By = {
  currently_registered?: InputMaybe<Order_By>;
  delegation?: InputMaybe<Delegation_Order_By>;
  delegation_id?: InputMaybe<Order_By>;
  delegations_aggregate?: InputMaybe<Delegation_Record_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  fee?: InputMaybe<Order_By>;
  financial_request_counter?: InputMaybe<Order_By>;
  governance_proposal_counter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  peer_id?: InputMaybe<Order_By>;
  public_key?: InputMaybe<Order_By>;
  registration_timestamp?: InputMaybe<Order_By>;
  satellite_action_counter?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  total_delegated_amount?: InputMaybe<Order_By>;
  user?: InputMaybe<Maven_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** columns and relationships of "satellite_rewards" */
export type Satellite_Rewards = {
  __typename?: 'satellite_rewards';
  /** An object relationship */
  delegation: Delegation;
  delegation_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  paid: Scalars['float8']['output'];
  participation_rewards_per_share: Scalars['float8']['output'];
  /** An object relationship */
  reference?: Maybe<Satellite_Rewards>;
  reference_governance_cycle_id: Scalars['bigint']['output'];
  reference_id?: Maybe<Scalars['bigint']['output']>;
  satellite_accumulated_reward_per_share: Scalars['float8']['output'];
  /** An array relationship */
  satellite_references: Array<Satellite_Rewards>;
  /** An aggregate relationship */
  satellite_references_aggregate: Satellite_Rewards_Aggregate;
  tracked: Scalars['Boolean']['output'];
  unpaid: Scalars['float8']['output'];
  /** An object relationship */
  user: Maven_User;
  user_id: Scalars['bigint']['output'];
};


/** columns and relationships of "satellite_rewards" */
export type Satellite_RewardsSatellite_ReferencesArgs = {
  distinct_on?: InputMaybe<Array<Satellite_Rewards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Satellite_Rewards_Order_By>>;
  where?: InputMaybe<Satellite_Rewards_Bool_Exp>;
};


/** columns and relationships of "satellite_rewards" */
export type Satellite_RewardsSatellite_References_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Satellite_Rewards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Satellite_Rewards_Order_By>>;
  where?: InputMaybe<Satellite_Rewards_Bool_Exp>;
};

/** aggregated selection of "satellite_rewards" */
export type Satellite_Rewards_Aggregate = {
  __typename?: 'satellite_rewards_aggregate';
  aggregate?: Maybe<Satellite_Rewards_Aggregate_Fields>;
  nodes: Array<Satellite_Rewards>;
};

export type Satellite_Rewards_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Satellite_Rewards_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Satellite_Rewards_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Satellite_Rewards_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Satellite_Rewards_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Satellite_Rewards_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Satellite_Rewards_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Satellite_Rewards_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Satellite_Rewards_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Satellite_Rewards_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Satellite_Rewards_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Satellite_Rewards_Aggregate_Bool_Exp_Var_Samp>;
};

export type Satellite_Rewards_Aggregate_Bool_Exp_Avg = {
  arguments: Satellite_Rewards_Select_Column_Satellite_Rewards_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Satellite_Rewards_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Satellite_Rewards_Aggregate_Bool_Exp_Bool_And = {
  arguments: Satellite_Rewards_Select_Column_Satellite_Rewards_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Satellite_Rewards_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Satellite_Rewards_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Satellite_Rewards_Select_Column_Satellite_Rewards_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Satellite_Rewards_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Satellite_Rewards_Aggregate_Bool_Exp_Corr = {
  arguments: Satellite_Rewards_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Satellite_Rewards_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Satellite_Rewards_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Satellite_Rewards_Select_Column_Satellite_Rewards_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Satellite_Rewards_Select_Column_Satellite_Rewards_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Satellite_Rewards_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Satellite_Rewards_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Satellite_Rewards_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Satellite_Rewards_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Satellite_Rewards_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Satellite_Rewards_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Satellite_Rewards_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Satellite_Rewards_Select_Column_Satellite_Rewards_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Satellite_Rewards_Select_Column_Satellite_Rewards_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Satellite_Rewards_Aggregate_Bool_Exp_Max = {
  arguments: Satellite_Rewards_Select_Column_Satellite_Rewards_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Satellite_Rewards_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Satellite_Rewards_Aggregate_Bool_Exp_Min = {
  arguments: Satellite_Rewards_Select_Column_Satellite_Rewards_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Satellite_Rewards_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Satellite_Rewards_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Satellite_Rewards_Select_Column_Satellite_Rewards_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Satellite_Rewards_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Satellite_Rewards_Aggregate_Bool_Exp_Sum = {
  arguments: Satellite_Rewards_Select_Column_Satellite_Rewards_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Satellite_Rewards_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Satellite_Rewards_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Satellite_Rewards_Select_Column_Satellite_Rewards_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Satellite_Rewards_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "satellite_rewards" */
export type Satellite_Rewards_Aggregate_Fields = {
  __typename?: 'satellite_rewards_aggregate_fields';
  avg?: Maybe<Satellite_Rewards_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Satellite_Rewards_Max_Fields>;
  min?: Maybe<Satellite_Rewards_Min_Fields>;
  stddev?: Maybe<Satellite_Rewards_Stddev_Fields>;
  stddev_pop?: Maybe<Satellite_Rewards_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Satellite_Rewards_Stddev_Samp_Fields>;
  sum?: Maybe<Satellite_Rewards_Sum_Fields>;
  var_pop?: Maybe<Satellite_Rewards_Var_Pop_Fields>;
  var_samp?: Maybe<Satellite_Rewards_Var_Samp_Fields>;
  variance?: Maybe<Satellite_Rewards_Variance_Fields>;
};


/** aggregate fields of "satellite_rewards" */
export type Satellite_Rewards_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Satellite_Rewards_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "satellite_rewards" */
export type Satellite_Rewards_Aggregate_Order_By = {
  avg?: InputMaybe<Satellite_Rewards_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Satellite_Rewards_Max_Order_By>;
  min?: InputMaybe<Satellite_Rewards_Min_Order_By>;
  stddev?: InputMaybe<Satellite_Rewards_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Satellite_Rewards_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Satellite_Rewards_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Satellite_Rewards_Sum_Order_By>;
  var_pop?: InputMaybe<Satellite_Rewards_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Satellite_Rewards_Var_Samp_Order_By>;
  variance?: InputMaybe<Satellite_Rewards_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Satellite_Rewards_Avg_Fields = {
  __typename?: 'satellite_rewards_avg_fields';
  delegation_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  paid?: Maybe<Scalars['Float']['output']>;
  participation_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  reference_governance_cycle_id?: Maybe<Scalars['Float']['output']>;
  reference_id?: Maybe<Scalars['Float']['output']>;
  satellite_accumulated_reward_per_share?: Maybe<Scalars['Float']['output']>;
  unpaid?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "satellite_rewards" */
export type Satellite_Rewards_Avg_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  paid?: InputMaybe<Order_By>;
  participation_rewards_per_share?: InputMaybe<Order_By>;
  reference_governance_cycle_id?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  satellite_accumulated_reward_per_share?: InputMaybe<Order_By>;
  unpaid?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "satellite_rewards". All fields are combined with a logical 'AND'. */
export type Satellite_Rewards_Bool_Exp = {
  _and?: InputMaybe<Array<Satellite_Rewards_Bool_Exp>>;
  _not?: InputMaybe<Satellite_Rewards_Bool_Exp>;
  _or?: InputMaybe<Array<Satellite_Rewards_Bool_Exp>>;
  delegation?: InputMaybe<Delegation_Bool_Exp>;
  delegation_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  paid?: InputMaybe<Float8_Comparison_Exp>;
  participation_rewards_per_share?: InputMaybe<Float8_Comparison_Exp>;
  reference?: InputMaybe<Satellite_Rewards_Bool_Exp>;
  reference_governance_cycle_id?: InputMaybe<Bigint_Comparison_Exp>;
  reference_id?: InputMaybe<Bigint_Comparison_Exp>;
  satellite_accumulated_reward_per_share?: InputMaybe<Float8_Comparison_Exp>;
  satellite_references?: InputMaybe<Satellite_Rewards_Bool_Exp>;
  satellite_references_aggregate?: InputMaybe<Satellite_Rewards_Aggregate_Bool_Exp>;
  tracked?: InputMaybe<Boolean_Comparison_Exp>;
  unpaid?: InputMaybe<Float8_Comparison_Exp>;
  user?: InputMaybe<Maven_User_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Satellite_Rewards_Max_Fields = {
  __typename?: 'satellite_rewards_max_fields';
  delegation_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  paid?: Maybe<Scalars['float8']['output']>;
  participation_rewards_per_share?: Maybe<Scalars['float8']['output']>;
  reference_governance_cycle_id?: Maybe<Scalars['bigint']['output']>;
  reference_id?: Maybe<Scalars['bigint']['output']>;
  satellite_accumulated_reward_per_share?: Maybe<Scalars['float8']['output']>;
  unpaid?: Maybe<Scalars['float8']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "satellite_rewards" */
export type Satellite_Rewards_Max_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  paid?: InputMaybe<Order_By>;
  participation_rewards_per_share?: InputMaybe<Order_By>;
  reference_governance_cycle_id?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  satellite_accumulated_reward_per_share?: InputMaybe<Order_By>;
  unpaid?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Satellite_Rewards_Min_Fields = {
  __typename?: 'satellite_rewards_min_fields';
  delegation_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  paid?: Maybe<Scalars['float8']['output']>;
  participation_rewards_per_share?: Maybe<Scalars['float8']['output']>;
  reference_governance_cycle_id?: Maybe<Scalars['bigint']['output']>;
  reference_id?: Maybe<Scalars['bigint']['output']>;
  satellite_accumulated_reward_per_share?: Maybe<Scalars['float8']['output']>;
  unpaid?: Maybe<Scalars['float8']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "satellite_rewards" */
export type Satellite_Rewards_Min_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  paid?: InputMaybe<Order_By>;
  participation_rewards_per_share?: InputMaybe<Order_By>;
  reference_governance_cycle_id?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  satellite_accumulated_reward_per_share?: InputMaybe<Order_By>;
  unpaid?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "satellite_rewards". */
export type Satellite_Rewards_Order_By = {
  delegation?: InputMaybe<Delegation_Order_By>;
  delegation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  paid?: InputMaybe<Order_By>;
  participation_rewards_per_share?: InputMaybe<Order_By>;
  reference?: InputMaybe<Satellite_Rewards_Order_By>;
  reference_governance_cycle_id?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  satellite_accumulated_reward_per_share?: InputMaybe<Order_By>;
  satellite_references_aggregate?: InputMaybe<Satellite_Rewards_Aggregate_Order_By>;
  tracked?: InputMaybe<Order_By>;
  unpaid?: InputMaybe<Order_By>;
  user?: InputMaybe<Maven_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "satellite_rewards" */
export enum Satellite_Rewards_Select_Column {
  /** column name */
  DelegationId = 'delegation_id',
  /** column name */
  Id = 'id',
  /** column name */
  Paid = 'paid',
  /** column name */
  ParticipationRewardsPerShare = 'participation_rewards_per_share',
  /** column name */
  ReferenceGovernanceCycleId = 'reference_governance_cycle_id',
  /** column name */
  ReferenceId = 'reference_id',
  /** column name */
  SatelliteAccumulatedRewardPerShare = 'satellite_accumulated_reward_per_share',
  /** column name */
  Tracked = 'tracked',
  /** column name */
  Unpaid = 'unpaid',
  /** column name */
  UserId = 'user_id'
}

/** select "satellite_rewards_aggregate_bool_exp_avg_arguments_columns" columns of table "satellite_rewards" */
export enum Satellite_Rewards_Select_Column_Satellite_Rewards_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Paid = 'paid',
  /** column name */
  ParticipationRewardsPerShare = 'participation_rewards_per_share',
  /** column name */
  SatelliteAccumulatedRewardPerShare = 'satellite_accumulated_reward_per_share',
  /** column name */
  Unpaid = 'unpaid'
}

/** select "satellite_rewards_aggregate_bool_exp_bool_and_arguments_columns" columns of table "satellite_rewards" */
export enum Satellite_Rewards_Select_Column_Satellite_Rewards_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Tracked = 'tracked'
}

/** select "satellite_rewards_aggregate_bool_exp_bool_or_arguments_columns" columns of table "satellite_rewards" */
export enum Satellite_Rewards_Select_Column_Satellite_Rewards_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Tracked = 'tracked'
}

/** select "satellite_rewards_aggregate_bool_exp_corr_arguments_columns" columns of table "satellite_rewards" */
export enum Satellite_Rewards_Select_Column_Satellite_Rewards_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Paid = 'paid',
  /** column name */
  ParticipationRewardsPerShare = 'participation_rewards_per_share',
  /** column name */
  SatelliteAccumulatedRewardPerShare = 'satellite_accumulated_reward_per_share',
  /** column name */
  Unpaid = 'unpaid'
}

/** select "satellite_rewards_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "satellite_rewards" */
export enum Satellite_Rewards_Select_Column_Satellite_Rewards_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Paid = 'paid',
  /** column name */
  ParticipationRewardsPerShare = 'participation_rewards_per_share',
  /** column name */
  SatelliteAccumulatedRewardPerShare = 'satellite_accumulated_reward_per_share',
  /** column name */
  Unpaid = 'unpaid'
}

/** select "satellite_rewards_aggregate_bool_exp_max_arguments_columns" columns of table "satellite_rewards" */
export enum Satellite_Rewards_Select_Column_Satellite_Rewards_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Paid = 'paid',
  /** column name */
  ParticipationRewardsPerShare = 'participation_rewards_per_share',
  /** column name */
  SatelliteAccumulatedRewardPerShare = 'satellite_accumulated_reward_per_share',
  /** column name */
  Unpaid = 'unpaid'
}

/** select "satellite_rewards_aggregate_bool_exp_min_arguments_columns" columns of table "satellite_rewards" */
export enum Satellite_Rewards_Select_Column_Satellite_Rewards_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Paid = 'paid',
  /** column name */
  ParticipationRewardsPerShare = 'participation_rewards_per_share',
  /** column name */
  SatelliteAccumulatedRewardPerShare = 'satellite_accumulated_reward_per_share',
  /** column name */
  Unpaid = 'unpaid'
}

/** select "satellite_rewards_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "satellite_rewards" */
export enum Satellite_Rewards_Select_Column_Satellite_Rewards_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Paid = 'paid',
  /** column name */
  ParticipationRewardsPerShare = 'participation_rewards_per_share',
  /** column name */
  SatelliteAccumulatedRewardPerShare = 'satellite_accumulated_reward_per_share',
  /** column name */
  Unpaid = 'unpaid'
}

/** select "satellite_rewards_aggregate_bool_exp_sum_arguments_columns" columns of table "satellite_rewards" */
export enum Satellite_Rewards_Select_Column_Satellite_Rewards_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Paid = 'paid',
  /** column name */
  ParticipationRewardsPerShare = 'participation_rewards_per_share',
  /** column name */
  SatelliteAccumulatedRewardPerShare = 'satellite_accumulated_reward_per_share',
  /** column name */
  Unpaid = 'unpaid'
}

/** select "satellite_rewards_aggregate_bool_exp_var_samp_arguments_columns" columns of table "satellite_rewards" */
export enum Satellite_Rewards_Select_Column_Satellite_Rewards_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Paid = 'paid',
  /** column name */
  ParticipationRewardsPerShare = 'participation_rewards_per_share',
  /** column name */
  SatelliteAccumulatedRewardPerShare = 'satellite_accumulated_reward_per_share',
  /** column name */
  Unpaid = 'unpaid'
}

/** aggregate stddev on columns */
export type Satellite_Rewards_Stddev_Fields = {
  __typename?: 'satellite_rewards_stddev_fields';
  delegation_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  paid?: Maybe<Scalars['Float']['output']>;
  participation_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  reference_governance_cycle_id?: Maybe<Scalars['Float']['output']>;
  reference_id?: Maybe<Scalars['Float']['output']>;
  satellite_accumulated_reward_per_share?: Maybe<Scalars['Float']['output']>;
  unpaid?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "satellite_rewards" */
export type Satellite_Rewards_Stddev_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  paid?: InputMaybe<Order_By>;
  participation_rewards_per_share?: InputMaybe<Order_By>;
  reference_governance_cycle_id?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  satellite_accumulated_reward_per_share?: InputMaybe<Order_By>;
  unpaid?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Satellite_Rewards_Stddev_Pop_Fields = {
  __typename?: 'satellite_rewards_stddev_pop_fields';
  delegation_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  paid?: Maybe<Scalars['Float']['output']>;
  participation_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  reference_governance_cycle_id?: Maybe<Scalars['Float']['output']>;
  reference_id?: Maybe<Scalars['Float']['output']>;
  satellite_accumulated_reward_per_share?: Maybe<Scalars['Float']['output']>;
  unpaid?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "satellite_rewards" */
export type Satellite_Rewards_Stddev_Pop_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  paid?: InputMaybe<Order_By>;
  participation_rewards_per_share?: InputMaybe<Order_By>;
  reference_governance_cycle_id?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  satellite_accumulated_reward_per_share?: InputMaybe<Order_By>;
  unpaid?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Satellite_Rewards_Stddev_Samp_Fields = {
  __typename?: 'satellite_rewards_stddev_samp_fields';
  delegation_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  paid?: Maybe<Scalars['Float']['output']>;
  participation_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  reference_governance_cycle_id?: Maybe<Scalars['Float']['output']>;
  reference_id?: Maybe<Scalars['Float']['output']>;
  satellite_accumulated_reward_per_share?: Maybe<Scalars['Float']['output']>;
  unpaid?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "satellite_rewards" */
export type Satellite_Rewards_Stddev_Samp_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  paid?: InputMaybe<Order_By>;
  participation_rewards_per_share?: InputMaybe<Order_By>;
  reference_governance_cycle_id?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  satellite_accumulated_reward_per_share?: InputMaybe<Order_By>;
  unpaid?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "satellite_rewards" */
export type Satellite_Rewards_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Satellite_Rewards_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Satellite_Rewards_Stream_Cursor_Value_Input = {
  delegation_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  paid?: InputMaybe<Scalars['float8']['input']>;
  participation_rewards_per_share?: InputMaybe<Scalars['float8']['input']>;
  reference_governance_cycle_id?: InputMaybe<Scalars['bigint']['input']>;
  reference_id?: InputMaybe<Scalars['bigint']['input']>;
  satellite_accumulated_reward_per_share?: InputMaybe<Scalars['float8']['input']>;
  tracked?: InputMaybe<Scalars['Boolean']['input']>;
  unpaid?: InputMaybe<Scalars['float8']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Satellite_Rewards_Sum_Fields = {
  __typename?: 'satellite_rewards_sum_fields';
  delegation_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  paid?: Maybe<Scalars['float8']['output']>;
  participation_rewards_per_share?: Maybe<Scalars['float8']['output']>;
  reference_governance_cycle_id?: Maybe<Scalars['bigint']['output']>;
  reference_id?: Maybe<Scalars['bigint']['output']>;
  satellite_accumulated_reward_per_share?: Maybe<Scalars['float8']['output']>;
  unpaid?: Maybe<Scalars['float8']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "satellite_rewards" */
export type Satellite_Rewards_Sum_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  paid?: InputMaybe<Order_By>;
  participation_rewards_per_share?: InputMaybe<Order_By>;
  reference_governance_cycle_id?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  satellite_accumulated_reward_per_share?: InputMaybe<Order_By>;
  unpaid?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Satellite_Rewards_Var_Pop_Fields = {
  __typename?: 'satellite_rewards_var_pop_fields';
  delegation_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  paid?: Maybe<Scalars['Float']['output']>;
  participation_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  reference_governance_cycle_id?: Maybe<Scalars['Float']['output']>;
  reference_id?: Maybe<Scalars['Float']['output']>;
  satellite_accumulated_reward_per_share?: Maybe<Scalars['Float']['output']>;
  unpaid?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "satellite_rewards" */
export type Satellite_Rewards_Var_Pop_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  paid?: InputMaybe<Order_By>;
  participation_rewards_per_share?: InputMaybe<Order_By>;
  reference_governance_cycle_id?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  satellite_accumulated_reward_per_share?: InputMaybe<Order_By>;
  unpaid?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Satellite_Rewards_Var_Samp_Fields = {
  __typename?: 'satellite_rewards_var_samp_fields';
  delegation_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  paid?: Maybe<Scalars['Float']['output']>;
  participation_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  reference_governance_cycle_id?: Maybe<Scalars['Float']['output']>;
  reference_id?: Maybe<Scalars['Float']['output']>;
  satellite_accumulated_reward_per_share?: Maybe<Scalars['Float']['output']>;
  unpaid?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "satellite_rewards" */
export type Satellite_Rewards_Var_Samp_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  paid?: InputMaybe<Order_By>;
  participation_rewards_per_share?: InputMaybe<Order_By>;
  reference_governance_cycle_id?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  satellite_accumulated_reward_per_share?: InputMaybe<Order_By>;
  unpaid?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Satellite_Rewards_Variance_Fields = {
  __typename?: 'satellite_rewards_variance_fields';
  delegation_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  paid?: Maybe<Scalars['Float']['output']>;
  participation_rewards_per_share?: Maybe<Scalars['Float']['output']>;
  reference_governance_cycle_id?: Maybe<Scalars['Float']['output']>;
  reference_id?: Maybe<Scalars['Float']['output']>;
  satellite_accumulated_reward_per_share?: Maybe<Scalars['Float']['output']>;
  unpaid?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "satellite_rewards" */
export type Satellite_Rewards_Variance_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  paid?: InputMaybe<Order_By>;
  participation_rewards_per_share?: InputMaybe<Order_By>;
  reference_governance_cycle_id?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  satellite_accumulated_reward_per_share?: InputMaybe<Order_By>;
  unpaid?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "satellite" */
export enum Satellite_Select_Column {
  /** column name */
  CurrentlyRegistered = 'currently_registered',
  /** column name */
  DelegationId = 'delegation_id',
  /** column name */
  Description = 'description',
  /** column name */
  Fee = 'fee',
  /** column name */
  FinancialRequestCounter = 'financial_request_counter',
  /** column name */
  GovernanceProposalCounter = 'governance_proposal_counter',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Name = 'name',
  /** column name */
  PeerId = 'peer_id',
  /** column name */
  PublicKey = 'public_key',
  /** column name */
  RegistrationTimestamp = 'registration_timestamp',
  /** column name */
  SatelliteActionCounter = 'satellite_action_counter',
  /** column name */
  Status = 'status',
  /** column name */
  TotalDelegatedAmount = 'total_delegated_amount',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Website = 'website'
}

/** select "satellite_aggregate_bool_exp_avg_arguments_columns" columns of table "satellite" */
export enum Satellite_Select_Column_Satellite_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  TotalDelegatedAmount = 'total_delegated_amount'
}

/** select "satellite_aggregate_bool_exp_bool_and_arguments_columns" columns of table "satellite" */
export enum Satellite_Select_Column_Satellite_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CurrentlyRegistered = 'currently_registered'
}

/** select "satellite_aggregate_bool_exp_bool_or_arguments_columns" columns of table "satellite" */
export enum Satellite_Select_Column_Satellite_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CurrentlyRegistered = 'currently_registered'
}

/** select "satellite_aggregate_bool_exp_corr_arguments_columns" columns of table "satellite" */
export enum Satellite_Select_Column_Satellite_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  TotalDelegatedAmount = 'total_delegated_amount'
}

/** select "satellite_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "satellite" */
export enum Satellite_Select_Column_Satellite_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  TotalDelegatedAmount = 'total_delegated_amount'
}

/** select "satellite_aggregate_bool_exp_max_arguments_columns" columns of table "satellite" */
export enum Satellite_Select_Column_Satellite_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  TotalDelegatedAmount = 'total_delegated_amount'
}

/** select "satellite_aggregate_bool_exp_min_arguments_columns" columns of table "satellite" */
export enum Satellite_Select_Column_Satellite_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  TotalDelegatedAmount = 'total_delegated_amount'
}

/** select "satellite_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "satellite" */
export enum Satellite_Select_Column_Satellite_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  TotalDelegatedAmount = 'total_delegated_amount'
}

/** select "satellite_aggregate_bool_exp_sum_arguments_columns" columns of table "satellite" */
export enum Satellite_Select_Column_Satellite_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  TotalDelegatedAmount = 'total_delegated_amount'
}

/** select "satellite_aggregate_bool_exp_var_samp_arguments_columns" columns of table "satellite" */
export enum Satellite_Select_Column_Satellite_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  TotalDelegatedAmount = 'total_delegated_amount'
}

/** aggregate stddev on columns */
export type Satellite_Stddev_Fields = {
  __typename?: 'satellite_stddev_fields';
  delegation_id?: Maybe<Scalars['Float']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  financial_request_counter?: Maybe<Scalars['Float']['output']>;
  governance_proposal_counter?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_action_counter?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nSUSPENDED: 1\nBANNED: 2 */
  status?: Maybe<Scalars['Float']['output']>;
  total_delegated_amount?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "satellite" */
export type Satellite_Stddev_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  fee?: InputMaybe<Order_By>;
  financial_request_counter?: InputMaybe<Order_By>;
  governance_proposal_counter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_action_counter?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nSUSPENDED: 1\nBANNED: 2 */
  status?: InputMaybe<Order_By>;
  total_delegated_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Satellite_Stddev_Pop_Fields = {
  __typename?: 'satellite_stddev_pop_fields';
  delegation_id?: Maybe<Scalars['Float']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  financial_request_counter?: Maybe<Scalars['Float']['output']>;
  governance_proposal_counter?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_action_counter?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nSUSPENDED: 1\nBANNED: 2 */
  status?: Maybe<Scalars['Float']['output']>;
  total_delegated_amount?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "satellite" */
export type Satellite_Stddev_Pop_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  fee?: InputMaybe<Order_By>;
  financial_request_counter?: InputMaybe<Order_By>;
  governance_proposal_counter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_action_counter?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nSUSPENDED: 1\nBANNED: 2 */
  status?: InputMaybe<Order_By>;
  total_delegated_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Satellite_Stddev_Samp_Fields = {
  __typename?: 'satellite_stddev_samp_fields';
  delegation_id?: Maybe<Scalars['Float']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  financial_request_counter?: Maybe<Scalars['Float']['output']>;
  governance_proposal_counter?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_action_counter?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nSUSPENDED: 1\nBANNED: 2 */
  status?: Maybe<Scalars['Float']['output']>;
  total_delegated_amount?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "satellite" */
export type Satellite_Stddev_Samp_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  fee?: InputMaybe<Order_By>;
  financial_request_counter?: InputMaybe<Order_By>;
  governance_proposal_counter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_action_counter?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nSUSPENDED: 1\nBANNED: 2 */
  status?: InputMaybe<Order_By>;
  total_delegated_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "satellite" */
export type Satellite_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Satellite_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Satellite_Stream_Cursor_Value_Input = {
  currently_registered?: InputMaybe<Scalars['Boolean']['input']>;
  delegation_id?: InputMaybe<Scalars['bigint']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['smallint']['input']>;
  financial_request_counter?: InputMaybe<Scalars['bigint']['input']>;
  governance_proposal_counter?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  peer_id?: InputMaybe<Scalars['String']['input']>;
  public_key?: InputMaybe<Scalars['String']['input']>;
  registration_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  satellite_action_counter?: InputMaybe<Scalars['bigint']['input']>;
  /** ACTIVE: 0\nSUSPENDED: 1\nBANNED: 2 */
  status?: InputMaybe<Scalars['smallint']['input']>;
  total_delegated_amount?: InputMaybe<Scalars['float8']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Satellite_Sum_Fields = {
  __typename?: 'satellite_sum_fields';
  delegation_id?: Maybe<Scalars['bigint']['output']>;
  fee?: Maybe<Scalars['smallint']['output']>;
  financial_request_counter?: Maybe<Scalars['bigint']['output']>;
  governance_proposal_counter?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  satellite_action_counter?: Maybe<Scalars['bigint']['output']>;
  /** ACTIVE: 0\nSUSPENDED: 1\nBANNED: 2 */
  status?: Maybe<Scalars['smallint']['output']>;
  total_delegated_amount?: Maybe<Scalars['float8']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "satellite" */
export type Satellite_Sum_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  fee?: InputMaybe<Order_By>;
  financial_request_counter?: InputMaybe<Order_By>;
  governance_proposal_counter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_action_counter?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nSUSPENDED: 1\nBANNED: 2 */
  status?: InputMaybe<Order_By>;
  total_delegated_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Satellite_Var_Pop_Fields = {
  __typename?: 'satellite_var_pop_fields';
  delegation_id?: Maybe<Scalars['Float']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  financial_request_counter?: Maybe<Scalars['Float']['output']>;
  governance_proposal_counter?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_action_counter?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nSUSPENDED: 1\nBANNED: 2 */
  status?: Maybe<Scalars['Float']['output']>;
  total_delegated_amount?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "satellite" */
export type Satellite_Var_Pop_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  fee?: InputMaybe<Order_By>;
  financial_request_counter?: InputMaybe<Order_By>;
  governance_proposal_counter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_action_counter?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nSUSPENDED: 1\nBANNED: 2 */
  status?: InputMaybe<Order_By>;
  total_delegated_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Satellite_Var_Samp_Fields = {
  __typename?: 'satellite_var_samp_fields';
  delegation_id?: Maybe<Scalars['Float']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  financial_request_counter?: Maybe<Scalars['Float']['output']>;
  governance_proposal_counter?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_action_counter?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nSUSPENDED: 1\nBANNED: 2 */
  status?: Maybe<Scalars['Float']['output']>;
  total_delegated_amount?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "satellite" */
export type Satellite_Var_Samp_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  fee?: InputMaybe<Order_By>;
  financial_request_counter?: InputMaybe<Order_By>;
  governance_proposal_counter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_action_counter?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nSUSPENDED: 1\nBANNED: 2 */
  status?: InputMaybe<Order_By>;
  total_delegated_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Satellite_Variance_Fields = {
  __typename?: 'satellite_variance_fields';
  delegation_id?: Maybe<Scalars['Float']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  financial_request_counter?: Maybe<Scalars['Float']['output']>;
  governance_proposal_counter?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  satellite_action_counter?: Maybe<Scalars['Float']['output']>;
  /** ACTIVE: 0\nSUSPENDED: 1\nBANNED: 2 */
  status?: Maybe<Scalars['Float']['output']>;
  total_delegated_amount?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "satellite" */
export type Satellite_Variance_Order_By = {
  delegation_id?: InputMaybe<Order_By>;
  fee?: InputMaybe<Order_By>;
  financial_request_counter?: InputMaybe<Order_By>;
  governance_proposal_counter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  satellite_action_counter?: InputMaybe<Order_By>;
  /** ACTIVE: 0\nSUSPENDED: 1\nBANNED: 2 */
  status?: InputMaybe<Order_By>;
  total_delegated_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['smallint']['input']>;
  _gt?: InputMaybe<Scalars['smallint']['input']>;
  _gte?: InputMaybe<Scalars['smallint']['input']>;
  _in?: InputMaybe<Array<Scalars['smallint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['smallint']['input']>;
  _lte?: InputMaybe<Scalars['smallint']['input']>;
  _neq?: InputMaybe<Scalars['smallint']['input']>;
  _nin?: InputMaybe<Array<Scalars['smallint']['input']>>;
};

/** columns and relationships of "smvn_history_data" */
export type Smvn_History_Data = {
  __typename?: 'smvn_history_data';
  avg_smvn_per_user: Scalars['float8']['output'];
  /** An object relationship */
  doorman: Doorman;
  doorman_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  level: Scalars['bigint']['output'];
  mvn_total_supply: Scalars['float8']['output'];
  smvn_total_supply: Scalars['float8']['output'];
  timestamp: Scalars['timestamptz']['output'];
};

/** aggregated selection of "smvn_history_data" */
export type Smvn_History_Data_Aggregate = {
  __typename?: 'smvn_history_data_aggregate';
  aggregate?: Maybe<Smvn_History_Data_Aggregate_Fields>;
  nodes: Array<Smvn_History_Data>;
};

export type Smvn_History_Data_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Smvn_History_Data_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Smvn_History_Data_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Smvn_History_Data_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Smvn_History_Data_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Smvn_History_Data_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Smvn_History_Data_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Smvn_History_Data_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Smvn_History_Data_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Smvn_History_Data_Aggregate_Bool_Exp_Var_Samp>;
};

export type Smvn_History_Data_Aggregate_Bool_Exp_Avg = {
  arguments: Smvn_History_Data_Select_Column_Smvn_History_Data_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Smvn_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Smvn_History_Data_Aggregate_Bool_Exp_Corr = {
  arguments: Smvn_History_Data_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Smvn_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Smvn_History_Data_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Smvn_History_Data_Select_Column_Smvn_History_Data_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Smvn_History_Data_Select_Column_Smvn_History_Data_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Smvn_History_Data_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Smvn_History_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Smvn_History_Data_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Smvn_History_Data_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Smvn_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Smvn_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Smvn_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Smvn_History_Data_Select_Column_Smvn_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Smvn_History_Data_Select_Column_Smvn_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Smvn_History_Data_Aggregate_Bool_Exp_Max = {
  arguments: Smvn_History_Data_Select_Column_Smvn_History_Data_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Smvn_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Smvn_History_Data_Aggregate_Bool_Exp_Min = {
  arguments: Smvn_History_Data_Select_Column_Smvn_History_Data_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Smvn_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Smvn_History_Data_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Smvn_History_Data_Select_Column_Smvn_History_Data_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Smvn_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Smvn_History_Data_Aggregate_Bool_Exp_Sum = {
  arguments: Smvn_History_Data_Select_Column_Smvn_History_Data_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Smvn_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Smvn_History_Data_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Smvn_History_Data_Select_Column_Smvn_History_Data_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Smvn_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "smvn_history_data" */
export type Smvn_History_Data_Aggregate_Fields = {
  __typename?: 'smvn_history_data_aggregate_fields';
  avg?: Maybe<Smvn_History_Data_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Smvn_History_Data_Max_Fields>;
  min?: Maybe<Smvn_History_Data_Min_Fields>;
  stddev?: Maybe<Smvn_History_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Smvn_History_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Smvn_History_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Smvn_History_Data_Sum_Fields>;
  var_pop?: Maybe<Smvn_History_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Smvn_History_Data_Var_Samp_Fields>;
  variance?: Maybe<Smvn_History_Data_Variance_Fields>;
};


/** aggregate fields of "smvn_history_data" */
export type Smvn_History_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Smvn_History_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "smvn_history_data" */
export type Smvn_History_Data_Aggregate_Order_By = {
  avg?: InputMaybe<Smvn_History_Data_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Smvn_History_Data_Max_Order_By>;
  min?: InputMaybe<Smvn_History_Data_Min_Order_By>;
  stddev?: InputMaybe<Smvn_History_Data_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Smvn_History_Data_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Smvn_History_Data_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Smvn_History_Data_Sum_Order_By>;
  var_pop?: InputMaybe<Smvn_History_Data_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Smvn_History_Data_Var_Samp_Order_By>;
  variance?: InputMaybe<Smvn_History_Data_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Smvn_History_Data_Avg_Fields = {
  __typename?: 'smvn_history_data_avg_fields';
  avg_smvn_per_user?: Maybe<Scalars['Float']['output']>;
  doorman_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  mvn_total_supply?: Maybe<Scalars['Float']['output']>;
  smvn_total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "smvn_history_data" */
export type Smvn_History_Data_Avg_Order_By = {
  avg_smvn_per_user?: InputMaybe<Order_By>;
  doorman_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  mvn_total_supply?: InputMaybe<Order_By>;
  smvn_total_supply?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "smvn_history_data". All fields are combined with a logical 'AND'. */
export type Smvn_History_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Smvn_History_Data_Bool_Exp>>;
  _not?: InputMaybe<Smvn_History_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Smvn_History_Data_Bool_Exp>>;
  avg_smvn_per_user?: InputMaybe<Float8_Comparison_Exp>;
  doorman?: InputMaybe<Doorman_Bool_Exp>;
  doorman_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  level?: InputMaybe<Bigint_Comparison_Exp>;
  mvn_total_supply?: InputMaybe<Float8_Comparison_Exp>;
  smvn_total_supply?: InputMaybe<Float8_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Smvn_History_Data_Max_Fields = {
  __typename?: 'smvn_history_data_max_fields';
  avg_smvn_per_user?: Maybe<Scalars['float8']['output']>;
  doorman_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  level?: Maybe<Scalars['bigint']['output']>;
  mvn_total_supply?: Maybe<Scalars['float8']['output']>;
  smvn_total_supply?: Maybe<Scalars['float8']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "smvn_history_data" */
export type Smvn_History_Data_Max_Order_By = {
  avg_smvn_per_user?: InputMaybe<Order_By>;
  doorman_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  mvn_total_supply?: InputMaybe<Order_By>;
  smvn_total_supply?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Smvn_History_Data_Min_Fields = {
  __typename?: 'smvn_history_data_min_fields';
  avg_smvn_per_user?: Maybe<Scalars['float8']['output']>;
  doorman_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  level?: Maybe<Scalars['bigint']['output']>;
  mvn_total_supply?: Maybe<Scalars['float8']['output']>;
  smvn_total_supply?: Maybe<Scalars['float8']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "smvn_history_data" */
export type Smvn_History_Data_Min_Order_By = {
  avg_smvn_per_user?: InputMaybe<Order_By>;
  doorman_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  mvn_total_supply?: InputMaybe<Order_By>;
  smvn_total_supply?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "smvn_history_data". */
export type Smvn_History_Data_Order_By = {
  avg_smvn_per_user?: InputMaybe<Order_By>;
  doorman?: InputMaybe<Doorman_Order_By>;
  doorman_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  mvn_total_supply?: InputMaybe<Order_By>;
  smvn_total_supply?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
};

/** select columns of table "smvn_history_data" */
export enum Smvn_History_Data_Select_Column {
  /** column name */
  AvgSmvnPerUser = 'avg_smvn_per_user',
  /** column name */
  DoormanId = 'doorman_id',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  MvnTotalSupply = 'mvn_total_supply',
  /** column name */
  SmvnTotalSupply = 'smvn_total_supply',
  /** column name */
  Timestamp = 'timestamp'
}

/** select "smvn_history_data_aggregate_bool_exp_avg_arguments_columns" columns of table "smvn_history_data" */
export enum Smvn_History_Data_Select_Column_Smvn_History_Data_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  AvgSmvnPerUser = 'avg_smvn_per_user',
  /** column name */
  MvnTotalSupply = 'mvn_total_supply',
  /** column name */
  SmvnTotalSupply = 'smvn_total_supply'
}

/** select "smvn_history_data_aggregate_bool_exp_corr_arguments_columns" columns of table "smvn_history_data" */
export enum Smvn_History_Data_Select_Column_Smvn_History_Data_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  AvgSmvnPerUser = 'avg_smvn_per_user',
  /** column name */
  MvnTotalSupply = 'mvn_total_supply',
  /** column name */
  SmvnTotalSupply = 'smvn_total_supply'
}

/** select "smvn_history_data_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "smvn_history_data" */
export enum Smvn_History_Data_Select_Column_Smvn_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  AvgSmvnPerUser = 'avg_smvn_per_user',
  /** column name */
  MvnTotalSupply = 'mvn_total_supply',
  /** column name */
  SmvnTotalSupply = 'smvn_total_supply'
}

/** select "smvn_history_data_aggregate_bool_exp_max_arguments_columns" columns of table "smvn_history_data" */
export enum Smvn_History_Data_Select_Column_Smvn_History_Data_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  AvgSmvnPerUser = 'avg_smvn_per_user',
  /** column name */
  MvnTotalSupply = 'mvn_total_supply',
  /** column name */
  SmvnTotalSupply = 'smvn_total_supply'
}

/** select "smvn_history_data_aggregate_bool_exp_min_arguments_columns" columns of table "smvn_history_data" */
export enum Smvn_History_Data_Select_Column_Smvn_History_Data_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  AvgSmvnPerUser = 'avg_smvn_per_user',
  /** column name */
  MvnTotalSupply = 'mvn_total_supply',
  /** column name */
  SmvnTotalSupply = 'smvn_total_supply'
}

/** select "smvn_history_data_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "smvn_history_data" */
export enum Smvn_History_Data_Select_Column_Smvn_History_Data_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  AvgSmvnPerUser = 'avg_smvn_per_user',
  /** column name */
  MvnTotalSupply = 'mvn_total_supply',
  /** column name */
  SmvnTotalSupply = 'smvn_total_supply'
}

/** select "smvn_history_data_aggregate_bool_exp_sum_arguments_columns" columns of table "smvn_history_data" */
export enum Smvn_History_Data_Select_Column_Smvn_History_Data_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  AvgSmvnPerUser = 'avg_smvn_per_user',
  /** column name */
  MvnTotalSupply = 'mvn_total_supply',
  /** column name */
  SmvnTotalSupply = 'smvn_total_supply'
}

/** select "smvn_history_data_aggregate_bool_exp_var_samp_arguments_columns" columns of table "smvn_history_data" */
export enum Smvn_History_Data_Select_Column_Smvn_History_Data_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  AvgSmvnPerUser = 'avg_smvn_per_user',
  /** column name */
  MvnTotalSupply = 'mvn_total_supply',
  /** column name */
  SmvnTotalSupply = 'smvn_total_supply'
}

/** aggregate stddev on columns */
export type Smvn_History_Data_Stddev_Fields = {
  __typename?: 'smvn_history_data_stddev_fields';
  avg_smvn_per_user?: Maybe<Scalars['Float']['output']>;
  doorman_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  mvn_total_supply?: Maybe<Scalars['Float']['output']>;
  smvn_total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "smvn_history_data" */
export type Smvn_History_Data_Stddev_Order_By = {
  avg_smvn_per_user?: InputMaybe<Order_By>;
  doorman_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  mvn_total_supply?: InputMaybe<Order_By>;
  smvn_total_supply?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Smvn_History_Data_Stddev_Pop_Fields = {
  __typename?: 'smvn_history_data_stddev_pop_fields';
  avg_smvn_per_user?: Maybe<Scalars['Float']['output']>;
  doorman_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  mvn_total_supply?: Maybe<Scalars['Float']['output']>;
  smvn_total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "smvn_history_data" */
export type Smvn_History_Data_Stddev_Pop_Order_By = {
  avg_smvn_per_user?: InputMaybe<Order_By>;
  doorman_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  mvn_total_supply?: InputMaybe<Order_By>;
  smvn_total_supply?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Smvn_History_Data_Stddev_Samp_Fields = {
  __typename?: 'smvn_history_data_stddev_samp_fields';
  avg_smvn_per_user?: Maybe<Scalars['Float']['output']>;
  doorman_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  mvn_total_supply?: Maybe<Scalars['Float']['output']>;
  smvn_total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "smvn_history_data" */
export type Smvn_History_Data_Stddev_Samp_Order_By = {
  avg_smvn_per_user?: InputMaybe<Order_By>;
  doorman_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  mvn_total_supply?: InputMaybe<Order_By>;
  smvn_total_supply?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "smvn_history_data" */
export type Smvn_History_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Smvn_History_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Smvn_History_Data_Stream_Cursor_Value_Input = {
  avg_smvn_per_user?: InputMaybe<Scalars['float8']['input']>;
  doorman_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  level?: InputMaybe<Scalars['bigint']['input']>;
  mvn_total_supply?: InputMaybe<Scalars['float8']['input']>;
  smvn_total_supply?: InputMaybe<Scalars['float8']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Smvn_History_Data_Sum_Fields = {
  __typename?: 'smvn_history_data_sum_fields';
  avg_smvn_per_user?: Maybe<Scalars['float8']['output']>;
  doorman_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  level?: Maybe<Scalars['bigint']['output']>;
  mvn_total_supply?: Maybe<Scalars['float8']['output']>;
  smvn_total_supply?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "smvn_history_data" */
export type Smvn_History_Data_Sum_Order_By = {
  avg_smvn_per_user?: InputMaybe<Order_By>;
  doorman_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  mvn_total_supply?: InputMaybe<Order_By>;
  smvn_total_supply?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Smvn_History_Data_Var_Pop_Fields = {
  __typename?: 'smvn_history_data_var_pop_fields';
  avg_smvn_per_user?: Maybe<Scalars['Float']['output']>;
  doorman_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  mvn_total_supply?: Maybe<Scalars['Float']['output']>;
  smvn_total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "smvn_history_data" */
export type Smvn_History_Data_Var_Pop_Order_By = {
  avg_smvn_per_user?: InputMaybe<Order_By>;
  doorman_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  mvn_total_supply?: InputMaybe<Order_By>;
  smvn_total_supply?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Smvn_History_Data_Var_Samp_Fields = {
  __typename?: 'smvn_history_data_var_samp_fields';
  avg_smvn_per_user?: Maybe<Scalars['Float']['output']>;
  doorman_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  mvn_total_supply?: Maybe<Scalars['Float']['output']>;
  smvn_total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "smvn_history_data" */
export type Smvn_History_Data_Var_Samp_Order_By = {
  avg_smvn_per_user?: InputMaybe<Order_By>;
  doorman_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  mvn_total_supply?: InputMaybe<Order_By>;
  smvn_total_supply?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Smvn_History_Data_Variance_Fields = {
  __typename?: 'smvn_history_data_variance_fields';
  avg_smvn_per_user?: Maybe<Scalars['Float']['output']>;
  doorman_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  mvn_total_supply?: Maybe<Scalars['Float']['output']>;
  smvn_total_supply?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "smvn_history_data" */
export type Smvn_History_Data_Variance_Order_By = {
  avg_smvn_per_user?: InputMaybe<Order_By>;
  doorman_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  mvn_total_supply?: InputMaybe<Order_By>;
  smvn_total_supply?: InputMaybe<Order_By>;
};

/** columns and relationships of "stake_history_data" */
export type Stake_History_Data = {
  __typename?: 'stake_history_data';
  desired_amount: Scalars['float8']['output'];
  /** An object relationship */
  doorman: Doorman;
  doorman_id: Scalars['bigint']['output'];
  final_amount: Scalars['float8']['output'];
  /** An object relationship */
  from_: Maven_User;
  from__id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  timestamp: Scalars['timestamptz']['output'];
  /** STAKE: 0\nUNSTAKE: 1\nFARM_CLAIM: 2\nCOMPOUND: 3\nSATELLITE_REWARD: 4\nVAULT_DEPOSIT_STAKED_TOKEN: 5\nVAULT_WITHDRAW_STAKED_TOKEN: 6\nVAULT_LIQUIDATE_STAKED_TOKEN: 7\nEXIT: 8 */
  type: Scalars['smallint']['output'];
};

/** aggregated selection of "stake_history_data" */
export type Stake_History_Data_Aggregate = {
  __typename?: 'stake_history_data_aggregate';
  aggregate?: Maybe<Stake_History_Data_Aggregate_Fields>;
  nodes: Array<Stake_History_Data>;
};

export type Stake_History_Data_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Stake_History_Data_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Stake_History_Data_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Stake_History_Data_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Stake_History_Data_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Stake_History_Data_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Stake_History_Data_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Stake_History_Data_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Stake_History_Data_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Stake_History_Data_Aggregate_Bool_Exp_Var_Samp>;
};

export type Stake_History_Data_Aggregate_Bool_Exp_Avg = {
  arguments: Stake_History_Data_Select_Column_Stake_History_Data_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Stake_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Stake_History_Data_Aggregate_Bool_Exp_Corr = {
  arguments: Stake_History_Data_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Stake_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Stake_History_Data_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Stake_History_Data_Select_Column_Stake_History_Data_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Stake_History_Data_Select_Column_Stake_History_Data_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Stake_History_Data_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Stake_History_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Stake_History_Data_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Stake_History_Data_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Stake_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Stake_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Stake_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Stake_History_Data_Select_Column_Stake_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Stake_History_Data_Select_Column_Stake_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Stake_History_Data_Aggregate_Bool_Exp_Max = {
  arguments: Stake_History_Data_Select_Column_Stake_History_Data_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Stake_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Stake_History_Data_Aggregate_Bool_Exp_Min = {
  arguments: Stake_History_Data_Select_Column_Stake_History_Data_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Stake_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Stake_History_Data_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Stake_History_Data_Select_Column_Stake_History_Data_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Stake_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Stake_History_Data_Aggregate_Bool_Exp_Sum = {
  arguments: Stake_History_Data_Select_Column_Stake_History_Data_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Stake_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Stake_History_Data_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Stake_History_Data_Select_Column_Stake_History_Data_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Stake_History_Data_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "stake_history_data" */
export type Stake_History_Data_Aggregate_Fields = {
  __typename?: 'stake_history_data_aggregate_fields';
  avg?: Maybe<Stake_History_Data_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Stake_History_Data_Max_Fields>;
  min?: Maybe<Stake_History_Data_Min_Fields>;
  stddev?: Maybe<Stake_History_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Stake_History_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Stake_History_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Stake_History_Data_Sum_Fields>;
  var_pop?: Maybe<Stake_History_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Stake_History_Data_Var_Samp_Fields>;
  variance?: Maybe<Stake_History_Data_Variance_Fields>;
};


/** aggregate fields of "stake_history_data" */
export type Stake_History_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Stake_History_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "stake_history_data" */
export type Stake_History_Data_Aggregate_Order_By = {
  avg?: InputMaybe<Stake_History_Data_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Stake_History_Data_Max_Order_By>;
  min?: InputMaybe<Stake_History_Data_Min_Order_By>;
  stddev?: InputMaybe<Stake_History_Data_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Stake_History_Data_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Stake_History_Data_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Stake_History_Data_Sum_Order_By>;
  var_pop?: InputMaybe<Stake_History_Data_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Stake_History_Data_Var_Samp_Order_By>;
  variance?: InputMaybe<Stake_History_Data_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Stake_History_Data_Avg_Fields = {
  __typename?: 'stake_history_data_avg_fields';
  desired_amount?: Maybe<Scalars['Float']['output']>;
  doorman_id?: Maybe<Scalars['Float']['output']>;
  final_amount?: Maybe<Scalars['Float']['output']>;
  from__id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** STAKE: 0\nUNSTAKE: 1\nFARM_CLAIM: 2\nCOMPOUND: 3\nSATELLITE_REWARD: 4\nVAULT_DEPOSIT_STAKED_TOKEN: 5\nVAULT_WITHDRAW_STAKED_TOKEN: 6\nVAULT_LIQUIDATE_STAKED_TOKEN: 7\nEXIT: 8 */
  type?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "stake_history_data" */
export type Stake_History_Data_Avg_Order_By = {
  desired_amount?: InputMaybe<Order_By>;
  doorman_id?: InputMaybe<Order_By>;
  final_amount?: InputMaybe<Order_By>;
  from__id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** STAKE: 0\nUNSTAKE: 1\nFARM_CLAIM: 2\nCOMPOUND: 3\nSATELLITE_REWARD: 4\nVAULT_DEPOSIT_STAKED_TOKEN: 5\nVAULT_WITHDRAW_STAKED_TOKEN: 6\nVAULT_LIQUIDATE_STAKED_TOKEN: 7\nEXIT: 8 */
  type?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "stake_history_data". All fields are combined with a logical 'AND'. */
export type Stake_History_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Stake_History_Data_Bool_Exp>>;
  _not?: InputMaybe<Stake_History_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Stake_History_Data_Bool_Exp>>;
  desired_amount?: InputMaybe<Float8_Comparison_Exp>;
  doorman?: InputMaybe<Doorman_Bool_Exp>;
  doorman_id?: InputMaybe<Bigint_Comparison_Exp>;
  final_amount?: InputMaybe<Float8_Comparison_Exp>;
  from_?: InputMaybe<Maven_User_Bool_Exp>;
  from__id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  type?: InputMaybe<Smallint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Stake_History_Data_Max_Fields = {
  __typename?: 'stake_history_data_max_fields';
  desired_amount?: Maybe<Scalars['float8']['output']>;
  doorman_id?: Maybe<Scalars['bigint']['output']>;
  final_amount?: Maybe<Scalars['float8']['output']>;
  from__id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  /** STAKE: 0\nUNSTAKE: 1\nFARM_CLAIM: 2\nCOMPOUND: 3\nSATELLITE_REWARD: 4\nVAULT_DEPOSIT_STAKED_TOKEN: 5\nVAULT_WITHDRAW_STAKED_TOKEN: 6\nVAULT_LIQUIDATE_STAKED_TOKEN: 7\nEXIT: 8 */
  type?: Maybe<Scalars['smallint']['output']>;
};

/** order by max() on columns of table "stake_history_data" */
export type Stake_History_Data_Max_Order_By = {
  desired_amount?: InputMaybe<Order_By>;
  doorman_id?: InputMaybe<Order_By>;
  final_amount?: InputMaybe<Order_By>;
  from__id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  /** STAKE: 0\nUNSTAKE: 1\nFARM_CLAIM: 2\nCOMPOUND: 3\nSATELLITE_REWARD: 4\nVAULT_DEPOSIT_STAKED_TOKEN: 5\nVAULT_WITHDRAW_STAKED_TOKEN: 6\nVAULT_LIQUIDATE_STAKED_TOKEN: 7\nEXIT: 8 */
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Stake_History_Data_Min_Fields = {
  __typename?: 'stake_history_data_min_fields';
  desired_amount?: Maybe<Scalars['float8']['output']>;
  doorman_id?: Maybe<Scalars['bigint']['output']>;
  final_amount?: Maybe<Scalars['float8']['output']>;
  from__id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  /** STAKE: 0\nUNSTAKE: 1\nFARM_CLAIM: 2\nCOMPOUND: 3\nSATELLITE_REWARD: 4\nVAULT_DEPOSIT_STAKED_TOKEN: 5\nVAULT_WITHDRAW_STAKED_TOKEN: 6\nVAULT_LIQUIDATE_STAKED_TOKEN: 7\nEXIT: 8 */
  type?: Maybe<Scalars['smallint']['output']>;
};

/** order by min() on columns of table "stake_history_data" */
export type Stake_History_Data_Min_Order_By = {
  desired_amount?: InputMaybe<Order_By>;
  doorman_id?: InputMaybe<Order_By>;
  final_amount?: InputMaybe<Order_By>;
  from__id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  /** STAKE: 0\nUNSTAKE: 1\nFARM_CLAIM: 2\nCOMPOUND: 3\nSATELLITE_REWARD: 4\nVAULT_DEPOSIT_STAKED_TOKEN: 5\nVAULT_WITHDRAW_STAKED_TOKEN: 6\nVAULT_LIQUIDATE_STAKED_TOKEN: 7\nEXIT: 8 */
  type?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "stake_history_data". */
export type Stake_History_Data_Order_By = {
  desired_amount?: InputMaybe<Order_By>;
  doorman?: InputMaybe<Doorman_Order_By>;
  doorman_id?: InputMaybe<Order_By>;
  final_amount?: InputMaybe<Order_By>;
  from_?: InputMaybe<Maven_User_Order_By>;
  from__id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "stake_history_data" */
export enum Stake_History_Data_Select_Column {
  /** column name */
  DesiredAmount = 'desired_amount',
  /** column name */
  DoormanId = 'doorman_id',
  /** column name */
  FinalAmount = 'final_amount',
  /** column name */
  FromId = 'from__id',
  /** column name */
  Id = 'id',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Type = 'type'
}

/** select "stake_history_data_aggregate_bool_exp_avg_arguments_columns" columns of table "stake_history_data" */
export enum Stake_History_Data_Select_Column_Stake_History_Data_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  DesiredAmount = 'desired_amount',
  /** column name */
  FinalAmount = 'final_amount'
}

/** select "stake_history_data_aggregate_bool_exp_corr_arguments_columns" columns of table "stake_history_data" */
export enum Stake_History_Data_Select_Column_Stake_History_Data_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  DesiredAmount = 'desired_amount',
  /** column name */
  FinalAmount = 'final_amount'
}

/** select "stake_history_data_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "stake_history_data" */
export enum Stake_History_Data_Select_Column_Stake_History_Data_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  DesiredAmount = 'desired_amount',
  /** column name */
  FinalAmount = 'final_amount'
}

/** select "stake_history_data_aggregate_bool_exp_max_arguments_columns" columns of table "stake_history_data" */
export enum Stake_History_Data_Select_Column_Stake_History_Data_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  DesiredAmount = 'desired_amount',
  /** column name */
  FinalAmount = 'final_amount'
}

/** select "stake_history_data_aggregate_bool_exp_min_arguments_columns" columns of table "stake_history_data" */
export enum Stake_History_Data_Select_Column_Stake_History_Data_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  DesiredAmount = 'desired_amount',
  /** column name */
  FinalAmount = 'final_amount'
}

/** select "stake_history_data_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "stake_history_data" */
export enum Stake_History_Data_Select_Column_Stake_History_Data_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  DesiredAmount = 'desired_amount',
  /** column name */
  FinalAmount = 'final_amount'
}

/** select "stake_history_data_aggregate_bool_exp_sum_arguments_columns" columns of table "stake_history_data" */
export enum Stake_History_Data_Select_Column_Stake_History_Data_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  DesiredAmount = 'desired_amount',
  /** column name */
  FinalAmount = 'final_amount'
}

/** select "stake_history_data_aggregate_bool_exp_var_samp_arguments_columns" columns of table "stake_history_data" */
export enum Stake_History_Data_Select_Column_Stake_History_Data_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  DesiredAmount = 'desired_amount',
  /** column name */
  FinalAmount = 'final_amount'
}

/** aggregate stddev on columns */
export type Stake_History_Data_Stddev_Fields = {
  __typename?: 'stake_history_data_stddev_fields';
  desired_amount?: Maybe<Scalars['Float']['output']>;
  doorman_id?: Maybe<Scalars['Float']['output']>;
  final_amount?: Maybe<Scalars['Float']['output']>;
  from__id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** STAKE: 0\nUNSTAKE: 1\nFARM_CLAIM: 2\nCOMPOUND: 3\nSATELLITE_REWARD: 4\nVAULT_DEPOSIT_STAKED_TOKEN: 5\nVAULT_WITHDRAW_STAKED_TOKEN: 6\nVAULT_LIQUIDATE_STAKED_TOKEN: 7\nEXIT: 8 */
  type?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "stake_history_data" */
export type Stake_History_Data_Stddev_Order_By = {
  desired_amount?: InputMaybe<Order_By>;
  doorman_id?: InputMaybe<Order_By>;
  final_amount?: InputMaybe<Order_By>;
  from__id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** STAKE: 0\nUNSTAKE: 1\nFARM_CLAIM: 2\nCOMPOUND: 3\nSATELLITE_REWARD: 4\nVAULT_DEPOSIT_STAKED_TOKEN: 5\nVAULT_WITHDRAW_STAKED_TOKEN: 6\nVAULT_LIQUIDATE_STAKED_TOKEN: 7\nEXIT: 8 */
  type?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Stake_History_Data_Stddev_Pop_Fields = {
  __typename?: 'stake_history_data_stddev_pop_fields';
  desired_amount?: Maybe<Scalars['Float']['output']>;
  doorman_id?: Maybe<Scalars['Float']['output']>;
  final_amount?: Maybe<Scalars['Float']['output']>;
  from__id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** STAKE: 0\nUNSTAKE: 1\nFARM_CLAIM: 2\nCOMPOUND: 3\nSATELLITE_REWARD: 4\nVAULT_DEPOSIT_STAKED_TOKEN: 5\nVAULT_WITHDRAW_STAKED_TOKEN: 6\nVAULT_LIQUIDATE_STAKED_TOKEN: 7\nEXIT: 8 */
  type?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "stake_history_data" */
export type Stake_History_Data_Stddev_Pop_Order_By = {
  desired_amount?: InputMaybe<Order_By>;
  doorman_id?: InputMaybe<Order_By>;
  final_amount?: InputMaybe<Order_By>;
  from__id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** STAKE: 0\nUNSTAKE: 1\nFARM_CLAIM: 2\nCOMPOUND: 3\nSATELLITE_REWARD: 4\nVAULT_DEPOSIT_STAKED_TOKEN: 5\nVAULT_WITHDRAW_STAKED_TOKEN: 6\nVAULT_LIQUIDATE_STAKED_TOKEN: 7\nEXIT: 8 */
  type?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Stake_History_Data_Stddev_Samp_Fields = {
  __typename?: 'stake_history_data_stddev_samp_fields';
  desired_amount?: Maybe<Scalars['Float']['output']>;
  doorman_id?: Maybe<Scalars['Float']['output']>;
  final_amount?: Maybe<Scalars['Float']['output']>;
  from__id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** STAKE: 0\nUNSTAKE: 1\nFARM_CLAIM: 2\nCOMPOUND: 3\nSATELLITE_REWARD: 4\nVAULT_DEPOSIT_STAKED_TOKEN: 5\nVAULT_WITHDRAW_STAKED_TOKEN: 6\nVAULT_LIQUIDATE_STAKED_TOKEN: 7\nEXIT: 8 */
  type?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "stake_history_data" */
export type Stake_History_Data_Stddev_Samp_Order_By = {
  desired_amount?: InputMaybe<Order_By>;
  doorman_id?: InputMaybe<Order_By>;
  final_amount?: InputMaybe<Order_By>;
  from__id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** STAKE: 0\nUNSTAKE: 1\nFARM_CLAIM: 2\nCOMPOUND: 3\nSATELLITE_REWARD: 4\nVAULT_DEPOSIT_STAKED_TOKEN: 5\nVAULT_WITHDRAW_STAKED_TOKEN: 6\nVAULT_LIQUIDATE_STAKED_TOKEN: 7\nEXIT: 8 */
  type?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "stake_history_data" */
export type Stake_History_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Stake_History_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Stake_History_Data_Stream_Cursor_Value_Input = {
  desired_amount?: InputMaybe<Scalars['float8']['input']>;
  doorman_id?: InputMaybe<Scalars['bigint']['input']>;
  final_amount?: InputMaybe<Scalars['float8']['input']>;
  from__id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  /** STAKE: 0\nUNSTAKE: 1\nFARM_CLAIM: 2\nCOMPOUND: 3\nSATELLITE_REWARD: 4\nVAULT_DEPOSIT_STAKED_TOKEN: 5\nVAULT_WITHDRAW_STAKED_TOKEN: 6\nVAULT_LIQUIDATE_STAKED_TOKEN: 7\nEXIT: 8 */
  type?: InputMaybe<Scalars['smallint']['input']>;
};

/** aggregate sum on columns */
export type Stake_History_Data_Sum_Fields = {
  __typename?: 'stake_history_data_sum_fields';
  desired_amount?: Maybe<Scalars['float8']['output']>;
  doorman_id?: Maybe<Scalars['bigint']['output']>;
  final_amount?: Maybe<Scalars['float8']['output']>;
  from__id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  /** STAKE: 0\nUNSTAKE: 1\nFARM_CLAIM: 2\nCOMPOUND: 3\nSATELLITE_REWARD: 4\nVAULT_DEPOSIT_STAKED_TOKEN: 5\nVAULT_WITHDRAW_STAKED_TOKEN: 6\nVAULT_LIQUIDATE_STAKED_TOKEN: 7\nEXIT: 8 */
  type?: Maybe<Scalars['smallint']['output']>;
};

/** order by sum() on columns of table "stake_history_data" */
export type Stake_History_Data_Sum_Order_By = {
  desired_amount?: InputMaybe<Order_By>;
  doorman_id?: InputMaybe<Order_By>;
  final_amount?: InputMaybe<Order_By>;
  from__id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** STAKE: 0\nUNSTAKE: 1\nFARM_CLAIM: 2\nCOMPOUND: 3\nSATELLITE_REWARD: 4\nVAULT_DEPOSIT_STAKED_TOKEN: 5\nVAULT_WITHDRAW_STAKED_TOKEN: 6\nVAULT_LIQUIDATE_STAKED_TOKEN: 7\nEXIT: 8 */
  type?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Stake_History_Data_Var_Pop_Fields = {
  __typename?: 'stake_history_data_var_pop_fields';
  desired_amount?: Maybe<Scalars['Float']['output']>;
  doorman_id?: Maybe<Scalars['Float']['output']>;
  final_amount?: Maybe<Scalars['Float']['output']>;
  from__id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** STAKE: 0\nUNSTAKE: 1\nFARM_CLAIM: 2\nCOMPOUND: 3\nSATELLITE_REWARD: 4\nVAULT_DEPOSIT_STAKED_TOKEN: 5\nVAULT_WITHDRAW_STAKED_TOKEN: 6\nVAULT_LIQUIDATE_STAKED_TOKEN: 7\nEXIT: 8 */
  type?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "stake_history_data" */
export type Stake_History_Data_Var_Pop_Order_By = {
  desired_amount?: InputMaybe<Order_By>;
  doorman_id?: InputMaybe<Order_By>;
  final_amount?: InputMaybe<Order_By>;
  from__id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** STAKE: 0\nUNSTAKE: 1\nFARM_CLAIM: 2\nCOMPOUND: 3\nSATELLITE_REWARD: 4\nVAULT_DEPOSIT_STAKED_TOKEN: 5\nVAULT_WITHDRAW_STAKED_TOKEN: 6\nVAULT_LIQUIDATE_STAKED_TOKEN: 7\nEXIT: 8 */
  type?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Stake_History_Data_Var_Samp_Fields = {
  __typename?: 'stake_history_data_var_samp_fields';
  desired_amount?: Maybe<Scalars['Float']['output']>;
  doorman_id?: Maybe<Scalars['Float']['output']>;
  final_amount?: Maybe<Scalars['Float']['output']>;
  from__id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** STAKE: 0\nUNSTAKE: 1\nFARM_CLAIM: 2\nCOMPOUND: 3\nSATELLITE_REWARD: 4\nVAULT_DEPOSIT_STAKED_TOKEN: 5\nVAULT_WITHDRAW_STAKED_TOKEN: 6\nVAULT_LIQUIDATE_STAKED_TOKEN: 7\nEXIT: 8 */
  type?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "stake_history_data" */
export type Stake_History_Data_Var_Samp_Order_By = {
  desired_amount?: InputMaybe<Order_By>;
  doorman_id?: InputMaybe<Order_By>;
  final_amount?: InputMaybe<Order_By>;
  from__id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** STAKE: 0\nUNSTAKE: 1\nFARM_CLAIM: 2\nCOMPOUND: 3\nSATELLITE_REWARD: 4\nVAULT_DEPOSIT_STAKED_TOKEN: 5\nVAULT_WITHDRAW_STAKED_TOKEN: 6\nVAULT_LIQUIDATE_STAKED_TOKEN: 7\nEXIT: 8 */
  type?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Stake_History_Data_Variance_Fields = {
  __typename?: 'stake_history_data_variance_fields';
  desired_amount?: Maybe<Scalars['Float']['output']>;
  doorman_id?: Maybe<Scalars['Float']['output']>;
  final_amount?: Maybe<Scalars['Float']['output']>;
  from__id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** STAKE: 0\nUNSTAKE: 1\nFARM_CLAIM: 2\nCOMPOUND: 3\nSATELLITE_REWARD: 4\nVAULT_DEPOSIT_STAKED_TOKEN: 5\nVAULT_WITHDRAW_STAKED_TOKEN: 6\nVAULT_LIQUIDATE_STAKED_TOKEN: 7\nEXIT: 8 */
  type?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "stake_history_data" */
export type Stake_History_Data_Variance_Order_By = {
  desired_amount?: InputMaybe<Order_By>;
  doorman_id?: InputMaybe<Order_By>;
  final_amount?: InputMaybe<Order_By>;
  from__id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** STAKE: 0\nUNSTAKE: 1\nFARM_CLAIM: 2\nCOMPOUND: 3\nSATELLITE_REWARD: 4\nVAULT_DEPOSIT_STAKED_TOKEN: 5\nVAULT_WITHDRAW_STAKED_TOKEN: 6\nVAULT_LIQUIDATE_STAKED_TOKEN: 7\nEXIT: 8 */
  type?: InputMaybe<Order_By>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "aggregator" */
  aggregator: Array<Aggregator>;
  /** fetch aggregated fields from the table: "aggregator" */
  aggregator_aggregate: Aggregator_Aggregate;
  /** fetch data from the table: "aggregator" using primary key columns */
  aggregator_by_pk?: Maybe<Aggregator>;
  /** fetch data from the table: "aggregator_factory" */
  aggregator_factory: Array<Aggregator_Factory>;
  /** fetch aggregated fields from the table: "aggregator_factory" */
  aggregator_factory_aggregate: Aggregator_Factory_Aggregate;
  /** fetch data from the table: "aggregator_factory_aggregator_lambda" */
  aggregator_factory_aggregator_lambda: Array<Aggregator_Factory_Aggregator_Lambda>;
  /** fetch aggregated fields from the table: "aggregator_factory_aggregator_lambda" */
  aggregator_factory_aggregator_lambda_aggregate: Aggregator_Factory_Aggregator_Lambda_Aggregate;
  /** fetch data from the table: "aggregator_factory_aggregator_lambda" using primary key columns */
  aggregator_factory_aggregator_lambda_by_pk?: Maybe<Aggregator_Factory_Aggregator_Lambda>;
  /** fetch data from the table in a streaming manner: "aggregator_factory_aggregator_lambda" */
  aggregator_factory_aggregator_lambda_stream: Array<Aggregator_Factory_Aggregator_Lambda>;
  /** fetch data from the table: "aggregator_factory" using primary key columns */
  aggregator_factory_by_pk?: Maybe<Aggregator_Factory>;
  /** fetch data from the table: "aggregator_factory_general_contract" */
  aggregator_factory_general_contract: Array<Aggregator_Factory_General_Contract>;
  /** fetch aggregated fields from the table: "aggregator_factory_general_contract" */
  aggregator_factory_general_contract_aggregate: Aggregator_Factory_General_Contract_Aggregate;
  /** fetch data from the table: "aggregator_factory_general_contract" using primary key columns */
  aggregator_factory_general_contract_by_pk?: Maybe<Aggregator_Factory_General_Contract>;
  /** fetch data from the table in a streaming manner: "aggregator_factory_general_contract" */
  aggregator_factory_general_contract_stream: Array<Aggregator_Factory_General_Contract>;
  /** fetch data from the table: "aggregator_factory_lambda" */
  aggregator_factory_lambda: Array<Aggregator_Factory_Lambda>;
  /** fetch aggregated fields from the table: "aggregator_factory_lambda" */
  aggregator_factory_lambda_aggregate: Aggregator_Factory_Lambda_Aggregate;
  /** fetch data from the table: "aggregator_factory_lambda" using primary key columns */
  aggregator_factory_lambda_by_pk?: Maybe<Aggregator_Factory_Lambda>;
  /** fetch data from the table in a streaming manner: "aggregator_factory_lambda" */
  aggregator_factory_lambda_stream: Array<Aggregator_Factory_Lambda>;
  /** fetch data from the table in a streaming manner: "aggregator_factory" */
  aggregator_factory_stream: Array<Aggregator_Factory>;
  /** fetch data from the table: "aggregator_factory_whitelist_contract" */
  aggregator_factory_whitelist_contract: Array<Aggregator_Factory_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "aggregator_factory_whitelist_contract" */
  aggregator_factory_whitelist_contract_aggregate: Aggregator_Factory_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "aggregator_factory_whitelist_contract" using primary key columns */
  aggregator_factory_whitelist_contract_by_pk?: Maybe<Aggregator_Factory_Whitelist_Contract>;
  /** fetch data from the table in a streaming manner: "aggregator_factory_whitelist_contract" */
  aggregator_factory_whitelist_contract_stream: Array<Aggregator_Factory_Whitelist_Contract>;
  /** fetch data from the table: "aggregator_general_contract" */
  aggregator_general_contract: Array<Aggregator_General_Contract>;
  /** fetch aggregated fields from the table: "aggregator_general_contract" */
  aggregator_general_contract_aggregate: Aggregator_General_Contract_Aggregate;
  /** fetch data from the table: "aggregator_general_contract" using primary key columns */
  aggregator_general_contract_by_pk?: Maybe<Aggregator_General_Contract>;
  /** fetch data from the table in a streaming manner: "aggregator_general_contract" */
  aggregator_general_contract_stream: Array<Aggregator_General_Contract>;
  /** fetch data from the table: "aggregator_history_data" */
  aggregator_history_data: Array<Aggregator_History_Data>;
  /** fetch aggregated fields from the table: "aggregator_history_data" */
  aggregator_history_data_aggregate: Aggregator_History_Data_Aggregate;
  /** fetch data from the table: "aggregator_history_data" using primary key columns */
  aggregator_history_data_by_pk?: Maybe<Aggregator_History_Data>;
  /** fetch data from the table in a streaming manner: "aggregator_history_data" */
  aggregator_history_data_stream: Array<Aggregator_History_Data>;
  /** fetch data from the table: "aggregator_lambda" */
  aggregator_lambda: Array<Aggregator_Lambda>;
  /** fetch aggregated fields from the table: "aggregator_lambda" */
  aggregator_lambda_aggregate: Aggregator_Lambda_Aggregate;
  /** fetch data from the table: "aggregator_lambda" using primary key columns */
  aggregator_lambda_by_pk?: Maybe<Aggregator_Lambda>;
  /** fetch data from the table in a streaming manner: "aggregator_lambda" */
  aggregator_lambda_stream: Array<Aggregator_Lambda>;
  /** fetch data from the table: "aggregator_oracle" */
  aggregator_oracle: Array<Aggregator_Oracle>;
  /** fetch aggregated fields from the table: "aggregator_oracle" */
  aggregator_oracle_aggregate: Aggregator_Oracle_Aggregate;
  /** fetch data from the table: "aggregator_oracle" using primary key columns */
  aggregator_oracle_by_pk?: Maybe<Aggregator_Oracle>;
  /** fetch data from the table: "aggregator_oracle_observation" */
  aggregator_oracle_observation: Array<Aggregator_Oracle_Observation>;
  /** fetch aggregated fields from the table: "aggregator_oracle_observation" */
  aggregator_oracle_observation_aggregate: Aggregator_Oracle_Observation_Aggregate;
  /** fetch data from the table: "aggregator_oracle_observation" using primary key columns */
  aggregator_oracle_observation_by_pk?: Maybe<Aggregator_Oracle_Observation>;
  /** fetch data from the table in a streaming manner: "aggregator_oracle_observation" */
  aggregator_oracle_observation_stream: Array<Aggregator_Oracle_Observation>;
  /** fetch data from the table: "aggregator_oracle_reward" */
  aggregator_oracle_reward: Array<Aggregator_Oracle_Reward>;
  /** fetch aggregated fields from the table: "aggregator_oracle_reward" */
  aggregator_oracle_reward_aggregate: Aggregator_Oracle_Reward_Aggregate;
  /** fetch data from the table: "aggregator_oracle_reward" using primary key columns */
  aggregator_oracle_reward_by_pk?: Maybe<Aggregator_Oracle_Reward>;
  /** fetch data from the table in a streaming manner: "aggregator_oracle_reward" */
  aggregator_oracle_reward_stream: Array<Aggregator_Oracle_Reward>;
  /** fetch data from the table in a streaming manner: "aggregator_oracle" */
  aggregator_oracle_stream: Array<Aggregator_Oracle>;
  /** fetch data from the table in a streaming manner: "aggregator" */
  aggregator_stream: Array<Aggregator>;
  /** fetch data from the table: "aggregator_whitelist_contract" */
  aggregator_whitelist_contract: Array<Aggregator_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "aggregator_whitelist_contract" */
  aggregator_whitelist_contract_aggregate: Aggregator_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "aggregator_whitelist_contract" using primary key columns */
  aggregator_whitelist_contract_by_pk?: Maybe<Aggregator_Whitelist_Contract>;
  /** fetch data from the table in a streaming manner: "aggregator_whitelist_contract" */
  aggregator_whitelist_contract_stream: Array<Aggregator_Whitelist_Contract>;
  /** fetch data from the table: "break_glass" */
  break_glass: Array<Break_Glass>;
  /** fetch data from the table: "break_glass_action" */
  break_glass_action: Array<Break_Glass_Action>;
  /** fetch aggregated fields from the table: "break_glass_action" */
  break_glass_action_aggregate: Break_Glass_Action_Aggregate;
  /** fetch data from the table: "break_glass_action" using primary key columns */
  break_glass_action_by_pk?: Maybe<Break_Glass_Action>;
  /** fetch data from the table: "break_glass_action_parameter" */
  break_glass_action_parameter: Array<Break_Glass_Action_Parameter>;
  /** fetch aggregated fields from the table: "break_glass_action_parameter" */
  break_glass_action_parameter_aggregate: Break_Glass_Action_Parameter_Aggregate;
  /** fetch data from the table: "break_glass_action_parameter" using primary key columns */
  break_glass_action_parameter_by_pk?: Maybe<Break_Glass_Action_Parameter>;
  /** fetch data from the table in a streaming manner: "break_glass_action_parameter" */
  break_glass_action_parameter_stream: Array<Break_Glass_Action_Parameter>;
  /** fetch data from the table: "break_glass_action_signer" */
  break_glass_action_signer: Array<Break_Glass_Action_Signer>;
  /** fetch aggregated fields from the table: "break_glass_action_signer" */
  break_glass_action_signer_aggregate: Break_Glass_Action_Signer_Aggregate;
  /** fetch data from the table: "break_glass_action_signer" using primary key columns */
  break_glass_action_signer_by_pk?: Maybe<Break_Glass_Action_Signer>;
  /** fetch data from the table in a streaming manner: "break_glass_action_signer" */
  break_glass_action_signer_stream: Array<Break_Glass_Action_Signer>;
  /** fetch data from the table in a streaming manner: "break_glass_action" */
  break_glass_action_stream: Array<Break_Glass_Action>;
  /** fetch data from the table: "break_glass_action_temp_parameter" */
  break_glass_action_temp_parameter: Array<Break_Glass_Action_Temp_Parameter>;
  /** fetch aggregated fields from the table: "break_glass_action_temp_parameter" */
  break_glass_action_temp_parameter_aggregate: Break_Glass_Action_Temp_Parameter_Aggregate;
  /** fetch data from the table: "break_glass_action_temp_parameter" using primary key columns */
  break_glass_action_temp_parameter_by_pk?: Maybe<Break_Glass_Action_Temp_Parameter>;
  /** fetch data from the table in a streaming manner: "break_glass_action_temp_parameter" */
  break_glass_action_temp_parameter_stream: Array<Break_Glass_Action_Temp_Parameter>;
  /** fetch aggregated fields from the table: "break_glass" */
  break_glass_aggregate: Break_Glass_Aggregate;
  /** fetch data from the table: "break_glass" using primary key columns */
  break_glass_by_pk?: Maybe<Break_Glass>;
  /** fetch data from the table: "break_glass_council_member" */
  break_glass_council_member: Array<Break_Glass_Council_Member>;
  /** fetch aggregated fields from the table: "break_glass_council_member" */
  break_glass_council_member_aggregate: Break_Glass_Council_Member_Aggregate;
  /** fetch data from the table: "break_glass_council_member" using primary key columns */
  break_glass_council_member_by_pk?: Maybe<Break_Glass_Council_Member>;
  /** fetch data from the table in a streaming manner: "break_glass_council_member" */
  break_glass_council_member_stream: Array<Break_Glass_Council_Member>;
  /** fetch data from the table: "break_glass_general_contract" */
  break_glass_general_contract: Array<Break_Glass_General_Contract>;
  /** fetch aggregated fields from the table: "break_glass_general_contract" */
  break_glass_general_contract_aggregate: Break_Glass_General_Contract_Aggregate;
  /** fetch data from the table: "break_glass_general_contract" using primary key columns */
  break_glass_general_contract_by_pk?: Maybe<Break_Glass_General_Contract>;
  /** fetch data from the table in a streaming manner: "break_glass_general_contract" */
  break_glass_general_contract_stream: Array<Break_Glass_General_Contract>;
  /** fetch data from the table: "break_glass_lambda" */
  break_glass_lambda: Array<Break_Glass_Lambda>;
  /** fetch aggregated fields from the table: "break_glass_lambda" */
  break_glass_lambda_aggregate: Break_Glass_Lambda_Aggregate;
  /** fetch data from the table: "break_glass_lambda" using primary key columns */
  break_glass_lambda_by_pk?: Maybe<Break_Glass_Lambda>;
  /** fetch data from the table in a streaming manner: "break_glass_lambda" */
  break_glass_lambda_stream: Array<Break_Glass_Lambda>;
  /** fetch data from the table in a streaming manner: "break_glass" */
  break_glass_stream: Array<Break_Glass>;
  /** fetch data from the table: "break_glass_whitelist_contract" */
  break_glass_whitelist_contract: Array<Break_Glass_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "break_glass_whitelist_contract" */
  break_glass_whitelist_contract_aggregate: Break_Glass_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "break_glass_whitelist_contract" using primary key columns */
  break_glass_whitelist_contract_by_pk?: Maybe<Break_Glass_Whitelist_Contract>;
  /** fetch data from the table in a streaming manner: "break_glass_whitelist_contract" */
  break_glass_whitelist_contract_stream: Array<Break_Glass_Whitelist_Contract>;
  /** fetch data from the table: "council" */
  council: Array<Council>;
  /** fetch data from the table: "council_action" */
  council_action: Array<Council_Action>;
  /** fetch aggregated fields from the table: "council_action" */
  council_action_aggregate: Council_Action_Aggregate;
  /** fetch data from the table: "council_action" using primary key columns */
  council_action_by_pk?: Maybe<Council_Action>;
  /** fetch data from the table: "council_action_parameter" */
  council_action_parameter: Array<Council_Action_Parameter>;
  /** fetch aggregated fields from the table: "council_action_parameter" */
  council_action_parameter_aggregate: Council_Action_Parameter_Aggregate;
  /** fetch data from the table: "council_action_parameter" using primary key columns */
  council_action_parameter_by_pk?: Maybe<Council_Action_Parameter>;
  /** fetch data from the table in a streaming manner: "council_action_parameter" */
  council_action_parameter_stream: Array<Council_Action_Parameter>;
  /** fetch data from the table: "council_action_signer" */
  council_action_signer: Array<Council_Action_Signer>;
  /** fetch aggregated fields from the table: "council_action_signer" */
  council_action_signer_aggregate: Council_Action_Signer_Aggregate;
  /** fetch data from the table: "council_action_signer" using primary key columns */
  council_action_signer_by_pk?: Maybe<Council_Action_Signer>;
  /** fetch data from the table in a streaming manner: "council_action_signer" */
  council_action_signer_stream: Array<Council_Action_Signer>;
  /** fetch data from the table in a streaming manner: "council_action" */
  council_action_stream: Array<Council_Action>;
  /** fetch data from the table: "council_action_temp_parameter" */
  council_action_temp_parameter: Array<Council_Action_Temp_Parameter>;
  /** fetch aggregated fields from the table: "council_action_temp_parameter" */
  council_action_temp_parameter_aggregate: Council_Action_Temp_Parameter_Aggregate;
  /** fetch data from the table: "council_action_temp_parameter" using primary key columns */
  council_action_temp_parameter_by_pk?: Maybe<Council_Action_Temp_Parameter>;
  /** fetch data from the table in a streaming manner: "council_action_temp_parameter" */
  council_action_temp_parameter_stream: Array<Council_Action_Temp_Parameter>;
  /** fetch aggregated fields from the table: "council" */
  council_aggregate: Council_Aggregate;
  /** fetch data from the table: "council" using primary key columns */
  council_by_pk?: Maybe<Council>;
  /** fetch data from the table: "council_council_member" */
  council_council_member: Array<Council_Council_Member>;
  /** fetch aggregated fields from the table: "council_council_member" */
  council_council_member_aggregate: Council_Council_Member_Aggregate;
  /** fetch data from the table: "council_council_member" using primary key columns */
  council_council_member_by_pk?: Maybe<Council_Council_Member>;
  /** fetch data from the table in a streaming manner: "council_council_member" */
  council_council_member_stream: Array<Council_Council_Member>;
  /** fetch data from the table: "council_general_contract" */
  council_general_contract: Array<Council_General_Contract>;
  /** fetch aggregated fields from the table: "council_general_contract" */
  council_general_contract_aggregate: Council_General_Contract_Aggregate;
  /** fetch data from the table: "council_general_contract" using primary key columns */
  council_general_contract_by_pk?: Maybe<Council_General_Contract>;
  /** fetch data from the table in a streaming manner: "council_general_contract" */
  council_general_contract_stream: Array<Council_General_Contract>;
  /** fetch data from the table: "council_lambda" */
  council_lambda: Array<Council_Lambda>;
  /** fetch aggregated fields from the table: "council_lambda" */
  council_lambda_aggregate: Council_Lambda_Aggregate;
  /** fetch data from the table: "council_lambda" using primary key columns */
  council_lambda_by_pk?: Maybe<Council_Lambda>;
  /** fetch data from the table in a streaming manner: "council_lambda" */
  council_lambda_stream: Array<Council_Lambda>;
  /** fetch data from the table in a streaming manner: "council" */
  council_stream: Array<Council>;
  /** fetch data from the table: "council_whitelist_contract" */
  council_whitelist_contract: Array<Council_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "council_whitelist_contract" */
  council_whitelist_contract_aggregate: Council_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "council_whitelist_contract" using primary key columns */
  council_whitelist_contract_by_pk?: Maybe<Council_Whitelist_Contract>;
  /** fetch data from the table in a streaming manner: "council_whitelist_contract" */
  council_whitelist_contract_stream: Array<Council_Whitelist_Contract>;
  /** fetch data from the table: "delegation" */
  delegation: Array<Delegation>;
  /** fetch aggregated fields from the table: "delegation" */
  delegation_aggregate: Delegation_Aggregate;
  /** fetch data from the table: "delegation" using primary key columns */
  delegation_by_pk?: Maybe<Delegation>;
  /** fetch data from the table: "delegation_general_contract" */
  delegation_general_contract: Array<Delegation_General_Contract>;
  /** fetch aggregated fields from the table: "delegation_general_contract" */
  delegation_general_contract_aggregate: Delegation_General_Contract_Aggregate;
  /** fetch data from the table: "delegation_general_contract" using primary key columns */
  delegation_general_contract_by_pk?: Maybe<Delegation_General_Contract>;
  /** fetch data from the table in a streaming manner: "delegation_general_contract" */
  delegation_general_contract_stream: Array<Delegation_General_Contract>;
  /** fetch data from the table: "delegation_lambda" */
  delegation_lambda: Array<Delegation_Lambda>;
  /** fetch aggregated fields from the table: "delegation_lambda" */
  delegation_lambda_aggregate: Delegation_Lambda_Aggregate;
  /** fetch data from the table: "delegation_lambda" using primary key columns */
  delegation_lambda_by_pk?: Maybe<Delegation_Lambda>;
  /** fetch data from the table in a streaming manner: "delegation_lambda" */
  delegation_lambda_stream: Array<Delegation_Lambda>;
  /** fetch data from the table: "delegation_record" */
  delegation_record: Array<Delegation_Record>;
  /** fetch aggregated fields from the table: "delegation_record" */
  delegation_record_aggregate: Delegation_Record_Aggregate;
  /** fetch data from the table: "delegation_record" using primary key columns */
  delegation_record_by_pk?: Maybe<Delegation_Record>;
  /** fetch data from the table in a streaming manner: "delegation_record" */
  delegation_record_stream: Array<Delegation_Record>;
  /** fetch data from the table in a streaming manner: "delegation" */
  delegation_stream: Array<Delegation>;
  /** fetch data from the table: "delegation_whitelist_contract" */
  delegation_whitelist_contract: Array<Delegation_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "delegation_whitelist_contract" */
  delegation_whitelist_contract_aggregate: Delegation_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "delegation_whitelist_contract" using primary key columns */
  delegation_whitelist_contract_by_pk?: Maybe<Delegation_Whitelist_Contract>;
  /** fetch data from the table in a streaming manner: "delegation_whitelist_contract" */
  delegation_whitelist_contract_stream: Array<Delegation_Whitelist_Contract>;
  /** fetch data from the table: "dipdup_contract" */
  dipdup_contract: Array<Dipdup_Contract>;
  /** fetch aggregated fields from the table: "dipdup_contract" */
  dipdup_contract_aggregate: Dipdup_Contract_Aggregate;
  /** fetch data from the table: "dipdup_contract" using primary key columns */
  dipdup_contract_by_pk?: Maybe<Dipdup_Contract>;
  /** fetch data from the table: "dipdup_contract_metadata" */
  dipdup_contract_metadata: Array<Dipdup_Contract_Metadata>;
  /** fetch aggregated fields from the table: "dipdup_contract_metadata" */
  dipdup_contract_metadata_aggregate: Dipdup_Contract_Metadata_Aggregate;
  /** fetch data from the table: "dipdup_contract_metadata" using primary key columns */
  dipdup_contract_metadata_by_pk?: Maybe<Dipdup_Contract_Metadata>;
  /** fetch data from the table in a streaming manner: "dipdup_contract_metadata" */
  dipdup_contract_metadata_stream: Array<Dipdup_Contract_Metadata>;
  /** fetch data from the table in a streaming manner: "dipdup_contract" */
  dipdup_contract_stream: Array<Dipdup_Contract>;
  /** fetch data from the table: "dipdup_exception" */
  dipdup_exception: Array<Dipdup_Exception>;
  /** fetch aggregated fields from the table: "dipdup_exception" */
  dipdup_exception_aggregate: Dipdup_Exception_Aggregate;
  /** fetch data from the table: "dipdup_exception" using primary key columns */
  dipdup_exception_by_pk?: Maybe<Dipdup_Exception>;
  /** fetch data from the table in a streaming manner: "dipdup_exception" */
  dipdup_exception_stream: Array<Dipdup_Exception>;
  /** fetch data from the table: "dipdup_head" */
  dipdup_head: Array<Dipdup_Head>;
  /** fetch aggregated fields from the table: "dipdup_head" */
  dipdup_head_aggregate: Dipdup_Head_Aggregate;
  /** fetch data from the table: "dipdup_head" using primary key columns */
  dipdup_head_by_pk?: Maybe<Dipdup_Head>;
  /** fetch data from the table in a streaming manner: "dipdup_head" */
  dipdup_head_stream: Array<Dipdup_Head>;
  /** fetch data from the table: "dipdup_index" */
  dipdup_index: Array<Dipdup_Index>;
  /** fetch aggregated fields from the table: "dipdup_index" */
  dipdup_index_aggregate: Dipdup_Index_Aggregate;
  /** fetch data from the table: "dipdup_index" using primary key columns */
  dipdup_index_by_pk?: Maybe<Dipdup_Index>;
  /** fetch data from the table in a streaming manner: "dipdup_index" */
  dipdup_index_stream: Array<Dipdup_Index>;
  /** fetch data from the table: "dipdup_meta" */
  dipdup_meta: Array<Dipdup_Meta>;
  /** fetch aggregated fields from the table: "dipdup_meta" */
  dipdup_meta_aggregate: Dipdup_Meta_Aggregate;
  /** fetch data from the table: "dipdup_meta" using primary key columns */
  dipdup_meta_by_pk?: Maybe<Dipdup_Meta>;
  /** fetch data from the table in a streaming manner: "dipdup_meta" */
  dipdup_meta_stream: Array<Dipdup_Meta>;
  /** fetch data from the table: "dipdup_model_update" */
  dipdup_model_update: Array<Dipdup_Model_Update>;
  /** fetch aggregated fields from the table: "dipdup_model_update" */
  dipdup_model_update_aggregate: Dipdup_Model_Update_Aggregate;
  /** fetch data from the table: "dipdup_model_update" using primary key columns */
  dipdup_model_update_by_pk?: Maybe<Dipdup_Model_Update>;
  /** fetch data from the table in a streaming manner: "dipdup_model_update" */
  dipdup_model_update_stream: Array<Dipdup_Model_Update>;
  /** fetch data from the table: "dipdup_schema" */
  dipdup_schema: Array<Dipdup_Schema>;
  /** fetch aggregated fields from the table: "dipdup_schema" */
  dipdup_schema_aggregate: Dipdup_Schema_Aggregate;
  /** fetch data from the table: "dipdup_schema" using primary key columns */
  dipdup_schema_by_pk?: Maybe<Dipdup_Schema>;
  /** fetch data from the table in a streaming manner: "dipdup_schema" */
  dipdup_schema_stream: Array<Dipdup_Schema>;
  /** fetch data from the table: "dipdup_status" */
  dipdup_status: Array<Dipdup_Status>;
  /** fetch aggregated fields from the table: "dipdup_status" */
  dipdup_status_aggregate: Dipdup_Status_Aggregate;
  /** fetch data from the table in a streaming manner: "dipdup_status" */
  dipdup_status_stream: Array<Dipdup_Status>;
  /** fetch data from the table: "dipdup_token_metadata" */
  dipdup_token_metadata: Array<Dipdup_Token_Metadata>;
  /** fetch aggregated fields from the table: "dipdup_token_metadata" */
  dipdup_token_metadata_aggregate: Dipdup_Token_Metadata_Aggregate;
  /** fetch data from the table: "dipdup_token_metadata" using primary key columns */
  dipdup_token_metadata_by_pk?: Maybe<Dipdup_Token_Metadata>;
  /** fetch data from the table in a streaming manner: "dipdup_token_metadata" */
  dipdup_token_metadata_stream: Array<Dipdup_Token_Metadata>;
  /** fetch data from the table: "doorman" */
  doorman: Array<Doorman>;
  /** fetch aggregated fields from the table: "doorman" */
  doorman_aggregate: Doorman_Aggregate;
  /** fetch data from the table: "doorman" using primary key columns */
  doorman_by_pk?: Maybe<Doorman>;
  /** fetch data from the table: "doorman_general_contract" */
  doorman_general_contract: Array<Doorman_General_Contract>;
  /** fetch aggregated fields from the table: "doorman_general_contract" */
  doorman_general_contract_aggregate: Doorman_General_Contract_Aggregate;
  /** fetch data from the table: "doorman_general_contract" using primary key columns */
  doorman_general_contract_by_pk?: Maybe<Doorman_General_Contract>;
  /** fetch data from the table in a streaming manner: "doorman_general_contract" */
  doorman_general_contract_stream: Array<Doorman_General_Contract>;
  /** fetch data from the table: "doorman_lambda" */
  doorman_lambda: Array<Doorman_Lambda>;
  /** fetch aggregated fields from the table: "doorman_lambda" */
  doorman_lambda_aggregate: Doorman_Lambda_Aggregate;
  /** fetch data from the table: "doorman_lambda" using primary key columns */
  doorman_lambda_by_pk?: Maybe<Doorman_Lambda>;
  /** fetch data from the table in a streaming manner: "doorman_lambda" */
  doorman_lambda_stream: Array<Doorman_Lambda>;
  /** fetch data from the table: "doorman_stake_account" */
  doorman_stake_account: Array<Doorman_Stake_Account>;
  /** fetch aggregated fields from the table: "doorman_stake_account" */
  doorman_stake_account_aggregate: Doorman_Stake_Account_Aggregate;
  /** fetch data from the table: "doorman_stake_account" using primary key columns */
  doorman_stake_account_by_pk?: Maybe<Doorman_Stake_Account>;
  /** fetch data from the table in a streaming manner: "doorman_stake_account" */
  doorman_stake_account_stream: Array<Doorman_Stake_Account>;
  /** fetch data from the table in a streaming manner: "doorman" */
  doorman_stream: Array<Doorman>;
  /** fetch data from the table: "doorman_whitelist_contract" */
  doorman_whitelist_contract: Array<Doorman_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "doorman_whitelist_contract" */
  doorman_whitelist_contract_aggregate: Doorman_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "doorman_whitelist_contract" using primary key columns */
  doorman_whitelist_contract_by_pk?: Maybe<Doorman_Whitelist_Contract>;
  /** fetch data from the table in a streaming manner: "doorman_whitelist_contract" */
  doorman_whitelist_contract_stream: Array<Doorman_Whitelist_Contract>;
  /** fetch data from the table: "emergency_governance" */
  emergency_governance: Array<Emergency_Governance>;
  /** fetch aggregated fields from the table: "emergency_governance" */
  emergency_governance_aggregate: Emergency_Governance_Aggregate;
  /** fetch data from the table: "emergency_governance" using primary key columns */
  emergency_governance_by_pk?: Maybe<Emergency_Governance>;
  /** fetch data from the table: "emergency_governance_general_contract" */
  emergency_governance_general_contract: Array<Emergency_Governance_General_Contract>;
  /** fetch aggregated fields from the table: "emergency_governance_general_contract" */
  emergency_governance_general_contract_aggregate: Emergency_Governance_General_Contract_Aggregate;
  /** fetch data from the table: "emergency_governance_general_contract" using primary key columns */
  emergency_governance_general_contract_by_pk?: Maybe<Emergency_Governance_General_Contract>;
  /** fetch data from the table in a streaming manner: "emergency_governance_general_contract" */
  emergency_governance_general_contract_stream: Array<Emergency_Governance_General_Contract>;
  /** fetch data from the table: "emergency_governance_lambda" */
  emergency_governance_lambda: Array<Emergency_Governance_Lambda>;
  /** fetch aggregated fields from the table: "emergency_governance_lambda" */
  emergency_governance_lambda_aggregate: Emergency_Governance_Lambda_Aggregate;
  /** fetch data from the table: "emergency_governance_lambda" using primary key columns */
  emergency_governance_lambda_by_pk?: Maybe<Emergency_Governance_Lambda>;
  /** fetch data from the table in a streaming manner: "emergency_governance_lambda" */
  emergency_governance_lambda_stream: Array<Emergency_Governance_Lambda>;
  /** fetch data from the table: "emergency_governance_record" */
  emergency_governance_record: Array<Emergency_Governance_Record>;
  /** fetch aggregated fields from the table: "emergency_governance_record" */
  emergency_governance_record_aggregate: Emergency_Governance_Record_Aggregate;
  /** fetch data from the table: "emergency_governance_record" using primary key columns */
  emergency_governance_record_by_pk?: Maybe<Emergency_Governance_Record>;
  /** fetch data from the table in a streaming manner: "emergency_governance_record" */
  emergency_governance_record_stream: Array<Emergency_Governance_Record>;
  /** fetch data from the table in a streaming manner: "emergency_governance" */
  emergency_governance_stream: Array<Emergency_Governance>;
  /** fetch data from the table: "emergency_governance_vote" */
  emergency_governance_vote: Array<Emergency_Governance_Vote>;
  /** fetch aggregated fields from the table: "emergency_governance_vote" */
  emergency_governance_vote_aggregate: Emergency_Governance_Vote_Aggregate;
  /** fetch data from the table: "emergency_governance_vote" using primary key columns */
  emergency_governance_vote_by_pk?: Maybe<Emergency_Governance_Vote>;
  /** fetch data from the table in a streaming manner: "emergency_governance_vote" */
  emergency_governance_vote_stream: Array<Emergency_Governance_Vote>;
  /** fetch data from the table: "emergency_governance_whitelist_contract" */
  emergency_governance_whitelist_contract: Array<Emergency_Governance_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "emergency_governance_whitelist_contract" */
  emergency_governance_whitelist_contract_aggregate: Emergency_Governance_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "emergency_governance_whitelist_contract" using primary key columns */
  emergency_governance_whitelist_contract_by_pk?: Maybe<Emergency_Governance_Whitelist_Contract>;
  /** fetch data from the table in a streaming manner: "emergency_governance_whitelist_contract" */
  emergency_governance_whitelist_contract_stream: Array<Emergency_Governance_Whitelist_Contract>;
  /** fetch data from the table: "farm" */
  farm: Array<Farm>;
  /** fetch data from the table: "farm_account" */
  farm_account: Array<Farm_Account>;
  /** fetch aggregated fields from the table: "farm_account" */
  farm_account_aggregate: Farm_Account_Aggregate;
  /** fetch data from the table: "farm_account" using primary key columns */
  farm_account_by_pk?: Maybe<Farm_Account>;
  /** fetch data from the table in a streaming manner: "farm_account" */
  farm_account_stream: Array<Farm_Account>;
  /** fetch aggregated fields from the table: "farm" */
  farm_aggregate: Farm_Aggregate;
  /** fetch data from the table: "farm" using primary key columns */
  farm_by_pk?: Maybe<Farm>;
  /** fetch data from the table: "farm_factory" */
  farm_factory: Array<Farm_Factory>;
  /** fetch aggregated fields from the table: "farm_factory" */
  farm_factory_aggregate: Farm_Factory_Aggregate;
  /** fetch data from the table: "farm_factory" using primary key columns */
  farm_factory_by_pk?: Maybe<Farm_Factory>;
  /** fetch data from the table: "farm_factory_farm_lambda" */
  farm_factory_farm_lambda: Array<Farm_Factory_Farm_Lambda>;
  /** fetch aggregated fields from the table: "farm_factory_farm_lambda" */
  farm_factory_farm_lambda_aggregate: Farm_Factory_Farm_Lambda_Aggregate;
  /** fetch data from the table: "farm_factory_farm_lambda" using primary key columns */
  farm_factory_farm_lambda_by_pk?: Maybe<Farm_Factory_Farm_Lambda>;
  /** fetch data from the table in a streaming manner: "farm_factory_farm_lambda" */
  farm_factory_farm_lambda_stream: Array<Farm_Factory_Farm_Lambda>;
  /** fetch data from the table: "farm_factory_general_contract" */
  farm_factory_general_contract: Array<Farm_Factory_General_Contract>;
  /** fetch aggregated fields from the table: "farm_factory_general_contract" */
  farm_factory_general_contract_aggregate: Farm_Factory_General_Contract_Aggregate;
  /** fetch data from the table: "farm_factory_general_contract" using primary key columns */
  farm_factory_general_contract_by_pk?: Maybe<Farm_Factory_General_Contract>;
  /** fetch data from the table in a streaming manner: "farm_factory_general_contract" */
  farm_factory_general_contract_stream: Array<Farm_Factory_General_Contract>;
  /** fetch data from the table: "farm_factory_lambda" */
  farm_factory_lambda: Array<Farm_Factory_Lambda>;
  /** fetch aggregated fields from the table: "farm_factory_lambda" */
  farm_factory_lambda_aggregate: Farm_Factory_Lambda_Aggregate;
  /** fetch data from the table: "farm_factory_lambda" using primary key columns */
  farm_factory_lambda_by_pk?: Maybe<Farm_Factory_Lambda>;
  /** fetch data from the table in a streaming manner: "farm_factory_lambda" */
  farm_factory_lambda_stream: Array<Farm_Factory_Lambda>;
  /** fetch data from the table: "farm_factory_m_farm_lambda" */
  farm_factory_m_farm_lambda: Array<Farm_Factory_M_Farm_Lambda>;
  /** fetch aggregated fields from the table: "farm_factory_m_farm_lambda" */
  farm_factory_m_farm_lambda_aggregate: Farm_Factory_M_Farm_Lambda_Aggregate;
  /** fetch data from the table: "farm_factory_m_farm_lambda" using primary key columns */
  farm_factory_m_farm_lambda_by_pk?: Maybe<Farm_Factory_M_Farm_Lambda>;
  /** fetch data from the table in a streaming manner: "farm_factory_m_farm_lambda" */
  farm_factory_m_farm_lambda_stream: Array<Farm_Factory_M_Farm_Lambda>;
  /** fetch data from the table in a streaming manner: "farm_factory" */
  farm_factory_stream: Array<Farm_Factory>;
  /** fetch data from the table: "farm_factory_whitelist_contract" */
  farm_factory_whitelist_contract: Array<Farm_Factory_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "farm_factory_whitelist_contract" */
  farm_factory_whitelist_contract_aggregate: Farm_Factory_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "farm_factory_whitelist_contract" using primary key columns */
  farm_factory_whitelist_contract_by_pk?: Maybe<Farm_Factory_Whitelist_Contract>;
  /** fetch data from the table in a streaming manner: "farm_factory_whitelist_contract" */
  farm_factory_whitelist_contract_stream: Array<Farm_Factory_Whitelist_Contract>;
  /** fetch data from the table: "farm_general_contract" */
  farm_general_contract: Array<Farm_General_Contract>;
  /** fetch aggregated fields from the table: "farm_general_contract" */
  farm_general_contract_aggregate: Farm_General_Contract_Aggregate;
  /** fetch data from the table: "farm_general_contract" using primary key columns */
  farm_general_contract_by_pk?: Maybe<Farm_General_Contract>;
  /** fetch data from the table in a streaming manner: "farm_general_contract" */
  farm_general_contract_stream: Array<Farm_General_Contract>;
  /** fetch data from the table: "farm_lambda" */
  farm_lambda: Array<Farm_Lambda>;
  /** fetch aggregated fields from the table: "farm_lambda" */
  farm_lambda_aggregate: Farm_Lambda_Aggregate;
  /** fetch data from the table: "farm_lambda" using primary key columns */
  farm_lambda_by_pk?: Maybe<Farm_Lambda>;
  /** fetch data from the table in a streaming manner: "farm_lambda" */
  farm_lambda_stream: Array<Farm_Lambda>;
  /** fetch data from the table in a streaming manner: "farm" */
  farm_stream: Array<Farm>;
  /** fetch data from the table: "farm_whitelist_contract" */
  farm_whitelist_contract: Array<Farm_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "farm_whitelist_contract" */
  farm_whitelist_contract_aggregate: Farm_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "farm_whitelist_contract" using primary key columns */
  farm_whitelist_contract_by_pk?: Maybe<Farm_Whitelist_Contract>;
  /** fetch data from the table in a streaming manner: "farm_whitelist_contract" */
  farm_whitelist_contract_stream: Array<Farm_Whitelist_Contract>;
  /** fetch data from the table: "governance" */
  governance: Array<Governance>;
  /** fetch aggregated fields from the table: "governance" */
  governance_aggregate: Governance_Aggregate;
  /** fetch data from the table: "governance" using primary key columns */
  governance_by_pk?: Maybe<Governance>;
  /** fetch data from the table: "governance_financial" */
  governance_financial: Array<Governance_Financial>;
  /** fetch aggregated fields from the table: "governance_financial" */
  governance_financial_aggregate: Governance_Financial_Aggregate;
  /** fetch data from the table: "governance_financial" using primary key columns */
  governance_financial_by_pk?: Maybe<Governance_Financial>;
  /** fetch data from the table: "governance_financial_general_contract" */
  governance_financial_general_contract: Array<Governance_Financial_General_Contract>;
  /** fetch aggregated fields from the table: "governance_financial_general_contract" */
  governance_financial_general_contract_aggregate: Governance_Financial_General_Contract_Aggregate;
  /** fetch data from the table: "governance_financial_general_contract" using primary key columns */
  governance_financial_general_contract_by_pk?: Maybe<Governance_Financial_General_Contract>;
  /** fetch data from the table in a streaming manner: "governance_financial_general_contract" */
  governance_financial_general_contract_stream: Array<Governance_Financial_General_Contract>;
  /** fetch data from the table: "governance_financial_lambda" */
  governance_financial_lambda: Array<Governance_Financial_Lambda>;
  /** fetch aggregated fields from the table: "governance_financial_lambda" */
  governance_financial_lambda_aggregate: Governance_Financial_Lambda_Aggregate;
  /** fetch data from the table: "governance_financial_lambda" using primary key columns */
  governance_financial_lambda_by_pk?: Maybe<Governance_Financial_Lambda>;
  /** fetch data from the table in a streaming manner: "governance_financial_lambda" */
  governance_financial_lambda_stream: Array<Governance_Financial_Lambda>;
  /** fetch data from the table: "governance_financial_request" */
  governance_financial_request: Array<Governance_Financial_Request>;
  /** fetch aggregated fields from the table: "governance_financial_request" */
  governance_financial_request_aggregate: Governance_Financial_Request_Aggregate;
  /** fetch data from the table: "governance_financial_request" using primary key columns */
  governance_financial_request_by_pk?: Maybe<Governance_Financial_Request>;
  /** fetch data from the table in a streaming manner: "governance_financial_request" */
  governance_financial_request_stream: Array<Governance_Financial_Request>;
  /** fetch data from the table: "governance_financial_request_vote" */
  governance_financial_request_vote: Array<Governance_Financial_Request_Vote>;
  /** fetch aggregated fields from the table: "governance_financial_request_vote" */
  governance_financial_request_vote_aggregate: Governance_Financial_Request_Vote_Aggregate;
  /** fetch data from the table: "governance_financial_request_vote" using primary key columns */
  governance_financial_request_vote_by_pk?: Maybe<Governance_Financial_Request_Vote>;
  /** fetch data from the table in a streaming manner: "governance_financial_request_vote" */
  governance_financial_request_vote_stream: Array<Governance_Financial_Request_Vote>;
  /** fetch data from the table in a streaming manner: "governance_financial" */
  governance_financial_stream: Array<Governance_Financial>;
  /** fetch data from the table: "governance_financial_whitelist_contract" */
  governance_financial_whitelist_contract: Array<Governance_Financial_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "governance_financial_whitelist_contract" */
  governance_financial_whitelist_contract_aggregate: Governance_Financial_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "governance_financial_whitelist_contract" using primary key columns */
  governance_financial_whitelist_contract_by_pk?: Maybe<Governance_Financial_Whitelist_Contract>;
  /** fetch data from the table in a streaming manner: "governance_financial_whitelist_contract" */
  governance_financial_whitelist_contract_stream: Array<Governance_Financial_Whitelist_Contract>;
  /** fetch data from the table: "governance_financial_whitelist_token_contract" */
  governance_financial_whitelist_token_contract: Array<Governance_Financial_Whitelist_Token_Contract>;
  /** fetch aggregated fields from the table: "governance_financial_whitelist_token_contract" */
  governance_financial_whitelist_token_contract_aggregate: Governance_Financial_Whitelist_Token_Contract_Aggregate;
  /** fetch data from the table: "governance_financial_whitelist_token_contract" using primary key columns */
  governance_financial_whitelist_token_contract_by_pk?: Maybe<Governance_Financial_Whitelist_Token_Contract>;
  /** fetch data from the table in a streaming manner: "governance_financial_whitelist_token_contract" */
  governance_financial_whitelist_token_contract_stream: Array<Governance_Financial_Whitelist_Token_Contract>;
  /** fetch data from the table: "governance_general_contract" */
  governance_general_contract: Array<Governance_General_Contract>;
  /** fetch aggregated fields from the table: "governance_general_contract" */
  governance_general_contract_aggregate: Governance_General_Contract_Aggregate;
  /** fetch data from the table: "governance_general_contract" using primary key columns */
  governance_general_contract_by_pk?: Maybe<Governance_General_Contract>;
  /** fetch data from the table in a streaming manner: "governance_general_contract" */
  governance_general_contract_stream: Array<Governance_General_Contract>;
  /** fetch data from the table: "governance_lambda" */
  governance_lambda: Array<Governance_Lambda>;
  /** fetch aggregated fields from the table: "governance_lambda" */
  governance_lambda_aggregate: Governance_Lambda_Aggregate;
  /** fetch data from the table: "governance_lambda" using primary key columns */
  governance_lambda_by_pk?: Maybe<Governance_Lambda>;
  /** fetch data from the table in a streaming manner: "governance_lambda" */
  governance_lambda_stream: Array<Governance_Lambda>;
  /** fetch data from the table: "governance_proposal" */
  governance_proposal: Array<Governance_Proposal>;
  /** fetch aggregated fields from the table: "governance_proposal" */
  governance_proposal_aggregate: Governance_Proposal_Aggregate;
  /** fetch data from the table: "governance_proposal" using primary key columns */
  governance_proposal_by_pk?: Maybe<Governance_Proposal>;
  /** fetch data from the table: "governance_proposal_data" */
  governance_proposal_data: Array<Governance_Proposal_Data>;
  /** fetch aggregated fields from the table: "governance_proposal_data" */
  governance_proposal_data_aggregate: Governance_Proposal_Data_Aggregate;
  /** fetch data from the table: "governance_proposal_data" using primary key columns */
  governance_proposal_data_by_pk?: Maybe<Governance_Proposal_Data>;
  /** fetch data from the table in a streaming manner: "governance_proposal_data" */
  governance_proposal_data_stream: Array<Governance_Proposal_Data>;
  /** fetch data from the table: "governance_proposal_payment" */
  governance_proposal_payment: Array<Governance_Proposal_Payment>;
  /** fetch aggregated fields from the table: "governance_proposal_payment" */
  governance_proposal_payment_aggregate: Governance_Proposal_Payment_Aggregate;
  /** fetch data from the table: "governance_proposal_payment" using primary key columns */
  governance_proposal_payment_by_pk?: Maybe<Governance_Proposal_Payment>;
  /** fetch data from the table in a streaming manner: "governance_proposal_payment" */
  governance_proposal_payment_stream: Array<Governance_Proposal_Payment>;
  /** fetch data from the table in a streaming manner: "governance_proposal" */
  governance_proposal_stream: Array<Governance_Proposal>;
  /** fetch data from the table: "governance_proposal_vote" */
  governance_proposal_vote: Array<Governance_Proposal_Vote>;
  /** fetch aggregated fields from the table: "governance_proposal_vote" */
  governance_proposal_vote_aggregate: Governance_Proposal_Vote_Aggregate;
  /** fetch data from the table: "governance_proposal_vote" using primary key columns */
  governance_proposal_vote_by_pk?: Maybe<Governance_Proposal_Vote>;
  /** fetch data from the table in a streaming manner: "governance_proposal_vote" */
  governance_proposal_vote_stream: Array<Governance_Proposal_Vote>;
  /** fetch data from the table: "governance_proxy" */
  governance_proxy: Array<Governance_Proxy>;
  /** fetch aggregated fields from the table: "governance_proxy" */
  governance_proxy_aggregate: Governance_Proxy_Aggregate;
  /** fetch data from the table: "governance_proxy" using primary key columns */
  governance_proxy_by_pk?: Maybe<Governance_Proxy>;
  /** fetch data from the table: "governance_proxy_lambda" */
  governance_proxy_lambda: Array<Governance_Proxy_Lambda>;
  /** fetch aggregated fields from the table: "governance_proxy_lambda" */
  governance_proxy_lambda_aggregate: Governance_Proxy_Lambda_Aggregate;
  /** fetch data from the table: "governance_proxy_lambda" using primary key columns */
  governance_proxy_lambda_by_pk?: Maybe<Governance_Proxy_Lambda>;
  /** fetch data from the table in a streaming manner: "governance_proxy_lambda" */
  governance_proxy_lambda_stream: Array<Governance_Proxy_Lambda>;
  /** fetch data from the table in a streaming manner: "governance_proxy" */
  governance_proxy_stream: Array<Governance_Proxy>;
  /** fetch data from the table: "governance_satellite" */
  governance_satellite: Array<Governance_Satellite>;
  /** fetch data from the table: "governance_satellite_action" */
  governance_satellite_action: Array<Governance_Satellite_Action>;
  /** fetch aggregated fields from the table: "governance_satellite_action" */
  governance_satellite_action_aggregate: Governance_Satellite_Action_Aggregate;
  /** fetch data from the table: "governance_satellite_action" using primary key columns */
  governance_satellite_action_by_pk?: Maybe<Governance_Satellite_Action>;
  /** fetch data from the table: "governance_satellite_action_parameter" */
  governance_satellite_action_parameter: Array<Governance_Satellite_Action_Parameter>;
  /** fetch aggregated fields from the table: "governance_satellite_action_parameter" */
  governance_satellite_action_parameter_aggregate: Governance_Satellite_Action_Parameter_Aggregate;
  /** fetch data from the table: "governance_satellite_action_parameter" using primary key columns */
  governance_satellite_action_parameter_by_pk?: Maybe<Governance_Satellite_Action_Parameter>;
  /** fetch data from the table in a streaming manner: "governance_satellite_action_parameter" */
  governance_satellite_action_parameter_stream: Array<Governance_Satellite_Action_Parameter>;
  /** fetch data from the table in a streaming manner: "governance_satellite_action" */
  governance_satellite_action_stream: Array<Governance_Satellite_Action>;
  /** fetch data from the table: "governance_satellite_action_vote" */
  governance_satellite_action_vote: Array<Governance_Satellite_Action_Vote>;
  /** fetch aggregated fields from the table: "governance_satellite_action_vote" */
  governance_satellite_action_vote_aggregate: Governance_Satellite_Action_Vote_Aggregate;
  /** fetch data from the table: "governance_satellite_action_vote" using primary key columns */
  governance_satellite_action_vote_by_pk?: Maybe<Governance_Satellite_Action_Vote>;
  /** fetch data from the table in a streaming manner: "governance_satellite_action_vote" */
  governance_satellite_action_vote_stream: Array<Governance_Satellite_Action_Vote>;
  /** fetch aggregated fields from the table: "governance_satellite" */
  governance_satellite_aggregate: Governance_Satellite_Aggregate;
  /** fetch data from the table: "governance_satellite" using primary key columns */
  governance_satellite_by_pk?: Maybe<Governance_Satellite>;
  /** fetch data from the table: "governance_satellite_general_contract" */
  governance_satellite_general_contract: Array<Governance_Satellite_General_Contract>;
  /** fetch aggregated fields from the table: "governance_satellite_general_contract" */
  governance_satellite_general_contract_aggregate: Governance_Satellite_General_Contract_Aggregate;
  /** fetch data from the table: "governance_satellite_general_contract" using primary key columns */
  governance_satellite_general_contract_by_pk?: Maybe<Governance_Satellite_General_Contract>;
  /** fetch data from the table in a streaming manner: "governance_satellite_general_contract" */
  governance_satellite_general_contract_stream: Array<Governance_Satellite_General_Contract>;
  /** fetch data from the table: "governance_satellite_lambda" */
  governance_satellite_lambda: Array<Governance_Satellite_Lambda>;
  /** fetch aggregated fields from the table: "governance_satellite_lambda" */
  governance_satellite_lambda_aggregate: Governance_Satellite_Lambda_Aggregate;
  /** fetch data from the table: "governance_satellite_lambda" using primary key columns */
  governance_satellite_lambda_by_pk?: Maybe<Governance_Satellite_Lambda>;
  /** fetch data from the table in a streaming manner: "governance_satellite_lambda" */
  governance_satellite_lambda_stream: Array<Governance_Satellite_Lambda>;
  /** fetch data from the table: "governance_satellite_oracle" */
  governance_satellite_oracle: Array<Governance_Satellite_Oracle>;
  /** fetch aggregated fields from the table: "governance_satellite_oracle" */
  governance_satellite_oracle_aggregate: Governance_Satellite_Oracle_Aggregate;
  /** fetch data from the table: "governance_satellite_oracle_aggregator" */
  governance_satellite_oracle_aggregator: Array<Governance_Satellite_Oracle_Aggregator>;
  /** fetch aggregated fields from the table: "governance_satellite_oracle_aggregator" */
  governance_satellite_oracle_aggregator_aggregate: Governance_Satellite_Oracle_Aggregator_Aggregate;
  /** fetch data from the table: "governance_satellite_oracle_aggregator" using primary key columns */
  governance_satellite_oracle_aggregator_by_pk?: Maybe<Governance_Satellite_Oracle_Aggregator>;
  /** fetch data from the table in a streaming manner: "governance_satellite_oracle_aggregator" */
  governance_satellite_oracle_aggregator_stream: Array<Governance_Satellite_Oracle_Aggregator>;
  /** fetch data from the table: "governance_satellite_oracle" using primary key columns */
  governance_satellite_oracle_by_pk?: Maybe<Governance_Satellite_Oracle>;
  /** fetch data from the table in a streaming manner: "governance_satellite_oracle" */
  governance_satellite_oracle_stream: Array<Governance_Satellite_Oracle>;
  /** fetch data from the table: "governance_satellite_snapshot" */
  governance_satellite_snapshot: Array<Governance_Satellite_Snapshot>;
  /** fetch aggregated fields from the table: "governance_satellite_snapshot" */
  governance_satellite_snapshot_aggregate: Governance_Satellite_Snapshot_Aggregate;
  /** fetch data from the table: "governance_satellite_snapshot" using primary key columns */
  governance_satellite_snapshot_by_pk?: Maybe<Governance_Satellite_Snapshot>;
  /** fetch data from the table in a streaming manner: "governance_satellite_snapshot" */
  governance_satellite_snapshot_stream: Array<Governance_Satellite_Snapshot>;
  /** fetch data from the table in a streaming manner: "governance_satellite" */
  governance_satellite_stream: Array<Governance_Satellite>;
  /** fetch data from the table: "governance_satellite_whitelist_contract" */
  governance_satellite_whitelist_contract: Array<Governance_Satellite_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "governance_satellite_whitelist_contract" */
  governance_satellite_whitelist_contract_aggregate: Governance_Satellite_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "governance_satellite_whitelist_contract" using primary key columns */
  governance_satellite_whitelist_contract_by_pk?: Maybe<Governance_Satellite_Whitelist_Contract>;
  /** fetch data from the table in a streaming manner: "governance_satellite_whitelist_contract" */
  governance_satellite_whitelist_contract_stream: Array<Governance_Satellite_Whitelist_Contract>;
  /** fetch data from the table: "governance_smvn_snapshot" */
  governance_smvn_snapshot: Array<Governance_Smvn_Snapshot>;
  /** fetch aggregated fields from the table: "governance_smvn_snapshot" */
  governance_smvn_snapshot_aggregate: Governance_Smvn_Snapshot_Aggregate;
  /** fetch data from the table: "governance_smvn_snapshot" using primary key columns */
  governance_smvn_snapshot_by_pk?: Maybe<Governance_Smvn_Snapshot>;
  /** fetch data from the table in a streaming manner: "governance_smvn_snapshot" */
  governance_smvn_snapshot_stream: Array<Governance_Smvn_Snapshot>;
  /** fetch data from the table in a streaming manner: "governance" */
  governance_stream: Array<Governance>;
  /** fetch data from the table: "governance_whitelist_contract" */
  governance_whitelist_contract: Array<Governance_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "governance_whitelist_contract" */
  governance_whitelist_contract_aggregate: Governance_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "governance_whitelist_contract" using primary key columns */
  governance_whitelist_contract_by_pk?: Maybe<Governance_Whitelist_Contract>;
  /** fetch data from the table in a streaming manner: "governance_whitelist_contract" */
  governance_whitelist_contract_stream: Array<Governance_Whitelist_Contract>;
  /** fetch data from the table: "gql_history_data_summary" */
  gql_history_data_summary: Array<Gql_History_Data_Summary>;
  /** fetch aggregated fields from the table: "gql_history_data_summary" */
  gql_history_data_summary_aggregate: Gql_History_Data_Summary_Aggregate;
  /** fetch data from the table in a streaming manner: "gql_history_data_summary" */
  gql_history_data_summary_stream: Array<Gql_History_Data_Summary>;
  /** fetch data from the table: "gql_loan_token_market_stats" */
  gql_loan_token_market_stats: Array<Gql_Loan_Token_Market_Stats>;
  /** fetch aggregated fields from the table: "gql_loan_token_market_stats" */
  gql_loan_token_market_stats_aggregate: Gql_Loan_Token_Market_Stats_Aggregate;
  /** fetch data from the table in a streaming manner: "gql_loan_token_market_stats" */
  gql_loan_token_market_stats_stream: Array<Gql_Loan_Token_Market_Stats>;
  /** fetch data from the table: "gql_vault_with_balances" */
  gql_vault_with_balances: Array<Gql_Vault_With_Balances>;
  /** fetch aggregated fields from the table: "gql_vault_with_balances" */
  gql_vault_with_balances_aggregate: Gql_Vault_With_Balances_Aggregate;
  /** fetch data from the table in a streaming manner: "gql_vault_with_balances" */
  gql_vault_with_balances_stream: Array<Gql_Vault_With_Balances>;
  /** fetch data from the table: "lending_controller" */
  lending_controller: Array<Lending_Controller>;
  /** fetch aggregated fields from the table: "lending_controller" */
  lending_controller_aggregate: Lending_Controller_Aggregate;
  /** fetch data from the table: "lending_controller" using primary key columns */
  lending_controller_by_pk?: Maybe<Lending_Controller>;
  /** fetch data from the table: "lending_controller_collateral_token" */
  lending_controller_collateral_token: Array<Lending_Controller_Collateral_Token>;
  /** fetch aggregated fields from the table: "lending_controller_collateral_token" */
  lending_controller_collateral_token_aggregate: Lending_Controller_Collateral_Token_Aggregate;
  /** fetch data from the table: "lending_controller_collateral_token" using primary key columns */
  lending_controller_collateral_token_by_pk?: Maybe<Lending_Controller_Collateral_Token>;
  /** fetch data from the table in a streaming manner: "lending_controller_collateral_token" */
  lending_controller_collateral_token_stream: Array<Lending_Controller_Collateral_Token>;
  /** fetch data from the table: "lending_controller_history_data" */
  lending_controller_history_data: Array<Lending_Controller_History_Data>;
  /** fetch aggregated fields from the table: "lending_controller_history_data" */
  lending_controller_history_data_aggregate: Lending_Controller_History_Data_Aggregate;
  /** fetch data from the table: "lending_controller_history_data" using primary key columns */
  lending_controller_history_data_by_pk?: Maybe<Lending_Controller_History_Data>;
  /** fetch data from the table in a streaming manner: "lending_controller_history_data" */
  lending_controller_history_data_stream: Array<Lending_Controller_History_Data>;
  /** fetch data from the table: "lending_controller_lambda" */
  lending_controller_lambda: Array<Lending_Controller_Lambda>;
  /** fetch aggregated fields from the table: "lending_controller_lambda" */
  lending_controller_lambda_aggregate: Lending_Controller_Lambda_Aggregate;
  /** fetch data from the table: "lending_controller_lambda" using primary key columns */
  lending_controller_lambda_by_pk?: Maybe<Lending_Controller_Lambda>;
  /** fetch data from the table in a streaming manner: "lending_controller_lambda" */
  lending_controller_lambda_stream: Array<Lending_Controller_Lambda>;
  /** fetch data from the table: "lending_controller_loan_token" */
  lending_controller_loan_token: Array<Lending_Controller_Loan_Token>;
  /** fetch aggregated fields from the table: "lending_controller_loan_token" */
  lending_controller_loan_token_aggregate: Lending_Controller_Loan_Token_Aggregate;
  /** fetch data from the table: "lending_controller_loan_token" using primary key columns */
  lending_controller_loan_token_by_pk?: Maybe<Lending_Controller_Loan_Token>;
  /** fetch data from the table in a streaming manner: "lending_controller_loan_token" */
  lending_controller_loan_token_stream: Array<Lending_Controller_Loan_Token>;
  /** fetch data from the table in a streaming manner: "lending_controller" */
  lending_controller_stream: Array<Lending_Controller>;
  /** fetch data from the table: "lending_controller_vault" */
  lending_controller_vault: Array<Lending_Controller_Vault>;
  /** fetch aggregated fields from the table: "lending_controller_vault" */
  lending_controller_vault_aggregate: Lending_Controller_Vault_Aggregate;
  /** fetch data from the table: "lending_controller_vault" using primary key columns */
  lending_controller_vault_by_pk?: Maybe<Lending_Controller_Vault>;
  /** fetch data from the table: "lending_controller_vault_collateral_balance" */
  lending_controller_vault_collateral_balance: Array<Lending_Controller_Vault_Collateral_Balance>;
  /** fetch aggregated fields from the table: "lending_controller_vault_collateral_balance" */
  lending_controller_vault_collateral_balance_aggregate: Lending_Controller_Vault_Collateral_Balance_Aggregate;
  /** fetch data from the table: "lending_controller_vault_collateral_balance" using primary key columns */
  lending_controller_vault_collateral_balance_by_pk?: Maybe<Lending_Controller_Vault_Collateral_Balance>;
  /** fetch data from the table in a streaming manner: "lending_controller_vault_collateral_balance" */
  lending_controller_vault_collateral_balance_stream: Array<Lending_Controller_Vault_Collateral_Balance>;
  /** fetch data from the table in a streaming manner: "lending_controller_vault" */
  lending_controller_vault_stream: Array<Lending_Controller_Vault>;
  /** fetch data from the table: "loan_token_view" */
  loan_token_view: Array<Loan_Token_View>;
  /** fetch aggregated fields from the table: "loan_token_view" */
  loan_token_view_aggregate: Loan_Token_View_Aggregate;
  /** fetch data from the table in a streaming manner: "loan_token_view" */
  loan_token_view_stream: Array<Loan_Token_View>;
  /** fetch data from the table: "m_token" */
  m_token: Array<M_Token>;
  /** fetch data from the table: "m_token_account" */
  m_token_account: Array<M_Token_Account>;
  /** fetch aggregated fields from the table: "m_token_account" */
  m_token_account_aggregate: M_Token_Account_Aggregate;
  /** fetch data from the table: "m_token_account" using primary key columns */
  m_token_account_by_pk?: Maybe<M_Token_Account>;
  /** fetch data from the table: "m_token_account_history_data" */
  m_token_account_history_data: Array<M_Token_Account_History_Data>;
  /** fetch aggregated fields from the table: "m_token_account_history_data" */
  m_token_account_history_data_aggregate: M_Token_Account_History_Data_Aggregate;
  /** fetch data from the table: "m_token_account_history_data" using primary key columns */
  m_token_account_history_data_by_pk?: Maybe<M_Token_Account_History_Data>;
  /** fetch data from the table in a streaming manner: "m_token_account_history_data" */
  m_token_account_history_data_stream: Array<M_Token_Account_History_Data>;
  /** fetch data from the table in a streaming manner: "m_token_account" */
  m_token_account_stream: Array<M_Token_Account>;
  /** fetch aggregated fields from the table: "m_token" */
  m_token_aggregate: M_Token_Aggregate;
  /** fetch data from the table: "m_token" using primary key columns */
  m_token_by_pk?: Maybe<M_Token>;
  /** fetch data from the table: "m_token_general_contract" */
  m_token_general_contract: Array<M_Token_General_Contract>;
  /** fetch aggregated fields from the table: "m_token_general_contract" */
  m_token_general_contract_aggregate: M_Token_General_Contract_Aggregate;
  /** fetch data from the table: "m_token_general_contract" using primary key columns */
  m_token_general_contract_by_pk?: Maybe<M_Token_General_Contract>;
  /** fetch data from the table in a streaming manner: "m_token_general_contract" */
  m_token_general_contract_stream: Array<M_Token_General_Contract>;
  /** fetch data from the table: "m_token_lambda" */
  m_token_lambda: Array<M_Token_Lambda>;
  /** fetch aggregated fields from the table: "m_token_lambda" */
  m_token_lambda_aggregate: M_Token_Lambda_Aggregate;
  /** fetch data from the table: "m_token_lambda" using primary key columns */
  m_token_lambda_by_pk?: Maybe<M_Token_Lambda>;
  /** fetch data from the table in a streaming manner: "m_token_lambda" */
  m_token_lambda_stream: Array<M_Token_Lambda>;
  /** fetch data from the table: "m_token_operator" */
  m_token_operator: Array<M_Token_Operator>;
  /** fetch aggregated fields from the table: "m_token_operator" */
  m_token_operator_aggregate: M_Token_Operator_Aggregate;
  /** fetch data from the table: "m_token_operator" using primary key columns */
  m_token_operator_by_pk?: Maybe<M_Token_Operator>;
  /** fetch data from the table in a streaming manner: "m_token_operator" */
  m_token_operator_stream: Array<M_Token_Operator>;
  /** fetch data from the table in a streaming manner: "m_token" */
  m_token_stream: Array<M_Token>;
  /** fetch data from the table: "m_token_whitelist_contract" */
  m_token_whitelist_contract: Array<M_Token_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "m_token_whitelist_contract" */
  m_token_whitelist_contract_aggregate: M_Token_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "m_token_whitelist_contract" using primary key columns */
  m_token_whitelist_contract_by_pk?: Maybe<M_Token_Whitelist_Contract>;
  /** fetch data from the table in a streaming manner: "m_token_whitelist_contract" */
  m_token_whitelist_contract_stream: Array<M_Token_Whitelist_Contract>;
  /** fetch data from the table: "maven_user" */
  maven_user: Array<Maven_User>;
  /** fetch aggregated fields from the table: "maven_user" */
  maven_user_aggregate: Maven_User_Aggregate;
  /** fetch data from the table: "maven_user" using primary key columns */
  maven_user_by_pk?: Maybe<Maven_User>;
  /** fetch data from the table in a streaming manner: "maven_user" */
  maven_user_stream: Array<Maven_User>;
  /** fetch data from the table: "mvn_mint_or_burn_history_data" */
  mvn_mint_or_burn_history_data: Array<Mvn_Mint_Or_Burn_History_Data>;
  /** fetch aggregated fields from the table: "mvn_mint_or_burn_history_data" */
  mvn_mint_or_burn_history_data_aggregate: Mvn_Mint_Or_Burn_History_Data_Aggregate;
  /** fetch data from the table: "mvn_mint_or_burn_history_data" using primary key columns */
  mvn_mint_or_burn_history_data_by_pk?: Maybe<Mvn_Mint_Or_Burn_History_Data>;
  /** fetch data from the table in a streaming manner: "mvn_mint_or_burn_history_data" */
  mvn_mint_or_burn_history_data_stream: Array<Mvn_Mint_Or_Burn_History_Data>;
  /** fetch data from the table: "mvn_token" */
  mvn_token: Array<Mvn_Token>;
  /** fetch aggregated fields from the table: "mvn_token" */
  mvn_token_aggregate: Mvn_Token_Aggregate;
  /** fetch data from the table: "mvn_token" using primary key columns */
  mvn_token_by_pk?: Maybe<Mvn_Token>;
  /** fetch data from the table: "mvn_token_general_contract" */
  mvn_token_general_contract: Array<Mvn_Token_General_Contract>;
  /** fetch aggregated fields from the table: "mvn_token_general_contract" */
  mvn_token_general_contract_aggregate: Mvn_Token_General_Contract_Aggregate;
  /** fetch data from the table: "mvn_token_general_contract" using primary key columns */
  mvn_token_general_contract_by_pk?: Maybe<Mvn_Token_General_Contract>;
  /** fetch data from the table in a streaming manner: "mvn_token_general_contract" */
  mvn_token_general_contract_stream: Array<Mvn_Token_General_Contract>;
  /** fetch data from the table: "mvn_token_operator" */
  mvn_token_operator: Array<Mvn_Token_Operator>;
  /** fetch aggregated fields from the table: "mvn_token_operator" */
  mvn_token_operator_aggregate: Mvn_Token_Operator_Aggregate;
  /** fetch data from the table: "mvn_token_operator" using primary key columns */
  mvn_token_operator_by_pk?: Maybe<Mvn_Token_Operator>;
  /** fetch data from the table in a streaming manner: "mvn_token_operator" */
  mvn_token_operator_stream: Array<Mvn_Token_Operator>;
  /** fetch data from the table in a streaming manner: "mvn_token" */
  mvn_token_stream: Array<Mvn_Token>;
  /** fetch data from the table: "mvn_token_whitelist_contract" */
  mvn_token_whitelist_contract: Array<Mvn_Token_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "mvn_token_whitelist_contract" */
  mvn_token_whitelist_contract_aggregate: Mvn_Token_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "mvn_token_whitelist_contract" using primary key columns */
  mvn_token_whitelist_contract_by_pk?: Maybe<Mvn_Token_Whitelist_Contract>;
  /** fetch data from the table in a streaming manner: "mvn_token_whitelist_contract" */
  mvn_token_whitelist_contract_stream: Array<Mvn_Token_Whitelist_Contract>;
  /** fetch data from the table: "mvn_transfer_history_data" */
  mvn_transfer_history_data: Array<Mvn_Transfer_History_Data>;
  /** fetch aggregated fields from the table: "mvn_transfer_history_data" */
  mvn_transfer_history_data_aggregate: Mvn_Transfer_History_Data_Aggregate;
  /** fetch data from the table: "mvn_transfer_history_data" using primary key columns */
  mvn_transfer_history_data_by_pk?: Maybe<Mvn_Transfer_History_Data>;
  /** fetch data from the table in a streaming manner: "mvn_transfer_history_data" */
  mvn_transfer_history_data_stream: Array<Mvn_Transfer_History_Data>;
  /** fetch data from the table: "satellite" */
  satellite: Array<Satellite>;
  /** fetch aggregated fields from the table: "satellite" */
  satellite_aggregate: Satellite_Aggregate;
  /** fetch data from the table: "satellite" using primary key columns */
  satellite_by_pk?: Maybe<Satellite>;
  /** fetch data from the table: "satellite_rewards" */
  satellite_rewards: Array<Satellite_Rewards>;
  /** fetch aggregated fields from the table: "satellite_rewards" */
  satellite_rewards_aggregate: Satellite_Rewards_Aggregate;
  /** fetch data from the table: "satellite_rewards" using primary key columns */
  satellite_rewards_by_pk?: Maybe<Satellite_Rewards>;
  /** fetch data from the table in a streaming manner: "satellite_rewards" */
  satellite_rewards_stream: Array<Satellite_Rewards>;
  /** fetch data from the table in a streaming manner: "satellite" */
  satellite_stream: Array<Satellite>;
  /** fetch data from the table: "smvn_history_data" */
  smvn_history_data: Array<Smvn_History_Data>;
  /** fetch aggregated fields from the table: "smvn_history_data" */
  smvn_history_data_aggregate: Smvn_History_Data_Aggregate;
  /** fetch data from the table: "smvn_history_data" using primary key columns */
  smvn_history_data_by_pk?: Maybe<Smvn_History_Data>;
  /** fetch data from the table in a streaming manner: "smvn_history_data" */
  smvn_history_data_stream: Array<Smvn_History_Data>;
  /** fetch data from the table: "stake_history_data" */
  stake_history_data: Array<Stake_History_Data>;
  /** fetch aggregated fields from the table: "stake_history_data" */
  stake_history_data_aggregate: Stake_History_Data_Aggregate;
  /** fetch data from the table: "stake_history_data" using primary key columns */
  stake_history_data_by_pk?: Maybe<Stake_History_Data>;
  /** fetch data from the table in a streaming manner: "stake_history_data" */
  stake_history_data_stream: Array<Stake_History_Data>;
  /** fetch data from the table: "token" */
  token: Array<Token>;
  /** fetch aggregated fields from the table: "token" */
  token_aggregate: Token_Aggregate;
  /** fetch data from the table: "token" using primary key columns */
  token_by_pk?: Maybe<Token>;
  /** fetch data from the table in a streaming manner: "token" */
  token_stream: Array<Token>;
  /** fetch data from the table: "treasury" */
  treasury: Array<Treasury>;
  /** fetch aggregated fields from the table: "treasury" */
  treasury_aggregate: Treasury_Aggregate;
  /** fetch data from the table: "treasury_balance" */
  treasury_balance: Array<Treasury_Balance>;
  /** fetch aggregated fields from the table: "treasury_balance" */
  treasury_balance_aggregate: Treasury_Balance_Aggregate;
  /** fetch data from the table: "treasury_balance" using primary key columns */
  treasury_balance_by_pk?: Maybe<Treasury_Balance>;
  /** fetch data from the table in a streaming manner: "treasury_balance" */
  treasury_balance_stream: Array<Treasury_Balance>;
  /** fetch data from the table: "treasury" using primary key columns */
  treasury_by_pk?: Maybe<Treasury>;
  /** fetch data from the table: "treasury_factory" */
  treasury_factory: Array<Treasury_Factory>;
  /** fetch aggregated fields from the table: "treasury_factory" */
  treasury_factory_aggregate: Treasury_Factory_Aggregate;
  /** fetch data from the table: "treasury_factory" using primary key columns */
  treasury_factory_by_pk?: Maybe<Treasury_Factory>;
  /** fetch data from the table: "treasury_factory_general_contract" */
  treasury_factory_general_contract: Array<Treasury_Factory_General_Contract>;
  /** fetch aggregated fields from the table: "treasury_factory_general_contract" */
  treasury_factory_general_contract_aggregate: Treasury_Factory_General_Contract_Aggregate;
  /** fetch data from the table: "treasury_factory_general_contract" using primary key columns */
  treasury_factory_general_contract_by_pk?: Maybe<Treasury_Factory_General_Contract>;
  /** fetch data from the table in a streaming manner: "treasury_factory_general_contract" */
  treasury_factory_general_contract_stream: Array<Treasury_Factory_General_Contract>;
  /** fetch data from the table: "treasury_factory_lambda" */
  treasury_factory_lambda: Array<Treasury_Factory_Lambda>;
  /** fetch aggregated fields from the table: "treasury_factory_lambda" */
  treasury_factory_lambda_aggregate: Treasury_Factory_Lambda_Aggregate;
  /** fetch data from the table: "treasury_factory_lambda" using primary key columns */
  treasury_factory_lambda_by_pk?: Maybe<Treasury_Factory_Lambda>;
  /** fetch data from the table in a streaming manner: "treasury_factory_lambda" */
  treasury_factory_lambda_stream: Array<Treasury_Factory_Lambda>;
  /** fetch data from the table in a streaming manner: "treasury_factory" */
  treasury_factory_stream: Array<Treasury_Factory>;
  /** fetch data from the table: "treasury_factory_treasury_lambda" */
  treasury_factory_treasury_lambda: Array<Treasury_Factory_Treasury_Lambda>;
  /** fetch aggregated fields from the table: "treasury_factory_treasury_lambda" */
  treasury_factory_treasury_lambda_aggregate: Treasury_Factory_Treasury_Lambda_Aggregate;
  /** fetch data from the table: "treasury_factory_treasury_lambda" using primary key columns */
  treasury_factory_treasury_lambda_by_pk?: Maybe<Treasury_Factory_Treasury_Lambda>;
  /** fetch data from the table in a streaming manner: "treasury_factory_treasury_lambda" */
  treasury_factory_treasury_lambda_stream: Array<Treasury_Factory_Treasury_Lambda>;
  /** fetch data from the table: "treasury_factory_whitelist_contract" */
  treasury_factory_whitelist_contract: Array<Treasury_Factory_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "treasury_factory_whitelist_contract" */
  treasury_factory_whitelist_contract_aggregate: Treasury_Factory_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "treasury_factory_whitelist_contract" using primary key columns */
  treasury_factory_whitelist_contract_by_pk?: Maybe<Treasury_Factory_Whitelist_Contract>;
  /** fetch data from the table in a streaming manner: "treasury_factory_whitelist_contract" */
  treasury_factory_whitelist_contract_stream: Array<Treasury_Factory_Whitelist_Contract>;
  /** fetch data from the table: "treasury_factory_whitelist_token_contract" */
  treasury_factory_whitelist_token_contract: Array<Treasury_Factory_Whitelist_Token_Contract>;
  /** fetch aggregated fields from the table: "treasury_factory_whitelist_token_contract" */
  treasury_factory_whitelist_token_contract_aggregate: Treasury_Factory_Whitelist_Token_Contract_Aggregate;
  /** fetch data from the table: "treasury_factory_whitelist_token_contract" using primary key columns */
  treasury_factory_whitelist_token_contract_by_pk?: Maybe<Treasury_Factory_Whitelist_Token_Contract>;
  /** fetch data from the table in a streaming manner: "treasury_factory_whitelist_token_contract" */
  treasury_factory_whitelist_token_contract_stream: Array<Treasury_Factory_Whitelist_Token_Contract>;
  /** fetch data from the table: "treasury_general_contract" */
  treasury_general_contract: Array<Treasury_General_Contract>;
  /** fetch aggregated fields from the table: "treasury_general_contract" */
  treasury_general_contract_aggregate: Treasury_General_Contract_Aggregate;
  /** fetch data from the table: "treasury_general_contract" using primary key columns */
  treasury_general_contract_by_pk?: Maybe<Treasury_General_Contract>;
  /** fetch data from the table in a streaming manner: "treasury_general_contract" */
  treasury_general_contract_stream: Array<Treasury_General_Contract>;
  /** fetch data from the table: "treasury_lambda" */
  treasury_lambda: Array<Treasury_Lambda>;
  /** fetch aggregated fields from the table: "treasury_lambda" */
  treasury_lambda_aggregate: Treasury_Lambda_Aggregate;
  /** fetch data from the table: "treasury_lambda" using primary key columns */
  treasury_lambda_by_pk?: Maybe<Treasury_Lambda>;
  /** fetch data from the table in a streaming manner: "treasury_lambda" */
  treasury_lambda_stream: Array<Treasury_Lambda>;
  /** fetch data from the table in a streaming manner: "treasury" */
  treasury_stream: Array<Treasury>;
  /** fetch data from the table: "treasury_transfer_history_data" */
  treasury_transfer_history_data: Array<Treasury_Transfer_History_Data>;
  /** fetch aggregated fields from the table: "treasury_transfer_history_data" */
  treasury_transfer_history_data_aggregate: Treasury_Transfer_History_Data_Aggregate;
  /** fetch data from the table: "treasury_transfer_history_data" using primary key columns */
  treasury_transfer_history_data_by_pk?: Maybe<Treasury_Transfer_History_Data>;
  /** fetch data from the table in a streaming manner: "treasury_transfer_history_data" */
  treasury_transfer_history_data_stream: Array<Treasury_Transfer_History_Data>;
  /** fetch data from the table: "treasury_whitelist_contract" */
  treasury_whitelist_contract: Array<Treasury_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "treasury_whitelist_contract" */
  treasury_whitelist_contract_aggregate: Treasury_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "treasury_whitelist_contract" using primary key columns */
  treasury_whitelist_contract_by_pk?: Maybe<Treasury_Whitelist_Contract>;
  /** fetch data from the table in a streaming manner: "treasury_whitelist_contract" */
  treasury_whitelist_contract_stream: Array<Treasury_Whitelist_Contract>;
  /** fetch data from the table: "treasury_whitelist_token_contract" */
  treasury_whitelist_token_contract: Array<Treasury_Whitelist_Token_Contract>;
  /** fetch aggregated fields from the table: "treasury_whitelist_token_contract" */
  treasury_whitelist_token_contract_aggregate: Treasury_Whitelist_Token_Contract_Aggregate;
  /** fetch data from the table: "treasury_whitelist_token_contract" using primary key columns */
  treasury_whitelist_token_contract_by_pk?: Maybe<Treasury_Whitelist_Token_Contract>;
  /** fetch data from the table in a streaming manner: "treasury_whitelist_token_contract" */
  treasury_whitelist_token_contract_stream: Array<Treasury_Whitelist_Token_Contract>;
  /** fetch data from the table: "tvl_stats" */
  tvl_stats: Array<Tvl_Stats>;
  /** fetch aggregated fields from the table: "tvl_stats" */
  tvl_stats_aggregate: Tvl_Stats_Aggregate;
  /** fetch data from the table in a streaming manner: "tvl_stats" */
  tvl_stats_stream: Array<Tvl_Stats>;
  /** fetch data from the table: "user_dashboard" */
  user_dashboard: Array<User_Dashboard>;
  /** fetch aggregated fields from the table: "user_dashboard" */
  user_dashboard_aggregate: User_Dashboard_Aggregate;
  /** fetch data from the table in a streaming manner: "user_dashboard" */
  user_dashboard_stream: Array<User_Dashboard>;
  /** fetch data from the table: "vault" */
  vault: Array<Vault>;
  /** fetch aggregated fields from the table: "vault" */
  vault_aggregate: Vault_Aggregate;
  /** fetch data from the table: "vault" using primary key columns */
  vault_by_pk?: Maybe<Vault>;
  /** fetch data from the table: "vault_collateral_view" */
  vault_collateral_view: Array<Vault_Collateral_View>;
  /** fetch aggregated fields from the table: "vault_collateral_view" */
  vault_collateral_view_aggregate: Vault_Collateral_View_Aggregate;
  /** fetch data from the table in a streaming manner: "vault_collateral_view" */
  vault_collateral_view_stream: Array<Vault_Collateral_View>;
  /** fetch data from the table: "vault_depositor" */
  vault_depositor: Array<Vault_Depositor>;
  /** fetch aggregated fields from the table: "vault_depositor" */
  vault_depositor_aggregate: Vault_Depositor_Aggregate;
  /** fetch data from the table: "vault_depositor" using primary key columns */
  vault_depositor_by_pk?: Maybe<Vault_Depositor>;
  /** fetch data from the table in a streaming manner: "vault_depositor" */
  vault_depositor_stream: Array<Vault_Depositor>;
  /** fetch data from the table: "vault_factory" */
  vault_factory: Array<Vault_Factory>;
  /** fetch aggregated fields from the table: "vault_factory" */
  vault_factory_aggregate: Vault_Factory_Aggregate;
  /** fetch data from the table: "vault_factory" using primary key columns */
  vault_factory_by_pk?: Maybe<Vault_Factory>;
  /** fetch data from the table: "vault_factory_general_contract" */
  vault_factory_general_contract: Array<Vault_Factory_General_Contract>;
  /** fetch aggregated fields from the table: "vault_factory_general_contract" */
  vault_factory_general_contract_aggregate: Vault_Factory_General_Contract_Aggregate;
  /** fetch data from the table: "vault_factory_general_contract" using primary key columns */
  vault_factory_general_contract_by_pk?: Maybe<Vault_Factory_General_Contract>;
  /** fetch data from the table in a streaming manner: "vault_factory_general_contract" */
  vault_factory_general_contract_stream: Array<Vault_Factory_General_Contract>;
  /** fetch data from the table: "vault_factory_lambda" */
  vault_factory_lambda: Array<Vault_Factory_Lambda>;
  /** fetch aggregated fields from the table: "vault_factory_lambda" */
  vault_factory_lambda_aggregate: Vault_Factory_Lambda_Aggregate;
  /** fetch data from the table: "vault_factory_lambda" using primary key columns */
  vault_factory_lambda_by_pk?: Maybe<Vault_Factory_Lambda>;
  /** fetch data from the table in a streaming manner: "vault_factory_lambda" */
  vault_factory_lambda_stream: Array<Vault_Factory_Lambda>;
  /** fetch data from the table in a streaming manner: "vault_factory" */
  vault_factory_stream: Array<Vault_Factory>;
  /** fetch data from the table: "vault_factory_vault_lambda" */
  vault_factory_vault_lambda: Array<Vault_Factory_Vault_Lambda>;
  /** fetch aggregated fields from the table: "vault_factory_vault_lambda" */
  vault_factory_vault_lambda_aggregate: Vault_Factory_Vault_Lambda_Aggregate;
  /** fetch data from the table: "vault_factory_vault_lambda" using primary key columns */
  vault_factory_vault_lambda_by_pk?: Maybe<Vault_Factory_Vault_Lambda>;
  /** fetch data from the table in a streaming manner: "vault_factory_vault_lambda" */
  vault_factory_vault_lambda_stream: Array<Vault_Factory_Vault_Lambda>;
  /** fetch data from the table: "vault_factory_whitelist_contract" */
  vault_factory_whitelist_contract: Array<Vault_Factory_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "vault_factory_whitelist_contract" */
  vault_factory_whitelist_contract_aggregate: Vault_Factory_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "vault_factory_whitelist_contract" using primary key columns */
  vault_factory_whitelist_contract_by_pk?: Maybe<Vault_Factory_Whitelist_Contract>;
  /** fetch data from the table in a streaming manner: "vault_factory_whitelist_contract" */
  vault_factory_whitelist_contract_stream: Array<Vault_Factory_Whitelist_Contract>;
  /** fetch data from the table: "vault_lambda" */
  vault_lambda: Array<Vault_Lambda>;
  /** fetch aggregated fields from the table: "vault_lambda" */
  vault_lambda_aggregate: Vault_Lambda_Aggregate;
  /** fetch data from the table: "vault_lambda" using primary key columns */
  vault_lambda_by_pk?: Maybe<Vault_Lambda>;
  /** fetch data from the table in a streaming manner: "vault_lambda" */
  vault_lambda_stream: Array<Vault_Lambda>;
  /** fetch data from the table in a streaming manner: "vault" */
  vault_stream: Array<Vault>;
  /** fetch data from the table: "vesting" */
  vesting: Array<Vesting>;
  /** fetch aggregated fields from the table: "vesting" */
  vesting_aggregate: Vesting_Aggregate;
  /** fetch data from the table: "vesting" using primary key columns */
  vesting_by_pk?: Maybe<Vesting>;
  /** fetch data from the table: "vesting_general_contract" */
  vesting_general_contract: Array<Vesting_General_Contract>;
  /** fetch aggregated fields from the table: "vesting_general_contract" */
  vesting_general_contract_aggregate: Vesting_General_Contract_Aggregate;
  /** fetch data from the table: "vesting_general_contract" using primary key columns */
  vesting_general_contract_by_pk?: Maybe<Vesting_General_Contract>;
  /** fetch data from the table in a streaming manner: "vesting_general_contract" */
  vesting_general_contract_stream: Array<Vesting_General_Contract>;
  /** fetch data from the table: "vesting_lambda" */
  vesting_lambda: Array<Vesting_Lambda>;
  /** fetch aggregated fields from the table: "vesting_lambda" */
  vesting_lambda_aggregate: Vesting_Lambda_Aggregate;
  /** fetch data from the table: "vesting_lambda" using primary key columns */
  vesting_lambda_by_pk?: Maybe<Vesting_Lambda>;
  /** fetch data from the table in a streaming manner: "vesting_lambda" */
  vesting_lambda_stream: Array<Vesting_Lambda>;
  /** fetch data from the table in a streaming manner: "vesting" */
  vesting_stream: Array<Vesting>;
  /** fetch data from the table: "vesting_vestee" */
  vesting_vestee: Array<Vesting_Vestee>;
  /** fetch aggregated fields from the table: "vesting_vestee" */
  vesting_vestee_aggregate: Vesting_Vestee_Aggregate;
  /** fetch data from the table: "vesting_vestee" using primary key columns */
  vesting_vestee_by_pk?: Maybe<Vesting_Vestee>;
  /** fetch data from the table in a streaming manner: "vesting_vestee" */
  vesting_vestee_stream: Array<Vesting_Vestee>;
  /** fetch data from the table: "vesting_whitelist_contract" */
  vesting_whitelist_contract: Array<Vesting_Whitelist_Contract>;
  /** fetch aggregated fields from the table: "vesting_whitelist_contract" */
  vesting_whitelist_contract_aggregate: Vesting_Whitelist_Contract_Aggregate;
  /** fetch data from the table: "vesting_whitelist_contract" using primary key columns */
  vesting_whitelist_contract_by_pk?: Maybe<Vesting_Whitelist_Contract>;
  /** fetch data from the table in a streaming manner: "vesting_whitelist_contract" */
  vesting_whitelist_contract_stream: Array<Vesting_Whitelist_Contract>;
  /** fetch data from the table: "whitelist_developer" */
  whitelist_developer: Array<Whitelist_Developer>;
  /** fetch aggregated fields from the table: "whitelist_developer" */
  whitelist_developer_aggregate: Whitelist_Developer_Aggregate;
  /** fetch data from the table: "whitelist_developer" using primary key columns */
  whitelist_developer_by_pk?: Maybe<Whitelist_Developer>;
  /** fetch data from the table in a streaming manner: "whitelist_developer" */
  whitelist_developer_stream: Array<Whitelist_Developer>;
};


export type Subscription_RootAggregatorArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Order_By>>;
  where?: InputMaybe<Aggregator_Bool_Exp>;
};


export type Subscription_RootAggregator_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Order_By>>;
  where?: InputMaybe<Aggregator_Bool_Exp>;
};


export type Subscription_RootAggregator_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAggregator_FactoryArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_Bool_Exp>;
};


export type Subscription_RootAggregator_Factory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_Bool_Exp>;
};


export type Subscription_RootAggregator_Factory_Aggregator_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_Aggregator_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_Aggregator_Lambda_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_Aggregator_Lambda_Bool_Exp>;
};


export type Subscription_RootAggregator_Factory_Aggregator_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_Aggregator_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_Aggregator_Lambda_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_Aggregator_Lambda_Bool_Exp>;
};


export type Subscription_RootAggregator_Factory_Aggregator_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAggregator_Factory_Aggregator_Lambda_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Aggregator_Factory_Aggregator_Lambda_Stream_Cursor_Input>>;
  where?: InputMaybe<Aggregator_Factory_Aggregator_Lambda_Bool_Exp>;
};


export type Subscription_RootAggregator_Factory_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAggregator_Factory_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_General_Contract_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_General_Contract_Bool_Exp>;
};


export type Subscription_RootAggregator_Factory_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_General_Contract_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_General_Contract_Bool_Exp>;
};


export type Subscription_RootAggregator_Factory_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAggregator_Factory_General_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Aggregator_Factory_General_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Aggregator_Factory_General_Contract_Bool_Exp>;
};


export type Subscription_RootAggregator_Factory_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_Lambda_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_Lambda_Bool_Exp>;
};


export type Subscription_RootAggregator_Factory_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_Lambda_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_Lambda_Bool_Exp>;
};


export type Subscription_RootAggregator_Factory_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAggregator_Factory_Lambda_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Aggregator_Factory_Lambda_Stream_Cursor_Input>>;
  where?: InputMaybe<Aggregator_Factory_Lambda_Bool_Exp>;
};


export type Subscription_RootAggregator_Factory_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Aggregator_Factory_Stream_Cursor_Input>>;
  where?: InputMaybe<Aggregator_Factory_Bool_Exp>;
};


export type Subscription_RootAggregator_Factory_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootAggregator_Factory_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Factory_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Factory_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Aggregator_Factory_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootAggregator_Factory_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAggregator_Factory_Whitelist_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Aggregator_Factory_Whitelist_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Aggregator_Factory_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootAggregator_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_General_Contract_Order_By>>;
  where?: InputMaybe<Aggregator_General_Contract_Bool_Exp>;
};


export type Subscription_RootAggregator_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_General_Contract_Order_By>>;
  where?: InputMaybe<Aggregator_General_Contract_Bool_Exp>;
};


export type Subscription_RootAggregator_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAggregator_General_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Aggregator_General_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Aggregator_General_Contract_Bool_Exp>;
};


export type Subscription_RootAggregator_History_DataArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_History_Data_Order_By>>;
  where?: InputMaybe<Aggregator_History_Data_Bool_Exp>;
};


export type Subscription_RootAggregator_History_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_History_Data_Order_By>>;
  where?: InputMaybe<Aggregator_History_Data_Bool_Exp>;
};


export type Subscription_RootAggregator_History_Data_By_PkArgs = {
  id: Scalars['bigint']['input'];
  timestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootAggregator_History_Data_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Aggregator_History_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Aggregator_History_Data_Bool_Exp>;
};


export type Subscription_RootAggregator_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Lambda_Order_By>>;
  where?: InputMaybe<Aggregator_Lambda_Bool_Exp>;
};


export type Subscription_RootAggregator_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Lambda_Order_By>>;
  where?: InputMaybe<Aggregator_Lambda_Bool_Exp>;
};


export type Subscription_RootAggregator_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAggregator_Lambda_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Aggregator_Lambda_Stream_Cursor_Input>>;
  where?: InputMaybe<Aggregator_Lambda_Bool_Exp>;
};


export type Subscription_RootAggregator_OracleArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Oracle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Oracle_Order_By>>;
  where?: InputMaybe<Aggregator_Oracle_Bool_Exp>;
};


export type Subscription_RootAggregator_Oracle_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Oracle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Oracle_Order_By>>;
  where?: InputMaybe<Aggregator_Oracle_Bool_Exp>;
};


export type Subscription_RootAggregator_Oracle_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAggregator_Oracle_ObservationArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Oracle_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Oracle_Observation_Order_By>>;
  where?: InputMaybe<Aggregator_Oracle_Observation_Bool_Exp>;
};


export type Subscription_RootAggregator_Oracle_Observation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Oracle_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Oracle_Observation_Order_By>>;
  where?: InputMaybe<Aggregator_Oracle_Observation_Bool_Exp>;
};


export type Subscription_RootAggregator_Oracle_Observation_By_PkArgs = {
  id: Scalars['bigint']['input'];
  timestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootAggregator_Oracle_Observation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Aggregator_Oracle_Observation_Stream_Cursor_Input>>;
  where?: InputMaybe<Aggregator_Oracle_Observation_Bool_Exp>;
};


export type Subscription_RootAggregator_Oracle_RewardArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Oracle_Reward_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Oracle_Reward_Order_By>>;
  where?: InputMaybe<Aggregator_Oracle_Reward_Bool_Exp>;
};


export type Subscription_RootAggregator_Oracle_Reward_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Oracle_Reward_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Oracle_Reward_Order_By>>;
  where?: InputMaybe<Aggregator_Oracle_Reward_Bool_Exp>;
};


export type Subscription_RootAggregator_Oracle_Reward_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAggregator_Oracle_Reward_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Aggregator_Oracle_Reward_Stream_Cursor_Input>>;
  where?: InputMaybe<Aggregator_Oracle_Reward_Bool_Exp>;
};


export type Subscription_RootAggregator_Oracle_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Aggregator_Oracle_Stream_Cursor_Input>>;
  where?: InputMaybe<Aggregator_Oracle_Bool_Exp>;
};


export type Subscription_RootAggregator_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Aggregator_Stream_Cursor_Input>>;
  where?: InputMaybe<Aggregator_Bool_Exp>;
};


export type Subscription_RootAggregator_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Aggregator_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootAggregator_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Aggregator_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregator_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Aggregator_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootAggregator_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAggregator_Whitelist_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Aggregator_Whitelist_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Aggregator_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootBreak_GlassArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Order_By>>;
  where?: InputMaybe<Break_Glass_Bool_Exp>;
};


export type Subscription_RootBreak_Glass_ActionArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Bool_Exp>;
};


export type Subscription_RootBreak_Glass_Action_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Bool_Exp>;
};


export type Subscription_RootBreak_Glass_Action_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootBreak_Glass_Action_ParameterArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Parameter_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Parameter_Bool_Exp>;
};


export type Subscription_RootBreak_Glass_Action_Parameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Parameter_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Parameter_Bool_Exp>;
};


export type Subscription_RootBreak_Glass_Action_Parameter_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootBreak_Glass_Action_Parameter_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Break_Glass_Action_Parameter_Stream_Cursor_Input>>;
  where?: InputMaybe<Break_Glass_Action_Parameter_Bool_Exp>;
};


export type Subscription_RootBreak_Glass_Action_SignerArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Signer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Signer_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Signer_Bool_Exp>;
};


export type Subscription_RootBreak_Glass_Action_Signer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Signer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Signer_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Signer_Bool_Exp>;
};


export type Subscription_RootBreak_Glass_Action_Signer_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootBreak_Glass_Action_Signer_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Break_Glass_Action_Signer_Stream_Cursor_Input>>;
  where?: InputMaybe<Break_Glass_Action_Signer_Bool_Exp>;
};


export type Subscription_RootBreak_Glass_Action_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Break_Glass_Action_Stream_Cursor_Input>>;
  where?: InputMaybe<Break_Glass_Action_Bool_Exp>;
};


export type Subscription_RootBreak_Glass_Action_Temp_ParameterArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Temp_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Temp_Parameter_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Temp_Parameter_Bool_Exp>;
};


export type Subscription_RootBreak_Glass_Action_Temp_Parameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Action_Temp_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Action_Temp_Parameter_Order_By>>;
  where?: InputMaybe<Break_Glass_Action_Temp_Parameter_Bool_Exp>;
};


export type Subscription_RootBreak_Glass_Action_Temp_Parameter_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootBreak_Glass_Action_Temp_Parameter_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Break_Glass_Action_Temp_Parameter_Stream_Cursor_Input>>;
  where?: InputMaybe<Break_Glass_Action_Temp_Parameter_Bool_Exp>;
};


export type Subscription_RootBreak_Glass_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Order_By>>;
  where?: InputMaybe<Break_Glass_Bool_Exp>;
};


export type Subscription_RootBreak_Glass_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootBreak_Glass_Council_MemberArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Council_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Council_Member_Order_By>>;
  where?: InputMaybe<Break_Glass_Council_Member_Bool_Exp>;
};


export type Subscription_RootBreak_Glass_Council_Member_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Council_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Council_Member_Order_By>>;
  where?: InputMaybe<Break_Glass_Council_Member_Bool_Exp>;
};


export type Subscription_RootBreak_Glass_Council_Member_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootBreak_Glass_Council_Member_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Break_Glass_Council_Member_Stream_Cursor_Input>>;
  where?: InputMaybe<Break_Glass_Council_Member_Bool_Exp>;
};


export type Subscription_RootBreak_Glass_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_General_Contract_Order_By>>;
  where?: InputMaybe<Break_Glass_General_Contract_Bool_Exp>;
};


export type Subscription_RootBreak_Glass_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_General_Contract_Order_By>>;
  where?: InputMaybe<Break_Glass_General_Contract_Bool_Exp>;
};


export type Subscription_RootBreak_Glass_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootBreak_Glass_General_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Break_Glass_General_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Break_Glass_General_Contract_Bool_Exp>;
};


export type Subscription_RootBreak_Glass_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Lambda_Order_By>>;
  where?: InputMaybe<Break_Glass_Lambda_Bool_Exp>;
};


export type Subscription_RootBreak_Glass_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Lambda_Order_By>>;
  where?: InputMaybe<Break_Glass_Lambda_Bool_Exp>;
};


export type Subscription_RootBreak_Glass_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootBreak_Glass_Lambda_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Break_Glass_Lambda_Stream_Cursor_Input>>;
  where?: InputMaybe<Break_Glass_Lambda_Bool_Exp>;
};


export type Subscription_RootBreak_Glass_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Break_Glass_Stream_Cursor_Input>>;
  where?: InputMaybe<Break_Glass_Bool_Exp>;
};


export type Subscription_RootBreak_Glass_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Break_Glass_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootBreak_Glass_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Break_Glass_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Break_Glass_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Break_Glass_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootBreak_Glass_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootBreak_Glass_Whitelist_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Break_Glass_Whitelist_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Break_Glass_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootCouncilArgs = {
  distinct_on?: InputMaybe<Array<Council_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Order_By>>;
  where?: InputMaybe<Council_Bool_Exp>;
};


export type Subscription_RootCouncil_ActionArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Order_By>>;
  where?: InputMaybe<Council_Action_Bool_Exp>;
};


export type Subscription_RootCouncil_Action_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Order_By>>;
  where?: InputMaybe<Council_Action_Bool_Exp>;
};


export type Subscription_RootCouncil_Action_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootCouncil_Action_ParameterArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Parameter_Order_By>>;
  where?: InputMaybe<Council_Action_Parameter_Bool_Exp>;
};


export type Subscription_RootCouncil_Action_Parameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Parameter_Order_By>>;
  where?: InputMaybe<Council_Action_Parameter_Bool_Exp>;
};


export type Subscription_RootCouncil_Action_Parameter_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootCouncil_Action_Parameter_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Council_Action_Parameter_Stream_Cursor_Input>>;
  where?: InputMaybe<Council_Action_Parameter_Bool_Exp>;
};


export type Subscription_RootCouncil_Action_SignerArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Signer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Signer_Order_By>>;
  where?: InputMaybe<Council_Action_Signer_Bool_Exp>;
};


export type Subscription_RootCouncil_Action_Signer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Signer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Signer_Order_By>>;
  where?: InputMaybe<Council_Action_Signer_Bool_Exp>;
};


export type Subscription_RootCouncil_Action_Signer_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootCouncil_Action_Signer_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Council_Action_Signer_Stream_Cursor_Input>>;
  where?: InputMaybe<Council_Action_Signer_Bool_Exp>;
};


export type Subscription_RootCouncil_Action_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Council_Action_Stream_Cursor_Input>>;
  where?: InputMaybe<Council_Action_Bool_Exp>;
};


export type Subscription_RootCouncil_Action_Temp_ParameterArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Temp_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Temp_Parameter_Order_By>>;
  where?: InputMaybe<Council_Action_Temp_Parameter_Bool_Exp>;
};


export type Subscription_RootCouncil_Action_Temp_Parameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Action_Temp_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Action_Temp_Parameter_Order_By>>;
  where?: InputMaybe<Council_Action_Temp_Parameter_Bool_Exp>;
};


export type Subscription_RootCouncil_Action_Temp_Parameter_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootCouncil_Action_Temp_Parameter_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Council_Action_Temp_Parameter_Stream_Cursor_Input>>;
  where?: InputMaybe<Council_Action_Temp_Parameter_Bool_Exp>;
};


export type Subscription_RootCouncil_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Order_By>>;
  where?: InputMaybe<Council_Bool_Exp>;
};


export type Subscription_RootCouncil_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootCouncil_Council_MemberArgs = {
  distinct_on?: InputMaybe<Array<Council_Council_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Council_Member_Order_By>>;
  where?: InputMaybe<Council_Council_Member_Bool_Exp>;
};


export type Subscription_RootCouncil_Council_Member_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Council_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Council_Member_Order_By>>;
  where?: InputMaybe<Council_Council_Member_Bool_Exp>;
};


export type Subscription_RootCouncil_Council_Member_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootCouncil_Council_Member_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Council_Council_Member_Stream_Cursor_Input>>;
  where?: InputMaybe<Council_Council_Member_Bool_Exp>;
};


export type Subscription_RootCouncil_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Council_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_General_Contract_Order_By>>;
  where?: InputMaybe<Council_General_Contract_Bool_Exp>;
};


export type Subscription_RootCouncil_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_General_Contract_Order_By>>;
  where?: InputMaybe<Council_General_Contract_Bool_Exp>;
};


export type Subscription_RootCouncil_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootCouncil_General_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Council_General_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Council_General_Contract_Bool_Exp>;
};


export type Subscription_RootCouncil_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Council_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Lambda_Order_By>>;
  where?: InputMaybe<Council_Lambda_Bool_Exp>;
};


export type Subscription_RootCouncil_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Lambda_Order_By>>;
  where?: InputMaybe<Council_Lambda_Bool_Exp>;
};


export type Subscription_RootCouncil_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootCouncil_Lambda_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Council_Lambda_Stream_Cursor_Input>>;
  where?: InputMaybe<Council_Lambda_Bool_Exp>;
};


export type Subscription_RootCouncil_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Council_Stream_Cursor_Input>>;
  where?: InputMaybe<Council_Bool_Exp>;
};


export type Subscription_RootCouncil_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Council_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Council_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootCouncil_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Council_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Council_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Council_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootCouncil_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootCouncil_Whitelist_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Council_Whitelist_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Council_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootDelegationArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Order_By>>;
  where?: InputMaybe<Delegation_Bool_Exp>;
};


export type Subscription_RootDelegation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Order_By>>;
  where?: InputMaybe<Delegation_Bool_Exp>;
};


export type Subscription_RootDelegation_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootDelegation_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Delegation_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_General_Contract_Order_By>>;
  where?: InputMaybe<Delegation_General_Contract_Bool_Exp>;
};


export type Subscription_RootDelegation_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delegation_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_General_Contract_Order_By>>;
  where?: InputMaybe<Delegation_General_Contract_Bool_Exp>;
};


export type Subscription_RootDelegation_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootDelegation_General_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Delegation_General_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Delegation_General_Contract_Bool_Exp>;
};


export type Subscription_RootDelegation_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Lambda_Order_By>>;
  where?: InputMaybe<Delegation_Lambda_Bool_Exp>;
};


export type Subscription_RootDelegation_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Lambda_Order_By>>;
  where?: InputMaybe<Delegation_Lambda_Bool_Exp>;
};


export type Subscription_RootDelegation_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootDelegation_Lambda_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Delegation_Lambda_Stream_Cursor_Input>>;
  where?: InputMaybe<Delegation_Lambda_Bool_Exp>;
};


export type Subscription_RootDelegation_RecordArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Record_Order_By>>;
  where?: InputMaybe<Delegation_Record_Bool_Exp>;
};


export type Subscription_RootDelegation_Record_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Record_Order_By>>;
  where?: InputMaybe<Delegation_Record_Bool_Exp>;
};


export type Subscription_RootDelegation_Record_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootDelegation_Record_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Delegation_Record_Stream_Cursor_Input>>;
  where?: InputMaybe<Delegation_Record_Bool_Exp>;
};


export type Subscription_RootDelegation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Delegation_Stream_Cursor_Input>>;
  where?: InputMaybe<Delegation_Bool_Exp>;
};


export type Subscription_RootDelegation_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Delegation_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootDelegation_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delegation_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delegation_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Delegation_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootDelegation_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootDelegation_Whitelist_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Delegation_Whitelist_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Delegation_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootDipdup_ContractArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Contract_Order_By>>;
  where?: InputMaybe<Dipdup_Contract_Bool_Exp>;
};


export type Subscription_RootDipdup_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Contract_Order_By>>;
  where?: InputMaybe<Dipdup_Contract_Bool_Exp>;
};


export type Subscription_RootDipdup_Contract_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootDipdup_Contract_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Contract_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Contract_Metadata_Order_By>>;
  where?: InputMaybe<Dipdup_Contract_Metadata_Bool_Exp>;
};


export type Subscription_RootDipdup_Contract_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Contract_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Contract_Metadata_Order_By>>;
  where?: InputMaybe<Dipdup_Contract_Metadata_Bool_Exp>;
};


export type Subscription_RootDipdup_Contract_Metadata_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootDipdup_Contract_Metadata_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dipdup_Contract_Metadata_Stream_Cursor_Input>>;
  where?: InputMaybe<Dipdup_Contract_Metadata_Bool_Exp>;
};


export type Subscription_RootDipdup_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dipdup_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Dipdup_Contract_Bool_Exp>;
};


export type Subscription_RootDipdup_ExceptionArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Exception_Order_By>>;
  where?: InputMaybe<Dipdup_Exception_Bool_Exp>;
};


export type Subscription_RootDipdup_Exception_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Exception_Order_By>>;
  where?: InputMaybe<Dipdup_Exception_Bool_Exp>;
};


export type Subscription_RootDipdup_Exception_By_PkArgs = {
  id: Scalars['bigint']['input'];
  timestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootDipdup_Exception_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dipdup_Exception_Stream_Cursor_Input>>;
  where?: InputMaybe<Dipdup_Exception_Bool_Exp>;
};


export type Subscription_RootDipdup_HeadArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Head_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Head_Order_By>>;
  where?: InputMaybe<Dipdup_Head_Bool_Exp>;
};


export type Subscription_RootDipdup_Head_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Head_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Head_Order_By>>;
  where?: InputMaybe<Dipdup_Head_Bool_Exp>;
};


export type Subscription_RootDipdup_Head_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootDipdup_Head_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dipdup_Head_Stream_Cursor_Input>>;
  where?: InputMaybe<Dipdup_Head_Bool_Exp>;
};


export type Subscription_RootDipdup_IndexArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Index_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Index_Order_By>>;
  where?: InputMaybe<Dipdup_Index_Bool_Exp>;
};


export type Subscription_RootDipdup_Index_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Index_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Index_Order_By>>;
  where?: InputMaybe<Dipdup_Index_Bool_Exp>;
};


export type Subscription_RootDipdup_Index_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootDipdup_Index_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dipdup_Index_Stream_Cursor_Input>>;
  where?: InputMaybe<Dipdup_Index_Bool_Exp>;
};


export type Subscription_RootDipdup_MetaArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Meta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Meta_Order_By>>;
  where?: InputMaybe<Dipdup_Meta_Bool_Exp>;
};


export type Subscription_RootDipdup_Meta_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Meta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Meta_Order_By>>;
  where?: InputMaybe<Dipdup_Meta_Bool_Exp>;
};


export type Subscription_RootDipdup_Meta_By_PkArgs = {
  key: Scalars['String']['input'];
};


export type Subscription_RootDipdup_Meta_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dipdup_Meta_Stream_Cursor_Input>>;
  where?: InputMaybe<Dipdup_Meta_Bool_Exp>;
};


export type Subscription_RootDipdup_Model_UpdateArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Model_Update_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Model_Update_Order_By>>;
  where?: InputMaybe<Dipdup_Model_Update_Bool_Exp>;
};


export type Subscription_RootDipdup_Model_Update_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Model_Update_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Model_Update_Order_By>>;
  where?: InputMaybe<Dipdup_Model_Update_Bool_Exp>;
};


export type Subscription_RootDipdup_Model_Update_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootDipdup_Model_Update_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dipdup_Model_Update_Stream_Cursor_Input>>;
  where?: InputMaybe<Dipdup_Model_Update_Bool_Exp>;
};


export type Subscription_RootDipdup_SchemaArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Schema_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Schema_Order_By>>;
  where?: InputMaybe<Dipdup_Schema_Bool_Exp>;
};


export type Subscription_RootDipdup_Schema_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Schema_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Schema_Order_By>>;
  where?: InputMaybe<Dipdup_Schema_Bool_Exp>;
};


export type Subscription_RootDipdup_Schema_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootDipdup_Schema_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dipdup_Schema_Stream_Cursor_Input>>;
  where?: InputMaybe<Dipdup_Schema_Bool_Exp>;
};


export type Subscription_RootDipdup_StatusArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Status_Order_By>>;
  where?: InputMaybe<Dipdup_Status_Bool_Exp>;
};


export type Subscription_RootDipdup_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Status_Order_By>>;
  where?: InputMaybe<Dipdup_Status_Bool_Exp>;
};


export type Subscription_RootDipdup_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dipdup_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Dipdup_Status_Bool_Exp>;
};


export type Subscription_RootDipdup_Token_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Token_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Token_Metadata_Order_By>>;
  where?: InputMaybe<Dipdup_Token_Metadata_Bool_Exp>;
};


export type Subscription_RootDipdup_Token_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dipdup_Token_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dipdup_Token_Metadata_Order_By>>;
  where?: InputMaybe<Dipdup_Token_Metadata_Bool_Exp>;
};


export type Subscription_RootDipdup_Token_Metadata_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootDipdup_Token_Metadata_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dipdup_Token_Metadata_Stream_Cursor_Input>>;
  where?: InputMaybe<Dipdup_Token_Metadata_Bool_Exp>;
};


export type Subscription_RootDoormanArgs = {
  distinct_on?: InputMaybe<Array<Doorman_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_Order_By>>;
  where?: InputMaybe<Doorman_Bool_Exp>;
};


export type Subscription_RootDoorman_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Doorman_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_Order_By>>;
  where?: InputMaybe<Doorman_Bool_Exp>;
};


export type Subscription_RootDoorman_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootDoorman_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Doorman_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_General_Contract_Order_By>>;
  where?: InputMaybe<Doorman_General_Contract_Bool_Exp>;
};


export type Subscription_RootDoorman_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Doorman_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_General_Contract_Order_By>>;
  where?: InputMaybe<Doorman_General_Contract_Bool_Exp>;
};


export type Subscription_RootDoorman_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootDoorman_General_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Doorman_General_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Doorman_General_Contract_Bool_Exp>;
};


export type Subscription_RootDoorman_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Doorman_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_Lambda_Order_By>>;
  where?: InputMaybe<Doorman_Lambda_Bool_Exp>;
};


export type Subscription_RootDoorman_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Doorman_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_Lambda_Order_By>>;
  where?: InputMaybe<Doorman_Lambda_Bool_Exp>;
};


export type Subscription_RootDoorman_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootDoorman_Lambda_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Doorman_Lambda_Stream_Cursor_Input>>;
  where?: InputMaybe<Doorman_Lambda_Bool_Exp>;
};


export type Subscription_RootDoorman_Stake_AccountArgs = {
  distinct_on?: InputMaybe<Array<Doorman_Stake_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_Stake_Account_Order_By>>;
  where?: InputMaybe<Doorman_Stake_Account_Bool_Exp>;
};


export type Subscription_RootDoorman_Stake_Account_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Doorman_Stake_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_Stake_Account_Order_By>>;
  where?: InputMaybe<Doorman_Stake_Account_Bool_Exp>;
};


export type Subscription_RootDoorman_Stake_Account_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootDoorman_Stake_Account_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Doorman_Stake_Account_Stream_Cursor_Input>>;
  where?: InputMaybe<Doorman_Stake_Account_Bool_Exp>;
};


export type Subscription_RootDoorman_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Doorman_Stream_Cursor_Input>>;
  where?: InputMaybe<Doorman_Bool_Exp>;
};


export type Subscription_RootDoorman_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Doorman_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Doorman_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootDoorman_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Doorman_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doorman_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Doorman_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootDoorman_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootDoorman_Whitelist_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Doorman_Whitelist_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Doorman_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootEmergency_GovernanceArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Bool_Exp>;
};


export type Subscription_RootEmergency_Governance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Bool_Exp>;
};


export type Subscription_RootEmergency_Governance_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootEmergency_Governance_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_General_Contract_Order_By>>;
  where?: InputMaybe<Emergency_Governance_General_Contract_Bool_Exp>;
};


export type Subscription_RootEmergency_Governance_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_General_Contract_Order_By>>;
  where?: InputMaybe<Emergency_Governance_General_Contract_Bool_Exp>;
};


export type Subscription_RootEmergency_Governance_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootEmergency_Governance_General_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Emergency_Governance_General_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Emergency_Governance_General_Contract_Bool_Exp>;
};


export type Subscription_RootEmergency_Governance_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Lambda_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Lambda_Bool_Exp>;
};


export type Subscription_RootEmergency_Governance_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Lambda_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Lambda_Bool_Exp>;
};


export type Subscription_RootEmergency_Governance_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootEmergency_Governance_Lambda_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Emergency_Governance_Lambda_Stream_Cursor_Input>>;
  where?: InputMaybe<Emergency_Governance_Lambda_Bool_Exp>;
};


export type Subscription_RootEmergency_Governance_RecordArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Record_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Record_Bool_Exp>;
};


export type Subscription_RootEmergency_Governance_Record_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Record_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Record_Bool_Exp>;
};


export type Subscription_RootEmergency_Governance_Record_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootEmergency_Governance_Record_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Emergency_Governance_Record_Stream_Cursor_Input>>;
  where?: InputMaybe<Emergency_Governance_Record_Bool_Exp>;
};


export type Subscription_RootEmergency_Governance_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Emergency_Governance_Stream_Cursor_Input>>;
  where?: InputMaybe<Emergency_Governance_Bool_Exp>;
};


export type Subscription_RootEmergency_Governance_VoteArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Vote_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Vote_Bool_Exp>;
};


export type Subscription_RootEmergency_Governance_Vote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Vote_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Vote_Bool_Exp>;
};


export type Subscription_RootEmergency_Governance_Vote_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootEmergency_Governance_Vote_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Emergency_Governance_Vote_Stream_Cursor_Input>>;
  where?: InputMaybe<Emergency_Governance_Vote_Bool_Exp>;
};


export type Subscription_RootEmergency_Governance_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootEmergency_Governance_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emergency_Governance_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emergency_Governance_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Emergency_Governance_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootEmergency_Governance_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootEmergency_Governance_Whitelist_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Emergency_Governance_Whitelist_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Emergency_Governance_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootFarmArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


export type Subscription_RootFarm_AccountArgs = {
  distinct_on?: InputMaybe<Array<Farm_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Account_Order_By>>;
  where?: InputMaybe<Farm_Account_Bool_Exp>;
};


export type Subscription_RootFarm_Account_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Account_Order_By>>;
  where?: InputMaybe<Farm_Account_Bool_Exp>;
};


export type Subscription_RootFarm_Account_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootFarm_Account_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Farm_Account_Stream_Cursor_Input>>;
  where?: InputMaybe<Farm_Account_Bool_Exp>;
};


export type Subscription_RootFarm_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


export type Subscription_RootFarm_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootFarm_FactoryArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_Order_By>>;
  where?: InputMaybe<Farm_Factory_Bool_Exp>;
};


export type Subscription_RootFarm_Factory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_Order_By>>;
  where?: InputMaybe<Farm_Factory_Bool_Exp>;
};


export type Subscription_RootFarm_Factory_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootFarm_Factory_Farm_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_Farm_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_Farm_Lambda_Order_By>>;
  where?: InputMaybe<Farm_Factory_Farm_Lambda_Bool_Exp>;
};


export type Subscription_RootFarm_Factory_Farm_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_Farm_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_Farm_Lambda_Order_By>>;
  where?: InputMaybe<Farm_Factory_Farm_Lambda_Bool_Exp>;
};


export type Subscription_RootFarm_Factory_Farm_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootFarm_Factory_Farm_Lambda_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Farm_Factory_Farm_Lambda_Stream_Cursor_Input>>;
  where?: InputMaybe<Farm_Factory_Farm_Lambda_Bool_Exp>;
};


export type Subscription_RootFarm_Factory_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_General_Contract_Order_By>>;
  where?: InputMaybe<Farm_Factory_General_Contract_Bool_Exp>;
};


export type Subscription_RootFarm_Factory_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_General_Contract_Order_By>>;
  where?: InputMaybe<Farm_Factory_General_Contract_Bool_Exp>;
};


export type Subscription_RootFarm_Factory_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootFarm_Factory_General_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Farm_Factory_General_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Farm_Factory_General_Contract_Bool_Exp>;
};


export type Subscription_RootFarm_Factory_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_Lambda_Order_By>>;
  where?: InputMaybe<Farm_Factory_Lambda_Bool_Exp>;
};


export type Subscription_RootFarm_Factory_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_Lambda_Order_By>>;
  where?: InputMaybe<Farm_Factory_Lambda_Bool_Exp>;
};


export type Subscription_RootFarm_Factory_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootFarm_Factory_Lambda_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Farm_Factory_Lambda_Stream_Cursor_Input>>;
  where?: InputMaybe<Farm_Factory_Lambda_Bool_Exp>;
};


export type Subscription_RootFarm_Factory_M_Farm_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_M_Farm_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_M_Farm_Lambda_Order_By>>;
  where?: InputMaybe<Farm_Factory_M_Farm_Lambda_Bool_Exp>;
};


export type Subscription_RootFarm_Factory_M_Farm_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_M_Farm_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_M_Farm_Lambda_Order_By>>;
  where?: InputMaybe<Farm_Factory_M_Farm_Lambda_Bool_Exp>;
};


export type Subscription_RootFarm_Factory_M_Farm_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootFarm_Factory_M_Farm_Lambda_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Farm_Factory_M_Farm_Lambda_Stream_Cursor_Input>>;
  where?: InputMaybe<Farm_Factory_M_Farm_Lambda_Bool_Exp>;
};


export type Subscription_RootFarm_Factory_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Farm_Factory_Stream_Cursor_Input>>;
  where?: InputMaybe<Farm_Factory_Bool_Exp>;
};


export type Subscription_RootFarm_Factory_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Farm_Factory_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootFarm_Factory_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Factory_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Factory_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Farm_Factory_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootFarm_Factory_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootFarm_Factory_Whitelist_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Farm_Factory_Whitelist_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Farm_Factory_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootFarm_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Farm_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_General_Contract_Order_By>>;
  where?: InputMaybe<Farm_General_Contract_Bool_Exp>;
};


export type Subscription_RootFarm_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_General_Contract_Order_By>>;
  where?: InputMaybe<Farm_General_Contract_Bool_Exp>;
};


export type Subscription_RootFarm_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootFarm_General_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Farm_General_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Farm_General_Contract_Bool_Exp>;
};


export type Subscription_RootFarm_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Farm_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Lambda_Order_By>>;
  where?: InputMaybe<Farm_Lambda_Bool_Exp>;
};


export type Subscription_RootFarm_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Lambda_Order_By>>;
  where?: InputMaybe<Farm_Lambda_Bool_Exp>;
};


export type Subscription_RootFarm_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootFarm_Lambda_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Farm_Lambda_Stream_Cursor_Input>>;
  where?: InputMaybe<Farm_Lambda_Bool_Exp>;
};


export type Subscription_RootFarm_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Farm_Stream_Cursor_Input>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


export type Subscription_RootFarm_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Farm_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Farm_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootFarm_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Farm_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootFarm_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootFarm_Whitelist_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Farm_Whitelist_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Farm_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootGovernanceArgs = {
  distinct_on?: InputMaybe<Array<Governance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Order_By>>;
  where?: InputMaybe<Governance_Bool_Exp>;
};


export type Subscription_RootGovernance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Order_By>>;
  where?: InputMaybe<Governance_Bool_Exp>;
};


export type Subscription_RootGovernance_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_FinancialArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Order_By>>;
  where?: InputMaybe<Governance_Financial_Bool_Exp>;
};


export type Subscription_RootGovernance_Financial_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Order_By>>;
  where?: InputMaybe<Governance_Financial_Bool_Exp>;
};


export type Subscription_RootGovernance_Financial_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_Financial_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_General_Contract_Order_By>>;
  where?: InputMaybe<Governance_Financial_General_Contract_Bool_Exp>;
};


export type Subscription_RootGovernance_Financial_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_General_Contract_Order_By>>;
  where?: InputMaybe<Governance_Financial_General_Contract_Bool_Exp>;
};


export type Subscription_RootGovernance_Financial_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_Financial_General_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Financial_General_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Financial_General_Contract_Bool_Exp>;
};


export type Subscription_RootGovernance_Financial_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Lambda_Order_By>>;
  where?: InputMaybe<Governance_Financial_Lambda_Bool_Exp>;
};


export type Subscription_RootGovernance_Financial_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Lambda_Order_By>>;
  where?: InputMaybe<Governance_Financial_Lambda_Bool_Exp>;
};


export type Subscription_RootGovernance_Financial_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_Financial_Lambda_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Financial_Lambda_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Financial_Lambda_Bool_Exp>;
};


export type Subscription_RootGovernance_Financial_RequestArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Request_Order_By>>;
  where?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
};


export type Subscription_RootGovernance_Financial_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Request_Order_By>>;
  where?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
};


export type Subscription_RootGovernance_Financial_Request_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_Financial_Request_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Financial_Request_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
};


export type Subscription_RootGovernance_Financial_Request_VoteArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Request_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Request_Vote_Order_By>>;
  where?: InputMaybe<Governance_Financial_Request_Vote_Bool_Exp>;
};


export type Subscription_RootGovernance_Financial_Request_Vote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Request_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Request_Vote_Order_By>>;
  where?: InputMaybe<Governance_Financial_Request_Vote_Bool_Exp>;
};


export type Subscription_RootGovernance_Financial_Request_Vote_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_Financial_Request_Vote_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Financial_Request_Vote_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Financial_Request_Vote_Bool_Exp>;
};


export type Subscription_RootGovernance_Financial_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Financial_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Financial_Bool_Exp>;
};


export type Subscription_RootGovernance_Financial_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Governance_Financial_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootGovernance_Financial_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Governance_Financial_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootGovernance_Financial_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_Financial_Whitelist_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Financial_Whitelist_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Financial_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootGovernance_Financial_Whitelist_Token_ContractArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Whitelist_Token_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Whitelist_Token_Contract_Order_By>>;
  where?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Bool_Exp>;
};


export type Subscription_RootGovernance_Financial_Whitelist_Token_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Whitelist_Token_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Whitelist_Token_Contract_Order_By>>;
  where?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Bool_Exp>;
};


export type Subscription_RootGovernance_Financial_Whitelist_Token_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_Financial_Whitelist_Token_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Financial_Whitelist_Token_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Bool_Exp>;
};


export type Subscription_RootGovernance_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Governance_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_General_Contract_Order_By>>;
  where?: InputMaybe<Governance_General_Contract_Bool_Exp>;
};


export type Subscription_RootGovernance_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_General_Contract_Order_By>>;
  where?: InputMaybe<Governance_General_Contract_Bool_Exp>;
};


export type Subscription_RootGovernance_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_General_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_General_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_General_Contract_Bool_Exp>;
};


export type Subscription_RootGovernance_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Governance_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Lambda_Order_By>>;
  where?: InputMaybe<Governance_Lambda_Bool_Exp>;
};


export type Subscription_RootGovernance_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Lambda_Order_By>>;
  where?: InputMaybe<Governance_Lambda_Bool_Exp>;
};


export type Subscription_RootGovernance_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_Lambda_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Lambda_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Lambda_Bool_Exp>;
};


export type Subscription_RootGovernance_ProposalArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Bool_Exp>;
};


export type Subscription_RootGovernance_Proposal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Bool_Exp>;
};


export type Subscription_RootGovernance_Proposal_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_Proposal_DataArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Data_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Data_Bool_Exp>;
};


export type Subscription_RootGovernance_Proposal_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Data_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Data_Bool_Exp>;
};


export type Subscription_RootGovernance_Proposal_Data_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_Proposal_Data_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Proposal_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Proposal_Data_Bool_Exp>;
};


export type Subscription_RootGovernance_Proposal_PaymentArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Payment_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Payment_Bool_Exp>;
};


export type Subscription_RootGovernance_Proposal_Payment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Payment_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Payment_Bool_Exp>;
};


export type Subscription_RootGovernance_Proposal_Payment_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_Proposal_Payment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Proposal_Payment_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Proposal_Payment_Bool_Exp>;
};


export type Subscription_RootGovernance_Proposal_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Proposal_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Proposal_Bool_Exp>;
};


export type Subscription_RootGovernance_Proposal_VoteArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Vote_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Vote_Bool_Exp>;
};


export type Subscription_RootGovernance_Proposal_Vote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Vote_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Vote_Bool_Exp>;
};


export type Subscription_RootGovernance_Proposal_Vote_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_Proposal_Vote_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Proposal_Vote_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Proposal_Vote_Bool_Exp>;
};


export type Subscription_RootGovernance_ProxyArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proxy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proxy_Order_By>>;
  where?: InputMaybe<Governance_Proxy_Bool_Exp>;
};


export type Subscription_RootGovernance_Proxy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proxy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proxy_Order_By>>;
  where?: InputMaybe<Governance_Proxy_Bool_Exp>;
};


export type Subscription_RootGovernance_Proxy_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_Proxy_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proxy_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proxy_Lambda_Order_By>>;
  where?: InputMaybe<Governance_Proxy_Lambda_Bool_Exp>;
};


export type Subscription_RootGovernance_Proxy_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proxy_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proxy_Lambda_Order_By>>;
  where?: InputMaybe<Governance_Proxy_Lambda_Bool_Exp>;
};


export type Subscription_RootGovernance_Proxy_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_Proxy_Lambda_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Proxy_Lambda_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Proxy_Lambda_Bool_Exp>;
};


export type Subscription_RootGovernance_Proxy_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Proxy_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Proxy_Bool_Exp>;
};


export type Subscription_RootGovernance_SatelliteArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_ActionArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Action_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Action_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_Action_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Action_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Action_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_Action_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_Satellite_Action_ParameterArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Action_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Action_Parameter_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Action_Parameter_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_Action_Parameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Action_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Action_Parameter_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Action_Parameter_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_Action_Parameter_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_Satellite_Action_Parameter_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Satellite_Action_Parameter_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Satellite_Action_Parameter_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_Action_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Satellite_Action_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Satellite_Action_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_Action_VoteArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Action_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Action_Vote_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Action_Vote_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_Action_Vote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Action_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Action_Vote_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Action_Vote_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_Action_Vote_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_Satellite_Action_Vote_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Satellite_Action_Vote_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Satellite_Action_Vote_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_Satellite_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_General_Contract_Order_By>>;
  where?: InputMaybe<Governance_Satellite_General_Contract_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_General_Contract_Order_By>>;
  where?: InputMaybe<Governance_Satellite_General_Contract_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_Satellite_General_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Satellite_General_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Satellite_General_Contract_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Lambda_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Lambda_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Lambda_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Lambda_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_Satellite_Lambda_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Satellite_Lambda_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Satellite_Lambda_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_OracleArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Oracle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Oracle_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Oracle_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_Oracle_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Oracle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Oracle_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Oracle_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_Oracle_AggregatorArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Oracle_Aggregator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Oracle_Aggregator_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_Oracle_Aggregator_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Oracle_Aggregator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Oracle_Aggregator_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_Oracle_Aggregator_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_Satellite_Oracle_Aggregator_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Satellite_Oracle_Aggregator_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Satellite_Oracle_Aggregator_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_Oracle_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_Satellite_Oracle_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Satellite_Oracle_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Satellite_Oracle_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_SnapshotArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Snapshot_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Snapshot_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_Snapshot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Snapshot_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Snapshot_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_Snapshot_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_Satellite_Snapshot_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Satellite_Snapshot_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Satellite_Snapshot_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Satellite_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Satellite_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Satellite_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Satellite_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Governance_Satellite_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootGovernance_Satellite_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_Satellite_Whitelist_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Satellite_Whitelist_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Satellite_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootGovernance_Smvn_SnapshotArgs = {
  distinct_on?: InputMaybe<Array<Governance_Smvn_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Smvn_Snapshot_Order_By>>;
  where?: InputMaybe<Governance_Smvn_Snapshot_Bool_Exp>;
};


export type Subscription_RootGovernance_Smvn_Snapshot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Smvn_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Smvn_Snapshot_Order_By>>;
  where?: InputMaybe<Governance_Smvn_Snapshot_Bool_Exp>;
};


export type Subscription_RootGovernance_Smvn_Snapshot_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_Smvn_Snapshot_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Smvn_Snapshot_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Smvn_Snapshot_Bool_Exp>;
};


export type Subscription_RootGovernance_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Bool_Exp>;
};


export type Subscription_RootGovernance_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Governance_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Governance_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootGovernance_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Governance_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootGovernance_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGovernance_Whitelist_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Governance_Whitelist_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Governance_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootGql_History_Data_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Gql_History_Data_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gql_History_Data_Summary_Order_By>>;
  where?: InputMaybe<Gql_History_Data_Summary_Bool_Exp>;
};


export type Subscription_RootGql_History_Data_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gql_History_Data_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gql_History_Data_Summary_Order_By>>;
  where?: InputMaybe<Gql_History_Data_Summary_Bool_Exp>;
};


export type Subscription_RootGql_History_Data_Summary_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gql_History_Data_Summary_Stream_Cursor_Input>>;
  where?: InputMaybe<Gql_History_Data_Summary_Bool_Exp>;
};


export type Subscription_RootGql_Loan_Token_Market_StatsArgs = {
  distinct_on?: InputMaybe<Array<Gql_Loan_Token_Market_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gql_Loan_Token_Market_Stats_Order_By>>;
  where?: InputMaybe<Gql_Loan_Token_Market_Stats_Bool_Exp>;
};


export type Subscription_RootGql_Loan_Token_Market_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gql_Loan_Token_Market_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gql_Loan_Token_Market_Stats_Order_By>>;
  where?: InputMaybe<Gql_Loan_Token_Market_Stats_Bool_Exp>;
};


export type Subscription_RootGql_Loan_Token_Market_Stats_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gql_Loan_Token_Market_Stats_Stream_Cursor_Input>>;
  where?: InputMaybe<Gql_Loan_Token_Market_Stats_Bool_Exp>;
};


export type Subscription_RootGql_Vault_With_BalancesArgs = {
  distinct_on?: InputMaybe<Array<Gql_Vault_With_Balances_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gql_Vault_With_Balances_Order_By>>;
  where?: InputMaybe<Gql_Vault_With_Balances_Bool_Exp>;
};


export type Subscription_RootGql_Vault_With_Balances_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gql_Vault_With_Balances_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gql_Vault_With_Balances_Order_By>>;
  where?: InputMaybe<Gql_Vault_With_Balances_Bool_Exp>;
};


export type Subscription_RootGql_Vault_With_Balances_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gql_Vault_With_Balances_Stream_Cursor_Input>>;
  where?: InputMaybe<Gql_Vault_With_Balances_Bool_Exp>;
};


export type Subscription_RootLending_ControllerArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Order_By>>;
  where?: InputMaybe<Lending_Controller_Bool_Exp>;
};


export type Subscription_RootLending_Controller_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Order_By>>;
  where?: InputMaybe<Lending_Controller_Bool_Exp>;
};


export type Subscription_RootLending_Controller_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootLending_Controller_Collateral_TokenArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Collateral_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Collateral_Token_Order_By>>;
  where?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
};


export type Subscription_RootLending_Controller_Collateral_Token_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Collateral_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Collateral_Token_Order_By>>;
  where?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
};


export type Subscription_RootLending_Controller_Collateral_Token_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootLending_Controller_Collateral_Token_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lending_Controller_Collateral_Token_Stream_Cursor_Input>>;
  where?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
};


export type Subscription_RootLending_Controller_History_DataArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_History_Data_Order_By>>;
  where?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
};


export type Subscription_RootLending_Controller_History_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_History_Data_Order_By>>;
  where?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
};


export type Subscription_RootLending_Controller_History_Data_By_PkArgs = {
  id: Scalars['bigint']['input'];
  timestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootLending_Controller_History_Data_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lending_Controller_History_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Lending_Controller_History_Data_Bool_Exp>;
};


export type Subscription_RootLending_Controller_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Lambda_Order_By>>;
  where?: InputMaybe<Lending_Controller_Lambda_Bool_Exp>;
};


export type Subscription_RootLending_Controller_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Lambda_Order_By>>;
  where?: InputMaybe<Lending_Controller_Lambda_Bool_Exp>;
};


export type Subscription_RootLending_Controller_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootLending_Controller_Lambda_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lending_Controller_Lambda_Stream_Cursor_Input>>;
  where?: InputMaybe<Lending_Controller_Lambda_Bool_Exp>;
};


export type Subscription_RootLending_Controller_Loan_TokenArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Loan_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Loan_Token_Order_By>>;
  where?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
};


export type Subscription_RootLending_Controller_Loan_Token_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Loan_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Loan_Token_Order_By>>;
  where?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
};


export type Subscription_RootLending_Controller_Loan_Token_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootLending_Controller_Loan_Token_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lending_Controller_Loan_Token_Stream_Cursor_Input>>;
  where?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
};


export type Subscription_RootLending_Controller_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lending_Controller_Stream_Cursor_Input>>;
  where?: InputMaybe<Lending_Controller_Bool_Exp>;
};


export type Subscription_RootLending_Controller_VaultArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Vault_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Vault_Order_By>>;
  where?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
};


export type Subscription_RootLending_Controller_Vault_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Vault_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Vault_Order_By>>;
  where?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
};


export type Subscription_RootLending_Controller_Vault_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootLending_Controller_Vault_Collateral_BalanceArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Vault_Collateral_Balance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Vault_Collateral_Balance_Order_By>>;
  where?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Bool_Exp>;
};


export type Subscription_RootLending_Controller_Vault_Collateral_Balance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Vault_Collateral_Balance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Vault_Collateral_Balance_Order_By>>;
  where?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Bool_Exp>;
};


export type Subscription_RootLending_Controller_Vault_Collateral_Balance_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootLending_Controller_Vault_Collateral_Balance_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lending_Controller_Vault_Collateral_Balance_Stream_Cursor_Input>>;
  where?: InputMaybe<Lending_Controller_Vault_Collateral_Balance_Bool_Exp>;
};


export type Subscription_RootLending_Controller_Vault_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lending_Controller_Vault_Stream_Cursor_Input>>;
  where?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
};


export type Subscription_RootLoan_Token_ViewArgs = {
  distinct_on?: InputMaybe<Array<Loan_Token_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Loan_Token_View_Order_By>>;
  where?: InputMaybe<Loan_Token_View_Bool_Exp>;
};


export type Subscription_RootLoan_Token_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Loan_Token_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Loan_Token_View_Order_By>>;
  where?: InputMaybe<Loan_Token_View_Bool_Exp>;
};


export type Subscription_RootLoan_Token_View_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Loan_Token_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Loan_Token_View_Bool_Exp>;
};


export type Subscription_RootM_TokenArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Order_By>>;
  where?: InputMaybe<M_Token_Bool_Exp>;
};


export type Subscription_RootM_Token_AccountArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Account_Order_By>>;
  where?: InputMaybe<M_Token_Account_Bool_Exp>;
};


export type Subscription_RootM_Token_Account_AggregateArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Account_Order_By>>;
  where?: InputMaybe<M_Token_Account_Bool_Exp>;
};


export type Subscription_RootM_Token_Account_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootM_Token_Account_History_DataArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Account_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Account_History_Data_Order_By>>;
  where?: InputMaybe<M_Token_Account_History_Data_Bool_Exp>;
};


export type Subscription_RootM_Token_Account_History_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Account_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Account_History_Data_Order_By>>;
  where?: InputMaybe<M_Token_Account_History_Data_Bool_Exp>;
};


export type Subscription_RootM_Token_Account_History_Data_By_PkArgs = {
  id: Scalars['bigint']['input'];
  timestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootM_Token_Account_History_Data_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<M_Token_Account_History_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<M_Token_Account_History_Data_Bool_Exp>;
};


export type Subscription_RootM_Token_Account_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<M_Token_Account_Stream_Cursor_Input>>;
  where?: InputMaybe<M_Token_Account_Bool_Exp>;
};


export type Subscription_RootM_Token_AggregateArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Order_By>>;
  where?: InputMaybe<M_Token_Bool_Exp>;
};


export type Subscription_RootM_Token_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootM_Token_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<M_Token_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_General_Contract_Order_By>>;
  where?: InputMaybe<M_Token_General_Contract_Bool_Exp>;
};


export type Subscription_RootM_Token_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<M_Token_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_General_Contract_Order_By>>;
  where?: InputMaybe<M_Token_General_Contract_Bool_Exp>;
};


export type Subscription_RootM_Token_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootM_Token_General_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<M_Token_General_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<M_Token_General_Contract_Bool_Exp>;
};


export type Subscription_RootM_Token_LambdaArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Lambda_Order_By>>;
  where?: InputMaybe<M_Token_Lambda_Bool_Exp>;
};


export type Subscription_RootM_Token_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Lambda_Order_By>>;
  where?: InputMaybe<M_Token_Lambda_Bool_Exp>;
};


export type Subscription_RootM_Token_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootM_Token_Lambda_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<M_Token_Lambda_Stream_Cursor_Input>>;
  where?: InputMaybe<M_Token_Lambda_Bool_Exp>;
};


export type Subscription_RootM_Token_OperatorArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Operator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Operator_Order_By>>;
  where?: InputMaybe<M_Token_Operator_Bool_Exp>;
};


export type Subscription_RootM_Token_Operator_AggregateArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Operator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Operator_Order_By>>;
  where?: InputMaybe<M_Token_Operator_Bool_Exp>;
};


export type Subscription_RootM_Token_Operator_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootM_Token_Operator_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<M_Token_Operator_Stream_Cursor_Input>>;
  where?: InputMaybe<M_Token_Operator_Bool_Exp>;
};


export type Subscription_RootM_Token_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<M_Token_Stream_Cursor_Input>>;
  where?: InputMaybe<M_Token_Bool_Exp>;
};


export type Subscription_RootM_Token_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<M_Token_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootM_Token_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<M_Token_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootM_Token_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootM_Token_Whitelist_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<M_Token_Whitelist_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<M_Token_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootMaven_UserArgs = {
  distinct_on?: InputMaybe<Array<Maven_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Maven_User_Order_By>>;
  where?: InputMaybe<Maven_User_Bool_Exp>;
};


export type Subscription_RootMaven_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Maven_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Maven_User_Order_By>>;
  where?: InputMaybe<Maven_User_Bool_Exp>;
};


export type Subscription_RootMaven_User_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootMaven_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Maven_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Maven_User_Bool_Exp>;
};


export type Subscription_RootMvn_Mint_Or_Burn_History_DataArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Mint_Or_Burn_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Mint_Or_Burn_History_Data_Order_By>>;
  where?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Bool_Exp>;
};


export type Subscription_RootMvn_Mint_Or_Burn_History_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Mint_Or_Burn_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Mint_Or_Burn_History_Data_Order_By>>;
  where?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Bool_Exp>;
};


export type Subscription_RootMvn_Mint_Or_Burn_History_Data_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootMvn_Mint_Or_Burn_History_Data_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mvn_Mint_Or_Burn_History_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Mvn_Mint_Or_Burn_History_Data_Bool_Exp>;
};


export type Subscription_RootMvn_TokenArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_Order_By>>;
  where?: InputMaybe<Mvn_Token_Bool_Exp>;
};


export type Subscription_RootMvn_Token_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_Order_By>>;
  where?: InputMaybe<Mvn_Token_Bool_Exp>;
};


export type Subscription_RootMvn_Token_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootMvn_Token_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_General_Contract_Order_By>>;
  where?: InputMaybe<Mvn_Token_General_Contract_Bool_Exp>;
};


export type Subscription_RootMvn_Token_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_General_Contract_Order_By>>;
  where?: InputMaybe<Mvn_Token_General_Contract_Bool_Exp>;
};


export type Subscription_RootMvn_Token_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootMvn_Token_General_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mvn_Token_General_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Mvn_Token_General_Contract_Bool_Exp>;
};


export type Subscription_RootMvn_Token_OperatorArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_Operator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_Operator_Order_By>>;
  where?: InputMaybe<Mvn_Token_Operator_Bool_Exp>;
};


export type Subscription_RootMvn_Token_Operator_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_Operator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_Operator_Order_By>>;
  where?: InputMaybe<Mvn_Token_Operator_Bool_Exp>;
};


export type Subscription_RootMvn_Token_Operator_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootMvn_Token_Operator_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mvn_Token_Operator_Stream_Cursor_Input>>;
  where?: InputMaybe<Mvn_Token_Operator_Bool_Exp>;
};


export type Subscription_RootMvn_Token_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mvn_Token_Stream_Cursor_Input>>;
  where?: InputMaybe<Mvn_Token_Bool_Exp>;
};


export type Subscription_RootMvn_Token_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Mvn_Token_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootMvn_Token_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Mvn_Token_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootMvn_Token_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootMvn_Token_Whitelist_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mvn_Token_Whitelist_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Mvn_Token_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootMvn_Transfer_History_DataArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Transfer_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Transfer_History_Data_Order_By>>;
  where?: InputMaybe<Mvn_Transfer_History_Data_Bool_Exp>;
};


export type Subscription_RootMvn_Transfer_History_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Transfer_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Transfer_History_Data_Order_By>>;
  where?: InputMaybe<Mvn_Transfer_History_Data_Bool_Exp>;
};


export type Subscription_RootMvn_Transfer_History_Data_By_PkArgs = {
  id: Scalars['bigint']['input'];
  timestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootMvn_Transfer_History_Data_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mvn_Transfer_History_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Mvn_Transfer_History_Data_Bool_Exp>;
};


export type Subscription_RootSatelliteArgs = {
  distinct_on?: InputMaybe<Array<Satellite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Satellite_Order_By>>;
  where?: InputMaybe<Satellite_Bool_Exp>;
};


export type Subscription_RootSatellite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Satellite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Satellite_Order_By>>;
  where?: InputMaybe<Satellite_Bool_Exp>;
};


export type Subscription_RootSatellite_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootSatellite_RewardsArgs = {
  distinct_on?: InputMaybe<Array<Satellite_Rewards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Satellite_Rewards_Order_By>>;
  where?: InputMaybe<Satellite_Rewards_Bool_Exp>;
};


export type Subscription_RootSatellite_Rewards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Satellite_Rewards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Satellite_Rewards_Order_By>>;
  where?: InputMaybe<Satellite_Rewards_Bool_Exp>;
};


export type Subscription_RootSatellite_Rewards_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootSatellite_Rewards_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Satellite_Rewards_Stream_Cursor_Input>>;
  where?: InputMaybe<Satellite_Rewards_Bool_Exp>;
};


export type Subscription_RootSatellite_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Satellite_Stream_Cursor_Input>>;
  where?: InputMaybe<Satellite_Bool_Exp>;
};


export type Subscription_RootSmvn_History_DataArgs = {
  distinct_on?: InputMaybe<Array<Smvn_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smvn_History_Data_Order_By>>;
  where?: InputMaybe<Smvn_History_Data_Bool_Exp>;
};


export type Subscription_RootSmvn_History_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Smvn_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smvn_History_Data_Order_By>>;
  where?: InputMaybe<Smvn_History_Data_Bool_Exp>;
};


export type Subscription_RootSmvn_History_Data_By_PkArgs = {
  id: Scalars['bigint']['input'];
  timestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootSmvn_History_Data_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Smvn_History_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Smvn_History_Data_Bool_Exp>;
};


export type Subscription_RootStake_History_DataArgs = {
  distinct_on?: InputMaybe<Array<Stake_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stake_History_Data_Order_By>>;
  where?: InputMaybe<Stake_History_Data_Bool_Exp>;
};


export type Subscription_RootStake_History_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stake_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Stake_History_Data_Order_By>>;
  where?: InputMaybe<Stake_History_Data_Bool_Exp>;
};


export type Subscription_RootStake_History_Data_By_PkArgs = {
  id: Scalars['bigint']['input'];
  timestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootStake_History_Data_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Stake_History_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Stake_History_Data_Bool_Exp>;
};


export type Subscription_RootTokenArgs = {
  distinct_on?: InputMaybe<Array<Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Token_Order_By>>;
  where?: InputMaybe<Token_Bool_Exp>;
};


export type Subscription_RootToken_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Token_Order_By>>;
  where?: InputMaybe<Token_Bool_Exp>;
};


export type Subscription_RootToken_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootToken_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Token_Stream_Cursor_Input>>;
  where?: InputMaybe<Token_Bool_Exp>;
};


export type Subscription_RootTreasuryArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Order_By>>;
  where?: InputMaybe<Treasury_Bool_Exp>;
};


export type Subscription_RootTreasury_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Order_By>>;
  where?: InputMaybe<Treasury_Bool_Exp>;
};


export type Subscription_RootTreasury_BalanceArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Balance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Balance_Order_By>>;
  where?: InputMaybe<Treasury_Balance_Bool_Exp>;
};


export type Subscription_RootTreasury_Balance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Balance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Balance_Order_By>>;
  where?: InputMaybe<Treasury_Balance_Bool_Exp>;
};


export type Subscription_RootTreasury_Balance_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTreasury_Balance_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Treasury_Balance_Stream_Cursor_Input>>;
  where?: InputMaybe<Treasury_Balance_Bool_Exp>;
};


export type Subscription_RootTreasury_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTreasury_FactoryArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Bool_Exp>;
};


export type Subscription_RootTreasury_Factory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Bool_Exp>;
};


export type Subscription_RootTreasury_Factory_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTreasury_Factory_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_General_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Factory_General_Contract_Bool_Exp>;
};


export type Subscription_RootTreasury_Factory_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_General_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Factory_General_Contract_Bool_Exp>;
};


export type Subscription_RootTreasury_Factory_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTreasury_Factory_General_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Treasury_Factory_General_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Treasury_Factory_General_Contract_Bool_Exp>;
};


export type Subscription_RootTreasury_Factory_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Lambda_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Lambda_Bool_Exp>;
};


export type Subscription_RootTreasury_Factory_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Lambda_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Lambda_Bool_Exp>;
};


export type Subscription_RootTreasury_Factory_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTreasury_Factory_Lambda_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Treasury_Factory_Lambda_Stream_Cursor_Input>>;
  where?: InputMaybe<Treasury_Factory_Lambda_Bool_Exp>;
};


export type Subscription_RootTreasury_Factory_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Treasury_Factory_Stream_Cursor_Input>>;
  where?: InputMaybe<Treasury_Factory_Bool_Exp>;
};


export type Subscription_RootTreasury_Factory_Treasury_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Treasury_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Treasury_Lambda_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Treasury_Lambda_Bool_Exp>;
};


export type Subscription_RootTreasury_Factory_Treasury_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Treasury_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Treasury_Lambda_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Treasury_Lambda_Bool_Exp>;
};


export type Subscription_RootTreasury_Factory_Treasury_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTreasury_Factory_Treasury_Lambda_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Treasury_Factory_Treasury_Lambda_Stream_Cursor_Input>>;
  where?: InputMaybe<Treasury_Factory_Treasury_Lambda_Bool_Exp>;
};


export type Subscription_RootTreasury_Factory_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootTreasury_Factory_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootTreasury_Factory_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTreasury_Factory_Whitelist_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Treasury_Factory_Whitelist_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Treasury_Factory_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootTreasury_Factory_Whitelist_Token_ContractArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Whitelist_Token_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Whitelist_Token_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Bool_Exp>;
};


export type Subscription_RootTreasury_Factory_Whitelist_Token_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Whitelist_Token_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Whitelist_Token_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Bool_Exp>;
};


export type Subscription_RootTreasury_Factory_Whitelist_Token_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTreasury_Factory_Whitelist_Token_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Bool_Exp>;
};


export type Subscription_RootTreasury_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Treasury_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_General_Contract_Order_By>>;
  where?: InputMaybe<Treasury_General_Contract_Bool_Exp>;
};


export type Subscription_RootTreasury_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_General_Contract_Order_By>>;
  where?: InputMaybe<Treasury_General_Contract_Bool_Exp>;
};


export type Subscription_RootTreasury_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTreasury_General_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Treasury_General_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Treasury_General_Contract_Bool_Exp>;
};


export type Subscription_RootTreasury_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Lambda_Order_By>>;
  where?: InputMaybe<Treasury_Lambda_Bool_Exp>;
};


export type Subscription_RootTreasury_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Lambda_Order_By>>;
  where?: InputMaybe<Treasury_Lambda_Bool_Exp>;
};


export type Subscription_RootTreasury_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTreasury_Lambda_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Treasury_Lambda_Stream_Cursor_Input>>;
  where?: InputMaybe<Treasury_Lambda_Bool_Exp>;
};


export type Subscription_RootTreasury_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Treasury_Stream_Cursor_Input>>;
  where?: InputMaybe<Treasury_Bool_Exp>;
};


export type Subscription_RootTreasury_Transfer_History_DataArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Transfer_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Transfer_History_Data_Order_By>>;
  where?: InputMaybe<Treasury_Transfer_History_Data_Bool_Exp>;
};


export type Subscription_RootTreasury_Transfer_History_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Transfer_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Transfer_History_Data_Order_By>>;
  where?: InputMaybe<Treasury_Transfer_History_Data_Bool_Exp>;
};


export type Subscription_RootTreasury_Transfer_History_Data_By_PkArgs = {
  id: Scalars['bigint']['input'];
  timestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootTreasury_Transfer_History_Data_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Treasury_Transfer_History_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Treasury_Transfer_History_Data_Bool_Exp>;
};


export type Subscription_RootTreasury_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootTreasury_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootTreasury_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTreasury_Whitelist_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Treasury_Whitelist_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Treasury_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootTreasury_Whitelist_Token_ContractArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Whitelist_Token_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Whitelist_Token_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Whitelist_Token_Contract_Bool_Exp>;
};


export type Subscription_RootTreasury_Whitelist_Token_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Whitelist_Token_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Whitelist_Token_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Whitelist_Token_Contract_Bool_Exp>;
};


export type Subscription_RootTreasury_Whitelist_Token_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTreasury_Whitelist_Token_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Treasury_Whitelist_Token_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Treasury_Whitelist_Token_Contract_Bool_Exp>;
};


export type Subscription_RootTvl_StatsArgs = {
  distinct_on?: InputMaybe<Array<Tvl_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tvl_Stats_Order_By>>;
  where?: InputMaybe<Tvl_Stats_Bool_Exp>;
};


export type Subscription_RootTvl_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tvl_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tvl_Stats_Order_By>>;
  where?: InputMaybe<Tvl_Stats_Bool_Exp>;
};


export type Subscription_RootTvl_Stats_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tvl_Stats_Stream_Cursor_Input>>;
  where?: InputMaybe<Tvl_Stats_Bool_Exp>;
};


export type Subscription_RootUser_DashboardArgs = {
  distinct_on?: InputMaybe<Array<User_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Dashboard_Order_By>>;
  where?: InputMaybe<User_Dashboard_Bool_Exp>;
};


export type Subscription_RootUser_Dashboard_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Dashboard_Order_By>>;
  where?: InputMaybe<User_Dashboard_Bool_Exp>;
};


export type Subscription_RootUser_Dashboard_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Dashboard_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Dashboard_Bool_Exp>;
};


export type Subscription_RootVaultArgs = {
  distinct_on?: InputMaybe<Array<Vault_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Order_By>>;
  where?: InputMaybe<Vault_Bool_Exp>;
};


export type Subscription_RootVault_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Order_By>>;
  where?: InputMaybe<Vault_Bool_Exp>;
};


export type Subscription_RootVault_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVault_Collateral_ViewArgs = {
  distinct_on?: InputMaybe<Array<Vault_Collateral_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Collateral_View_Order_By>>;
  where?: InputMaybe<Vault_Collateral_View_Bool_Exp>;
};


export type Subscription_RootVault_Collateral_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Collateral_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Collateral_View_Order_By>>;
  where?: InputMaybe<Vault_Collateral_View_Bool_Exp>;
};


export type Subscription_RootVault_Collateral_View_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vault_Collateral_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Vault_Collateral_View_Bool_Exp>;
};


export type Subscription_RootVault_DepositorArgs = {
  distinct_on?: InputMaybe<Array<Vault_Depositor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Depositor_Order_By>>;
  where?: InputMaybe<Vault_Depositor_Bool_Exp>;
};


export type Subscription_RootVault_Depositor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Depositor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Depositor_Order_By>>;
  where?: InputMaybe<Vault_Depositor_Bool_Exp>;
};


export type Subscription_RootVault_Depositor_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVault_Depositor_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vault_Depositor_Stream_Cursor_Input>>;
  where?: InputMaybe<Vault_Depositor_Bool_Exp>;
};


export type Subscription_RootVault_FactoryArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_Order_By>>;
  where?: InputMaybe<Vault_Factory_Bool_Exp>;
};


export type Subscription_RootVault_Factory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_Order_By>>;
  where?: InputMaybe<Vault_Factory_Bool_Exp>;
};


export type Subscription_RootVault_Factory_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVault_Factory_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_General_Contract_Order_By>>;
  where?: InputMaybe<Vault_Factory_General_Contract_Bool_Exp>;
};


export type Subscription_RootVault_Factory_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_General_Contract_Order_By>>;
  where?: InputMaybe<Vault_Factory_General_Contract_Bool_Exp>;
};


export type Subscription_RootVault_Factory_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVault_Factory_General_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vault_Factory_General_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Vault_Factory_General_Contract_Bool_Exp>;
};


export type Subscription_RootVault_Factory_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_Lambda_Order_By>>;
  where?: InputMaybe<Vault_Factory_Lambda_Bool_Exp>;
};


export type Subscription_RootVault_Factory_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_Lambda_Order_By>>;
  where?: InputMaybe<Vault_Factory_Lambda_Bool_Exp>;
};


export type Subscription_RootVault_Factory_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVault_Factory_Lambda_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vault_Factory_Lambda_Stream_Cursor_Input>>;
  where?: InputMaybe<Vault_Factory_Lambda_Bool_Exp>;
};


export type Subscription_RootVault_Factory_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vault_Factory_Stream_Cursor_Input>>;
  where?: InputMaybe<Vault_Factory_Bool_Exp>;
};


export type Subscription_RootVault_Factory_Vault_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_Vault_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_Vault_Lambda_Order_By>>;
  where?: InputMaybe<Vault_Factory_Vault_Lambda_Bool_Exp>;
};


export type Subscription_RootVault_Factory_Vault_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_Vault_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_Vault_Lambda_Order_By>>;
  where?: InputMaybe<Vault_Factory_Vault_Lambda_Bool_Exp>;
};


export type Subscription_RootVault_Factory_Vault_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVault_Factory_Vault_Lambda_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vault_Factory_Vault_Lambda_Stream_Cursor_Input>>;
  where?: InputMaybe<Vault_Factory_Vault_Lambda_Bool_Exp>;
};


export type Subscription_RootVault_Factory_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Vault_Factory_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootVault_Factory_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Vault_Factory_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootVault_Factory_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVault_Factory_Whitelist_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vault_Factory_Whitelist_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Vault_Factory_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootVault_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Vault_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Lambda_Order_By>>;
  where?: InputMaybe<Vault_Lambda_Bool_Exp>;
};


export type Subscription_RootVault_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Lambda_Order_By>>;
  where?: InputMaybe<Vault_Lambda_Bool_Exp>;
};


export type Subscription_RootVault_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVault_Lambda_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vault_Lambda_Stream_Cursor_Input>>;
  where?: InputMaybe<Vault_Lambda_Bool_Exp>;
};


export type Subscription_RootVault_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vault_Stream_Cursor_Input>>;
  where?: InputMaybe<Vault_Bool_Exp>;
};


export type Subscription_RootVestingArgs = {
  distinct_on?: InputMaybe<Array<Vesting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_Order_By>>;
  where?: InputMaybe<Vesting_Bool_Exp>;
};


export type Subscription_RootVesting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vesting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_Order_By>>;
  where?: InputMaybe<Vesting_Bool_Exp>;
};


export type Subscription_RootVesting_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVesting_General_ContractArgs = {
  distinct_on?: InputMaybe<Array<Vesting_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_General_Contract_Order_By>>;
  where?: InputMaybe<Vesting_General_Contract_Bool_Exp>;
};


export type Subscription_RootVesting_General_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vesting_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_General_Contract_Order_By>>;
  where?: InputMaybe<Vesting_General_Contract_Bool_Exp>;
};


export type Subscription_RootVesting_General_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVesting_General_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vesting_General_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Vesting_General_Contract_Bool_Exp>;
};


export type Subscription_RootVesting_LambdaArgs = {
  distinct_on?: InputMaybe<Array<Vesting_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_Lambda_Order_By>>;
  where?: InputMaybe<Vesting_Lambda_Bool_Exp>;
};


export type Subscription_RootVesting_Lambda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vesting_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_Lambda_Order_By>>;
  where?: InputMaybe<Vesting_Lambda_Bool_Exp>;
};


export type Subscription_RootVesting_Lambda_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVesting_Lambda_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vesting_Lambda_Stream_Cursor_Input>>;
  where?: InputMaybe<Vesting_Lambda_Bool_Exp>;
};


export type Subscription_RootVesting_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vesting_Stream_Cursor_Input>>;
  where?: InputMaybe<Vesting_Bool_Exp>;
};


export type Subscription_RootVesting_VesteeArgs = {
  distinct_on?: InputMaybe<Array<Vesting_Vestee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_Vestee_Order_By>>;
  where?: InputMaybe<Vesting_Vestee_Bool_Exp>;
};


export type Subscription_RootVesting_Vestee_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vesting_Vestee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_Vestee_Order_By>>;
  where?: InputMaybe<Vesting_Vestee_Bool_Exp>;
};


export type Subscription_RootVesting_Vestee_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVesting_Vestee_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vesting_Vestee_Stream_Cursor_Input>>;
  where?: InputMaybe<Vesting_Vestee_Bool_Exp>;
};


export type Subscription_RootVesting_Whitelist_ContractArgs = {
  distinct_on?: InputMaybe<Array<Vesting_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Vesting_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootVesting_Whitelist_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vesting_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Vesting_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootVesting_Whitelist_Contract_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVesting_Whitelist_Contract_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vesting_Whitelist_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Vesting_Whitelist_Contract_Bool_Exp>;
};


export type Subscription_RootWhitelist_DeveloperArgs = {
  distinct_on?: InputMaybe<Array<Whitelist_Developer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whitelist_Developer_Order_By>>;
  where?: InputMaybe<Whitelist_Developer_Bool_Exp>;
};


export type Subscription_RootWhitelist_Developer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whitelist_Developer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whitelist_Developer_Order_By>>;
  where?: InputMaybe<Whitelist_Developer_Bool_Exp>;
};


export type Subscription_RootWhitelist_Developer_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootWhitelist_Developer_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Whitelist_Developer_Stream_Cursor_Input>>;
  where?: InputMaybe<Whitelist_Developer_Bool_Exp>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "token" */
export type Token = {
  __typename?: 'token';
  /** An array relationship */
  farms_lp_tokens: Array<Farm>;
  /** An aggregate relationship */
  farms_lp_tokens_aggregate: Farm_Aggregate;
  /** An array relationship */
  farms_tokens_0: Array<Farm>;
  /** An aggregate relationship */
  farms_tokens_0_aggregate: Farm_Aggregate;
  /** An array relationship */
  farms_tokens_1: Array<Farm>;
  /** An aggregate relationship */
  farms_tokens_1_aggregate: Farm_Aggregate;
  /** An array relationship */
  governance_financial_requests: Array<Governance_Financial_Request>;
  /** An aggregate relationship */
  governance_financial_requests_aggregate: Governance_Financial_Request_Aggregate;
  /** An array relationship */
  governance_financial_whitelist_token_contracts: Array<Governance_Financial_Whitelist_Token_Contract>;
  /** An aggregate relationship */
  governance_financial_whitelist_token_contracts_aggregate: Governance_Financial_Whitelist_Token_Contract_Aggregate;
  /** An array relationship */
  governance_proposals_payments: Array<Governance_Proposal_Payment>;
  /** An aggregate relationship */
  governance_proposals_payments_aggregate: Governance_Proposal_Payment_Aggregate;
  id: Scalars['bigint']['output'];
  /** An array relationship */
  lending_controller_collateral_tokens: Array<Lending_Controller_Collateral_Token>;
  /** An aggregate relationship */
  lending_controller_collateral_tokens_aggregate: Lending_Controller_Collateral_Token_Aggregate;
  /** An array relationship */
  lending_controller_loan_tokens: Array<Lending_Controller_Loan_Token>;
  /** An aggregate relationship */
  lending_controller_loan_tokens_aggregate: Lending_Controller_Loan_Token_Aggregate;
  /** An array relationship */
  m_tokens: Array<M_Token>;
  /** An aggregate relationship */
  m_tokens_aggregate: M_Token_Aggregate;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  mvn_tokens: Array<Mvn_Token>;
  /** An aggregate relationship */
  mvn_tokens_aggregate: Mvn_Token_Aggregate;
  network: Scalars['String']['output'];
  token_address: Scalars['String']['output'];
  token_id: Scalars['smallint']['output'];
  token_standard?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  treasury_balances: Array<Treasury_Balance>;
  /** An aggregate relationship */
  treasury_balances_aggregate: Treasury_Balance_Aggregate;
  /** An array relationship */
  treasury_factory_whitelist_token_contracts: Array<Treasury_Factory_Whitelist_Token_Contract>;
  /** An aggregate relationship */
  treasury_factory_whitelist_token_contracts_aggregate: Treasury_Factory_Whitelist_Token_Contract_Aggregate;
  /** An array relationship */
  treasury_whitelist_token_contracts: Array<Treasury_Whitelist_Token_Contract>;
  /** An aggregate relationship */
  treasury_whitelist_token_contracts_aggregate: Treasury_Whitelist_Token_Contract_Aggregate;
};


/** columns and relationships of "token" */
export type TokenFarms_Lp_TokensArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


/** columns and relationships of "token" */
export type TokenFarms_Lp_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


/** columns and relationships of "token" */
export type TokenFarms_Tokens_0Args = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


/** columns and relationships of "token" */
export type TokenFarms_Tokens_0_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


/** columns and relationships of "token" */
export type TokenFarms_Tokens_1Args = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


/** columns and relationships of "token" */
export type TokenFarms_Tokens_1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


/** columns and relationships of "token" */
export type TokenGovernance_Financial_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Request_Order_By>>;
  where?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
};


/** columns and relationships of "token" */
export type TokenGovernance_Financial_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Request_Order_By>>;
  where?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
};


/** columns and relationships of "token" */
export type TokenGovernance_Financial_Whitelist_Token_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Whitelist_Token_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Whitelist_Token_Contract_Order_By>>;
  where?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Bool_Exp>;
};


/** columns and relationships of "token" */
export type TokenGovernance_Financial_Whitelist_Token_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Whitelist_Token_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Whitelist_Token_Contract_Order_By>>;
  where?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Bool_Exp>;
};


/** columns and relationships of "token" */
export type TokenGovernance_Proposals_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Payment_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Payment_Bool_Exp>;
};


/** columns and relationships of "token" */
export type TokenGovernance_Proposals_Payments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Proposal_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Proposal_Payment_Order_By>>;
  where?: InputMaybe<Governance_Proposal_Payment_Bool_Exp>;
};


/** columns and relationships of "token" */
export type TokenLending_Controller_Collateral_TokensArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Collateral_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Collateral_Token_Order_By>>;
  where?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
};


/** columns and relationships of "token" */
export type TokenLending_Controller_Collateral_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Collateral_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Collateral_Token_Order_By>>;
  where?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
};


/** columns and relationships of "token" */
export type TokenLending_Controller_Loan_TokensArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Loan_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Loan_Token_Order_By>>;
  where?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
};


/** columns and relationships of "token" */
export type TokenLending_Controller_Loan_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Loan_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Loan_Token_Order_By>>;
  where?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
};


/** columns and relationships of "token" */
export type TokenM_TokensArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Order_By>>;
  where?: InputMaybe<M_Token_Bool_Exp>;
};


/** columns and relationships of "token" */
export type TokenM_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<M_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<M_Token_Order_By>>;
  where?: InputMaybe<M_Token_Bool_Exp>;
};


/** columns and relationships of "token" */
export type TokenMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "token" */
export type TokenMvn_TokensArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_Order_By>>;
  where?: InputMaybe<Mvn_Token_Bool_Exp>;
};


/** columns and relationships of "token" */
export type TokenMvn_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mvn_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mvn_Token_Order_By>>;
  where?: InputMaybe<Mvn_Token_Bool_Exp>;
};


/** columns and relationships of "token" */
export type TokenTreasury_BalancesArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Balance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Balance_Order_By>>;
  where?: InputMaybe<Treasury_Balance_Bool_Exp>;
};


/** columns and relationships of "token" */
export type TokenTreasury_Balances_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Balance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Balance_Order_By>>;
  where?: InputMaybe<Treasury_Balance_Bool_Exp>;
};


/** columns and relationships of "token" */
export type TokenTreasury_Factory_Whitelist_Token_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Whitelist_Token_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Whitelist_Token_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Bool_Exp>;
};


/** columns and relationships of "token" */
export type TokenTreasury_Factory_Whitelist_Token_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Whitelist_Token_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Whitelist_Token_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Bool_Exp>;
};


/** columns and relationships of "token" */
export type TokenTreasury_Whitelist_Token_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Whitelist_Token_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Whitelist_Token_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Whitelist_Token_Contract_Bool_Exp>;
};


/** columns and relationships of "token" */
export type TokenTreasury_Whitelist_Token_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Whitelist_Token_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Whitelist_Token_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Whitelist_Token_Contract_Bool_Exp>;
};

/** aggregated selection of "token" */
export type Token_Aggregate = {
  __typename?: 'token_aggregate';
  aggregate?: Maybe<Token_Aggregate_Fields>;
  nodes: Array<Token>;
};

/** aggregate fields of "token" */
export type Token_Aggregate_Fields = {
  __typename?: 'token_aggregate_fields';
  avg?: Maybe<Token_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Token_Max_Fields>;
  min?: Maybe<Token_Min_Fields>;
  stddev?: Maybe<Token_Stddev_Fields>;
  stddev_pop?: Maybe<Token_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Token_Stddev_Samp_Fields>;
  sum?: Maybe<Token_Sum_Fields>;
  var_pop?: Maybe<Token_Var_Pop_Fields>;
  var_samp?: Maybe<Token_Var_Samp_Fields>;
  variance?: Maybe<Token_Variance_Fields>;
};


/** aggregate fields of "token" */
export type Token_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Token_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Token_Avg_Fields = {
  __typename?: 'token_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "token". All fields are combined with a logical 'AND'. */
export type Token_Bool_Exp = {
  _and?: InputMaybe<Array<Token_Bool_Exp>>;
  _not?: InputMaybe<Token_Bool_Exp>;
  _or?: InputMaybe<Array<Token_Bool_Exp>>;
  farms_lp_tokens?: InputMaybe<Farm_Bool_Exp>;
  farms_lp_tokens_aggregate?: InputMaybe<Farm_Aggregate_Bool_Exp>;
  farms_tokens_0?: InputMaybe<Farm_Bool_Exp>;
  farms_tokens_0_aggregate?: InputMaybe<Farm_Aggregate_Bool_Exp>;
  farms_tokens_1?: InputMaybe<Farm_Bool_Exp>;
  farms_tokens_1_aggregate?: InputMaybe<Farm_Aggregate_Bool_Exp>;
  governance_financial_requests?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
  governance_financial_requests_aggregate?: InputMaybe<Governance_Financial_Request_Aggregate_Bool_Exp>;
  governance_financial_whitelist_token_contracts?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Bool_Exp>;
  governance_financial_whitelist_token_contracts_aggregate?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Aggregate_Bool_Exp>;
  governance_proposals_payments?: InputMaybe<Governance_Proposal_Payment_Bool_Exp>;
  governance_proposals_payments_aggregate?: InputMaybe<Governance_Proposal_Payment_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lending_controller_collateral_tokens?: InputMaybe<Lending_Controller_Collateral_Token_Bool_Exp>;
  lending_controller_collateral_tokens_aggregate?: InputMaybe<Lending_Controller_Collateral_Token_Aggregate_Bool_Exp>;
  lending_controller_loan_tokens?: InputMaybe<Lending_Controller_Loan_Token_Bool_Exp>;
  lending_controller_loan_tokens_aggregate?: InputMaybe<Lending_Controller_Loan_Token_Aggregate_Bool_Exp>;
  m_tokens?: InputMaybe<M_Token_Bool_Exp>;
  m_tokens_aggregate?: InputMaybe<M_Token_Aggregate_Bool_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mvn_tokens?: InputMaybe<Mvn_Token_Bool_Exp>;
  mvn_tokens_aggregate?: InputMaybe<Mvn_Token_Aggregate_Bool_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
  token_address?: InputMaybe<String_Comparison_Exp>;
  token_id?: InputMaybe<Smallint_Comparison_Exp>;
  token_standard?: InputMaybe<String_Comparison_Exp>;
  treasury_balances?: InputMaybe<Treasury_Balance_Bool_Exp>;
  treasury_balances_aggregate?: InputMaybe<Treasury_Balance_Aggregate_Bool_Exp>;
  treasury_factory_whitelist_token_contracts?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Bool_Exp>;
  treasury_factory_whitelist_token_contracts_aggregate?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Aggregate_Bool_Exp>;
  treasury_whitelist_token_contracts?: InputMaybe<Treasury_Whitelist_Token_Contract_Bool_Exp>;
  treasury_whitelist_token_contracts_aggregate?: InputMaybe<Treasury_Whitelist_Token_Contract_Aggregate_Bool_Exp>;
};

/** aggregate max on columns */
export type Token_Max_Fields = {
  __typename?: 'token_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  token_address?: Maybe<Scalars['String']['output']>;
  token_id?: Maybe<Scalars['smallint']['output']>;
  token_standard?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Token_Min_Fields = {
  __typename?: 'token_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  token_address?: Maybe<Scalars['String']['output']>;
  token_id?: Maybe<Scalars['smallint']['output']>;
  token_standard?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "token". */
export type Token_Order_By = {
  farms_lp_tokens_aggregate?: InputMaybe<Farm_Aggregate_Order_By>;
  farms_tokens_0_aggregate?: InputMaybe<Farm_Aggregate_Order_By>;
  farms_tokens_1_aggregate?: InputMaybe<Farm_Aggregate_Order_By>;
  governance_financial_requests_aggregate?: InputMaybe<Governance_Financial_Request_Aggregate_Order_By>;
  governance_financial_whitelist_token_contracts_aggregate?: InputMaybe<Governance_Financial_Whitelist_Token_Contract_Aggregate_Order_By>;
  governance_proposals_payments_aggregate?: InputMaybe<Governance_Proposal_Payment_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  lending_controller_collateral_tokens_aggregate?: InputMaybe<Lending_Controller_Collateral_Token_Aggregate_Order_By>;
  lending_controller_loan_tokens_aggregate?: InputMaybe<Lending_Controller_Loan_Token_Aggregate_Order_By>;
  m_tokens_aggregate?: InputMaybe<M_Token_Aggregate_Order_By>;
  metadata?: InputMaybe<Order_By>;
  mvn_tokens_aggregate?: InputMaybe<Mvn_Token_Aggregate_Order_By>;
  network?: InputMaybe<Order_By>;
  token_address?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  token_standard?: InputMaybe<Order_By>;
  treasury_balances_aggregate?: InputMaybe<Treasury_Balance_Aggregate_Order_By>;
  treasury_factory_whitelist_token_contracts_aggregate?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Aggregate_Order_By>;
  treasury_whitelist_token_contracts_aggregate?: InputMaybe<Treasury_Whitelist_Token_Contract_Aggregate_Order_By>;
};

/** select columns of table "token" */
export enum Token_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Network = 'network',
  /** column name */
  TokenAddress = 'token_address',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  TokenStandard = 'token_standard'
}

/** aggregate stddev on columns */
export type Token_Stddev_Fields = {
  __typename?: 'token_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Token_Stddev_Pop_Fields = {
  __typename?: 'token_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Token_Stddev_Samp_Fields = {
  __typename?: 'token_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "token" */
export type Token_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Token_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Token_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  token_address?: InputMaybe<Scalars['String']['input']>;
  token_id?: InputMaybe<Scalars['smallint']['input']>;
  token_standard?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Token_Sum_Fields = {
  __typename?: 'token_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  token_id?: Maybe<Scalars['smallint']['output']>;
};

/** aggregate var_pop on columns */
export type Token_Var_Pop_Fields = {
  __typename?: 'token_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Token_Var_Samp_Fields = {
  __typename?: 'token_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Token_Variance_Fields = {
  __typename?: 'token_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "treasury" */
export type Treasury = {
  __typename?: 'treasury';
  address: Scalars['String']['output'];
  admin: Scalars['String']['output'];
  /** An object relationship */
  baker?: Maybe<Maven_User>;
  baker_id?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  balances: Array<Treasury_Balance>;
  /** An aggregate relationship */
  balances_aggregate: Treasury_Balance_Aggregate;
  creation_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  factory?: Maybe<Treasury_Factory>;
  factory_id?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  general_contracts: Array<Treasury_General_Contract>;
  /** An aggregate relationship */
  general_contracts_aggregate: Treasury_General_Contract_Aggregate;
  /** An object relationship */
  governance: Governance;
  /** An array relationship */
  governance_financial_requests: Array<Governance_Financial_Request>;
  /** An aggregate relationship */
  governance_financial_requests_aggregate: Governance_Financial_Request_Aggregate;
  governance_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An array relationship */
  lambdas: Array<Treasury_Lambda>;
  /** An aggregate relationship */
  lambdas_aggregate: Treasury_Lambda_Aggregate;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  mint_mvn_and_transfer_paused: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  network: Scalars['String']['output'];
  stake_tokens_paused: Scalars['Boolean']['output'];
  /** An array relationship */
  transfer_history_data: Array<Treasury_Transfer_History_Data>;
  /** An aggregate relationship */
  transfer_history_data_aggregate: Treasury_Transfer_History_Data_Aggregate;
  transfer_paused: Scalars['Boolean']['output'];
  unstake_tokens_paused: Scalars['Boolean']['output'];
  update_token_operators_paused: Scalars['Boolean']['output'];
  /** An array relationship */
  whitelist_contracts: Array<Treasury_Whitelist_Contract>;
  /** An aggregate relationship */
  whitelist_contracts_aggregate: Treasury_Whitelist_Contract_Aggregate;
  /** An array relationship */
  whitelist_token_contracts: Array<Treasury_Whitelist_Token_Contract>;
  /** An aggregate relationship */
  whitelist_token_contracts_aggregate: Treasury_Whitelist_Token_Contract_Aggregate;
};


/** columns and relationships of "treasury" */
export type TreasuryBalancesArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Balance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Balance_Order_By>>;
  where?: InputMaybe<Treasury_Balance_Bool_Exp>;
};


/** columns and relationships of "treasury" */
export type TreasuryBalances_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Balance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Balance_Order_By>>;
  where?: InputMaybe<Treasury_Balance_Bool_Exp>;
};


/** columns and relationships of "treasury" */
export type TreasuryGeneral_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Treasury_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_General_Contract_Order_By>>;
  where?: InputMaybe<Treasury_General_Contract_Bool_Exp>;
};


/** columns and relationships of "treasury" */
export type TreasuryGeneral_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_General_Contract_Order_By>>;
  where?: InputMaybe<Treasury_General_Contract_Bool_Exp>;
};


/** columns and relationships of "treasury" */
export type TreasuryGovernance_Financial_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Request_Order_By>>;
  where?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
};


/** columns and relationships of "treasury" */
export type TreasuryGovernance_Financial_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Governance_Financial_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Governance_Financial_Request_Order_By>>;
  where?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
};


/** columns and relationships of "treasury" */
export type TreasuryLambdasArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Lambda_Order_By>>;
  where?: InputMaybe<Treasury_Lambda_Bool_Exp>;
};


/** columns and relationships of "treasury" */
export type TreasuryLambdas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Lambda_Order_By>>;
  where?: InputMaybe<Treasury_Lambda_Bool_Exp>;
};


/** columns and relationships of "treasury" */
export type TreasuryMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "treasury" */
export type TreasuryTransfer_History_DataArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Transfer_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Transfer_History_Data_Order_By>>;
  where?: InputMaybe<Treasury_Transfer_History_Data_Bool_Exp>;
};


/** columns and relationships of "treasury" */
export type TreasuryTransfer_History_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Transfer_History_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Transfer_History_Data_Order_By>>;
  where?: InputMaybe<Treasury_Transfer_History_Data_Bool_Exp>;
};


/** columns and relationships of "treasury" */
export type TreasuryWhitelist_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Whitelist_Contract_Bool_Exp>;
};


/** columns and relationships of "treasury" */
export type TreasuryWhitelist_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Whitelist_Contract_Bool_Exp>;
};


/** columns and relationships of "treasury" */
export type TreasuryWhitelist_Token_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Whitelist_Token_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Whitelist_Token_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Whitelist_Token_Contract_Bool_Exp>;
};


/** columns and relationships of "treasury" */
export type TreasuryWhitelist_Token_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Whitelist_Token_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Whitelist_Token_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Whitelist_Token_Contract_Bool_Exp>;
};

/** aggregated selection of "treasury" */
export type Treasury_Aggregate = {
  __typename?: 'treasury_aggregate';
  aggregate?: Maybe<Treasury_Aggregate_Fields>;
  nodes: Array<Treasury>;
};

export type Treasury_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Treasury_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Treasury_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Treasury_Aggregate_Bool_Exp_Count>;
};

export type Treasury_Aggregate_Bool_Exp_Bool_And = {
  arguments: Treasury_Select_Column_Treasury_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Treasury_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Treasury_Select_Column_Treasury_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Treasury_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Treasury_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "treasury" */
export type Treasury_Aggregate_Fields = {
  __typename?: 'treasury_aggregate_fields';
  avg?: Maybe<Treasury_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Treasury_Max_Fields>;
  min?: Maybe<Treasury_Min_Fields>;
  stddev?: Maybe<Treasury_Stddev_Fields>;
  stddev_pop?: Maybe<Treasury_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Treasury_Stddev_Samp_Fields>;
  sum?: Maybe<Treasury_Sum_Fields>;
  var_pop?: Maybe<Treasury_Var_Pop_Fields>;
  var_samp?: Maybe<Treasury_Var_Samp_Fields>;
  variance?: Maybe<Treasury_Variance_Fields>;
};


/** aggregate fields of "treasury" */
export type Treasury_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Treasury_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "treasury" */
export type Treasury_Aggregate_Order_By = {
  avg?: InputMaybe<Treasury_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Treasury_Max_Order_By>;
  min?: InputMaybe<Treasury_Min_Order_By>;
  stddev?: InputMaybe<Treasury_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Treasury_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Treasury_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Treasury_Sum_Order_By>;
  var_pop?: InputMaybe<Treasury_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Treasury_Var_Samp_Order_By>;
  variance?: InputMaybe<Treasury_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Treasury_Avg_Fields = {
  __typename?: 'treasury_avg_fields';
  baker_id?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "treasury" */
export type Treasury_Avg_Order_By = {
  baker_id?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "treasury_balance" */
export type Treasury_Balance = {
  __typename?: 'treasury_balance';
  balance: Scalars['float8']['output'];
  id: Scalars['bigint']['output'];
  mvkt_token_id: Scalars['bigint']['output'];
  /** An object relationship */
  token: Token;
  token_id: Scalars['bigint']['output'];
  /** An object relationship */
  treasury: Treasury;
  treasury_id: Scalars['bigint']['output'];
  whitelisted: Scalars['Boolean']['output'];
};

/** aggregated selection of "treasury_balance" */
export type Treasury_Balance_Aggregate = {
  __typename?: 'treasury_balance_aggregate';
  aggregate?: Maybe<Treasury_Balance_Aggregate_Fields>;
  nodes: Array<Treasury_Balance>;
};

export type Treasury_Balance_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Treasury_Balance_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Treasury_Balance_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Treasury_Balance_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Treasury_Balance_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Treasury_Balance_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Treasury_Balance_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Treasury_Balance_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Treasury_Balance_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Treasury_Balance_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Treasury_Balance_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Treasury_Balance_Aggregate_Bool_Exp_Var_Samp>;
};

export type Treasury_Balance_Aggregate_Bool_Exp_Avg = {
  arguments: Treasury_Balance_Select_Column_Treasury_Balance_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_Balance_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Treasury_Balance_Aggregate_Bool_Exp_Bool_And = {
  arguments: Treasury_Balance_Select_Column_Treasury_Balance_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_Balance_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Treasury_Balance_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Treasury_Balance_Select_Column_Treasury_Balance_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_Balance_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Treasury_Balance_Aggregate_Bool_Exp_Corr = {
  arguments: Treasury_Balance_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_Balance_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Treasury_Balance_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Treasury_Balance_Select_Column_Treasury_Balance_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Treasury_Balance_Select_Column_Treasury_Balance_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Treasury_Balance_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Treasury_Balance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_Balance_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Treasury_Balance_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Treasury_Balance_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_Balance_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Treasury_Balance_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Treasury_Balance_Select_Column_Treasury_Balance_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Treasury_Balance_Select_Column_Treasury_Balance_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Treasury_Balance_Aggregate_Bool_Exp_Max = {
  arguments: Treasury_Balance_Select_Column_Treasury_Balance_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_Balance_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Treasury_Balance_Aggregate_Bool_Exp_Min = {
  arguments: Treasury_Balance_Select_Column_Treasury_Balance_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_Balance_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Treasury_Balance_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Treasury_Balance_Select_Column_Treasury_Balance_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_Balance_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Treasury_Balance_Aggregate_Bool_Exp_Sum = {
  arguments: Treasury_Balance_Select_Column_Treasury_Balance_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_Balance_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Treasury_Balance_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Treasury_Balance_Select_Column_Treasury_Balance_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_Balance_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "treasury_balance" */
export type Treasury_Balance_Aggregate_Fields = {
  __typename?: 'treasury_balance_aggregate_fields';
  avg?: Maybe<Treasury_Balance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Treasury_Balance_Max_Fields>;
  min?: Maybe<Treasury_Balance_Min_Fields>;
  stddev?: Maybe<Treasury_Balance_Stddev_Fields>;
  stddev_pop?: Maybe<Treasury_Balance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Treasury_Balance_Stddev_Samp_Fields>;
  sum?: Maybe<Treasury_Balance_Sum_Fields>;
  var_pop?: Maybe<Treasury_Balance_Var_Pop_Fields>;
  var_samp?: Maybe<Treasury_Balance_Var_Samp_Fields>;
  variance?: Maybe<Treasury_Balance_Variance_Fields>;
};


/** aggregate fields of "treasury_balance" */
export type Treasury_Balance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Treasury_Balance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "treasury_balance" */
export type Treasury_Balance_Aggregate_Order_By = {
  avg?: InputMaybe<Treasury_Balance_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Treasury_Balance_Max_Order_By>;
  min?: InputMaybe<Treasury_Balance_Min_Order_By>;
  stddev?: InputMaybe<Treasury_Balance_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Treasury_Balance_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Treasury_Balance_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Treasury_Balance_Sum_Order_By>;
  var_pop?: InputMaybe<Treasury_Balance_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Treasury_Balance_Var_Samp_Order_By>;
  variance?: InputMaybe<Treasury_Balance_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Treasury_Balance_Avg_Fields = {
  __typename?: 'treasury_balance_avg_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mvkt_token_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  treasury_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "treasury_balance" */
export type Treasury_Balance_Avg_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mvkt_token_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "treasury_balance". All fields are combined with a logical 'AND'. */
export type Treasury_Balance_Bool_Exp = {
  _and?: InputMaybe<Array<Treasury_Balance_Bool_Exp>>;
  _not?: InputMaybe<Treasury_Balance_Bool_Exp>;
  _or?: InputMaybe<Array<Treasury_Balance_Bool_Exp>>;
  balance?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  mvkt_token_id?: InputMaybe<Bigint_Comparison_Exp>;
  token?: InputMaybe<Token_Bool_Exp>;
  token_id?: InputMaybe<Bigint_Comparison_Exp>;
  treasury?: InputMaybe<Treasury_Bool_Exp>;
  treasury_id?: InputMaybe<Bigint_Comparison_Exp>;
  whitelisted?: InputMaybe<Boolean_Comparison_Exp>;
};

/** aggregate max on columns */
export type Treasury_Balance_Max_Fields = {
  __typename?: 'treasury_balance_max_fields';
  balance?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  mvkt_token_id?: Maybe<Scalars['bigint']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  treasury_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "treasury_balance" */
export type Treasury_Balance_Max_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mvkt_token_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Treasury_Balance_Min_Fields = {
  __typename?: 'treasury_balance_min_fields';
  balance?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  mvkt_token_id?: Maybe<Scalars['bigint']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  treasury_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "treasury_balance" */
export type Treasury_Balance_Min_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mvkt_token_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "treasury_balance". */
export type Treasury_Balance_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mvkt_token_id?: InputMaybe<Order_By>;
  token?: InputMaybe<Token_Order_By>;
  token_id?: InputMaybe<Order_By>;
  treasury?: InputMaybe<Treasury_Order_By>;
  treasury_id?: InputMaybe<Order_By>;
  whitelisted?: InputMaybe<Order_By>;
};

/** select columns of table "treasury_balance" */
export enum Treasury_Balance_Select_Column {
  /** column name */
  Balance = 'balance',
  /** column name */
  Id = 'id',
  /** column name */
  MvktTokenId = 'mvkt_token_id',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  TreasuryId = 'treasury_id',
  /** column name */
  Whitelisted = 'whitelisted'
}

/** select "treasury_balance_aggregate_bool_exp_avg_arguments_columns" columns of table "treasury_balance" */
export enum Treasury_Balance_Select_Column_Treasury_Balance_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Balance = 'balance'
}

/** select "treasury_balance_aggregate_bool_exp_bool_and_arguments_columns" columns of table "treasury_balance" */
export enum Treasury_Balance_Select_Column_Treasury_Balance_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Whitelisted = 'whitelisted'
}

/** select "treasury_balance_aggregate_bool_exp_bool_or_arguments_columns" columns of table "treasury_balance" */
export enum Treasury_Balance_Select_Column_Treasury_Balance_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Whitelisted = 'whitelisted'
}

/** select "treasury_balance_aggregate_bool_exp_corr_arguments_columns" columns of table "treasury_balance" */
export enum Treasury_Balance_Select_Column_Treasury_Balance_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Balance = 'balance'
}

/** select "treasury_balance_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "treasury_balance" */
export enum Treasury_Balance_Select_Column_Treasury_Balance_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Balance = 'balance'
}

/** select "treasury_balance_aggregate_bool_exp_max_arguments_columns" columns of table "treasury_balance" */
export enum Treasury_Balance_Select_Column_Treasury_Balance_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Balance = 'balance'
}

/** select "treasury_balance_aggregate_bool_exp_min_arguments_columns" columns of table "treasury_balance" */
export enum Treasury_Balance_Select_Column_Treasury_Balance_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Balance = 'balance'
}

/** select "treasury_balance_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "treasury_balance" */
export enum Treasury_Balance_Select_Column_Treasury_Balance_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Balance = 'balance'
}

/** select "treasury_balance_aggregate_bool_exp_sum_arguments_columns" columns of table "treasury_balance" */
export enum Treasury_Balance_Select_Column_Treasury_Balance_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Balance = 'balance'
}

/** select "treasury_balance_aggregate_bool_exp_var_samp_arguments_columns" columns of table "treasury_balance" */
export enum Treasury_Balance_Select_Column_Treasury_Balance_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Balance = 'balance'
}

/** aggregate stddev on columns */
export type Treasury_Balance_Stddev_Fields = {
  __typename?: 'treasury_balance_stddev_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mvkt_token_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  treasury_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "treasury_balance" */
export type Treasury_Balance_Stddev_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mvkt_token_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Treasury_Balance_Stddev_Pop_Fields = {
  __typename?: 'treasury_balance_stddev_pop_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mvkt_token_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  treasury_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "treasury_balance" */
export type Treasury_Balance_Stddev_Pop_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mvkt_token_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Treasury_Balance_Stddev_Samp_Fields = {
  __typename?: 'treasury_balance_stddev_samp_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mvkt_token_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  treasury_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "treasury_balance" */
export type Treasury_Balance_Stddev_Samp_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mvkt_token_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "treasury_balance" */
export type Treasury_Balance_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Treasury_Balance_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Treasury_Balance_Stream_Cursor_Value_Input = {
  balance?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  mvkt_token_id?: InputMaybe<Scalars['bigint']['input']>;
  token_id?: InputMaybe<Scalars['bigint']['input']>;
  treasury_id?: InputMaybe<Scalars['bigint']['input']>;
  whitelisted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Treasury_Balance_Sum_Fields = {
  __typename?: 'treasury_balance_sum_fields';
  balance?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  mvkt_token_id?: Maybe<Scalars['bigint']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  treasury_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "treasury_balance" */
export type Treasury_Balance_Sum_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mvkt_token_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Treasury_Balance_Var_Pop_Fields = {
  __typename?: 'treasury_balance_var_pop_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mvkt_token_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  treasury_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "treasury_balance" */
export type Treasury_Balance_Var_Pop_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mvkt_token_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Treasury_Balance_Var_Samp_Fields = {
  __typename?: 'treasury_balance_var_samp_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mvkt_token_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  treasury_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "treasury_balance" */
export type Treasury_Balance_Var_Samp_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mvkt_token_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Treasury_Balance_Variance_Fields = {
  __typename?: 'treasury_balance_variance_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mvkt_token_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  treasury_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "treasury_balance" */
export type Treasury_Balance_Variance_Order_By = {
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mvkt_token_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "treasury". All fields are combined with a logical 'AND'. */
export type Treasury_Bool_Exp = {
  _and?: InputMaybe<Array<Treasury_Bool_Exp>>;
  _not?: InputMaybe<Treasury_Bool_Exp>;
  _or?: InputMaybe<Array<Treasury_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  admin?: InputMaybe<String_Comparison_Exp>;
  baker?: InputMaybe<Maven_User_Bool_Exp>;
  baker_id?: InputMaybe<Bigint_Comparison_Exp>;
  balances?: InputMaybe<Treasury_Balance_Bool_Exp>;
  balances_aggregate?: InputMaybe<Treasury_Balance_Aggregate_Bool_Exp>;
  creation_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  factory?: InputMaybe<Treasury_Factory_Bool_Exp>;
  factory_id?: InputMaybe<Bigint_Comparison_Exp>;
  general_contracts?: InputMaybe<Treasury_General_Contract_Bool_Exp>;
  general_contracts_aggregate?: InputMaybe<Treasury_General_Contract_Aggregate_Bool_Exp>;
  governance?: InputMaybe<Governance_Bool_Exp>;
  governance_financial_requests?: InputMaybe<Governance_Financial_Request_Bool_Exp>;
  governance_financial_requests_aggregate?: InputMaybe<Governance_Financial_Request_Aggregate_Bool_Exp>;
  governance_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambdas?: InputMaybe<Treasury_Lambda_Bool_Exp>;
  lambdas_aggregate?: InputMaybe<Treasury_Lambda_Aggregate_Bool_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mint_mvn_and_transfer_paused?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
  stake_tokens_paused?: InputMaybe<Boolean_Comparison_Exp>;
  transfer_history_data?: InputMaybe<Treasury_Transfer_History_Data_Bool_Exp>;
  transfer_history_data_aggregate?: InputMaybe<Treasury_Transfer_History_Data_Aggregate_Bool_Exp>;
  transfer_paused?: InputMaybe<Boolean_Comparison_Exp>;
  unstake_tokens_paused?: InputMaybe<Boolean_Comparison_Exp>;
  update_token_operators_paused?: InputMaybe<Boolean_Comparison_Exp>;
  whitelist_contracts?: InputMaybe<Treasury_Whitelist_Contract_Bool_Exp>;
  whitelist_contracts_aggregate?: InputMaybe<Treasury_Whitelist_Contract_Aggregate_Bool_Exp>;
  whitelist_token_contracts?: InputMaybe<Treasury_Whitelist_Token_Contract_Bool_Exp>;
  whitelist_token_contracts_aggregate?: InputMaybe<Treasury_Whitelist_Token_Contract_Aggregate_Bool_Exp>;
};

/** columns and relationships of "treasury_factory" */
export type Treasury_Factory = {
  __typename?: 'treasury_factory';
  address: Scalars['String']['output'];
  admin: Scalars['String']['output'];
  create_treasury_paused: Scalars['Boolean']['output'];
  /** An array relationship */
  general_contracts: Array<Treasury_Factory_General_Contract>;
  /** An aggregate relationship */
  general_contracts_aggregate: Treasury_Factory_General_Contract_Aggregate;
  /** An object relationship */
  governance: Governance;
  governance_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An array relationship */
  lambdas: Array<Treasury_Factory_Lambda>;
  /** An aggregate relationship */
  lambdas_aggregate: Treasury_Factory_Lambda_Aggregate;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  network: Scalars['String']['output'];
  track_treasury_paused: Scalars['Boolean']['output'];
  /** An array relationship */
  treasuries: Array<Treasury>;
  /** An aggregate relationship */
  treasuries_aggregate: Treasury_Aggregate;
  /** An array relationship */
  treasury_lambdas: Array<Treasury_Factory_Treasury_Lambda>;
  /** An aggregate relationship */
  treasury_lambdas_aggregate: Treasury_Factory_Treasury_Lambda_Aggregate;
  treasury_name_max_length: Scalars['smallint']['output'];
  untrack_treasury_paused: Scalars['Boolean']['output'];
  /** An array relationship */
  whitelist_contracts: Array<Treasury_Factory_Whitelist_Contract>;
  /** An aggregate relationship */
  whitelist_contracts_aggregate: Treasury_Factory_Whitelist_Contract_Aggregate;
  /** An array relationship */
  whitelist_token_contracts: Array<Treasury_Factory_Whitelist_Token_Contract>;
  /** An aggregate relationship */
  whitelist_token_contracts_aggregate: Treasury_Factory_Whitelist_Token_Contract_Aggregate;
};


/** columns and relationships of "treasury_factory" */
export type Treasury_FactoryGeneral_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_General_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Factory_General_Contract_Bool_Exp>;
};


/** columns and relationships of "treasury_factory" */
export type Treasury_FactoryGeneral_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_General_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Factory_General_Contract_Bool_Exp>;
};


/** columns and relationships of "treasury_factory" */
export type Treasury_FactoryLambdasArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Lambda_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Lambda_Bool_Exp>;
};


/** columns and relationships of "treasury_factory" */
export type Treasury_FactoryLambdas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Lambda_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Lambda_Bool_Exp>;
};


/** columns and relationships of "treasury_factory" */
export type Treasury_FactoryMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "treasury_factory" */
export type Treasury_FactoryTreasuriesArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Order_By>>;
  where?: InputMaybe<Treasury_Bool_Exp>;
};


/** columns and relationships of "treasury_factory" */
export type Treasury_FactoryTreasuries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Order_By>>;
  where?: InputMaybe<Treasury_Bool_Exp>;
};


/** columns and relationships of "treasury_factory" */
export type Treasury_FactoryTreasury_LambdasArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Treasury_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Treasury_Lambda_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Treasury_Lambda_Bool_Exp>;
};


/** columns and relationships of "treasury_factory" */
export type Treasury_FactoryTreasury_Lambdas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Treasury_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Treasury_Lambda_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Treasury_Lambda_Bool_Exp>;
};


/** columns and relationships of "treasury_factory" */
export type Treasury_FactoryWhitelist_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Whitelist_Contract_Bool_Exp>;
};


/** columns and relationships of "treasury_factory" */
export type Treasury_FactoryWhitelist_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Whitelist_Contract_Bool_Exp>;
};


/** columns and relationships of "treasury_factory" */
export type Treasury_FactoryWhitelist_Token_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Whitelist_Token_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Whitelist_Token_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Bool_Exp>;
};


/** columns and relationships of "treasury_factory" */
export type Treasury_FactoryWhitelist_Token_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Treasury_Factory_Whitelist_Token_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Treasury_Factory_Whitelist_Token_Contract_Order_By>>;
  where?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Bool_Exp>;
};

/** aggregated selection of "treasury_factory" */
export type Treasury_Factory_Aggregate = {
  __typename?: 'treasury_factory_aggregate';
  aggregate?: Maybe<Treasury_Factory_Aggregate_Fields>;
  nodes: Array<Treasury_Factory>;
};

export type Treasury_Factory_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Treasury_Factory_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Treasury_Factory_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Treasury_Factory_Aggregate_Bool_Exp_Count>;
};

export type Treasury_Factory_Aggregate_Bool_Exp_Bool_And = {
  arguments: Treasury_Factory_Select_Column_Treasury_Factory_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_Factory_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Treasury_Factory_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Treasury_Factory_Select_Column_Treasury_Factory_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_Factory_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Treasury_Factory_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Treasury_Factory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_Factory_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "treasury_factory" */
export type Treasury_Factory_Aggregate_Fields = {
  __typename?: 'treasury_factory_aggregate_fields';
  avg?: Maybe<Treasury_Factory_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Treasury_Factory_Max_Fields>;
  min?: Maybe<Treasury_Factory_Min_Fields>;
  stddev?: Maybe<Treasury_Factory_Stddev_Fields>;
  stddev_pop?: Maybe<Treasury_Factory_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Treasury_Factory_Stddev_Samp_Fields>;
  sum?: Maybe<Treasury_Factory_Sum_Fields>;
  var_pop?: Maybe<Treasury_Factory_Var_Pop_Fields>;
  var_samp?: Maybe<Treasury_Factory_Var_Samp_Fields>;
  variance?: Maybe<Treasury_Factory_Variance_Fields>;
};


/** aggregate fields of "treasury_factory" */
export type Treasury_Factory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Treasury_Factory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "treasury_factory" */
export type Treasury_Factory_Aggregate_Order_By = {
  avg?: InputMaybe<Treasury_Factory_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Treasury_Factory_Max_Order_By>;
  min?: InputMaybe<Treasury_Factory_Min_Order_By>;
  stddev?: InputMaybe<Treasury_Factory_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Treasury_Factory_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Treasury_Factory_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Treasury_Factory_Sum_Order_By>;
  var_pop?: InputMaybe<Treasury_Factory_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Treasury_Factory_Var_Samp_Order_By>;
  variance?: InputMaybe<Treasury_Factory_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Treasury_Factory_Avg_Fields = {
  __typename?: 'treasury_factory_avg_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  treasury_name_max_length?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "treasury_factory" */
export type Treasury_Factory_Avg_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  treasury_name_max_length?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "treasury_factory". All fields are combined with a logical 'AND'. */
export type Treasury_Factory_Bool_Exp = {
  _and?: InputMaybe<Array<Treasury_Factory_Bool_Exp>>;
  _not?: InputMaybe<Treasury_Factory_Bool_Exp>;
  _or?: InputMaybe<Array<Treasury_Factory_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  admin?: InputMaybe<String_Comparison_Exp>;
  create_treasury_paused?: InputMaybe<Boolean_Comparison_Exp>;
  general_contracts?: InputMaybe<Treasury_Factory_General_Contract_Bool_Exp>;
  general_contracts_aggregate?: InputMaybe<Treasury_Factory_General_Contract_Aggregate_Bool_Exp>;
  governance?: InputMaybe<Governance_Bool_Exp>;
  governance_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambdas?: InputMaybe<Treasury_Factory_Lambda_Bool_Exp>;
  lambdas_aggregate?: InputMaybe<Treasury_Factory_Lambda_Aggregate_Bool_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
  track_treasury_paused?: InputMaybe<Boolean_Comparison_Exp>;
  treasuries?: InputMaybe<Treasury_Bool_Exp>;
  treasuries_aggregate?: InputMaybe<Treasury_Aggregate_Bool_Exp>;
  treasury_lambdas?: InputMaybe<Treasury_Factory_Treasury_Lambda_Bool_Exp>;
  treasury_lambdas_aggregate?: InputMaybe<Treasury_Factory_Treasury_Lambda_Aggregate_Bool_Exp>;
  treasury_name_max_length?: InputMaybe<Smallint_Comparison_Exp>;
  untrack_treasury_paused?: InputMaybe<Boolean_Comparison_Exp>;
  whitelist_contracts?: InputMaybe<Treasury_Factory_Whitelist_Contract_Bool_Exp>;
  whitelist_contracts_aggregate?: InputMaybe<Treasury_Factory_Whitelist_Contract_Aggregate_Bool_Exp>;
  whitelist_token_contracts?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Bool_Exp>;
  whitelist_token_contracts_aggregate?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Aggregate_Bool_Exp>;
};

/** columns and relationships of "treasury_factory_general_contract" */
export type Treasury_Factory_General_Contract = {
  __typename?: 'treasury_factory_general_contract';
  /** An object relationship */
  contract: Treasury_Factory;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  contract_name: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "treasury_factory_general_contract" */
export type Treasury_Factory_General_Contract_Aggregate = {
  __typename?: 'treasury_factory_general_contract_aggregate';
  aggregate?: Maybe<Treasury_Factory_General_Contract_Aggregate_Fields>;
  nodes: Array<Treasury_Factory_General_Contract>;
};

export type Treasury_Factory_General_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Treasury_Factory_General_Contract_Aggregate_Bool_Exp_Count>;
};

export type Treasury_Factory_General_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Treasury_Factory_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_Factory_General_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "treasury_factory_general_contract" */
export type Treasury_Factory_General_Contract_Aggregate_Fields = {
  __typename?: 'treasury_factory_general_contract_aggregate_fields';
  avg?: Maybe<Treasury_Factory_General_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Treasury_Factory_General_Contract_Max_Fields>;
  min?: Maybe<Treasury_Factory_General_Contract_Min_Fields>;
  stddev?: Maybe<Treasury_Factory_General_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Treasury_Factory_General_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Treasury_Factory_General_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Treasury_Factory_General_Contract_Sum_Fields>;
  var_pop?: Maybe<Treasury_Factory_General_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Treasury_Factory_General_Contract_Var_Samp_Fields>;
  variance?: Maybe<Treasury_Factory_General_Contract_Variance_Fields>;
};


/** aggregate fields of "treasury_factory_general_contract" */
export type Treasury_Factory_General_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Treasury_Factory_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "treasury_factory_general_contract" */
export type Treasury_Factory_General_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Treasury_Factory_General_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Treasury_Factory_General_Contract_Max_Order_By>;
  min?: InputMaybe<Treasury_Factory_General_Contract_Min_Order_By>;
  stddev?: InputMaybe<Treasury_Factory_General_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Treasury_Factory_General_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Treasury_Factory_General_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Treasury_Factory_General_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Treasury_Factory_General_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Treasury_Factory_General_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Treasury_Factory_General_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Treasury_Factory_General_Contract_Avg_Fields = {
  __typename?: 'treasury_factory_general_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "treasury_factory_general_contract" */
export type Treasury_Factory_General_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "treasury_factory_general_contract". All fields are combined with a logical 'AND'. */
export type Treasury_Factory_General_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Treasury_Factory_General_Contract_Bool_Exp>>;
  _not?: InputMaybe<Treasury_Factory_General_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Treasury_Factory_General_Contract_Bool_Exp>>;
  contract?: InputMaybe<Treasury_Factory_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  contract_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Treasury_Factory_General_Contract_Max_Fields = {
  __typename?: 'treasury_factory_general_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "treasury_factory_general_contract" */
export type Treasury_Factory_General_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Treasury_Factory_General_Contract_Min_Fields = {
  __typename?: 'treasury_factory_general_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "treasury_factory_general_contract" */
export type Treasury_Factory_General_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "treasury_factory_general_contract". */
export type Treasury_Factory_General_Contract_Order_By = {
  contract?: InputMaybe<Treasury_Factory_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "treasury_factory_general_contract" */
export enum Treasury_Factory_General_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  ContractName = 'contract_name',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Treasury_Factory_General_Contract_Stddev_Fields = {
  __typename?: 'treasury_factory_general_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "treasury_factory_general_contract" */
export type Treasury_Factory_General_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Treasury_Factory_General_Contract_Stddev_Pop_Fields = {
  __typename?: 'treasury_factory_general_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "treasury_factory_general_contract" */
export type Treasury_Factory_General_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Treasury_Factory_General_Contract_Stddev_Samp_Fields = {
  __typename?: 'treasury_factory_general_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "treasury_factory_general_contract" */
export type Treasury_Factory_General_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "treasury_factory_general_contract" */
export type Treasury_Factory_General_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Treasury_Factory_General_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Treasury_Factory_General_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  contract_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Treasury_Factory_General_Contract_Sum_Fields = {
  __typename?: 'treasury_factory_general_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "treasury_factory_general_contract" */
export type Treasury_Factory_General_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Treasury_Factory_General_Contract_Var_Pop_Fields = {
  __typename?: 'treasury_factory_general_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "treasury_factory_general_contract" */
export type Treasury_Factory_General_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Treasury_Factory_General_Contract_Var_Samp_Fields = {
  __typename?: 'treasury_factory_general_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "treasury_factory_general_contract" */
export type Treasury_Factory_General_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Treasury_Factory_General_Contract_Variance_Fields = {
  __typename?: 'treasury_factory_general_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "treasury_factory_general_contract" */
export type Treasury_Factory_General_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "treasury_factory_lambda" */
export type Treasury_Factory_Lambda = {
  __typename?: 'treasury_factory_lambda';
  /** An object relationship */
  contract: Treasury_Factory;
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lambda_bytes: Scalars['String']['output'];
  lambda_name: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "treasury_factory_lambda" */
export type Treasury_Factory_Lambda_Aggregate = {
  __typename?: 'treasury_factory_lambda_aggregate';
  aggregate?: Maybe<Treasury_Factory_Lambda_Aggregate_Fields>;
  nodes: Array<Treasury_Factory_Lambda>;
};

export type Treasury_Factory_Lambda_Aggregate_Bool_Exp = {
  count?: InputMaybe<Treasury_Factory_Lambda_Aggregate_Bool_Exp_Count>;
};

export type Treasury_Factory_Lambda_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Treasury_Factory_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_Factory_Lambda_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "treasury_factory_lambda" */
export type Treasury_Factory_Lambda_Aggregate_Fields = {
  __typename?: 'treasury_factory_lambda_aggregate_fields';
  avg?: Maybe<Treasury_Factory_Lambda_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Treasury_Factory_Lambda_Max_Fields>;
  min?: Maybe<Treasury_Factory_Lambda_Min_Fields>;
  stddev?: Maybe<Treasury_Factory_Lambda_Stddev_Fields>;
  stddev_pop?: Maybe<Treasury_Factory_Lambda_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Treasury_Factory_Lambda_Stddev_Samp_Fields>;
  sum?: Maybe<Treasury_Factory_Lambda_Sum_Fields>;
  var_pop?: Maybe<Treasury_Factory_Lambda_Var_Pop_Fields>;
  var_samp?: Maybe<Treasury_Factory_Lambda_Var_Samp_Fields>;
  variance?: Maybe<Treasury_Factory_Lambda_Variance_Fields>;
};


/** aggregate fields of "treasury_factory_lambda" */
export type Treasury_Factory_Lambda_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Treasury_Factory_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "treasury_factory_lambda" */
export type Treasury_Factory_Lambda_Aggregate_Order_By = {
  avg?: InputMaybe<Treasury_Factory_Lambda_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Treasury_Factory_Lambda_Max_Order_By>;
  min?: InputMaybe<Treasury_Factory_Lambda_Min_Order_By>;
  stddev?: InputMaybe<Treasury_Factory_Lambda_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Treasury_Factory_Lambda_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Treasury_Factory_Lambda_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Treasury_Factory_Lambda_Sum_Order_By>;
  var_pop?: InputMaybe<Treasury_Factory_Lambda_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Treasury_Factory_Lambda_Var_Samp_Order_By>;
  variance?: InputMaybe<Treasury_Factory_Lambda_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Treasury_Factory_Lambda_Avg_Fields = {
  __typename?: 'treasury_factory_lambda_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "treasury_factory_lambda" */
export type Treasury_Factory_Lambda_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "treasury_factory_lambda". All fields are combined with a logical 'AND'. */
export type Treasury_Factory_Lambda_Bool_Exp = {
  _and?: InputMaybe<Array<Treasury_Factory_Lambda_Bool_Exp>>;
  _not?: InputMaybe<Treasury_Factory_Lambda_Bool_Exp>;
  _or?: InputMaybe<Array<Treasury_Factory_Lambda_Bool_Exp>>;
  contract?: InputMaybe<Treasury_Factory_Bool_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambda_bytes?: InputMaybe<String_Comparison_Exp>;
  lambda_name?: InputMaybe<String_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Treasury_Factory_Lambda_Max_Fields = {
  __typename?: 'treasury_factory_lambda_max_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "treasury_factory_lambda" */
export type Treasury_Factory_Lambda_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Treasury_Factory_Lambda_Min_Fields = {
  __typename?: 'treasury_factory_lambda_min_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "treasury_factory_lambda" */
export type Treasury_Factory_Lambda_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "treasury_factory_lambda". */
export type Treasury_Factory_Lambda_Order_By = {
  contract?: InputMaybe<Treasury_Factory_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "treasury_factory_lambda" */
export enum Treasury_Factory_Lambda_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaBytes = 'lambda_bytes',
  /** column name */
  LambdaName = 'lambda_name',
  /** column name */
  LastUpdatedAt = 'last_updated_at'
}

/** aggregate stddev on columns */
export type Treasury_Factory_Lambda_Stddev_Fields = {
  __typename?: 'treasury_factory_lambda_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "treasury_factory_lambda" */
export type Treasury_Factory_Lambda_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Treasury_Factory_Lambda_Stddev_Pop_Fields = {
  __typename?: 'treasury_factory_lambda_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "treasury_factory_lambda" */
export type Treasury_Factory_Lambda_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Treasury_Factory_Lambda_Stddev_Samp_Fields = {
  __typename?: 'treasury_factory_lambda_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "treasury_factory_lambda" */
export type Treasury_Factory_Lambda_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "treasury_factory_lambda" */
export type Treasury_Factory_Lambda_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Treasury_Factory_Lambda_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Treasury_Factory_Lambda_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lambda_bytes?: InputMaybe<Scalars['String']['input']>;
  lambda_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Treasury_Factory_Lambda_Sum_Fields = {
  __typename?: 'treasury_factory_lambda_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "treasury_factory_lambda" */
export type Treasury_Factory_Lambda_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Treasury_Factory_Lambda_Var_Pop_Fields = {
  __typename?: 'treasury_factory_lambda_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "treasury_factory_lambda" */
export type Treasury_Factory_Lambda_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Treasury_Factory_Lambda_Var_Samp_Fields = {
  __typename?: 'treasury_factory_lambda_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "treasury_factory_lambda" */
export type Treasury_Factory_Lambda_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Treasury_Factory_Lambda_Variance_Fields = {
  __typename?: 'treasury_factory_lambda_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "treasury_factory_lambda" */
export type Treasury_Factory_Lambda_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Treasury_Factory_Max_Fields = {
  __typename?: 'treasury_factory_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  treasury_name_max_length?: Maybe<Scalars['smallint']['output']>;
};

/** order by max() on columns of table "treasury_factory" */
export type Treasury_Factory_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  treasury_name_max_length?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Treasury_Factory_Min_Fields = {
  __typename?: 'treasury_factory_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  treasury_name_max_length?: Maybe<Scalars['smallint']['output']>;
};

/** order by min() on columns of table "treasury_factory" */
export type Treasury_Factory_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  treasury_name_max_length?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "treasury_factory". */
export type Treasury_Factory_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  create_treasury_paused?: InputMaybe<Order_By>;
  general_contracts_aggregate?: InputMaybe<Treasury_Factory_General_Contract_Aggregate_Order_By>;
  governance?: InputMaybe<Governance_Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambdas_aggregate?: InputMaybe<Treasury_Factory_Lambda_Aggregate_Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  track_treasury_paused?: InputMaybe<Order_By>;
  treasuries_aggregate?: InputMaybe<Treasury_Aggregate_Order_By>;
  treasury_lambdas_aggregate?: InputMaybe<Treasury_Factory_Treasury_Lambda_Aggregate_Order_By>;
  treasury_name_max_length?: InputMaybe<Order_By>;
  untrack_treasury_paused?: InputMaybe<Order_By>;
  whitelist_contracts_aggregate?: InputMaybe<Treasury_Factory_Whitelist_Contract_Aggregate_Order_By>;
  whitelist_token_contracts_aggregate?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Aggregate_Order_By>;
};

/** select columns of table "treasury_factory" */
export enum Treasury_Factory_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Admin = 'admin',
  /** column name */
  CreateTreasuryPaused = 'create_treasury_paused',
  /** column name */
  GovernanceId = 'governance_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Network = 'network',
  /** column name */
  TrackTreasuryPaused = 'track_treasury_paused',
  /** column name */
  TreasuryNameMaxLength = 'treasury_name_max_length',
  /** column name */
  UntrackTreasuryPaused = 'untrack_treasury_paused'
}

/** select "treasury_factory_aggregate_bool_exp_bool_and_arguments_columns" columns of table "treasury_factory" */
export enum Treasury_Factory_Select_Column_Treasury_Factory_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CreateTreasuryPaused = 'create_treasury_paused',
  /** column name */
  TrackTreasuryPaused = 'track_treasury_paused',
  /** column name */
  UntrackTreasuryPaused = 'untrack_treasury_paused'
}

/** select "treasury_factory_aggregate_bool_exp_bool_or_arguments_columns" columns of table "treasury_factory" */
export enum Treasury_Factory_Select_Column_Treasury_Factory_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CreateTreasuryPaused = 'create_treasury_paused',
  /** column name */
  TrackTreasuryPaused = 'track_treasury_paused',
  /** column name */
  UntrackTreasuryPaused = 'untrack_treasury_paused'
}

/** aggregate stddev on columns */
export type Treasury_Factory_Stddev_Fields = {
  __typename?: 'treasury_factory_stddev_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  treasury_name_max_length?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "treasury_factory" */
export type Treasury_Factory_Stddev_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  treasury_name_max_length?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Treasury_Factory_Stddev_Pop_Fields = {
  __typename?: 'treasury_factory_stddev_pop_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  treasury_name_max_length?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "treasury_factory" */
export type Treasury_Factory_Stddev_Pop_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  treasury_name_max_length?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Treasury_Factory_Stddev_Samp_Fields = {
  __typename?: 'treasury_factory_stddev_samp_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  treasury_name_max_length?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "treasury_factory" */
export type Treasury_Factory_Stddev_Samp_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  treasury_name_max_length?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "treasury_factory" */
export type Treasury_Factory_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Treasury_Factory_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Treasury_Factory_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['String']['input']>;
  create_treasury_paused?: InputMaybe<Scalars['Boolean']['input']>;
  governance_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  track_treasury_paused?: InputMaybe<Scalars['Boolean']['input']>;
  treasury_name_max_length?: InputMaybe<Scalars['smallint']['input']>;
  untrack_treasury_paused?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Treasury_Factory_Sum_Fields = {
  __typename?: 'treasury_factory_sum_fields';
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  treasury_name_max_length?: Maybe<Scalars['smallint']['output']>;
};

/** order by sum() on columns of table "treasury_factory" */
export type Treasury_Factory_Sum_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  treasury_name_max_length?: InputMaybe<Order_By>;
};

/** columns and relationships of "treasury_factory_treasury_lambda" */
export type Treasury_Factory_Treasury_Lambda = {
  __typename?: 'treasury_factory_treasury_lambda';
  /** An object relationship */
  contract: Treasury_Factory;
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lambda_bytes: Scalars['String']['output'];
  lambda_name: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "treasury_factory_treasury_lambda" */
export type Treasury_Factory_Treasury_Lambda_Aggregate = {
  __typename?: 'treasury_factory_treasury_lambda_aggregate';
  aggregate?: Maybe<Treasury_Factory_Treasury_Lambda_Aggregate_Fields>;
  nodes: Array<Treasury_Factory_Treasury_Lambda>;
};

export type Treasury_Factory_Treasury_Lambda_Aggregate_Bool_Exp = {
  count?: InputMaybe<Treasury_Factory_Treasury_Lambda_Aggregate_Bool_Exp_Count>;
};

export type Treasury_Factory_Treasury_Lambda_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Treasury_Factory_Treasury_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_Factory_Treasury_Lambda_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "treasury_factory_treasury_lambda" */
export type Treasury_Factory_Treasury_Lambda_Aggregate_Fields = {
  __typename?: 'treasury_factory_treasury_lambda_aggregate_fields';
  avg?: Maybe<Treasury_Factory_Treasury_Lambda_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Treasury_Factory_Treasury_Lambda_Max_Fields>;
  min?: Maybe<Treasury_Factory_Treasury_Lambda_Min_Fields>;
  stddev?: Maybe<Treasury_Factory_Treasury_Lambda_Stddev_Fields>;
  stddev_pop?: Maybe<Treasury_Factory_Treasury_Lambda_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Treasury_Factory_Treasury_Lambda_Stddev_Samp_Fields>;
  sum?: Maybe<Treasury_Factory_Treasury_Lambda_Sum_Fields>;
  var_pop?: Maybe<Treasury_Factory_Treasury_Lambda_Var_Pop_Fields>;
  var_samp?: Maybe<Treasury_Factory_Treasury_Lambda_Var_Samp_Fields>;
  variance?: Maybe<Treasury_Factory_Treasury_Lambda_Variance_Fields>;
};


/** aggregate fields of "treasury_factory_treasury_lambda" */
export type Treasury_Factory_Treasury_Lambda_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Treasury_Factory_Treasury_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "treasury_factory_treasury_lambda" */
export type Treasury_Factory_Treasury_Lambda_Aggregate_Order_By = {
  avg?: InputMaybe<Treasury_Factory_Treasury_Lambda_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Treasury_Factory_Treasury_Lambda_Max_Order_By>;
  min?: InputMaybe<Treasury_Factory_Treasury_Lambda_Min_Order_By>;
  stddev?: InputMaybe<Treasury_Factory_Treasury_Lambda_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Treasury_Factory_Treasury_Lambda_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Treasury_Factory_Treasury_Lambda_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Treasury_Factory_Treasury_Lambda_Sum_Order_By>;
  var_pop?: InputMaybe<Treasury_Factory_Treasury_Lambda_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Treasury_Factory_Treasury_Lambda_Var_Samp_Order_By>;
  variance?: InputMaybe<Treasury_Factory_Treasury_Lambda_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Treasury_Factory_Treasury_Lambda_Avg_Fields = {
  __typename?: 'treasury_factory_treasury_lambda_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "treasury_factory_treasury_lambda" */
export type Treasury_Factory_Treasury_Lambda_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "treasury_factory_treasury_lambda". All fields are combined with a logical 'AND'. */
export type Treasury_Factory_Treasury_Lambda_Bool_Exp = {
  _and?: InputMaybe<Array<Treasury_Factory_Treasury_Lambda_Bool_Exp>>;
  _not?: InputMaybe<Treasury_Factory_Treasury_Lambda_Bool_Exp>;
  _or?: InputMaybe<Array<Treasury_Factory_Treasury_Lambda_Bool_Exp>>;
  contract?: InputMaybe<Treasury_Factory_Bool_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambda_bytes?: InputMaybe<String_Comparison_Exp>;
  lambda_name?: InputMaybe<String_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Treasury_Factory_Treasury_Lambda_Max_Fields = {
  __typename?: 'treasury_factory_treasury_lambda_max_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "treasury_factory_treasury_lambda" */
export type Treasury_Factory_Treasury_Lambda_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Treasury_Factory_Treasury_Lambda_Min_Fields = {
  __typename?: 'treasury_factory_treasury_lambda_min_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "treasury_factory_treasury_lambda" */
export type Treasury_Factory_Treasury_Lambda_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "treasury_factory_treasury_lambda". */
export type Treasury_Factory_Treasury_Lambda_Order_By = {
  contract?: InputMaybe<Treasury_Factory_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "treasury_factory_treasury_lambda" */
export enum Treasury_Factory_Treasury_Lambda_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaBytes = 'lambda_bytes',
  /** column name */
  LambdaName = 'lambda_name',
  /** column name */
  LastUpdatedAt = 'last_updated_at'
}

/** aggregate stddev on columns */
export type Treasury_Factory_Treasury_Lambda_Stddev_Fields = {
  __typename?: 'treasury_factory_treasury_lambda_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "treasury_factory_treasury_lambda" */
export type Treasury_Factory_Treasury_Lambda_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Treasury_Factory_Treasury_Lambda_Stddev_Pop_Fields = {
  __typename?: 'treasury_factory_treasury_lambda_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "treasury_factory_treasury_lambda" */
export type Treasury_Factory_Treasury_Lambda_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Treasury_Factory_Treasury_Lambda_Stddev_Samp_Fields = {
  __typename?: 'treasury_factory_treasury_lambda_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "treasury_factory_treasury_lambda" */
export type Treasury_Factory_Treasury_Lambda_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "treasury_factory_treasury_lambda" */
export type Treasury_Factory_Treasury_Lambda_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Treasury_Factory_Treasury_Lambda_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Treasury_Factory_Treasury_Lambda_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lambda_bytes?: InputMaybe<Scalars['String']['input']>;
  lambda_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Treasury_Factory_Treasury_Lambda_Sum_Fields = {
  __typename?: 'treasury_factory_treasury_lambda_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "treasury_factory_treasury_lambda" */
export type Treasury_Factory_Treasury_Lambda_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Treasury_Factory_Treasury_Lambda_Var_Pop_Fields = {
  __typename?: 'treasury_factory_treasury_lambda_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "treasury_factory_treasury_lambda" */
export type Treasury_Factory_Treasury_Lambda_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Treasury_Factory_Treasury_Lambda_Var_Samp_Fields = {
  __typename?: 'treasury_factory_treasury_lambda_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "treasury_factory_treasury_lambda" */
export type Treasury_Factory_Treasury_Lambda_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Treasury_Factory_Treasury_Lambda_Variance_Fields = {
  __typename?: 'treasury_factory_treasury_lambda_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "treasury_factory_treasury_lambda" */
export type Treasury_Factory_Treasury_Lambda_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Treasury_Factory_Var_Pop_Fields = {
  __typename?: 'treasury_factory_var_pop_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  treasury_name_max_length?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "treasury_factory" */
export type Treasury_Factory_Var_Pop_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  treasury_name_max_length?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Treasury_Factory_Var_Samp_Fields = {
  __typename?: 'treasury_factory_var_samp_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  treasury_name_max_length?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "treasury_factory" */
export type Treasury_Factory_Var_Samp_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  treasury_name_max_length?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Treasury_Factory_Variance_Fields = {
  __typename?: 'treasury_factory_variance_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  treasury_name_max_length?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "treasury_factory" */
export type Treasury_Factory_Variance_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  treasury_name_max_length?: InputMaybe<Order_By>;
};

/** columns and relationships of "treasury_factory_whitelist_contract" */
export type Treasury_Factory_Whitelist_Contract = {
  __typename?: 'treasury_factory_whitelist_contract';
  /** An object relationship */
  contract: Treasury_Factory;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "treasury_factory_whitelist_contract" */
export type Treasury_Factory_Whitelist_Contract_Aggregate = {
  __typename?: 'treasury_factory_whitelist_contract_aggregate';
  aggregate?: Maybe<Treasury_Factory_Whitelist_Contract_Aggregate_Fields>;
  nodes: Array<Treasury_Factory_Whitelist_Contract>;
};

export type Treasury_Factory_Whitelist_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Treasury_Factory_Whitelist_Contract_Aggregate_Bool_Exp_Count>;
};

export type Treasury_Factory_Whitelist_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Treasury_Factory_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_Factory_Whitelist_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "treasury_factory_whitelist_contract" */
export type Treasury_Factory_Whitelist_Contract_Aggregate_Fields = {
  __typename?: 'treasury_factory_whitelist_contract_aggregate_fields';
  avg?: Maybe<Treasury_Factory_Whitelist_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Treasury_Factory_Whitelist_Contract_Max_Fields>;
  min?: Maybe<Treasury_Factory_Whitelist_Contract_Min_Fields>;
  stddev?: Maybe<Treasury_Factory_Whitelist_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Treasury_Factory_Whitelist_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Treasury_Factory_Whitelist_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Treasury_Factory_Whitelist_Contract_Sum_Fields>;
  var_pop?: Maybe<Treasury_Factory_Whitelist_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Treasury_Factory_Whitelist_Contract_Var_Samp_Fields>;
  variance?: Maybe<Treasury_Factory_Whitelist_Contract_Variance_Fields>;
};


/** aggregate fields of "treasury_factory_whitelist_contract" */
export type Treasury_Factory_Whitelist_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Treasury_Factory_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "treasury_factory_whitelist_contract" */
export type Treasury_Factory_Whitelist_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Treasury_Factory_Whitelist_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Treasury_Factory_Whitelist_Contract_Max_Order_By>;
  min?: InputMaybe<Treasury_Factory_Whitelist_Contract_Min_Order_By>;
  stddev?: InputMaybe<Treasury_Factory_Whitelist_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Treasury_Factory_Whitelist_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Treasury_Factory_Whitelist_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Treasury_Factory_Whitelist_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Treasury_Factory_Whitelist_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Treasury_Factory_Whitelist_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Treasury_Factory_Whitelist_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Treasury_Factory_Whitelist_Contract_Avg_Fields = {
  __typename?: 'treasury_factory_whitelist_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "treasury_factory_whitelist_contract" */
export type Treasury_Factory_Whitelist_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "treasury_factory_whitelist_contract". All fields are combined with a logical 'AND'. */
export type Treasury_Factory_Whitelist_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Treasury_Factory_Whitelist_Contract_Bool_Exp>>;
  _not?: InputMaybe<Treasury_Factory_Whitelist_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Treasury_Factory_Whitelist_Contract_Bool_Exp>>;
  contract?: InputMaybe<Treasury_Factory_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Treasury_Factory_Whitelist_Contract_Max_Fields = {
  __typename?: 'treasury_factory_whitelist_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "treasury_factory_whitelist_contract" */
export type Treasury_Factory_Whitelist_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Treasury_Factory_Whitelist_Contract_Min_Fields = {
  __typename?: 'treasury_factory_whitelist_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "treasury_factory_whitelist_contract" */
export type Treasury_Factory_Whitelist_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "treasury_factory_whitelist_contract". */
export type Treasury_Factory_Whitelist_Contract_Order_By = {
  contract?: InputMaybe<Treasury_Factory_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "treasury_factory_whitelist_contract" */
export enum Treasury_Factory_Whitelist_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Treasury_Factory_Whitelist_Contract_Stddev_Fields = {
  __typename?: 'treasury_factory_whitelist_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "treasury_factory_whitelist_contract" */
export type Treasury_Factory_Whitelist_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Treasury_Factory_Whitelist_Contract_Stddev_Pop_Fields = {
  __typename?: 'treasury_factory_whitelist_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "treasury_factory_whitelist_contract" */
export type Treasury_Factory_Whitelist_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Treasury_Factory_Whitelist_Contract_Stddev_Samp_Fields = {
  __typename?: 'treasury_factory_whitelist_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "treasury_factory_whitelist_contract" */
export type Treasury_Factory_Whitelist_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "treasury_factory_whitelist_contract" */
export type Treasury_Factory_Whitelist_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Treasury_Factory_Whitelist_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Treasury_Factory_Whitelist_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Treasury_Factory_Whitelist_Contract_Sum_Fields = {
  __typename?: 'treasury_factory_whitelist_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "treasury_factory_whitelist_contract" */
export type Treasury_Factory_Whitelist_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Treasury_Factory_Whitelist_Contract_Var_Pop_Fields = {
  __typename?: 'treasury_factory_whitelist_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "treasury_factory_whitelist_contract" */
export type Treasury_Factory_Whitelist_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Treasury_Factory_Whitelist_Contract_Var_Samp_Fields = {
  __typename?: 'treasury_factory_whitelist_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "treasury_factory_whitelist_contract" */
export type Treasury_Factory_Whitelist_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Treasury_Factory_Whitelist_Contract_Variance_Fields = {
  __typename?: 'treasury_factory_whitelist_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "treasury_factory_whitelist_contract" */
export type Treasury_Factory_Whitelist_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "treasury_factory_whitelist_token_contract" */
export type Treasury_Factory_Whitelist_Token_Contract = {
  __typename?: 'treasury_factory_whitelist_token_contract';
  /** An object relationship */
  contract: Treasury_Factory;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  token: Token;
  token_id: Scalars['bigint']['output'];
};

/** aggregated selection of "treasury_factory_whitelist_token_contract" */
export type Treasury_Factory_Whitelist_Token_Contract_Aggregate = {
  __typename?: 'treasury_factory_whitelist_token_contract_aggregate';
  aggregate?: Maybe<Treasury_Factory_Whitelist_Token_Contract_Aggregate_Fields>;
  nodes: Array<Treasury_Factory_Whitelist_Token_Contract>;
};

export type Treasury_Factory_Whitelist_Token_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Aggregate_Bool_Exp_Count>;
};

export type Treasury_Factory_Whitelist_Token_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Treasury_Factory_Whitelist_Token_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "treasury_factory_whitelist_token_contract" */
export type Treasury_Factory_Whitelist_Token_Contract_Aggregate_Fields = {
  __typename?: 'treasury_factory_whitelist_token_contract_aggregate_fields';
  avg?: Maybe<Treasury_Factory_Whitelist_Token_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Treasury_Factory_Whitelist_Token_Contract_Max_Fields>;
  min?: Maybe<Treasury_Factory_Whitelist_Token_Contract_Min_Fields>;
  stddev?: Maybe<Treasury_Factory_Whitelist_Token_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Treasury_Factory_Whitelist_Token_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Treasury_Factory_Whitelist_Token_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Treasury_Factory_Whitelist_Token_Contract_Sum_Fields>;
  var_pop?: Maybe<Treasury_Factory_Whitelist_Token_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Treasury_Factory_Whitelist_Token_Contract_Var_Samp_Fields>;
  variance?: Maybe<Treasury_Factory_Whitelist_Token_Contract_Variance_Fields>;
};


/** aggregate fields of "treasury_factory_whitelist_token_contract" */
export type Treasury_Factory_Whitelist_Token_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Treasury_Factory_Whitelist_Token_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "treasury_factory_whitelist_token_contract" */
export type Treasury_Factory_Whitelist_Token_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Max_Order_By>;
  min?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Min_Order_By>;
  stddev?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Treasury_Factory_Whitelist_Token_Contract_Avg_Fields = {
  __typename?: 'treasury_factory_whitelist_token_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "treasury_factory_whitelist_token_contract" */
export type Treasury_Factory_Whitelist_Token_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "treasury_factory_whitelist_token_contract". All fields are combined with a logical 'AND'. */
export type Treasury_Factory_Whitelist_Token_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Treasury_Factory_Whitelist_Token_Contract_Bool_Exp>>;
  _not?: InputMaybe<Treasury_Factory_Whitelist_Token_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Treasury_Factory_Whitelist_Token_Contract_Bool_Exp>>;
  contract?: InputMaybe<Treasury_Factory_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  token?: InputMaybe<Token_Bool_Exp>;
  token_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Treasury_Factory_Whitelist_Token_Contract_Max_Fields = {
  __typename?: 'treasury_factory_whitelist_token_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "treasury_factory_whitelist_token_contract" */
export type Treasury_Factory_Whitelist_Token_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Treasury_Factory_Whitelist_Token_Contract_Min_Fields = {
  __typename?: 'treasury_factory_whitelist_token_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "treasury_factory_whitelist_token_contract" */
export type Treasury_Factory_Whitelist_Token_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "treasury_factory_whitelist_token_contract". */
export type Treasury_Factory_Whitelist_Token_Contract_Order_By = {
  contract?: InputMaybe<Treasury_Factory_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token?: InputMaybe<Token_Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** select columns of table "treasury_factory_whitelist_token_contract" */
export enum Treasury_Factory_Whitelist_Token_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  TokenId = 'token_id'
}

/** aggregate stddev on columns */
export type Treasury_Factory_Whitelist_Token_Contract_Stddev_Fields = {
  __typename?: 'treasury_factory_whitelist_token_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "treasury_factory_whitelist_token_contract" */
export type Treasury_Factory_Whitelist_Token_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Treasury_Factory_Whitelist_Token_Contract_Stddev_Pop_Fields = {
  __typename?: 'treasury_factory_whitelist_token_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "treasury_factory_whitelist_token_contract" */
export type Treasury_Factory_Whitelist_Token_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Treasury_Factory_Whitelist_Token_Contract_Stddev_Samp_Fields = {
  __typename?: 'treasury_factory_whitelist_token_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "treasury_factory_whitelist_token_contract" */
export type Treasury_Factory_Whitelist_Token_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "treasury_factory_whitelist_token_contract" */
export type Treasury_Factory_Whitelist_Token_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Treasury_Factory_Whitelist_Token_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Treasury_Factory_Whitelist_Token_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  token_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Treasury_Factory_Whitelist_Token_Contract_Sum_Fields = {
  __typename?: 'treasury_factory_whitelist_token_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "treasury_factory_whitelist_token_contract" */
export type Treasury_Factory_Whitelist_Token_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Treasury_Factory_Whitelist_Token_Contract_Var_Pop_Fields = {
  __typename?: 'treasury_factory_whitelist_token_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "treasury_factory_whitelist_token_contract" */
export type Treasury_Factory_Whitelist_Token_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Treasury_Factory_Whitelist_Token_Contract_Var_Samp_Fields = {
  __typename?: 'treasury_factory_whitelist_token_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "treasury_factory_whitelist_token_contract" */
export type Treasury_Factory_Whitelist_Token_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Treasury_Factory_Whitelist_Token_Contract_Variance_Fields = {
  __typename?: 'treasury_factory_whitelist_token_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "treasury_factory_whitelist_token_contract" */
export type Treasury_Factory_Whitelist_Token_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "treasury_general_contract" */
export type Treasury_General_Contract = {
  __typename?: 'treasury_general_contract';
  /** An object relationship */
  contract: Treasury;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  contract_name: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "treasury_general_contract" */
export type Treasury_General_Contract_Aggregate = {
  __typename?: 'treasury_general_contract_aggregate';
  aggregate?: Maybe<Treasury_General_Contract_Aggregate_Fields>;
  nodes: Array<Treasury_General_Contract>;
};

export type Treasury_General_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Treasury_General_Contract_Aggregate_Bool_Exp_Count>;
};

export type Treasury_General_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Treasury_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_General_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "treasury_general_contract" */
export type Treasury_General_Contract_Aggregate_Fields = {
  __typename?: 'treasury_general_contract_aggregate_fields';
  avg?: Maybe<Treasury_General_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Treasury_General_Contract_Max_Fields>;
  min?: Maybe<Treasury_General_Contract_Min_Fields>;
  stddev?: Maybe<Treasury_General_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Treasury_General_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Treasury_General_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Treasury_General_Contract_Sum_Fields>;
  var_pop?: Maybe<Treasury_General_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Treasury_General_Contract_Var_Samp_Fields>;
  variance?: Maybe<Treasury_General_Contract_Variance_Fields>;
};


/** aggregate fields of "treasury_general_contract" */
export type Treasury_General_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Treasury_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "treasury_general_contract" */
export type Treasury_General_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Treasury_General_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Treasury_General_Contract_Max_Order_By>;
  min?: InputMaybe<Treasury_General_Contract_Min_Order_By>;
  stddev?: InputMaybe<Treasury_General_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Treasury_General_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Treasury_General_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Treasury_General_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Treasury_General_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Treasury_General_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Treasury_General_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Treasury_General_Contract_Avg_Fields = {
  __typename?: 'treasury_general_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "treasury_general_contract" */
export type Treasury_General_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "treasury_general_contract". All fields are combined with a logical 'AND'. */
export type Treasury_General_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Treasury_General_Contract_Bool_Exp>>;
  _not?: InputMaybe<Treasury_General_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Treasury_General_Contract_Bool_Exp>>;
  contract?: InputMaybe<Treasury_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  contract_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Treasury_General_Contract_Max_Fields = {
  __typename?: 'treasury_general_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "treasury_general_contract" */
export type Treasury_General_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Treasury_General_Contract_Min_Fields = {
  __typename?: 'treasury_general_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "treasury_general_contract" */
export type Treasury_General_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "treasury_general_contract". */
export type Treasury_General_Contract_Order_By = {
  contract?: InputMaybe<Treasury_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "treasury_general_contract" */
export enum Treasury_General_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  ContractName = 'contract_name',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Treasury_General_Contract_Stddev_Fields = {
  __typename?: 'treasury_general_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "treasury_general_contract" */
export type Treasury_General_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Treasury_General_Contract_Stddev_Pop_Fields = {
  __typename?: 'treasury_general_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "treasury_general_contract" */
export type Treasury_General_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Treasury_General_Contract_Stddev_Samp_Fields = {
  __typename?: 'treasury_general_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "treasury_general_contract" */
export type Treasury_General_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "treasury_general_contract" */
export type Treasury_General_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Treasury_General_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Treasury_General_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  contract_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Treasury_General_Contract_Sum_Fields = {
  __typename?: 'treasury_general_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "treasury_general_contract" */
export type Treasury_General_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Treasury_General_Contract_Var_Pop_Fields = {
  __typename?: 'treasury_general_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "treasury_general_contract" */
export type Treasury_General_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Treasury_General_Contract_Var_Samp_Fields = {
  __typename?: 'treasury_general_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "treasury_general_contract" */
export type Treasury_General_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Treasury_General_Contract_Variance_Fields = {
  __typename?: 'treasury_general_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "treasury_general_contract" */
export type Treasury_General_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "treasury_lambda" */
export type Treasury_Lambda = {
  __typename?: 'treasury_lambda';
  /** An object relationship */
  contract: Treasury;
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lambda_bytes: Scalars['String']['output'];
  lambda_name: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "treasury_lambda" */
export type Treasury_Lambda_Aggregate = {
  __typename?: 'treasury_lambda_aggregate';
  aggregate?: Maybe<Treasury_Lambda_Aggregate_Fields>;
  nodes: Array<Treasury_Lambda>;
};

export type Treasury_Lambda_Aggregate_Bool_Exp = {
  count?: InputMaybe<Treasury_Lambda_Aggregate_Bool_Exp_Count>;
};

export type Treasury_Lambda_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Treasury_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_Lambda_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "treasury_lambda" */
export type Treasury_Lambda_Aggregate_Fields = {
  __typename?: 'treasury_lambda_aggregate_fields';
  avg?: Maybe<Treasury_Lambda_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Treasury_Lambda_Max_Fields>;
  min?: Maybe<Treasury_Lambda_Min_Fields>;
  stddev?: Maybe<Treasury_Lambda_Stddev_Fields>;
  stddev_pop?: Maybe<Treasury_Lambda_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Treasury_Lambda_Stddev_Samp_Fields>;
  sum?: Maybe<Treasury_Lambda_Sum_Fields>;
  var_pop?: Maybe<Treasury_Lambda_Var_Pop_Fields>;
  var_samp?: Maybe<Treasury_Lambda_Var_Samp_Fields>;
  variance?: Maybe<Treasury_Lambda_Variance_Fields>;
};


/** aggregate fields of "treasury_lambda" */
export type Treasury_Lambda_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Treasury_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "treasury_lambda" */
export type Treasury_Lambda_Aggregate_Order_By = {
  avg?: InputMaybe<Treasury_Lambda_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Treasury_Lambda_Max_Order_By>;
  min?: InputMaybe<Treasury_Lambda_Min_Order_By>;
  stddev?: InputMaybe<Treasury_Lambda_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Treasury_Lambda_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Treasury_Lambda_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Treasury_Lambda_Sum_Order_By>;
  var_pop?: InputMaybe<Treasury_Lambda_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Treasury_Lambda_Var_Samp_Order_By>;
  variance?: InputMaybe<Treasury_Lambda_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Treasury_Lambda_Avg_Fields = {
  __typename?: 'treasury_lambda_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "treasury_lambda" */
export type Treasury_Lambda_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "treasury_lambda". All fields are combined with a logical 'AND'. */
export type Treasury_Lambda_Bool_Exp = {
  _and?: InputMaybe<Array<Treasury_Lambda_Bool_Exp>>;
  _not?: InputMaybe<Treasury_Lambda_Bool_Exp>;
  _or?: InputMaybe<Array<Treasury_Lambda_Bool_Exp>>;
  contract?: InputMaybe<Treasury_Bool_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambda_bytes?: InputMaybe<String_Comparison_Exp>;
  lambda_name?: InputMaybe<String_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Treasury_Lambda_Max_Fields = {
  __typename?: 'treasury_lambda_max_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "treasury_lambda" */
export type Treasury_Lambda_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Treasury_Lambda_Min_Fields = {
  __typename?: 'treasury_lambda_min_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "treasury_lambda" */
export type Treasury_Lambda_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "treasury_lambda". */
export type Treasury_Lambda_Order_By = {
  contract?: InputMaybe<Treasury_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "treasury_lambda" */
export enum Treasury_Lambda_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaBytes = 'lambda_bytes',
  /** column name */
  LambdaName = 'lambda_name',
  /** column name */
  LastUpdatedAt = 'last_updated_at'
}

/** aggregate stddev on columns */
export type Treasury_Lambda_Stddev_Fields = {
  __typename?: 'treasury_lambda_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "treasury_lambda" */
export type Treasury_Lambda_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Treasury_Lambda_Stddev_Pop_Fields = {
  __typename?: 'treasury_lambda_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "treasury_lambda" */
export type Treasury_Lambda_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Treasury_Lambda_Stddev_Samp_Fields = {
  __typename?: 'treasury_lambda_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "treasury_lambda" */
export type Treasury_Lambda_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "treasury_lambda" */
export type Treasury_Lambda_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Treasury_Lambda_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Treasury_Lambda_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lambda_bytes?: InputMaybe<Scalars['String']['input']>;
  lambda_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Treasury_Lambda_Sum_Fields = {
  __typename?: 'treasury_lambda_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "treasury_lambda" */
export type Treasury_Lambda_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Treasury_Lambda_Var_Pop_Fields = {
  __typename?: 'treasury_lambda_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "treasury_lambda" */
export type Treasury_Lambda_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Treasury_Lambda_Var_Samp_Fields = {
  __typename?: 'treasury_lambda_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "treasury_lambda" */
export type Treasury_Lambda_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Treasury_Lambda_Variance_Fields = {
  __typename?: 'treasury_lambda_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "treasury_lambda" */
export type Treasury_Lambda_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Treasury_Max_Fields = {
  __typename?: 'treasury_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  baker_id?: Maybe<Scalars['bigint']['output']>;
  creation_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  factory_id?: Maybe<Scalars['bigint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "treasury" */
export type Treasury_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  baker_id?: InputMaybe<Order_By>;
  creation_timestamp?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Treasury_Min_Fields = {
  __typename?: 'treasury_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  baker_id?: Maybe<Scalars['bigint']['output']>;
  creation_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  factory_id?: Maybe<Scalars['bigint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "treasury" */
export type Treasury_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  baker_id?: InputMaybe<Order_By>;
  creation_timestamp?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "treasury". */
export type Treasury_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  baker?: InputMaybe<Maven_User_Order_By>;
  baker_id?: InputMaybe<Order_By>;
  balances_aggregate?: InputMaybe<Treasury_Balance_Aggregate_Order_By>;
  creation_timestamp?: InputMaybe<Order_By>;
  factory?: InputMaybe<Treasury_Factory_Order_By>;
  factory_id?: InputMaybe<Order_By>;
  general_contracts_aggregate?: InputMaybe<Treasury_General_Contract_Aggregate_Order_By>;
  governance?: InputMaybe<Governance_Order_By>;
  governance_financial_requests_aggregate?: InputMaybe<Governance_Financial_Request_Aggregate_Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambdas_aggregate?: InputMaybe<Treasury_Lambda_Aggregate_Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  mint_mvn_and_transfer_paused?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  stake_tokens_paused?: InputMaybe<Order_By>;
  transfer_history_data_aggregate?: InputMaybe<Treasury_Transfer_History_Data_Aggregate_Order_By>;
  transfer_paused?: InputMaybe<Order_By>;
  unstake_tokens_paused?: InputMaybe<Order_By>;
  update_token_operators_paused?: InputMaybe<Order_By>;
  whitelist_contracts_aggregate?: InputMaybe<Treasury_Whitelist_Contract_Aggregate_Order_By>;
  whitelist_token_contracts_aggregate?: InputMaybe<Treasury_Whitelist_Token_Contract_Aggregate_Order_By>;
};

/** select columns of table "treasury" */
export enum Treasury_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Admin = 'admin',
  /** column name */
  BakerId = 'baker_id',
  /** column name */
  CreationTimestamp = 'creation_timestamp',
  /** column name */
  FactoryId = 'factory_id',
  /** column name */
  GovernanceId = 'governance_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MintMvnAndTransferPaused = 'mint_mvn_and_transfer_paused',
  /** column name */
  Name = 'name',
  /** column name */
  Network = 'network',
  /** column name */
  StakeTokensPaused = 'stake_tokens_paused',
  /** column name */
  TransferPaused = 'transfer_paused',
  /** column name */
  UnstakeTokensPaused = 'unstake_tokens_paused',
  /** column name */
  UpdateTokenOperatorsPaused = 'update_token_operators_paused'
}

/** select "treasury_aggregate_bool_exp_bool_and_arguments_columns" columns of table "treasury" */
export enum Treasury_Select_Column_Treasury_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  MintMvnAndTransferPaused = 'mint_mvn_and_transfer_paused',
  /** column name */
  StakeTokensPaused = 'stake_tokens_paused',
  /** column name */
  TransferPaused = 'transfer_paused',
  /** column name */
  UnstakeTokensPaused = 'unstake_tokens_paused',
  /** column name */
  UpdateTokenOperatorsPaused = 'update_token_operators_paused'
}

/** select "treasury_aggregate_bool_exp_bool_or_arguments_columns" columns of table "treasury" */
export enum Treasury_Select_Column_Treasury_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  MintMvnAndTransferPaused = 'mint_mvn_and_transfer_paused',
  /** column name */
  StakeTokensPaused = 'stake_tokens_paused',
  /** column name */
  TransferPaused = 'transfer_paused',
  /** column name */
  UnstakeTokensPaused = 'unstake_tokens_paused',
  /** column name */
  UpdateTokenOperatorsPaused = 'update_token_operators_paused'
}

/** aggregate stddev on columns */
export type Treasury_Stddev_Fields = {
  __typename?: 'treasury_stddev_fields';
  baker_id?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "treasury" */
export type Treasury_Stddev_Order_By = {
  baker_id?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Treasury_Stddev_Pop_Fields = {
  __typename?: 'treasury_stddev_pop_fields';
  baker_id?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "treasury" */
export type Treasury_Stddev_Pop_Order_By = {
  baker_id?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Treasury_Stddev_Samp_Fields = {
  __typename?: 'treasury_stddev_samp_fields';
  baker_id?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "treasury" */
export type Treasury_Stddev_Samp_Order_By = {
  baker_id?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "treasury" */
export type Treasury_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Treasury_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Treasury_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['String']['input']>;
  baker_id?: InputMaybe<Scalars['bigint']['input']>;
  creation_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  factory_id?: InputMaybe<Scalars['bigint']['input']>;
  governance_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  mint_mvn_and_transfer_paused?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  stake_tokens_paused?: InputMaybe<Scalars['Boolean']['input']>;
  transfer_paused?: InputMaybe<Scalars['Boolean']['input']>;
  unstake_tokens_paused?: InputMaybe<Scalars['Boolean']['input']>;
  update_token_operators_paused?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Treasury_Sum_Fields = {
  __typename?: 'treasury_sum_fields';
  baker_id?: Maybe<Scalars['bigint']['output']>;
  factory_id?: Maybe<Scalars['bigint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "treasury" */
export type Treasury_Sum_Order_By = {
  baker_id?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "treasury_transfer_history_data" */
export type Treasury_Transfer_History_Data = {
  __typename?: 'treasury_transfer_history_data';
  amount: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  timestamp: Scalars['timestamptz']['output'];
  /** An object relationship */
  to_: Maven_User;
  to__id: Scalars['bigint']['output'];
  token_address: Scalars['String']['output'];
  /** An object relationship */
  treasury: Treasury;
  treasury_id: Scalars['bigint']['output'];
};

/** aggregated selection of "treasury_transfer_history_data" */
export type Treasury_Transfer_History_Data_Aggregate = {
  __typename?: 'treasury_transfer_history_data_aggregate';
  aggregate?: Maybe<Treasury_Transfer_History_Data_Aggregate_Fields>;
  nodes: Array<Treasury_Transfer_History_Data>;
};

export type Treasury_Transfer_History_Data_Aggregate_Bool_Exp = {
  count?: InputMaybe<Treasury_Transfer_History_Data_Aggregate_Bool_Exp_Count>;
};

export type Treasury_Transfer_History_Data_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Treasury_Transfer_History_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_Transfer_History_Data_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "treasury_transfer_history_data" */
export type Treasury_Transfer_History_Data_Aggregate_Fields = {
  __typename?: 'treasury_transfer_history_data_aggregate_fields';
  avg?: Maybe<Treasury_Transfer_History_Data_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Treasury_Transfer_History_Data_Max_Fields>;
  min?: Maybe<Treasury_Transfer_History_Data_Min_Fields>;
  stddev?: Maybe<Treasury_Transfer_History_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Treasury_Transfer_History_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Treasury_Transfer_History_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Treasury_Transfer_History_Data_Sum_Fields>;
  var_pop?: Maybe<Treasury_Transfer_History_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Treasury_Transfer_History_Data_Var_Samp_Fields>;
  variance?: Maybe<Treasury_Transfer_History_Data_Variance_Fields>;
};


/** aggregate fields of "treasury_transfer_history_data" */
export type Treasury_Transfer_History_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Treasury_Transfer_History_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "treasury_transfer_history_data" */
export type Treasury_Transfer_History_Data_Aggregate_Order_By = {
  avg?: InputMaybe<Treasury_Transfer_History_Data_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Treasury_Transfer_History_Data_Max_Order_By>;
  min?: InputMaybe<Treasury_Transfer_History_Data_Min_Order_By>;
  stddev?: InputMaybe<Treasury_Transfer_History_Data_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Treasury_Transfer_History_Data_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Treasury_Transfer_History_Data_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Treasury_Transfer_History_Data_Sum_Order_By>;
  var_pop?: InputMaybe<Treasury_Transfer_History_Data_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Treasury_Transfer_History_Data_Var_Samp_Order_By>;
  variance?: InputMaybe<Treasury_Transfer_History_Data_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Treasury_Transfer_History_Data_Avg_Fields = {
  __typename?: 'treasury_transfer_history_data_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  to__id?: Maybe<Scalars['Float']['output']>;
  treasury_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "treasury_transfer_history_data" */
export type Treasury_Transfer_History_Data_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "treasury_transfer_history_data". All fields are combined with a logical 'AND'. */
export type Treasury_Transfer_History_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Treasury_Transfer_History_Data_Bool_Exp>>;
  _not?: InputMaybe<Treasury_Transfer_History_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Treasury_Transfer_History_Data_Bool_Exp>>;
  amount?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  to_?: InputMaybe<Maven_User_Bool_Exp>;
  to__id?: InputMaybe<Bigint_Comparison_Exp>;
  token_address?: InputMaybe<String_Comparison_Exp>;
  treasury?: InputMaybe<Treasury_Bool_Exp>;
  treasury_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Treasury_Transfer_History_Data_Max_Fields = {
  __typename?: 'treasury_transfer_history_data_max_fields';
  amount?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  to__id?: Maybe<Scalars['bigint']['output']>;
  token_address?: Maybe<Scalars['String']['output']>;
  treasury_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "treasury_transfer_history_data" */
export type Treasury_Transfer_History_Data_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
  token_address?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Treasury_Transfer_History_Data_Min_Fields = {
  __typename?: 'treasury_transfer_history_data_min_fields';
  amount?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  to__id?: Maybe<Scalars['bigint']['output']>;
  token_address?: Maybe<Scalars['String']['output']>;
  treasury_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "treasury_transfer_history_data" */
export type Treasury_Transfer_History_Data_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
  token_address?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "treasury_transfer_history_data". */
export type Treasury_Transfer_History_Data_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  to_?: InputMaybe<Maven_User_Order_By>;
  to__id?: InputMaybe<Order_By>;
  token_address?: InputMaybe<Order_By>;
  treasury?: InputMaybe<Treasury_Order_By>;
  treasury_id?: InputMaybe<Order_By>;
};

/** select columns of table "treasury_transfer_history_data" */
export enum Treasury_Transfer_History_Data_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Id = 'id',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  ToId = 'to__id',
  /** column name */
  TokenAddress = 'token_address',
  /** column name */
  TreasuryId = 'treasury_id'
}

/** aggregate stddev on columns */
export type Treasury_Transfer_History_Data_Stddev_Fields = {
  __typename?: 'treasury_transfer_history_data_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  to__id?: Maybe<Scalars['Float']['output']>;
  treasury_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "treasury_transfer_history_data" */
export type Treasury_Transfer_History_Data_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Treasury_Transfer_History_Data_Stddev_Pop_Fields = {
  __typename?: 'treasury_transfer_history_data_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  to__id?: Maybe<Scalars['Float']['output']>;
  treasury_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "treasury_transfer_history_data" */
export type Treasury_Transfer_History_Data_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Treasury_Transfer_History_Data_Stddev_Samp_Fields = {
  __typename?: 'treasury_transfer_history_data_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  to__id?: Maybe<Scalars['Float']['output']>;
  treasury_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "treasury_transfer_history_data" */
export type Treasury_Transfer_History_Data_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "treasury_transfer_history_data" */
export type Treasury_Transfer_History_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Treasury_Transfer_History_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Treasury_Transfer_History_Data_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  to__id?: InputMaybe<Scalars['bigint']['input']>;
  token_address?: InputMaybe<Scalars['String']['input']>;
  treasury_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Treasury_Transfer_History_Data_Sum_Fields = {
  __typename?: 'treasury_transfer_history_data_sum_fields';
  amount?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  to__id?: Maybe<Scalars['bigint']['output']>;
  treasury_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "treasury_transfer_history_data" */
export type Treasury_Transfer_History_Data_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Treasury_Transfer_History_Data_Var_Pop_Fields = {
  __typename?: 'treasury_transfer_history_data_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  to__id?: Maybe<Scalars['Float']['output']>;
  treasury_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "treasury_transfer_history_data" */
export type Treasury_Transfer_History_Data_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Treasury_Transfer_History_Data_Var_Samp_Fields = {
  __typename?: 'treasury_transfer_history_data_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  to__id?: Maybe<Scalars['Float']['output']>;
  treasury_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "treasury_transfer_history_data" */
export type Treasury_Transfer_History_Data_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Treasury_Transfer_History_Data_Variance_Fields = {
  __typename?: 'treasury_transfer_history_data_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  to__id?: Maybe<Scalars['Float']['output']>;
  treasury_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "treasury_transfer_history_data" */
export type Treasury_Transfer_History_Data_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to__id?: InputMaybe<Order_By>;
  treasury_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Treasury_Var_Pop_Fields = {
  __typename?: 'treasury_var_pop_fields';
  baker_id?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "treasury" */
export type Treasury_Var_Pop_Order_By = {
  baker_id?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Treasury_Var_Samp_Fields = {
  __typename?: 'treasury_var_samp_fields';
  baker_id?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "treasury" */
export type Treasury_Var_Samp_Order_By = {
  baker_id?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Treasury_Variance_Fields = {
  __typename?: 'treasury_variance_fields';
  baker_id?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "treasury" */
export type Treasury_Variance_Order_By = {
  baker_id?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "treasury_whitelist_contract" */
export type Treasury_Whitelist_Contract = {
  __typename?: 'treasury_whitelist_contract';
  /** An object relationship */
  contract: Treasury;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "treasury_whitelist_contract" */
export type Treasury_Whitelist_Contract_Aggregate = {
  __typename?: 'treasury_whitelist_contract_aggregate';
  aggregate?: Maybe<Treasury_Whitelist_Contract_Aggregate_Fields>;
  nodes: Array<Treasury_Whitelist_Contract>;
};

export type Treasury_Whitelist_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Treasury_Whitelist_Contract_Aggregate_Bool_Exp_Count>;
};

export type Treasury_Whitelist_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Treasury_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_Whitelist_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "treasury_whitelist_contract" */
export type Treasury_Whitelist_Contract_Aggregate_Fields = {
  __typename?: 'treasury_whitelist_contract_aggregate_fields';
  avg?: Maybe<Treasury_Whitelist_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Treasury_Whitelist_Contract_Max_Fields>;
  min?: Maybe<Treasury_Whitelist_Contract_Min_Fields>;
  stddev?: Maybe<Treasury_Whitelist_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Treasury_Whitelist_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Treasury_Whitelist_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Treasury_Whitelist_Contract_Sum_Fields>;
  var_pop?: Maybe<Treasury_Whitelist_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Treasury_Whitelist_Contract_Var_Samp_Fields>;
  variance?: Maybe<Treasury_Whitelist_Contract_Variance_Fields>;
};


/** aggregate fields of "treasury_whitelist_contract" */
export type Treasury_Whitelist_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Treasury_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "treasury_whitelist_contract" */
export type Treasury_Whitelist_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Treasury_Whitelist_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Treasury_Whitelist_Contract_Max_Order_By>;
  min?: InputMaybe<Treasury_Whitelist_Contract_Min_Order_By>;
  stddev?: InputMaybe<Treasury_Whitelist_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Treasury_Whitelist_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Treasury_Whitelist_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Treasury_Whitelist_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Treasury_Whitelist_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Treasury_Whitelist_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Treasury_Whitelist_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Treasury_Whitelist_Contract_Avg_Fields = {
  __typename?: 'treasury_whitelist_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "treasury_whitelist_contract" */
export type Treasury_Whitelist_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "treasury_whitelist_contract". All fields are combined with a logical 'AND'. */
export type Treasury_Whitelist_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Treasury_Whitelist_Contract_Bool_Exp>>;
  _not?: InputMaybe<Treasury_Whitelist_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Treasury_Whitelist_Contract_Bool_Exp>>;
  contract?: InputMaybe<Treasury_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Treasury_Whitelist_Contract_Max_Fields = {
  __typename?: 'treasury_whitelist_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "treasury_whitelist_contract" */
export type Treasury_Whitelist_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Treasury_Whitelist_Contract_Min_Fields = {
  __typename?: 'treasury_whitelist_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "treasury_whitelist_contract" */
export type Treasury_Whitelist_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "treasury_whitelist_contract". */
export type Treasury_Whitelist_Contract_Order_By = {
  contract?: InputMaybe<Treasury_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "treasury_whitelist_contract" */
export enum Treasury_Whitelist_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Treasury_Whitelist_Contract_Stddev_Fields = {
  __typename?: 'treasury_whitelist_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "treasury_whitelist_contract" */
export type Treasury_Whitelist_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Treasury_Whitelist_Contract_Stddev_Pop_Fields = {
  __typename?: 'treasury_whitelist_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "treasury_whitelist_contract" */
export type Treasury_Whitelist_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Treasury_Whitelist_Contract_Stddev_Samp_Fields = {
  __typename?: 'treasury_whitelist_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "treasury_whitelist_contract" */
export type Treasury_Whitelist_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "treasury_whitelist_contract" */
export type Treasury_Whitelist_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Treasury_Whitelist_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Treasury_Whitelist_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Treasury_Whitelist_Contract_Sum_Fields = {
  __typename?: 'treasury_whitelist_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "treasury_whitelist_contract" */
export type Treasury_Whitelist_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Treasury_Whitelist_Contract_Var_Pop_Fields = {
  __typename?: 'treasury_whitelist_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "treasury_whitelist_contract" */
export type Treasury_Whitelist_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Treasury_Whitelist_Contract_Var_Samp_Fields = {
  __typename?: 'treasury_whitelist_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "treasury_whitelist_contract" */
export type Treasury_Whitelist_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Treasury_Whitelist_Contract_Variance_Fields = {
  __typename?: 'treasury_whitelist_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "treasury_whitelist_contract" */
export type Treasury_Whitelist_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "treasury_whitelist_token_contract" */
export type Treasury_Whitelist_Token_Contract = {
  __typename?: 'treasury_whitelist_token_contract';
  /** An object relationship */
  contract: Treasury;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  token: Token;
  token_id: Scalars['bigint']['output'];
};

/** aggregated selection of "treasury_whitelist_token_contract" */
export type Treasury_Whitelist_Token_Contract_Aggregate = {
  __typename?: 'treasury_whitelist_token_contract_aggregate';
  aggregate?: Maybe<Treasury_Whitelist_Token_Contract_Aggregate_Fields>;
  nodes: Array<Treasury_Whitelist_Token_Contract>;
};

export type Treasury_Whitelist_Token_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Treasury_Whitelist_Token_Contract_Aggregate_Bool_Exp_Count>;
};

export type Treasury_Whitelist_Token_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Treasury_Whitelist_Token_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Treasury_Whitelist_Token_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "treasury_whitelist_token_contract" */
export type Treasury_Whitelist_Token_Contract_Aggregate_Fields = {
  __typename?: 'treasury_whitelist_token_contract_aggregate_fields';
  avg?: Maybe<Treasury_Whitelist_Token_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Treasury_Whitelist_Token_Contract_Max_Fields>;
  min?: Maybe<Treasury_Whitelist_Token_Contract_Min_Fields>;
  stddev?: Maybe<Treasury_Whitelist_Token_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Treasury_Whitelist_Token_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Treasury_Whitelist_Token_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Treasury_Whitelist_Token_Contract_Sum_Fields>;
  var_pop?: Maybe<Treasury_Whitelist_Token_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Treasury_Whitelist_Token_Contract_Var_Samp_Fields>;
  variance?: Maybe<Treasury_Whitelist_Token_Contract_Variance_Fields>;
};


/** aggregate fields of "treasury_whitelist_token_contract" */
export type Treasury_Whitelist_Token_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Treasury_Whitelist_Token_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "treasury_whitelist_token_contract" */
export type Treasury_Whitelist_Token_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Treasury_Whitelist_Token_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Treasury_Whitelist_Token_Contract_Max_Order_By>;
  min?: InputMaybe<Treasury_Whitelist_Token_Contract_Min_Order_By>;
  stddev?: InputMaybe<Treasury_Whitelist_Token_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Treasury_Whitelist_Token_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Treasury_Whitelist_Token_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Treasury_Whitelist_Token_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Treasury_Whitelist_Token_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Treasury_Whitelist_Token_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Treasury_Whitelist_Token_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Treasury_Whitelist_Token_Contract_Avg_Fields = {
  __typename?: 'treasury_whitelist_token_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "treasury_whitelist_token_contract" */
export type Treasury_Whitelist_Token_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "treasury_whitelist_token_contract". All fields are combined with a logical 'AND'. */
export type Treasury_Whitelist_Token_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Treasury_Whitelist_Token_Contract_Bool_Exp>>;
  _not?: InputMaybe<Treasury_Whitelist_Token_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Treasury_Whitelist_Token_Contract_Bool_Exp>>;
  contract?: InputMaybe<Treasury_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  token?: InputMaybe<Token_Bool_Exp>;
  token_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Treasury_Whitelist_Token_Contract_Max_Fields = {
  __typename?: 'treasury_whitelist_token_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "treasury_whitelist_token_contract" */
export type Treasury_Whitelist_Token_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Treasury_Whitelist_Token_Contract_Min_Fields = {
  __typename?: 'treasury_whitelist_token_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "treasury_whitelist_token_contract" */
export type Treasury_Whitelist_Token_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "treasury_whitelist_token_contract". */
export type Treasury_Whitelist_Token_Contract_Order_By = {
  contract?: InputMaybe<Treasury_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token?: InputMaybe<Token_Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** select columns of table "treasury_whitelist_token_contract" */
export enum Treasury_Whitelist_Token_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  TokenId = 'token_id'
}

/** aggregate stddev on columns */
export type Treasury_Whitelist_Token_Contract_Stddev_Fields = {
  __typename?: 'treasury_whitelist_token_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "treasury_whitelist_token_contract" */
export type Treasury_Whitelist_Token_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Treasury_Whitelist_Token_Contract_Stddev_Pop_Fields = {
  __typename?: 'treasury_whitelist_token_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "treasury_whitelist_token_contract" */
export type Treasury_Whitelist_Token_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Treasury_Whitelist_Token_Contract_Stddev_Samp_Fields = {
  __typename?: 'treasury_whitelist_token_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "treasury_whitelist_token_contract" */
export type Treasury_Whitelist_Token_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "treasury_whitelist_token_contract" */
export type Treasury_Whitelist_Token_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Treasury_Whitelist_Token_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Treasury_Whitelist_Token_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  token_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Treasury_Whitelist_Token_Contract_Sum_Fields = {
  __typename?: 'treasury_whitelist_token_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "treasury_whitelist_token_contract" */
export type Treasury_Whitelist_Token_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Treasury_Whitelist_Token_Contract_Var_Pop_Fields = {
  __typename?: 'treasury_whitelist_token_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "treasury_whitelist_token_contract" */
export type Treasury_Whitelist_Token_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Treasury_Whitelist_Token_Contract_Var_Samp_Fields = {
  __typename?: 'treasury_whitelist_token_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "treasury_whitelist_token_contract" */
export type Treasury_Whitelist_Token_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Treasury_Whitelist_Token_Contract_Variance_Fields = {
  __typename?: 'treasury_whitelist_token_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "treasury_whitelist_token_contract" */
export type Treasury_Whitelist_Token_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "tvl_stats" */
export type Tvl_Stats = {
  __typename?: 'tvl_stats';
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated?: Maybe<Scalars['timestamptz']['output']>;
  token_address?: Maybe<Scalars['String']['output']>;
  token_pool_total?: Maybe<Scalars['float8']['output']>;
  total_borrowed?: Maybe<Scalars['float8']['output']>;
};

/** aggregated selection of "tvl_stats" */
export type Tvl_Stats_Aggregate = {
  __typename?: 'tvl_stats_aggregate';
  aggregate?: Maybe<Tvl_Stats_Aggregate_Fields>;
  nodes: Array<Tvl_Stats>;
};

/** aggregate fields of "tvl_stats" */
export type Tvl_Stats_Aggregate_Fields = {
  __typename?: 'tvl_stats_aggregate_fields';
  avg?: Maybe<Tvl_Stats_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tvl_Stats_Max_Fields>;
  min?: Maybe<Tvl_Stats_Min_Fields>;
  stddev?: Maybe<Tvl_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<Tvl_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tvl_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<Tvl_Stats_Sum_Fields>;
  var_pop?: Maybe<Tvl_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<Tvl_Stats_Var_Samp_Fields>;
  variance?: Maybe<Tvl_Stats_Variance_Fields>;
};


/** aggregate fields of "tvl_stats" */
export type Tvl_Stats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tvl_Stats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Tvl_Stats_Avg_Fields = {
  __typename?: 'tvl_stats_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "tvl_stats". All fields are combined with a logical 'AND'. */
export type Tvl_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Tvl_Stats_Bool_Exp>>;
  _not?: InputMaybe<Tvl_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Tvl_Stats_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  last_updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  token_address?: InputMaybe<String_Comparison_Exp>;
  token_pool_total?: InputMaybe<Float8_Comparison_Exp>;
  total_borrowed?: InputMaybe<Float8_Comparison_Exp>;
};

/** aggregate max on columns */
export type Tvl_Stats_Max_Fields = {
  __typename?: 'tvl_stats_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated?: Maybe<Scalars['timestamptz']['output']>;
  token_address?: Maybe<Scalars['String']['output']>;
  token_pool_total?: Maybe<Scalars['float8']['output']>;
  total_borrowed?: Maybe<Scalars['float8']['output']>;
};

/** aggregate min on columns */
export type Tvl_Stats_Min_Fields = {
  __typename?: 'tvl_stats_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated?: Maybe<Scalars['timestamptz']['output']>;
  token_address?: Maybe<Scalars['String']['output']>;
  token_pool_total?: Maybe<Scalars['float8']['output']>;
  total_borrowed?: Maybe<Scalars['float8']['output']>;
};

/** Ordering options when selecting data from "tvl_stats". */
export type Tvl_Stats_Order_By = {
  id?: InputMaybe<Order_By>;
  last_updated?: InputMaybe<Order_By>;
  token_address?: InputMaybe<Order_By>;
  token_pool_total?: InputMaybe<Order_By>;
  total_borrowed?: InputMaybe<Order_By>;
};

/** select columns of table "tvl_stats" */
export enum Tvl_Stats_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdated = 'last_updated',
  /** column name */
  TokenAddress = 'token_address',
  /** column name */
  TokenPoolTotal = 'token_pool_total',
  /** column name */
  TotalBorrowed = 'total_borrowed'
}

/** aggregate stddev on columns */
export type Tvl_Stats_Stddev_Fields = {
  __typename?: 'tvl_stats_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Tvl_Stats_Stddev_Pop_Fields = {
  __typename?: 'tvl_stats_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Tvl_Stats_Stddev_Samp_Fields = {
  __typename?: 'tvl_stats_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "tvl_stats" */
export type Tvl_Stats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tvl_Stats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tvl_Stats_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_updated?: InputMaybe<Scalars['timestamptz']['input']>;
  token_address?: InputMaybe<Scalars['String']['input']>;
  token_pool_total?: InputMaybe<Scalars['float8']['input']>;
  total_borrowed?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type Tvl_Stats_Sum_Fields = {
  __typename?: 'tvl_stats_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  token_pool_total?: Maybe<Scalars['float8']['output']>;
  total_borrowed?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Tvl_Stats_Var_Pop_Fields = {
  __typename?: 'tvl_stats_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Tvl_Stats_Var_Samp_Fields = {
  __typename?: 'tvl_stats_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Tvl_Stats_Variance_Fields = {
  __typename?: 'tvl_stats_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  token_pool_total?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "user_dashboard" */
export type User_Dashboard = {
  __typename?: 'user_dashboard';
  active_vaults_count?: Maybe<Scalars['bigint']['output']>;
  last_updated?: Maybe<Scalars['timestamptz']['output']>;
  m_tokens?: Maybe<Scalars['jsonb']['output']>;
  total_borrowed?: Maybe<Scalars['float8']['output']>;
  user_address?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  vaults_count?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "user_dashboard" */
export type User_DashboardM_TokensArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "user_dashboard" */
export type User_Dashboard_Aggregate = {
  __typename?: 'user_dashboard_aggregate';
  aggregate?: Maybe<User_Dashboard_Aggregate_Fields>;
  nodes: Array<User_Dashboard>;
};

/** aggregate fields of "user_dashboard" */
export type User_Dashboard_Aggregate_Fields = {
  __typename?: 'user_dashboard_aggregate_fields';
  avg?: Maybe<User_Dashboard_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Dashboard_Max_Fields>;
  min?: Maybe<User_Dashboard_Min_Fields>;
  stddev?: Maybe<User_Dashboard_Stddev_Fields>;
  stddev_pop?: Maybe<User_Dashboard_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Dashboard_Stddev_Samp_Fields>;
  sum?: Maybe<User_Dashboard_Sum_Fields>;
  var_pop?: Maybe<User_Dashboard_Var_Pop_Fields>;
  var_samp?: Maybe<User_Dashboard_Var_Samp_Fields>;
  variance?: Maybe<User_Dashboard_Variance_Fields>;
};


/** aggregate fields of "user_dashboard" */
export type User_Dashboard_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Dashboard_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type User_Dashboard_Avg_Fields = {
  __typename?: 'user_dashboard_avg_fields';
  active_vaults_count?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vaults_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "user_dashboard". All fields are combined with a logical 'AND'. */
export type User_Dashboard_Bool_Exp = {
  _and?: InputMaybe<Array<User_Dashboard_Bool_Exp>>;
  _not?: InputMaybe<User_Dashboard_Bool_Exp>;
  _or?: InputMaybe<Array<User_Dashboard_Bool_Exp>>;
  active_vaults_count?: InputMaybe<Bigint_Comparison_Exp>;
  last_updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  m_tokens?: InputMaybe<Jsonb_Comparison_Exp>;
  total_borrowed?: InputMaybe<Float8_Comparison_Exp>;
  user_address?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
  vaults_count?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type User_Dashboard_Max_Fields = {
  __typename?: 'user_dashboard_max_fields';
  active_vaults_count?: Maybe<Scalars['bigint']['output']>;
  last_updated?: Maybe<Scalars['timestamptz']['output']>;
  total_borrowed?: Maybe<Scalars['float8']['output']>;
  user_address?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  vaults_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type User_Dashboard_Min_Fields = {
  __typename?: 'user_dashboard_min_fields';
  active_vaults_count?: Maybe<Scalars['bigint']['output']>;
  last_updated?: Maybe<Scalars['timestamptz']['output']>;
  total_borrowed?: Maybe<Scalars['float8']['output']>;
  user_address?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  vaults_count?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "user_dashboard". */
export type User_Dashboard_Order_By = {
  active_vaults_count?: InputMaybe<Order_By>;
  last_updated?: InputMaybe<Order_By>;
  m_tokens?: InputMaybe<Order_By>;
  total_borrowed?: InputMaybe<Order_By>;
  user_address?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vaults_count?: InputMaybe<Order_By>;
};

/** select columns of table "user_dashboard" */
export enum User_Dashboard_Select_Column {
  /** column name */
  ActiveVaultsCount = 'active_vaults_count',
  /** column name */
  LastUpdated = 'last_updated',
  /** column name */
  MTokens = 'm_tokens',
  /** column name */
  TotalBorrowed = 'total_borrowed',
  /** column name */
  UserAddress = 'user_address',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VaultsCount = 'vaults_count'
}

/** aggregate stddev on columns */
export type User_Dashboard_Stddev_Fields = {
  __typename?: 'user_dashboard_stddev_fields';
  active_vaults_count?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vaults_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type User_Dashboard_Stddev_Pop_Fields = {
  __typename?: 'user_dashboard_stddev_pop_fields';
  active_vaults_count?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vaults_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type User_Dashboard_Stddev_Samp_Fields = {
  __typename?: 'user_dashboard_stddev_samp_fields';
  active_vaults_count?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vaults_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "user_dashboard" */
export type User_Dashboard_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Dashboard_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Dashboard_Stream_Cursor_Value_Input = {
  active_vaults_count?: InputMaybe<Scalars['bigint']['input']>;
  last_updated?: InputMaybe<Scalars['timestamptz']['input']>;
  m_tokens?: InputMaybe<Scalars['jsonb']['input']>;
  total_borrowed?: InputMaybe<Scalars['float8']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  vaults_count?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type User_Dashboard_Sum_Fields = {
  __typename?: 'user_dashboard_sum_fields';
  active_vaults_count?: Maybe<Scalars['bigint']['output']>;
  total_borrowed?: Maybe<Scalars['float8']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  vaults_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type User_Dashboard_Var_Pop_Fields = {
  __typename?: 'user_dashboard_var_pop_fields';
  active_vaults_count?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vaults_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type User_Dashboard_Var_Samp_Fields = {
  __typename?: 'user_dashboard_var_samp_fields';
  active_vaults_count?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vaults_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type User_Dashboard_Variance_Fields = {
  __typename?: 'user_dashboard_variance_fields';
  active_vaults_count?: Maybe<Scalars['Float']['output']>;
  total_borrowed?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vaults_count?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "vault" */
export type Vault = {
  __typename?: 'vault';
  address: Scalars['String']['output'];
  admin: Scalars['String']['output'];
  /** ANY: 0\nWHITELIST: 1 */
  allowance: Scalars['smallint']['output'];
  /** An object relationship */
  baker?: Maybe<Maven_User>;
  baker_id?: Maybe<Scalars['bigint']['output']>;
  creation_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  depositors: Array<Vault_Depositor>;
  /** An aggregate relationship */
  depositors_aggregate: Vault_Depositor_Aggregate;
  /** An object relationship */
  factory?: Maybe<Vault_Factory>;
  factory_id?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  /** An array relationship */
  lambdas: Array<Vault_Lambda>;
  /** An aggregate relationship */
  lambdas_aggregate: Vault_Lambda_Aggregate;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  lending_controller_vaults: Array<Lending_Controller_Vault>;
  /** An aggregate relationship */
  lending_controller_vaults_aggregate: Lending_Controller_Vault_Aggregate;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  name: Scalars['String']['output'];
  network: Scalars['String']['output'];
};


/** columns and relationships of "vault" */
export type VaultDepositorsArgs = {
  distinct_on?: InputMaybe<Array<Vault_Depositor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Depositor_Order_By>>;
  where?: InputMaybe<Vault_Depositor_Bool_Exp>;
};


/** columns and relationships of "vault" */
export type VaultDepositors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Depositor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Depositor_Order_By>>;
  where?: InputMaybe<Vault_Depositor_Bool_Exp>;
};


/** columns and relationships of "vault" */
export type VaultLambdasArgs = {
  distinct_on?: InputMaybe<Array<Vault_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Lambda_Order_By>>;
  where?: InputMaybe<Vault_Lambda_Bool_Exp>;
};


/** columns and relationships of "vault" */
export type VaultLambdas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Lambda_Order_By>>;
  where?: InputMaybe<Vault_Lambda_Bool_Exp>;
};


/** columns and relationships of "vault" */
export type VaultLending_Controller_VaultsArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Vault_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Vault_Order_By>>;
  where?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
};


/** columns and relationships of "vault" */
export type VaultLending_Controller_Vaults_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lending_Controller_Vault_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lending_Controller_Vault_Order_By>>;
  where?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
};


/** columns and relationships of "vault" */
export type VaultMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "vault" */
export type Vault_Aggregate = {
  __typename?: 'vault_aggregate';
  aggregate?: Maybe<Vault_Aggregate_Fields>;
  nodes: Array<Vault>;
};

export type Vault_Aggregate_Bool_Exp = {
  count?: InputMaybe<Vault_Aggregate_Bool_Exp_Count>;
};

export type Vault_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vault_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vault_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vault" */
export type Vault_Aggregate_Fields = {
  __typename?: 'vault_aggregate_fields';
  avg?: Maybe<Vault_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vault_Max_Fields>;
  min?: Maybe<Vault_Min_Fields>;
  stddev?: Maybe<Vault_Stddev_Fields>;
  stddev_pop?: Maybe<Vault_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vault_Stddev_Samp_Fields>;
  sum?: Maybe<Vault_Sum_Fields>;
  var_pop?: Maybe<Vault_Var_Pop_Fields>;
  var_samp?: Maybe<Vault_Var_Samp_Fields>;
  variance?: Maybe<Vault_Variance_Fields>;
};


/** aggregate fields of "vault" */
export type Vault_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vault_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vault" */
export type Vault_Aggregate_Order_By = {
  avg?: InputMaybe<Vault_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vault_Max_Order_By>;
  min?: InputMaybe<Vault_Min_Order_By>;
  stddev?: InputMaybe<Vault_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Vault_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Vault_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Vault_Sum_Order_By>;
  var_pop?: InputMaybe<Vault_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Vault_Var_Samp_Order_By>;
  variance?: InputMaybe<Vault_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Vault_Avg_Fields = {
  __typename?: 'vault_avg_fields';
  /** ANY: 0\nWHITELIST: 1 */
  allowance?: Maybe<Scalars['Float']['output']>;
  baker_id?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "vault" */
export type Vault_Avg_Order_By = {
  /** ANY: 0\nWHITELIST: 1 */
  allowance?: InputMaybe<Order_By>;
  baker_id?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vault". All fields are combined with a logical 'AND'. */
export type Vault_Bool_Exp = {
  _and?: InputMaybe<Array<Vault_Bool_Exp>>;
  _not?: InputMaybe<Vault_Bool_Exp>;
  _or?: InputMaybe<Array<Vault_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  admin?: InputMaybe<String_Comparison_Exp>;
  allowance?: InputMaybe<Smallint_Comparison_Exp>;
  baker?: InputMaybe<Maven_User_Bool_Exp>;
  baker_id?: InputMaybe<Bigint_Comparison_Exp>;
  creation_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  depositors?: InputMaybe<Vault_Depositor_Bool_Exp>;
  depositors_aggregate?: InputMaybe<Vault_Depositor_Aggregate_Bool_Exp>;
  factory?: InputMaybe<Vault_Factory_Bool_Exp>;
  factory_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambdas?: InputMaybe<Vault_Lambda_Bool_Exp>;
  lambdas_aggregate?: InputMaybe<Vault_Lambda_Aggregate_Bool_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  lending_controller_vaults?: InputMaybe<Lending_Controller_Vault_Bool_Exp>;
  lending_controller_vaults_aggregate?: InputMaybe<Lending_Controller_Vault_Aggregate_Bool_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "vault_collateral_view" */
export type Vault_Collateral_View = {
  __typename?: 'vault_collateral_view';
  balance?: Maybe<Scalars['float8']['output']>;
  collateral_token_id?: Maybe<Scalars['bigint']['output']>;
  collateral_token_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated?: Maybe<Scalars['timestamptz']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['bigint']['output']>;
  loan_outstanding_total?: Maybe<Scalars['float8']['output']>;
  owner_address?: Maybe<Scalars['String']['output']>;
  owner_id?: Maybe<Scalars['bigint']['output']>;
  token_address?: Maybe<Scalars['String']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  vault_address?: Maybe<Scalars['String']['output']>;
  vault_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "vault_collateral_view" */
export type Vault_Collateral_View_Aggregate = {
  __typename?: 'vault_collateral_view_aggregate';
  aggregate?: Maybe<Vault_Collateral_View_Aggregate_Fields>;
  nodes: Array<Vault_Collateral_View>;
};

/** aggregate fields of "vault_collateral_view" */
export type Vault_Collateral_View_Aggregate_Fields = {
  __typename?: 'vault_collateral_view_aggregate_fields';
  avg?: Maybe<Vault_Collateral_View_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vault_Collateral_View_Max_Fields>;
  min?: Maybe<Vault_Collateral_View_Min_Fields>;
  stddev?: Maybe<Vault_Collateral_View_Stddev_Fields>;
  stddev_pop?: Maybe<Vault_Collateral_View_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vault_Collateral_View_Stddev_Samp_Fields>;
  sum?: Maybe<Vault_Collateral_View_Sum_Fields>;
  var_pop?: Maybe<Vault_Collateral_View_Var_Pop_Fields>;
  var_samp?: Maybe<Vault_Collateral_View_Var_Samp_Fields>;
  variance?: Maybe<Vault_Collateral_View_Variance_Fields>;
};


/** aggregate fields of "vault_collateral_view" */
export type Vault_Collateral_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vault_Collateral_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Vault_Collateral_View_Avg_Fields = {
  __typename?: 'vault_collateral_view_avg_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  collateral_token_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['Float']['output']>;
  loan_outstanding_total?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "vault_collateral_view". All fields are combined with a logical 'AND'. */
export type Vault_Collateral_View_Bool_Exp = {
  _and?: InputMaybe<Array<Vault_Collateral_View_Bool_Exp>>;
  _not?: InputMaybe<Vault_Collateral_View_Bool_Exp>;
  _or?: InputMaybe<Array<Vault_Collateral_View_Bool_Exp>>;
  balance?: InputMaybe<Float8_Comparison_Exp>;
  collateral_token_id?: InputMaybe<Bigint_Comparison_Exp>;
  collateral_token_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  last_updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  lending_controller_vault_id?: InputMaybe<Bigint_Comparison_Exp>;
  loan_outstanding_total?: InputMaybe<Float8_Comparison_Exp>;
  owner_address?: InputMaybe<String_Comparison_Exp>;
  owner_id?: InputMaybe<Bigint_Comparison_Exp>;
  token_address?: InputMaybe<String_Comparison_Exp>;
  token_id?: InputMaybe<Bigint_Comparison_Exp>;
  vault_address?: InputMaybe<String_Comparison_Exp>;
  vault_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Vault_Collateral_View_Max_Fields = {
  __typename?: 'vault_collateral_view_max_fields';
  balance?: Maybe<Scalars['float8']['output']>;
  collateral_token_id?: Maybe<Scalars['bigint']['output']>;
  collateral_token_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated?: Maybe<Scalars['timestamptz']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['bigint']['output']>;
  loan_outstanding_total?: Maybe<Scalars['float8']['output']>;
  owner_address?: Maybe<Scalars['String']['output']>;
  owner_id?: Maybe<Scalars['bigint']['output']>;
  token_address?: Maybe<Scalars['String']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  vault_address?: Maybe<Scalars['String']['output']>;
  vault_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Vault_Collateral_View_Min_Fields = {
  __typename?: 'vault_collateral_view_min_fields';
  balance?: Maybe<Scalars['float8']['output']>;
  collateral_token_id?: Maybe<Scalars['bigint']['output']>;
  collateral_token_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated?: Maybe<Scalars['timestamptz']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['bigint']['output']>;
  loan_outstanding_total?: Maybe<Scalars['float8']['output']>;
  owner_address?: Maybe<Scalars['String']['output']>;
  owner_id?: Maybe<Scalars['bigint']['output']>;
  token_address?: Maybe<Scalars['String']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  vault_address?: Maybe<Scalars['String']['output']>;
  vault_id?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "vault_collateral_view". */
export type Vault_Collateral_View_Order_By = {
  balance?: InputMaybe<Order_By>;
  collateral_token_id?: InputMaybe<Order_By>;
  collateral_token_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated?: InputMaybe<Order_By>;
  lending_controller_vault_id?: InputMaybe<Order_By>;
  loan_outstanding_total?: InputMaybe<Order_By>;
  owner_address?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  token_address?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  vault_address?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** select columns of table "vault_collateral_view" */
export enum Vault_Collateral_View_Select_Column {
  /** column name */
  Balance = 'balance',
  /** column name */
  CollateralTokenId = 'collateral_token_id',
  /** column name */
  CollateralTokenName = 'collateral_token_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdated = 'last_updated',
  /** column name */
  LendingControllerVaultId = 'lending_controller_vault_id',
  /** column name */
  LoanOutstandingTotal = 'loan_outstanding_total',
  /** column name */
  OwnerAddress = 'owner_address',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  TokenAddress = 'token_address',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  VaultAddress = 'vault_address',
  /** column name */
  VaultId = 'vault_id'
}

/** aggregate stddev on columns */
export type Vault_Collateral_View_Stddev_Fields = {
  __typename?: 'vault_collateral_view_stddev_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  collateral_token_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['Float']['output']>;
  loan_outstanding_total?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Vault_Collateral_View_Stddev_Pop_Fields = {
  __typename?: 'vault_collateral_view_stddev_pop_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  collateral_token_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['Float']['output']>;
  loan_outstanding_total?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Vault_Collateral_View_Stddev_Samp_Fields = {
  __typename?: 'vault_collateral_view_stddev_samp_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  collateral_token_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['Float']['output']>;
  loan_outstanding_total?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "vault_collateral_view" */
export type Vault_Collateral_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vault_Collateral_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vault_Collateral_View_Stream_Cursor_Value_Input = {
  balance?: InputMaybe<Scalars['float8']['input']>;
  collateral_token_id?: InputMaybe<Scalars['bigint']['input']>;
  collateral_token_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_updated?: InputMaybe<Scalars['timestamptz']['input']>;
  lending_controller_vault_id?: InputMaybe<Scalars['bigint']['input']>;
  loan_outstanding_total?: InputMaybe<Scalars['float8']['input']>;
  owner_address?: InputMaybe<Scalars['String']['input']>;
  owner_id?: InputMaybe<Scalars['bigint']['input']>;
  token_address?: InputMaybe<Scalars['String']['input']>;
  token_id?: InputMaybe<Scalars['bigint']['input']>;
  vault_address?: InputMaybe<Scalars['String']['input']>;
  vault_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Vault_Collateral_View_Sum_Fields = {
  __typename?: 'vault_collateral_view_sum_fields';
  balance?: Maybe<Scalars['float8']['output']>;
  collateral_token_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['bigint']['output']>;
  loan_outstanding_total?: Maybe<Scalars['float8']['output']>;
  owner_id?: Maybe<Scalars['bigint']['output']>;
  token_id?: Maybe<Scalars['bigint']['output']>;
  vault_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Vault_Collateral_View_Var_Pop_Fields = {
  __typename?: 'vault_collateral_view_var_pop_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  collateral_token_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['Float']['output']>;
  loan_outstanding_total?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Vault_Collateral_View_Var_Samp_Fields = {
  __typename?: 'vault_collateral_view_var_samp_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  collateral_token_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['Float']['output']>;
  loan_outstanding_total?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Vault_Collateral_View_Variance_Fields = {
  __typename?: 'vault_collateral_view_variance_fields';
  balance?: Maybe<Scalars['Float']['output']>;
  collateral_token_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lending_controller_vault_id?: Maybe<Scalars['Float']['output']>;
  loan_outstanding_total?: Maybe<Scalars['Float']['output']>;
  owner_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "vault_depositor" */
export type Vault_Depositor = {
  __typename?: 'vault_depositor';
  /** An object relationship */
  depositor: Maven_User;
  depositor_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  vault: Vault;
  vault_id: Scalars['bigint']['output'];
};

/** aggregated selection of "vault_depositor" */
export type Vault_Depositor_Aggregate = {
  __typename?: 'vault_depositor_aggregate';
  aggregate?: Maybe<Vault_Depositor_Aggregate_Fields>;
  nodes: Array<Vault_Depositor>;
};

export type Vault_Depositor_Aggregate_Bool_Exp = {
  count?: InputMaybe<Vault_Depositor_Aggregate_Bool_Exp_Count>;
};

export type Vault_Depositor_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vault_Depositor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vault_Depositor_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vault_depositor" */
export type Vault_Depositor_Aggregate_Fields = {
  __typename?: 'vault_depositor_aggregate_fields';
  avg?: Maybe<Vault_Depositor_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vault_Depositor_Max_Fields>;
  min?: Maybe<Vault_Depositor_Min_Fields>;
  stddev?: Maybe<Vault_Depositor_Stddev_Fields>;
  stddev_pop?: Maybe<Vault_Depositor_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vault_Depositor_Stddev_Samp_Fields>;
  sum?: Maybe<Vault_Depositor_Sum_Fields>;
  var_pop?: Maybe<Vault_Depositor_Var_Pop_Fields>;
  var_samp?: Maybe<Vault_Depositor_Var_Samp_Fields>;
  variance?: Maybe<Vault_Depositor_Variance_Fields>;
};


/** aggregate fields of "vault_depositor" */
export type Vault_Depositor_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vault_Depositor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vault_depositor" */
export type Vault_Depositor_Aggregate_Order_By = {
  avg?: InputMaybe<Vault_Depositor_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vault_Depositor_Max_Order_By>;
  min?: InputMaybe<Vault_Depositor_Min_Order_By>;
  stddev?: InputMaybe<Vault_Depositor_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Vault_Depositor_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Vault_Depositor_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Vault_Depositor_Sum_Order_By>;
  var_pop?: InputMaybe<Vault_Depositor_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Vault_Depositor_Var_Samp_Order_By>;
  variance?: InputMaybe<Vault_Depositor_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Vault_Depositor_Avg_Fields = {
  __typename?: 'vault_depositor_avg_fields';
  depositor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "vault_depositor" */
export type Vault_Depositor_Avg_Order_By = {
  depositor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vault_depositor". All fields are combined with a logical 'AND'. */
export type Vault_Depositor_Bool_Exp = {
  _and?: InputMaybe<Array<Vault_Depositor_Bool_Exp>>;
  _not?: InputMaybe<Vault_Depositor_Bool_Exp>;
  _or?: InputMaybe<Array<Vault_Depositor_Bool_Exp>>;
  depositor?: InputMaybe<Maven_User_Bool_Exp>;
  depositor_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  vault?: InputMaybe<Vault_Bool_Exp>;
  vault_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Vault_Depositor_Max_Fields = {
  __typename?: 'vault_depositor_max_fields';
  depositor_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  vault_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "vault_depositor" */
export type Vault_Depositor_Max_Order_By = {
  depositor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vault_Depositor_Min_Fields = {
  __typename?: 'vault_depositor_min_fields';
  depositor_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  vault_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "vault_depositor" */
export type Vault_Depositor_Min_Order_By = {
  depositor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "vault_depositor". */
export type Vault_Depositor_Order_By = {
  depositor?: InputMaybe<Maven_User_Order_By>;
  depositor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  vault?: InputMaybe<Vault_Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** select columns of table "vault_depositor" */
export enum Vault_Depositor_Select_Column {
  /** column name */
  DepositorId = 'depositor_id',
  /** column name */
  Id = 'id',
  /** column name */
  VaultId = 'vault_id'
}

/** aggregate stddev on columns */
export type Vault_Depositor_Stddev_Fields = {
  __typename?: 'vault_depositor_stddev_fields';
  depositor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "vault_depositor" */
export type Vault_Depositor_Stddev_Order_By = {
  depositor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vault_Depositor_Stddev_Pop_Fields = {
  __typename?: 'vault_depositor_stddev_pop_fields';
  depositor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "vault_depositor" */
export type Vault_Depositor_Stddev_Pop_Order_By = {
  depositor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vault_Depositor_Stddev_Samp_Fields = {
  __typename?: 'vault_depositor_stddev_samp_fields';
  depositor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "vault_depositor" */
export type Vault_Depositor_Stddev_Samp_Order_By = {
  depositor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "vault_depositor" */
export type Vault_Depositor_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vault_Depositor_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vault_Depositor_Stream_Cursor_Value_Input = {
  depositor_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  vault_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Vault_Depositor_Sum_Fields = {
  __typename?: 'vault_depositor_sum_fields';
  depositor_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  vault_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "vault_depositor" */
export type Vault_Depositor_Sum_Order_By = {
  depositor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Vault_Depositor_Var_Pop_Fields = {
  __typename?: 'vault_depositor_var_pop_fields';
  depositor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "vault_depositor" */
export type Vault_Depositor_Var_Pop_Order_By = {
  depositor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vault_Depositor_Var_Samp_Fields = {
  __typename?: 'vault_depositor_var_samp_fields';
  depositor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "vault_depositor" */
export type Vault_Depositor_Var_Samp_Order_By = {
  depositor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Vault_Depositor_Variance_Fields = {
  __typename?: 'vault_depositor_variance_fields';
  depositor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  vault_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "vault_depositor" */
export type Vault_Depositor_Variance_Order_By = {
  depositor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  vault_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "vault_factory" */
export type Vault_Factory = {
  __typename?: 'vault_factory';
  address: Scalars['String']['output'];
  admin: Scalars['String']['output'];
  create_vault_paused: Scalars['Boolean']['output'];
  /** An array relationship */
  general_contracts: Array<Vault_Factory_General_Contract>;
  /** An aggregate relationship */
  general_contracts_aggregate: Vault_Factory_General_Contract_Aggregate;
  /** An object relationship */
  governance: Governance;
  governance_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An array relationship */
  lambdas: Array<Vault_Factory_Lambda>;
  /** An aggregate relationship */
  lambdas_aggregate: Vault_Factory_Lambda_Aggregate;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  network: Scalars['String']['output'];
  /** An array relationship */
  vault_lambdas: Array<Vault_Factory_Vault_Lambda>;
  /** An aggregate relationship */
  vault_lambdas_aggregate: Vault_Factory_Vault_Lambda_Aggregate;
  vault_name_max_length: Scalars['smallint']['output'];
  /** An array relationship */
  vaults: Array<Vault>;
  /** An aggregate relationship */
  vaults_aggregate: Vault_Aggregate;
  /** An array relationship */
  whitelist_contracts: Array<Vault_Factory_Whitelist_Contract>;
  /** An aggregate relationship */
  whitelist_contracts_aggregate: Vault_Factory_Whitelist_Contract_Aggregate;
};


/** columns and relationships of "vault_factory" */
export type Vault_FactoryGeneral_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_General_Contract_Order_By>>;
  where?: InputMaybe<Vault_Factory_General_Contract_Bool_Exp>;
};


/** columns and relationships of "vault_factory" */
export type Vault_FactoryGeneral_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_General_Contract_Order_By>>;
  where?: InputMaybe<Vault_Factory_General_Contract_Bool_Exp>;
};


/** columns and relationships of "vault_factory" */
export type Vault_FactoryLambdasArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_Lambda_Order_By>>;
  where?: InputMaybe<Vault_Factory_Lambda_Bool_Exp>;
};


/** columns and relationships of "vault_factory" */
export type Vault_FactoryLambdas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_Lambda_Order_By>>;
  where?: InputMaybe<Vault_Factory_Lambda_Bool_Exp>;
};


/** columns and relationships of "vault_factory" */
export type Vault_FactoryMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "vault_factory" */
export type Vault_FactoryVault_LambdasArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_Vault_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_Vault_Lambda_Order_By>>;
  where?: InputMaybe<Vault_Factory_Vault_Lambda_Bool_Exp>;
};


/** columns and relationships of "vault_factory" */
export type Vault_FactoryVault_Lambdas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_Vault_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_Vault_Lambda_Order_By>>;
  where?: InputMaybe<Vault_Factory_Vault_Lambda_Bool_Exp>;
};


/** columns and relationships of "vault_factory" */
export type Vault_FactoryVaultsArgs = {
  distinct_on?: InputMaybe<Array<Vault_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Order_By>>;
  where?: InputMaybe<Vault_Bool_Exp>;
};


/** columns and relationships of "vault_factory" */
export type Vault_FactoryVaults_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Order_By>>;
  where?: InputMaybe<Vault_Bool_Exp>;
};


/** columns and relationships of "vault_factory" */
export type Vault_FactoryWhitelist_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Vault_Factory_Whitelist_Contract_Bool_Exp>;
};


/** columns and relationships of "vault_factory" */
export type Vault_FactoryWhitelist_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vault_Factory_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vault_Factory_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Vault_Factory_Whitelist_Contract_Bool_Exp>;
};

/** aggregated selection of "vault_factory" */
export type Vault_Factory_Aggregate = {
  __typename?: 'vault_factory_aggregate';
  aggregate?: Maybe<Vault_Factory_Aggregate_Fields>;
  nodes: Array<Vault_Factory>;
};

export type Vault_Factory_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Vault_Factory_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Vault_Factory_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Vault_Factory_Aggregate_Bool_Exp_Count>;
};

export type Vault_Factory_Aggregate_Bool_Exp_Bool_And = {
  arguments: Vault_Factory_Select_Column_Vault_Factory_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vault_Factory_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vault_Factory_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Vault_Factory_Select_Column_Vault_Factory_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vault_Factory_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vault_Factory_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vault_Factory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vault_Factory_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vault_factory" */
export type Vault_Factory_Aggregate_Fields = {
  __typename?: 'vault_factory_aggregate_fields';
  avg?: Maybe<Vault_Factory_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vault_Factory_Max_Fields>;
  min?: Maybe<Vault_Factory_Min_Fields>;
  stddev?: Maybe<Vault_Factory_Stddev_Fields>;
  stddev_pop?: Maybe<Vault_Factory_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vault_Factory_Stddev_Samp_Fields>;
  sum?: Maybe<Vault_Factory_Sum_Fields>;
  var_pop?: Maybe<Vault_Factory_Var_Pop_Fields>;
  var_samp?: Maybe<Vault_Factory_Var_Samp_Fields>;
  variance?: Maybe<Vault_Factory_Variance_Fields>;
};


/** aggregate fields of "vault_factory" */
export type Vault_Factory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vault_Factory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vault_factory" */
export type Vault_Factory_Aggregate_Order_By = {
  avg?: InputMaybe<Vault_Factory_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vault_Factory_Max_Order_By>;
  min?: InputMaybe<Vault_Factory_Min_Order_By>;
  stddev?: InputMaybe<Vault_Factory_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Vault_Factory_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Vault_Factory_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Vault_Factory_Sum_Order_By>;
  var_pop?: InputMaybe<Vault_Factory_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Vault_Factory_Var_Samp_Order_By>;
  variance?: InputMaybe<Vault_Factory_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Vault_Factory_Avg_Fields = {
  __typename?: 'vault_factory_avg_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  vault_name_max_length?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "vault_factory" */
export type Vault_Factory_Avg_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  vault_name_max_length?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vault_factory". All fields are combined with a logical 'AND'. */
export type Vault_Factory_Bool_Exp = {
  _and?: InputMaybe<Array<Vault_Factory_Bool_Exp>>;
  _not?: InputMaybe<Vault_Factory_Bool_Exp>;
  _or?: InputMaybe<Array<Vault_Factory_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  admin?: InputMaybe<String_Comparison_Exp>;
  create_vault_paused?: InputMaybe<Boolean_Comparison_Exp>;
  general_contracts?: InputMaybe<Vault_Factory_General_Contract_Bool_Exp>;
  general_contracts_aggregate?: InputMaybe<Vault_Factory_General_Contract_Aggregate_Bool_Exp>;
  governance?: InputMaybe<Governance_Bool_Exp>;
  governance_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambdas?: InputMaybe<Vault_Factory_Lambda_Bool_Exp>;
  lambdas_aggregate?: InputMaybe<Vault_Factory_Lambda_Aggregate_Bool_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
  vault_lambdas?: InputMaybe<Vault_Factory_Vault_Lambda_Bool_Exp>;
  vault_lambdas_aggregate?: InputMaybe<Vault_Factory_Vault_Lambda_Aggregate_Bool_Exp>;
  vault_name_max_length?: InputMaybe<Smallint_Comparison_Exp>;
  vaults?: InputMaybe<Vault_Bool_Exp>;
  vaults_aggregate?: InputMaybe<Vault_Aggregate_Bool_Exp>;
  whitelist_contracts?: InputMaybe<Vault_Factory_Whitelist_Contract_Bool_Exp>;
  whitelist_contracts_aggregate?: InputMaybe<Vault_Factory_Whitelist_Contract_Aggregate_Bool_Exp>;
};

/** columns and relationships of "vault_factory_general_contract" */
export type Vault_Factory_General_Contract = {
  __typename?: 'vault_factory_general_contract';
  /** An object relationship */
  contract: Vault_Factory;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  contract_name: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "vault_factory_general_contract" */
export type Vault_Factory_General_Contract_Aggregate = {
  __typename?: 'vault_factory_general_contract_aggregate';
  aggregate?: Maybe<Vault_Factory_General_Contract_Aggregate_Fields>;
  nodes: Array<Vault_Factory_General_Contract>;
};

export type Vault_Factory_General_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Vault_Factory_General_Contract_Aggregate_Bool_Exp_Count>;
};

export type Vault_Factory_General_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vault_Factory_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vault_Factory_General_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vault_factory_general_contract" */
export type Vault_Factory_General_Contract_Aggregate_Fields = {
  __typename?: 'vault_factory_general_contract_aggregate_fields';
  avg?: Maybe<Vault_Factory_General_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vault_Factory_General_Contract_Max_Fields>;
  min?: Maybe<Vault_Factory_General_Contract_Min_Fields>;
  stddev?: Maybe<Vault_Factory_General_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Vault_Factory_General_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vault_Factory_General_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Vault_Factory_General_Contract_Sum_Fields>;
  var_pop?: Maybe<Vault_Factory_General_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Vault_Factory_General_Contract_Var_Samp_Fields>;
  variance?: Maybe<Vault_Factory_General_Contract_Variance_Fields>;
};


/** aggregate fields of "vault_factory_general_contract" */
export type Vault_Factory_General_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vault_Factory_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vault_factory_general_contract" */
export type Vault_Factory_General_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Vault_Factory_General_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vault_Factory_General_Contract_Max_Order_By>;
  min?: InputMaybe<Vault_Factory_General_Contract_Min_Order_By>;
  stddev?: InputMaybe<Vault_Factory_General_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Vault_Factory_General_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Vault_Factory_General_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Vault_Factory_General_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Vault_Factory_General_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Vault_Factory_General_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Vault_Factory_General_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Vault_Factory_General_Contract_Avg_Fields = {
  __typename?: 'vault_factory_general_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "vault_factory_general_contract" */
export type Vault_Factory_General_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vault_factory_general_contract". All fields are combined with a logical 'AND'. */
export type Vault_Factory_General_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Vault_Factory_General_Contract_Bool_Exp>>;
  _not?: InputMaybe<Vault_Factory_General_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Vault_Factory_General_Contract_Bool_Exp>>;
  contract?: InputMaybe<Vault_Factory_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  contract_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Vault_Factory_General_Contract_Max_Fields = {
  __typename?: 'vault_factory_general_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "vault_factory_general_contract" */
export type Vault_Factory_General_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vault_Factory_General_Contract_Min_Fields = {
  __typename?: 'vault_factory_general_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "vault_factory_general_contract" */
export type Vault_Factory_General_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "vault_factory_general_contract". */
export type Vault_Factory_General_Contract_Order_By = {
  contract?: InputMaybe<Vault_Factory_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "vault_factory_general_contract" */
export enum Vault_Factory_General_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  ContractName = 'contract_name',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Vault_Factory_General_Contract_Stddev_Fields = {
  __typename?: 'vault_factory_general_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "vault_factory_general_contract" */
export type Vault_Factory_General_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vault_Factory_General_Contract_Stddev_Pop_Fields = {
  __typename?: 'vault_factory_general_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "vault_factory_general_contract" */
export type Vault_Factory_General_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vault_Factory_General_Contract_Stddev_Samp_Fields = {
  __typename?: 'vault_factory_general_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "vault_factory_general_contract" */
export type Vault_Factory_General_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "vault_factory_general_contract" */
export type Vault_Factory_General_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vault_Factory_General_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vault_Factory_General_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  contract_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Vault_Factory_General_Contract_Sum_Fields = {
  __typename?: 'vault_factory_general_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "vault_factory_general_contract" */
export type Vault_Factory_General_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Vault_Factory_General_Contract_Var_Pop_Fields = {
  __typename?: 'vault_factory_general_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "vault_factory_general_contract" */
export type Vault_Factory_General_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vault_Factory_General_Contract_Var_Samp_Fields = {
  __typename?: 'vault_factory_general_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "vault_factory_general_contract" */
export type Vault_Factory_General_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Vault_Factory_General_Contract_Variance_Fields = {
  __typename?: 'vault_factory_general_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "vault_factory_general_contract" */
export type Vault_Factory_General_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "vault_factory_lambda" */
export type Vault_Factory_Lambda = {
  __typename?: 'vault_factory_lambda';
  /** An object relationship */
  contract: Vault_Factory;
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lambda_bytes: Scalars['String']['output'];
  lambda_name: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "vault_factory_lambda" */
export type Vault_Factory_Lambda_Aggregate = {
  __typename?: 'vault_factory_lambda_aggregate';
  aggregate?: Maybe<Vault_Factory_Lambda_Aggregate_Fields>;
  nodes: Array<Vault_Factory_Lambda>;
};

export type Vault_Factory_Lambda_Aggregate_Bool_Exp = {
  count?: InputMaybe<Vault_Factory_Lambda_Aggregate_Bool_Exp_Count>;
};

export type Vault_Factory_Lambda_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vault_Factory_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vault_Factory_Lambda_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vault_factory_lambda" */
export type Vault_Factory_Lambda_Aggregate_Fields = {
  __typename?: 'vault_factory_lambda_aggregate_fields';
  avg?: Maybe<Vault_Factory_Lambda_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vault_Factory_Lambda_Max_Fields>;
  min?: Maybe<Vault_Factory_Lambda_Min_Fields>;
  stddev?: Maybe<Vault_Factory_Lambda_Stddev_Fields>;
  stddev_pop?: Maybe<Vault_Factory_Lambda_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vault_Factory_Lambda_Stddev_Samp_Fields>;
  sum?: Maybe<Vault_Factory_Lambda_Sum_Fields>;
  var_pop?: Maybe<Vault_Factory_Lambda_Var_Pop_Fields>;
  var_samp?: Maybe<Vault_Factory_Lambda_Var_Samp_Fields>;
  variance?: Maybe<Vault_Factory_Lambda_Variance_Fields>;
};


/** aggregate fields of "vault_factory_lambda" */
export type Vault_Factory_Lambda_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vault_Factory_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vault_factory_lambda" */
export type Vault_Factory_Lambda_Aggregate_Order_By = {
  avg?: InputMaybe<Vault_Factory_Lambda_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vault_Factory_Lambda_Max_Order_By>;
  min?: InputMaybe<Vault_Factory_Lambda_Min_Order_By>;
  stddev?: InputMaybe<Vault_Factory_Lambda_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Vault_Factory_Lambda_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Vault_Factory_Lambda_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Vault_Factory_Lambda_Sum_Order_By>;
  var_pop?: InputMaybe<Vault_Factory_Lambda_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Vault_Factory_Lambda_Var_Samp_Order_By>;
  variance?: InputMaybe<Vault_Factory_Lambda_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Vault_Factory_Lambda_Avg_Fields = {
  __typename?: 'vault_factory_lambda_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "vault_factory_lambda" */
export type Vault_Factory_Lambda_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vault_factory_lambda". All fields are combined with a logical 'AND'. */
export type Vault_Factory_Lambda_Bool_Exp = {
  _and?: InputMaybe<Array<Vault_Factory_Lambda_Bool_Exp>>;
  _not?: InputMaybe<Vault_Factory_Lambda_Bool_Exp>;
  _or?: InputMaybe<Array<Vault_Factory_Lambda_Bool_Exp>>;
  contract?: InputMaybe<Vault_Factory_Bool_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambda_bytes?: InputMaybe<String_Comparison_Exp>;
  lambda_name?: InputMaybe<String_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Vault_Factory_Lambda_Max_Fields = {
  __typename?: 'vault_factory_lambda_max_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "vault_factory_lambda" */
export type Vault_Factory_Lambda_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vault_Factory_Lambda_Min_Fields = {
  __typename?: 'vault_factory_lambda_min_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "vault_factory_lambda" */
export type Vault_Factory_Lambda_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "vault_factory_lambda". */
export type Vault_Factory_Lambda_Order_By = {
  contract?: InputMaybe<Vault_Factory_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "vault_factory_lambda" */
export enum Vault_Factory_Lambda_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaBytes = 'lambda_bytes',
  /** column name */
  LambdaName = 'lambda_name',
  /** column name */
  LastUpdatedAt = 'last_updated_at'
}

/** aggregate stddev on columns */
export type Vault_Factory_Lambda_Stddev_Fields = {
  __typename?: 'vault_factory_lambda_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "vault_factory_lambda" */
export type Vault_Factory_Lambda_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vault_Factory_Lambda_Stddev_Pop_Fields = {
  __typename?: 'vault_factory_lambda_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "vault_factory_lambda" */
export type Vault_Factory_Lambda_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vault_Factory_Lambda_Stddev_Samp_Fields = {
  __typename?: 'vault_factory_lambda_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "vault_factory_lambda" */
export type Vault_Factory_Lambda_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "vault_factory_lambda" */
export type Vault_Factory_Lambda_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vault_Factory_Lambda_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vault_Factory_Lambda_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lambda_bytes?: InputMaybe<Scalars['String']['input']>;
  lambda_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Vault_Factory_Lambda_Sum_Fields = {
  __typename?: 'vault_factory_lambda_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "vault_factory_lambda" */
export type Vault_Factory_Lambda_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Vault_Factory_Lambda_Var_Pop_Fields = {
  __typename?: 'vault_factory_lambda_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "vault_factory_lambda" */
export type Vault_Factory_Lambda_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vault_Factory_Lambda_Var_Samp_Fields = {
  __typename?: 'vault_factory_lambda_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "vault_factory_lambda" */
export type Vault_Factory_Lambda_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Vault_Factory_Lambda_Variance_Fields = {
  __typename?: 'vault_factory_lambda_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "vault_factory_lambda" */
export type Vault_Factory_Lambda_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Vault_Factory_Max_Fields = {
  __typename?: 'vault_factory_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  vault_name_max_length?: Maybe<Scalars['smallint']['output']>;
};

/** order by max() on columns of table "vault_factory" */
export type Vault_Factory_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  vault_name_max_length?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vault_Factory_Min_Fields = {
  __typename?: 'vault_factory_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  vault_name_max_length?: Maybe<Scalars['smallint']['output']>;
};

/** order by min() on columns of table "vault_factory" */
export type Vault_Factory_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  vault_name_max_length?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "vault_factory". */
export type Vault_Factory_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  create_vault_paused?: InputMaybe<Order_By>;
  general_contracts_aggregate?: InputMaybe<Vault_Factory_General_Contract_Aggregate_Order_By>;
  governance?: InputMaybe<Governance_Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambdas_aggregate?: InputMaybe<Vault_Factory_Lambda_Aggregate_Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  vault_lambdas_aggregate?: InputMaybe<Vault_Factory_Vault_Lambda_Aggregate_Order_By>;
  vault_name_max_length?: InputMaybe<Order_By>;
  vaults_aggregate?: InputMaybe<Vault_Aggregate_Order_By>;
  whitelist_contracts_aggregate?: InputMaybe<Vault_Factory_Whitelist_Contract_Aggregate_Order_By>;
};

/** select columns of table "vault_factory" */
export enum Vault_Factory_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Admin = 'admin',
  /** column name */
  CreateVaultPaused = 'create_vault_paused',
  /** column name */
  GovernanceId = 'governance_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Network = 'network',
  /** column name */
  VaultNameMaxLength = 'vault_name_max_length'
}

/** select "vault_factory_aggregate_bool_exp_bool_and_arguments_columns" columns of table "vault_factory" */
export enum Vault_Factory_Select_Column_Vault_Factory_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CreateVaultPaused = 'create_vault_paused'
}

/** select "vault_factory_aggregate_bool_exp_bool_or_arguments_columns" columns of table "vault_factory" */
export enum Vault_Factory_Select_Column_Vault_Factory_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CreateVaultPaused = 'create_vault_paused'
}

/** aggregate stddev on columns */
export type Vault_Factory_Stddev_Fields = {
  __typename?: 'vault_factory_stddev_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  vault_name_max_length?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "vault_factory" */
export type Vault_Factory_Stddev_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  vault_name_max_length?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vault_Factory_Stddev_Pop_Fields = {
  __typename?: 'vault_factory_stddev_pop_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  vault_name_max_length?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "vault_factory" */
export type Vault_Factory_Stddev_Pop_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  vault_name_max_length?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vault_Factory_Stddev_Samp_Fields = {
  __typename?: 'vault_factory_stddev_samp_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  vault_name_max_length?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "vault_factory" */
export type Vault_Factory_Stddev_Samp_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  vault_name_max_length?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "vault_factory" */
export type Vault_Factory_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vault_Factory_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vault_Factory_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['String']['input']>;
  create_vault_paused?: InputMaybe<Scalars['Boolean']['input']>;
  governance_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  vault_name_max_length?: InputMaybe<Scalars['smallint']['input']>;
};

/** aggregate sum on columns */
export type Vault_Factory_Sum_Fields = {
  __typename?: 'vault_factory_sum_fields';
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  vault_name_max_length?: Maybe<Scalars['smallint']['output']>;
};

/** order by sum() on columns of table "vault_factory" */
export type Vault_Factory_Sum_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  vault_name_max_length?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Vault_Factory_Var_Pop_Fields = {
  __typename?: 'vault_factory_var_pop_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  vault_name_max_length?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "vault_factory" */
export type Vault_Factory_Var_Pop_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  vault_name_max_length?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vault_Factory_Var_Samp_Fields = {
  __typename?: 'vault_factory_var_samp_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  vault_name_max_length?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "vault_factory" */
export type Vault_Factory_Var_Samp_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  vault_name_max_length?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Vault_Factory_Variance_Fields = {
  __typename?: 'vault_factory_variance_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  vault_name_max_length?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "vault_factory" */
export type Vault_Factory_Variance_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  vault_name_max_length?: InputMaybe<Order_By>;
};

/** columns and relationships of "vault_factory_vault_lambda" */
export type Vault_Factory_Vault_Lambda = {
  __typename?: 'vault_factory_vault_lambda';
  /** An object relationship */
  contract: Vault_Factory;
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lambda_bytes: Scalars['String']['output'];
  lambda_name: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "vault_factory_vault_lambda" */
export type Vault_Factory_Vault_Lambda_Aggregate = {
  __typename?: 'vault_factory_vault_lambda_aggregate';
  aggregate?: Maybe<Vault_Factory_Vault_Lambda_Aggregate_Fields>;
  nodes: Array<Vault_Factory_Vault_Lambda>;
};

export type Vault_Factory_Vault_Lambda_Aggregate_Bool_Exp = {
  count?: InputMaybe<Vault_Factory_Vault_Lambda_Aggregate_Bool_Exp_Count>;
};

export type Vault_Factory_Vault_Lambda_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vault_Factory_Vault_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vault_Factory_Vault_Lambda_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vault_factory_vault_lambda" */
export type Vault_Factory_Vault_Lambda_Aggregate_Fields = {
  __typename?: 'vault_factory_vault_lambda_aggregate_fields';
  avg?: Maybe<Vault_Factory_Vault_Lambda_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vault_Factory_Vault_Lambda_Max_Fields>;
  min?: Maybe<Vault_Factory_Vault_Lambda_Min_Fields>;
  stddev?: Maybe<Vault_Factory_Vault_Lambda_Stddev_Fields>;
  stddev_pop?: Maybe<Vault_Factory_Vault_Lambda_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vault_Factory_Vault_Lambda_Stddev_Samp_Fields>;
  sum?: Maybe<Vault_Factory_Vault_Lambda_Sum_Fields>;
  var_pop?: Maybe<Vault_Factory_Vault_Lambda_Var_Pop_Fields>;
  var_samp?: Maybe<Vault_Factory_Vault_Lambda_Var_Samp_Fields>;
  variance?: Maybe<Vault_Factory_Vault_Lambda_Variance_Fields>;
};


/** aggregate fields of "vault_factory_vault_lambda" */
export type Vault_Factory_Vault_Lambda_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vault_Factory_Vault_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vault_factory_vault_lambda" */
export type Vault_Factory_Vault_Lambda_Aggregate_Order_By = {
  avg?: InputMaybe<Vault_Factory_Vault_Lambda_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vault_Factory_Vault_Lambda_Max_Order_By>;
  min?: InputMaybe<Vault_Factory_Vault_Lambda_Min_Order_By>;
  stddev?: InputMaybe<Vault_Factory_Vault_Lambda_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Vault_Factory_Vault_Lambda_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Vault_Factory_Vault_Lambda_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Vault_Factory_Vault_Lambda_Sum_Order_By>;
  var_pop?: InputMaybe<Vault_Factory_Vault_Lambda_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Vault_Factory_Vault_Lambda_Var_Samp_Order_By>;
  variance?: InputMaybe<Vault_Factory_Vault_Lambda_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Vault_Factory_Vault_Lambda_Avg_Fields = {
  __typename?: 'vault_factory_vault_lambda_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "vault_factory_vault_lambda" */
export type Vault_Factory_Vault_Lambda_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vault_factory_vault_lambda". All fields are combined with a logical 'AND'. */
export type Vault_Factory_Vault_Lambda_Bool_Exp = {
  _and?: InputMaybe<Array<Vault_Factory_Vault_Lambda_Bool_Exp>>;
  _not?: InputMaybe<Vault_Factory_Vault_Lambda_Bool_Exp>;
  _or?: InputMaybe<Array<Vault_Factory_Vault_Lambda_Bool_Exp>>;
  contract?: InputMaybe<Vault_Factory_Bool_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambda_bytes?: InputMaybe<String_Comparison_Exp>;
  lambda_name?: InputMaybe<String_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Vault_Factory_Vault_Lambda_Max_Fields = {
  __typename?: 'vault_factory_vault_lambda_max_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "vault_factory_vault_lambda" */
export type Vault_Factory_Vault_Lambda_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vault_Factory_Vault_Lambda_Min_Fields = {
  __typename?: 'vault_factory_vault_lambda_min_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "vault_factory_vault_lambda" */
export type Vault_Factory_Vault_Lambda_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "vault_factory_vault_lambda". */
export type Vault_Factory_Vault_Lambda_Order_By = {
  contract?: InputMaybe<Vault_Factory_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "vault_factory_vault_lambda" */
export enum Vault_Factory_Vault_Lambda_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaBytes = 'lambda_bytes',
  /** column name */
  LambdaName = 'lambda_name',
  /** column name */
  LastUpdatedAt = 'last_updated_at'
}

/** aggregate stddev on columns */
export type Vault_Factory_Vault_Lambda_Stddev_Fields = {
  __typename?: 'vault_factory_vault_lambda_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "vault_factory_vault_lambda" */
export type Vault_Factory_Vault_Lambda_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vault_Factory_Vault_Lambda_Stddev_Pop_Fields = {
  __typename?: 'vault_factory_vault_lambda_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "vault_factory_vault_lambda" */
export type Vault_Factory_Vault_Lambda_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vault_Factory_Vault_Lambda_Stddev_Samp_Fields = {
  __typename?: 'vault_factory_vault_lambda_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "vault_factory_vault_lambda" */
export type Vault_Factory_Vault_Lambda_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "vault_factory_vault_lambda" */
export type Vault_Factory_Vault_Lambda_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vault_Factory_Vault_Lambda_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vault_Factory_Vault_Lambda_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lambda_bytes?: InputMaybe<Scalars['String']['input']>;
  lambda_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Vault_Factory_Vault_Lambda_Sum_Fields = {
  __typename?: 'vault_factory_vault_lambda_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "vault_factory_vault_lambda" */
export type Vault_Factory_Vault_Lambda_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Vault_Factory_Vault_Lambda_Var_Pop_Fields = {
  __typename?: 'vault_factory_vault_lambda_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "vault_factory_vault_lambda" */
export type Vault_Factory_Vault_Lambda_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vault_Factory_Vault_Lambda_Var_Samp_Fields = {
  __typename?: 'vault_factory_vault_lambda_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "vault_factory_vault_lambda" */
export type Vault_Factory_Vault_Lambda_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Vault_Factory_Vault_Lambda_Variance_Fields = {
  __typename?: 'vault_factory_vault_lambda_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "vault_factory_vault_lambda" */
export type Vault_Factory_Vault_Lambda_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "vault_factory_whitelist_contract" */
export type Vault_Factory_Whitelist_Contract = {
  __typename?: 'vault_factory_whitelist_contract';
  /** An object relationship */
  contract: Vault_Factory;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "vault_factory_whitelist_contract" */
export type Vault_Factory_Whitelist_Contract_Aggregate = {
  __typename?: 'vault_factory_whitelist_contract_aggregate';
  aggregate?: Maybe<Vault_Factory_Whitelist_Contract_Aggregate_Fields>;
  nodes: Array<Vault_Factory_Whitelist_Contract>;
};

export type Vault_Factory_Whitelist_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Vault_Factory_Whitelist_Contract_Aggregate_Bool_Exp_Count>;
};

export type Vault_Factory_Whitelist_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vault_Factory_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vault_Factory_Whitelist_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vault_factory_whitelist_contract" */
export type Vault_Factory_Whitelist_Contract_Aggregate_Fields = {
  __typename?: 'vault_factory_whitelist_contract_aggregate_fields';
  avg?: Maybe<Vault_Factory_Whitelist_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vault_Factory_Whitelist_Contract_Max_Fields>;
  min?: Maybe<Vault_Factory_Whitelist_Contract_Min_Fields>;
  stddev?: Maybe<Vault_Factory_Whitelist_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Vault_Factory_Whitelist_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vault_Factory_Whitelist_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Vault_Factory_Whitelist_Contract_Sum_Fields>;
  var_pop?: Maybe<Vault_Factory_Whitelist_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Vault_Factory_Whitelist_Contract_Var_Samp_Fields>;
  variance?: Maybe<Vault_Factory_Whitelist_Contract_Variance_Fields>;
};


/** aggregate fields of "vault_factory_whitelist_contract" */
export type Vault_Factory_Whitelist_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vault_Factory_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vault_factory_whitelist_contract" */
export type Vault_Factory_Whitelist_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Vault_Factory_Whitelist_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vault_Factory_Whitelist_Contract_Max_Order_By>;
  min?: InputMaybe<Vault_Factory_Whitelist_Contract_Min_Order_By>;
  stddev?: InputMaybe<Vault_Factory_Whitelist_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Vault_Factory_Whitelist_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Vault_Factory_Whitelist_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Vault_Factory_Whitelist_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Vault_Factory_Whitelist_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Vault_Factory_Whitelist_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Vault_Factory_Whitelist_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Vault_Factory_Whitelist_Contract_Avg_Fields = {
  __typename?: 'vault_factory_whitelist_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "vault_factory_whitelist_contract" */
export type Vault_Factory_Whitelist_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vault_factory_whitelist_contract". All fields are combined with a logical 'AND'. */
export type Vault_Factory_Whitelist_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Vault_Factory_Whitelist_Contract_Bool_Exp>>;
  _not?: InputMaybe<Vault_Factory_Whitelist_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Vault_Factory_Whitelist_Contract_Bool_Exp>>;
  contract?: InputMaybe<Vault_Factory_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Vault_Factory_Whitelist_Contract_Max_Fields = {
  __typename?: 'vault_factory_whitelist_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "vault_factory_whitelist_contract" */
export type Vault_Factory_Whitelist_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vault_Factory_Whitelist_Contract_Min_Fields = {
  __typename?: 'vault_factory_whitelist_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "vault_factory_whitelist_contract" */
export type Vault_Factory_Whitelist_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "vault_factory_whitelist_contract". */
export type Vault_Factory_Whitelist_Contract_Order_By = {
  contract?: InputMaybe<Vault_Factory_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "vault_factory_whitelist_contract" */
export enum Vault_Factory_Whitelist_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Vault_Factory_Whitelist_Contract_Stddev_Fields = {
  __typename?: 'vault_factory_whitelist_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "vault_factory_whitelist_contract" */
export type Vault_Factory_Whitelist_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vault_Factory_Whitelist_Contract_Stddev_Pop_Fields = {
  __typename?: 'vault_factory_whitelist_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "vault_factory_whitelist_contract" */
export type Vault_Factory_Whitelist_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vault_Factory_Whitelist_Contract_Stddev_Samp_Fields = {
  __typename?: 'vault_factory_whitelist_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "vault_factory_whitelist_contract" */
export type Vault_Factory_Whitelist_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "vault_factory_whitelist_contract" */
export type Vault_Factory_Whitelist_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vault_Factory_Whitelist_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vault_Factory_Whitelist_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Vault_Factory_Whitelist_Contract_Sum_Fields = {
  __typename?: 'vault_factory_whitelist_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "vault_factory_whitelist_contract" */
export type Vault_Factory_Whitelist_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Vault_Factory_Whitelist_Contract_Var_Pop_Fields = {
  __typename?: 'vault_factory_whitelist_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "vault_factory_whitelist_contract" */
export type Vault_Factory_Whitelist_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vault_Factory_Whitelist_Contract_Var_Samp_Fields = {
  __typename?: 'vault_factory_whitelist_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "vault_factory_whitelist_contract" */
export type Vault_Factory_Whitelist_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Vault_Factory_Whitelist_Contract_Variance_Fields = {
  __typename?: 'vault_factory_whitelist_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "vault_factory_whitelist_contract" */
export type Vault_Factory_Whitelist_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "vault_lambda" */
export type Vault_Lambda = {
  __typename?: 'vault_lambda';
  /** An object relationship */
  contract: Vault;
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lambda_bytes: Scalars['String']['output'];
  lambda_name: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "vault_lambda" */
export type Vault_Lambda_Aggregate = {
  __typename?: 'vault_lambda_aggregate';
  aggregate?: Maybe<Vault_Lambda_Aggregate_Fields>;
  nodes: Array<Vault_Lambda>;
};

export type Vault_Lambda_Aggregate_Bool_Exp = {
  count?: InputMaybe<Vault_Lambda_Aggregate_Bool_Exp_Count>;
};

export type Vault_Lambda_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vault_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vault_Lambda_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vault_lambda" */
export type Vault_Lambda_Aggregate_Fields = {
  __typename?: 'vault_lambda_aggregate_fields';
  avg?: Maybe<Vault_Lambda_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vault_Lambda_Max_Fields>;
  min?: Maybe<Vault_Lambda_Min_Fields>;
  stddev?: Maybe<Vault_Lambda_Stddev_Fields>;
  stddev_pop?: Maybe<Vault_Lambda_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vault_Lambda_Stddev_Samp_Fields>;
  sum?: Maybe<Vault_Lambda_Sum_Fields>;
  var_pop?: Maybe<Vault_Lambda_Var_Pop_Fields>;
  var_samp?: Maybe<Vault_Lambda_Var_Samp_Fields>;
  variance?: Maybe<Vault_Lambda_Variance_Fields>;
};


/** aggregate fields of "vault_lambda" */
export type Vault_Lambda_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vault_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vault_lambda" */
export type Vault_Lambda_Aggregate_Order_By = {
  avg?: InputMaybe<Vault_Lambda_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vault_Lambda_Max_Order_By>;
  min?: InputMaybe<Vault_Lambda_Min_Order_By>;
  stddev?: InputMaybe<Vault_Lambda_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Vault_Lambda_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Vault_Lambda_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Vault_Lambda_Sum_Order_By>;
  var_pop?: InputMaybe<Vault_Lambda_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Vault_Lambda_Var_Samp_Order_By>;
  variance?: InputMaybe<Vault_Lambda_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Vault_Lambda_Avg_Fields = {
  __typename?: 'vault_lambda_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "vault_lambda" */
export type Vault_Lambda_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vault_lambda". All fields are combined with a logical 'AND'. */
export type Vault_Lambda_Bool_Exp = {
  _and?: InputMaybe<Array<Vault_Lambda_Bool_Exp>>;
  _not?: InputMaybe<Vault_Lambda_Bool_Exp>;
  _or?: InputMaybe<Array<Vault_Lambda_Bool_Exp>>;
  contract?: InputMaybe<Vault_Bool_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambda_bytes?: InputMaybe<String_Comparison_Exp>;
  lambda_name?: InputMaybe<String_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Vault_Lambda_Max_Fields = {
  __typename?: 'vault_lambda_max_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "vault_lambda" */
export type Vault_Lambda_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vault_Lambda_Min_Fields = {
  __typename?: 'vault_lambda_min_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "vault_lambda" */
export type Vault_Lambda_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "vault_lambda". */
export type Vault_Lambda_Order_By = {
  contract?: InputMaybe<Vault_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "vault_lambda" */
export enum Vault_Lambda_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaBytes = 'lambda_bytes',
  /** column name */
  LambdaName = 'lambda_name',
  /** column name */
  LastUpdatedAt = 'last_updated_at'
}

/** aggregate stddev on columns */
export type Vault_Lambda_Stddev_Fields = {
  __typename?: 'vault_lambda_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "vault_lambda" */
export type Vault_Lambda_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vault_Lambda_Stddev_Pop_Fields = {
  __typename?: 'vault_lambda_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "vault_lambda" */
export type Vault_Lambda_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vault_Lambda_Stddev_Samp_Fields = {
  __typename?: 'vault_lambda_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "vault_lambda" */
export type Vault_Lambda_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "vault_lambda" */
export type Vault_Lambda_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vault_Lambda_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vault_Lambda_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lambda_bytes?: InputMaybe<Scalars['String']['input']>;
  lambda_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Vault_Lambda_Sum_Fields = {
  __typename?: 'vault_lambda_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "vault_lambda" */
export type Vault_Lambda_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Vault_Lambda_Var_Pop_Fields = {
  __typename?: 'vault_lambda_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "vault_lambda" */
export type Vault_Lambda_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vault_Lambda_Var_Samp_Fields = {
  __typename?: 'vault_lambda_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "vault_lambda" */
export type Vault_Lambda_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Vault_Lambda_Variance_Fields = {
  __typename?: 'vault_lambda_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "vault_lambda" */
export type Vault_Lambda_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Vault_Max_Fields = {
  __typename?: 'vault_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  /** ANY: 0\nWHITELIST: 1 */
  allowance?: Maybe<Scalars['smallint']['output']>;
  baker_id?: Maybe<Scalars['bigint']['output']>;
  creation_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  factory_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "vault" */
export type Vault_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  /** ANY: 0\nWHITELIST: 1 */
  allowance?: InputMaybe<Order_By>;
  baker_id?: InputMaybe<Order_By>;
  creation_timestamp?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vault_Min_Fields = {
  __typename?: 'vault_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  /** ANY: 0\nWHITELIST: 1 */
  allowance?: Maybe<Scalars['smallint']['output']>;
  baker_id?: Maybe<Scalars['bigint']['output']>;
  creation_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  factory_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "vault" */
export type Vault_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  /** ANY: 0\nWHITELIST: 1 */
  allowance?: InputMaybe<Order_By>;
  baker_id?: InputMaybe<Order_By>;
  creation_timestamp?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "vault". */
export type Vault_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  allowance?: InputMaybe<Order_By>;
  baker?: InputMaybe<Maven_User_Order_By>;
  baker_id?: InputMaybe<Order_By>;
  creation_timestamp?: InputMaybe<Order_By>;
  depositors_aggregate?: InputMaybe<Vault_Depositor_Aggregate_Order_By>;
  factory?: InputMaybe<Vault_Factory_Order_By>;
  factory_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambdas_aggregate?: InputMaybe<Vault_Lambda_Aggregate_Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  lending_controller_vaults_aggregate?: InputMaybe<Lending_Controller_Vault_Aggregate_Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
};

/** select columns of table "vault" */
export enum Vault_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Admin = 'admin',
  /** column name */
  Allowance = 'allowance',
  /** column name */
  BakerId = 'baker_id',
  /** column name */
  CreationTimestamp = 'creation_timestamp',
  /** column name */
  FactoryId = 'factory_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Network = 'network'
}

/** aggregate stddev on columns */
export type Vault_Stddev_Fields = {
  __typename?: 'vault_stddev_fields';
  /** ANY: 0\nWHITELIST: 1 */
  allowance?: Maybe<Scalars['Float']['output']>;
  baker_id?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "vault" */
export type Vault_Stddev_Order_By = {
  /** ANY: 0\nWHITELIST: 1 */
  allowance?: InputMaybe<Order_By>;
  baker_id?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vault_Stddev_Pop_Fields = {
  __typename?: 'vault_stddev_pop_fields';
  /** ANY: 0\nWHITELIST: 1 */
  allowance?: Maybe<Scalars['Float']['output']>;
  baker_id?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "vault" */
export type Vault_Stddev_Pop_Order_By = {
  /** ANY: 0\nWHITELIST: 1 */
  allowance?: InputMaybe<Order_By>;
  baker_id?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vault_Stddev_Samp_Fields = {
  __typename?: 'vault_stddev_samp_fields';
  /** ANY: 0\nWHITELIST: 1 */
  allowance?: Maybe<Scalars['Float']['output']>;
  baker_id?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "vault" */
export type Vault_Stddev_Samp_Order_By = {
  /** ANY: 0\nWHITELIST: 1 */
  allowance?: InputMaybe<Order_By>;
  baker_id?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "vault" */
export type Vault_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vault_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vault_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['String']['input']>;
  /** ANY: 0\nWHITELIST: 1 */
  allowance?: InputMaybe<Scalars['smallint']['input']>;
  baker_id?: InputMaybe<Scalars['bigint']['input']>;
  creation_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  factory_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Vault_Sum_Fields = {
  __typename?: 'vault_sum_fields';
  /** ANY: 0\nWHITELIST: 1 */
  allowance?: Maybe<Scalars['smallint']['output']>;
  baker_id?: Maybe<Scalars['bigint']['output']>;
  factory_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "vault" */
export type Vault_Sum_Order_By = {
  /** ANY: 0\nWHITELIST: 1 */
  allowance?: InputMaybe<Order_By>;
  baker_id?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Vault_Var_Pop_Fields = {
  __typename?: 'vault_var_pop_fields';
  /** ANY: 0\nWHITELIST: 1 */
  allowance?: Maybe<Scalars['Float']['output']>;
  baker_id?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "vault" */
export type Vault_Var_Pop_Order_By = {
  /** ANY: 0\nWHITELIST: 1 */
  allowance?: InputMaybe<Order_By>;
  baker_id?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vault_Var_Samp_Fields = {
  __typename?: 'vault_var_samp_fields';
  /** ANY: 0\nWHITELIST: 1 */
  allowance?: Maybe<Scalars['Float']['output']>;
  baker_id?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "vault" */
export type Vault_Var_Samp_Order_By = {
  /** ANY: 0\nWHITELIST: 1 */
  allowance?: InputMaybe<Order_By>;
  baker_id?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Vault_Variance_Fields = {
  __typename?: 'vault_variance_fields';
  /** ANY: 0\nWHITELIST: 1 */
  allowance?: Maybe<Scalars['Float']['output']>;
  baker_id?: Maybe<Scalars['Float']['output']>;
  factory_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "vault" */
export type Vault_Variance_Order_By = {
  /** ANY: 0\nWHITELIST: 1 */
  allowance?: InputMaybe<Order_By>;
  baker_id?: InputMaybe<Order_By>;
  factory_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "vesting" */
export type Vesting = {
  __typename?: 'vesting';
  address: Scalars['String']['output'];
  admin: Scalars['String']['output'];
  /** An array relationship */
  general_contracts: Array<Vesting_General_Contract>;
  /** An aggregate relationship */
  general_contracts_aggregate: Vesting_General_Contract_Aggregate;
  /** An object relationship */
  governance: Governance;
  governance_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An array relationship */
  lambdas: Array<Vesting_Lambda>;
  /** An aggregate relationship */
  lambdas_aggregate: Vesting_Lambda_Aggregate;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  network: Scalars['String']['output'];
  total_vested_amount: Scalars['bigint']['output'];
  /** An array relationship */
  vestees: Array<Vesting_Vestee>;
  /** An aggregate relationship */
  vestees_aggregate: Vesting_Vestee_Aggregate;
  /** An array relationship */
  whitelist_contracts: Array<Vesting_Whitelist_Contract>;
  /** An aggregate relationship */
  whitelist_contracts_aggregate: Vesting_Whitelist_Contract_Aggregate;
};


/** columns and relationships of "vesting" */
export type VestingGeneral_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Vesting_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_General_Contract_Order_By>>;
  where?: InputMaybe<Vesting_General_Contract_Bool_Exp>;
};


/** columns and relationships of "vesting" */
export type VestingGeneral_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vesting_General_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_General_Contract_Order_By>>;
  where?: InputMaybe<Vesting_General_Contract_Bool_Exp>;
};


/** columns and relationships of "vesting" */
export type VestingLambdasArgs = {
  distinct_on?: InputMaybe<Array<Vesting_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_Lambda_Order_By>>;
  where?: InputMaybe<Vesting_Lambda_Bool_Exp>;
};


/** columns and relationships of "vesting" */
export type VestingLambdas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vesting_Lambda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_Lambda_Order_By>>;
  where?: InputMaybe<Vesting_Lambda_Bool_Exp>;
};


/** columns and relationships of "vesting" */
export type VestingMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "vesting" */
export type VestingVesteesArgs = {
  distinct_on?: InputMaybe<Array<Vesting_Vestee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_Vestee_Order_By>>;
  where?: InputMaybe<Vesting_Vestee_Bool_Exp>;
};


/** columns and relationships of "vesting" */
export type VestingVestees_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vesting_Vestee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_Vestee_Order_By>>;
  where?: InputMaybe<Vesting_Vestee_Bool_Exp>;
};


/** columns and relationships of "vesting" */
export type VestingWhitelist_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Vesting_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Vesting_Whitelist_Contract_Bool_Exp>;
};


/** columns and relationships of "vesting" */
export type VestingWhitelist_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vesting_Whitelist_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vesting_Whitelist_Contract_Order_By>>;
  where?: InputMaybe<Vesting_Whitelist_Contract_Bool_Exp>;
};

/** aggregated selection of "vesting" */
export type Vesting_Aggregate = {
  __typename?: 'vesting_aggregate';
  aggregate?: Maybe<Vesting_Aggregate_Fields>;
  nodes: Array<Vesting>;
};

export type Vesting_Aggregate_Bool_Exp = {
  count?: InputMaybe<Vesting_Aggregate_Bool_Exp_Count>;
};

export type Vesting_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vesting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vesting_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vesting" */
export type Vesting_Aggregate_Fields = {
  __typename?: 'vesting_aggregate_fields';
  avg?: Maybe<Vesting_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vesting_Max_Fields>;
  min?: Maybe<Vesting_Min_Fields>;
  stddev?: Maybe<Vesting_Stddev_Fields>;
  stddev_pop?: Maybe<Vesting_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vesting_Stddev_Samp_Fields>;
  sum?: Maybe<Vesting_Sum_Fields>;
  var_pop?: Maybe<Vesting_Var_Pop_Fields>;
  var_samp?: Maybe<Vesting_Var_Samp_Fields>;
  variance?: Maybe<Vesting_Variance_Fields>;
};


/** aggregate fields of "vesting" */
export type Vesting_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vesting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vesting" */
export type Vesting_Aggregate_Order_By = {
  avg?: InputMaybe<Vesting_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vesting_Max_Order_By>;
  min?: InputMaybe<Vesting_Min_Order_By>;
  stddev?: InputMaybe<Vesting_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Vesting_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Vesting_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Vesting_Sum_Order_By>;
  var_pop?: InputMaybe<Vesting_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Vesting_Var_Samp_Order_By>;
  variance?: InputMaybe<Vesting_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Vesting_Avg_Fields = {
  __typename?: 'vesting_avg_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  total_vested_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "vesting" */
export type Vesting_Avg_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  total_vested_amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vesting". All fields are combined with a logical 'AND'. */
export type Vesting_Bool_Exp = {
  _and?: InputMaybe<Array<Vesting_Bool_Exp>>;
  _not?: InputMaybe<Vesting_Bool_Exp>;
  _or?: InputMaybe<Array<Vesting_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  admin?: InputMaybe<String_Comparison_Exp>;
  general_contracts?: InputMaybe<Vesting_General_Contract_Bool_Exp>;
  general_contracts_aggregate?: InputMaybe<Vesting_General_Contract_Aggregate_Bool_Exp>;
  governance?: InputMaybe<Governance_Bool_Exp>;
  governance_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambdas?: InputMaybe<Vesting_Lambda_Bool_Exp>;
  lambdas_aggregate?: InputMaybe<Vesting_Lambda_Aggregate_Bool_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
  total_vested_amount?: InputMaybe<Bigint_Comparison_Exp>;
  vestees?: InputMaybe<Vesting_Vestee_Bool_Exp>;
  vestees_aggregate?: InputMaybe<Vesting_Vestee_Aggregate_Bool_Exp>;
  whitelist_contracts?: InputMaybe<Vesting_Whitelist_Contract_Bool_Exp>;
  whitelist_contracts_aggregate?: InputMaybe<Vesting_Whitelist_Contract_Aggregate_Bool_Exp>;
};

/** columns and relationships of "vesting_general_contract" */
export type Vesting_General_Contract = {
  __typename?: 'vesting_general_contract';
  /** An object relationship */
  contract: Vesting;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  contract_name: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "vesting_general_contract" */
export type Vesting_General_Contract_Aggregate = {
  __typename?: 'vesting_general_contract_aggregate';
  aggregate?: Maybe<Vesting_General_Contract_Aggregate_Fields>;
  nodes: Array<Vesting_General_Contract>;
};

export type Vesting_General_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Vesting_General_Contract_Aggregate_Bool_Exp_Count>;
};

export type Vesting_General_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vesting_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vesting_General_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vesting_general_contract" */
export type Vesting_General_Contract_Aggregate_Fields = {
  __typename?: 'vesting_general_contract_aggregate_fields';
  avg?: Maybe<Vesting_General_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vesting_General_Contract_Max_Fields>;
  min?: Maybe<Vesting_General_Contract_Min_Fields>;
  stddev?: Maybe<Vesting_General_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Vesting_General_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vesting_General_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Vesting_General_Contract_Sum_Fields>;
  var_pop?: Maybe<Vesting_General_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Vesting_General_Contract_Var_Samp_Fields>;
  variance?: Maybe<Vesting_General_Contract_Variance_Fields>;
};


/** aggregate fields of "vesting_general_contract" */
export type Vesting_General_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vesting_General_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vesting_general_contract" */
export type Vesting_General_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Vesting_General_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vesting_General_Contract_Max_Order_By>;
  min?: InputMaybe<Vesting_General_Contract_Min_Order_By>;
  stddev?: InputMaybe<Vesting_General_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Vesting_General_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Vesting_General_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Vesting_General_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Vesting_General_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Vesting_General_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Vesting_General_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Vesting_General_Contract_Avg_Fields = {
  __typename?: 'vesting_general_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "vesting_general_contract" */
export type Vesting_General_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vesting_general_contract". All fields are combined with a logical 'AND'. */
export type Vesting_General_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Vesting_General_Contract_Bool_Exp>>;
  _not?: InputMaybe<Vesting_General_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Vesting_General_Contract_Bool_Exp>>;
  contract?: InputMaybe<Vesting_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  contract_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Vesting_General_Contract_Max_Fields = {
  __typename?: 'vesting_general_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "vesting_general_contract" */
export type Vesting_General_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vesting_General_Contract_Min_Fields = {
  __typename?: 'vesting_general_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "vesting_general_contract" */
export type Vesting_General_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "vesting_general_contract". */
export type Vesting_General_Contract_Order_By = {
  contract?: InputMaybe<Vesting_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  contract_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "vesting_general_contract" */
export enum Vesting_General_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  ContractName = 'contract_name',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Vesting_General_Contract_Stddev_Fields = {
  __typename?: 'vesting_general_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "vesting_general_contract" */
export type Vesting_General_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vesting_General_Contract_Stddev_Pop_Fields = {
  __typename?: 'vesting_general_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "vesting_general_contract" */
export type Vesting_General_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vesting_General_Contract_Stddev_Samp_Fields = {
  __typename?: 'vesting_general_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "vesting_general_contract" */
export type Vesting_General_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "vesting_general_contract" */
export type Vesting_General_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vesting_General_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vesting_General_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  contract_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Vesting_General_Contract_Sum_Fields = {
  __typename?: 'vesting_general_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "vesting_general_contract" */
export type Vesting_General_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Vesting_General_Contract_Var_Pop_Fields = {
  __typename?: 'vesting_general_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "vesting_general_contract" */
export type Vesting_General_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vesting_General_Contract_Var_Samp_Fields = {
  __typename?: 'vesting_general_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "vesting_general_contract" */
export type Vesting_General_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Vesting_General_Contract_Variance_Fields = {
  __typename?: 'vesting_general_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "vesting_general_contract" */
export type Vesting_General_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "vesting_lambda" */
export type Vesting_Lambda = {
  __typename?: 'vesting_lambda';
  /** An object relationship */
  contract: Vesting;
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lambda_bytes: Scalars['String']['output'];
  lambda_name: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "vesting_lambda" */
export type Vesting_Lambda_Aggregate = {
  __typename?: 'vesting_lambda_aggregate';
  aggregate?: Maybe<Vesting_Lambda_Aggregate_Fields>;
  nodes: Array<Vesting_Lambda>;
};

export type Vesting_Lambda_Aggregate_Bool_Exp = {
  count?: InputMaybe<Vesting_Lambda_Aggregate_Bool_Exp_Count>;
};

export type Vesting_Lambda_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vesting_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vesting_Lambda_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vesting_lambda" */
export type Vesting_Lambda_Aggregate_Fields = {
  __typename?: 'vesting_lambda_aggregate_fields';
  avg?: Maybe<Vesting_Lambda_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vesting_Lambda_Max_Fields>;
  min?: Maybe<Vesting_Lambda_Min_Fields>;
  stddev?: Maybe<Vesting_Lambda_Stddev_Fields>;
  stddev_pop?: Maybe<Vesting_Lambda_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vesting_Lambda_Stddev_Samp_Fields>;
  sum?: Maybe<Vesting_Lambda_Sum_Fields>;
  var_pop?: Maybe<Vesting_Lambda_Var_Pop_Fields>;
  var_samp?: Maybe<Vesting_Lambda_Var_Samp_Fields>;
  variance?: Maybe<Vesting_Lambda_Variance_Fields>;
};


/** aggregate fields of "vesting_lambda" */
export type Vesting_Lambda_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vesting_Lambda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vesting_lambda" */
export type Vesting_Lambda_Aggregate_Order_By = {
  avg?: InputMaybe<Vesting_Lambda_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vesting_Lambda_Max_Order_By>;
  min?: InputMaybe<Vesting_Lambda_Min_Order_By>;
  stddev?: InputMaybe<Vesting_Lambda_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Vesting_Lambda_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Vesting_Lambda_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Vesting_Lambda_Sum_Order_By>;
  var_pop?: InputMaybe<Vesting_Lambda_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Vesting_Lambda_Var_Samp_Order_By>;
  variance?: InputMaybe<Vesting_Lambda_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Vesting_Lambda_Avg_Fields = {
  __typename?: 'vesting_lambda_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "vesting_lambda" */
export type Vesting_Lambda_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vesting_lambda". All fields are combined with a logical 'AND'. */
export type Vesting_Lambda_Bool_Exp = {
  _and?: InputMaybe<Array<Vesting_Lambda_Bool_Exp>>;
  _not?: InputMaybe<Vesting_Lambda_Bool_Exp>;
  _or?: InputMaybe<Array<Vesting_Lambda_Bool_Exp>>;
  contract?: InputMaybe<Vesting_Bool_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lambda_bytes?: InputMaybe<String_Comparison_Exp>;
  lambda_name?: InputMaybe<String_Comparison_Exp>;
  last_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Vesting_Lambda_Max_Fields = {
  __typename?: 'vesting_lambda_max_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "vesting_lambda" */
export type Vesting_Lambda_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vesting_Lambda_Min_Fields = {
  __typename?: 'vesting_lambda_min_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lambda_bytes?: Maybe<Scalars['String']['output']>;
  lambda_name?: Maybe<Scalars['String']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "vesting_lambda" */
export type Vesting_Lambda_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "vesting_lambda". */
export type Vesting_Lambda_Order_By = {
  contract?: InputMaybe<Vesting_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_bytes?: InputMaybe<Order_By>;
  lambda_name?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "vesting_lambda" */
export enum Vesting_Lambda_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaBytes = 'lambda_bytes',
  /** column name */
  LambdaName = 'lambda_name',
  /** column name */
  LastUpdatedAt = 'last_updated_at'
}

/** aggregate stddev on columns */
export type Vesting_Lambda_Stddev_Fields = {
  __typename?: 'vesting_lambda_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "vesting_lambda" */
export type Vesting_Lambda_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vesting_Lambda_Stddev_Pop_Fields = {
  __typename?: 'vesting_lambda_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "vesting_lambda" */
export type Vesting_Lambda_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vesting_Lambda_Stddev_Samp_Fields = {
  __typename?: 'vesting_lambda_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "vesting_lambda" */
export type Vesting_Lambda_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "vesting_lambda" */
export type Vesting_Lambda_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vesting_Lambda_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vesting_Lambda_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lambda_bytes?: InputMaybe<Scalars['String']['input']>;
  lambda_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Vesting_Lambda_Sum_Fields = {
  __typename?: 'vesting_lambda_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "vesting_lambda" */
export type Vesting_Lambda_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Vesting_Lambda_Var_Pop_Fields = {
  __typename?: 'vesting_lambda_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "vesting_lambda" */
export type Vesting_Lambda_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vesting_Lambda_Var_Samp_Fields = {
  __typename?: 'vesting_lambda_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "vesting_lambda" */
export type Vesting_Lambda_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Vesting_Lambda_Variance_Fields = {
  __typename?: 'vesting_lambda_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "vesting_lambda" */
export type Vesting_Lambda_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Vesting_Max_Fields = {
  __typename?: 'vesting_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  total_vested_amount?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "vesting" */
export type Vesting_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  total_vested_amount?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vesting_Min_Fields = {
  __typename?: 'vesting_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  total_vested_amount?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "vesting" */
export type Vesting_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  total_vested_amount?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "vesting". */
export type Vesting_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  general_contracts_aggregate?: InputMaybe<Vesting_General_Contract_Aggregate_Order_By>;
  governance?: InputMaybe<Governance_Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambdas_aggregate?: InputMaybe<Vesting_Lambda_Aggregate_Order_By>;
  last_updated_at?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  total_vested_amount?: InputMaybe<Order_By>;
  vestees_aggregate?: InputMaybe<Vesting_Vestee_Aggregate_Order_By>;
  whitelist_contracts_aggregate?: InputMaybe<Vesting_Whitelist_Contract_Aggregate_Order_By>;
};

/** select columns of table "vesting" */
export enum Vesting_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Admin = 'admin',
  /** column name */
  GovernanceId = 'governance_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Network = 'network',
  /** column name */
  TotalVestedAmount = 'total_vested_amount'
}

/** aggregate stddev on columns */
export type Vesting_Stddev_Fields = {
  __typename?: 'vesting_stddev_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  total_vested_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "vesting" */
export type Vesting_Stddev_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  total_vested_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vesting_Stddev_Pop_Fields = {
  __typename?: 'vesting_stddev_pop_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  total_vested_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "vesting" */
export type Vesting_Stddev_Pop_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  total_vested_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vesting_Stddev_Samp_Fields = {
  __typename?: 'vesting_stddev_samp_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  total_vested_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "vesting" */
export type Vesting_Stddev_Samp_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  total_vested_amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "vesting" */
export type Vesting_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vesting_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vesting_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['String']['input']>;
  governance_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  total_vested_amount?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Vesting_Sum_Fields = {
  __typename?: 'vesting_sum_fields';
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  total_vested_amount?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "vesting" */
export type Vesting_Sum_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  total_vested_amount?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Vesting_Var_Pop_Fields = {
  __typename?: 'vesting_var_pop_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  total_vested_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "vesting" */
export type Vesting_Var_Pop_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  total_vested_amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vesting_Var_Samp_Fields = {
  __typename?: 'vesting_var_samp_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  total_vested_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "vesting" */
export type Vesting_Var_Samp_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  total_vested_amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Vesting_Variance_Fields = {
  __typename?: 'vesting_variance_fields';
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  total_vested_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "vesting" */
export type Vesting_Variance_Order_By = {
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  total_vested_amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "vesting_vestee" */
export type Vesting_Vestee = {
  __typename?: 'vesting_vestee';
  claim_amount_per_month: Scalars['float8']['output'];
  cliff_months: Scalars['smallint']['output'];
  end_cliff_timestamp: Scalars['timestamptz']['output'];
  end_vesting_timestamp: Scalars['timestamptz']['output'];
  id: Scalars['bigint']['output'];
  last_claimed_timestamp: Scalars['timestamptz']['output'];
  locked: Scalars['Boolean']['output'];
  months_claimed: Scalars['smallint']['output'];
  months_remaining: Scalars['smallint']['output'];
  next_redemption_timestamp: Scalars['timestamptz']['output'];
  start_timestamp: Scalars['timestamptz']['output'];
  total_allocated_amount: Scalars['float8']['output'];
  total_claimed: Scalars['float8']['output'];
  total_remainder: Scalars['float8']['output'];
  /** An object relationship */
  vestee: Maven_User;
  vestee_id: Scalars['bigint']['output'];
  /** An object relationship */
  vesting: Vesting;
  vesting_id: Scalars['bigint']['output'];
  vesting_months: Scalars['smallint']['output'];
};

/** aggregated selection of "vesting_vestee" */
export type Vesting_Vestee_Aggregate = {
  __typename?: 'vesting_vestee_aggregate';
  aggregate?: Maybe<Vesting_Vestee_Aggregate_Fields>;
  nodes: Array<Vesting_Vestee>;
};

export type Vesting_Vestee_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Vesting_Vestee_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Vesting_Vestee_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Vesting_Vestee_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Vesting_Vestee_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Vesting_Vestee_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Vesting_Vestee_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Vesting_Vestee_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Vesting_Vestee_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Vesting_Vestee_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Vesting_Vestee_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Vesting_Vestee_Aggregate_Bool_Exp_Var_Samp>;
};

export type Vesting_Vestee_Aggregate_Bool_Exp_Avg = {
  arguments: Vesting_Vestee_Select_Column_Vesting_Vestee_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vesting_Vestee_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Vesting_Vestee_Aggregate_Bool_Exp_Bool_And = {
  arguments: Vesting_Vestee_Select_Column_Vesting_Vestee_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vesting_Vestee_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vesting_Vestee_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Vesting_Vestee_Select_Column_Vesting_Vestee_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vesting_Vestee_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vesting_Vestee_Aggregate_Bool_Exp_Corr = {
  arguments: Vesting_Vestee_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vesting_Vestee_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Vesting_Vestee_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Vesting_Vestee_Select_Column_Vesting_Vestee_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Vesting_Vestee_Select_Column_Vesting_Vestee_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Vesting_Vestee_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vesting_Vestee_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vesting_Vestee_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Vesting_Vestee_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Vesting_Vestee_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vesting_Vestee_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Vesting_Vestee_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Vesting_Vestee_Select_Column_Vesting_Vestee_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Vesting_Vestee_Select_Column_Vesting_Vestee_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Vesting_Vestee_Aggregate_Bool_Exp_Max = {
  arguments: Vesting_Vestee_Select_Column_Vesting_Vestee_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vesting_Vestee_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Vesting_Vestee_Aggregate_Bool_Exp_Min = {
  arguments: Vesting_Vestee_Select_Column_Vesting_Vestee_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vesting_Vestee_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Vesting_Vestee_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Vesting_Vestee_Select_Column_Vesting_Vestee_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vesting_Vestee_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Vesting_Vestee_Aggregate_Bool_Exp_Sum = {
  arguments: Vesting_Vestee_Select_Column_Vesting_Vestee_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vesting_Vestee_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Vesting_Vestee_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Vesting_Vestee_Select_Column_Vesting_Vestee_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vesting_Vestee_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "vesting_vestee" */
export type Vesting_Vestee_Aggregate_Fields = {
  __typename?: 'vesting_vestee_aggregate_fields';
  avg?: Maybe<Vesting_Vestee_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vesting_Vestee_Max_Fields>;
  min?: Maybe<Vesting_Vestee_Min_Fields>;
  stddev?: Maybe<Vesting_Vestee_Stddev_Fields>;
  stddev_pop?: Maybe<Vesting_Vestee_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vesting_Vestee_Stddev_Samp_Fields>;
  sum?: Maybe<Vesting_Vestee_Sum_Fields>;
  var_pop?: Maybe<Vesting_Vestee_Var_Pop_Fields>;
  var_samp?: Maybe<Vesting_Vestee_Var_Samp_Fields>;
  variance?: Maybe<Vesting_Vestee_Variance_Fields>;
};


/** aggregate fields of "vesting_vestee" */
export type Vesting_Vestee_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vesting_Vestee_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vesting_vestee" */
export type Vesting_Vestee_Aggregate_Order_By = {
  avg?: InputMaybe<Vesting_Vestee_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vesting_Vestee_Max_Order_By>;
  min?: InputMaybe<Vesting_Vestee_Min_Order_By>;
  stddev?: InputMaybe<Vesting_Vestee_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Vesting_Vestee_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Vesting_Vestee_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Vesting_Vestee_Sum_Order_By>;
  var_pop?: InputMaybe<Vesting_Vestee_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Vesting_Vestee_Var_Samp_Order_By>;
  variance?: InputMaybe<Vesting_Vestee_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Vesting_Vestee_Avg_Fields = {
  __typename?: 'vesting_vestee_avg_fields';
  claim_amount_per_month?: Maybe<Scalars['Float']['output']>;
  cliff_months?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  months_claimed?: Maybe<Scalars['Float']['output']>;
  months_remaining?: Maybe<Scalars['Float']['output']>;
  total_allocated_amount?: Maybe<Scalars['Float']['output']>;
  total_claimed?: Maybe<Scalars['Float']['output']>;
  total_remainder?: Maybe<Scalars['Float']['output']>;
  vestee_id?: Maybe<Scalars['Float']['output']>;
  vesting_id?: Maybe<Scalars['Float']['output']>;
  vesting_months?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "vesting_vestee" */
export type Vesting_Vestee_Avg_Order_By = {
  claim_amount_per_month?: InputMaybe<Order_By>;
  cliff_months?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  months_claimed?: InputMaybe<Order_By>;
  months_remaining?: InputMaybe<Order_By>;
  total_allocated_amount?: InputMaybe<Order_By>;
  total_claimed?: InputMaybe<Order_By>;
  total_remainder?: InputMaybe<Order_By>;
  vestee_id?: InputMaybe<Order_By>;
  vesting_id?: InputMaybe<Order_By>;
  vesting_months?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vesting_vestee". All fields are combined with a logical 'AND'. */
export type Vesting_Vestee_Bool_Exp = {
  _and?: InputMaybe<Array<Vesting_Vestee_Bool_Exp>>;
  _not?: InputMaybe<Vesting_Vestee_Bool_Exp>;
  _or?: InputMaybe<Array<Vesting_Vestee_Bool_Exp>>;
  claim_amount_per_month?: InputMaybe<Float8_Comparison_Exp>;
  cliff_months?: InputMaybe<Smallint_Comparison_Exp>;
  end_cliff_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_vesting_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  last_claimed_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  locked?: InputMaybe<Boolean_Comparison_Exp>;
  months_claimed?: InputMaybe<Smallint_Comparison_Exp>;
  months_remaining?: InputMaybe<Smallint_Comparison_Exp>;
  next_redemption_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  start_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  total_allocated_amount?: InputMaybe<Float8_Comparison_Exp>;
  total_claimed?: InputMaybe<Float8_Comparison_Exp>;
  total_remainder?: InputMaybe<Float8_Comparison_Exp>;
  vestee?: InputMaybe<Maven_User_Bool_Exp>;
  vestee_id?: InputMaybe<Bigint_Comparison_Exp>;
  vesting?: InputMaybe<Vesting_Bool_Exp>;
  vesting_id?: InputMaybe<Bigint_Comparison_Exp>;
  vesting_months?: InputMaybe<Smallint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Vesting_Vestee_Max_Fields = {
  __typename?: 'vesting_vestee_max_fields';
  claim_amount_per_month?: Maybe<Scalars['float8']['output']>;
  cliff_months?: Maybe<Scalars['smallint']['output']>;
  end_cliff_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  end_vesting_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_claimed_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  months_claimed?: Maybe<Scalars['smallint']['output']>;
  months_remaining?: Maybe<Scalars['smallint']['output']>;
  next_redemption_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  start_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  total_allocated_amount?: Maybe<Scalars['float8']['output']>;
  total_claimed?: Maybe<Scalars['float8']['output']>;
  total_remainder?: Maybe<Scalars['float8']['output']>;
  vestee_id?: Maybe<Scalars['bigint']['output']>;
  vesting_id?: Maybe<Scalars['bigint']['output']>;
  vesting_months?: Maybe<Scalars['smallint']['output']>;
};

/** order by max() on columns of table "vesting_vestee" */
export type Vesting_Vestee_Max_Order_By = {
  claim_amount_per_month?: InputMaybe<Order_By>;
  cliff_months?: InputMaybe<Order_By>;
  end_cliff_timestamp?: InputMaybe<Order_By>;
  end_vesting_timestamp?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_claimed_timestamp?: InputMaybe<Order_By>;
  months_claimed?: InputMaybe<Order_By>;
  months_remaining?: InputMaybe<Order_By>;
  next_redemption_timestamp?: InputMaybe<Order_By>;
  start_timestamp?: InputMaybe<Order_By>;
  total_allocated_amount?: InputMaybe<Order_By>;
  total_claimed?: InputMaybe<Order_By>;
  total_remainder?: InputMaybe<Order_By>;
  vestee_id?: InputMaybe<Order_By>;
  vesting_id?: InputMaybe<Order_By>;
  vesting_months?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vesting_Vestee_Min_Fields = {
  __typename?: 'vesting_vestee_min_fields';
  claim_amount_per_month?: Maybe<Scalars['float8']['output']>;
  cliff_months?: Maybe<Scalars['smallint']['output']>;
  end_cliff_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  end_vesting_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_claimed_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  months_claimed?: Maybe<Scalars['smallint']['output']>;
  months_remaining?: Maybe<Scalars['smallint']['output']>;
  next_redemption_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  start_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  total_allocated_amount?: Maybe<Scalars['float8']['output']>;
  total_claimed?: Maybe<Scalars['float8']['output']>;
  total_remainder?: Maybe<Scalars['float8']['output']>;
  vestee_id?: Maybe<Scalars['bigint']['output']>;
  vesting_id?: Maybe<Scalars['bigint']['output']>;
  vesting_months?: Maybe<Scalars['smallint']['output']>;
};

/** order by min() on columns of table "vesting_vestee" */
export type Vesting_Vestee_Min_Order_By = {
  claim_amount_per_month?: InputMaybe<Order_By>;
  cliff_months?: InputMaybe<Order_By>;
  end_cliff_timestamp?: InputMaybe<Order_By>;
  end_vesting_timestamp?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_claimed_timestamp?: InputMaybe<Order_By>;
  months_claimed?: InputMaybe<Order_By>;
  months_remaining?: InputMaybe<Order_By>;
  next_redemption_timestamp?: InputMaybe<Order_By>;
  start_timestamp?: InputMaybe<Order_By>;
  total_allocated_amount?: InputMaybe<Order_By>;
  total_claimed?: InputMaybe<Order_By>;
  total_remainder?: InputMaybe<Order_By>;
  vestee_id?: InputMaybe<Order_By>;
  vesting_id?: InputMaybe<Order_By>;
  vesting_months?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "vesting_vestee". */
export type Vesting_Vestee_Order_By = {
  claim_amount_per_month?: InputMaybe<Order_By>;
  cliff_months?: InputMaybe<Order_By>;
  end_cliff_timestamp?: InputMaybe<Order_By>;
  end_vesting_timestamp?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_claimed_timestamp?: InputMaybe<Order_By>;
  locked?: InputMaybe<Order_By>;
  months_claimed?: InputMaybe<Order_By>;
  months_remaining?: InputMaybe<Order_By>;
  next_redemption_timestamp?: InputMaybe<Order_By>;
  start_timestamp?: InputMaybe<Order_By>;
  total_allocated_amount?: InputMaybe<Order_By>;
  total_claimed?: InputMaybe<Order_By>;
  total_remainder?: InputMaybe<Order_By>;
  vestee?: InputMaybe<Maven_User_Order_By>;
  vestee_id?: InputMaybe<Order_By>;
  vesting?: InputMaybe<Vesting_Order_By>;
  vesting_id?: InputMaybe<Order_By>;
  vesting_months?: InputMaybe<Order_By>;
};

/** select columns of table "vesting_vestee" */
export enum Vesting_Vestee_Select_Column {
  /** column name */
  ClaimAmountPerMonth = 'claim_amount_per_month',
  /** column name */
  CliffMonths = 'cliff_months',
  /** column name */
  EndCliffTimestamp = 'end_cliff_timestamp',
  /** column name */
  EndVestingTimestamp = 'end_vesting_timestamp',
  /** column name */
  Id = 'id',
  /** column name */
  LastClaimedTimestamp = 'last_claimed_timestamp',
  /** column name */
  Locked = 'locked',
  /** column name */
  MonthsClaimed = 'months_claimed',
  /** column name */
  MonthsRemaining = 'months_remaining',
  /** column name */
  NextRedemptionTimestamp = 'next_redemption_timestamp',
  /** column name */
  StartTimestamp = 'start_timestamp',
  /** column name */
  TotalAllocatedAmount = 'total_allocated_amount',
  /** column name */
  TotalClaimed = 'total_claimed',
  /** column name */
  TotalRemainder = 'total_remainder',
  /** column name */
  VesteeId = 'vestee_id',
  /** column name */
  VestingId = 'vesting_id',
  /** column name */
  VestingMonths = 'vesting_months'
}

/** select "vesting_vestee_aggregate_bool_exp_avg_arguments_columns" columns of table "vesting_vestee" */
export enum Vesting_Vestee_Select_Column_Vesting_Vestee_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  ClaimAmountPerMonth = 'claim_amount_per_month',
  /** column name */
  TotalAllocatedAmount = 'total_allocated_amount',
  /** column name */
  TotalClaimed = 'total_claimed',
  /** column name */
  TotalRemainder = 'total_remainder'
}

/** select "vesting_vestee_aggregate_bool_exp_bool_and_arguments_columns" columns of table "vesting_vestee" */
export enum Vesting_Vestee_Select_Column_Vesting_Vestee_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Locked = 'locked'
}

/** select "vesting_vestee_aggregate_bool_exp_bool_or_arguments_columns" columns of table "vesting_vestee" */
export enum Vesting_Vestee_Select_Column_Vesting_Vestee_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Locked = 'locked'
}

/** select "vesting_vestee_aggregate_bool_exp_corr_arguments_columns" columns of table "vesting_vestee" */
export enum Vesting_Vestee_Select_Column_Vesting_Vestee_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  ClaimAmountPerMonth = 'claim_amount_per_month',
  /** column name */
  TotalAllocatedAmount = 'total_allocated_amount',
  /** column name */
  TotalClaimed = 'total_claimed',
  /** column name */
  TotalRemainder = 'total_remainder'
}

/** select "vesting_vestee_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "vesting_vestee" */
export enum Vesting_Vestee_Select_Column_Vesting_Vestee_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  ClaimAmountPerMonth = 'claim_amount_per_month',
  /** column name */
  TotalAllocatedAmount = 'total_allocated_amount',
  /** column name */
  TotalClaimed = 'total_claimed',
  /** column name */
  TotalRemainder = 'total_remainder'
}

/** select "vesting_vestee_aggregate_bool_exp_max_arguments_columns" columns of table "vesting_vestee" */
export enum Vesting_Vestee_Select_Column_Vesting_Vestee_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  ClaimAmountPerMonth = 'claim_amount_per_month',
  /** column name */
  TotalAllocatedAmount = 'total_allocated_amount',
  /** column name */
  TotalClaimed = 'total_claimed',
  /** column name */
  TotalRemainder = 'total_remainder'
}

/** select "vesting_vestee_aggregate_bool_exp_min_arguments_columns" columns of table "vesting_vestee" */
export enum Vesting_Vestee_Select_Column_Vesting_Vestee_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  ClaimAmountPerMonth = 'claim_amount_per_month',
  /** column name */
  TotalAllocatedAmount = 'total_allocated_amount',
  /** column name */
  TotalClaimed = 'total_claimed',
  /** column name */
  TotalRemainder = 'total_remainder'
}

/** select "vesting_vestee_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "vesting_vestee" */
export enum Vesting_Vestee_Select_Column_Vesting_Vestee_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  ClaimAmountPerMonth = 'claim_amount_per_month',
  /** column name */
  TotalAllocatedAmount = 'total_allocated_amount',
  /** column name */
  TotalClaimed = 'total_claimed',
  /** column name */
  TotalRemainder = 'total_remainder'
}

/** select "vesting_vestee_aggregate_bool_exp_sum_arguments_columns" columns of table "vesting_vestee" */
export enum Vesting_Vestee_Select_Column_Vesting_Vestee_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  ClaimAmountPerMonth = 'claim_amount_per_month',
  /** column name */
  TotalAllocatedAmount = 'total_allocated_amount',
  /** column name */
  TotalClaimed = 'total_claimed',
  /** column name */
  TotalRemainder = 'total_remainder'
}

/** select "vesting_vestee_aggregate_bool_exp_var_samp_arguments_columns" columns of table "vesting_vestee" */
export enum Vesting_Vestee_Select_Column_Vesting_Vestee_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  ClaimAmountPerMonth = 'claim_amount_per_month',
  /** column name */
  TotalAllocatedAmount = 'total_allocated_amount',
  /** column name */
  TotalClaimed = 'total_claimed',
  /** column name */
  TotalRemainder = 'total_remainder'
}

/** aggregate stddev on columns */
export type Vesting_Vestee_Stddev_Fields = {
  __typename?: 'vesting_vestee_stddev_fields';
  claim_amount_per_month?: Maybe<Scalars['Float']['output']>;
  cliff_months?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  months_claimed?: Maybe<Scalars['Float']['output']>;
  months_remaining?: Maybe<Scalars['Float']['output']>;
  total_allocated_amount?: Maybe<Scalars['Float']['output']>;
  total_claimed?: Maybe<Scalars['Float']['output']>;
  total_remainder?: Maybe<Scalars['Float']['output']>;
  vestee_id?: Maybe<Scalars['Float']['output']>;
  vesting_id?: Maybe<Scalars['Float']['output']>;
  vesting_months?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "vesting_vestee" */
export type Vesting_Vestee_Stddev_Order_By = {
  claim_amount_per_month?: InputMaybe<Order_By>;
  cliff_months?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  months_claimed?: InputMaybe<Order_By>;
  months_remaining?: InputMaybe<Order_By>;
  total_allocated_amount?: InputMaybe<Order_By>;
  total_claimed?: InputMaybe<Order_By>;
  total_remainder?: InputMaybe<Order_By>;
  vestee_id?: InputMaybe<Order_By>;
  vesting_id?: InputMaybe<Order_By>;
  vesting_months?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vesting_Vestee_Stddev_Pop_Fields = {
  __typename?: 'vesting_vestee_stddev_pop_fields';
  claim_amount_per_month?: Maybe<Scalars['Float']['output']>;
  cliff_months?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  months_claimed?: Maybe<Scalars['Float']['output']>;
  months_remaining?: Maybe<Scalars['Float']['output']>;
  total_allocated_amount?: Maybe<Scalars['Float']['output']>;
  total_claimed?: Maybe<Scalars['Float']['output']>;
  total_remainder?: Maybe<Scalars['Float']['output']>;
  vestee_id?: Maybe<Scalars['Float']['output']>;
  vesting_id?: Maybe<Scalars['Float']['output']>;
  vesting_months?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "vesting_vestee" */
export type Vesting_Vestee_Stddev_Pop_Order_By = {
  claim_amount_per_month?: InputMaybe<Order_By>;
  cliff_months?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  months_claimed?: InputMaybe<Order_By>;
  months_remaining?: InputMaybe<Order_By>;
  total_allocated_amount?: InputMaybe<Order_By>;
  total_claimed?: InputMaybe<Order_By>;
  total_remainder?: InputMaybe<Order_By>;
  vestee_id?: InputMaybe<Order_By>;
  vesting_id?: InputMaybe<Order_By>;
  vesting_months?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vesting_Vestee_Stddev_Samp_Fields = {
  __typename?: 'vesting_vestee_stddev_samp_fields';
  claim_amount_per_month?: Maybe<Scalars['Float']['output']>;
  cliff_months?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  months_claimed?: Maybe<Scalars['Float']['output']>;
  months_remaining?: Maybe<Scalars['Float']['output']>;
  total_allocated_amount?: Maybe<Scalars['Float']['output']>;
  total_claimed?: Maybe<Scalars['Float']['output']>;
  total_remainder?: Maybe<Scalars['Float']['output']>;
  vestee_id?: Maybe<Scalars['Float']['output']>;
  vesting_id?: Maybe<Scalars['Float']['output']>;
  vesting_months?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "vesting_vestee" */
export type Vesting_Vestee_Stddev_Samp_Order_By = {
  claim_amount_per_month?: InputMaybe<Order_By>;
  cliff_months?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  months_claimed?: InputMaybe<Order_By>;
  months_remaining?: InputMaybe<Order_By>;
  total_allocated_amount?: InputMaybe<Order_By>;
  total_claimed?: InputMaybe<Order_By>;
  total_remainder?: InputMaybe<Order_By>;
  vestee_id?: InputMaybe<Order_By>;
  vesting_id?: InputMaybe<Order_By>;
  vesting_months?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "vesting_vestee" */
export type Vesting_Vestee_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vesting_Vestee_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vesting_Vestee_Stream_Cursor_Value_Input = {
  claim_amount_per_month?: InputMaybe<Scalars['float8']['input']>;
  cliff_months?: InputMaybe<Scalars['smallint']['input']>;
  end_cliff_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  end_vesting_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_claimed_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  months_claimed?: InputMaybe<Scalars['smallint']['input']>;
  months_remaining?: InputMaybe<Scalars['smallint']['input']>;
  next_redemption_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  start_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  total_allocated_amount?: InputMaybe<Scalars['float8']['input']>;
  total_claimed?: InputMaybe<Scalars['float8']['input']>;
  total_remainder?: InputMaybe<Scalars['float8']['input']>;
  vestee_id?: InputMaybe<Scalars['bigint']['input']>;
  vesting_id?: InputMaybe<Scalars['bigint']['input']>;
  vesting_months?: InputMaybe<Scalars['smallint']['input']>;
};

/** aggregate sum on columns */
export type Vesting_Vestee_Sum_Fields = {
  __typename?: 'vesting_vestee_sum_fields';
  claim_amount_per_month?: Maybe<Scalars['float8']['output']>;
  cliff_months?: Maybe<Scalars['smallint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  months_claimed?: Maybe<Scalars['smallint']['output']>;
  months_remaining?: Maybe<Scalars['smallint']['output']>;
  total_allocated_amount?: Maybe<Scalars['float8']['output']>;
  total_claimed?: Maybe<Scalars['float8']['output']>;
  total_remainder?: Maybe<Scalars['float8']['output']>;
  vestee_id?: Maybe<Scalars['bigint']['output']>;
  vesting_id?: Maybe<Scalars['bigint']['output']>;
  vesting_months?: Maybe<Scalars['smallint']['output']>;
};

/** order by sum() on columns of table "vesting_vestee" */
export type Vesting_Vestee_Sum_Order_By = {
  claim_amount_per_month?: InputMaybe<Order_By>;
  cliff_months?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  months_claimed?: InputMaybe<Order_By>;
  months_remaining?: InputMaybe<Order_By>;
  total_allocated_amount?: InputMaybe<Order_By>;
  total_claimed?: InputMaybe<Order_By>;
  total_remainder?: InputMaybe<Order_By>;
  vestee_id?: InputMaybe<Order_By>;
  vesting_id?: InputMaybe<Order_By>;
  vesting_months?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Vesting_Vestee_Var_Pop_Fields = {
  __typename?: 'vesting_vestee_var_pop_fields';
  claim_amount_per_month?: Maybe<Scalars['Float']['output']>;
  cliff_months?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  months_claimed?: Maybe<Scalars['Float']['output']>;
  months_remaining?: Maybe<Scalars['Float']['output']>;
  total_allocated_amount?: Maybe<Scalars['Float']['output']>;
  total_claimed?: Maybe<Scalars['Float']['output']>;
  total_remainder?: Maybe<Scalars['Float']['output']>;
  vestee_id?: Maybe<Scalars['Float']['output']>;
  vesting_id?: Maybe<Scalars['Float']['output']>;
  vesting_months?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "vesting_vestee" */
export type Vesting_Vestee_Var_Pop_Order_By = {
  claim_amount_per_month?: InputMaybe<Order_By>;
  cliff_months?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  months_claimed?: InputMaybe<Order_By>;
  months_remaining?: InputMaybe<Order_By>;
  total_allocated_amount?: InputMaybe<Order_By>;
  total_claimed?: InputMaybe<Order_By>;
  total_remainder?: InputMaybe<Order_By>;
  vestee_id?: InputMaybe<Order_By>;
  vesting_id?: InputMaybe<Order_By>;
  vesting_months?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vesting_Vestee_Var_Samp_Fields = {
  __typename?: 'vesting_vestee_var_samp_fields';
  claim_amount_per_month?: Maybe<Scalars['Float']['output']>;
  cliff_months?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  months_claimed?: Maybe<Scalars['Float']['output']>;
  months_remaining?: Maybe<Scalars['Float']['output']>;
  total_allocated_amount?: Maybe<Scalars['Float']['output']>;
  total_claimed?: Maybe<Scalars['Float']['output']>;
  total_remainder?: Maybe<Scalars['Float']['output']>;
  vestee_id?: Maybe<Scalars['Float']['output']>;
  vesting_id?: Maybe<Scalars['Float']['output']>;
  vesting_months?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "vesting_vestee" */
export type Vesting_Vestee_Var_Samp_Order_By = {
  claim_amount_per_month?: InputMaybe<Order_By>;
  cliff_months?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  months_claimed?: InputMaybe<Order_By>;
  months_remaining?: InputMaybe<Order_By>;
  total_allocated_amount?: InputMaybe<Order_By>;
  total_claimed?: InputMaybe<Order_By>;
  total_remainder?: InputMaybe<Order_By>;
  vestee_id?: InputMaybe<Order_By>;
  vesting_id?: InputMaybe<Order_By>;
  vesting_months?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Vesting_Vestee_Variance_Fields = {
  __typename?: 'vesting_vestee_variance_fields';
  claim_amount_per_month?: Maybe<Scalars['Float']['output']>;
  cliff_months?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  months_claimed?: Maybe<Scalars['Float']['output']>;
  months_remaining?: Maybe<Scalars['Float']['output']>;
  total_allocated_amount?: Maybe<Scalars['Float']['output']>;
  total_claimed?: Maybe<Scalars['Float']['output']>;
  total_remainder?: Maybe<Scalars['Float']['output']>;
  vestee_id?: Maybe<Scalars['Float']['output']>;
  vesting_id?: Maybe<Scalars['Float']['output']>;
  vesting_months?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "vesting_vestee" */
export type Vesting_Vestee_Variance_Order_By = {
  claim_amount_per_month?: InputMaybe<Order_By>;
  cliff_months?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  months_claimed?: InputMaybe<Order_By>;
  months_remaining?: InputMaybe<Order_By>;
  total_allocated_amount?: InputMaybe<Order_By>;
  total_claimed?: InputMaybe<Order_By>;
  total_remainder?: InputMaybe<Order_By>;
  vestee_id?: InputMaybe<Order_By>;
  vesting_id?: InputMaybe<Order_By>;
  vesting_months?: InputMaybe<Order_By>;
};

/** columns and relationships of "vesting_whitelist_contract" */
export type Vesting_Whitelist_Contract = {
  __typename?: 'vesting_whitelist_contract';
  /** An object relationship */
  contract: Vesting;
  contract_address: Scalars['String']['output'];
  contract_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "vesting_whitelist_contract" */
export type Vesting_Whitelist_Contract_Aggregate = {
  __typename?: 'vesting_whitelist_contract_aggregate';
  aggregate?: Maybe<Vesting_Whitelist_Contract_Aggregate_Fields>;
  nodes: Array<Vesting_Whitelist_Contract>;
};

export type Vesting_Whitelist_Contract_Aggregate_Bool_Exp = {
  count?: InputMaybe<Vesting_Whitelist_Contract_Aggregate_Bool_Exp_Count>;
};

export type Vesting_Whitelist_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vesting_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vesting_Whitelist_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vesting_whitelist_contract" */
export type Vesting_Whitelist_Contract_Aggregate_Fields = {
  __typename?: 'vesting_whitelist_contract_aggregate_fields';
  avg?: Maybe<Vesting_Whitelist_Contract_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vesting_Whitelist_Contract_Max_Fields>;
  min?: Maybe<Vesting_Whitelist_Contract_Min_Fields>;
  stddev?: Maybe<Vesting_Whitelist_Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Vesting_Whitelist_Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vesting_Whitelist_Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Vesting_Whitelist_Contract_Sum_Fields>;
  var_pop?: Maybe<Vesting_Whitelist_Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Vesting_Whitelist_Contract_Var_Samp_Fields>;
  variance?: Maybe<Vesting_Whitelist_Contract_Variance_Fields>;
};


/** aggregate fields of "vesting_whitelist_contract" */
export type Vesting_Whitelist_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vesting_Whitelist_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vesting_whitelist_contract" */
export type Vesting_Whitelist_Contract_Aggregate_Order_By = {
  avg?: InputMaybe<Vesting_Whitelist_Contract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vesting_Whitelist_Contract_Max_Order_By>;
  min?: InputMaybe<Vesting_Whitelist_Contract_Min_Order_By>;
  stddev?: InputMaybe<Vesting_Whitelist_Contract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Vesting_Whitelist_Contract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Vesting_Whitelist_Contract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Vesting_Whitelist_Contract_Sum_Order_By>;
  var_pop?: InputMaybe<Vesting_Whitelist_Contract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Vesting_Whitelist_Contract_Var_Samp_Order_By>;
  variance?: InputMaybe<Vesting_Whitelist_Contract_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Vesting_Whitelist_Contract_Avg_Fields = {
  __typename?: 'vesting_whitelist_contract_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "vesting_whitelist_contract" */
export type Vesting_Whitelist_Contract_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vesting_whitelist_contract". All fields are combined with a logical 'AND'. */
export type Vesting_Whitelist_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Vesting_Whitelist_Contract_Bool_Exp>>;
  _not?: InputMaybe<Vesting_Whitelist_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Vesting_Whitelist_Contract_Bool_Exp>>;
  contract?: InputMaybe<Vesting_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  contract_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Vesting_Whitelist_Contract_Max_Fields = {
  __typename?: 'vesting_whitelist_contract_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "vesting_whitelist_contract" */
export type Vesting_Whitelist_Contract_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vesting_Whitelist_Contract_Min_Fields = {
  __typename?: 'vesting_whitelist_contract_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "vesting_whitelist_contract" */
export type Vesting_Whitelist_Contract_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "vesting_whitelist_contract". */
export type Vesting_Whitelist_Contract_Order_By = {
  contract?: InputMaybe<Vesting_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "vesting_whitelist_contract" */
export enum Vesting_Whitelist_Contract_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Vesting_Whitelist_Contract_Stddev_Fields = {
  __typename?: 'vesting_whitelist_contract_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "vesting_whitelist_contract" */
export type Vesting_Whitelist_Contract_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vesting_Whitelist_Contract_Stddev_Pop_Fields = {
  __typename?: 'vesting_whitelist_contract_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "vesting_whitelist_contract" */
export type Vesting_Whitelist_Contract_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vesting_Whitelist_Contract_Stddev_Samp_Fields = {
  __typename?: 'vesting_whitelist_contract_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "vesting_whitelist_contract" */
export type Vesting_Whitelist_Contract_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "vesting_whitelist_contract" */
export type Vesting_Whitelist_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vesting_Whitelist_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vesting_Whitelist_Contract_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Vesting_Whitelist_Contract_Sum_Fields = {
  __typename?: 'vesting_whitelist_contract_sum_fields';
  contract_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "vesting_whitelist_contract" */
export type Vesting_Whitelist_Contract_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Vesting_Whitelist_Contract_Var_Pop_Fields = {
  __typename?: 'vesting_whitelist_contract_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "vesting_whitelist_contract" */
export type Vesting_Whitelist_Contract_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vesting_Whitelist_Contract_Var_Samp_Fields = {
  __typename?: 'vesting_whitelist_contract_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "vesting_whitelist_contract" */
export type Vesting_Whitelist_Contract_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Vesting_Whitelist_Contract_Variance_Fields = {
  __typename?: 'vesting_whitelist_contract_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "vesting_whitelist_contract" */
export type Vesting_Whitelist_Contract_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "whitelist_developer" */
export type Whitelist_Developer = {
  __typename?: 'whitelist_developer';
  /** An object relationship */
  developer: Maven_User;
  developer_id: Scalars['bigint']['output'];
  /** An object relationship */
  governance: Governance;
  governance_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "whitelist_developer" */
export type Whitelist_Developer_Aggregate = {
  __typename?: 'whitelist_developer_aggregate';
  aggregate?: Maybe<Whitelist_Developer_Aggregate_Fields>;
  nodes: Array<Whitelist_Developer>;
};

export type Whitelist_Developer_Aggregate_Bool_Exp = {
  count?: InputMaybe<Whitelist_Developer_Aggregate_Bool_Exp_Count>;
};

export type Whitelist_Developer_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Whitelist_Developer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Whitelist_Developer_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "whitelist_developer" */
export type Whitelist_Developer_Aggregate_Fields = {
  __typename?: 'whitelist_developer_aggregate_fields';
  avg?: Maybe<Whitelist_Developer_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Whitelist_Developer_Max_Fields>;
  min?: Maybe<Whitelist_Developer_Min_Fields>;
  stddev?: Maybe<Whitelist_Developer_Stddev_Fields>;
  stddev_pop?: Maybe<Whitelist_Developer_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Whitelist_Developer_Stddev_Samp_Fields>;
  sum?: Maybe<Whitelist_Developer_Sum_Fields>;
  var_pop?: Maybe<Whitelist_Developer_Var_Pop_Fields>;
  var_samp?: Maybe<Whitelist_Developer_Var_Samp_Fields>;
  variance?: Maybe<Whitelist_Developer_Variance_Fields>;
};


/** aggregate fields of "whitelist_developer" */
export type Whitelist_Developer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Whitelist_Developer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "whitelist_developer" */
export type Whitelist_Developer_Aggregate_Order_By = {
  avg?: InputMaybe<Whitelist_Developer_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Whitelist_Developer_Max_Order_By>;
  min?: InputMaybe<Whitelist_Developer_Min_Order_By>;
  stddev?: InputMaybe<Whitelist_Developer_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Whitelist_Developer_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Whitelist_Developer_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Whitelist_Developer_Sum_Order_By>;
  var_pop?: InputMaybe<Whitelist_Developer_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Whitelist_Developer_Var_Samp_Order_By>;
  variance?: InputMaybe<Whitelist_Developer_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Whitelist_Developer_Avg_Fields = {
  __typename?: 'whitelist_developer_avg_fields';
  developer_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "whitelist_developer" */
export type Whitelist_Developer_Avg_Order_By = {
  developer_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "whitelist_developer". All fields are combined with a logical 'AND'. */
export type Whitelist_Developer_Bool_Exp = {
  _and?: InputMaybe<Array<Whitelist_Developer_Bool_Exp>>;
  _not?: InputMaybe<Whitelist_Developer_Bool_Exp>;
  _or?: InputMaybe<Array<Whitelist_Developer_Bool_Exp>>;
  developer?: InputMaybe<Maven_User_Bool_Exp>;
  developer_id?: InputMaybe<Bigint_Comparison_Exp>;
  governance?: InputMaybe<Governance_Bool_Exp>;
  governance_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Whitelist_Developer_Max_Fields = {
  __typename?: 'whitelist_developer_max_fields';
  developer_id?: Maybe<Scalars['bigint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "whitelist_developer" */
export type Whitelist_Developer_Max_Order_By = {
  developer_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Whitelist_Developer_Min_Fields = {
  __typename?: 'whitelist_developer_min_fields';
  developer_id?: Maybe<Scalars['bigint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "whitelist_developer" */
export type Whitelist_Developer_Min_Order_By = {
  developer_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "whitelist_developer". */
export type Whitelist_Developer_Order_By = {
  developer?: InputMaybe<Maven_User_Order_By>;
  developer_id?: InputMaybe<Order_By>;
  governance?: InputMaybe<Governance_Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "whitelist_developer" */
export enum Whitelist_Developer_Select_Column {
  /** column name */
  DeveloperId = 'developer_id',
  /** column name */
  GovernanceId = 'governance_id',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Whitelist_Developer_Stddev_Fields = {
  __typename?: 'whitelist_developer_stddev_fields';
  developer_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "whitelist_developer" */
export type Whitelist_Developer_Stddev_Order_By = {
  developer_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Whitelist_Developer_Stddev_Pop_Fields = {
  __typename?: 'whitelist_developer_stddev_pop_fields';
  developer_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "whitelist_developer" */
export type Whitelist_Developer_Stddev_Pop_Order_By = {
  developer_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Whitelist_Developer_Stddev_Samp_Fields = {
  __typename?: 'whitelist_developer_stddev_samp_fields';
  developer_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "whitelist_developer" */
export type Whitelist_Developer_Stddev_Samp_Order_By = {
  developer_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "whitelist_developer" */
export type Whitelist_Developer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Whitelist_Developer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Whitelist_Developer_Stream_Cursor_Value_Input = {
  developer_id?: InputMaybe<Scalars['bigint']['input']>;
  governance_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Whitelist_Developer_Sum_Fields = {
  __typename?: 'whitelist_developer_sum_fields';
  developer_id?: Maybe<Scalars['bigint']['output']>;
  governance_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "whitelist_developer" */
export type Whitelist_Developer_Sum_Order_By = {
  developer_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Whitelist_Developer_Var_Pop_Fields = {
  __typename?: 'whitelist_developer_var_pop_fields';
  developer_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "whitelist_developer" */
export type Whitelist_Developer_Var_Pop_Order_By = {
  developer_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Whitelist_Developer_Var_Samp_Fields = {
  __typename?: 'whitelist_developer_var_samp_fields';
  developer_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "whitelist_developer" */
export type Whitelist_Developer_Var_Samp_Order_By = {
  developer_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Whitelist_Developer_Variance_Fields = {
  __typename?: 'whitelist_developer_variance_fields';
  developer_id?: Maybe<Scalars['Float']['output']>;
  governance_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "whitelist_developer" */
export type Whitelist_Developer_Variance_Order_By = {
  developer_id?: InputMaybe<Order_By>;
  governance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

export type GlassBrokenStatusAndWhiteListDevsQueryVariables = Exact<{ [key: string]: never; }>;


export type GlassBrokenStatusAndWhiteListDevsQuery = { __typename?: 'query_root', break_glass: Array<{ __typename?: 'break_glass', glass_broken: boolean }>, whitelist_developer: Array<{ __typename?: 'whitelist_developer', developer: { __typename?: 'maven_user', address: string } }> };

export type GetAllContractStatusesDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllContractStatusesDataQuery = { __typename?: 'query_root', farm: Array<{ __typename?: 'farm', name: string, address: string, claim_paused: boolean, deposit_paused: boolean, withdraw_paused: boolean, admin: string, last_updated_at?: any | null }>, farm_factory: Array<{ __typename?: 'farm_factory', create_farm_paused: boolean, create_farm_m_token_paused: boolean, track_farm_paused: boolean, untrack_farm_paused: boolean, address: string, admin: string, last_updated_at?: any | null }>, delegation: Array<{ __typename?: 'delegation', delegate_to_satellite_paused: boolean, distribute_reward_paused: boolean, register_as_satellite_paused: boolean, undelegate_from_satellite_paused: boolean, unregister_as_satellite_paused: boolean, update_satellite_record_paused: boolean, take_satellites_snapshot_paused: boolean, address: string, admin: string, last_updated_at?: any | null }>, doorman: Array<{ __typename?: 'doorman', address: string, compound_paused: boolean, farm_claim_paused: boolean, stake_mvn_paused: boolean, unstake_mvn_paused: boolean, exit_paused: boolean, on_vault_deposit_stake_paused: boolean, on_vault_liquidate_stake_paused: boolean, on_vault_withdraw_stake_paused: boolean, admin: string, last_updated_at?: any | null }>, treasury: Array<{ __typename?: 'treasury', name: string, address: string, admin: string, mint_mvn_and_transfer_paused: boolean, stake_tokens_paused: boolean, transfer_paused: boolean, unstake_tokens_paused: boolean, update_token_operators_paused: boolean, last_updated_at?: any | null }>, treasury_factory: Array<{ __typename?: 'treasury_factory', create_treasury_paused: boolean, track_treasury_paused: boolean, untrack_treasury_paused: boolean, address: string, admin: string, last_updated_at?: any | null }>, aggregator: Array<{ __typename?: 'aggregator', address: string, name: string, withdraw_reward_smvn_paused: boolean, withdraw_reward_mvrk_paused: boolean, admin: string, last_updated_at?: any | null }>, aggregator_factory: Array<{ __typename?: 'aggregator_factory', address: string, admin: string, untrack_aggregator_paused: boolean, track_aggregator_paused: boolean, distribute_reward_mvrk_paused: boolean, distribute_reward_smvn_paused: boolean, create_aggregator_paused: boolean, last_updated_at?: any | null }>, lending_controller: Array<{ __typename?: 'lending_controller', address: string, admin: string, last_updated_at?: any | null, add_liquidity_paused: boolean, close_vault_paused: boolean, liquidate_vault_paused: boolean, mark_for_liquidation_paused: boolean, register_deposit_paused: boolean, register_vault_creation_paused: boolean, register_withdrawal_paused: boolean, remove_liquidity_paused: boolean, repay_paused: boolean, set_collateral_token_paused: boolean, set_loan_token_paused: boolean, vault_deposit_paused: boolean, vault_deposit_staked_token_paused: boolean, vault_on_liquidate_paused: boolean, vault_withdraw_paused: boolean, vault_withdraw_staked_token_paused: boolean }>, vault_factory: Array<{ __typename?: 'vault_factory', address: string, admin: string, create_vault_paused: boolean, last_updated_at?: any | null }> };

export type GetBreakGlassCouncilMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBreakGlassCouncilMembersQuery = { __typename?: 'query_root', break_glass_council_member: Array<{ __typename?: 'break_glass_council_member', name: string, website: string, image: string, id: any, user: { __typename?: 'maven_user', address: string, satellites: Array<{ __typename?: 'satellite', status: any, currently_registered: boolean }> } }> };

export type GetBgAllPastCouncilActionsQueryVariables = Exact<{
  currentTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type GetBgAllPastCouncilActionsQuery = { __typename?: 'query_root', break_glass_action: Array<{ __typename?: 'break_glass_action', action_type: string, signers_count: any, start_datetime: any, executed: boolean, status: any, council_size_snapshot: any, expiration_datetime: any, id: any, initiator: { __typename?: 'maven_user', address: string }, break_glass: { __typename?: 'break_glass', address: string }, signers: Array<{ __typename?: 'break_glass_action_signer', signer: { __typename?: 'maven_user', address: string } }>, parameters: Array<{ __typename?: 'break_glass_action_parameter', id: any, name: string, value: string }> }> };

export type GetBgAllOngoingCouncilActionsQueryVariables = Exact<{
  currentTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type GetBgAllOngoingCouncilActionsQuery = { __typename?: 'query_root', break_glass_action: Array<{ __typename?: 'break_glass_action', action_type: string, signers_count: any, start_datetime: any, executed: boolean, status: any, council_size_snapshot: any, expiration_datetime: any, id: any, initiator: { __typename?: 'maven_user', address: string }, break_glass: { __typename?: 'break_glass', address: string }, signers: Array<{ __typename?: 'break_glass_action_signer', signer: { __typename?: 'maven_user', address: string } }>, parameters: Array<{ __typename?: 'break_glass_action_parameter', id: any, name: string, value: string }> }> };

export type GetBgMyPastCouncilActionsQueryVariables = Exact<{
  currentTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  userAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBgMyPastCouncilActionsQuery = { __typename?: 'query_root', break_glass_action: Array<{ __typename?: 'break_glass_action', action_type: string, signers_count: any, start_datetime: any, executed: boolean, status: any, council_size_snapshot: any, expiration_datetime: any, id: any, initiator: { __typename?: 'maven_user', address: string }, break_glass: { __typename?: 'break_glass', address: string }, signers: Array<{ __typename?: 'break_glass_action_signer', signer: { __typename?: 'maven_user', address: string } }>, parameters: Array<{ __typename?: 'break_glass_action_parameter', id: any, name: string, value: string }> }> };

export type GetCouncilMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCouncilMembersQuery = { __typename?: 'query_root', council: Array<{ __typename?: 'council', members: Array<{ __typename?: 'council_council_member', id: any, name: string, image: string, website: string, user: { __typename?: 'maven_user', address: string, satellites: Array<{ __typename?: 'satellite', status: any, currently_registered: boolean }> } }> }> };

export type GetAllPastCouncilActionsQueryVariables = Exact<{
  currentTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type GetAllPastCouncilActionsQuery = { __typename?: 'query_root', council_action: Array<{ __typename?: 'council_action', action_type: string, executed: boolean, council_size_snapshot: any, id: any, status: any, signers_count: any, start_datetime: any, expiration_datetime: any, council: { __typename?: 'council', address: string }, initiator: { __typename?: 'maven_user', address: string }, signers: Array<{ __typename?: 'council_action_signer', signer: { __typename?: 'maven_user', address: string } }>, parameters: Array<{ __typename?: 'council_action_parameter', id: any, name: string, value: string }> }> };

export type GetAllOngoingCouncilActionsQueryVariables = Exact<{
  currentTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type GetAllOngoingCouncilActionsQuery = { __typename?: 'query_root', council_action: Array<{ __typename?: 'council_action', action_type: string, executed: boolean, council_size_snapshot: any, id: any, status: any, signers_count: any, start_datetime: any, expiration_datetime: any, council: { __typename?: 'council', address: string }, initiator: { __typename?: 'maven_user', address: string }, signers: Array<{ __typename?: 'council_action_signer', signer: { __typename?: 'maven_user', address: string } }>, parameters: Array<{ __typename?: 'council_action_parameter', id: any, name: string, value: string }> }> };

export type GetMyPastCouncilActionsQueryVariables = Exact<{
  currentTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  userAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMyPastCouncilActionsQuery = { __typename?: 'query_root', council_action: Array<{ __typename?: 'council_action', action_type: string, executed: boolean, council_size_snapshot: any, id: any, status: any, signers_count: any, start_datetime: any, expiration_datetime: any, council: { __typename?: 'council', address: string }, initiator: { __typename?: 'maven_user', address: string }, signers: Array<{ __typename?: 'council_action_signer', signer: { __typename?: 'maven_user', address: string } }>, parameters: Array<{ __typename?: 'council_action_parameter', id: any, name: string, value: string }> }> };

export type GetContractAddressesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContractAddressesQueryQuery = { __typename?: 'query_root', delegation: Array<{ __typename?: 'delegation', address: string }>, doorman: Array<{ __typename?: 'doorman', address: string }>, mvn_token: Array<{ __typename?: 'mvn_token', address: string }>, farm: Array<{ __typename?: 'farm', address: string }>, farm_factory: Array<{ __typename?: 'farm_factory', address: string }>, council: Array<{ __typename?: 'council', address: string }>, break_glass: Array<{ __typename?: 'break_glass', address: string }>, emergency_governance: Array<{ __typename?: 'emergency_governance', address: string }>, governance: Array<{ __typename?: 'governance', address: string }>, governance_proxy: Array<{ __typename?: 'governance_proxy', address: string }>, treasury: Array<{ __typename?: 'treasury', address: string }>, treasury_factory: Array<{ __typename?: 'treasury_factory', address: string }>, vesting: Array<{ __typename?: 'vesting', address: string }>, governance_satellite: Array<{ __typename?: 'governance_satellite', address: string }>, aggregator_factory: Array<{ __typename?: 'aggregator_factory', address: string }>, aggregator: Array<{ __typename?: 'aggregator', address: string }>, governance_financial: Array<{ __typename?: 'governance_financial', address: string }>, lending_controller: Array<{ __typename?: 'lending_controller', address: string }>, vault_factory: Array<{ __typename?: 'vault_factory', address: string }> };

export type InitialDappQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type InitialDappQueryQuery = { __typename?: 'query_root', council: Array<{ __typename?: 'council', council_member_image_max_length: any, council_member_name_max_length: any, council_member_website_max_length: any, request_purpose_max_length: any, request_token_name_max_length: any }>, governance: Array<{ __typename?: 'governance', proposal_description_max_length: any, proposal_invoice_max_length: any, proposal_metadata_title_max_length: any, proposal_source_code_max_length: any, proposal_title_max_length: any }>, emergency_governance: Array<{ __typename?: 'emergency_governance', proposal_desc_max_length: any, proposal_title_max_length: any }>, governance_satellite: Array<{ __typename?: 'governance_satellite', gov_purpose_max_length: any }>, delegation: Array<{ __typename?: 'delegation', satellite_description_max_length: any, satellite_name_max_length: any, satellite_website_max_length: any, minimum_smvn_balance: any }>, dipdup_index: Array<{ __typename?: 'dipdup_index', level: number }> };

export type DashboardTvlQueryVariables = Exact<{
  doormanContractAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type DashboardTvlQuery = { __typename?: 'query_root', doormanTVL: Array<{ __typename?: 'maven_user', smvn_balance: any, mvn_balance: any }>, lending_controller: Array<{ __typename?: 'lending_controller', vaultsLvl: Array<{ __typename?: 'lending_controller_collateral_token', token: { __typename?: 'token', token_address: string }, balances_aggregate: { __typename?: 'lending_controller_vault_collateral_balance_aggregate', aggregate?: { __typename?: 'lending_controller_vault_collateral_balance_aggregate_fields', sum?: { __typename?: 'lending_controller_vault_collateral_balance_sum_fields', balance?: any | null } | null } | null } }>, collateralsForActiveVaults: Array<{ __typename?: 'lending_controller_collateral_token', token: { __typename?: 'token', token_address: string }, balances_aggregate: { __typename?: 'lending_controller_vault_collateral_balance_aggregate', aggregate?: { __typename?: 'lending_controller_vault_collateral_balance_aggregate_fields', sum?: { __typename?: 'lending_controller_vault_collateral_balance_sum_fields', balance?: any | null } | null } | null } }>, activeVaults: { __typename?: 'lending_controller_vault_aggregate', aggregate?: { __typename?: 'lending_controller_vault_aggregate_fields', count: number } | null }, marketsTvl: Array<{ __typename?: 'lending_controller_loan_token', total_borrowed: any, total_remaining: any, token: { __typename?: 'token', token_address: string } }> }>, treasuryTvl: Array<{ __typename?: 'treasury_balance', balance: any, token: { __typename?: 'token', token_address: string } }> };

export type SubscribeToIndexerLevelSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeToIndexerLevelSubscription = { __typename?: 'subscription_root', dipdup_index: Array<{ __typename?: 'dipdup_index', level: number }> };

export type FeedHistoryQeuryQueryVariables = Exact<{
  feedAddress?: InputMaybe<Scalars['String']['input']>;
  periodTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type FeedHistoryQeuryQuery = { __typename?: 'query_root', aggregator: Array<{ __typename?: 'aggregator', history_data: Array<{ __typename?: 'aggregator_history_data', data: any, timestamp: any, aggregator: { __typename?: 'aggregator', decimals: any } }> }> };

export type DataFeedsQueryVariables = Exact<{ [key: string]: never; }>;


export type DataFeedsQuery = { __typename?: 'query_root', aggregator: Array<{ __typename?: 'aggregator', address: string, name: string, admin: string, decimals: any, network: string, metadata?: any | null, creation_timestamp: any, last_completed_data: any, last_completed_data_last_updated_at: any, last_completed_data_pct_oracle_resp: any, last_completed_data_epoch: any, heart_beat_seconds: any, reward_amount_mvrk: any, reward_amount_smvn: any, pct_oracle_threshold: any, alpha_pct_per_thousand: any, oracles: Array<{ __typename?: 'aggregator_oracle', user: { __typename?: 'maven_user', address: string } }> }> };

export type DataFeedsPricesQueryVariables = Exact<{ [key: string]: never; }>;


export type DataFeedsPricesQuery = { __typename?: 'query_root', aggregator: Array<{ __typename?: 'aggregator', address: string, name: string, decimals: any, last_completed_data: any, last_completed_data_pct_oracle_resp: any, last_completed_data_last_updated_at: any, last_completed_data_epoch: any }> };

export type SmvnMvnHistoryDataQueryVariables = Exact<{
  periodTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type SmvnMvnHistoryDataQuery = { __typename?: 'query_root', operationsInPeriod: Array<{ __typename?: 'smvn_history_data', mvn_total_supply: any, smvn_total_supply: any, timestamp: any }>, lastOperationBeforePeriod: Array<{ __typename?: 'smvn_history_data', mvn_total_supply: any, smvn_total_supply: any, timestamp: any }>, amountOfOperationsBeforePeriod: { __typename?: 'smvn_history_data_aggregate', aggregate?: { __typename?: 'smvn_history_data_aggregate_fields', count: number } | null } };

export type GetDappSmvnMvnStatsQueryVariables = Exact<{
  doormanContractAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDappSmvnMvnStatsQuery = { __typename?: 'query_root', maven_user: Array<{ __typename?: 'maven_user', address: string, mvn_balance: any, smvn_balance: any }>, mvn_token: Array<{ __typename?: 'mvn_token', total_supply: any, maximum_supply: any }> };

export type GetEGovConfigQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEGovConfigQueryQuery = { __typename?: 'query_root', emergency_governance: Array<{ __typename?: 'emergency_governance', current_emergency_record_id: any, smvn_percentage_required: any, required_fee_mumav: any, min_smvn_required_to_vote: any }> };

export type GetEGovAllProposalsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEGovAllProposalsQueryQuery = { __typename?: 'query_root', emergency_governance_record: Array<{ __typename?: 'emergency_governance_record', id: any, title: string, description: string, executed: boolean, start_timestamp: any, execution_datetime?: any | null, expiration_timestamp: any, smvn_percentage_required: any, smvn_required_for_trigger: any, total_smvn_votes: any, proposer: { __typename?: 'maven_user', address: string }, voters: Array<{ __typename?: 'emergency_governance_vote', smvn_amount: any, timestamp: any, voter: { __typename?: 'maven_user', address: string } }> }> };

export type FarmsAllLiveQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FarmsAllLiveQueryQuery = { __typename?: 'query_root', farm: Array<{ __typename?: 'farm', address: string, name: string, open: boolean, creation_timestamp: any, end_timestamp?: any | null, infinite: boolean, lp_token_balance: any, withdraw_paused: boolean, claim_paused: boolean, deposit_paused: boolean, is_m_farm: boolean, current_reward_per_block: any, lp_token: { __typename?: 'token', token_address: string }, farm_accounts: Array<{ __typename?: 'farm_account', deposited_amount: any, unclaimed_rewards: any, participation_rewards_per_share: any, user: { __typename?: 'maven_user', address: string } }> }> };

export type FarmsStakedLiveQueryQueryVariables = Exact<{
  userAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type FarmsStakedLiveQueryQuery = { __typename?: 'query_root', farm: Array<{ __typename?: 'farm', address: string, name: string, open: boolean, creation_timestamp: any, end_timestamp?: any | null, infinite: boolean, lp_token_balance: any, withdraw_paused: boolean, claim_paused: boolean, deposit_paused: boolean, is_m_farm: boolean, current_reward_per_block: any, lp_token: { __typename?: 'token', token_address: string }, farm_accounts: Array<{ __typename?: 'farm_account', deposited_amount: any, unclaimed_rewards: any, participation_rewards_per_share: any, user: { __typename?: 'maven_user', address: string } }> }> };

export type FarmsAllFinishedQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FarmsAllFinishedQueryQuery = { __typename?: 'query_root', farm: Array<{ __typename?: 'farm', address: string, name: string, open: boolean, creation_timestamp: any, end_timestamp?: any | null, infinite: boolean, lp_token_balance: any, withdraw_paused: boolean, claim_paused: boolean, deposit_paused: boolean, is_m_farm: boolean, current_reward_per_block: any, lp_token: { __typename?: 'token', token_address: string }, farm_accounts: Array<{ __typename?: 'farm_account', deposited_amount: any, unclaimed_rewards: any, participation_rewards_per_share: any, user: { __typename?: 'maven_user', address: string } }> }> };

export type FarmsStakedFinishedQueryQueryVariables = Exact<{
  userAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type FarmsStakedFinishedQueryQuery = { __typename?: 'query_root', farm: Array<{ __typename?: 'farm', address: string, name: string, open: boolean, creation_timestamp: any, end_timestamp?: any | null, infinite: boolean, lp_token_balance: any, withdraw_paused: boolean, claim_paused: boolean, deposit_paused: boolean, is_m_farm: boolean, current_reward_per_block: any, lp_token: { __typename?: 'token', token_address: string }, farm_accounts: Array<{ __typename?: 'farm_account', deposited_amount: any, unclaimed_rewards: any, participation_rewards_per_share: any, user: { __typename?: 'maven_user', address: string } }> }> };

export type GetAllFinRequestsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllFinRequestsQueryQuery = { __typename?: 'query_root', governance_financial_request: Array<{ __typename?: 'governance_financial_request', executed: boolean, expiration_datetime: any, dropped_datetime?: any | null, execution_datetime?: any | null, id: any, request_purpose: string, request_type: string, requested_datetime: any, smvn_percentage_for_approval: any, snapshot_smvn_total_supply: any, status: any, token_amount: any, pass_vote_smvn_total: any, nay_vote_smvn_total: any, yay_vote_smvn_total: any, requester: { __typename?: 'maven_user', address: string }, token: { __typename?: 'token', token_address: string }, governance_financial: { __typename?: 'governance_financial', address: string, governance: { __typename?: 'governance', address: string } }, treasury: { __typename?: 'treasury', address: string }, votes: Array<{ __typename?: 'governance_financial_request_vote', governance_financial_request_id: any, id: any, timestamp?: any | null, vote: any, voter_id: any, voter: { __typename?: 'maven_user', address: string } }> }> };

export type GetActiveFinRequestsQueryQueryVariables = Exact<{
  currentTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type GetActiveFinRequestsQueryQuery = { __typename?: 'query_root', governance_financial_request: Array<{ __typename?: 'governance_financial_request', executed: boolean, expiration_datetime: any, dropped_datetime?: any | null, execution_datetime?: any | null, id: any, request_purpose: string, request_type: string, requested_datetime: any, smvn_percentage_for_approval: any, snapshot_smvn_total_supply: any, status: any, token_amount: any, pass_vote_smvn_total: any, nay_vote_smvn_total: any, yay_vote_smvn_total: any, requester: { __typename?: 'maven_user', address: string }, token: { __typename?: 'token', token_address: string }, governance_financial: { __typename?: 'governance_financial', address: string, governance: { __typename?: 'governance', address: string } }, treasury: { __typename?: 'treasury', address: string }, votes: Array<{ __typename?: 'governance_financial_request_vote', governance_financial_request_id: any, id: any, timestamp?: any | null, vote: any, voter_id: any, voter: { __typename?: 'maven_user', address: string } }> }> };

export type GetLending24hDiffQueryVariables = Exact<{
  currentTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type GetLending24hDiffQuery = { __typename?: 'query_root', lending_controller: Array<{ __typename?: 'lending_controller', history_data: Array<{ __typename?: 'lending_controller_history_data', type: any, amount: any, timestamp: any, loan_token?: { __typename?: 'lending_controller_loan_token', token: { __typename?: 'token', token_address: string } } | null }>, loan_tokens: Array<{ __typename?: 'lending_controller_loan_token', total_borrowed: any, token_pool_total: any, token: { __typename?: 'token', token_address: string } }> }> };

export type GetLoansHistoryDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoansHistoryDataQuery = { __typename?: 'query_root', lending_controller: Array<{ __typename?: 'lending_controller', history_data: Array<{ __typename?: 'lending_controller_history_data', type: any, amount: any, timestamp: any, loan_token?: { __typename?: 'lending_controller_loan_token', loan_token_name: string, token: { __typename?: 'token', token_address: string } } | null, collateral_token?: { __typename?: 'lending_controller_collateral_token', token: { __typename?: 'token', token_address: string } } | null }> }> };

export type GetLoansTransactionsHistoryQueryVariables = Exact<{
  marketTokenAddress?: InputMaybe<Scalars['String']['input']>;
  userAddress?: InputMaybe<Scalars['String']['input']>;
  vaultAddress?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Array<InputMaybe<Scalars['smallint']['input']>> | InputMaybe<Scalars['smallint']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLoansTransactionsHistoryQuery = { __typename?: 'query_root', lending_controller: Array<{ __typename?: 'lending_controller', history_data: Array<{ __typename?: 'lending_controller_history_data', type: any, amount: any, timestamp: any, operation_hash: string, loan_token?: { __typename?: 'lending_controller_loan_token', loan_token_name: string, token: { __typename?: 'token', token_address: string } } | null, collateral_token?: { __typename?: 'lending_controller_collateral_token', token: { __typename?: 'token', token_address: string, mvn_tokens: Array<{ __typename?: 'mvn_token', address: string }> } } | null, sender: { __typename?: 'maven_user', address: string }, vault?: { __typename?: 'lending_controller_vault', vault?: { __typename?: 'vault', address: string } | null } | null }>, historyItemsAmount: { __typename?: 'lending_controller_history_data_aggregate', aggregate?: { __typename?: 'lending_controller_history_data_aggregate_fields', count: number } | null } }> };

export type GetDevLoansTransactionsHistoryQueryVariables = Exact<{
  marketTokenAddress?: InputMaybe<Scalars['String']['input']>;
  userAddress?: InputMaybe<Scalars['String']['input']>;
  vaultAddress?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Array<InputMaybe<Scalars['smallint']['input']>> | InputMaybe<Scalars['smallint']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetDevLoansTransactionsHistoryQuery = { __typename?: 'query_root', lending_controller: Array<{ __typename?: 'lending_controller', history_data: Array<{ __typename?: 'lending_controller_history_data', type: any, amount: any, timestamp: any, operation_hash: string, loan_token?: { __typename?: 'lending_controller_loan_token', loan_token_name: string, token: { __typename?: 'token', token_address: string } } | null, collateral_token?: { __typename?: 'lending_controller_collateral_token', token: { __typename?: 'token', token_address: string, mvn_tokens: Array<{ __typename?: 'mvn_token', address: string }> } } | null, sender: { __typename?: 'maven_user', address: string }, vault?: { __typename?: 'lending_controller_vault', vault?: { __typename?: 'vault', address: string } | null } | null }>, historyItemsAmount: { __typename?: 'lending_controller_history_data_aggregate', aggregate?: { __typename?: 'lending_controller_history_data_aggregate_fields', count: number } | null } }> };

export type LoansMarketByAddressQueryQueryVariables = Exact<{
  marketTokenAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type LoansMarketByAddressQueryQuery = { __typename?: 'query_root', allMarketsAddresses: Array<{ __typename?: 'lending_controller', loan_tokens: Array<{ __typename?: 'lending_controller_loan_token', token: { __typename?: 'token', token_address: string } }> }>, lending_controller: Array<{ __typename?: 'lending_controller', collateral_ratio: any, interest_treasury_share: any, interest_rate_decimals: any, decimals: any, loan_tokens: Array<{ __typename?: 'lending_controller_loan_token', loan_token_name: string, id: any, utilisation_rate: any, total_borrowed: any, token_pool_total: any, total_remaining: any, reserve_ratio: any, current_interest_rate: any, token: { __typename?: 'token', token_address: string }, m_token: { __typename?: 'm_token', address: string, depositorsAmount: { __typename?: 'm_token_account_aggregate', aggregate?: { __typename?: 'm_token_account_aggregate_fields', count: number } | null }, mTokenRewardsAmount: { __typename?: 'm_token_account_aggregate', aggregate?: { __typename?: 'm_token_account_aggregate_fields', sum?: { __typename?: 'm_token_account_sum_fields', rewards_earned?: any | null } | null } | null } }, vaults_aggregate: { __typename?: 'lending_controller_vault_aggregate', aggregate?: { __typename?: 'lending_controller_vault_aggregate_fields', count: number } | null } }> }> };

export type AllLoansMarketsQueryQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AllLoansMarketsQueryQuery = { __typename?: 'query_root', markets: Array<{ __typename?: 'gql_loan_token_market_stats', id?: any | null, token_address?: string | null, m_token_address?: string | null, loan_token_name?: string | null, token_pool_total?: any | null, total_borrowed?: any | null, total_remaining?: any | null, utilisation_rate?: any | null, current_interest_rate?: any | null, depositors_count?: any | null, borrowers_count?: any | null, rewards_earned_total?: any | null, reserve_ratio?: any | null }>, lending_controller: Array<{ __typename?: 'lending_controller', collateral_ratio: any, interest_treasury_share: any, interest_rate_decimals: any, decimals: any }> };

export type GetLoansConfigQueryVariables = Exact<{
  currentTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type GetLoansConfigQuery = { __typename?: 'query_root', lending_controller: Array<{ __typename?: 'lending_controller', minimum_loan_fee_pct: any, collateral_ratio: any }> };

export type CheckWitherMarketExistsQueryVariables = Exact<{
  marketAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckWitherMarketExistsQuery = { __typename?: 'query_root', lending_controller: Array<{ __typename?: 'lending_controller', loan_tokens: Array<{ __typename?: 'lending_controller_loan_token', token: { __typename?: 'token', token_address: string } }> }> };

export type GetGovernanceLatestUserProposalsQueryQueryVariables = Exact<{
  userAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetGovernanceLatestUserProposalsQueryQuery = { __typename?: 'query_root', governance_proposal: Array<{ __typename?: 'governance_proposal', id: any }> };

export type GovernanceConfigQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GovernanceConfigQueryQuery = { __typename?: 'query_root', governance: Array<{ __typename?: 'governance', address: string, current_round: any, success_reward: any, cycle_id: any, proposal_submission_fee_mumav: any, timelock_proposal_id: any, cycle_highest_voted_proposal_id: any, current_round_end_level: any, proposals: Array<{ __typename?: 'governance_proposal', id: any }> }> };

export type PastProposalsDataQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type PastProposalsDataQueryQuery = { __typename?: 'query_root', governance: Array<{ __typename?: 'governance', current_round: any, timelock_proposal_id: any, cycle_highest_voted_proposal_id: any }>, governance_proposal: Array<{ __typename?: 'governance_proposal', current_cycle_end_level: any, cycle: any, success_reward: any, id: any, description: string, title: string, invoice: string, current_round_proposal: boolean, dropped_datetime?: any | null, execution_datetime?: any | null, defeated_datetime?: any | null, locked: boolean, executed: boolean, status: any, payment_processed: boolean, min_quorum_percentage: any, quorum_smvn_total: any, nay_vote_smvn_total: any, pass_vote_smvn_total: any, yay_vote_smvn_total: any, proposal_vote_smvn_total: any, source_code: string, proposer: { __typename?: 'maven_user', address: string }, governance: { __typename?: 'governance', address: string }, votes: Array<{ __typename?: 'governance_proposal_vote', round: any, vote: any, voter: { __typename?: 'maven_user', address: string, satellites: Array<{ __typename?: 'satellite', image: string, name: string }> } }>, data: Array<{ __typename?: 'governance_proposal_data', encoded_code?: string | null, governance_proposal_id: any, code_description?: string | null, id: any, title?: string | null }>, payments: Array<{ __typename?: 'governance_proposal_payment', governance_proposal_id: any, id: any, internal_id: any, title?: string | null, token_id?: any | null, token_amount?: any | null, to_?: { __typename?: 'maven_user', address: string } | null, token?: { __typename?: 'token', token_address: string } | null }> }> };

export type ProposalsDataQueryQueryVariables = Exact<{
  timelockProposalId?: InputMaybe<Scalars['bigint']['input']>;
}>;


export type ProposalsDataQueryQuery = { __typename?: 'query_root', governance: Array<{ __typename?: 'governance', current_round: any, timelock_proposal_id: any, cycle_highest_voted_proposal_id: any }>, governance_proposal: Array<{ __typename?: 'governance_proposal', current_cycle_end_level: any, cycle: any, success_reward: any, id: any, description: string, title: string, invoice: string, current_round_proposal: boolean, dropped_datetime?: any | null, execution_datetime?: any | null, defeated_datetime?: any | null, locked: boolean, executed: boolean, status: any, payment_processed: boolean, min_quorum_percentage: any, quorum_smvn_total: any, nay_vote_smvn_total: any, pass_vote_smvn_total: any, yay_vote_smvn_total: any, proposal_vote_smvn_total: any, source_code: string, proposer: { __typename?: 'maven_user', address: string }, governance: { __typename?: 'governance', address: string }, votes: Array<{ __typename?: 'governance_proposal_vote', round: any, vote: any, voter: { __typename?: 'maven_user', address: string, satellites: Array<{ __typename?: 'satellite', image: string, name: string }> } }>, data: Array<{ __typename?: 'governance_proposal_data', encoded_code?: string | null, governance_proposal_id: any, code_description?: string | null, id: any, title?: string | null }>, payments: Array<{ __typename?: 'governance_proposal_payment', governance_proposal_id: any, id: any, internal_id: any, title?: string | null, token_id?: any | null, token_amount?: any | null, to_?: { __typename?: 'maven_user', address: string } | null, token?: { __typename?: 'token', token_address: string } | null }> }> };

export type SubmissionProposalsDataqueryQueryVariables = Exact<{
  userAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubmissionProposalsDataqueryQuery = { __typename?: 'query_root', governance: Array<{ __typename?: 'governance', current_round: any, timelock_proposal_id: any, cycle_highest_voted_proposal_id: any }>, governance_proposal: Array<{ __typename?: 'governance_proposal', current_cycle_end_level: any, cycle: any, success_reward: any, id: any, description: string, title: string, invoice: string, current_round_proposal: boolean, dropped_datetime?: any | null, execution_datetime?: any | null, defeated_datetime?: any | null, locked: boolean, executed: boolean, status: any, payment_processed: boolean, min_quorum_percentage: any, quorum_smvn_total: any, nay_vote_smvn_total: any, pass_vote_smvn_total: any, yay_vote_smvn_total: any, proposal_vote_smvn_total: any, source_code: string, proposer: { __typename?: 'maven_user', address: string }, governance: { __typename?: 'governance', address: string }, votes: Array<{ __typename?: 'governance_proposal_vote', round: any, vote: any, voter: { __typename?: 'maven_user', address: string, satellites: Array<{ __typename?: 'satellite', image: string, name: string }> } }>, data: Array<{ __typename?: 'governance_proposal_data', encoded_code?: string | null, governance_proposal_id: any, code_description?: string | null, id: any, title?: string | null }>, payments: Array<{ __typename?: 'governance_proposal_payment', governance_proposal_id: any, id: any, internal_id: any, title?: string | null, token_amount?: any | null, token_id?: any | null, to_?: { __typename?: 'maven_user', address: string } | null, token?: { __typename?: 'token', token_address: string } | null }> }> };

export type GetGovernanceSatelliteConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGovernanceSatelliteConfigQuery = { __typename?: 'query_root', governance_satellite: Array<{ __typename?: 'governance_satellite', address: string, admin: string, approval_percentage: any, sat_action_duration_in_days: any, governance_satellite_counter: any, max_actions_per_satellite: any, governance: { __typename?: 'governance', address: string } }> };

export type OngoingGovernanceSatelliteActionsQueryQueryVariables = Exact<{
  currentTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type OngoingGovernanceSatelliteActionsQueryQuery = { __typename?: 'query_root', governance_satellite_action: Array<{ __typename?: 'governance_satellite_action', executed: boolean, expiration_datetime?: any | null, execution_datetime?: any | null, dropped_datetime?: any | null, governance_purpose: string, governance_type: string, id: any, nay_vote_smvn_total: any, pass_vote_smvn_total: any, smvn_percentage_for_approval: any, smvn_required_for_approval: any, snapshot_smvn_total_supply: any, start_datetime: any, status: any, yay_vote_smvn_total: any, governance_satellite: { __typename?: 'governance_satellite', address: string }, initiator: { __typename?: 'maven_user', address: string }, parameters: Array<{ __typename?: 'governance_satellite_action_parameter', name: string, value: string, id: any }>, votes: Array<{ __typename?: 'governance_satellite_action_vote', governance_satellite_action_id: any, id: any, timestamp?: any | null, vote: any, voter: { __typename?: 'maven_user', address: string } }> }> };

export type PastGovernanceSatelliteActionsQueryQueryVariables = Exact<{
  currentTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type PastGovernanceSatelliteActionsQueryQuery = { __typename?: 'query_root', governance_satellite_action: Array<{ __typename?: 'governance_satellite_action', executed: boolean, expiration_datetime?: any | null, execution_datetime?: any | null, dropped_datetime?: any | null, governance_purpose: string, governance_type: string, id: any, nay_vote_smvn_total: any, pass_vote_smvn_total: any, smvn_percentage_for_approval: any, smvn_required_for_approval: any, snapshot_smvn_total_supply: any, start_datetime: any, status: any, yay_vote_smvn_total: any, governance_satellite: { __typename?: 'governance_satellite', address: string }, initiator: { __typename?: 'maven_user', address: string }, parameters: Array<{ __typename?: 'governance_satellite_action_parameter', name: string, value: string, id: any }>, votes: Array<{ __typename?: 'governance_satellite_action_vote', governance_satellite_action_id: any, id: any, timestamp?: any | null, vote: any, voter: { __typename?: 'maven_user', address: string } }> }> };

export type UserGovernanceSatelliteActionsQueryQueryVariables = Exact<{
  userAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserGovernanceSatelliteActionsQueryQuery = { __typename?: 'query_root', governance_satellite_action: Array<{ __typename?: 'governance_satellite_action', executed: boolean, expiration_datetime?: any | null, execution_datetime?: any | null, dropped_datetime?: any | null, governance_purpose: string, governance_type: string, id: any, nay_vote_smvn_total: any, pass_vote_smvn_total: any, smvn_percentage_for_approval: any, smvn_required_for_approval: any, snapshot_smvn_total_supply: any, start_datetime: any, status: any, yay_vote_smvn_total: any, governance_satellite: { __typename?: 'governance_satellite', address: string }, initiator: { __typename?: 'maven_user', address: string }, parameters: Array<{ __typename?: 'governance_satellite_action_parameter', name: string, value: string, id: any }>, votes: Array<{ __typename?: 'governance_satellite_action_vote', governance_satellite_action_id: any, id: any, timestamp?: any | null, vote: any, voter: { __typename?: 'maven_user', address: string } }> }> };

export type SatelliteVotesQueryQueryVariables = Exact<{
  userAddress: Scalars['String']['input'];
}>;


export type SatelliteVotesQueryQuery = { __typename?: 'query_root', satellite: Array<{ __typename?: 'satellite', user: { __typename?: 'maven_user', governance_financial_requests_votes: Array<{ __typename?: 'governance_financial_request_vote', timestamp?: any | null, vote: any, id: any, governance_financial_request: { __typename?: 'governance_financial_request', request_type: string } }>, governance_proposals_votes: Array<{ __typename?: 'governance_proposal_vote', timestamp?: any | null, vote: any, id: any, governance_proposal: { __typename?: 'governance_proposal', title: string } }>, governance_satellite_actions_votes: Array<{ __typename?: 'governance_satellite_action_vote', timestamp?: any | null, vote: any, id: any, governance_satellite_action: { __typename?: 'governance_satellite_action', governance_type: string } }> } }> };

export type CheckWitherSatelliteExistsQueryVariables = Exact<{
  userAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckWitherSatelliteExistsQuery = { __typename?: 'query_root', satellite: Array<{ __typename?: 'satellite', user: { __typename?: 'maven_user', address: string } }> };

export type SatelliteDataQueryQueryVariables = Exact<{
  userAddress: Scalars['String']['input'];
}>;


export type SatelliteDataQueryQuery = { __typename?: 'query_root', satelliteAddresses: { __typename?: 'satellite_aggregate', nodes: Array<{ __typename?: 'satellite', user: { __typename?: 'maven_user', address: string } }> }, satellite: Array<{ __typename?: 'satellite', description: string, fee: any, image: string, name: string, status: any, website: string, currently_registered: boolean, peer_id?: string | null, public_key?: string | null, satellite_action_counter: any, governance_proposal_counter: any, financial_request_counter: any, total_delegated_amount: any, delegatorCount: { __typename?: 'delegation_record_aggregate', aggregate?: { __typename?: 'delegation_record_aggregate_fields', count: number } | null }, delegation: { __typename?: 'delegation', delegation_ratio: any }, user: { __typename?: 'maven_user', address: string, smvn_balance: any, mvn_balance: any, aggregator_oracles: Array<{ __typename?: 'aggregator_oracle', init_epoch: any, init_round: any, aggregator: { __typename?: 'aggregator', address: string }, observations: Array<{ __typename?: 'aggregator_oracle_observation', epoch: any, round: any, timestamp: any, data: any }>, smvnRewardsAmount: { __typename?: 'aggregator_oracle_reward_aggregate', aggregate?: { __typename?: 'aggregator_oracle_reward_aggregate_fields', sum?: { __typename?: 'aggregator_oracle_reward_sum_fields', reward?: any | null } | null } | null }, xtzRewardsAmount: { __typename?: 'aggregator_oracle_reward_aggregate', aggregate?: { __typename?: 'aggregator_oracle_reward_aggregate_fields', sum?: { __typename?: 'aggregator_oracle_reward_sum_fields', reward?: any | null } | null } | null } }>, feedsObservationsAmount: { __typename?: 'aggregator_oracle_aggregate', nodes: Array<{ __typename?: 'aggregator_oracle', observations_aggregate: { __typename?: 'aggregator_oracle_observation_aggregate', aggregate?: { __typename?: 'aggregator_oracle_observation_aggregate_fields', count: number } | null } }> }, governance_satellite_snapshots: Array<{ __typename?: 'governance_satellite_snapshot', total_voting_power: any }>, lastVotedProposal: Array<{ __typename?: 'governance_proposal_vote', vote: any, governance_proposal: { __typename?: 'governance_proposal', id: any, title: string, cycle: any, current_round_proposal: boolean, governance: { __typename?: 'governance', cycle_id: any } } }>, createdGovProposalsAmount: { __typename?: 'governance_proposal_aggregate', aggregate?: { __typename?: 'governance_proposal_aggregate_fields', count: number } | null }, createdFinRequestsAmount: { __typename?: 'governance_financial_request_aggregate', aggregate?: { __typename?: 'governance_financial_request_aggregate_fields', count: number } | null }, createdSatelliteGovActionsAmount: { __typename?: 'governance_satellite_action_aggregate', aggregate?: { __typename?: 'governance_satellite_action_aggregate_fields', count: number } | null }, govProposalsVotesAmount: { __typename?: 'governance_proposal_vote_aggregate', aggregate?: { __typename?: 'governance_proposal_vote_aggregate_fields', count: number } | null }, finRequestsVotesAmount: { __typename?: 'governance_financial_request_vote_aggregate', aggregate?: { __typename?: 'governance_financial_request_vote_aggregate_fields', count: number } | null }, satelliteGovActionsVotesAmount: { __typename?: 'governance_satellite_action_vote_aggregate', aggregate?: { __typename?: 'governance_satellite_action_vote_aggregate_fields', count: number } | null } } }> };

export type ActiveSatellitesDataQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveSatellitesDataQueryQuery = { __typename?: 'query_root', satelliteAddresses: { __typename?: 'satellite_aggregate', nodes: Array<{ __typename?: 'satellite', user: { __typename?: 'maven_user', address: string } }> }, satellite: Array<{ __typename?: 'satellite', description: string, fee: any, image: string, name: string, status: any, website: string, currently_registered: boolean, peer_id?: string | null, public_key?: string | null, satellite_action_counter: any, governance_proposal_counter: any, financial_request_counter: any, total_delegated_amount: any, delegatorCount: { __typename?: 'delegation_record_aggregate', aggregate?: { __typename?: 'delegation_record_aggregate_fields', count: number } | null }, delegation: { __typename?: 'delegation', delegation_ratio: any }, user: { __typename?: 'maven_user', address: string, smvn_balance: any, mvn_balance: any, aggregator_oracles: Array<{ __typename?: 'aggregator_oracle', init_epoch: any, init_round: any, aggregator: { __typename?: 'aggregator', address: string }, observations: Array<{ __typename?: 'aggregator_oracle_observation', epoch: any, round: any, timestamp: any, data: any }>, smvnRewardsAmount: { __typename?: 'aggregator_oracle_reward_aggregate', aggregate?: { __typename?: 'aggregator_oracle_reward_aggregate_fields', sum?: { __typename?: 'aggregator_oracle_reward_sum_fields', reward?: any | null } | null } | null }, xtzRewardsAmount: { __typename?: 'aggregator_oracle_reward_aggregate', aggregate?: { __typename?: 'aggregator_oracle_reward_aggregate_fields', sum?: { __typename?: 'aggregator_oracle_reward_sum_fields', reward?: any | null } | null } | null } }>, feedsObservationsAmount: { __typename?: 'aggregator_oracle_aggregate', nodes: Array<{ __typename?: 'aggregator_oracle', observations_aggregate: { __typename?: 'aggregator_oracle_observation_aggregate', aggregate?: { __typename?: 'aggregator_oracle_observation_aggregate_fields', count: number } | null } }> }, governance_satellite_snapshots: Array<{ __typename?: 'governance_satellite_snapshot', total_voting_power: any }>, lastVotedProposal: Array<{ __typename?: 'governance_proposal_vote', vote: any, governance_proposal: { __typename?: 'governance_proposal', id: any, title: string, cycle: any, current_round_proposal: boolean, governance: { __typename?: 'governance', cycle_id: any } } }>, createdGovProposalsAmount: { __typename?: 'governance_proposal_aggregate', aggregate?: { __typename?: 'governance_proposal_aggregate_fields', count: number } | null }, createdFinRequestsAmount: { __typename?: 'governance_financial_request_aggregate', aggregate?: { __typename?: 'governance_financial_request_aggregate_fields', count: number } | null }, createdSatelliteGovActionsAmount: { __typename?: 'governance_satellite_action_aggregate', aggregate?: { __typename?: 'governance_satellite_action_aggregate_fields', count: number } | null }, govProposalsVotesAmount: { __typename?: 'governance_proposal_vote_aggregate', aggregate?: { __typename?: 'governance_proposal_vote_aggregate_fields', count: number } | null }, finRequestsVotesAmount: { __typename?: 'governance_financial_request_vote_aggregate', aggregate?: { __typename?: 'governance_financial_request_vote_aggregate_fields', count: number } | null }, satelliteGovActionsVotesAmount: { __typename?: 'governance_satellite_action_vote_aggregate', aggregate?: { __typename?: 'governance_satellite_action_vote_aggregate_fields', count: number } | null } } }> };

export type AllSatellitesDataQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSatellitesDataQueryQuery = { __typename?: 'query_root', satelliteAddresses: { __typename?: 'satellite_aggregate', nodes: Array<{ __typename?: 'satellite', user: { __typename?: 'maven_user', address: string } }> }, satellite: Array<{ __typename?: 'satellite', description: string, fee: any, image: string, name: string, status: any, website: string, currently_registered: boolean, peer_id?: string | null, public_key?: string | null, satellite_action_counter: any, governance_proposal_counter: any, financial_request_counter: any, total_delegated_amount: any, delegatorCount: { __typename?: 'delegation_record_aggregate', aggregate?: { __typename?: 'delegation_record_aggregate_fields', count: number } | null }, delegation: { __typename?: 'delegation', delegation_ratio: any }, user: { __typename?: 'maven_user', address: string, smvn_balance: any, mvn_balance: any, aggregator_oracles: Array<{ __typename?: 'aggregator_oracle', init_epoch: any, init_round: any, aggregator: { __typename?: 'aggregator', address: string }, observations: Array<{ __typename?: 'aggregator_oracle_observation', epoch: any, round: any, timestamp: any, data: any }>, smvnRewardsAmount: { __typename?: 'aggregator_oracle_reward_aggregate', aggregate?: { __typename?: 'aggregator_oracle_reward_aggregate_fields', sum?: { __typename?: 'aggregator_oracle_reward_sum_fields', reward?: any | null } | null } | null }, xtzRewardsAmount: { __typename?: 'aggregator_oracle_reward_aggregate', aggregate?: { __typename?: 'aggregator_oracle_reward_aggregate_fields', sum?: { __typename?: 'aggregator_oracle_reward_sum_fields', reward?: any | null } | null } | null } }>, feedsObservationsAmount: { __typename?: 'aggregator_oracle_aggregate', nodes: Array<{ __typename?: 'aggregator_oracle', observations_aggregate: { __typename?: 'aggregator_oracle_observation_aggregate', aggregate?: { __typename?: 'aggregator_oracle_observation_aggregate_fields', count: number } | null } }> }, governance_satellite_snapshots: Array<{ __typename?: 'governance_satellite_snapshot', total_voting_power: any }>, lastVotedProposal: Array<{ __typename?: 'governance_proposal_vote', vote: any, governance_proposal: { __typename?: 'governance_proposal', id: any, title: string, cycle: any, current_round_proposal: boolean, governance: { __typename?: 'governance', cycle_id: any } } }>, createdGovProposalsAmount: { __typename?: 'governance_proposal_aggregate', aggregate?: { __typename?: 'governance_proposal_aggregate_fields', count: number } | null }, createdFinRequestsAmount: { __typename?: 'governance_financial_request_aggregate', aggregate?: { __typename?: 'governance_financial_request_aggregate_fields', count: number } | null }, createdSatelliteGovActionsAmount: { __typename?: 'governance_satellite_action_aggregate', aggregate?: { __typename?: 'governance_satellite_action_aggregate_fields', count: number } | null }, govProposalsVotesAmount: { __typename?: 'governance_proposal_vote_aggregate', aggregate?: { __typename?: 'governance_proposal_vote_aggregate_fields', count: number } | null }, finRequestsVotesAmount: { __typename?: 'governance_financial_request_vote_aggregate', aggregate?: { __typename?: 'governance_financial_request_vote_aggregate_fields', count: number } | null }, satelliteGovActionsVotesAmount: { __typename?: 'governance_satellite_action_vote_aggregate', aggregate?: { __typename?: 'governance_satellite_action_vote_aggregate_fields', count: number } | null } } }> };

export type OraclesSatellitesDataQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type OraclesSatellitesDataQueryQuery = { __typename?: 'query_root', satelliteAddresses: { __typename?: 'satellite_aggregate', nodes: Array<{ __typename?: 'satellite', user: { __typename?: 'maven_user', address: string } }> }, satellite: Array<{ __typename?: 'satellite', description: string, fee: any, image: string, name: string, status: any, website: string, currently_registered: boolean, peer_id?: string | null, public_key?: string | null, satellite_action_counter: any, governance_proposal_counter: any, financial_request_counter: any, total_delegated_amount: any, delegatorCount: { __typename?: 'delegation_record_aggregate', aggregate?: { __typename?: 'delegation_record_aggregate_fields', count: number } | null }, delegation: { __typename?: 'delegation', delegation_ratio: any }, user: { __typename?: 'maven_user', address: string, smvn_balance: any, mvn_balance: any, aggregator_oracles: Array<{ __typename?: 'aggregator_oracle', init_epoch: any, init_round: any, aggregator: { __typename?: 'aggregator', address: string }, observations: Array<{ __typename?: 'aggregator_oracle_observation', epoch: any, round: any, timestamp: any, data: any }>, smvnRewardsAmount: { __typename?: 'aggregator_oracle_reward_aggregate', aggregate?: { __typename?: 'aggregator_oracle_reward_aggregate_fields', sum?: { __typename?: 'aggregator_oracle_reward_sum_fields', reward?: any | null } | null } | null }, xtzRewardsAmount: { __typename?: 'aggregator_oracle_reward_aggregate', aggregate?: { __typename?: 'aggregator_oracle_reward_aggregate_fields', sum?: { __typename?: 'aggregator_oracle_reward_sum_fields', reward?: any | null } | null } | null } }>, feedsObservationsAmount: { __typename?: 'aggregator_oracle_aggregate', nodes: Array<{ __typename?: 'aggregator_oracle', observations_aggregate: { __typename?: 'aggregator_oracle_observation_aggregate', aggregate?: { __typename?: 'aggregator_oracle_observation_aggregate_fields', count: number } | null } }> }, governance_satellite_snapshots: Array<{ __typename?: 'governance_satellite_snapshot', total_voting_power: any }>, lastVotedProposal: Array<{ __typename?: 'governance_proposal_vote', vote: any, governance_proposal: { __typename?: 'governance_proposal', id: any, title: string, cycle: any, current_round_proposal: boolean, governance: { __typename?: 'governance', cycle_id: any } } }>, createdGovProposalsAmount: { __typename?: 'governance_proposal_aggregate', aggregate?: { __typename?: 'governance_proposal_aggregate_fields', count: number } | null }, createdFinRequestsAmount: { __typename?: 'governance_financial_request_aggregate', aggregate?: { __typename?: 'governance_financial_request_aggregate_fields', count: number } | null }, createdSatelliteGovActionsAmount: { __typename?: 'governance_satellite_action_aggregate', aggregate?: { __typename?: 'governance_satellite_action_aggregate_fields', count: number } | null }, govProposalsVotesAmount: { __typename?: 'governance_proposal_vote_aggregate', aggregate?: { __typename?: 'governance_proposal_vote_aggregate_fields', count: number } | null }, finRequestsVotesAmount: { __typename?: 'governance_financial_request_vote_aggregate', aggregate?: { __typename?: 'governance_financial_request_vote_aggregate_fields', count: number } | null }, satelliteGovActionsVotesAmount: { __typename?: 'governance_satellite_action_vote_aggregate', aggregate?: { __typename?: 'governance_satellite_action_vote_aggregate_fields', count: number } | null } } }> };

export type DappDataForSatelliteMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type DappDataForSatelliteMetricsQuery = { __typename?: 'query_root', governance_proposal_aggregate: { __typename?: 'governance_proposal_aggregate', aggregate?: { __typename?: 'governance_proposal_aggregate_fields', count: number } | null }, governance_satellite_action_aggregate: { __typename?: 'governance_satellite_action_aggregate', aggregate?: { __typename?: 'governance_satellite_action_aggregate_fields', count: number } | null }, governance_financial_request_aggregate: { __typename?: 'governance_financial_request_aggregate', aggregate?: { __typename?: 'governance_financial_request_aggregate_fields', count: number } | null } };

export type SatellitesStatsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SatellitesStatsQueryQuery = { __typename?: 'query_root', oraclesAmount: { __typename?: 'satellite_aggregate', aggregate?: { __typename?: 'satellite_aggregate_fields', count: number } | null }, activeSatellitesAmount: { __typename?: 'satellite_aggregate', aggregate?: { __typename?: 'satellite_aggregate_fields', count: number } | null }, oraclesRewards: { __typename?: 'aggregator_oracle_reward_aggregate', aggregate?: { __typename?: 'aggregator_oracle_reward_aggregate_fields', count: number, sum?: { __typename?: 'aggregator_oracle_reward_sum_fields', reward?: any | null } | null } | null }, satellite_aggregate: { __typename?: 'satellite_aggregate', nodes: Array<{ __typename?: 'satellite', user: { __typename?: 'maven_user', smvn_balance: any }, delegations: Array<{ __typename?: 'delegation_record', user: { __typename?: 'maven_user', smvn_balance: any } }> }> } };

export type TokensMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type TokensMetadataQuery = { __typename?: 'query_root', token: Array<{ __typename?: 'token', token_id: any, metadata?: any | null, token_address: string, token_standard?: string | null, lending_controller_collateral_tokens: Array<{ __typename?: 'lending_controller_collateral_token', token_name: string, paused: boolean, is_scaled_token: boolean, is_staked_token: boolean }>, lending_controller_loan_tokens: Array<{ __typename?: 'lending_controller_loan_token', loan_token_name: string, min_repayment_amount: any }>, m_tokens: Array<{ __typename?: 'm_token', metadata: any, address: string }>, mvn_tokens: Array<{ __typename?: 'mvn_token', address: string }>, farms_lp_tokens: Array<{ __typename?: 'farm', name: string, metadata?: any | null, token0?: { __typename?: 'token', token_address: string, metadata?: any | null } | null, token1?: { __typename?: 'token', token_address: string, metadata?: any | null } | null }> }> };

export type GetTreasuryStorageDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTreasuryStorageDataQuery = { __typename?: 'query_root', treasury: Array<{ __typename?: 'treasury', address: string, admin: string, creation_timestamp?: any | null, name: string, balances: Array<{ __typename?: 'treasury_balance', balance: any, token: { __typename?: 'token', token_address: string } }> }> };

export type GetTreasurySmvnBalancesQueryVariables = Exact<{
  addresses?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetTreasurySmvnBalancesQuery = { __typename?: 'query_root', maven_user: Array<{ __typename?: 'maven_user', smvn_balance: any, address: string }> };

export type GetUserDataQueryVariables = Exact<{
  userAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserDataQuery = { __typename?: 'query_root', maven_user: Array<{ __typename?: 'maven_user', address: string, smvn_balance: any, mvn_balance: any, m_token_accounts: Array<{ __typename?: 'm_token_account', balance: any, rewards_earned: any, reward_index: any, m_token: { __typename?: 'm_token', token_reward_index: any, address: string, metadata: any } }>, delegations: Array<{ __typename?: 'delegation_record', satellite: { __typename?: 'satellite', user: { __typename?: 'maven_user', address: string } } }>, satellites: Array<{ __typename?: 'satellite', currently_registered: boolean, status: any, image: string, name: string, user: { __typename?: 'maven_user', address: string } }>, council_council_members: Array<{ __typename?: 'council_council_member', image: string, user: { __typename?: 'maven_user', address: string } }>, break_glass_council_members: Array<{ __typename?: 'break_glass_council_member', image: string, user: { __typename?: 'maven_user', address: string } }>, vesting_vestees: Array<{ __typename?: 'vesting_vestee', end_vesting_timestamp: any }>, governance_satellite_snapshots: Array<{ __typename?: 'governance_satellite_snapshot', cycle: any, ready: boolean, next_snapshot_cycle_id?: any | null, governance: { __typename?: 'governance', cycle_id: any } }>, governance_satellite_action_initiators_aggregate: { __typename?: 'governance_satellite_action_aggregate', aggregate?: { __typename?: 'governance_satellite_action_aggregate_fields', count: number } | null } }> };

export type GetUserActionsHistoryDataQueryVariables = Exact<{
  userAddress?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUserActionsHistoryDataQuery = { __typename?: 'query_root', maven_user: Array<{ __typename?: 'maven_user', stakes_history_data: Array<{ __typename?: 'stake_history_data', type: any, id: any, timestamp: any, desired_amount: any, final_amount: any, from_: { __typename?: 'maven_user', mvn_balance: any, smvn_balance: any } }>, historyItemsAmount: { __typename?: 'stake_history_data_aggregate', aggregate?: { __typename?: 'stake_history_data_aggregate_fields', count: number } | null } }> };

export type GetUserEarningHistoryDataQueryVariables = Exact<{
  userAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserEarningHistoryDataQuery = { __typename?: 'query_root', maven_user: Array<{ __typename?: 'maven_user', stakes_history_data: Array<{ __typename?: 'stake_history_data', timestamp: any, desired_amount: any, final_amount: any }>, farm_accounts: Array<{ __typename?: 'farm_account', claimed_rewards: any }> }> };

export type GetUserRewardsDataQueryVariables = Exact<{
  userAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserRewardsDataQuery = { __typename?: 'query_root', governance_proposal: Array<{ __typename?: 'governance_proposal', id: any }>, maven_user: Array<{ __typename?: 'maven_user', smvn_balance: any, doorman_stake_accounts: Array<{ __typename?: 'doorman_stake_account', total_satellite_rewards_claimed: any, total_exit_fee_rewards_claimed: any, participation_fees_per_share: any, smvn_balance: any, doorman: { __typename?: 'doorman', unclaimed_rewards: any, accumulated_fees_per_share: any } }>, satellite_rewardss: Array<{ __typename?: 'satellite_rewards', unpaid: any, participation_rewards_per_share: any, reference?: { __typename?: 'satellite_rewards', satellite_accumulated_reward_per_share: any } | null }>, farm_accounts: Array<{ __typename?: 'farm_account', claimed_rewards: any, deposited_amount: any, participation_rewards_per_share: any, farm: { __typename?: 'farm', address: string, accumulated_rewards_per_share: any, current_reward_per_block: any, last_block_update: any, total_rewards: any, paid_rewards: any, unpaid_rewards: any, infinite: boolean, lp_token_balance: any } }> }> };

export type GetUserLoansDataQueryVariables = Exact<{
  userAddress?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['smallint']['input']> | Scalars['smallint']['input']>;
}>;


export type GetUserLoansDataQuery = { __typename?: 'query_root', maven_user: Array<{ __typename?: 'maven_user', lending_controller_history_data_sender: Array<{ __typename?: 'lending_controller_history_data', id: any, type: any, timestamp: any, operation_hash: string, amount: any, loan_token?: { __typename?: 'lending_controller_loan_token', current_interest_rate: any, utilisation_rate: any, token: { __typename?: 'token', token_address: string } } | null, lending_controller: { __typename?: 'lending_controller', interest_rate_decimals: any, interest_treasury_share: any, decimals: any } }>, lending_controller_vaults: Array<{ __typename?: 'lending_controller_vault', loan_decimals: any, loan_principal_total: any, loan_interest_total: any, collateral_balances: Array<{ __typename?: 'lending_controller_vault_collateral_balance', balance: any, collateral_token: { __typename?: 'lending_controller_collateral_token', token: { __typename?: 'token', token_address: string } } }>, loan_token: { __typename?: 'lending_controller_loan_token', token: { __typename?: 'token', token_address: string } } }> }> };

export type GetUsersLastestCreatedVaultQueryVariables = Exact<{
  userAddress?: InputMaybe<Scalars['String']['input']>;
  vaultName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUsersLastestCreatedVaultQuery = { __typename?: 'query_root', vault: Array<{ __typename?: 'vault', name: string, address: string, creation_timestamp?: any | null, id: any }> };

export type GetUserVaultsNamesQueryQueryVariables = Exact<{
  userAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserVaultsNamesQueryQuery = { __typename?: 'query_root', lending_controller: Array<{ __typename?: 'lending_controller', vaults: Array<{ __typename?: 'lending_controller_vault', vault?: { __typename?: 'vault', name: string } | null }> }> };

export type GetVaultAccIntIndexesQueryQueryVariables = Exact<{
  vaultAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetVaultAccIntIndexesQueryQuery = { __typename?: 'query_root', lending_controller: Array<{ __typename?: 'lending_controller', vaults: Array<{ __typename?: 'lending_controller_vault', loan_interest_total: any, borrow_index: any, last_updated_block_level: any, loan_token: { __typename?: 'lending_controller_loan_token', borrow_index: any, token: { __typename?: 'token', metadata?: any | null } } }> }> };

export type GetUserDepositorAllVaultsQueryQueryVariables = Exact<{
  userAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserDepositorAllVaultsQueryQuery = { __typename?: 'query_root', lending_controller: Array<{ __typename?: 'lending_controller', max_vault_liquidation_pct: any, decimals: any, liquidation_fee_pct: any, liquidation_ratio: any, interest_rate_decimals: any, admin_liquidation_fee_pct: any, liquidation_delay_in_minutes: any, vaults: Array<{ __typename?: 'lending_controller_vault', last_updated_block_level: any, marked_for_liquidation_level: any, liquidation_end_level: any, loan_outstanding_total: any, loan_principal_total: any, loan_interest_total: any, internal_id: any, borrow_index: any, collateral_balances: Array<{ __typename?: 'lending_controller_vault_collateral_balance', balance: any, collateral_token: { __typename?: 'lending_controller_collateral_token', token_name: string, token: { __typename?: 'token', token_address: string } } }>, vault?: { __typename?: 'vault', creation_timestamp?: any | null, address: string, name: string, allowance: any, baker?: { __typename?: 'maven_user', address: string } | null, depositors: Array<{ __typename?: 'vault_depositor', depositor: { __typename?: 'maven_user', address: string } }> } | null, loan_token: { __typename?: 'lending_controller_loan_token', current_interest_rate: any, borrow_index: any, total_remaining: any, token_pool_total: any, reserve_ratio: any, min_repayment_amount: any, token: { __typename?: 'token', token_address: string } }, owner: { __typename?: 'maven_user', address: string } }> }> };

export type GetUserAllVaultsQueryQueryVariables = Exact<{
  userAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserAllVaultsQueryQuery = { __typename?: 'query_root', lending_controller: Array<{ __typename?: 'lending_controller', max_vault_liquidation_pct: any, decimals: any, liquidation_fee_pct: any, liquidation_ratio: any, interest_rate_decimals: any, admin_liquidation_fee_pct: any, liquidation_delay_in_minutes: any, vaults: Array<{ __typename?: 'lending_controller_vault', last_updated_block_level: any, marked_for_liquidation_level: any, liquidation_end_level: any, loan_outstanding_total: any, loan_principal_total: any, loan_interest_total: any, internal_id: any, borrow_index: any, collateral_balances: Array<{ __typename?: 'lending_controller_vault_collateral_balance', balance: any, collateral_token: { __typename?: 'lending_controller_collateral_token', token_name: string, token: { __typename?: 'token', token_address: string } } }>, vault?: { __typename?: 'vault', creation_timestamp?: any | null, address: string, name: string, allowance: any, baker?: { __typename?: 'maven_user', address: string } | null, depositors: Array<{ __typename?: 'vault_depositor', depositor: { __typename?: 'maven_user', address: string } }> } | null, loan_token: { __typename?: 'lending_controller_loan_token', current_interest_rate: any, borrow_index: any, total_remaining: any, token_pool_total: any, reserve_ratio: any, min_repayment_amount: any, token: { __typename?: 'token', token_address: string } }, owner: { __typename?: 'maven_user', address: string } }> }> };

export type GetAllVaultsQueryQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllVaultsQueryQuery = { __typename?: 'query_root', lending_controller: Array<{ __typename?: 'lending_controller', max_vault_liquidation_pct: any, decimals: any, liquidation_fee_pct: any, liquidation_ratio: any, interest_rate_decimals: any, admin_liquidation_fee_pct: any, liquidation_delay_in_minutes: any }>, vaults: Array<{ __typename?: 'gql_vault_with_balances', vault_address?: string | null, vault_name?: string | null, owner_address?: string | null, loan_token_address?: string | null, loan_outstanding_total?: any | null, loan_principal_total?: any | null, loan_interest_total?: any | null, collateral_json?: any | null, depositors_json?: any | null, is_open?: boolean | null, current_interest_rate?: any | null, borrow_index?: any | null, total_remaining?: any | null, token_pool_total?: any | null, reserve_ratio?: any | null, min_repayment_amount?: any | null, allowance?: any | null, creation_timestamp?: any | null, baker_address?: string | null, last_updated_block_level?: any | null, marked_for_liquidation_level?: any | null, liquidation_end_level?: any | null, internal_id?: any | null }> };

export type GetVaultCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVaultCountQuery = { __typename?: 'query_root', vault_aggregate: { __typename?: 'vault_aggregate', aggregate?: { __typename?: 'vault_aggregate_fields', count: number } | null } };

export type DashboardVaultsTabDataQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardVaultsTabDataQuery = { __typename?: 'query_root', lending_controller: Array<{ __typename?: 'lending_controller', allVaultsCollaterals: Array<{ __typename?: 'lending_controller_collateral_token', token: { __typename?: 'token', token_address: string }, balances_aggregate: { __typename?: 'lending_controller_vault_collateral_balance_aggregate', aggregate?: { __typename?: 'lending_controller_vault_collateral_balance_aggregate_fields', sum?: { __typename?: 'lending_controller_vault_collateral_balance_sum_fields', balance?: any | null } | null } | null } }>, collateralsForActiveVaults: Array<{ __typename?: 'lending_controller_collateral_token', token: { __typename?: 'token', token_address: string }, balances_aggregate: { __typename?: 'lending_controller_vault_collateral_balance_aggregate', aggregate?: { __typename?: 'lending_controller_vault_collateral_balance_aggregate_fields', sum?: { __typename?: 'lending_controller_vault_collateral_balance_sum_fields', balance?: any | null } | null } | null } }>, activeVaults: { __typename?: 'lending_controller_vault_aggregate', aggregate?: { __typename?: 'lending_controller_vault_aggregate_fields', count: number } | null }, borrowedFromMarkets: Array<{ __typename?: 'lending_controller_loan_token', total_borrowed: any, token: { __typename?: 'token', token_address: string } }> }> };

export type GetVestingQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVestingQueryQuery = { __typename?: 'query_root', vesting: Array<{ __typename?: 'vesting', address: string, admin: string, governance_id: any, total_vested_amount: any, vestees_aggregate: { __typename?: 'vesting_vestee_aggregate', aggregate?: { __typename?: 'vesting_vestee_aggregate_fields', sum?: { __typename?: 'vesting_vestee_sum_fields', total_claimed?: any | null, total_remainder?: any | null } | null } | null }, vestees: Array<{ __typename?: 'vesting_vestee', locked: boolean, total_remainder: any, total_allocated_amount: any, claim_amount_per_month: any, cliff_months: any, vesting_months: any, next_redemption_timestamp: any, last_claimed_timestamp: any, end_cliff_timestamp: any, vestee: { __typename?: 'maven_user', address: string } }> }> };


export const GlassBrokenStatusAndWhiteListDevsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"glassBrokenStatusAndWhiteListDevs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"break_glass"},"name":{"kind":"Name","value":"break_glass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"glass_broken"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"whitelist_developer"},"name":{"kind":"Name","value":"whitelist_developer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"developer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]}}]} as unknown as DocumentNode<GlassBrokenStatusAndWhiteListDevsQuery, GlassBrokenStatusAndWhiteListDevsQueryVariables>;
export const GetAllContractStatusesDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllContractStatusesData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"farm"},"name":{"kind":"Name","value":"farm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"admin"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"claim_paused"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_paused"}},{"kind":"Field","name":{"kind":"Name","value":"withdraw_paused"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"last_updated_at"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"farm_factory"},"name":{"kind":"Name","value":"farm_factory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"admin"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create_farm_paused"}},{"kind":"Field","name":{"kind":"Name","value":"create_farm_m_token_paused"}},{"kind":"Field","name":{"kind":"Name","value":"track_farm_paused"}},{"kind":"Field","name":{"kind":"Name","value":"untrack_farm_paused"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"last_updated_at"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"delegation"},"name":{"kind":"Name","value":"delegation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"admin"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delegate_to_satellite_paused"}},{"kind":"Field","name":{"kind":"Name","value":"distribute_reward_paused"}},{"kind":"Field","name":{"kind":"Name","value":"register_as_satellite_paused"}},{"kind":"Field","name":{"kind":"Name","value":"undelegate_from_satellite_paused"}},{"kind":"Field","name":{"kind":"Name","value":"unregister_as_satellite_paused"}},{"kind":"Field","name":{"kind":"Name","value":"update_satellite_record_paused"}},{"kind":"Field","name":{"kind":"Name","value":"take_satellites_snapshot_paused"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"last_updated_at"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"doorman"},"name":{"kind":"Name","value":"doorman"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"admin"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"compound_paused"}},{"kind":"Field","name":{"kind":"Name","value":"farm_claim_paused"}},{"kind":"Field","name":{"kind":"Name","value":"stake_mvn_paused"}},{"kind":"Field","name":{"kind":"Name","value":"unstake_mvn_paused"}},{"kind":"Field","name":{"kind":"Name","value":"exit_paused"}},{"kind":"Field","name":{"kind":"Name","value":"on_vault_deposit_stake_paused"}},{"kind":"Field","name":{"kind":"Name","value":"on_vault_liquidate_stake_paused"}},{"kind":"Field","name":{"kind":"Name","value":"on_vault_withdraw_stake_paused"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"last_updated_at"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"treasury"},"name":{"kind":"Name","value":"treasury"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"admin"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"mint_mvn_and_transfer_paused"}},{"kind":"Field","name":{"kind":"Name","value":"stake_tokens_paused"}},{"kind":"Field","name":{"kind":"Name","value":"transfer_paused"}},{"kind":"Field","name":{"kind":"Name","value":"unstake_tokens_paused"}},{"kind":"Field","name":{"kind":"Name","value":"update_token_operators_paused"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"last_updated_at"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"treasury_factory"},"name":{"kind":"Name","value":"treasury_factory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"admin"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create_treasury_paused"}},{"kind":"Field","name":{"kind":"Name","value":"track_treasury_paused"}},{"kind":"Field","name":{"kind":"Name","value":"untrack_treasury_paused"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"last_updated_at"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"aggregator"},"name":{"kind":"Name","value":"aggregator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"admin"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"withdraw_reward_smvn_paused"}},{"kind":"Field","name":{"kind":"Name","value":"withdraw_reward_mvrk_paused"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"last_updated_at"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"aggregator_factory"},"name":{"kind":"Name","value":"aggregator_factory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"admin"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"untrack_aggregator_paused"}},{"kind":"Field","name":{"kind":"Name","value":"track_aggregator_paused"}},{"kind":"Field","name":{"kind":"Name","value":"distribute_reward_mvrk_paused"}},{"kind":"Field","name":{"kind":"Name","value":"distribute_reward_smvn_paused"}},{"kind":"Field","name":{"kind":"Name","value":"create_aggregator_paused"}},{"kind":"Field","name":{"kind":"Name","value":"last_updated_at"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lending_controller"},"name":{"kind":"Name","value":"lending_controller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"last_updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"add_liquidity_paused"}},{"kind":"Field","name":{"kind":"Name","value":"close_vault_paused"}},{"kind":"Field","name":{"kind":"Name","value":"liquidate_vault_paused"}},{"kind":"Field","name":{"kind":"Name","value":"mark_for_liquidation_paused"}},{"kind":"Field","name":{"kind":"Name","value":"register_deposit_paused"}},{"kind":"Field","name":{"kind":"Name","value":"register_vault_creation_paused"}},{"kind":"Field","name":{"kind":"Name","value":"register_withdrawal_paused"}},{"kind":"Field","name":{"kind":"Name","value":"remove_liquidity_paused"}},{"kind":"Field","name":{"kind":"Name","value":"repay_paused"}},{"kind":"Field","name":{"kind":"Name","value":"set_collateral_token_paused"}},{"kind":"Field","name":{"kind":"Name","value":"set_loan_token_paused"}},{"kind":"Field","name":{"kind":"Name","value":"vault_deposit_paused"}},{"kind":"Field","name":{"kind":"Name","value":"vault_deposit_staked_token_paused"}},{"kind":"Field","name":{"kind":"Name","value":"vault_on_liquidate_paused"}},{"kind":"Field","name":{"kind":"Name","value":"vault_withdraw_paused"}},{"kind":"Field","name":{"kind":"Name","value":"vault_withdraw_staked_token_paused"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"vault_factory"},"name":{"kind":"Name","value":"vault_factory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"create_vault_paused"}},{"kind":"Field","name":{"kind":"Name","value":"last_updated_at"}}]}}]}}]} as unknown as DocumentNode<GetAllContractStatusesDataQuery, GetAllContractStatusesDataQueryVariables>;
export const GetBreakGlassCouncilMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBreakGlassCouncilMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"break_glass_council_member"},"name":{"kind":"Name","value":"break_glass_council_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"satellites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currently_registered"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBreakGlassCouncilMembersQuery, GetBreakGlassCouncilMembersQueryVariables>;
export const GetBgAllPastCouncilActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBgAllPastCouncilActions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}},"defaultValue":{"kind":"StringValue","value":"1970-01-01T00:00:00.000Z","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"break_glass_action"},"name":{"kind":"Name","value":"break_glass_action"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start_datetime"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expiration_datetime"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentTimestamp"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"1","block":false},{"kind":"StringValue","value":"2","block":false}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action_type"}},{"kind":"Field","name":{"kind":"Name","value":"signers_count"}},{"kind":"Field","name":{"kind":"Name","value":"start_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"executed"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"council_size_snapshot"}},{"kind":"Field","name":{"kind":"Name","value":"expiration_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"initiator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"break_glass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"parameters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<GetBgAllPastCouncilActionsQuery, GetBgAllPastCouncilActionsQueryVariables>;
export const GetBgAllOngoingCouncilActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBgAllOngoingCouncilActions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}},"defaultValue":{"kind":"StringValue","value":"1970-01-01T00:00:00.000Z","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"break_glass_action"},"name":{"kind":"Name","value":"break_glass_action"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start_datetime"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"0","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"expiration_datetime"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentTimestamp"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action_type"}},{"kind":"Field","name":{"kind":"Name","value":"signers_count"}},{"kind":"Field","name":{"kind":"Name","value":"start_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"executed"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"council_size_snapshot"}},{"kind":"Field","name":{"kind":"Name","value":"expiration_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"initiator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"break_glass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"parameters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<GetBgAllOngoingCouncilActionsQuery, GetBgAllOngoingCouncilActionsQueryVariables>;
export const GetBgMyPastCouncilActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBgMyPastCouncilActions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}},"defaultValue":{"kind":"StringValue","value":"1970-01-01T00:00:00.000Z","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"break_glass_action"},"name":{"kind":"Name","value":"break_glass_action"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start_datetime"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expiration_datetime"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentTimestamp"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"1","block":false},{"kind":"StringValue","value":"2","block":false}]}}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"initiator"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}}}]}}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expiration_datetime"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentTimestamp"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"0","block":false}}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"initiator"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}}}]}}]}}]}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action_type"}},{"kind":"Field","name":{"kind":"Name","value":"signers_count"}},{"kind":"Field","name":{"kind":"Name","value":"start_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"executed"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"council_size_snapshot"}},{"kind":"Field","name":{"kind":"Name","value":"expiration_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"initiator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"break_glass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"parameters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<GetBgMyPastCouncilActionsQuery, GetBgMyPastCouncilActionsQueryVariables>;
export const GetCouncilMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCouncilMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"council"},"name":{"kind":"Name","value":"council"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"satellites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currently_registered"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCouncilMembersQuery, GetCouncilMembersQueryVariables>;
export const GetAllPastCouncilActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllPastCouncilActions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}},"defaultValue":{"kind":"StringValue","value":"1970-01-01T00:00:00.000Z","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"council_action"},"name":{"kind":"Name","value":"council_action"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start_datetime"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expiration_datetime"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentTimestamp"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"1","block":false},{"kind":"StringValue","value":"2","block":false}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action_type"}},{"kind":"Field","name":{"kind":"Name","value":"executed"}},{"kind":"Field","name":{"kind":"Name","value":"council_size_snapshot"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"signers_count"}},{"kind":"Field","name":{"kind":"Name","value":"start_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"expiration_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"council"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"parameters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllPastCouncilActionsQuery, GetAllPastCouncilActionsQueryVariables>;
export const GetAllOngoingCouncilActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllOngoingCouncilActions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}},"defaultValue":{"kind":"StringValue","value":"1970-01-01T00:00:00.000Z","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"council_action"},"name":{"kind":"Name","value":"council_action"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start_datetime"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"0","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"expiration_datetime"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentTimestamp"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action_type"}},{"kind":"Field","name":{"kind":"Name","value":"executed"}},{"kind":"Field","name":{"kind":"Name","value":"council_size_snapshot"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"signers_count"}},{"kind":"Field","name":{"kind":"Name","value":"start_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"expiration_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"council"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"parameters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllOngoingCouncilActionsQuery, GetAllOngoingCouncilActionsQueryVariables>;
export const GetMyPastCouncilActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyPastCouncilActions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}},"defaultValue":{"kind":"StringValue","value":"1970-01-01T00:00:00.000Z","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"council_action"},"name":{"kind":"Name","value":"council_action"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start_datetime"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expiration_datetime"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentTimestamp"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"1","block":false},{"kind":"StringValue","value":"2","block":false}]}}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"initiator"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}}}]}}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expiration_datetime"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentTimestamp"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"0","block":false}}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"initiator"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}}}]}}]}}]}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action_type"}},{"kind":"Field","name":{"kind":"Name","value":"executed"}},{"kind":"Field","name":{"kind":"Name","value":"council_size_snapshot"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"signers_count"}},{"kind":"Field","name":{"kind":"Name","value":"start_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"expiration_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"council"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"parameters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<GetMyPastCouncilActionsQuery, GetMyPastCouncilActionsQueryVariables>;
export const GetContractAddressesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getContractAddressesQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"delegation"},"name":{"kind":"Name","value":"delegation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"doorman"},"name":{"kind":"Name","value":"doorman"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"mvn_token"},"name":{"kind":"Name","value":"mvn_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"farm"},"name":{"kind":"Name","value":"farm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"farm_factory"},"name":{"kind":"Name","value":"farm_factory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"council"},"name":{"kind":"Name","value":"council"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"break_glass"},"name":{"kind":"Name","value":"break_glass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"emergency_governance"},"name":{"kind":"Name","value":"emergency_governance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"governance"},"name":{"kind":"Name","value":"governance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"governance_proxy"},"name":{"kind":"Name","value":"governance_proxy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"treasury"},"name":{"kind":"Name","value":"treasury"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"treasury_factory"},"name":{"kind":"Name","value":"treasury_factory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"vesting"},"name":{"kind":"Name","value":"vesting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"governance_satellite"},"name":{"kind":"Name","value":"governance_satellite"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"aggregator_factory"},"name":{"kind":"Name","value":"aggregator_factory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"aggregator"},"name":{"kind":"Name","value":"aggregator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"governance_financial"},"name":{"kind":"Name","value":"governance_financial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lending_controller"},"name":{"kind":"Name","value":"lending_controller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"vault_factory"},"name":{"kind":"Name","value":"vault_factory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]} as unknown as DocumentNode<GetContractAddressesQueryQuery, GetContractAddressesQueryQueryVariables>;
export const InitialDappQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"initialDappQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"council"},"name":{"kind":"Name","value":"council"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"council_member_image_max_length"}},{"kind":"Field","name":{"kind":"Name","value":"council_member_name_max_length"}},{"kind":"Field","name":{"kind":"Name","value":"council_member_website_max_length"}},{"kind":"Field","name":{"kind":"Name","value":"request_purpose_max_length"}},{"kind":"Field","name":{"kind":"Name","value":"request_token_name_max_length"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"governance"},"name":{"kind":"Name","value":"governance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"proposal_description_max_length"}},{"kind":"Field","name":{"kind":"Name","value":"proposal_invoice_max_length"}},{"kind":"Field","name":{"kind":"Name","value":"proposal_metadata_title_max_length"}},{"kind":"Field","name":{"kind":"Name","value":"proposal_source_code_max_length"}},{"kind":"Field","name":{"kind":"Name","value":"proposal_title_max_length"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"emergency_governance"},"name":{"kind":"Name","value":"emergency_governance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"proposal_desc_max_length"}},{"kind":"Field","name":{"kind":"Name","value":"proposal_title_max_length"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"governance_satellite"},"name":{"kind":"Name","value":"governance_satellite"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gov_purpose_max_length"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"delegation"},"name":{"kind":"Name","value":"delegation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"satellite_description_max_length"}},{"kind":"Field","name":{"kind":"Name","value":"satellite_name_max_length"}},{"kind":"Field","name":{"kind":"Name","value":"satellite_website_max_length"}},{"kind":"Field","name":{"kind":"Name","value":"minimum_smvn_balance"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"dipdup_index"},"name":{"kind":"Name","value":"dipdup_index"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"maven_finance","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"level"}}]}}]}}]} as unknown as DocumentNode<InitialDappQueryQuery, InitialDappQueryQueryVariables>;
export const DashboardTvlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DashboardTVL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"doormanContractAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"doormanTVL"},"name":{"kind":"Name","value":"maven_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"doormanContractAddress"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"smvn_balance"}},{"kind":"Field","name":{"kind":"Name","value":"mvn_balance"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lending_controller"},"name":{"kind":"Name","value":"lending_controller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"vaultsLvl"},"name":{"kind":"Name","value":"collateral_tokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"balances_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balance"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"collateralsForActiveVaults"},"name":{"kind":"Name","value":"collateral_tokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"balances_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lending_controller_vault"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"loan_outstanding_total"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balance"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"activeVaults"},"name":{"kind":"Name","value":"vaults_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"open"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"marketsTvl"},"name":{"kind":"Name","value":"loan_tokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_borrowed"}},{"kind":"Field","name":{"kind":"Name","value":"total_remaining"}},{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"treasuryTvl"},"name":{"kind":"Name","value":"treasury_balance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}}]}}]}}]} as unknown as DocumentNode<DashboardTvlQuery, DashboardTvlQueryVariables>;
export const SubscribeToIndexerLevelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"subscribeToIndexerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"dipdup_index"},"name":{"kind":"Name","value":"dipdup_index"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"maven_finance","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"level"}}]}}]}}]} as unknown as DocumentNode<SubscribeToIndexerLevelSubscription, SubscribeToIndexerLevelSubscriptionVariables>;
export const FeedHistoryQeuryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"feedHistoryQeury"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feedAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"periodTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}},"defaultValue":{"kind":"StringValue","value":"1970-01-01T00:00:00.000Z","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"aggregator"},"name":{"kind":"Name","value":"aggregator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feedAddress"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"history_data"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"timestamp"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"periodTimestamp"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"aggregator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"decimals"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FeedHistoryQeuryQuery, FeedHistoryQeuryQueryVariables>;
export const DataFeedsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dataFeeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"aggregator"},"name":{"kind":"Name","value":"aggregator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"admin"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"creation_timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"network"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"creation_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"last_completed_data"}},{"kind":"Field","name":{"kind":"Name","value":"last_completed_data_last_updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_completed_data_pct_oracle_resp"}},{"kind":"Field","name":{"kind":"Name","value":"last_completed_data_epoch"}},{"kind":"Field","name":{"kind":"Name","value":"heart_beat_seconds"}},{"kind":"Field","name":{"kind":"Name","value":"reward_amount_mvrk"}},{"kind":"Field","name":{"kind":"Name","value":"reward_amount_smvn"}},{"kind":"Field","name":{"kind":"Name","value":"pct_oracle_threshold"}},{"kind":"Field","name":{"kind":"Name","value":"alpha_pct_per_thousand"}},{"kind":"Field","name":{"kind":"Name","value":"oracles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"satellites"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"currently_registered"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DataFeedsQuery, DataFeedsQueryVariables>;
export const DataFeedsPricesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dataFeedsPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"aggregator"},"name":{"kind":"Name","value":"aggregator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"admin"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"creation_timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"last_completed_data"}},{"kind":"Field","name":{"kind":"Name","value":"last_completed_data_pct_oracle_resp"}},{"kind":"Field","name":{"kind":"Name","value":"last_completed_data_last_updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_completed_data_epoch"}}]}}]}}]} as unknown as DocumentNode<DataFeedsPricesQuery, DataFeedsPricesQueryVariables>;
export const SmvnMvnHistoryDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"smvnMvnHistoryData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"periodTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}},"defaultValue":{"kind":"StringValue","value":"1970-01-01T00:00:00.000Z","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"operationsInPeriod"},"name":{"kind":"Name","value":"smvn_history_data"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"timestamp"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"periodTimestamp"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mvn_total_supply"}},{"kind":"Field","name":{"kind":"Name","value":"smvn_total_supply"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lastOperationBeforePeriod"},"name":{"kind":"Name","value":"smvn_history_data"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"timestamp"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"periodTimestamp"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mvn_total_supply"}},{"kind":"Field","name":{"kind":"Name","value":"smvn_total_supply"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"amountOfOperationsBeforePeriod"},"name":{"kind":"Name","value":"smvn_history_data_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"periodTimestamp"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<SmvnMvnHistoryDataQuery, SmvnMvnHistoryDataQueryVariables>;
export const GetDappSmvnMvnStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDappSmvnMvnStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"doormanContractAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"maven_user"},"name":{"kind":"Name","value":"maven_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"doormanContractAddress"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"mvn_balance"}},{"kind":"Field","name":{"kind":"Name","value":"smvn_balance"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"mvn_token"},"name":{"kind":"Name","value":"mvn_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_supply"}},{"kind":"Field","name":{"kind":"Name","value":"maximum_supply"}}]}}]}}]} as unknown as DocumentNode<GetDappSmvnMvnStatsQuery, GetDappSmvnMvnStatsQueryVariables>;
export const GetEGovConfigQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEGovConfigQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"emergency_governance"},"name":{"kind":"Name","value":"emergency_governance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current_emergency_record_id"}},{"kind":"Field","name":{"kind":"Name","value":"smvn_percentage_required"}},{"kind":"Field","name":{"kind":"Name","value":"required_fee_mumav"}},{"kind":"Field","name":{"kind":"Name","value":"min_smvn_required_to_vote"}}]}}]}}]} as unknown as DocumentNode<GetEGovConfigQueryQuery, GetEGovConfigQueryQueryVariables>;
export const GetEGovAllProposalsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEGovAllProposalsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"emergency_governance_record"},"name":{"kind":"Name","value":"emergency_governance_record"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start_timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"executed"}},{"kind":"Field","name":{"kind":"Name","value":"start_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"execution_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"expiration_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"smvn_percentage_required"}},{"kind":"Field","name":{"kind":"Name","value":"smvn_required_for_trigger"}},{"kind":"Field","name":{"kind":"Name","value":"total_smvn_votes"}},{"kind":"Field","name":{"kind":"Name","value":"proposer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"smvn_amount"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}}]} as unknown as DocumentNode<GetEGovAllProposalsQueryQuery, GetEGovAllProposalsQueryQueryVariables>;
export const FarmsAllLiveQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"farmsAllLiveQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"farm"},"name":{"kind":"Name","value":"farm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"creation_timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"open"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"open"}},{"kind":"Field","name":{"kind":"Name","value":"creation_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"end_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"infinite"}},{"kind":"Field","name":{"kind":"Name","value":"lp_token_balance"}},{"kind":"Field","name":{"kind":"Name","value":"lp_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"withdraw_paused"}},{"kind":"Field","name":{"kind":"Name","value":"claim_paused"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_paused"}},{"kind":"Field","name":{"kind":"Name","value":"is_m_farm"}},{"kind":"Field","name":{"kind":"Name","value":"current_reward_per_block"}},{"kind":"Field","name":{"kind":"Name","value":"farm_accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deposited_amount"}},{"kind":"Field","name":{"kind":"Name","value":"unclaimed_rewards"}},{"kind":"Field","name":{"kind":"Name","value":"participation_rewards_per_share"}}]}}]}}]}}]} as unknown as DocumentNode<FarmsAllLiveQueryQuery, FarmsAllLiveQueryQueryVariables>;
export const FarmsStakedLiveQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"farmsStakedLiveQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"farm"},"name":{"kind":"Name","value":"farm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"creation_timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"open"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"farm_accounts"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"open"}},{"kind":"Field","name":{"kind":"Name","value":"creation_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"end_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"infinite"}},{"kind":"Field","name":{"kind":"Name","value":"lp_token_balance"}},{"kind":"Field","name":{"kind":"Name","value":"lp_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"withdraw_paused"}},{"kind":"Field","name":{"kind":"Name","value":"claim_paused"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_paused"}},{"kind":"Field","name":{"kind":"Name","value":"is_m_farm"}},{"kind":"Field","name":{"kind":"Name","value":"current_reward_per_block"}},{"kind":"Field","name":{"kind":"Name","value":"farm_accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deposited_amount"}},{"kind":"Field","name":{"kind":"Name","value":"unclaimed_rewards"}},{"kind":"Field","name":{"kind":"Name","value":"participation_rewards_per_share"}}]}}]}}]}}]} as unknown as DocumentNode<FarmsStakedLiveQueryQuery, FarmsStakedLiveQueryQueryVariables>;
export const FarmsAllFinishedQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"farmsAllFinishedQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"farm"},"name":{"kind":"Name","value":"farm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"creation_timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"open"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"open"}},{"kind":"Field","name":{"kind":"Name","value":"creation_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"end_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"infinite"}},{"kind":"Field","name":{"kind":"Name","value":"lp_token_balance"}},{"kind":"Field","name":{"kind":"Name","value":"lp_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"withdraw_paused"}},{"kind":"Field","name":{"kind":"Name","value":"claim_paused"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_paused"}},{"kind":"Field","name":{"kind":"Name","value":"is_m_farm"}},{"kind":"Field","name":{"kind":"Name","value":"current_reward_per_block"}},{"kind":"Field","name":{"kind":"Name","value":"farm_accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deposited_amount"}},{"kind":"Field","name":{"kind":"Name","value":"unclaimed_rewards"}},{"kind":"Field","name":{"kind":"Name","value":"participation_rewards_per_share"}}]}}]}}]}}]} as unknown as DocumentNode<FarmsAllFinishedQueryQuery, FarmsAllFinishedQueryQueryVariables>;
export const FarmsStakedFinishedQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"farmsStakedFinishedQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"farm"},"name":{"kind":"Name","value":"farm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"creation_timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"open"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"farm_accounts"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"open"}},{"kind":"Field","name":{"kind":"Name","value":"creation_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"end_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"infinite"}},{"kind":"Field","name":{"kind":"Name","value":"lp_token_balance"}},{"kind":"Field","name":{"kind":"Name","value":"lp_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"withdraw_paused"}},{"kind":"Field","name":{"kind":"Name","value":"claim_paused"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_paused"}},{"kind":"Field","name":{"kind":"Name","value":"is_m_farm"}},{"kind":"Field","name":{"kind":"Name","value":"current_reward_per_block"}},{"kind":"Field","name":{"kind":"Name","value":"farm_accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deposited_amount"}},{"kind":"Field","name":{"kind":"Name","value":"unclaimed_rewards"}},{"kind":"Field","name":{"kind":"Name","value":"participation_rewards_per_share"}}]}}]}}]}}]} as unknown as DocumentNode<FarmsStakedFinishedQueryQuery, FarmsStakedFinishedQueryQueryVariables>;
export const GetAllFinRequestsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllFinRequestsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"governance_financial_request"},"name":{"kind":"Name","value":"governance_financial_request"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"requested_datetime"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"executed"}},{"kind":"Field","name":{"kind":"Name","value":"expiration_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"dropped_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"execution_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"request_purpose"}},{"kind":"Field","name":{"kind":"Name","value":"request_type"}},{"kind":"Field","name":{"kind":"Name","value":"requested_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"smvn_percentage_for_approval"}},{"kind":"Field","name":{"kind":"Name","value":"requester"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_smvn_total_supply"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"token_amount"}},{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"governance_financial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"treasury"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pass_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"nay_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"yay_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"votes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"governance_financial_request_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"vote"}},{"kind":"Field","name":{"kind":"Name","value":"voter_id"}},{"kind":"Field","name":{"kind":"Name","value":"voter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"governance_financial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"governance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAllFinRequestsQueryQuery, GetAllFinRequestsQueryQueryVariables>;
export const GetActiveFinRequestsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getActiveFinRequestsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}},"defaultValue":{"kind":"StringValue","value":"1970-01-01T00:00:00.000Z","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"governance_financial_request"},"name":{"kind":"Name","value":"governance_financial_request"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"requested_datetime"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"executed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"expiration_datetime"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentTimestamp"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"executed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"execution_datetime"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentTimestamp"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"executed"}},{"kind":"Field","name":{"kind":"Name","value":"expiration_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"dropped_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"execution_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"request_purpose"}},{"kind":"Field","name":{"kind":"Name","value":"request_type"}},{"kind":"Field","name":{"kind":"Name","value":"requested_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"smvn_percentage_for_approval"}},{"kind":"Field","name":{"kind":"Name","value":"requester"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_smvn_total_supply"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"token_amount"}},{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"governance_financial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"treasury"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pass_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"nay_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"yay_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"votes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"governance_financial_request_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"vote"}},{"kind":"Field","name":{"kind":"Name","value":"voter_id"}},{"kind":"Field","name":{"kind":"Name","value":"voter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"governance_financial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"governance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetActiveFinRequestsQueryQuery, GetActiveFinRequestsQueryQueryVariables>;
export const GetLending24hDiffDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLending24hDiff"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lending_controller"},"name":{"kind":"Name","value":"lending_controller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"history_data"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"0","block":false},{"kind":"StringValue","value":"1","block":false},{"kind":"StringValue","value":"2","block":false},{"kind":"StringValue","value":"3","block":false}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentTimestamp"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"loan_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"loan_tokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_borrowed"}},{"kind":"Field","name":{"kind":"Name","value":"token_pool_total"}},{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLending24hDiffQuery, GetLending24hDiffQueryVariables>;
export const GetLoansHistoryDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLoansHistoryData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lending_controller"},"name":{"kind":"Name","value":"lending_controller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"history_data"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"0","block":false},{"kind":"StringValue","value":"1","block":false},{"kind":"StringValue","value":"2","block":false},{"kind":"StringValue","value":"3","block":false},{"kind":"StringValue","value":"4","block":false},{"kind":"StringValue","value":"5","block":false},{"kind":"StringValue","value":"6","block":false},{"kind":"StringValue","value":"7","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"loan_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loan_token_name"}},{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"collateral_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLoansHistoryDataQuery, GetLoansHistoryDataQueryVariables>;
export const GetLoansTransactionsHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLoansTransactionsHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketTokenAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vaultAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"typeFilter"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"smallint"}}},"defaultValue":{"kind":"ListValue","values":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"8"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lending_controller"},"name":{"kind":"Name","value":"lending_controller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"history_data"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"loan_token"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"token"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"token_address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketTokenAddress"}}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"loan_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loan_token_name"}},{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"collateral_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}},{"kind":"Field","name":{"kind":"Name","value":"mvn_tokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"operation_hash"}},{"kind":"Field","name":{"kind":"Name","value":"sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vault"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vault"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"historyItemsAmount"},"name":{"kind":"Name","value":"history_data_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"loan_token"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"token"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"token_address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketTokenAddress"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLoansTransactionsHistoryQuery, GetLoansTransactionsHistoryQueryVariables>;
export const GetDevLoansTransactionsHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDevLoansTransactionsHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketTokenAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vaultAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"typeFilter"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"smallint"}}},"defaultValue":{"kind":"ListValue","values":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"8"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lending_controller"},"name":{"kind":"Name","value":"lending_controller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"history_data"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"loan_token"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"token"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"token_address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketTokenAddress"}}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"loan_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loan_token_name"}},{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"collateral_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}},{"kind":"Field","name":{"kind":"Name","value":"mvn_tokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"operation_hash"}},{"kind":"Field","name":{"kind":"Name","value":"sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vault"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vault"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"historyItemsAmount"},"name":{"kind":"Name","value":"history_data_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"loan_token"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"token"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"token_address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketTokenAddress"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDevLoansTransactionsHistoryQuery, GetDevLoansTransactionsHistoryQueryVariables>;
export const LoansMarketByAddressQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loansMarketByAddressQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketTokenAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allMarketsAddresses"},"name":{"kind":"Name","value":"lending_controller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loan_tokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lending_controller"},"name":{"kind":"Name","value":"lending_controller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collateral_ratio"}},{"kind":"Field","name":{"kind":"Name","value":"interest_treasury_share"}},{"kind":"Field","name":{"kind":"Name","value":"interest_rate_decimals"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"loan_tokens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"token"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"token_address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketTokenAddress"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"loan_token_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"utilisation_rate"}},{"kind":"Field","name":{"kind":"Name","value":"total_borrowed"}},{"kind":"Field","name":{"kind":"Name","value":"token_pool_total"}},{"kind":"Field","name":{"kind":"Name","value":"total_remaining"}},{"kind":"Field","name":{"kind":"Name","value":"reserve_ratio"}},{"kind":"Field","name":{"kind":"Name","value":"current_interest_rate"}},{"kind":"Field","name":{"kind":"Name","value":"m_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","alias":{"kind":"Name","value":"depositorsAmount"},"name":{"kind":"Name","value":"accounts_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"balance"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"IntValue","value":"0"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"mTokenRewardsAmount"},"name":{"kind":"Name","value":"accounts_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rewards_earned"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vaults_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"loan_outstanding_total"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"0","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"columns"},"value":{"kind":"EnumValue","value":"owner_id"}}]}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LoansMarketByAddressQueryQuery, LoansMarketByAddressQueryQueryVariables>;
export const AllLoansMarketsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allLoansMarketsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"markets"},"name":{"kind":"Name","value":"gql_loan_token_market_stats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token_address"}},{"kind":"Field","name":{"kind":"Name","value":"m_token_address"}},{"kind":"Field","name":{"kind":"Name","value":"loan_token_name"}},{"kind":"Field","name":{"kind":"Name","value":"token_pool_total"}},{"kind":"Field","name":{"kind":"Name","value":"total_borrowed"}},{"kind":"Field","name":{"kind":"Name","value":"total_remaining"}},{"kind":"Field","name":{"kind":"Name","value":"utilisation_rate"}},{"kind":"Field","name":{"kind":"Name","value":"current_interest_rate"}},{"kind":"Field","name":{"kind":"Name","value":"depositors_count"}},{"kind":"Field","name":{"kind":"Name","value":"borrowers_count"}},{"kind":"Field","name":{"kind":"Name","value":"rewards_earned_total"}},{"kind":"Field","name":{"kind":"Name","value":"reserve_ratio"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lending_controller"},"name":{"kind":"Name","value":"lending_controller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collateral_ratio"}},{"kind":"Field","name":{"kind":"Name","value":"interest_treasury_share"}},{"kind":"Field","name":{"kind":"Name","value":"interest_rate_decimals"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}}]}}]}}]} as unknown as DocumentNode<AllLoansMarketsQueryQuery, AllLoansMarketsQueryQueryVariables>;
export const GetLoansConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLoansConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lending_controller"},"name":{"kind":"Name","value":"lending_controller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minimum_loan_fee_pct"}},{"kind":"Field","name":{"kind":"Name","value":"collateral_ratio"}}]}}]}}]} as unknown as DocumentNode<GetLoansConfigQuery, GetLoansConfigQueryVariables>;
export const CheckWitherMarketExistsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"checkWitherMarketExists"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lending_controller"},"name":{"kind":"Name","value":"lending_controller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loan_tokens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"token"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"token_address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketAddress"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CheckWitherMarketExistsQuery, CheckWitherMarketExistsQueryVariables>;
export const GetGovernanceLatestUserProposalsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetGovernanceLatestUserProposalsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"governance_proposal"},"name":{"kind":"Name","value":"governance_proposal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start_datetime"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"proposer"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetGovernanceLatestUserProposalsQueryQuery, GetGovernanceLatestUserProposalsQueryQueryVariables>;
export const GovernanceConfigQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"governanceConfigQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"governance"},"name":{"kind":"Name","value":"governance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"current_round"}},{"kind":"Field","name":{"kind":"Name","value":"success_reward"}},{"kind":"Field","name":{"kind":"Name","value":"cycle_id"}},{"kind":"Field","name":{"kind":"Name","value":"proposal_submission_fee_mumav"}},{"kind":"Field","name":{"kind":"Name","value":"timelock_proposal_id"}},{"kind":"Field","name":{"kind":"Name","value":"cycle_highest_voted_proposal_id"}},{"kind":"Field","name":{"kind":"Name","value":"current_round_end_level"}},{"kind":"Field","name":{"kind":"Name","value":"proposals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"executed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"0","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"locked"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"defeated_datetime"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dropped_datetime"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GovernanceConfigQueryQuery, GovernanceConfigQueryQueryVariables>;
export const PastProposalsDataQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"pastProposalsDataQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"governance"},"name":{"kind":"Name","value":"governance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current_round"}},{"kind":"Field","name":{"kind":"Name","value":"timelock_proposal_id"}},{"kind":"Field","name":{"kind":"Name","value":"cycle_highest_voted_proposal_id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"governance_proposal"},"name":{"kind":"Name","value":"governance_proposal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start_datetime"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"executed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"current_round_proposal"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"1"}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current_cycle_end_level"}},{"kind":"Field","name":{"kind":"Name","value":"cycle"}},{"kind":"Field","name":{"kind":"Name","value":"success_reward"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"proposer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"governance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"invoice"}},{"kind":"Field","name":{"kind":"Name","value":"current_round_proposal"}},{"kind":"Field","name":{"kind":"Name","value":"dropped_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"execution_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"defeated_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"locked"}},{"kind":"Field","name":{"kind":"Name","value":"executed"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"payment_processed"}},{"kind":"Field","name":{"kind":"Name","value":"min_quorum_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"quorum_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"nay_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"pass_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"yay_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"proposal_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"source_code"}},{"kind":"Field","name":{"kind":"Name","value":"votes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"round"}},{"kind":"Field","name":{"kind":"Name","value":"vote"}},{"kind":"Field","name":{"kind":"Name","value":"voter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"satellites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"encoded_code"}},{"kind":"Field","name":{"kind":"Name","value":"governance_proposal_id"}},{"kind":"Field","name":{"kind":"Name","value":"code_description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"governance_proposal_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internal_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"to_"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"token_id"}},{"kind":"Field","name":{"kind":"Name","value":"token_amount"}},{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PastProposalsDataQueryQuery, PastProposalsDataQueryQueryVariables>;
export const ProposalsDataQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"proposalsDataQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timelockProposalId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"governance"},"name":{"kind":"Name","value":"governance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current_round"}},{"kind":"Field","name":{"kind":"Name","value":"timelock_proposal_id"}},{"kind":"Field","name":{"kind":"Name","value":"cycle_highest_voted_proposal_id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"governance_proposal"},"name":{"kind":"Name","value":"governance_proposal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start_datetime"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"current_round_proposal"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timelockProposalId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"executed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"payment_processed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current_cycle_end_level"}},{"kind":"Field","name":{"kind":"Name","value":"cycle"}},{"kind":"Field","name":{"kind":"Name","value":"success_reward"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"proposer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"governance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"invoice"}},{"kind":"Field","name":{"kind":"Name","value":"current_round_proposal"}},{"kind":"Field","name":{"kind":"Name","value":"dropped_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"execution_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"defeated_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"locked"}},{"kind":"Field","name":{"kind":"Name","value":"executed"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"payment_processed"}},{"kind":"Field","name":{"kind":"Name","value":"min_quorum_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"quorum_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"nay_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"pass_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"yay_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"proposal_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"source_code"}},{"kind":"Field","name":{"kind":"Name","value":"votes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"round"}},{"kind":"Field","name":{"kind":"Name","value":"vote"}},{"kind":"Field","name":{"kind":"Name","value":"voter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"satellites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"encoded_code"}},{"kind":"Field","name":{"kind":"Name","value":"governance_proposal_id"}},{"kind":"Field","name":{"kind":"Name","value":"code_description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"governance_proposal_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internal_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"to_"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"token_id"}},{"kind":"Field","name":{"kind":"Name","value":"token_amount"}},{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProposalsDataQueryQuery, ProposalsDataQueryQueryVariables>;
export const SubmissionProposalsDataqueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"submissionProposalsDataquery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"governance"},"name":{"kind":"Name","value":"governance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current_round"}},{"kind":"Field","name":{"kind":"Name","value":"timelock_proposal_id"}},{"kind":"Field","name":{"kind":"Name","value":"cycle_highest_voted_proposal_id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"governance_proposal"},"name":{"kind":"Name","value":"governance_proposal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start_datetime"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"proposer"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"current_round_proposal"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"0"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"2"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current_cycle_end_level"}},{"kind":"Field","name":{"kind":"Name","value":"cycle"}},{"kind":"Field","name":{"kind":"Name","value":"success_reward"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"proposer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"governance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"invoice"}},{"kind":"Field","name":{"kind":"Name","value":"current_round_proposal"}},{"kind":"Field","name":{"kind":"Name","value":"dropped_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"execution_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"defeated_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"locked"}},{"kind":"Field","name":{"kind":"Name","value":"executed"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"payment_processed"}},{"kind":"Field","name":{"kind":"Name","value":"min_quorum_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"quorum_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"nay_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"pass_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"yay_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"proposal_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"source_code"}},{"kind":"Field","name":{"kind":"Name","value":"votes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"round"}},{"kind":"Field","name":{"kind":"Name","value":"vote"}},{"kind":"Field","name":{"kind":"Name","value":"voter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"satellites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"encoded_code"}},{"kind":"Field","name":{"kind":"Name","value":"governance_proposal_id"}},{"kind":"Field","name":{"kind":"Name","value":"code_description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"governance_proposal_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internal_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"to_"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"token_amount"}},{"kind":"Field","name":{"kind":"Name","value":"token_id"}},{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SubmissionProposalsDataqueryQuery, SubmissionProposalsDataqueryQueryVariables>;
export const GetGovernanceSatelliteConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetGovernanceSatelliteConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"governance_satellite"},"name":{"kind":"Name","value":"governance_satellite"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"approval_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"sat_action_duration_in_days"}},{"kind":"Field","name":{"kind":"Name","value":"governance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"governance_satellite_counter"}},{"kind":"Field","name":{"kind":"Name","value":"max_actions_per_satellite"}}]}}]}}]} as unknown as DocumentNode<GetGovernanceSatelliteConfigQuery, GetGovernanceSatelliteConfigQueryVariables>;
export const OngoingGovernanceSatelliteActionsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ongoingGovernanceSatelliteActionsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}},"defaultValue":{"kind":"StringValue","value":"1970-01-01T00:00:00.000Z","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"governance_satellite_action"},"name":{"kind":"Name","value":"governance_satellite_action"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expiration_datetime"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"executed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"expiration_datetime"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentTimestamp"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"executed"}},{"kind":"Field","name":{"kind":"Name","value":"expiration_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"execution_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"dropped_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"governance_purpose"}},{"kind":"Field","name":{"kind":"Name","value":"governance_satellite"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"governance_type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"initiator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nay_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"pass_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"smvn_percentage_for_approval"}},{"kind":"Field","name":{"kind":"Name","value":"smvn_required_for_approval"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_smvn_total_supply"}},{"kind":"Field","name":{"kind":"Name","value":"start_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"yay_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"parameters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"votes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"governance_satellite_action_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"vote"}},{"kind":"Field","name":{"kind":"Name","value":"voter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OngoingGovernanceSatelliteActionsQueryQuery, OngoingGovernanceSatelliteActionsQueryQueryVariables>;
export const PastGovernanceSatelliteActionsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"pastGovernanceSatelliteActionsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}},"defaultValue":{"kind":"StringValue","value":"1970-01-01T00:00:00.000Z","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"governance_satellite_action"},"name":{"kind":"Name","value":"governance_satellite_action"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expiration_datetime"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"executed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"1","block":false}}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"executed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"execution_datetime"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentTimestamp"}}}]}}]}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"executed"}},{"kind":"Field","name":{"kind":"Name","value":"expiration_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"execution_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"dropped_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"governance_purpose"}},{"kind":"Field","name":{"kind":"Name","value":"governance_satellite"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"governance_type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"initiator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nay_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"pass_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"smvn_percentage_for_approval"}},{"kind":"Field","name":{"kind":"Name","value":"smvn_required_for_approval"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_smvn_total_supply"}},{"kind":"Field","name":{"kind":"Name","value":"start_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"yay_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"parameters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"votes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"governance_satellite_action_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"vote"}},{"kind":"Field","name":{"kind":"Name","value":"voter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PastGovernanceSatelliteActionsQueryQuery, PastGovernanceSatelliteActionsQueryQueryVariables>;
export const UserGovernanceSatelliteActionsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userGovernanceSatelliteActionsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"governance_satellite_action"},"name":{"kind":"Name","value":"governance_satellite_action"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expiration_datetime"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"initiator"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"executed"}},{"kind":"Field","name":{"kind":"Name","value":"expiration_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"execution_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"dropped_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"governance_purpose"}},{"kind":"Field","name":{"kind":"Name","value":"governance_satellite"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"governance_type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"initiator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nay_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"pass_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"smvn_percentage_for_approval"}},{"kind":"Field","name":{"kind":"Name","value":"smvn_required_for_approval"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_smvn_total_supply"}},{"kind":"Field","name":{"kind":"Name","value":"start_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"yay_vote_smvn_total"}},{"kind":"Field","name":{"kind":"Name","value":"parameters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"votes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"governance_satellite_action_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"vote"}},{"kind":"Field","name":{"kind":"Name","value":"voter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserGovernanceSatelliteActionsQueryQuery, UserGovernanceSatelliteActionsQueryQueryVariables>;
export const SatelliteVotesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"satelliteVotesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"satellite"},"name":{"kind":"Name","value":"satellite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"registration_timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"currently_registered"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"governance_financial_requests_votes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"vote"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"governance_financial_request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"request_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"governance_proposals_votes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"round"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"1","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"vote"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"governance_proposal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"governance_satellite_actions_votes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"vote"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"governance_satellite_action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"governance_type"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SatelliteVotesQueryQuery, SatelliteVotesQueryQueryVariables>;
export const CheckWitherSatelliteExistsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"checkWitherSatelliteExists"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"satellite"},"name":{"kind":"Name","value":"satellite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"registration_timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]}}]} as unknown as DocumentNode<CheckWitherSatelliteExistsQuery, CheckWitherSatelliteExistsQueryVariables>;
export const SatelliteDataQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"satelliteDataQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"satelliteAddresses"},"name":{"kind":"Name","value":"satellite_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"currently_registered"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"satellite"},"name":{"kind":"Name","value":"satellite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"registration_timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"currently_registered"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"currently_registered"}},{"kind":"Field","name":{"kind":"Name","value":"peer_id"}},{"kind":"Field","name":{"kind":"Name","value":"public_key"}},{"kind":"Field","name":{"kind":"Name","value":"satellite_action_counter"}},{"kind":"Field","name":{"kind":"Name","value":"governance_proposal_counter"}},{"kind":"Field","name":{"kind":"Name","value":"financial_request_counter"}},{"kind":"Field","name":{"kind":"Name","value":"total_delegated_amount"}},{"kind":"Field","alias":{"kind":"Name","value":"delegatorCount"},"name":{"kind":"Name","value":"delegations_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delegation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delegation_ratio"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"smvn_balance"}},{"kind":"Field","name":{"kind":"Name","value":"mvn_balance"}},{"kind":"Field","name":{"kind":"Name","value":"aggregator_oracles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"init_epoch"}},{"kind":"Field","name":{"kind":"Name","value":"init_round"}},{"kind":"Field","name":{"kind":"Name","value":"observations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epoch"}},{"kind":"Field","name":{"kind":"Name","value":"round"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"smvnRewardsAmount"},"name":{"kind":"Name","value":"rewards_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"1","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reward"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"xtzRewardsAmount"},"name":{"kind":"Name","value":"rewards_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"0","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reward"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"feedsObservationsAmount"},"name":{"kind":"Name","value":"aggregator_oracles_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"observations_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"governance_satellite_snapshots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"latest"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_voting_power"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lastVotedProposal"},"name":{"kind":"Name","value":"governance_proposals_votes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vote"}},{"kind":"Field","name":{"kind":"Name","value":"governance_proposal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"cycle"}},{"kind":"Field","name":{"kind":"Name","value":"current_round_proposal"}},{"kind":"Field","name":{"kind":"Name","value":"governance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cycle_id"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"createdGovProposalsAmount"},"name":{"kind":"Name","value":"governance_proposals_proposer_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"createdFinRequestsAmount"},"name":{"kind":"Name","value":"governance_financial_requests_requester_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"createdSatelliteGovActionsAmount"},"name":{"kind":"Name","value":"governance_satellite_action_initiators_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"govProposalsVotesAmount"},"name":{"kind":"Name","value":"governance_proposals_votes_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"finRequestsVotesAmount"},"name":{"kind":"Name","value":"governance_financial_requests_votes_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"satelliteGovActionsVotesAmount"},"name":{"kind":"Name","value":"governance_satellite_actions_votes_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SatelliteDataQueryQuery, SatelliteDataQueryQueryVariables>;
export const ActiveSatellitesDataQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"activeSatellitesDataQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"satelliteAddresses"},"name":{"kind":"Name","value":"satellite_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"currently_registered"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"satellite"},"name":{"kind":"Name","value":"satellite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"registration_timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"currently_registered"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"0","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"currently_registered"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"currently_registered"}},{"kind":"Field","name":{"kind":"Name","value":"peer_id"}},{"kind":"Field","name":{"kind":"Name","value":"public_key"}},{"kind":"Field","name":{"kind":"Name","value":"satellite_action_counter"}},{"kind":"Field","name":{"kind":"Name","value":"governance_proposal_counter"}},{"kind":"Field","name":{"kind":"Name","value":"financial_request_counter"}},{"kind":"Field","name":{"kind":"Name","value":"total_delegated_amount"}},{"kind":"Field","alias":{"kind":"Name","value":"delegatorCount"},"name":{"kind":"Name","value":"delegations_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delegation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delegation_ratio"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"smvn_balance"}},{"kind":"Field","name":{"kind":"Name","value":"mvn_balance"}},{"kind":"Field","name":{"kind":"Name","value":"aggregator_oracles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"init_epoch"}},{"kind":"Field","name":{"kind":"Name","value":"init_round"}},{"kind":"Field","name":{"kind":"Name","value":"observations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epoch"}},{"kind":"Field","name":{"kind":"Name","value":"round"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"smvnRewardsAmount"},"name":{"kind":"Name","value":"rewards_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"1","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reward"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"xtzRewardsAmount"},"name":{"kind":"Name","value":"rewards_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"0","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reward"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"feedsObservationsAmount"},"name":{"kind":"Name","value":"aggregator_oracles_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"observations_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"governance_satellite_snapshots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"latest"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_voting_power"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lastVotedProposal"},"name":{"kind":"Name","value":"governance_proposals_votes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vote"}},{"kind":"Field","name":{"kind":"Name","value":"governance_proposal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"cycle"}},{"kind":"Field","name":{"kind":"Name","value":"current_round_proposal"}},{"kind":"Field","name":{"kind":"Name","value":"governance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cycle_id"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"createdGovProposalsAmount"},"name":{"kind":"Name","value":"governance_proposals_proposer_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"createdFinRequestsAmount"},"name":{"kind":"Name","value":"governance_financial_requests_requester_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"createdSatelliteGovActionsAmount"},"name":{"kind":"Name","value":"governance_satellite_action_initiators_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"govProposalsVotesAmount"},"name":{"kind":"Name","value":"governance_proposals_votes_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"finRequestsVotesAmount"},"name":{"kind":"Name","value":"governance_financial_requests_votes_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"satelliteGovActionsVotesAmount"},"name":{"kind":"Name","value":"governance_satellite_actions_votes_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ActiveSatellitesDataQueryQuery, ActiveSatellitesDataQueryQueryVariables>;
export const AllSatellitesDataQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allSatellitesDataQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"satelliteAddresses"},"name":{"kind":"Name","value":"satellite_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"currently_registered"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"satellite"},"name":{"kind":"Name","value":"satellite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"registration_timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"currently_registered"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"currently_registered"}},{"kind":"Field","name":{"kind":"Name","value":"peer_id"}},{"kind":"Field","name":{"kind":"Name","value":"public_key"}},{"kind":"Field","name":{"kind":"Name","value":"satellite_action_counter"}},{"kind":"Field","name":{"kind":"Name","value":"governance_proposal_counter"}},{"kind":"Field","name":{"kind":"Name","value":"financial_request_counter"}},{"kind":"Field","name":{"kind":"Name","value":"total_delegated_amount"}},{"kind":"Field","alias":{"kind":"Name","value":"delegatorCount"},"name":{"kind":"Name","value":"delegations_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delegation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delegation_ratio"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"smvn_balance"}},{"kind":"Field","name":{"kind":"Name","value":"mvn_balance"}},{"kind":"Field","name":{"kind":"Name","value":"aggregator_oracles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"init_epoch"}},{"kind":"Field","name":{"kind":"Name","value":"init_round"}},{"kind":"Field","name":{"kind":"Name","value":"observations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epoch"}},{"kind":"Field","name":{"kind":"Name","value":"round"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"smvnRewardsAmount"},"name":{"kind":"Name","value":"rewards_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"1","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reward"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"xtzRewardsAmount"},"name":{"kind":"Name","value":"rewards_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"0","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reward"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"feedsObservationsAmount"},"name":{"kind":"Name","value":"aggregator_oracles_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"observations_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"governance_satellite_snapshots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"latest"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_voting_power"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lastVotedProposal"},"name":{"kind":"Name","value":"governance_proposals_votes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vote"}},{"kind":"Field","name":{"kind":"Name","value":"governance_proposal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"cycle"}},{"kind":"Field","name":{"kind":"Name","value":"current_round_proposal"}},{"kind":"Field","name":{"kind":"Name","value":"governance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cycle_id"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"createdGovProposalsAmount"},"name":{"kind":"Name","value":"governance_proposals_proposer_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"createdFinRequestsAmount"},"name":{"kind":"Name","value":"governance_financial_requests_requester_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"createdSatelliteGovActionsAmount"},"name":{"kind":"Name","value":"governance_satellite_action_initiators_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"govProposalsVotesAmount"},"name":{"kind":"Name","value":"governance_proposals_votes_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"finRequestsVotesAmount"},"name":{"kind":"Name","value":"governance_financial_requests_votes_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"satelliteGovActionsVotesAmount"},"name":{"kind":"Name","value":"governance_satellite_actions_votes_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllSatellitesDataQueryQuery, AllSatellitesDataQueryQueryVariables>;
export const OraclesSatellitesDataQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"oraclesSatellitesDataQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"satelliteAddresses"},"name":{"kind":"Name","value":"satellite_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"currently_registered"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"satellite"},"name":{"kind":"Name","value":"satellite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"registration_timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"aggregator_oracles_aggregate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"count"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"predicate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"IntValue","value":"1"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"observations_aggregate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"count"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"predicate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"IntValue","value":"1"}}]}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"currently_registered"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"currently_registered"}},{"kind":"Field","name":{"kind":"Name","value":"peer_id"}},{"kind":"Field","name":{"kind":"Name","value":"public_key"}},{"kind":"Field","name":{"kind":"Name","value":"satellite_action_counter"}},{"kind":"Field","name":{"kind":"Name","value":"governance_proposal_counter"}},{"kind":"Field","name":{"kind":"Name","value":"financial_request_counter"}},{"kind":"Field","name":{"kind":"Name","value":"total_delegated_amount"}},{"kind":"Field","alias":{"kind":"Name","value":"delegatorCount"},"name":{"kind":"Name","value":"delegations_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delegation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delegation_ratio"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"smvn_balance"}},{"kind":"Field","name":{"kind":"Name","value":"mvn_balance"}},{"kind":"Field","name":{"kind":"Name","value":"aggregator_oracles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"init_epoch"}},{"kind":"Field","name":{"kind":"Name","value":"init_round"}},{"kind":"Field","name":{"kind":"Name","value":"observations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epoch"}},{"kind":"Field","name":{"kind":"Name","value":"round"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"smvnRewardsAmount"},"name":{"kind":"Name","value":"rewards_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"1","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reward"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"xtzRewardsAmount"},"name":{"kind":"Name","value":"rewards_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"0","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reward"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"feedsObservationsAmount"},"name":{"kind":"Name","value":"aggregator_oracles_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"observations_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"governance_satellite_snapshots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"latest"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_voting_power"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lastVotedProposal"},"name":{"kind":"Name","value":"governance_proposals_votes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vote"}},{"kind":"Field","name":{"kind":"Name","value":"governance_proposal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"cycle"}},{"kind":"Field","name":{"kind":"Name","value":"current_round_proposal"}},{"kind":"Field","name":{"kind":"Name","value":"governance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cycle_id"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"createdGovProposalsAmount"},"name":{"kind":"Name","value":"governance_proposals_proposer_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"createdFinRequestsAmount"},"name":{"kind":"Name","value":"governance_financial_requests_requester_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"createdSatelliteGovActionsAmount"},"name":{"kind":"Name","value":"governance_satellite_action_initiators_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"govProposalsVotesAmount"},"name":{"kind":"Name","value":"governance_proposals_votes_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"finRequestsVotesAmount"},"name":{"kind":"Name","value":"governance_financial_requests_votes_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"satelliteGovActionsVotesAmount"},"name":{"kind":"Name","value":"governance_satellite_actions_votes_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OraclesSatellitesDataQueryQuery, OraclesSatellitesDataQueryQueryVariables>;
export const DappDataForSatelliteMetricsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dappDataForSatelliteMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"governance_proposal_aggregate"},"name":{"kind":"Name","value":"governance_proposal_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"governance_satellite_action_aggregate"},"name":{"kind":"Name","value":"governance_satellite_action_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"governance_financial_request_aggregate"},"name":{"kind":"Name","value":"governance_financial_request_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<DappDataForSatelliteMetricsQuery, DappDataForSatelliteMetricsQueryVariables>;
export const SatellitesStatsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SatellitesStatsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"oraclesAmount"},"name":{"kind":"Name","value":"satellite_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"aggregator_oracles_aggregate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"count"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"predicate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"activeSatellitesAmount"},"name":{"kind":"Name","value":"satellite_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"satellites"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"0","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"currently_registered"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"oraclesRewards"},"name":{"kind":"Name","value":"aggregator_oracle_reward_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"1","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"oracle"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"satellites"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"registration_timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reward"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"satellite_aggregate"},"name":{"kind":"Name","value":"satellite_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"currently_registered"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"0","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"smvn_balance"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delegations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"smvn_balance"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SatellitesStatsQueryQuery, SatellitesStatsQueryQueryVariables>;
export const TokensMetadataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"tokensMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"token"},"name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_id"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"token_address"}},{"kind":"Field","name":{"kind":"Name","value":"token_standard"}},{"kind":"Field","name":{"kind":"Name","value":"lending_controller_collateral_tokens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_name"}},{"kind":"Field","name":{"kind":"Name","value":"paused"}},{"kind":"Field","name":{"kind":"Name","value":"is_scaled_token"}},{"kind":"Field","name":{"kind":"Name","value":"is_staked_token"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lending_controller_loan_tokens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loan_token_name"}},{"kind":"Field","name":{"kind":"Name","value":"min_repayment_amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"m_tokens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mvn_tokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"farms_lp_tokens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"token0"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"token1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TokensMetadataQuery, TokensMetadataQueryVariables>;
export const GetTreasuryStorageDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTreasuryStorageData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"treasury"},"name":{"kind":"Name","value":"treasury"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"admin"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"creation_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"balances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"whitelisted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTreasuryStorageDataQuery, GetTreasuryStorageDataQueryVariables>;
export const GetTreasurySmvnBalancesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTreasurySmvnBalances"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addresses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"defaultValue":{"kind":"ListValue","values":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"maven_user"},"name":{"kind":"Name","value":"maven_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addresses"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"smvn_balance"}},{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]} as unknown as DocumentNode<GetTreasurySmvnBalancesQuery, GetTreasurySmvnBalancesQueryVariables>;
export const GetUserDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"maven_user"},"name":{"kind":"Name","value":"maven_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"smvn_balance"}},{"kind":"Field","name":{"kind":"Name","value":"mvn_balance"}},{"kind":"Field","name":{"kind":"Name","value":"m_token_accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"rewards_earned"}},{"kind":"Field","name":{"kind":"Name","value":"reward_index"}},{"kind":"Field","name":{"kind":"Name","value":"m_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_reward_index"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delegations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"satellite"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"satellites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currently_registered"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"council_council_members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"break_glass_council_members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vesting_vestees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"end_vesting_timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"governance_satellite_snapshots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cycle"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cycle"}},{"kind":"Field","name":{"kind":"Name","value":"ready"}},{"kind":"Field","name":{"kind":"Name","value":"next_snapshot_cycle_id"}},{"kind":"Field","name":{"kind":"Name","value":"governance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cycle_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"governance_satellite_action_initiators_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"0","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserDataQuery, GetUserDataQueryVariables>;
export const GetUserActionsHistoryDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserActionsHistoryData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"8"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"maven_user"},"name":{"kind":"Name","value":"maven_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stakes_history_data"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"0","block":false},{"kind":"StringValue","value":"1","block":false},{"kind":"StringValue","value":"2","block":false},{"kind":"StringValue","value":"3","block":false},{"kind":"StringValue","value":"4","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"desired_amount"}},{"kind":"Field","name":{"kind":"Name","value":"final_amount"}},{"kind":"Field","name":{"kind":"Name","value":"from_"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mvn_balance"}},{"kind":"Field","name":{"kind":"Name","value":"smvn_balance"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"historyItemsAmount"},"name":{"kind":"Name","value":"stakes_history_data_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserActionsHistoryDataQuery, GetUserActionsHistoryDataQueryVariables>;
export const GetUserEarningHistoryDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserEarningHistoryData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"maven_user"},"name":{"kind":"Name","value":"maven_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stakes_history_data"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"3","block":false},{"kind":"StringValue","value":"4","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"desired_amount"}},{"kind":"Field","name":{"kind":"Name","value":"final_amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"farm_accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"claimed_rewards"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserEarningHistoryDataQuery, GetUserEarningHistoryDataQueryVariables>;
export const GetUserRewardsDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserRewardsData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"governance_proposal"},"name":{"kind":"Name","value":"governance_proposal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"reward_claim_ready"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"votes"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"voter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"voting_reward_claimed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"maven_user"},"name":{"kind":"Name","value":"maven_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"smvn_balance"}},{"kind":"Field","name":{"kind":"Name","value":"doorman_stake_accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_satellite_rewards_claimed"}},{"kind":"Field","name":{"kind":"Name","value":"total_exit_fee_rewards_claimed"}},{"kind":"Field","name":{"kind":"Name","value":"participation_fees_per_share"}},{"kind":"Field","name":{"kind":"Name","value":"smvn_balance"}},{"kind":"Field","name":{"kind":"Name","value":"doorman"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unclaimed_rewards"}},{"kind":"Field","name":{"kind":"Name","value":"accumulated_fees_per_share"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"satellite_rewardss"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unpaid"}},{"kind":"Field","name":{"kind":"Name","value":"participation_rewards_per_share"}},{"kind":"Field","name":{"kind":"Name","value":"reference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"satellite_accumulated_reward_per_share"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"farm_accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"claimed_rewards"}},{"kind":"Field","name":{"kind":"Name","value":"deposited_amount"}},{"kind":"Field","name":{"kind":"Name","value":"participation_rewards_per_share"}},{"kind":"Field","name":{"kind":"Name","value":"farm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"accumulated_rewards_per_share"}},{"kind":"Field","name":{"kind":"Name","value":"current_reward_per_block"}},{"kind":"Field","name":{"kind":"Name","value":"last_block_update"}},{"kind":"Field","name":{"kind":"Name","value":"total_rewards"}},{"kind":"Field","name":{"kind":"Name","value":"paid_rewards"}},{"kind":"Field","name":{"kind":"Name","value":"unpaid_rewards"}},{"kind":"Field","name":{"kind":"Name","value":"infinite"}},{"kind":"Field","name":{"kind":"Name","value":"lp_token_balance"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserRewardsDataQuery, GetUserRewardsDataQueryVariables>;
export const GetUserLoansDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserLoansData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_in"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"smallint"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"StringValue","value":"0","block":false},{"kind":"StringValue","value":"1","block":false},{"kind":"StringValue","value":"2","block":false},{"kind":"StringValue","value":"3","block":false}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"maven_user"},"name":{"kind":"Name","value":"maven_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lending_controller_history_data_sender"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_in"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"asc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"operation_hash"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"loan_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"current_interest_rate"}},{"kind":"Field","name":{"kind":"Name","value":"utilisation_rate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lending_controller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interest_rate_decimals"}},{"kind":"Field","name":{"kind":"Name","value":"interest_treasury_share"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lending_controller_vaults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"open"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collateral_balances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"collateral_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"loan_decimals"}},{"kind":"Field","name":{"kind":"Name","value":"loan_principal_total"}},{"kind":"Field","name":{"kind":"Name","value":"loan_interest_total"}},{"kind":"Field","name":{"kind":"Name","value":"loan_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserLoansDataQuery, GetUserLoansDataQueryVariables>;
export const GetUsersLastestCreatedVaultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsersLastestCreatedVault"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vaultName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"vault"},"name":{"kind":"Name","value":"vault"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vaultName"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lending_controller_vaults"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"creation_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetUsersLastestCreatedVaultQuery, GetUsersLastestCreatedVaultQueryVariables>;
export const GetUserVaultsNamesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserVaultsNamesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lending_controller"},"name":{"kind":"Name","value":"lending_controller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vaults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"open"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vault"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserVaultsNamesQueryQuery, GetUserVaultsNamesQueryQueryVariables>;
export const GetVaultAccIntIndexesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getVaultAccIntIndexesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vaultAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lending_controller"},"name":{"kind":"Name","value":"lending_controller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vaults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"vault"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vaultAddress"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loan_interest_total"}},{"kind":"Field","name":{"kind":"Name","value":"borrow_index"}},{"kind":"Field","name":{"kind":"Name","value":"last_updated_block_level"}},{"kind":"Field","name":{"kind":"Name","value":"loan_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"borrow_index"}},{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetVaultAccIntIndexesQueryQuery, GetVaultAccIntIndexesQueryQueryVariables>;
export const GetUserDepositorAllVaultsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserDepositorAllVaultsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lending_controller"},"name":{"kind":"Name","value":"lending_controller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max_vault_liquidation_pct"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"liquidation_fee_pct"}},{"kind":"Field","name":{"kind":"Name","value":"liquidation_ratio"}},{"kind":"Field","name":{"kind":"Name","value":"interest_rate_decimals"}},{"kind":"Field","name":{"kind":"Name","value":"admin_liquidation_fee_pct"}},{"kind":"Field","name":{"kind":"Name","value":"liquidation_delay_in_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"vaults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"vault"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"creation_timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"open"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"vault"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowance"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"0","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"depositors"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"depositor"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowance"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"1","block":false}}]}}]}}]}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collateral_balances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"collateral_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_name"}},{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vault"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creation_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"allowance"}},{"kind":"Field","name":{"kind":"Name","value":"baker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"depositors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depositor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"loan_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"current_interest_rate"}},{"kind":"Field","name":{"kind":"Name","value":"borrow_index"}},{"kind":"Field","name":{"kind":"Name","value":"total_remaining"}},{"kind":"Field","name":{"kind":"Name","value":"token_pool_total"}},{"kind":"Field","name":{"kind":"Name","value":"reserve_ratio"}},{"kind":"Field","name":{"kind":"Name","value":"min_repayment_amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"last_updated_block_level"}},{"kind":"Field","name":{"kind":"Name","value":"marked_for_liquidation_level"}},{"kind":"Field","name":{"kind":"Name","value":"liquidation_end_level"}},{"kind":"Field","name":{"kind":"Name","value":"loan_outstanding_total"}},{"kind":"Field","name":{"kind":"Name","value":"loan_principal_total"}},{"kind":"Field","name":{"kind":"Name","value":"loan_interest_total"}},{"kind":"Field","name":{"kind":"Name","value":"internal_id"}},{"kind":"Field","name":{"kind":"Name","value":"borrow_index"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserDepositorAllVaultsQueryQuery, GetUserDepositorAllVaultsQueryQueryVariables>;
export const GetUserAllVaultsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserAllVaultsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lending_controller"},"name":{"kind":"Name","value":"lending_controller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max_vault_liquidation_pct"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"liquidation_fee_pct"}},{"kind":"Field","name":{"kind":"Name","value":"liquidation_ratio"}},{"kind":"Field","name":{"kind":"Name","value":"interest_rate_decimals"}},{"kind":"Field","name":{"kind":"Name","value":"admin_liquidation_fee_pct"}},{"kind":"Field","name":{"kind":"Name","value":"liquidation_delay_in_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"vaults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"vault"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"creation_timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"open"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collateral_balances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"collateral_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_name"}},{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vault"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creation_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"allowance"}},{"kind":"Field","name":{"kind":"Name","value":"baker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"depositors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depositor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"loan_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"current_interest_rate"}},{"kind":"Field","name":{"kind":"Name","value":"borrow_index"}},{"kind":"Field","name":{"kind":"Name","value":"total_remaining"}},{"kind":"Field","name":{"kind":"Name","value":"token_pool_total"}},{"kind":"Field","name":{"kind":"Name","value":"reserve_ratio"}},{"kind":"Field","name":{"kind":"Name","value":"min_repayment_amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"last_updated_block_level"}},{"kind":"Field","name":{"kind":"Name","value":"marked_for_liquidation_level"}},{"kind":"Field","name":{"kind":"Name","value":"liquidation_end_level"}},{"kind":"Field","name":{"kind":"Name","value":"loan_outstanding_total"}},{"kind":"Field","name":{"kind":"Name","value":"loan_principal_total"}},{"kind":"Field","name":{"kind":"Name","value":"loan_interest_total"}},{"kind":"Field","name":{"kind":"Name","value":"internal_id"}},{"kind":"Field","name":{"kind":"Name","value":"borrow_index"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserAllVaultsQueryQuery, GetUserAllVaultsQueryQueryVariables>;
export const GetAllVaultsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllVaultsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lending_controller"},"name":{"kind":"Name","value":"lending_controller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max_vault_liquidation_pct"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"liquidation_fee_pct"}},{"kind":"Field","name":{"kind":"Name","value":"liquidation_ratio"}},{"kind":"Field","name":{"kind":"Name","value":"interest_rate_decimals"}},{"kind":"Field","name":{"kind":"Name","value":"admin_liquidation_fee_pct"}},{"kind":"Field","name":{"kind":"Name","value":"liquidation_delay_in_minutes"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"vaults"},"name":{"kind":"Name","value":"gql_vault_with_balances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"creation_timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_open"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vault_address"}},{"kind":"Field","name":{"kind":"Name","value":"vault_name"}},{"kind":"Field","name":{"kind":"Name","value":"owner_address"}},{"kind":"Field","name":{"kind":"Name","value":"loan_token_address"}},{"kind":"Field","name":{"kind":"Name","value":"loan_outstanding_total"}},{"kind":"Field","name":{"kind":"Name","value":"loan_principal_total"}},{"kind":"Field","name":{"kind":"Name","value":"loan_interest_total"}},{"kind":"Field","name":{"kind":"Name","value":"collateral_json"}},{"kind":"Field","name":{"kind":"Name","value":"depositors_json"}},{"kind":"Field","name":{"kind":"Name","value":"is_open"}},{"kind":"Field","name":{"kind":"Name","value":"current_interest_rate"}},{"kind":"Field","name":{"kind":"Name","value":"borrow_index"}},{"kind":"Field","name":{"kind":"Name","value":"total_remaining"}},{"kind":"Field","name":{"kind":"Name","value":"token_pool_total"}},{"kind":"Field","name":{"kind":"Name","value":"reserve_ratio"}},{"kind":"Field","name":{"kind":"Name","value":"min_repayment_amount"}},{"kind":"Field","name":{"kind":"Name","value":"allowance"}},{"kind":"Field","name":{"kind":"Name","value":"creation_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"baker_address"}},{"kind":"Field","name":{"kind":"Name","value":"last_updated_block_level"}},{"kind":"Field","name":{"kind":"Name","value":"marked_for_liquidation_level"}},{"kind":"Field","name":{"kind":"Name","value":"liquidation_end_level"}},{"kind":"Field","name":{"kind":"Name","value":"internal_id"}}]}}]}}]} as unknown as DocumentNode<GetAllVaultsQueryQuery, GetAllVaultsQueryQueryVariables>;
export const GetVaultCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVaultCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vault_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetVaultCountQuery, GetVaultCountQueryVariables>;
export const DashboardVaultsTabDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dashboardVaultsTabData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lending_controller"},"name":{"kind":"Name","value":"lending_controller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allVaultsCollaterals"},"name":{"kind":"Name","value":"collateral_tokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"balances_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balance"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"collateralsForActiveVaults"},"name":{"kind":"Name","value":"collateral_tokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"balances_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lending_controller_vault"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"loan_outstanding_total"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balance"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"activeVaults"},"name":{"kind":"Name","value":"vaults_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"open"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"borrowedFromMarkets"},"name":{"kind":"Name","value":"loan_tokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_borrowed"}},{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_address"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DashboardVaultsTabDataQuery, DashboardVaultsTabDataQueryVariables>;
export const GetVestingQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getVestingQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"vesting"},"name":{"kind":"Name","value":"vesting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"governance_id"}},{"kind":"Field","name":{"kind":"Name","value":"total_vested_amount"}},{"kind":"Field","name":{"kind":"Name","value":"vestees_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_claimed"}},{"kind":"Field","name":{"kind":"Name","value":"total_remainder"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vestees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locked"}},{"kind":"Field","name":{"kind":"Name","value":"vestee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total_remainder"}},{"kind":"Field","name":{"kind":"Name","value":"total_allocated_amount"}},{"kind":"Field","name":{"kind":"Name","value":"claim_amount_per_month"}},{"kind":"Field","name":{"kind":"Name","value":"cliff_months"}},{"kind":"Field","name":{"kind":"Name","value":"vesting_months"}},{"kind":"Field","name":{"kind":"Name","value":"next_redemption_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"last_claimed_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"end_cliff_timestamp"}}]}}]}}]}}]} as unknown as DocumentNode<GetVestingQueryQuery, GetVestingQueryQueryVariables>;